class $3791d940664efc96$export$2e2bcd8739ae039 {
    constructor(input, list, { tabInsertsSuggestions: tabInsertsSuggestions, defaultFirstOption: defaultFirstOption, scrollIntoViewOptions: scrollIntoViewOptions } = {}){
        this.input = input;
        this.list = list;
        this.tabInsertsSuggestions = tabInsertsSuggestions !== null && tabInsertsSuggestions !== void 0 ? tabInsertsSuggestions : true;
        this.defaultFirstOption = defaultFirstOption !== null && defaultFirstOption !== void 0 ? defaultFirstOption : false;
        this.scrollIntoViewOptions = scrollIntoViewOptions !== null && scrollIntoViewOptions !== void 0 ? scrollIntoViewOptions : {
            block: "nearest",
            inline: "nearest"
        };
        this.isComposing = false;
        if (!list.id) list.id = `combobox-${Math.random().toString().slice(2, 6)}`;
        this.ctrlBindings = !!navigator.userAgent.match(/Macintosh/);
        this.keyboardEventHandler = (event)=>$3791d940664efc96$var$keyboardBindings(event, this);
        this.compositionEventHandler = (event)=>$3791d940664efc96$var$trackComposition(event, this);
        this.inputHandler = this.clearSelection.bind(this);
        input.setAttribute("role", "combobox");
        input.setAttribute("aria-controls", list.id);
        input.setAttribute("aria-expanded", "false");
        input.setAttribute("aria-autocomplete", "list");
        input.setAttribute("aria-haspopup", "listbox");
    }
    destroy() {
        this.clearSelection();
        this.stop();
        this.input.removeAttribute("role");
        this.input.removeAttribute("aria-controls");
        this.input.removeAttribute("aria-expanded");
        this.input.removeAttribute("aria-autocomplete");
        this.input.removeAttribute("aria-haspopup");
    }
    start() {
        this.input.setAttribute("aria-expanded", "true");
        this.input.addEventListener("compositionstart", this.compositionEventHandler);
        this.input.addEventListener("compositionend", this.compositionEventHandler);
        this.input.addEventListener("input", this.inputHandler);
        this.input.addEventListener("keydown", this.keyboardEventHandler);
        this.list.addEventListener("click", $3791d940664efc96$var$commitWithElement);
        this.indicateDefaultOption();
    }
    stop() {
        this.clearSelection();
        this.input.setAttribute("aria-expanded", "false");
        this.input.removeEventListener("compositionstart", this.compositionEventHandler);
        this.input.removeEventListener("compositionend", this.compositionEventHandler);
        this.input.removeEventListener("input", this.inputHandler);
        this.input.removeEventListener("keydown", this.keyboardEventHandler);
        this.list.removeEventListener("click", $3791d940664efc96$var$commitWithElement);
    }
    indicateDefaultOption() {
        var _a;
        if (this.defaultFirstOption) (_a = Array.from(this.list.querySelectorAll('[role="option"]:not([aria-disabled="true"])')).filter($3791d940664efc96$var$visible)[0]) === null || _a === void 0 || _a.setAttribute("data-combobox-option-default", "true");
    }
    navigate(indexDiff = 1) {
        const focusEl = Array.from(this.list.querySelectorAll('[aria-selected="true"]')).filter($3791d940664efc96$var$visible)[0];
        const els = Array.from(this.list.querySelectorAll('[role="option"]')).filter($3791d940664efc96$var$visible);
        const focusIndex = els.indexOf(focusEl);
        if (focusIndex === els.length - 1 && indexDiff === 1 || focusIndex === 0 && indexDiff === -1) {
            this.clearSelection();
            this.input.focus();
            return;
        }
        let indexOfItem = indexDiff === 1 ? 0 : els.length - 1;
        if (focusEl && focusIndex >= 0) {
            const newIndex = focusIndex + indexDiff;
            if (newIndex >= 0 && newIndex < els.length) indexOfItem = newIndex;
        }
        const target = els[indexOfItem];
        if (!target) return;
        for (const el of els){
            el.removeAttribute("data-combobox-option-default");
            if (target === el) {
                this.input.setAttribute("aria-activedescendant", target.id);
                target.setAttribute("aria-selected", "true");
                $3791d940664efc96$var$fireSelectEvent(target);
                target.scrollIntoView(this.scrollIntoViewOptions);
            } else el.removeAttribute("aria-selected");
        }
    }
    clearSelection() {
        this.input.removeAttribute("aria-activedescendant");
        for (const el of this.list.querySelectorAll('[aria-selected="true"]'))el.removeAttribute("aria-selected");
        this.indicateDefaultOption();
    }
}
function $3791d940664efc96$var$keyboardBindings(event, combobox) {
    if (event.shiftKey || event.metaKey || event.altKey) return;
    if (!combobox.ctrlBindings && event.ctrlKey) return;
    if (combobox.isComposing) return;
    switch(event.key){
        case "Enter":
            if ($3791d940664efc96$var$commit(combobox.input, combobox.list)) event.preventDefault();
            break;
        case "Tab":
            if (combobox.tabInsertsSuggestions && $3791d940664efc96$var$commit(combobox.input, combobox.list)) event.preventDefault();
            break;
        case "Escape":
            combobox.clearSelection();
            break;
        case "ArrowDown":
            combobox.navigate(1);
            event.preventDefault();
            break;
        case "ArrowUp":
            combobox.navigate(-1);
            event.preventDefault();
            break;
        case "n":
            if (combobox.ctrlBindings && event.ctrlKey) {
                combobox.navigate(1);
                event.preventDefault();
            }
            break;
        case "p":
            if (combobox.ctrlBindings && event.ctrlKey) {
                combobox.navigate(-1);
                event.preventDefault();
            }
            break;
        default:
            if (event.ctrlKey) break;
            combobox.clearSelection();
    }
}
function $3791d940664efc96$var$commitWithElement(event) {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('[role="option"]');
    if (!target) return;
    if (target.getAttribute("aria-disabled") === "true") return;
    $3791d940664efc96$var$fireCommitEvent(target, {
        event: event
    });
}
function $3791d940664efc96$var$commit(input, list) {
    const target = list.querySelector('[aria-selected="true"], [data-combobox-option-default="true"]');
    if (!target) return false;
    if (target.getAttribute("aria-disabled") === "true") return true;
    target.click();
    return true;
}
function $3791d940664efc96$var$fireCommitEvent(target, detail) {
    target.dispatchEvent(new CustomEvent("combobox-commit", {
        bubbles: true,
        detail: detail
    }));
}
function $3791d940664efc96$var$fireSelectEvent(target) {
    target.dispatchEvent(new Event("combobox-select", {
        bubbles: true
    }));
}
function $3791d940664efc96$var$visible(el) {
    return !el.hidden && !(el instanceof HTMLInputElement && el.type === "hidden") && (el.offsetWidth > 0 || el.offsetHeight > 0);
}
function $3791d940664efc96$var$trackComposition(event, combobox) {
    combobox.isComposing = event.type === "compositionstart";
    const list = document.getElementById(combobox.input.getAttribute("aria-controls") || "");
    if (!list) return;
    combobox.clearSelection();
}


function $a43d8cb124a0d66b$export$2e2bcd8739ae039(callback, wait = 0) {
    let timeout;
    return function(...Rest) {
        clearTimeout(timeout);
        timeout = window.setTimeout(()=>{
            clearTimeout(timeout);
            callback(...Rest);
        }, wait);
    };
}


const $17d439654615f6cc$var$SCREEN_READER_DELAY = window.testScreenReaderDelay || 100;
class $17d439654615f6cc$export$2e2bcd8739ae039 {
    constructor(container, input, results, autoselectEnabled = false){
        var _a;
        this.container = container;
        this.input = input;
        this.results = results;
        this.combobox = new (0, $3791d940664efc96$export$2e2bcd8739ae039)(input, results, {
            defaultFirstOption: autoselectEnabled
        });
        this.feedback = container.getRootNode().getElementById(`${this.results.id}-feedback`);
        this.autoselectEnabled = autoselectEnabled;
        this.clearButton = container.getRootNode().getElementById(`${this.input.id || this.input.name}-clear`);
        this.clientOptions = results.querySelectorAll("[role=option]");
        if (this.feedback) {
            this.feedback.setAttribute("aria-live", "polite");
            this.feedback.setAttribute("aria-atomic", "true");
        }
        if (this.clearButton && !this.clearButton.getAttribute("aria-label")) {
            const labelElem = document.querySelector(`label[for="${this.input.name}"]`);
            this.clearButton.setAttribute("aria-label", `clear:`);
            this.clearButton.setAttribute("aria-labelledby", `${this.clearButton.id} ${(labelElem === null || labelElem === void 0 ? void 0 : labelElem.id) || ""}`);
        }
        if (!this.input.getAttribute("aria-expanded")) this.input.setAttribute("aria-expanded", "false");
        if (this.results.popover) {
            if (this.results.matches(":popover-open")) this.results.hidePopover();
        } else this.results.hidden = true;
        if (!this.results.getAttribute("aria-label")) this.results.setAttribute("aria-label", "results");
        this.input.setAttribute("autocomplete", "off");
        this.input.setAttribute("spellcheck", "false");
        this.interactingWithList = false;
        this.onInputChange = (0, $a43d8cb124a0d66b$export$2e2bcd8739ae039)(this.onInputChange.bind(this), 300);
        this.onResultsMouseDown = this.onResultsMouseDown.bind(this);
        this.onInputBlur = this.onInputBlur.bind(this);
        this.onInputFocus = this.onInputFocus.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onCommit = this.onCommit.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.input.addEventListener("keydown", this.onKeydown);
        this.input.addEventListener("focus", this.onInputFocus);
        this.input.addEventListener("blur", this.onInputBlur);
        this.input.addEventListener("input", this.onInputChange);
        this.results.addEventListener("mousedown", this.onResultsMouseDown);
        this.results.addEventListener("combobox-commit", this.onCommit);
        (_a = this.clearButton) === null || _a === void 0 || _a.addEventListener("click", this.handleClear);
    }
    destroy() {
        this.input.removeEventListener("keydown", this.onKeydown);
        this.input.removeEventListener("focus", this.onInputFocus);
        this.input.removeEventListener("blur", this.onInputBlur);
        this.input.removeEventListener("input", this.onInputChange);
        this.results.removeEventListener("mousedown", this.onResultsMouseDown);
        this.results.removeEventListener("combobox-commit", this.onCommit);
    }
    handleClear(event) {
        event.preventDefault();
        if (this.input.getAttribute("aria-expanded") === "true") {
            this.input.setAttribute("aria-expanded", "false");
            this.updateFeedbackForScreenReaders("Results hidden.");
        }
        this.input.value = "";
        this.container.value = "";
        this.input.focus();
        this.input.dispatchEvent(new Event("change"));
        this.close();
    }
    onKeydown(event) {
        if (event.key === "Escape" && this.container.open) {
            this.close();
            event.stopPropagation();
            event.preventDefault();
        } else if (event.altKey && event.key === "ArrowUp" && this.container.open) {
            this.close();
            event.stopPropagation();
            event.preventDefault();
        } else if (event.altKey && event.key === "ArrowDown" && !this.container.open) {
            if (!this.input.value.trim()) return;
            this.open();
            event.stopPropagation();
            event.preventDefault();
        }
    }
    onInputFocus() {
        if (this.interactingWithList) return;
        this.fetchResults();
    }
    onInputBlur() {
        if (this.interactingWithList) return;
        this.close();
    }
    onCommit({ target: target }) {
        const selected = target;
        if (!(selected instanceof HTMLElement)) return;
        this.close();
        if (selected instanceof HTMLAnchorElement) return;
        const value = selected.getAttribute("data-autocomplete-value") || selected.textContent;
        this.updateFeedbackForScreenReaders(`${selected.textContent || ""} selected.`);
        this.container.value = value;
        if (!value) this.updateFeedbackForScreenReaders(`Results hidden.`);
    }
    onResultsMouseDown() {
        this.interactingWithList = true;
    }
    onInputChange() {
        if (this.feedback && this.feedback.textContent) this.feedback.textContent = "";
        this.container.removeAttribute("value");
        this.fetchResults();
    }
    identifyOptions() {
        let id = 0;
        for (const el of this.results.querySelectorAll('[role="option"]:not([id])'))el.id = `${this.results.id}-option-${id++}`;
    }
    updateFeedbackForScreenReaders(inputString) {
        setTimeout(()=>{
            if (this.feedback) this.feedback.textContent = inputString;
        }, $17d439654615f6cc$var$SCREEN_READER_DELAY);
    }
    fetchResults() {
        const query = this.input.value.trim();
        if (!query && !this.container.fetchOnEmpty) {
            this.close();
            return;
        }
        const src = this.container.src;
        if (!src) return;
        const url = new URL(src, window.location.href);
        const params = new URLSearchParams(url.search.slice(1));
        params.append("q", query);
        url.search = params.toString();
        this.container.dispatchEvent(new CustomEvent("loadstart"));
        this.container.fetchResult(url).then((html)=>{
            this.results.innerHTML = html;
            this.identifyOptions();
            this.combobox.indicateDefaultOption();
            const allNewOptions = this.results.querySelectorAll('[role="option"]');
            const hasResults = !!allNewOptions.length || !!this.results.querySelectorAll('[data-no-result-found="true"]').length;
            const numOptions = allNewOptions.length;
            const [firstOption] = allNewOptions;
            const firstOptionValue = firstOption === null || firstOption === void 0 ? void 0 : firstOption.textContent;
            if (this.autoselectEnabled && firstOptionValue) this.updateFeedbackForScreenReaders(`${numOptions} results. ${firstOptionValue} is the top result: Press Enter to activate.`);
            else this.updateFeedbackForScreenReaders(`${numOptions || "No"} results.`);
            hasResults ? this.open() : this.close();
            this.container.dispatchEvent(new CustomEvent("load"));
            this.container.dispatchEvent(new CustomEvent("loadend"));
        }).catch(()=>{
            this.container.dispatchEvent(new CustomEvent("error"));
            this.container.dispatchEvent(new CustomEvent("loadend"));
        });
    }
    open() {
        const isHidden = this.results.popover ? !this.results.matches(":popover-open") : this.results.hidden;
        if (isHidden) {
            this.combobox.start();
            if (this.results.popover) this.results.showPopover();
            else this.results.hidden = false;
        }
        this.container.open = true;
        this.interactingWithList = true;
    }
    close() {
        const isVisible = this.results.popover ? this.results.matches(":popover-open") : !this.results.hidden;
        if (isVisible) {
            this.combobox.stop();
            if (this.results.popover) this.results.hidePopover();
            else this.results.hidden = true;
        }
        this.container.open = false;
        this.interactingWithList = false;
    }
}


var $2424af6bdadb9c22$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $2424af6bdadb9c22$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $2424af6bdadb9c22$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2424af6bdadb9c22$var$_AutoCompleteElement_instances, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState, $2424af6bdadb9c22$var$_AutoCompleteElement_requestController;
const $2424af6bdadb9c22$var$HTMLElement = globalThis.HTMLElement || null;
class $2424af6bdadb9c22$export$bf58dbf529e87120 extends Event {
    constructor(type, _a){
        var { relatedTarget: relatedTarget } = _a, init = $2424af6bdadb9c22$var$__rest(_a, [
            "relatedTarget"
        ]);
        super(type, init);
        this.relatedTarget = relatedTarget;
    }
}
const $2424af6bdadb9c22$var$state = new WeakMap();
let $2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise = null;
class $2424af6bdadb9c22$export$d22562a5dbba41e6 extends $2424af6bdadb9c22$var$HTMLElement {
    constructor(){
        super(...arguments);
        $2424af6bdadb9c22$var$_AutoCompleteElement_instances.add(this);
        $2424af6bdadb9c22$var$_AutoCompleteElement_forElement.set(this, null);
        $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement.set(this, null);
        $2424af6bdadb9c22$var$_AutoCompleteElement_requestController.set(this, void 0);
    }
    static define(tag = "auto-complete", registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    static setCSPTrustedTypesPolicy(policy) {
        $2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise = policy === null ? policy : Promise.resolve(policy);
    }
    get forElement() {
        var _a;
        if ((_a = $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, "f")) === null || _a === void 0 ? void 0 : _a.isConnected) return $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, "f");
        const id = this.getAttribute("for");
        const root = this.getRootNode();
        if (id && (root instanceof Document || root instanceof ShadowRoot)) return root.getElementById(id);
        return null;
    }
    set forElement(element) {
        $2424af6bdadb9c22$var$__classPrivateFieldSet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_forElement, element, "f");
        this.setAttribute("for", "");
    }
    get inputElement() {
        var _a;
        if ((_a = $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, "f")) === null || _a === void 0 ? void 0 : _a.isConnected) return $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, "f");
        return this.querySelector("input");
    }
    set inputElement(input) {
        $2424af6bdadb9c22$var$__classPrivateFieldSet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement, input, "f");
        $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
        new MutationObserver(()=>{
            if (!$2424af6bdadb9c22$var$state.get(this)) $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
        }).observe(this, {
            subtree: true,
            childList: true
        });
    }
    disconnectedCallback() {
        const autocomplete = $2424af6bdadb9c22$var$state.get(this);
        if (autocomplete) {
            autocomplete.destroy();
            $2424af6bdadb9c22$var$state.delete(this);
        }
    }
    get src() {
        return this.getAttribute("src") || "";
    }
    set src(url) {
        this.setAttribute("src", url);
    }
    get value() {
        return this.getAttribute("value") || "";
    }
    set value(value) {
        this.setAttribute("value", value);
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(value) {
        if (value) this.setAttribute("open", "");
        else this.removeAttribute("open");
    }
    get fetchOnEmpty() {
        return this.hasAttribute("fetch-on-empty");
    }
    set fetchOnEmpty(fetchOnEmpty) {
        this.toggleAttribute("fetch-on-empty", fetchOnEmpty);
    }
    async fetchResult(url) {
        var _a;
        (_a = $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_requestController, "f")) === null || _a === void 0 || _a.abort();
        const { signal: signal } = $2424af6bdadb9c22$var$__classPrivateFieldSet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_requestController, new AbortController(), "f");
        const res = await fetch(url.toString(), {
            signal: signal,
            headers: {
                Accept: "text/fragment+html"
            }
        });
        if (!res.ok) throw new Error(await res.text());
        if ($2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise) {
            const cspTrustedTypesPolicy = await $2424af6bdadb9c22$var$cspTrustedTypesPolicyPromise;
            return cspTrustedTypesPolicy.createHTML(await res.text(), res);
        }
        return await res.text();
    }
    static get observedAttributes() {
        return [
            "open",
            "value",
            "for"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        var _a, _b;
        if (oldValue === newValue) return;
        const autocomplete = $2424af6bdadb9c22$var$state.get(this);
        if (!autocomplete) return;
        if (this.forElement !== ((_a = $2424af6bdadb9c22$var$state.get(this)) === null || _a === void 0 ? void 0 : _a.results) || this.inputElement !== ((_b = $2424af6bdadb9c22$var$state.get(this)) === null || _b === void 0 ? void 0 : _b.input)) $2424af6bdadb9c22$var$__classPrivateFieldGet(this, $2424af6bdadb9c22$var$_AutoCompleteElement_instances, "m", $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState).call(this);
        switch(name){
            case "open":
                newValue === null ? autocomplete.close() : autocomplete.open();
                break;
            case "value":
                if (newValue !== null) autocomplete.input.value = newValue;
                this.dispatchEvent(new $2424af6bdadb9c22$export$bf58dbf529e87120("auto-complete-change", {
                    bubbles: true,
                    relatedTarget: autocomplete.input
                }));
                break;
        }
    }
}
$2424af6bdadb9c22$var$_AutoCompleteElement_forElement = new WeakMap(), $2424af6bdadb9c22$var$_AutoCompleteElement_inputElement = new WeakMap(), $2424af6bdadb9c22$var$_AutoCompleteElement_requestController = new WeakMap(), $2424af6bdadb9c22$var$_AutoCompleteElement_instances = new WeakSet(), $2424af6bdadb9c22$var$_AutoCompleteElement_reattachState = function _AutoCompleteElement_reattachState() {
    var _a;
    (_a = $2424af6bdadb9c22$var$state.get(this)) === null || _a === void 0 || _a.destroy();
    const { forElement: forElement, inputElement: inputElement } = this;
    if (!forElement || !inputElement) return;
    const autoselectEnabled = this.getAttribute("data-autoselect") === "true";
    $2424af6bdadb9c22$var$state.set(this, new (0, $17d439654615f6cc$export$2e2bcd8739ae039)(this, inputElement, forElement, autoselectEnabled));
    forElement.setAttribute("role", "listbox");
};
var $2424af6bdadb9c22$export$2e2bcd8739ae039 = $2424af6bdadb9c22$export$d22562a5dbba41e6;


const $139db8d084e757ca$var$root = typeof globalThis !== "undefined" ? globalThis : window;
try {
    $139db8d084e757ca$var$root.AutocompleteElement = $139db8d084e757ca$var$root.AutoCompleteElement = (0, $2424af6bdadb9c22$export$d22562a5dbba41e6).define();
} catch (e) {
    if (!($139db8d084e757ca$var$root.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) throw e;
}
var $139db8d084e757ca$export$2e2bcd8739ae039 = (0, $2424af6bdadb9c22$export$d22562a5dbba41e6);


function $a4ae59bd85166939$var$createNode(text) {
    const node = document.createElement("pre");
    node.style.width = "1px";
    node.style.height = "1px";
    node.style.position = "fixed";
    node.style.top = "5px";
    node.textContent = text;
    return node;
}
function $a4ae59bd85166939$export$978ef9948557240e(node) {
    if ("clipboard" in navigator) return navigator.clipboard.writeText(node.textContent || "");
    const selection = getSelection();
    if (selection == null) return Promise.reject(new Error());
    selection.removeAllRanges();
    const range = document.createRange();
    range.selectNodeContents(node);
    selection.addRange(range);
    document.execCommand("copy");
    selection.removeAllRanges();
    return Promise.resolve();
}
function $a4ae59bd85166939$export$c8531afc97e1e0f8(text) {
    if ("clipboard" in navigator) return navigator.clipboard.writeText(text);
    const body = document.body;
    if (!body) return Promise.reject(new Error());
    const node = $a4ae59bd85166939$var$createNode(text);
    body.appendChild(node);
    $a4ae59bd85166939$export$978ef9948557240e(node);
    body.removeChild(node);
    return Promise.resolve();
}


async function $ef6a8c01f13c245c$var$copy(button) {
    const id = button.getAttribute("for");
    const text = button.getAttribute("value");
    function trigger() {
        button.dispatchEvent(new CustomEvent("clipboard-copy", {
            bubbles: true
        }));
    }
    if (button.getAttribute("aria-disabled") === "true") return;
    if (text) {
        await (0, $a4ae59bd85166939$export$c8531afc97e1e0f8)(text);
        trigger();
    } else if (id) {
        const root = "getRootNode" in Element.prototype ? button.getRootNode() : button.ownerDocument;
        if (!(root instanceof Document || "ShadowRoot" in window && root instanceof ShadowRoot)) return;
        const node = root.getElementById(id);
        if (node) {
            await $ef6a8c01f13c245c$var$copyTarget(node);
            trigger();
        }
    }
}
function $ef6a8c01f13c245c$var$copyTarget(content) {
    if (content instanceof HTMLInputElement || content instanceof HTMLTextAreaElement) return (0, $a4ae59bd85166939$export$c8531afc97e1e0f8)(content.value);
    else if (content instanceof HTMLAnchorElement && content.hasAttribute("href")) return (0, $a4ae59bd85166939$export$c8531afc97e1e0f8)(content.href);
    else return (0, $a4ae59bd85166939$export$978ef9948557240e)(content);
}
function $ef6a8c01f13c245c$var$clicked(event) {
    const button = event.currentTarget;
    if (button instanceof HTMLElement) $ef6a8c01f13c245c$var$copy(button);
}
function $ef6a8c01f13c245c$var$keydown(event) {
    if (event.key === " " || event.key === "Enter") {
        const button = event.currentTarget;
        if (button instanceof HTMLElement) {
            event.preventDefault();
            $ef6a8c01f13c245c$var$copy(button);
        }
    }
}
function $ef6a8c01f13c245c$var$focused(event) {
    event.currentTarget.addEventListener("keydown", $ef6a8c01f13c245c$var$keydown);
}
function $ef6a8c01f13c245c$var$blurred(event) {
    event.currentTarget.removeEventListener("keydown", $ef6a8c01f13c245c$var$keydown);
}
class $ef6a8c01f13c245c$export$c06ca7125051d4c8 extends HTMLElement {
    static define(tag = "clipboard-copy", registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    constructor(){
        super();
        this.addEventListener("click", $ef6a8c01f13c245c$var$clicked);
        this.addEventListener("focus", $ef6a8c01f13c245c$var$focused);
        this.addEventListener("blur", $ef6a8c01f13c245c$var$blurred);
    }
    connectedCallback() {
        if (!this.hasAttribute("tabindex")) this.setAttribute("tabindex", "0");
        if (!this.hasAttribute("role")) this.setAttribute("role", "button");
    }
    get value() {
        return this.getAttribute("value") || "";
    }
    set value(text) {
        this.setAttribute("value", text);
    }
}



const $336c1e18e7b6ef2c$var$root = typeof globalThis !== "undefined" ? globalThis : window;
try {
    $336c1e18e7b6ef2c$var$root.ClipboardCopyElement = (0, $ef6a8c01f13c245c$export$c06ca7125051d4c8).define();
} catch (e) {
    if (!($336c1e18e7b6ef2c$var$root.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) throw e;
}
var $336c1e18e7b6ef2c$export$2e2bcd8739ae039 = (0, $ef6a8c01f13c245c$export$c06ca7125051d4c8);


var $e8d9fb58cefaae39$export$2e2bcd8739ae039 = (0, $ef6a8c01f13c245c$export$c06ca7125051d4c8);


class $8449f1a811eb81cd$var$DetailsMenuElement extends HTMLElement {
    get preload() {
        return this.hasAttribute("preload");
    }
    set preload(value) {
        if (value) this.setAttribute("preload", "");
        else this.removeAttribute("preload");
    }
    get src() {
        return this.getAttribute("src") || "";
    }
    set src(value) {
        this.setAttribute("src", value);
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "menu");
        const details = this.parentElement;
        if (!details) return;
        const summary = details.querySelector("summary");
        if (summary) {
            summary.setAttribute("aria-haspopup", "menu");
            if (!summary.hasAttribute("role")) summary.setAttribute("role", "button");
        }
        const subscriptions = [
            $8449f1a811eb81cd$var$fromEvent(details, "compositionstart", (e)=>$8449f1a811eb81cd$var$trackComposition(this, e)),
            $8449f1a811eb81cd$var$fromEvent(details, "compositionend", (e)=>$8449f1a811eb81cd$var$trackComposition(this, e)),
            $8449f1a811eb81cd$var$fromEvent(details, "click", (e)=>$8449f1a811eb81cd$var$shouldCommit(details, e)),
            $8449f1a811eb81cd$var$fromEvent(details, "change", (e)=>$8449f1a811eb81cd$var$shouldCommit(details, e)),
            $8449f1a811eb81cd$var$fromEvent(details, "keydown", (e)=>$8449f1a811eb81cd$var$keydown(details, this, e)),
            $8449f1a811eb81cd$var$fromEvent(details, "toggle", ()=>$8449f1a811eb81cd$var$loadFragment(details, this), {
                once: true
            }),
            $8449f1a811eb81cd$var$fromEvent(details, "toggle", ()=>$8449f1a811eb81cd$var$closeCurrentMenu(details)),
            this.preload ? $8449f1a811eb81cd$var$fromEvent(details, "mouseover", ()=>$8449f1a811eb81cd$var$loadFragment(details, this), {
                once: true
            }) : $8449f1a811eb81cd$var$NullSubscription,
            ...$8449f1a811eb81cd$var$focusOnOpen(details)
        ];
        $8449f1a811eb81cd$var$states.set(this, {
            subscriptions: subscriptions,
            loaded: false,
            isComposing: false
        });
    }
    disconnectedCallback() {
        const state = $8449f1a811eb81cd$var$states.get(this);
        if (!state) return;
        $8449f1a811eb81cd$var$states.delete(this);
        for (const sub of state.subscriptions)sub.unsubscribe();
    }
}
const $8449f1a811eb81cd$var$states = new WeakMap();
const $8449f1a811eb81cd$var$NullSubscription = {
    unsubscribe () {}
};
function $8449f1a811eb81cd$var$fromEvent(target, eventName, onNext, options = false) {
    target.addEventListener(eventName, onNext, options);
    return {
        unsubscribe: ()=>{
            target.removeEventListener(eventName, onNext, options);
        }
    };
}
function $8449f1a811eb81cd$var$loadFragment(details, menu) {
    const src = menu.getAttribute("src");
    if (!src) return;
    const state = $8449f1a811eb81cd$var$states.get(menu);
    if (!state) return;
    if (state.loaded) return;
    state.loaded = true;
    const loader = menu.querySelector("include-fragment");
    if (loader && !loader.hasAttribute("src")) {
        loader.addEventListener("loadend", ()=>$8449f1a811eb81cd$var$autofocus(details));
        loader.setAttribute("src", src);
    }
}
function $8449f1a811eb81cd$var$focusOnOpen(details) {
    let isMouse = false;
    const onmousedown = ()=>isMouse = true;
    const onkeydown = ()=>isMouse = false;
    const ontoggle = ()=>{
        if (!details.hasAttribute("open")) return;
        if ($8449f1a811eb81cd$var$autofocus(details)) return;
        if (!isMouse) $8449f1a811eb81cd$var$focusFirstItem(details);
    };
    return [
        $8449f1a811eb81cd$var$fromEvent(details, "mousedown", onmousedown),
        $8449f1a811eb81cd$var$fromEvent(details, "keydown", onkeydown),
        $8449f1a811eb81cd$var$fromEvent(details, "toggle", ontoggle)
    ];
}
function $8449f1a811eb81cd$var$closeCurrentMenu(details) {
    if (!details.hasAttribute("open")) return;
    for (const menu of document.querySelectorAll("details[open] > details-menu")){
        const opened = menu.closest("details");
        if (opened && opened !== details && !opened.contains(details)) opened.removeAttribute("open");
    }
}
function $8449f1a811eb81cd$var$autofocus(details) {
    if (!details.hasAttribute("open")) return false;
    const input = details.querySelector("details-menu [autofocus]");
    if (input) {
        input.focus();
        return true;
    } else return false;
}
function $8449f1a811eb81cd$var$focusFirstItem(details) {
    const selected = document.activeElement;
    if (selected && $8449f1a811eb81cd$var$isMenuItem(selected) && details.contains(selected)) return;
    const target = $8449f1a811eb81cd$var$sibling(details, true);
    if (target) target.focus();
}
function $8449f1a811eb81cd$var$sibling(details, next) {
    const options = Array.from(details.querySelectorAll('[role^="menuitem"]:not([hidden]):not([disabled])'));
    const selected = document.activeElement;
    const index = selected instanceof HTMLElement ? options.indexOf(selected) : -1;
    const found = next ? options[index + 1] : options[index - 1];
    const def = next ? options[0] : options[options.length - 1];
    return found || def;
}
const $8449f1a811eb81cd$var$ctrlBindings = navigator.userAgent.match(/Macintosh/);
function $8449f1a811eb81cd$var$shouldCommit(details, event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest("details") !== details) return;
    if (event.type === "click") {
        const menuitem = target.closest('[role="menuitem"], [role="menuitemradio"]');
        if (!menuitem) return;
        const input = menuitem.querySelector("input");
        if (menuitem.tagName === "LABEL" && target === input) return;
        const onlyCommitOnChangeEvent = menuitem.tagName === "LABEL" && input && !input.checked;
        if (!onlyCommitOnChangeEvent) $8449f1a811eb81cd$var$commit(menuitem, details);
    } else if (event.type === "change") {
        const menuitem = target.closest('[role="menuitemradio"], [role="menuitemcheckbox"]');
        if (menuitem) $8449f1a811eb81cd$var$commit(menuitem, details);
    }
}
function $8449f1a811eb81cd$var$updateChecked(selected, details) {
    for (const el of details.querySelectorAll('[role="menuitemradio"], [role="menuitemcheckbox"]')){
        const input = el.querySelector('input[type="radio"], input[type="checkbox"]');
        let checkState = (el === selected).toString();
        if (input instanceof HTMLInputElement) checkState = input.indeterminate ? "mixed" : input.checked.toString();
        el.setAttribute("aria-checked", checkState);
    }
}
function $8449f1a811eb81cd$var$commit(selected, details) {
    if (selected.hasAttribute("disabled") || selected.getAttribute("aria-disabled") === "true") return;
    const menu = selected.closest("details-menu");
    if (!menu) return;
    const dispatched = menu.dispatchEvent(new CustomEvent("details-menu-select", {
        cancelable: true,
        detail: {
            relatedTarget: selected
        }
    }));
    if (!dispatched) return;
    $8449f1a811eb81cd$var$updateLabel(selected, details);
    $8449f1a811eb81cd$var$updateChecked(selected, details);
    if (selected.getAttribute("role") !== "menuitemcheckbox") $8449f1a811eb81cd$var$close(details);
    menu.dispatchEvent(new CustomEvent("details-menu-selected", {
        detail: {
            relatedTarget: selected
        }
    }));
}
function $8449f1a811eb81cd$var$keydown(details, menu, event) {
    if (!(event instanceof KeyboardEvent)) return;
    if (details.querySelector("details[open]")) return;
    const state = $8449f1a811eb81cd$var$states.get(menu);
    if (!state || state.isComposing) return;
    const isSummaryFocused = event.target instanceof Element && event.target.tagName === "SUMMARY";
    switch(event.key){
        case "Escape":
            if (details.hasAttribute("open")) {
                $8449f1a811eb81cd$var$close(details);
                event.preventDefault();
                event.stopPropagation();
            }
            break;
        case "ArrowDown":
            {
                if (isSummaryFocused && !details.hasAttribute("open")) details.setAttribute("open", "");
                const target = $8449f1a811eb81cd$var$sibling(details, true);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case "ArrowUp":
            {
                if (isSummaryFocused && !details.hasAttribute("open")) details.setAttribute("open", "");
                const target = $8449f1a811eb81cd$var$sibling(details, false);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case "n":
            if ($8449f1a811eb81cd$var$ctrlBindings && event.ctrlKey) {
                const target = $8449f1a811eb81cd$var$sibling(details, true);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case "p":
            if ($8449f1a811eb81cd$var$ctrlBindings && event.ctrlKey) {
                const target = $8449f1a811eb81cd$var$sibling(details, false);
                if (target) target.focus();
                event.preventDefault();
            }
            break;
        case " ":
        case "Enter":
            {
                const selected = document.activeElement;
                if (selected instanceof HTMLElement && $8449f1a811eb81cd$var$isMenuItem(selected) && selected.closest("details") === details) {
                    event.preventDefault();
                    event.stopPropagation();
                    selected.click();
                }
            }
            break;
    }
}
function $8449f1a811eb81cd$var$isMenuItem(el) {
    const role = el.getAttribute("role");
    return role === "menuitem" || role === "menuitemcheckbox" || role === "menuitemradio";
}
function $8449f1a811eb81cd$var$close(details) {
    const wasOpen = details.hasAttribute("open");
    if (!wasOpen) return;
    details.removeAttribute("open");
    const summary = details.querySelector("summary");
    if (summary) summary.focus();
}
function $8449f1a811eb81cd$var$updateLabel(item, details) {
    const button = details.querySelector("[data-menu-button]");
    if (!button) return;
    const text = $8449f1a811eb81cd$var$labelText(item);
    if (text) button.textContent = text;
    else {
        const html = $8449f1a811eb81cd$var$labelHTML(item);
        if (html) button.innerHTML = html;
    }
}
function $8449f1a811eb81cd$var$labelText(el) {
    if (!el) return null;
    const textEl = el.hasAttribute("data-menu-button-text") ? el : el.querySelector("[data-menu-button-text]");
    if (!textEl) return null;
    return textEl.getAttribute("data-menu-button-text") || textEl.textContent;
}
function $8449f1a811eb81cd$var$labelHTML(el) {
    if (!el) return null;
    const contentsEl = el.hasAttribute("data-menu-button-contents") ? el : el.querySelector("[data-menu-button-contents]");
    return contentsEl ? contentsEl.innerHTML : null;
}
function $8449f1a811eb81cd$var$trackComposition(menu, event) {
    const state = $8449f1a811eb81cd$var$states.get(menu);
    if (!state) return;
    state.isComposing = event.type === "compositionstart";
}
var $8449f1a811eb81cd$export$2e2bcd8739ae039 = $8449f1a811eb81cd$var$DetailsMenuElement;
if (!window.customElements.get("details-menu")) {
    window.DetailsMenuElement = $8449f1a811eb81cd$var$DetailsMenuElement;
    window.customElements.define("details-menu", $8449f1a811eb81cd$var$DetailsMenuElement);
}


class $60111cd6ea196be2$export$71e4db985cfcf9e3 {
    constructor(file, directory){
        this.file = file;
        this.directory = directory;
        this.state = "pending";
        this.id = null;
        this.href = null;
        this.name = null;
        this.percent = 0;
    }
    static traverse(transfer, directory) {
        return $60111cd6ea196be2$var$transferredFiles(transfer, directory);
    }
    static from(files) {
        const result = [];
        for (const file of files){
            if (file instanceof File) result.push(new $60111cd6ea196be2$export$71e4db985cfcf9e3(file));
            else if (file instanceof $60111cd6ea196be2$export$71e4db985cfcf9e3) result.push(file);
            else throw new Error("Unexpected type");
        }
        return result;
    }
    get fullPath() {
        return this.directory ? `${this.directory}/${this.file.name}` : this.file.name;
    }
    isImage() {
        return [
            "image/gif",
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/svg+xml"
        ].indexOf(this.file.type) > -1;
    }
    isVideo() {
        return [
            "video/mp4",
            "video/quicktime"
        ].indexOf(this.file.type) > -1;
    }
    saving(percent) {
        if (this.state !== "pending" && this.state !== "saving") throw new Error(`Unexpected transition from ${this.state} to saving`);
        this.state = "saving";
        this.percent = percent;
    }
    saved(attributes) {
        var _a, _b, _c;
        if (this.state !== "pending" && this.state !== "saving") throw new Error(`Unexpected transition from ${this.state} to saved`);
        this.state = "saved";
        this.id = (_a = attributes === null || attributes === void 0 ? void 0 : attributes.id) !== null && _a !== void 0 ? _a : null;
        this.href = (_b = attributes === null || attributes === void 0 ? void 0 : attributes.href) !== null && _b !== void 0 ? _b : null;
        this.name = (_c = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _c !== void 0 ? _c : null;
    }
    isPending() {
        return this.state === "pending";
    }
    isSaving() {
        return this.state === "saving";
    }
    isSaved() {
        return this.state === "saved";
    }
}
function $60111cd6ea196be2$var$transferredFiles(transfer, directory) {
    if (directory && $60111cd6ea196be2$var$isDirectory(transfer)) return $60111cd6ea196be2$var$traverse("", $60111cd6ea196be2$var$roots(transfer));
    return Promise.resolve($60111cd6ea196be2$var$visible(Array.from(transfer.files || [])).map((f)=>new $60111cd6ea196be2$export$71e4db985cfcf9e3(f)));
}
function $60111cd6ea196be2$var$hidden(file) {
    return file.name.startsWith(".");
}
function $60111cd6ea196be2$var$visible(files) {
    return Array.from(files).filter((file)=>!$60111cd6ea196be2$var$hidden(file));
}
function $60111cd6ea196be2$var$getFile(entry) {
    return new Promise(function(resolve, reject) {
        entry.file(resolve, reject);
    });
}
function $60111cd6ea196be2$var$getEntries(entry) {
    return new Promise(function(resolve, reject) {
        const result = [];
        const reader = entry.createReader();
        const read = ()=>{
            reader.readEntries((entries)=>{
                if (entries.length > 0) {
                    result.push(...entries);
                    read();
                } else resolve(result);
            }, reject);
        };
        read();
    });
}
async function $60111cd6ea196be2$var$traverse(path, entries) {
    const results = [];
    for (const entry of $60111cd6ea196be2$var$visible(entries))if (entry.isDirectory) results.push(...await $60111cd6ea196be2$var$traverse(entry.fullPath, await $60111cd6ea196be2$var$getEntries(entry)));
    else {
        const file = await $60111cd6ea196be2$var$getFile(entry);
        results.push(new $60111cd6ea196be2$export$71e4db985cfcf9e3(file, path));
    }
    return results;
}
function $60111cd6ea196be2$var$isDirectory(transfer) {
    return transfer.items && Array.from(transfer.items).some((item)=>{
        const entry = item.webkitGetAsEntry && item.webkitGetAsEntry();
        return entry && entry.isDirectory;
    });
}
function $60111cd6ea196be2$var$roots(transfer) {
    return Array.from(transfer.items).map((item)=>item.webkitGetAsEntry()).filter((entry)=>entry != null);
}
class $60111cd6ea196be2$var$FileAttachmentElement extends HTMLElement {
    connectedCallback() {
        this.addEventListener("dragenter", $60111cd6ea196be2$var$onDragenter);
        this.addEventListener("dragover", $60111cd6ea196be2$var$onDragenter);
        this.addEventListener("dragleave", $60111cd6ea196be2$var$onDragleave);
        this.addEventListener("drop", $60111cd6ea196be2$var$onDrop);
        this.addEventListener("paste", $60111cd6ea196be2$var$onPaste);
        this.addEventListener("change", $60111cd6ea196be2$var$onChange);
    }
    disconnectedCallback() {
        this.removeEventListener("dragenter", $60111cd6ea196be2$var$onDragenter);
        this.removeEventListener("dragover", $60111cd6ea196be2$var$onDragenter);
        this.removeEventListener("dragleave", $60111cd6ea196be2$var$onDragleave);
        this.removeEventListener("drop", $60111cd6ea196be2$var$onDrop);
        this.removeEventListener("paste", $60111cd6ea196be2$var$onPaste);
        this.removeEventListener("change", $60111cd6ea196be2$var$onChange);
    }
    get directory() {
        return this.hasAttribute("directory");
    }
    set directory(value) {
        if (value) this.setAttribute("directory", "");
        else this.removeAttribute("directory");
    }
    async attach(transferred) {
        const attachments = transferred instanceof DataTransfer ? await $60111cd6ea196be2$export$71e4db985cfcf9e3.traverse(transferred, this.directory) : $60111cd6ea196be2$export$71e4db985cfcf9e3.from(transferred);
        const accepted = this.dispatchEvent(new CustomEvent("file-attachment-accept", {
            bubbles: true,
            cancelable: true,
            detail: {
                attachments: attachments
            }
        }));
        if (accepted && attachments.length) this.dispatchEvent(new CustomEvent("file-attachment-accepted", {
            bubbles: true,
            detail: {
                attachments: attachments
            }
        }));
    }
}
function $60111cd6ea196be2$var$hasFile(transfer) {
    return Array.from(transfer.types).indexOf("Files") >= 0;
}
let $60111cd6ea196be2$var$dragging = null;
function $60111cd6ea196be2$var$onDragenter(event) {
    const target = event.currentTarget;
    if ($60111cd6ea196be2$var$dragging) clearTimeout($60111cd6ea196be2$var$dragging);
    $60111cd6ea196be2$var$dragging = window.setTimeout(()=>target.removeAttribute("hover"), 200);
    const transfer = event.dataTransfer;
    if (!transfer || !$60111cd6ea196be2$var$hasFile(transfer)) return;
    transfer.dropEffect = "copy";
    target.setAttribute("hover", "");
    event.preventDefault();
}
function $60111cd6ea196be2$var$onDragleave(event) {
    if (event.dataTransfer) event.dataTransfer.dropEffect = "none";
    const target = event.currentTarget;
    target.removeAttribute("hover");
    event.stopPropagation();
    event.preventDefault();
}
function $60111cd6ea196be2$var$onDrop(event) {
    const container = event.currentTarget;
    if (!(container instanceof $60111cd6ea196be2$var$FileAttachmentElement)) return;
    container.removeAttribute("hover");
    const transfer = event.dataTransfer;
    if (!transfer || !$60111cd6ea196be2$var$hasFile(transfer)) return;
    container.attach(transfer);
    event.stopPropagation();
    event.preventDefault();
}
const $60111cd6ea196be2$var$images = /^image\/(gif|png|jpeg)$/;
function $60111cd6ea196be2$var$pastedFile(items) {
    for (const item of items){
        if (item.kind === "file" && $60111cd6ea196be2$var$images.test(item.type)) return item.getAsFile();
    }
    return null;
}
function $60111cd6ea196be2$var$onPaste(event) {
    if (!event.clipboardData) return;
    if (!event.clipboardData.items) return;
    const container = event.currentTarget;
    if (!(container instanceof $60111cd6ea196be2$var$FileAttachmentElement)) return;
    const file = $60111cd6ea196be2$var$pastedFile(event.clipboardData.items);
    if (!file) return;
    const files = [
        file
    ];
    container.attach(files);
    event.preventDefault();
}
function $60111cd6ea196be2$var$onChange(event) {
    const container = event.currentTarget;
    if (!(container instanceof $60111cd6ea196be2$var$FileAttachmentElement)) return;
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const id = container.getAttribute("input");
    if (id && input.id !== id) return;
    const files = input.files;
    if (!files || files.length === 0) return;
    container.attach(files);
    input.value = "";
}
if (!window.customElements.get("file-attachment")) {
    window.FileAttachmentElement = $60111cd6ea196be2$var$FileAttachmentElement;
    window.customElements.define("file-attachment", $60111cd6ea196be2$var$FileAttachmentElement);
}
var $60111cd6ea196be2$export$2e2bcd8739ae039 = $60111cd6ea196be2$var$FileAttachmentElement;


class $4a0ea0d445e524c4$var$FilterInputElement extends HTMLElement {
    constructor(){
        super();
        this.currentQuery = null;
        this.filter = null;
        this.debounceInputChange = $4a0ea0d445e524c4$var$debounce(()=>$4a0ea0d445e524c4$var$filterResults(this, true));
        this.boundFilterResults = ()=>{
            $4a0ea0d445e524c4$var$filterResults(this, false);
        };
    }
    static get observedAttributes() {
        return [
            "aria-owns"
        ];
    }
    attributeChangedCallback(name, oldValue) {
        if (oldValue && name === "aria-owns") $4a0ea0d445e524c4$var$filterResults(this, false);
    }
    connectedCallback() {
        const input = this.input;
        if (!input) return;
        input.setAttribute("autocomplete", "off");
        input.setAttribute("spellcheck", "false");
        input.addEventListener("focus", this.boundFilterResults);
        input.addEventListener("change", this.boundFilterResults);
        input.addEventListener("input", this.debounceInputChange);
    }
    disconnectedCallback() {
        const input = this.input;
        if (!input) return;
        input.removeEventListener("focus", this.boundFilterResults);
        input.removeEventListener("change", this.boundFilterResults);
        input.removeEventListener("input", this.debounceInputChange);
    }
    get input() {
        const input = this.querySelector("input");
        return input instanceof HTMLInputElement ? input : null;
    }
    reset() {
        const input = this.input;
        if (input) {
            input.value = "";
            input.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        }
    }
}
async function $4a0ea0d445e524c4$var$filterResults(filterInput, checkCurrentQuery = false) {
    const input = filterInput.input;
    if (!input) return;
    const query = input.value.trim();
    const id = filterInput.getAttribute("aria-owns");
    if (!id) return;
    const container = document.getElementById(id);
    if (!container) return;
    const list = container.hasAttribute("data-filter-list") ? container : container.querySelector("[data-filter-list]");
    if (!list) return;
    filterInput.dispatchEvent(new CustomEvent("filter-input-start", {
        bubbles: true
    }));
    if (checkCurrentQuery && filterInput.currentQuery === query) return;
    filterInput.currentQuery = query;
    const filter = filterInput.filter || $4a0ea0d445e524c4$var$matchSubstring;
    const total = list.childElementCount;
    let count = 0;
    let hideNew = false;
    for (const item of Array.from(list.children)){
        if (!(item instanceof HTMLElement)) continue;
        const itemText = $4a0ea0d445e524c4$var$getText(item);
        const result = filter(item, itemText, query);
        if (result.hideNew === true) hideNew = result.hideNew;
        item.hidden = !result.match;
        if (result.match) count++;
    }
    const newItem = container.querySelector("[data-filter-new-item]");
    const showCreateOption = !!newItem && query.length > 0 && !hideNew;
    if (newItem instanceof HTMLElement) {
        newItem.hidden = !showCreateOption;
        if (showCreateOption) $4a0ea0d445e524c4$var$updateNewItem(newItem, query);
    }
    $4a0ea0d445e524c4$var$toggleBlankslate(container, count > 0 || showCreateOption);
    filterInput.dispatchEvent(new CustomEvent("filter-input-updated", {
        bubbles: true,
        detail: {
            count: count,
            total: total
        }
    }));
}
function $4a0ea0d445e524c4$var$matchSubstring(_item, itemText, query) {
    const match = itemText.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    return {
        match: match,
        hideNew: itemText === query
    };
}
function $4a0ea0d445e524c4$var$getText(filterableItem) {
    const target = filterableItem.querySelector("[data-filter-item-text]") || filterableItem;
    return (target.textContent || "").trim();
}
function $4a0ea0d445e524c4$var$updateNewItem(newItem, query) {
    const newItemText = newItem.querySelector("[data-filter-new-item-text]");
    if (newItemText) newItemText.textContent = query;
    const newItemValue = newItem.querySelector("[data-filter-new-item-value]");
    if (newItemValue instanceof HTMLInputElement || newItemValue instanceof HTMLButtonElement) newItemValue.value = query;
}
function $4a0ea0d445e524c4$var$toggleBlankslate(container, force) {
    const emptyState = container.querySelector("[data-filter-empty-state]");
    if (emptyState instanceof HTMLElement) emptyState.hidden = force;
}
function $4a0ea0d445e524c4$var$debounce(callback) {
    let timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            clearTimeout(timeout);
            callback();
        }, 300);
    };
}
var $4a0ea0d445e524c4$export$2e2bcd8739ae039 = $4a0ea0d445e524c4$var$FilterInputElement;
if (!window.customElements.get("filter-input")) {
    window.FilterInputElement = $4a0ea0d445e524c4$var$FilterInputElement;
    window.customElements.define("filter-input", $4a0ea0d445e524c4$var$FilterInputElement);
}


const $76c7154c799bf107$var$startPositions = new WeakMap();
const $76c7154c799bf107$var$dragStartPositions = new WeakMap();
const $76c7154c799bf107$var$constructedElements = new WeakMap();
function $76c7154c799bf107$var$moveCropArea(event) {
    const el = event.currentTarget;
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    const { box: box, image: image } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!box || !image) return;
    let deltaX = 0;
    let deltaY = 0;
    if (event instanceof KeyboardEvent) {
        if (event.key === "ArrowUp") deltaY = -1;
        else if (event.key === "ArrowDown") deltaY = 1;
        else if (event.key === "ArrowLeft") deltaX = -1;
        else if (event.key === "ArrowRight") deltaX = 1;
    } else if ($76c7154c799bf107$var$dragStartPositions.has(el) && event instanceof MouseEvent) {
        const pos = $76c7154c799bf107$var$dragStartPositions.get(el);
        deltaX = event.pageX - pos.dragStartX;
        deltaY = event.pageY - pos.dragStartY;
    } else if ($76c7154c799bf107$var$dragStartPositions.has(el) && event instanceof TouchEvent) {
        const { pageX: pageX, pageY: pageY } = event.changedTouches[0];
        const { dragStartX: dragStartX, dragStartY: dragStartY } = $76c7154c799bf107$var$dragStartPositions.get(el);
        deltaX = pageX - dragStartX;
        deltaY = pageY - dragStartY;
    }
    if (deltaX !== 0 || deltaY !== 0) {
        const x = Math.min(Math.max(0, box.offsetLeft + deltaX), image.width - box.offsetWidth);
        const y = Math.min(Math.max(0, box.offsetTop + deltaY), image.height - box.offsetHeight);
        box.style.left = `${x}px`;
        box.style.top = `${y}px`;
        $76c7154c799bf107$var$fireChangeEvent(el, {
            x: x,
            y: y,
            width: box.offsetWidth,
            height: box.offsetHeight
        });
    }
    if (event instanceof MouseEvent) $76c7154c799bf107$var$dragStartPositions.set(el, {
        dragStartX: event.pageX,
        dragStartY: event.pageY
    });
    else if (event instanceof TouchEvent) {
        const { pageX: pageX, pageY: pageY } = event.changedTouches[0];
        $76c7154c799bf107$var$dragStartPositions.set(el, {
            dragStartX: pageX,
            dragStartY: pageY
        });
    }
}
function $76c7154c799bf107$var$updateCropArea(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const el = $76c7154c799bf107$var$getShadowHost(target);
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    const { box: box } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!box) return;
    const rect = el.getBoundingClientRect();
    let deltaX, deltaY, delta;
    if (event instanceof KeyboardEvent) {
        if (event.key === "Escape") return $76c7154c799bf107$var$setInitialPosition(el);
        if (event.key === "-") delta = -10;
        if (event.key === "=") delta = 10;
        if (!delta) return;
        deltaX = box.offsetWidth + delta;
        deltaY = box.offsetHeight + delta;
        $76c7154c799bf107$var$startPositions.set(el, {
            startX: box.offsetLeft,
            startY: box.offsetTop
        });
    } else if (event instanceof MouseEvent) {
        const pos = $76c7154c799bf107$var$startPositions.get(el);
        if (!pos) return;
        deltaX = event.pageX - pos.startX - rect.left - window.pageXOffset;
        deltaY = event.pageY - pos.startY - rect.top - window.pageYOffset;
    } else if (event instanceof TouchEvent) {
        const pos = $76c7154c799bf107$var$startPositions.get(el);
        if (!pos) return;
        deltaX = event.changedTouches[0].pageX - pos.startX - rect.left - window.pageXOffset;
        deltaY = event.changedTouches[0].pageY - pos.startY - rect.top - window.pageYOffset;
    }
    if (deltaX && deltaY) $76c7154c799bf107$var$updateDimensions(el, deltaX, deltaY, !(event instanceof KeyboardEvent));
}
function $76c7154c799bf107$var$getShadowHost(el) {
    const rootNode = el.getRootNode();
    if (!(rootNode instanceof ShadowRoot)) return el;
    return rootNode.host;
}
function $76c7154c799bf107$var$startUpdate(event) {
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLElement)) return;
    const el = $76c7154c799bf107$var$getShadowHost(currentTarget);
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    const { box: box } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!box) return;
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.hasAttribute("data-direction")) {
        const direction = target.getAttribute("data-direction") || "";
        el.addEventListener("mousemove", $76c7154c799bf107$var$updateCropArea);
        el.addEventListener("touchmove", $76c7154c799bf107$var$updateCropArea, {
            passive: true
        });
        if ([
            "nw",
            "se"
        ].indexOf(direction) >= 0) el.classList.add("nwse");
        if ([
            "ne",
            "sw"
        ].indexOf(direction) >= 0) el.classList.add("nesw");
        $76c7154c799bf107$var$startPositions.set(el, {
            startX: box.offsetLeft + ([
                "se",
                "ne"
            ].indexOf(direction) >= 0 ? 0 : box.offsetWidth),
            startY: box.offsetTop + ([
                "se",
                "sw"
            ].indexOf(direction) >= 0 ? 0 : box.offsetHeight)
        });
        $76c7154c799bf107$var$updateCropArea(event);
    } else {
        el.addEventListener("mousemove", $76c7154c799bf107$var$moveCropArea);
        el.addEventListener("touchmove", $76c7154c799bf107$var$moveCropArea, {
            passive: true
        });
    }
}
function $76c7154c799bf107$var$updateDimensions(target, deltaX, deltaY, reposition = true) {
    let newSide = Math.max(Math.abs(deltaX), Math.abs(deltaY), 10);
    const pos = $76c7154c799bf107$var$startPositions.get(target);
    if (!pos) return;
    const { box: box, image: image } = $76c7154c799bf107$var$constructedElements.get(target) || {};
    if (!box || !image) return;
    newSide = Math.min(newSide, deltaY > 0 ? image.height - pos.startY : pos.startY, deltaX > 0 ? image.width - pos.startX : pos.startX);
    const x = reposition ? Math.round(Math.max(0, deltaX > 0 ? pos.startX : pos.startX - newSide)) : box.offsetLeft;
    const y = reposition ? Math.round(Math.max(0, deltaY > 0 ? pos.startY : pos.startY - newSide)) : box.offsetTop;
    box.style.left = `${x}px`;
    box.style.top = `${y}px`;
    box.style.width = `${newSide}px`;
    box.style.height = `${newSide}px`;
    $76c7154c799bf107$var$fireChangeEvent(target, {
        x: x,
        y: y,
        width: newSide,
        height: newSide
    });
}
function $76c7154c799bf107$var$setInitialPosition(el) {
    const { image: image } = $76c7154c799bf107$var$constructedElements.get(el) || {};
    if (!image) return;
    const side = Math.round(image.clientWidth > image.clientHeight ? image.clientHeight : image.clientWidth);
    $76c7154c799bf107$var$startPositions.set(el, {
        startX: (image.clientWidth - side) / 2,
        startY: (image.clientHeight - side) / 2
    });
    $76c7154c799bf107$var$updateDimensions(el, side, side);
}
function $76c7154c799bf107$var$stopUpdate(event) {
    const el = event.currentTarget;
    if (!(el instanceof $76c7154c799bf107$var$ImageCropElement)) return;
    $76c7154c799bf107$var$dragStartPositions.delete(el);
    el.classList.remove("nwse", "nesw");
    el.removeEventListener("mousemove", $76c7154c799bf107$var$updateCropArea);
    el.removeEventListener("mousemove", $76c7154c799bf107$var$moveCropArea);
    el.removeEventListener("touchmove", $76c7154c799bf107$var$updateCropArea);
    el.removeEventListener("touchmove", $76c7154c799bf107$var$moveCropArea);
}
function $76c7154c799bf107$var$fireChangeEvent(target, result) {
    const { image: image } = $76c7154c799bf107$var$constructedElements.get(target) || {};
    if (!image) return;
    const ratio = image.naturalWidth / image.width;
    for(const key in result){
        const value = Math.round(result[key] * ratio);
        result[key] = value;
        const slottedInput = target.querySelector(`[data-image-crop-input='${key}']`);
        if (slottedInput instanceof HTMLInputElement) slottedInput.value = value.toString();
    }
    target.dispatchEvent(new CustomEvent("image-crop-change", {
        bubbles: true,
        detail: result
    }));
}
class $76c7154c799bf107$var$ImageCropElement extends HTMLElement {
    connectedCallback() {
        if ($76c7154c799bf107$var$constructedElements.has(this)) return;
        const shadowRoot = this.attachShadow({
            mode: "open"
        });
        shadowRoot.innerHTML = `
<style>
  :host { touch-action: none; display: block; }
  :host(.nesw) { cursor: nesw-resize; }
  :host(.nwse) { cursor: nwse-resize; }
  :host(.nesw) .crop-box, :host(.nwse) .crop-box { cursor: inherit; }
  :host([loaded]) .crop-image { display: block; }
  :host([loaded]) ::slotted([data-loading-slot]), .crop-image { display: none; }

  .crop-wrapper {
    position: relative;
    font-size: 0;
  }
  .crop-container {
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    position: absolute;
    overflow: hidden;
    z-index: 1;
    top: 0;
    width: 100%;
    height: 100%;
  }

  :host([rounded]) .crop-box {
    border-radius: 50%;
    box-shadow: 0 0 0 4000px rgba(0, 0, 0, 0.3);
  }
  .crop-box {
    position: absolute;
    border: 1px dashed #fff;
    box-sizing: border-box;
    cursor: move;
  }

  :host([rounded]) .crop-outline {
    outline: none;
  }
  .crop-outline {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    outline: 4000px solid rgba(0, 0, 0, .3);
  }

  .handle { position: absolute; }
  :host([rounded]) .handle::before { border-radius: 50%; }
  .handle:before {
    position: absolute;
    display: block;
    padding: 4px;
    transform: translate(-50%, -50%);
    content: ' ';
    background: #fff;
    border: 1px solid #767676;
  }
  .ne { top: 0; right: 0; cursor: nesw-resize; }
  .nw { top: 0; left: 0; cursor: nwse-resize; }
  .se { bottom: 0; right: 0; cursor: nwse-resize; }
  .sw { bottom: 0; left: 0; cursor: nesw-resize; }
</style>
<slot></slot>
<div class="crop-wrapper">
  <img width="100%" class="crop-image" alt="">
  <div class="crop-container">
    <div data-crop-box class="crop-box">
      <div class="crop-outline"></div>
      <div data-direction="nw" class="handle nw"></div>
      <div data-direction="ne" class="handle ne"></div>
      <div data-direction="sw" class="handle sw"></div>
      <div data-direction="se" class="handle se"></div>
    </div>
  </div>
</div>
`;
        const box = shadowRoot.querySelector("[data-crop-box]");
        if (!(box instanceof HTMLElement)) return;
        const image = shadowRoot.querySelector("img");
        if (!(image instanceof HTMLImageElement)) return;
        $76c7154c799bf107$var$constructedElements.set(this, {
            box: box,
            image: image
        });
        image.addEventListener("load", ()=>{
            this.loaded = true;
            $76c7154c799bf107$var$setInitialPosition(this);
        });
        this.addEventListener("mouseleave", $76c7154c799bf107$var$stopUpdate);
        this.addEventListener("touchend", $76c7154c799bf107$var$stopUpdate);
        this.addEventListener("mouseup", $76c7154c799bf107$var$stopUpdate);
        box.addEventListener("mousedown", $76c7154c799bf107$var$startUpdate);
        box.addEventListener("touchstart", $76c7154c799bf107$var$startUpdate, {
            passive: true
        });
        this.addEventListener("keydown", $76c7154c799bf107$var$moveCropArea);
        this.addEventListener("keydown", $76c7154c799bf107$var$updateCropArea);
        if (this.src) image.src = this.src;
    }
    static get observedAttributes() {
        return [
            "src"
        ];
    }
    get src() {
        return this.getAttribute("src");
    }
    set src(val) {
        if (val) this.setAttribute("src", val);
        else this.removeAttribute("src");
    }
    get loaded() {
        return this.hasAttribute("loaded");
    }
    set loaded(val) {
        if (val) this.setAttribute("loaded", "");
        else this.removeAttribute("loaded");
    }
    attributeChangedCallback(attribute, oldValue, newValue) {
        const { image: image } = $76c7154c799bf107$var$constructedElements.get(this) || {};
        if (attribute === "src") {
            this.loaded = false;
            if (image) image.src = newValue;
        }
    }
}
var $76c7154c799bf107$export$2e2bcd8739ae039 = $76c7154c799bf107$var$ImageCropElement;
if (!window.customElements.get("image-crop")) {
    window.ImageCropElement = $76c7154c799bf107$var$ImageCropElement;
    window.customElements.define("image-crop", $76c7154c799bf107$var$ImageCropElement);
}


var $e10f768813a7f4c9$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e10f768813a7f4c9$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData, $e10f768813a7f4c9$var$_IncludeFragmentElement_getData, $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData, $e10f768813a7f4c9$var$_IncludeFragmentElement_task, $e10f768813a7f4c9$var$_IncludeFragmentElement_fetchDataWithEvents;
const $e10f768813a7f4c9$var$privateData = new WeakMap();
function $e10f768813a7f4c9$var$isWildcard(accept) {
    return accept && !!accept.split(",").find((x)=>x.match(/^\s*\*\/\*/));
}
let $e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise = null;
class $e10f768813a7f4c9$export$65e04f6f22ddde0e extends HTMLElement {
    constructor(){
        super(...arguments);
        $e10f768813a7f4c9$var$_IncludeFragmentElement_instances.add(this);
        $e10f768813a7f4c9$var$_IncludeFragmentElement_busy.set(this, false);
        $e10f768813a7f4c9$var$_IncludeFragmentElement_observer.set(this, new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) {
                const { target: target } = entry;
                $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, "f").unobserve(target);
                if (!(target instanceof $e10f768813a7f4c9$export$65e04f6f22ddde0e)) return;
                if (target.loading === "lazy") $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
            }
        }, {
            rootMargin: "0px 0px 256px 0px",
            threshold: 0.01
        }));
    }
    static define(tag = "include-fragment", registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    static setCSPTrustedTypesPolicy(policy) {
        $e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise = policy === null ? policy : Promise.resolve(policy);
    }
    static get observedAttributes() {
        return [
            "src",
            "loading"
        ];
    }
    get src() {
        const src = this.getAttribute("src");
        if (src) {
            const link = this.ownerDocument.createElement("a");
            link.href = src;
            return link.href;
        } else return "";
    }
    set src(val) {
        this.setAttribute("src", val);
    }
    get loading() {
        if (this.getAttribute("loading") === "lazy") return "lazy";
        return "eager";
    }
    set loading(value) {
        this.setAttribute("loading", value);
    }
    get accept() {
        return this.getAttribute("accept") || "";
    }
    set accept(val) {
        this.setAttribute("accept", val);
    }
    get data() {
        return $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData).call(this);
    }
    attributeChangedCallback(attribute, oldVal) {
        if (attribute === "src") {
            if (this.isConnected && this.loading === "eager") $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
        } else if (attribute === "loading") {
            if (this.isConnected && oldVal !== "eager" && this.loading === "eager") $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
        }
    }
    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({
                mode: "open"
            });
            const style = document.createElement("style");
            style.textContent = `:host {display: block;}`;
            this.shadowRoot.append(style, document.createElement("slot"));
        }
        if (this.src && this.loading === "eager") $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
        if (this.loading === "lazy") $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, "f").observe(this);
    }
    request() {
        const src = this.src;
        if (!src) throw new Error("missing src");
        return new Request(src, {
            method: "GET",
            credentials: "same-origin",
            headers: {
                Accept: this.accept || "text/html"
            }
        });
    }
    load() {
        return $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData).call(this);
    }
    fetch(request) {
        return fetch(request);
    }
    refetch() {
        $e10f768813a7f4c9$var$privateData.delete(this);
        $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData).call(this);
    }
}
$e10f768813a7f4c9$var$_IncludeFragmentElement_busy = new WeakMap(), $e10f768813a7f4c9$var$_IncludeFragmentElement_observer = new WeakMap(), $e10f768813a7f4c9$var$_IncludeFragmentElement_instances = new WeakSet(), $e10f768813a7f4c9$var$_IncludeFragmentElement_handleData = async function _IncludeFragmentElement_handleData() {
    if ($e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, "f")) return;
    $e10f768813a7f4c9$var$__classPrivateFieldSet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, true, "f");
    $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_observer, "f").unobserve(this);
    try {
        const data = await $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getData).call(this);
        if (data instanceof Error) throw data;
        const dataTreatedAsString = data;
        const template = document.createElement("template");
        template.innerHTML = dataTreatedAsString;
        const fragment = document.importNode(template.content, true);
        const canceled = !this.dispatchEvent(new CustomEvent("include-fragment-replace", {
            cancelable: true,
            detail: {
                fragment: fragment
            }
        }));
        if (canceled) {
            $e10f768813a7f4c9$var$__classPrivateFieldSet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, false, "f");
            return;
        }
        this.replaceWith(fragment);
        this.dispatchEvent(new CustomEvent("include-fragment-replaced"));
    } catch (_a) {
        this.classList.add("is-error");
    } finally{
        $e10f768813a7f4c9$var$__classPrivateFieldSet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_busy, false, "f");
    }
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_getData = async function _IncludeFragmentElement_getData() {
    const src = this.src;
    const cachedData = $e10f768813a7f4c9$var$privateData.get(this);
    if (cachedData && cachedData.src === src) return cachedData.data;
    else {
        let data;
        if (src) data = $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_fetchDataWithEvents).call(this);
        else data = Promise.reject(new Error("missing src"));
        $e10f768813a7f4c9$var$privateData.set(this, {
            src: src,
            data: data
        });
        return data;
    }
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_getStringOrErrorData = async function _IncludeFragmentElement_getStringOrErrorData() {
    const data = await $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_getData).call(this);
    if (data instanceof Error) throw data;
    return data.toString();
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_task = async function _IncludeFragmentElement_task(eventsToDispatch) {
    await new Promise((resolve)=>setTimeout(resolve, 0));
    for (const eventType of eventsToDispatch)this.dispatchEvent(new Event(eventType));
}, $e10f768813a7f4c9$var$_IncludeFragmentElement_fetchDataWithEvents = async function _IncludeFragmentElement_fetchDataWithEvents() {
    try {
        await $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_task).call(this, [
            "loadstart"
        ]);
        const response = await this.fetch(this.request());
        if (response.status !== 200) throw new Error(`Failed to load resource: the server responded with a status of ${response.status}`);
        const ct = response.headers.get("Content-Type");
        if (!$e10f768813a7f4c9$var$isWildcard(this.accept) && (!ct || !ct.includes(this.accept ? this.accept : "text/html"))) throw new Error(`Failed to load resource: expected ${this.accept || "text/html"} but was ${ct}`);
        const responseText = await response.text();
        let data = responseText;
        if ($e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise) {
            const cspTrustedTypesPolicy = await $e10f768813a7f4c9$var$cspTrustedTypesPolicyPromise;
            data = cspTrustedTypesPolicy.createHTML(responseText, response);
        }
        $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_task).call(this, [
            "load",
            "loadend"
        ]);
        return data;
    } catch (error) {
        $e10f768813a7f4c9$var$__classPrivateFieldGet(this, $e10f768813a7f4c9$var$_IncludeFragmentElement_instances, "m", $e10f768813a7f4c9$var$_IncludeFragmentElement_task).call(this, [
            "error",
            "loadend"
        ]);
        throw error;
    }
};



const $9871d058a4ab7a2d$var$root = typeof globalThis !== "undefined" ? globalThis : window;
try {
    $9871d058a4ab7a2d$var$root.IncludeFragmentElement = (0, $e10f768813a7f4c9$export$65e04f6f22ddde0e).define();
} catch (e) {
    if (!($9871d058a4ab7a2d$var$root.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) throw e;
}
var $9871d058a4ab7a2d$export$2e2bcd8739ae039 = (0, $e10f768813a7f4c9$export$65e04f6f22ddde0e);


var $4941bdcfe743ed78$export$2e2bcd8739ae039 = (0, $e10f768813a7f4c9$export$65e04f6f22ddde0e);


var $cb3b1a5cab3c6120$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances, $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle;
const $cb3b1a5cab3c6120$var$buttonSelectors = [
    "[data-md-button]",
    "md-header",
    "md-bold",
    "md-italic",
    "md-quote",
    "md-code",
    "md-link",
    "md-image",
    "md-unordered-list",
    "md-ordered-list",
    "md-task-list",
    "md-mention",
    "md-ref",
    "md-strikethrough"
];
function $cb3b1a5cab3c6120$var$getButtons(toolbar) {
    const els = [];
    for (const button of toolbar.querySelectorAll($cb3b1a5cab3c6120$var$buttonSelectors.join(", "))){
        if (button.hidden || button.offsetWidth <= 0 && button.offsetHeight <= 0) continue;
        if (button.closest("markdown-toolbar") === toolbar) els.push(button);
    }
    return els;
}
function $cb3b1a5cab3c6120$var$keydown(fn) {
    return function(event) {
        if (event.key === " " || event.key === "Enter") fn(event);
    };
}
const $cb3b1a5cab3c6120$var$styles = new WeakMap();
const $cb3b1a5cab3c6120$var$manualStyles = {
    "header-1": {
        prefix: "# "
    },
    "header-2": {
        prefix: "## "
    },
    "header-3": {
        prefix: "### "
    },
    "header-4": {
        prefix: "#### "
    },
    "header-5": {
        prefix: "##### "
    },
    "header-6": {
        prefix: "###### "
    },
    bold: {
        prefix: "**",
        suffix: "**",
        trimFirst: true
    },
    italic: {
        prefix: "_",
        suffix: "_",
        trimFirst: true
    },
    quote: {
        prefix: "> ",
        multiline: true,
        surroundWithNewlines: true
    },
    code: {
        prefix: "`",
        suffix: "`",
        blockPrefix: "```",
        blockSuffix: "```"
    },
    link: {
        prefix: "[",
        suffix: "](url)",
        replaceNext: "url",
        scanFor: "https?://"
    },
    image: {
        prefix: "![",
        suffix: "](url)",
        replaceNext: "url",
        scanFor: "https?://"
    },
    "unordered-list": {
        prefix: "- ",
        multiline: true,
        unorderedList: true
    },
    "ordered-list": {
        prefix: "1. ",
        multiline: true,
        orderedList: true
    },
    "task-list": {
        prefix: "- [ ] ",
        multiline: true,
        surroundWithNewlines: true
    },
    mention: {
        prefix: "@",
        prefixSpace: true
    },
    ref: {
        prefix: "#",
        prefixSpace: true
    },
    strikethrough: {
        prefix: "~~",
        suffix: "~~",
        trimFirst: true
    }
};
class $cb3b1a5cab3c6120$var$MarkdownButtonElement extends HTMLElement {
    constructor(){
        super();
        const apply = (event)=>{
            const style = $cb3b1a5cab3c6120$var$styles.get(this);
            if (!style) return;
            event.preventDefault();
            $cb3b1a5cab3c6120$var$applyStyle(this, style);
        };
        this.addEventListener("keydown", $cb3b1a5cab3c6120$var$keydown(apply));
        this.addEventListener("click", apply);
    }
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "button");
    }
    click() {
        const style = $cb3b1a5cab3c6120$var$styles.get(this);
        if (!style) return;
        $cb3b1a5cab3c6120$var$applyStyle(this, style);
    }
}
class $cb3b1a5cab3c6120$var$MarkdownHeaderButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    constructor(){
        super(...arguments);
        $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances.add(this);
    }
    connectedCallback() {
        const level = parseInt(this.getAttribute("level") || "3", 10);
        $cb3b1a5cab3c6120$var$__classPrivateFieldGet(this, $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances, "m", $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
    }
    static get observedAttributes() {
        return [
            "level"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name !== "level") return;
        const level = parseInt(newValue || "3", 10);
        $cb3b1a5cab3c6120$var$__classPrivateFieldGet(this, $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances, "m", $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
    }
}
$cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_instances = new WeakSet(), $cb3b1a5cab3c6120$var$_MarkdownHeaderButtonElement_setLevelStyle = function _MarkdownHeaderButtonElement_setLevelStyle(level) {
    if (level < 1 || level > 6) return;
    const prefix = `${"#".repeat(level)} `;
    $cb3b1a5cab3c6120$var$styles.set(this, {
        prefix: prefix
    });
};
if (!window.customElements.get("md-header")) {
    window.MarkdownHeaderButtonElement = $cb3b1a5cab3c6120$var$MarkdownHeaderButtonElement;
    window.customElements.define("md-header", $cb3b1a5cab3c6120$var$MarkdownHeaderButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownBoldButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "**",
            suffix: "**",
            trimFirst: true
        });
    }
}
if (!window.customElements.get("md-bold")) {
    window.MarkdownBoldButtonElement = $cb3b1a5cab3c6120$var$MarkdownBoldButtonElement;
    window.customElements.define("md-bold", $cb3b1a5cab3c6120$var$MarkdownBoldButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownItalicButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "_",
            suffix: "_",
            trimFirst: true
        });
    }
}
if (!window.customElements.get("md-italic")) {
    window.MarkdownItalicButtonElement = $cb3b1a5cab3c6120$var$MarkdownItalicButtonElement;
    window.customElements.define("md-italic", $cb3b1a5cab3c6120$var$MarkdownItalicButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownQuoteButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "> ",
            multiline: true,
            surroundWithNewlines: true
        });
    }
}
if (!window.customElements.get("md-quote")) {
    window.MarkdownQuoteButtonElement = $cb3b1a5cab3c6120$var$MarkdownQuoteButtonElement;
    window.customElements.define("md-quote", $cb3b1a5cab3c6120$var$MarkdownQuoteButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownCodeButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "`",
            suffix: "`",
            blockPrefix: "```",
            blockSuffix: "```"
        });
    }
}
if (!window.customElements.get("md-code")) {
    window.MarkdownCodeButtonElement = $cb3b1a5cab3c6120$var$MarkdownCodeButtonElement;
    window.customElements.define("md-code", $cb3b1a5cab3c6120$var$MarkdownCodeButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownLinkButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "[",
            suffix: "](url)",
            replaceNext: "url",
            scanFor: "https?://"
        });
    }
}
if (!window.customElements.get("md-link")) {
    window.MarkdownLinkButtonElement = $cb3b1a5cab3c6120$var$MarkdownLinkButtonElement;
    window.customElements.define("md-link", $cb3b1a5cab3c6120$var$MarkdownLinkButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownImageButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "![",
            suffix: "](url)",
            replaceNext: "url",
            scanFor: "https?://"
        });
    }
}
if (!window.customElements.get("md-image")) {
    window.MarkdownImageButtonElement = $cb3b1a5cab3c6120$var$MarkdownImageButtonElement;
    window.customElements.define("md-image", $cb3b1a5cab3c6120$var$MarkdownImageButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownUnorderedListButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "- ",
            multiline: true,
            unorderedList: true
        });
    }
}
if (!window.customElements.get("md-unordered-list")) {
    window.MarkdownUnorderedListButtonElement = $cb3b1a5cab3c6120$var$MarkdownUnorderedListButtonElement;
    window.customElements.define("md-unordered-list", $cb3b1a5cab3c6120$var$MarkdownUnorderedListButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownOrderedListButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "1. ",
            multiline: true,
            orderedList: true
        });
    }
}
if (!window.customElements.get("md-ordered-list")) {
    window.MarkdownOrderedListButtonElement = $cb3b1a5cab3c6120$var$MarkdownOrderedListButtonElement;
    window.customElements.define("md-ordered-list", $cb3b1a5cab3c6120$var$MarkdownOrderedListButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownTaskListButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "- [ ] ",
            multiline: true,
            surroundWithNewlines: true
        });
    }
}
if (!window.customElements.get("md-task-list")) {
    window.MarkdownTaskListButtonElement = $cb3b1a5cab3c6120$var$MarkdownTaskListButtonElement;
    window.customElements.define("md-task-list", $cb3b1a5cab3c6120$var$MarkdownTaskListButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownMentionButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "@",
            prefixSpace: true
        });
    }
}
if (!window.customElements.get("md-mention")) {
    window.MarkdownMentionButtonElement = $cb3b1a5cab3c6120$var$MarkdownMentionButtonElement;
    window.customElements.define("md-mention", $cb3b1a5cab3c6120$var$MarkdownMentionButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownRefButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "#",
            prefixSpace: true
        });
    }
}
if (!window.customElements.get("md-ref")) {
    window.MarkdownRefButtonElement = $cb3b1a5cab3c6120$var$MarkdownRefButtonElement;
    window.customElements.define("md-ref", $cb3b1a5cab3c6120$var$MarkdownRefButtonElement);
}
class $cb3b1a5cab3c6120$var$MarkdownStrikethroughButtonElement extends $cb3b1a5cab3c6120$var$MarkdownButtonElement {
    connectedCallback() {
        $cb3b1a5cab3c6120$var$styles.set(this, {
            prefix: "~~",
            suffix: "~~",
            trimFirst: true
        });
    }
}
if (!window.customElements.get("md-strikethrough")) {
    window.MarkdownStrikethroughButtonElement = $cb3b1a5cab3c6120$var$MarkdownStrikethroughButtonElement;
    window.customElements.define("md-strikethrough", $cb3b1a5cab3c6120$var$MarkdownStrikethroughButtonElement);
}
function $cb3b1a5cab3c6120$var$applyFromToolbar(event) {
    const { target: target, currentTarget: currentTarget } = event;
    if (!(target instanceof Element)) return;
    const mdButton = target.closest("[data-md-button]");
    if (!mdButton || mdButton.closest("markdown-toolbar") !== currentTarget) return;
    const mdButtonStyle = mdButton.getAttribute("data-md-button");
    const style = $cb3b1a5cab3c6120$var$manualStyles[mdButtonStyle];
    if (!style) return;
    event.preventDefault();
    $cb3b1a5cab3c6120$var$applyStyle(target, style);
}
function $cb3b1a5cab3c6120$var$setFocusManagement(toolbar) {
    toolbar.addEventListener("keydown", $cb3b1a5cab3c6120$var$focusKeydown);
    toolbar.setAttribute("tabindex", "0");
    toolbar.addEventListener("focus", $cb3b1a5cab3c6120$var$onToolbarFocus, {
        once: true
    });
}
function $cb3b1a5cab3c6120$var$unsetFocusManagement(toolbar) {
    toolbar.removeEventListener("keydown", $cb3b1a5cab3c6120$var$focusKeydown);
    toolbar.removeAttribute("tabindex");
    toolbar.removeEventListener("focus", $cb3b1a5cab3c6120$var$onToolbarFocus);
}
class $cb3b1a5cab3c6120$var$MarkdownToolbarElement extends HTMLElement {
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "toolbar");
        if (!this.hasAttribute("data-no-focus")) $cb3b1a5cab3c6120$var$setFocusManagement(this);
        this.addEventListener("keydown", $cb3b1a5cab3c6120$var$keydown($cb3b1a5cab3c6120$var$applyFromToolbar));
        this.addEventListener("click", $cb3b1a5cab3c6120$var$applyFromToolbar);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name !== "data-no-focus") return;
        if (newValue === null) $cb3b1a5cab3c6120$var$setFocusManagement(this);
        else $cb3b1a5cab3c6120$var$unsetFocusManagement(this);
    }
    disconnectedCallback() {
        $cb3b1a5cab3c6120$var$unsetFocusManagement(this);
    }
    get field() {
        const id = this.getAttribute("for");
        if (!id) return null;
        const root = "getRootNode" in this ? this.getRootNode() : document;
        let field;
        if (root instanceof Document || root instanceof ShadowRoot) field = root.getElementById(id);
        return field instanceof HTMLTextAreaElement ? field : null;
    }
}
$cb3b1a5cab3c6120$var$MarkdownToolbarElement.observedAttributes = [
    "data-no-focus"
];
function $cb3b1a5cab3c6120$var$onToolbarFocus({ target: target }) {
    if (!(target instanceof Element)) return;
    target.removeAttribute("tabindex");
    let tabindex = "0";
    for (const button of $cb3b1a5cab3c6120$var$getButtons(target)){
        button.setAttribute("tabindex", tabindex);
        if (tabindex === "0") {
            button.focus();
            tabindex = "-1";
        }
    }
}
function $cb3b1a5cab3c6120$var$focusKeydown(event) {
    const key = event.key;
    if (key !== "ArrowRight" && key !== "ArrowLeft" && key !== "Home" && key !== "End") return;
    const toolbar = event.currentTarget;
    if (!(toolbar instanceof HTMLElement)) return;
    const buttons = $cb3b1a5cab3c6120$var$getButtons(toolbar);
    const index = buttons.indexOf(event.target);
    const length = buttons.length;
    if (index === -1) return;
    let n = 0;
    if (key === "ArrowLeft") n = index - 1;
    if (key === "ArrowRight") n = index + 1;
    if (key === "End") n = length - 1;
    if (n < 0) n = length - 1;
    if (n > length - 1) n = 0;
    for(let i = 0; i < length; i += 1)buttons[i].setAttribute("tabindex", i === n ? "0" : "-1");
    event.preventDefault();
    buttons[n].focus();
}
if (!window.customElements.get("markdown-toolbar")) {
    window.MarkdownToolbarElement = $cb3b1a5cab3c6120$var$MarkdownToolbarElement;
    window.customElements.define("markdown-toolbar", $cb3b1a5cab3c6120$var$MarkdownToolbarElement);
}
function $cb3b1a5cab3c6120$var$isMultipleLines(string) {
    return string.trim().split("\n").length > 1;
}
function $cb3b1a5cab3c6120$var$repeat(string, n) {
    return Array(n + 1).join(string);
}
function $cb3b1a5cab3c6120$var$wordSelectionStart(text, i) {
    let index = i;
    while(text[index] && text[index - 1] != null && !text[index - 1].match(/\s/))index--;
    return index;
}
function $cb3b1a5cab3c6120$var$wordSelectionEnd(text, i, multiline) {
    let index = i;
    const breakpoint = multiline ? /\n/ : /\s/;
    while(text[index] && !text[index].match(breakpoint))index++;
    return index;
}
let $cb3b1a5cab3c6120$var$canInsertText = null;
function $cb3b1a5cab3c6120$var$insertText(textarea, { text: text, selectionStart: selectionStart, selectionEnd: selectionEnd }) {
    const originalSelectionStart = textarea.selectionStart;
    const before = textarea.value.slice(0, originalSelectionStart);
    const after = textarea.value.slice(textarea.selectionEnd);
    if ($cb3b1a5cab3c6120$var$canInsertText === null || $cb3b1a5cab3c6120$var$canInsertText === true) {
        textarea.contentEditable = "true";
        try {
            $cb3b1a5cab3c6120$var$canInsertText = document.execCommand("insertText", false, text);
        } catch (error) {
            $cb3b1a5cab3c6120$var$canInsertText = false;
        }
        textarea.contentEditable = "false";
    }
    if ($cb3b1a5cab3c6120$var$canInsertText && !textarea.value.slice(0, textarea.selectionStart).endsWith(text)) $cb3b1a5cab3c6120$var$canInsertText = false;
    if (!$cb3b1a5cab3c6120$var$canInsertText) {
        try {
            document.execCommand("ms-beginUndoUnit");
        } catch (e) {}
        textarea.value = before + text + after;
        try {
            document.execCommand("ms-endUndoUnit");
        } catch (e) {}
        textarea.dispatchEvent(new CustomEvent("input", {
            bubbles: true,
            cancelable: true
        }));
    }
    if (selectionStart != null && selectionEnd != null) textarea.setSelectionRange(selectionStart, selectionEnd);
    else textarea.setSelectionRange(originalSelectionStart, textarea.selectionEnd);
}
function $cb3b1a5cab3c6120$var$styleSelectedText(textarea, styleArgs) {
    const text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    let result;
    if (styleArgs.orderedList || styleArgs.unorderedList) result = $cb3b1a5cab3c6120$var$listStyle(textarea, styleArgs);
    else if (styleArgs.multiline && $cb3b1a5cab3c6120$var$isMultipleLines(text)) result = $cb3b1a5cab3c6120$var$multilineStyle(textarea, styleArgs);
    else result = $cb3b1a5cab3c6120$var$blockStyle(textarea, styleArgs);
    $cb3b1a5cab3c6120$var$insertText(textarea, result);
}
function $cb3b1a5cab3c6120$var$expandSelectionToLine(textarea) {
    const lines = textarea.value.split("\n");
    let counter = 0;
    for(let index = 0; index < lines.length; index++){
        const lineLength = lines[index].length + 1;
        if (textarea.selectionStart >= counter && textarea.selectionStart < counter + lineLength) textarea.selectionStart = counter;
        if (textarea.selectionEnd >= counter && textarea.selectionEnd < counter + lineLength) textarea.selectionEnd = counter + lineLength - 1;
        counter += lineLength;
    }
}
function $cb3b1a5cab3c6120$var$expandSelectedText(textarea, prefixToUse, suffixToUse, multiline = false) {
    if (textarea.selectionStart === textarea.selectionEnd) {
        textarea.selectionStart = $cb3b1a5cab3c6120$var$wordSelectionStart(textarea.value, textarea.selectionStart);
        textarea.selectionEnd = $cb3b1a5cab3c6120$var$wordSelectionEnd(textarea.value, textarea.selectionEnd, multiline);
    } else {
        const expandedSelectionStart = textarea.selectionStart - prefixToUse.length;
        const expandedSelectionEnd = textarea.selectionEnd + suffixToUse.length;
        const beginsWithPrefix = textarea.value.slice(expandedSelectionStart, textarea.selectionStart) === prefixToUse;
        const endsWithSuffix = textarea.value.slice(textarea.selectionEnd, expandedSelectionEnd) === suffixToUse;
        if (beginsWithPrefix && endsWithSuffix) {
            textarea.selectionStart = expandedSelectionStart;
            textarea.selectionEnd = expandedSelectionEnd;
        }
    }
    return textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
}
function $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea) {
    const beforeSelection = textarea.value.slice(0, textarea.selectionStart);
    const afterSelection = textarea.value.slice(textarea.selectionEnd);
    const breaksBefore = beforeSelection.match(/\n*$/);
    const breaksAfter = afterSelection.match(/^\n*/);
    const newlinesBeforeSelection = breaksBefore ? breaksBefore[0].length : 0;
    const newlinesAfterSelection = breaksAfter ? breaksAfter[0].length : 0;
    let newlinesToAppend;
    let newlinesToPrepend;
    if (beforeSelection.match(/\S/) && newlinesBeforeSelection < 2) newlinesToAppend = $cb3b1a5cab3c6120$var$repeat("\n", 2 - newlinesBeforeSelection);
    if (afterSelection.match(/\S/) && newlinesAfterSelection < 2) newlinesToPrepend = $cb3b1a5cab3c6120$var$repeat("\n", 2 - newlinesAfterSelection);
    if (newlinesToAppend == null) newlinesToAppend = "";
    if (newlinesToPrepend == null) newlinesToPrepend = "";
    return {
        newlinesToAppend: newlinesToAppend,
        newlinesToPrepend: newlinesToPrepend
    };
}
function $cb3b1a5cab3c6120$var$blockStyle(textarea, arg) {
    let newlinesToAppend;
    let newlinesToPrepend;
    const { prefix: prefix, suffix: suffix, blockPrefix: blockPrefix, blockSuffix: blockSuffix, replaceNext: replaceNext, prefixSpace: prefixSpace, scanFor: scanFor, surroundWithNewlines: surroundWithNewlines } = arg;
    const originalSelectionStart = textarea.selectionStart;
    const originalSelectionEnd = textarea.selectionEnd;
    let selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    let prefixToUse = $cb3b1a5cab3c6120$var$isMultipleLines(selectedText) && blockPrefix.length > 0 ? `${blockPrefix}\n` : prefix;
    let suffixToUse = $cb3b1a5cab3c6120$var$isMultipleLines(selectedText) && blockSuffix.length > 0 ? `\n${blockSuffix}` : suffix;
    if (prefixSpace) {
        const beforeSelection = textarea.value[textarea.selectionStart - 1];
        if (textarea.selectionStart !== 0 && beforeSelection != null && !beforeSelection.match(/\s/)) prefixToUse = ` ${prefixToUse}`;
    }
    selectedText = $cb3b1a5cab3c6120$var$expandSelectedText(textarea, prefixToUse, suffixToUse, arg.multiline);
    let selectionStart = textarea.selectionStart;
    let selectionEnd = textarea.selectionEnd;
    const hasReplaceNext = replaceNext.length > 0 && suffixToUse.indexOf(replaceNext) > -1 && selectedText.length > 0;
    if (surroundWithNewlines) {
        const ref = $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea);
        newlinesToAppend = ref.newlinesToAppend;
        newlinesToPrepend = ref.newlinesToPrepend;
        prefixToUse = newlinesToAppend + prefix;
        suffixToUse += newlinesToPrepend;
    }
    if (selectedText.startsWith(prefixToUse) && selectedText.endsWith(suffixToUse)) {
        const replacementText = selectedText.slice(prefixToUse.length, selectedText.length - suffixToUse.length);
        if (originalSelectionStart === originalSelectionEnd) {
            let position = originalSelectionStart - prefixToUse.length;
            position = Math.max(position, selectionStart);
            position = Math.min(position, selectionStart + replacementText.length);
            selectionStart = selectionEnd = position;
        } else selectionEnd = selectionStart + replacementText.length;
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    } else if (!hasReplaceNext) {
        let replacementText = prefixToUse + selectedText + suffixToUse;
        selectionStart = originalSelectionStart + prefixToUse.length;
        selectionEnd = originalSelectionEnd + prefixToUse.length;
        const whitespaceEdges = selectedText.match(/^\s*|\s*$/g);
        if (arg.trimFirst && whitespaceEdges) {
            const leadingWhitespace = whitespaceEdges[0] || "";
            const trailingWhitespace = whitespaceEdges[1] || "";
            replacementText = leadingWhitespace + prefixToUse + selectedText.trim() + suffixToUse + trailingWhitespace;
            selectionStart += leadingWhitespace.length;
            selectionEnd -= trailingWhitespace.length;
        }
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    } else if (scanFor.length > 0 && selectedText.match(scanFor)) {
        suffixToUse = suffixToUse.replace(replaceNext, selectedText);
        const replacementText = prefixToUse + suffixToUse;
        selectionStart = selectionEnd = selectionStart + prefixToUse.length;
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    } else {
        const replacementText = prefixToUse + selectedText + suffixToUse;
        selectionStart = selectionStart + prefixToUse.length + selectedText.length + suffixToUse.indexOf(replaceNext);
        selectionEnd = selectionStart + replaceNext.length;
        return {
            text: replacementText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    }
}
function $cb3b1a5cab3c6120$var$multilineStyle(textarea, arg) {
    const { prefix: prefix, suffix: suffix, surroundWithNewlines: surroundWithNewlines } = arg;
    let text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    let selectionStart = textarea.selectionStart;
    let selectionEnd = textarea.selectionEnd;
    const lines = text.split("\n");
    const undoStyle = lines.every((line)=>line.startsWith(prefix) && line.endsWith(suffix));
    if (undoStyle) {
        text = lines.map((line)=>line.slice(prefix.length, line.length - suffix.length)).join("\n");
        selectionEnd = selectionStart + text.length;
    } else {
        text = lines.map((line)=>prefix + line + suffix).join("\n");
        if (surroundWithNewlines) {
            const { newlinesToAppend: newlinesToAppend, newlinesToPrepend: newlinesToPrepend } = $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea);
            selectionStart += newlinesToAppend.length;
            selectionEnd = selectionStart + text.length;
            text = newlinesToAppend + text + newlinesToPrepend;
        }
    }
    return {
        text: text,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
    };
}
function $cb3b1a5cab3c6120$var$undoOrderedListStyle(text) {
    const lines = text.split("\n");
    const orderedListRegex = /^\d+\.\s+/;
    const shouldUndoOrderedList = lines.every((line)=>orderedListRegex.test(line));
    let result = lines;
    if (shouldUndoOrderedList) result = lines.map((line)=>line.replace(orderedListRegex, ""));
    return {
        text: result.join("\n"),
        processed: shouldUndoOrderedList
    };
}
function $cb3b1a5cab3c6120$var$undoUnorderedListStyle(text) {
    const lines = text.split("\n");
    const unorderedListPrefix = "- ";
    const shouldUndoUnorderedList = lines.every((line)=>line.startsWith(unorderedListPrefix));
    let result = lines;
    if (shouldUndoUnorderedList) result = lines.map((line)=>line.slice(unorderedListPrefix.length, line.length));
    return {
        text: result.join("\n"),
        processed: shouldUndoUnorderedList
    };
}
function $cb3b1a5cab3c6120$var$makePrefix(index, unorderedList) {
    if (unorderedList) return "- ";
    else return `${index + 1}. `;
}
function $cb3b1a5cab3c6120$var$clearExistingListStyle(style, selectedText) {
    let undoResultOpositeList;
    let undoResult;
    let pristineText;
    if (style.orderedList) {
        undoResult = $cb3b1a5cab3c6120$var$undoOrderedListStyle(selectedText);
        undoResultOpositeList = $cb3b1a5cab3c6120$var$undoUnorderedListStyle(undoResult.text);
        pristineText = undoResultOpositeList.text;
    } else {
        undoResult = $cb3b1a5cab3c6120$var$undoUnorderedListStyle(selectedText);
        undoResultOpositeList = $cb3b1a5cab3c6120$var$undoOrderedListStyle(undoResult.text);
        pristineText = undoResultOpositeList.text;
    }
    return [
        undoResult,
        undoResultOpositeList,
        pristineText
    ];
}
function $cb3b1a5cab3c6120$var$listStyle(textarea, style) {
    const noInitialSelection = textarea.selectionStart === textarea.selectionEnd;
    let selectionStart = textarea.selectionStart;
    let selectionEnd = textarea.selectionEnd;
    $cb3b1a5cab3c6120$var$expandSelectionToLine(textarea);
    const selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
    const [undoResult, undoResultOpositeList, pristineText] = $cb3b1a5cab3c6120$var$clearExistingListStyle(style, selectedText);
    const prefixedLines = pristineText.split("\n").map((value, index)=>{
        return `${$cb3b1a5cab3c6120$var$makePrefix(index, style.unorderedList)}${value}`;
    });
    const totalPrefixLength = prefixedLines.reduce((previousValue, _currentValue, currentIndex)=>{
        return previousValue + $cb3b1a5cab3c6120$var$makePrefix(currentIndex, style.unorderedList).length;
    }, 0);
    const totalPrefixLengthOpositeList = prefixedLines.reduce((previousValue, _currentValue, currentIndex)=>{
        return previousValue + $cb3b1a5cab3c6120$var$makePrefix(currentIndex, !style.unorderedList).length;
    }, 0);
    if (undoResult.processed) {
        if (noInitialSelection) {
            selectionStart = Math.max(selectionStart - $cb3b1a5cab3c6120$var$makePrefix(0, style.unorderedList).length, 0);
            selectionEnd = selectionStart;
        } else {
            selectionStart = textarea.selectionStart;
            selectionEnd = textarea.selectionEnd - totalPrefixLength;
        }
        return {
            text: pristineText,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
    }
    const { newlinesToAppend: newlinesToAppend, newlinesToPrepend: newlinesToPrepend } = $cb3b1a5cab3c6120$var$newlinesToSurroundSelectedText(textarea);
    const text = newlinesToAppend + prefixedLines.join("\n") + newlinesToPrepend;
    if (noInitialSelection) {
        selectionStart = Math.max(selectionStart + $cb3b1a5cab3c6120$var$makePrefix(0, style.unorderedList).length + newlinesToAppend.length, 0);
        selectionEnd = selectionStart;
    } else if (undoResultOpositeList.processed) {
        selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
        selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength - totalPrefixLengthOpositeList;
    } else {
        selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
        selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength;
    }
    return {
        text: text,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
    };
}
function $cb3b1a5cab3c6120$var$applyStyle(button, stylesToApply) {
    const toolbar = button.closest("markdown-toolbar");
    if (!(toolbar instanceof $cb3b1a5cab3c6120$var$MarkdownToolbarElement)) return;
    const defaults = {
        prefix: "",
        suffix: "",
        blockPrefix: "",
        blockSuffix: "",
        multiline: false,
        replaceNext: "",
        prefixSpace: false,
        scanFor: "",
        surroundWithNewlines: false,
        orderedList: false,
        unorderedList: false,
        trimFirst: false
    };
    const style = Object.assign(Object.assign({}, defaults), stylesToApply);
    const field = toolbar.field;
    if (field) {
        field.focus();
        $cb3b1a5cab3c6120$var$styleSelectedText(field, style);
    }
}
var $cb3b1a5cab3c6120$export$2e2bcd8739ae039 = $cb3b1a5cab3c6120$var$MarkdownToolbarElement;


var $996dd9e14abad76e$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $996dd9e14abad76e$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $996dd9e14abad76e$var$_DurationFormat_options;
class $996dd9e14abad76e$var$ListFormatPonyFill {
    formatToParts(members) {
        const parts = [];
        for (const value of members){
            parts.push({
                type: "element",
                value: value
            });
            parts.push({
                type: "literal",
                value: ", "
            });
        }
        return parts.slice(0, -1);
    }
}
const $996dd9e14abad76e$var$ListFormat = typeof Intl !== "undefined" && Intl.ListFormat || $996dd9e14abad76e$var$ListFormatPonyFill;
const $996dd9e14abad76e$var$partsTable = [
    [
        "years",
        "year"
    ],
    [
        "months",
        "month"
    ],
    [
        "weeks",
        "week"
    ],
    [
        "days",
        "day"
    ],
    [
        "hours",
        "hour"
    ],
    [
        "minutes",
        "minute"
    ],
    [
        "seconds",
        "second"
    ],
    [
        "milliseconds",
        "millisecond"
    ]
];
const $996dd9e14abad76e$var$twoDigitFormatOptions = {
    minimumIntegerDigits: 2
};
class $996dd9e14abad76e$export$2e2bcd8739ae039 {
    constructor(locale, options = {}){
        $996dd9e14abad76e$var$_DurationFormat_options.set(this, void 0);
        let style = String(options.style || "short");
        if (style !== "long" && style !== "short" && style !== "narrow" && style !== "digital") style = "short";
        let prevStyle = style === "digital" ? "numeric" : style;
        const hours = options.hours || prevStyle;
        prevStyle = hours === "2-digit" ? "numeric" : hours;
        const minutes = options.minutes || prevStyle;
        prevStyle = minutes === "2-digit" ? "numeric" : minutes;
        const seconds = options.seconds || prevStyle;
        prevStyle = seconds === "2-digit" ? "numeric" : seconds;
        const milliseconds = options.milliseconds || prevStyle;
        $996dd9e14abad76e$var$__classPrivateFieldSet(this, $996dd9e14abad76e$var$_DurationFormat_options, {
            locale: locale,
            style: style,
            years: options.years || style === "digital" ? "short" : style,
            yearsDisplay: options.yearsDisplay === "always" ? "always" : "auto",
            months: options.months || style === "digital" ? "short" : style,
            monthsDisplay: options.monthsDisplay === "always" ? "always" : "auto",
            weeks: options.weeks || style === "digital" ? "short" : style,
            weeksDisplay: options.weeksDisplay === "always" ? "always" : "auto",
            days: options.days || style === "digital" ? "short" : style,
            daysDisplay: options.daysDisplay === "always" ? "always" : "auto",
            hours: hours,
            hoursDisplay: options.hoursDisplay === "always" ? "always" : style === "digital" ? "always" : "auto",
            minutes: minutes,
            minutesDisplay: options.minutesDisplay === "always" ? "always" : style === "digital" ? "always" : "auto",
            seconds: seconds,
            secondsDisplay: options.secondsDisplay === "always" ? "always" : style === "digital" ? "always" : "auto",
            milliseconds: milliseconds,
            millisecondsDisplay: options.millisecondsDisplay === "always" ? "always" : "auto"
        }, "f");
    }
    resolvedOptions() {
        return $996dd9e14abad76e$var$__classPrivateFieldGet(this, $996dd9e14abad76e$var$_DurationFormat_options, "f");
    }
    formatToParts(duration) {
        const list = [];
        const options = $996dd9e14abad76e$var$__classPrivateFieldGet(this, $996dd9e14abad76e$var$_DurationFormat_options, "f");
        const style = options.style;
        const locale = options.locale;
        for (const [unit, nfUnit] of $996dd9e14abad76e$var$partsTable){
            const value = duration[unit];
            if (options[`${unit}Display`] === "auto" && !value) continue;
            const unitStyle = options[unit];
            const nfOpts = unitStyle === "2-digit" ? $996dd9e14abad76e$var$twoDigitFormatOptions : unitStyle === "numeric" ? {} : {
                style: "unit",
                unit: nfUnit,
                unitDisplay: unitStyle
            };
            list.push(new Intl.NumberFormat(locale, nfOpts).format(value));
        }
        return new $996dd9e14abad76e$var$ListFormat(locale, {
            type: "unit",
            style: style === "digital" ? "short" : style
        }).formatToParts(list);
    }
    format(duration) {
        return this.formatToParts(duration).map((p)=>p.value).join("");
    }
}
$996dd9e14abad76e$var$_DurationFormat_options = new WeakMap();


const $b25b272eec4d4cd0$var$durationRe = /^[-+]?P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;
const $b25b272eec4d4cd0$export$ab2b613392a6a176 = [
    "year",
    "month",
    "week",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
const $b25b272eec4d4cd0$export$757a451204d10ad6 = (str)=>$b25b272eec4d4cd0$var$durationRe.test(str);
class $b25b272eec4d4cd0$export$3b11bc38611c5941 {
    constructor(years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0){
        this.years = years;
        this.months = months;
        this.weeks = weeks;
        this.days = days;
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.milliseconds = milliseconds;
        this.years || (this.years = 0);
        this.sign || (this.sign = Math.sign(this.years));
        this.months || (this.months = 0);
        this.sign || (this.sign = Math.sign(this.months));
        this.weeks || (this.weeks = 0);
        this.sign || (this.sign = Math.sign(this.weeks));
        this.days || (this.days = 0);
        this.sign || (this.sign = Math.sign(this.days));
        this.hours || (this.hours = 0);
        this.sign || (this.sign = Math.sign(this.hours));
        this.minutes || (this.minutes = 0);
        this.sign || (this.sign = Math.sign(this.minutes));
        this.seconds || (this.seconds = 0);
        this.sign || (this.sign = Math.sign(this.seconds));
        this.milliseconds || (this.milliseconds = 0);
        this.sign || (this.sign = Math.sign(this.milliseconds));
        this.blank = this.sign === 0;
    }
    abs() {
        return new $b25b272eec4d4cd0$export$3b11bc38611c5941(Math.abs(this.years), Math.abs(this.months), Math.abs(this.weeks), Math.abs(this.days), Math.abs(this.hours), Math.abs(this.minutes), Math.abs(this.seconds), Math.abs(this.milliseconds));
    }
    static from(durationLike) {
        var _a;
        if (typeof durationLike === "string") {
            const str = String(durationLike).trim();
            const factor = str.startsWith("-") ? -1 : 1;
            const parsed = (_a = str.match($b25b272eec4d4cd0$var$durationRe)) === null || _a === void 0 ? void 0 : _a.slice(1).map((x)=>(Number(x) || 0) * factor);
            if (!parsed) return new $b25b272eec4d4cd0$export$3b11bc38611c5941();
            return new $b25b272eec4d4cd0$export$3b11bc38611c5941(...parsed);
        } else if (typeof durationLike === "object") {
            const { years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds, milliseconds: milliseconds } = durationLike;
            return new $b25b272eec4d4cd0$export$3b11bc38611c5941(years, months, weeks, days, hours, minutes, seconds, milliseconds);
        }
        throw new RangeError("invalid duration");
    }
    static compare(one, two) {
        const now = Date.now();
        const oneApplied = Math.abs($b25b272eec4d4cd0$export$ba4b4889be7cd2f0(now, $b25b272eec4d4cd0$export$3b11bc38611c5941.from(one)).getTime() - now);
        const twoApplied = Math.abs($b25b272eec4d4cd0$export$ba4b4889be7cd2f0(now, $b25b272eec4d4cd0$export$3b11bc38611c5941.from(two)).getTime() - now);
        return oneApplied > twoApplied ? -1 : oneApplied < twoApplied ? 1 : 0;
    }
    toLocaleString(locale, opts) {
        return new (0, $996dd9e14abad76e$export$2e2bcd8739ae039)(locale, opts).format(this);
    }
}
function $b25b272eec4d4cd0$export$ba4b4889be7cd2f0(date, duration) {
    const r = new Date(date);
    if (duration.sign < 0) {
        r.setUTCSeconds(r.getUTCSeconds() + duration.seconds);
        r.setUTCMinutes(r.getUTCMinutes() + duration.minutes);
        r.setUTCHours(r.getUTCHours() + duration.hours);
        r.setUTCDate(r.getUTCDate() + duration.weeks * 7 + duration.days);
        r.setUTCMonth(r.getUTCMonth() + duration.months);
        r.setUTCFullYear(r.getUTCFullYear() + duration.years);
    } else {
        r.setUTCFullYear(r.getUTCFullYear() + duration.years);
        r.setUTCMonth(r.getUTCMonth() + duration.months);
        r.setUTCDate(r.getUTCDate() + duration.weeks * 7 + duration.days);
        r.setUTCHours(r.getUTCHours() + duration.hours);
        r.setUTCMinutes(r.getUTCMinutes() + duration.minutes);
        r.setUTCSeconds(r.getUTCSeconds() + duration.seconds);
    }
    return r;
}
function $b25b272eec4d4cd0$export$1ea91570c695dfb2(date, precision = "second", now = Date.now()) {
    const delta = date.getTime() - now;
    if (delta === 0) return new $b25b272eec4d4cd0$export$3b11bc38611c5941();
    const sign = Math.sign(delta);
    const ms = Math.abs(delta);
    const sec = Math.floor(ms / 1000);
    const min = Math.floor(sec / 60);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    const month = Math.floor(day / 30);
    const year = Math.floor(month / 12);
    const i = $b25b272eec4d4cd0$export$ab2b613392a6a176.indexOf(precision) || $b25b272eec4d4cd0$export$ab2b613392a6a176.length;
    return new $b25b272eec4d4cd0$export$3b11bc38611c5941(i >= 0 ? year * sign : 0, i >= 1 ? (month - year * 12) * sign : 0, 0, i >= 3 ? (day - month * 30) * sign : 0, i >= 4 ? (hr - day * 24) * sign : 0, i >= 5 ? (min - hr * 60) * sign : 0, i >= 6 ? (sec - min * 60) * sign : 0, i >= 7 ? (ms - sec * 1000) * sign : 0);
}
function $b25b272eec4d4cd0$export$56623f543516c50f(duration, { relativeTo: relativeTo = Date.now() } = {}) {
    relativeTo = new Date(relativeTo);
    if (duration.blank) return duration;
    const sign = duration.sign;
    let years = Math.abs(duration.years);
    let months = Math.abs(duration.months);
    let weeks = Math.abs(duration.weeks);
    let days = Math.abs(duration.days);
    let hours = Math.abs(duration.hours);
    let minutes = Math.abs(duration.minutes);
    let seconds = Math.abs(duration.seconds);
    let milliseconds = Math.abs(duration.milliseconds);
    if (milliseconds >= 900) seconds += Math.round(milliseconds / 1000);
    if (seconds || minutes || hours || days || weeks || months || years) milliseconds = 0;
    if (seconds >= 55) minutes += Math.round(seconds / 60);
    if (minutes || hours || days || weeks || months || years) seconds = 0;
    if (minutes >= 55) hours += Math.round(minutes / 60);
    if (hours || days || weeks || months || years) minutes = 0;
    if (days && hours >= 12) days += Math.round(hours / 24);
    if (!days && hours >= 21) days += Math.round(hours / 24);
    if (days || weeks || months || years) hours = 0;
    const currentYear = relativeTo.getFullYear();
    const currentMonth = relativeTo.getMonth();
    const currentDate = relativeTo.getDate();
    if (days >= 27 || years + months + days) {
        const newMonthDate = new Date(relativeTo);
        newMonthDate.setDate(1);
        newMonthDate.setMonth(currentMonth + months * sign + 1);
        newMonthDate.setDate(0);
        const monthDateCorrection = Math.max(0, currentDate - newMonthDate.getDate());
        const newDate = new Date(relativeTo);
        newDate.setFullYear(currentYear + years * sign);
        newDate.setDate(currentDate - monthDateCorrection);
        newDate.setMonth(currentMonth + months * sign);
        newDate.setDate(currentDate - monthDateCorrection + days * sign);
        const yearDiff = newDate.getFullYear() - relativeTo.getFullYear();
        const monthDiff = newDate.getMonth() - relativeTo.getMonth();
        const daysDiff = Math.abs(Math.round((Number(newDate) - Number(relativeTo)) / 86400000)) + monthDateCorrection;
        const monthsDiff = Math.abs(yearDiff * 12 + monthDiff);
        if (daysDiff < 27) {
            if (days >= 6) {
                weeks += Math.round(days / 7);
                days = 0;
            } else days = daysDiff;
            months = years = 0;
        } else if (monthsDiff <= 11) {
            months = monthsDiff;
            years = 0;
        } else {
            months = 0;
            years = yearDiff * sign;
        }
        if (months || years) days = 0;
    }
    if (years) months = 0;
    if (weeks >= 4) months += Math.round(weeks / 4);
    if (months || years) weeks = 0;
    if (days && weeks && !months && !years) {
        weeks += Math.round(days / 7);
        days = 0;
    }
    return new $b25b272eec4d4cd0$export$3b11bc38611c5941(years * sign, months * sign, weeks * sign, days * sign, hours * sign, minutes * sign, seconds * sign, milliseconds * sign);
}
function $b25b272eec4d4cd0$export$d2cb509fe1f5058d(duration, opts) {
    const rounded = $b25b272eec4d4cd0$export$56623f543516c50f(duration, opts);
    if (rounded.blank) return [
        0,
        "second"
    ];
    for (const unit of $b25b272eec4d4cd0$export$ab2b613392a6a176){
        if (unit === "millisecond") continue;
        const val = rounded[`${unit}s`];
        if (val) return [
            val,
            unit
        ];
    }
    return [
        0,
        "second"
    ];
}


var $03ae7077c712265a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $03ae7077c712265a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $03ae7077c712265a$var$_RelativeTimeElement_instances, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, $03ae7077c712265a$var$_RelativeTimeElement_updating, $03ae7077c712265a$var$_RelativeTimeElement_lang_get, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle, $03ae7077c712265a$var$_RelativeTimeElement_resolveFormat, $03ae7077c712265a$var$_RelativeTimeElement_getDurationFormat, $03ae7077c712265a$var$_RelativeTimeElement_getRelativeFormat, $03ae7077c712265a$var$_RelativeTimeElement_getDateTimeFormat, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated;
const $03ae7077c712265a$var$HTMLElement = globalThis.HTMLElement || null;
const $03ae7077c712265a$var$emptyDuration = new (0, $b25b272eec4d4cd0$export$3b11bc38611c5941)();
const $03ae7077c712265a$var$microEmptyDuration = new (0, $b25b272eec4d4cd0$export$3b11bc38611c5941)(0, 0, 0, 0, 0, 1);
class $03ae7077c712265a$export$1d6cc3abc67a5072 extends Event {
    constructor(oldText, newText, oldTitle, newTitle){
        super("relative-time-updated", {
            bubbles: true,
            composed: true
        });
        this.oldText = oldText;
        this.newText = newText;
        this.oldTitle = oldTitle;
        this.newTitle = newTitle;
    }
}
function $03ae7077c712265a$var$getUnitFactor(el) {
    if (!el.date) return Infinity;
    if (el.format === "duration" || el.format === "elapsed") {
        const precision = el.precision;
        if (precision === "second") return 1000;
        else if (precision === "minute") return 60000;
    }
    const ms = Math.abs(Date.now() - el.date.getTime());
    if (ms < 60000) return 1000;
    if (ms < 3600000) return 60000;
    return 3600000;
}
const $03ae7077c712265a$var$dateObserver = new class {
    constructor(){
        this.elements = new Set();
        this.time = Infinity;
        this.timer = -1;
    }
    observe(element) {
        if (this.elements.has(element)) return;
        this.elements.add(element);
        const date = element.date;
        if (date && date.getTime()) {
            const ms = $03ae7077c712265a$var$getUnitFactor(element);
            const time = Date.now() + ms;
            if (time < this.time) {
                clearTimeout(this.timer);
                this.timer = setTimeout(()=>this.update(), ms);
                this.time = time;
            }
        }
    }
    unobserve(element) {
        if (!this.elements.has(element)) return;
        this.elements.delete(element);
    }
    update() {
        clearTimeout(this.timer);
        if (!this.elements.size) return;
        let nearestDistance = Infinity;
        for (const timeEl of this.elements){
            nearestDistance = Math.min(nearestDistance, $03ae7077c712265a$var$getUnitFactor(timeEl));
            timeEl.update();
        }
        this.time = Math.min(3600000, nearestDistance);
        this.timer = setTimeout(()=>this.update(), this.time);
        this.time += Date.now();
    }
}();
class $03ae7077c712265a$export$8f5d2bd03530cdd0 extends $03ae7077c712265a$var$HTMLElement {
    constructor(){
        super(...arguments);
        $03ae7077c712265a$var$_RelativeTimeElement_instances.add(this);
        $03ae7077c712265a$var$_RelativeTimeElement_customTitle.set(this, false);
        $03ae7077c712265a$var$_RelativeTimeElement_updating.set(this, false);
        $03ae7077c712265a$var$_RelativeTimeElement_renderRoot.set(this, this.shadowRoot ? this.shadowRoot : this.attachShadow ? this.attachShadow({
            mode: "open"
        }) : this);
        $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated.set(this, null);
    }
    static define(tag = "relative-time", registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    static get observedAttributes() {
        return [
            "second",
            "minute",
            "hour",
            "weekday",
            "day",
            "month",
            "year",
            "time-zone-name",
            "prefix",
            "threshold",
            "tense",
            "precision",
            "format",
            "format-style",
            "no-title",
            "datetime",
            "lang",
            "title"
        ];
    }
    get onRelativeTimeUpdated() {
        return $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, "f");
    }
    set onRelativeTimeUpdated(listener) {
        if ($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, "f")) this.removeEventListener("relative-time-updated", $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, "f"));
        $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated, typeof listener === "object" || typeof listener === "function" ? listener : null, "f");
        if (typeof listener === "function") this.addEventListener("relative-time-updated", listener);
    }
    get second() {
        const second = this.getAttribute("second");
        if (second === "numeric" || second === "2-digit") return second;
    }
    set second(value) {
        this.setAttribute("second", value || "");
    }
    get minute() {
        const minute = this.getAttribute("minute");
        if (minute === "numeric" || minute === "2-digit") return minute;
    }
    set minute(value) {
        this.setAttribute("minute", value || "");
    }
    get hour() {
        const hour = this.getAttribute("hour");
        if (hour === "numeric" || hour === "2-digit") return hour;
    }
    set hour(value) {
        this.setAttribute("hour", value || "");
    }
    get weekday() {
        const weekday = this.getAttribute("weekday");
        if (weekday === "long" || weekday === "short" || weekday === "narrow") return weekday;
        if (this.format === "datetime" && weekday !== "") return this.formatStyle;
    }
    set weekday(value) {
        this.setAttribute("weekday", value || "");
    }
    get day() {
        var _a;
        const day = (_a = this.getAttribute("day")) !== null && _a !== void 0 ? _a : "numeric";
        if (day === "numeric" || day === "2-digit") return day;
    }
    set day(value) {
        this.setAttribute("day", value || "");
    }
    get month() {
        const format = this.format;
        let month = this.getAttribute("month");
        if (month === "") return;
        month !== null && month !== void 0 ? month : month = format === "datetime" ? this.formatStyle : "short";
        if (month === "numeric" || month === "2-digit" || month === "short" || month === "long" || month === "narrow") return month;
    }
    set month(value) {
        this.setAttribute("month", value || "");
    }
    get year() {
        var _a;
        const year = this.getAttribute("year");
        if (year === "numeric" || year === "2-digit") return year;
        if (!this.hasAttribute("year") && new Date().getUTCFullYear() !== ((_a = this.date) === null || _a === void 0 ? void 0 : _a.getUTCFullYear())) return "numeric";
    }
    set year(value) {
        this.setAttribute("year", value || "");
    }
    get timeZoneName() {
        const name = this.getAttribute("time-zone-name");
        if (name === "long" || name === "short" || name === "shortOffset" || name === "longOffset" || name === "shortGeneric" || name === "longGeneric") return name;
    }
    set timeZoneName(value) {
        this.setAttribute("time-zone-name", value || "");
    }
    get prefix() {
        var _a;
        return (_a = this.getAttribute("prefix")) !== null && _a !== void 0 ? _a : this.format === "datetime" ? "" : "on";
    }
    set prefix(value) {
        this.setAttribute("prefix", value);
    }
    get threshold() {
        const threshold = this.getAttribute("threshold");
        return threshold && (0, $b25b272eec4d4cd0$export$757a451204d10ad6)(threshold) ? threshold : "P30D";
    }
    set threshold(value) {
        this.setAttribute("threshold", value);
    }
    get tense() {
        const tense = this.getAttribute("tense");
        if (tense === "past") return "past";
        if (tense === "future") return "future";
        return "auto";
    }
    set tense(value) {
        this.setAttribute("tense", value);
    }
    get precision() {
        const precision = this.getAttribute("precision");
        if ((0, $b25b272eec4d4cd0$export$ab2b613392a6a176).includes(precision)) return precision;
        if (this.format === "micro") return "minute";
        return "second";
    }
    set precision(value) {
        this.setAttribute("precision", value);
    }
    get format() {
        const format = this.getAttribute("format");
        if (format === "datetime") return "datetime";
        if (format === "relative") return "relative";
        if (format === "duration") return "duration";
        if (format === "micro") return "micro";
        if (format === "elapsed") return "elapsed";
        return "auto";
    }
    set format(value) {
        this.setAttribute("format", value);
    }
    get formatStyle() {
        const formatStyle = this.getAttribute("format-style");
        if (formatStyle === "long") return "long";
        if (formatStyle === "short") return "short";
        if (formatStyle === "narrow") return "narrow";
        const format = this.format;
        if (format === "elapsed" || format === "micro") return "narrow";
        if (format === "datetime") return "short";
        return "long";
    }
    set formatStyle(value) {
        this.setAttribute("format-style", value);
    }
    get noTitle() {
        return this.hasAttribute("no-title");
    }
    set noTitle(value) {
        this.toggleAttribute("no-title", value);
    }
    get datetime() {
        return this.getAttribute("datetime") || "";
    }
    set datetime(value) {
        this.setAttribute("datetime", value);
    }
    get date() {
        const parsed = Date.parse(this.datetime);
        return Number.isNaN(parsed) ? null : new Date(parsed);
    }
    set date(value) {
        this.datetime = (value === null || value === void 0 ? void 0 : value.toISOString()) || "";
    }
    connectedCallback() {
        this.update();
    }
    disconnectedCallback() {
        $03ae7077c712265a$var$dateObserver.unobserve(this);
    }
    attributeChangedCallback(attrName, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (attrName === "title") $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, newValue !== null && (this.date && $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle).call(this, this.date)) !== newValue, "f");
        if (!$03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_updating, "f") && !(attrName === "title" && $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, "f"))) $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_updating, (async ()=>{
            await Promise.resolve();
            this.update();
            $03ae7077c712265a$var$__classPrivateFieldSet(this, $03ae7077c712265a$var$_RelativeTimeElement_updating, false, "f");
        })(), "f");
    }
    update() {
        const oldText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f").textContent || this.textContent || "";
        const oldTitle = this.getAttribute("title") || "";
        let newTitle = oldTitle;
        const date = this.date;
        if (typeof Intl === "undefined" || !Intl.DateTimeFormat || !date) {
            $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f").textContent = oldText;
            return;
        }
        const now = Date.now();
        if (!$03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_customTitle, "f")) {
            newTitle = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle).call(this, date) || "";
            if (newTitle && !this.noTitle) this.setAttribute("title", newTitle);
        }
        const duration = (0, $b25b272eec4d4cd0$export$1ea91570c695dfb2)(date, this.precision, now);
        const format = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_resolveFormat).call(this, duration);
        let newText = oldText;
        if (format === "duration") newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getDurationFormat).call(this, duration);
        else if (format === "relative") newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getRelativeFormat).call(this, duration);
        else newText = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "m", $03ae7077c712265a$var$_RelativeTimeElement_getDateTimeFormat).call(this, date);
        if (newText) $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f").textContent = newText;
        else if (this.shadowRoot === $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f") && this.textContent) $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_renderRoot, "f").textContent = this.textContent;
        if (newText !== oldText || newTitle !== oldTitle) this.dispatchEvent(new $03ae7077c712265a$export$1d6cc3abc67a5072(oldText, newText, oldTitle, newTitle));
        if (format === "relative" || format === "duration") $03ae7077c712265a$var$dateObserver.observe(this);
        else $03ae7077c712265a$var$dateObserver.unobserve(this);
    }
}
$03ae7077c712265a$var$_RelativeTimeElement_customTitle = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_updating = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_renderRoot = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_onRelativeTimeUpdated = new WeakMap(), $03ae7077c712265a$var$_RelativeTimeElement_instances = new WeakSet(), $03ae7077c712265a$var$_RelativeTimeElement_lang_get = function _RelativeTimeElement_lang_get() {
    var _a;
    const lang = ((_a = this.closest("[lang]")) === null || _a === void 0 ? void 0 : _a.getAttribute("lang")) || this.ownerDocument.documentElement.getAttribute("lang");
    try {
        return new Intl.Locale(lang !== null && lang !== void 0 ? lang : "").toString();
    } catch (_b) {
        return "default";
    }
}, $03ae7077c712265a$var$_RelativeTimeElement_getFormattedTitle = function _RelativeTimeElement_getFormattedTitle(date) {
    return new Intl.DateTimeFormat($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "a", $03ae7077c712265a$var$_RelativeTimeElement_lang_get), {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short"
    }).format(date);
}, $03ae7077c712265a$var$_RelativeTimeElement_resolveFormat = function _RelativeTimeElement_resolveFormat(duration) {
    const format = this.format;
    if (format === "datetime") return "datetime";
    if (format === "duration") return "duration";
    if (format === "elapsed") return "duration";
    if (format === "micro") return "duration";
    if ((format === "auto" || format === "relative") && typeof Intl !== "undefined" && Intl.RelativeTimeFormat) {
        const tense = this.tense;
        if (tense === "past" || tense === "future") return "relative";
        if ((0, $b25b272eec4d4cd0$export$3b11bc38611c5941).compare(duration, this.threshold) === 1) return "relative";
    }
    return "datetime";
}, $03ae7077c712265a$var$_RelativeTimeElement_getDurationFormat = function _RelativeTimeElement_getDurationFormat(duration) {
    const locale = $03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "a", $03ae7077c712265a$var$_RelativeTimeElement_lang_get);
    const format = this.format;
    const style = this.formatStyle;
    const tense = this.tense;
    let empty = $03ae7077c712265a$var$emptyDuration;
    if (format === "micro") {
        duration = (0, $b25b272eec4d4cd0$export$56623f543516c50f)(duration);
        empty = $03ae7077c712265a$var$microEmptyDuration;
        if (this.tense === "past" && duration.sign !== -1 || this.tense === "future" && duration.sign !== 1) duration = $03ae7077c712265a$var$microEmptyDuration;
    } else if (tense === "past" && duration.sign !== -1 || tense === "future" && duration.sign !== 1) duration = empty;
    const display = `${this.precision}sDisplay`;
    if (duration.blank) return empty.toLocaleString(locale, {
        style: style,
        [display]: "always"
    });
    return duration.abs().toLocaleString(locale, {
        style: style
    });
}, $03ae7077c712265a$var$_RelativeTimeElement_getRelativeFormat = function _RelativeTimeElement_getRelativeFormat(duration) {
    const relativeFormat = new Intl.RelativeTimeFormat($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "a", $03ae7077c712265a$var$_RelativeTimeElement_lang_get), {
        numeric: "auto",
        style: this.formatStyle
    });
    const tense = this.tense;
    if (tense === "future" && duration.sign !== 1) duration = $03ae7077c712265a$var$emptyDuration;
    if (tense === "past" && duration.sign !== -1) duration = $03ae7077c712265a$var$emptyDuration;
    const [int, unit] = (0, $b25b272eec4d4cd0$export$d2cb509fe1f5058d)(duration);
    if (unit === "second" && int < 10) return relativeFormat.format(0, this.precision === "millisecond" ? "second" : this.precision);
    return relativeFormat.format(int, unit);
}, $03ae7077c712265a$var$_RelativeTimeElement_getDateTimeFormat = function _RelativeTimeElement_getDateTimeFormat(date) {
    const formatter = new Intl.DateTimeFormat($03ae7077c712265a$var$__classPrivateFieldGet(this, $03ae7077c712265a$var$_RelativeTimeElement_instances, "a", $03ae7077c712265a$var$_RelativeTimeElement_lang_get), {
        second: this.second,
        minute: this.minute,
        hour: this.hour,
        weekday: this.weekday,
        day: this.day,
        month: this.month,
        year: this.year,
        timeZoneName: this.timeZoneName
    });
    return `${this.prefix} ${formatter.format(date)}`.trim();
};
var $03ae7077c712265a$export$2e2bcd8739ae039 = $03ae7077c712265a$export$8f5d2bd03530cdd0;


const $14d9951328a8e257$var$root = typeof globalThis !== "undefined" ? globalThis : window;
try {
    $14d9951328a8e257$var$root.RelativeTimeElement = (0, $03ae7077c712265a$export$8f5d2bd03530cdd0).define();
} catch (e) {
    if (!($14d9951328a8e257$var$root.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) throw e;
}
var $14d9951328a8e257$export$2e2bcd8739ae039 = (0, $03ae7077c712265a$export$8f5d2bd03530cdd0);


var $554bd593dedd9121$export$2e2bcd8739ae039 = (0, $14d9951328a8e257$export$2e2bcd8739ae039);


const $59c92a63e141fec3$var$states = new WeakMap();
class $59c92a63e141fec3$var$RemoteInputElement extends HTMLElement {
    constructor(){
        super();
        const fetch1 = $59c92a63e141fec3$var$fetchResults.bind(null, this, true);
        const state = {
            currentQuery: null,
            oninput: $59c92a63e141fec3$var$debounce((e)=>fetch1(e)),
            fetch: fetch1,
            controller: null
        };
        $59c92a63e141fec3$var$states.set(this, state);
    }
    static get observedAttributes() {
        return [
            "src"
        ];
    }
    attributeChangedCallback(name, oldValue) {
        if (oldValue && name === "src") $59c92a63e141fec3$var$fetchResults(this, false);
    }
    connectedCallback() {
        const input = this.input;
        if (!input) return;
        input.setAttribute("autocomplete", "off");
        input.setAttribute("spellcheck", "false");
        const state = $59c92a63e141fec3$var$states.get(this);
        if (!state) return;
        input.addEventListener("focus", state.fetch);
        input.addEventListener("change", state.fetch);
        input.addEventListener("input", state.oninput);
    }
    disconnectedCallback() {
        const input = this.input;
        if (!input) return;
        const state = $59c92a63e141fec3$var$states.get(this);
        if (!state) return;
        input.removeEventListener("focus", state.fetch);
        input.removeEventListener("change", state.fetch);
        input.removeEventListener("input", state.oninput);
    }
    get input() {
        const input = this.querySelector("input, textarea");
        return input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement ? input : null;
    }
    get src() {
        return this.getAttribute("src") || "";
    }
    set src(url) {
        this.setAttribute("src", url);
    }
}
function $59c92a63e141fec3$var$makeAbortController() {
    if ("AbortController" in window) return new AbortController();
    return {
        signal: null,
        abort () {}
    };
}
async function $59c92a63e141fec3$var$fetchResults(remoteInput, checkCurrentQuery, event) {
    const input = remoteInput.input;
    if (!input) return;
    const state = $59c92a63e141fec3$var$states.get(remoteInput);
    if (!state) return;
    const query = input.value;
    if (checkCurrentQuery && state.currentQuery === query) return;
    state.currentQuery = query;
    const src = remoteInput.src;
    if (!src) return;
    const resultsContainer = document.getElementById(remoteInput.getAttribute("aria-owns") || "");
    if (!resultsContainer) return;
    const url = new URL(src, window.location.href);
    const params = new URLSearchParams(url.search);
    params.append(remoteInput.getAttribute("param") || "q", query);
    url.search = params.toString();
    if (state.controller) state.controller.abort();
    else {
        remoteInput.dispatchEvent(new CustomEvent("loadstart"));
        remoteInput.setAttribute("loading", "");
    }
    state.controller = $59c92a63e141fec3$var$makeAbortController();
    let response;
    let html = "";
    try {
        response = await $59c92a63e141fec3$var$fetchWithNetworkEvents(remoteInput, url.toString(), {
            signal: state.controller.signal,
            credentials: "same-origin",
            headers: {
                accept: "text/fragment+html"
            }
        });
        html = await response.text();
        remoteInput.removeAttribute("loading");
        state.controller = null;
    } catch (error) {
        if (error instanceof Error && error.name !== "AbortError") {
            remoteInput.removeAttribute("loading");
            state.controller = null;
        }
        return;
    }
    if (response && response.ok) {
        resultsContainer.innerHTML = html;
        remoteInput.dispatchEvent(new CustomEvent("remote-input-success", {
            bubbles: true,
            detail: {
                "eventType": event ? event.type : undefined
            }
        }));
    } else remoteInput.dispatchEvent(new CustomEvent("remote-input-error", {
        bubbles: true
    }));
}
async function $59c92a63e141fec3$var$fetchWithNetworkEvents(el, url, options) {
    try {
        const response = await fetch(url, options);
        el.dispatchEvent(new CustomEvent("load"));
        el.dispatchEvent(new CustomEvent("loadend"));
        return response;
    } catch (error) {
        if (error instanceof Error && (error === null || error === void 0 ? void 0 : error.name) !== "AbortError") {
            el.dispatchEvent(new CustomEvent("error"));
            el.dispatchEvent(new CustomEvent("loadend"));
        }
        throw error;
    }
}
function $59c92a63e141fec3$var$debounce(callback) {
    let timeout;
    return function(args) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            clearTimeout(timeout);
            callback(args);
        }, 300);
    };
}
var $59c92a63e141fec3$export$2e2bcd8739ae039 = $59c92a63e141fec3$var$RemoteInputElement;
if (!window.customElements.get("remote-input")) {
    window.RemoteInputElement = $59c92a63e141fec3$var$RemoteInputElement;
    window.customElements.define("remote-input", $59c92a63e141fec3$var$RemoteInputElement);
}


var $938ab5d81a50cbfe$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $938ab5d81a50cbfe$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $938ab5d81a50cbfe$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged;
const $938ab5d81a50cbfe$var$HTMLElement = globalThis.HTMLElement || null;
function $938ab5d81a50cbfe$var$getTabs(el) {
    return Array.from(el.querySelectorAll('[role="tablist"] [role="tab"]')).filter((tab)=>tab instanceof $938ab5d81a50cbfe$var$HTMLElement && tab.closest(el.tagName) === el);
}
class $938ab5d81a50cbfe$export$6a3733570e3be366 extends Event {
    constructor(type, _a){
        var { tab: tab, panel: panel } = _a, init = $938ab5d81a50cbfe$var$__rest(_a, [
            "tab",
            "panel"
        ]);
        super(type, init);
        $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel.set(this, null);
        $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab.set(this, null);
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab, tab || null, "f");
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, panel || null, "f");
    }
    get detail() {
        console.warn("TabContainerElement.detail is deprecated, please use .panel instead");
        return {
            relatedTarget: $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, "f")
        };
    }
    get panel() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel, "f");
    }
    get tab() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab, "f");
    }
}
$938ab5d81a50cbfe$var$_TabContainerChangeEvent_panel = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerChangeEvent_tab = new WeakMap();
function $938ab5d81a50cbfe$var$getNavigationKeyCodes(vertical) {
    if (vertical) return [
        [
            "ArrowDown",
            "ArrowRight"
        ],
        [
            "ArrowUp",
            "ArrowLeft"
        ]
    ];
    else return [
        [
            "ArrowRight"
        ],
        [
            "ArrowLeft"
        ]
    ];
}
class $938ab5d81a50cbfe$export$d423894cc51549d0 extends $938ab5d81a50cbfe$var$HTMLElement {
    constructor(){
        super(...arguments);
        $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange.set(this, null);
        $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged.set(this, null);
    }
    static define(tag = "tab-container", registry = customElements) {
        registry.define(tag, this);
        return this;
    }
    get onTabContainerChange() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, "f");
    }
    set onTabContainerChange(listener) {
        if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, "f")) this.removeEventListener("tab-container-change", $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, "f"));
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange, typeof listener === "object" || typeof listener === "function" ? listener : null, "f");
        if (typeof listener === "function") this.addEventListener("tab-container-change", listener);
    }
    get onTabContainerChanged() {
        return $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, "f");
    }
    set onTabContainerChanged(listener) {
        if ($938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, "f")) this.removeEventListener("tab-container-changed", $938ab5d81a50cbfe$var$__classPrivateFieldGet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, "f"));
        $938ab5d81a50cbfe$var$__classPrivateFieldSet(this, $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged, typeof listener === "object" || typeof listener === "function" ? listener : null, "f");
        if (typeof listener === "function") this.addEventListener("tab-container-changed", listener);
    }
    connectedCallback() {
        this.addEventListener("keydown", (event)=>{
            var _a;
            const target = event.target;
            if (!(target instanceof $938ab5d81a50cbfe$var$HTMLElement)) return;
            if (target.closest(this.tagName) !== this) return;
            if (target.getAttribute("role") !== "tab" && !target.closest('[role="tablist"]')) return;
            const tabs = $938ab5d81a50cbfe$var$getTabs(this);
            const currentIndex = tabs.indexOf(tabs.find((tab)=>tab.matches('[aria-selected="true"]')));
            const [incrementKeys, decrementKeys] = $938ab5d81a50cbfe$var$getNavigationKeyCodes(((_a = target.closest('[role="tablist"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("aria-orientation")) === "vertical");
            if (incrementKeys.some((code)=>event.code === code)) {
                let index = currentIndex + 1;
                if (index >= tabs.length) index = 0;
                this.selectTab(index);
            } else if (decrementKeys.some((code)=>event.code === code)) {
                let index = currentIndex - 1;
                if (index < 0) index = tabs.length - 1;
                this.selectTab(index);
            } else if (event.code === "Home") {
                this.selectTab(0);
                event.preventDefault();
            } else if (event.code === "End") {
                this.selectTab(tabs.length - 1);
                event.preventDefault();
            }
        });
        this.addEventListener("click", (event)=>{
            const tabs = $938ab5d81a50cbfe$var$getTabs(this);
            if (!(event.target instanceof Element)) return;
            if (event.target.closest(this.tagName) !== this) return;
            const tab = event.target.closest('[role="tab"]');
            if (!(tab instanceof $938ab5d81a50cbfe$var$HTMLElement) || !tab.closest('[role="tablist"]')) return;
            const index = tabs.indexOf(tab);
            this.selectTab(index);
        });
        for (const tab of $938ab5d81a50cbfe$var$getTabs(this)){
            if (!tab.hasAttribute("aria-selected")) tab.setAttribute("aria-selected", "false");
            if (!tab.hasAttribute("tabindex")) {
                if (tab.getAttribute("aria-selected") === "true") tab.setAttribute("tabindex", "0");
                else tab.setAttribute("tabindex", "-1");
            }
        }
    }
    selectTab(index) {
        const tabs = $938ab5d81a50cbfe$var$getTabs(this);
        const panels = Array.from(this.querySelectorAll('[role="tabpanel"]')).filter((panel)=>panel.closest(this.tagName) === this);
        if (index > tabs.length - 1) throw new RangeError(`Index "${index}" out of bounds`);
        const selectedTab = tabs[index];
        const selectedPanel = panels[index];
        const cancelled = !this.dispatchEvent(new $938ab5d81a50cbfe$export$6a3733570e3be366("tab-container-change", {
            bubbles: true,
            cancelable: true,
            tab: selectedTab,
            panel: selectedPanel
        }));
        if (cancelled) return;
        for (const tab of tabs){
            tab.setAttribute("aria-selected", "false");
            tab.setAttribute("tabindex", "-1");
        }
        for (const panel of panels){
            panel.hidden = true;
            if (!panel.hasAttribute("tabindex") && !panel.hasAttribute("data-tab-container-no-tabstop")) panel.setAttribute("tabindex", "0");
        }
        selectedTab.setAttribute("aria-selected", "true");
        selectedTab.setAttribute("tabindex", "0");
        selectedTab.focus();
        selectedPanel.hidden = false;
        this.dispatchEvent(new $938ab5d81a50cbfe$export$6a3733570e3be366("tab-container-changed", {
            bubbles: true,
            tab: selectedTab,
            panel: selectedPanel
        }));
    }
}
$938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChange = new WeakMap(), $938ab5d81a50cbfe$var$_TabContainerElement_onTabContainerChanged = new WeakMap();



const $6e35d35d50cffb2c$var$root = typeof globalThis !== "undefined" ? globalThis : window;
try {
    $6e35d35d50cffb2c$var$root.TabContainerElement = (0, $938ab5d81a50cbfe$export$d423894cc51549d0).define();
} catch (e) {
    if (!($6e35d35d50cffb2c$var$root.DOMException && e instanceof DOMException && e.name === "NotSupportedError") && !(e instanceof ReferenceError)) throw e;
}
var $6e35d35d50cffb2c$export$2e2bcd8739ae039 = (0, $938ab5d81a50cbfe$export$d423894cc51549d0);


var $d684e09b0ab56ade$export$2e2bcd8739ae039 = (0, $938ab5d81a50cbfe$export$d423894cc51549d0);



const $f3c96cfcabe38876$var$boundary = /\s|\(|\[/;
function $f3c96cfcabe38876$var$query(text, key, cursor, { multiWord: multiWord, lookBackIndex: lookBackIndex, lastMatchPosition: lastMatchPosition } = {
    multiWord: false,
    lookBackIndex: 0,
    lastMatchPosition: null
}) {
    let keyIndex = text.lastIndexOf(key, cursor - 1);
    if (keyIndex === -1) return;
    if (keyIndex < lookBackIndex) return;
    if (multiWord) {
        if (lastMatchPosition != null) {
            if (lastMatchPosition === keyIndex) return;
            keyIndex = lastMatchPosition - key.length;
        }
        const charAfterKey = text[keyIndex + 1];
        if (charAfterKey === " " && cursor >= keyIndex + key.length + 1) return;
        const newLineIndex = text.lastIndexOf("\n", cursor - 1);
        if (newLineIndex > keyIndex) return;
        const dotIndex = text.lastIndexOf(".", cursor - 1);
        if (dotIndex > keyIndex) return;
    } else {
        const spaceIndex = text.lastIndexOf(" ", cursor - 1);
        if (spaceIndex > keyIndex) return;
    }
    const pre = text[keyIndex - 1];
    if (pre && !$f3c96cfcabe38876$var$boundary.test(pre)) return;
    const queryString = text.substring(keyIndex + key.length, cursor);
    return {
        text: queryString,
        position: keyIndex + key.length
    };
}
/**
 * A custom element is implemented as a class which extends HTMLElement (in the
 * case of autonomous elements) or the interface you want to customize (in the
 * case of customized built-in elements).
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_custom_elements#custom_element_lifecycle_callbacks
 */ class $f3c96cfcabe38876$var$CustomHTMLElement extends HTMLElement {
}
class $f3c96cfcabe38876$var$InputStyleCloneUpdateEvent extends Event {
    constructor(){
        super("update");
    }
}
const $f3c96cfcabe38876$var$CloneRegistry = new WeakMap();
/**
 * Create an element that exactly matches an input pixel-for-pixel and automatically stays in sync with it. This
 * is a non-interactive overlay on to the input and can be used to affect the visual appearance of the input
 * without modifying its behavior. The clone element is hidden by default.
 *
 * This lower level API powers the `InputRange` but provides more advanced functionality including event updates.
 *
 * Emits `update` events whenever anything is recalculated: when the layout changes, when the user scrolls, when the
 * input is updated, etc. This event may be emitted more than once per change.
 *
 * @note There may be cases in which the clone cannot observe changes to the input and fails to automatically update.
 * For example, if the `value` property on the input is written to directly, no `input` event is emitted by the input
 * and the clone does not automatically update. In these cases, `forceUpdate` can be used to manually trigger an update.
 */ // PRIOR ART: This approach was adapted from the following MIT-licensed sources:
//  - primer/react (Copyright (c) 2018 GitHub, Inc.): https://github.com/primer/react/blob/a0db832302702b869aa22b0c4049ad9305ef631f/src/drafts/utils/character-coordinates.ts
//  - component/textarea-caret-position (Copyright (c) 2015 Jonathan Ong me@jongleberry.com): https://github.com/component/textarea-caret-position/blob/b5db7a7e47dd149c2a66276183c69234e4dabe30/index.js
//  - koddsson/textarea-caret-position (Copyright (c) 2015 Jonathan Ong me@jongleberry.com): https://github.com/koddsson/textarea-caret-position/blob/eba40ec8488eed4d77815f109af22e1d9c0751d3/index.js
class $f3c96cfcabe38876$var$InputStyleCloneElement extends $f3c96cfcabe38876$var$CustomHTMLElement {
    #styleObserver = new MutationObserver(()=>this.#updateStyles());
    #resizeObserver = new ResizeObserver(()=>this.#requestUpdateLayout());
    // This class is unique in that it will prevent itself from getting garbage collected because of the subscribed
    // observers (if never detached). Because of this, we want to avoid preventing the existence of this class from also
    // preventing the garbage collection of the associated input. This also allows us to automatically detach if the
    // input gets collected.
    #inputRef;
    #container;
    /**
     * Get the clone for an input, reusing an existing one if available. This avoids creating unecessary clones, which
     * have a performance cost due to their high-frequency event-based updates. Because these elements are shared, they
     * should be mutated with caution.
     *
     * Upon initial creation the clone element will automatically be inserted into the DOM and begin observing the
     * linked input. Only one clone per input can ever exist at a time.
     * @param input The target input to clone.
     */ static for(input) {
        let clone = $f3c96cfcabe38876$var$CloneRegistry.get(input);
        if (!clone) {
            clone = new $f3c96cfcabe38876$var$InputStyleCloneElement();
            clone.connect(input);
            $f3c96cfcabe38876$var$CloneRegistry.set(input, clone);
        }
        return clone;
    }
    /**
     * Connect this instance to a target input element and insert this instance into the DOM in the correct location.
     *
     * NOTE: calling the static `for` method is nearly always preferable as it will reuse an existing clone if available.
     * However, if reusing clones is problematic (ie, if the clone needs to be mutated), a clone can be constructed
     * directly with `new InputStyleCloneElement()` and then bound to an input and inserted into the DOM with
     * `clone.connect(target)`.
     */ connect(input) {
        this.#inputRef = new WeakRef(input);
        // We want position:absolute so it doesn't take space in the layout, but that doesn't work with display:table-cell
        // used in the HTMLInputElement approach. So we need a wrapper.
        this.#container = document.createElement("div");
        this.#container.style.position = "absolute";
        this.#container.style.pointerEvents = "none";
        input.after(this.#container);
        this.#container.appendChild(this);
    }
    /**
     * Force a recalculation. Will emit an `update` event. This is typically not needed unless the input has changed in
     * an unobservable way, eg by directly writing to the `value` property.
     */ forceUpdate() {
        this.#updateStyles();
        this.#updateText();
    }
    /** @private */ connectedCallback() {
        this.#usingInput((input)=>{
            this.style.pointerEvents = "none";
            this.style.userSelect = "none";
            this.style.overflow = "hidden";
            this.style.display = "block";
            // Important not to use display:none which would not render the content at all
            this.style.visibility = "hidden";
            if (input instanceof HTMLTextAreaElement) {
                this.style.whiteSpace = "pre-wrap";
                this.style.wordWrap = "break-word";
            } else {
                this.style.whiteSpace = "nowrap";
                // text in single-line inputs is vertically centered
                this.style.display = "table-cell";
                this.style.verticalAlign = "middle";
            }
            this.setAttribute("aria-hidden", "true");
            this.#updateStyles();
            this.#updateText();
            this.#styleObserver.observe(input, {
                attributeFilter: [
                    "style",
                    "dir"
                ]
            });
            this.#resizeObserver.observe(input);
            document.addEventListener("scroll", this.#onDocumentScrollOrResize, {
                capture: true
            });
            window.addEventListener("resize", this.#onDocumentScrollOrResize, {
                capture: true
            });
            // capture so this happens first, so other things can respond to `input` events after this data updates
            input.addEventListener("input", this.#onInput, {
                capture: true
            });
        });
    }
    /** @private */ disconnectedCallback() {
        this.#container?.remove();
        this.#styleObserver.disconnect();
        this.#resizeObserver.disconnect();
        document.removeEventListener("scroll", this.#onDocumentScrollOrResize, {
            capture: true
        });
        window.removeEventListener("resize", this.#onDocumentScrollOrResize, {
            capture: true
        });
        // Can't use `usingInput` here since that could infinitely recurse
        const input = this.#input;
        if (input) {
            input.removeEventListener("input", this.#onInput, {
                capture: true
            });
            $f3c96cfcabe38876$var$CloneRegistry.delete(input);
        }
    }
    // --- private ---
    get #input() {
        return this.#inputRef?.deref();
    }
    /** Perform `fn` using the `input` if it is still available. If not, clean up the clone instead. */ #usingInput(fn) {
        const input = this.#input;
        if (!input) return this.remove();
        return fn(input);
    }
    /** Current relative x-adjustment in pixels, executed via CSS transform. */ #xOffset = 0;
    /** Current relative y-adjustment in pixels, executed via CSS transform. */ #yOffset = 0;
    /**
     * Update only geometric properties without recalculating styles. Typically call `#requestUpdateLayout` instead to
     * only update once per animation frame.
     */ #updateLayout() {
        // This runs often, so keep it as fast as possible! Avoid all unecessary updates.
        this.#usingInput((input)=>{
            const inputStyle = window.getComputedStyle(input);
            this.style.height = inputStyle.height;
            this.style.width = inputStyle.width;
            // Immediately re-adjust for browser inconsistencies in scrollbar handling, if necessary
            if (input.clientHeight !== this.clientHeight) this.style.height = `calc(${inputStyle.height} + ${input.clientHeight - this.clientHeight}px)`;
            if (input.clientWidth !== this.clientWidth) this.style.width = `calc(${inputStyle.width} + ${input.clientWidth - this.clientWidth}px)`;
            // Position on top of the input
            const inputRect = input.getBoundingClientRect();
            const cloneRect = this.getBoundingClientRect();
            this.#xOffset = this.#xOffset + inputRect.left - cloneRect.left;
            this.#yOffset = this.#yOffset + inputRect.top - cloneRect.top;
            this.style.transform = `translate(${this.#xOffset}px, ${this.#yOffset}px)`;
            this.scrollTop = input.scrollTop;
            this.scrollLeft = input.scrollLeft;
            this.dispatchEvent(new $f3c96cfcabe38876$var$InputStyleCloneUpdateEvent());
        });
    }
    #isLayoutUpdating = false;
    /** Request a layout update. Will only happen once per animation frame, to avoid unecessary updates. */ #requestUpdateLayout() {
        if (this.#isLayoutUpdating) return;
        this.#isLayoutUpdating = true;
        requestAnimationFrame(()=>{
            this.#updateLayout();
            this.#isLayoutUpdating = false;
        });
    }
    /** Update the styles of the clone based on the styles of the input, then request a layout update. */ #updateStyles() {
        this.#usingInput((input)=>{
            const inputStyle = window.getComputedStyle(input);
            for (const prop of $f3c96cfcabe38876$var$propertiesToCopy)this.style[prop] = inputStyle[prop];
            this.#requestUpdateLayout();
        });
    }
    /**
     * Update the text content of the clone based on the text content of the input. Triggers a layout update in case the
     * text update caused scrolling.
     */ #updateText() {
        this.#usingInput((input)=>{
            this.textContent = input.value;
            // This is often unecessary on a pure text update, but text updates could potentially cause layout updates like
            // scrolling or resizing. And we run the update on _every frame_ when scrolling, so this isn't that expensive.
            // We don't requestUpdateLayout here because this one should happen synchronously, so that clients can react
            // within their own `input` event handlers.
            this.#updateLayout();
        });
    }
    #onInput = ()=>this.#updateText();
    #onDocumentScrollOrResize = (event)=>{
        this.#usingInput((input)=>{
            if (event.target === document || event.target === window || event.target instanceof Node && event.target.contains(input)) this.#requestUpdateLayout();
        });
    };
}
// Note that some browsers, such as Firefox, do not concatenate properties
// into their shorthand (e.g. padding-top, padding-bottom etc. -> padding),
// so we have to list every single property explicitly.
const $f3c96cfcabe38876$var$propertiesToCopy = [
    // RTL / vertical writing modes support:
    "direction",
    "writingMode",
    "unicodeBidi",
    "textOrientation",
    "boxSizing",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "borderStyle",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    // https://developer.mozilla.org/en-US/docs/Web/CSS/font
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "fontStretch",
    "fontSize",
    "fontSizeAdjust",
    "lineHeight",
    "fontFamily",
    "textAlign",
    "textTransform",
    "textIndent",
    "textDecoration",
    "letterSpacing",
    "wordSpacing",
    "tabSize",
    "MozTabSize"
];
// Inspired by https://github.com/github/catalyst/blob/dc284dcf4f82329a9cac5c867462a8fa529b6c40/src/register.ts
try {
    customElements.define("input-style-clone", $f3c96cfcabe38876$var$InputStyleCloneElement);
} catch (e) {
    // Throws DOMException with NotSupportedError if already defined
    if (!(e instanceof DOMException && e.name === "NotSupportedError")) throw e;
}
class $f3c96cfcabe38876$var$InputRange {
    #inputElement;
    #startOffset;
    #endOffset;
    /**
     * Construct a new `InputRange`.
     * @param element The target input element that contains the content for the range.
     * @param startOffset The inclusive 0-based start index for the range. Will be adjusted to fit in the input contents.
     * @param endOffset The exclusive 0-based end index for the range. Will be adjusted to fit in the input contents.
     */ constructor(element, startOffset = 0, endOffset = startOffset){
        this.#inputElement = element;
        this.#startOffset = startOffset;
        this.#endOffset = endOffset;
    }
    /**
     * Create a new range from the current user selection. If the input is not focused, the range will just be the start
     * of the input (offsets `0` to `0`).
     *
     * This can be used to get the caret coordinates: if the resulting range is `collapsed`, the location of the
     * `getBoundingClientRect` will be the location of the caret caret (note, however, that the width will be `0` in
     * this case).
     */ static fromSelection(input) {
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = input;
        return new $f3c96cfcabe38876$var$InputRange(input, selectionStart ?? undefined, selectionEnd ?? undefined);
    }
    /** Returns true if the start is equal to the end of this range. */ get collapsed() {
        return this.startOffset === this.endOffset;
    }
    /** Always returns the containing input element. */ get commonAncestorContainer() {
        return this.#inputElement;
    }
    /** Always returns the containing input element. */ get endContainer() {
        return this.#inputElement;
    }
    /** Always returns the containing input element. */ get startContainer() {
        return this.#inputElement;
    }
    get startOffset() {
        return this.#startOffset;
    }
    get endOffset() {
        return this.#endOffset;
    }
    /** Update the inclusive start offset. Will be adjusted to fit within the content size. */ setStartOffset(offset) {
        this.#startOffset = this.#clampOffset(offset);
    }
    /** Update the exclusive end offset. Will be adjusted to fit within the content size. */ setEndOffset(offset) {
        this.#endOffset = this.#clampOffset(offset);
    }
    /**
     * Collapse this range to one side.
     * @param toStart If `true`, will collapse to the start side. Otherwise, will collapse to the end.
     */ collapse(toStart = false) {
        if (toStart) this.setEndOffset(this.startOffset);
        else this.setStartOffset(this.endOffset);
    }
    /** Returns a `DocumentFragment` containing a new `Text` node containing the content in the range. */ cloneContents() {
        return this.#createCloneRange().cloneContents();
    }
    /** Create a copy of this range. */ cloneRange() {
        return new $f3c96cfcabe38876$var$InputRange(this.#inputElement, this.startOffset, this.endOffset);
    }
    /**
     * Obtain one rect that contains the entire contents of the range. If the range spans multiple lines, this box will
     * contain all pieces of the range but may also contain some space outside the range.
     * @see https://iansan5653.github.io/dom-input-range/demos/playground/
     */ getBoundingClientRect() {
        return this.#createCloneRange().getBoundingClientRect();
    }
    /**
     * Obtain the rects that contain contents of this range. If the range spans multiple lines, there will be multiple
     * bounding boxes. These boxes can be used, for example, to draw a highlight over the range.
     * @see https://iansan5653.github.io/dom-input-range/demos/playground/
     */ getClientRects() {
        return this.#createCloneRange().getClientRects();
    }
    /** Get the contents of the range as a string. */ toString() {
        return this.#createCloneRange().toString();
    }
    /**
     * Get the underlying `InputStyleClone` instance powering these calculations. This can be used to listen for
     * updates to trigger layout recalculation.
     */ getStyleClone() {
        return this.#styleClone;
    }
    // --- private ---
    get #styleClone() {
        return $f3c96cfcabe38876$var$InputStyleCloneElement.for(this.#inputElement);
    }
    get #cloneElement() {
        return this.#styleClone;
    }
    #clampOffset(offset) {
        return Math.max(0, Math.min(offset, this.#inputElement.value.length));
    }
    #createCloneRange() {
        // It's tempting to create a single Range and reuse it across the lifetime of the class. However, this wouldn't be
        // accurate because the contents of the input can change and the contents of the range would become stale. So we
        // must create a new range every time we need it.
        const range = document.createRange();
        const textNode = this.#cloneElement.childNodes[0];
        if (textNode) {
            range.setStart(textNode, this.startOffset);
            range.setEnd(textNode, this.endOffset);
        }
        return range;
    }
}
const $f3c96cfcabe38876$var$states = new WeakMap();
class $f3c96cfcabe38876$var$TextExpander {
    constructor(expander, input){
        this.expander = expander;
        this.input = input;
        this.combobox = null;
        this.menu = null;
        this.match = null;
        this.justPasted = false;
        this.lookBackIndex = 0;
        this.oninput = this.onInput.bind(this);
        this.onpaste = this.onPaste.bind(this);
        this.onkeydown = this.onKeydown.bind(this);
        this.oncommit = this.onCommit.bind(this);
        this.onmousedown = this.onMousedown.bind(this);
        this.onblur = this.onBlur.bind(this);
        this.interactingWithList = false;
        input.addEventListener("paste", this.onpaste);
        input.addEventListener("input", this.oninput);
        input.addEventListener("keydown", this.onkeydown);
        input.addEventListener("blur", this.onblur);
    }
    destroy() {
        this.input.removeEventListener("paste", this.onpaste);
        this.input.removeEventListener("input", this.oninput);
        this.input.removeEventListener("keydown", this.onkeydown);
        this.input.removeEventListener("blur", this.onblur);
    }
    dismissMenu() {
        if (this.deactivate()) this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex;
    }
    activate(match, menu) {
        var _a, _b;
        if (this.input !== document.activeElement && this.input !== ((_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.activeElement)) return;
        this.deactivate();
        this.menu = menu;
        if (!menu.id) menu.id = `text-expander-${Math.floor(Math.random() * 100000).toString()}`;
        this.expander.append(menu);
        this.combobox = new (0, $3791d940664efc96$export$2e2bcd8739ae039)(this.input, menu);
        this.expander.dispatchEvent(new Event("text-expander-activate"));
        this.positionMenu(menu, match.position);
        this.combobox.start();
        menu.addEventListener("combobox-commit", this.oncommit);
        menu.addEventListener("mousedown", this.onmousedown);
        this.combobox.navigate(1);
    }
    positionMenu(menu, position) {
        const caretRect = new $f3c96cfcabe38876$var$InputRange(this.input, position).getBoundingClientRect();
        const targetPosition = {
            left: caretRect.left,
            top: caretRect.top + caretRect.height
        };
        const currentPosition = menu.getBoundingClientRect();
        const delta = {
            left: targetPosition.left - currentPosition.left,
            top: targetPosition.top - currentPosition.top
        };
        if (delta.left !== 0 || delta.top !== 0) {
            const currentStyle = getComputedStyle(menu);
            menu.style.left = currentStyle.left ? `calc(${currentStyle.left} + ${delta.left}px)` : `${delta.left}px`;
            menu.style.top = currentStyle.top ? `calc(${currentStyle.top} + ${delta.top}px)` : `${delta.top}px`;
        }
    }
    deactivate() {
        const menu = this.menu;
        if (!menu || !this.combobox) return false;
        this.expander.dispatchEvent(new Event("text-expander-deactivate"));
        this.menu = null;
        menu.removeEventListener("combobox-commit", this.oncommit);
        menu.removeEventListener("mousedown", this.onmousedown);
        this.combobox.destroy();
        this.combobox = null;
        menu.remove();
        return true;
    }
    onCommit({ target: target }) {
        var _a;
        const item = target;
        if (!(item instanceof HTMLElement)) return;
        if (!this.combobox) return;
        const match = this.match;
        if (!match) return;
        const beginning = this.input.value.substring(0, match.position - match.key.length);
        const remaining = this.input.value.substring(match.position + match.text.length);
        const detail = {
            item: item,
            key: match.key,
            value: null,
            continue: false
        };
        const canceled = !this.expander.dispatchEvent(new CustomEvent("text-expander-value", {
            cancelable: true,
            detail: detail
        }));
        if (canceled) return;
        if (!detail.value) return;
        let suffix = (_a = this.expander.getAttribute("suffix")) !== null && _a !== void 0 ? _a : " ";
        if (detail.continue) suffix = "";
        const value = `${detail.value}${suffix}`;
        this.input.value = beginning + value + remaining;
        const cursor = beginning.length + value.length;
        this.deactivate();
        this.input.focus({
            preventScroll: true
        });
        this.input.selectionStart = cursor;
        this.input.selectionEnd = cursor;
        if (!detail.continue) {
            this.lookBackIndex = cursor;
            this.match = null;
        }
        this.expander.dispatchEvent(new CustomEvent("text-expander-committed", {
            cancelable: false,
            detail: {
                input: this.input
            }
        }));
    }
    onBlur() {
        if (this.interactingWithList) {
            this.interactingWithList = false;
            return;
        }
        this.deactivate();
    }
    onPaste() {
        this.justPasted = true;
    }
    async onInput() {
        if (this.justPasted) {
            this.justPasted = false;
            return;
        }
        const match = this.findMatch();
        if (match) {
            this.match = match;
            const menu = await this.notifyProviders(match);
            if (!this.match) return;
            if (menu) this.activate(match, menu);
            else this.deactivate();
        } else {
            this.match = null;
            this.deactivate();
        }
    }
    findMatch() {
        const cursor = this.input.selectionEnd || 0;
        const text = this.input.value;
        if (cursor <= this.lookBackIndex) this.lookBackIndex = cursor - 1;
        for (const { key: key, multiWord: multiWord } of this.expander.keys){
            const found = $f3c96cfcabe38876$var$query(text, key, cursor, {
                multiWord: multiWord,
                lookBackIndex: this.lookBackIndex,
                lastMatchPosition: this.match ? this.match.position : null
            });
            if (found) return {
                text: found.text,
                key: key,
                position: found.position
            };
        }
    }
    async notifyProviders(match) {
        const providers = [];
        const provide = (result)=>providers.push(result);
        const changeEvent = new CustomEvent("text-expander-change", {
            cancelable: true,
            detail: {
                provide: provide,
                text: match.text,
                key: match.key
            }
        });
        const canceled = !this.expander.dispatchEvent(changeEvent);
        if (canceled) return;
        const all = await Promise.all(providers);
        const fragments = all.filter((x)=>x.matched).map((x)=>x.fragment);
        return fragments[0];
    }
    onMousedown() {
        this.interactingWithList = true;
    }
    onKeydown(event) {
        if (event.key === "Escape") {
            this.match = null;
            if (this.deactivate()) {
                this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex;
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        }
    }
}
class $f3c96cfcabe38876$export$2e2bcd8739ae039 extends HTMLElement {
    get keys() {
        const keysAttr = this.getAttribute("keys");
        const keys = keysAttr ? keysAttr.split(" ") : [];
        const multiWordAttr = this.getAttribute("multiword");
        const multiWord = multiWordAttr ? multiWordAttr.split(" ") : [];
        const globalMultiWord = multiWord.length === 0 && this.hasAttribute("multiword");
        return keys.map((key)=>({
                key: key,
                multiWord: globalMultiWord || multiWord.includes(key)
            }));
    }
    set keys(value) {
        this.setAttribute("keys", value);
    }
    connectedCallback() {
        const input = this.querySelector('input[type="text"], textarea');
        if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
        const state = new $f3c96cfcabe38876$var$TextExpander(this, input);
        $f3c96cfcabe38876$var$states.set(this, state);
    }
    disconnectedCallback() {
        const state = $f3c96cfcabe38876$var$states.get(this);
        if (!state) return;
        state.destroy();
        $f3c96cfcabe38876$var$states.delete(this);
    }
    dismiss() {
        const state = $f3c96cfcabe38876$var$states.get(this);
        if (!state) return;
        state.dismissMenu();
    }
}
if (!window.customElements.get("text-expander")) {
    window.TextExpanderElement = $f3c96cfcabe38876$export$2e2bcd8739ae039;
    window.customElements.define("text-expander", $f3c96cfcabe38876$export$2e2bcd8739ae039);
}


const $f2e3bdb9929a0de6$export$df1c34db1371eeed = [
    {
        locale: "ar",
        dir: "rtl",
        en_name: "Arabic",
        name: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629"
    },
    {
        locale: "de",
        dir: "ltr",
        en_name: "German",
        name: "Deutsch"
    },
    {
        locale: "en",
        dir: "ltr",
        en_name: "English",
        name: "English"
    },
    {
        locale: "es",
        dir: "ltr",
        en_name: "Spanish",
        name: "Espa\xf1ol"
    },
    {
        locale: "fil",
        dir: "ltr",
        en_name: "Filipino",
        name: "Filipino"
    },
    {
        locale: "fr",
        dir: "ltr",
        en_name: "French",
        name: "Fran\xe7ais"
    },
    {
        locale: "ht",
        dir: "ltr",
        en_name: "Haitian Creole",
        name: "Krey\xf2l ayisyen"
    },
    {
        locale: "hi",
        dir: "ltr",
        en_name: "Hindi",
        name: "\u0939\u093F\u0902\u0926\u0940"
    },
    {
        locale: "mww",
        dir: "ltr",
        en_name: "Hmong Daw (Latin)",
        name: "Hmoob"
    },
    {
        locale: "it",
        dir: "ltr",
        en_name: "Italian",
        name: "Italiano"
    },
    {
        locale: "ja",
        dir: "ltr",
        en_name: "Japanese",
        name: "\u65E5\u672C\u8A9E"
    },
    {
        locale: "ko",
        dir: "ltr",
        en_name: "Korean",
        name: "\uD55C\uAD6D\uC5B4"
    },
    {
        locale: "fa",
        dir: "rtl",
        en_name: "Persian",
        name: "\u0641\u0627\u0631\u0633\u06CC"
    },
    {
        locale: "ps",
        dir: "rtl",
        en_name: "Pashto",
        name: "\u067E\u069A\u062A\u0648"
    },
    {
        locale: "pt",
        dir: "ltr",
        en_name: "Portuguese (Brazil)",
        name: "Portugu\xeas (Brasil)"
    },
    {
        locale: "pt-pt",
        dir: "ltr",
        en_name: "Portuguese (Portugal)",
        name: "Portugu\xeas (Portugal)"
    },
    {
        locale: "ru",
        dir: "ltr",
        en_name: "Russian",
        name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    {
        locale: "sm",
        dir: "ltr",
        en_name: "Samoan",
        name: "S\u0101moa"
    },
    {
        locale: "so",
        dir: "ltr",
        en_name: "Somali",
        name: "Soomaali"
    },
    {
        locale: "th",
        dir: "ltr",
        en_name: "Thai",
        name: "\u0E44\u0E17\u0E22"
    },
    {
        locale: "ur",
        dir: "rtl",
        en_name: "Urdu",
        name: "\u0627\u0631\u062F\u0648"
    },
    {
        locale: "vi",
        dir: "ltr",
        en_name: "Vietnamese",
        name: "Ti\xea\u0301ngVi\xea\u0323t"
    },
    {
        locale: "zh-hans",
        dir: "ltr",
        en_name: "Chinese (Simplified)",
        name: "\u4E2D\u6587 (\u7B80\u4F53)"
    },
    {
        locale: "zh-hant",
        dir: "ltr",
        en_name: "Chinese (Traditional)",
        name: "\u4E2D\u6587 (\u7E41\u9AD4)"
    }
];
const $f2e3bdb9929a0de6$export$bc9baa0814b80b55 = $f2e3bdb9929a0de6$export$df1c34db1371eeed.reduce((p, c)=>{
    p[c.locale] = c;
    return p;
}, {});
const $f2e3bdb9929a0de6$export$d7f512c98c859244 = "en";

// GENERATED FILE - DO NOT EDIT
const $2868cc1235412e16$var$TEMPLATE_RESULT = Symbol.for("cumulus.templates.result");
/*#__NO_SIDE_EFFECTS__*/ function $2868cc1235412e16$var$html(strings, ...values) {
    return {
        [$2868cc1235412e16$var$TEMPLATE_RESULT]: true,
        strings: strings,
        values: values
    };
}
function $2868cc1235412e16$export$a520d1ac34aa3762(s) {
    return s// Remove trailing underscores, including the whitespace preceding the trailing underscores
    .replace(/(?:\s+)?_+$/, "")// Replace "covid-19" with "COVID-19"
    .replace(/([^\s])?covid-19([\s$])?/g, "$1COVID-19$2");
}
function $2868cc1235412e16$export$9e3208c5100f4979(locale, s) {
    const overrides = {
        es: {
            Hembra: "Femenino"
        }
    };
    return overrides[locale]?.[s] ?? s;
}
const $2868cc1235412e16$export$fd61571d318841e9 = {
    ar: `\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}`,
    de: `Fragebogen`,
    es: `Cuestionario`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Talatanungan`,
    fr: `Questionnaire`,
    hi: `\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{200D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8`,
    it: `Questionario`,
    ja: `\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C124}\u{BB38}\u{C9C0}`,
    mww: `Lus nug`,
    ps: `\u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}`,
    pt: `Question\xe1rio`,
    "pt-pt": `Question\xe1rio`,
    ru: `\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{430}`,
    sm: `Fesili`,
    so: `haku`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}`,
    ur: `\u{627}\u{633}\u{62A}\u{641}\u{633}\u{627}\u{631} \u{646}\u{627}\u{645}\u{6C1}`,
    vi: `B\u{1EA3}n c\xe2u h\u{1ECF}i`,
    "zh-hans": `\u{95EE}\u{5377}`,
    "zh-hant": `\u{554F}\u{5377}`,
    en: `Questionnaire`
};
const $2868cc1235412e16$export$44f2e10589b682de = {
    ar: `\u{627}\u{644}\u{627}\u{62D}\u{627}\u{644}\u{647}`,
    de: `Weiterempfehlung`,
    es: `Recomendaci\xf3n`,
    fa: `\u{627}\u{631}\u{62C}\u{627}\u{639}`,
    fil: `Email Address *`,
    fr: `Ajournement`,
    hi: `\u{930}\u{947}\u{92B}\u{930}\u{932}`,
    ht: `Rek\xf2mandasyon`,
    it: `Deferimento`,
    ja: `\u{7D39}\u{4ECB}`,
    ko: `\u{CD94}\u{CC9C}`,
    mww: `Xa mus cuag`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Refer\xeancia`,
    "pt-pt": `Encaminhamento`,
    ru: `\u{41D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fa'asino`,
    so: `Referral`,
    th: `\u{E2D}\u{E49}\u{E32}\u{E07} \u{E2D}\u{E34}\u{E07}`,
    ur: `\u{631}\u{6CC}\u{641}\u{631}\u{6CC}\u{644}`,
    vi: `Gi\u{1EDB}i thi\u{1EC7}u`,
    "zh-hans": `\u{8F6C} \u{4ECB}`,
    "zh-hant": `\u{8F49} \u{4ECB}`,
    en: `Referral`
};
const $2868cc1235412e16$export$34939fd411dd88a8 = {
    ar: `\u{645}\u{647}\u{645}\u{629}`,
    de: `Aufgabe`,
    es: `Tarea`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647}`,
    fil: `Gawain`,
    fr: `T\xe2che`,
    hi: `\u{928}\u{93F}\u{92F}\u{924} \u{915}\u{93E}\u{930}\u{94D}\u{92F}`,
    ht: `Travay`,
    it: `Compito`,
    ja: `\u{30BF}\u{30B9}\u{30AF}`,
    ko: `\u{ACFC}\u{C5C5}`,
    mww: `hauj lwm`,
    ps: `\u{62F}\u{646}\u{62F}\u{647}`,
    pt: `Tarefa`,
    "pt-pt": `Tarefa`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}`,
    sm: `Galuega`,
    so: `Hawlaha`,
    th: `\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645}`,
    vi: `Nhi\u{1EC7}m v\u{1EE5}`,
    "zh-hans": `\u{4EFB}\u{52A1}`,
    "zh-hant": `\u{4EFB}\u{52D9}`,
    en: `Task`
};
const $2868cc1235412e16$export$c1de9343f1c61b4e = {
    ar: `\u{62D}\u{62F}\u{62B}`,
    de: `Ereignis`,
    es: `Evento`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}`,
    fil: `Kaganapan`,
    fr: `\xc9v\xe9nement`,
    hi: `\u{918}\u{91F}\u{928}\u{93E}`,
    ht: `Evenman`,
    it: `Evento`,
    ja: `\u{51FA}\u{6765}\u{4E8B}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8}`,
    mww: `kev tshwm sim`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{647}`,
    pt: `Acontecimento`,
    "pt-pt": `Evento`,
    ru: `\u{421}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{435}`,
    sm: `Mea na tupu`,
    so: `Dhacdooyinka`,
    th: `\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{627}\u{62D}\u{648}\u{627}\u{644}`,
    vi: `S\u{1EF1} ki\u{1EC7}n`,
    "zh-hans": `\u{4E8B}\u{4EF6}`,
    "zh-hant": `\u{4E8B}\u{4EF6}`,
    en: `Event`
};
const $2868cc1235412e16$export$d954651d35c76c4d = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{644}\u{63A}\u{629}`,
    de: `Sprache ausw\xe4hlen`,
    es: `Seleccionar idioma`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{632}\u{628}\u{627}\u{646}`,
    fil: `Pumili ng wika`,
    fr: `S\xe9lectionner une langue`,
    hi: `\u{92D}\u{93E}\u{937}\u{93E} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi lang`,
    it: `Seleziona lingua`,
    ja: `\u{8A00}\u{8A9E}\u{306E}\u{9078}\u{629E}`,
    ko: `\u{C5B8}\u{C5B4} \u{C120}\u{D0DD}`,
    mww: `Xaiv lus`,
    ps: `\u{698}\u{628}\u{647} \u{63A}\u{648}\u{631}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Selecionar idioma`,
    "pt-pt": `Selecionar idioma`,
    ru: `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: `Filifili le gagana`,
    so: `Luqadda select`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E20}\u{E32}\u{E29}\u{E32}`,
    ur: `\u{632}\u{628}\u{627}\u{646} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\xf4n ng\u{1EEF}`,
    "zh-hans": `\u{9009}\u{62E9}\u{8BED}\u{8A00}`,
    "zh-hant": `\u{9078}\u{64C7}\u{8A9E}\u{8A00}`,
    en: `Select language`
};
const $2868cc1235412e16$export$815d12d51263bc71 = {
    ar: `\u{62D}\u{62F}\u{62F} \u{644}\u{63A}\u{629}`,
    de: `W\xe4hlen Sie eine Sprache aus`,
    es: `Seleccione un idioma`,
    fa: `\u{6CC}\u{6A9} \u{632}\u{628}\u{627}\u{646} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng Wika`,
    fr: `S\xe9lectionnez une langue`,
    hi: `\u{90F}\u{915} \u{92D}\u{93E}\u{937}\u{93E} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi yon lang`,
    it: `Seleziona una lingua`,
    ja: `\u{8A00}\u{8A9E}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{C5B8}\u{C5B4} \u{C120}\u{D0DD}`,
    mww: `Xaiv ib hom lus`,
    ps: `\u{698}\u{628}\u{647} \u{63A}\u{648}\u{631}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Selecione um idioma`,
    "pt-pt": `Selecione um idioma`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: `Filifili se gagana`,
    so: `Dalbo luqad`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E20}\u{E32}\u{E29}\u{E32}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{632}\u{628}\u{627}\u{646} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\xf4n ng\u{1EEF}`,
    "zh-hans": `\u{9009}\u{62E9}\u{8BED}\u{8A00}`,
    "zh-hant": `\u{9078}\u{64C7}\u{8A9E}\u{8A00}`,
    en: `Select a language`
};
const $2868cc1235412e16$export$5a2dd80712c90361 = {
    ar: `\u{62A}\u{639}\u{631}\u{64A}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `Definitionen von Aktivit\xe4ten`,
    es: `Definiciones de actividades`,
    fa: `\u{62A}\u{639}\u{627}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `Mga kahulugan ng aktibidad`,
    fr: `D\xe9finitions des activit\xe9s`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}\u{90F}\u{902}`,
    ht: `Definisyon aktivite`,
    it: `Definizioni delle attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{5B9A}\u{7FA9}`,
    ko: `\u{D65C}\u{B3D9} \u{C815}\u{C758}`,
    mww: `Kev txhais cov ntsiab lus txhais cov ntsiab lus`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{648}\u{646}\u{647}`,
    pt: `Defini\xe7\xf5es de atividade`,
    "pt-pt": `Defini\xe7\xf5es de atividade`,
    ru: `\u{41E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439}`,
    sm: `Faauigaga o gaoioiga`,
    so: `Qeexidda waxqabadka`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `Activity definitions`
};
const $2868cc1235412e16$export$8c6db5e01ccfbb18 = {
    ar: `\u{62A}\u{639}\u{631}\u{64A}\u{641} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `Definition der Aktivit\xe4t`,
    es: `Definici\xf3n de la actividad`,
    fa: `\u{62A}\u{639}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `Kahulugan ng aktibidad`,
    fr: `D\xe9finition de l\u{2019}activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}`,
    ht: `Definisyon aktivite`,
    it: `Definizione dell'attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{5B9A}\u{7FA9}`,
    ko: `\u{D65C}\u{B3D9} \u{C815}\u{C758}`,
    mww: `Kev txhais cov ntsiab lus txhais`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    pt: `Defini\xe7\xe3o de atividade`,
    "pt-pt": `Defini\xe7\xe3o da atividade`,
    ru: `\u{41E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Fa'amatalaga o le gaioiga`,
    so: `Qeexidda waxqabadka`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `Activity definition`
};
const $2868cc1235412e16$export$223a3cbc60d01473 = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639}`,
    de: `Projekte`,
    es: `Proyectos`,
    fa: `\u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Mga proyekto`,
    fr: `Projets`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E}\u{913}\u{902}`,
    ht: `Pwoj\xe8`,
    it: `Progetti`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8}`,
    mww: `Tej yaam num`,
    ps: `\u{67E}\u{631}\u{648}\u{698}\u{6D0}`,
    pt: `Projetos`,
    "pt-pt": `Projetos`,
    ru: `\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{44B}`,
    sm: `Galuega faatino`,
    so: `Mashaariicda`,
    th: `\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{645}\u{646}\u{635}\u{648}\u{628}\u{648}\u{6BA}`,
    vi: `D\u{1EF1} \xe1n`,
    "zh-hans": `\u{9879}\u{76EE}`,
    "zh-hant": `\u{5C08}\u{6848}`,
    en: `Projects`
};
const $2868cc1235412e16$export$aac94472455dcfa2 = {
    ar: (entity)=>`${entity} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: (entity)=>`Neuer ${entity}`,
    es: (entity)=>`${entity}`,
    fa: (entity)=>`${entity} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: (entity)=>`Bagong ${entity}`,
    fr: (entity)=>`Nouvel ${entity}`,
    hi: (entity)=>`\u{928}\u{92F}\u{93E} ${entity}`,
    ht: (entity)=>`Nouvo ${entity}`,
    it: (entity)=>`Nuovo ${entity}`,
    ja: (entity)=>`\u{65B0} ${entity}`,
    ko: (entity)=>`\u{C2E0} ${entity}`,
    mww: (entity)=>`${entity}`,
    ps: (entity)=>`\u{646}\u{648}\u{6CC} ${entity}`,
    pt: (entity)=>`Novo ${entity}`,
    "pt-pt": (entity)=>`Novo ${entity}`,
    ru: (entity)=>`${entity}`,
    sm: (entity)=>`${entity} fou`,
    so: (entity)=>`${entity} cusub`,
    th: (entity)=>`${entity}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: (entity)=>`\u{646}\u{626}\u{6CC} ${entity}`,
    vi: (entity)=>`${entity} m\u{1EDB}i`,
    "zh-hans": (entity)=>`\u{65B0}\u{5EFA} ${entity}`,
    "zh-hant": (entity)=>`\u{65B0}\u{5EFA} ${entity}`,
    en: (entity)=>`New ${entity}`
};
const $2868cc1235412e16$export$da0039b16b06a993 = {
    ar: `\u{627}\u{644}\u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neu`,
    es: `Nuevo`,
    fa: `\u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bago`,
    fr: `Nouveau`,
    hi: `\u{928}\u{92F}\u{93E}`,
    ht: `New`,
    it: `Nuovo`,
    ja: `\u{65B0}\u{6A5F}\u{80FD}`,
    ko: `\u{C0C8}\u{B85C}\u{C6B4}`,
    mww: `Tshiab`,
    ps: `\u{646}\u{648}\u{6CC}`,
    pt: `Novo`,
    "pt-pt": `Novo`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{435} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{438}`,
    sm: `Fou`,
    so: `Cusub`,
    th: `\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627}`,
    vi: `M\u{1EDB}i`,
    "zh-hans": `\u{65B0}\u{589E}\u{529F}\u{80FD}`,
    "zh-hant": `\u{65B0}\u{589E}\u{529F}\u{80FD}`,
    en: `New`
};
const $2868cc1235412e16$export$b5cfc9ee72391036 = {
    ar: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">امسح تفضيلات لغتي</button> على هذا الموقع`,
    de: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Meine Spracheinstellung löschen</button> auf dieser Seite`,
    es: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Borrar mi preferencia de idioma</button> En este sitio`,
    fa: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">ترجیحات زبانی من را پاک کنید</button> در این سایت`,
    fil: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">I-clear ang aking kagustuhan sa wika</button> Sa site na ito`,
    fr: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Effacer ma préférence de langue</button> Sur ce site`,
    hi: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">मेरी भाषा प्राथमिकता साफ़ करें</button> इस साइट पर`,
    ht: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Klè preferans lang mwen an</button> sou sit sa a`,
    it: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Cancella la mia lingua preferita</button> su questo sito`,
    ja: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">言語設定をクリアする</button> このサイトの内容`,
    ko: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">내 언어 기본 설정 지우기</button> 이 사이트에서`,
    mww: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Tseeb kuv hom lus nyiam</button> ntawm no`,
    ps: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">زما د ژبې ترجیح پاک کړئ</button> په دې وېبپاڼه کې راغلی دی چې د افغانستان`,
    pt: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Limpar minha preferência de idioma</button> neste site`,
    "pt-pt": $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Limpar a minha preferência de idioma</button> neste site`,
    ru: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Очистить языковые настройки</button> на этом сайте`,
    sm: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Kilia la'u gagana e fiafia i ai</button> i luga o lenei 'upega tafa'ilagi`,
    so: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Clear aan afkayga doorbidid</button> on this site`,
    th: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">ล้างการตั้งค่าภาษาของฉัน</button> บนเว็บไซต์นี้`,
    ur: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">میری زبان کی ترجیح کو صاف کریں</button> اس سائٹ پر`,
    vi: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Xóa tùy chọn ngôn ngữ của tôi</button> Trên trang web này`,
    "zh-hans": $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">清除我的语言首选项</button> 在本站`,
    "zh-hant": $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">清除我的語言首選項</button> 在本站`,
    en: $2868cc1235412e16$var$html`<button class="btn-link" type="submit" name="locale" value="">Clear my language preference</button> on this site`
};
const $2868cc1235412e16$export$5178e1572c9e18b9 = {
    ar: (name)=>$2868cc1235412e16$var$html`الاختيار الحالي: <strong>${name}</strong>`,
    de: (name)=>$2868cc1235412e16$var$html`Aktuelle Auswahl: <strong>${name}</strong>`,
    es: (name)=>$2868cc1235412e16$var$html`Selección actual: <strong>${name}</strong>`,
    fa: (name)=>$2868cc1235412e16$var$html`انتخاب فعلی: <strong>${name}</strong>`,
    fil: (name)=>$2868cc1235412e16$var$html`Kasalukuyang seleksyon: <strong>${name}</strong>`,
    fr: (name)=>$2868cc1235412e16$var$html`Sélection actuelle : <strong>${name}</strong>`,
    hi: (name)=>$2868cc1235412e16$var$html`वर्तमान चयन: <strong>${name}</strong>`,
    ht: (name)=>$2868cc1235412e16$var$html`Lòt <strong>${name}</strong>`,
    it: (name)=>$2868cc1235412e16$var$html`Selezione corrente: <strong>${name}</strong>`,
    ja: (name)=>$2868cc1235412e16$var$html`現在の選択: <strong>${name}</strong>`,
    ko: (name)=>$2868cc1235412e16$var$html`현재 선택 : <strong>${name}</strong>`,
    mww: (name)=>$2868cc1235412e16$var$html`Xaiv tam sim no: <strong>${name}</strong>`,
    ps: (name)=>$2868cc1235412e16$var$html`اوسنی انتخاب: <strong>${name}</strong>`,
    pt: (name)=>$2868cc1235412e16$var$html`Seleção atual: <strong>${name}</strong>`,
    "pt-pt": (name)=>$2868cc1235412e16$var$html`Seleção atual: <strong>${name}</strong>`,
    ru: (name)=>$2868cc1235412e16$var$html`Текущий выбор: <strong>${name}</strong>`,
    sm: (name)=>$2868cc1235412e16$var$html`Filifiliga o lo'o i ai nei: <strong>${name}</strong>`,
    so: (name)=>$2868cc1235412e16$var$html`Xulashada hadda: <strong>${name}</strong>`,
    th: (name)=>$2868cc1235412e16$var$html`การเลือกปัจจุบัน: <strong>${name}</strong>`,
    ur: (name)=>$2868cc1235412e16$var$html`موجودہ انتخاب: <strong>${name}</strong>`,
    vi: (name)=>$2868cc1235412e16$var$html`Lựa chọn hiện tại: <strong>${name}</strong>`,
    "zh-hans": (name)=>$2868cc1235412e16$var$html`当前选择： <strong>${name}</strong>`,
    "zh-hant": (name)=>$2868cc1235412e16$var$html`當前選擇： <strong>${name}</strong>`,
    en: (name)=>$2868cc1235412e16$var$html`Current selection: <strong>${name}</strong>`
};
const $2868cc1235412e16$export$8db4589b927d8eb = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{644}\u{63A}\u{629}`,
    de: `Sprache finden`,
    es: `Buscar idioma`,
    fa: `\u{632}\u{628}\u{627}\u{646} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Trouver une langue`,
    hi: `\u{92D}\u{93E}\u{937}\u{93E} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Jwenn lang`,
    it: `Trova la lingua`,
    ja: `\u{8A00}\u{8A9E}\u{306E}\u{691C}\u{7D22}`,
    ko: `\u{C5B8}\u{C5B4} \u{CC3E}\u{AE30}`,
    mww: `Nrhiav lus`,
    ps: `\u{698}\u{628}\u{647}`,
    pt: `Encontrar idioma`,
    "pt-pt": `Procurar idioma`,
    ru: `\u{41D}\u{430}\u{439}\u{442}\u{438} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: `Su'e le gagana`,
    so: `Raadi luqad`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E20}\u{E32}\u{E29}\u{E32}`,
    ur: `\u{632}\u{628}\u{627}\u{646} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm ng\xf4n ng\u{1EEF}`,
    "zh-hans": `\u{67E5}\u{627E}\u{8BED}\u{8A00}`,
    "zh-hant": `\u{67E5}\u{627E}\u{8A9E}\u{8A00}`,
    en: `Find language`
};
const $2868cc1235412e16$export$e45e1052e4defba = {
    ar: `\u{625}\u{631}\u{633}\u{627}\u{644}`,
    de: `Senden`,
    es: `Enviar`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644}`,
    fil: `Email Address *`,
    fr: `Envoyer`,
    hi: `\u{91C}\u{92E}\u{93E} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Soum\xe8t`,
    it: `Invia`,
    ja: `\u{9001}\u{4FE1}`,
    ko: `\u{C804}\u{C1A1}`,
    mww: `Xa`,
    ps: `\u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{693}\u{647}`,
    pt: `Enviar`,
    "pt-pt": `Enviar`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C}`,
    sm: `Alu e ave i totonu`,
    so: `Gudbi`,
    th: `\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{67E}\u{6CC}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Tr\xecnh`,
    "zh-hans": `\u{63D0}\u{4EA4}`,
    "zh-hant": `\u{63D0}\u{4EA4}`,
    en: `Submit`
};
const $2868cc1235412e16$export$47596adf6caa9a84 = {
    ar: `\u{645}\u{642}\u{62F}\u{645}`,
    de: `Vorgelegt`,
    es: `Presentado`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644}`,
    fil: `Isinumite`,
    fr: `Soumis`,
    hi: `\u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}`,
    ht: `Soum\xe8t`,
    it: `Sommesso`,
    ja: `\u{63D0}\u{51FA}`,
    ko: `\u{C81C}\u{CD9C}`,
    mww: `Xa`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Enviada`,
    "pt-pt": `Enviada`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{44B}`,
    sm: `Auina atu`,
    so: `Gudbiyey`,
    th: `\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{67E}\u{6CC}\u{634}`,
    vi: `G\u{1EED}i`,
    "zh-hans": `\u{63D0}\u{4EA4}`,
    "zh-hant": `\u{63D0}\u{4EA4}`,
    en: `Submitted`
};
const $2868cc1235412e16$export$4a01edaa0a874ea5 = {
    ar: `\u{645}\u{648}\u{636}\u{648}\u{639}`,
    de: `Thema`,
    es: `Tema`,
    fa: `\u{62A}\u{645}`,
    fil: `Tema`,
    fr: `Th\xe8me`,
    hi: `\u{935}\u{93F}\u{937}\u{92F}`,
    ht: `T\xe8m`,
    it: `Tema`,
    ja: `\u{30C6}\u{30FC}\u{30DE}`,
    ko: `\u{C8FC}\u{C81C}`,
    mww: `ntsiab lus`,
    ps: `\u{645}\u{648}\u{636}\u{648}\u{639}`,
    pt: `Tema`,
    "pt-pt": `Tema`,
    ru: `\u{422}\u{435}\u{43C}\u{430}`,
    sm: `Autu`,
    so: `Mawduuca`,
    th: `\u{E2B}\u{E31}\u{E27}\u{E02}\u{E49}\u{E2D}`,
    ur: `\u{645}\u{648}\u{636}\u{648}\u{639}`,
    vi: `\u{110}\u{1EC1} t\xe0i`,
    "zh-hans": `\u{4E3B}\u{9898}`,
    "zh-hant": `\u{4E3B}\u{984C}`,
    en: `Theme`
};
const $2868cc1235412e16$export$ffeb9312ef3f9dcb = {
    ar: `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{646}\u{633}\u{642}`,
    de: `W\xe4hlen Sie ein Thema`,
    es: `Elige un tema`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{637}\u{631}\u{62D} \u{632}\u{645}\u{6CC}\u{646}\u{647}`,
    fil: `Pumili ng Tema`,
    fr: `Choisissez un th\xe8me`,
    hi: `\u{90F}\u{915} \u{925}\u{940}\u{92E} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi yon t\xe8m`,
    it: `Scegli un tema`,
    ja: `\u{30C6}\u{30FC}\u{30DE}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}`,
    ko: `\u{D14C}\u{B9C8} \u{C120}\u{D0DD}`,
    mww: `Xaiv ib lub ntsiab`,
    ps: `\u{645}\u{648}\u{636}\u{648}\u{639} \u{63A}\u{648}\u{631}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha um tema`,
    "pt-pt": `Escolha um tema`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{435}\u{43C}\u{443}`,
    sm: `Filifili se autu`,
    so: `Dooro mawduuc`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E18}\u{E35}\u{E21}`,
    ur: `\u{645}\u{648}\u{636}\u{648}\u{639} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ch\u{1EE7} \u{111}\u{1EC1}`,
    "zh-hans": `\u{9009}\u{62E9}\u{4E3B}\u{9898}`,
    "zh-hant": `\u{9078}\u{64C7}\u{4E3B}\u{984C}`,
    en: `Choose a theme`
};
const $2868cc1235412e16$export$a793bbaad7f3eb70 = {
    ar: (cumulus)=>`\u{645}\u{62F}\u{639}\u{648}\u{645} \u{645}\u{646} ${cumulus}`,
    de: (cumulus)=>`Angetrieben von ${cumulus}`,
    es: (cumulus)=>`Desarrollado por ${cumulus}`,
    fa: (cumulus)=>`\u{637}\u{631}\u{627}\u{62D}\u{6CC} \u{634}\u{62F}\u{647} \u{62A}\u{648}\u{633}\u{637} ${cumulus}`,
    fil: (cumulus)=>`Username: ${cumulus}`,
    fr: (cumulus)=>`Propuls\xe9 par ${cumulus}`,
    hi: (cumulus)=>`${cumulus} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{938}\u{902}\u{91A}\u{93E}\u{932}\u{93F}\u{924}`,
    ht: (cumulus)=>`Patwone pa ${cumulus}`,
    it: (cumulus)=>`Realizzato da ${cumulus}`,
    ja: (cumulus)=>`${cumulus} \u{3092}\u{642D}\u{8F09}`,
    ko: (cumulus)=>`${cumulus} \u{C81C}\u{ACF5}`,
    mww: (cumulus)=>`Powered los ${cumulus}`,
    ps: (cumulus)=>`\u{62F} ${cumulus} \u{644}\u{62E}\u{648}\u{627} \u{681}\u{648}\u{627}\u{6A9}\u{645}\u{646} \u{634}\u{648}\u{6CC}`,
    pt: (cumulus)=>`Desenvolvido por ${cumulus}`,
    "pt-pt": (cumulus)=>`Desenvolvido por ${cumulus}`,
    ru: (cumulus)=>`\u{420}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{435}\u{442} \u{43D}\u{430} ${cumulus}`,
    sm: (cumulus)=>`Fa'amalosia e ${cumulus}`,
    so: (cumulus)=>`Waxaa laga awoodaa ${cumulus}`,
    th: (cumulus)=>`\u{E02}\u{E31}\u{E1A}\u{E40}\u{E04}\u{E25}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E42}\u{E14}\u{E22} ${cumulus}`,
    ur: (cumulus)=>`\u{6A9}\u{645}\u{648}\u{644}\u{633} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6C1} ${cumulus}`,
    vi: (cumulus)=>`\u{110}\u{1B0}\u{1EE3}c cung c\u{1EA5}p b\u{1EDF}i ${cumulus}`,
    "zh-hans": (cumulus)=>`\u{7531} ${cumulus} \u{63D0}\u{4F9B}\u{652F}\u{6301}`,
    "zh-hant": (cumulus)=>`\u{7531} ${cumulus} \u{63D0}\u{4F9B}\u{652F}\u{63F4}`,
    en: (cumulus)=>`Powered by ${cumulus}`
};
const $2868cc1235412e16$export$2f8dde2e869bc7b8 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{631}\u{62F} \u{639}\u{644}\u{64A}\u{647}`,
    de: `Unbeantwortet`,
    es: `Por contestar`,
    fa: `\u{628}\u{6CC} \u{67E}\u{627}\u{633}\u{62E}`,
    fil: `Hindi nasagot`,
    fr: `Sans r\xe9ponse`,
    hi: `\u{905}\u{928}\u{941}\u{924}\u{94D}\u{924}\u{930}\u{93F}\u{924}`,
    ht: `San repons`,
    it: `Senza risposta`,
    ja: `\u{672A}\u{89E3}\u{6C7A}`,
    ko: `\u{B2F5}`,
    mww: `unanswered`,
    ps: `\u{628}\u{6D0} \u{681}\u{648}\u{627}\u{628}\u{647}`,
    pt: `Sem resposta`,
    "pt-pt": `Sem resposta`,
    ru: `\u{411}\u{435}\u{437}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{43D}\u{44B}\u{439}`,
    sm: `E le'i taliina`,
    so: `Jawaab la'aan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E04}\u{E4D}\u{E32}\u{E15}\u{E2D}\u{E1A}`,
    ur: `\u{62C}\u{648}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `Unanswered`,
    "zh-hans": `\u{60AC}\u{800C}\u{672A}\u{51B3}`,
    "zh-hant": `\u{61F8}\u{800C}\u{672A}\u{6C7A}`,
    en: `Unanswered`
};
const $2868cc1235412e16$export$bf155eef9c17fa3b = {
    ar: `(\u{645}\u{637}\u{644}\u{648}\u{628})`,
    de: `(Erforderlich)`,
    es: `(Obligatorio)`,
    fa: `(\u{636}\u{631}\u{648}\u{631}\u{6CC})`,
    fil: `(Kinakailangan)`,
    fr: `(Obligatoire)`,
    hi: `(\u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915})`,
    ht: `(Obligatwa)`,
    it: `(Obbligatorio)`,
    ja: `(\u{5FC5}\u{9808}\u{9805}\u{76EE})`,
    ko: `(\u{D544}\u{C218})`,
    mww: `(Yuav tsum tau)`,
    ps: `(\u{636}\u{631}\u{648}\u{631}\u{6CC})`,
    pt: `(Obrigat\xf3rio)`,
    "pt-pt": `(Obrigat\xf3rio)`,
    ru: `(\u{41E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E})`,
    sm: `(Mana'omia)`,
    so: `(Baahan yahay)`,
    th: `(\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19})`,
    ur: `(\u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2})`,
    vi: `(B\u{1EAF}t bu\u{1ED9}c)`,
    "zh-hans": `\u{FF08}\u{5FC5}\u{586B}\u{FF09}`,
    "zh-hant": `\u{FF08}\u{5FC5}\u{586B}\u{FF09}`,
    en: `(Required)`
};
const $2868cc1235412e16$export$825e8c5a8de791dd = {
    ar: `\u{634}\u{643}\u{631}\u{627} \u{644}\u{645}\u{634}\u{627}\u{631}\u{643}\u{62A}\u{643} \u{641}\u{64A} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{637}\u{644}\u{627}\u{639}! \u{64A}\u{645}\u{643}\u{646}\u{643} \u{625}\u{63A}\u{644}\u{627}\u{642} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}.`,
    de: `Vielen Dank, dass Sie an der Umfrage teilgenommen haben! Sie k\xf6nnen diese Seite schlie\xdfen.`,
    es: `\xa1Gracias por participar en la encuesta! Puede cerrar esta p\xe1gina.`,
    fa: `\u{628}\u{627} \u{62A}\u{634}\u{6A9}\u{631} \u{627}\u{632} \u{634}\u{645}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{634}\u{631}\u{6A9}\u{62A} \u{62F}\u{631} \u{646}\u{638}\u{631}\u{633}\u{646}\u{62C}\u{6CC}! \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{631}\u{627} \u{628}\u{628}\u{646}\u{62F}\u{6CC}\u{62F}.`,
    fil: `Salamat sa pakikilahok sa survey! Maaari mong isara ang pahinang ito.`,
    fr: `Merci de participer au sondage\xa0! Vous pouvez fermer cette page.`,
    hi: `\u{938}\u{930}\u{94D}\u{935}\u{947}\u{915}\u{94D}\u{937}\u{923} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{927}\u{928}\u{94D}\u{92F}\u{935}\u{93E}\u{926}! \u{906}\u{92A} \u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{915}\u{94B} \u{92C}\u{902}\u{926} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}\u{964}`,
    ht: `M\xe8si pou patisipe nan sondaj la! Ou ka f\xe8men paj sa a.`,
    it: `Grazie per aver partecipato al sondaggio! Puoi chiudere questa pagina.`,
    ja: `\u{3053}\u{306E}\u{5EA6}\u{306F}\u{3001}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{306B}\u{3054}\u{5354}\u{529B}\u{3044}\u{305F}\u{3060}\u{304D}\u{3001}\u{8AA0}\u{306B}\u{3042}\u{308A}\u{304C}\u{3068}\u{3046}\u{3054}\u{3056}\u{3044}\u{307E}\u{3057}\u{305F}\u{3002}\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306F}\u{9589}\u{3058}\u{3066}\u{3082}\u{304B}\u{307E}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C124}\u{BB38}\u{C870}\u{C0AC}\u{C5D0} \u{CC38}\u{C5EC}\u{D574} \u{C8FC}\u{C154}\u{C11C} \u{AC10}\u{C0AC}\u{D569}\u{B2C8}\u{B2E4}! \u{C774} \u{D398}\u{C774}\u{C9C0}\u{B97C} \u{B2EB}\u{C744} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Ua tsaug rau koj koom rau hauv daim ntawv ntsuam xyuas! Koj yuav kaw tau nplooj ntawv no.`,
    ps: `\u{645}\u{646}\u{646}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{633}\u{631}\u{648}\u{6D0} \u{6A9}\u{6D0} \u{6CC}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{648}\u{627}\u{62E}\u{6CC}\u{633}\u{62A}\u{647}! \u{634}\u{645}\u{627} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{631}\u{627} \u{628}\u{628}\u{646}\u{62F}\u{6CC}\u{62F}.`,
    pt: `Obrigado por participar da pesquisa! Voc\xea pode fechar esta p\xe1gina.`,
    "pt-pt": `Obrigado por participar no inqu\xe9rito! Pode fechar esta p\xe1gina.`,
    ru: `\u{411}\u{43B}\u{430}\u{433}\u{43E}\u{434}\u{430}\u{440}\u{438}\u{43C} \u{412}\u{430}\u{441} \u{437}\u{430} \u{443}\u{447}\u{430}\u{441}\u{442}\u{438}\u{435} \u{432} \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{435}! \u{412}\u{44B} \u{43C}\u{43E}\u{436}\u{435}\u{442}\u{435} \u{437}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{443}.`,
    sm: `Fa'afetai mo le auai i le su'esu'ega! E mafai ona e tapunia lenei itulau.`,
    so: `Waad ku mahadsan tahay ka qayb qaadashada baadhitaanka! Waxaa laga yaabaa inaad ku xirato boggan.`,
    th: `\u{E02}\u{E2D}\u{E02}\u{E2D}\u{E1A}\u{E04}\u{E38}\u{E13}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08}! \u{E04}\u{E38}\u{E13}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E1B}\u{E34}\u{E14}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{633}\u{631}\u{648}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{622}\u{67E} \u{6A9}\u{627} \u{634}\u{6A9}\u{631}\u{6CC}\u{6C1}! \u{622}\u{67E} \u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{6A9}\u{648} \u{628}\u{646}\u{62F} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}.`,
    vi: `C\u{1EA3}m \u{1A1}n b\u{1EA1}n \u{111}\xe3 tham gia kh\u{1EA3}o s\xe1t! B\u{1EA1}n c\xf3 th\u{1EC3} \u{111}\xf3ng trang n\xe0y.`,
    "zh-hans": `\u{611F}\u{8C22}\u{60A8}\u{53C2}\u{4E0E}\u{8C03}\u{67E5}\u{FF01}\u{60A8}\u{53EF}\u{4EE5}\u{5173}\u{95ED}\u{6B64}\u{9875}\u{9762}\u{3002}`,
    "zh-hant": `\u{611F}\u{8B1D}\u{60A8}\u{53C3}\u{8207}\u{8ABF}\u{67E5}\u{FF01}\u{60A8}\u{53EF}\u{4EE5}\u{95DC}\u{9589}\u{6B64}\u{9801}\u{9762}\u{3002}`,
    en: `Thank you for participating in the survey! You may close this page.`
};
const $2868cc1235412e16$export$826275f81608c9b6 = {
    ar: (href)=>$2868cc1235412e16$var$html`<a href="${href}">إرسال استطلاع آخر</a> لشخص آخر.`,
    de: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Reichen Sie eine weitere Umfrage</a> für eine andere Person ein.`,
    es: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Envíe otra encuesta</a> para otra persona.`,
    fa: (href)=>$2868cc1235412e16$var$html`<a href="${href}">نظرسنجی دیگری</a> برای شخص دیگری ارسال کنید.`,
    fil: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Magsumite ng isa pang survey</a> para sa iba.`,
    fr: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Soumettez un autre sondage</a> pour quelqu’un d’autre.`,
    hi: (href)=>$2868cc1235412e16$var$html`किसी अन्य व्यक्ति के लिए <a href="${href}">कोई अन्य सर्वेक्षण सबमिट करें</a>.`,
    ht: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Soumèt yon lòt sondaj pou yon</a> lòt moun.`,
    it: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Invia un'altra indagine</a> per qualcun altro.`,
    ja: (href)=>$2868cc1235412e16$var$html`他のユーザーのために<a href="${href}">別のアンケートを送信します</a>。`,
    ko: (href)=>$2868cc1235412e16$var$html`다른 사람을 위해 <a href="${href}">다른 설문조사를 제출합니다</a>.`,
    mww: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Xa lwm daim ntawv ntsuam xyuas</a> rau lwm tus neeg.`,
    ps: (href)=>$2868cc1235412e16$var$html`د بل چا لپاره <a href="${href}">یوه بله سروې ثبت</a> کړئ.`,
    pt: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Envie outra pesquisa</a> para outra pessoa.`,
    "pt-pt": (href)=>$2868cc1235412e16$var$html`<a href="${href}">Envie outra pesquisa</a> para outra pessoa.`,
    ru: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Отправьте еще один опрос</a> для другого человека.`,
    sm: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Auina atu se isi sailiiliga</a> mo se isi tagata.`,
    so: (href)=>$2868cc1235412e16$var$html`<a href="${href}">U samee sahan kale</a> qof kale.`,
    th: (href)=>$2868cc1235412e16$var$html`<a href="${href}">ส่งแบบสํารวจอื่น</a> ให้คนอื่น`,
    ur: (href)=>$2868cc1235412e16$var$html`کسی اور کے لئے <a href="${href}">ایک اور سروے پیش کریں</a>.`,
    vi: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Gửi một cuộc khảo sát khác</a> cho người khác.`,
    "zh-hans": (href)=>$2868cc1235412e16$var$html`为其他人<a href="${href}">提交另一个调查</a>。`,
    "zh-hant": (href)=>$2868cc1235412e16$var$html`為其他人<a href="${href}">提交另一個調查</a>。`,
    en: (href)=>$2868cc1235412e16$var$html`<a href="${href}">Submit another survey</a> for someone else.`
};
const $2868cc1235412e16$export$9783dfaf4b8f5180 = {
    ar: $2868cc1235412e16$var$html`هذا الموقع محمي بواسطة reCAPTCHA وتطبق <a class="Link--secondary" href="https://policies.google.com/privacy">سياسة خصوصية</a> Google <a class="Link--secondary" href="https://policies.google.com/terms">وبنود</a> الخدمة.`,
    de: $2868cc1235412e16$var$html`Diese Website ist durch reCAPTCHA geschützt und es gelten die <a class="Link--secondary" href="https://policies.google.com/privacy">Datenschutzbestimmungen</a> und <a class="Link--secondary" href="https://policies.google.com/terms">Nutzungsbedingungen von</a> Google.`,
    es: $2868cc1235412e16$var$html`Este sitio está protegido por reCAPTCHA y se aplican la <a class="Link--secondary" href="https://policies.google.com/privacy">Política de privacidad</a> y los <a class="Link--secondary" href="https://policies.google.com/terms">Términos de servicio de</a> Google.`,
    fa: $2868cc1235412e16$var$html`این سایت توسط reCAPTCHA محافظت می شود و <a class="Link--secondary" href="https://policies.google.com/privacy">سیاست حفظ حریم خصوصی</a> و <a class="Link--secondary" href="https://policies.google.com/terms">شرایط خدمات</a> Google اعمال می شود.`,
    fil: $2868cc1235412e16$var$html`Ang site na ito ay protektado ng reCAPTCHA at nalalapat ang <a class="Link--secondary" href="https://policies.google.com/privacy">Patakaran sa Privacy</a> at <a class="Link--secondary" href="https://policies.google.com/terms">Mga Tuntunin ng Serbisyo</a> ng Google.`,
    fr: $2868cc1235412e16$var$html`Ce site est protégé par reCAPTCHA et les <a class="Link--secondary" href="https://policies.google.com/privacy">règles de confidentialité</a> et <a class="Link--secondary" href="https://policies.google.com/terms">les conditions d’utilisation de Google s’appliquent</a> .`,
    hi: $2868cc1235412e16$var$html`यह साइट reCAPTCHA द्वारा सुरक्षित है और Google <a class="Link--secondary" href="https://policies.google.com/privacy">गोपनीयता नीति</a> और <a class="Link--secondary" href="https://policies.google.com/terms">सेवा की शर्तें</a> लागू होती हैं।`,
    ht: $2868cc1235412e16$var$html`Sit sa a pwoteje pa reCAPTCHA ak Règleman <a class="Link--secondary" href="https://policies.google.com/privacy">sou enfòmasyon prive</a> Google ak <a class="Link--secondary" href="https://policies.google.com/terms">Kondisyon sèvis aplike</a> .`,
    it: $2868cc1235412e16$var$html`Questo sito è protetto da reCAPTCHA e si applicano le <a class="Link--secondary" href="https://policies.google.com/privacy">Norme sulla privacy</a> e i <a class="Link--secondary" href="https://policies.google.com/terms">Termini di servizio di</a> Google.`,
    ja: $2868cc1235412e16$var$html`このサイトはreCAPTCHAによって保護されており、Googleの <a class="Link--secondary" href="https://policies.google.com/privacy">プライバシーポリシー</a> と <a class="Link--secondary" href="https://policies.google.com/terms">利用規約</a> が適用されます。`,
    ko: $2868cc1235412e16$var$html`이 사이트는 reCAPTCHA로 보호되며 Google <a class="Link--secondary" href="https://policies.google.com/privacy">개인 정보 보호 정책</a> 및 <a class="Link--secondary" href="https://policies.google.com/terms">서비스 약관</a> 이 적용됩니다.`,
    mww: $2868cc1235412e16$var$html`Qhov chaw no yog tiv thaiv los ntawm reCAPTCHA thiab cov Google <a class="Link--secondary" href="https://policies.google.com/privacy">Privacy Policy</a> thiab <a class="Link--secondary" href="https://policies.google.com/terms">cov ntsiab lus uas</a> siv.`,
    ps: $2868cc1235412e16$var$html`دا ویب پاڼه د reCAPTCHA لخوا ساتل کیږی او د ګوګل <a class="Link--secondary" href="https://policies.google.com/privacy">محرمیت پالیسۍ</a> او د <a class="Link--secondary" href="https://policies.google.com/terms">خدمتونو شرایط</a> پلی کیږی.`,
    pt: $2868cc1235412e16$var$html`Este site é protegido por reCAPTCHA e a <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidade</a> e os <a class="Link--secondary" href="https://policies.google.com/terms">Termos de Serviço do</a> Google se aplicam.`,
    "pt-pt": $2868cc1235412e16$var$html`Este site é protegido pelo reCAPTCHA e aplicam-se a <a class="Link--secondary" href="https://policies.google.com/privacy">Política de Privacidade</a> e <a class="Link--secondary" href="https://policies.google.com/terms">os Termos de Serviço do</a> Google.`,
    ru: $2868cc1235412e16$var$html`Этот сайт защищен reCAPTCHA, и на него распространяются <a class="Link--secondary" href="https://policies.google.com/privacy">Политика конфиденциальности</a> и <a class="Link--secondary" href="https://policies.google.com/terms">Условия предоставления услуг</a> Google.`,
    sm: $2868cc1235412e16$var$html`O lenei 'upega tafa'ilagi e puipuia e le reCAPTCHA ma le Google <a class="Link--secondary" href="https://policies.google.com/privacy">faalauaiteleina Faiga Faavae</a> ma <a class="Link--secondary" href="https://policies.google.com/terms">Tuutuuga o Auaunaga fa'aaogaina</a> .`,
    so: $2868cc1235412e16$var$html`Boggan waxaa ilaaliya reCAPTCHA iyo <a class="Link--secondary" href="https://policies.google.com/privacy">Siyaasadda Khaaska ah</a> ee Google iyo <a class="Link--secondary" href="https://policies.google.com/terms">Shuruudaha Adeeggu waxay</a> codsan karaan.`,
    th: $2868cc1235412e16$var$html`ไซต์นี้ได้รับการคุ้มครองโดย reCAPTCHA และมีผลบังคับใช้ <a class="Link--secondary" href="https://policies.google.com/privacy">นโยบายความเป็นส่วนตัว</a> และ <a class="Link--secondary" href="https://policies.google.com/terms">ข้อกําหนดในการให้บริการ</a> ของ Google`,
    ur: $2868cc1235412e16$var$html`یہ سائٹ ری کیپچا کے ذریعہ محفوظ ہے اور گوگل <a class="Link--secondary" href="https://policies.google.com/privacy">پرائیویسی پالیسی</a> اور <a class="Link--secondary" href="https://policies.google.com/terms">سروس کی شرائط لاگو</a> ہوتی ہیں۔`,
    vi: $2868cc1235412e16$var$html`Trang web này được bảo vệ bởi reCAPTCHA và <a class="Link--secondary" href="https://policies.google.com/privacy">áp dụng Chính sách quyền riêng tư</a> và <a class="Link--secondary" href="https://policies.google.com/terms">Điều khoản dịch vụ</a> của Google.`,
    "zh-hans": $2868cc1235412e16$var$html`本网站受 reCAPTCHA 保护，并适用 Google <a class="Link--secondary" href="https://policies.google.com/privacy">隐私政策</a> 和 <a class="Link--secondary" href="https://policies.google.com/terms">服务条款</a> 。`,
    "zh-hant": $2868cc1235412e16$var$html`本網站受 reCAPTCHA 保護，並適用 Google <a class="Link--secondary" href="https://policies.google.com/privacy">隱私政策</a> 和 <a class="Link--secondary" href="https://policies.google.com/terms">服務條款</a> 。`,
    en: $2868cc1235412e16$var$html`This site is protected by reCAPTCHA and the Google <a class="Link--secondary" href="https://policies.google.com/privacy">Privacy Policy</a> and <a class="Link--secondary" href="https://policies.google.com/terms">Terms of Service</a> apply.`
};
const $2868cc1235412e16$export$6dbdd35290b5a961 = {
    ar: `\u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A} \u{627}\u{644}\u{62E}\u{641}\u{64A}\u{641}`,
    de: `Leichter Ausfall`,
    es: `Luz predeterminada`,
    fa: `\u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{646}\u{648}\u{631}`,
    fil: `Banayad na Default`,
    fr: `Lumi\xe8re par d\xe9faut`,
    hi: `\u{932}\u{93E}\u{907}\u{91F} \u{921}\u{940}\u{92B}\u{949}\u{932}\u{94D}\u{91F}`,
    ht: `Limy\xe8 default`,
    it: `Luce predefinita`,
    ja: `\u{30E9}\u{30A4}\u{30C8}\u{306E}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}`,
    ko: `\u{B77C}\u{C774}\u{D2B8} \u{AE30}\u{BCF8}\u{AC12}`,
    mww: `Teeb Default`,
    ps: `\u{62F} \u{631}\u{6BC}\u{627} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C}`,
    pt: `Padr\xe3o leve`,
    "pt-pt": `Padr\xe3o de luz`,
    ru: `\u{421}\u{432}\u{435}\u{442}\u{43B}\u{44B}\u{439} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Fa'aletonu Malamalama`,
    so: `Light Default`,
    th: `\u{E04}\u{E48}\u{E32}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E41}\u{E2A}\u{E07}`,
    ur: `\u{644}\u{627}\u{626}\u{679} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679}`,
    vi: `M\u{1EB7}c \u{111}\u{1ECB}nh \xe1nh s\xe1ng`,
    "zh-hans": `Light Default`,
    "zh-hant": `Light Default`,
    en: `Light Default`
};
const $2868cc1235412e16$export$e3e04cfa8cb29bc6 = {
    ar: `\u{636}\u{648}\u{621} \u{639}\u{627}\u{644}\u{64A} \u{627}\u{644}\u{62A}\u{628}\u{627}\u{64A}\u{646}`,
    de: `Licht Hoher Kontrast`,
    es: `Luz de alto contraste`,
    fa: `\u{6A9}\u{646}\u{62A}\u{631}\u{627}\u{633}\u{62A} \u{628}\u{627}\u{644}\u{627} \u{646}\u{648}\u{631}`,
    fil: `Banayad na Mataas na Pagkakaiba`,
    fr: `Lumi\xe8re \xe0 contraste \xe9lev\xe9`,
    hi: `\u{932}\u{93E}\u{907}\u{91F} \u{939}\u{93E}\u{908} \u{915}\u{902}\u{91F}\u{94D}\u{930}\u{93E}\u{938}\u{94D}\u{91F}`,
    ht: `Limy\xe8 gwo kontras`,
    it: `Luce ad alto contrasto`,
    ja: `\u{30E9}\u{30A4}\u{30C8}\u{30CF}\u{30A4}\u{30B3}\u{30F3}\u{30C8}\u{30E9}\u{30B9}\u{30C8}`,
    ko: `\u{B77C}\u{C774}\u{D2B8} \u{D558}\u{C774} \u{CF58}\u{D2B8}\u{B77C}\u{C2A4}\u{D2B8}`,
    mww: `Siab contrast`,
    ps: `\u{62F} \u{631}\u{6BC}\u{627} \u{644}\u{648}\u{693} \u{6A9}\u{646}\u{62A}\u{631}\u{627}\u{633}\u{62A}`,
    pt: `Luz de alto contraste`,
    "pt-pt": `Luz de Alto Contraste`,
    ru: `\u{421}\u{432}\u{435}\u{442}, \u{432}\u{44B}\u{441}\u{43E}\u{43A}\u{430}\u{44F} \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{441}\u{442}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Malamalama Maualuga Eseesega`,
    so: `Light High Contrast`,
    th: `\u{E41}\u{E2A}\u{E07} \u{E04}\u{E2D}\u{E19}\u{E17}\u{E23}\u{E32}\u{E2A}\u{E15}\u{E4C}\u{E2A}\u{E39}\u{E07}`,
    ur: `\u{644}\u{627}\u{626}\u{679} \u{6C1}\u{627}\u{626}\u{6CC} \u{6A9}\u{646}\u{679}\u{631}\u{627}\u{633}\u{679}`,
    vi: `\u{110}\u{1ED9} t\u{1B0}\u{1A1}ng ph\u{1EA3}n cao \xe1nh s\xe1ng`,
    "zh-hans": `Light High Contrast`,
    "zh-hant": `Light High Contrast`,
    en: `Light High Contrast`
};
const $2868cc1235412e16$export$1dc738496858a682 = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{62E}\u{641}\u{64A}\u{641}\u{629} & \u{62F}\u{64A}\u{648}\u{62A}\u{64A}\u{631}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627}`,
    de: `Leichte Protanopie & Deuteranopie`,
    es: `Protanopia ligera y deuteranopia`,
    fa: `\u{67E}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{646}\u{648}\u{631} \u{648} \u{62F}\u{648}\u{62A}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    fil: `Banayad na Protanopia at Deuteranopia`,
    fr: `Protanopie l\xe9g\xe8re et deut\xe9ranopie`,
    hi: `\u{932}\u{93E}\u{907}\u{91F} \u{92A}\u{94D}\u{930}\u{94B}\u{91F}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E} \u{914}\u{930} \u{921}\u{94D}\u{92F}\u{942}\u{91F}\u{947}\u{930}\u{94B}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Limy\xe8 Protanopia & Deuteranopia`,
    it: `Protanopia leggera e deuteranopia`,
    ja: `\u{30E9}\u{30A4}\u{30C8}\u{30D7}\u{30ED}\u{30BF}\u{30CE}\u{30D4}\u{30A2}\u{3068}\u{30C7}\u{30E5}\u{30FC}\u{30BB}\u{30E9}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{AC00}\u{BCBC}\u{C6B4} Protanopia & Deuteranopia`,
    mww: `Teeb Protanopia & Deuteranopia`,
    ps: `Light Protanopia & Deuteranopia`,
    pt: `Protanopia Leve & Deuteranopia`,
    "pt-pt": `Protanopia leve & Deuteranopia`,
    ru: `\u{41B}\u{435}\u{433}\u{43A}\u{430}\u{44F} \u{43F}\u{440}\u{43E}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F} \u{438} \u{434}\u{435}\u{439}\u{442}\u{435}\u{440}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Malamalama Protanopia ma Deuteranopia`,
    so: `Light Protanopia & Deuteranopia`,
    th: `\u{E42}\u{E1B}\u{E23}\u{E15}\u{E32}\u{E42}\u{E19}\u{E40}\u{E1B}\u{E35}\u{E22}\u{E40}\u{E1A}\u{E32} \u{E41}\u{E25}\u{E30} Deuteranopia`,
    ur: `Light Protanopeia &Deuteran\u{648}\u{67E}\u{6CC}\u{627}`,
    vi: `Protanopia nh\u{1EB9} & Deuteranopia`,
    "zh-hans": `\u{8F7B}\u{7EA2}\u{8272}\u{76F2} & \u{7EFF}\u{8272}\u{76F2}`,
    "zh-hant": `\u{8F15}\u{7D05}\u{8272}\u{76F2} & \u{7DA0}\u{8272}\u{76F2}`,
    en: `Light Protanopia & Deuteranopia`
};
const $2868cc1235412e16$export$ec1bd9825525d3c4 = {
    ar: `\u{62A}\u{631}\u{64A}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{62E}\u{641}\u{64A}\u{641}\u{629}`,
    de: `Leichte Tritanopie`,
    es: `Tritanopia ligera`,
    fa: `Tritanopia \u{633}\u{628}\u{6A9}`,
    fil: `Banayad na Tritanopia`,
    fr: `Tritanopie l\xe9g\xe8re`,
    hi: `\u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{936} \u{91F}\u{94D}\u{930}\u{93F}\u{91F}\u{947}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Limy\xe8 Tritanopia`,
    it: `Tritanopia Chiara`,
    ja: `\u{30E9}\u{30A4}\u{30C8}\u{30C8}\u{30EA}\u{30BF}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{B77C}\u{C774}\u{D2B8} \u{D2B8}\u{B9AC}\u{D0C0}\u{B178}\u{D53C}\u{C544}`,
    mww: `Teeb Tritanopia`,
    ps: `\u{631}\u{6BC}\u{627} \u{67C}\u{631}\u{6CC}\u{67C}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    pt: `Tritanopia leve`,
    "pt-pt": `Tritanopia leve`,
    ru: `\u{421}\u{432}\u{435}\u{442}\u{43B}\u{430}\u{44F} \u{442}\u{440}\u{438}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Tritanopia Malamalama`,
    so: `Light Tritanopia`,
    th: `\u{E44}\u{E25}\u{E17}\u{E4C} Tritanopia`,
    ur: `Light Tritanopia`,
    vi: `Tritanopia nh\u{1EB9}`,
    "zh-hans": `\u{8F7B}\u{5EA6}\u{84DD}\u{8272}\u{76F2}`,
    "zh-hant": `\u{8F15}\u{5EA6}\u{85CD}\u{8272}\u{76F2}`,
    en: `Light Tritanopia`
};
const $2868cc1235412e16$export$e6d78ef699b242e3 = {
    ar: `\u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A} \u{627}\u{644}\u{62F}\u{627}\u{643}\u{646}`,
    de: `Dunkler Standard`,
    es: `Oscuro por defecto`,
    fa: `\u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{62A}\u{627}\u{631}\u{6CC}\u{6A9}`,
    fil: `Madilim na Default`,
    fr: `Sombre par d\xe9faut`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{921}\u{93F}\u{92B}\u{949}\u{932}\u{94D}\u{91F}`,
    ht: `Default nwa`,
    it: `Scuro predefinito`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}`,
    ko: `\u{C5B4}\u{B450}\u{C6B4} \u{AE30}\u{BCF8}\u{AC12}`,
    mww: `Tsaus default`,
    ps: `\u{62A}\u{627}\u{631}\u{6CC}\u{6A9} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C}`,
    pt: `Padr\xe3o escuro`,
    "pt-pt": `Padr\xe3o escuro`,
    ru: `\u{422}\u{435}\u{43C}\u{43D}\u{44B}\u{439} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Pogisa Faaletonu`,
    so: `Dark Default`,
    th: `\u{E04}\u{E48}\u{E32}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E21}\u{E37}\u{E14}`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{688}\u{6CC}\u{641}\u{627}\u{644}\u{679}`,
    vi: `M\u{1EB7}c \u{111}\u{1ECB}nh t\u{1ED1}i`,
    "zh-hans": `\u{6DF1}\u{8272}\u{9ED8}\u{8BA4}`,
    "zh-hant": `\u{6DF1}\u{8272}\u{9810}\u{8A2D}`,
    en: `Dark Default`
};
const $2868cc1235412e16$export$6853c47cb425f877 = {
    ar: `\u{62A}\u{628}\u{627}\u{64A}\u{646} \u{639}\u{627}\u{644} \u{62F}\u{627}\u{643}\u{646}`,
    de: `Dunkel Hoher Kontrast`,
    es: `Oscuro de alto contraste`,
    fa: `\u{6A9}\u{646}\u{62A}\u{631}\u{627}\u{633}\u{62A} \u{628}\u{627}\u{644}\u{627} \u{62A}\u{6CC}\u{631}\u{647}`,
    fil: `Madilim na Mataas na Pagkakaiba`,
    fr: `Contraste \xe9lev\xe9 fonc\xe9`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{939}\u{93E}\u{908} \u{915}\u{902}\u{91F}\u{94D}\u{930}\u{93E}\u{938}\u{94D}\u{91F}`,
    ht: `Nwa segond\xe8 kontras`,
    it: `Scuro ad alto contrasto`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30CF}\u{30A4}\u{30B3}\u{30F3}\u{30C8}\u{30E9}\u{30B9}\u{30C8}`,
    ko: `\u{C9C4}\u{D55C} \u{ACE0}\u{B300}\u{BE44}`,
    mww: `Tsaus nti contrast`,
    ps: `\u{62A}\u{6CC}\u{627}\u{631}\u{647} \u{644}\u{648}\u{693} \u{6A9}\u{646}\u{62A}\u{631}\u{627}\u{633}\u{62A}`,
    pt: `Alto contraste escuro`,
    "pt-pt": `Alto contraste escuro`,
    ru: `\u{422}\u{435}\u{43C}\u{43D}\u{44B}\u{439} \u{432}\u{44B}\u{441}\u{43E}\u{43A}\u{43E}\u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{441}\u{442}\u{43D}\u{44B}\u{439}`,
    sm: `Pogisa Maualuga Eseesega`,
    so: `Dark High Contrast`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E21}\u{E0A}\u{E31}\u{E14}\u{E2A}\u{E39}\u{E07}\u{E40}\u{E02}\u{E49}\u{E21}`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{6C1}\u{627}\u{626}\u{6CC} \u{6A9}\u{646}\u{679}\u{631}\u{627}\u{633}\u{679}`,
    vi: `\u{110}\u{1ED9} t\u{1B0}\u{1A1}ng ph\u{1EA3}n cao t\u{1ED1}i`,
    "zh-hans": `\u{6DF1}\u{8272}\u{9AD8}\u{5BF9}\u{6BD4}\u{5EA6}`,
    "zh-hant": `\u{6DF1}\u{8272}\u{9AD8}\u{5C0D}\u{6BD4}\u{5EA6}`,
    en: `Dark High Contrast`
};
const $2868cc1235412e16$export$355b3fec45de38c5 = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{62F}\u{627}\u{643}\u{646}\u{629} \u{648} Deuteranopia`,
    de: `Dunkle Protanopie & Deuteranopie`,
    es: `Protanopia oscura y deuteranopia`,
    fa: `\u{67E}\u{631}\u{648}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{62A}\u{627}\u{631}\u{6CC}\u{6A9} \u{648} \u{62F}\u{648}\u{62A}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    fil: `Madilim na Protanopia at Deuteranopia`,
    fr: `Protanopie fonc\xe9e et deut\xe9ranopie`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{92A}\u{94D}\u{930}\u{94B}\u{91F}\u{93E}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E} & \u{921}\u{94D}\u{92F}\u{942}\u{91F}\u{947}\u{930}\u{94B}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Pwotans nwa & Deuteranopia`,
    it: `Protanopia scura e deuteranopia`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30D7}\u{30ED}\u{30BF}\u{30CE}\u{30D4}\u{30A2}\u{3068}\u{30C7}\u{30E5}\u{30FC}\u{30BB}\u{30E9}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{B2E4}\u{D06C} \u{D504}\u{B85C}\u{D0C0}\u{B178}\u{D53C}\u{C544} & \u{B4C0}\u{D14C}\u{B77C}\u{B178}\u{D53C}\u{C544}`,
    mww: `Tsaus Protanopia & Deuteranopia`,
    ps: `\u{62A}\u{648}\u{631}\u{647} \u{67E}\u{631}\u{648}\u{67C}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{627}\u{648} \u{689}\u{6CC}\u{648}\u{67C}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    pt: `Protanopia Escura & Deuteranopia`,
    "pt-pt": `Protanopia Escura & Deuteranopia`,
    ru: `\u{422}\u{435}\u{43C}\u{43D}\u{430}\u{44F} \u{43F}\u{440}\u{43E}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F} \u{438} \u{434}\u{435}\u{439}\u{442}\u{435}\u{440}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Pogisa Protanopia ma Deuteranopia`,
    so: `Dark Protanopia & Deuteranopia`,
    th: `Dark Protanopia \u{E41}\u{E25}\u{E30} Deuteranopia`,
    ur: `\u{688}\u{627}\u{631}\u{6A9} \u{67E}\u{631}\u{648}\u{679}\u{6CC}\u{646}\u{648}\u{67E}\u{6CC}\u{627} \u{627}\u{648}\u{631} \u{688}\u{6CC}\u{648}\u{679}\u{6CC}\u{631}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    vi: `Protanopia \u{111}en v\xe0 Deuteranopia`,
    "zh-hans": `\u{6DF1}\u{8272}\u{7EA2}\u{8272}\u{76F2}\u{548C}\u{7EFF}\u{8272}\u{76F2}`,
    "zh-hant": `\u{6DF1}\u{8272}\u{7D05}\u{8272}\u{76F2}\u{548C}\u{7DA0}\u{8272}\u{76F2}`,
    en: `Dark Protanopia & Deuteranopia`
};
const $2868cc1235412e16$export$7ea2cd3bde4da51f = {
    ar: `\u{62A}\u{631}\u{64A}\u{62A}\u{627}\u{646}\u{648}\u{628}\u{64A}\u{627} \u{627}\u{644}\u{638}\u{644}\u{627}\u{645}`,
    de: `Dunkle Tritanopie`,
    es: `Tritanopia oscura`,
    fa: `Tritanopia \u{62A}\u{627}\u{631}\u{6CC}\u{6A9}`,
    fil: `Madilim na Tritanopia`,
    fr: `Tritanopie fonc\xe9e`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{91F}\u{94D}\u{930}\u{93F}\u{91F}\u{947}\u{928}\u{94B}\u{92A}\u{93F}\u{92F}\u{93E}`,
    ht: `Tritanopia nwa`,
    it: `Tritanopia Scura`,
    ja: `\u{30C0}\u{30FC}\u{30AF}\u{30C8}\u{30EA}\u{30BF}\u{30CE}\u{30D4}\u{30A2}`,
    ko: `\u{B2E4}\u{D06C} \u{D2B8}\u{B9AC}\u{D0C0}\u{B178}\u{D53C}\u{C544}`,
    mww: `Tsaus Nti Tritanopia`,
    ps: `\u{62A}\u{627}\u{631}\u{6CC}\u{6A9} \u{62A}\u{631}\u{6CC}\u{62A}\u{627}\u{646}\u{648}\u{67E}\u{6CC}\u{627}`,
    pt: `Tritanopia Escura`,
    "pt-pt": `Tritanopia escura`,
    ru: `\u{422}\u{435}\u{43C}\u{43D}\u{430}\u{44F} \u{442}\u{440}\u{438}\u{442}\u{430}\u{43D}\u{43E}\u{43F}\u{438}\u{44F}`,
    sm: `Tritanopia pogisa`,
    so: `Dark Tritanopia`,
    th: `Dark Tritanopia`,
    ur: `Dark Tritanopia`,
    vi: `Tritanopia \u{111}en t\u{1ED1}i`,
    "zh-hans": `\u{6DF1}\u{8272}\u{84DD}\u{8272}\u{76F2}`,
    "zh-hant": `\u{6DF1}\u{8272}\u{85CD}\u{8272}\u{76F2}`,
    en: `Dark Tritanopia`
};
const $2868cc1235412e16$export$2c3e747abbbbfa2e = {
    ar: `\u{62E}\u{627}\u{641}\u{62A} \u{63A}\u{627}\u{645}\u{642}`,
    de: `Dunkel abgedunkelt`,
    es: `Atenuado oscuro`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{6A9} \u{6A9}\u{645} \u{646}\u{648}\u{631}`,
    fil: `Madilim na Malabo`,
    fr: `Sombre att\xe9nu\xe9`,
    hi: `\u{921}\u{93E}\u{930}\u{94D}\u{915} \u{921}\u{93F}\u{92E}\u{94D}\u{921}`,
    ht: `Nwa Dimmed`,
    it: `Scuro Oscurato`,
    ja: `\u{30C0}\u{30FC}\u{30AF} \u{30C0}\u{30FC}\u{30AF}`,
    ko: `\u{C5B4}\u{B461}\u{AC8C} \u{D750}\u{B9AC}\u{AC8C}`,
    mww: `Tsaus Nti Dimmed`,
    ps: `\u{62A}\u{6CC}\u{627}\u{631}\u{647} \u{6A9}\u{645} \u{631}\u{646}\u{6AB}\u{647}`,
    pt: `Escuro esmaecido`,
    "pt-pt": `Escurecido escuro`,
    ru: `\u{422}\u{435}\u{43C}\u{43D}\u{44B}\u{439} \u{437}\u{430}\u{442}\u{435}\u{43C}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `Pogisa pogisa`,
    so: `Diirada madow`,
    th: `\u{E21}\u{E37}\u{E14}\u{E2A}\u{E25}\u{E31}\u{E27}`,
    ur: `\u{627}\u{646}\u{62F}\u{6BE}\u{6CC}\u{631}\u{627} \u{62F}\u{6BE}\u{646}\u{62F}\u{644}\u{627}`,
    vi: `T\u{1ED1}i m\u{1EDD}`,
    "zh-hans": `\u{6697}\u{6697} \u{6697}`,
    "zh-hant": `\u{6697}\u{6697} \u{6697}`,
    en: `Dark Dimmed`
};
const $2868cc1235412e16$export$5f009e0fa3d2cf28 = {
    ar: `\u{627}\u{644}\u{646}\u{638}\u{627}\u{645} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Systemstandard`,
    es: `Predeterminado del sistema`,
    fa: `\u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{633}\u{6CC}\u{633}\u{62A}\u{645}`,
    fil: `System Default`,
    fr: `Syst\xe8me par d\xe9faut`,
    hi: `\u{938}\u{93F}\u{938}\u{94D}\u{91F}\u{92E} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F}`,
    ht: `Sist\xe8m Default`,
    it: `Impostazioni predefinite del sistema`,
    ja: `\u{30B7}\u{30B9}\u{30C6}\u{30E0}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}`,
    ko: `\u{C2DC}\u{C2A4}\u{D15C} \u{AE30}\u{BCF8}\u{AC12}`,
    mww: `System Default`,
    ps: `\u{62F} \u{633}\u{6CC}\u{633}\u{67C}\u{645} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C}`,
    pt: `Padr\xe3o do sistema`,
    "pt-pt": `Padr\xe3o do sistema`,
    ru: `\u{421}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{43D}\u{44B}\u{435} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Fa'aletonu o le Faiga`,
    so: `System Default`,
    th: `\u{E04}\u{E48}\u{E32}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E30}\u{E1A}\u{E1A}`,
    ur: `\u{646}\u{638}\u{627}\u{645} \u{637}\u{6D2} \u{634}\u{62F}\u{6C1}`,
    vi: `H\u{1EC7} th\u{1ED1}ng m\u{1EB7}c \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{7CFB}\u{7EDF}\u{9ED8}\u{8BA4}\u{503C}`,
    "zh-hant": `\u{7CFB}\u{7D71}\u{9810}\u{8A2D}\u{503C}`,
    en: `System Default`
};
const $2868cc1235412e16$export$ff6a452cc674d674 = {
    ar: `\u{627}\u{644}\u{627}\u{62D}\u{627}\u{644}\u{647}`,
    de: `Weiterempfehlung`,
    es: `Recomendaci\xf3n`,
    fa: `\u{627}\u{631}\u{62C}\u{627}\u{639}`,
    fil: `Email Address *`,
    fr: `Ajournement`,
    hi: `\u{930}\u{947}\u{92B}\u{930}\u{932}`,
    ht: `Rek\xf2mandasyon`,
    it: `Deferimento`,
    ja: `\u{7D39}\u{4ECB}`,
    ko: `\u{CD94}\u{CC9C}`,
    mww: `Xa mus cuag`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Refer\xeancia`,
    "pt-pt": `Encaminhamento`,
    ru: `\u{41D}\u{430}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fa'asino`,
    so: `Referral`,
    th: `\u{E2D}\u{E49}\u{E32}\u{E07} \u{E2D}\u{E34}\u{E07}`,
    ur: `\u{631}\u{6CC}\u{641}\u{631}\u{6CC}\u{644}`,
    vi: `Gi\u{1EDB}i thi\u{1EC7}u`,
    "zh-hans": `\u{8F6C} \u{4ECB}`,
    "zh-hant": `\u{8F49} \u{4ECB}`,
    en: `Referral`
};
const $2868cc1235412e16$export$e31ed6ed548e255b = {
    ar: `\u{645}\u{647}\u{645}\u{629}`,
    de: `Aufgabe`,
    es: `Tarea`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647}`,
    fil: `Gawain`,
    fr: `T\xe2che`,
    hi: `\u{928}\u{93F}\u{92F}\u{924} \u{915}\u{93E}\u{930}\u{94D}\u{92F}`,
    ht: `Travay`,
    it: `Compito`,
    ja: `\u{30BF}\u{30B9}\u{30AF}`,
    ko: `\u{ACFC}\u{C5C5}`,
    mww: `hauj lwm`,
    ps: `\u{62F}\u{646}\u{62F}\u{647}`,
    pt: `Tarefa`,
    "pt-pt": `Tarefa`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}`,
    sm: `Galuega`,
    so: `Hawlaha`,
    th: `\u{E07}\u{E32}\u{E19}`,
    ur: `\u{6A9}\u{627}\u{645}`,
    vi: `Nhi\u{1EC7}m v\u{1EE5}`,
    "zh-hans": `\u{4EFB}\u{52A1}`,
    "zh-hant": `\u{4EFB}\u{52D9}`,
    en: `Task`
};
const $2868cc1235412e16$export$375f6e4643646315 = {
    ar: `\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}`,
    de: `Fragebogen`,
    es: `Cuestionario`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Talatanungan`,
    fr: `Questionnaire`,
    hi: `\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{200D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8`,
    it: `Questionario`,
    ja: `\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C124}\u{BB38}\u{C9C0}`,
    mww: `Lus nug`,
    ps: `\u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}`,
    pt: `Question\xe1rio`,
    "pt-pt": `Question\xe1rio`,
    ru: `\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{430}`,
    sm: `Fesili`,
    so: `haku`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}`,
    ur: `\u{627}\u{633}\u{62A}\u{641}\u{633}\u{627}\u{631} \u{646}\u{627}\u{645}\u{6C1}`,
    vi: `B\u{1EA3}n c\xe2u h\u{1ECF}i`,
    "zh-hans": `\u{95EE}\u{5377}`,
    "zh-hant": `\u{554F}\u{5377}`,
    en: `Questionnaire`
};
const $2868cc1235412e16$export$1f61287e5d30e3cf = {
    ar: `\u{627}\u{644}\u{62A}\u{642}\u{649}`,
    de: `Treffen`,
    es: `Encuentro`,
    fa: `\u{628}\u{631}\u{62E}\u{648}\u{631}\u{62F}`,
    fil: `Tagpo`,
    fr: `Rencontrer`,
    hi: `\u{92E}\u{941}\u{920}\u{92D}\u{947}\u{95C}`,
    ht: `Rankont`,
    it: `Incontro`,
    ja: `\u{51FA}\u{4F1A}\u{3044}`,
    ko: `\u{B9CC}\u{B0A8}`,
    mww: `ces yuav tsum`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Encontrar`,
    "pt-pt": `Encontro`,
    ru: `\u{412}\u{441}\u{442}\u{440}\u{435}\u{447}\u{430}`,
    sm: `Feiloa'iga`,
    so: `La kulanka`,
    th: `\u{E1E}\u{E1A}`,
    ur: `\u{645}\u{644}\u{627}\u{642}\u{627}\u{62A}`,
    vi: `G\u{1EB7}p`,
    "zh-hans": `\u{9047}\u{5230}`,
    "zh-hant": `\u{9047}\u{5230}`,
    en: `Encounter`
};
const $2868cc1235412e16$export$9ea0062ee8a62693 = {
    ar: `\u{62D}\u{644}\u{642}\u{629} \u{631}\u{639}\u{627}\u{64A}\u{629}`,
    de: `Episode der Pflege`,
    es: `Episodio de cuidado`,
    fa: `\u{642}\u{633}\u{645}\u{62A} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A}`,
    fil: `Episode ng pangangalaga`,
    fr: `\xc9pisode de soins`,
    hi: `\u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{915}\u{930}\u{923}`,
    ht: `Epiz\xf2d swen`,
    it: `Episodio di cura`,
    ja: `\u{304A}\u{624B}\u{5165}\u{308C}\u{306E}\u{30A8}\u{30D4}\u{30BD}\u{30FC}\u{30C9}`,
    ko: `\u{B3CC}\u{BD04}\u{C758} \u{C5D0}\u{D53C}\u{C18C}\u{B4DC}`,
    mww: `rov xyuas dua`,
    ps: `\u{62F} \u{67E}\u{627}\u{645}\u{644}\u{631}\u{646}\u{6D0} \u{67E}\u{6D0}\u{69A}\u{647}`,
    pt: `Epis\xf3dio de cuidado`,
    "pt-pt": `Epis\xf3dio de cuidado`,
    ru: `\u{42D}\u{43F}\u{438}\u{437}\u{43E}\u{434} \u{443}\u{445}\u{43E}\u{434}\u{430}`,
    sm: `Vaega o le tausiga`,
    so: `Dhacdooyinka daryeelka`,
    th: `\u{E15}\u{E2D}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}`,
    ur: `\u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{6A9}\u{6CC} \u{642}\u{633}\u{637}`,
    vi: `Giai \u{111}o\u{1EA1}n ch\u{103}m s\xf3c`,
    "zh-hans": `\u{62A4}\u{7406}\u{53D1}\u{4F5C}`,
    "zh-hant": `\u{8B77}\u{7406}\u{9AEE}\u{4F5C}`,
    en: `Episode of care`
};
const $2868cc1235412e16$export$7c1b73b3fc2f0159 = {
    ar: `\u{645}\u{648}\u{627}\u{641}\u{642}\u{647}`,
    de: `Einwilligen`,
    es: `Consentimiento`,
    fa: `\u{631}\u{636}\u{627}\u{6CC}\u{62A}`,
    fil: `Pahintulot`,
    fr: `Consentement`,
    hi: `\u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F}`,
    ht: `Konsantman`,
    it: `Consenso`,
    ja: `\u{540C}\u{610F}`,
    ko: `\u{C2B9}\u{B099}`,
    mww: `Kev Tso Cai`,
    ps: `\u{631}\u{636}\u{627}\u{6CC}\u{62A}`,
    pt: `Consentimento`,
    "pt-pt": `Consentimento`,
    ru: `\u{421}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{435}`,
    sm: `Maliega`,
    so: `Ogolaanshaha`,
    th: `\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A}`,
    vi: `\u{110}\u{1ED3}ng \xfd`,
    "zh-hans": `\u{540C}\u{610F}`,
    "zh-hant": `\u{540C}\u{610F}`,
    en: `Consent`
};
const $2868cc1235412e16$export$a38a7850cefdb2b2 = {
    ar: `\u{645}\u{647}\u{645}\u{629} \u{627}\u{644}\u{62A}\u{646}\u{638}\u{64A}\u{645}`,
    de: `Aufgabe der Organisation`,
    es: `Tarea de organizaci\xf3n`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Gawain ng organisasyon`,
    fr: `T\xe2che d\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{915}\u{93E}\u{930}\u{94D}\u{92F}`,
    ht: `Travay \xf2ganizasyon`,
    it: `Attivit\xe0 organizzativa`,
    ja: `\u{7D44}\u{7E54}\u{306E}\u{30BF}\u{30B9}\u{30AF}`,
    ko: `\u{C870}\u{C9C1} \u{C791}\u{C5C5}`,
    mww: `Koom haum ua hauj lwm`,
    ps: `\u{62F} \u{627}\u{62F}\u{627}\u{631}\u{6CC} \u{62F}\u{646}\u{62F}\u{6D0}`,
    pt: `Tarefa da organiza\xe7\xe3o`,
    "pt-pt": `Tarefa da organiza\xe7\xe3o`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Galuega a le faalapotopotoga`,
    so: `Hay'adda Hawsha`,
    th: `\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{6A9}\u{627}\u{645}`,
    vi: `Nhi\u{1EC7}m v\u{1EE5} t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{7EC4}\u{7EC7}\u{4EFB}\u{52A1}`,
    "zh-hant": `\u{7D44}\u{7E54}\u{4EFB}\u{52D9}`,
    en: `Organization task`
};
const $2868cc1235412e16$export$fc6d25d72e8dca9c = {
    ar: `\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Fragebogen zur Organisation`,
    es: `Cuestionario de organizaci\xf3n`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Talatanungan ng organisasyon`,
    fr: `Questionnaire d\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8 \xf2ganizasyon`,
    it: `Questionario sull'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C870}\u{C9C1} \u{C124}\u{BB38}\u{C9C0}`,
    mww: `Koom haum questionnaire`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}`,
    pt: `Question\xe1rio da organiza\xe7\xe3o`,
    "pt-pt": `Question\xe1rio de organiza\xe7\xe3o`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{430}\u{43D}\u{43A}\u{435}\u{442}\u{430}`,
    sm: `Fesili a le faalapotopotoga`,
    so: `Ururka ee su'aalaha`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6C1}`,
    vi: `B\u{1EA3}ng c\xe2u h\u{1ECF}i t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{7EC4}\u{7EC7}\u{8C03}\u{67E5}\u{95EE}\u{5377}`,
    "zh-hant": `\u{7D44}\u{7E54}\u{8ABF}\u{67E5}\u{554F}\u{5377}`,
    en: `Organization questionnaire`
};
const $2868cc1235412e16$export$d23e7a1502780659 = {
    ar: `\u{62D}\u{62F}\u{62B}`,
    de: `Ereignis`,
    es: `Evento`,
    fa: `\u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}`,
    fil: `Kaganapan`,
    fr: `\xc9v\xe9nement`,
    hi: `\u{918}\u{91F}\u{928}\u{93E}`,
    ht: `Evenman`,
    it: `Evento`,
    ja: `\u{51FA}\u{6765}\u{4E8B}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8}`,
    mww: `kev tshwm sim`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{647}`,
    pt: `Acontecimento`,
    "pt-pt": `Evento`,
    ru: `\u{421}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{435}`,
    sm: `Mea na tupu`,
    so: `Dhacdooyinka`,
    th: `\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{627}\u{62D}\u{648}\u{627}\u{644}`,
    vi: `S\u{1EF1} ki\u{1EC7}n`,
    "zh-hans": `\u{4E8B}\u{4EF6}`,
    "zh-hant": `\u{4E8B}\u{4EF6}`,
    en: `Event`
};
const $2868cc1235412e16$export$90f6380a62d43dd9 = {
    ar: `\u{633}\u{62C}\u{644} \u{644}\u{637}\u{644}\u{628} \u{627}\u{644}\u{62E}\u{62F}\u{645}\u{629} \u{645}\u{62B}\u{644} \u{627}\u{644}\u{641}\u{62D}\u{648}\u{635}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{634}\u{62E}\u{64A}\u{635}\u{64A}\u{629} \u{623}\u{648} \u{627}\u{644}\u{639}\u{644}\u{627}\u{62C}\u{627}\u{62A} \u{623}\u{648} \u{627}\u{644}\u{639}\u{645}\u{644}\u{64A}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{64A} \u{64A}\u{62A}\u{639}\u{64A}\u{646} \u{625}\u{62C}\u{631}\u{627}\u{624}\u{647}\u{627}.`,
    de: `Eine Aufzeichnung einer Serviceanforderung, z. B. diagnostische Untersuchungen, Behandlungen oder durchzuf\xfchrende Operationen.`,
    es: `Un registro de una solicitud de servicio, como investigaciones diagn\xf3sticas, tratamientos u operaciones que se realizar\xe1n.`,
    fa: `\u{633}\u{627}\u{628}\u{642}\u{647} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{645}\u{627}\u{646}\u{646}\u{62F} \u{62A}\u{62D}\u{642}\u{6CC}\u{642}\u{627}\u{62A} \u{62A}\u{634}\u{62E}\u{6CC}\u{635}\u{6CC}\u{60C} \u{62F}\u{631}\u{645}\u{627}\u{646} \u{647}\u{627} \u{6CC}\u{627} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A}\u{6CC} \u{6A9}\u{647} \u{628}\u{627}\u{6CC}\u{62F} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{634}\u{648}\u{62F}.`,
    fil: `Isang talaan ng isang kahilingan para sa serbisyo tulad ng mga pagsisiyasat sa diagnostic, paggamot, o operasyon na isasagawa.`,
    fr: `Enregistrement d\u{2019}une demande de service, comme des investigations diagnostiques, des traitements ou des op\xe9rations \xe0 effectuer.`,
    hi: `\u{938}\u{947}\u{935}\u{93E} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{93E} \u{90F}\u{915} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921}, \u{91C}\u{948}\u{938}\u{947} \u{928}\u{948}\u{926}\u{93E}\u{928}\u{93F}\u{915} \u{91C}\u{93E}\u{902}\u{91A}, \u{909}\u{92A}\u{91A}\u{93E}\u{930}, \u{92F}\u{93E} \u{911}\u{92A}\u{930}\u{947}\u{936}\u{928} \u{915}\u{93F}\u{90F} \u{91C}\u{93E}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}\u{964}`,
    ht: `Yon dosye sou yon demann pou s\xe8vis tankou ank\xe8t dyagnostik, tretman, oswa operasyon yo dwe f\xe8t.`,
    it: `Una registrazione di una richiesta di servizio come indagini diagnostiche, trattamenti o operazioni da eseguire.`,
    ja: `\u{8A3A}\u{65AD}\u{8ABF}\u{67FB}\u{3001}\u{6CBB}\u{7642}\u{3001}\u{307E}\u{305F}\u{306F}\u{5B9F}\u{884C}\u{3059}\u{308B}\u{64CD}\u{4F5C}\u{306A}\u{3069}\u{306E}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{306E}\u{8981}\u{6C42}\u{306E}\u{8A18}\u{9332}\u{3002}`,
    ko: `\u{C9C4}\u{B2E8} \u{C870}\u{C0AC}, \u{CE58}\u{B8CC} \u{B610}\u{B294} \u{C218}\u{D589}\u{D560} \u{C791}\u{C5C5}\u{ACFC} \u{AC19}\u{C740} \u{C11C}\u{BE44}\u{C2A4} \u{C694}\u{CCAD} \u{AE30}\u{B85D}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib daim ntawv thov kev pab xws li kev tshawb nrhiav txog kev tshawb nrhiav, kev kho mob, los yog haujlwm ua tau.`,
    ps: `\u{62F} \u{62E}\u{62F}\u{645}\u{62A} \u{62F} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{644}\u{6A9}\u{647} \u{62A}\u{634}\u{62E}\u{6CC}\u{635}\u{6CC} \u{62A}\u{62D}\u{642}\u{6CC}\u{642}\u{627}\u{62A}\u{60C} \u{62F}\u{631}\u{645}\u{644}\u{646}\u{647}\u{60C} \u{6CC}\u{627} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A} \u{686}\u{6D0} \u{628}\u{627}\u{6CC}\u{62F} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{634}\u{6CC}.`,
    pt: `Um registro de uma solicita\xe7\xe3o de servi\xe7o, como investiga\xe7\xf5es diagn\xf3sticas, tratamentos ou opera\xe7\xf5es a serem realizadas.`,
    "pt-pt": `Um registro de uma solicita\xe7\xe3o de servi\xe7o, como investiga\xe7\xf5es de diagn\xf3stico, tratamentos ou opera\xe7\xf5es a serem realizadas.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{43E} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{435} \u{43D}\u{430} \u{442}\u{430}\u{43A}\u{443}\u{44E} \u{443}\u{441}\u{43B}\u{443}\u{433}\u{443}, \u{43A}\u{430}\u{43A} \u{434}\u{438}\u{430}\u{433}\u{43D}\u{43E}\u{441}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{435} \u{438}\u{441}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}, \u{43B}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{438}\u{43B}\u{438} \u{43E}\u{43F}\u{435}\u{440}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{44B} \u{431}\u{44B}\u{442}\u{44C} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{44B}.`,
    sm: `O se fa'amaumauga o se talosaga mo auaunaga e pei o su'esu'ega fa'ama'i, togafitiga, po'o taotoga e fa'atinoina.`,
    so: `Diiwaanka codsi adeeg sida baaritaan baaris, daaweyn, ama qalliin la sameyn doono.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23} \u{E40}\u{E0A}\u{E48}\u{E19} \u{E01}\u{E32}\u{E23}\u{E15}\u{E23}\u{E27}\u{E08}\u{E27}\u{E34}\u{E19}\u{E34}\u{E08}\u{E09}\u{E31}\u{E22} \u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E01}\u{E29}\u{E32} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E32}\u{E23}\u{E1C}\u{E48}\u{E32}\u{E15}\u{E31}\u{E14}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{627} \u{627}\u{6CC}\u{6A9} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{62C}\u{6CC}\u{633}\u{6D2} \u{62A}\u{634}\u{62E}\u{6CC}\u{635}\u{6CC} \u{62A}\u{62D}\u{642}\u{6CC}\u{642}\u{627}\u{62A}\u{60C} \u{639}\u{644}\u{627}\u{62C}\u{60C} \u{6CC}\u{627} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{6CC}\u{626}\u{6D2} \u{62C}\u{627}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{622}\u{67E}\u{631}\u{6CC}\u{634}\u{646}.`,
    vi: `H\u{1ED3} s\u{1A1} y\xeau c\u{1EA7}u d\u{1ECB}ch v\u{1EE5} nh\u{1B0} \u{111}i\u{1EC1}u tra ch\u{1EA9}n \u{111}o\xe1n, \u{111}i\u{1EC1}u tr\u{1ECB} ho\u{1EB7}c ph\u{1EAB}u thu\u{1EAD}t \u{111}\u{1B0}\u{1EE3}c th\u{1EF1}c hi\u{1EC7}n.`,
    "zh-hans": `\u{670D}\u{52A1}\u{8BF7}\u{6C42}\u{7684}\u{8BB0}\u{5F55}\u{FF0C}\u{4F8B}\u{5982}\u{8BCA}\u{65AD}\u{8C03}\u{67E5}\u{3001}\u{6CBB}\u{7597}\u{6216}\u{8981}\u{6267}\u{884C}\u{7684}\u{4F5C}\u{3002}`,
    "zh-hant": `\u{670D}\u{52D9}\u{8ACB}\u{6C42}\u{7684}\u{8A18}\u{9304}\u{FF0C}\u{4F8B}\u{5982}\u{8A3A}\u{65B7}\u{8ABF}\u{67E5}\u{3001}\u{6CBB}\u{7642}\u{6216}\u{8981}\u{57F7}\u{884C}\u{7684}\u{4F5C}\u{3002}`,
    en: `A record of a request for service such as diagnostic investigations, treatments, or operations to be performed.`
};
const $2868cc1235412e16$export$dad853a619f75d14 = {
    ar: `\u{645}\u{647}\u{645}\u{629} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{629} \u{628}\u{639}\u{645}\u{64A}\u{644} \u{645}\u{62B}\u{644} \u{627}\u{644}\u{645}\u{62A}\u{627}\u{628}\u{639}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{64A}\u{645}\u{643}\u{646} \u{62A}\u{646}\u{641}\u{64A}\u{630}\u{647}\u{627}.`,
    de: `Eine Aufgabe, die sich auf einen Kunden bezieht, z. B. eine Wiederverfolgung, die ausgef\xfchrt werden kann.`,
    es: `Una tarea relacionada con un cliente, como un seguimiento que se puede realizar.`,
    fa: `\u{6CC}\u{6A9} \u{6A9}\u{627}\u{631} \u{645}\u{631}\u{628}\u{648}\u{637} \u{628}\u{647} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{645}\u{627}\u{646}\u{646}\u{62F} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{6A9}\u{647} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{634}\u{648}\u{62F}.`,
    fil: `Isang gawain na may kaugnayan sa isang kliyente tulad ng isang follow-up na maaaring maisagawa.`,
    fr: `T\xe2che li\xe9e \xe0 un client, telle qu\u{2019}un suivi, qui peut \xeatre effectu\xe9e.`,
    hi: `\u{915}\u{94D}\u{932}\u{93E}\u{907}\u{902}\u{91F} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{90F}\u{915} \u{915}\u{93E}\u{930}\u{94D}\u{92F}, \u{91C}\u{948}\u{938}\u{947} \u{905}\u{928}\u{941}\u{935}\u{930}\u{94D}\u{924}\u{940} \u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908} \u{91C}\u{93F}\u{938}\u{947} \u{928}\u{93F}\u{937}\u{94D}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon travay ki gen rap\xf2 ak yon kliyan tankou yon swivi ki ka f\xe8t.`,
    it: `Un'attivit\xe0 correlata a un client, ad esempio un follow-up che pu\xf2 essere eseguito.`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{306B}\u{95A2}\u{9023}\u{3059}\u{308B}\u{30BF}\u{30B9}\u{30AF} (\u{30D5}\u{30A9}\u{30ED}\u{30FC}\u{30A2}\u{30C3}\u{30D7}\u{306A}\u{3069}\u{3001}\u{5B9F}\u{884C}\u{53EF}\u{80FD}\u{306A}\u{3082}\u{306E})\u{3002}`,
    ko: `\u{C218}\u{D589}\u{D560} \u{C218} \u{C788}\u{B294} \u{D6C4}\u{C18D} \u{C870}\u{CE58}\u{C640} \u{AC19}\u{C740} \u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640} \u{AD00}\u{B828}\u{B41C} \u{C791}\u{C5C5}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib tug neeg ua hauj lwm hais txog ib tug neeg tau txais kev pab xws li ib tug ua raws li uas yuav tau.`,
    ps: `\u{62F} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{6CC}\u{646}\u{648} \u{67E}\u{648}\u{631}\u{6D0} \u{62A}\u{693}\u{644}\u{6D0} \u{62F}\u{646}\u{62F}\u{647} \u{644}\u{6A9}\u{647} \u{62A}\u{639}\u{642}\u{6CC}\u{628} \u{686}\u{6D0} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{6CC}\u{62F}\u{6CC} \u{634}\u{6CC}.`,
    pt: `Uma tarefa relacionada a um cliente, como um acompanhamento que pode ser executado.`,
    "pt-pt": `Uma tarefa relacionada a um cliente, como um acompanhamento que pode ser executado.`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}, \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{441} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C}, \u{43D}\u{430}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{440}, \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{443}\u{44E} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{44C}.`,
    sm: `O se galuega e feso'ota'i ma se tagata fa'atau e pei o se tulitatao e mafai ona fa'atinoina.`,
    so: `Hawl la xiriira macmiilka, sida dabagal la sameyn karo oo kale.`,
    th: `\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32} \u{E40}\u{E0A}\u{E48}\u{E19} \u{E01}\u{E32}\u{E23}\u{E15}\u{E34}\u{E14}\u{E15}\u{E32}\u{E21}\u{E1C}\u{E25}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E17}\u{E4D}\u{E32}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{627}\u{6CC}\u{6A9} \u{6A9}\u{627}\u{645} \u{62C}\u{6CC}\u{633}\u{6D2} \u{641}\u{627}\u{644}\u{648} \u{627}\u{67E} \u{62C}\u{648} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{6CC}\u{627} \u{62C}\u{627}\u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t nhi\u{1EC7}m v\u{1EE5} li\xean quan \u{111}\u{1EBF}n kh\xe1ch h\xe0ng nh\u{1B0} theo d\xf5i c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c th\u{1EF1}c hi\u{1EC7}n.`,
    "zh-hans": `\u{4E0E}\u{5BA2}\u{6237}\u{76F8}\u{5173}\u{7684}\u{4EFB}\u{52A1}\u{FF0C}\u{4F8B}\u{5982}\u{53EF}\u{4EE5}\u{6267}\u{884C}\u{7684}\u{540E}\u{7EED}\u{884C}\u{52A8}\u{3002}`,
    "zh-hant": `\u{8207}\u{5BA2}\u{6236}\u{76F8}\u{95DC}\u{7684}\u{4EFB}\u{52D9}\u{FF0C}\u{4F8B}\u{5982}\u{53EF}\u{4EE5}\u{57F7}\u{884C}\u{7684}\u{5F8C}\u{7E8C}\u{884C}\u{52D5}\u{3002}`,
    en: `A task related to a client such as a follow-up that can be performed.`
};
const $2868cc1235412e16$export$a9202f9fc8a3c137 = {
    ar: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{645}\u{646}\u{638}\u{645}\u{629} \u{645}\u{646} \u{627}\u{644}\u{623}\u{633}\u{626}\u{644}\u{629} \u{627}\u{644}\u{645}\u{62A}\u{639}\u{644}\u{642}\u{629} \u{628}\u{627}\u{644}\u{639}\u{645}\u{64A}\u{644} \u{60C} \u{62A}\u{647}\u{62F}\u{641} \u{625}\u{644}\u{649} \u{62A}\u{648}\u{62C}\u{64A}\u{647} \u{62C}\u{645}\u{639} \u{627}\u{644}\u{625}\u{62C}\u{627}\u{628}\u{627}\u{62A} \u{645}\u{646} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{64A}\u{646} \u{627}\u{644}\u{646}\u{647}\u{627}\u{626}\u{64A}\u{64A}\u{646}.`,
    de: `Ein strukturierter Satz von Fragen zu einem Kunden, der das Sammeln von Antworten von Endbenutzern leiten soll.`,
    es: `Un conjunto estructurado de preguntas relacionadas con un cliente, destinadas a guiar la recopilaci\xf3n de respuestas de los usuarios finales.`,
    fa: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{647} \u{627}\u{6CC} \u{633}\u{627}\u{62E}\u{62A}\u{627}\u{631}\u{6CC}\u{627}\u{641}\u{62A}\u{647} \u{627}\u{632} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{645}\u{631}\u{628}\u{648}\u{637} \u{628}\u{647} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{6A9}\u{647} \u{628}\u{631}\u{627}\u{6CC} \u{647}\u{62F}\u{627}\u{6CC}\u{62A} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{647} \u{67E}\u{627}\u{633}\u{62E} \u{647}\u{627} \u{627}\u{632} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{627}\u{646} \u{646}\u{647}\u{627}\u{6CC}\u{6CC} \u{62F}\u{631} \u{646}\u{638}\u{631} \u{6AF}\u{631}\u{641}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Isang nakabalangkas na hanay ng mga katanungan na may kaugnayan sa isang kliyente, na inilaan upang gabayan ang koleksyon ng mga sagot mula sa mga end-user.`,
    fr: `Ensemble structur\xe9 de questions relatives \xe0 un client, destin\xe9 \xe0 guider la collecte des r\xe9ponses des utilisateurs finaux.`,
    hi: `\u{915}\u{94D}\u{932}\u{93E}\u{907}\u{902}\u{91F} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{94B}\u{902} \u{915}\u{93E} \u{90F}\u{915} \u{938}\u{902}\u{930}\u{91A}\u{93F}\u{924} \u{938}\u{947}\u{91F}, \u{91C}\u{93F}\u{938}\u{915}\u{93E} \u{909}\u{926}\u{94D}\u{926}\u{947}\u{936}\u{94D}\u{92F} \u{905}\u{902}\u{924}\u{93F}\u{92E} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}\u{913}\u{902} \u{938}\u{947} \u{909}\u{924}\u{94D}\u{924}\u{930}\u{94B}\u{902} \u{915}\u{947} \u{938}\u{902}\u{917}\u{94D}\u{930}\u{939} \u{915}\u{93E} \u{92E}\u{93E}\u{930}\u{94D}\u{917}\u{926}\u{930}\u{94D}\u{936}\u{928} \u{915}\u{930}\u{928}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon seri estriktire nan kesyon ki gen rap\xf2 ak yon kliyan, gen entansyon gide koleksyon an nan repons soti nan itilizat\xe8 fen-itilizat\xe8 yo.`,
    it: `Un insieme strutturato di domande relative a un cliente, destinato a guidare la raccolta delle risposte da parte degli utenti finali.`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{306B}\u{95A2}\u{9023}\u{3059}\u{308B}\u{69CB}\u{9020}\u{5316}\u{3055}\u{308C}\u{305F}\u{4E00}\u{9023}\u{306E}\u{8CEA}\u{554F}\u{3067}\u{3001}\u{30A8}\u{30F3}\u{30C9}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{304B}\u{3089}\u{306E}\u{56DE}\u{7B54}\u{306E}\u{53CE}\u{96C6}\u{3092}\u{30AC}\u{30A4}\u{30C9}\u{3059}\u{308B}\u{3053}\u{3068}\u{3092}\u{76EE}\u{7684}\u{3068}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640} \u{AD00}\u{B828}\u{B41C} \u{AD6C}\u{C870}\u{D654}\u{B41C} \u{C9C8}\u{BB38} \u{C9D1}\u{D569}\u{C73C}\u{B85C}, \u{CD5C}\u{C885} \u{C0AC}\u{C6A9}\u{C790}\u{C758} \u{B2F5}\u{BCC0} \u{C218}\u{C9D1}\u{C744} \u{C548}\u{B0B4}\u{D558}\u{AE30} \u{C704}\u{D55C} \u{AC83}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib tug qauv teev cov lus nug txog ib tug neeg tau txais kev pab, npaj los qhia cov lus teb los ntawm cov lus teb los ntawm cov neeg siv end-users.`,
    ps: `\u{62F} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{6CC}\u{646}\u{648} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{62F} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{648} \u{6CC}\u{648}\u{647} \u{645}\u{646}\u{638}\u{645}\u{647} \u{67C}\u{648}\u{644}\u{6AB}\u{647} \u{60C} \u{686}\u{6D0} \u{645}\u{648}\u{62E}\u{647} \u{6CC}\u{6D0} \u{62F} \u{646}\u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{685}\u{62E}\u{647} \u{62F} \u{681}\u{648}\u{627}\u{628}\u{648}\u{646}\u{648} \u{67C}\u{648}\u{644}\u{6AB}\u{647} \u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{647} \u{62F}\u{647}.`,
    pt: `Um conjunto estruturado de perguntas relacionadas a um cliente, destinado a orientar a coleta de respostas dos usu\xe1rios finais.`,
    "pt-pt": `Um conjunto estruturado de perguntas relacionadas com um cliente, destinado a orientar a recolha de respostas dos utilizadores finais.`,
    ru: `\u{421}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{443}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{43D}\u{430}\u{431}\u{43E}\u{440} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43E}\u{432}, \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{441} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C}, \u{43F}\u{440}\u{435}\u{434}\u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{434}\u{43B}\u{44F} \u{440}\u{443}\u{43A}\u{43E}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{430} \u{441}\u{431}\u{43E}\u{440}\u{43E}\u{43C} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{43E}\u{432} \u{43E}\u{442} \u{43A}\u{43E}\u{43D}\u{435}\u{447}\u{43D}\u{44B}\u{445} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439}.`,
    sm: `O se seti fa'atulagaina o fesili e feso'ota'i ma se tagata fa'atau, fa'amoemoe e ta'ita'ia le aoina o tali mai tagata fa'aoga.`,
    so: `Su'aalo qaabaysan oo la xidhiidha macmiilka, loogu talagalay in lagu hago ururinta jawaabaha laga helayo dhammaystirka isticmaalayaasha.`,
    th: `\u{E0A}\u{E38}\u{E14}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E21}\u{E35}\u{E42}\u{E04}\u{E23}\u{E07}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32} \u{E42}\u{E14}\u{E22}\u{E21}\u{E35}\u{E08}\u{E38}\u{E14}\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E07}\u{E04}\u{E4C}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E41}\u{E19}\u{E27}\u{E17}\u{E32}\u{E07}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E23}\u{E27}\u{E1A}\u{E23}\u{E27}\u{E21}\u{E04}\u{E4D}\u{E32}\u{E15}\u{E2D}\u{E1A}\u{E08}\u{E32}\u{E01}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E1B}\u{E25}\u{E32}\u{E22}\u{E17}\u{E32}\u{E07}`,
    ur: `\u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{6A9}\u{627} \u{627}\u{6CC}\u{6A9} \u{645}\u{646}\u{638}\u{645} \u{633}\u{6CC}\u{679} \u{60C} \u{62C}\u{633} \u{6A9}\u{627} \u{645}\u{642}\u{635}\u{62F} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645}\u{6CC} \u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646} \u{633}\u{6D2} \u{62C}\u{648}\u{627}\u{628}\u{627}\u{62A} \u{6A9}\u{6D2} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{6C1} \u{6A9}\u{6CC} \u{631}\u{6C1}\u{646}\u{645}\u{627}\u{626}\u{6CC} \u{6A9}\u{631}\u{646}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t t\u{1EAD}p h\u{1EE3}p c\xe1c c\xe2u h\u{1ECF}i c\xf3 c\u{1EA5}u tr\xfac li\xean quan \u{111}\u{1EBF}n kh\xe1ch h\xe0ng, nh\u{1EB1}m h\u{1B0}\u{1EDB}ng d\u{1EAB}n thu th\u{1EAD}p c\xe2u tr\u{1EA3} l\u{1EDD}i t\u{1EEB} ng\u{1B0}\u{1EDD}i d\xf9ng cu\u{1ED1}i.`,
    "zh-hans": `\u{4E0E}\u{5BA2}\u{6237}\u{76F8}\u{5173}\u{7684}\u{4E00}\u{7EC4}\u{7ED3}\u{6784}\u{5316}\u{95EE}\u{9898}\u{FF0C}\u{65E8}\u{5728}\u{6307}\u{5BFC}\u{6700}\u{7EC8}\u{7528}\u{6237}\u{6536}\u{96C6}\u{7B54}\u{6848}\u{3002}`,
    "zh-hant": `\u{8207}\u{5BA2}\u{6236}\u{76F8}\u{95DC}\u{7684}\u{4E00}\u{7D44}\u{7D50}\u{69CB}\u{5316}\u{554F}\u{984C}\u{FF0C}\u{65E8}\u{5728}\u{6307}\u{5C0E}\u{6700}\u{7D42}\u{4F7F}\u{7528}\u{8005}\u{6536}\u{96C6}\u{7B54}\u{6848}\u{3002}`,
    en: `A structured set of questions related to a client, intended to guide the collection of answers from end-users.`
};
const $2868cc1235412e16$export$aac1b84c33b9a082 = {
    ar: `\u{62A}\u{641}\u{627}\u{639}\u{644} \u{628}\u{64A}\u{646} \u{627}\u{644}\u{645}\u{631}\u{64A}\u{636} \u{648}\u{645}\u{642}\u{62F}\u{645} (\u{645}\u{642}\u{62F}\u{645}\u{64A} \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{635}\u{62D}\u{64A}\u{629}) \u{644}\u{63A}\u{631}\u{636} \u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{62E}\u{62F}\u{645}\u{629} (\u{62E}\u{62F}\u{645}\u{627}\u{62A}) \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{635}\u{62D}\u{64A}\u{629} \u{623}\u{648} \u{62A}\u{642}\u{64A}\u{64A}\u{645} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629} \u{627}\u{644}\u{635}\u{62D}\u{64A}\u{629} \u{644}\u{644}\u{645}\u{631}\u{64A}\u{636}.`,
    de: `Eine Interaktion zwischen einem Patienten und einem oder mehreren Gesundheitsdienstleistern zum Zwecke der Erbringung von Gesundheitsdienstleistungen oder zur Beurteilung des Gesundheitszustands eines Patienten.`,
    es: `Una interacci\xf3n entre un paciente y los proveedores de atenci\xf3n m\xe9dica con el fin de proporcionar servicios de atenci\xf3n m\xe9dica o evaluar el estado de salud de un paciente.`,
    fa: `\u{62A}\u{639}\u{627}\u{645}\u{644} \u{628}\u{6CC}\u{646} \u{628}\u{6CC}\u{645}\u{627}\u{631} \u{648} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62F}\u{647}\u{646}\u{62F}\u{647}(\u{647}\u{627}\u{6CC}) \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{647}\u{62F}\u{627}\u{634}\u{62A}\u{6CC} \u{628}\u{647} \u{645}\u{646}\u{638}\u{648}\u{631} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62E}\u{62F}\u{645}\u{627}\u{62A}(\u{647}\u{627}\u{6CC}) \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{647}\u{62F}\u{627}\u{634}\u{62A}\u{6CC} \u{6CC}\u{627} \u{627}\u{631}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{633}\u{644}\u{627}\u{645}\u{62A} \u{628}\u{6CC}\u{645}\u{627}\u{631}.`,
    fil: `Isang pakikipag-ugnayan sa pagitan ng isang pasyente at (mga) tagapagbigay ng pangangalagang pangkalusugan para sa layunin ng pagbibigay ng (mga) serbisyo sa pangangalagang pangkalusugan o pagtatasa ng katayuan sa kalusugan ng isang pasyente.`,
    fr: `Interaction entre un patient et un ou plusieurs fournisseurs de soins de sant\xe9 dans le but de fournir des services de sant\xe9 ou d\u{2019}\xe9valuer l\u{2019}\xe9tat de sant\xe9 d\u{2019}un patient.`,
    hi: `\u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{926}\u{947}\u{916}\u{92D}\u{93E}\u{932} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{93E} \u{930}\u{94B}\u{917}\u{940} \u{915}\u{947} \u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{915}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{915}\u{93E} \u{906}\u{915}\u{932}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{909}\u{926}\u{94D}\u{926}\u{947}\u{936}\u{94D}\u{92F} \u{938}\u{947} \u{930}\u{94B}\u{917}\u{940} \u{914}\u{930} \u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{924}\u{93E} (\u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{924}\u{93E}\u{913}\u{902}) \u{915}\u{947} \u{92C}\u{940}\u{91A} \u{90F}\u{915} \u{92C}\u{93E}\u{924}\u{91A}\u{940}\u{924}\u{964}`,
    ht: `Yon ent\xe8raksyon ant yon pasyan ak founis\xe8 swen sante (yo) nan bi pou yo bay s\xe8vis swen sante (yo) oswa evalye estati sante yon pasyan.`,
    it: `Un'interazione tra un paziente e uno o pi\xf9 operatori sanitari allo scopo di fornire servizi sanitari o valutare lo stato di salute di un paziente.`,
    ja: `\u{533B}\u{7642}\u{30B5}\u{30FC}\u{30D3}\u{30B9}\u{306E}\u{63D0}\u{4F9B}\u{307E}\u{305F}\u{306F}\u{60A3}\u{8005}\u{306E}\u{5065}\u{5EB7}\u{72B6}\u{614B}\u{306E}\u{8A55}\u{4FA1}\u{3092}\u{76EE}\u{7684}\u{3068}\u{3057}\u{305F}\u{3001}\u{60A3}\u{8005}\u{3068}\u{533B}\u{7642}\u{63D0}\u{4F9B}\u{8005}\u{3068}\u{306E}\u{9593}\u{306E}\u{76F8}\u{4E92}\u{4F5C}\u{7528}\u{3002}`,
    ko: `\u{C758}\u{B8CC} \u{C11C}\u{BE44}\u{C2A4}\u{B97C} \u{C81C}\u{ACF5}\u{D558}\u{AC70}\u{B098} \u{D658}\u{C790}\u{C758} \u{AC74}\u{AC15} \u{C0C1}\u{D0DC}\u{B97C} \u{D3C9}\u{AC00}\u{D558}\u{AE30} \u{C704}\u{D55C} \u{BAA9}\u{C801}\u{C73C}\u{B85C} \u{D658}\u{C790}\u{C640} \u{C758}\u{B8CC} \u{C11C}\u{BE44}\u{C2A4} \u{C81C}\u{ACF5}\u{C790} \u{AC04}\u{C758} \u{C0C1}\u{D638} \u{C791}\u{C6A9}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Kev sib tshuam ntawm ib tug neeg mob thiab tus neeg muab kev pab kho mob(cov) rau lub hom phiaj ntawm kev muab kev pab kho mob los yog ntsuam xyuas txoj kev noj qab haus huv ntawm ib tug neeg mob.`,
    ps: `\u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{627}\u{648} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{62A}\u{631} \u{645}\u{646}\u{681} \u{62A}\u{639}\u{627}\u{645}\u{644} \u{62F} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{62E}\u{62F}\u{645}\u{62A}\u{648}\u{646}\u{648} \u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{648}\u{644}\u{648} \u{6CC}\u{627} \u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{62F} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} \u{627}\u{631}\u{632}\u{648}\u{646}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F}\u{6CC}.`,
    pt: `Uma intera\xe7\xe3o entre um paciente e o(s) provedor(es) de sa\xfade com a finalidade de fornecer servi\xe7o(s) de sa\xfade ou avaliar o estado de sa\xfade de um paciente.`,
    "pt-pt": `Intera\xe7\xe3o entre um doente e o(s) prestador(es) de cuidados de sa\xfade para efeitos de presta\xe7\xe3o de servi\xe7os de sa\xfade ou de avalia\xe7\xe3o do estado de sa\xfade de um doente.`,
    ru: `\u{412}\u{437}\u{430}\u{438}\u{43C}\u{43E}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{43C}\u{435}\u{436}\u{434}\u{443} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C} \u{438} \u{43F}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{449}\u{438}\u{43A}\u{43E}\u{43C} (\u{43F}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{449}\u{438}\u{43A}\u{430}\u{43C}\u{438}) \u{43C}\u{435}\u{434}\u{438}\u{446}\u{438}\u{43D}\u{441}\u{43A}\u{438}\u{445} \u{443}\u{441}\u{43B}\u{443}\u{433} \u{441} \u{446}\u{435}\u{43B}\u{44C}\u{44E} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43C}\u{435}\u{434}\u{438}\u{446}\u{438}\u{43D}\u{441}\u{43A}\u{43E}\u{439} \u{443}\u{441}\u{43B}\u{443}\u{433}\u{438} (\u{443}\u{441}\u{43B}\u{443}\u{433}) \u{438}\u{43B}\u{438} \u{43E}\u{446}\u{435}\u{43D}\u{43A}\u{438} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44F} \u{437}\u{434}\u{43E}\u{440}\u{43E}\u{432}\u{44C}\u{44F} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{430}.`,
    sm: `O se fegalegaleaiga i le va o se tagata ma'i ma le tausi soifua maloloina mo le fa'amoemoe o le tu'uina atu o auaunaga tau soifua maloloina po'o le iloiloina o le tulaga o le soifua maloloina o se tagata ma'i.`,
    so: `Isdhexgalka u dhexeeya bukaanka iyo bixiyaha daryeelka caafimaadka (s) ujeedada laga leeyahay bixinta adeega daryeelka caafimaadka (s) ama qiimaynta xaaladda caafimaad ee bukaanka.`,
    th: `\u{E1B}\u{E0F}\u{E34}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}\u{E41}\u{E25}\u{E30}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E32}\u{E19}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E27}\u{E31}\u{E15}\u{E16}\u{E38}\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E07}\u{E04}\u{E4C}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E43}\u{E2B}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E32}\u{E19}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E21}\u{E34}\u{E19}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E02}\u{E2D}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}`,
    ur: `\u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{6A9}\u{6CC} \u{62E}\u{62F}\u{645}\u{627}\u{62A} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{6CC}\u{627} \u{645}\u{631}\u{6CC}\u{636} \u{6A9}\u{6CC} \u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} \u{6A9}\u{627} \u{627}\u{646}\u{62F}\u{627}\u{632}\u{6C1} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{645}\u{642}\u{635}\u{62F} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{645}\u{631}\u{6CC}\u{636} \u{627}\u{648}\u{631} \u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{62F}\u{631}\u{645}\u{6CC}\u{627}\u{646} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{6D4}`,
    vi: `S\u{1EF1} t\u{1B0}\u{1A1}ng t\xe1c gi\u{1EEF}a b\u{1EC7}nh nh\xe2n v\xe0 (c\xe1c) nh\xe0 cung c\u{1EA5}p d\u{1ECB}ch v\u{1EE5} ch\u{103}m s\xf3c s\u{1EE9}c kh\u{1ECF}e nh\u{1EB1}m m\u{1EE5}c \u{111}\xedch cung c\u{1EA5}p (c\xe1c) d\u{1ECB}ch v\u{1EE5} ch\u{103}m s\xf3c s\u{1EE9}c kh\u{1ECF}e ho\u{1EB7}c \u{111}\xe1nh gi\xe1 t\xecnh tr\u{1EA1}ng s\u{1EE9}c kh\u{1ECF}e c\u{1EE7}a b\u{1EC7}nh nh\xe2n.`,
    "zh-hans": `\u{60A3}\u{8005}\u{4E0E}\u{533B}\u{7597}\u{4FDD}\u{5065}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{95F4}\u{4E3A}\u{63D0}\u{4F9B}\u{533B}\u{7597}\u{4FDD}\u{5065}\u{670D}\u{52A1}\u{6216}\u{8BC4}\u{4F30}\u{60A3}\u{8005}\u{5065}\u{5EB7}\u{72B6}\u{51B5}\u{800C}\u{8FDB}\u{884C}\u{7684}\u{4E92}\u{52A8}\u{3002}`,
    "zh-hant": `\u{60A3}\u{8005}\u{8207}\u{91AB}\u{7642}\u{4FDD}\u{5065}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{9593}\u{70BA}\u{63D0}\u{4F9B}\u{91AB}\u{7642}\u{4FDD}\u{5065}\u{670D}\u{52D9}\u{6216}\u{8A55}\u{4F30}\u{60A3}\u{8005}\u{5065}\u{5EB7}\u{60C5}\u{6CC1}\u{800C}\u{9032}\u{884C}\u{7684}\u{4E92}\u{52D5}\u{3002}`,
    en: `An interaction between a patient and healthcare provider(s) for the purpose of providing healthcare service(s) or assessing the health status of a patient.`
};
const $2868cc1235412e16$export$b1642650037543f = {
    ar: `\u{627}\u{631}\u{62A}\u{628}\u{627}\u{637} \u{628}\u{64A}\u{646} \u{627}\u{644}\u{645}\u{631}\u{64A}\u{636} \u{648}\u{645}\u{646}\u{638}\u{645}\u{629} (\u{645}\u{642}\u{62F}\u{645}\u{64A}) \u{627}\u{644}\u{631}\u{639}\u{627}\u{64A}\u{629} \u{627}\u{644}\u{635}\u{62D}\u{64A}\u{629} \u{642}\u{62F} \u{62A}\u{62D}\u{62F}\u{62B} \u{62E}\u{644}\u{627}\u{644}\u{647}\u{627} \u{644}\u{642}\u{627}\u{621}\u{627}\u{62A}. \u{62A}\u{62A}\u{62D}\u{645}\u{644} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{64A}\u{631}\u{629} \u{645}\u{633}\u{62A}\u{648}\u{649} \u{645}\u{646} \u{627}\u{644}\u{645}\u{633}\u{624}\u{648}\u{644}\u{64A}\u{629} \u{62A}\u{62C}\u{627}\u{647} \u{627}\u{644}\u{645}\u{631}\u{64A}\u{636} \u{62E}\u{644}\u{627}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{648}\u{642}\u{62A}.`,
    de: `Eine Verbindung zwischen einem Patienten und einer Organisation / einem oder mehreren Gesundheitsdienstleistern, in deren Verlauf Begegnungen auftreten k\xf6nnen. Die leitende Organisation \xfcbernimmt in dieser Zeit ein gewisses Ma\xdf an Verantwortung f\xfcr den Patienten.`,
    es: `Una asociaci\xf3n entre un paciente y una organizaci\xf3n/proveedor(es) de atenci\xf3n m\xe9dica durante la cual pueden ocurrir encuentros temporales. La organizaci\xf3n gestora asume un nivel de responsabilidad para con el paciente durante este tiempo.`,
    fa: `\u{627}\u{631}\u{62A}\u{628}\u{627}\u{637} \u{628}\u{6CC}\u{646} \u{628}\u{6CC}\u{645}\u{627}\u{631} \u{648} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} / \u{627}\u{631}\u{627}\u{626}\u{647} \u{62F}\u{647}\u{646}\u{62F}\u{647} \u{645}\u{631}\u{627}\u{642}\u{628}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{647}\u{62F}\u{627}\u{634}\u{62A}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{637}\u{6CC} \u{622}\u{646} \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{628}\u{631}\u{62E}\u{648}\u{631}\u{62F}\u{647}\u{627}\u{6CC}\u{6CC} \u{631}\u{62E} \u{62F}\u{647}\u{62F}. \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{645}\u{62F}\u{62A} \u{633}\u{637}\u{62D}\u{6CC} \u{627}\u{632} \u{645}\u{633}\u{626}\u{648}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{62F}\u{631} \u{642}\u{628}\u{627}\u{644} \u{628}\u{6CC}\u{645}\u{627}\u{631} \u{628}\u{631} \u{639}\u{647}\u{62F}\u{647} \u{645}\u{6CC} \u{6AF}\u{6CC}\u{631}\u{62F}.`,
    fil: `Isang asosasyon sa pagitan ng isang pasyente at isang organisasyon / tagapagbigay ng pangangalagang pangkalusugan kung saan maaaring mangyari ang mga nakatagpo ng oras. Ang pamamahala ng organisasyon ay may antas ng responsibilidad para sa pasyente sa panahong ito.`,
    fr: `Association entre un patient et une organisation ou un ou plusieurs prestataires de soins de sant\xe9 au cours de laquelle des rencontres peuvent avoir lieu. L\u{2019}organisation de gestion assume un certain niveau de responsabilit\xe9 pour le patient pendant cette p\xe9riode.`,
    hi: `\u{90F}\u{915} \u{930}\u{94B}\u{917}\u{940} \u{914}\u{930} \u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} / \u{938}\u{94D}\u{935}\u{93E}\u{938}\u{94D}\u{925}\u{94D}\u{92F} \u{938}\u{947}\u{935}\u{93E} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{924}\u{93E} (\u{913}\u{902}) \u{915}\u{947} \u{92C}\u{940}\u{91A} \u{90F}\u{915} \u{938}\u{902}\u{92C}\u{902}\u{927} \u{91C}\u{93F}\u{938}\u{915}\u{947} \u{926}\u{94C}\u{930}\u{93E}\u{928} \u{938}\u{92E}\u{92F} \u{92E}\u{941}\u{920}\u{92D}\u{947}\u{921}\u{93C} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{940} \u{939}\u{948}\u{964} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927} \u{938}\u{902}\u{917}\u{920}\u{928} \u{907}\u{938} \u{938}\u{92E}\u{92F} \u{915}\u{947} \u{926}\u{94C}\u{930}\u{93E}\u{928} \u{930}\u{94B}\u{917}\u{940} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{91C}\u{93F}\u{92E}\u{94D}\u{92E}\u{947}\u{926}\u{93E}\u{930}\u{940} \u{915}\u{93E} \u{90F}\u{915} \u{938}\u{94D}\u{924}\u{930} \u{92E}\u{93E}\u{928}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon asosyasyon ant yon pasyan ak yon \xf2ganizasyon / founis\xe8 swen sante (yo) pandan ki tan rankont ka rive. \xd2ganizasyon jere a pran yon nivo responsablite pou pasyan an pandan tan sa a.`,
    it: `Un'associazione tra un paziente e un'organizzazione/operatori sanitari durante la quale possono verificarsi incontri di tempo. L'organizzazione di gestione si assume un livello di responsabilit\xe0 nei confronti del paziente durante questo periodo.`,
    ja: `\u{60A3}\u{8005}\u{3068}\u{7D44}\u{7E54}/\u{533B}\u{7642}\u{63D0}\u{4F9B}\u{8005}\u{3068}\u{306E}\u{9593}\u{306E}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{3067}\u{3001}\u{305D}\u{306E}\u{9593}\u{306B}\u{906D}\u{9047}\u{304C}\u{767A}\u{751F}\u{3059}\u{308B}\u{53EF}\u{80FD}\u{6027}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}\u{3053}\u{306E}\u{671F}\u{9593}\u{4E2D}\u{3001}\u{7BA1}\u{7406}\u{7D44}\u{7E54}\u{306F}\u{60A3}\u{8005}\u{306B}\u{5BFE}\u{3057}\u{3066}\u{3042}\u{308B}\u{7A0B}\u{5EA6}\u{306E}\u{8CAC}\u{4EFB}\u{3092}\u{5F15}\u{304D}\u{53D7}\u{3051}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D658}\u{C790}\u{C640} \u{C870}\u{C9C1}/\u{C758}\u{B8CC} \u{C11C}\u{BE44}\u{C2A4} \u{C81C}\u{ACF5}\u{C790} \u{AC04}\u{C758} \u{C5F0}\u{AD00}\u{C131}\u{C73C}\u{B85C}, \u{C774} \u{AE30}\u{AC04} \u{B3D9}\u{C548} \u{B9CC}\u{B0A8}\u{C774} \u{BC1C}\u{C0DD}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{AD00}\u{B9AC} \u{C870}\u{C9C1}\u{C740} \u{C774} \u{AE30}\u{AC04} \u{B3D9}\u{C548} \u{D658}\u{C790}\u{C5D0} \u{B300}\u{D55C} \u{C77C}\u{C815} \u{C218}\u{C900}\u{C758} \u{CC45}\u{C784}\u{C744} \u{C9D1}\u{B2C8}\u{B2E4}.`,
    mww: `Ib lub koom haum los ntawm ib tug neeg mob thiab ib lub koom haum / ib lub koom haum / cov kws kho mob /cov kws kho mob yuav tshwm sim thaum lub sij hawm uas tej zaum yuav tshwm sim. Lub koom haum tswj lub koom haum assumes ib theem ntawm lub luag hauj lwm rau tus neeg mob lub sij hawm no.`,
    ps: `\u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{627}\u{648} \u{6CC}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} / \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{627}\u{631}\u{6A9}\u{648}\u{646}\u{6A9}\u{6CC} \u{62A}\u{631} \u{645}\u{646}\u{681} \u{62A}\u{693}\u{627}\u{648} \u{686}\u{6D0} \u{67E}\u{647} \u{647}\u{63A}\u{647} \u{645}\u{648}\u{62F}\u{647} \u{6A9}\u{6D0} \u{645}\u{645}\u{6A9}\u{646} \u{645}\u{62E}\u{627}\u{645}\u{62E} \u{6A9}\u{6CC}\u{696}\u{6CC}. \u{627}\u{62F}\u{627}\u{631}\u{647} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{67E}\u{647} \u{62F}\u{6D0} \u{645}\u{648}\u{62F}\u{647} \u{6A9}\u{6D0} \u{62F} \u{646}\u{627}\u{631}\u{648}\u{63A} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6CC}\u{648}\u{647} \u{6A9}\u{686}\u{647} \u{645}\u{633}\u{648}\u{648}\u{644}\u{6CC}\u{62A} \u{67E}\u{647} \u{63A}\u{627}\u{693}\u{647} \u{627}\u{62E}\u{644}\u{6CC}.`,
    pt: `Uma associa\xe7\xe3o entre um paciente e uma organiza\xe7\xe3o / provedor (es) de sa\xfade durante o qual os encontros podem ocorrer. A organiza\xe7\xe3o gestora assume um n\xedvel de responsabilidade pelo paciente durante esse per\xedodo.`,
    "pt-pt": `Uma associa\xe7\xe3o entre um paciente e uma organiza\xe7\xe3o/prestador de cuidados de sa\xfade durante o qual podem ocorrer encontros. A organiza\xe7\xe3o gestora assume um n\xedvel de responsabilidade pelo paciente durante este tempo.`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{44C} \u{43C}\u{435}\u{436}\u{434}\u{443} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C} \u{438} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}/\u{43F}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{449}\u{438}\u{43A}\u{43E}\u{43C} \u{43C}\u{435}\u{434}\u{438}\u{446}\u{438}\u{43D}\u{441}\u{43A}\u{438}\u{445} \u{443}\u{441}\u{43B}\u{443}\u{433}, \u{432} \u{442}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{439} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{43F}\u{440}\u{43E}\u{438}\u{441}\u{445}\u{43E}\u{434}\u{438}\u{442}\u{44C} \u{432}\u{441}\u{442}\u{440}\u{435}\u{447}\u{438}. \u{423}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{44E}\u{449}\u{430}\u{44F} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{431}\u{435}\u{440}\u{435}\u{442} \u{43D}\u{430} \u{441}\u{435}\u{431}\u{44F} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{443}\u{440}\u{43E}\u{432}\u{435}\u{43D}\u{44C} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{437}\u{430} \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{430} \u{432} \u{442}\u{435}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{44D}\u{442}\u{43E}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438}.`,
    sm: `O se feso'ota'iga i le va o se tagata ma'i ma se fa'alapotopotoga / tausi soifua maloloina (s) i le taimi e ono tupu ai feiloaiga. O le fa'alapotopotoga fa'atautaia o lo'o i ai se tulaga o le tiutetauave mo le tagata ma'i i lenei taimi.`,
    so: `Xidhiidh dhexmara bukaanka iyo hay'ad bixiyaha /daryeelka caafimaadka(s) kaas oo ay dhici karto waqti kulmay. Ururka maamulku waxa uu xil ka saaran yahay mas'uuliyadda bukaanka muddadan.`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23} / \u{E1C}\u{E39}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E1A}\u{E23}\u{E34}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E32}\u{E19}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2A}\u{E38}\u{E02}\u{E20}\u{E32}\u{E1E}\u{E43}\u{E19}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E32}\u{E08}\u{E40}\u{E01}\u{E34}\u{E14}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1C}\u{E0A}\u{E34}\u{E0D}\u{E2B}\u{E19}\u{E49}\u{E32} \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E08}\u{E30}\u{E23}\u{E31}\u{E1A}\u{E1C}\u{E34}\u{E14}\u{E0A}\u{E2D}\u{E1A}\u{E15}\u{E48}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22}\u{E43}\u{E19}\u{E23}\u{E30}\u{E14}\u{E31}\u{E1A}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E43}\u{E19}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{645}\u{631}\u{6CC}\u{636} \u{627}\u{648}\u{631} \u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} / \u{635}\u{62D}\u{62A} \u{6A9}\u{6CC} \u{62F}\u{6CC}\u{6A9}\u{6BE} \u{628}\u{6BE}\u{627}\u{644} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{62F}\u{631}\u{645}\u{6CC}\u{627}\u{646} \u{627}\u{6CC}\u{6A9} \u{62A}\u{639}\u{644}\u{642} \u{62C}\u{633} \u{6A9}\u{6D2} \u{62F}\u{648}\u{631}\u{627}\u{646} \u{645}\u{644}\u{627}\u{642}\u{627}\u{62A}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{633}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4} \u{645}\u{6CC}\u{646}\u{6CC}\u{62C}\u{646}\u{6AF} \u{622}\u{631}\u{6AF}\u{646}\u{627}\u{626}\u{632}\u{6CC}\u{634}\u{646} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{6A9}\u{6D2} \u{62F}\u{648}\u{631}\u{627}\u{646} \u{645}\u{631}\u{6CC}\u{636} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{630}\u{645}\u{6C1} \u{62F}\u{627}\u{631}\u{6CC} \u{6A9}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{633}\u{637}\u{62D} \u{642}\u{628}\u{648}\u{644} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED1}i li\xean h\u{1EC7} gi\u{1EEF}a b\u{1EC7}nh nh\xe2n v\xe0 t\u{1ED5} ch\u{1EE9}c / (c\xe1c) nh\xe0 cung c\u{1EA5}p d\u{1ECB}ch v\u{1EE5} ch\u{103}m s\xf3c s\u{1EE9}c kh\u{1ECF}e trong th\u{1EDD}i gian \u{111}\xf3 c\xe1c cu\u{1ED9}c g\u{1EB7}p g\u{1EE1} c\xf3 th\u{1EC3} x\u{1EA3}y ra. T\u{1ED5} ch\u{1EE9}c qu\u{1EA3}n l\xfd \u{111}\u{1EA3}m nh\u{1EAD}n m\u{1ED9}t m\u{1EE9}c tr\xe1ch nhi\u{1EC7}m \u{111}\u{1ED1}i v\u{1EDB}i b\u{1EC7}nh nh\xe2n trong th\u{1EDD}i gian n\xe0y.`,
    "zh-hans": `\u{60A3}\u{8005}\u{4E0E}\u{7EC4}\u{7EC7}/\u{533B}\u{7597}\u{4FDD}\u{5065}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{95F4}\u{7684}\u{5173}\u{8054}\u{FF0C}\u{5728}\u{6B64}\u{671F}\u{95F4}\u{53EF}\u{80FD}\u{4F1A}\u{53D1}\u{751F}\u{76F8}\u{9047}\u{3002}\u{5728}\u{6B64}\u{671F}\u{95F4}\u{FF0C}\u{7BA1}\u{7406}\u{7EC4}\u{7EC7}\u{5BF9}\u{60A3}\u{8005}\u{627F}\u{62C5}\u{4E00}\u{5B9A}\u{7A0B}\u{5EA6}\u{7684}\u{8D23}\u{4EFB}\u{3002}`,
    "zh-hant": `\u{60A3}\u{8005}\u{8207}\u{7D44}\u{7E54}/\u{91AB}\u{7642}\u{4FDD}\u{5065}\u{63D0}\u{4F9B}\u{8005}\u{4E4B}\u{9593}\u{7684}\u{95DC}\u{806F}\u{FF0C}\u{5728}\u{6B64}\u{671F}\u{9593}\u{53EF}\u{80FD}\u{6703}\u{767C}\u{751F}\u{76F8}\u{9047}\u{3002}\u{5728}\u{6B64}\u{671F}\u{9593}\u{FF0C}\u{7BA1}\u{7406}\u{7D44}\u{7E54}\u{5C0D}\u{60A3}\u{8005}\u{627F}\u{64D4}\u{4E00}\u{5B9A}\u{7A0B}\u{5EA6}\u{7684}\u{8CAC}\u{4EFB}\u{3002}`,
    en: `An association between a patient and an organization / healthcare provider(s) during which time encounters may occur. The managing organization assumes a level of responsibility for the patient during this time.`
};
const $2868cc1235412e16$export$1aab9202c7b650e6 = {
    ar: `\u{633}\u{62C}\u{644} \u{627}\u{62A}\u{641}\u{627}\u{642}\u{64A}\u{629} \u{644}\u{62C}\u{645}\u{639} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{623}\u{648} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{64A}\u{647}\u{627} \u{623}\u{648} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645}\u{647}\u{627} \u{623}\u{648} \u{627}\u{644}\u{625}\u{641}\u{635}\u{627}\u{62D} \u{639}\u{646}\u{647}\u{627} (\u{645}\u{634}\u{627}\u{631}\u{643}\u{62A}\u{647}\u{627}).`,
    de: `Eine Aufzeichnung einer Vereinbarung \xfcber die Erfassung, den Zugriff, die Nutzung oder die Offenlegung (Weitergabe) von Informationen.`,
    es: `Un registro de un acuerdo para recopilar, acceder, usar o divulgar (compartir) informaci\xf3n.`,
    fa: `\u{633}\u{627}\u{628}\u{642}\u{647} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{628}\u{631}\u{627}\u{6CC} \u{62C}\u{645}\u{639} \u{622}\u{648}\u{631}\u{6CC}\u{60C} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC}\u{60C} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6CC}\u{627} \u{627}\u{641}\u{634}\u{627}\u{6CC} (\u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{631}\u{6CC}) \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A}.`,
    fil: `Isang talaan ng isang kasunduan upang mangolekta, ma-access, gamitin o ibunyag (ibahagi) ang impormasyon.`,
    fr: `Enregistrement d\u{2019}une entente de collecte, d\u{2019}acc\xe8s, d\u{2019}utilisation ou de divulgation (partage) de renseignements.`,
    hi: `\u{938}\u{942}\u{91A}\u{928}\u{93E} \u{90F}\u{915}\u{924}\u{94D}\u{930} \u{915}\u{930}\u{928}\u{947}, \u{90F}\u{915}\u{94D}\u{938}\u{947}\u{938} \u{915}\u{930}\u{928}\u{947}, \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{93E} \u{92A}\u{94D}\u{930}\u{915}\u{91F} \u{915}\u{930}\u{928}\u{947} (\u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{930}\u{928}\u{947}) \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{93F}\u{938}\u{940} \u{915}\u{930}\u{93E}\u{930} \u{915}\u{93E} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{964}`,
    ht: `Yon dosye sou yon ak\xf2 pou kolekte, aks\xe8, itilize oswa divilge enf\xf2masyon (pataje) enf\xf2masyon.`,
    it: `Una registrazione di un accordo per la raccolta, l'accesso, l'utilizzo o la divulgazione (condivisione) di informazioni.`,
    ja: `\u{60C5}\u{5831}\u{306E}\u{53CE}\u{96C6}\u{3001}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3001}\u{4F7F}\u{7528}\u{3001}\u{307E}\u{305F}\u{306F}\u{958B}\u{793A}(\u{5171}\u{6709})\u{306B}\u{95A2}\u{3059}\u{308B}\u{5408}\u{610F}\u{306E}\u{8A18}\u{9332}\u{3002}`,
    ko: `\u{C815}\u{BCF4}\u{B97C} \u{C218}\u{C9D1}, \u{C811}\u{ADFC}, \u{C0AC}\u{C6A9} \u{B610}\u{B294} \u{ACF5}\u{AC1C}(\u{ACF5}\u{C720})\u{D558}\u{AE30}\u{B85C} \u{D569}\u{C758}\u{D55C} \u{AE30}\u{B85D}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib daim ntawv cog lus los mus sau, siv los yog sib faib tawm (sib faib tawm)`,
    ps: `\u{62F} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}\u{648} \u{62F} \u{631}\u{627}\u{67C}\u{648}\u{644}\u{648}\u{644}\u{648}\u{60C} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC}\u{60C} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{6CC}\u{627} \u{627}\u{641}\u{634}\u{627} \u{6A9}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{62A}\u{693}\u{648}\u{646} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}.`,
    pt: `Um registro de um contrato para coletar, acessar, usar ou divulgar (compartilhar) informa\xe7\xf5es.`,
    "pt-pt": `Um registo de um acordo para recolher, aceder, utilizar ou divulgar (partilhar) informa\xe7\xf5es.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{43E} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{438} \u{43D}\u{430} \u{441}\u{431}\u{43E}\u{440}, \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{441}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{435} (\u{43E}\u{431}\u{43C}\u{435}\u{43D}) \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `O se fa'amaumauga o se maliega e aoina, fa'aaogaina, fa'aaoga pe fa'aalia (fa'asoa) fa'amatalaga.`,
    so: `Diiwaanka heshiiska macluumaadka la ururinayo, ku helitaanka, la isticmaalayo ama la shaacinayo (Share) macluumaadka.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E02}\u{E49}\u{E2D}\u{E15}\u{E01}\u{E25}\u{E07}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E40}\u{E01}\u{E47}\u{E1A}\u{E23}\u{E27}\u{E1A}\u{E23}\u{E27}\u{E21} \u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07} \u{E43}\u{E0A}\u{E49} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E40}\u{E1C}\u{E22} (\u{E41}\u{E1A}\u{E48}\u{E07}\u{E1B}\u{E31}\u{E19}) \u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}`,
    ur: `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62C}\u{645}\u{639} \u{6A9}\u{631}\u{646}\u{6D2} \u{60C} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{60C} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6CC}\u{627} \u{638}\u{627}\u{6C1}\u{631} \u{6A9}\u{631}\u{646}\u{6D2} (\u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9}) \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6D2} \u{6A9}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688}\u{6D4}`,
    vi: `H\u{1ED3} s\u{1A1} th\u{1ECF}a thu\u{1EAD}n thu th\u{1EAD}p, truy c\u{1EAD}p, s\u{1EED} d\u{1EE5}ng ho\u{1EB7}c ti\u{1EBF}t l\u{1ED9} (chia s\u{1EBB}) th\xf4ng tin.`,
    "zh-hans": `\u{6536}\u{96C6}\u{3001}\u{8BBF}\u{95EE}\u{3001}\u{4F7F}\u{7528}\u{6216}\u{62AB}\u{9732}\u{FF08}\u{5171}\u{4EAB}\u{FF09}\u{4FE1}\u{606F}\u{7684}\u{534F}\u{8BAE}\u{8BB0}\u{5F55}\u{3002}`,
    "zh-hant": `\u{6536}\u{96C6}\u{3001}\u{8A2A}\u{554F}\u{3001}\u{4F7F}\u{7528}\u{6216}\u{62AB}\u{9732}\u{FF08}\u{5171}\u{7528}\u{FF09}\u{4FE1}\u{606F}\u{7684}\u{5354}\u{8B70}\u{8A18}\u{9304}\u{3002}`,
    en: `A record of an agreement to collect, access, use or disclose (share) information.`
};
const $2868cc1235412e16$export$f20156ec63e0a45d = {
    ar: `\u{645}\u{647}\u{645}\u{629} \u{62A}\u{633}\u{62A}\u{647}\u{62F}\u{641} \u{645}\u{624}\u{633}\u{633}\u{629} \u{623}\u{648} \u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{60C} \u{644}\u{627} \u{639}\u{644}\u{627}\u{642}\u{629} \u{644}\u{647}\u{627} \u{628}\u{639}\u{645}\u{64A}\u{644} \u{645}\u{639}\u{64A}\u{646}.`,
    de: `Eine Aufgabe, die auf eine Organisation oder einen Benutzer abzielt und sich nicht auf einen bestimmten Client bezieht.`,
    es: `Una tarea dirigida a una organizaci\xf3n o usuario, no relacionada con un cliente espec\xedfico.`,
    fa: `\u{648}\u{638}\u{6CC}\u{641}\u{647} \u{627}\u{6CC} \u{6A9}\u{647} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{628}\u{631} \u{631}\u{627} \u{647}\u{62F}\u{641} \u{642}\u{631}\u{627}\u{631} \u{645}\u{6CC} \u{62F}\u{647}\u{62F} \u{648} \u{628}\u{647} \u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{62E}\u{627}\u{635} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Isang gawain na nagta-target sa isang organisasyon o gumagamit, na walang kaugnayan sa isang tukoy na kliyente.`,
    fr: `T\xe2che ciblant une organisation ou un utilisateur, sans rapport avec un client sp\xe9cifique.`,
    hi: `\u{915}\u{93F}\u{938}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928} \u{92F}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{915}\u{94B} \u{932}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{915}\u{93E}\u{930}\u{94D}\u{92F}, \u{91C}\u{94B} \u{915}\u{93F}\u{938}\u{940} \u{935}\u{93F}\u{936}\u{93F}\u{937}\u{94D}\u{91F} \u{915}\u{94D}\u{932}\u{93E}\u{907}\u{902}\u{91F} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Yon travay ki vize yon \xf2ganizasyon oswa itilizat\xe8, ki pa gen rap\xf2 ak yon kliyan espesifik.`,
    it: `Un'attivit\xe0 destinata a un'organizzazione o a un utente, non correlata a un cliente specifico.`,
    ja: `\u{7279}\u{5B9A}\u{306E}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{3068}\u{306F}\u{7121}\u{95A2}\u{4FC2}\u{306E}\u{7D44}\u{7E54}\u{307E}\u{305F}\u{306F}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{3092}\u{5BFE}\u{8C61}\u{3068}\u{3059}\u{308B}\u{30BF}\u{30B9}\u{30AF}\u{3002}`,
    ko: `\u{D2B9}\u{C815} \u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640} \u{AD00}\u{B828}\u{C774} \u{C5C6}\u{B294} \u{C870}\u{C9C1} \u{B610}\u{B294} \u{C0AC}\u{C6A9}\u{C790}\u{B97C} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{D558}\u{B294} \u{C791}\u{C5C5}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib tug neeg ua hauj lwm targeting ib lub koom haum los yog neeg siv, unrelated rau ib tug neeg tau txais kev pab.`,
    ps: `\u{6CC}\u{648}\u{647} \u{62F}\u{646}\u{62F}\u{647} \u{686}\u{6D0} \u{6CC}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{67E}\u{647} \u{646}\u{69A}\u{647} \u{6A9}\u{648}\u{6CC} \u{60C} \u{686}\u{6D0} \u{62F} \u{6CC}\u{648} \u{681}\u{627}\u{646}\u{6AB}\u{693}\u{6CC} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Uma tarefa direcionada a uma organiza\xe7\xe3o ou usu\xe1rio, n\xe3o relacionada a um cliente espec\xedfico.`,
    "pt-pt": `Uma tarefa direcionada a uma organiza\xe7\xe3o ou usu\xe1rio, n\xe3o relacionada a um cliente espec\xedfico.`,
    ru: `\u{417}\u{430}\u{434}\u{430}\u{447}\u{430}, \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{43D}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E} \u{438}\u{43B}\u{438} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}, \u{43D}\u{435} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{430}\u{44F} \u{441} \u{43A}\u{43E}\u{43D}\u{43A}\u{440}\u{435}\u{442}\u{43D}\u{44B}\u{43C} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{43C}.`,
    sm: `O se galuega e fa'atatau i se fa'alapotopotoga po'o se tagata fa'aaoga, e le feso'ota'i ma se tagata fa'atau fa'apitoa.`,
    so: `Hawl lagu beegsanayo urur ama isticmaale, oo aan xiriir la lahayn macmiil gaar ah.`,
    th: `\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E1B}\u{E49}\u{E32}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32}\u{E17}\u{E35}\u{E48}\u{E40}\u{E09}\u{E1E}\u{E32}\u{E30}\u{E40}\u{E08}\u{E32}\u{E30}\u{E08}\u{E07}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633}\u{627} \u{6A9}\u{627}\u{645} \u{62C}\u{648} \u{6A9}\u{633}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6CC}\u{627} \u{635}\u{627}\u{631}\u{641} \u{6A9}\u{648} \u{646}\u{634}\u{627}\u{646}\u{6C1} \u{628}\u{646}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2} \u{60C} \u{62C}\u{633} \u{6A9}\u{627} \u{6A9}\u{633}\u{6CC} \u{645}\u{62E}\u{635}\u{648}\u{635} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{6A9}\u{648}\u{626}\u{6CC} \u{62A}\u{639}\u{644}\u{642} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t t\xe1c v\u{1EE5} nh\u{1EAF}m m\u{1EE5}c ti\xeau \u{111}\u{1EBF}n m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c ho\u{1EB7}c ng\u{1B0}\u{1EDD}i d\xf9ng, kh\xf4ng li\xean quan \u{111}\u{1EBF}n m\u{1ED9}t kh\xe1ch h\xe0ng c\u{1EE5} th\u{1EC3}.`,
    "zh-hans": `\u{4EE5}\u{7EC4}\u{7EC7}\u{6216}\u{7528}\u{6237}\u{4E3A}\u{76EE}\u{6807}\u{7684}\u{4EFB}\u{52A1}\u{FF0C}\u{4E0E}\u{7279}\u{5B9A}\u{5BA2}\u{6237}\u{7AEF}\u{65E0}\u{5173}\u{3002}`,
    "zh-hant": `\u{4EE5}\u{7D44}\u{7E54}\u{6216}\u{7528}\u{6236}\u{70BA}\u{76EE}\u{6A19}\u{7684}\u{4EFB}\u{52D9}\u{FF0C}\u{8207}\u{7279}\u{5B9A}\u{5BA2}\u{6236}\u{7AEF}\u{7121}\u{95DC}\u{3002}`,
    en: `A task targeting an organization or user, unrelated to a specific client.`
};
const $2868cc1235412e16$export$d010d50b14e45bda = {
    ar: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{645}\u{646} \u{627}\u{644}\u{623}\u{633}\u{626}\u{644}\u{629} \u{627}\u{644}\u{645}\u{62A}\u{639}\u{644}\u{642}\u{629} \u{628}\u{645}\u{624}\u{633}\u{633}\u{629} \u{623}\u{648} \u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{60C} \u{644}\u{627} \u{639}\u{644}\u{627}\u{642}\u{629} \u{644}\u{647}\u{627} \u{628}\u{639}\u{645}\u{64A}\u{644} \u{645}\u{639}\u{64A}\u{646}.`,
    de: `Eine Reihe von Fragen, die sich auf eine Organisation oder einen Benutzer beziehen, die sich nicht auf einen bestimmten Client beziehen.`,
    es: `Un conjunto de preguntas relacionadas con una organizaci\xf3n o usuario, no relacionadas con un cliente espec\xedfico.`,
    fa: `\u{645}\u{62C}\u{645}\u{648}\u{639}\u{647} \u{627}\u{6CC} \u{627}\u{632} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{645}\u{631}\u{628}\u{648}\u{637} \u{628}\u{647} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{60C} \u{63A}\u{6CC}\u{631} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{628}\u{627} \u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{62E}\u{627}\u{635}.`,
    fil: `Isang hanay ng mga katanungan na may kaugnayan sa isang organisasyon o gumagamit, na walang kaugnayan sa isang partikular na kliyente.`,
    fr: `Ensemble de questions relatives \xe0 une organisation ou \xe0 un utilisateur, sans rapport avec un client sp\xe9cifique.`,
    hi: `\u{915}\u{93F}\u{938}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928} \u{92F}\u{93E} \u{92A}\u{94D}\u{930}\u{92F}\u{94B}\u{915}\u{94D}\u{924}\u{93E} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{94B}\u{902} \u{915}\u{93E} \u{938}\u{92E}\u{942}\u{939}, \u{91C}\u{94B} \u{915}\u{93F}\u{938}\u{940} \u{935}\u{93F}\u{936}\u{93F}\u{937}\u{94D}\u{91F} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915} \u{938}\u{947} \u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B}\u{924}\u{93E} \u{939}\u{948}.`,
    ht: `Yon seri kesyon ki gen rap\xf2 ak yon \xf2ganizasyon oswa itilizat\xe8, ki pa gen rap\xf2 ak yon kliyan espesifik.`,
    it: `Un insieme di domande relative a un'organizzazione o a un utente, non correlate a un cliente specifico.`,
    ja: `\u{7279}\u{5B9A}\u{306E}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{3068}\u{306F}\u{7121}\u{95A2}\u{4FC2}\u{3067}\u{3001}\u{7D44}\u{7E54}\u{307E}\u{305F}\u{306F}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{306B}\u{95A2}\u{9023}\u{3059}\u{308B}\u{4E00}\u{9023}\u{306E}\u{8CEA}\u{554F}\u{3002}`,
    ko: `\u{D2B9}\u{C815} \u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C640} \u{AD00}\u{B828}\u{C774} \u{C5C6}\u{B294} \u{C870}\u{C9C1} \u{B610}\u{B294} \u{C0AC}\u{C6A9}\u{C790}\u{C640} \u{AD00}\u{B828}\u{B41C} \u{C77C}\u{B828}\u{C758} \u{C9C8}\u{BB38}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib cov lus nug txog ib lub koom haum los yog neeg siv, unrelated rau ib tug neeg tau txais kev pab.`,
    ps: `\u{62F} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{648} \u{6CC}\u{648}\u{647} \u{67C}\u{648}\u{644}\u{6AB}\u{647} \u{686}\u{6D0} \u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{6CC}\u{627} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{644}\u{631}\u{6CC}\u{60C} \u{686}\u{6D0} \u{62F} \u{6CC}\u{648} \u{681}\u{627}\u{646}\u{6AB}\u{693}\u{6CC} \u{645}\u{631}\u{627}\u{62C}\u{639} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Um conjunto de perguntas relacionadas a uma organiza\xe7\xe3o ou usu\xe1rio, n\xe3o relacionadas a um cliente espec\xedfico.`,
    "pt-pt": `Um conjunto de perguntas relacionadas a uma organiza\xe7\xe3o ou usu\xe1rio, n\xe3o relacionadas a um cliente espec\xedfico.`,
    ru: `\u{41D}\u{430}\u{431}\u{43E}\u{440} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{43E}\u{432}, \u{43E}\u{442}\u{43D}\u{43E}\u{441}\u{44F}\u{449}\u{438}\u{445}\u{441}\u{44F} \u{43A} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{438}\u{43B}\u{438} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44E}, \u{43D}\u{435} \u{43E}\u{442}\u{43D}\u{43E}\u{441}\u{44F}\u{449}\u{438}\u{445}\u{441}\u{44F} \u{43A} \u{43A}\u{43E}\u{43D}\u{43A}\u{440}\u{435}\u{442}\u{43D}\u{43E}\u{43C}\u{443} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{443}.`,
    sm: `O se seti o fesili e feso'ota'i ma se fa'alapotopotoga po'o se tagata fa'aaoga, e le feso'ota'i ma se tagata fa'apitoa.`,
    so: `Su'aalo badan oo la xiriira urur ama isticmaale, oo aan la xiriirin macmiil gaar ah.`,
    th: `\u{E0A}\u{E38}\u{E14}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32}\u{E40}\u{E09}\u{E1E}\u{E32}\u{E30}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6CC}\u{627} \u{635}\u{627}\u{631}\u{641} \u{633}\u{6D2} \u{645}\u{62A}\u{639}\u{644}\u{642} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{6A9}\u{627} \u{627}\u{6CC}\u{6A9} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{6C1} \u{60C} \u{62C}\u{633} \u{6A9}\u{627} \u{6A9}\u{633}\u{6CC} \u{645}\u{62E}\u{635}\u{648}\u{635} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{633}\u{6D2} \u{6A9}\u{648}\u{626}\u{6CC} \u{62A}\u{639}\u{644}\u{642} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t t\u{1EAD}p h\u{1EE3}p c\xe1c c\xe2u h\u{1ECF}i li\xean quan \u{111}\u{1EBF}n m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c ho\u{1EB7}c ng\u{1B0}\u{1EDD}i d\xf9ng, kh\xf4ng li\xean quan \u{111}\u{1EBF}n m\u{1ED9}t kh\xe1ch h\xe0ng c\u{1EE5} th\u{1EC3}.`,
    "zh-hans": `\u{4E0E}\u{7EC4}\u{7EC7}\u{6216}\u{7528}\u{6237}\u{76F8}\u{5173}\u{3001}\u{4E0E}\u{7279}\u{5B9A}\u{5BA2}\u{6237}\u{7AEF}\u{65E0}\u{5173}\u{7684}\u{4E00}\u{7EC4}\u{95EE}\u{9898}\u{3002}`,
    "zh-hant": `\u{8207}\u{7D44}\u{7E54}\u{6216}\u{4F7F}\u{7528}\u{8005}\u{76F8}\u{95DC}\u{3001}\u{8207}\u{7279}\u{5B9A}\u{5BA2}\u{6236}\u{7AEF}\u{7121}\u{95DC}\u{7684}\u{4E00}\u{7D44}\u{554F}\u{984C}\u{3002}`,
    en: `A set of questions related to an organization or user, unrelated to a specific client.`
};
const $2868cc1235412e16$export$fd5fa5d7e2f6be5d = {
    ar: `\u{62D}\u{62F}\u{62B} \u{645}\u{628}\u{627}\u{634}\u{631} \u{623}\u{648} \u{62D}\u{645}\u{644}\u{629} \u{623}\u{648} \u{646}\u{634}\u{627}\u{637} \u{622}\u{62E}\u{631} \u{64A}\u{633}\u{62A}\u{647}\u{62F}\u{641} \u{645}\u{62C}\u{645}\u{648}\u{639}\u{629} \u{645}\u{646} \u{627}\u{644}\u{623}\u{641}\u{631}\u{627}\u{62F}.`,
    de: `Ein pers\xf6nliches Live-Event, eine Kampagne oder eine andere Aktivit\xe4t, die sich an eine Gruppe von Personen richtet.`,
    es: `Un evento en vivo, una campa\xf1a u otra actividad en persona dirigida a un grupo de personas.`,
    fa: `\u{6CC}\u{6A9} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{632}\u{646}\u{62F}\u{647} \u{62D}\u{636}\u{648}\u{631}\u{6CC}\u{60C} \u{6A9}\u{645}\u{67E}\u{6CC}\u{646} \u{6CC}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{6A9}\u{647} \u{6AF}\u{631}\u{648}\u{647}\u{6CC} \u{627}\u{632} \u{627}\u{641}\u{631}\u{627}\u{62F} \u{631}\u{627} \u{647}\u{62F}\u{641} \u{642}\u{631}\u{627}\u{631} \u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Isang personal na live na kaganapan, kampanya, o iba pang aktibidad na nagta-target sa isang pangkat ng mga indibidwal.`,
    fr: `Un \xe9v\xe9nement en direct, une campagne ou toute autre activit\xe9 en personne ciblant un groupe de personnes.`,
    hi: `\u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{938}\u{92E}\u{942}\u{939} \u{915}\u{94B} \u{932}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{917}\u{924} \u{932}\u{93E}\u{907}\u{935} \u{907}\u{935}\u{947}\u{902}\u{91F}, \u{905}\u{92D}\u{93F}\u{92F}\u{93E}\u{928} \u{92F}\u{93E} \u{905}\u{928}\u{94D}\u{92F} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}.`,
    ht: `Yon ev\xe8nman an p\xe8s\xf2n ap viv, kanpay, oswa l\xf2t aktivite ki vize yon gwoup moun.`,
    it: `Un evento dal vivo, una campagna o un'altra attivit\xe0 di persona rivolta a un gruppo di individui.`,
    ja: `\u{500B}\u{4EBA}\u{306E}\u{30B0}\u{30EB}\u{30FC}\u{30D7}\u{3092}\u{5BFE}\u{8C61}\u{3068}\u{3057}\u{305F}\u{5BFE}\u{9762}\u{5F0F}\u{306E}\u{30E9}\u{30A4}\u{30D6} \u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{3001}\u{30AD}\u{30E3}\u{30F3}\u{30DA}\u{30FC}\u{30F3}\u{3001}\u{307E}\u{305F}\u{306F}\u{305D}\u{306E}\u{4ED6}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3002}`,
    ko: `\u{B300}\u{BA74} \u{B77C}\u{C774}\u{BE0C} \u{C774}\u{BCA4}\u{D2B8}, \u{CEA0}\u{D398}\u{C778} \u{B610}\u{B294} \u{AC1C}\u{C778} \u{ADF8}\u{B8F9}\u{C744} \u{B300}\u{C0C1}\u{C73C}\u{B85C} \u{D558}\u{B294} \u{AE30}\u{D0C0} \u{D65C}\u{B3D9}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib tug neeg nyob hauv-tus neeg nyob kev tshwm sim, kev sib tw, los yog lwm yam kev ua targeting ib pawg neeg.`,
    ps: `\u{6CC}\u{648} \u{634}\u{62E}\u{635}\u{6CC} \u{698}\u{648}\u{646}\u{62F}\u{6CD} \u{67E}\u{6CC}\u{69A}\u{647}\u{60C} \u{6A9}\u{645}\u{67E}\u{627}\u{6CC}\u{646}\u{60C} \u{6CC}\u{627} \u{628}\u{644} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{686}\u{6D0} \u{62F} \u{627}\u{641}\u{631}\u{627}\u{62F}\u{648} \u{6CC}\u{648}\u{647} \u{689}\u{644}\u{647} \u{67E}\u{647} \u{646}\u{69A}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Um evento presencial ao vivo, campanha ou outra atividade direcionada a um grupo de indiv\xedduos.`,
    "pt-pt": `Um evento ao vivo presencial, campanha ou outra atividade direcionada a um grupo de indiv\xedduos.`,
    ru: `\u{41E}\u{447}\u{43D}\u{43E}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{432} \u{43F}\u{440}\u{44F}\u{43C}\u{43E}\u{43C} \u{44D}\u{444}\u{438}\u{440}\u{435}, \u{43A}\u{430}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{44F} \u{438}\u{43B}\u{438} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435}, \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{43D}\u{430} \u{433}\u{440}\u{443}\u{43F}\u{43F}\u{443} \u{43B}\u{44E}\u{434}\u{435}\u{439}.`,
    sm: `O se mea na tupu i le tagata lava ia, tauiviga, po'o isi gaioiga e fa'atatau i se vaega o tagata ta'ito'atasi.`,
    so: `Dhacdo qof ahaan toos u ah, olole, ama hawlo kale oo lagu beegsanayo koox shaqsiyaad ah.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E16}\u{E48}\u{E32}\u{E22}\u{E17}\u{E2D}\u{E14}\u{E2A}\u{E14} \u{E41}\u{E04}\u{E21}\u{E40}\u{E1B}\u{E0D} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E46} \u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E1B}\u{E49}\u{E32}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E01}\u{E25}\u{E38}\u{E48}\u{E21}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}`,
    ur: `\u{627}\u{641}\u{631}\u{627}\u{62F} \u{6A9}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{6AF}\u{631}\u{648}\u{67E} \u{6A9}\u{648} \u{646}\u{634}\u{627}\u{646}\u{6C1} \u{628}\u{646}\u{627}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627} \u{630}\u{627}\u{62A}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{628}\u{631}\u{627}\u{6C1} \u{631}\u{627}\u{633}\u{62A} \u{67E}\u{631}\u{648}\u{6AF}\u{631}\u{627}\u{645} \u{60C} \u{645}\u{6C1}\u{645} \u{60C} \u{6CC}\u{627} \u{62F}\u{6CC}\u{6AF}\u{631} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{6D4}`,
    vi: `S\u{1EF1} ki\u{1EC7}n tr\u{1EF1}c ti\u{1EBF}p, chi\u{1EBF}n d\u{1ECB}ch ho\u{1EB7}c ho\u{1EA1}t \u{111}\u{1ED9}ng kh\xe1c nh\u{1EAF}m m\u{1EE5}c ti\xeau \u{111}\u{1EBF}n m\u{1ED9}t nh\xf3m c\xe1 nh\xe2n.`,
    "zh-hans": `\u{9488}\u{5BF9}\u{4E00}\u{7EC4}\u{4E2A}\u{4EBA}\u{7684}\u{73B0}\u{573A}\u{76F4}\u{64AD}\u{6D3B}\u{52A8}\u{3001}\u{6D3B}\u{52A8}\u{6216}\u{5176}\u{4ED6}\u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": `\u{91DD}\u{5C0D}\u{4E00}\u{7D44}\u{500B}\u{4EBA}\u{7684}\u{73FE}\u{5834}\u{76F4}\u{64AD}\u{6D3B}\u{52D5}\u{3001}\u{6D3B}\u{52D5}\u{6216}\u{5176}\u{4ED6}\u{6D3B}\u{52D5}\u{3002}`,
    en: `An in-person live event, campaign, or other activity targeting a group of individuals.`
};
const $2868cc1235412e16$export$c5b368b2998a6f37 = {
    ar: `\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{623}\u{645}\u{631}`,
    de: `Abbrechen`,
    es: `Cancelar`,
    fa: `\u{644}\u{63A}\u{648}`,
    fil: `Kanselahin`,
    fr: `Annuler`,
    hi: `\u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Anile`,
    it: `Annulla`,
    ja: `\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}`,
    ko: `\u{CDE8}\u{C18C}`,
    mww: `raug muab tso tseg`,
    ps: `\u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Cancelar`,
    "pt-pt": `Cancelar`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{430}`,
    sm: `Fa'al\u{113}\u{101}og\u{101}ina`,
    so: `Jooji`,
    th: `\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}`,
    ur: `\u{645}\u{646}\u{633}\u{648}\u{62E}`,
    vi: `H\u{1EE7}y`,
    "zh-hans": `\u{53D6}\u{6D88}`,
    "zh-hant": `\u{53D6}\u{6D88}`,
    en: `Cancel`
};
const $2868cc1235412e16$export$363d9660a18487e1 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{646}\u{648}\u{639} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `W\xe4hlen Sie die Aktivit\xe4tsart`,
    es: `Elegir tipo de actividad`,
    fa: `\u{646}\u{648}\u{639} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng uri ng aktibidad`,
    fr: `Choisissez le type d\u{2019}activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kalite aktivite`,
    it: `Scegli il tipo di attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{7A2E}\u{985E}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{D65C}\u{B3D9} \u{C720}\u{D615} \u{C120}\u{D0DD}`,
    mww: `Xaiv hom kev ua ub no`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{689}\u{648}\u{644} \u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{689}\u{648}\u{644}\u{648}\u{646}\u{647} \u{648}\u{67C}\u{627}\u{6A9}\u{647}`,
    pt: `Escolher tipo de atividade`,
    "pt-pt": `Escolha o tipo de atividade`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{438}\u{43F} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Filifili le ituaiga o gaoioiga`,
    so: `Dooro nooca waxqabadka`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{642}\u{633}\u{645} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n lo\u{1EA1}i ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{9009}\u{62E9}\u{6D3B}\u{52A8}\u{7C7B}\u{578B}`,
    "zh-hant": `\u{9078}\u{64C7}\u{6D3B}\u{52D5}\u{985E}\u{578B}`,
    en: `Choose activity type`
};
const $2868cc1235412e16$export$b352d5c1a5b9238 = {
    ar: `\u{62A}\u{639}\u{631}\u{64A}\u{641} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{627}\u{644}\u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neue Aktivit\xe4tsdefinition`,
    es: `Nueva definici\xf3n de actividad`,
    fa: `\u{62A}\u{639}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong kahulugan ng aktibidad`,
    fr: `D\xe9finition d\u{2019}une nouvelle activit\xe9`,
    hi: `\u{928}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}`,
    ht: `Nouvo definisyon aktivite`,
    it: `Nuova definizione di attivit\xe0`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{5B9A}\u{7FA9}`,
    ko: `\u{C0C8} \u{D65C}\u{B3D9} \u{C815}\u{C758}`,
    mww: `Kev ua tshiab txhais`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{646}\u{648}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    pt: `Nova defini\xe7\xe3o de atividade`,
    "pt-pt": `Nova defini\xe7\xe3o de atividade`,
    ru: `\u{41D}\u{43E}\u{432}\u{43E}\u{435} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Fa'auigaga fou o gaioiga`,
    so: `Qeexidda waxqabadka cusub`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{646}\u{626}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDB}i`,
    "zh-hans": `\u{65B0}\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    "zh-hant": `\u{65B0}\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `New activity definition`
};
const $2868cc1235412e16$export$178bd34954964b38 = {
    ar: `\u{639}\u{644}\u{646}\u{64A}`,
    de: `\xd6ffentlich`,
    es: `P\xfablico`,
    fa: `\u{639}\u{645}\u{648}\u{645}\u{6CC}`,
    fil: `Publiko`,
    fr: `Public`,
    hi: `\u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915}`,
    ht: `Piblik`,
    it: `Pubblico`,
    ja: `\u{516C}\u{5171}`,
    ko: `\u{ACF5}\u{ACF5}\u{C758}`,
    mww: `Pej Xeem`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{639}\u{627}\u{645}\u{6D0} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627} \u{648}\u{632}\u{627}\u{631}\u{62A} \u{648}\u{627}\u{6CC}\u{6CC}`,
    pt: `P\xfablico`,
    "pt-pt": `P\xfablico`,
    ru: `\u{41E}\u{431}\u{449}\u{435}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `Tagata lautele`,
    so: `Dadweynaha`,
    th: `\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30}`,
    ur: `\u{639}\u{648}\u{627}\u{645}`,
    vi: `C\xf4ng c\u{1ED9}ng`,
    "zh-hans": `\u{516C}\u{5171}`,
    "zh-hant": `\u{516C}\u{5171}`,
    en: `Public`
};
const $2868cc1235412e16$export$542d8f2b7fbbccd2 = {
    ar: (cumulus)=>`\u{64A}\u{645}\u{643}\u{646} \u{631}\u{628}\u{637} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{639}\u{627}\u{645}\u{629} \u{628}\u{627}\u{644}\u{623}\u{62D}\u{62F}\u{627}\u{62B} \u{648}\u{62A}\u{639}\u{628}\u{626}\u{62A}\u{647}\u{627} \u{645}\u{646} \u{642}\u{628}\u{644} \u{627}\u{644}\u{623}\u{641}\u{631}\u{627}\u{62F} \u{627}\u{644}\u{630}\u{64A}\u{646} \u{644}\u{64A}\u{633} \u{644}\u{62F}\u{64A}\u{647}\u{645} \u{62D}\u{633}\u{627}\u{628} ${cumulus} .`,
    de: (cumulus)=>`\xd6ffentliche Frageb\xf6gen k\xf6nnen mit Veranstaltungen verkn\xfcpft und von Personen ohne ${cumulus} ausgef\xfcllt werden.`,
    es: (cumulus)=>`Los cuestionarios p\xfablicos pueden asociarse con eventos y ser completados por personas sin una cuenta de ${cumulus} .`,
    fa: (cumulus)=>`\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{647}\u{627}\u{6CC} \u{639}\u{645}\u{648}\u{645}\u{6CC} \u{631}\u{627} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646} \u{628}\u{627} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{6A9}\u{631}\u{62F} \u{648} \u{62A}\u{648}\u{633}\u{637} \u{627}\u{641}\u{631}\u{627}\u{62F} \u{628}\u{62F}\u{648}\u{646} \u{62D}\u{633}\u{627}\u{628} ${cumulus} \u{67E}\u{631} \u{6A9}\u{631}\u{62F}.`,
    fil: (cumulus)=>`Ang mga pampublikong questionnaire ay maaaring maiugnay sa mga kaganapan at punan ng mga indibidwal na walang ${cumulus} account.`,
    fr: (cumulus)=>`Les questionnaires publics peuvent \xeatre associ\xe9s \xe0 des \xe9v\xe9nements et remplis par des personnes sans compte ${cumulus} .`,
    hi: (cumulus)=>`\u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} \u{918}\u{91F}\u{928}\u{93E}\u{913}\u{902} \u{938}\u{947} \u{91C}\u{941}\u{921}\u{93C}\u{940} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{940} \u{939}\u{948} \u{914}\u{930} ${cumulus} \u{916}\u{93E}\u{924}\u{947} \u{915}\u{947} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}\u{92F}\u{94B}\u{902} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92D}\u{930}\u{940} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{940} \u{939}\u{948}\u{964}`,
    ht: (cumulus)=>`Kesyon\xe8 piblik yo ka asosye ak ev\xe8nman ak ranpli pa moun san yo pa yon kont ${cumulus} .`,
    it: (cumulus)=>`I questionari pubblici possono essere associati a eventi e compilati da persone che non dispongono di un account ${cumulus} .`,
    ja: (cumulus)=>`\u{516C}\u{958B}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{306F}\u{3001}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306B}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{3066}\u{3001} ${cumulus} \u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{6301}\u{305F}\u{306A}\u{3044}\u{500B}\u{4EBA}\u{304C}\u{8A18}\u{5165}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    ko: (cumulus)=>`\u{ACF5}\u{AC1C} \u{C124}\u{BB38}\u{C9C0}\u{B294} \u{C774}\u{BCA4}\u{D2B8}\u{C640} \u{C5F0}\u{ACB0}\u{B420} \u{C218} \u{C788}\u{C73C}\u{BA70} ${cumulus} \u{ACC4}\u{C815}\u{C774} \u{C5C6}\u{B294} \u{AC1C}\u{C778}\u{C774} \u{C791}\u{C131}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (cumulus)=>`Pej xeem questionnaires yuav muaj kab mob nrog cov txheej xwm thiab sau los ntawm cov neeg tsis muaj ib ${cumulus} nyiaj.`,
    ps: (cumulus)=>`\u{639}\u{627}\u{645}\u{647} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{6A9}\u{6CC}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC} \u{62F} \u{67E}\u{6CC}\u{69A}\u{648} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{648}\u{644}\u{631}\u{6CC} \u{627}\u{648} \u{62F} \u{647}\u{63A}\u{648} \u{6A9}\u{633}\u{627}\u{646}\u{648} \u{644}\u{62E}\u{648}\u{627} \u{689}\u{6A9} \u{634}\u{6CC} \u{686}\u{6D0} ${cumulus} \u{62D}\u{633}\u{627}\u{628} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: (cumulus)=>`Os question\xe1rios p\xfablicos podem ser associados a eventos e preenchidos por indiv\xedduos sem uma conta ${cumulus} .`,
    "pt-pt": (cumulus)=>`Os question\xe1rios p\xfablicos podem ser associados a eventos e preenchidos por indiv\xedduos sem uma conta ${cumulus} .`,
    ru: (cumulus)=>`\u{41F}\u{443}\u{431}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{435} \u{430}\u{43D}\u{43A}\u{435}\u{442}\u{44B} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{44B} \u{441} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{43C}\u{438} \u{438} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{44F}\u{442}\u{44C}\u{441}\u{44F} \u{43B}\u{438}\u{446}\u{430}\u{43C}\u{438}, \u{43D}\u{435} \u{438}\u{43C}\u{435}\u{44E}\u{449}\u{438}\u{43C}\u{438} \u{443}\u{447}\u{435}\u{442}\u{43D}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} ${cumulus} .`,
    sm: (cumulus)=>`O fesili lautele e mafai ona feso'ota'i ma mea na tutupu ma fa'atumuina e tagata ta'ito'atasi e aunoa ma se ${cumulus} account.`,
    so: (cumulus)=>`Su'aalaha dadweynaha waxaa la xiriirin karaa dhacdooyinka ayadoo shakhsiyaadka ay buuxiyaan koontada ${cumulus} la'aanta.`,
    th: (cumulus)=>`\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E42}\u{E22}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C}\u{E41}\u{E25}\u{E30}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E42}\u{E14}\u{E22}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} ${cumulus}`,
    ur: (cumulus)=>`\u{639}\u{648}\u{627}\u{645}\u{6CC} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2} \u{648}\u{627}\u{642}\u{639}\u{627}\u{62A} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{645}\u{646}\u{633}\u{644}\u{6A9} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627}\u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{6A9}\u{645}\u{648}\u{644}\u{633} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{6D2} \u{628}\u{63A}\u{6CC}\u{631} \u{627}\u{641}\u{631}\u{627}\u{62F} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6C1} ${cumulus} \u{6D4}`,
    vi: (cumulus)=>`B\u{1EA3}ng c\xe2u h\u{1ECF}i c\xf4ng khai c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t v\u{1EDB}i c\xe1c s\u{1EF1} ki\u{1EC7}n v\xe0 \u{111}\u{1B0}\u{1EE3}c \u{111}i\u{1EC1}n b\u{1EDF}i c\xe1c c\xe1 nh\xe2n kh\xf4ng c\xf3 t\xe0i kho\u{1EA3}n ${cumulus} .`,
    "zh-hans": (cumulus)=>`\u{516C}\u{5171}\u{8C03}\u{67E5}\u{95EE}\u{5377}\u{53EF}\u{4EE5}\u{4E0E}\u{4E8B}\u{4EF6}\u{76F8}\u{5173}\u{8054}\u{FF0C}\u{5E76}\u{7531}\u{6CA1}\u{6709} ${cumulus} \u{8D26}\u{6237}\u{7684}\u{4E2A}\u{4EBA}\u{586B}\u{5199}\u{3002}`,
    "zh-hant": (cumulus)=>`\u{516C}\u{5171}\u{8ABF}\u{67E5}\u{554F}\u{5377}\u{53EF}\u{4EE5}\u{8207}\u{4E8B}\u{4EF6}\u{76F8}\u{95DC}\u{806F}\u{FF0C}\u{4E26}\u{7531}\u{6C92}\u{6709} ${cumulus} \u{5E33}\u{6236}\u{7684}\u{500B}\u{4EBA}\u{586B}\u{5BEB}\u{3002}`,
    en: (cumulus)=>`Public questionnaires can be associated with events and filled out by individuals without a ${cumulus} account.`
};
const $2868cc1235412e16$export$bf95549dd21eca03 = {
    ar: `\u{62A}\u{635}\u{631}\u{64A}\u{62D} \u{645}\u{62C}\u{647}\u{648}\u{644}`,
    de: `Anonym zulassen`,
    es: `Permiso an\xf3nimo`,
    fa: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633}`,
    fil: `Pahintulutan na hindi nagpapakilala`,
    fr: `Permis anonyme`,
    hi: `\u{905}\u{928}\u{93E}\u{92E} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}`,
    ht: `P\xe8m\xe8t anonim`,
    it: `Permesso anonimo`,
    ja: `\u{533F}\u{540D}\u{3067}\u{8A31}\u{53EF}`,
    ko: `\u{C775}\u{BA85} \u{D5C8}\u{C6A9}`,
    mww: `Daim Ntawv Tso Cai Anonymous`,
    ps: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633}`,
    pt: `Permitir an\xf4nimo`,
    "pt-pt": `Permitir an\xf3nimo`,
    ru: `\u{420}\u{430}\u{437}\u{440}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{430}\u{43D}\u{43E}\u{43D}\u{438}\u{43C}\u{43D}\u{43E}`,
    sm: `Fa'atagaina le le fa'ailoaina`,
    so: `qarsoodiga ah`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E0A}\u{E37}\u{E48}\u{E2D}`,
    ur: `\u{6AF}\u{645}\u{646}\u{627}\u{645} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{6BA}`,
    vi: `Cho ph\xe9p \u{1EA9}n danh`,
    "zh-hans": `\u{5141}\u{8BB8}\u{533F}\u{540D}`,
    "zh-hant": `\u{5141}\u{8A31}\u{533F}\u{540D}`,
    en: `Permit anonymous`
};
const $2868cc1235412e16$export$f88a30428911aa95 = {
    ar: (cumulus)=>`\u{64A}\u{645}\u{643}\u{646} \u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{633}\u{645}\u{62D} \u{628}\u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{627}\u{644}\u{645}\u{62C}\u{647}\u{648}\u{644} \u{62F}\u{648}\u{646} \u{627}\u{644}\u{627}\u{631}\u{62A}\u{628}\u{627}\u{637} \u{628}\u{634}\u{62E}\u{635} \u{645}\u{633}\u{62C}\u{644} \u{641}\u{64A} ${cumulus}.`,
    de: (cumulus)=>`Frageb\xf6gen, die eine anonyme Eingabe erm\xf6glichen, k\xf6nnen ohne Zuordnung zu einer registrierten Person in ${cumulus} erfasst werden.`,
    es: (cumulus)=>`Los cuestionarios que permiten la entrada an\xf3nima pueden ser grabados sin asociaci\xf3n con una persona registrada en ${cumulus}.`,
    fa: (cumulus)=>`\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{648}\u{62F} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633} \u{631}\u{627} \u{645}\u{6CC} \u{62F}\u{647}\u{646}\u{62F} \u{631}\u{627} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646} \u{628}\u{62F}\u{648}\u{646} \u{627}\u{631}\u{62A}\u{628}\u{627}\u{637} \u{628}\u{627} \u{634}\u{62E}\u{635} \u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{634}\u{62F}\u{647} \u{62F}\u{631} ${cumulus} \u{62B}\u{628}\u{62A} \u{6A9}\u{631}\u{62F}.`,
    fil: (cumulus)=>`Ang mga questionnaire na nagpapahintulot sa hindi nagpapakilalang pagpasok ay maaaring maitala nang walang kaugnayan sa isang rehistradong tao sa ${cumulus}.`,
    fr: (cumulus)=>`Les questionnaires qui permettent une saisie anonyme peuvent \xeatre enregistr\xe9s sans association avec une personne enregistr\xe9e dans ${cumulus}.`,
    hi: (cumulus)=>`\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} \u{91C}\u{94B} \u{905}\u{928}\u{93E}\u{92E} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{924}\u{940} \u{939}\u{948}, ${cumulus} \u{92E}\u{947}\u{902} \u{92A}\u{902}\u{91C}\u{940}\u{915}\u{943}\u{924} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{902}\u{92C}\u{902}\u{927} \u{915}\u{947} \u{92C}\u{93F}\u{928}\u{93E} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (cumulus)=>`Kesyon\xe8 ki p\xe8m\xe8t antre anonim ka anrejistre san asosyasyon ak yon moun ki anrejistre nan ${cumulus}.`,
    it: (cumulus)=>`I questionari che consentono l'inserimento anonimo possono essere registrati senza essere associati a una persona registrata in ${cumulus}.`,
    ja: (cumulus)=>`\u{533F}\u{540D}\u{3067}\u{53C2}\u{52A0}\u{3067}\u{304D}\u{308B}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{306F}\u{3001} ${cumulus} \u{306B}\u{767B}\u{9332}\u{3055}\u{308C}\u{305F}\u{4EBA}\u{7269}\u{3068}\u{306E}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{306A}\u{3057}\u{306B}\u{8A18}\u{9332}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    ko: (cumulus)=>`\u{C775}\u{BA85} \u{C785}\u{B825}\u{C744} \u{D5C8}\u{C6A9}\u{D558}\u{B294} \u{C124}\u{BB38}\u{C9C0}\u{B294} ${cumulus}\u{C5D0} \u{B4F1}\u{B85D}\u{B41C} \u{C0AC}\u{B78C}\u{ACFC} \u{C5F0}\u{AD00}\u{B418}\u{C9C0} \u{C54A}\u{ACE0} \u{AE30}\u{B85D}\u{B420} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (cumulus)=>`Questionnaires uas tso cai anonymous nkag teb chaws yuav raug kaw tsis muaj koom haum nrog ib tug neeg sau npe nyob ${cumulus}.`,
    ps: (cumulus)=>`\u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{686}\u{6D0} \u{62F} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633} \u{62F}\u{627}\u{62E}\u{644}\u{6CC}\u{62F}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{6CC} \u{67E}\u{647} ${cumulus} \u{6A9}\u{6D0} \u{62F} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC} \u{634}\u{62E}\u{635} \u{633}\u{631}\u{647} \u{62F} \u{62A}\u{693}\u{627}\u{648} \u{67E}\u{631}\u{62A}\u{647} \u{62B}\u{628}\u{62A} \u{6A9}\u{6CC}\u{62F}\u{644}\u{6CC} \u{634}\u{6CC}.`,
    pt: (cumulus)=>`Os question\xe1rios que permitem a entrada an\xf4nima podem ser gravados sem associa\xe7\xe3o com uma pessoa registrada no ${cumulus}.`,
    "pt-pt": (cumulus)=>`Os question\xe1rios que permitem a entrada an\xf3nima podem ser registados sem associa\xe7\xe3o com uma pessoa registada no ${cumulus}.`,
    ru: (cumulus)=>`\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{44B}, \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{430}\u{44E}\u{449}\u{438}\u{435} \u{430}\u{43D}\u{43E}\u{43D}\u{438}\u{43C}\u{43D}\u{44B}\u{439} \u{432}\u{44A}\u{435}\u{437}\u{434}, \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{44B} \u{431}\u{435}\u{437} \u{441}\u{432}\u{44F}\u{437}\u{438} \u{441} \u{437}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{43C} \u{43B}\u{438}\u{446}\u{43E}\u{43C} \u{432} ${cumulus}.`,
    sm: (cumulus)=>`O fesili e fa'atagaina ai le ulufale e le fa'ailoaina e mafai ona pu'eina e aunoa ma le feso'ota'iga ma se tagata lesitala i ${cumulus}.`,
    so: (cumulus)=>`Su'aalaha ogolaanaya soo gelitaanka qarsoodi lagu galo, waxaa lagu diiwaangelin karaa haddii aan lala xiriirin dadka ka diiwaangashan ${cumulus}.`,
    th: (cumulus)=>`\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E42}\u{E14}\u{E22}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E44}\u{E14}\u{E49}\u{E42}\u{E14}\u{E22}\u{E44}\u{E21}\u{E48}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E17}\u{E35}\u{E48}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E43}\u{E19} ${cumulus}`,
    ur: (cumulus)=>`\u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2} \u{62C}\u{648} \u{6AF}\u{645}\u{646}\u{627}\u{645} \u{62F}\u{627}\u{62E}\u{644}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} ${cumulus} \u{645}\u{6CC}\u{6BA} \u{631}\u{62C}\u{633}\u{679}\u{631}\u{688} \u{634}\u{62E}\u{635} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{648}\u{627}\u{628}\u{633}\u{62A}\u{6AF}\u{6CC} \u{6A9}\u{6D2} \u{628}\u{63A}\u{6CC}\u{631} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627}\u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (cumulus)=>`B\u{1EA3}ng c\xe2u h\u{1ECF}i cho ph\xe9p nh\u{1EAD}p c\u{1EA3}nh \u{1EA9}n danh c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c ghi l\u{1EA1}i m\xe0 kh\xf4ng c\u{1EA7}n li\xean h\u{1EC7} v\u{1EDB}i ng\u{1B0}\u{1EDD}i \u{111}\xe3 \u{111}\u{103}ng k\xfd \u{1EDF} ${cumulus}.`,
    "zh-hans": (cumulus)=>`\u{5141}\u{8BB8}\u{533F}\u{540D}\u{8F93}\u{5165}\u{7684}\u{95EE}\u{5377}\u{53EF}\u{4EE5}\u{8BB0}\u{5F55}\u{FF0C}\u{800C}\u{65E0}\u{9700}\u{4E0E} ${cumulus} \u{4E2D}\u{7684}\u{6CE8}\u{518C}\u{4EBA}\u{5458}\u{76F8}\u{5173}\u{8054}\u{3002}`,
    "zh-hant": (cumulus)=>`\u{5141}\u{8A31}\u{533F}\u{540D}\u{8F38}\u{5165}\u{7684}\u{554F}\u{5377}\u{53EF}\u{4EE5}\u{8A18}\u{9304}\u{FF0C}\u{800C}\u{7121}\u{9700}\u{8207} ${cumulus} \u{4E2D}\u{7684}\u{8A3B}\u{518A}\u{4EBA}\u{54E1}\u{76F8}\u{95DC}\u{806F}\u{3002}`,
    en: (cumulus)=>`Questionnaires which permit anonymous entry can be recorded without association with a registered person in ${cumulus}.`
};
const $2868cc1235412e16$export$c649626dc103486 = {
    ar: `\u{627}\u{644}\u{627}\u{646}\u{634}\u{637}\u{647}`,
    de: `Aktivit\xe4ten`,
    es: `Actividades`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `Mga Aktibidad`,
    fr: `Activit\xe9s`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902}`,
    ht: `Aktivite`,
    it: `Attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}`,
    ko: `\u{D65C}\u{B3D9}`,
    mww: `Yam`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Atividades`,
    "pt-pt": `Atividades`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Gaoioiga`,
    so: `Waxqabadyada`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{6D3B}\u{52D5}`,
    en: `Activities`
};
const $2868cc1235412e16$export$f093e2a834170186 = {
    ar: `\u{623}\u{646}\u{642}\u{630}`,
    de: `Retten`,
    es: `Salvar`,
    fa: `\u{630}\u{62E}\u{6CC}\u{631}\u{647}`,
    fil: `I-save`,
    fr: `Sauvegarder`,
    hi: `\u{930}\u{915}\u{94D}\u{937}\u{93E} \u{915}\u{930}`,
    ht: `Sove`,
    it: `Salvare`,
    ja: `\u{30BB}\u{30FC}\u{30D6}`,
    ko: `\u{AD6C}\u{D574}\u{B0B4}\u{B2E4}`,
    mww: `Tseg`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Salvar`,
    "pt-pt": `Gravar`,
    ru: `\u{421}\u{43F}\u{430}\u{441}\u{430}\u{442}\u{44C}`,
    sm: `Sefe`,
    so: `Xaree`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E2B}\u{E22}\u{E31}\u{E14}`,
    ur: `\u{628}\u{686}\u{627}\u{646}\u{627}`,
    vi: `C\u{1EE9}u`,
    "zh-hans": `\u{6551}`,
    "zh-hant": `\u{6551}`,
    en: `Save`
};
const $2868cc1235412e16$export$7c0278eb6fbbdd9e = {
    ar: `\u{645}\u{644}\u{627}\u{62D}\u{629}`,
    de: `Navigation`,
    es: `Navegaci\xf3n`,
    fa: `\u{646}\u{627}\u{648}\u{628}\u{631}\u{6CC}`,
    fil: `Nabigasyon`,
    fr: `Navigation`,
    hi: `\u{928}\u{94C}\u{938}\u{902}\u{91A}\u{93E}\u{932}\u{928}`,
    ht: `Navigasyon`,
    it: `Navigazione`,
    ja: `\u{822A}\u{6CD5}`,
    ko: `\u{D56D}\u{D589}`,
    mww: `navigation`,
    ps: `\u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{647}`,
    pt: `Navega\xe7\xe3o`,
    "pt-pt": `Navega\xe7\xe3o`,
    ru: `\u{41D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fa'atautaia`,
    so: `Navigation`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E14}\u{E34}\u{E19}\u{E40}\u{E23}\u{E37}\u{E2D}`,
    ur: `\u{6AF}\u{634}\u{62A}`,
    vi: `Menu`,
    "zh-hans": `\u{5BFC}\u{822A}`,
    "zh-hant": `\u{5C0E}\u{822A}`,
    en: `Navigation`
};
const $2868cc1235412e16$export$d0810dde2fad6b9a = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62D}\u{642}\u{627}\u{642}`,
    de: `F\xe4lligkeitsdatum`,
    es: `Fecha de vencimiento`,
    fa: `\u{633}\u{631}\u{631}\u{633}\u{6CC}\u{62F}`,
    fil: `Takdang petsa`,
    fr: `\xc9ch\xe9ance`,
    hi: `\u{928}\u{93F}\u{92F}\u{924} \u{924}\u{93E}\u{930}\u{940}\u{916}`,
    ht: `Dat limit limit`,
    it: `Data di scadenza`,
    ja: `\u{671F}\u{65E5}`,
    ko: `\u{B9C8}\u{AC10}\u{C77C}`,
    mww: `Hnub Tim`,
    ps: `\u{62F} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6D0} \u{646}\u{6CC}\u{67C}\u{6D0}`,
    pt: `Data de vencimento`,
    "pt-pt": `Data de vencimento`,
    ru: `\u{421}\u{440}\u{43E}\u{43A}`,
    sm: `Aso e faagata ai`,
    so: `Due date`,
    th: `\u{E27}\u{E31}\u{E19}\u{E04}\u{E23}\u{E1A}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}`,
    ur: `\u{645}\u{642}\u{631}\u{631}\u{6C1} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y \u{111}\u{1EBF}n h\u{1EA1}n`,
    "zh-hans": `\u{671F}\u{9650}`,
    "zh-hant": `\u{671F}\u{9650}`,
    en: `Due date`
};
const $2868cc1235412e16$export$9504159bc7ac9a88 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621}`,
    de: `Startdatum`,
    es: `Fecha de inicio`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639}`,
    fil: `Petsa ng pagsisimula`,
    fr: `Date de d\xe9but`,
    hi: `\u{936}\u{941}\u{930}\u{942} \u{939}\u{94B}\u{928}\u{947} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916}`,
    ht: `K\xf2manse dat`,
    it: `Data di inizio`,
    ja: `\u{958B}\u{59CB}\u{65E5}`,
    ko: `\u{C2DC}\u{C791} \u{B0A0}\u{C9DC}`,
    mww: `Pib hnub tim`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de in\xedcio`,
    "pt-pt": `Data de in\xedcio`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    sm: `Aso amata`,
    so: `Taariikhda Bilowga`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{622}\u{63A}\u{627}\u{632} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u`,
    "zh-hans": `\u{5F00}\u{59CB}\u{65E5}\u{671F}`,
    "zh-hant": `\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    en: `Start date`
};
const $2868cc1235412e16$export$5ac70ff8a5f1a5bf = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    de: `Enddatum`,
    es: `Fecha final`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Petsa ng pagtatapos`,
    fr: `Date de fin`,
    hi: `\u{916}\u{924}\u{94D}\u{92E} \u{939}\u{94B}\u{928}\u{947} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916}`,
    ht: `Dat fen`,
    it: `Data di fine`,
    ja: `\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{C885}\u{B8CC}\u{C77C}`,
    mww: `Hnub Kawg`,
    ps: `\u{62F} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de t\xe9rmino`,
    "pt-pt": `Data de fim`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso fa'amutaina`,
    so: `Taariikhda dhammaad`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y k\u{1EBF}t th\xfac`,
    "zh-hans": `\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "zh-hant": `\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `End date`
};
const $2868cc1235412e16$export$79dba243bd6a1f7c = {
    ar: `\u{627}\u{644}\u{645}\u{62D}\u{627}\u{644}`,
    de: `Abtretungsempf\xe4nger`,
    es: `Cesionario`,
    fa: `\u{648}\u{6A9}\u{6CC}\u{644}`,
    fil: `Tagapag-atas`,
    fr: `Cessionnaire`,
    hi: `\u{938}\u{92E}\u{928}\u{941}\u{926}\u{947}\u{936}\u{93F}\u{924}\u{940}`,
    ht: `Devwa`,
    it: `Assegnatario`,
    ja: `\u{62C5}\u{5F53}\u{8005}`,
    ko: `\u{B2F4}\u{B2F9}\u{C790}`,
    mww: `Assignee`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Cession\xe1rio`,
    "pt-pt": `Cession\xe1rio`,
    ru: `\u{41F}\u{440}\u{430}\u{432}\u{43E}\u{43F}\u{440}\u{435}\u{435}\u{43C}\u{43D}\u{438}\u{43A}`,
    sm: `Tofia`,
    so: `assignee`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `Assignee`,
    vi: `Chuy\u{1EC3}n nh\u{1B0}\u{1EE3}ng`,
    "zh-hans": `\u{53D7}\u{8BA9}\u{4EBA}`,
    "zh-hant": `\u{53D7}\u{8B93}\u{4EBA}`,
    en: `Assignee`
};
const $2868cc1235412e16$export$9bcb1cec33b64194 = {
    ar: `\u{627}\u{64A}`,
    de: `Nichts`,
    es: `Ninguno`,
    fa: `\u{647}\u{6CC}\u{686} \u{6A9}\u{62F}\u{627}\u{645}`,
    fil: `Wala`,
    fr: `Aucun`,
    hi: `\u{915}\u{94B}\u{908} \u{928}\u{939}\u{940}\u{902}`,
    ht: `anyen`,
    it: `Nessuno`,
    ja: `\u{4F55}\u{4E00}\u{3064}`,
    ko: `\u{C5C6}\u{C74C}`,
    mww: `Tsis muaj`,
    ps: `\u{647}\u{6CC}\u{685} \u{646}\u{647}`,
    pt: `Nenhum`,
    "pt-pt": `Nenhum`,
    ru: `\u{41D}\u{438}\u{43A}\u{430}\u{43A}\u{43E}\u{439}`,
    sm: `Leai se tasi`,
    so: `None`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E43}\u{E04}\u{E23}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC}`,
    vi: `Kh\xf4ng ai`,
    "zh-hans": `\u{6CA1}\u{6709}`,
    "zh-hant": `\u{6C92}\u{6709}`,
    en: `None`
};
const $2868cc1235412e16$export$905c65de4ff97758 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{639}\u{64A}\u{646}`,
    de: `Nicht zugeordnet`,
    es: `No asignado`,
    fa: `\u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Hindi nakatalaga`,
    fr: `Non attribu\xe9`,
    hi: `\u{905}\u{938}\u{93E}\u{907}\u{928} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Pa asiyen`,
    it: `Non assegnato`,
    ja: `\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}`,
    ko: `\u{D560}\u{B2F9}\u{B418}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Tsis raug muab xa mus rau lub tsev kawm ntawv`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `N\xe3o atribu\xeddo`,
    "pt-pt": `N\xe3o atribu\xeddo`,
    ru: `\u{41D}\u{435} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43E}`,
    sm: `E le'i tofia`,
    so: `Looma xilsaarin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `\u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `Kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{672A}\u{5206}\u{914D}`,
    "zh-hant": `\u{672A}\u{5206}\u{914D}`,
    en: `Not assigned`
};
const $2868cc1235412e16$export$8155d83ad7fe9d53 = {
    ar: `\u{64A}\u{643}\u{62A}\u{628}`,
    de: `Schreiben`,
    es: `Escribir`,
    fa: `\u{646}\u{648}\u{634}\u{62A}\u{646}`,
    fil: `Sumulat`,
    fr: `\xc9crire`,
    hi: `\u{932}\u{93F}\u{916}\u{928}\u{93E}`,
    ht: `Ekri`,
    it: `Scrivere`,
    ja: `\u{66F8}\u{304F}`,
    ko: `\u{C4F0}\u{B2E4}`,
    mww: `Sau`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Escrever`,
    "pt-pt": `Escrever`,
    ru: `\u{41F}\u{438}\u{441}\u{430}\u{442}\u{44C}`,
    sm: `Tusi`,
    so: `Ku qor`,
    th: `\u{E40}\u{E02}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{644}\u{6A9}\u{6BE}\u{646}\u{627}`,
    vi: `Vi\u{1EBF}t`,
    "zh-hans": `\u{5199}`,
    "zh-hant": `\u{5BEB}`,
    en: `Write`
};
const $2868cc1235412e16$export$777328b73ed02304 = {
    ar: `\u{645}\u{639}\u{627}\u{64A}\u{646}\u{647}`,
    de: `Vorschau`,
    es: `Vista previa`,
    fa: `\u{67E}\u{6CC}\u{634}\u{646}\u{645}\u{627}\u{6CC}\u{634}`,
    fil: `Preview`,
    fr: `Aper\xe7u`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{935}\u{938}\u{92E}\u{940}\u{915}\u{94D}\u{937}\u{93E}`,
    ht: `Preview`,
    it: `Anteprima`,
    ja: `\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}`,
    ko: `\u{BBF8}\u{B9AC} \u{BCF4}\u{AE30}`,
    mww: `saib ua ntej`,
    ps: `\u{645}\u{62E}\u{6A9}\u{62A}\u{646}\u{647}`,
    pt: `Visualizar`,
    "pt-pt": `Previsualizar`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{432}\u{430}\u{440}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}`,
    sm: `Muai vaaiga`,
    so: `Faah faafinta`,
    th: `\u{E14}\u{E39}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{67E}\u{6CC}\u{634}`,
    vi: `Download`,
    "zh-hans": `\u{9884}\u{89C8}`,
    "zh-hant": `\u{9810}\u{89BD}`,
    en: `Preview`
};
const $2868cc1235412e16$export$30a33fbafb74fce6 = {
    ar: `\u{627}\u{62A}\u{631}\u{643} \u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}`,
    de: `Hinterlasse einen Kommentar`,
    es: `Deja un comentario`,
    fa: `\u{62F}\u{6CC}\u{62F}\u{6AF}\u{627}\u{647}\u{62A}\u{627}\u{646} \u{631}\u{627} \u{628}\u{646}\u{648}\u{6CC}\u{633}\u{6CC}\u{62F}`,
    fil: `Mag-iwan ng komento`,
    fr: `Laisser un commentaire`,
    hi: `\u{90F}\u{915} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{91B}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Kite yon k\xf2mant\xe8`,
    it: `Lascia un commento`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{3092}\u{66F8}\u{304F}`,
    ko: `\u{CF54}\u{BA58}\u{D2B8}\u{B97C} \u{B0A8}\u{ACA8}\u{C8FC}\u{C138}\u{C694}`,
    mww: `Cia ib saib`,
    ps: `\u{62A}\u{628}\u{635}\u{631}\u{647} \u{67E}\u{631}\u{6CC}\u{696}\u{62F}\u{626}`,
    pt: `Deixe um coment\xe1rio`,
    "pt-pt": `Deixe um coment\xe1rio`,
    ru: `\u{41E}\u{441}\u{442}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}`,
    sm: `Tu'u se fa'amatalaga`,
    so: `Leave a comment`,
    th: `\u{E17}\u{E34}\u{E49}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E44}\u{E27}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{686}\u{6BE}\u{648}\u{691}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{1EC3} l\u{1EA1}i m\u{1ED9}t b\xecnh lu\u{1EAD}n`,
    "zh-hans": `\u{53D1}\u{8868}\u{8BC4}\u{8BBA}`,
    "zh-hant": `\u{767C}\u{8868}\u{8A55}\u{8AD6}`,
    en: `Leave a comment`
};
const $2868cc1235412e16$export$770a7072c65bfb8b = {
    ar: `\u{627}\u{644}\u{62A}\u{635}\u{645}\u{64A}\u{645} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} Markdown \u{645}\u{62F}\u{639}\u{648}\u{645}`,
    de: `Styling mit Markdown wird unterst\xfctzt`,
    es: `Se admite el estilo con Markdown`,
    fa: `\u{627}\u{633}\u{62A}\u{627}\u{6CC}\u{644} \u{62F}\u{647}\u{6CC} \u{628}\u{627} Markdown \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{645}\u{6CC} \u{634}\u{648}\u{62F}`,
    fil: `Sinusuportahan ang pag-istilo gamit ang Markdown`,
    fr: `Le style avec Markdown est pris en charge`,
    hi: `\u{92E}\u{93E}\u{930}\u{94D}\u{915}\u{921}\u{93E}\u{909}\u{928} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{94D}\u{91F}\u{93E}\u{907}\u{932}\u{93F}\u{902}\u{917} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{93F}\u{924} \u{939}\u{948}`,
    ht: `Styling ak Markdown sip\xf2te`,
    it: `L'applicazione di stili con Markdown \xe8 supportata`,
    ja: `Markdown \u{306B}\u{3088}\u{308B}\u{30B9}\u{30BF}\u{30A4}\u{30EB}\u{8A2D}\u{5B9A}\u{304C}\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `Markdown\u{C744} \u{C0AC}\u{C6A9}\u{D55C} \u{C2A4}\u{D0C0}\u{C77C}\u{B9C1}\u{C774} \u{C9C0}\u{C6D0}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Styling nrog Markdown yog txaus siab`,
    ps: `\u{62F} \u{645}\u{627}\u{631}\u{6A9} \u{689}\u{627}\u{648}\u{646} \u{633}\u{631}\u{647} \u{633}\u{67C}\u{627}\u{6CC}\u{644} \u{6A9}\u{648}\u{644} \u{645}\u{644}\u{627}\u{62A}\u{693} \u{6A9}\u{6CC}\u{696}\u{6CC}`,
    pt: `H\xe1 suporte para o estilo com Markdown`,
    "pt-pt": `O estilo com Markdown \xe9 suportado`,
    ru: `\u{41F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{441}\u{442}\u{438}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} Markdown`,
    sm: `E lagolagoina le fa'ata'ita'iga ma le Markdown`,
    so: `Qalabaynta Markdown waxaa taageeray`,
    th: `\u{E23}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E08}\u{E31}\u{E14}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E14}\u{E49}\u{E27}\u{E22} Markdown`,
    ur: `\u{645}\u{627}\u{631}\u{6A9} \u{688}\u{627}\u{624}\u{646} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{627}\u{633}\u{679}\u{627}\u{626}\u{644} \u{6A9}\u{6CC} \u{62D}\u{645}\u{627}\u{6CC}\u{62A} \u{6A9}\u{6CC} \u{62C}\u{627}\u{62A}\u{6CC} \u{6C1}\u{6D2}`,
    vi: `Ki\u{1EC3}u d\xe1ng v\u{1EDB}i Markdown \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3}`,
    "zh-hans": `\u{652F}\u{6301}\u{4F7F}\u{7528} Markdown \u{8FDB}\u{884C}\u{6837}\u{5F0F}\u{8BBE}\u{7F6E}`,
    "zh-hant": `\u{652F}\u{63F4}\u{4F7F}\u{7528} Markdown \u{9032}\u{884C}\u{6A23}\u{5F0F}\u{8A2D}\u{7F6E}`,
    en: `Styling with Markdown is supported`
};
const $2868cc1235412e16$export$fff7de9eec117c98 = {
    ar: `\u{644}\u{627} \u{634}\u{64A}\u{621} \u{644}\u{645}\u{639}\u{627}\u{64A}\u{646}\u{62A}\u{647}`,
    de: `Nichts zur Vorschau`,
    es: `Nada que previsualizar`,
    fa: `\u{686}\u{6CC}\u{632}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{646}\u{645}\u{627}\u{6CC}\u{634} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Walang dapat i-preview`,
    fr: `Rien \xe0 pr\xe9visualiser`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{935}\u{93E}\u{935}\u{932}\u{94B}\u{915}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{941}\u{91B} \u{92D}\u{940} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen anyen pou prevwa`,
    it: `Niente da visualizzare in anteprima`,
    ja: `\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{3059}\u{308B}\u{3082}\u{306E}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{BBF8}\u{B9AC} \u{BCFC} \u{AC83}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj dab tsi los saib ua ntej`,
    ps: `\u{647}\u{6CC}\u{685} \u{634}\u{6CC} \u{646}\u{647} \u{62F}\u{6CC} \u{686}\u{6D0} \u{62F} \u{644}\u{6CC}\u{62F}\u{646}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{648}\u{6AB}\u{648}\u{631}\u{6CC}`,
    pt: `Nada para visualizar`,
    "pt-pt": `Nada para pr\xe9-visualizar`,
    ru: `\u{41D}\u{438}\u{447}\u{435}\u{433}\u{43E} \u{434}\u{43B}\u{44F} \u{43F}\u{440}\u{435}\u{434}\u{432}\u{430}\u{440}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{430}`,
    sm: `Leai se mea e muai va'ai`,
    so: `Waxba kama hordhac`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E30}\u{E44}\u{E23}\u{E43}\u{E2B}\u{E49}\u{E14}\u{E39}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{67E}\u{6CC}\u{634} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{6A9}\u{686}\u{6BE} \u{628}\u{6BE}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 g\xec \u{111}\u{1EC3} xem tr\u{1B0}\u{1EDB}c`,
    "zh-hans": `\u{6CA1}\u{6709}\u{8981}\u{9884}\u{89C8}\u{7684}\u{5185}\u{5BB9}`,
    "zh-hant": `\u{6C92}\u{6709}\u{8981}\u{9810}\u{89BD}\u{7684}\u{5167}\u{5BB9}`,
    en: `Nothing to preview`
};
const $2868cc1235412e16$export$2a353ffa74523b9e = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}\u{62A}`,
    de: `Kommentare`,
    es: `Comentarios`,
    fa: `\u{646}\u{638}\u{631}\u{627}\u{62A}`,
    fil: `Mga Komento`,
    fr: `Commentaires`,
    hi: `\u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `K\xf2mant\xe8`,
    it: `Commenti`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `\u{CF54}\u{BA58}\u{D2B8}`,
    mww: `Lus`,
    ps: `\u{62A}\u{628}\u{635}\u{631}\u{647} \u{647}\u{627}`,
    pt: `Coment\xe1rios`,
    "pt-pt": `Observa\xe7\xf5es`,
    ru: `\u{41A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{438}`,
    sm: `Faamatalaga`,
    so: `Comments`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21} \u{E04}\u{E34}\u{E14} \u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `\u{62A}\u{628}\u{635}\u{631}\u{6D2}`,
    vi: `\xdd ki\u{1EBF}n`,
    "zh-hans": `\u{8BC4}\u{8BBA}`,
    "zh-hant": `\u{8A55}\u{8AD6}`,
    en: `Comments`
};
const $2868cc1235412e16$export$748f3ce2bc9515d1 = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}`,
    de: `Kommentar`,
    es: `Comentario`,
    fa: `\u{646}\u{638}\u{631}`,
    fil: `Komento`,
    fr: `Commentaire`,
    hi: `\u{938}\u{92E}\u{94D}\u{200D}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{928}\u{93E}`,
    ht: `K\xf2mant\xe8`,
    it: `Commento`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `\u{C8FC}\u{C11D}`,
    mww: `Saib`,
    ps: `\u{62A}\u{628}\u{635}\u{631}\u{647}`,
    pt: `Coment\xe1rio`,
    "pt-pt": `Comentar`,
    ru: `\u{41A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}`,
    sm: `Faamatalaga`,
    so: `comment`,
    th: `\u{E15}\u{E34}\u{E0A}\u{E21}`,
    ur: `\u{62A}\u{628}\u{635}\u{631}\u{6C1}`,
    vi: `B\xecnh lu\u{1EAD}n`,
    "zh-hans": `\u{8BC4}\u{8BBA}`,
    "zh-hant": `\u{8A55}\u{8AD6}`,
    en: `Comment`
};
const $2868cc1235412e16$export$71895d4fc88671c0 = {
    ar: `\u{639}\u{645}\u{631}`,
    de: `Alter`,
    es: `Edad`,
    fa: `\u{633}\u{646}`,
    fil: `Edad`,
    fr: `\xc2ge`,
    hi: `\u{909}\u{92E}\u{94D}\u{930}`,
    ht: `Laj`,
    it: `Et\xe0`,
    ja: `\u{5E74}\u{9F62}`,
    ko: `\u{C5F0}\u{B839}`,
    mww: `hnub nyoog`,
    ps: `\u{639}\u{645}\u{631}`,
    pt: `Idade`,
    "pt-pt": `Idade`,
    ru: `\u{412}\u{43E}\u{437}\u{440}\u{430}\u{441}\u{442}`,
    sm: `Tausaga`,
    so: `Age`,
    th: `\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{639}\u{645}\u{631}`,
    vi: `Tu\u{1ED5}i`,
    "zh-hans": `\u{5E74}\u{9F84}`,
    "zh-hant": `\u{5E74}\u{9F61}`,
    en: `Age`
};
const $2868cc1235412e16$export$d9537d64b8fd7c31 = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A}`,
    de: `Frageb\xf6gen`,
    es: `Cuestionarios`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Mga talatanungan`,
    fr: `Questionnaire`,
    hi: `\u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940}`,
    ht: `Kesyon\xe8 yo`,
    it: `Questionari`,
    ja: `\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}`,
    ko: `\u{C124}\u{BB38} \u{C870}\u{C0AC}`,
    mww: `Questionnaires`,
    ps: `\u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `Question\xe1rio`,
    "pt-pt": `Question\xe1rios`,
    ru: `\u{410}\u{43D}\u{43A}\u{435}\u{442}\u{44B}`,
    sm: `Fesili`,
    so: `Haku`,
    th: `\u{E41}\u{E1A}\u{E1A} \u{E2A}\u{E2D}\u{E1A} \u{E16}\u{E32}\u{E21}`,
    ur: `\u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2}`,
    vi: `C\xe2u h\u{1ECF}i`,
    "zh-hans": `\u{95EE}\u{5377}`,
    "zh-hant": `\u{554F}\u{5377}`,
    en: `Questionnaires`
};
const $2868cc1235412e16$export$29ba8b81c6cc7b43 = {
    ar: `\u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629}`,
    de: `QR-Code`,
    es: `C\xf3digo QR`,
    fa: `\u{6A9}\u{62F} QR`,
    fil: `Email Address *`,
    fr: `Code QR`,
    hi: `QR \u{915}\u{94B}\u{921}`,
    ht: `K\xf2d QR`,
    it: `Codice QR`,
    ja: `QR\u{30B3}\u{30FC}\u{30C9}`,
    ko: `QR \u{CF54}\u{B4DC}`,
    mww: `QR code`,
    ps: `\u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo QR`,
    "pt-pt": `C\xf3digo QR`,
    ru: `QR-\u{43A}\u{43E}\u{434}`,
    sm: `QR code`,
    so: `QR code`,
    th: `\u{E04}\u{E34}\u{E27}\u{E2D}\u{E32}\u{E23}\u{E4C}\u{E42}\u{E04}\u{E49}\u{E14}`,
    ur: `QR code`,
    vi: `M\xe3 QR`,
    "zh-hans": `\u{4E8C}\u{7EF4}\u{7801}`,
    "zh-hant": `\u{4E8C}\u{7DAD}\u{78BC}`,
    en: `QR code`
};
const $2868cc1235412e16$export$ca2e5371c05fb46f = {
    ar: `\u{637}\u{628}\u{639}`,
    de: `Drucken`,
    es: `Impresi\xf3n`,
    fa: `\u{686}\u{627}\u{67E}`,
    fil: `I-print`,
    fr: `Imprimer`,
    hi: `\u{92B}\u{93C}\u{94B}\u{91F}\u{94B}`,
    ht: `Enprime`,
    it: `Stampare`,
    ja: `\u{30D7}\u{30EA}\u{30F3}\u{30C8}`,
    ko: `\u{C778}\u{C1C4}\u{D558}\u{B2E4}`,
    mww: `Sau`,
    ps: `\u{686}\u{627}\u{67E}`,
    pt: `Imprimir`,
    "pt-pt": `Impress\xe3o`,
    ru: `\u{41F}\u{435}\u{447}\u{430}\u{442}\u{430}\u{442}\u{44C}`,
    sm: `Lolomi`,
    so: `Haku`,
    th: `\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}`,
    ur: `\u{686}\u{6BE}\u{627}\u{67E}\u{646}\u{627}`,
    vi: `In`,
    "zh-hans": `\u{6253}\u{5370}`,
    "zh-hant": `\u{5217}\u{5370}`,
    en: `Print`
};
const $2868cc1235412e16$export$9a0b973819fb310 = {
    ar: `\u{634}\u{639}\u{628}`,
    de: `Volk`,
    es: `Gente`,
    fa: `\u{645}\u{631}\u{62F}\u{645}`,
    fil: `Mga Tao`,
    fr: `Gens`,
    hi: `\u{932}\u{94B}\u{917}`,
    ht: `Moun`,
    it: `Gente`,
    ja: `\u{4EBA}`,
    ko: `\u{C0AC}\u{B78C}`,
    mww: `Neeg`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Povo`,
    "pt-pt": `Pessoas`,
    ru: `\u{41D}\u{430}\u{440}\u{43E}\u{434}`,
    sm: `Tagata`,
    so: `Dadka`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}\u{E0A}\u{E19}`,
    ur: `\u{644}\u{648}\u{6AF}`,
    vi: `D\xe2n t\u{1ED9}c`,
    "zh-hans": `\u{4EBA}`,
    "zh-hant": `\u{4EBA}`,
    en: `People`
};
const $2868cc1235412e16$export$c7ccf165d99d4bc7 = {
    ar: `\u{646}\u{634}\u{627}\u{637} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neue Aktivit\xe4t`,
    es: `Nueva actividad`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong aktibidad`,
    fr: `Nouvelle activit\xe9`,
    hi: `\u{928}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `Nouvo aktivite`,
    it: `Nuova attivit\xe0`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}`,
    ko: `\u{C0C8}\u{B85C}\u{C6B4} \u{D65C}\u{B3D9}`,
    mww: `kev ua ub no tshiab`,
    ps: `\u{646}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Nova atividade`,
    "pt-pt": `Nova atividade`,
    ru: `\u{41D}\u{43E}\u{432}\u{430}\u{44F} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Gaoioiga fou`,
    so: `Shaqoo hor leh`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDB}i`,
    "zh-hans": `\u{65B0}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{65B0}\u{6D3B}\u{52D5}`,
    en: `New activity`
};
const $2868cc1235412e16$export$891b945946a1cefd = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{62A}\u{639}\u{631}\u{64A}\u{641}\u{627}\u{62A} \u{646}\u{634}\u{627}\u{637} \u{642}\u{627}\u{628}\u{644}\u{629} \u{644}\u{644}\u{62A}\u{637}\u{628}\u{64A}\u{642}`,
    de: `Keine anwendbaren Aktivit\xe4tsdefinitionen`,
    es: `No hay definiciones de actividad aplicables`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{62A}\u{639}\u{627}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{642}\u{627}\u{628}\u{644} \u{627}\u{62C}\u{631}\u{627}`,
    fil: `Walang naaangkop na mga kahulugan ng aktibidad`,
    fr: `Aucune d\xe9finition d\u{2019}activit\xe9 applicable`,
    hi: `\u{915}\u{94B}\u{908} \u{932}\u{93E}\u{917}\u{942} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen definisyon aktivite aplikab`,
    it: `Nessuna definizione di attivit\xe0 applicabile`,
    ja: `\u{9069}\u{7528}\u{53EF}\u{80FD}\u{306A}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{5B9A}\u{7FA9}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C801}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{D65C}\u{B3D9} \u{C815}\u{C758}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj kev txhais cov ntsiab lus tseem ceeb`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{648}\u{646}\u{647} \u{646}\u{647} \u{62F}\u{6CC} \u{62F} \u{62A}\u{637}\u{628}\u{6CC}\u{642} \u{648}\u{693}`,
    pt: `Nenhuma defini\xe7\xe3o de atividade aplic\xe1vel`,
    "pt-pt": `Sem defini\xe7\xf5es de atividade aplic\xe1veis`,
    ru: `\u{41D}\u{435}\u{442} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{43C}\u{44B}\u{445} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{439} \u{432}\u{438}\u{434}\u{43E}\u{432} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `E leai ni faauigaga talafeagai o gaoioiga`,
    so: `Qeexitaanka waxqabadka ee khuseeya ma jiro`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{642}\u{627}\u{628}\u{644} \u{627}\u{637}\u{644}\u{627}\u{642} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 \u{111}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng \xe1p d\u{1EE5}ng`,
    "zh-hans": `\u{65E0}\u{9002}\u{7528}\u{7684}\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}`,
    "zh-hant": `\u{7121}\u{9069}\u{7528}\u{7684}\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}`,
    en: `No applicable activity definitions`
};
const $2868cc1235412e16$export$68919206df5157d9 = {
    ar: `\u{62A}\u{62A}\u{645} \u{625}\u{62F}\u{627}\u{631}\u{629} \u{62A}\u{639}\u{631}\u{64A}\u{641}\u{627}\u{62A} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{641}\u{64A} \u{625}\u{639}\u{62F}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639} \u{641}\u{64A} \u{645}\u{624}\u{633}\u{633}\u{62A}\u{643}.`,
    de: `Aktivit\xe4tsdefinitionen werden in den Projekteinstellungen Ihrer Organisation verwaltet.`,
    es: `Las definiciones de actividad se administran en la configuraci\xf3n del proyecto de su organizaci\xf3n.`,
    fa: `\u{62A}\u{639}\u{627}\u{631}\u{6CC}\u{641} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62F}\u{631} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{627}\u{62A} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Ang mga kahulugan ng aktibidad ay pinamamahalaan sa mga setting ng proyekto ng iyong organisasyon.`,
    fr: `Les d\xe9finitions d\u{2019}activit\xe9s sont g\xe9r\xe9es dans les param\xe8tres de projet de votre organisation.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930}\u{93F}\u{92D}\u{93E}\u{937}\u{93E}\u{90F}\u{901} \u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{940} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{938}\u{947}\u{91F}\u{93F}\u{902}\u{917}\u{94D}\u{938} \u{92E}\u{947}\u{902} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{915}\u{940} \u{91C}\u{93E}\u{924}\u{940} \u{939}\u{948}\u{902}.`,
    ht: `Definisyon aktivite yo jere nan anviw\xf2nman pwoj\xe8 \xf2ganizasyon ou an.`,
    it: `Le definizioni delle attivit\xe0 vengono gestite nelle impostazioni del progetto dell'organizzazione.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{5B9A}\u{7FA9}\u{306F}\u{3001}\u{7D44}\u{7E54}\u{306E}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{8A2D}\u{5B9A}\u{3067}\u{7BA1}\u{7406}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D65C}\u{B3D9} \u{C815}\u{C758}\u{B294} \u{C870}\u{C9C1}\u{C758} \u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{C124}\u{C815}\u{C5D0}\u{C11C} \u{AD00}\u{B9AC}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntsiab lus txhais cov ntsiab lus yog tswj nyob rau hauv koj lub koom haum qhov project project.`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{648}\u{646}\u{647} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{67E}\u{647} \u{62A}\u{631}\u{62A}\u{6CC}\u{628}\u{627}\u{62A}\u{648} \u{6A9}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `As defini\xe7\xf5es de atividade s\xe3o gerenciadas nas configura\xe7\xf5es de projeto da sua organiza\xe7\xe3o.`,
    "pt-pt": `As defini\xe7\xf5es de atividade s\xe3o gerenciadas nas configura\xe7\xf5es de projeto da sua organiza\xe7\xe3o.`,
    ru: `\u{423}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{438}\u{44F}\u{43C}\u{438} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439} \u{43E}\u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{43B}\u{44F}\u{435}\u{442}\u{441}\u{44F} \u{432} \u{43F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{430}\u{445} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `O faauigaga o gaoioiga o loo pulea i faatulagaga o galuega faatino a lau faalapotopotoga.`,
    so: `Qeexidda waxqabadka waxaa lagu maamulaa goobaha mashruuca ee ururkaaga.`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E08}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E14}\u{E04}\u{E27}\u{E32}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{62A}\u{639}\u{631}\u{6CC}\u{641}\u{6CC}\u{6BA} \u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{631}\u{62A}\u{6CC}\u{628}\u{627}\u{62A} \u{645}\u{6CC}\u{6BA} \u{645}\u{646}\u{638}\u{645} \u{6A9}\u{6CC} \u{62C}\u{627}\u{62A}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\u{1ECB}nh ngh\u{129}a ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c qu\u{1EA3}n l\xfd trong c\xe0i \u{111}\u{1EB7}t d\u{1EF1} \xe1n c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c b\u{1EA1}n.`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{5B9A}\u{4E49}\u{5728}\u{7EC4}\u{7EC7}\u{7684}\u{9879}\u{76EE}\u{8BBE}\u{7F6E}\u{4E2D}\u{8FDB}\u{884C}\u{7BA1}\u{7406}\u{3002}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{5B9A}\u{7FA9}\u{5728}\u{7D44}\u{7E54}\u{7684}\u{9805}\u{76EE}\u{8A2D}\u{7F6E}\u{4E2D}\u{9032}\u{884C}\u{7BA1}\u{7406}\u{3002}`,
    en: `Activity definitions are managed in your organization's project settings.`
};
const $2868cc1235412e16$export$baff25308003b0cc = {
    ar: `\u{62E}\u{644}\u{642}`,
    de: `Schaffen`,
    es: `Crear`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F}`,
    fil: `Lumikha`,
    fr: `Cr\xe9er`,
    hi: `\u{92C}\u{928}\u{93E}\u{928}\u{93E}`,
    ht: `Kreye`,
    it: `Creare`,
    ja: `\u{5275}\u{9020}\u{3059}\u{308B}`,
    ko: `\u{CC3D}\u{C870}\u{D558}\u{B2E4}`,
    mww: `Rhawv`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Criar`,
    "pt-pt": `Criar`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Fausia`,
    so: `Abuuri`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62A}\u{62E}\u{644}\u{6CC}\u{642}`,
    vi: `T\u{1EA1}o`,
    "zh-hans": `\u{521B}\u{9020}`,
    "zh-hant": `\u{5275}\u{9020}`,
    en: `Create`
};
const $2868cc1235412e16$export$707a8412863caea1 = {
    ar: `\u{625}\u{639}\u{62F}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projekt-Einstellungen`,
    es: `Configuraci\xf3n del proyecto`,
    fa: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{627}\u{62A} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Mga setting ng proyekto`,
    fr: `Param\xe8tres du projet`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{938}\u{947}\u{91F}\u{93F}\u{902}\u{917}\u{94D}\u{938}`,
    ht: `Anviw\xf2nman pwoj\xe8`,
    it: `Impostazioni del progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{8A2D}\u{5B9A}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{C124}\u{C815}`,
    mww: `Tej yaam num teev tseg`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{62A}\u{631}\u{62A}\u{6CC}\u{628}\u{627}\u{62A}`,
    pt: `Configura\xe7\xf5es do projeto`,
    "pt-pt": `Configura\xe7\xf5es do projeto`,
    ru: `\u{41D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}`,
    sm: `Tulaga o galuega faatino`,
    so: `Goobaha Mashruuca`,
    th: `\u{E01}\u{E32}\u{E23}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{6A9}\u{6CC} \u{62A}\u{631}\u{62A}\u{6CC}\u{628}\u{627}\u{62A}`,
    vi: `C\xe0i \u{111}\u{1EB7}t d\u{1EF1} \xe1n`,
    "zh-hans": `\u{9879}\u{76EE}\u{8BBE}\u{7F6E}`,
    "zh-hant": `\u{9805}\u{76EE}\u{8A2D}\u{7F6E}`,
    en: `Project settings`
};
const $2868cc1235412e16$export$7226b538ca62ac55 = {
    ar: `\u{62A}\u{639}\u{644}\u{64A}\u{645}\u{627}\u{62A}`,
    de: `Anweisungen`,
    es: `Instrucciones`,
    fa: `\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{644}\u{639}\u{645}\u{644}`,
    fil: `Mga tagubilin`,
    fr: `Instructions`,
    hi: `\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{947}\u{936}`,
    ht: `Sa pou enstriksyon yo`,
    it: `Disposizioni`,
    ja: `\u{6307}\u{793A}`,
    ko: `\u{C9C0}\u{C2DC}`,
    mww: `Qhia`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Instru\xe7\xf5es`,
    "pt-pt": `Instru\xe7\xf5es`,
    ru: `\u{420}\u{435}\u{437}\u{43E}\u{43B}\u{44E}\u{446}\u{438}\u{44F}`,
    sm: `Faatonuga`,
    so: `Tilmaamaha`,
    th: `\u{E04}\u{E33} \u{E41}\u{E19}\u{E30} \u{E19}\u{E33}`,
    ur: `\u{6C1}\u{62F}\u{627}\u{6CC}\u{627}\u{62A}`,
    vi: `Ch\u{1EC9} th\u{1ECB}`,
    "zh-hans": `\u{6307}\u{793A}`,
    "zh-hant": `\u{6307}\u{793A}`,
    en: `Instructions`
};
const $2868cc1235412e16$export$89c7954a99376945 = {
    ar: (entityType)=>`\u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{645}\u{627}\u{62A} \u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631}\u{64A}\u{629} \u{648}\u{633}\u{62A}\u{638}\u{647}\u{631} \u{641}\u{64A} \u{623}\u{639}\u{644}\u{649} \u{643}\u{644} ${entityType}.`,
    de: (entityType)=>`Anweisungen sind optional und werden oben in jeder ${entityType} angezeigt.`,
    es: (entityType)=>`Las instrucciones son opcionales y aparecer\xe1n en la parte superior de cada ${entityType}.`,
    fa: (entityType)=>`\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{644}\u{639}\u{645}\u{644} \u{647}\u{627} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{647}\u{633}\u{62A}\u{646}\u{62F} \u{648} \u{62F}\u{631} \u{628}\u{627}\u{644}\u{627}\u{6CC} \u{647}\u{631} ${entityType} \u{638}\u{627}\u{647}\u{631} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (entityType)=>`Ang mga tagubilin ay opsyonal at lilitaw sa tuktok ng bawat ${entityType}.`,
    fr: (entityType)=>`Les instructions sont facultatives et appara\xeetront en haut de chaque ${entityType}.`,
    hi: (entityType)=>`\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{947}\u{936} \u{935}\u{948}\u{915}\u{932}\u{94D}\u{92A}\u{93F}\u{915} \u{939}\u{948}\u{902} \u{914}\u{930} \u{92A}\u{94D}\u{930}\u{924}\u{94D}\u{92F}\u{947}\u{915} ${entityType} \u{915}\u{947} \u{936}\u{940}\u{930}\u{94D}\u{937} \u{92A}\u{930} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{902}\u{917}\u{947}\u{964}`,
    ht: (entityType)=>`Enstriksyon yo si ou vle epi yo pral par\xe8t nan t\xe8t la nan chak ${entityType}.`,
    it: (entityType)=>`Le istruzioni sono facoltative e appariranno nella parte superiore di ogni ${entityType}.`,
    ja: (entityType)=>`\u{624B}\u{9806}\u{306F}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{3067}\u{3042}\u{308A}\u{3001}\u{5404} ${entityType}\u{306E}\u{4E0A}\u{90E8}\u{306B}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: (entityType)=>`\u{C9C0}\u{CE68}\u{C740} \u{C120}\u{D0DD} \u{C0AC}\u{D56D}\u{C774}\u{BA70} \u{AC01} ${entityType} \u{B9E8} \u{C704}\u{C5D0} \u{D45C}\u{C2DC}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: (entityType)=>`Cov lus qhia yog xaiv thiab yuav tshwm sim nyob saum txhua ${entityType}.`,
    ps: (entityType)=>`\u{644}\u{627}\u{631}\u{69A}\u{648}\u{648}\u{646}\u{6D0} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{62F}\u{6CC} \u{627}\u{648} \u{62F} ${entityType} \u{67E}\u{647} \u{633}\u{631} \u{6A9}\u{6D0} \u{628}\u{647} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{634}\u{6CC}.`,
    pt: (entityType)=>`As instru\xe7\xf5es s\xe3o opcionais e aparecer\xe3o na parte superior de cada ${entityType}.`,
    "pt-pt": (entityType)=>`As instru\xe7\xf5es s\xe3o opcionais e aparecer\xe3o na parte superior de cada ${entityType}.`,
    ru: (entityType)=>`\u{418}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{446}\u{438}\u{438} \u{43D}\u{435} \u{44F}\u{432}\u{43B}\u{44F}\u{44E}\u{442}\u{441}\u{44F} \u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{43C}\u{438} \u{438} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{44E}\u{442}\u{441}\u{44F} \u{432} \u{432}\u{435}\u{440}\u{445}\u{43D}\u{435}\u{439} \u{447}\u{430}\u{441}\u{442}\u{438} \u{43A}\u{430}\u{436}\u{434}\u{43E}\u{439} ${entityType}.`,
    sm: (entityType)=>`O faatonuga e faitaliatia ma o le a faaali mai i le pito i luga o ${entityType} taitasi.`,
    so: (entityType)=>`Tilmaamaha waa optional oo ka soo muuqan doona ugu sareysa ${entityType} kasta.`,
    th: (entityType)=>`\u{E04}\u{E4D}\u{E32}\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E17}\u{E32}\u{E07}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E41}\u{E25}\u{E30}\u{E08}\u{E30}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E17}\u{E35}\u{E48}\u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}\u{E02}\u{E2D}\u{E07}${entityType}`,
    ur: (entityType)=>`\u{6C1}\u{62F}\u{627}\u{6CC}\u{627}\u{62A} \u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{631}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{6C1}\u{631} ${entityType} \u{6A9}\u{6D2} \u{627}\u{648}\u{67E}\u{631}\u{6CC} \u{62D}\u{635}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: (entityType)=>`H\u{1B0}\u{1EDB}ng d\u{1EAB}n l\xe0 t\xf9y ch\u{1ECD}n v\xe0 s\u{1EBD} xu\u{1EA5}t hi\u{1EC7}n \u{1EDF} \u{111}\u{1EA7}u m\u{1ED7}i ${entityType}.`,
    "zh-hans": (entityType)=>`\u{8BF4}\u{660E}\u{662F}\u{53EF}\u{9009}\u{7684}\u{FF0C}\u{5C06}\u{663E}\u{793A}\u{5728}\u{6BCF}\u{4E2A} ${entityType}\u{7684}\u{9876}\u{90E8}\u{3002}`,
    "zh-hant": (entityType)=>`\u{8AAA}\u{660E}\u{662F}\u{53EF}\u{9078}\u{7684}\u{FF0C}\u{5C07}\u{986F}\u{793A}\u{5728}\u{6BCF}\u{500B} ${entityType}\u{7684}\u{9802}\u{90E8}\u{3002}`,
    en: (entityType)=>`Instructions are optional and will appear at the top of each ${entityType}.`
};
const $2868cc1235412e16$export$394c96a95e34e24a = {
    ar: (entityType)=>`\u{62A}\u{648}\u{641}\u{64A}\u{631} \u{62A}\u{639}\u{644}\u{64A}\u{645}\u{627}\u{62A} ${entityType}`,
    de: (entityType)=>`Geben ${entityType} Sie Aufgabenanweisungen`,
    es: (entityType)=>`Proporcionar instrucciones ${entityType}`,
    fa: (entityType)=>`\u{62F}\u{633}\u{62A}\u{648}\u{631}\u{627}\u{644}\u{639}\u{645}\u{644} ${entityType} \u{631}\u{627} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62F}\u{647}\u{6CC}\u{62F}`,
    fil: (entityType)=>`Magbigay ng mga tagubilin ${entityType}`,
    fr: (entityType)=>`Fournir des instructions sur ${entityType}`,
    hi: (entityType)=>`${entityType} \u{928}\u{93F}\u{930}\u{94D}\u{926}\u{947}\u{936} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: (entityType)=>`Bay ${entityType}`,
    it: (entityType)=>`Fornire istruzioni ${entityType}`,
    ja: (entityType)=>`${entityType}\u{306E}\u{6307}\u{793A}\u{3092}\u{63D0}\u{4F9B}\u{3059}\u{308B}`,
    ko: (entityType)=>`${entityType} \u{C9C0}\u{CE68} \u{C81C}\u{ACF5}`,
    mww: (entityType)=>`Npaj ${entityType}`,
    ps: (entityType)=>`\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} ${entityType}`,
    pt: (entityType)=>`Fornecer instru\xe7\xf5es ${entityType}`,
    "pt-pt": (entityType)=>`Fornecer instru\xe7\xf5es ${entityType}`,
    ru: (entityType)=>`\u{41F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{438}\u{43D}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{446}\u{438}\u{438} \u{43F}\u{43E} ${entityType}`,
    sm: (entityType)=>`Tuuina atu faatonuga ${entityType}`,
    so: (entityType)=>`Bixiya ${entityType}`,
    th: (entityType)=>`\u{E43}\u{E2B}\u{E49}\u{E04}\u{E4D}\u{E32}\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}${entityType}`,
    ur: (entityType)=>`${entityType} \u{6A9}\u{6CC} \u{6C1}\u{62F}\u{627}\u{6CC}\u{627}\u{62A} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (entityType)=>`Cung c\u{1EA5}p h\u{1B0}\u{1EDB}ng d\u{1EAB}n ${entityType}`,
    "zh-hans": (entityType)=>`\u{63D0}\u{4F9B} ${entityType} \u{8BF4}\u{660E}`,
    "zh-hant": (entityType)=>`\u{63D0}\u{4F9B} ${entityType} \u{8AAA}\u{660E}`,
    en: (entityType)=>`Provide ${entityType} instructions`
};
const $2868cc1235412e16$export$7452b9f476cd7d5e = {
    ar: `\u{645}\u{646}\u{638}\u{631}`,
    de: `Ansehen`,
    es: `Vista`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647}`,
    fil: `Tingnan`,
    fr: `Vue`,
    hi: `\u{926}\u{947}\u{916}\u{928}\u{93E}`,
    ht: `View`,
    it: `Vista`,
    ja: `\u{773A}\u{3081}\u{308B}`,
    ko: `\u{BCF4}\u{AE30}`,
    mww: `Saib`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Vista`,
    "pt-pt": `Vis\xe3o`,
    ru: `\u{412}\u{438}\u{434}`,
    sm: `Va'ai`,
    so: `View`,
    th: `\u{E17}\u{E34}\u{E27}\u{E17}\u{E31}\u{E28}\u{E19}\u{E4C}`,
    ur: `\u{645}\u{646}\u{638}\u{631}`,
    vi: `C\u{1EA3}nh`,
    "zh-hans": `\u{89C6}\u{56FE}`,
    "zh-hant": `\u{8996}\u{5716}`,
    en: `View`
};
const $2868cc1235412e16$export$dad4342a62c89f83 = {
    ar: `\u{62D}\u{631}\u{631}`,
    de: `Redigieren`,
    es: `Editar`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}`,
    fil: `Baguhin`,
    fr: `\xc9diter`,
    hi: `\u{938}\u{902}\u{92A}\u{93E}\u{926}\u{928} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Edit`,
    it: `Redigere`,
    ja: `\u{7DE8}\u{96C6}`,
    ko: `\u{D3B8}\u{C9D1}\u{D558}\u{B2E4}`,
    mww: `Edit`,
    ps: `\u{633}\u{645}\u{648}\u{646}`,
    pt: `Editar`,
    "pt-pt": `Editar`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Fa'asa'o`,
    so: `bedel`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}`,
    ur: `\u{62A}\u{62F}\u{648}\u{6CC}\u{646}`,
    vi: `Bi\xean t\u{1EAD}p`,
    "zh-hans": `\u{7F16}\u{8F91}`,
    "zh-hant": `\u{7DE8}\u{8F2F}`,
    en: `Edit`
};
const $2868cc1235412e16$export$6788e256fd63ddc4 = {
    ar: `\u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{627}\u{644}\u{62A}\u{639}\u{644}\u{64A}\u{642}`,
    de: `Kommentar aktualisieren`,
    es: `Comentario de actualizaci\xf3n`,
    fa: `\u{628}\u{647} \u{631}\u{648}\u{632} \u{631}\u{633}\u{627}\u{646}\u{6CC} \u{646}\u{638}\u{631}`,
    fil: `I-update ang komento`,
    fr: `Mettre \xe0 jour le commentaire`,
    hi: `\u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `K\xf2mant\xe8 Mizajou`,
    it: `Aggiorna commento`,
    ja: `\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{306E}\u{66F4}\u{65B0}`,
    ko: `\u{B313}\u{AE00} \u{C5C5}\u{B370}\u{C774}\u{D2B8}`,
    mww: `Hloov tshiab saib`,
    ps: `\u{62A}\u{627}\u{632}\u{647} \u{62A}\u{628}\u{635}\u{631}\u{647}`,
    pt: `Atualizar coment\xe1rio`,
    "pt-pt": `Atualizar coment\xe1rio`,
    ru: `\u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}`,
    sm: `Fa'afouina fa'amatalaga`,
    so: `Faallo cusub`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `\u{62A}\u{627}\u{632}\u{6C1} \u{62A}\u{631}\u{6CC}\u{646} \u{62A}\u{628}\u{635}\u{631}\u{6C1}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t b\xecnh lu\u{1EAD}n`,
    "zh-hans": `\u{66F4}\u{65B0}\u{8BC4}\u{8BBA}`,
    "zh-hant": `\u{66F4}\u{65B0}\u{8A55}\u{8AD6}`,
    en: `Update comment`
};
const $2868cc1235412e16$export$6ef445400e80da34 = {
    ar: `\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Organisatorische Aktivit\xe4ten`,
    es: `Actividades de la organizaci\xf3n`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Mga aktibidad ng organisasyon`,
    fr: `Activit\xe9s de l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Aktivite \xf2ganizasyon yo`,
    it: `Attivit\xe0 dell'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{6D3B}\u{52D5}`,
    ko: `\u{C870}\u{C9C1} \u{D65C}\u{B3D9}`,
    mww: `Koom haum kev ua ub no`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Atividades da organiza\xe7\xe3o`,
    "pt-pt": `Atividades da organiza\xe7\xe3o`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Gaoioiga a le faalapotopotoga`,
    so: `Hawlaha ururka`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{7EC4}\u{7EC7}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{7D44}\u{7E54}\u{6D3B}\u{52D5}`,
    en: `Organization activities`
};
const $2868cc1235412e16$export$55830664ab17444 = {
    ar: `\u{627}\u{644}\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644}`,
    de: `Details`,
    es: `Detalles`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A}`,
    fil: `Mga Detalye`,
    fr: `D\xe9tails`,
    hi: `\u{92C}\u{94D}\u{92F}\u{94C}\u{930}\u{93E}`,
    ht: `Detay`,
    it: `Dettagli`,
    ja: `\u{7D30}\u{90E8}`,
    ko: `\u{C138}\u{BD80} \u{C815}\u{BCF4}`,
    mww: `paub meej`,
    ps: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes`,
    "pt-pt": `Detalhes`,
    ru: `\u{41F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Auiliiliga`,
    so: `Details`,
    th: `\u{E23}\u{E32}\u{E22} \u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}`,
    ur: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `Chi ti\u{1EBF}t`,
    "zh-hans": `\u{8BE6}`,
    "zh-hant": `\u{8A73}`,
    en: `Details`
};
const $2868cc1235412e16$export$68070717ade7a84 = {
    ar: `\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{627}\u{634}\u{62A}\u{631}\u{627}\u{643}`,
    de: `Abmelden`,
    es: `Anular la suscripci\xf3n`,
    fa: `\u{644}\u{63A}\u{648} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9}`,
    fil: `Email Address *`,
    fr: `Se d\xe9sabonner`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Ab\xf2nman`,
    it: `Disiscrizione`,
    ja: `\u{914D}\u{4FE1}\u{505C}\u{6B62}`,
    ko: `\u{AD6C}\u{B3C5} \u{CDE8}\u{C18C}`,
    mww: `Unsubscribe`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Cancelar inscri\xe7\xe3o`,
    "pt-pt": `Cancelar inscri\xe7\xe3o`,
    ru: `\u{41E}\u{442}\u{43F}\u{438}\u{441}\u{430}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `Unsubscribe`,
    so: `Unsubscribe`,
    th: `\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}`,
    ur: `Unsubscribe`,
    vi: `H\u{1EE7}y \u{111}\u{103}ng k\xfd`,
    "zh-hans": `\u{53D6}\u{6D88}\u{8BA2}\u{9605}`,
    "zh-hant": `\u{53D6}\u{6D88}\u{8A02}\u{95B1}`,
    en: `Unsubscribe`
};
const $2868cc1235412e16$export$111b9e9b1ab035e9 = {
    ar: `\u{627}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Abonnieren`,
    es: `Subscribir`,
    fa: `\u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9}`,
    fil: `Email Address *`,
    fr: `S\u{2019}inscrire`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{947}\u{902}`,
    ht: `Ab\xf2nman`,
    it: `Abbonarsi`,
    ja: `\u{8CFC}\u{8AAD}\u{3059}\u{308B}`,
    ko: `\u{AD6C}\u{B3C5}\u{D558}\u{B2E4}`,
    mww: `Subscribe`,
    ps: `\u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628}`,
    pt: `Subscrever`,
    "pt-pt": `Subscrever`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44B}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `Lesitala`,
    so: `Subscribe`,
    th: `\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}`,
    ur: `\u{631}\u{6A9}\u{646}\u{6CC}\u{62A}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    "zh-hans": `\u{8BA2}\u{9605}`,
    "zh-hant": `\u{8A02}\u{95B1}`,
    en: `Subscribe`
};
const $2868cc1235412e16$export$60c7c9a86a4ee833 = {
    ar: `1 \u{645}\u{634}\u{627}\u{631}\u{643}`,
    de: `1 Teilnehmer`,
    es: `1 participante`,
    fa: `1 \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `1 kalahok`,
    fr: `1 participant`,
    hi: `1 \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940}`,
    ht: `1 patisipan`,
    it: `1 partecipante`,
    ja: `\u{53C2}\u{52A0}\u{8005}1\u{540D}`,
    ko: `\u{CC38}\u{AC00}\u{C790} 1\u{BA85}`,
    mww: `1 tus neeg tau txais kev pab`,
    ps: `1 \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: `1 participante`,
    "pt-pt": `1 participante`,
    ru: `1 \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}`,
    sm: `1 tagata auai`,
    so: `1 ka qaybgalayaasha`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21} 1 \u{E04}\u{E19}`,
    ur: `1 \u{634}\u{631}\u{6A9}\u{627}\u{621}`,
    vi: `1 ng\u{1B0}\u{1EDD}i tham gia`,
    "zh-hans": `1 \u{540D}\u{53C2}\u{4E0E}\u{8005}`,
    "zh-hant": `1 \u{540D}\u{53C3}\u{8207}\u{8005}`,
    en: `1 participant`
};
const $2868cc1235412e16$export$fadf449bba626fc1 = {
    ar: (count)=>`${count} \u{645}\u{634}\u{627}\u{631}\u{643}\u{64A}\u{646}`,
    de: (count)=>`${count} Teilnehmer`,
    es: (count)=>`${count} participantes`,
    fa: (count)=>`${count} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: (count)=>`${count} kalahok`,
    fr: (count)=>`${count} participants`,
    hi: (count)=>`${count} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{93F}\u{92F}\u{94B}\u{902}`,
    ht: (count)=>`${count} patisipan yo`,
    it: (count)=>`${count} partecipanti`,
    ja: (count)=>`${count} \u{540D}`,
    ko: (count)=>`${count} \u{BA85}`,
    mww: (count)=>`${count} cov neeg koom`,
    ps: (count)=>`${count} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}`,
    pt: (count)=>`${count} participantes`,
    "pt-pt": (count)=>`${count} participantes`,
    ru: (count)=>`${count} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: (count)=>`${count} tagata auai`,
    so: (count)=>`${count} ka qaybgalayaasha`,
    th: (count)=>`\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21} ${count} \u{E04}\u{E19}`,
    ur: (count)=>`${count} \u{634}\u{631}\u{6A9}\u{627}\u{621}`,
    vi: (count)=>`${count} ng\u{1B0}\u{1EDD}i tham gia`,
    "zh-hans": (count)=>`${count} \u{540D}\u{53C2}\u{4E0E}\u{8005}`,
    "zh-hant": (count)=>`${count} \u{540D}\u{53C3}\u{8207}\u{8005}`,
    en: (count)=>`${count} participants`
};
const $2868cc1235412e16$export$a07a7cb78e70dc7 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{644}\u{627} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{628}\u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten keine Benachrichtigungen f\xfcr diese ${type}.`,
    es: (type)=>`No recibes notificaciones de esta ${type}.`,
    fa: (type)=>`\u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} ${type} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (type)=>`Hindi ka nakakatanggap ng mga abiso para sa ${type} na ito.`,
    fr: (type)=>`Vous ne recevez pas de notifications pour cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} ${type}.`,
    ht: (type)=>`Ou pa resevwa notifikasyon pou ${type} sa a.`,
    it: (type)=>`Non ricevi notifiche per questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{306B}\u{95A2}\u{3059}\u{308B}\u{901A}\u{77E5}\u{306F}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{B300}\u{D55C} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tsis tau txais ntawv ceeb toom rau ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{62F}\u{6D0} ${type} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{646}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626}.`,
    pt: (type)=>`Voc\xea n\xe3o est\xe1 recebendo notifica\xe7\xf5es para esta ${type}.`,
    "pt-pt": (type)=>`Voc\xea n\xe3o est\xe1 recebendo notifica\xe7\xf5es sobre essa ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43D}\u{435} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{431} \u{44D}\u{442}\u{43E}\u{43C} ${type}.`,
    sm: (type)=>`E te le o mauaina ni faasilasilaga mo lenei ${type}`,
    so: (type)=>`Adigu ma hesho ogeysiisyo ku saabsan ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} ${type} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n kh\xf4ng nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\u{1EC1} ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{6CA1}\u{6709}\u{6536}\u{5230}\u{6B64} ${type}\u{7684}\u{901A}\u{77E5}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{6C92}\u{6709}\u{6536}\u{5230}\u{6B64} ${type}\u{7684}\u{901A}\u{77E5}\u{3002}`,
    en: (type)=>`You're not receiving notifications for this ${type}.`
};
const $2868cc1235412e16$export$870104d5b672042c = {
    ar: (type)=>`\u{644}\u{627} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{628}\u{647}\u{630}\u{627} ${type} \u{644}\u{623}\u{646}\u{643} \u{642}\u{645}\u{62A} \u{628}\u{625}\u{644}\u{63A}\u{627}\u{621} \u{627}\u{644}\u{627}\u{634}\u{62A}\u{631}\u{627}\u{643}.`,
    de: (type)=>`Sie erhalten keine Benachrichtigungen f\xfcr diese ${type} , da Sie sich abgemeldet haben.`,
    es: (type)=>`No recibes notificaciones de esta ${type} porque has cancelado la suscripci\xf3n.`,
    fa: (type)=>`\u{628}\u{647} \u{62F}\u{644}\u{6CC}\u{644} \u{644}\u{63A}\u{648} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9}\u{60C} \u{627}\u{639}\u{644}\u{627}\u{646} \u{647}\u{627}\u{6CC}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} ${type} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (type)=>`Hindi ka nakakatanggap ng mga abiso para sa ${type} na ito dahil nag-unsubscribe ka.`,
    fr: (type)=>`Vous ne recevez pas de notifications pour cette ${type} , car vous vous \xeates d\xe9sabonn\xe9.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938} ${type} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{928}\u{94B}\u{91F}\u{93F}\u{92B}\u{93C}\u{93F}\u{915}\u{947}\u{936}\u{928} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{91B}\u{94B}\u{921}\u{93C} \u{926}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`Ou pa resevwa notifikasyon pou ${type} sa a paske ou pa respekte.`,
    it: (type)=>`Non ricevi notifiche per questa ${type} perch\xe9 hai annullato l'iscrizione.`,
    ja: (type)=>`\u{767B}\u{9332}\u{3092}\u{89E3}\u{9664}\u{3057}\u{305F}\u{305F}\u{3081}\u{3001}\u{3053}\u{306E} ${type} \u{306B}\u{95A2}\u{3059}\u{308B}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (type)=>`\u{AD6C}\u{B3C5}\u{C744} \u{CDE8}\u{C18C}\u{D588}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C774} ${type} \u{B300}\u{D55C} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{C9C0} \u{BABB}\u{D558}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tsis tau txais ntawv ceeb toom rau ${type} no vim hais tias koj unsubscribed.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{62F}\u{6D0} ${type} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{646}\u{647} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{6AB}\u{689}\u{648}\u{646} \u{646}\u{647} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea n\xe3o est\xe1 recebendo notifica\xe7\xf5es para esta ${type} porque cancelou a assinatura.`,
    "pt-pt": (type)=>`N\xe3o est\xe1 a receber notifica\xe7\xf5es para esta ${type} porque cancelou a subscri\xe7\xe3o.`,
    ru: (type)=>`\u{412}\u{44B} \u{43D}\u{435} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{43E}\u{431} \u{44D}\u{442}\u{43E}\u{43C} ${type} , \u{442}\u{430}\u{43A} \u{43A}\u{430}\u{43A} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{43B}\u{438} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{43A}\u{443}.`,
    sm: (type)=>`E te le mauaina ni faasilasilaga mo lenei ${type} ona ua e le lesitalaina.`,
    so: (type)=>`Adigu ma helaysid ogeysiisyo ${type} sababtoo ah waxaad ka shaqaynaysid si aan la qori karin.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A} ${type} \u{E19}\u{E35}\u{E49}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E23}\u{E31}\u{E1A}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} ${type} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n kh\xf4ng nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\u{1EC1} ${type} n\xe0y v\xec b\u{1EA1}n \u{111}\xe3 h\u{1EE7}y \u{111}\u{103}ng k\xfd.`,
    "zh-hans": (type)=>`\u{7531}\u{4E8E}\u{60A8}\u{53D6}\u{6D88}\u{8BA2}\u{9605}\u{FF0C}\u{60A8}\u{6CA1}\u{6709}\u{6536}\u{5230}\u{6B64} ${type} \u{7684}\u{901A}\u{77E5}\u{3002}`,
    "zh-hant": (type)=>`\u{7531}\u{65BC}\u{60A8}\u{53D6}\u{6D88}\u{8A02}\u{95B1}\u{FF0C}\u{60A8}\u{6C92}\u{6709}\u{6536}\u{5230}\u{6B64} ${type} \u{7684}\u{901A}\u{77E5}\u{3002}`,
    en: (type)=>`You're not receiving notifications for this ${type} because you unsubscribed.`
};
const $2868cc1235412e16$export$a34bc0eefd7e0f6 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{627}\u{634}\u{62A}\u{631}\u{643}\u{62A} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie diese ${type} abonniert haben.`,
    es: (type)=>`Recibes notificaciones porque te has suscrito a esta ${type}.`,
    fa: (type)=>`\u{628}\u{647} \u{627}\u{6CC}\u{646} \u{62F}\u{644}\u{6CC}\u{644} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil nag-subscribe ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous vous \xeates abonn\xe9 \xe0 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{907}\u{938} ${type} \u{915}\u{940} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske w enskri nan ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 ti sei iscritto a questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{3092}\u{8CFC}\u{8AAD}\u{3057}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{AC00}\u{C785}\u{D588}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim hais tias koj subscribed rau ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{67E}\u{647} \u{62F}\u{6D0} ${type} \u{6A9}\u{6D0} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{693}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque se inscreveu nessa ${type}.`,
    "pt-pt": (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque subscreveu esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43B}\u{438}\u{441}\u{44C} \u{43D}\u{430} \u{44D}\u{442}\u{43E} ${type}.`,
    sm: (type)=>`O lo'o e mauaina fa'asilasilaga ona ua e lesitala i lenei ${type}.`,
    so: (type)=>`Waxaa kuu imaanaya ogeysiisyo sababtoo ah waxaad subscribed to ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{627}\u{633} ${type} \u{6A9}\u{648} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec \u{111}\xe3 \u{111}\u{103}ng k\xfd ho\u{1EA1}t ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{4E4B}\u{6240}\u{4EE5}\u{6536}\u{5230}\u{901A}\u{77E5}\u{FF0C}\u{662F}\u{56E0}\u{4E3A}\u{60A8}\u{8BA2}\u{9605}\u{4E86}\u{6B64} ${type}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{4E4B}\u{6240}\u{4EE5}\u{6536}\u{5230}\u{901A}\u{77E5}\u{FF0C}\u{662F}\u{56E0}\u{70BA}\u{60A8}\u{8A02}\u{95B1}\u{4E86}\u{6B64} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you subscribed to this ${type}.`
};
const $2868cc1235412e16$export$d1d1e7344faf74a9 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{623}\u{646}\u{634}\u{623}\u{62A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie diese ${type} erstellt haben.`,
    es: (type)=>`Recibes notificaciones porque has creado esta ${type}.`,
    fa: (type)=>`\u{628}\u{647} \u{627}\u{6CC}\u{646} \u{62F}\u{644}\u{6CC}\u{644} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} ${type} \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil nilikha mo ang ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications car vous avez cr\xe9\xe9 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{92F}\u{939} ${type} \u{92C}\u{928}\u{93E}\u{908} \u{939}\u{948}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske ou te kreye ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 hai creato questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{3092}\u{4F5C}\u{6210}\u{3057}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{B9CC}\u{B4E4}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim hais tias koj tsim ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62F}\u{627} ${type} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque criou essa ${type}.`,
    "pt-pt": (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque criou esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43B}\u{438} \u{44D}\u{442}\u{43E} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa e fatuina lenei ${type}.`,
    so: (type)=>`Waxaad helaysaa ogeysiisyo sababtoo ah waxaad abuurtay ${type} this.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{6CC}\u{6C1} ${type} \u{628}\u{646}\u{627}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 t\u{1EA1}o ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{4E4B}\u{6240}\u{4EE5}\u{6536}\u{5230}\u{901A}\u{77E5}\u{FF0C}\u{662F}\u{56E0}\u{4E3A}\u{60A8}\u{521B}\u{5EFA}\u{4E86}\u{6B64} ${type}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{4E4B}\u{6240}\u{4EE5}\u{6536}\u{5230}\u{901A}\u{77E5}\u{FF0C}\u{662F}\u{56E0}\u{70BA}\u{60A8}\u{5275}\u{5EFA}\u{4E86}\u{6B64} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you created this ${type}.`
};
const $2868cc1235412e16$export$a9564ee2df9884f7 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{639}\u{644}\u{627}\u{645}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{647} \u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646} \u{647}\u{630}\u{627} ${type} \u{644}\u{643}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Ihnen diese ${type} zugewiesen wurde.`,
    es: (type)=>`Recibes notificaciones porque se te asign\xf3 esta ${type}.`,
    fa: (type)=>`\u{628}\u{647} \u{627}\u{6CC}\u{646} \u{62F}\u{644}\u{6CC}\u{644} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} ${type} \u{628}\u{647} \u{634}\u{645}\u{627} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil naatasan ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications car cette ${type} vous a \xe9t\xe9 attribu\xe9e.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{901} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{915}\u{94B} \u{92F}\u{939} ${type} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{940} \u{917}\u{908} \u{925}\u{940}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske ou te ${type} sa a.`,
    it: (type)=>`Si ricevono notifiche perch\xe9 ${type} \xe8 stata assegnata.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{304C}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{D560}\u{B2F9}\u{B418}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim hais tias koj tau raug xa mus ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62A}\u{647} \u{62F}\u{627} ${type} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque recebeu essa ${type}.`,
    "pt-pt": (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque lhe foi atribu\xedda esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{432}\u{430}\u{43C} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43E} \u{44D}\u{442}\u{43E} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa tofia oe i lenei ${type}`,
    so: (type)=>`Waxaa laguu ogaysiinayaa sababtoo ah waxaa laguu xil saaray ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{6A9}\u{648} \u{6CC}\u{6C1} ${type} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62A}\u{6BE}\u{6CC}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{60A8}\u{88AB}\u{5206}\u{914D}\u{4E86}\u{6B64} ${type}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{60A8}\u{88AB}\u{5206}\u{914D}\u{4E86}\u{6B64} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you were assigned this ${type}.`
};
const $2868cc1235412e16$export$3f7a9c0c6b45d6d2 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{639}\u{644}\u{642}\u{62A} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie diese ${type} kommentiert haben.`,
    es: (type)=>`Recibes notificaciones porque has comentado esta ${type}.`,
    fa: (type)=>`\u{628}\u{647} \u{627}\u{6CC}\u{646} \u{62F}\u{644}\u{6CC}\u{644} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{62F}\u{631}\u{628}\u{627}\u{631}\u{647} \u{627}\u{6CC}\u{646} ${type} \u{646}\u{638}\u{631} \u{62F}\u{627}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil nagkomento ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications parce que vous avez comment\xe9 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{907}\u{938} ${type} \u{92A}\u{930} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{915}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske w ap ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 hai commentato questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{306B}\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{3057}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{B313}\u{AE00}\u{C744} \u{B2EC}\u{C558}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim hais tias koj commented rau ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62F} \u{62F}\u{6D0} ${type} \u{67E}\u{647} \u{627}\u{693}\u{647} \u{62A}\u{628}\u{635}\u{631}\u{647} \u{6A9}\u{693}\u{6D0} \u{62F}\u{647}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque comentou sobre essa ${type}.`,
    "pt-pt": (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque comentou esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43E}\u{441}\u{442}\u{430}\u{432}\u{438}\u{43B}\u{438} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439} \u{43A} \u{44D}\u{442}\u{43E}\u{43C}\u{443} ${type}.`,
    sm: (type)=>`O lo'o e mauaina ni fa'asilasilaga ona ua e fa'amatalaina lenei ${type}.`,
    so: (type)=>`Waxaa laguu ogaysiiyay wargaysyo sababtoo ah waxaad ka ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{627}\u{633} ${type} \u{67E}\u{631} \u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{6A9}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 nh\u{1EAD}n x\xe9t v\u{1EC1} ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{4E4B}\u{6240}\u{4EE5}\u{6536}\u{5230}\u{901A}\u{77E5}\u{FF0C}\u{662F}\u{56E0}\u{4E3A}\u{60A8}\u{5BF9}\u{6B64} ${type}\u{53D1}\u{8868}\u{4E86}\u{8BC4}\u{8BBA}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{4E4B}\u{6240}\u{4EE5}\u{6536}\u{5230}\u{901A}\u{77E5}\u{FF0C}\u{662F}\u{56E0}\u{70BA}\u{60A8}\u{5C0D}\u{6B64} ${type}\u{767C}\u{8868}\u{4E86}\u{8A55}\u{8AD6}\u{3002}`,
    en: (type)=>`You're receiving notifications because you commented on this ${type}.`
};
const $2868cc1235412e16$export$d5792a6242510aa5 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{647} \u{62A}\u{645}\u{62A} \u{627}\u{644}\u{625}\u{634}\u{627}\u{631}\u{629} \u{625}\u{644}\u{64A}\u{643} \u{645}\u{628}\u{627}\u{634}\u{631}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie in dieser ${type} direkt erw\xe4hnt wurden.`,
    es: (type)=>`Recibes notificaciones porque se te ha mencionado directamente en esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{647}\u{627}\u{6CC}\u{6CC} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{632}\u{6CC}\u{631}\u{627} \u{645}\u{633}\u{62A}\u{642}\u{6CC}\u{645}\u{627} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{627}\u{632} \u{634}\u{645}\u{627} \u{646}\u{627}\u{645} \u{628}\u{631}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil direktang binanggit ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications car vous avez \xe9t\xe9 directement mentionn\xe9 dans cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{907}\u{938} ${type} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{93E} \u{938}\u{940}\u{927}\u{947} \u{924}\u{94C}\u{930} \u{92A}\u{930} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske ou te dir\xe8kteman mansyone nan ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 sei stato menzionato direttamente in questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{3067}\u{76F4}\u{63A5}\u{30E1}\u{30F3}\u{30B7}\u{30E7}\u{30F3}\u{3055}\u{308C}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type}\u{C5D0}\u{C11C} \u{C9C1}\u{C811} \u{C5B8}\u{AE09}\u{B418}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim hais tias koj tau ncaj qha mus hais nyob rau hauv ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{67E}\u{647} \u{645}\u{633}\u{62A}\u{642}\u{6CC}\u{645} \u{689}\u{648}\u{644} \u{67E}\u{647} \u{62F}\u{6D0} ${type} \u{6A9}\u{6D0} \u{630}\u{6A9}\u{631} \u{634}\u{648}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque foi mencionado diretamente nesta ${type}.`,
    "pt-pt": (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque foi mencionado diretamente nesta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{432}\u{430}\u{441} \u{43F}\u{440}\u{44F}\u{43C}\u{43E} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{43B}\u{438} \u{432} \u{44D}\u{442}\u{43E}\u{43C} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa ta'ua sa'o lava oe i lenei ${type}`,
    so: (type)=>`Waxaa lagaa helayaa ogeysiisyo sababtoo ah waxaa si toos ah laguugu sheegay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E04}\u{E38}\u{E13}\u{E42}\u{E14}\u{E22}\u{E15}\u{E23}\u{E07}\u{E43}\u{E19} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{648}\u{635}\u{648}\u{644} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} ${type} \u{645}\u{6CC}\u{6BA} \u{628}\u{631}\u{627}\u{6C1} \u{631}\u{627}\u{633}\u{62A} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p tr\u{1EF1}c ti\u{1EBF}p trong ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{6B64} ${type}\u{4E2D}\u{76F4}\u{63A5}\u{63D0}\u{5230}\u{4E86}\u{60A8}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{6B64} ${type}\u{4E2D}\u{76F4}\u{63A5}\u{63D0}\u{5230}\u{4E86}\u{60A8}\u{3002}`,
    en: (type)=>`You're receiving notifications because you were directly mentioned in this ${type}.`
};
const $2868cc1235412e16$export$cc74ec0e2bf1c390 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{642}\u{645}\u{62A} \u{628}\u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie diese ${type} aktualisiert haben.`,
    es: (type)=>`Recibes notificaciones porque has actualizado esta ${type}.`,
    fa: (type)=>`\u{628}\u{647} \u{627}\u{6CC}\u{646} \u{62F}\u{644}\u{6CC}\u{644} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} ${type} \u{631}\u{627} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga notification dahil na-update mo ang ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications car vous avez mis \xe0 jour cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{92F}\u{939} ${type} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske w mete ajou ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 hai aggiornato questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{3092}\u{66F4}\u{65B0}\u{3057}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{D588}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim hais tias koj muab kho ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62F}\u{627} ${type} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque atualizou essa ${type}.`,
    "pt-pt": (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque atualizou esta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{43B}\u{438} \u{44D}\u{442}\u{43E} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona ua e faafouina lenei ${type}.`,
    so: (type)=>`Waxaa laguu ogaysiiyay ogeysiisyo sababtoo ah waxaad ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15} ${type}\u{E19}\u{E35}\u{E49}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{646}\u{6D2} \u{627}\u{633} ${type} \u{6A9}\u{648} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 c\u{1EAD}p nh\u{1EAD}t ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{60A8}\u{66F4}\u{65B0}\u{4E86}\u{6B64} ${type}\u{8BB0}\u{5F55}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{60A8}\u{66F4}\u{65B0}\u{4E86}\u{6B64} ${type}\u{8A18}\u{9304}\u{3002}`,
    en: (type)=>`You're receiving notifications because you updated this ${type}.`
};
const $2868cc1235412e16$export$94b61b888e588ac2 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{639}\u{644}\u{627}\u{645}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{647} \u{62A}\u{645} \u{630}\u{643}\u{631} \u{641}\u{631}\u{64A}\u{642} \u{623}\u{646}\u{62A} \u{639}\u{636}\u{648} \u{641}\u{64A}\u{647} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil ein Team, in dem Sie Mitglied sind, in dieser ${type} erw\xe4hnt wurde.`,
    es: (type)=>`Recibes notificaciones porque un equipo del que eres miembro se mencion\xf3 en esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{647}\u{627}\u{6CC}\u{6CC} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{632}\u{6CC}\u{631}\u{627} \u{62A}\u{6CC}\u{645}\u{6CC} \u{6A9}\u{647} \u{639}\u{636}\u{648} \u{622}\u{646} \u{647}\u{633}\u{62A}\u{6CC}\u{62F} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil ang isang koponan na iyong kinabibilangan ay binanggit sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications car une \xe9quipe dont vous \xeates membre a \xe9t\xe9 mentionn\xe9e dans cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{901} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{907}\u{938} ${type} \u{92E}\u{947}\u{902} \u{909}\u{938} \u{91F}\u{940}\u{92E} \u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E} \u{91C}\u{93F}\u{938}\u{915}\u{947} \u{906}\u{92A} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{939}\u{948}\u{902}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske yon ekip ou se yon manm nan te mansyone nan ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 un team di cui fai parte \xe8 stato menzionato in questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{3067}\u{81EA}\u{5206}\u{304C}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3067}\u{3042}\u{308B}\u{30C1}\u{30FC}\u{30E0}\u{304C}\u{30E1}\u{30F3}\u{30B7}\u{30E7}\u{30F3}\u{3055}\u{308C}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C0AC}\u{C6A9}\u{C790}\u{AC00} \u{AD6C}\u{C131}\u{C6D0}\u{C778} \u{D300}\u{C774} \u{C774} ${type}\u{C5D0}\u{C11C} \u{C5B8}\u{AE09}\u{B418}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim ib pab neeg uas koj nyob nraum ib tug nyob hauv ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62F} \u{647}\u{63A}\u{647} \u{67C}\u{6CC}\u{645} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{6CC}\u{6D0} \u{63A}\u{693}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A} \u{67E}\u{647} \u{62F}\u{6D0} ${type} \u{6A9}\u{6D0} \u{630}\u{6A9}\u{631} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque uma equipe da qual voc\xea \xe9 membro foi mencionada nesta ${type}.`,
    "pt-pt": (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque uma equipa da qual \xe9 membro foi mencionada nesta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430}, \u{432} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{439} \u{432}\u{44B} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{438}\u{442}\u{435}, \u{431}\u{44B}\u{43B}\u{430} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442}\u{430} \u{432} \u{44D}\u{442}\u{43E}\u{43C} ${type}.`,
    sm: (type)=>`O lo'o e mauaina ni fa'asilasilaga ona o se 'au o oe o se sui na ta'ua i lenei ${type}.`,
    so: (type)=>`Waxaa laguu ogaysiinayaa sababtoo ah koox aad xubin ka tahay ayaa lagu sheegay ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E17}\u{E35}\u{E21}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E43}\u{E19}${type}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{627}\u{633} ${type} \u{645}\u{6CC}\u{6BA} \u{62C}\u{633} \u{679}\u{6CC}\u{645} \u{6A9}\u{627} \u{622}\u{67E} \u{631}\u{6A9}\u{646} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{633} \u{6A9}\u{627} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec m\u{1ED9}t nh\xf3m m\xe0 b\u{1EA1}n l\xe0 th\xe0nh vi\xean \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{6B64} ${type}\u{4E2D}\u{63D0}\u{5230}\u{4E86}\u{60A8}\u{6240}\u{5C5E}\u{7684}\u{56E2}\u{961F}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{6B64} ${type}\u{4E2D}\u{63D0}\u{5230}\u{4E86}\u{60A8}\u{6240}\u{5C6C}\u{7684}\u{5718}\u{968A}\u{3002}`,
    en: (type)=>`You're receiving notifications because a team you're a member of was mentioned in this ${type}.`
};
const $2868cc1235412e16$export$9e80186c98919fd3 = {
    ar: (type)=>`\u{623}\u{646}\u{62A} \u{62A}\u{62A}\u{644}\u{642}\u{649} \u{625}\u{634}\u{639}\u{627}\u{631}\u{627}\u{62A} \u{644}\u{623}\u{646}\u{643} \u{627}\u{634}\u{62A}\u{631}\u{643}\u{62A} \u{62A}\u{644}\u{642}\u{627}\u{626}\u{64A}\u{627} \u{641}\u{64A} \u{647}\u{630}\u{627} ${type}.`,
    de: (type)=>`Sie erhalten Benachrichtigungen, weil Sie diese ${type} automatisch abonniert haben.`,
    es: (type)=>`Recibes notificaciones porque te has suscrito autom\xe1ticamente a esta ${type}.`,
    fa: (type)=>`\u{634}\u{645}\u{627} \u{627}\u{639}\u{644}\u{627}\u{646} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{632}\u{6CC}\u{631}\u{627} \u{628}\u{647} \u{637}\u{648}\u{631} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631} \u{62F}\u{631} \u{627}\u{6CC}\u{646} ${type} \u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{634}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: (type)=>`Tumatanggap ka ng mga abiso dahil awtomatikong naka-subscribe ka sa ${type} na ito.`,
    fr: (type)=>`Vous recevez des notifications car vous avez \xe9t\xe9 automatiquement abonn\xe9 \xe0 cette ${type}.`,
    hi: (type)=>`\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{942}\u{91A}\u{928}\u{93E}\u{90F}\u{902} \u{907}\u{938}\u{932}\u{93F}\u{90F} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{94B}\u{902}\u{915}\u{93F} \u{906}\u{92A}\u{928}\u{947} \u{907}\u{938} ${type} \u{915}\u{940} \u{905}\u{92A}\u{928}\u{947} \u{906}\u{92A} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{947} \u{932}\u{940} \u{939}\u{948}.`,
    ht: (type)=>`W ap resevwa notifikasyon paske ou te otomatikman enskri nan ${type} sa a.`,
    it: (type)=>`Stai ricevendo notifiche perch\xe9 sei stato automaticamente iscritto a questa ${type}.`,
    ja: (type)=>`\u{3053}\u{306E} ${type}\u{306B}\u{81EA}\u{52D5}\u{7684}\u{306B}\u{767B}\u{9332}\u{3055}\u{308C}\u{305F}\u{305F}\u{3081}\u{3001}\u{901A}\u{77E5}\u{304C}\u{5C4A}\u{3044}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (type)=>`\u{C774} ${type} \u{C790}\u{B3D9}\u{C73C}\u{B85C} \u{AC00}\u{C785}\u{B418}\u{C5C8}\u{AE30} \u{B54C}\u{BB38}\u{C5D0} \u{C54C}\u{B9BC}\u{C744} \u{BC1B}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`Koj nyob nraum tau txais ntawv ceeb toom vim hais tias koj twb tau subscribed rau ${type} no.`,
    ps: (type)=>`\u{62A}\u{627}\u{633}\u{648} \u{62E}\u{628}\u{631}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{626} \u{681}\u{6A9}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{67E}\u{647} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{62A} \u{689}\u{648}\u{644} \u{62F} \u{62F}\u{6D0} ${type} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{634}\u{648}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}.`,
    pt: (type)=>`Voc\xea est\xe1 recebendo notifica\xe7\xf5es porque foi inscrito automaticamente nessa ${type}.`,
    "pt-pt": (type)=>`Est\xe1 a receber notifica\xe7\xf5es porque foi automaticamente inscrito nesta ${type}.`,
    ru: (type)=>`\u{412}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{442}\u{435} \u{443}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}, \u{43F}\u{43E}\u{442}\u{43E}\u{43C}\u{443} \u{447}\u{442}\u{43E} \u{431}\u{44B}\u{43B}\u{438} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{44B} \u{43D}\u{430} \u{44D}\u{442}\u{43E} ${type}.`,
    sm: (type)=>`O loo e mauaina ni faasilasilaga ona sa otometi lava ona e lesitala i lenei ${type}`,
    so: (type)=>`Waxaa laguu ogaysiiyay ogeysiisyo sababtoo ah si toos ah ayaa loogu qoray ${type}.`,
    th: (type)=>`\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19} ${type}\u{E19}\u{E35}\u{E49}\u{E42}\u{E14}\u{E22}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: (type)=>`\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{648}\u{646}\u{6A9}\u{6C1} \u{622}\u{67E} \u{62E}\u{648}\u{62F} \u{628}\u{62E}\u{648}\u{62F} \u{627}\u{633} ${type} \u{645}\u{6CC}\u{6BA} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6C1}\u{648} \u{6AF}\u{626}\u{6D2} \u{62A}\u{6BE}\u{6D2}\u{6D4}`,
    vi: (type)=>`B\u{1EA1}n \u{111}ang nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c th\xf4ng b\xe1o v\xec b\u{1EA1}n \u{111}\xe3 t\u{1EF1} \u{111}\u{1ED9}ng \u{111}\u{103}ng k\xfd ho\u{1EA1}t ${type} n\xe0y.`,
    "zh-hans": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{4E3A}\u{60A8}\u{5DF2}\u{81EA}\u{52A8}\u{8BA2}\u{9605}\u{6B64} ${type}\u{3002}`,
    "zh-hant": (type)=>`\u{60A8}\u{6536}\u{5230}\u{901A}\u{77E5}\u{662F}\u{56E0}\u{70BA}\u{60A8}\u{5DF2}\u{81EA}\u{52D5}\u{8A02}\u{95B1}\u{6B64} ${type}\u{3002}`,
    en: (type)=>`You're receiving notifications because you were automatically subscribed to this ${type}.`
};
const $2868cc1235412e16$export$d3bf1e6107f4313 = {
    ar: `\u{625}\u{63A}\u{644}\u{627}\u{642} \u{627}\u{644}\u{62A}\u{62D}\u{631}\u{64A}\u{631}`,
    de: `Bearbeiten schlie\xdfen`,
    es: `Cerrar edici\xf3n`,
    fa: `\u{628}\u{633}\u{62A}\u{646} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}`,
    fil: `Isara ang pag-edit`,
    fr: `Fermer modifier`,
    hi: `\u{92C}\u{902}\u{926} \u{915}\u{930}\u{947}\u{902} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit f\xe8men`,
    it: `Chiudi modifica`,
    ja: `\u{7DE8}\u{96C6}\u{3092}\u{9589}\u{3058}\u{308B}`,
    ko: `\u{D3B8}\u{C9D1} \u{B2EB}\u{AE30}`,
    mww: `Kaw edit`,
    ps: `\u{633}\u{645}\u{648}\u{646} \u{631}\u{627} \u{628}\u{646}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    pt: `Fechar edi\xe7\xe3o`,
    "pt-pt": `Fechar edi\xe7\xe3o`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Tapunia faasa'oga`,
    so: `Edit Close`,
    th: `\u{E1B}\u{E34}\u{E14}\u{E01}\u{E32}\u{E23}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}`,
    ur: `\u{642}\u{631}\u{6CC}\u{628}\u{6CC} \u{62A}\u{631}\u{645}\u{6CC}\u{645}`,
    vi: `\u{110}\xf3ng s\u{1EED}a \u{111}\u{1ED5}i`,
    "zh-hans": `\u{5173}\u{95ED}\u{7F16}\u{8F91}`,
    "zh-hant": `\u{95DC}\u{9589}\u{7DE8}\u{8F2F}`,
    en: `Close edit`
};
const $2868cc1235412e16$export$310250c811816278 = {
    ar: `\u{646}\u{639}\u{645}`,
    de: `Ja`,
    es: `S\xed`,
    fa: `\u{628}\u{644}\u{647}`,
    fil: `Oo`,
    fr: `Oui`,
    hi: `\u{939}\u{93E}\u{901}`,
    ht: `Wi`,
    it: `S\xec`,
    ja: `\u{306F}\u{3044}`,
    ko: `\u{C608}`,
    mww: `Muaj`,
    ps: `\u{628}\u{644}\u{6CC}`,
    pt: `Sim`,
    "pt-pt": `Sim`,
    ru: `\u{414}\u{430}`,
    sm: `Ioe`,
    so: `Haa`,
    th: `\u{E43}\u{E0A}\u{E48}`,
    ur: `\u{6C1}\u{627}\u{6BA}`,
    vi: `C\xf3`,
    "zh-hans": `\u{662F}\u{7684}`,
    "zh-hant": `\u{662F}\u{7684}`,
    en: `Yes`
};
const $2868cc1235412e16$export$9692d1a0658a3861 = {
    ar: `\u{644}\u{627}`,
    de: `Nein`,
    es: `No`,
    fa: `\u{646}\u{647}`,
    fil: `Hindi`,
    fr: `Non`,
    hi: `\u{928}\u{939}\u{940}\u{902}`,
    ht: `Non`,
    it: `No`,
    ja: `\u{3044}\u{3044}\u{3048}`,
    ko: `\u{C544}\u{B2C8}\u{C694}`,
    mww: `Tsis`,
    ps: `\u{646}\u{627}`,
    pt: `N\xe3o`,
    "pt-pt": `N\xe3o`,
    ru: `\u{41D}\u{435}\u{442}`,
    sm: `Leai`,
    so: `Maya`,
    th: `\u{E44}\u{E21}\u{E48}\u{E43}\u{E0A}\u{E48}`,
    ur: `\u{646}\u{6C1}\u{64A}\u{6BA}`,
    vi: `Kh\xf4ng`,
    "zh-hans": `\u{4E0D}`,
    "zh-hant": `\u{4E0D}`,
    en: `No`
};
const $2868cc1235412e16$export$433bde3ee140c661 = {
    ar: (label)=>`${label} \u{645}\u{637}\u{644}\u{648}\u{628}.`,
    de: (label)=>`${label} ist erforderlich.`,
    es: (label)=>`${label} es obligatorio.`,
    fa: (label)=>`${label} \u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC} \u{627}\u{633}\u{62A}.`,
    fil: (label)=>`Kinakailangan ang ${label}.`,
    fr: (label)=>`${label} est obligatoire.`,
    hi: (label)=>`${label} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948}.`,
    ht: (label)=>`${label} obligatwa.`,
    it: (label)=>`${label} \xe8 obbligatorio.`,
    ja: (label)=>`${label} \u{306F}\u{5FC5}\u{9808}\u{3067}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{D544}\u{C218} \u{D56D}\u{BAA9}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum muaj.`,
    ps: (label)=>`${label} \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC}.`,
    pt: (label)=>`${label} \xe9 obrigat\xf3rio.`,
    "pt-pt": (label)=>`${label} \xe9 obrigat\xf3rio.`,
    ru: (label)=>`${label} \u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: (label)=>`E mana'omia le ${label}.`,
    so: (label)=>`${label} ayaa loo baahan yahay.`,
    th: (label)=>`\u{E15}\u{E49}\u{E2D}\u{E07}\u{E23}\u{E30}\u{E1A}\u{E38}${label}`,
    ur: (label)=>`${label} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{6D2}.`,
    vi: (label)=>`${label} l\xe0 b\u{1EAF}t bu\u{1ED9}c.`,
    "zh-hans": (label)=>`${label} \u{4E3A}\u{5FC5}\u{586B}\u{9879}\u{3002}`,
    "zh-hant": (label)=>`${label} \u{70BA}\u{5FC5}\u{586B}\u{9805}\u{3002}`,
    en: (label)=>`${label} is required.`
};
const $2868cc1235412e16$export$dd0340f9174b778 = {
    ar: (label)=>`${label} \u{628}\u{634}\u{643}\u{644} \u{63A}\u{64A}\u{631} \u{635}\u{62D}\u{64A}\u{62D}.`,
    de: (label)=>`${label} ist falsch formatiert.`,
    es: (label)=>`${label} tiene un formato incorrecto.`,
    fa: (label)=>`${label} \u{628}\u{647} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{642}\u{627}\u{644}\u{628} \u{628}\u{646}\u{62F}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (label)=>`Mali ang format ng ${label}.`,
    fr: (label)=>`${label} n\u{2019}est pas correct.`,
    hi: (label)=>`${label} \u{917}\u{93C}\u{932}\u{924} \u{938}\u{94D}\u{935}\u{930}\u{942}\u{92A}\u{93F}\u{924} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}.`,
    ht: (label)=>`${label} se k\xf2r\xe8kteman f\xf2ma.`,
    it: (label)=>`${label} non \xe8 formattato correttamente.`,
    ja: (label)=>`${label} \u{306E}\u{5F62}\u{5F0F}\u{304C}\u{6B63}\u{3057}\u{304F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} \u{D615}\u{C2DD}\u{C774} \u{C798}\u{BABB}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yog incorrectly formatted.`,
    ps: (label)=>`${label} \u{63A}\u{644}\u{637} \u{628}\u{6BC}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: (label)=>`${label} est\xe1 formatado incorretamente.`,
    "pt-pt": (label)=>`${label} est\xe1 formatado incorretamente.`,
    ru: (label)=>`${label} \u{43E}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43E} \u{43D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{43E}.`,
    sm: (label)=>`E le sa'o le ${label}.`,
    so: (label)=>`${label} si qaldan formatted.`,
    th: (label)=>`${label} \u{E16}\u{E39}\u{E01}\u{E08}\u{E31}\u{E14}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: (label)=>`${label} \u{63A}\u{644}\u{637} \u{641}\u{627}\u{631}\u{645}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1ECB}nh d\u{1EA1}ng kh\xf4ng ch\xednh x\xe1c.`,
    "zh-hans": (label)=>`${label} \u{683C}\u{5F0F}\u{4E0D}\u{6B63}\u{786E}\u{3002}`,
    "zh-hant": (label)=>`${label} \u{683C}\u{5F0F}\u{4E0D}\u{6B63}\u{78BA}\u{3002}`,
    en: (label)=>`${label} is incorrectly formatted.`
};
const $2868cc1235412e16$export$cd31f99195471735 = {
    ar: (label)=>`${label} \u{644}\u{627} \u{64A}\u{633}\u{645}\u{62D} \u{628}\u{627}\u{644}\u{643}\u{633}\u{648}\u{631}.`,
    de: (label)=>`${label} l\xe4sst keine Br\xfcche zu.`,
    es: (label)=>`${label} no admite fracciones.`,
    fa: (label)=>`${label} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{6A9}\u{633}\u{631}\u{6CC} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: (label)=>`Hindi pinapayagan ${label} ang mga fraction.`,
    fr: (label)=>`${label} n\u{2019}autorise pas les fractions.`,
    hi: (label)=>`${label} \u{92D}\u{93F}\u{928}\u{94D}\u{928}\u{94B}\u{902} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{926}\u{947}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (label)=>`${label} pa p\xe8m\xe8t fraksyon.`,
    it: (label)=>`${label} non consente frazioni.`,
    ja: (label)=>`${label} \u{306F}\u{5206}\u{6570}\u{3092}\u{8A31}\u{53EF}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} \u{C740} \u{BD84}\u{C218}\u{B97C} \u{D5C8}\u{C6A9}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} tsis pub muaj feem tau feem ( fractions).`,
    ps: (label)=>`${label} \u{62F} \u{6A9}\u{633}\u{631}\u{648}\u{646}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{6CC}.`,
    pt: (label)=>`${label} n\xe3o permite fra\xe7\xf5es.`,
    "pt-pt": (label)=>`${label} n\xe3o permite fra\xe7\xf5es.`,
    ru: (label)=>`${label} \u{43D}\u{435} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{43A}\u{430}\u{435}\u{442} \u{434}\u{440}\u{43E}\u{431}\u{435}\u{439}.`,
    sm: (label)=>`E le faatagaina e ${label} ni vaega ninii.`,
    so: (label)=>`${label} ma ogola in kala jajabku uu kala jajabku dhaco.`,
    th: (label)=>`${label} \u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E28}\u{E29}\u{E2A}\u{E48}\u{E27}\u{E19}`,
    ur: (label)=>`${label} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} cho ph\xe9p ph\xe2n s\u{1ED1}.`,
    "zh-hans": (label)=>`${label} \u{4E0D}\u{5141}\u{8BB8}\u{4F7F}\u{7528}\u{5206}\u{6570}\u{3002}`,
    "zh-hant": (label)=>`${label} \u{4E0D}\u{5141}\u{8A31}\u{4F7F}\u{7528}\u{5206}\u{6578}\u{3002}`,
    en: (label)=>`${label} does not permit fractions.`
};
const $2868cc1235412e16$export$b79fa817bdc814b1 = {
    ar: (label, step)=>`\u{64A}\u{62C}\u{628} ${label} \u{645}\u{646} \u{645}\u{636}\u{627}\u{639}\u{641}\u{627}\u{62A} ${step}`,
    de: (label, step)=>`${label} muss ein Vielfaches von ${step} sein`,
    es: (label, step)=>`${label} debe ser un m\xfaltiplo de ${step}`,
    fa: (label, step)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{636}\u{631}\u{628}\u{6CC} ${step} \u{628}\u{627}\u{634}\u{62F}`,
    fil: (label, step)=>`Ang ${label} ay dapat na maramihang ${step}`,
    fr: (label, step)=>`${label} doit \xeatre un multiple de ${step}`,
    hi: (label, step)=>`${label} ${step} \u{915}\u{93E} \u{917}\u{941}\u{923}\u{91C} \u{939}\u{94B}\u{928}\u{93E} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948}`,
    ht: (label, step)=>`${label} dwe yon miltip ${step}`,
    it: (label, step)=>`${label} deve essere un multiplo di ${step}`,
    ja: (label, step)=>`${label}\u{306F} ${step} \u{306E}\u{500D}\u{6570}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`,
    ko: (label, step)=>`${label} ${step}\u{C758} \u{BC30}\u{C218}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label, step)=>`${label} yuav tsum muaj ntau ${step}`,
    ps: (label, step)=>`\u{646}\u{648}\u{645} ${label} ${step} \u{636}\u{631}\u{628} \u{648}\u{6CC}`,
    pt: (label, step)=>`${label} deve ser um m\xfaltiplo de ${step}`,
    "pt-pt": (label, step)=>`${label} deve ser um m\xfaltiplo de ${step}`,
    ru: (label, step)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} ${step}`,
    sm: (label, step)=>`${label} e tatau ona i ai se numera o le ${step}`,
    so: (label, step)=>`${label} waa inuu noqdaa mid badan oo ${step} ah`,
    th: (label, step)=>`${label} \u{E40}\u{E1B}\u{E47}\u{E19}\u{E17}\u{E27}\u{E35}\u{E04}\u{E39}\u{E13}\u{E02}\u{E2D}\u{E07} ${step}`,
    ur: (label, step)=>`${label} ${step} \u{6A9}\u{627} \u{645}\u{644}\u{679}\u{6CC} \u{67E}\u{644} \u{6C1}\u{648}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}`,
    vi: (label, step)=>`${label} ph\u{1EA3}i l\xe0 b\u{1ED9}i s\u{1ED1} c\u{1EE7}a ${step}`,
    "zh-hans": (label, step)=>`${label}\u{5FC5}\u{987B}\u{662F} ${step} \u{7684}\u{500D}\u{6570}`,
    "zh-hant": (label, step)=>`${label}\u{5FC5}\u{9808}\u{662F} ${step} \u{7684}\u{500D}\u{6578}`,
    en: (label, step)=>`${label} must be a multiple of ${step}`
};
const $2868cc1235412e16$export$110dcc8e73edbe8a = {
    ar: (label)=>`\u{642}\u{62F} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${label} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{623}\u{648} \u{623}\u{631}\u{642}\u{627}\u{645} \u{623}\u{648} \u{648}\u{627}\u{635}\u{644}\u{627}\u{62A} \u{645}\u{641}\u{631}\u{62F}\u{629} \u{641}\u{642}\u{637}\u{60C} \u{648}\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{628}\u{62F}\u{623} \u{623}\u{648} \u{64A}\u{646}\u{62A}\u{647}\u{64A} \u{628}\u{648}\u{635}\u{644}\u{629}.`,
    de: (label)=>`${label} darf nur Buchstaben, Zahlen oder einzelne Bindestriche enthalten und darf nicht mit einem Bindestrich beginnen oder enden.`,
    es: (label)=>`${label} solo puede contener letras, n\xfameros o guiones simples, y no puede comenzar ni terminar con un gui\xf3n.`,
    fa: (label)=>`${label} \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{641}\u{642}\u{637} \u{634}\u{627}\u{645}\u{644} \u{62D}\u{631}\u{648}\u{641}\u{60C} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{6CC}\u{627} \u{62E}\u{637} \u{62A}\u{6CC}\u{631}\u{647} \u{628}\u{627}\u{634}\u{62F} \u{648} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{628}\u{627} \u{62E}\u{637} \u{641}\u{627}\u{635}\u{644}\u{647} \u{634}\u{631}\u{648}\u{639} \u{6CC}\u{627} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{6CC}\u{627}\u{628}\u{62F}.`,
    fil: (label)=>`${label} ay maaaring maglaman lamang ng mga titik, numero, o solong hyphen, at hindi maaaring magsimula o magtapos sa isang hyphen.`,
    fr: (label)=>`${label} ne peut contenir que des lettres, des chiffres ou des traits d\u{2019}union simples, et ne peut pas commencer ou se terminer par un trait d\u{2019}union.`,
    hi: (label)=>`${label} \u{92E}\u{947}\u{902} \u{915}\u{947}\u{935}\u{932} \u{905}\u{915}\u{94D}\u{937}\u{930}, \u{938}\u{902}\u{916}\u{94D}\u{92F}\u{93E}\u{90F}\u{901} \u{92F}\u{93E} \u{90F}\u{915}\u{932} \u{939}\u{93E}\u{907}\u{92B}\u{93C}\u{928} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}, \u{914}\u{930} \u{939}\u{93E}\u{907}\u{92B}\u{93C}\u{928} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{92F}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{947}.`,
    ht: (label)=>`${label} li ka s\xe8lman gen l\xe8t, nimewo, oswa yon s\xe8l tifi, epi yo pa ka k\xf2manse oswa fini ak yon tir\xe8.`,
    it: (label)=>`${label} pu\xf2 contenere solo lettere, numeri o singoli trattini e non pu\xf2 iniziare o terminare con un trattino.`,
    ja: (label)=>`${label} \u{306B}\u{306F}\u{3001}\u{6587}\u{5B57}\u{3001}\u{6570}\u{5B57}\u{3001}\u{307E}\u{305F}\u{306F}\u{5358}\u{4E00}\u{306E}\u{30CF}\u{30A4}\u{30D5}\u{30F3}\u{306E}\u{307F}\u{3092}\u{542B}\u{3081}\u{308B}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{3001}\u{30CF}\u{30A4}\u{30D5}\u{30F3}\u{3067}\u{958B}\u{59CB}\u{307E}\u{305F}\u{306F}\u{7D42}\u{4E86}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label)=>`${label} \u{C5D0}\u{B294} \u{BB38}\u{C790}, \u{C22B}\u{C790} \u{B610}\u{B294} \u{B2E8}\u{C77C} \u{D558}\u{C774}\u{D508}\u{B9CC} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C73C}\u{BA70} \u{D558}\u{C774}\u{D508}\u{C73C}\u{B85C} \u{C2DC}\u{C791}\u{D558}\u{AC70}\u{B098} \u{B05D}\u{B0A0} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsuas muaj cov ntawv, zauv, los yog ib zaug xwb hyphens, thiab tsis tau pib los yog xaus nrog ib hyphen.`,
    ps: (label)=>`${label} \u{6A9}\u{6CC}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{62A}\u{648}\u{631}\u{6CC}\u{60C} \u{627}\u{639}\u{62F}\u{627}\u{62F}\u{60C} \u{6CC}\u{627} \u{648}\u{627}\u{62D}\u{62F} \u{647}\u{627}\u{6CC}\u{641}\u{646} \u{648}\u{644}\u{631}\u{6CC}\u{60C} \u{627}\u{648} \u{67E}\u{647} \u{647}\u{627}\u{6CC}\u{641}\u{646} \u{633}\u{631}\u{647} \u{646}\u{647} \u{634}\u{6CC} \u{67E}\u{6CC}\u{644} \u{6CC}\u{627} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6CC}\u{696}\u{6CC}.`,
    pt: (label)=>`${label} pode conter apenas letras, n\xfameros ou h\xedfens simples e n\xe3o pode come\xe7ar ou terminar com um h\xedfen.`,
    "pt-pt": (label)=>`${label} s\xf3 pode conter letras, n\xfameros ou h\xedfenes \xfanicos, e n\xe3o pode come\xe7ar ou terminar com um h\xedfen.`,
    ru: (label)=>`${label} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{44B}, \u{446}\u{438}\u{444}\u{440}\u{44B} \u{438}\u{43B}\u{438} \u{43E}\u{434}\u{438}\u{43D}\u{430}\u{440}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{444}\u{438}\u{441}\u{44B} \u{438} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{438}\u{43B}\u{438} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{434}\u{435}\u{444}\u{438}\u{441}\u{43E}\u{43C}.`,
    sm: (label)=>`${label} e mafai ona na o mataitusi, fuainumera, po o vase se tasi, ma e le mafai ona amata pe faaiu i se vase upu.`,
    so: (label)=>`${label} wuxuu ku jiri karaa xarafaha, lambarada, ama xarfaha hal mar, mana ku bilaaban karo kumana dhamaan karo xarfaha xarfaha.`,
    th: (label)=>`${label} \u{E40}\u{E09}\u{E1E}\u{E32}\u{E30}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23} \u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E22}\u{E31}\u{E15}\u{E34}\u{E20}\u{E31}\u{E07}\u{E04}\u{E4C}\u{E15}\u{E31}\u{E27}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27} \u{E41}\u{E25}\u{E30}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E02}\u{E36}\u{E49}\u{E19}\u{E15}\u{E49}\u{E19}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E25}\u{E07}\u{E17}\u{E49}\u{E32}\u{E22}\u{E14}\u{E49}\u{E27}\u{E22}\u{E22}\u{E31}\u{E15}\u{E34}\u{E20}\u{E31}\u{E07}\u{E04}\u{E4C}\u{E44}\u{E14}\u{E49}`,
    ur: (label)=>`${label} \u{645}\u{6CC}\u{6BA} \u{635}\u{631}\u{641} \u{62D}\u{631}\u{648}\u{641} \u{60C} \u{646}\u{645}\u{628}\u{631} \u{60C} \u{6CC}\u{627} \u{633}\u{646}\u{6AF}\u{644} \u{6C1}\u{627}\u{626}\u{6CC}\u{641}\u{6CC}\u{646} \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{648}\u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{60C} \u{627}\u{648}\u{631} \u{6C1}\u{627}\u{626}\u{641}\u{6CC}\u{646} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{634}\u{631}\u{648}\u{639} \u{6CC}\u{627} \u{62E}\u{62A}\u{645} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} c\xf3 th\u{1EC3} ch\u{1EE9}a ch\u{1EEF} c\xe1i, s\u{1ED1} ho\u{1EB7}c d\u{1EA5}u g\u{1EA1}ch n\u{1ED1}i \u{111}\u{1A1}n l\u{1EBB} v\xe0 kh\xf4ng \u{111}\u{1B0}\u{1EE3}c b\u{1EAF}t \u{111}\u{1EA7}u ho\u{1EB7}c k\u{1EBF}t th\xfac b\u{1EB1}ng d\u{1EA5}u g\u{1EA1}ch n\u{1ED1}i.`,
    "zh-hans": (label)=>`${label} \u{FF09} \u{53EA}\u{80FD}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{3001}\u{6570}\u{5B57}\u{6216}\u{5355}\u{4E2A}\u{8FDE}\u{5B57}\u{7B26}\u{FF0C}\u{4E0D}\u{80FD}\u{4EE5}\u{8FDE}\u{5B57}\u{7B26}\u{5F00}\u{5934}\u{6216}\u{7ED3}\u{5C3E}\u{3002}`,
    "zh-hant": (label)=>`${label} \u{FF09} \u{53EA}\u{80FD}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{3001}\u{6578}\u{4F4D}\u{6216}\u{55AE}\u{500B}\u{9023}\u{5B57}\u{5143}\u{FF0C}\u{4E0D}\u{80FD}\u{4EE5}\u{9023}\u{5B57}\u{5143}\u{958B}\u{982D}\u{6216}\u{7D50}\u{5C3E}\u{3002}`,
    en: (label)=>`${label} may only contain letters, numbers, or single hyphens, and cannot begin or end with a hyphen.`
};
const $2868cc1235412e16$export$6c61a0cedd6edf45 = {
    ar: (label)=>`${label} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D}.`,
    de: (label)=>`${label} ist ung\xfcltig.`,
    es: (label)=>`${label} no es v\xe1lido.`,
    fa: (label)=>`${label} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{627}\u{633}\u{62A}.`,
    fil: (label)=>`Hindi wasto ang ${label}.`,
    fr: (label)=>`${label} n\u{2019}est pas valide.`,
    hi: (label)=>`${label} \u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{939}\u{948}.`,
    ht: (label)=>`${label} se envalid.`,
    it: (label)=>`${label} non \xe8 valido.`,
    ja: (label)=>`${label} \u{304C}\u{7121}\u{52B9}\u{3067}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{C798}\u{BABB}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yog invalid.`,
    ps: (label)=>`${label} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{62F}\u{6CC}.`,
    pt: (label)=>`${label} \xe9 inv\xe1lido.`,
    "pt-pt": (label)=>`${label} \xe9 inv\xe1lido.`,
    ru: (label)=>`${label} \u{43D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}.`,
    sm: (label)=>`E le o sa'o ${label}.`,
    so: (label)=>`${label} waa mid aan dhab ahayn.`,
    th: (label)=>`${label}`,
    ur: (label)=>`${label} \u{63A}\u{6CC}\u{631} \u{642}\u{627}\u{646}\u{648}\u{646}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (label)=>`${label} h\u{1EE3}p l\u{1EC7}.`,
    "zh-hans": (label)=>`${label} \u{65E0}\u{6548}\u{3002}`,
    "zh-hant": (label)=>`${label} \u{7121}\u{6548}\u{3002}`,
    en: (label)=>`${label} is invalid.`
};
const $2868cc1235412e16$export$9138bb72343fb2ba = {
    ar: (label, min)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62A}\u{643}\u{648}\u{646} ${label} ${min} \u{623}\u{62D}\u{631}\u{641} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644}.`,
    de: (label, min)=>`${label} muss mindestens ${min} Zeichen lang sein.`,
    es: (label, min)=>`${label} debe tener al menos ${min} caracteres.`,
    fa: (label, min)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{62F}\u{627}\u{642}\u{644} ${min} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, min)=>`${label} ay dapat na hindi bababa sa ${min} character.`,
    fr: (label, min)=>`${label} doit comporter au moins ${min} caract\xe8res.`,
    hi: (label, min)=>`${label} \u{915}\u{92E} \u{938}\u{947} \u{915}\u{92E} ${min} \u{935}\u{930}\u{94D}\u{923}\u{94B}\u{902} \u{915}\u{93E} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}.`,
    ht: (label, min)=>`${label} dwe omwen ${min} karakt\xe8.`,
    it: (label, min)=>`${label} deve essere composto da almeno ${min} caratteri.`,
    ja: (label, min)=>`${label} \u{306F} ${min} \u{6587}\u{5B57}\u{4EE5}\u{4E0A}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (label, min)=>`${label} ${min} \u{C790} \u{C774}\u{C0C1}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label, min)=>`${label} yuav tsum muaj tsawg kawg yog ${min} cim.`,
    ps: (label, min)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{644}\u{696} \u{62A}\u{631} \u{644}\u{696}\u{647} ${min} \u{62A}\u{648}\u{631}\u{6CC} \u{648}\u{6CC}.`,
    pt: (label, min)=>`${label} deve ter pelo menos ${min} caracteres.`,
    "pt-pt": (label, min)=>`${label} deve ter pelo menos ${min} caracteres.`,
    ru: (label, min)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{442}\u{44C} \u{43D}\u{435} \u{43C}\u{435}\u{43D}\u{435}\u{435} ${min} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}.`,
    sm: (label, min)=>`${label} e tatau ona le itiiti ifo ma ${min} mataitusi.`,
    so: (label, min)=>`${label} waa inuu ahaadaa ugu yaraan ${min} characters.`,
    th: (label, min)=>`${label} \u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22} ${min} \u{E2D}\u{E31}\u{E01}\u{E02}\u{E23}\u{E30}`,
    ur: (label, min)=>`${label} \u{6A9}\u{645} \u{627}\u{632} \u{6A9}\u{645} ${min} \u{62D}\u{631}\u{648}\u{641} \u{6A9}\u{627} \u{6C1}\u{648}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}.`,
    vi: (label, min)=>`${label} c\xf3 \xedt nh\u{1EA5}t ${min} k\xfd t\u{1EF1}.`,
    "zh-hans": (label, min)=>`${label} \u{5FC5}\u{987B}\u{81F3}\u{5C11}\u{4E3A} ${min} \u{4E2A}\u{5B57}\u{7B26}\u{3002}`,
    "zh-hant": (label, min)=>`${label} \u{5FC5}\u{9808}\u{81F3}\u{5C11}\u{70BA} ${min} \u{500B}\u{5B57}\u{5143}\u{3002}`,
    en: (label, min)=>`${label} must be at least ${min} characters.`
};
const $2868cc1235412e16$export$eefaf1eea407a083 = {
    ar: (label, max)=>`\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} ${label} ${max} \u{62D}\u{631}\u{641}\u{627}.`,
    de: (label, max)=>`${label} darf nicht l\xe4nger als ${max} Zeichen sein.`,
    es: (label, max)=>`${label} no puede tener m\xe1s de ${max} caracteres.`,
    fa: (label, max)=>`${label} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{628}\u{6CC}\u{634}\u{62A}\u{631} ${max} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, max)=>`${label} ay hindi maaaring lumampas sa ${max} character.`,
    fr: (label, max)=>`${label} ne peut pas comporter plus de ${max} caract\xe8res.`,
    hi: (label, max)=>`${label} ${max} \u{935}\u{930}\u{94D}\u{923}\u{94B}\u{902} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915} \u{932}\u{902}\u{92C}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E}.`,
    ht: (label, max)=>`${label} pa ka pi long pase ${max} karakt\xe8.`,
    it: (label, max)=>`${label} non pu\xf2 contenere pi\xf9 di ${max} caratteri.`,
    ja: (label, max)=>`${label} \u{306F} ${max} \u{6587}\u{5B57}\u{4EE5}\u{5185}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (label, max)=>`${label} ${max} \u{C790}\u{B97C} \u{CD08}\u{ACFC}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, max)=>`${label} yuav tsis ntev tshaj ${max} cim.`,
    ps: (label, max)=>`${label} \u{646}\u{634}\u{6CC} \u{6A9}\u{648}\u{644}\u{627}\u{6CC} \u{644}\u{647} ${max} \u{62A}\u{648}\u{631}\u{648} \u{685}\u{62E}\u{647} \u{627}\u{648}\u{696}\u{62F} \u{648}\u{6CC}.`,
    pt: (label, max)=>`${label} n\xe3o pode ter mais de ${max} caracteres.`,
    "pt-pt": (label, max)=>`${label} n\xe3o pode ter mais de ${max} caracteres.`,
    ru: (label, max)=>`${label} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{434}\u{43B}\u{438}\u{43D}\u{43D}\u{435}\u{435} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}.`,
    sm: (max, label)=>`E le mafai ona sili atu ma ${max} mataitusi le ${label}.`,
    so: (label, max)=>`${label} ma noqon karo wax ka badan ${max} jimo.`,
    th: (label, max)=>`${label} \u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${max} \u{E2D}\u{E31}\u{E01}\u{E02}\u{E23}\u{E30}`,
    ur: (label, max)=>`${label} 30 \u{62D}\u{631}\u{648}\u{641} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{644}\u{645}\u{628}\u{627} \u{646}\u{6C1}\u{6CC}\u{6BA} ${max} \u{6D4}`,
    vi: (label, max)=>`${label} \u{111}\u{1B0}\u{1EE3}c d\xe0i h\u{1A1}n ${max} k\xfd t\u{1EF1}.`,
    "zh-hans": (label, max)=>`${label} \u{4E0D}\u{80FD}\u{8D85}\u{8FC7} ${max} \u{4E2A}\u{5B57}\u{7B26}\u{3002}`,
    "zh-hant": (label, max)=>`${label} \u{4E0D}\u{80FD}\u{8D85}\u{904E} ${max} \u{500B}\u{5B57}\u{5143}\u{3002}`,
    en: (label, max)=>`${label} cannot be longer than ${max} characters.`
};
const $2868cc1235412e16$export$76d1215b01ac474d = {
    ar: (label, min)=>`\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} ${label} \u{623}\u{642}\u{644} \u{645}\u{646} ${min}.`,
    de: (label, min)=>`${label} darf nicht kleiner als ${min} sein.`,
    es: (label, min)=>`${label} no puede ser inferior a ${min}.`,
    fa: (label, min)=>`${label} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} \u{627}\u{632} ${min} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, min)=>`${label} ay hindi maaaring mas mababa sa ${min}.`,
    fr: (label, min)=>`${label} ne peut pas \xeatre inf\xe9rieur \xe0 ${min}.`,
    hi: (label, min)=>`${label} ${min} \u{938}\u{947} \u{915}\u{92E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E}\u{964}`,
    ht: (label, min)=>`${label} pa kapab mwens pase ${min}.`,
    it: (label, min)=>`${label} non pu\xf2 essere inferiore a ${min}.`,
    ja: (label, min)=>`${label} \u{3092} ${min} \u{672A}\u{6E80}\u{306B}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, min)=>`${label} ${min}\u{BCF4}\u{B2E4} \u{C791}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, min)=>`${label} yuav tsis tau tsawg tshaj ${min}.`,
    ps: (label, min)=>`${label} \u{646}\u{647} \u{634}\u{6CC} \u{6A9}\u{648}\u{644}\u{627}\u{6CC} \u{644}\u{647} ${min} \u{685}\u{62E}\u{647} \u{6A9}\u{645} \u{648}\u{6CC}.`,
    pt: (label, min)=>`${label} n\xe3o pode ser inferior a ${min}.`,
    "pt-pt": (label, min)=>`${label} n\xe3o pode ser inferior a ${min}.`,
    ru: (label, min)=>`${label} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435} ${min}.`,
    sm: (label, min)=>`${label} e le mafai ona itiiti ifo ma ${min}.`,
    so: (label, min)=>`${label} kama yaraan karo ${min}.`,
    th: (label, min)=>`${label}\u{E44}\u{E21}\u{E48}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32} ${min}`,
    ur: (label, min)=>`${label} ${min} \u{633}\u{6D2} \u{6A9}\u{645} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4}`,
    vi: (label, min)=>`${label} \u{111}\u{1B0}\u{1EE3}c nh\u{1ECF} h\u{1A1}n ${min}.`,
    "zh-hans": (label, min)=>`${label} \u{4E0D}\u{80FD}\u{5C0F}\u{4E8E} ${min}\u{3002}`,
    "zh-hant": (label, min)=>`${label} \u{4E0D}\u{80FD}\u{5C0F}\u{65BC} ${min}\u{3002}`,
    en: (label, min)=>`${label} cannot be less than ${min}.`
};
const $2868cc1235412e16$export$7090c56f2894c141 = {
    ar: (label, max)=>`\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} ${label} \u{623}\u{643}\u{628}\u{631} ${max}.`,
    de: (label, max)=>`${label} darf nicht gr\xf6\xdfer als ${max} sein.`,
    es: (label, max)=>`${label} no puede ser mayor que ${max}.`,
    fa: (label, max)=>`${label} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{628}\u{632}\u{631}\u{6AF}\u{62A}\u{631} ${max} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, max)=>`${label} ay hindi maaaring hihigit sa ${max}.`,
    fr: (label, max)=>`${label} ne peut pas \xeatre sup\xe9rieur \xe0 ${max}.`,
    hi: (label, max)=>`${label} ${max} \u{938}\u{947} \u{905}\u{927}\u{93F}\u{915} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E}.`,
    ht: (label, max)=>`${label} pa ka pi gran pase ${max}.`,
    it: (label, max)=>`${label} non pu\xf2 essere maggiore di ${max}.`,
    ja: (label, max)=>`${label} \u{306F} ${max} \u{3088}\u{308A}\u{5927}\u{304D}\u{304F}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, max)=>`${label} ${max}\u{BCF4}\u{B2E4} \u{D074} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, max)=>`${label} yuav tsis tau ntau tshaj ${max}.`,
    ps: (label, max)=>`${label} \u{646}\u{647} \u{634}\u{6CC} \u{6A9}\u{648}\u{644}\u{627}\u{6CC} \u{644}\u{647} ${max} \u{685}\u{62E}\u{647} \u{632}\u{6CC}\u{627}\u{62A} \u{648}\u{6CC}.`,
    pt: (label, max)=>`${label} n\xe3o pode ser maior que ${max}.`,
    "pt-pt": (label, max)=>`${label} n\xe3o pode ser maior que ${max}.`,
    ru: (label, max)=>`${label} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} ${max}.`,
    sm: (label, max)=>`O ${label} le mafai ona sili atu nai lo ${max}.`,
    so: (label, max)=>`${label} kama weynaan karaan ${max} jir.`,
    th: (label, max)=>`${label}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${max}`,
    ur: (label, max)=>`${label} ${max} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4}`,
    vi: (label, max)=>`${label} \u{111}\u{1B0}\u{1EE3}c l\u{1EDB}n h\u{1A1}n ${max}.`,
    "zh-hans": (label, max)=>`${label} \u{4E0D}\u{80FD}\u{5927}\u{4E8E} ${max}\u{3002}`,
    "zh-hant": (label, max)=>`${label} \u{4E0D}\u{80FD}\u{5927}\u{65BC} ${max}\u{3002}`,
    en: (label, max)=>`${label} cannot be greater than ${max}.`
};
const $2868cc1235412e16$export$22ec1f3944b408e9 = {
    ar: (length)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} \u{644}\u{639}\u{62F}\u{62F} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631} \u{647}\u{648} ${length}.`,
    de: (length)=>`Die maximale Anzahl von Elementen betr\xe4gt ${length}.`,
    es: (length)=>`El n\xfamero m\xe1ximo de art\xedculos es ${length}.`,
    fa: (length)=>`\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} \u{62A}\u{639}\u{62F}\u{627}\u{62F} \u{627}\u{642}\u{644}\u{627}\u{645} ${length} \u{627}\u{633}\u{62A}.`,
    fil: (length)=>`Ang maximum na bilang ng mga item ay ${length}.`,
    fr: (length)=>`Le nombre maximum d\u{2019}articles est de ${length}.`,
    hi: (length)=>`\u{906}\u{907}\u{91F}\u{92E}\u{94D}\u{938} \u{915}\u{940} \u{905}\u{927}\u{93F}\u{915}\u{924}\u{92E} \u{938}\u{902}\u{916}\u{94D}\u{92F}\u{93E} ${length} \u{939}\u{948}.`,
    ht: (length)=>`Nimewo maksim\xf2m atik yo se ${length}.`,
    it: (length)=>`Il numero massimo di oggetti \xe8 ${length}.`,
    ja: (length)=>`\u{6700}\u{5927}\u{30A2}\u{30A4}\u{30C6}\u{30E0}\u{6570}\u{306F} ${length}\u{500B}\u{3067}\u{3059}\u{3002}`,
    ko: (length)=>`\u{CD5C}\u{B300} \u{D56D}\u{BAA9} \u{C218}\u{B294} ${length}\u{AC1C}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (length)=>`Cov khoom muaj tsawg tshaj plaws yog ${length}.`,
    ps: (length)=>`\u{62F} \u{62A}\u{648}\u{6A9}\u{648} \u{627}\u{639}\u{638}\u{645}\u{6CC} \u{634}\u{645}\u{6CC}\u{631} ${length} \u{62F}\u{6CC}.`,
    pt: (length)=>`O n\xfamero m\xe1ximo de itens \xe9 ${length}.`,
    "pt-pt": (length)=>`O n\xfamero m\xe1ximo de itens \xe9 ${length}.`,
    ru: (length)=>`\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{43A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}\u{43E}\u{432} - ${length}.`,
    sm: (length)=>`O le aofa'i aupito maualuga o aitema o le ${length}.`,
    so: (length)=>`Tirada ugu badan ee sheyga waa ${length}.`,
    th: (length)=>`\u{E08}\u{E4D}\u{E32}\u{E19}\u{E27}\u{E19}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E39}\u{E07}\u{E2A}\u{E38}\u{E14}\u{E04}\u{E37}\u{E2D} ${length} \u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: (length)=>`\u{627}\u{634}\u{6CC}\u{627}\u{621} \u{6A9}\u{6CC} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{633}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{62A}\u{639}\u{62F}\u{627}\u{62F} ${length} \u{6C1}\u{6D2}.`,
    vi: (length)=>`S\u{1ED1} l\u{1B0}\u{1EE3}ng m\u{1EB7}t h\xe0ng t\u{1ED1}i \u{111}a l\xe0 ${length}.`,
    "zh-hans": (length)=>`\u{6700}\u{5927}\u{9879}\u{6570}\u{4E3A} ${length}\u{3002}`,
    "zh-hant": (length)=>`\u{6700}\u{5927}\u{9805}\u{6578}\u{70BA} ${length}\u{3002}`,
    en: (length)=>`Maximum number of items is ${length}.`
};
const $2868cc1235412e16$export$edb12e2f2b2628ce = {
    ar: (label)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${label} \u{641}\u{631}\u{64A}\u{62F}\u{627}.`,
    de: (label)=>`${label} muss eindeutig sein.`,
    es: (label)=>`${label} debe ser \xfanico.`,
    fa: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{646}\u{62D}\u{635}\u{631} \u{628}\u{647} \u{641}\u{631}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label)=>`${label} ay dapat na natatangi.`,
    fr: (label)=>`${label} doit \xeatre unique.`,
    hi: (label)=>`${label} \u{905}\u{926}\u{94D}\u{935}\u{93F}\u{924}\u{940}\u{92F} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}.`,
    ht: (label)=>`${label} yo dwe inik.`,
    it: (label)=>`${label} deve essere univoco.`,
    ja: (label)=>`${label} \u{306F}\u{4E00}\u{610F}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{ACE0}\u{C720}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum muaj nws lub npe.`,
    ps: (label)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{646}\u{62D}\u{635}\u{631} \u{628}\u{647} \u{641}\u{631}\u{62F} \u{648}\u{6CC}.`,
    pt: (label)=>`${label} deve ser exclusivo.`,
    "pt-pt": (label)=>`${label} deve ser exclusivo.`,
    ru: (label)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{443}\u{43D}\u{438}\u{43A}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{43C}.`,
    sm: (label)=>`${label} e tatau ona tulaga ese.`,
    so: (label)=>`${label} waa inuu ahaadaa mid aan caadi aheyn.`,
    th: (label)=>`${label} \u{E44}\u{E21}\u{E48}\u{E0B}\u{E49}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E19}`,
    ur: (label)=>`${label} \u{645}\u{646}\u{641}\u{631}\u{62F} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{626}\u{6D2}.`,
    vi: (label)=>`${label} l\xe0 duy nh\u{1EA5}t.`,
    "zh-hans": (label)=>`${label} \u{5FC5}\u{987B}\u{552F}\u{4E00}\u{3002}`,
    "zh-hant": (label)=>`${label} \u{5FC5}\u{9808}\u{552F}\u{4E00}\u{3002}`,
    en: (label)=>`${label} must be unique.`
};
const $2868cc1235412e16$export$18d990bed133506d = {
    ar: (label, count)=>`\u{64A}\u{645}\u{643}\u{646} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{646}\u{641}\u{633} ${label} ${count} \u{641}\u{642}\u{637}.`,
    de: (label, count)=>`Derselbe ${label} kann nur ${count} Mal ausgew\xe4hlt werden.`,
    es: (label, count)=>`El mismo ${label} solo se puede seleccionar ${count} veces.`,
    fa: (label, count)=>`\u{647}\u{645}\u{6CC}\u{646} ${label} \u{631}\u{627} \u{641}\u{642}\u{637} ${count} \u{628}\u{627}\u{631} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{62F}.`,
    fil: (count, label)=>`Dalawang ${count} mapipili ang ${label}.`,
    fr: (label, count)=>`Le m\xeame ${label} ne peut \xeatre s\xe9lectionn\xe9 que ${count} fois.`,
    hi: (label, count)=>`\u{90F}\u{915} \u{939}\u{940} ${label} \u{915}\u{947}\u{935}\u{932} ${count} \u{92C}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{93E} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (label, count)=>`Menm ${label} an ka s\xe8lman chwazi ${count} fwa.`,
    it: (label, count)=>`Lo stesso ${label} pu\xf2 essere selezionato solo ${count} volte.`,
    ja: (label, count)=>`\u{540C}\u{3058} ${label} \u{306F} ${count} \u{56DE}\u{3057}\u{304B}\u{9078}\u{629E}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (label, count)=>`\u{AC19}\u{C740} ${label} ${count} \u{BC88}\u{B9CC} \u{C120}\u{D0DD}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label, count)=>`Tib ${label} tsuas xaiv ${count} zaug xwb.`,
    ps: (label, count)=>`\u{647}\u{645}\u{62F}\u{63A}\u{647} ${label} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} ${count} \u{681}\u{644}\u{647} \u{67C}\u{627}\u{6A9}\u{644} \u{6A9}\u{6CC}\u{62F}\u{6CC} \u{634}\u{6CC}.`,
    pt: (label, count)=>`O mesmo ${label} s\xf3 pode ser selecionado ${count} vezes.`,
    "pt-pt": (label, count)=>`O mesmo ${label} s\xf3 pode ser selecionado ${count} vezes.`,
    ru: (label, count)=>`\u{41E}\u{434}\u{43D}\u{43E} \u{438} \u{442}\u{43E} \u{436}\u{435} ${label} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} ${count} \u{440}\u{430}\u{437}\u{430}.`,
    sm: (label, count)=>`O le ${label} lava lea e tasi e mafai ona filifilia na o ${count} taimi.`,
    so: (label, count)=>`${label} isku midka ah waxaa la dooran karaa oo keliya ${count} jeer.`,
    th: (label, count)=>`\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01} ${label} \u{E44}\u{E14}\u{E49}\u{E40}\u{E1E}\u{E35}\u{E22}\u{E07} ${count} \u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: (label, count)=>`\u{627}\u{6CC}\u{6A9} \u{6C1}\u{6CC} ${label} \u{635}\u{631}\u{641} ${count} \u{628}\u{627}\u{631} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2}.`,
    vi: (label, count)=>`C\xf9ng m\u{1ED9}t ${label} ch\u{1EC9} c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c ch\u{1ECD}n ${count} l\u{1EA7}n.`,
    "zh-hans": (label, count)=>`\u{76F8}\u{540C}\u{7684} ${label} \u{53EA}\u{80FD}\u{9009}\u{62E9} ${count} \u{6B21}\u{3002}`,
    "zh-hant": (label, count)=>`\u{76F8}\u{540C}\u{7684} ${label} \u{53EA}\u{80FD}\u{9078}\u{64C7} ${count} \u{6B21}\u{3002}`,
    en: (label, count)=>`The same ${label} can only be selected ${count} times.`
};
const $2868cc1235412e16$export$5d0a69f765a632f4 = {
    ar: (label, maxLabel)=>`\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${label} \u{623}\u{642}\u{644} \u{645}\u{646} \u{62A}\u{627}\u{631}\u{64A}\u{62E} ${maxLabel} \u{623}\u{648} \u{64A}\u{633}\u{627}\u{648}\u{64A}\u{647}.`,
    de: (label, maxLabel)=>`${label} muss kleiner oder gleich dem ${maxLabel} sein.`,
    es: (label, maxLabel)=>`${label} debe ser menor o igual que la ${maxLabel}.`,
    fa: (label, maxLabel)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} \u{6CC}\u{627} \u{645}\u{633}\u{627}\u{648}\u{6CC} ${maxLabel} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (label, maxLabel)=>`Ang ${label} ay dapat na mas mababa o katumbas ng ${maxLabel}.`,
    fr: (label, maxLabel)=>`${label} doit \xeatre inf\xe9rieure ou \xe9gale \xe0 ${maxLabel}.`,
    hi: (label, maxLabel)=>`${label} ${maxLabel} \u{915}\u{92E} \u{92F}\u{93E} \u{909}\u{938}\u{915}\u{947} \u{92C}\u{930}\u{93E}\u{92C}\u{930} \u{939}\u{94B}\u{928}\u{93E} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948}.`,
    ht: (label, maxLabel)=>`${label} dwe mwens pase oswa egal a ${maxLabel}.`,
    it: (label, maxLabel)=>`${label} deve essere minore o uguale alla ${maxLabel}.`,
    ja: (label, maxLabel)=>`${label} \u{306F} ${maxLabel}\u{4EE5}\u{4E0B}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (label, maxLabel)=>`${label} \u{B294} ${maxLabel}\u{BCF4}\u{B2E4} \u{C791}\u{AC70}\u{B098} \u{AC19}\u{C544}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (label, maxLabel)=>`${label} tsum tsawg tshaj li ${maxLabel}.`,
    ps: (label, maxLabel)=>`${label} \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${maxLabel} \u{685}\u{62E}\u{647} \u{6A9}\u{645} \u{6CC}\u{627} \u{645}\u{633}\u{627}\u{648}\u{6CC} \u{648}\u{6CC}.`,
    pt: (label, maxLabel)=>`${label} deve ser menor ou igual \xe0 ${maxLabel}.`,
    "pt-pt": (label, maxLabel)=>`${label} deve ser menor ou igual \xe0 ${maxLabel}.`,
    ru: (label, maxLabel)=>`${label} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{430} ${maxLabel}.`,
    sm: (label, maxLabel)=>`O le ${label} e tatau ona itiiti ifo pe tutusa foi ma le ${maxLabel} ai.`,
    so: (label, maxLabel)=>`${label} waa in ay ahaataa wax ka yar ama loo siman yahay ${maxLabel}.`,
    th: (label, maxLabel)=>`${label}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E40}\u{E17}\u{E48}\u{E32}\u{E01}\u{E31}\u{E1A}${maxLabel}`,
    ur: (label, maxLabel)=>`${label} ${maxLabel} \u{633}\u{6D2} \u{6A9}\u{645} \u{6CC}\u{627} \u{628}\u{631}\u{627}\u{628}\u{631} \u{6C1}\u{648}\u{646}\u{6CC} \u{686}\u{627}\u{6C1}\u{626}\u{6D2}\u{6D4}`,
    vi: (label, maxLabel)=>`${label} ph\u{1EA3}i nh\u{1ECF} h\u{1A1}n ho\u{1EB7}c b\u{1EB1}ng ${maxLabel}.`,
    "zh-hans": (label, maxLabel)=>`${label} \u{5FC5}\u{987B}\u{5C0F}\u{4E8E}\u{6216}\u{7B49}\u{4E8E} ${maxLabel}\u{3002}`,
    "zh-hant": (label, maxLabel)=>`${label} \u{5FC5}\u{9808}\u{5C0F}\u{65BC}\u{6216}\u{7B49}\u{65BC} ${maxLabel}\u{3002}`,
    en: (label, maxLabel)=>`${label} must be less than or equal to ${maxLabel}.`
};
const $2868cc1235412e16$export$a1c514477edb0163 = {
    ar: `\u{623}\u{62E}\u{637}\u{627}\u{621} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{627}\u{644}\u{635}\u{62D}\u{629}`,
    de: `Fehler bei der Validierung`,
    es: `Errores de validaci\xf3n`,
    fa: `\u{62E}\u{637}\u{627}\u{647}\u{627}\u{6CC} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631}\u{633}\u{646}\u{62C}\u{6CC}`,
    fil: `Mga error sa pagpapatunay`,
    fr: `Erreurs de validation`,
    hi: `\u{92A}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{91C}\u{941}\u{921}\u{93C}\u{940} \u{917}\u{921}\u{93C}\u{92C}\u{921}\u{93C}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: `Er\xe8 validasyon`,
    it: `Errori di convalida`,
    ja: `\u{691C}\u{8A3C}\u{30A8}\u{30E9}\u{30FC}`,
    ko: `\u{C720}\u{D6A8}\u{C131} \u{AC80}\u{C0AC} \u{C624}\u{B958}`,
    mww: `Validation errors`,
    ps: `\u{62F} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631} \u{63A}\u{644}\u{637}\u{6CD}`,
    pt: `Erros de valida\xe7\xe3o`,
    "pt-pt": `Erros de valida\xe7\xe3o`,
    ru: `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{438} \u{432}\u{430}\u{43B}\u{438}\u{434}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Mea sese o le faamaoniga`,
    so: `Khaladaadka anshaxinta`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{62A}\u{648}\u{62B}\u{6CC}\u{642} \u{6A9}\u{6CC} \u{63A}\u{644}\u{637}\u{6CC}\u{627}\u{6BA}`,
    vi: `L\u{1ED7}i x\xe1c th\u{1EF1}c`,
    "zh-hans": `\u{9A8C}\u{8BC1}\u{9519}\u{8BEF}`,
    "zh-hant": `\u{9A57}\u{8B49}\u{932F}\u{8AA4}`,
    en: `Validation errors`
};
const $2868cc1235412e16$export$f725eab7abaa007d = {
    ar: $2868cc1235412e16$var$html`حدث خطأ ما. لقد سجلنا الخطأ. يرجى <a class="Link--primary text-bold" href="/support">الاتصال بالدعم</a> إذا استمرت المشكلة.`,
    de: $2868cc1235412e16$var$html`Irgendetwas ist schief gelaufen. Wir haben den Fehler protokolliert. <a class="Link--primary text-bold" href="/support">Wenden Sie sich an den Support</a> , wenn das Problem weiterhin besteht.`,
    es: $2868cc1235412e16$var$html`Algo salió mal. Hemos registrado el error. <a class="Link--primary text-bold" href="/support">Póngase en contacto con el servicio de asistencia</a> si el problema persiste.`,
    fa: $2868cc1235412e16$var$html`مشکلی پیش آمد. ما خطا را ثبت کرده ایم. لطفا در صورت ادامه <a class="Link--primary text-bold" href="/support">مشکل با پشتیبانی</a> تماس بگیرید.`,
    fil: $2868cc1235412e16$var$html`May nangyaring mali. Na-log na namin ang error. Mangyaring <a class="Link--primary text-bold" href="/support">makipag-ugnay sa suporta</a> kung magpapatuloy ang isyu.`,
    fr: $2868cc1235412e16$var$html`Quelque chose a mal tourné. Nous avons consigné l’erreur. Veuillez <a class="Link--primary text-bold" href="/support">contacter l’assistance</a> si le problème persiste.`,
    hi: $2868cc1235412e16$var$html`कुछ गलत हो गया। हमने त्रुटि लॉग की है। यदि समस्या बनी रहती है, तो कृपया <a class="Link--primary text-bold" href="/support">समर्थन से संपर्क</a> करें।`,
    ht: $2868cc1235412e16$var$html`Gen yon bagay ki te pase mal. Nou te louvri sesyon an erè. Tanpri <a class="Link--primary text-bold" href="/support">kontakte sipò</a> si pwoblèm nan pèsiste.`,
    it: $2868cc1235412e16$var$html`Qualcosa è andato storto. L'errore è stato registrato. <a class="Link--primary text-bold" href="/support">Contatta l'assistenza</a> se il problema persiste.`,
    ja: $2868cc1235412e16$var$html`問題が発生しました。エラーをログに記録しました。問題が解決しない場合は <a class="Link--primary text-bold" href="/support">、サポートにお問い合わせください</a> 。`,
    ko: $2868cc1235412e16$var$html`문제가 발생했습니다. 오류를 기록했습니다. 문제가 지속되면 <a class="Link--primary text-bold" href="/support">지원팀에 문의하십시오</a> .`,
    mww: $2868cc1235412e16$var$html`Tej yam mus tsis ncaj ncees lawm. Peb twb logged qhov yuam kev. Thov <a class="Link--primary text-bold" href="/support">hu rau kev them nyiaj yug</a> yog hais tias qhov teeb meem persists.`,
    ps: $2868cc1235412e16$var$html`یو څه خراب شول. موږ غلطی ثبت کړه. مهربانی وکړئ <a class="Link--primary text-bold" href="/support">د ملاتړ سره اړیکه</a> ونیسئ که ستونزه دوام وکړه.`,
    pt: $2868cc1235412e16$var$html`Algo deu errado. Registramos o erro. Entre <a class="Link--primary text-bold" href="/support">em contato com o suporte</a> se o problema persistir.`,
    "pt-pt": $2868cc1235412e16$var$html`Algo correu mal. Registamos o erro. <a class="Link--primary text-bold" href="/support">Entre em contato com o suporte</a> se o problema persistir.`,
    ru: $2868cc1235412e16$var$html`Что-то пошло не так. Мы зарегистрировали ошибку. <a class="Link--primary text-bold" href="/support">Обратитесь в службу поддержки</a> , если проблема не устранена.`,
    sm: $2868cc1235412e16$var$html`Sa i ai se mea na sese. Ua matou fa'amauina le mea sese. <a class="Link--primary text-bold" href="/support">Fa'amolemole fa'afeso'ota'i le lagolago pe</a> a fa'aauau pea le fa'afitauli.`,
    so: $2868cc1235412e16$var$html`Wax baa khaldamay. Waxaanu qaadnay khaladka. Fadlan <a class="Link--primary text-bold" href="/support">la xiriir taageero</a> haddii ay arrintu ka taagantahay.`,
    th: $2868cc1235412e16$var$html`มีบางอย่างผิดพลาด เราได้บันทึกข้อผิดพลาดแล้ว โปรดติดต่อ <a class="Link--primary text-bold" href="/support">ฝ่ายสนับสนุน</a> หากปัญหายังคงอยู่`,
    ur: $2868cc1235412e16$var$html`کچھ غلط ہو گیا. ہم نے غلطی لاگ ان کر لی ہے۔ اگر <a class="Link--primary text-bold" href="/support">مسئلہ</a> برقرار رہتا ہے تو براہ کرم سپورٹ سے رابطہ کریں۔`,
    vi: $2868cc1235412e16$var$html`Có điều gì đó không ổn. Chúng tôi đã ghi lại lỗi. Vui lòng <a class="Link--primary text-bold" href="/support">liên hệ với bộ phận hỗ trợ</a> nếu sự cố vẫn tiếp diễn.`,
    "zh-hans": $2868cc1235412e16$var$html`出了点问题。我们已记录此错误。如果问题仍然存在， <a class="Link--primary text-bold" href="/support">请联系支持人员</a> 。`,
    "zh-hant": $2868cc1235412e16$var$html`出了點問題。我們已記錄此錯誤。如果問題仍然存在， <a class="Link--primary text-bold" href="/support">請聯繫支持人員</a> 。`,
    en: $2868cc1235412e16$var$html`Something went wrong. We've logged the error. Please <a class="Link--primary text-bold" href="/support">contact support</a> if the issue persists.`
};
const $2868cc1235412e16$export$a86e9a9bd8b26f8a = {
    ar: `\u{647}\u{646}\u{627}\u{643} \u{645}\u{634}\u{643}\u{644}\u{629}`,
    de: `Es gibt ein Problem`,
    es: `Hay un problema`,
    fa: `\u{645}\u{634}\u{6A9}\u{644}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{627}\u{631}\u{62F}`,
    fil: `May problema`,
    fr: `Il y a un probl\xe8me`,
    hi: `\u{90F}\u{915} \u{938}\u{92E}\u{938}\u{94D}\u{92F}\u{93E} \u{939}\u{948}`,
    ht: `Genyen yon pwobl\xe8m`,
    it: `C'\xe8 un problema`,
    ja: `\u{554F}\u{984C}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`,
    ko: `\u{BB38}\u{C81C}\u{AC00} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Nws muaj nws ib qho teeb meem`,
    ps: `\u{6CC}\u{648}\u{647} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{647} \u{634}\u{62A}\u{647}`,
    pt: `H\xe1 um problema`,
    "pt-pt": `H\xe1 um problema`,
    ru: `\u{415}\u{441}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{430}`,
    sm: `O loo i ai se faafitauli`,
    so: `Waxaa jira dhibaato`,
    th: `\u{E21}\u{E35}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{645}\u{633}\u{626}\u{644}\u{6C1} \u{6C1}\u{6D2}`,
    vi: `C\xf3 m\u{1ED9}t v\u{1EA5}n \u{111}\u{1EC1}`,
    "zh-hans": `\u{6709}\u{95EE}\u{9898}`,
    "zh-hant": `\u{6709}\u{554F}\u{984C}`,
    en: `There's a problem`
};
const $2868cc1235412e16$export$aa8574e0ba44bca8 = {
    ar: (language)=>`\u{645}\u{62D}\u{62F}\u{62F} \u{644}\u{63A}\u{629} \u{627}\u{644}\u{645}\u{62D}\u{62A}\u{648}\u{649}. \u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647} \u{62D}\u{627}\u{644}\u{64A}\u{627} \u{639}\u{644}\u{649} ${language}`,
    de: (language)=>`Auswahl der Inhaltssprache. Derzeit auf ${language} eingestellt`,
    es: (language)=>`Selector de idioma de contenido. Actualmente configurado en ${language}`,
    fa: (language)=>`\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}\u{6AF}\u{631} \u{632}\u{628}\u{627}\u{646} \u{645}\u{62D}\u{62A}\u{648}\u{627}. \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62D}\u{627}\u{636}\u{631} \u{631}\u{648}\u{6CC} ${language} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: (language)=>`Tagapili ng wika ng nilalaman. Kasalukuyang nakatakda sa ${language}`,
    fr: (language)=>`S\xe9lecteur de langue de contenu. Actuellement r\xe9gl\xe9 sur ${language}`,
    hi: (language)=>`\u{938}\u{93E}\u{92E}\u{917}\u{94D}\u{930}\u{940} \u{92D}\u{93E}\u{937}\u{93E} \u{91A}\u{92F}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}. \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{92E}\u{947}\u{902} ${language} \u{92A}\u{930} \u{938}\u{947}\u{91F} \u{939}\u{948}`,
    ht: (language)=>`Seleksyon lang kontni. Kounye a mete ${language}`,
    it: (language)=>`Selettore della lingua del contenuto. Attualmente impostato su ${language}`,
    ja: (language)=>`\u{30B3}\u{30F3}\u{30C6}\u{30F3}\u{30C4}\u{8A00}\u{8A9E}\u{30BB}\u{30EC}\u{30AF}\u{30BF}\u{30FC}\u{3002}\u{73FE}\u{5728}\u{306F}${language}\u{306B}\u{8A2D}\u{5B9A}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: (language)=>`\u{CF58}\u{D150}\u{CE20} \u{C5B8}\u{C5B4} \u{C120}\u{D0DD}\u{AE30}. \u{D604}\u{C7AC} ${language} \u{C124}\u{C815}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (language)=>`Cov lus xaiv. Tam sim no teem caij mus ${language}`,
    ps: (language)=>`\u{62F} \u{645}\u{62D}\u{62A}\u{648}\u{627} \u{62F} \u{698}\u{628}\u{6D0} \u{67C}\u{627}\u{6A9}\u{648}\u{646}\u{6A9}\u{6CC}. \u{627}\u{648}\u{633} \u{645}\u{647}\u{627}\u{644} \u{67E}\u{647} ${language} \u{6A9}\u{6D0} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{634}\u{648}\u{6CC}`,
    pt: (language)=>`Seletor de idioma do conte\xfado. Atualmente definido como ${language}`,
    "pt-pt": (language)=>`Seletor de idioma de conte\xfado. Atualmente definido para ${language}`,
    ru: (language)=>`\u{421}\u{435}\u{43B}\u{435}\u{43A}\u{442}\u{43E}\u{440} \u{44F}\u{437}\u{44B}\u{43A}\u{430} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{438}\u{43C}\u{43E}\u{433}\u{43E}. \u{412} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{43E} \u{43D}\u{430} ${language} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: (language)=>`Tagata filifilia o le gagana o le anotusi. O lo'o fa'atulagaina nei i le ${language}`,
    so: (language)=>`Xulashada luqada content. Waxaa hadda lagu wadaa in ay ${language}`,
    th: (language)=>`\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E20}\u{E32}\u{E29}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E19}\u{E37}\u{E49}\u{E2D}\u{E2B}\u{E32} \u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19} ${language}`,
    ur: (language)=>`\u{645}\u{648}\u{627}\u{62F} \u{6A9}\u{6CC} \u{632}\u{628}\u{627}\u{646} \u{6A9}\u{6D2} \u{633}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}. \u{641}\u{6CC} \u{627}\u{644}\u{62D}\u{627}\u{644} \u{627}\u{646}\u{6AF}\u{631}\u{6CC}\u{632}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{633}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627} ${language}`,
    vi: (language)=>`B\u{1ED9} ch\u{1ECD}n ng\xf4n ng\u{1EEF} n\u{1ED9}i dung. Hi\u{1EC7}n \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EB7}t th\xe0nh ${language}`,
    "zh-hans": (language)=>`\u{5185}\u{5BB9}\u{8BED}\u{8A00}\u{9009}\u{62E9}\u{5668}\u{3002}\u{5F53}\u{524D}\u{8BBE}\u{7F6E}\u{4E3A} ${language}`,
    "zh-hant": (language)=>`\u{5167}\u{5BB9}\u{8A9E}\u{8A00}\u{9078}\u{64C7}\u{5668}\u{3002}\u{7576}\u{524D}\u{8A2D}\u{7F6E}\u{70BA} ${language}`,
    en: (language)=>`Content language selector. Currently set to ${language}`
};
const $2868cc1235412e16$export$b515f6dda739aa14 = {
    ar: `\u{645}\u{624}\u{633}\u{633}\u{627}\u{62A}\u{643}`,
    de: `Ihre Organisationen`,
    es: `Sus organizaciones`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{634}\u{645}\u{627}`,
    fil: `Ang iyong mga organisasyon`,
    fr: `Vos organisations`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon ou yo`,
    it: `Le tue organizzazioni`,
    ja: `\u{304A}\u{5BA2}\u{69D8}\u{306E}\u{7D44}\u{7E54}`,
    ko: `\u{B0B4} \u{C870}\u{C9C1}`,
    mww: `Koj lub koom haum`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Suas organiza\xe7\xf5es`,
    "pt-pt": `As suas organiza\xe7\xf5es`,
    ru: `\u{412}\u{430}\u{448}\u{438} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Au fa'alapotopotoga`,
    so: `Ururadaada`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA}`,
    vi: `T\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n`,
    "zh-hans": `\u{60A8}\u{7684}\u{7EC4}\u{7EC7}`,
    "zh-hant": `\u{60A8}\u{7684}\u{7D44}\u{7E54}`,
    en: `Your organizations`
};
const $2868cc1235412e16$export$bcb597a2bb0c6ebd = {
    ar: `\u{625}\u{63A}\u{644}\u{627}\u{642} \u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629}`,
    de: `Men\xfc schlie\xdfen`,
    es: `Cerrar men\xfa`,
    fa: `\u{628}\u{633}\u{62A}\u{646} \u{645}\u{646}\u{648}`,
    fil: `Email Address *`,
    fr: `Fermer le menu`,
    hi: `\u{92E}\u{947}\u{928}\u{942} \u{92C}\u{902}\u{926} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Meni f\xe8men`,
    it: `Chiudi menu`,
    ja: `\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{9589}\u{3058}\u{308B}`,
    ko: `\u{BA54}\u{B274} \u{B2EB}\u{AE30}`,
    mww: `Kaw zaub mov`,
    ps: `\u{645}\u{6CC}\u{646}\u{648} \u{628}\u{646}\u{62F}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Fechar menu`,
    "pt-pt": `Fechar menu`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44E}`,
    sm: `Tapuni le lisi autu`,
    so: `Xir menu`,
    th: `\u{E1B}\u{E34}\u{E14}\u{E40}\u{E21}\u{E19}\u{E39}`,
    ur: `\u{645}\u{6CC}\u{646}\u{648} \u{628}\u{646}\u{62F} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\xf3ng menu`,
    "zh-hans": `\u{5173}\u{95ED}\u{83DC}\u{5355}`,
    "zh-hant": `\u{95DC}\u{9589}\u{529F}\u{80FD}\u{8868}`,
    en: `Close menu`
};
const $2868cc1235412e16$export$5a9a90c319cc6950 = {
    ar: `\u{627}\u{644}\u{642}\u{627}\u{626}\u{645}\u{629} \u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}`,
    de: `Men\xfc wird geladen`,
    es: `El men\xfa se est\xe1 cargando`,
    fa: `\u{645}\u{646}\u{648} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{628}\u{627}\u{631}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{627}\u{633}\u{62A}`,
    fil: `Naglo-load ang menu`,
    fr: `Le menu est en cours de chargement`,
    hi: `\u{92E}\u{947}\u{928}\u{942} \u{932}\u{94B}\u{921} \u{939}\u{94B} \u{930}\u{939}\u{93E} \u{939}\u{948}`,
    ht: `Meni ap chaje`,
    it: `Il menu \xe8 in fase di caricamento`,
    ja: `\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{304C}\u{8AAD}\u{307F}\u{8FBC}\u{307E}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `\u{BA54}\u{B274}\u{AC00} \u{B85C}\u{B529} \u{C911}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Zaub mov yog loading`,
    ps: `\u{645}\u{6CC}\u{646}\u{648} \u{628}\u{627}\u{631}\u{6CC}\u{696}\u{6CC}`,
    pt: `O menu est\xe1 carregando`,
    "pt-pt": `O menu est\xe1 a carregar`,
    ru: `\u{41C}\u{435}\u{43D}\u{44E} \u{437}\u{430}\u{433}\u{440}\u{443}\u{436}\u{430}\u{435}\u{442}\u{441}\u{44F}`,
    sm: `O lo'o utaina le lisi`,
    so: `menu waxaa loading`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E42}\u{E2B}\u{E25}\u{E14}\u{E40}\u{E21}\u{E19}\u{E39}`,
    ur: `\u{645}\u{6CC}\u{646}\u{648} \u{644}\u{648}\u{688} \u{6C1}\u{648} \u{631}\u{6C1}\u{627} \u{6C1}\u{6D2}`,
    vi: `Menu \u{111}ang t\u{1EA3}i`,
    "zh-hans": `\u{83DC}\u{5355}\u{6B63}\u{5728}\u{52A0}\u{8F7D}`,
    "zh-hant": `\u{529F}\u{80FD}\u{8868}\u{6B63}\u{5728}\u{8F09}\u{5165}`,
    en: `Menu is loading`
};
const $2868cc1235412e16$export$25a57b30938bf753 = {
    ar: `\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    de: `Laden...`,
    es: `Carga...`,
    fa: `\u{628}\u{627}\u{631}\u{6AF}\u{630}\u{627}\u{631}\u{6CC}...`,
    fil: `Naglo-load...`,
    fr: `Chargement...`,
    hi: `\u{932}\u{94B}\u{921}\u{964}\u{964}\u{964}`,
    ht: `Chaje ...`,
    it: `Caricamento...`,
    ja: `\u{7A4D}\u{8F09}\u{3002}\u{3002}\u{3002}`,
    ko: `\u{B85C}\u{B4DC}...`,
    mww: `Loading...`,
    ps: `Loading...`,
    pt: `Carregamento...`,
    "pt-pt": `A carregar...`,
    ru: `\u{41F}\u{43E}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    sm: `Utaina ...`,
    so: `Loading...`,
    th: `\u{E01}\u{E32}\u{E23}\u{E42}\u{E2B}\u{E25}\u{E14}   `,
    ur: `\u{644}\u{648}\u{688}\u{646}\u{6AF}...`,
    vi: `T\u{1EA3}i...`,
    "zh-hans": `\u{88C5}\u{8F7D}\u{3002}\u{3002}\u{3002}`,
    "zh-hant": `\u{88DD}\u{8F09}\u{3002}\u{3002}\u{3002}`,
    en: `Loading...`
};
const $2868cc1235412e16$export$b216620a6709d9c7 = {
    ar: `\u{62A}\u{628}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{628}\u{62D}\u{62B}`,
    de: `Suche umschalten`,
    es: `Alternar b\xfasqueda`,
    fa: `\u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{62C}\u{633}\u{62A}\u{62C}\u{648}`,
    fil: `Email Address *`,
    fr: `Basculer la recherche`,
    hi: `\u{91F}\u{949}\u{917}\u{932} \u{916}\u{94B}\u{91C}`,
    ht: `Rech\xe8ch togle`,
    it: `Attiva/disattiva ricerca`,
    ja: `\u{691C}\u{7D22}\u{306E}\u{5207}\u{308A}\u{66FF}\u{3048}`,
    ko: `\u{AC80}\u{C0C9} \u{C804}\u{D658}`,
    mww: `Toggle nrhiav`,
    ps: `\u{62F} \u{644}\u{67C}\u{648}\u{646} \u{628}\u{62F}\u{644}\u{648}\u{644}`,
    pt: `Alternar pesquisa`,
    "pt-pt": `Alternar pesquisa`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{438}\u{441}\u{43A}`,
    sm: `Toggle search`,
    so: `Haku`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}`,
    ur: `Toggle search`,
    vi: `Chuy\u{1EC3}n \u{111}\u{1ED5}i t\xecm ki\u{1EBF}m`,
    "zh-hans": `\u{5207}\u{6362}\u{641C}\u{7D22}`,
    "zh-hant": `\u{5207}\u{63DB}\u{641C}\u{7D22}`,
    en: `Toggle search`
};
const $2868cc1235412e16$export$13ddb5340ae7eaf3 = {
    ar: `\u{628}\u{62D}\u{62B}...`,
    de: `Suchen...`,
    es: `Buscar...`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648}...`,
    fil: `Paghahanap...`,
    fr: `Rechercher...`,
    hi: `\u{922}\u{942}\u{901}\u{922}\u{964}\u{964}\u{964}`,
    ht: `Fouye...`,
    it: `Ricerca...`,
    ja: `\u{635C}\u{7D22}\u{3002}\u{3002}\u{3002}`,
    ko: `\u{AC80}\u{C0C9}...`,
    mww: `Nrhiav...`,
    ps: `\u{644}\u{67C}\u{648}\u{646}...`,
    pt: `Procurar...`,
    "pt-pt": `Pesquisar...`,
    ru: `\u{418}\u{441}\u{43A}\u{430}\u{442}\u{44C}...`,
    sm: `Su'esu'e...`,
    so: `Haku...`,
    th: `\u{E04}\u{E49}\u{E19}   `,
    ur: `\u{62A}\u{644}\u{627}\u{634}...`,
    vi: `T\xecm ki\u{1EBF}m...`,
    "zh-hans": `\u{641C}\u{7D22}\u{3002}\u{3002}\u{3002}`,
    "zh-hant": `\u{641C}\u{7D22}\u{3002}\u{3002}\u{3002}`,
    en: `Search...`
};
const $2868cc1235412e16$export$b6fc2912e8df702f = {
    ar: `\u{628}\u{62D}\u{62B}`,
    de: `Suchen`,
    es: `Buscar`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648}`,
    fil: `Paghahanap`,
    fr: `Rechercher`,
    hi: `\u{922}\u{942}\u{901}\u{922}`,
    ht: `Fouye`,
    it: `Ricerca`,
    ja: `\u{635C}\u{7D22}`,
    ko: `\u{AC80}\u{C0C9}`,
    mww: `nrhiav`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Procurar`,
    "pt-pt": `Pesquisar`,
    ru: `\u{418}\u{441}\u{43A}\u{430}\u{442}\u{44C}`,
    sm: `Saili`,
    so: `Haku`,
    th: `\u{E04}\u{E49}\u{E19}`,
    ur: `\u{62A}\u{644}\u{627}\u{634}`,
    vi: `T\xecm ki\u{1EBF}m`,
    "zh-hans": `\u{641C}\u{7D22}`,
    "zh-hant": `\u{641C}\u{7D22}`,
    en: `Search`
};
const $2868cc1235412e16$export$7bda472d63b843a4 = {
    ar: `\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Organisation`,
    es: `Organizaci\xf3n`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Organisasyon`,
    fr: `Organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon`,
    it: `Organizzazione`,
    ja: `\u{7D44}\u{7E54}`,
    ko: `\u{C870}\u{C9C1}`,
    mww: `Koom haum`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Organiza\xe7\xe3o`,
    "pt-pt": `Organiza\xe7\xe3o`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fa'alapotopotoga`,
    so: `Hay'ad`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    vi: `T\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{7EC4}\u{7EC7}`,
    "zh-hant": `\u{7D44}\u{7E54}`,
    en: `Organization`
};
const $2868cc1235412e16$export$177202d8e35cf0d5 = {
    ar: `\u{648}\u{637}\u{646}`,
    de: `Heim`,
    es: `Hogar`,
    fa: `\u{62E}\u{627}\u{646}\u{647}`,
    fil: `Tahanan`,
    fr: `Domicile`,
    hi: `\u{918}\u{930}`,
    ht: `Lakay`,
    it: `Casa`,
    ja: `\u{5BB6}`,
    ko: `\u{C9D1}`,
    mww: `Tsev`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Casa`,
    "pt-pt": `Casa`,
    ru: `\u{414}\u{43E}\u{43C}`,
    sm: `Aiga`,
    so: `Haku`,
    th: `\u{E1A}\u{E49}\u{E32}\u{E19}`,
    ur: `\u{6AF}\u{6BE}\u{631}`,
    vi: `Nh\xe0`,
    "zh-hans": `\u{5BB6}`,
    "zh-hant": `\u{5BB6}`,
    en: `Home`
};
const $2868cc1235412e16$export$f783852a4ad65ea8 = {
    ar: `\u{627}\u{644}\u{62A}\u{642}\u{627}\u{631}\u{64A}\u{631}`,
    de: `Berichte`,
    es: `Informes`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634}`,
    fil: `Mga Ulat`,
    fr: `Rapports`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: `Rap\xf2`,
    it: `Rapporti`,
    ja: `\u{30EC}\u{30DD}\u{30FC}\u{30C8}`,
    ko: `\u{BCF4}\u{ACE0}\u{C11C}`,
    mww: `ntaub ntawv qhia txog`,
    ps: `\u{631}\u{67E}\u{648}\u{67C}\u{648}\u{646}\u{647}`,
    pt: `Relat\xf3rios`,
    "pt-pt": `Relat\xf3rios`,
    ru: `\u{41E}\u{442}\u{447}\u{435}\u{442}\u{44B}`,
    sm: `Lipoti`,
    so: `Wararka`,
    th: `\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{631}\u{67E}\u{648}\u{631}\u{679}\u{6CC}\u{6BA}`,
    vi: `B\xe1o c\xe1o`,
    "zh-hans": `\u{62A5}\u{544A}`,
    "zh-hant": `\u{5831}\u{544A}`,
    en: `Reports`
};
const $2868cc1235412e16$export$d10d41ec6043e1b1 = {
    ar: `\u{627}\u{639}\u{62F}\u{627}\u{62F}\u{627}\u{62A}`,
    de: `Einstellungen`,
    es: `Configuraci\xf3n`,
    fa: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{627}\u{62A}`,
    fil: `Mga Setting`,
    fr: `Param\xe8tres`,
    hi: `\u{938}\u{947}\u{91F}\u{93F}\u{902}\u{917}\u{94D}\u{938}`,
    ht: `Anviw\xf2nman`,
    it: `Impostazioni`,
    ja: `\u{8A2D}\u{5B9A}`,
    ko: `\u{C124}\u{C815}`,
    mww: `Teev tseg`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Configura\xe7\xf5es`,
    "pt-pt": `Configura\xe7\xf5es`,
    ru: `\u{41F}\u{430}\u{440}\u{430}\u{43C}\u{435}\u{442}\u{440}\u{44B}`,
    sm: `Tulaga`,
    so: `Settings`,
    th: `\u{E01}\u{E32}\u{E23}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}`,
    ur: `\u{633}\u{6CC}\u{679}\u{646}\u{6AF}\u{6CC}\u{6BA}`,
    vi: `C\xe0i \u{111}\u{1EB7}t`,
    "zh-hans": `\u{8BBE}\u{7F6E}`,
    "zh-hant": `\u{8A2D}\u{7F6E}`,
    en: `Settings`
};
const $2868cc1235412e16$export$911dda8e10c12221 = {
    ar: `\u{62F}\u{639}\u{645}`,
    de: `Unterst\xfctzen`,
    es: `Apoyo`,
    fa: `\u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC}`,
    fil: `Suporta`,
    fr: `Soutien`,
    hi: `\u{91C}\u{940}\u{935}\u{93F}\u{915}\u{93E}`,
    ht: `Sip\xf2`,
    it: `Appoggiare`,
    ja: `\u{652F}\u{3048}\u{308B}`,
    ko: `\u{C9C0}\u{C6D0}`,
    mww: `kev them nyiaj yug me`,
    ps: `\u{62F} \u{647}\u{631}\u{627}\u{62A} \u{648}\u{644}\u{627}\u{6CC}\u{62A} \u{62F} \u{627}\u{645}\u{646}\u{6CC}\u{647} \u{642}\u{648}\u{645}\u{646}\u{62F}\u{627}\u{646}`,
    pt: `Apoio`,
    "pt-pt": `Suporte`,
    ru: `\u{41F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{430}`,
    sm: `Lagolago`,
    so: `Taageero`,
    th: `\u{E2A}\u{E19}\u{E31}\u{E1A}\u{E2A}\u{E19}\u{E38}\u{E19}`,
    ur: `\u{645}\u{639}\u{627}\u{648}\u{646}\u{62A}`,
    vi: `H\u{1ED7} tr\u{1EE3}`,
    "zh-hans": `\u{652F}\u{6301}`,
    "zh-hant": `\u{652F}\u{63F4}`,
    en: `Support`
};
const $2868cc1235412e16$export$6729e646902b016c = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A} \u{648}\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}`,
    de: `Profil anzeigen und mehr`,
    es: `Ver perfil y m\xe1s`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{646}\u{645}\u{627}\u{6CC}\u{647} \u{648} \u{645}\u{648}\u{627}\u{631}\u{62F} \u{62F}\u{6CC}\u{6AF}\u{631}`,
    fil: `Tingnan ang profile at higit pa`,
    fr: `Voir le profil et plus encore`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{914}\u{930} \u{905}\u{927}\u{93F}\u{915} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade pwofil ak plis ank\xf2`,
    it: `Visualizza il profilo e altro ancora`,
    ja: `\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{306A}\u{3069}\u{3092}\u{8868}\u{793A}`,
    ko: `\u{D504}\u{B85C}\u{D544} \u{B4F1} \u{BCF4}\u{AE30}`,
    mww: `Saib profile thiab ntau dua`,
    ps: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{648}\u{6AB}\u{648}\u{631}\u{626} \u{627}\u{648} \u{646}\u{648}\u{631}`,
    pt: `Ver perfil e muito mais`,
    "pt-pt": `Visualizar perfil e muito mais`,
    ru: `\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44C} \u{438} \u{43C}\u{43D}\u{43E}\u{433}\u{43E}\u{435} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{435}`,
    sm: `Va'ai talaaga otooto ma sili atu`,
    so: `View profile iyo in ka badan`,
    th: `\u{E14}\u{E39}\u{E42}\u{E1E}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E25}\u{E30}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E46}`,
    ur: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{645}\u{632}\u{6CC}\u{62F}`,
    vi: `Xem h\u{1ED3} s\u{1A1} v\xe0 h\u{1A1}n th\u{1EBF} n\u{1EEF}a`,
    "zh-hans": `\u{67E5}\u{770B}\u{4E2A}\u{4EBA}\u{8D44}\u{6599}\u{7B49}`,
    "zh-hant": `\u{67E5}\u{770B}\u{500B}\u{4EBA}\u{8CC7}\u{6599}\u{7B49}`,
    en: `View profile and more`
};
const $2868cc1235412e16$export$91d193269850f490 = {
    ar: `\u{62A}\u{628}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{634}\u{631}\u{64A}\u{637} \u{627}\u{644}\u{62C}\u{627}\u{646}\u{628}\u{64A}`,
    de: `Seitenleiste umschalten`,
    es: `Alternar barra lateral`,
    fa: `\u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{6A9}\u{644}\u{6CC}\u{62F} \u{646}\u{648}\u{627}\u{631} \u{6A9}\u{646}\u{627}\u{631}\u{6CC}`,
    fil: `I-toggle sidebar`,
    fr: `Basculer la barre lat\xe9rale`,
    hi: `\u{91F}\u{949}\u{917}\u{932} \u{938}\u{93E}\u{907}\u{921}\u{92C}\u{93E}\u{930}`,
    ht: `Toggle sidebar`,
    it: `Attiva/disattiva la barra laterale`,
    ja: `\u{30B5}\u{30A4}\u{30C9}\u{30D0}\u{30FC}\u{306E}\u{5207}\u{308A}\u{66FF}\u{3048}`,
    ko: `\u{C0AC}\u{C774}\u{B4DC}\u{BC14} \u{D1A0}\u{AE00}`,
    mww: `Toggle sidebar`,
    ps: `\u{627}\u{693}\u{62E}\u{67E}\u{67C}\u{647} \u{628}\u{62F}\u{644}\u{648}\u{644}`,
    pt: `Alternar barra lateral`,
    "pt-pt": `Alternar barra lateral`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{442}\u{44C} \u{431}\u{43E}\u{43A}\u{43E}\u{432}\u{443}\u{44E} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C}`,
    sm: `Toggle sidebar`,
    so: `Toggle sidebar`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E41}\u{E16}\u{E1A}\u{E14}\u{E49}\u{E32}\u{E19}\u{E02}\u{E49}\u{E32}\u{E07}`,
    ur: `Toggle sidebar`,
    vi: `Chuy\u{1EC3}n \u{111}\u{1ED5}i thanh b\xean`,
    "zh-hans": `\u{5207}\u{6362}\u{4FA7}\u{8FB9}\u{680F}`,
    "zh-hant": `\u{5207}\u{63DB}\u{5074}\u{908A}\u{6B04}`,
    en: `Toggle sidebar`
};
const $2868cc1235412e16$export$318c8afd1f8ee455 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{627}\u{62A}`,
    de: `Organisationen`,
    es: `Organizaciones`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Mga Organisasyon`,
    fr: `Organisations`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928}\u{94B}\u{902}`,
    ht: `\xd2ganizasyon`,
    it: `Organizzazioni`,
    ja: `\u{7D44}\u{7E54}`,
    ko: `\u{C870}\u{C9C1}`,
    mww: `Koom haum`,
    ps: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Organiza\xe7\xf5es`,
    "pt-pt": `Organiza\xe7\xf5es`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{439}`,
    sm: `Fa'alapotopotoga`,
    so: `Ururada`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{648}\u{6BA}`,
    vi: `T\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{7EC4}\u{7EC7}`,
    "zh-hant": `\u{7D44}\u{7E54}`,
    en: `Organizations`
};
const $2868cc1235412e16$export$29fd1d46de7a7ac0 = {
    ar: `\u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakt`,
    es: `Contacto`,
    fa: `\u{62A}\u{645}\u{627}\u{633}`,
    fil: `Makipag-ugnay`,
    fr: `Contact`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Kontak`,
    it: `Contatto`,
    ja: `\u{63A5}\u{89E6}`,
    ko: `\u{C811}\u{CD09}`,
    mww: `Hu`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Contato`,
    "pt-pt": `Contato`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}`,
    sm: `Fa'afeso'ota'i`,
    so: `Xiriirka`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1}`,
    vi: `S\u{1EF1} ti\u{1EBF}p x\xfac`,
    "zh-hans": `\u{8054}\u{7CFB}`,
    "zh-hant": `\u{806F}\u{7E6B}`,
    en: `Contact`
};
const $2868cc1235412e16$export$55a5d9027c8ca2e0 = {
    ar: `\u{62E}\u{628}\u{631}`,
    de: `Nachrichten`,
    es: `Noticia`,
    fa: `\u{627}\u{62E}\u{628}\u{627}\u{631}`,
    fil: `Balita`,
    fr: `Nouvelles`,
    hi: `\u{938}\u{92E}\u{93E}\u{91A}\u{93E}\u{930}`,
    ht: `Nouv\xe8l`,
    it: `Notizie`,
    ja: `\u{30CB}\u{30E5}\u{30FC}\u{30B9}`,
    ko: `\u{C18C}\u{C2DD}`,
    mww: `Moo`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Not\xedcia`,
    "pt-pt": `Not\xedcias`,
    ru: `\u{41D}\u{43E}\u{432}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Tala Fou`,
    so: `Wararka`,
    th: `\u{E02}\u{E48}\u{E32}\u{E27}`,
    ur: `\u{62E}\u{628}\u{631}`,
    vi: `Tin t\u{1EE9}c`,
    "zh-hans": `\u{65B0}\u{95FB}`,
    "zh-hant": `\u{65B0}\u{805E}`,
    en: `News`
};
const $2868cc1235412e16$export$651ee9ff79413819 = {
    ar: `\u{639}\u{646}`,
    de: `\xdcber`,
    es: `Acerca de`,
    fa: `\u{645}\u{648}\u{631}\u{62F}`,
    fil: `Tungkol sa`,
    fr: `Environ`,
    hi: `\u{915}\u{930}\u{940}\u{92C}\u{928}`,
    ht: `Sou`,
    it: `Circa`,
    ja: `\u{306B}\u{95A2}\u{3057}\u{3066}\u{306F}`,
    ko: `\u{C57D}`,
    mww: `Txog`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Sobre`,
    "pt-pt": `Sobre n\xf3s`,
    ru: `\u{41E}\u{43A}\u{43E}\u{43B}\u{43E}`,
    sm: `E uiga i`,
    so: `Ku saabsan`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E21}\u{E32}\u{E13}`,
    ur: `\u{62A}\u{642}\u{631}\u{6CC}\u{628}\u{627}\u{64B}`,
    vi: `V\u{1EC1}`,
    "zh-hans": `\u{5927}\u{7EA6}`,
    "zh-hant": `\u{5927}\u{7D04}`,
    en: `About`
};
const $2868cc1235412e16$export$df7d62b22f2942d4 = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644}`,
    de: `Anmelden`,
    es: `Inicia sesi\xf3n`,
    fa: `\u{648}\u{631}\u{648}\u{62F} \u{628}\u{647} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Mag-sign in`,
    fr: `Connexion`,
    hi: `\u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Antre`,
    it: `Accedi`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}`,
    ko: `\u{C11C}\u{BA85}\u{D558}\u{C138}\u{C694}`,
    mww: `Sau npe nkag mus`,
    ps: `\u{62F}\u{646}\u{646}\u{647} \u{634}\u{647}`,
    pt: `Entrar`,
    "pt-pt": `Iniciar sess\xe3o`,
    ru: `\u{412}\u{43E}\u{439}\u{442}\u{438}`,
    sm: `Saini`,
    so: `Gal`,
    th: `\u{E40}\u{E02}\u{E49}\u{E32}\u{E2A}\u{E39}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E1A}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng nh\u{1EAD}p`,
    "zh-hans": `\u{767B}\u{5F55}`,
    "zh-hant": `\u{767B}\u{9304}`,
    en: `Sign in`
};
const $2868cc1235412e16$export$c5f3019e79d09a30 = {
    ar: `\u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644}`,
    de: `Anmelden`,
    es: `\xdanete`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645}`,
    fil: `Email Address *`,
    fr: `S\u{2019}enregistrer`,
    hi: `\u{928}\u{93E}\u{92E} \u{932}\u{93F}\u{916}\u{94B}`,
    ht: `Enskri`,
    it: `Registrati`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30C3}\u{30D7}`,
    ko: `\u{B4F1}\u{B85D}\u{D558}\u{C138}\u{C694}`,
    mww: `Cuv npe`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{648}\u{6A9}\u{693}\u{647}`,
    pt: `Inscri\xe7\xe3o`,
    "pt-pt": `Registar-me`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Resitala`,
    so: `Diiwaangeli`,
    th: `\u{E44}\u{E0B}\u{E19}\u{E4C}\u{E2D}\u{E31}\u{E1E}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{627}\u{67E} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    "zh-hans": `\u{767B}\u{8BB0}`,
    "zh-hant": `\u{767B}\u{8A18}`,
    en: `Sign up`
};
const $2868cc1235412e16$export$945006ae9f8dcf14 = {
    ar: (login)=>`\u{62A}\u{645} \u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{628}\u{627}\u{633}\u{645} ${login}`,
    de: (login)=>`Angemeldet als ${login}`,
    es: (login)=>`Iniciado sesi\xf3n como ${login}`,
    fa: (login)=>`\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{628}\u{647} \u{639}\u{646}\u{648}\u{627}\u{646} ${login}`,
    fil: (login)=>`Naka-sign in bilang ${login}`,
    fr: (login)=>`Connect\xe9 en tant que ${login}`,
    hi: (login)=>`${login} \u{915}\u{947} \u{930}\u{942}\u{92A} \u{92E}\u{947}\u{902} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{93F}\u{92F}\u{93E}`,
    ht: (login)=>`Siyen ${login}`,
    it: (login)=>`Ha effettuato l'accesso come ${login}`,
    ja: (login)=>`${login} \u{3068}\u{3057}\u{3066}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}`,
    ko: (login)=>`${login}\u{C73C}\u{B85C} \u{B85C}\u{ADF8}\u{C778}\u{B428}`,
    mww: (login)=>`Kos npe raws li ${login}`,
    ps: (login)=>`\u{62F} ${login} \u{67E}\u{647} \u{62A}\u{648}\u{6AB}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC}`,
    pt: (login)=>`Conectado como ${login}`,
    "pt-pt": (login)=>`Entrou como ${login}`,
    ru: (login)=>`\u{412}\u{43E}\u{448}\u{435}\u{43B} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443} \u{43A}\u{430}\u{43A} ${login}`,
    sm: (login)=>`Saini i totonu o ${login}`,
    so: (login)=>`Saxiixay sida ${login}`,
    th: (login)=>`\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1B}\u{E47}\u{E19} ${login}`,
    ur: (login)=>`${login} \u{6A9}\u{6D2} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{6CC}\u{627}`,
    vi: (login)=>`\u{110}\u{103}ng nh\u{1EAD}p v\u{1EDB}i t\u{1B0} c\xe1ch l\xe0 ${login}`,
    "zh-hans": (login)=>`\u{4EE5} ${login} \u{8EAB}\u{4EFD}\u{767B}\u{5F55}`,
    "zh-hant": (login)=>`\u{4EE5} ${login} \u{8EAB}\u{4EFD}\u{767B}\u{9304}`,
    en: (login)=>`Signed in as ${login}`
};
const $2868cc1235412e16$export$6380852208e673e5 = {
    ar: `\u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{644}\u{634}\u{62E}\u{635}\u{64A} \u{648}\u{627}\u{644}\u{62D}\u{633}\u{627}\u{628}`,
    de: `Profil & Konto bearbeiten`,
    es: `Editar perfil y cuenta`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{648} \u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6CC}`,
    fil: `I-edit ang profile at account`,
    fr: `Modifier le profil et le compte`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{914}\u{930} \u{916}\u{93E}\u{924}\u{93E} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit pwofil & kont`,
    it: `Modifica profilo e account`,
    ja: `\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{3068}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{306E}\u{7DE8}\u{96C6}`,
    ko: `\u{D504}\u{B85C}\u{D544} \u{BC0F} \u{ACC4}\u{C815} \u{D3B8}\u{C9D1}`,
    mww: `Edit profile & account`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{641}\u{627}\u{6CC}\u{644} \u{627}\u{648} \u{62D}\u{633}\u{627}\u{628} \u{633}\u{645}\u{648}\u{646}`,
    pt: `Editar perfil e conta`,
    "pt-pt": `Editar perfil & conta`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44F} \u{438} \u{443}\u{447}\u{435}\u{442}\u{43D}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}`,
    sm: `Fa'asa'o talaaga otooto ma teuga tupe`,
    so: `Bedelaada borofayl & account`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E42}\u{E1B}\u{E23}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E25}\u{E30}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}`,
    ur: `\u{67E}\u{631}\u{648}\u{641}\u{627}\u{626}\u{644} \u{627}\u{648}\u{631} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a h\u{1ED3} s\u{1A1} v\xe0 t\xe0i kho\u{1EA3}n`,
    "zh-hans": `\u{7F16}\u{8F91}\u{4E2A}\u{4EBA}\u{8D44}\u{6599}\u{548C}\u{8D26}\u{6237}`,
    "zh-hant": `\u{7DE8}\u{8F2F}\u{500B}\u{4EBA}\u{8CC7}\u{6599}\u{548C}\u{5E33}\u{6236}`,
    en: `Edit profile & account`
};
const $2868cc1235412e16$export$12c93f49b1bc9e53 = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62E}\u{631}\u{648}\u{62C}`,
    de: `Abmelden`,
    es: `Cerrar sesi\xf3n`,
    fa: `\u{62E}\u{631}\u{648}\u{62C} \u{627}\u{632} \u{633}\u{6CC}\u{633}\u{62A}\u{645}`,
    fil: `Mag-sign out`,
    fr: `Se d\xe9connecter`,
    hi: `\u{938}\u{93E}\u{907}\u{928} \u{906}\u{909}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Siyen`,
    it: `Disconnettersi`,
    ja: `\u{30B5}\u{30A4}\u{30F3}\u{30A2}\u{30A6}\u{30C8}`,
    ko: `\u{B85C}\u{ADF8}\u{C544}\u{C6C3}`,
    mww: `kos npe rau`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Sair`,
    "pt-pt": `Sair`,
    ru: `\u{412}\u{44B}\u{439}\u{442}\u{438} \u{438}\u{437} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{44B}`,
    sm: `Saini i fafo`,
    so: `Saxiix`,
    th: `\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E2D}\u{E2D}\u{E01}`,
    ur: `\u{633}\u{627}\u{626}\u{646} \u{622}\u{624}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{103}ng xu\u{1EA5}t`,
    "zh-hans": `\u{767B}\u{51FA}`,
    "zh-hant": `\u{767B}\u{51FA}`,
    en: `Sign out`
};
const $2868cc1235412e16$export$5af50732e0f3df9b = {
    ar: `\u{646}\u{62D}\u{646} \u{646}\u{639}\u{645}\u{644} \u{639}\u{644}\u{649} \u{62A}\u{648}\u{641}\u{64A}\u{631} \u{627}\u{644}\u{62A}\u{631}\u{62C}\u{645}\u{629} \u{644}\u{644}\u{63A}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{630}\u{643}\u{648}\u{631}\u{629} \u{623}\u{62F}\u{646}\u{627}\u{647}. \u{633}\u{62A}\u{638}\u{647}\u{631} \u{645}\u{646}\u{627}\u{637}\u{642} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{62A}\u{64A} \u{644}\u{645} \u{62A}\u{62A}\u{645} \u{62A}\u{631}\u{62C}\u{645}\u{62A}\u{647}\u{627} \u{628}\u{639}\u{62F} \u{628}\u{627}\u{644}\u{644}\u{63A}\u{629} \u{627}\u{644}\u{625}\u{646}\u{62C}\u{644}\u{64A}\u{632}\u{64A}\u{629}.`,
    de: `Wir arbeiten daran, \xdcbersetzungen f\xfcr die unten aufgef\xfchrten Sprachen bereitzustellen. Bereiche der Website, die noch nicht \xfcbersetzt wurden, werden auf Englisch angezeigt.`,
    es: `Estamos trabajando para proporcionar traducci\xf3n a los idiomas que se enumeran a continuaci\xf3n. Las \xe1reas del sitio que a\xfan no han sido traducidas aparecer\xe1n en ingl\xe9s.`,
    fa: `\u{645}\u{627} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{6A9}\u{627}\u{631} \u{628}\u{631} \u{631}\u{648}\u{6CC} \u{627}\u{631}\u{627}\u{626}\u{647} \u{62A}\u{631}\u{62C}\u{645}\u{647} \u{628}\u{631}\u{627}\u{6CC} \u{632}\u{628}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{647}\u{633}\u{62A}\u{6CC}\u{645}. \u{645}\u{646}\u{627}\u{637}\u{642}\u{6CC} \u{627}\u{632} \u{633}\u{627}\u{6CC}\u{62A} \u{6A9}\u{647} \u{647}\u{646}\u{648}\u{632} \u{62A}\u{631}\u{62C}\u{645}\u{647} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{646}\u{62F} \u{628}\u{647} \u{632}\u{628}\u{627}\u{646} \u{627}\u{646}\u{6AF}\u{644}\u{6CC}\u{633}\u{6CC} \u{638}\u{627}\u{647}\u{631} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Nagtatrabaho kami sa pagbibigay ng pagsasalin para sa mga wika na nakalista sa ibaba. Ang mga bahagi ng site na hindi pa isinalin ay lilitaw sa Ingles.`,
    fr: `Nous travaillons \xe0 la traduction pour les langues \xe9num\xe9r\xe9es ci-dessous. Les parties du site qui n\u{2019}ont pas encore \xe9t\xe9 traduites appara\xeetront en anglais.`,
    hi: `\u{939}\u{92E} \u{928}\u{940}\u{91A}\u{947} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{92D}\u{93E}\u{937}\u{93E}\u{913}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{928}\u{941}\u{935}\u{93E}\u{926} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{930}\u{928}\u{947} \u{92A}\u{930} \u{915}\u{93E}\u{92E} \u{915}\u{930} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902}\u{964} \u{938}\u{93E}\u{907}\u{91F} \u{915}\u{947} \u{91C}\u{93F}\u{928} \u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}\u{94B}\u{902} \u{915}\u{93E} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{905}\u{928}\u{941}\u{935}\u{93E}\u{926} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}, \u{935}\u{947} \u{905}\u{902}\u{917}\u{94D}\u{930}\u{947}\u{91C}\u{940} \u{92E}\u{947}\u{902} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{902}\u{917}\u{947}\u{964}`,
    ht: `N ap travay sou bay tradiksyon pou lang ki nan lis anba a. Z\xf2n nan sit la ki poko tradui ap par\xe8t nan lang angle.`,
    it: `Stiamo lavorando per fornire la traduzione per le lingue elencate di seguito. Le aree del sito che non sono ancora state tradotte appariranno in inglese.`,
    ja: `\u{73FE}\u{5728}\u{3001}\u{4EE5}\u{4E0B}\u{306E}\u{8A00}\u{8A9E}\u{306E}\u{7FFB}\u{8A33}\u{306B}\u{53D6}\u{308A}\u{7D44}\u{3093}\u{3067}\u{3044}\u{307E}\u{3059}\u{3002}\u{30B5}\u{30A4}\u{30C8}\u{306E}\u{307E}\u{3060}\u{7FFB}\u{8A33}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{9818}\u{57DF}\u{306F}\u{82F1}\u{8A9E}\u{3067}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `Google\u{C740} \u{C544}\u{B798} \u{B098}\u{C5F4}\u{B41C} \u{C5B8}\u{C5B4}\u{C5D0} \u{B300}\u{D55C} \u{BC88}\u{C5ED}\u{C744} \u{C81C}\u{ACF5}\u{D558}\u{AE30} \u{C704}\u{D574} \u{B178}\u{B825}\u{D558}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C544}\u{C9C1} \u{BC88}\u{C5ED}\u{B418}\u{C9C0} \u{C54A}\u{C740} \u{C0AC}\u{C774}\u{D2B8} \u{C601}\u{C5ED}\u{C740} \u{C601}\u{C5B4}\u{B85C} \u{D45C}\u{C2DC}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Peb nyob nraum ua hauj lwm rau kev muab txhais lus rau cov lus teev nyob rau hauv qab no. Tej thaj chaw uas tsis tau tau txhais lus Askiv yuav tshwm sim nyob rau lus Askiv.`,
    ps: `\u{645}\u{648}\u{696} \u{62F} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{644}\u{633}\u{62A} \u{634}\u{648}\u{6CC}\u{648} \u{698}\u{628}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{698}\u{628}\u{627}\u{693}\u{6D0} \u{67E}\u{647} \u{686}\u{645}\u{62A}\u{648} \u{6A9}\u{648}\u{644}\u{648} \u{6A9}\u{627}\u{631} \u{6A9}\u{648}\u{648}. \u{62F} \u{633}\u{627}\u{6CC}\u{67C} \u{647}\u{63A}\u{647} \u{628}\u{631}\u{62E}\u{6D0} \u{686}\u{6D0} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{646}\u{647} \u{62F}\u{6CC} \u{698}\u{628}\u{627}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{67E}\u{647} \u{627}\u{646}\u{6AB}\u{644}\u{6CC}\u{633}\u{6CC} \u{6A9}\u{6D0} \u{628}\u{647} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{634}\u{6CC}.`,
    pt: `Estamos trabalhando para fornecer tradu\xe7\xe3o para os idiomas listados abaixo. As \xe1reas do site que ainda n\xe3o foram traduzidas aparecer\xe3o em ingl\xeas.`,
    "pt-pt": `Estamos trabalhando para fornecer tradu\xe7\xe3o para os idiomas listados abaixo. As \xe1reas do s\xedtio que ainda n\xe3o foram traduzidas ser\xe3o apresentadas em ingl\xeas.`,
    ru: `\u{41C}\u{44B} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{435}\u{43C} \u{43D}\u{430}\u{434} \u{43F}\u{435}\u{440}\u{435}\u{432}\u{43E}\u{434}\u{43E}\u{43C} \u{43D}\u{430} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{43D}\u{438}\u{436}\u{435} \u{44F}\u{437}\u{44B}\u{43A}\u{438}. \u{420}\u{430}\u{437}\u{434}\u{435}\u{43B}\u{44B} \u{441}\u{430}\u{439}\u{442}\u{430}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{431}\u{44B}\u{43B}\u{438} \u{43F}\u{435}\u{440}\u{435}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{44B}, \u{431}\u{443}\u{434}\u{443}\u{442} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} \u{430}\u{43D}\u{433}\u{43B}\u{438}\u{439}\u{441}\u{43A}\u{43E}\u{43C} \u{44F}\u{437}\u{44B}\u{43A}\u{435}.`,
    sm: `O lo'o matou galulue i le tu'uina atu o fa'aliliuga mo gagana o lo'o lisiina atu i lalo. O vaega o le saite e le'i faaliliuina o le a faaali mai i le gagana Peretania.`,
    so: `Waxaan ka shaqaynaynaa bixinta turjumaadda luuqadaha hoos ku qoran. Meelaha ka mid ah goobta oo aan weli la turjumay ku muuqan doona ingriiska.`,
    th: `\u{E40}\u{E23}\u{E32}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E41}\u{E1B}\u{E25}\u{E20}\u{E32}\u{E29}\u{E32}\u{E15}\u{E32}\u{E21}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07} \u{E1E}\u{E37}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E41}\u{E1B}\u{E25}\u{E08}\u{E30}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E20}\u{E32}\u{E29}\u{E32}\u{E2D}\u{E31}\u{E07}\u{E01}\u{E24}\u{E29}`,
    ur: `\u{6C1}\u{645} \u{630}\u{6CC}\u{644} \u{645}\u{6CC}\u{6BA} \u{62F}\u{631}\u{62C} \u{632}\u{628}\u{627}\u{646}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{62A}\u{631}\u{62C}\u{645}\u{6C1} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{67E}\u{631} \u{6A9}\u{627}\u{645} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}. \u{633}\u{627}\u{626}\u{679} \u{6A9}\u{6D2} \u{648}\u{6C1} \u{639}\u{644}\u{627}\u{642}\u{6D2} \u{62C}\u{648} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{62A}\u{631}\u{62C}\u{645}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{6D2} \u{6AF}\u{626}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{646}\u{6AF}\u{631}\u{6CC}\u{632}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `Ch\xfang t\xf4i \u{111}ang l\xe0m vi\u{1EC7}c \u{111}\u{1EC3} cung c\u{1EA5}p d\u{1ECB}ch thu\u{1EAD}t cho c\xe1c ng\xf4n ng\u{1EEF} \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea d\u{1B0}\u{1EDB}i \u{111}\xe2y. C\xe1c khu v\u{1EF1}c c\u{1EE7}a trang web ch\u{1B0}a \u{111}\u{1B0}\u{1EE3}c d\u{1ECB}ch s\u{1EBD} xu\u{1EA5}t hi\u{1EC7}n b\u{1EB1}ng ti\u{1EBF}ng Anh.`,
    "zh-hans": `\u{6211}\u{4EEC}\u{6B63}\u{5728}\u{52AA}\u{529B}\u{4E3A}\u{4E0B}\u{5217}\u{8BED}\u{8A00}\u{63D0}\u{4F9B}\u{7FFB}\u{8BD1}\u{3002}\u{7F51}\u{7AD9}\u{4E2D}\u{5C1A}\u{672A}\u{7FFB}\u{8BD1}\u{7684}\u{533A}\u{57DF}\u{5C06}\u{4EE5}\u{82F1}\u{6587}\u{663E}\u{793A}\u{3002}`,
    "zh-hant": `\u{6211}\u{5011}\u{6B63}\u{5728}\u{52AA}\u{529B}\u{70BA}\u{4E0B}\u{5217}\u{8A9E}\u{8A00}\u{63D0}\u{4F9B}\u{7FFB}\u{8B6F}\u{3002}\u{7DB2}\u{7AD9}\u{4E2D}\u{5C1A}\u{672A}\u{7FFB}\u{8B6F}\u{7684}\u{5340}\u{57DF}\u{5C07}\u{4EE5}\u{82F1}\u{6587}\u{986F}\u{793A}\u{3002}`,
    en: `We're working on providing translation for the languages listed below. Areas of the site which have not yet been translated will appear in English.`
};
const $2868cc1235412e16$export$478f773b207f692f = {
    ar: `\u{63A}\u{644}\u{642}`,
    de: `Schlie\xdfen`,
    es: `Cerrar`,
    fa: `\u{646}\u{632}\u{62F}\u{6CC}\u{6A9}`,
    fil: `Isara`,
    fr: `Fermer`,
    hi: `\u{92C}\u{902}\u{926} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `F\xe8men`,
    it: `Chiudere`,
    ja: `\u{9589}\u{3081}\u{308B}`,
    ko: `\u{B2EB}\u{B2E4}`,
    mww: `Kaw`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Fechar`,
    "pt-pt": `Fechar`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Tapuni`,
    so: `Kuuma`,
    th: `\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{628}\u{646}\u{62F} \u{6A9}\u{631}\u{646}\u{627}`,
    vi: `\u{110}\xf3ng`,
    "zh-hans": `\u{5173}\u{95ED}`,
    "zh-hant": `\u{95DC}\u{9589}`,
    en: `Close`
};
const $2868cc1235412e16$export$46741619b6614a26 = {
    ar: `\u{633}\u{64A}\u{62A}\u{648}\u{641}\u{631} \u{639}\u{646}\u{648}\u{627}\u{646} URL \u{627}\u{644}\u{639}\u{627}\u{645} \u{648}\u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629} \u{648}\u{648}\u{631}\u{642}\u{629} \u{627}\u{644}\u{639}\u{645}\u{644} \u{627}\u{644}\u{642}\u{627}\u{628}\u{644}\u{629} \u{644}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629} \u{628}\u{639}\u{62F} \u{627}\u{644}\u{62D}\u{641}\u{638}.`,
    de: `Die \xf6ffentliche URL, der QR-Code und das druckbare Arbeitsblatt sind nach dem Speichern verf\xfcgbar.`,
    es: `La URL p\xfablica, el c\xf3digo QR y la hoja de trabajo imprimible estar\xe1n disponibles despu\xe9s de guardar.`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{627}\u{6CC}\u{646}\u{62A}\u{631}\u{646}\u{62A}\u{6CC} \u{639}\u{645}\u{648}\u{645}\u{6CC}\u{60C} \u{6A9}\u{62F} QR \u{648} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{6AF} \u{642}\u{627}\u{628}\u{644} \u{686}\u{627}\u{67E} \u{67E}\u{633} \u{627}\u{632} \u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{62F}\u{631} \u{62F}\u{633}\u{62A}\u{631}\u{633} \u{62E}\u{648}\u{627}\u{647}\u{646}\u{62F} \u{628}\u{648}\u{62F}.`,
    fil: `Ang pampublikong url, QR code, at mai-print na worksheet ay magagamit pagkatapos i-save.`,
    fr: `L\u{2019}URL publique, le code QR et la feuille de travail imprimable seront disponibles apr\xe8s l\u{2019}enregistrement.`,
    hi: `\u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} url, QR \u{915}\u{94B}\u{921} \u{914}\u{930} \u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{92F}\u{94B}\u{917}\u{94D}\u{92F} \u{935}\u{930}\u{94D}\u{915}\u{936}\u{940}\u{91F} \u{938}\u{939}\u{947}\u{91C}\u{928}\u{947} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{939}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `K\xf2d piblik, k\xf2d QR, ak F\xe8y kalkil enprime ap disponib apre ekonomize.`,
    it: `L'URL pubblico, il codice QR e il foglio di lavoro stampabile saranno disponibili dopo il salvataggio.`,
    ja: `\u{516C}\u{958B}URL\u{3001}QR\u{30B3}\u{30FC}\u{30C9}\u{3001}\u{5370}\u{5237}\u{53EF}\u{80FD}\u{306A}\u{30EF}\u{30FC}\u{30AF}\u{30B7}\u{30FC}\u{30C8}\u{306F}\u{3001}\u{4FDD}\u{5B58}\u{5F8C}\u{306B}\u{5229}\u{7528}\u{53EF}\u{80FD}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{ACF5}\u{AC1C} URL, QR \u{CF54}\u{B4DC} \u{BC0F} \u{C778}\u{C1C4} \u{AC00}\u{B2A5}\u{D55C} \u{C6CC}\u{D06C}\u{C2DC}\u{D2B8}\u{B294} \u{C800}\u{C7A5} \u{D6C4} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Pej xeem url, QR code, thiab printable worksheet yuav muaj tom qab txuag.`,
    ps: `\u{639}\u{627}\u{645}\u{647} URL\u{60C} QR \u{6A9}\u{648}\u{689}\u{60C} \u{627}\u{648} \u{62F} \u{686}\u{627}\u{67E} \u{648}\u{693} \u{648}\u{631}\u{6A9} \u{67E}\u{627}\u{6BC}\u{647} \u{628}\u{647} \u{62F} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{648}\u{644}\u{648} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{647} \u{634}\u{62A}\u{648}\u{646} \u{648}\u{644}\u{631}\u{6CC}.`,
    pt: `URL p\xfablico, c\xf3digo QR e planilha para impress\xe3o estar\xe3o dispon\xedveis ap\xf3s salvar.`,
    "pt-pt": `URL p\xfablica, c\xf3digo QR e planilha imprim\xedvel estar\xe3o dispon\xedveis ap\xf3s salvar.`,
    ru: `\u{41E}\u{431}\u{449}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B}\u{439} URL-\u{430}\u{434}\u{440}\u{435}\u{441}, QR-\u{43A}\u{43E}\u{434} \u{438} \u{440}\u{430}\u{441}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{44B}\u{432}\u{430}\u{435}\u{43C}\u{44B}\u{439} \u{43B}\u{438}\u{441}\u{442} \u{431}\u{443}\u{434}\u{443}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{44B} \u{43F}\u{43E}\u{441}\u{43B}\u{435} \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: `O le a maua le URL lautele, QR code, ma le pepa o galuega e mafai ona lolomiina pe a uma ona sefeina.`,
    so: `Public url, QR code, iyo wargeyska daabacan karo ayaa la heli doonaa ka dib marka la kaydiyo.`,
    th: `URL \u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30} \u{E23}\u{E2B}\u{E31}\u{E2A} QR \u{E41}\u{E25}\u{E30}\u{E41}\u{E1C}\u{E48}\u{E19}\u{E07}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E44}\u{E14}\u{E49}\u{E08}\u{E30}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}`,
    ur: `\u{67E}\u{628}\u{644}\u{6A9} \u{6CC}\u{648} \u{622}\u{631} \u{627}\u{6CC}\u{644} \u{60C} \u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{688} \u{60C} \u{627}\u{648}\u{631} \u{67E}\u{631}\u{646}\u{679} \u{627}\u{6CC}\u{628}\u{644} \u{648}\u{631}\u{6A9} \u{634}\u{6CC}\u{679} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{6C1}\u{648}\u{6AF}\u{6CC}\u{6D4}`,
    vi: `URL c\xf4ng khai, m\xe3 QR v\xe0 b\u{1EA3}ng t\xednh c\xf3 th\u{1EC3} in s\u{1EBD} c\xf3 s\u{1EB5}n sau khi l\u{1B0}u.`,
    "zh-hans": `\u{4FDD}\u{5B58}\u{540E}\u{FF0C}\u{516C}\u{5171} URL\u{3001}QR \u{7801}\u{548C}\u{53EF}\u{6253}\u{5370}\u{5DE5}\u{4F5C}\u{8868}\u{5C06}\u{53EF}\u{7528}\u{3002}`,
    "zh-hant": `\u{4FDD}\u{5B58}\u{540E}\u{FF0C}\u{516C}\u{5171} URL\u{3001}QR \u{78BC}\u{548C}\u{53EF}\u{5217}\u{5370}\u{5DE5}\u{4F5C}\u{8868}\u{5C07}\u{53EF}\u{7528}\u{3002}`,
    en: `Public url, QR code, and printable worksheet will be available after saving.`
};
const $2868cc1235412e16$export$f3f08f4011de90bf = {
    ar: `\u{645}\u{633}\u{648}\u{62F}\u{629}`,
    de: `Entwurf`,
    es: `Corriente de aire`,
    fa: `\u{67E}\u{6CC}\u{634} \u{646}\u{648}\u{6CC}\u{633}`,
    fil: `Draft`,
    fr: `Brouillon`,
    hi: `\u{92E}\u{938}\u{94C}\u{926}\u{93E}`,
    ht: `Pwoj\xe8`,
    it: `Bozza`,
    ja: `\u{30C9}\u{30E9}\u{30D5}\u{30C8}`,
    ko: `\u{CD08}\u{C548}`,
    mww: `cua ntsawj ntshab`,
    ps: `\u{645}\u{633}\u{648}\u{62F}\u{647}`,
    pt: `Rascunho`,
    "pt-pt": `Projeto`,
    ru: `\u{427}\u{435}\u{440}\u{43D}\u{43E}\u{432}\u{438}\u{43A}`,
    sm: `Fa'ata'ita'iga`,
    so: `Dastuurka`,
    th: `\u{E23}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{645}\u{633}\u{648}\u{62F}\u{6C1}`,
    vi: `D\u{1EF1} th\u{1EA3}o`,
    "zh-hans": `\u{8349}\u{6848}`,
    "zh-hant": `\u{8349}\u{6848}`,
    en: `Draft`
};
const $2868cc1235412e16$export$f8107b180cdf43b3 = {
    ar: `\u{62C}\u{627}\u{647}\u{632}`,
    de: `Fertig`,
    es: `Listo`,
    fa: `\u{622}\u{645}\u{627}\u{62F}\u{647}`,
    fil: `Handa na`,
    fr: `Pr\xeat`,
    hi: `\u{924}\u{948}\u{92F}\u{93E}\u{930}`,
    ht: `Pare`,
    it: `Pronto`,
    ja: `\u{7528}\u{610F}`,
    ko: `\u{C900}\u{BE44}\u{B41C}`,
    mww: `npaj txhij`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Pronto`,
    "pt-pt": `Pronto`,
    ru: `\u{413}\u{43E}\u{442}\u{43E}\u{432}\u{44B}\u{439}`,
    sm: `Sauni`,
    so: `Ready`,
    th: `\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}`,
    ur: `\u{62A}\u{6CC}\u{627}\u{631}`,
    vi: `S\u{1EB5}n s\xe0ng`,
    "zh-hans": `\u{51C6}\u{5907}`,
    "zh-hant": `\u{6E96}\u{5099}`,
    en: `Ready`
};
const $2868cc1235412e16$export$e3df7b8d35edbd9d = {
    ar: `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630}`,
    de: `Im Gange`,
    es: `En curso`,
    fa: `\u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{627}\u{633}\u{62A}`,
    fil: `Sa pag-unlad`,
    fr: `En cours`,
    hi: `\u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{92A}\u{930} \u{939}\u{948}`,
    ht: `Nan pwogr\xe8`,
    it: `In corso`,
    ja: `\u{9032}\u{884C}\u{4E2D}\u{3067}`,
    ko: `\u{C9C4}\u{D589} \u{C911}`,
    mww: `Kev kawm tau zoo`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Em andamento`,
    "pt-pt": `Em curso`,
    ru: `\u{420}\u{430}\u{437}\u{432}\u{438}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `O loo faagasolo`,
    so: `In la socdo`,
    th: `\u{E2D}\u{E22}\u{E39}\u{E48}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{62C}\u{627}\u{631}\u{6CC} \u{6C1}\u{6D2}`,
    vi: `\u{110}ang ti\u{1EBF}n h\xe0nh`,
    "zh-hans": `\u{8FDB}\u{884C}\u{4E2D}`,
    "zh-hant": `\u{9032}\u{884C}\u{4E2D}`,
    en: `In progress`
};
const $2868cc1235412e16$export$49b81392f6018765 = {
    ar: `\u{627}\u{643}\u{645}\u{627}\u{644}`,
    de: `Abgeschlossen`,
    es: `Completado`,
    fa: `\u{62A}\u{6A9}\u{645}\u{6CC}\u{644}`,
    fil: `Nakumpleto`,
    fr: `Termin\xe9`,
    hi: `\u{92A}\u{942}\u{930}\u{93E} \u{915}\u{93F}\u{92F}\u{93E}`,
    ht: `Ranpli`,
    it: `Finito`,
    ja: `\u{5B8C}\u{4E86}`,
    ko: `\u{C644}\u{B8CC}`,
    mww: `tiav`,
    ps: `\u{628}\u{634}\u{67E}\u{693}`,
    pt: `Conclu\xeddo`,
    "pt-pt": `Conclu\xedda |`,
    ru: `\u{417}\u{430}\u{432}\u{435}\u{440}\u{448}\u{451}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `Faamaeaina`,
    so: `Dhameystiran`,
    th: `\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08} \u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{645}\u{6A9}\u{645}\u{644}`,
    vi: `Ho\xe0n th\xe0nh`,
    "zh-hans": `\u{5B8C}\u{6210}`,
    "zh-hant": `\u{5B8C}\u{6210}`,
    en: `Completed`
};
const $2868cc1235412e16$export$c6aa1bfa918ebf18 = {
    ar: `\u{627}\u{644}\u{63A}\u{627}\u{621}`,
    de: `Abgebrochen`,
    es: `Anulado`,
    fa: `\u{644}\u{63A}\u{648}`,
    fil: `Kinansela`,
    fr: `Annul\xe9`,
    hi: `\u{930}\u{926}\u{94D}\u{926}`,
    ht: `anile`,
    it: `Annullato`,
    ja: `\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}`,
    ko: `\u{CDE8}\u{C18C}`,
    mww: `lawm os`,
    ps: `\u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}`,
    pt: `Cancelado`,
    "pt-pt": `Cancelado`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}`,
    sm: `Fa'aleaogaina`,
    so: `La joojiyay`,
    th: `\u{E22}\u{E01} \u{E40}\u{E25}\u{E34}\u{E01}`,
    ur: `\u{645}\u{646}\u{633}\u{648}\u{62E}`,
    vi: `B\u{1ECB} h\u{1EE7}y b\u{1ECF}`,
    "zh-hans": `\u{53D6}\u{6D88}`,
    "zh-hant": `\u{53D6}\u{6D88}`,
    en: `Cancelled`
};
const $2868cc1235412e16$export$9f13a839d14cd3a4 = {
    ar: `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    de: `In der Warteschleife`,
    es: `En espera`,
    fa: `\u{62F}\u{631} \u{62D}\u{627}\u{644}\u{62A} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`,
    fil: `Naka-hold`,
    fr: `En attente`,
    hi: `\u{939}\u{94B}\u{932}\u{94D}\u{921} \u{92A}\u{930}`,
    ht: `sou kenbe`,
    it: `In sospeso`,
    ja: `\u{4FDD}\u{7559}\u{4E2D}`,
    ko: `\u{BCF4}\u{B958} \u{C911}`,
    mww: `tuav`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Em espera`,
    "pt-pt": `Em espera`,
    ru: `\u{41D}\u{430} \u{443}\u{434}\u{435}\u{440}\u{436}\u{430}\u{43D}\u{438}\u{438}`,
    sm: `O lo'o taofia`,
    so: `Oo la qabanayaa`,
    th: `\u{E1E}\u{E31}\u{E01}\u{E2A}\u{E32}\u{E22}`,
    ur: `\u{631}\u{648}\u{6A9} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `T\u{1EA1}m d\u{1EEB}ng`,
    "zh-hans": `\u{6682}\u{505C}`,
    "zh-hant": `\u{66AB}\u{505C}`,
    en: `On hold`
};
const $2868cc1235412e16$export$93c766db6ab6fc80 = {
    ar: (status)=>`${status} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621} \u{645}\u{646} \u{627}\u{644}\u{645}\u{62C}\u{645}\u{648}\u{639}\u{629}`,
    de: (status)=>`Set ${status}`,
    es: (status)=>`${status}`,
    fa: (status)=>`\u{645}\u{62C}\u{645}\u{648}\u{639}\u{647} ${status} \u{634}\u{62F}`,
    fil: (status)=>`${status}`,
    fr: (status)=>`${status}`,
    hi: (status)=>`\u{938}\u{947}\u{91F} ${status}`,
    ht: (status)=>`Mete ${status}`,
    it: (status)=>`${status}`,
    ja: (status)=>`\u{30BB}\u{30C3}\u{30C8} ${status}`,
    ko: (status)=>`\u{C138}\u{D2B8} ${status}`,
    mww: (status)=>`Teev ${status}`,
    ps: (status)=>`\u{633}\u{6CC}\u{67C} ${status} \u{634}\u{648}`,
    pt: (status)=>`Conjunto ${status}`,
    "pt-pt": (status)=>`${status}`,
    ru: (status)=>`\u{41D}\u{430}\u{431}\u{43E}\u{440} ${status}`,
    sm: (status)=>`${status}`,
    so: (status)=>`Set ${status}`,
    th: (status)=>`\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32} ${status}`,
    ur: (status)=>`${status} \u{6C1}\u{648}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627} \u{633}\u{6CC}\u{679}`,
    vi: (status)=>`B\u{1ED9} \u{111}\xe3 ${status}`,
    "zh-hans": (status)=>`Set ${status}`,
    "zh-hant": (status)=>`Set ${status}`,
    en: (status)=>`Set ${status}`
};
const $2868cc1235412e16$export$cf481ed232c88ae5 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{639}\u{64A}\u{646}`,
    de: `Unbestimmt`,
    es: `Sin asignar`,
    fa: `\u{62A}\u{62E}\u{635}\u{6CC}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{646}\u{634}\u{62F}\u{647}`,
    fil: `Hindi nakatalaga`,
    fr: `Non attribu\xe9`,
    hi: `\u{905}\u{928}\u{905}\u{938}\u{93E}\u{907}\u{928}\u{94D}\u{921}`,
    ht: `Moun ki pa asiyen`,
    it: `Nessuno`,
    ja: `\u{672A}\u{5272}\u{308A}\u{5F53}\u{3066}`,
    ko: `\u{D560}\u{B2F9}`,
    mww: `Unassigned`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `N\xe3o atribu\xeddo`,
    "pt-pt": `N\xe3o atribu\xeddo`,
    ru: `\u{41D}\u{435}\u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44B}\u{435}`,
    sm: `E le'i tofia`,
    so: `Waxna ma tarin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `Unassigned`,
    vi: `Ch\u{1B0}a \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{672A}\u{5206}\u{914D}`,
    "zh-hant": `\u{672A}\u{5206}\u{914D}`,
    en: `Unassigned`
};
const $2868cc1235412e16$export$dfc3117aefd0fe77 = {
    ar: `\u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{644}\u{64A}\u{633} \u{62C}\u{627}\u{647}\u{632}\u{627} \u{628}\u{639}\u{62F} \u{644}\u{644}\u{639}\u{645}\u{644} \u{628}\u{646}\u{627}\u{621} \u{639}\u{644}\u{64A}\u{647}.`,
    de: `Die Aktivit\xe4t ist noch nicht bereit, in die Tat umgesetzt zu werden.`,
    es: `La actividad a\xfan no est\xe1 lista para ser llevada a cabo.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{646}\u{648}\u{632} \u{622}\u{645}\u{627}\u{62F}\u{647} \u{639}\u{645}\u{644} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Ang aktibidad ay hindi pa handa na kumilos.`,
    fr: `L\u{2019}activit\xe9 n\u{2019}est pas encore pr\xeate \xe0 \xeatre mise en \u{153}uvre.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{924}\u{948}\u{92F}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a poko pare pou yo aji sou li.`,
    it: `L'attivit\xe0 non \xe8 ancora pronta per essere messa in pratica.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3001}\u{307E}\u{3060}\u{5B9F}\u{884C}\u{3059}\u{308B}\u{6E96}\u{5099}\u{304C}\u{3067}\u{304D}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C740} \u{C544}\u{C9C1} \u{C2E4}\u{D589}\u{C5D0} \u{C62E}\u{AE38} \u{C900}\u{BE44}\u{AC00} \u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Txoj kev ua no tsis tau npaj txhij raws li.`,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{627} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{686}\u{645}\u{62A}\u{648} \u{646}\u{647} \u{62F}\u{6CC} \u{686}\u{6D0} \u{639}\u{645}\u{644}\u{6CC} \u{634}\u{6CC}.`,
    pt: `A atividade ainda n\xe3o est\xe1 pronta para ser posta em pr\xe1tica.`,
    "pt-pt": `A atividade ainda n\xe3o est\xe1 pronta para ser executada.`,
    ru: `\u{42D}\u{442}\u{430} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{433}\u{43E}\u{442}\u{43E}\u{432}\u{430} \u{43A} \u{442}\u{43E}\u{43C}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{435}\u{435} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{43B}\u{43E} \u{440}\u{435}\u{430}\u{43B}\u{438}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{44C}.`,
    sm: `E le'i sauni le gaioiga e faatinoina.`,
    so: `Howshaan ayaan diyaar u aheyn in wax laga qabto.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{639}\u{645}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{62A}\u{6CC}\u{627}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng v\u{1EAB}n ch\u{1B0}a s\u{1EB5}n s\xe0ng \u{111}\u{1EC3} th\u{1EF1}c hi\u{1EC7}n.`,
    "zh-hans": `\u{8BE5}\u{6D3B}\u{52A8}\u{5C1A}\u{672A}\u{51C6}\u{5907}\u{597D}\u{6267}\u{884C}\u{4F5C}\u{3002}`,
    "zh-hant": `\u{8A72}\u{6D3B}\u{52D5}\u{5C1A}\u{672A}\u{6E96}\u{5099}\u{597D}\u{57F7}\u{884C}\u{4F5C}\u{3002}`,
    en: `The activity is not yet ready to be acted upon.`
};
const $2868cc1235412e16$export$fc65ca123a4d95d5 = {
    ar: `\u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{62C}\u{627}\u{647}\u{632} \u{644}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{60C} \u{648}\u{644}\u{643}\u{646} \u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{62A}\u{62E}\u{627}\u{630} \u{623}\u{64A} \u{625}\u{62C}\u{631}\u{627}\u{621} \u{628}\u{639}\u{62F}. `,
    de: `Die Aktivit\xe4t kann ausgef\xfchrt werden, aber es wurde noch keine Aktion ausgef\xfchrt. `,
    es: `La actividad est\xe1 lista para realizarse, pero a\xfan no se ha realizado ninguna acci\xf3n. `,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{622}\u{645}\u{627}\u{62F}\u{647} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{627}\u{633}\u{62A}\u{60C} \u{627}\u{645}\u{627} \u{647}\u{646}\u{648}\u{632} \u{647}\u{6CC}\u{686} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{6CC} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. `,
    fil: `Handa nang isagawa ang aktibidad, ngunit wala pang aksyon na ginawa. `,
    fr: `L\u{2019}activit\xe9 est pr\xeate \xe0 \xeatre r\xe9alis\xe9e, mais aucune mesure n\u{2019}a encore \xe9t\xe9 prise. `,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{93F}\u{937}\u{94D}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{93F}\u{90F} \u{91C}\u{93E}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{924}\u{948}\u{92F}\u{93E}\u{930} \u{939}\u{948}, \u{932}\u{947}\u{915}\u{93F}\u{928} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{94B}\u{908} \u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{917}\u{908} \u{939}\u{948}\u{964} `,
    ht: `Aktivite a pare yo dwe f\xe8t, men pa gen okenn aksyon ki poko pran. `,
    it: `L'attivit\xe0 \xe8 pronta per essere eseguita, ma non \xe8 stata ancora intrapresa alcuna azione. `,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{5B9F}\u{884C}\u{3059}\u{308B}\u{6E96}\u{5099}\u{304C}\u{3067}\u{304D}\u{3066}\u{3044}\u{307E}\u{3059}\u{304C}\u{3001}\u{307E}\u{3060}\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}\u{306F}\u{5B9F}\u{884C}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002} `,
    ko: `\u{D65C}\u{B3D9}\u{C744} \u{C218}\u{D589}\u{D560} \u{C900}\u{BE44}\u{AC00} \u{B418}\u{C5C8}\u{C9C0}\u{B9CC} \u{C544}\u{C9C1} \u{C544}\u{BB34} \u{C791}\u{C5C5}\u{B3C4} \u{C218}\u{D589}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}. `,
    mww: `Txoj kev ua yog npaj tau, tab sis tsis muaj tes hauj lwm twb tau noj. `,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62F} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{686}\u{645}\u{62A}\u{648} \u{62F}\u{6CC}\u{60C} \u{62E}\u{648} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{647}\u{6CC}\u{685} \u{627}\u{642}\u{62F}\u{627}\u{645} \u{646}\u{647} \u{62F}\u{6CC} \u{634}\u{648}\u{6CC}. `,
    pt: `A atividade est\xe1 pronta para ser executada, mas nenhuma a\xe7\xe3o foi tomada ainda. `,
    "pt-pt": `A atividade est\xe1 pronta para ser realizada, mas nenhuma a\xe7\xe3o ainda foi tomada. `,
    ru: `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{433}\u{43E}\u{442}\u{43E}\u{432}\u{43E} \u{43A} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44E}, \u{43D}\u{43E} \u{43D}\u{438}\u{43A}\u{430}\u{43A}\u{438}\u{445} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43F}\u{440}\u{438}\u{43D}\u{44F}\u{442}\u{43E}. `,
    sm: `O le gaioiga ua sauni e faatino, ae e leai se gaioiga na faia. `,
    so: `Howlgalka ayaa diyaar u ah in la fuliyo, balse ma jiraan wax tallaabo ah oo laga qaaday wali. `,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23} \u{E41}\u{E15}\u{E48}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E43}\u{E14}\u{E46} `,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{62A}\u{6CC}\u{627}\u{631} \u{6C1}\u{6D2} \u{60C} \u{644}\u{6CC}\u{6A9}\u{646} \u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{648}\u{626}\u{6CC} \u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4} `,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 s\u{1EB5}n s\xe0ng \u{111}\u{1EC3} th\u{1EF1}c hi\u{1EC7}n, nh\u{1B0}ng ch\u{1B0}a c\xf3 h\xe0nh \u{111}\u{1ED9}ng n\xe0o \u{111}\u{1B0}\u{1EE3}c th\u{1EF1}c hi\u{1EC7}n. `,
    "zh-hans": `\u{8BE5}\u{6D3B}\u{52A8}\u{5DF2}\u{51C6}\u{5907}\u{597D}\u{6267}\u{884C}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{6267}\u{884C}\u{4EFB}\u{4F55}\u{4F5C}\u{3002} `,
    "zh-hant": `\u{8A72}\u{6D3B}\u{52D5}\u{5DF2}\u{6E96}\u{5099}\u{597D}\u{57F7}\u{884C}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{57F7}\u{884C}\u{4EFB}\u{4F55}\u{4F5C}\u{3002} `,
    en: `The activity is ready to be performed, but no action has yet been taken. `
};
const $2868cc1235412e16$export$de87c35595e5d750 = {
    ar: `\u{644}\u{645} \u{64A}\u{643}\u{62A}\u{645}\u{644} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Die Aktivit\xe4t wurde nicht abgeschlossen.`,
    es: `La actividad no se complet\xf3.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{627}\u{645}\u{644} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Hindi pa tapos ang aktibidad.`,
    fr: `L\u{2019}activit\xe9 n\u{2019}a pas \xe9t\xe9 men\xe9e \xe0 terme.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{942}\u{930}\u{940} \u{928}\u{939}\u{940}\u{902} \u{939}\u{941}\u{908}.`,
    ht: `Aktivite a pa te fini.`,
    it: `L'attivit\xe0 non \xe8 stata completata.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C774} \u{C644}\u{B8CC}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua yog tsis tiav.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{634}\u{67E}\u{693} \u{646}\u{647} \u{634}\u{648}.`,
    pt: `A atividade n\xe3o foi conclu\xedda.`,
    "pt-pt": `A atividade n\xe3o foi conclu\xedda.`,
    ru: `\u{41C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{43D}\u{435} \u{431}\u{44B}\u{43B}\u{43E} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    sm: `E le'i mae'a le gaoioiga.`,
    so: `Howshaasi lama dhameystirin.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{626}\u{6CC} \u{62A}\u{6BE}\u{6CC}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng ch\u{1B0}a ho\xe0n th\xe0nh.`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    en: `The activity was not completed.`
};
const $2868cc1235412e16$export$878e78a909bcb42c = {
    ar: `\u{628}\u{62F}\u{623} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{648}\u{644}\u{643}\u{646}\u{647} \u{644}\u{645} \u{64A}\u{643}\u{62A}\u{645}\u{644} \u{628}\u{639}\u{62F}.`,
    de: `Die Aktivit\xe4t wurde gestartet, ist aber noch nicht abgeschlossen.`,
    es: `La actividad se ha iniciado, pero a\xfan no ha finalizado.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{622}\u{63A}\u{627}\u{632} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A} \u{627}\u{645}\u{627} \u{647}\u{646}\u{648}\u{632} \u{6A9}\u{627}\u{645}\u{644} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Sinimulan na ang aktibidad ngunit hindi pa rin kumpleto.`,
    fr: `L\u{2019}activit\xe9 a commenc\xe9 mais n\u{2019}est pas encore termin\xe9e.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{936}\u{941}\u{930}\u{942} \u{915}\u{940} \u{917}\u{908} \u{939}\u{948} \u{932}\u{947}\u{915}\u{93F}\u{928} \u{905}\u{92D}\u{940} \u{924}\u{915} \u{92A}\u{942}\u{930}\u{940} \u{928}\u{939}\u{940}\u{902} \u{939}\u{941}\u{908} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a te k\xf2manse men li poko konpl\xe8.`,
    it: `L'attivit\xe0 \xe8 stata avviata ma non \xe8 ancora completata.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{958B}\u{59CB}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{304C}\u{3001}\u{307E}\u{3060}\u{5B8C}\u{4E86}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C774} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C9C0}\u{B9CC} \u{C544}\u{C9C1} \u{C644}\u{B8CC}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua tau pib tab sis tsis tau tiav.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67E}\u{6CC}\u{644} \u{634}\u{648}\u{6CC} \u{62E}\u{648} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{646}\u{647} \u{62F}\u{6CC}.`,
    pt: `A atividade foi iniciada, mas ainda n\xe3o est\xe1 conclu\xedda.`,
    "pt-pt": `A atividade foi iniciada, mas ainda n\xe3o est\xe1 conclu\xedda.`,
    ru: `\u{41C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{43E}, \u{43D}\u{43E} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    sm: `Ua uma ona amataina le gaoioiga ae e le'i mae'a.`,
    so: `Hawsha waa la billaabay, hase yeeshee weli ma dhamaato.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E14}\u{E49}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E41}\u{E25}\u{E49}\u{E27} \u{E41}\u{E15}\u{E48}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{6A9}\u{631}\u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2} \u{644}\u{6CC}\u{6A9}\u{646} \u{627}\u{628}\u{6BE}\u{6CC} \u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c b\u{1EAF}t \u{111}\u{1EA7}u nh\u{1B0}ng ch\u{1B0}a ho\xe0n t\u{1EA5}t.`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{5DF2}\u{542F}\u{52A8}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{5DF2}\u{555F}\u{52D5}\u{FF0C}\u{4F46}\u{5C1A}\u{672A}\u{5B8C}\u{6210}\u{3002}`,
    en: `The activity has been started but is not yet complete.`
};
const $2868cc1235412e16$export$46d49c80898a4f02 = {
    ar: `\u{648}\u{642}\u{62F} \u{628}\u{62F}\u{623} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{648}\u{644}\u{643}\u{646} \u{62A}\u{648}\u{642}\u{641} \u{627}\u{644}\u{639}\u{645}\u{644}.`,
    de: `Die Aktivit\xe4t wurde gestartet, aber die Arbeit wurde pausiert.`,
    es: `La actividad se ha iniciado, pero los trabajos se han pausado.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{622}\u{63A}\u{627}\u{632} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A} \u{627}\u{645}\u{627} \u{6A9}\u{627}\u{631} \u{645}\u{62A}\u{648}\u{642}\u{641} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Sinimulan na ang aktibidad ngunit natigil pa rin ang trabaho.`,
    fr: `L\u{2019}activit\xe9 a d\xe9marr\xe9 mais les travaux ont \xe9t\xe9 interrompus.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{936}\u{941}\u{930}\u{942} \u{915}\u{930} \u{926}\u{940} \u{917}\u{908} \u{939}\u{948} \u{932}\u{947}\u{915}\u{93F}\u{928} \u{915}\u{93E}\u{92E} \u{930}\u{94B}\u{915} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a te k\xf2manse men travay te poze.`,
    it: `L'attivit\xe0 \xe8 stata avviata, ma il lavoro \xe8 stato sospeso.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{958B}\u{59CB}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{304C}\u{3001}\u{4F5C}\u{696D}\u{306F}\u{4E00}\u{6642}\u{505C}\u{6B62}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C774} \u{C2DC}\u{C791}\u{B418}\u{C5C8}\u{C9C0}\u{B9CC} \u{C791}\u{C5C5}\u{C774} \u{C77C}\u{C2DC} \u{C911}\u{C9C0}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Txoj kev ua tau pib tab sis ua hauj lwm muaj tau paused.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67E}\u{6CC}\u{644} \u{634}\u{648}\u{6CC} \u{62E}\u{648} \u{6A9}\u{627}\u{631} \u{681}\u{646}\u{689}\u{648}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `A atividade foi iniciada, mas o trabalho foi interrompido.`,
    "pt-pt": `A atividade foi iniciada, mas o trabalho foi interrompido.`,
    ru: `\u{414}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43D}\u{430}\u{447}\u{430}\u{442}\u{430}, \u{43D}\u{43E} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430} \u{43F}\u{440}\u{438}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{430}.`,
    sm: `Ua amataina le gaoioiga, ae ua taofi le galuega.`,
    so: `Hawshii waa la bilaabay, shaqaduse waa hakisay.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E14}\u{E49}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27} \u{E41}\u{E15}\u{E48}\u{E07}\u{E32}\u{E19}\u{E16}\u{E39}\u{E01}\u{E2B}\u{E22}\u{E38}\u{E14}\u{E0A}\u{E31}\u{E48}\u{E27}\u{E04}\u{E23}\u{E32}\u{E27}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{6A9}\u{631}\u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2} \u{644}\u{6CC}\u{6A9}\u{646} \u{6A9}\u{627}\u{645} \u{631}\u{648}\u{6A9} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c b\u{1EAF}t \u{111}\u{1EA7}u nh\u{1B0}ng c\xf4ng vi\u{1EC7}c \u{111}\xe3 b\u{1ECB} t\u{1EA1}m d\u{1EEB}ng.`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{5DF2}\u{542F}\u{52A8}\u{FF0C}\u{4F46}\u{5DE5}\u{4F5C}\u{5DF2}\u{6682}\u{505C}\u{3002}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{5DF2}\u{555F}\u{52D5}\u{FF0C}\u{4F46}\u{5DE5}\u{4F5C}\u{5DF2}\u{66AB}\u{505C}\u{3002}`,
    en: `The activity has been started but work has been paused.`
};
const $2868cc1235412e16$export$ecd960c60eeecfdb = {
    ar: `\u{62A}\u{645} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621} \u{645}\u{646} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Die Aktivit\xe4t wurde abgeschlossen.`,
    es: `La actividad se ha completado.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Nakumpleto na ang aktibidad.`,
    fr: `L\u{2019}activit\xe9 est termin\xe9e.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{942}\u{930}\u{940} \u{939}\u{94B} \u{917}\u{908} \u{939}\u{948}\u{964}`,
    ht: `Aktivite a fini.`,
    it: `L'attivit\xe0 \xe8 stata completata.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{304C}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{D65C}\u{B3D9}\u{C774} \u{C644}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev ua tau tiav lawm.`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `A atividade foi conclu\xedda.`,
    "pt-pt": `A atividade foi conclu\xedda.`,
    ru: `\u{41C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}.`,
    sm: `Ua mae'a le gaoioiga.`,
    so: `Howlgalka waa la dhammeystiray.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6A9}\u{645}\u{644} \u{6C1}\u{648} \u{686}\u{6A9}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 ho\xe0n t\u{1EA5}t.`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{5DF2}\u{5B8C}\u{6210}\u{3002}`,
    en: `The activity has been completed.`
};
const $2868cc1235412e16$export$db4f0c4f1f094613 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629}`,
    de: `Status w\xe4hlen`,
    es: `Elegir estado`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    fil: `Piliin ang katayuan`,
    fr: `Choisir le statut`,
    hi: `\u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi estati`,
    it: `Scegli lo stato`,
    ja: `\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{C0C1}\u{D0DC} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov txheej xwm raws li txoj`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Escolher status`,
    "pt-pt": `Escolher estado`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}`,
    sm: `Filifili le tulaga`,
    so: `Dooro status`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}`,
    ur: `\u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n tr\u{1EA1}ng th\xe1i`,
    "zh-hans": `\u{9009}\u{62E9}\u{72B6}\u{6001}`,
    "zh-hant": `\u{9078}\u{64C7}\u{72C0}\u{614B}`,
    en: `Choose status`
};
const $2868cc1235412e16$export$6b5428a07839d4c2 = {
    ar: `\u{62A}\u{628}\u{62F}\u{64A}\u{644} \u{642}\u{627}\u{626}\u{645}\u{629} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629}`,
    de: `Statusmen\xfc umschalten`,
    es: `Alternar men\xfa de estado`,
    fa: `\u{645}\u{646}\u{648}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{631}\u{627} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{62F}\u{647}\u{6CC}\u{62F}`,
    fil: `I-toggle ang menu ng katayuan`,
    fr: `Basculer le menu d\u{2019}\xe9tat`,
    hi: `\u{91F}\u{949}\u{917}\u{932} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{928}\u{942}`,
    ht: `Meni estati Toggle`,
    it: `Attiva/disattiva il menu di stato`,
    ja: `\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{306E}\u{5207}\u{308A}\u{66FF}\u{3048}`,
    ko: `\u{C0C1}\u{D0DC} \u{BA54}\u{B274} \u{C804}\u{D658}`,
    mww: `Toggle raws li txoj cai zaub mov`,
    ps: `\u{62F} \u{62D}\u{627}\u{644}\u{62A} \u{645}\u{6CC}\u{646}\u{648} \u{628}\u{62F}\u{644}\u{648}\u{644}`,
    pt: `Alternar menu de status`,
    "pt-pt": `Alternar menu de status`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{43C}\u{435}\u{43D}\u{44E} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{44F}`,
    sm: `Toggle status menu`,
    so: `xaaladda Toggle menu`,
    th: `\u{E2A}\u{E25}\u{E31}\u{E1A}\u{E40}\u{E21}\u{E19}\u{E39}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}`,
    ur: `Toggle status menu`,
    vi: `Chuy\u{1EC3}n \u{111}\u{1ED5}i menu tr\u{1EA1}ng th\xe1i`,
    "zh-hans": `\u{5207}\u{6362}\u{72B6}\u{6001}\u{83DC}\u{5355}`,
    "zh-hant": `\u{5207}\u{63DB}\u{72C0}\u{614B}\u{529F}\u{80FD}\u{8868}`,
    en: `Toggle status menu`
};
const $2868cc1235412e16$export$168e7f4521755dda = {
    ar: `\u{62D}\u{630}\u{641}`,
    de: `L\xf6schen`,
    es: `Borrar`,
    fa: `\u{62D}\u{630}\u{641}`,
    fil: `Tanggalin`,
    fr: `Supprimer`,
    hi: `\u{92E}\u{93F}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `efase`,
    it: `Cancellare`,
    ja: `\u{524A}\u{9664}`,
    ko: `\u{C0AD}\u{C81C}\u{D558}\u{B2E4}`,
    mww: `Delete`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Excluir`,
    "pt-pt": `Suprimir`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    sm: `Aveese`,
    so: `delete`,
    th: `\u{E25}\u{E1A}`,
    ur: `\u{645}\u{679}\u{627}\u{646}\u{627}`,
    vi: `X\xf3a`,
    "zh-hans": `\u{5220}\u{9664}`,
    "zh-hant": `\u{522A}\u{9664}`,
    en: `Delete`
};
const $2868cc1235412e16$export$d3f083e9ed202085 = {
    ar: `\u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{627}\u{644}\u{62D}\u{630}\u{641}`,
    de: `L\xf6schen best\xe4tigen`,
    es: `Confirmar eliminaci\xf3n`,
    fa: `\u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{62D}\u{630}\u{641}`,
    fil: `Kumpirmahin ang pagtanggal`,
    fr: `Confirmer la suppression`,
    hi: `\u{939}\u{91F}\u{93E}\u{928}\u{947} \u{915}\u{940} \u{92A}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Confirm et`,
    it: `Conferma l'eliminazione`,
    ja: `\u{524A}\u{9664}\u{306E}\u{78BA}\u{8A8D}`,
    ko: `\u{C0AD}\u{C81C} \u{D655}\u{C778}`,
    mww: `Tshawb kom paub meej tias delete`,
    ps: `\u{62F} \u{62D}\u{630}\u{641} \u{62A}\u{627}\u{6CC}\u{6CC}\u{62F}`,
    pt: `Confirmar exclus\xe3o`,
    "pt-pt": `Confirmar exclus\xe3o`,
    ru: `\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{434}\u{438}\u{442}\u{44C}, \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C}`,
    sm: `Faamaonia le tapeina`,
    so: `Xaqiijiso delete`,
    th: `\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A}`,
    ur: `\u{62D}\u{630}\u{641} \u{6A9}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xe1c nh\u{1EAD}n x\xf3a`,
    "zh-hans": `\u{786E}\u{8BA4}\u{5220}\u{9664}`,
    "zh-hant": `\u{78BA}\u{8A8D}\u{522A}\u{9664}`,
    en: `Confirm delete`
};
const $2868cc1235412e16$export$4a4b0db14c023cd8 = {
    ar: (title)=>`\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{645}\u{646} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{62D}\u{630}\u{641} "${title}"\u{61F}`,
    de: (title)=>`Sind Sie sicher, dass Sie "${title}" l\xf6schen m\xf6chten?`,
    es: (title)=>`\xbfEst\xe1s seguro de que quieres eliminar "${title}"?`,
    fa: (title)=>`\u{622}\u{6CC}\u{627} \u{645}\u{637}\u{645}\u{626}\u{646} \u{647}\u{633}\u{62A}\u{6CC}\u{62F} \u{6A9}\u{647} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} "${title} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
    fil: (title)=>`Sigurado ka bang gusto mong tanggalin ang "${title}"?`,
    fr: (title)=>`\xcates-vous s\xfbr de vouloir supprimer \xab\xa0${title}\xa0\xbb ?`,
    hi: (title)=>`\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} "${title}" \u{939}\u{91F}\u{93E}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: (title)=>`\xc8ske ou s\xe8ten ou vle efase "${title}"?`,
    it: (title)=>`Sei sicuro di voler eliminare "${title}"?`,
    ja: (title)=>`\u{300C}${title}\u{300D}\u{3092}\u{524A}\u{9664}\u{3057}\u{3066}\u{3082}\u{3088}\u{308D}\u{3057}\u{3044}\u{3067}\u{3059}\u{304B}?`,
    ko: (title)=>`"${title}"\u{B97C} \u{C0AD}\u{C81C}\u{D558}\u{C2DC}\u{ACA0}\u{C2B5}\u{B2C8}\u{AE4C}?`,
    mww: (title)=>`Koj puas paub tseeb tias koj xav delete "${title}"?`,
    ps: (title)=>`\u{622}\u{6CC}\u{627} \u{645}\u{637}\u{645}\u{626}\u{646}\u{627} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} "${title} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
    pt: (title)=>`Tem certeza de que deseja excluir "${title}"?`,
    "pt-pt": (title)=>`Tem certeza de que deseja excluir "${title}"?`,
    ru: (title)=>`\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} "${title}"?`,
    sm: (title)=>`E te mautinoa e te mana'o e aveese le "${title}"?`,
    so: (title)=>`Ma hubtaa inaad rabto in aad tirtiro "${title}"?`,
    th: (title)=>`\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A} "${title}"`,
    ur: (title)=>`\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} "\u{62C}\u{627}\u{646} \u{688}\u{648}" \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{646}\u{627} ${title}\u{61F}`,
    vi: (title)=>`B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n x\xf3a "${title}" kh\xf4ng?`,
    "zh-hans": (title)=>`\u{60A8}\u{786E}\u{5B9A}\u{8981}\u{5220}\u{9664} \u{201C}${title}\u{201D} \u{5417}\u{FF1F}`,
    "zh-hant": (title)=>`\u{60A8}\u{78BA}\u{5B9A}\u{8981}\u{522A}\u{9664} \u{300C}${title}\u{300D} \u{55CE}\u{FF1F}`,
    en: (title)=>`Are you sure you want to delete "${title}"?`
};
const $2868cc1235412e16$export$9279b045541daaab = {
    ar: (title)=>`\u{62D}\u{630}\u{641} ${title}`,
    de: (title)=>`${title} l\xf6schen`,
    es: (title)=>`Eliminar ${title}`,
    fa: (title)=>`\u{62D}\u{630}\u{641} ${title}`,
    fil: (title)=>`Tanggalin ${title}`,
    fr: (title)=>`Supprimer ${title}`,
    hi: (title)=>`${title} \u{915}\u{94B} \u{939}\u{91F}\u{93E}\u{90F}\u{901}`,
    ht: (title)=>`${title}`,
    it: (title)=>`Eliminare ${title}`,
    ja: (title)=>`${title}\u{306E}\u{524A}\u{9664}`,
    ko: (title)=>`${title} \u{C0AD}\u{C81C}`,
    mww: (title)=>`Delete ${title}`,
    ps: (title)=>`\u{62C}\u{627}\u{646} ${title} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{626}`,
    pt: (title)=>`Excluir ${title}`,
    "pt-pt": (title)=>`Excluir ${title}`,
    ru: (title)=>`\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} ${title}`,
    sm: (title)=>`Aveese ${title}`,
    so: (title)=>`Delete ${title}`,
    th: (title)=>`\u{E25}\u{E1A} ${title}`,
    ur: (title)=>`${title}`,
    vi: (title)=>`X\xf3a ${title}`,
    "zh-hans": (title)=>`\u{5220}\u{9664} ${title}`,
    "zh-hant": (title)=>`\u{522A}\u{9664} ${title}`,
    en: (title)=>`Delete ${title}`
};
const $2868cc1235412e16$export$62360ee1b063eeee = {
    ar: `\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Verwenden von Aktivit\xe4ten`,
    es: `Uso de actividades`,
    fa: `\u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}`,
    fil: `Paggamit ng mga aktibidad`,
    fr: `Utilisation des activit\xe9s`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `S\xe8vi ak aktivite`,
    it: `Utilizzo delle attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{4F7F}\u{7528}`,
    ko: `\u{D65C}\u{B3D9} \u{C0AC}\u{C6A9}`,
    mww: `Siv kev ua ub no`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648} \u{6A9}\u{627}\u{631}\u{648}\u{644}`,
    pt: `Usando atividades`,
    "pt-pt": `Utiliza\xe7\xe3o de atividades`,
    ru: `\u{418}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439}`,
    sm: `Faaaogaina o gaoioiga`,
    so: `U isticmaalka waxqabadka`,
    th: `\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644}`,
    vi: `S\u{1EED} d\u{1EE5}ng ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{4F7F}\u{7528}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{4F7F}\u{7528}\u{6D3B}\u{52D5}`,
    en: `Using activities`
};
const $2868cc1235412e16$export$e939d973dd9ee554 = {
    ar: `\u{644}\u{645} \u{64A}\u{628}\u{62F}\u{623} \u{627}\u{644}\u{62D}\u{62F}\u{62B}. \u{644}\u{627} \u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{637}\u{644}\u{628}\u{627}\u{62A} \u{641}\u{64A} \u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}.`,
    de: `Das Ereignis hat noch nicht begonnen. Einreichungen werden derzeit nicht angenommen.`,
    es: `El evento no ha comenzado. No se aceptan inscripciones en este momento.`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{634}\u{631}\u{648}\u{639} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62D}\u{627}\u{636}\u{631} \u{645}\u{637}\u{627}\u{644}\u{628} \u{627}\u{631}\u{633}\u{627}\u{644}\u{6CC} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Hindi pa nagsisimula ang event. Ang mga pagsusumite ay hindi tinatanggap sa oras na ito.`,
    fr: `L\u{2019}\xe9v\xe9nement n\u{2019}a pas encore commenc\xe9. Les soumissions ne sont pas accept\xe9es pour le moment.`,
    hi: `\u{907}\u{935}\u{947}\u{902}\u{91F} \u{936}\u{941}\u{930}\u{942} \u{928}\u{939}\u{940}\u{902} \u{939}\u{941}\u{906} \u{939}\u{948}\u{964} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{907}\u{938} \u{938}\u{92E}\u{92F} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Ev\xe8nman an pa te k\xf2manse. Soum\xe8t yo pa aksepte nan moman sa a.`,
    it: `L'evento non \xe8 iniziato. Al momento non si accettano candidature.`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{304C}\u{958B}\u{59CB}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}\u{73FE}\u{6642}\u{70B9}\u{3067}\u{306F}\u{3001}\u{6295}\u{7A3F}\u{306F}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3066}\u{304A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8}\u{AC00} \u{C2DC}\u{C791}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}. \u{D604}\u{C7AC} \u{C81C}\u{CD9C}\u{C744} \u{C218}\u{B77D}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cov kev tshwm sim twb tsis pib. Submissions yuav tsis tau txais thaum lub sij hawm no.`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{647} \u{646}\u{647} \u{62F}\u{647} \u{67E}\u{6CC}\u{644} \u{634}\u{648}\u{6D0}. \u{67E}\u{647} \u{627}\u{648}\u{633} \u{648}\u{62E}\u{62A} \u{6A9}\u{6D0} \u{633}\u{67E}\u{627}\u{631}\u{646}\u{6D0} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `O evento n\xe3o come\xe7ou. As inscri\xe7\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    "pt-pt": `O evento ainda n\xe3o come\xe7ou. As submiss\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    ru: `\u{41C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44C}. \u{412} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: `E le'i amataina le mea na tupu. E le o taliaina talosaga i le taimi nei.`,
    so: `Munaasabaddu ma bilaaban. Soo gudbinta lama aqbalayo waqtigan.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21} \u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{627}\u{628}\u{6BE}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{627} \u{6C1}\u{6D2}. \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `S\u{1EF1} ki\u{1EC7}n ch\u{1B0}a b\u{1EAF}t \u{111}\u{1EA7}u. C\xe1c b\xe0i d\u{1EF1} thi kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n t\u{1EA1}i th\u{1EDD}i \u{111}i\u{1EC3}m n\xe0y.`,
    "zh-hans": `\u{4E8B}\u{4EF6}\u{5C1A}\u{672A}\u{5F00}\u{59CB}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    "zh-hant": `\u{4E8B}\u{4EF6}\u{5C1A}\u{672A}\u{958B}\u{59CB}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    en: `The event has not started. Submissions are not being accepted at this time.`
};
const $2868cc1235412e16$export$367c616e423014ab = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{649} \u{627}\u{644}\u{62D}\u{62F}\u{62B} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644}. \u{644}\u{645} \u{64A}\u{639}\u{62F} \u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645}\u{627}\u{62A}.`,
    de: `Die Veranstaltung ist bereits beendet. Einreichungen werden nicht mehr akzeptiert.`,
    es: `El evento ya termin\xf3. Ya no se aceptan presentaciones.`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{642}\u{628}\u{644}\u{627} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}\u{647} \u{628}\u{648}\u{62F}. \u{645}\u{637}\u{627}\u{644}\u{628} \u{627}\u{631}\u{633}\u{627}\u{644}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Tapos na ang event. Hindi na tinatanggap ang mga pagsusumite.`,
    fr: `L\u{2019}\xe9v\xe9nement est d\xe9j\xe0 termin\xe9. Les soumissions ne sont plus accept\xe9es.`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E} \u{92A}\u{939}\u{932}\u{947} \u{939}\u{940} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{91A}\u{941}\u{915}\u{93E} \u{939}\u{948}\u{964} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{905}\u{92C} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Ev\xe8nman an te deja fini. Soum\xe8t yo pa aksepte ank\xf2.`,
    it: `L'evento \xe8 gi\xe0 terminato. Le candidature non vengono pi\xf9 accettate.`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{3059}\u{3067}\u{306B}\u{7D42}\u{4E86}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{6295}\u{7A3F}\u{306F}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{306A}\u{304F}\u{306A}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8}\u{B294} \u{C774}\u{BBF8} \u{C885}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C81C}\u{CD9C}\u{C740} \u{B354} \u{C774}\u{C0C1} \u{C218}\u{B77D}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cov kev tshwm sim twb twb. Submissions yuav tsis tau txais.`,
    ps: `\u{67E}\u{6CC}\u{69A}\u{647} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{647} \u{645}\u{62E}\u{6A9}\u{6D0} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{62F}\u{647}. \u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{646}\u{648}\u{631} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `O evento j\xe1 terminou. As inscri\xe7\xf5es n\xe3o est\xe3o mais sendo aceitas.`,
    "pt-pt": `O evento j\xe1 terminou. As submiss\xf5es j\xe1 n\xe3o s\xe3o aceites.`,
    ru: `\u{41C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{443}\u{436}\u{435} \u{437}\u{430}\u{43A}\u{43E}\u{43D}\u{447}\u{438}\u{43B}\u{43E}\u{441}\u{44C}. \u{417}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: `Ua uma le mea na tupu. E le o toe taliaina talosaga.`,
    so: `Xafladdii wey dhammaatay. Soo gudbinta mar dambe lama aqbalayo.`,
    th: `\u{E07}\u{E32}\u{E19}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E25}\u{E07}\u{E41}\u{E25}\u{E49}\u{E27} \u{E44}\u{E21}\u{E48}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{62A}\u{642}\u{631}\u{6CC}\u{628} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{686}\u{6A9}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{627}\u{628} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `S\u{1EF1} ki\u{1EC7}n \u{111}\xe3 k\u{1EBF}t th\xfac. C\xe1c b\xe0i d\u{1EF1} thi kh\xf4ng c\xf2n \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n.`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{5DF2}\u{7ED3}\u{675F}\u{3002}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{5DF2}\u{7D50}\u{675F}\u{3002}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    en: `The event already ended. Submissions are no longer being accepted.`
};
const $2868cc1235412e16$export$f27a732b735cc737 = {
    ar: (startDate)=>`\u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{62F}\u{62B} \u{644}\u{645} \u{64A}\u{628}\u{62F}\u{623} \u{628}\u{639}\u{62F}. \u{633}\u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{637}\u{644}\u{628}\u{627}\u{62A} \u{641}\u{64A} ${startDate}.`,
    de: (startDate)=>`Diese Veranstaltung hat noch nicht begonnen. Einreichungen werden ab dem ${startDate} entgegengenommen.`,
    es: (startDate)=>`Este evento a\xfan no ha comenzado. Las inscripciones se aceptar\xe1n el ${startDate}.`,
    fa: (startDate)=>`\u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{647}\u{646}\u{648}\u{632} \u{622}\u{63A}\u{627}\u{632} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{622}\u{62B}\u{627}\u{631} \u{627}\u{631}\u{633}\u{627}\u{644}\u{6CC} \u{62F}\u{631} ${startDate} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (startDate)=>`Hindi pa nagsisimula ang kaganapang ito. Ang mga pagsusumite ay tatanggapin sa ${startDate}.`,
    fr: (startDate)=>`Cet \xe9v\xe9nement n\u{2019}a pas encore commenc\xe9. Les soumissions seront accept\xe9es le ${startDate}.`,
    hi: (startDate)=>`\u{92F}\u{939} \u{907}\u{935}\u{947}\u{902}\u{91F} \u{905}\u{92D}\u{940} \u{936}\u{941}\u{930}\u{942} \u{928}\u{939}\u{940}\u{902} \u{939}\u{941}\u{906} \u{939}\u{948}\u{964} \u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F}\u{92F}\u{93E}\u{902} ${startDate} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{940} \u{91C}\u{93E}\u{90F}\u{902}\u{917}\u{940}\u{964}`,
    ht: (startDate)=>`Ev\xe8nman sa a poko k\xf2manse. Soum\xe8t yo pral aksepte ${startDate}.`,
    it: (startDate)=>`Questo evento non \xe8 ancora iniziato. Le iscrizioni saranno accettate il ${startDate}.`,
    ja: (startDate)=>`\u{3053}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{307E}\u{3060}\u{59CB}\u{307E}\u{3063}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}\u{5FDC}\u{52DF}\u{306F} ${startDate}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: (startDate)=>`\u{C774} \u{C774}\u{BCA4}\u{D2B8}\u{B294} \u{C544}\u{C9C1} \u{C2DC}\u{C791}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C81C}\u{CD9C}\u{C740} ${startDate} \u{C811}\u{C218}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: (startDate)=>`Qhov kev tshwm sim no twb tsis tau pib. Submissions yuav tau txais rau ${startDate}.`,
    ps: (startDate)=>`\u{62F}\u{627} \u{67E}\u{6CC}\u{69A}\u{647} \u{644}\u{627} \u{646}\u{647} \u{62F}\u{647} \u{67E}\u{6CC}\u{644} \u{634}\u{648}\u{6D0}. \u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{628}\u{647} \u{62F} ${startDate} \u{648}\u{645}\u{646}\u{644} \u{634}\u{6CC}.`,
    pt: (startDate)=>`Este evento ainda n\xe3o come\xe7ou. As inscri\xe7\xf5es ser\xe3o aceitas no ${startDate}.`,
    "pt-pt": (startDate)=>`Este evento ainda n\xe3o come\xe7ou. As inscri\xe7\xf5es ser\xe3o aceitas no dia ${startDate}.`,
    ru: (startDate)=>`\u{42D}\u{442}\u{43E} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{435} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44C}. \u{417}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{442}\u{44C}\u{441}\u{44F} ${startDate}.`,
    sm: (startDate)=>`E le'i amataina lenei mea na tupu. O talosaga o le a taliaina ia ${startDate}.`,
    so: (startDate)=>`Xafladan ayaan weli bilaaban. Soo gudbinta waxaa la aqbali doonaa ${startDate}.`,
    th: (startDate)=>`\u{E07}\u{E32}\u{E19}\u{E19}\u{E35}\u{E49}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21} \u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19}\u{E08}\u{E30}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${startDate}`,
    ur: (startDate)=>`\u{6CC}\u{6C1} \u{648}\u{627}\u{642}\u{639}\u{6C1} \u{627}\u{628}\u{6BE}\u{6CC} \u{634}\u{631}\u{648}\u{639} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{627} \u{6C1}\u{6D2}\u{6D4} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} ${startDate} \u{6A9}\u{648} \u{642}\u{628}\u{648}\u{644} \u{6A9}\u{6CC} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: (startDate)=>`S\u{1EF1} ki\u{1EC7}n n\xe0y v\u{1EAB}n ch\u{1B0}a b\u{1EAF}t \u{111}\u{1EA7}u. B\xe0i d\u{1EF1} thi s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n v\xe0o ${startDate}.`,
    "zh-hans": (startDate)=>`\u{6B64}\u{6D3B}\u{52A8}\u{5C1A}\u{672A}\u{5F00}\u{59CB}\u{3002}\u{63D0}\u{4EA4}\u{5C06}\u{4E8E} ${startDate} \u{65E5}\u{63A5}\u{53D7}\u{3002}`,
    "zh-hant": (startDate)=>`\u{6B64}\u{6D3B}\u{52D5}\u{5C1A}\u{672A}\u{958B}\u{59CB}\u{3002}\u{63D0}\u{4EA4}\u{5C07}\u{65BC} ${startDate} \u{65E5}\u{63A5}\u{53D7}\u{3002}`,
    en: (startDate)=>`This event has not yet started. Submissions will be accepted on ${startDate}.`
};
const $2868cc1235412e16$export$e6f33f006f04931a = {
    ar: (endDate)=>`\u{627}\u{646}\u{62A}\u{647}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{62F}\u{62B} \u{641}\u{64A} ${endDate}. \u{644}\u{645} \u{64A}\u{639}\u{62F} \u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{62A}\u{642}\u{62F}\u{64A}\u{645}\u{627}\u{62A}.`,
    de: (endDate)=>`Dieses Event ${endDate}. Einreichungen werden nicht mehr akzeptiert.`,
    es: (endDate)=>`Este evento finaliz\xf3 el ${endDate}. Ya no se aceptan presentaciones.`,
    fa: (endDate)=>`\u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{62F}\u{631} ${endDate} \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}. \u{645}\u{637}\u{627}\u{644}\u{628} \u{627}\u{631}\u{633}\u{627}\u{644}\u{6CC} \u{62F}\u{6CC}\u{6AF}\u{631} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (endDate)=>`Natapos ang kaganapang ito noong ${endDate}. Hindi na tinatanggap ang mga pagsusumite.`,
    fr: (endDate)=>`Cet \xe9v\xe9nement s\u{2019}est termin\xe9 ${endDate}. Les soumissions ne sont plus accept\xe9es.`,
    hi: (endDate)=>`\u{92F}\u{939} \u{906}\u{92F}\u{94B}\u{91C}\u{928} ${endDate} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{941}\u{906}\u{964} \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{905}\u{92C} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: (endDate)=>`Ev\xe8nman sa a te fini ${endDate}. Soum\xe8t yo pa aksepte ank\xf2.`,
    it: (endDate)=>`Questo evento si \xe8 concluso il ${endDate}. Le candidature non vengono pi\xf9 accettate.`,
    ja: (endDate)=>`\u{3053}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F} ${endDate}\u{3002}\u{6295}\u{7A3F}\u{306F}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{306A}\u{304F}\u{306A}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: (endDate)=>`\u{C774} \u{C774}\u{BCA4}\u{D2B8}\u{B294} ${endDate}\u{C77C}\u{C5D0} \u{C885}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C81C}\u{CD9C}\u{C740} \u{B354} \u{C774}\u{C0C1} \u{C218}\u{B77D}\u{B418}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (endDate)=>`Qhov kev tshwm sim no twb rau ${endDate}. Submissions yuav tsis tau txais.`,
    ps: (endDate)=>`\u{62F}\u{627} \u{67E}\u{6CC}\u{69A}\u{647} \u{62F} ${endDate} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{62F}\u{647}. \u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{6D0} \u{646}\u{648}\u{631} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: (endDate)=>`Este evento terminou em ${endDate}. As inscri\xe7\xf5es n\xe3o est\xe3o mais sendo aceitas.`,
    "pt-pt": (endDate)=>`Este evento terminou no dia ${endDate}. As submiss\xf5es j\xe1 n\xe3o s\xe3o aceites.`,
    ru: (endDate)=>`\u{42D}\u{442}\u{43E} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{435} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{43B}\u{43E}\u{441}\u{44C} ${endDate}. \u{417}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: (endDate)=>`O lenei fa'alavelave na fa'ai'uina i le ${endDate}. E le o toe taliaina talosaga.`,
    so: (endDate)=>`Xafladan ayaa soo dhamaatay ${endDate}. Soo gudbinta mar dambe lama aqbalayo.`,
    th: (endDate)=>`\u{E07}\u{E32}\u{E19}\u{E19}\u{E35}\u{E49}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E25}\u{E07}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${endDate} \u{E44}\u{E21}\u{E48}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: (endDate)=>`\u{6CC}\u{6C1} \u{62A}\u{642}\u{631}\u{6CC}\u{628} ${endDate}\u{6D4} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{627}\u{628} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (endDate)=>`S\u{1EF1} ki\u{1EC7}n n\xe0y k\u{1EBF}t th\xfac v\xe0o ${endDate}. C\xe1c b\xe0i d\u{1EF1} thi kh\xf4ng c\xf2n \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n.`,
    "zh-hans": (endDate)=>`\u{6B64}\u{6D3B}\u{52A8}\u{4E8E} ${endDate} \u{65E5}\u{7ED3}\u{675F}\u{3002}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    "zh-hant": (endDate)=>`\u{6B64}\u{6D3B}\u{52D5}\u{65BC} ${endDate} \u{65E5}\u{7D50}\u{675F}\u{3002}\u{4E0D}\u{518D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    en: (endDate)=>`This event ended on ${endDate}. Submissions are no longer being accepted.`
};
const $2868cc1235412e16$export$e2f11bbcf5062eda = {
    ar: `\u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{62F}\u{62B} \u{645}\u{639}\u{644}\u{642}. \u{644}\u{627} \u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{637}\u{644}\u{628}\u{627}\u{62A} \u{641}\u{64A} \u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}.`,
    de: `Diese Veranstaltung ist in der Warteschleife. Einreichungen werden derzeit nicht angenommen.`,
    es: `Este evento est\xe1 en espera. No se aceptan inscripciones en este momento.`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{62F}\u{631} \u{62D}\u{627}\u{644}\u{62A} \u{62A}\u{639}\u{644}\u{6CC}\u{642} \u{627}\u{633}\u{62A}. \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62D}\u{627}\u{636}\u{631} \u{645}\u{637}\u{627}\u{644}\u{628} \u{627}\u{631}\u{633}\u{627}\u{644}\u{6CC} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Ang kaganapang ito ay naka-hold. Ang mga pagsusumite ay hindi tinatanggap sa oras na ito.`,
    fr: `Cet \xe9v\xe9nement est en attente. Les soumissions ne sont pas accept\xe9es pour le moment.`,
    hi: `\u{92F}\u{939} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{911}\u{928}-\u{939}\u{94B}\u{932}\u{94D}\u{921} \u{939}\u{948}. \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{907}\u{938} \u{938}\u{92E}\u{92F} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Ev\xe8nman sa a se sou-kenbe. Soum\xe8t yo pa aksepte nan moman sa a.`,
    it: `Questo evento \xe8 in sospeso. Al momento non si accettano candidature.`,
    ja: `\u{3053}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{4FDD}\u{7559}\u{4E2D}\u{3067}\u{3059}\u{3002}\u{73FE}\u{6642}\u{70B9}\u{3067}\u{306F}\u{3001}\u{6295}\u{7A3F}\u{306F}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3066}\u{304A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{C774}\u{BCA4}\u{D2B8}\u{B294} \u{BCF4}\u{B958} \u{C911}\u{C785}\u{B2C8}\u{B2E4}. \u{D604}\u{C7AC} \u{C81C}\u{CD9C}\u{C744} \u{C218}\u{B77D}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev tshwm sim no yog on-tuav. Submissions yuav tsis tau txais thaum lub sij hawm no.`,
    ps: `\u{62F}\u{627} \u{67E}\u{6CC}\u{69A}\u{647} \u{67E}\u{647} \u{681}\u{646}\u{689} \u{6A9}\u{6D0} \u{62F}\u{647}. \u{67E}\u{647} \u{627}\u{648}\u{633} \u{648}\u{62E}\u{62A} \u{6A9}\u{6D0} \u{633}\u{67E}\u{627}\u{631}\u{646}\u{6D0} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `Este evento est\xe1 em espera. As inscri\xe7\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    "pt-pt": `Este evento est\xe1 suspenso. As submiss\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    ru: `\u{42D}\u{442}\u{43E} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{43F}\u{440}\u{438}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E}. \u{412} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: `O lenei mea na tupu o lo'o taofiofia. E le o taliaina talosaga i le taimi nei.`,
    so: `Xafladan waa is-waafqsan tahay. Soo gudbinta lama aqbalayo waqtigan.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E16}\u{E39}\u{E01}\u{E23}\u{E30}\u{E07}\u{E31}\u{E1A}\u{E44}\u{E27}\u{E49} \u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{6CC}\u{6C1} \u{62A}\u{642}\u{631}\u{6CC}\u{628} \u{631}\u{648}\u{6A9} \u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `S\u{1EF1} ki\u{1EC7}n n\xe0y \u{111}ang \u{111}\u{1B0}\u{1EE3}c t\u{1EA1}m d\u{1EEB}ng. C\xe1c b\xe0i d\u{1EF1} thi kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n t\u{1EA1}i th\u{1EDD}i \u{111}i\u{1EC3}m n\xe0y.`,
    "zh-hans": `\u{6B64}\u{6D3B}\u{52A8}\u{5904}\u{4E8E}\u{6682}\u{505C}\u{72B6}\u{6001}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    "zh-hant": `\u{6B64}\u{6D3B}\u{52D5}\u{8655}\u{65BC}\u{66AB}\u{505C}\u{72C0}\u{614B}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    en: `This event is on-hold. Submissions are not being accepted at this time.`
};
const $2868cc1235412e16$export$7fa9be6486c1f5f5 = {
    ar: `\u{62A}\u{645} \u{625}\u{644}\u{63A}\u{627}\u{621} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{62F}\u{62B}. \u{644}\u{627} \u{64A}\u{62A}\u{645} \u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{637}\u{644}\u{628}\u{627}\u{62A} \u{641}\u{64A} \u{627}\u{644}\u{648}\u{642}\u{62A} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}.`,
    de: `Diese Veranstaltung wurde abgesagt. Einreichungen werden derzeit nicht angenommen.`,
    es: `Este evento fue cancelado. No se aceptan inscripciones en este momento.`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{644}\u{63A}\u{648} \u{634}\u{62F}. \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{62D}\u{627}\u{636}\u{631} \u{645}\u{637}\u{627}\u{644}\u{628} \u{627}\u{631}\u{633}\u{627}\u{644}\u{6CC} \u{67E}\u{630}\u{6CC}\u{631}\u{641}\u{62A}\u{647} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Kinansela ang event na ito. Ang mga pagsusumite ay hindi tinatanggap sa oras na ito.`,
    fr: `Cet \xe9v\xe9nement a \xe9t\xe9 annul\xe9. Les soumissions ne sont pas accept\xe9es pour le moment.`,
    hi: `\u{92F}\u{939} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}. \u{92A}\u{94D}\u{930}\u{938}\u{94D}\u{924}\u{941}\u{924}\u{93F}\u{92F}\u{93E}\u{901} \u{907}\u{938} \u{938}\u{92E}\u{92F} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{930}\u{939}\u{940} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Ev\xe8nman sa a te anile. Soum\xe8t yo pa aksepte nan moman sa a.`,
    it: `L'evento \xe8 stato annullato. Al momento non si accettano candidature.`,
    ja: `\u{3053}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{4E2D}\u{6B62}\u{3068}\u{306A}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}\u{73FE}\u{6642}\u{70B9}\u{3067}\u{306F}\u{3001}\u{6295}\u{7A3F}\u{306F}\u{53D7}\u{3051}\u{4ED8}\u{3051}\u{3066}\u{304A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{C774}\u{BCA4}\u{D2B8}\u{B294} \u{CDE8}\u{C18C}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{D604}\u{C7AC} \u{C81C}\u{CD9C}\u{C744} \u{C218}\u{B77D}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kev tshwm sim no tau lawm os. Submissions yuav tsis tau txais thaum lub sij hawm no.`,
    ps: `\u{62F}\u{627} \u{67E}\u{6CC}\u{69A}\u{647} \u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}\u{647}. \u{67E}\u{647} \u{627}\u{648}\u{633} \u{648}\u{62E}\u{62A} \u{6A9}\u{6D0} \u{633}\u{67E}\u{627}\u{631}\u{646}\u{6D0} \u{646}\u{647} \u{645}\u{646}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `Este evento foi cancelado. As inscri\xe7\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    "pt-pt": `Este evento foi cancelado. As submiss\xf5es n\xe3o est\xe3o sendo aceitas no momento.`,
    ru: `\u{42D}\u{442}\u{43E} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{435} \u{431}\u{44B}\u{43B}\u{43E} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43E}. \u{412} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F} \u{437}\u{430}\u{44F}\u{432}\u{43A}\u{438} \u{43D}\u{435} \u{43F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44E}\u{442}\u{441}\u{44F}.`,
    sm: `O lenei mea na tupu na faaleaogaina. E le o taliaina talosaga i le taimi nei.`,
    so: `Xafladan ayaa baaqatay. Soo gudbinta lama aqbalayo waqtigan.`,
    th: `\u{E07}\u{E32}\u{E19}\u{E19}\u{E35}\u{E49}\u{E16}\u{E39}\u{E01}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01} \u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1C}\u{E25}\u{E07}\u{E32}\u{E19}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{6CC}\u{6C1} \u{62A}\u{642}\u{631}\u{6CC}\u{628} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631} \u{62F}\u{6CC} \u{6AF}\u{626}\u{6CC}\u{6D4} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}\u{6CC}\u{6BA} \u{642}\u{628}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC} \u{62C}\u{627} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `S\u{1EF1} ki\u{1EC7}n n\xe0y \u{111}\xe3 b\u{1ECB} h\u{1EE7}y b\u{1ECF}. C\xe1c b\xe0i d\u{1EF1} thi kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ch\u{1EA5}p nh\u{1EAD}n t\u{1EA1}i th\u{1EDD}i \u{111}i\u{1EC3}m n\xe0y.`,
    "zh-hans": `\u{6B64}\u{6D3B}\u{52A8}\u{5DF2}\u{53D6}\u{6D88}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    "zh-hant": `\u{6B64}\u{6D3B}\u{52D5}\u{5DF2}\u{53D6}\u{6D88}\u{3002}\u{76EE}\u{524D}\u{4E0D}\u{63A5}\u{53D7}\u{63D0}\u{4EA4}\u{3002}`,
    en: `This event was cancelled. Submissions are not being accepted at this time.`
};
const $2868cc1235412e16$export$666d23e8988a5a30 = {
    ar: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`بالتحويل من <a href="${activityHref}">${title}</a> التي انتهت في ${endDate}.`,
    de: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Weitergeleitet von <a href="${activityHref}">${title}</a> endete am ${endDate}.`,
    es: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Redirigido desde <a href="${activityHref}">${title}</a> que terminó el ${endDate}.`,
    fa: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`تغییرمسیر از <a href="${activityHref}">${title}</a> که در ${endDate} به پایان رسید.`,
    fil: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Idinirekta mula sa <a href="${activityHref}">${title}</a> na natapos noong ${endDate}`,
    fr: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Redirigé depuis <a href="${activityHref}">${title}</a> qui a terminé le ${endDate}.`,
    hi: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`<a href="${activityHref}">${title}</a> से अनुप्रेषित, जो ${endDate} को समाप्त हुआ।`,
    ht: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Redireksyon soti nan <a href="${activityHref}">${title}</a> ki te fini ${endDate}.`,
    it: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Reindirizzato da <a href="${activityHref}">${title}</a> che si è conclusa il ${endDate}.`,
    ja: (endDate, activityHref, title)=>$2868cc1235412e16$var$html`${endDate}終了した<a href="${activityHref}">${title}</a>からリダイレクトされました。`,
    ko: (endDate, activityHref, title)=>$2868cc1235412e16$var$html`${endDate}일에 종료된 <a href="${activityHref}">${title}</a>에서 리디렉션되었습니다.`,
    mww: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Redirected ntawm <a href="${activityHref}">${title}</a> uas twb rau ${endDate}.`,
    ps: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`د <a href="${activityHref}">${title}</a> څخه هدایت شوی چې د ${endDate}.`,
    pt: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Redirecionado de <a href="${activityHref}">${title}</a> que terminou em ${endDate}.`,
    "pt-pt": (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Redirecionado de <a href="${activityHref}">${title}</a> que terminou em ${endDate}.`,
    ru: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Перенаправлено с « <a href="${activityHref}">${title}</a> », которая закончилась ${endDate}.`,
    sm: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Toe fa'afo'i mai le <a href="${activityHref}">${title}</a> lea na fa'amutaina ia ${endDate}.`,
    so: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Waxaa si toos ah looga soo saaray <a href="${activityHref}">${title}</a> oo dhammaatay ${endDate}.`,
    th: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`เปลี่ยนทางจาก <a href="${activityHref}">${title}</a> ซึ่งสิ้นสุดเมื่อวันที่ ${endDate}`,
    ur: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`<a href="${activityHref}">${title}</a> سے ری ڈائریکٹ کیا گیا جو ${endDate} کو ختم ہوا۔`,
    vi: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Đổi hướng từ <a href="${activityHref}">${title}</a> kết thúc vào ngày ${endDate}.`,
    "zh-hans": (endDate, activityHref, title)=>$2868cc1235412e16$var$html`重定向自7${endDate}结束的<a href="${activityHref}">${title}</a>。`,
    "zh-hant": (endDate, activityHref, title)=>$2868cc1235412e16$var$html`重定向自7${endDate}結束的<a href="${activityHref}">${title}</a>。`,
    en: (activityHref, title, endDate)=>$2868cc1235412e16$var$html`Redirected from <a href="${activityHref}">${title}</a> which ended on ${endDate}.`
};
const $2868cc1235412e16$export$24d7027629fb8fb1 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Titel`,
    es: `T\xedtulo`,
    fa: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    fil: `Pamagat`,
    fr: `Titre`,
    hi: `\u{909}\u{92A}\u{93E}\u{927}\u{93F}`,
    ht: `Tit`,
    it: `Titolo`,
    ja: `\u{30BF}\u{30A4}\u{30C8}\u{30EB}`,
    ko: `\u{D0C0}\u{C774}\u{D2C0}`,
    mww: `Title`,
    ps: `\u{633}\u{631}\u{644}\u{6CC}\u{6A9}`,
    pt: `T\xedtulo`,
    "pt-pt": `T\xedtulo`,
    ru: `\u{422}\u{438}\u{442}\u{443}\u{43B}`,
    sm: `Ulutala`,
    so: `Title`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    vi: `Ti\xeau \u{111}\u{1EC1}`,
    "zh-hans": `\u{6807}\u{9898}`,
    "zh-hant": `\u{6A19}\u{984C}`,
    en: `Title`
};
const $2868cc1235412e16$export$88c17563ef32d480 = {
    ar: `\u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621}/\u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    de: `Start-/Enddatum`,
    es: `Fechas de inicio/finalizaci\xf3n`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639}/\u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Mga petsa ng pagsisimula / pagtatapos`,
    fr: `Dates de d\xe9but et de fin`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D}/\u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}`,
    ht: `K\xf2manse/fini dat`,
    it: `Date di inizio/fine`,
    ja: `\u{958B}\u{59CB}\u{65E5}/\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{C2DC}\u{C791}\u{C77C}/\u{C885}\u{B8CC}\u{C77C}`,
    mww: `Pib/hnub tim`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} / \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{6D0}`,
    pt: `Datas de in\xedcio/t\xe9rmino`,
    "pt-pt": `Datas de in\xedcio/fim`,
    ru: `\u{414}\u{430}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}/\u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso amata / fa'ai'u`,
    so: `Taariikhda Bilowga/dhamaadka`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}/\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{622}\u{63A}\u{627}\u{632} / \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{6CC}\u{6BA}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u/k\u{1EBF}t th\xfac`,
    "zh-hans": `\u{5F00}\u{59CB}/\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "zh-hant": `\u{958B}\u{59CB}/\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Start/end dates`
};
const $2868cc1235412e16$export$fdbabd02c17c33c3 = {
    ar: `\u{639}\u{646}\u{627}\u{648}\u{64A}\u{646}`,
    de: `Adressen`,
    es: `Direcciones`,
    fa: `\u{622}\u{62F}\u{631}\u{633}`,
    fil: `Email Address`,
    fr: `Adresses`,
    hi: `\u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s`,
    it: `Indirizzi`,
    ja: `\u{30A2}\u{30C9}\u{30EC}\u{30B9}`,
    ko: `\u{C8FC}\u{C18C}`,
    mww: `Chaw Nyob`,
    ps: `\u{627}\u{62F}\u{631}\u{633}\u{648}\u{646}\u{647}`,
    pt: `Endere\xe7os`,
    "pt-pt": `Endere\xe7os`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441}\u{430}`,
    sm: `Tuatusi`,
    so: `Cinwaanada`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{67E}\u{62A}\u{6D2}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9}`,
    "zh-hans": `\u{5730}\u{5740}`,
    "zh-hant": `\u{4F4D}\u{5740}`,
    en: `Addresses`
};
const $2868cc1235412e16$export$b1cfe4d9572aab22 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adresse`,
    es: `Direcci\xf3n`,
    fa: `\u{622}\u{62F}\u{631}\u{633}`,
    fil: `Email Address`,
    fr: `Adresse`,
    hi: `\u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s`,
    it: `Indirizzo`,
    ja: `\u{4F4F}\u{6240}`,
    ko: `\u{C8FC}\u{C18C}`,
    mww: `Address`,
    ps: `\u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o`,
    "pt-pt": `Endere\xe7o`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi`,
    so: `Cinwaanka`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9}`,
    "zh-hans": `\u{5730}\u{5740}`,
    "zh-hant": `\u{4F4D}\u{5740}`,
    en: `Address`
};
const $2868cc1235412e16$export$46b94f4580a8ef35 = {
    ar: (count)=>`${count} \u{645}\u{641}\u{62A}\u{648}\u{62D}`,
    de: (count)=>`${count} ge\xf6ffnet`,
    es: (count)=>`${count} abiertos`,
    fa: (count)=>`${count} \u{628}\u{627}\u{632}`,
    fil: (count)=>`${count} Buksan`,
    fr: (count)=>`${count} Ouvrir`,
    hi: (count)=>`${count} \u{909}\u{918}\u{921}\u{93E}`,
    ht: (count)=>`${count} louvri`,
    it: (count)=>`${count} apri`,
    ja: (count)=>`${count} \u{30AA}\u{30FC}\u{30D7}\u{30F3}`,
    ko: (count)=>`${count} \u{C5F4}\u{AE30}`,
    mww: (count)=>`${count} qhib`,
    ps: (count)=>`${count} \u{62E}\u{644}\u{627}\u{635}`,
    pt: (count)=>`${count} aberto`,
    "pt-pt": (count)=>`${count} aberto`,
    ru: (count)=>`${count} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{445}`,
    sm: (count)=>`${count} tatala`,
    so: (count)=>`${count} furan`,
    th: (count)=>`${count} \u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: (count)=>`${count} \u{6A9}\u{6BE}\u{644}\u{6CC}`,
    vi: (count)=>`${count} M\u{1EDF}`,
    "zh-hans": (count)=>`${count} \u{6253}\u{5F00}`,
    "zh-hant": (count)=>`${count} \u{6253}\u{958B}`,
    en: (count)=>`${count} open`
};
const $2868cc1235412e16$export$dd90b1584f439f31 = {
    ar: (count)=>`${count} \u{645}\u{63A}\u{644}\u{642}`,
    de: (count)=>`${count} geschlossen`,
    es: (count)=>`${count} cerrados`,
    fa: (count)=>`${count} \u{628}\u{633}\u{62A}\u{647}`,
    fil: (count)=>`${count} Sarado`,
    fr: (count)=>`${count} ferm\xe9`,
    hi: (count)=>`${count} \u{92C}\u{902}\u{926}`,
    ht: (count)=>`${count} f\xe8men`,
    it: (count)=>`${count} chiusi`,
    ja: (count)=>`${count} \u{5B9A}\u{4F11}\u{65E5}`,
    ko: (count)=>`${count} \u{B2EB}\u{D798}`,
    mww: (count)=>`${count} kaw`,
    ps: (count)=>`${count} \u{62A}\u{693}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: (count)=>`${count} Fechado`,
    "pt-pt": (count)=>`${count} fechados`,
    ru: (count)=>`${count} \u{437}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{43E}`,
    sm: (count)=>`${count} tapunia`,
    so: (count)=>`${count} xidhan`,
    th: (count)=>`${count} \u{E1B}\u{E34}\u{E14}`,
    ur: (count)=>`${count} \u{628}\u{646}\u{62F}`,
    vi: (count)=>`${count} \u{110}\xf3ng c\u{1EED}a`,
    "zh-hans": (count)=>`${count} \u{5173}\u{95ED}`,
    "zh-hant": (count)=>`${count} \u{95DC}\u{9589}`,
    en: (count)=>`${count} closed`
};
const $2868cc1235412e16$export$15565a177ad68852 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}`,
    de: `Keine offenen Aktivit\xe4ten`,
    es: `No hay actividades abiertas`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{627}\u{632}`,
    fil: `Walang bukas na aktibidad`,
    fr: `Pas d\u{2019}activit\xe9s ouvertes`,
    hi: `\u{915}\u{94B}\u{908} \u{916}\u{941}\u{932}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen aktivite ouv\xe8`,
    it: `Nessuna attivit\xe0 aperta`,
    ja: `\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{306A}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{ACF5}\u{AC1C} \u{D65C}\u{B3D9} \u{AE08}\u{C9C0}`,
    mww: `Tsis muaj kev ua ub no`,
    ps: `\u{646}\u{647} \u{67E}\u{631}\u{627}\u{646}\u{6CC}\u{633}\u{62A}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Sem atividades abertas`,
    "pt-pt": `Sem atividades abertas`,
    ru: `\u{41D}\u{435}\u{442} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{445} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439}`,
    sm: `Leai ni gaoioiga tatala`,
    so: `Wax shaqo ah oo furan ma qabanayo`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{6A9}\u{6BE}\u{644}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng m\u{1EDF}`,
    "zh-hans": `\u{65E0}\u{5F00}\u{653E}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{7121}\u{958B}\u{653E}\u{6D3B}\u{52D5}`,
    en: `No open activities`
};
const $2868cc1235412e16$export$a860e676d405bc34 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{63A}\u{644}\u{642}\u{629}`,
    de: `Keine geschlossenen Aktivit\xe4ten`,
    es: `No hay actividades cerradas`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{633}\u{62A}\u{647}`,
    fil: `Walang saradong aktibidad`,
    fr: `Pas d\u{2019}activit\xe9s ferm\xe9es`,
    hi: `\u{915}\u{94B}\u{908} \u{92C}\u{902}\u{926} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen aktivite f\xe8men`,
    it: `Nessuna attivit\xe0 chiusa`,
    ja: `\u{9589}\u{9396}\u{3055}\u{308C}\u{305F}\u{6D3B}\u{52D5}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{D3D0}\u{C1C4}\u{B41C} \u{D65C}\u{B3D9} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj kev ua ub no kaw`,
    ps: `\u{646}\u{647} \u{62A}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Sem atividades fechadas`,
    "pt-pt": `Sem atividades fechadas`,
    ru: `\u{41D}\u{435}\u{442} \u{437}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{445} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439}`,
    sm: `Leai ni gaoioiga tapunia`,
    so: `Wax hawl ah oo xiran ma jiro`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{646}\u{62F} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xf3ng c\u{1EED}a`,
    "zh-hans": `\u{65E0}\u{5DF2}\u{5173}\u{95ED}\u{7684}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{7121}\u{5DF2}\u{95DC}\u{9589}\u{7684}\u{6D3B}\u{52D5}`,
    en: `No closed activities`
};
const $2868cc1235412e16$export$fa90a448dd1987f = {
    ar: `\u{633}\u{64A}\u{62A}\u{645} \u{633}\u{631}\u{62F} \u{645}\u{633}\u{648}\u{62F}\u{629} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{648}\u{627}\u{644}\u{62C}\u{627}\u{647}\u{632}\u{629} \u{648}\u{627}\u{644}\u{62C}\u{627}\u{631}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{645}\u{639}\u{644}\u{642}\u{629} \u{647}\u{646}\u{627}.`,
    de: `Entwurfs-, Bereit-, In Bearbeitung- und Zur\xfcckgestellte Aktivit\xe4ten werden hier aufgelistet.`,
    es: `Las actividades en borrador, listas, en curso y en espera se enumerar\xe1n aqu\xed.`,
    fa: `\u{67E}\u{6CC}\u{634} \u{646}\u{648}\u{6CC}\u{633}\u{60C} \u{622}\u{645}\u{627}\u{62F}\u{647}\u{60C} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{62F}\u{631} \u{62D}\u{627}\u{644} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{631} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Ang mga draft, handa, in-progress, at on-hold na mga aktibidad ay nakalista dito.`,
    fr: `Les activit\xe9s en brouillon, pr\xeates, en cours et en attente seront r\xe9pertori\xe9es ici.`,
    hi: `\u{921}\u{94D}\u{930}\u{93E}\u{92B}\u{94D}\u{91F}, \u{930}\u{947}\u{921}\u{940}, \u{907}\u{928}-\u{92A}\u{94D}\u{930}\u{94B}\u{917}\u{94D}\u{930}\u{947}\u{938} \u{914}\u{930} \u{911}\u{928}-\u{939}\u{94B}\u{932}\u{94D}\u{921} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{92F}\u{939}\u{93E}\u{902} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: `Pwogr\xe8, nan-pwogr\xe8, ak sou-kenbe aktivite yo pral ki nan lis isit la.`,
    it: `Le attivit\xe0 in bozza, pronte, in corso e in sospeso saranno elencate qui.`,
    ja: `\u{30C9}\u{30E9}\u{30D5}\u{30C8}\u{3001}\u{6E96}\u{5099}\u{5B8C}\u{4E86}\u{3001}\u{9032}\u{884C}\u{4E2D}\u{3001}\u{304A}\u{3088}\u{3073}\u{4FDD}\u{7559}\u{4E2D}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{304C}\u{3053}\u{3053}\u{306B}\u{4E00}\u{89A7}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{CD08}\u{C548}, \u{C900}\u{BE44}, \u{C9C4}\u{D589} \u{C911} \u{BC0F} \u{BCF4}\u{B958} \u{D65C}\u{B3D9}\u{C774} \u{C5EC}\u{AE30}\u{C5D0} \u{B098}\u{C5F4}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Cua ntsawj ntshab, npaj, in-progress, thiab on-tuav cov kev ua ub no yuav muaj teev nyob ntawm no.`,
    ps: `\u{645}\u{633}\u{648}\u{62F}\u{647}\u{60C} \u{62A}\u{6CC}\u{627}\u{631}\u{647}\u{60C} \u{67E}\u{647} \u{62C}\u{631}\u{6CC}\u{627}\u{646} \u{6A9}\u{6D0} \u{627}\u{648} \u{681}\u{646}\u{689}\u{648}\u{644} \u{634}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{647} \u{62F}\u{644}\u{62A}\u{647} \u{644}\u{633}\u{62A} \u{634}\u{6CC}.`,
    pt: `As atividades de rascunho, prontas, em andamento e em espera ser\xe3o listadas aqui.`,
    "pt-pt": `As atividades de rascunho, prontas, em andamento e em espera ser\xe3o listadas aqui.`,
    ru: `\u{417}\u{434}\u{435}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{44B} \u{447}\u{435}\u{440}\u{43D}\u{43E}\u{432}\u{44B}\u{435}, \u{433}\u{43E}\u{442}\u{43E}\u{432}\u{44B}\u{435}, \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{44F}\u{435}\u{43C}\u{44B}\u{435} \u{438} \u{43E}\u{442}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}.`,
    sm: `O gaioiga fa'ata'ita'i, saunia, o lo'o alualu i luma, ma o lo'o taofia o le a lisiina iinei.`,
    so: `Qabyo qoraal, diyaar, horumar iyo hawlo kusaabsan ayaa halkan lagu soo koobi doonaa.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E41}\u{E1A}\u{E1A}\u{E23}\u{E48}\u{E32}\u{E07} \u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21} \u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23} \u{E41}\u{E25}\u{E30}\u{E23}\u{E2D}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E08}\u{E30}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{645}\u{633}\u{648}\u{62F}\u{6C1}\u{60C} \u{62A}\u{6CC}\u{627}\u{631}\u{60C} \u{62C}\u{627}\u{631}\u{6CC} \u{627}\u{648}\u{631} \u{62C}\u{627}\u{631}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{648} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627}.`,
    vi: `C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng d\u{1EF1} th\u{1EA3}o, s\u{1EB5}n s\xe0ng, \u{111}ang ti\u{1EBF}n h\xe0nh v\xe0 t\u{1EA1}m d\u{1EEB}ng s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea \u{1EDF} \u{111}\xe2y.`,
    "zh-hans": `\u{6B64}\u{5904}\u{5C06}\u{5217}\u{51FA} Draft\u{3001}Ready\u{3001}in-progress \u{548C} on-hold \u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": `\u{6B64}\u{8655}\u{5C07}\u{5217}\u{51FA} Draft\u{3001}Ready\u{3001}in-progress \u{548C} on-hold \u{6D3B}\u{52D5}\u{3002}`,
    en: `Draft, ready, in-progress, and on-hold activities will be listed here.`
};
const $2868cc1235412e16$export$147ffe3f4dd416a4 = {
    ar: `\u{633}\u{62A}\u{638}\u{647}\u{631} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{645}\u{644}\u{629} \u{648}\u{627}\u{644}\u{645}\u{644}\u{63A}\u{627}\u{629} \u{647}\u{646}\u{627}.`,
    de: `Abgeschlossene und stornierte Aktivit\xe4ten werden hier angezeigt.`,
    es: `Las actividades completadas y canceladas aparecer\xe1n aqu\xed.`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}\u{647} \u{648} \u{644}\u{63A}\u{648} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{638}\u{627}\u{647}\u{631} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Ang mga nakumpleto at kinansela na mga aktibidad ay lilitaw dito.`,
    fr: `Les activit\xe9s termin\xe9es et annul\xe9es appara\xeetront ici.`,
    hi: `\u{92A}\u{942}\u{930}\u{94D}\u{923} \u{914}\u{930} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{940} \u{917}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{92F}\u{939}\u{93E}\u{902} \u{926}\u{93F}\u{916}\u{93E}\u{908} \u{926}\u{947}\u{902}\u{917}\u{940}\u{964}`,
    ht: `Ranpli ak anile aktivite anile ap par\xe8t isit la.`,
    it: `Le attivit\xe0 completate e annullate appariranno qui.`,
    ja: `\u{5B8C}\u{4E86}\u{3057}\u{305F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3068}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3055}\u{308C}\u{305F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3053}\u{3053}\u{306B}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C644}\u{B8CC} \u{BC0F} \u{CDE8}\u{C18C}\u{B41C} \u{D65C}\u{B3D9}\u{C774} \u{C5EC}\u{AE30}\u{C5D0} \u{D45C}\u{C2DC}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Ua tiav thiab lawm os cov kev ua ub no yuav tshwm sim ntawm no.`,
    ps: `\u{628}\u{634}\u{67E}\u{693} \u{634}\u{648}\u{6CC} \u{627}\u{648} \u{644}\u{63A}\u{648}\u{647} \u{634}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{647} \u{62F}\u{644}\u{62A}\u{647} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{634}\u{6CC}.`,
    pt: `As atividades conclu\xeddas e canceladas aparecer\xe3o aqui.`,
    "pt-pt": `As atividades conclu\xeddas e canceladas aparecer\xe3o aqui.`,
    ru: `\u{417}\u{434}\u{435}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{438} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `O gaoioiga ua maea ma ua faaleaogaina o le a faaali mai iinei.`,
    so: `Hawlaha lasoo gabagabeeyay ee baajiyay ayaa halkan kasoo muuqan doona.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E41}\u{E25}\u{E30}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E08}\u{E30}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{645}\u{6A9}\u{645}\u{644} \u{627}\u{648}\u{631} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{634}\u{62F}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{6BA} \u{6AF}\u{6CC}\u{6D4}`,
    vi: `C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\xe3 ho\xe0n th\xe0nh v\xe0 b\u{1ECB} h\u{1EE7}y s\u{1EBD} xu\u{1EA5}t hi\u{1EC7}n t\u{1EA1}i \u{111}\xe2y.`,
    "zh-hans": `\u{5DF2}\u{5B8C}\u{6210}\u{548C}\u{5DF2}\u{53D6}\u{6D88}\u{7684}\u{6D3B}\u{52A8}\u{5C06}\u{663E}\u{793A}\u{5728}\u{6B64}\u{5904}\u{3002}`,
    "zh-hant": `\u{5DF2}\u{5B8C}\u{6210}\u{548C}\u{5DF2}\u{53D6}\u{6D88}\u{7684}\u{6D3B}\u{52D5}\u{5C07}\u{986F}\u{793A}\u{5728}\u{6B64}\u{8655}\u{3002}`,
    en: `Completed and cancelled activities will appear here.`
};
const $2868cc1235412e16$export$16256a8f0e357bc4 = {
    ar: (login)=>$2868cc1235412e16$var$html`تم تعيينه <span>${login}</span>`,
    de: (login)=>$2868cc1235412e16$var$html`<span>${login} zugewiesen</span>`,
    es: (login)=>$2868cc1235412e16$var$html`asignado a <span>${login}</span>`,
    fa: (login)=>$2868cc1235412e16$var$html`به جین اختصاص داده شده است <span>${login}</span>`,
    fil: (login)=>$2868cc1235412e16$var$html`Inatasan si <span>${login}</span>`,
    fr: (login)=>$2868cc1235412e16$var$html`attribué à <span>${login}</span>`,
    hi: (login)=>$2868cc1235412e16$var$html`<span>${login} को सौंपा</span>`,
    ht: (login)=>$2868cc1235412e16$var$html`asiyen nan <span>${login}</span>`,
    it: (login)=>$2868cc1235412e16$var$html`assegnato a <span>${login}</span>`,
    ja: (login)=>$2868cc1235412e16$var$html`<span>${login}に割り当てられました</span>`,
    ko: (login)=>$2868cc1235412e16$var$html`<span>${login}에게 배정됨</span>`,
    mww: (login)=>$2868cc1235412e16$var$html`raug xa mus rau <span>${login}</span>`,
    ps: (login)=>$2868cc1235412e16$var$html`جین <span>${login} ته سپارل شوی</span>`,
    pt: (login)=>$2868cc1235412e16$var$html`atribuído a <span>${login}</span>`,
    "pt-pt": (login)=>$2868cc1235412e16$var$html`atribuído a <span>${login}</span>`,
    ru: (login)=>$2868cc1235412e16$var$html`закреплено за <span>${login}</span>`,
    sm: (login)=>$2868cc1235412e16$var$html`Tofia ia <span>${login}</span>`,
    so: (login)=>$2868cc1235412e16$var$html`loo xilsaaray <span>${login}</span>`,
    th: (login)=>$2868cc1235412e16$var$html`มอบหมายให้ <span>${login}</span>`,
    ur: (login)=>$2868cc1235412e16$var$html`جین کو تفویض کیا گیا <span>${login}</span>`,
    vi: (login)=>$2868cc1235412e16$var$html`được giao cho <span>${login}</span>`,
    "zh-hans": (login)=>$2868cc1235412e16$var$html`分配给 <span>${login}</span>`,
    "zh-hant": (login)=>$2868cc1235412e16$var$html`分配給 <span>${login}</span>`,
    en: (login)=>$2868cc1235412e16$var$html`assigned to <span>${login}</span>`
};
const $2868cc1235412e16$export$f5d4437ca730d57d = {
    ar: (login)=>$2868cc1235412e16$var$html`تم إنشاؤه بواسطة <span>${login}</span>`,
    de: (login)=>$2868cc1235412e16$var$html`Erstellt von <span>${login}</span>`,
    es: (login)=>$2868cc1235412e16$var$html`Creado por <span>${login}</span>`,
    fa: (login)=>$2868cc1235412e16$var$html`ایجاد شده توسط <span>${login}</span>`,
    fil: (login)=>$2868cc1235412e16$var$html`Nilikha ni <span>${login}</span>`,
    fr: (login)=>$2868cc1235412e16$var$html`Créé par <span>${login}</span>`,
    hi: (login)=>$2868cc1235412e16$var$html`जेन द्वारा बनाया गया <span>${login}</span>`,
    ht: (login)=>$2868cc1235412e16$var$html`Kreye pa <span>${login}</span>`,
    it: (login)=>$2868cc1235412e16$var$html`Creato da <span>${login}</span>`,
    ja: (login)=>$2868cc1235412e16$var$html`<span>${login}</span>`,
    ko: (login)=>$2868cc1235412e16$var$html`만든 사람 <span>${login}</span>`,
    mww: (login)=>$2868cc1235412e16$var$html`Tsim los ntawm <span>${login}</span>`,
    ps: (login)=>$2868cc1235412e16$var$html`ایجاد شده توسط <span>${login}</span>`,
    pt: (login)=>$2868cc1235412e16$var$html`Criado por <span>${login}</span>`,
    "pt-pt": (login)=>$2868cc1235412e16$var$html`Criado por <span>${login}</span>`,
    ru: (login)=>$2868cc1235412e16$var$html`Создано <span>${login}</span>`,
    sm: (login)=>$2868cc1235412e16$var$html`Saunia e <span>${login}</span>`,
    so: (login)=>$2868cc1235412e16$var$html`Waxaa abuuray <span>${login}</span>`,
    th: (login)=>$2868cc1235412e16$var$html`สร้างโดย <span>${login}</span>`,
    ur: (login)=>$2868cc1235412e16$var$html`جین کے ذریعہ تخلیق کیا گیا <span>${login}</span>`,
    vi: (login)=>$2868cc1235412e16$var$html`Tạo bởi <span>${login}</span>`,
    "zh-hans": (login)=>$2868cc1235412e16$var$html`创建者 <span>${login}</span>`,
    "zh-hant": (login)=>$2868cc1235412e16$var$html`建立者 <span>${login}</span>`,
    en: (login)=>$2868cc1235412e16$var$html`Created by <span>${login}</span>`
};
const $2868cc1235412e16$export$e0f8ffeffb71452 = {
    ar: `1 \u{62A}\u{639}\u{644}\u{64A}\u{642}`,
    de: `1 Kommentar`,
    es: `1 comentario`,
    fa: `1 \u{646}\u{638}\u{631}`,
    fil: `1 komento`,
    fr: `1 commentaire`,
    hi: `1 \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940}`,
    ht: `1 k\xf2mant\xe8`,
    it: `1 commento`,
    ja: `1\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `1 \u{CF54}\u{BA58}\u{D2B8}`,
    mww: `1 saib`,
    ps: `1 \u{62A}\u{628}\u{635}\u{631}\u{647}`,
    pt: `1 coment\xe1rio`,
    "pt-pt": `1 coment\xe1rio`,
    ru: `1 \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{439}`,
    sm: `1 faamatalaga`,
    so: `1 comment`,
    th: `1 \u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}`,
    ur: `1 \u{62A}\u{628}\u{635}\u{631}\u{6C1}`,
    vi: `1 b\xecnh lu\u{1EAD}n`,
    "zh-hans": `1\u{8BC4}\u{8BBA}`,
    "zh-hant": `1\u{8A55}\u{8AD6}`,
    en: `1 comment`
};
const $2868cc1235412e16$export$abf4bfeea8a809b3 = {
    ar: (count)=>`${count} \u{62A}\u{639}\u{644}\u{64A}\u{642}\u{627}\u{62A}`,
    de: (count)=>`${count} Kommentare`,
    es: (count)=>`${count} comentarios`,
    fa: (count)=>`${count} \u{646}\u{638}\u{631}\u{627}\u{62A}`,
    fil: (count)=>`${count} Mga Komento`,
    fr: (count)=>`${count} commentaires`,
    hi: (count)=>`${count} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: (count)=>`${count} k\xf2mant\xe8`,
    it: (count)=>`${count} commenti`,
    ja: (count)=>`${count} \u{4EF6}\u{306E}\u{30B3}\u{30E1}\u{30F3}\u{30C8}`,
    ko: (count)=>`${count} \u{CF54}\u{BA58}\u{D2B8}`,
    mww: (count)=>`${count} lus`,
    ps: (count)=>`${count} \u{62A}\u{628}\u{635}\u{631}\u{6D0}`,
    pt: (count)=>`${count} coment\xe1rios`,
    "pt-pt": (count)=>`${count} coment\xe1rios`,
    ru: (count)=>`${count} \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{435}\u{432}`,
    sm: (count)=>`${count} fa'amatalaga`,
    so: (count)=>`${count} comments`,
    th: (count)=>`${count}`,
    ur: (count)=>`${count} \u{62A}\u{628}\u{635}\u{631}\u{6D2}`,
    vi: (count)=>`${count} b\xecnh lu\u{1EAD}n`,
    "zh-hans": (count)=>`${count} \u{8BC4}\u{8BBA}`,
    "zh-hant": (count)=>`${count} \u{8A55}\u{8AD6}`,
    en: (count)=>`${count} comments`
};
const $2868cc1235412e16$export$8a23b76271eff460 = {
    ar: (dueDate)=>`\u{62A}\u{633}\u{62A}\u{62D}\u{642} ${dueDate}`,
    de: (dueDate)=>`f\xe4llig am ${dueDate}`,
    es: (dueDate)=>`Fecha de vencimiento el ${dueDate}`,
    fa: (dueDate)=>`\u{633}\u{631}\u{631}\u{633}\u{6CC}\u{62F} \u{62F}\u{631} ${dueDate}`,
    fil: (dueDate)=>`dahil sa ${dueDate}`,
    fr: (dueDate)=>`d\xfb le ${dueDate}`,
    hi: (dueDate)=>`${dueDate} \u{915}\u{94B} \u{926}\u{947}\u{92F}`,
    ht: (dueDate)=>`ak\xf2z sou ${dueDate}`,
    it: (dueDate)=>`Scadenza il ${dueDate}`,
    ja: (dueDate)=>`${dueDate}\u{306B}\u{671F}\u{9650}`,
    ko: (dueDate)=>`${dueDate}\u{C77C} \u{B9C8}\u{AC10}`,
    mww: (dueDate)=>`vim ${dueDate}`,
    ps: (dueDate)=>`\u{67E}\u{647} 2 ${dueDate}`,
    pt: (dueDate)=>`Vencimento em ${dueDate}`,
    "pt-pt": (dueDate)=>`Vencimento em ${dueDate}`,
    ru: (dueDate)=>`\u{441}\u{440}\u{43E}\u{43A} \u{441}\u{434}\u{430}\u{447}\u{438} ${dueDate}`,
    sm: (dueDate)=>`Fa'atatau i le ${dueDate}`,
    so: (dueDate)=>`sababta on ${dueDate}`,
    th: (dueDate)=>`\u{E04}\u{E23}\u{E1A}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${dueDate}`,
    ur: (dueDate)=>`${dueDate} \u{6A9}\u{648} \u{648}\u{627}\u{62C}\u{628} \u{627}\u{644}\u{627}\u{62F}\u{627}`,
    vi: (dueDate)=>`\u{111}\u{1EBF}n h\u{1EA1}n v\xe0o ${dueDate}`,
    "zh-hans": (dueDate)=>`\u{622A}\u{6B62}\u{65E5}\u{671F}\u{FF1A}${dueDate} \u{65E5}`,
    "zh-hant": (dueDate)=>`\u{622A}\u{6B62}\u{65E5}\u{671F}\u{FF1A}${dueDate}\u{65E5}`,
    en: (dueDate)=>`due on ${dueDate}`
};
const $2868cc1235412e16$export$1f89b864013015b4 = {
    ar: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} اعتبارا من ${statusDate}</span>`,
    de: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} ab ${statusDate}</span>`,
    es: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} a partir del ${statusDate}</span>`,
    fa: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} از ${statusDate}</span>`,
    fil: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} noong ${statusDate}</span>`,
    fr: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} ${statusDate}</span>`,
    hi: (statusDate, status)=>$2868cc1235412e16$var$html`<span>${statusDate} से ${status}</span>`,
    ht: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} nan ${statusDate}</span>`,
    it: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} dal ${statusDate}</span>`,
    ja: (statusDate, status)=>$2868cc1235412e16$var$html`<span>${statusDate}日現在${status}</span>`,
    ko: (statusDate, status)=>$2868cc1235412e16$var$html`<span>${statusDate}일 ${status}</span>`,
    mww: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} raws li ${statusDate}</span>`,
    ps: (statusDate, status)=>$2868cc1235412e16$var$html`<span>د ${statusDate} ${status} شوی</span>`,
    pt: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} a ${statusDate}</span>`,
    "pt-pt": (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} a partir de ${statusDate}</span>`,
    ru: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} с ${statusDate}</span>`,
    sm: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} i le ${statusDate}</span>`,
    so: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} yahay sida ${statusDate}</span>`,
    th: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} ณ วันที่ ${statusDate}</span>`,
    ur: (statusDate, status)=>$2868cc1235412e16$var$html`<span>${statusDate} کو ${status}</span>`,
    vi: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} từ ${statusDate}</span>`,
    "zh-hans": (statusDate, status)=>$2868cc1235412e16$var$html`<span>自 ${statusDate} 日起${status}</span>`,
    "zh-hant": (statusDate, status)=>$2868cc1235412e16$var$html`<span>自 ${statusDate} 日起${status}</span>`,
    en: (status, statusDate)=>$2868cc1235412e16$var$html`<span>${status} as of ${statusDate}</span>`
};
const $2868cc1235412e16$export$549aaa164d88224e = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Details zur Veranstaltung`,
    es: `Detalles del evento`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}`,
    fil: `Mga detalye ng kaganapan`,
    fr: `D\xe9tails de l\u{2019}\xe9v\xe9nement`,
    hi: `\u{938}\u{94D}\u{92A}\u{930}\u{94D}\u{927}\u{93E} \u{935}\u{93F}\u{935}\u{930}\u{923}`,
    ht: `Detay ev\xe8nman`,
    it: `Dettagli dell'evento`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{8A73}\u{7D30}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8} \u{C138}\u{BD80} \u{C815}\u{BCF4}`,
    mww: `Cov txheej xwm kom paub meej`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes do evento`,
    "pt-pt": `Detalhes do evento`,
    ru: `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F} \u{43E} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{438}`,
    sm: `Auiliiliga o mea na tutupu`,
    so: `Faahfaahinta dhacdada`,
    th: `\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{648}\u{627}\u{642}\u{639}\u{6C1} \u{6A9}\u{6CC} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `Chi ti\u{1EBF}t s\u{1EF1} ki\u{1EC7}n`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{8BE6}\u{60C5}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{8A73}\u{60C5}`,
    en: `Event details`
};
const $2868cc1235412e16$export$575c6bbf7e1a082f = {
    ar: `\u{644}\u{642}\u{62F} \u{623}\u{643}\u{645}\u{644}\u{62A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{637}\u{644}\u{627}\u{639} \u{645}\u{624}\u{62E}\u{631}\u{627}.`,
    de: `Sie haben diese Umfrage vor kurzem abgeschlossen.`,
    es: `Has completado esta encuesta recientemente.`,
    fa: `\u{634}\u{645}\u{627} \u{627}\u{6CC}\u{646} \u{646}\u{638}\u{631}\u{633}\u{646}\u{62C}\u{6CC} \u{631}\u{627} \u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F}.`,
    fil: `Nakumpleto mo ang survey na ito kamakailan.`,
    fr: `Vous avez r\xe9cemment r\xe9pondu \xe0 ce sondage.`,
    hi: `\u{906}\u{92A}\u{928}\u{947} \u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{907}\u{938} \u{938}\u{930}\u{94D}\u{935}\u{947}\u{915}\u{94D}\u{937}\u{923} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{93E} \u{915}\u{93F}\u{92F}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Ou ranpli sondaj sa a d\xe8ny\xe8man.`,
    it: `Hai completato questo sondaggio di recente.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{306F}\u{6700}\u{8FD1}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{CD5C}\u{ADFC}\u{C5D0} \u{C774} \u{C124}\u{BB38}\u{C870}\u{C0AC}\u{B97C} \u{C644}\u{B8CC}\u{D558}\u{C168}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj ua daim ntawv ntsuam xyuas no tsis ntev los no.`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F}\u{627} \u{633}\u{631}\u{648}\u{6D0} \u{628}\u{634}\u{67E}\u{693}\u{647} \u{6A9}\u{693}\u{647}.`,
    pt: `Voc\xea completou esta pesquisa recentemente.`,
    "pt-pt": `Concluiu este inqu\xe9rito recentemente.`,
    ru: `\u{412}\u{44B} \u{43D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{43F}\u{440}\u{43E}\u{448}\u{43B}\u{438} \u{44D}\u{442}\u{43E}\u{442} \u{43E}\u{43F}\u{440}\u{43E}\u{441}.`,
    sm: `Na e faamaeaina talu ai nei lenei sailiiliga.`,
    so: `Waad dhameysay baadhitaan dhaweyd.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E17}\u{E4D}\u{E32}\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08}\u{E19}\u{E35}\u{E49}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E47}\u{E27} \u{E46} \u{E19}\u{E35}\u{E49}`,
    ur: `\u{622}\u{67E} \u{646}\u{6D2} \u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{6CC}\u{6C1} \u{633}\u{631}\u{648}\u{6D2} \u{645}\u{6A9}\u{645}\u{644} \u{6A9}\u{6CC}\u{627} \u{6C1}\u{6D2}.`,
    vi: `B\u{1EA1}n \u{111}\xe3 ho\xe0n th\xe0nh cu\u{1ED9}c kh\u{1EA3}o s\xe1t n\xe0y g\u{1EA7}n \u{111}\xe2y.`,
    "zh-hans": `\u{60A8}\u{6700}\u{8FD1}\u{5B8C}\u{6210}\u{4E86}\u{6B64}\u{8C03}\u{67E5}\u{3002}`,
    "zh-hant": `\u{60A8}\u{6700}\u{8FD1}\u{5B8C}\u{6210}\u{4E86}\u{6B64}\u{8ABF}\u{67E5}\u{3002}`,
    en: `You completed this survey recently.`
};
const $2868cc1235412e16$export$9a7334e53061c984 = {
    ar: $2868cc1235412e16$var$html`<ol><li>افتح تطبيق الكاميرا.</li><li>حدد الكاميرا الخلفية في وضع الصورة أو الكاميرا.</li><li>قم بتوسيط رمز الاستجابة السريعة على الشاشة وحافظ على ثبات هاتفك لبضع ثوان.</li><li>اضغط على الإشعار المنبثق لفتح الرابط.</li></ol>`,
    de: $2868cc1235412e16$var$html`<ol><li>Öffnen Sie die Kamera-App.</li><li>Wählen Sie die Rückfahrkamera im Foto- oder Kameramodus aus.</li><li>Zentrieren Sie den QR-Code auf dem Bildschirm und halten Sie Ihr Telefon einige Sekunden lang ruhig.</li><li>Tippen Sie auf die Benachrichtigung, die angezeigt wird, um den Link zu öffnen.</li></ol>`,
    es: $2868cc1235412e16$var$html`<ol><li>Abre la aplicación de la cámara.</li><li>Seleccione la cámara trasera en el modo Foto o Cámara.</li><li>Centra el código QR en la pantalla y mantén el teléfono firme durante un par de segundos.</li><li>Toca la notificación que aparece para abrir el enlace.</li></ol>`,
    fa: $2868cc1235412e16$var$html`<ol><li>برنامه دوربین را باز کنید.</li><li>دوربین عقب را در حالت عکس یا دوربین انتخاب کنید.</li><li>کد QR را روی صفحه در مرکز قرار دهید و گوشی خود را برای چند ثانیه ثابت نگه دارید.</li><li>روی اعلانی که باز می شود ضربه بزنید تا پیوند باز شود.</li></ol>`,
    fil: $2868cc1235412e16$var$html`<ol><li>Buksan ang app ng camera.</li><li>Piliin ang camera na nakaharap sa likuran sa mode ng Larawan o Camera.</li><li>Isentro ang QR code sa screen at hawakan nang matatag ang iyong telepono nang ilang segundo.</li><li>I-tap ang abiso na nag-pop up upang buksan ang link.</li></ol>`,
    fr: $2868cc1235412e16$var$html`<ol><li>Ouvrez l’application appareil photo.</li><li>Sélectionnez l’appareil photo arrière en mode Photo ou Appareil photo.</li><li>Centrez le code QR sur l’écran et maintenez votre téléphone stable pendant quelques secondes.</li><li>Appuyez sur la notification qui s’affiche pour ouvrir le lien.</li></ol>`,
    hi: $2868cc1235412e16$var$html`<ol><li>कैमरा ऐप खोलें।</li><li>फ़ोटो या कैमरा मोड में रियर-फ़ेसिंग कैमरा चुनें।</li><li>क्यूआर कोड को स्क्रीन पर केंद्रित करें और अपने फोन को कुछ सेकंड के लिए स्थिर रखें।</li><li>लिंक खोलने के लिए पॉप अप होने वाली सूचना पर टैप करें।</li></ol>`,
    ht: $2868cc1235412e16$var$html`<ol><li>Louvri app a kamera.</li><li>Chwazi kamera a re-fè fas a nan Foto oswa mòd Kamera.</li><li>Sant kòd QR sou ekran an epi kenbe telefòn ou fiks pou yon koup la segonn.</li><li>Tape notifikasyon an ki pòp jiska louvri lyen an.</li></ol>`,
    it: $2868cc1235412e16$var$html`<ol><li>Apri l'app della fotocamera.</li><li>Selezionare la fotocamera posteriore in modalità Foto o Fotocamera.</li><li>Centra il codice QR sullo schermo e tieni fermo il telefono per un paio di secondi.</li><li>Tocca la notifica che si apre per aprire il link.</li></ol>`,
    ja: $2868cc1235412e16$var$html`<ol><li>カメラアプリを開きます。</li><li>写真モードまたはカメラモードで背面カメラを選択します。</li><li>QRコードを画面の中央に配置し、電話を数秒間安定させます。</li><li>ポップアップする通知をタップして、リンクを開きます。</li></ol>`,
    ko: $2868cc1235412e16$var$html`<ol><li>카메라 앱을 엽니다.</li><li>사진 또는 카메라 모드에서 후면 카메라를 선택합니다.</li><li>QR 코드를 화면 중앙에 놓고 휴대전화를 몇 초 동안 흔들리지 않게 잡습니다.</li><li>팝업되는 알림을 탭하여 링크를 엽니다.</li></ol>`,
    mww: $2868cc1235412e16$var$html`<ol><li>Qhib lub koob yees duab app.</li><li>Xaiv lub koob yees duab rear-txojkev koob yees duab hauv Diam duab los yog Koob yees duab hom.</li><li>Center lub QR code ntawm qhov screen thiab tuav koj lub xov tooj khov kho rau ob peb vib nas this.</li><li>Coj mus rhaub daim ntawv ceeb toom tias pops qhib qhov txuas.</li></ol>`,
    ps: $2868cc1235412e16$var$html`<ol><li>د کامرې اپلیکیشن خلاص کړئ.</li><li>د عکس یا کیمرې موډ کې شا مخ کمره انتخاب کړئ.</li><li>په سکرین کې QR کوډ مرکز کړئ او خپل موبایل د څو ثانیو لپاره ثابت وساتئ.</li><li>د لینک د خلاصولو لپاره هغه نوټیفیکیشن چې پاپ اپ کیږی ټپ وکړئ.</li></ol>`,
    pt: $2868cc1235412e16$var$html`<ol><li>Abra o aplicativo da câmera.</li><li>Selecione a câmera traseira no modo Foto ou Câmera.</li><li>Centralize o código QR na tela e segure o telefone com firmeza por alguns segundos.</li><li>Toque na notificação que aparece para abrir o link.</li></ol>`,
    "pt-pt": $2868cc1235412e16$var$html`<ol><li>Abra a aplicação da câmara.</li><li>Selecione a câmara traseira no modo Fotografia ou Câmara.</li><li>Centralize o código QR no ecrã e mantenha o telemóvel estável durante alguns segundos.</li><li>Toque na notificação que aparece para abrir o link.</li></ol>`,
    ru: $2868cc1235412e16$var$html`<ol><li>Откройте приложение камеры.</li><li>Выберите заднюю камеру в режиме «Фото» или «Камера».</li><li>Отцентрируйте QR-код на экране и удерживайте телефон в неподвижном положении в течение нескольких секунд.</li><li>Нажмите всплывающее уведомление, чтобы открыть ссылку.</li></ol>`,
    sm: $2868cc1235412e16$var$html`<ol><li>Tatala le polokalama o le mea pu'eata.</li><li>Filifili le mea pu'eata i tua i le Ata po'o le Mea Pueata.</li><li>Fa'apipi'i le QR code i luga o le lau ma taofi lau telefoni mo ni nai sekone.</li><li>Kiliki i le fa'asilasilaga o lo'o oso a'e i luga e tatala ai le sootaga.</li></ol>`,
    so: $2868cc1235412e16$var$html`<ol><li>Fur barnaamijka kamaraduhu.</li><li>Dooro camera gadaal u jeeda in Photo ama hab Camera.</li><li>Xarunta QR code-ka shaashadda oo telefoonkaaga ku xaji si joogto ah laba ilbidhiqsi.</li><li>Taaba wargelinta in aruurin ilaa in la furo link ah.</li></ol>`,
    th: $2868cc1235412e16$var$html`<ol><li>เปิดแอปกล้อง</li><li>เลือกกล้องหลังในโหมดภาพถ่ายหรือกล้อง</li><li>จัดรหัส QR ไว้ตรงกลางหน้าจอและถือโทรศัพท์ของคุณให้นิ่งสักสองสามวินาที</li><li>แตะการแจ้งเตือนที่ปรากฏขึ้นเพื่อเปิดลิงก์</li></ol>`,
    ur: $2868cc1235412e16$var$html`<ol><li>کیمرہ ایپ کھولیں۔</li><li>فوٹو یا کیمرہ موڈ میں رئیر فیسنگ کیمرہ منتخب کریں۔</li><li>اسکرین پر کیو آر کوڈ کو مرکز بنائیں اور اپنے فون کو کچھ سیکنڈ کے لئے مستحکم رکھیں۔</li><li>لنک کھولنے کے لئے پاپ اپ ہونے والے نوٹیفکیشن پر ٹیپ کریں۔</li></ol>`,
    vi: $2868cc1235412e16$var$html`<ol><li>Mở ứng dụng máy ảnh.</li><li>Chọn camera sau ở chế độ Ảnh hoặc Máy ảnh.</li><li>Đặt mã QR giữa màn hình và giữ điện thoại của bạn ổn định trong vài giây.</li><li>Nhấn vào thông báo bật lên để mở liên kết.</li></ol>`,
    "zh-hans": $2868cc1235412e16$var$html`<ol><li>打开相机应用程序。</li><li>在 Photo （照片） 或 Camera （相机） 模式下选择后置摄像头。</li><li>将 QR 码在屏幕上居中并稳定手机几秒钟。</li><li>点击弹出的通知以打开链接。</li></ol>`,
    "zh-hant": $2868cc1235412e16$var$html`<ol><li>打開相機應用程式。</li><li>在 Photo （照片） 或 Camera （相機） 模式下選擇後置攝像頭。</li><li>將QR碼在螢幕上居中並穩定手機幾秒鐘。</li><li>點擊彈出的通知以打開連結。</li></ol>`,
    en: $2868cc1235412e16$var$html`<ol><li>Open the camera app.</li><li>Select the rear-facing camera in Photo or Camera mode.</li><li>Center the QR code on the screen and hold your phone steady for a couple of seconds.</li><li>Tap the notification that pops up to open the link.</li></ol>`
};
const $2868cc1235412e16$export$152c4be1b3779f87 = {
    ar: `\u{639}\u{631}\u{636} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629} \u{627}\u{644}\u{635}\u{63A}\u{64A}\u{631}`,
    de: `Kleinen QR-Code anzeigen`,
    es: `Ver c\xf3digo QR peque\xf1o`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{6A9}\u{62F} QR \u{6A9}\u{648}\u{686}\u{6A9}`,
    fil: `Tingnan ang maliit na QR code`,
    fr: `Voir le petit code QR`,
    hi: `\u{91B}\u{94B}\u{91F}\u{93E} \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade ti k\xf2d QR`,
    it: `Visualizza il piccolo codice QR`,
    ja: `\u{5C0F}\u{3055}\u{306A}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{898B}\u{308B}`,
    ko: `\u{C791}\u{C740} QR \u{CF54}\u{B4DC} \u{BCF4}\u{AE30}`,
    mww: `Saib me QR code`,
    ps: `\u{6A9}\u{648}\u{686}\u{646}\u{6CC} QR \u{6A9}\u{648}\u{689} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Ver pequeno c\xf3digo QR`,
    "pt-pt": `Ver c\xf3digo QR pequeno`,
    ru: `\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{43C}\u{430}\u{43B}\u{435}\u{43D}\u{44C}\u{43A}\u{438}\u{439} QR-\u{43A}\u{43E}\u{434}`,
    sm: `Va'ai la'ititi QR code`,
    so: `Eeg QR code yar`,
    th: `\u{E14}\u{E39}\u{E23}\u{E2B}\u{E31}\u{E2A} QR \u{E02}\u{E19}\u{E32}\u{E14}\u{E40}\u{E25}\u{E47}\u{E01}`,
    ur: `\u{686}\u{6BE}\u{648}\u{679}\u{627} QR \u{6A9}\u{648}\u{688} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem m\xe3 QR nh\u{1ECF}`,
    "zh-hans": `\u{67E5}\u{770B}\u{5C0F}\u{4E8C}\u{7EF4}\u{7801}`,
    "zh-hant": `\u{67E5}\u{770B}\u{5C0F}\u{4E8C}\u{7DAD}\u{78BC}`,
    en: `View small QR code`
};
const $2868cc1235412e16$export$3fe2ec103c6ce16a = {
    ar: `\u{639}\u{631}\u{636} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629} \u{627}\u{644}\u{643}\u{628}\u{64A}\u{631}`,
    de: `Gro\xdfer QR-Code anzeigen`,
    es: `Ver c\xf3digo QR grande`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{6A9}\u{62F} QR \u{628}\u{632}\u{631}\u{6AF}`,
    fil: `Tingnan ang malaking QR code`,
    fr: `Afficher le code QR grand format`,
    hi: `\u{92C}\u{921}\u{93C}\u{93E} \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `View gwo k\xf2d QR`,
    it: `Visualizza il codice QR grande`,
    ja: `\u{5927}\u{304D}\u{306A}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{8868}\u{793A}\u{3059}\u{308B}`,
    ko: `\u{B300}\u{D615} QR \u{CF54}\u{B4DC} \u{BCF4}\u{AE30}`,
    mww: `Saib loj QR code`,
    ps: `\u{644}\u{648}\u{6CC} QR \u{6A9}\u{648}\u{689} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Exibir c\xf3digo QR grande`,
    "pt-pt": `Ver c\xf3digo QR grande`,
    ru: `\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{439} QR-\u{43A}\u{43E}\u{434}`,
    sm: `Va'ai tele QR code`,
    so: `Eeg QR code weyn`,
    th: `\u{E14}\u{E39}\u{E04}\u{E34}\u{E27}\u{E2D}\u{E32}\u{E23}\u{E4C}\u{E42}\u{E04}\u{E49}\u{E14}\u{E02}\u{E19}\u{E32}\u{E14}\u{E43}\u{E2B}\u{E0D}\u{E48}`,
    ur: `\u{628}\u{691}\u{627} QR \u{6A9}\u{648}\u{688} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem m\xe3 QR l\u{1EDB}n`,
    "zh-hans": `\u{67E5}\u{770B}\u{5927}\u{578B}\u{4E8C}\u{7EF4}\u{7801}`,
    "zh-hant": `\u{67E5}\u{770B}\u{5927}\u{578B}\u{4E8C}\u{7DAD}\u{78BC}`,
    en: `View large QR code`
};
const $2868cc1235412e16$export$2beae1cfd23206a = {
    ar: `\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{643}\u{644} \u{645}\u{627} \u{64A}\u{646}\u{637}\u{628}\u{642}`,
    de: `Markieren Sie alles, was zutrifft`,
    es: `Marque todo lo que corresponda`,
    fa: `\u{647}\u{645}\u{647} \u{645}\u{648}\u{627}\u{631}\u{62F} \u{645}\u{631}\u{628}\u{648}\u{637} \u{628}\u{647} \u{622}\u{646} \u{631}\u{627} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Suriin ang lahat ng naaangkop`,
    fr: `Cochez toutes les r\xe9ponses qui s\u{2019}appliquent`,
    hi: `\u{932}\u{93E}\u{917}\u{942} \u{939}\u{94B}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{92D}\u{940} \u{915}\u{940} \u{91C}\u{93E}\u{901}\u{91A} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Tcheke tout sa ki aplike`,
    it: `Seleziona tutte le risposte pertinenti`,
    ja: `\u{8A72}\u{5F53}\u{3059}\u{308B}\u{3082}\u{306E}\u{3092}\u{3059}\u{3079}\u{3066}\u{30C1}\u{30A7}\u{30C3}\u{30AF}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{D574}\u{B2F9} \u{C0AC}\u{D56D} \u{BAA8}\u{B450} \u{C120}\u{D0DD}`,
    mww: `Kos kom tag nrho cov uas siv tau`,
    ps: `\u{67C}\u{648}\u{644} \u{647}\u{63A}\u{647} \u{648}\u{6AB}\u{648}\u{631}\u{626} \u{686}\u{6D0} \u{62A}\u{637}\u{628}\u{6CC}\u{642} \u{6A9}\u{6CC}\u{696}\u{6CC}`,
    pt: `Marque todas as op\xe7\xf5es aplic\xe1veis`,
    "pt-pt": `Marque todas as op\xe7\xf5es aplic\xe1veis`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{442}\u{44C}\u{442}\u{435} \u{432}\u{441}\u{435}, \u{447}\u{442}\u{43E} \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{438}\u{43C}\u{43E}`,
    sm: `Siaki mea uma e faatatau i ai`,
    so: `Hubi in dhan in codsan`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{644}\u{627}\u{6AF}\u{648} \u{6C1}\u{648}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{62A}\u{645}\u{627}\u{645} \u{686}\u{6CC}\u{632}\u{648}\u{6BA} \u{6A9}\u{648} \u{686}\u{6CC}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ki\u{1EC3}m tra t\u{1EA5}t c\u{1EA3} nh\u{1EEF}ng g\xec \xe1p d\u{1EE5}ng`,
    "zh-hans": `\u{52FE}\u{9009}\u{6240}\u{6709}\u{9002}\u{7528}\u{9879}`,
    "zh-hant": `\u{52FE}\u{9078}\u{6240}\u{6709}\u{9069}\u{7528}\u{9805}`,
    en: `Check all that apply`
};
const $2868cc1235412e16$export$24bd8284d2d99ce0 = {
    ar: `\u{62D}\u{62F}\u{62F} \u{648}\u{627}\u{62D}\u{62F}\u{627} \u{641}\u{642}\u{637}`,
    de: `W\xe4hlen Sie nur eine aus`,
    es: `Seleccione solo uno`,
    fa: `\u{641}\u{642}\u{637} \u{6CC}\u{6A9}\u{6CC} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili lamang ng isa`,
    fr: `N\u{2019}en s\xe9lectionner qu\u{2019}un seul`,
    hi: `\u{915}\u{947}\u{935}\u{932} \u{90F}\u{915} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi yon s\xe8l`,
    it: `Selezionane solo uno`,
    ja: `1\u{3064}\u{3060}\u{3051}\u{9078}\u{629E}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{D558}\u{B098}\u{B9CC} \u{C120}\u{D0DD}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    mww: `Xaiv ib qho xwb`,
    ps: `\u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{6CC}\u{648} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}`,
    pt: `Selecione apenas um`,
    "pt-pt": `Selecione apenas um`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{43E}\u{434}\u{438}\u{43D}`,
    sm: `Filifili na o le tasi`,
    so: `Dalbo mid kaliya`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E40}\u{E1E}\u{E35}\u{E22}\u{E07}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{635}\u{631}\u{641} \u{627}\u{6CC}\u{6A9} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9} ch\u{1ECD}n m\u{1ED9}t`,
    "zh-hans": `\u{4EC5}\u{9009}\u{4E00}\u{4E2A}`,
    "zh-hant": `\u{50C5}\u{9078}\u{4E00}\u{500B}`,
    en: `Select only one`
};
const $2868cc1235412e16$export$a290c6ac04e2eada = {
    ar: (eventDate, location)=>`${eventDate} \u{641}\u{64A} ${location}`,
    de: (eventDate, location)=>`${eventDate} in ${location}`,
    es: (eventDate, location)=>`${eventDate} en ${location}`,
    fa: (eventDate, location)=>`${eventDate} \u{62F}\u{631} ${location}`,
    fil: (eventDate, location)=>`${eventDate} sa ${location}`,
    fr: (eventDate, location)=>`${eventDate} au ${location}`,
    hi: (eventDate, location)=>`${eventDate} ${location} \u{92A}\u{930}`,
    ht: (eventDate, location)=>`${eventDate} nan ${location}`,
    it: (eventDate, location)=>`${eventDate} presso ${location}`,
    ja: (eventDate, location)=>`${eventDate} \u{65E5}\u{3001} ${location}`,
    ko: (eventDate, location)=>`${eventDate} \u{C77C} ${location}`,
    mww: (eventDate, location)=>`${eventDate} ntawm ${location}`,
    ps: (eventDate, location)=>`${eventDate} \u{67E}\u{647} ${location}`,
    pt: (eventDate, location)=>`${eventDate} em ${location}`,
    "pt-pt": (eventDate, location)=>`${eventDate} em ${location}`,
    ru: (eventDate, location)=>`${eventDate} \u{43F}\u{43E} \u{430}\u{434}\u{440}\u{435}\u{441}\u{443} ${location}`,
    sm: (eventDate, location)=>`${eventDate} i ${location}`,
    so: (eventDate, location)=>`${eventDate} at ${location}`,
    th: (eventDate, location)=>`${eventDate} \u{E17}\u{E35}\u{E48} ${location}`,
    ur: (eventDate, location)=>`${eventDate} ${location}`,
    vi: (eventDate, location)=>`${eventDate} t\u{1EA1}i ${location}`,
    "zh-hans": (eventDate, location)=>`${eventDate} \u{65E5}\u{FF0C}\u{5730}\u{5740}\u{FF1A} ${location}`,
    "zh-hant": (eventDate, location)=>`${eventDate} \u{65E5}\u{FF0C}\u{4F4D}\u{5740}\u{FF1A} ${location}`,
    en: (eventDate, location)=>`${eventDate} at ${location}`
};
const $2868cc1235412e16$export$dce4e5c439230d88 = {
    ar: `\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646} \u{639}\u{627}\u{645} (\u{642}\u{627}\u{628}\u{644} \u{644}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629})`,
    de: `\xd6ffentlicher Fragebogen (druckbar)`,
    es: `Cuestionario p\xfablico (imprimible)`,
    fa: `\u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647} \u{639}\u{645}\u{648}\u{645}\u{6CC} (\u{642}\u{627}\u{628}\u{644} \u{686}\u{627}\u{67E})`,
    fil: `Pampublikong palatanungan (mai-print)`,
    fr: `Questionnaire public (imprimable)`,
    hi: `\u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} (\u{92E}\u{941}\u{926}\u{94D}\u{930}\u{923} \u{92F}\u{94B}\u{917}\u{94D}\u{92F})`,
    ht: `Kesyon\xe8 piblik (printable)`,
    it: `Questionario pubblico (stampabile)`,
    ja: `\u{516C}\u{958B}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}(\u{5370}\u{5237}\u{53EF}\u{80FD})`,
    ko: `\u{ACF5}\u{AC1C} \u{C124}\u{BB38}\u{C9C0}(\u{C778}\u{C1C4} \u{AC00}\u{B2A5})`,
    mww: `Lus nug pej xeem (printable)`,
    ps: `\u{639}\u{645}\u{648}\u{645}\u{6CC} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9} (\u{62F} \u{686}\u{627}\u{67E} \u{648}\u{693} \u{62F}\u{6CC})`,
    pt: `Question\xe1rio p\xfablico (imprim\xedvel)`,
    "pt-pt": `Question\xe1rio p\xfablico (imprim\xedvel)`,
    ru: `\u{41E}\u{431}\u{449}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}\u{44F} \u{430}\u{43D}\u{43A}\u{435}\u{442}\u{430} (\u{434}\u{43B}\u{44F} \u{43F}\u{435}\u{447}\u{430}\u{442}\u{438})`,
    sm: `Fesili a le Malo (lolomiina)`,
    so: `Su'aalaha dadweynaha (printable)`,
    th: `\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30} (\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E44}\u{E14}\u{E49})`,
    ur: `\u{639}\u{648}\u{627}\u{645}\u{6CC} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6C1} (\u{642}\u{627}\u{628}\u{644} \u{627}\u{634}\u{627}\u{639}\u{62A})`,
    vi: `B\u{1EA3}ng c\xe2u h\u{1ECF}i c\xf4ng khai (c\xf3 th\u{1EC3} in)`,
    "zh-hans": `\u{516C}\u{5171}\u{95EE}\u{5377}\u{FF08}\u{53EF}\u{6253}\u{5370}\u{FF09}`,
    "zh-hant": `\u{516C}\u{5171}\u{554F}\u{5377}\u{FF08}\u{53EF}\u{5217}\u{5370}\u{FF09}`,
    en: `Public questionnaire (printable)`
};
const $2868cc1235412e16$export$8f9aad74ce8cb2cb = {
    ar: `\u{648}\u{635}\u{648}\u{644} \u{627}\u{644}\u{62C}\u{645}\u{647}\u{648}\u{631} \u{625}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{628}\u{64A}\u{627}\u{646}`,
    de: `\xd6ffentlicher Zugang zu diesem Fragebogen`,
    es: `Acceso p\xfablico a este cuestionario`,
    fa: `\u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{639}\u{645}\u{648}\u{645}\u{6CC} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{67E}\u{631}\u{633}\u{634}\u{646}\u{627}\u{645}\u{647}`,
    fil: `Pag-access ng publiko sa palatanungan na ito`,
    fr: `Acc\xe8s du public \xe0 ce questionnaire`,
    hi: `\u{907}\u{938} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928}\u{93E}\u{935}\u{932}\u{940} \u{924}\u{915} \u{938}\u{93E}\u{930}\u{94D}\u{935}\u{91C}\u{928}\u{93F}\u{915} \u{92A}\u{939}\u{941}\u{902}\u{91A}`,
    ht: `Aks\xe8 piblik nan kesyon\xe8 sa a`,
    it: `Accesso del pubblico a questo questionario`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{3078}\u{306E}\u{4E00}\u{822C}\u{516C}\u{958B}`,
    ko: `\u{C774} \u{C124}\u{BB38}\u{C9C0}\u{C5D0} \u{B300}\u{D55C} \u{ACF5}\u{AC1C} \u{C561}\u{C138}\u{C2A4}`,
    mww: `Pej xeem mus saib tau lo lus nug no`,
    ps: `\u{62F}\u{627} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{644}\u{6CC}\u{6A9} \u{62A}\u{647} \u{62F} \u{639}\u{627}\u{645}\u{648} \u{62E}\u{644}\u{6A9}\u{648} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC}`,
    pt: `Acesso do p\xfablico a este question\xe1rio`,
    "pt-pt": `Acesso do p\xfablico a este question\xe1rio`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{439} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{434}\u{430}\u{43D}\u{43D}\u{43E}\u{439} \u{430}\u{43D}\u{43A}\u{435}\u{442}\u{435}`,
    sm: `Avanoa lautele i lenei fesili`,
    so: `Galitaanka dadweynaha ee su'aalahan`,
    th: `\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E2D}\u{E1A}\u{E16}\u{E32}\u{E21}\u{E19}\u{E35}\u{E49}\u{E42}\u{E14}\u{E22}\u{E2A}\u{E32}\u{E18}\u{E32}\u{E23}\u{E13}\u{E30}`,
    ur: `\u{627}\u{633} \u{633}\u{648}\u{627}\u{644}\u{646}\u{627}\u{645}\u{6D2} \u{62A}\u{6A9} \u{639}\u{648}\u{627}\u{645} \u{6A9}\u{6CC} \u{631}\u{633}\u{627}\u{626}\u{6CC}`,
    vi: `Quy\u{1EC1}n truy c\u{1EAD}p c\xf4ng khai v\xe0o b\u{1EA3}ng c\xe2u h\u{1ECF}i n\xe0y`,
    "zh-hans": `\u{6B64}\u{8C03}\u{67E5}\u{95EE}\u{5377}\u{7684}\u{516C}\u{4F17}\u{8BBF}\u{95EE}\u{6743}\u{9650}`,
    "zh-hant": `\u{6B64}\u{8ABF}\u{67E5}\u{554F}\u{5377}\u{7684}\u{516C}\u{773E}\u{8A2A}\u{554F}\u{8A31}\u{53EF}\u{6B0A}`,
    en: `Public access to this questionnaire`
};
const $2868cc1235412e16$export$6afe45ba2034df4e = {
    ar: `\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{631}\u{62A}\u{628}\u{637}\u{629}`,
    de: `Zugeh\xf6rige Aktivit\xe4ten`,
    es: `Actividades asociadas`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{645}\u{631}\u{62A}\u{628}\u{637}`,
    fil: `Mga kaugnay na aktibidad`,
    fr: `Activit\xe9s associ\xe9es`,
    hi: `\u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}`,
    ht: `Aktivite ki asosye`,
    it: `Attivit\xe0 associate`,
    ja: `\u{95A2}\u{9023}\u{6D3B}\u{52D5}`,
    ko: `\u{AD00}\u{B828} \u{D65C}\u{B3D9}`,
    mww: `Kev ua ub no`,
    ps: `\u{62A}\u{693}\u{644}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Atividades associadas`,
    "pt-pt": `Atividades associadas`,
    ru: `\u{421}\u{43E}\u{43F}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{438}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F}`,
    sm: `Gaoioiga fesootai`,
    so: `Shaqooyinyada la xidhiidha`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean quan`,
    "zh-hans": `\u{5173}\u{8054}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{95DC}\u{806F}\u{6D3B}\u{52D5}`,
    en: `Associated activities`
};
const $2868cc1235412e16$export$597b5e961013f9bf = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{629}`,
    de: `Es gibt keine zugeh\xf6rigen Aktivit\xe4ten`,
    es: `No hay actividades asociadas`,
    fa: `\u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga kaugnay na aktibidad`,
    fr: `Il n\u{2019}y a pas d\u{2019}activit\xe9s associ\xe9es`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn aktivite ki asosye`,
    it: `Non ci sono attivit\xe0 associate`,
    ja: `\u{95A2}\u{9023}\u{3059}\u{308B}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{AD00}\u{B828} \u{D65C}\u{B3D9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ib yam kev ua ub no uas ua ub no`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{644}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{646}\u{647} \u{62F}\u{6CC} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{634}\u{648}\u{6CC}`,
    pt: `N\xe3o h\xe1 atividades associadas`,
    "pt-pt": `N\xe3o existem atividades associadas`,
    ru: `\u{41D}\u{438}\u{43A}\u{430}\u{43A}\u{438}\u{445} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439} \u{43D}\u{435}\u{442}`,
    sm: `E leai ni gaioiga e feso'ota'i`,
    so: `Mana jiro wax lala wadaajinayo.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean quan`,
    "zh-hans": `\u{6CA1}\u{6709}\u{5173}\u{8054}\u{7684}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{6C92}\u{6709}\u{95DC}\u{806F}\u{7684}\u{6D3B}\u{52D5}`,
    en: `There are no associated activities`
};
const $2868cc1235412e16$export$f036bc4eb2090575 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}`,
    de: `Es gibt keine zugeh\xf6rigen Aktivit\xe4ten auf dieser Seite`,
    es: `No hay actividades asociadas en esta p\xe1gina`,
    fa: `\u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637}\u{6CC} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga kaugnay na aktibidad sa pahinang ito`,
    fr: `Il n\u{2019}y a pas d\u{2019}activit\xe9s associ\xe9es sur cette page`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{92A}\u{930} \u{915}\u{94B}\u{908} \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn aktivite ki asosye nan paj sa a`,
    it: `Non ci sono attivit\xe0 associate in questa pagina`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{306F}\u{95A2}\u{9023}\u{3059}\u{308B}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0}\u{B294} \u{AD00}\u{B828} \u{D65C}\u{B3D9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ib yam kev ua ub no rau ntawm nplooj ntawv no`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{647} \u{6A9}\u{6D0} \u{647}\u{6CC}\u{685} \u{689}\u{648}\u{644} \u{62A}\u{693}\u{644}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{634}\u{62A}\u{648}\u{646} \u{646}\u{647} \u{644}\u{631}\u{6CC}`,
    pt: `N\xe3o existem atividades associadas nesta p\xe1gina`,
    "pt-pt": `N\xe3o h\xe1 atividades associadas nesta p\xe1gina`,
    ru: `\u{41D}\u{430} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435} \u{43D}\u{435}\u{442} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{445} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439}`,
    sm: `E leai ni gaioiga e feso'ota'i i luga o lenei itulau`,
    so: `Boggan kuma jiro wax hawlo ah oo lala xiriirinayo.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{67E}\u{631} \u{6A9}\u{648}\u{626}\u{6CC} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean quan n\xe0o tr\xean trang n\xe0y`,
    "zh-hans": `\u{6B64}\u{9875}\u{9762}\u{4E0A}\u{6CA1}\u{6709}\u{5173}\u{8054}\u{7684}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{6B64}\u{9801}\u{9762}\u{4E0A}\u{6C92}\u{6709}\u{95DC}\u{806F}\u{7684}\u{6D3B}\u{52D5}`,
    en: `There are no associated activities on this page`
};
const $2868cc1235412e16$export$7854ec72d946e9da = {
    ar: `\u{639}\u{636}\u{648} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Mitglied der Organisation`,
    es: `Miembro de la organizaci\xf3n`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Miyembro ng organisasyon`,
    fr: `Membre de l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}`,
    ht: `manm \xf2ganizasyon`,
    it: `Membro dell'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{30E1}\u{30F3}\u{30D0}\u{30FC}`,
    ko: `\u{C870}\u{C9C1} \u{AD6C}\u{C131}\u{C6D0}`,
    mww: `Koom haum`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC}`,
    pt: `Membro da organiza\xe7\xe3o`,
    "pt-pt": `Membro da organiza\xe7\xe3o`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Sui o le faalapotopotoga`,
    so: `xubin ka ah Ururka`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{631}\u{6A9}\u{646}`,
    vi: `Th\xe0nh vi\xean t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{7EC4}\u{7EC7}\u{6210}\u{5458}`,
    "zh-hant": `\u{7D44}\u{7E54}\u{6210}\u{54E1}`,
    en: `Organization member`
};
const $2868cc1235412e16$export$1c104532ca7e9cac = {
    ar: (login)=>`\u{62F}\u{639}\u{648}\u{629} \u{639}\u{636}\u{648} \u{641}\u{64A} ${login}`,
    de: (login)=>`Laden Sie ein Mitglied von ${login} ein`,
    es: (login)=>`Invitar a un miembro de ${login}`,
    fa: (login)=>`\u{62F}\u{639}\u{648}\u{62A} \u{627}\u{632} \u{639}\u{636}\u{648}\u{6CC} ${login}`,
    fil: (login)=>`Mag-imbita ng isang miyembro ng ${login}`,
    fr: (login)=>`Invitez un membre de ${login}`,
    hi: (login)=>`${login} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{915}\u{94B} \u{906}\u{92E}\u{902}\u{924}\u{94D}\u{930}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: (login)=>`Envite yon manm nan ${login}`,
    it: (login)=>`Invita un membro di ${login}`,
    ja: (login)=>`${login}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3092}\u{62DB}\u{5F85}\u{3059}\u{308B}`,
    ko: (login)=>`${login} \u{D68C}\u{C6D0} \u{CD08}\u{B300}`,
    mww: (login)=>`Caw ib tug nyob hauv ${login}`,
    ps: (login)=>`\u{62F} \u{627}\u{645}\u{631}\u{6CC}\u{6A9}\u{627} \u{62F} \u{645}\u{62A}\u{62D}\u{62F}\u{647} ${login} \u{6CC}\u{648} \u{63A}\u{693}\u{6CC} \u{62A}\u{647} \u{628}\u{644}\u{646}\u{647} \u{648}\u{631}\u{6A9}\u{693}\u{626}`,
    pt: (login)=>`Convide um membro da ${login}`,
    "pt-pt": (login)=>`Convide um membro da ${login}`,
    ru: (login)=>`\u{41F}\u{440}\u{438}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{442}\u{435} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430} ${login}`,
    sm: (login)=>`Valaaulia se tagata o le ${login}`,
    so: (login)=>`Ku martiqaad xubin ka mid ah ${login}`,
    th: (login)=>`\u{E40}\u{E0A}\u{E34}\u{E0D}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07} ${login}`,
    ur: (login)=>`${login} \u{6A9}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{631}\u{6A9}\u{646} \u{6A9}\u{648} \u{645}\u{62F}\u{639}\u{648} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: (login)=>`M\u{1EDD}i m\u{1ED9}t th\xe0nh vi\xean c\u{1EE7}a ${login}`,
    "zh-hans": (login)=>`\u{9080}\u{8BF7} ${login} \u{6210}\u{5458}`,
    "zh-hant": (login)=>`\u{9080}\u{8ACB}${login}\u{6210}\u{54E1}`,
    en: (login)=>`Invite a member of ${login}`
};
const $2868cc1235412e16$export$8c1159d8bda8df7d = {
    ar: (org, project)=>$2868cc1235412e16$var$html`<span>مقدمة من ${org} من خلال مشروع ${project} .</span>`,
    de: (org, project)=>$2868cc1235412e16$var$html`<span>Zur Verfügung gestellt von ${org} im Rahmen des ${project} .</span>`,
    es: (org, project)=>$2868cc1235412e16$var$html`<span>Proporcionado por ${org} a través del proyecto ${project} .</span>`,
    fa: (org, project)=>$2868cc1235412e16$var$html`<span>ارائه شده توسط ${org} از طریق پروژه ${project} .</span>`,
    fil: (org, project)=>$2868cc1235412e16$var$html`<span>Ibinigay ng ${org} sa pamamagitan ng proyekto ng ${project} .</span>`,
    fr: (org, project)=>$2868cc1235412e16$var$html`<span>Fourni par ${org} dans le cadre du ${project} .</span>`,
    hi: (project, org)=>$2868cc1235412e16$var$html`<span>${project} परियोजना के माध्यम से ${org} द्वारा प्रदान किया गया।</span>`,
    ht: (org, project)=>$2868cc1235412e16$var$html`<span>Bay pa ${org} atravè ${project} a.</span>`,
    it: (org, project)=>$2868cc1235412e16$var$html`<span>Fornito da ${org} attraverso il progetto ${project} .</span>`,
    ja: (org, project)=>$2868cc1235412e16$var$html`<span>${org}が${project}プロジェクトを通じて提供。</span>`,
    ko: (project, org)=>$2868cc1235412e16$var$html`<span>${project} 프로젝트를 통해 ${org}에서 제공합니다.</span>`,
    mww: (org, project)=>$2868cc1235412e16$var$html`<span>Muab los ntawm ${org} los ntawm lub ${project} project.</span>`,
    ps: (project, org)=>$2868cc1235412e16$var$html`<span>د ټولنې ${project} له لارې ${org} لخوا چمتو شوی.</span>`,
    pt: (org, project)=>$2868cc1235412e16$var$html`<span>Fornecido por ${org} através do projeto ${project} .</span>`,
    "pt-pt": (org, project)=>$2868cc1235412e16$var$html`<span>Fornecido pela ${org} através do projeto ${project} .</span>`,
    ru: (org, project)=>$2868cc1235412e16$var$html`<span>Предоставлено ${org} в рамках проекта ${project} .</span>`,
    sm: (org, project)=>$2868cc1235412e16$var$html`<span>Saunia e ${org} e ala i le poloketi o le ${project} .</span>`,
    so: (org, project)=>$2868cc1235412e16$var$html`<span>Waxaa bixiya ${org} iyada oo loo marayo ${project} .</span>`,
    th: (org, project)=>$2868cc1235412e16$var$html`<span>จัดทําโดย ${org} ผ่านโครงการ ${project} Project</span>`,
    ur: (project, org)=>$2868cc1235412e16$var$html`<span>${project} کے ذریعے ${org} کی طرف سے فراہم کی گئی۔</span>`,
    vi: (org, project)=>$2868cc1235412e16$var$html`<span>Được cung cấp bởi ${org} thông qua dự án ${project} .</span>`,
    "zh-hans": (org, project)=>$2868cc1235412e16$var$html`<span>由 ${org} 通过 ${project} 项目提供。</span>`,
    "zh-hant": (org, project)=>$2868cc1235412e16$var$html`<span>由 ${org} 透過 ${project} 專案提供。</span>`,
    en: (org, project)=>$2868cc1235412e16$var$html`<span>Provided by ${org} through the ${project} project.</span>`
};
const $2868cc1235412e16$export$6d3a7d28d4befbaa = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{646}\u{62A}\u{627}\u{626}\u{62C} \u{62A}\u{62A}\u{637}\u{627}\u{628}\u{642} \u{645}\u{639} \u{628}\u{62D}\u{62B}\u{643}.`,
    de: `Es gab keine Ergebnisse, die mit Ihrer Suche \xfcbereinstimmten.`,
    es: `No hay resultados que coincidan con su b\xfasqueda.`,
    fa: `\u{647}\u{6CC}\u{686} \u{646}\u{62A}\u{6CC}\u{62C}\u{647} \u{627}\u{6CC} \u{628}\u{627} \u{62C}\u{633}\u{62A}\u{62C}\u{648}\u{6CC} \u{634}\u{645}\u{627} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{646}\u{62F}\u{627}\u{634}\u{62A}.`,
    fil: `Walang mga resulta na tumutugma sa iyong paghahanap.`,
    fr: `Aucun r\xe9sultat ne correspondait \xe0 votre recherche.`,
    hi: `\u{906}\u{92A}\u{915}\u{940} \u{916}\u{94B}\u{91C} \u{938}\u{947} \u{915}\u{94B}\u{908} \u{92A}\u{930}\u{93F}\u{923}\u{93E}\u{92E} \u{92E}\u{947}\u{932} \u{928}\u{939}\u{940}\u{902} \u{916}\u{93E}\u{924}\u{93E}.`,
    ht: `Pa gen rezilta matche ak rech\xe8ch ou an.`,
    it: `Nessun risultato corrisponde alla tua ricerca.`,
    ja: `\u{691C}\u{7D22}\u{6761}\u{4EF6}\u{306B}\u{4E00}\u{81F4}\u{3059}\u{308B}\u{7D50}\u{679C}\u{304C}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{AC80}\u{C0C9}\u{C5B4}\u{C640} \u{C77C}\u{CE58}\u{D558}\u{B294} \u{ACB0}\u{ACFC}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis tau matched koj nrhiav.`,
    ps: `\u{647}\u{6CC}\u{685} \u{67E}\u{627}\u{6CC}\u{644}\u{6D0} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{644}\u{67C}\u{648}\u{646} \u{633}\u{631}\u{647} \u{633}\u{645}\u{648}\u{646} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Nenhum resultado correspondeu \xe0 sua pesquisa.`,
    "pt-pt": `Nenhum resultado correspondeu \xe0 sua pesquisa.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{438}\u{43D} \u{440}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442} \u{43D}\u{435} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442} \u{432}\u{430}\u{448}\u{435}\u{43C}\u{443} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{443}.`,
    sm: `E leai ni taunuuga e tutusa ma lau sailiga.`,
    so: `No natiijada waafqsanayd raadintaada.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1C}\u{E25}\u{E25}\u{E31}\u{E1E}\u{E18}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{646}\u{62A}\u{6CC}\u{62C}\u{6C1} \u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{644}\u{627}\u{634} \u{633}\u{6D2} \u{645}\u{6CC}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6BE}\u{627}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 k\u{1EBF}t qu\u{1EA3} n\xe0o kh\u{1EDB}p v\u{1EDB}i t\xecm ki\u{1EBF}m c\u{1EE7}a b\u{1EA1}n.`,
    "zh-hans": `\u{6CA1}\u{6709}\u{4E0E}\u{60A8}\u{7684}\u{641C}\u{7D22}\u{5339}\u{914D}\u{7684}\u{7ED3}\u{679C}\u{3002}`,
    "zh-hant": `\u{6C92}\u{6709}\u{8207}\u{60A8}\u{7684}\u{641C}\u{7D22}\u{5339}\u{914D}\u{7684}\u{7D50}\u{679C}\u{3002}`,
    en: `No results matched your search.`
};
const $2868cc1235412e16$export$2b75e18102dd39c2 = {
    ar: `\u{646}\u{634}\u{627}\u{637} \u{627}\u{644}\u{648}\u{627}\u{644}\u{62F}\u{64A}\u{646}`,
    de: `\xdcbergeordnete Aktivit\xe4t`,
    es: `Actividad de los padres`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{648}\u{627}\u{644}\u{62F}\u{6CC}\u{646}`,
    fil: `Aktibidad ng magulang`,
    fr: `Activit\xe9 des parents`,
    hi: `\u{905}\u{92D}\u{93F}\u{92D}\u{93E}\u{935}\u{915} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `Aktivite paran`,
    it: `Attivit\xe0 padre`,
    ja: `\u{89AA}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}`,
    ko: `\u{D559}\u{BD80}\u{BAA8} \u{D65C}\u{B3D9}`,
    mww: `Niam txiv kev ua niam txiv`,
    ps: `\u{62F} \u{645}\u{648}\u{631} \u{627}\u{648} \u{67E}\u{644}\u{627}\u{631} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Atividade dos pais`,
    "pt-pt": `Atividade dos pais`,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{440}\u{43E}\u{434}\u{438}\u{442}\u{435}\u{43B}\u{435}\u{439}`,
    sm: `Gaoioiga a matua`,
    so: `Howlaha waalidka`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E1C}\u{E39}\u{E49}\u{E1B}\u{E01}\u{E04}\u{E23}\u{E2D}\u{E07}`,
    ur: `\u{648}\u{627}\u{644}\u{62F}\u{6CC}\u{646} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng c\u{1EE7}a ph\u{1EE5} huynh`,
    "zh-hans": `\u{7236}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{7236}\u{6D3B}\u{52D5}`,
    en: `Parent activity`
};
const $2868cc1235412e16$export$a639cc9893796305 = {
    ar: `1 \u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `1 Organisation`,
    es: `1 organizaci\xf3n`,
    fa: `1 \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `1 organisasyon`,
    fr: `1 organisation`,
    hi: `1 \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `1 \xf2ganizasyon`,
    it: `1 organizzazione`,
    ja: `1\u{56E3}\u{4F53}`,
    ko: `1 \u{B2E8}\u{CCB4}`,
    mww: `1 lub koom haum`,
    ps: `1 \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    pt: `1 organiza\xe7\xe3o`,
    "pt-pt": `1 organiza\xe7\xe3o`,
    ru: `1 \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `1 faalapotopotoga`,
    so: `1 ururka`,
    th: `1 \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `1 \u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    vi: `1 t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `1 \u{4E2A}\u{7EC4}\u{7EC7}`,
    "zh-hant": `1 \u{500B}\u{7D44}\u{7E54}`,
    en: `1 organization`
};
const $2868cc1235412e16$export$39afa205509dcbe8 = {
    ar: (count)=>`${count} \u{645}\u{646}\u{638}\u{645}\u{627}\u{62A}`,
    de: (count)=>`${count} Organisationen`,
    es: (count)=>`${count} organizaciones`,
    fa: (count)=>`${count} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: (count)=>`${count} Mga Organisasyon`,
    fr: (count)=>`${count} organismes`,
    hi: (count)=>`${count} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: (count)=>`${count} \xf2ganizasyon`,
    it: (count)=>`${count} organizzazioni`,
    ja: (count)=>`${count} \u{56E3}\u{4F53}`,
    ko: (count)=>`${count} \u{AC1C} \u{B2E8}\u{CCB4}`,
    mww: (count)=>`${count} lub koom haum`,
    ps: (count)=>`${count} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} organiza\xe7\xf5es`,
    "pt-pt": (count)=>`${count} organiza\xe7\xf5es`,
    ru: (count)=>`${count} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{439}`,
    sm: (count)=>`${count} fa'alapotopotoga`,
    so: (count)=>`${count} ururo`,
    th: (count)=>`${count} \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: (count)=>`${count} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA}`,
    vi: (count)=>`${count} t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": (count)=>`${count} \u{4E2A}\u{7EC4}\u{7EC7}`,
    "zh-hant": (count)=>`${count} \u{500B}\u{7D44}\u{7E54}`,
    en: (count)=>`${count} organizations`
};
const $2868cc1235412e16$export$f2d46716c5f95f03 = {
    ar: `\u{645}\u{631}\u{641}\u{642}`,
    de: `Anhang`,
    es: `Archivo adjunto`,
    fa: `\u{67E}\u{6CC}\u{648}\u{633}\u{62A}`,
    fil: `Attachment`,
    fr: `Attachement`,
    hi: `\u{938}\u{902}\u{932}\u{917}\u{94D}\u{928}\u{915}`,
    ht: `Atachman`,
    it: `Allegato`,
    ja: `\u{611B}\u{7740}`,
    ko: `\u{CCA8}\u{BD80} \u{D30C}\u{C77C}`,
    mww: `rhais nrog daim`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Anexo`,
    "pt-pt": `Acess\xf3rio`,
    ru: `\u{41F}\u{440}\u{438}\u{43A}\u{440}\u{435}\u{43F}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Fa'apipi'i`,
    so: `Lifaaqa`,
    th: `\u{E01}\u{E32}\u{E23}\u{E1C}\u{E39}\u{E01}\u{E15}\u{E34}\u{E14}`,
    ur: `\u{645}\u{646}\u{633}\u{644}\u{6A9}\u{6C1}`,
    vi: `\u{110}\xednh k\xe8m`,
    "zh-hans": `\u{9644}\u{4EF6}`,
    "zh-hant": `\u{9644}\u{4EF6}`,
    en: `Attachment`
};
const $2868cc1235412e16$export$965c739f5b069c37 = {
    ar: `\u{627}\u{644}\u{645}\u{631}\u{641}\u{642}\u{627}\u{62A}`,
    de: `Anh\xe4ngsel`,
    es: `Accesorios`,
    fa: `\u{67E}\u{6CC}\u{648}\u{633}\u{62A}`,
    fil: `Mga Attachment`,
    fr: `Pi\xe8ces jointes`,
    hi: `\u{905}\u{928}\u{941}\u{932}\u{917}\u{94D}\u{928}\u{915}`,
    ht: `Atachman`,
    it: `Allegati`,
    ja: `\u{6DFB}\u{4ED8} \u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: `\u{CCA8}\u{BD80} \u{D30C}\u{C77C}`,
    mww: `Daim ntawv rhais nrog rau daim`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Anexos`,
    "pt-pt": `Anexos`,
    ru: `\u{412}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Fa'apipi'i`,
    so: `Lifaaqyada`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23} \u{E41}\u{E19}\u{E1A}`,
    ur: `\u{645}\u{646}\u{633}\u{644}\u{6A9}\u{627}\u{62A}`,
    vi: `\u{110}\xednh k\xe8m`,
    "zh-hans": `\u{9644}\u{4EF6}`,
    "zh-hant": `\u{9644}\u{4EF6}`,
    en: `Attachments`
};
const $2868cc1235412e16$export$234c584cd96079ce = {
    ar: `1 \u{645}\u{631}\u{641}\u{642}`,
    de: `1 Anhang`,
    es: `1 archivo adjunto`,
    fa: `1 \u{67E}\u{6CC}\u{648}\u{633}\u{62A}`,
    fil: `1 attachment`,
    fr: `1 pi\xe8ce jointe`,
    hi: `1 \u{938}\u{902}\u{932}\u{917}\u{94D}\u{928}\u{915}`,
    ht: `1 atachman`,
    it: `1 allegato`,
    ja: `1\u{3064}\u{306E}\u{6DFB}\u{4ED8}\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: `\u{CCA8}\u{BD80} \u{D30C}\u{C77C} 1\u{AC1C}`,
    mww: `1 attachment`,
    ps: `1 \u{636}\u{645}\u{6CC}\u{645}\u{647}`,
    pt: `1 acess\xf3rio`,
    "pt-pt": `1 anexo`,
    ru: `1 \u{432}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `1 fa'apipi'i`,
    so: `1 lifaaqa`,
    th: `1 \u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E19}\u{E1A}`,
    ur: `1 \u{627}\u{679}\u{6CC}\u{686}\u{645}\u{646}\u{679}`,
    vi: `1 t\u{1EC7}p \u{111}\xednh k\xe8m`,
    "zh-hans": `1 \u{4E2A}\u{9644}\u{4EF6}`,
    "zh-hant": `1 \u{500B}\u{9644}\u{4EF6}`,
    en: `1 attachment`
};
const $2868cc1235412e16$export$dd7aa9dbdc015ba1 = {
    ar: (count)=>`${count} \u{645}\u{644}\u{62D}\u{642}\u{627}\u{62A}`,
    de: (count)=>`${count} Anh\xe4nge`,
    es: (count)=>`${count} archivos adjuntos`,
    fa: (count)=>`${count} \u{67E}\u{6CC}\u{648}\u{633}\u{62A}`,
    fil: (count)=>`${count} Mga Attachment`,
    fr: (count)=>`${count} pi\xe8ces jointes`,
    hi: (count)=>`${count} \u{938}\u{902}\u{932}\u{917}\u{94D}\u{928}\u{915}`,
    ht: (count)=>`${count} atachman`,
    it: (count)=>`${count} allegati`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{6DFB}\u{4ED8}\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: (count)=>`\u{C5B4}\u{D0DC}\u{CE58}\u{BA3C}\u{D2B8} ${count}\u{AC1C}`,
    mww: (count)=>`${count} attachments`,
    ps: (count)=>`${count} \u{636}\u{645}\u{6CC}\u{645}\u{6D0}`,
    pt: (count)=>`${count} acess\xf3rios`,
    "pt-pt": (count)=>`${count} anexos`,
    ru: (count)=>`${count} \u{432}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{439}`,
    sm: (count)=>`${count} fa'apipi'i`,
    so: (count)=>`${count} lifaaqyada`,
    th: (count)=>`${count} \u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E19}\u{E1A}`,
    ur: (count)=>`${count} \u{645}\u{646}\u{633}\u{644}\u{6A9}\u{627}\u{62A}`,
    vi: (count)=>`${count} t\u{1EC7}p \u{111}\xednh k\xe8m`,
    "zh-hans": (count)=>`${count} \u{9644}\u{4EF6}`,
    "zh-hant": (count)=>`${count} \u{9644}\u{4EF6}`,
    en: (count)=>`${count} attachments`
};
const $2868cc1235412e16$export$4822b96394899afb = {
    ar: `1 \u{627}\u{644}\u{625}\u{635}\u{62F}\u{627}\u{631} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}`,
    de: `1 fr\xfchere Version`,
    es: `1 versi\xf3n anterior`,
    fa: `1 \u{646}\u{633}\u{62E}\u{647} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: `1 naunang bersyon`,
    fr: `1 version ant\xe9rieure`,
    hi: `1 \u{92A}\u{942}\u{930}\u{94D}\u{935} \u{938}\u{902}\u{938}\u{94D}\u{915}\u{930}\u{923}`,
    ht: `1 v\xe8syon pi bon\xe8`,
    it: `1 versione precedente`,
    ja: `1 \u{4EE5}\u{524D}\u{306E}\u{30D0}\u{30FC}\u{30B8}\u{30E7}\u{30F3}`,
    ko: `1 \u{C774}\u{C804} \u{BC84}\u{C804}`,
    mww: `1 ua ntej lawm version`,
    ps: `1 \u{646}\u{633}\u{62E}\u{647} \u{642}\u{628}\u{644}\u{6CC}`,
    pt: `1 vers\xe3o anterior`,
    "pt-pt": `1 vers\xe3o anterior`,
    ru: `1 \u{431}\u{43E}\u{43B}\u{435}\u{435} \u{440}\u{430}\u{43D}\u{43D}\u{44F}\u{44F} \u{432}\u{435}\u{440}\u{441}\u{438}\u{44F}`,
    sm: `1 lomiga muamua`,
    so: `1 version hore`,
    th: `1 \u{E40}\u{E27}\u{E2D}\u{E23}\u{E4C}\u{E0A}\u{E31}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `1 \u{633}\u{627}\u{628}\u{642}\u{6C1} \u{648}\u{631}\u{698}\u{646}`,
    vi: `1 Phi\xean b\u{1EA3}n tr\u{1B0}\u{1EDB}c \u{111}\xf3`,
    "zh-hans": `1 \u{4E2A}\u{65E9}\u{671F}\u{7248}\u{672C}`,
    "zh-hant": `1 \u{500B}\u{65E9}\u{671F}\u{7248}\u{672C}`,
    en: `1 earlier version`
};
const $2868cc1235412e16$export$a7ad54c5a26c2c49 = {
    ar: (count)=>`${count} \u{627}\u{644}\u{625}\u{635}\u{62F}\u{627}\u{631}\u{627}\u{62A} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}\u{629}`,
    de: (count)=>`${count} fr\xfchere Versionen`,
    es: (count)=>`${count} versiones anteriores`,
    fa: (count)=>`${count} \u{646}\u{633}\u{62E}\u{647} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: (count)=>`${count} naunang mga bersyon`,
    fr: (count)=>`${count} versions ant\xe9rieures`,
    hi: (count)=>`${count} \u{92A}\u{941}\u{930}\u{93E}\u{928}\u{947} \u{938}\u{902}\u{938}\u{94D}\u{915}\u{930}\u{923}`,
    ht: (count)=>`${count} v\xe8syon pi bon\xe8`,
    it: (count)=>`${count} versioni precedenti`,
    ja: (count)=>`${count} \u{4EE5}\u{524D}\u{306E}\u{30D0}\u{30FC}\u{30B8}\u{30E7}\u{30F3}`,
    ko: (count)=>`${count} \u{C774}\u{C804} \u{BC84}\u{C804}`,
    mww: (count)=>`${count} ua ntej lawm versions`,
    ps: (count)=>`${count} \u{646}\u{633}\u{62E}\u{647} \u{647}\u{627}\u{6CC} \u{642}\u{628}\u{644}\u{6CC}`,
    pt: (count)=>`${count} vers\xf5es anteriores`,
    "pt-pt": (count)=>`${count} vers\xf5es anteriores`,
    ru: (count)=>`${count} \u{411}\u{43E}\u{43B}\u{435}\u{435} \u{440}\u{430}\u{43D}\u{43D}\u{438}\u{435} \u{432}\u{435}\u{440}\u{441}\u{438}\u{438}`,
    sm: (count)=>`${count} lomiga muamua`,
    so: (count)=>`${count} noocyada hore`,
    th: (count)=>`${count} \u{E40}\u{E27}\u{E2D}\u{E23}\u{E4C}\u{E0A}\u{E31}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: (count)=>`${count} \u{67E}\u{631}\u{627}\u{646}\u{6D2} \u{648}\u{631}\u{698}\u{646}`,
    vi: (count)=>`${count} Phi\xean b\u{1EA3}n tr\u{1B0}\u{1EDB}c \u{111}\xf3`,
    "zh-hans": (count)=>`${count} \u{65E9}\u{671F}\u{7248}\u{672C}`,
    "zh-hant": (count)=>`${count} \u{65E9}\u{671F}\u{7248}\u{672C}`,
    en: (count)=>`${count} earlier versions`
};
const $2868cc1235412e16$export$ce92d729d899b6b1 = {
    ar: `\u{645}\u{633}\u{62A}\u{646}\u{62F}\u{627}\u{62A}`,
    de: `Doktoren`,
    es: `Docs`,
    fa: `\u{627}\u{633}\u{646}\u{627}\u{62F}`,
    fil: `Mga Dokumento`,
    fr: `Docs`,
    hi: `\u{921}\u{949}\u{915}\u{94D}\u{938}`,
    ht: `D\xf2k`,
    it: `Documenti`,
    ja: `\u{30C9}\u{30AD}\u{30E5}\u{30E1}\u{30F3}\u{30C8}`,
    ko: `\u{BB38}\u{C11C}`,
    mww: `Docs`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Docs`,
    "pt-pt": `Documentos`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Docs`,
    so: `Docs`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}`,
    ur: `Docs`,
    vi: `Documents`,
    "zh-hans": `\u{6587}\u{6863}`,
    "zh-hant": `\u{6587}\u{4EF6}`,
    en: `Docs`
};
const $2868cc1235412e16$export$ccbee3a13ebf2866 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Geschichte`,
    es: `Historia`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    fil: `Kasaysayan`,
    fr: `Histoire`,
    hi: `\u{907}\u{924}\u{93F}\u{939}\u{93E}\u{938}`,
    ht: `Istwa`,
    it: `Storia`,
    ja: `\u{6B74}\u{53F2}`,
    ko: `\u{C5ED}\u{C0AC}`,
    mww: `keeb kwm`,
    ps: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    pt: `Hist\xf3ria`,
    "pt-pt": `Hist\xf3ria`,
    ru: `\u{418}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{44F}`,
    sm: `Talafaasolopito`,
    so: `Taariikhda`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34}\u{E28}\u{E32}\u{E2A}\u{E15}\u{E23}\u{E4C}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `L\u{1ECB}ch s\u{1EED}`,
    "zh-hans": `\u{5386}\u{53F2}`,
    "zh-hant": `\u{6B77}\u{53F2}`,
    en: `History`
};
const $2868cc1235412e16$export$dae0630060ed6275 = {
    ar: `\u{623}\u{639}\u{644}\u{649}`,
    de: `Nach oben`,
    es: `Arriba`,
    fa: `\u{628}\u{627}\u{644}\u{627}`,
    fil: `Tuktok`,
    fr: `Retour au d\xe9but`,
    hi: `\u{932}\u{91F}\u{94D}\u{91F}\u{942}`,
    ht: `t\xe8t`,
    it: `In alto`,
    ja: `\u{30DA}\u{30FC}\u{30B8}\u{306E}\u{30C8}\u{30C3}\u{30D7}\u{3078}`,
    ko: `\u{B9E8} \u{C704}\u{B85C}`,
    mww: `saum toj kawg nkaus`,
    ps: `\u{633}\u{631}`,
    pt: `In\xedcio`,
    "pt-pt": `In\xedcio`,
    ru: `\u{412}\u{432}\u{435}\u{440}\u{445}`,
    sm: `Luga`,
    so: `Hore`,
    th: `\u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}`,
    ur: `\u{686}\u{648}\u{679}\u{6CC}`,
    vi: `\u{110}\u{1EC9}nh`,
    "zh-hans": `\u{8FD4}\u{56DE}\u{9875}\u{9996}`,
    "zh-hant": `\u{8FD4}\u{56DE}\u{9801}\u{9996}`,
    en: `Top`
};
const $2868cc1235412e16$export$2ac06249e0216e67 = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{627}\u{62A}`,
    de: `Antworten`,
    es: `Respuestas`,
    fa: `\u{67E}\u{627}\u{633}\u{62E}`,
    fil: `Mga tugon`,
    fr: `R\xe9ponses`,
    hi: `\u{91C}\u{935}\u{93E}\u{92C}`,
    ht: `Repons`,
    it: `Risposte`,
    ja: `\u{5FDC}\u{7B54}`,
    ko: `\u{C751}\u{B2F5}`,
    mww: `Responses`,
    ps: `\u{681}\u{648}\u{627}\u{628}\u{648}\u{646}\u{647}`,
    pt: `Respostas`,
    "pt-pt": `Respostas`,
    ru: `\u{41E}\u{442}\u{432}\u{435}\u{442}\u{44B}`,
    sm: `Tali`,
    so: `Jawaabaha`,
    th: `\u{E15}\u{E2D}\u{E1A} \u{E2A}\u{E19}\u{E2D}\u{E07}`,
    ur: `\u{62C}\u{648}\u{627}\u{628}\u{627}\u{62A}`,
    vi: `Ph\u{1EA3}n \u{1EE9}ng`,
    "zh-hans": `\u{53CD}\u{5E94}`,
    "zh-hant": `\u{53CD}\u{61C9}`,
    en: `Responses`
};
const $2868cc1235412e16$export$7ad47ed13860da91 = {
    ar: `\u{628}\u{644}\u{62D}`,
    de: `Datteln`,
    es: `Fechas`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    fil: `Mga Petsa`,
    fr: `Dattes`,
    hi: `\u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}\u{94B}\u{902}`,
    ht: `Dat`,
    it: `Datteri`,
    ja: `\u{65E5}\u{4ED8}`,
    ko: `\u{B0A0}\u{C9DC}`,
    mww: `Hnub Tim`,
    ps: `\u{646}\u{6D0}\u{67C}\u{6D0}`,
    pt: `Datas`,
    "pt-pt": `Datas`,
    ru: `\u{424}\u{438}\u{43D}\u{438}\u{43A}\u{438}`,
    sm: `Aso`,
    so: `Taariikhda`,
    th: `\u{E27}\u{E31}\u{E19}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA}`,
    vi: `Ng\xe0y`,
    "zh-hans": `\u{65E5}\u{671F}`,
    "zh-hant": `\u{65E5}\u{671F}`,
    en: `Dates`
};
const $2868cc1235412e16$export$d1f064ee71265e0c = {
    ar: `\u{623}\u{646}\u{634}\u{623}\u{62A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Sie haben diese Aktivit\xe4t erstellt.`,
    es: `Cre\xf3 esta actividad.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{631}\u{62F}.`,
    fil: `Nilikha ang aktibidad na ito.`,
    fr: `J\u{2019}ai cr\xe9\xe9 cette activit\xe9.`,
    hi: `\u{92F}\u{939} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92C}\u{928}\u{93E}\u{908} \u{917}\u{908}.`,
    ht: `Te kreye aktivite sa a.`,
    it: `Creata questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{4F5C}\u{6210}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{B9CC}\u{B4E4}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsim kom muaj txoj kev ua no.`,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6CC}\u{6D0} \u{62C}\u{648}\u{693} \u{6A9}\u{693}.`,
    pt: `Criou esta atividade.`,
    "pt-pt": `Criou esta atividade.`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{44D}\u{442}\u{43E} \u{443}\u{43F}\u{440}\u{430}\u{436}\u{43D}\u{435}\u{43D}\u{438}\u{435}.`,
    sm: `Fausiaina lenei gaoioiga.`,
    so: `Howshaan abuurisey.`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{6CC}\u{627}.`,
    vi: `T\u{1EA1}o ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{521B}\u{5EFA}\u{4E86}\u{6B64}\u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": `\u{5275}\u{5EFA}\u{4E86}\u{6B64}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Created this activity.`
};
const $2868cc1235412e16$export$7221236cb49b6ee2 = {
    ar: `\u{644}\u{62F}\u{64A}\u{647} \u{623}\u{639}\u{636}\u{627}\u{621} \u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647}\u{645} \u{644}\u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Verf\xfcgt \xfcber Mitglieder, die dieser Aktivit\xe4t zugewiesen wurden.`,
    es: `Tiene miembros que fueron asignados a esta actividad.`,
    fa: `\u{62F}\u{627}\u{631}\u{627}\u{6CC} \u{627}\u{639}\u{636}\u{627}\u{6CC}\u{6CC} \u{627}\u{633}\u{62A} \u{6A9}\u{647} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{646}\u{62F}.`,
    fil: `May mga miyembro na naatasan sa aktibidad na ito.`,
    fr: `A des membres qui ont \xe9t\xe9 affect\xe9s \xe0 cette activit\xe9.`,
    hi: `\u{910}\u{938}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{939}\u{948}\u{902} \u{91C}\u{93F}\u{928}\u{94D}\u{939}\u{947}\u{902} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}.`,
    ht: `Gen manm ki te asiyen nan aktivite sa a.`,
    it: `Contiene membri assegnati a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306B}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{305F}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{304C}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{D560}\u{B2F9}\u{B41C} \u{AD6C}\u{C131}\u{C6D0}\u{C774} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cov neeg uas raug txib mus ua qhov kev ua no.`,
    ps: `\u{63A}\u{693}\u{6CC} \u{644}\u{631}\u{6CC} \u{686}\u{6D0} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{647} \u{6AB}\u{648}\u{645}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `Tem membros que foram designados para esta atividade.`,
    "pt-pt": `Tem membros que foram designados para esta atividade.`,
    ru: `\u{418}\u{43C}\u{435}\u{435}\u{442} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}, \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44B}\u{445} \u{434}\u{43B}\u{44F} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{44D}\u{442}\u{43E}\u{433}\u{43E} \u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{44F}.`,
    sm: `O loo i ai tagata o e na tofia i lenei gaoioiga.`,
    so: `ayaa waxaa ka mid ah xubno loo magacaabay howshan.`,
    th: `\u{E21}\u{E35}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{633}\u{6D2} \u{627}\u{631}\u{6A9}\u{627}\u{646} \u{6C1}\u{6CC}\u{6BA} \u{62C}\u{648} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC}\u{6D2} \u{6AF}\u{626}\u{6D2} \u{62A}\u{6BE}\u{6D2}\u{6D4}`,
    vi: `C\xf3 c\xe1c th\xe0nh vi\xean \u{111}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh cho sinh ho\u{1EA1}t n\xe0y.`,
    "zh-hans": `\u{5177}\u{6709}\u{5206}\u{914D}\u{7ED9}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": `\u{5177}\u{6709}\u{5206}\u{914D}\u{7D66}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{6210}\u{54E1}\u{3002}`,
    en: `Has members who were assigned to this activity.`
};
const $2868cc1235412e16$export$33534dcbc6b4d188 = {
    ar: `\u{644}\u{62F}\u{64A}\u{647} \u{623}\u{639}\u{636}\u{627}\u{621} \u{62A}\u{645} \u{630}\u{643}\u{631}\u{647}\u{645} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Hat Mitglieder, die in dieser Aktivit\xe4t erw\xe4hnt wurden.`,
    es: `Tiene miembros que fueron mencionados en esta actividad.`,
    fa: `\u{62F}\u{627}\u{631}\u{627}\u{6CC} \u{627}\u{639}\u{636}\u{627}\u{6CC}\u{6CC} \u{627}\u{633}\u{62A} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{632} \u{622}\u{646}\u{647}\u{627} \u{646}\u{627}\u{645} \u{628}\u{631}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `May mga miyembro na binanggit sa aktibidad na ito.`,
    fr: `A des membres qui ont \xe9t\xe9 mentionn\xe9s dans cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{91C}\u{93F}\u{928} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{94B}\u{902} \u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Gen manm yo ki te mansyone nan aktivite sa a.`,
    it: `Ha membri che sono stati menzionati in questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3067}\u{30E1}\u{30F3}\u{30B7}\u{30E7}\u{30F3}\u{3055}\u{308C}\u{305F}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{304C}\u{3044}\u{308B}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0}\u{C11C} \u{C5B8}\u{AE09}\u{B41C} \u{D68C}\u{C6D0}\u{C774} \u{C788}\u{B2E4}.`,
    mww: `Muaj cov tswv cuab uas tau hais nyob rau hauv qhov kev ua no.`,
    ps: `\u{63A}\u{693}\u{6CC} \u{644}\u{631}\u{6CC} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{630}\u{6A9}\u{631} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `Tem membros que foram mencionados nesta atividade.`,
    "pt-pt": `Tem membros que foram mencionados nesta atividade.`,
    ru: `\u{418}\u{43C}\u{435}\u{435}\u{442} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{43E}\u{432}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{435} \u{431}\u{44B}\u{43B}\u{438} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442}\u{44B} \u{432} \u{44D}\u{442}\u{43E}\u{43C} \u{443}\u{43F}\u{440}\u{430}\u{436}\u{43D}\u{435}\u{43D}\u{438}\u{438}.`,
    sm: `E i ai tagata o le ekalesia o e na ta'ua i lenei gaoioiga.`,
    so: `ayaa waxaa ka mid ah xubno ku xusan howshaan.`,
    th: `\u{E21}\u{E35}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E17}\u{E35}\u{E48}\u{E16}\u{E39}\u{E01}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62C}\u{646} \u{645}\u{645}\u{628}\u{631}\u{648}\u{6BA} \u{6A9}\u{627} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `C\xf3 c\xe1c th\xe0nh vi\xean \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{62E5}\u{6709}\u{6B64}\u{6D3B}\u{52A8}\u{4E2D}\u{63D0}\u{53CA}\u{7684}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": `\u{64C1}\u{6709}\u{6B64}\u{6D3B}\u{52D5}\u{4E2D}\u{63D0}\u{53CA}\u{7684}\u{6210}\u{54E1}\u{3002}`,
    en: `Has members who were mentioned in this activity.`
};
const $2868cc1235412e16$export$7260ef100fa55b7c = {
    ar: (project)=>`\u{64A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{634}\u{631}\u{648}\u{639} ${project} .`,
    de: (project)=>`Betreut das Projekt ${project} .`,
    es: (project)=>`Supervisa el proyecto de ${project} .`,
    fa: (project)=>`\u{628}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} ${project} \u{646}\u{638}\u{627}\u{631}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: (project)=>`Pangangasiwa sa ${project} .`,
    fr: (project)=>`Supervise le projet de ${project} .`,
    hi: (project)=>`${project} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{915}\u{93E} \u{92A}\u{930}\u{94D}\u{92F}\u{935}\u{947}\u{915}\u{94D}\u{937}\u{923} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (project)=>`Sip\xe8vize pwoj\xe8 ${project} la.`,
    it: (project)=>`Supervisiona il progetto di ${project} .`,
    ja: (project)=>`${project}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3092}\u{76E3}\u{7763}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: (project)=>`${project} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{B97C} \u{AC10}\u{B3C5}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (project)=>`Saib xyuas qhov ${project} peb tes num.`,
    ps: (project)=>`\u{62F} ${project} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{685}\u{627}\u{631}\u{646}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: (project)=>`Supervisiona o projeto ${project} .`,
    "pt-pt": (project)=>`Supervisiona o projeto ${project} .`,
    ru: (project)=>`\u{41A}\u{443}\u{440}\u{438}\u{440}\u{443}\u{435}\u{442} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442} ${project} .`,
    sm: (project)=>`Va'ava'aia le poloketi ${project} .`,
    so: (project)=>`Wuxuu ilaaliyo mashruuca ${project} .`,
    th: (project)=>`\u{E14}\u{E39}\u{E41}\u{E25}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}${project}`,
    ur: (project)=>`${project} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (project)=>`Gi\xe1m s\xe1t d\u{1EF1} \xe1n ${project} .`,
    "zh-hans": (project)=>`\u{76D1}\u{7763} ${project} \u{9879}\u{76EE}\u{3002}`,
    "zh-hant": (project)=>`\u{76E3}\u{7763} ${project} \u{5C08}\u{6848}\u{3002}`,
    en: (project)=>`Supervises the ${project} project.`
};
const $2868cc1235412e16$export$b8784963d833b7d4 = {
    ar: `\u{64A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Beaufsichtigt eine Organisation, die an dieser Aktivit\xe4t teilnimmt.`,
    es: `Supervisa una organizaci\xf3n que participa en esta actividad.`,
    fa: `\u{628}\u{631} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{634}\u{631}\u{6A9}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F} \u{646}\u{638}\u{627}\u{631}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: `Pangasiwaan ang isang organisasyon na nakikilahok sa aktibidad na ito.`,
    fr: `Supervise une organisation participant \xe0 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{92A}\u{930}\u{94D}\u{92F}\u{935}\u{947}\u{915}\u{94D}\u{937}\u{923} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Sip\xe8vize yon \xf2ganizasyon ki patisipe nan aktivite sa a.`,
    it: `Supervisiona un'organizzazione che partecipa a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{53C2}\u{52A0}\u{3059}\u{308B}\u{7D44}\u{7E54}\u{3092}\u{76E3}\u{7763}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C744} \u{AC10}\u{B3C5}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Saib xyuas ib lub koom haum uas koom tes nrog txoj kev ua no.`,
    ps: `\u{62F} \u{647}\u{63A}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{685}\u{627}\u{631}\u{646}\u{647} \u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{627}\u{62E}\u{644}\u{6CC}.`,
    pt: `Supervisiona uma organiza\xe7\xe3o que participa desta atividade.`,
    "pt-pt": `Supervisiona uma organiza\xe7\xe3o participante nesta atividade.`,
    ru: `\u{41E}\u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{43B}\u{44F}\u{435}\u{442} \u{440}\u{443}\u{43A}\u{43E}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{435}\u{439} \u{432} \u{434}\u{430}\u{43D}\u{43D}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Vaavaaia se faalapotopotoga o loo auai i lenei gaoioiga.`,
    so: `Waxay kormeertaa hay'ad ka qaybqaadanaysa hawlahan.`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E1A}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Gi\xe1m s\xe1t m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c tham gia ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{76D1}\u{7763}\u{53C2}\u{4E0E}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{3002}`,
    "zh-hant": `\u{76E3}\u{7763}\u{53C3}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{3002}`,
    en: `Supervises an organization participating in this activity.`
};
const $2868cc1235412e16$export$e783655bdf5d6389 = {
    ar: `\u{62A}\u{639}\u{627}\u{642}\u{62F} \u{645}\u{639} \u{645}\u{646}\u{638}\u{645}\u{629} \u{645}\u{634}\u{627}\u{631}\u{643}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Eine Organisation, die an dieser Aktivit\xe4t teilnimmt, unter Vertrag genommen.`,
    es: `Contrat\xf3 a una organizaci\xf3n que participe en esta actividad.`,
    fa: `\u{628}\u{627} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{634}\u{631}\u{6A9}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{628}\u{633}\u{62A}.`,
    fil: `Nakipag-ugnayan sa isang organisasyon na nakikilahok sa aktibidad na ito.`,
    fr: `Contrat avec une organisation participant \xe0 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{94B} \u{905}\u{928}\u{941}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{915}\u{93F}\u{92F}\u{93E}\u{964}`,
    ht: `Kontra yon \xf2ganizasyon ki patisipe nan aktivite sa a.`,
    it: `Ha stipulato un contratto con un'organizzazione che partecipa a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{53C2}\u{52A0}\u{3057}\u{3066}\u{3044}\u{308B}\u{56E3}\u{4F53}\u{3068}\u{5951}\u{7D04}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{ACFC} \u{ACC4}\u{C57D}\u{C744} \u{B9FA}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Daim ntawv cog lus koom tes nrog txoj kev ua no.`,
    ps: `\u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{633}\u{631}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{627}\u{62E}\u{644}\u{6CC}.`,
    pt: `Contratou uma organiza\xe7\xe3o participante desta atividade.`,
    "pt-pt": `Contratou uma organiza\xe7\xe3o participante nesta atividade.`,
    ru: `\u{417}\u{430}\u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{43D} \u{434}\u{43E}\u{433}\u{43E}\u{432}\u{43E}\u{440} \u{441} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{435}\u{439} \u{432} \u{434}\u{430}\u{43D}\u{43D}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Fa'afeso'ota'i se fa'alapotopotoga o lo'o auai i lenei gaoioiga.`,
    so: `Waxaa qandaraas la siiyay hay\u{2BC}ad ka qayb qaadata howshan.`,
    th: `\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{633}\u{6D2} \u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6C1} \u{6A9}\u{6CC}\u{627}\u{6D4}`,
    vi: `\u{110}\xe3 k\xfd h\u{1EE3}p \u{111}\u{1ED3}ng v\u{1EDB}i m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c tham gia ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{4E0E}\u{53C2}\u{4E0E}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{7B7E}\u{8BA2}\u{5408}\u{540C}\u{3002}`,
    "zh-hant": `\u{8207}\u{53C3}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{7C3D}\u{8A02}\u{5408}\u{540C}\u{3002}`,
    en: `Contracted an organization participating in this activity.`
};
const $2868cc1235412e16$export$5eec64cb77d7c11a = {
    ar: `\u{645}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Abonniert`,
    es: `Subscrito`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6A9}`,
    fil: `Email Address *`,
    fr: `Souscrit`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E}`,
    ht: `Ab\xf2nman`,
    it: `Sottoscritto`,
    ja: `\u{8CFC}\u{8AAD}`,
    ko: `\u{AC00}\u{C785}`,
    mww: `Subscribed`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{634}\u{648}\u{6CC}`,
    pt: `Subscrito`,
    "pt-pt": `Subscrito`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{44B}`,
    sm: `Lesitala`,
    so: `Subscribed`,
    th: `\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    "zh-hans": `\u{8BA2}\u{9605}`,
    "zh-hant": `\u{8A02}\u{95B1}`,
    en: `Subscribed`
};
const $2868cc1235412e16$export$19c02d664a886ca5 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Nicht abonniert`,
    es: `No suscrito`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Hindi naka-subscribe`,
    fr: `Non abonn\xe9`,
    hi: `\u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{932}\u{940} \u{917}\u{908}`,
    ht: `Pa enskri`,
    it: `Non iscritto`,
    ja: `\u{8CFC}\u{8AAD}\u{3057}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{AD6C}\u{B3C5}\u{D558}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Tsis subscribed`,
    ps: `\u{6AB}\u{689}\u{648}\u{646} \u{646}\u{647} \u{6A9}\u{648}\u{6CC}`,
    pt: `N\xe3o inscrito`,
    "pt-pt": `N\xe3o subscrito`,
    ru: `\u{41D}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}`,
    sm: `E le'i lesitala`,
    so: `Lama subscribed`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `Ch\u{1B0}a \u{111}\u{103}ng k\xfd`,
    "zh-hans": `\u{672A}\u{8BA2}\u{9605}`,
    "zh-hant": `\u{672A}\u{8A02}\u{95B1}`,
    en: `Not subscribed`
};
const $2868cc1235412e16$export$bc45edeb9111b25a = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{623}\u{646}\u{634}\u{623}\u{62A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied der Organisation, die diese Aktivit\xe4t erstellt hat.`,
    es: `Miembro de la organizaci\xf3n creadora de esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Miyembro ng organisasyon na lumikha ng aktibidad na ito.`,
    fr: `Membre de l\u{2019}organisation qui a cr\xe9\xe9 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{92C}\u{928}\u{93E}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{926}\u{938}\u{94D}\u{92F}.`,
    ht: `Manm \xf2ganizasyon ki te kreye aktivite sa a.`,
    it: `Membro dell'organizzazione che ha creato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{4F5C}\u{6210}\u{3057}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{B9CC}\u{B4E0} \u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Cov koom haum uas tsim lub koom haum no.`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6CC}\u{6D0} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `Membro da organiza\xe7\xe3o que criou esta atividade.`,
    "pt-pt": `Membro da organiza\xe7\xe3o que criou esta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{441}\u{43E}\u{437}\u{434}\u{430}\u{432}\u{448}\u{435}\u{439} \u{44D}\u{442}\u{443} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Sui o le faalapotopotoga na faavaeina lenei gaoioiga.`,
    so: `Xubin ka mid ah ururkii abuuray howshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{633} \u{646}\u{6D2} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{6CC}\u{627}.`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c \u{111}\xe3 t\u{1EA1}o ra ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{521B}\u{5EFA}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": `\u{5275}\u{5EFA}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of organization who created this activity.`
};
const $2868cc1235412e16$export$4056dbe56ca22d08 = {
    ar: `\u{62A}\u{645} \u{62A}\u{643}\u{644}\u{64A}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Wurde diese Aktivit\xe4t zugewiesen.`,
    es: `Se le asign\xf3 esta actividad.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{647} \u{627}\u{648} \u{645}\u{62D}\u{648}\u{644} \u{634}\u{62F}.`,
    fil: `Inatasan siya sa aktibidad na ito.`,
    fr: `A \xe9t\xe9 charg\xe9 de cette activit\xe9.`,
    hi: `\u{92F}\u{939} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{940} \u{917}\u{908} \u{925}\u{940}.`,
    ht: `Te jwenn asiyasyon pou aktivite sa a.`,
    it: `\xc8 stata assegnata questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{304C}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774}(\u{AC00}) \u{C774} \u{D65C}\u{B3D9}\u{C744} \u{BC30}\u{C815}\u{BC1B}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Raug xa mus rau qhov chaw no.`,
    ps: `\u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{647} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC} \u{648}\u{648}.`,
    pt: `Foi atribu\xedda esta atividade.`,
    "pt-pt": `Foi atribu\xedda esta atividade.`,
    ru: `\u{411}\u{44B}\u{43B} \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D} \u{44D}\u{442}\u{43E}\u{442} \u{432}\u{438}\u{434} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Sa tofia i ai lenei gaoioiga.`,
    so: `Howshan loo xilsaaray.`,
    th: `\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62A}\u{6BE}\u{6CC}\u{6D4}`,
    vi: `\u{110}\xe3 \u{111}\u{1B0}\u{1EE3}c giao ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{5DF2}\u{5206}\u{914D}\u{6B64}\u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": `\u{5DF2}\u{5206}\u{914D}\u{6B64}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Was assigned this activity.`
};
const $2868cc1235412e16$export$73391a6b8d1cff8a = {
    ar: `\u{639}\u{636}\u{648} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{630}\u{64A} \u{62A}\u{645} \u{62A}\u{643}\u{644}\u{64A}\u{641}\u{647} \u{628}\u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied der Organisation, dem diese Aktivit\xe4t zugewiesen wurde.`,
    es: `Miembro de la organizaci\xf3n a la que se le asign\xf3 esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{647} \u{627}\u{648} \u{645}\u{62D}\u{648}\u{644} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Miyembro ng organisasyon na naatasan sa aktibidad na ito.`,
    fr: `Membre de l\u{2019}organisation \xe0 qui cette activit\xe9 a \xe9t\xe9 confi\xe9e.`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{93F}\u{938}\u{947} \u{92F}\u{939} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{938}\u{94C}\u{902}\u{92A}\u{940} \u{917}\u{908} \u{925}\u{940}\u{964}`,
    ht: `Manm \xf2ganizasyon ki te asiyen aktivite sa a.`,
    it: `Membro dell'organizzazione a cui \xe8 stata assegnata questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{304C}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C774} \u{BC30}\u{C815}\u{B41C} \u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Cov koom haum uas raug txib mus ua qhov no.`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{648}\u{631}\u{62A}\u{647} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC} \u{648}\u{648}.`,
    pt: `Membro da organiza\xe7\xe3o que recebeu esta atividade.`,
    "pt-pt": `Membro da organiza\xe7\xe3o a quem foi atribu\xedda esta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43D}\u{430} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{443}\u{44E} \u{431}\u{44B}\u{43B}\u{430} \u{432}\u{43E}\u{437}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{430} \u{44D}\u{442}\u{430} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Sui o le faalapotopotoga lea na tofia i lenei gaoioiga.`,
    so: `Xubin ka mid ah hay\u{2BC}adda loo magacaabay hawlahan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{633}\u{6D2} \u{6CC}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{62A}\u{6BE}\u{6CC}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c \u{111}\u{1B0}\u{1EE3}c giao ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{5206}\u{914D}\u{4E86}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": `\u{5206}\u{914D}\u{4E86}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of organization who was assigned this activity.`
};
const $2868cc1235412e16$export$5aac962701afc155 = {
    ar: `\u{62A}\u{645} \u{630}\u{643}\u{631}\u{647} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Wurde in dieser Aktivit\xe4t erw\xe4hnt.`,
    es: `Fue mencionado en esta actividad.`,
    fa: `\u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Binanggit ito sa aktibidad na ito.`,
    fr: `A \xe9t\xe9 mentionn\xe9 dans cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Yo te pale de li nan aktivite sa a.`,
    it: `\xc8 stato menzionato in questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{3067}\u{8A00}\u{53CA}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0}\u{C11C} \u{C5B8}\u{AE09}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Yog hais nyob rau hauv qhov kev ua no.`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{630}\u{6A9}\u{631} \u{634}\u{648}\u{6CC} \u{648}.`,
    pt: `Foi mencionado nesta atividade.`,
    "pt-pt": `Foi mencionado nesta atividade.`,
    ru: `\u{411}\u{44B}\u{43B} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442} \u{432} \u{44D}\u{442}\u{43E}\u{43C} \u{443}\u{43F}\u{440}\u{430}\u{436}\u{43D}\u{435}\u{43D}\u{438}\u{438}.`,
    sm: `Sa ta'ua i lenei gaoioiga.`,
    so: `Howshaan ayaa lagu xusay.`,
    th: `\u{E16}\u{E39}\u{E01}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}.`,
    vi: `\u{110}\xe3 \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{5728}\u{6B64}\u{6D3B}\u{52A8}\u{4E2D}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    "zh-hant": `\u{5728}\u{6B64}\u{6D3B}\u{52D5}\u{4E2D}\u{88AB}\u{63D0}\u{53CA}\u{3002}`,
    en: `Was mentioned in this activity.`
};
const $2868cc1235412e16$export$1963ca3fcfedab3 = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{627}\u{644}\u{630}\u{64A} \u{648}\u{631}\u{62F} \u{630}\u{643}\u{631}\u{647} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied der Organisation, das in dieser Aktivit\xe4t erw\xe4hnt wurde.`,
    es: `Miembro de la organizaci\xf3n que se mencion\xf3 en esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{632} \u{622}\u{646}\u{647}\u{627} \u{646}\u{627}\u{645} \u{628}\u{631}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Miyembro ng organisasyon na binanggit sa aktibidad na ito.`,
    fr: `Membre de l\u{2019}organisation qui a \xe9t\xe9 mentionn\xe9 dans cette activit\xe9.`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{93F}\u{938}\u{915}\u{93E} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Manm \xf2ganizasyon ki te mansyone nan aktivite sa a.`,
    it: `Membro dell'organizzazione che \xe8 stato menzionato in questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3067}\u{8A00}\u{53CA}\u{3055}\u{308C}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0}\u{C11C} \u{C5B8}\u{AE09}\u{B41C} \u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0}.`,
    mww: `Cov koom haum uas tau hais nyob rau hauv qhov kev ua no.`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6CC} \u{62A}\u{647} \u{62F} \u{6A9}\u{627}\u{628}\u{644} \u{67E}\u{647} \u{69A}\u{627}\u{631} \u{6A9}\u{6D0} \u{62F} \u{6A9}\u{627}\u{628}\u{644} \u{67E}\u{647} \u{69A}\u{627}\u{631} \u{6A9}\u{6D0} \u{62F} \u{627}\u{645}\u{646}\u{6CC}\u{62A} \u{62F} \u{67C}\u{6CC}\u{646}\u{6AB}\u{69A}\u{62A}`,
    pt: `Membro da organiza\xe7\xe3o que foi mencionado nesta atividade.`,
    "pt-pt": `Membro da organiza\xe7\xe3o que foi mencionado nesta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{430}\u{44F} \u{431}\u{44B}\u{43B}\u{430} \u{443}\u{43F}\u{43E}\u{43C}\u{44F}\u{43D}\u{443}\u{442}\u{430} \u{432} \u{434}\u{430}\u{43D}\u{43D}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Sui o le faalapotopotoga lea na ta'ua i lenei gaoioiga.`,
    so: `Xubin ka tirsan hay\u{2BC}adda oo lagu xusay howshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{633} \u{6A9}\u{627} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{630}\u{6A9}\u{631} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a t\u{1ED5} ch\u{1EE9}c \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p trong ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{6B64}\u{6D3B}\u{52A8}\u{4E2D}\u{63D0}\u{53CA}\u{7684}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": `\u{6B64}\u{6D3B}\u{52D5}\u{4E2D}\u{63D0}\u{53CA}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of organization who was mentioned in this activity.`
};
const $2868cc1235412e16$export$9502146eb1d5b0ff = {
    ar: `\u{627}\u{634}\u{62A}\u{631}\u{643}\u{62A} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{639}\u{628}\u{631} \u{627}\u{644}\u{623}\u{62A}\u{645}\u{62A}\u{629}.`,
    de: `Wurde f\xfcr diese Aktivit\xe4t \xfcber die Automatisierung abonniert.`,
    es: `Se suscribi\xf3 a esta actividad a trav\xe9s de la automatizaci\xf3n.`,
    fa: `\u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{634}\u{62F}.`,
    fil: `Nag-subscribe sa aktibidad na ito sa pamamagitan ng automation.`,
    fr: `A \xe9t\xe9 abonn\xe9 \xe0 cette activit\xe9 via l\u{2019}automatisation.`,
    hi: `\u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{928} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{940} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{940} \u{917}\u{908} \u{925}\u{940}\u{964}`,
    ht: `Te enskri nan aktivite sa a atrav\xe8 automatisation.`,
    it: `\xc8 stato iscritto a questa attivit\xe0 tramite automazione.`,
    ja: `\u{81EA}\u{52D5}\u{5316}\u{306B}\u{3088}\u{3063}\u{3066}\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306B}\u{767B}\u{9332}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C790}\u{B3D9}\u{D654}\u{B97C} \u{D1B5}\u{D574} \u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{AC00}\u{C785}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Yog subscribed rau qhov kev ua no ntawm automation.`,
    ps: `\u{62F} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{6AB}\u{689}\u{648}\u{646} \u{634}\u{648}\u{6CC} \u{648}.`,
    pt: `Foi inscrito nesta atividade via automa\xe7\xe3o.`,
    "pt-pt": `Foi inscrito nesta atividade via automa\xe7\xe3o.`,
    ru: `\u{411}\u{44B}\u{43B} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D} \u{43D}\u{430} \u{44D}\u{442}\u{443} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{447}\u{435}\u{440}\u{435}\u{437} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E}.`,
    sm: `Sa lesitala i lenei gaoioiga e ala i le otometi.`,
    so: `Waxaa loogu subscribed howshan via qalabaynta.`,
    th: `\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{622}\u{679}\u{648}\u{645}\u{6CC}\u{634}\u{646} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `\u{110}\xe3 \u{111}\u{103}ng k\xfd ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y th\xf4ng qua t\u{1EF1} \u{111}\u{1ED9}ng h\xf3a.`,
    "zh-hans": `\u{901A}\u{8FC7}\u{81EA}\u{52A8}\u{5316}\u{8BA2}\u{9605}\u{4E86}\u{6B64}\u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": `\u{901A}\u{904E}\u{81EA}\u{52D5}\u{5316}\u{8A02}\u{95B1}\u{4E86}\u{6B64}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Was subscribed to this activity via automation.`
};
const $2868cc1235412e16$export$3143c2b51f566b5 = {
    ar: `\u{627}\u{631}\u{62A}\u{628}\u{637} \u{628}\u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{623}\u{62A}\u{645}\u{62A}\u{629}.`,
    de: `Wurde \xfcber die Automatisierung mit dieser Aktivit\xe4t in Verbindung gebracht.`,
    es: `Se asoci\xf3 a esta actividad a trav\xe9s de la automatizaci\xf3n.`,
    fa: `\u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{628}\u{627} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{645}\u{631}\u{627}\u{647} \u{628}\u{648}\u{62F}.`,
    fil: `Ito ay nauugnay sa aktibidad na ito sa pamamagitan ng automation.`,
    fr: `A \xe9t\xe9 associ\xe9 \xe0 cette activit\xe9 via l\u{2019}automatisation.`,
    hi: `\u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{928} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{938}\u{947} \u{91C}\u{941}\u{921}\u{93C}\u{93E} \u{925}\u{93E}\u{964}`,
    ht: `Te asosye ak aktivite sa a atrav\xe8 automatisation.`,
    it: `\xc8 stato associato a questa attivit\xe0 tramite l'automazione.`,
    ja: `\u{81EA}\u{52D5}\u{5316}\u{306B}\u{3088}\u{3063}\u{3066}\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306B}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C790}\u{B3D9}\u{D654}\u{B97C} \u{D1B5}\u{D574} \u{C774} \u{D65C}\u{B3D9}\u{ACFC} \u{C5F0}\u{ACB0}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Yog mob nrog qhov kev ua no ntawm automation.`,
    ps: `\u{62F} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{633}\u{631}\u{647} \u{62A}\u{693}\u{627}\u{648} \u{644}\u{631}\u{6CC}.`,
    pt: `Foi associado a esta atividade via automa\xe7\xe3o.`,
    "pt-pt": `Associou-se a esta atividade via automa\xe7\xe3o.`,
    ru: `\u{411}\u{44B}\u{43B} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D} \u{441} \u{44D}\u{442}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{44E} \u{447}\u{435}\u{440}\u{435}\u{437} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44E}.`,
    sm: `Na feso'ota'i ma lenei gaioiga e ala i le otometi.`,
    so: `Waxaa lagu xiriirinayay howshaan iyadoo loo marayo qalabaynta.`,
    th: `\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{622}\u{679}\u{648}\u{645}\u{6CC}\u{634}\u{646} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{633}\u{6D2} \u{648}\u{627}\u{628}\u{633}\u{62A}\u{6C1} \u{62A}\u{6BE}\u{627}\u{6D4}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t v\u{1EDB}i ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y th\xf4ng qua t\u{1EF1} \u{111}\u{1ED9}ng h\xf3a.`,
    "zh-hans": `\u{901A}\u{8FC7}\u{81EA}\u{52A8}\u{5316}\u{4E0E}\u{6B64}\u{6D3B}\u{52A8}\u{76F8}\u{5173}\u{8054}\u{3002}`,
    "zh-hant": `\u{901A}\u{904E}\u{81EA}\u{52D5}\u{5316}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{76F8}\u{95DC}\u{806F}\u{3002}`,
    en: `Was associated with this activity via automation.`
};
const $2868cc1235412e16$export$60bccc00e91b24bf = {
    ar: `\u{62A}\u{645} \u{62A}\u{644}\u{642}\u{64A} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{645}\u{646} \u{62E}\u{644}\u{627}\u{644} \u{646}\u{634}\u{627}\u{637} \u{645}\u{631}\u{62A}\u{628}\u{637}.`,
    de: `Zugriff \xfcber eine zugeordnete Aktivit\xe4t erhalten.`,
    es: `Acceso recibido a trav\xe9s de una actividad asociada.`,
    fa: `\u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{631}\u{627} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{6CC}\u{6A9} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{631}\u{62A}\u{628}\u{637} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{62F}.`,
    fil: `Nakatanggap ng access sa pamamagitan ng isang kaugnay na aktibidad.`,
    fr: `Acc\xe8s re\xe7u par le biais d\u{2019}une activit\xe9 associ\xe9e.`,
    hi: `\u{90F}\u{915} \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{940}\u{964}`,
    ht: `Te resevwa aks\xe8 nan yon aktivite ki asosye.`,
    it: `Accesso ricevuto tramite un'attivit\xe0 associata.`,
    ja: `\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{305F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{901A}\u{3058}\u{3066}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{305F}\u{3002}`,
    ko: `\u{C5F0}\u{AD00}\u{B41C} \u{D65C}\u{B3D9}\u{C744} \u{D1B5}\u{D574} \u{C561}\u{C138}\u{C2A4} \u{AD8C}\u{D55C}\u{C744} \u{BC1B}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau txais kev pab los ntawm ib qho kev ua ub no.`,
    ps: `\u{62F} \u{62A}\u{693}\u{644}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Acesso recebido por meio de uma atividade associada.`,
    "pt-pt": `Acesso recebido atrav\xe9s de uma atividade associada.`,
    ru: `\u{41F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{447}\u{435}\u{440}\u{435}\u{437} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{443}\u{44E} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Mauaina le avanoa e ala i se gaoioiga e fesootai i ai.`,
    so: `Waxay ku heshay fursado la xiriira waxqabadyada la xiriira.`,
    th: `\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC}.`,
    vi: `\u{110}\xe3 nh\u{1EAD}n quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua m\u{1ED9}t ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t.`,
    "zh-hans": `\u{901A}\u{8FC7}\u{5173}\u{8054}\u{7684}\u{6D3B}\u{52A8}\u{63A5}\u{6536}\u{8BBF}\u{95EE}\u{6743}\u{9650}\u{3002}`,
    "zh-hant": `\u{901A}\u{904E}\u{95DC}\u{806F}\u{7684}\u{6D3B}\u{52D5}\u{63A5}\u{6536}\u{8A2A}\u{554F}\u{8A31}\u{53EF}\u{6B0A}\u{3002}`,
    en: `Received access through an associated activity.`
};
const $2868cc1235412e16$export$30763d83faa276a = {
    ar: `\u{62A}\u{645} \u{62A}\u{644}\u{642}\u{64A} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{645}\u{646} \u{62E}\u{644}\u{627}\u{644} \u{646}\u{634}\u{627}\u{637} \u{64A}\u{634}\u{64A}\u{631} \u{625}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Zugriff \xfcber eine Aktivit\xe4t erhalten, die auf diese Aktivit\xe4t verweist.`,
    es: `Acceso recibido a trav\xe9s de una actividad que hace referencia a esta actividad.`,
    fa: `\u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{6CC} \u{6A9}\u{647} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{631}\u{62C}\u{627}\u{639} \u{645}\u{6CC} \u{62F}\u{647}\u{62F}\u{60C} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Nakatanggap ng access sa pamamagitan ng isang aktibidad na tumutukoy sa aktibidad na ito.`,
    fr: `Acc\xe8s re\xe7u par le biais d\u{2019}une activit\xe9 qui fait r\xe9f\xe9rence \xe0 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{93E} \u{938}\u{902}\u{926}\u{930}\u{94D}\u{92D} \u{926}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{940}.`,
    ht: `Resevwa aks\xe8 nan yon aktivite ki refere aktivite sa a.`,
    it: `Accesso ricevuto tramite un'attivit\xe0 che fa riferimento a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{53C2}\u{7167}\u{3059}\u{308B}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{901A}\u{3058}\u{3066}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{CC38}\u{C870}\u{D558}\u{B294} \u{D65C}\u{B3D9}\u{C744} \u{D1B5}\u{D574} \u{C561}\u{C138}\u{C2A4} \u{AD8C}\u{D55C}\u{C744} \u{BC1B}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tau txais kev mus saib tau los ntawm ib qho kev ua uas siv cov kev ua no.`,
    ps: `\u{62F} \u{647}\u{63A}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62D}\u{648}\u{627}\u{644}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{6CC}.`,
    pt: `Acesso recebido por meio de uma atividade que faz refer\xeancia a essa atividade.`,
    "pt-pt": `Acesso recebido atrav\xe9s de uma atividade que faz refer\xeancia a essa atividade.`,
    ru: `\u{41F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{447}\u{435}\u{440}\u{435}\u{437} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{435} \u{441}\u{441}\u{44B}\u{43B}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{43D}\u{430} \u{44D}\u{442}\u{43E} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435}.`,
    sm: `Na maua le avanoa e ala i se gaoioiga e faasino i lenei gaoioiga.`,
    so: `Waxaa lagu helay helitaanka shaqooyin tixraacaya waxqabadkaan.`,
    th: `\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{6CC} \u{62C}\u{648} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{627} \u{62D}\u{648}\u{627}\u{644}\u{6C1} \u{62F}\u{6CC}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `\u{110}\xe3 nh\u{1EAD}n quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua m\u{1ED9}t ho\u{1EA1}t \u{111}\u{1ED9}ng tham chi\u{1EBF}u \u{111}\u{1EBF}n ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{901A}\u{8FC7}\u{5F15}\u{7528}\u{6B64}\u{6D3B}\u{52A8}\u{7684} Activity \u{63A5}\u{6536}\u{8BBF}\u{95EE}\u{6743}\u{9650}\u{3002}`,
    "zh-hant": `\u{901A}\u{904E}\u{5F15}\u{7528}\u{6B64}\u{6D3B}\u{52D5}\u{7684} Activity \u{63A5}\u{6536}\u{8A2A}\u{554F}\u{8A31}\u{53EF}\u{6B0A}\u{3002}`,
    en: `Received access through an activity that references this activity.`
};
const $2868cc1235412e16$export$611b0f37f4164ee6 = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{639}\u{627}\u{642}\u{62F}\u{62A} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied einer Organisation, die diese Aktivit\xe4t in Auftrag gegeben hat.`,
    es: `Miembro de una organizaci\xf3n que contrat\xf3 esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{628}\u{627} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{628}\u{633}\u{62A}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Miyembro ng isang organisasyon na nakipagkumpitensya sa aktibidad na ito.`,
    fr: `Membre d\u{2019}une organisation qui a contract\xe9 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{905}\u{928}\u{941}\u{92C}\u{902}\u{927}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{964}`,
    ht: `Manm yon \xf2ganizasyon ki te trape aktivite sa a.`,
    it: `Membro di un'organizzazione che ha appaltato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{5951}\u{7D04}\u{3057}\u{305F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{ACC4}\u{C57D}\u{D55C} \u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib lub koom haum uas cog lus no.`,
    ps: `\u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{633}\u{631}\u{647} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{644}\u{631}\u{6CC}.`,
    pt: `Membro de uma organiza\xe7\xe3o que contratou esta atividade.`,
    "pt-pt": `Membro de uma organiza\xe7\xe3o que contratou esta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{430}\u{44F} \u{437}\u{430}\u{43A}\u{43B}\u{44E}\u{447}\u{438}\u{43B}\u{430} \u{434}\u{43E}\u{433}\u{43E}\u{432}\u{43E}\u{440} \u{43D}\u{430} \u{44D}\u{442}\u{443} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Sui o se fa'alapotopotoga na fa'atautaia lenei fa'alapotopotoga.`,
    so: `xubin ka ah hay\u{2BC}ad qandaraas la yeeshay howshan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{633} \u{646}\u{6D2} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{627} \u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6C1} \u{6A9}\u{6CC}\u{627}.`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c \u{111}\xe3 k\xfd h\u{1EE3}p \u{111}\u{1ED3}ng v\u{1EDB}i ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{627F}\u{5305}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{7EC4}\u{7EC7}\u{7684}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": `\u{627F}\u{5305}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{7D44}\u{7E54}\u{7684}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of an organization that contracted this activity.`
};
const $2868cc1235412e16$export$9dfa01f928fcc96e = {
    ar: (project)=>`\u{639}\u{636}\u{648} \u{641}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{634}\u{631}\u{648}\u{639} ${project} \u{627}\u{644}\u{62A}\u{643}\u{644}\u{641}\u{629}.`,
    de: (project)=>`Mitglied einer Organisation, die das Projekt ${project} betreut.`,
    es: (project)=>`Miembro de una organizaci\xf3n que supervisa el proyecto de ${project} .`,
    fa: (project)=>`\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{628}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} ${project} \u{646}\u{638}\u{627}\u{631}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: (project)=>`Miyembro ng isang organisasyon na nangangasiwa sa ${project} .`,
    fr: (project)=>`Membre d\u{2019}un organisme qui supervise le projet de ${project} .`,
    hi: (project)=>`\u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{94B} ${project} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{915}\u{940} \u{926}\u{947}\u{916}\u{930}\u{947}\u{916} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: (project)=>`Manm yon \xf2ganizasyon ki sip\xe8vize pwoj\xe8 ${project} la.`,
    it: (project)=>`Membro di un'organizzazione che supervisiona il progetto di ${project} .`,
    ja: (project)=>`${project}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3092}\u{76E3}\u{7763}\u{3059}\u{308B}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: (project)=>`${project} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{B97C} \u{AC10}\u{B3C5}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0}.`,
    mww: (project)=>`Ib lub koom haum uas saib xyuas qhov ${project} .`,
    ps: (project)=>`\u{62F} \u{6CC}\u{648}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{62F} ${project} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{685}\u{627}\u{631}\u{646}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: (project)=>`Membro de uma organiza\xe7\xe3o que supervisiona o projeto de ${project} .`,
    "pt-pt": (project)=>`Membro de uma organiza\xe7\xe3o que supervisiona o projeto de ${project} .`,
    ru: (project)=>`\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{430}\u{44F} \u{43E}\u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{43B}\u{44F}\u{435}\u{442} \u{43D}\u{430}\u{434}\u{437}\u{43E}\u{440} \u{437}\u{430} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{43E}\u{43C} ${project} .`,
    sm: (project)=>`Sui o se fa'alapotopotoga o lo'o va'ava'aia le poloketi o ${project} .`,
    so: (project)=>`Xubin ka mida hay'adda ilaaliya mashruuca ${project} .`,
    th: (project)=>`\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E14}\u{E39}\u{E41}\u{E25}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}${project}`,
    ur: (project)=>`\u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{631}\u{6A9}\u{646} \u{62C}\u{648} ${project} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}.`,
    vi: (project)=>`Th\xe0nh vi\xean c\u{1EE7}a m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c gi\xe1m s\xe1t d\u{1EF1} \xe1n ${project} .`,
    "zh-hans": (project)=>`\u{76D1}\u{7763} ${project} \u{9879}\u{76EE}\u{7684}\u{7EC4}\u{7EC7}\u{7684}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": (project)=>`\u{76E3}\u{7763} ${project} \u{9805}\u{76EE}\u{7684}\u{7D44}\u{7E54}\u{7684}\u{6210}\u{54E1}\u{3002}`,
    en: (project)=>`Member of an organization that supervises the ${project} project.`
};
const $2868cc1235412e16$export$c21fad0a67d5499c = {
    ar: `\u{639}\u{636}\u{648} \u{641}\u{64A} \u{645}\u{646}\u{638}\u{645}\u{629} \u{62A}\u{634}\u{631}\u{641} \u{639}\u{644}\u{649} \u{645}\u{646}\u{638}\u{645}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Mitglied einer Organisation, die eine andere Organisation beaufsichtigt, die an dieser Aktivit\xe4t teilnimmt.`,
    es: `Miembro de una organizaci\xf3n que supervisa a otra organizaci\xf3n que participa en esta actividad.`,
    fa: `\u{639}\u{636}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{628}\u{631} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{634}\u{631}\u{6A9}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F} \u{646}\u{638}\u{627}\u{631}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}.`,
    fil: `Miyembro ng isang organisasyon na nangangasiwa sa ibang organisasyon na nakikilahok sa aktibidad na ito.`,
    fr: `Membre d\u{2019}une organisation qui supervise une autre organisation participant \xe0 cette activit\xe9.`,
    hi: `\u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{91C}\u{94B} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{915}\u{93F}\u{938}\u{940} \u{905}\u{928}\u{94D}\u{92F} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{92A}\u{930}\u{94D}\u{92F}\u{935}\u{947}\u{915}\u{94D}\u{937}\u{923} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Manm yon \xf2ganizasyon ki sip\xe8vize yon l\xf2t \xf2ganizasyon ki patisipe nan aktivite sa a.`,
    it: `Membro di un'organizzazione che supervisiona un'altra organizzazione che partecipa a questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{53C2}\u{52A0}\u{3057}\u{3066}\u{3044}\u{308B}\u{4ED6}\u{306E}\u{7D44}\u{7E54}\u{3092}\u{76E3}\u{7763}\u{3059}\u{308B}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{B2E4}\u{B978} \u{C870}\u{C9C1}\u{C744} \u{AC10}\u{B3C5}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib lub koom haum uas saib xyuas lwm lub koom haum uas saib xyuas lwm lub koom haum uas koom tes nrog txoj kev ua no.`,
    ps: `\u{62F} \u{6CC}\u{648}\u{6D0} \u{62F}\u{627}\u{633}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{63A}\u{693}\u{6CC} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{62F} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{628}\u{644} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{685}\u{627}\u{631}\u{646}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Membro de uma organiza\xe7\xe3o que supervisiona outra organiza\xe7\xe3o que participa desta atividade.`,
    "pt-pt": `Membro de uma organiza\xe7\xe3o que supervisiona outra organiza\xe7\xe3o participante nesta atividade.`,
    ru: `\u{427}\u{43B}\u{435}\u{43D} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{430}\u{44F} \u{43E}\u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{43B}\u{44F}\u{435}\u{442} \u{43D}\u{430}\u{434}\u{437}\u{43E}\u{440} \u{437}\u{430} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{435}\u{439} \u{432} \u{434}\u{430}\u{43D}\u{43D}\u{43E}\u{439} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `Sui o se faalapotopotoga o loo vaavaaia se isi faalapotopotoga o loo auai i lenei gaoioiga.`,
    so: `Xubin ka mid ah hay'ad kormeerta hay\u{2BC}ad kale oo howshan ka qayb qaadanaysa.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E01}\u{E31}\u{E1A}\u{E14}\u{E39}\u{E41}\u{E25}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{631}\u{6A9}\u{646} \u{62C}\u{648} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} \u{6A9}\u{633}\u{6CC} \u{62F}\u{648}\u{633}\u{631}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{646}\u{6AF}\u{631}\u{627}\u{646}\u{6CC} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Th\xe0nh vi\xean c\u{1EE7}a m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c gi\xe1m s\xe1t m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c kh\xe1c tham gia v\xe0o ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{76D1}\u{7763}\u{53C2}\u{4E0E}\u{6B64}\u{6D3B}\u{52A8}\u{7684}\u{5176}\u{4ED6}\u{7EC4}\u{7EC7}\u{7684}\u{7EC4}\u{7EC7}\u{7684}\u{6210}\u{5458}\u{3002}`,
    "zh-hant": `\u{76E3}\u{7763}\u{53C3}\u{8207}\u{6B64}\u{6D3B}\u{52D5}\u{7684}\u{5176}\u{4ED6}\u{7D44}\u{7E54}\u{7684}\u{7D44}\u{7E54}\u{7684}\u{6210}\u{54E1}\u{3002}`,
    en: `Member of an organization that supervises another organization participating in this activity.`
};
const $2868cc1235412e16$export$6572ae3c15566261 = {
    ar: `\u{639}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Kommentierte diese Aktivit\xe4t.`,
    es: `Comentado sobre esta actividad.`,
    fa: `\u{62F}\u{631} \u{645}\u{648}\u{631}\u{62F} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{638}\u{647}\u{627}\u{631} \u{646}\u{638}\u{631} \u{6A9}\u{631}\u{62F}\u{645}.`,
    fil: `Nagkomento tungkol sa aktibidad na ito.`,
    fr: `Comment\xe9 cette activit\xe9.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930} \u{91F}\u{93F}\u{92A}\u{94D}\u{92A}\u{923}\u{940} \u{915}\u{940}\u{964}`,
    ht: `K\xf2mante sou aktivite sa a.`,
    it: `Ha commentato questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{3064}\u{3044}\u{3066}\u{30B3}\u{30E1}\u{30F3}\u{30C8}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{B300}\u{D574} \u{B313}\u{AE00}\u{C744} \u{B2EC}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Saib rau qhov kev ua no.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{67E}\u{647} \u{627}\u{693}\u{647} \u{62A}\u{628}\u{635}\u{631}\u{647} \u{648}\u{6A9}\u{693}\u{647}.`,
    pt: `Comentei sobre esta atividade.`,
    "pt-pt": `Comentou esta atividade.`,
    ru: `\u{41F}\u{440}\u{43E}\u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43B} \u{44D}\u{442}\u{443} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `Na ia fa'amatalaina lenei gaoioiga.`,
    so: `Ka faallooday howshan.`,
    th: `\u{E41}\u{E2A}\u{E14}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}\u{E40}\u{E2B}\u{E47}\u{E19}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{67E}\u{631} \u{62A}\u{628}\u{635}\u{631}\u{6C1} \u{6A9}\u{6CC}\u{627}.`,
    vi: `Nh\u{1EAD}n x\xe9t v\u{1EC1} ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{5BF9}\u{6B64}\u{6D3B}\u{52A8}\u{8FDB}\u{884C}\u{4E86}\u{8BC4}\u{8BBA}\u{3002}`,
    "zh-hant": `\u{5C0D}\u{6B64}\u{6D3B}\u{52D5}\u{9032}\u{884C}\u{4E86}\u{8A55}\u{8AD6}\u{3002}`,
    en: `Commented on this activity.`
};
const $2868cc1235412e16$export$4ceeef0826347df8 = {
    ar: `\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Diese Aktivit\xe4t wurde aktualisiert.`,
    es: `Se actualiz\xf3 esta actividad.`,
    fa: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{647} \u{631}\u{648}\u{632} \u{6A9}\u{631}\u{62F}.`,
    fil: `Na-update ang aktibidad na ito.`,
    fr: `Cette activit\xe9 a \xe9t\xe9 mise \xe0 jour.`,
    hi: `\u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}.`,
    ht: `Mete ajou aktivite sa a.`,
    it: `Aggiornata questa attivit\xe0.`,
    ja: `\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{66F4}\u{65B0}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C744} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kho tshiab qhov kev ua ub no no.`,
    ps: `\u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{631}\u{62F}.`,
    pt: `Atualizada esta atividade.`,
    "pt-pt": `Atualizada esta atividade.`,
    ru: `\u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E} \u{44D}\u{442}\u{43E} \u{443}\u{43F}\u{440}\u{430}\u{436}\u{43D}\u{435}\u{43D}\u{438}\u{435}.`,
    sm: `Fa'afouina lenei gaoioiga.`,
    so: `Cusbooneysiiyay waxqabadkan.`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627}\u{6D4}`,
    vi: `\u{110}\xe3 c\u{1EAD}p nh\u{1EAD}t ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{66F4}\u{65B0}\u{4E86}\u{6B64}\u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": `\u{66F4}\u{65B0}\u{4E86}\u{6B64}\u{6D3B}\u{52D5}\u{3002}`,
    en: `Updated this activity.`
};
const $2868cc1235412e16$export$927235c868aa0c00 = {
    ar: `\u{645}\u{62A}\u{642}\u{62F}\u{645}`,
    de: `Fortgeschritten`,
    es: `Avanzado`,
    fa: `\u{67E}\u{6CC}\u{634}\u{631}\u{641}\u{62A}\u{647}`,
    fil: `Advanced`,
    fr: `Avanc\xe9`,
    hi: `\u{905}\u{917}\u{94D}\u{930}\u{935}\u{930}\u{94D}\u{924}\u{940}`,
    ht: `Avanse`,
    it: `Avanzato`,
    ja: `\u{30A2}\u{30C9}\u{30D0}\u{30F3}\u{30B9}\u{30C9}`,
    ko: `\u{ACE0}\u{AE09}`,
    mww: `siab heev`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Avan\xe7ado`,
    "pt-pt": `Avan\xe7ado`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{432}\u{438}\u{43D}\u{443}\u{442}\u{44B}\u{439}`,
    sm: `Alualu i luma`,
    so: `hore`,
    th: `\u{E14}\u{E36}\u{E01}`,
    ur: `\u{627}\u{639}\u{644}\u{6CC}`,
    vi: `Ti\xean ti\u{1EBF}n`,
    "zh-hans": `\u{9AD8}\u{6DF1}`,
    "zh-hant": `\u{9AD8}\u{6DF1}`,
    en: `Advanced`
};
const $2868cc1235412e16$export$df43ba9fb6c5a259 = {
    ar: `\u{648}\u{627}\u{636}\u{62D}`,
    de: `Klar`,
    es: `Claro`,
    fa: `\u{631}\u{648}\u{634}\u{646}`,
    fil: `I-clear`,
    fr: `Clair`,
    hi: `\u{938}\u{94D}\u{92A}\u{937}\u{94D}\u{91F}`,
    ht: `Kl\xe8`,
    it: `Chiaro`,
    ja: `\u{30AF}\u{30EA}\u{30A2}`,
    ko: `\u{B9D1}\u{B2E4}`,
    mww: `Ntshiab`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Claro`,
    "pt-pt": `Limpar`,
    ru: `\u{42F}\u{441}\u{43D}\u{44B}\u{439}`,
    sm: `Manino`,
    so: `Clear`,
    th: `\u{E43}\u{E2A}`,
    ur: `\u{635}\u{627}\u{641}`,
    vi: `Trong`,
    "zh-hans": `\u{6E05}\u{695A}`,
    "zh-hant": `\u{6E05}\u{695A}`,
    en: `Clear`
};
const $2868cc1235412e16$export$ffc352a26526998f = {
    ar: `\u{645}\u{62D}\u{627}\u{644}\u{64A}\u{644}`,
    de: `L\xf6sungen`,
    es: `Soluciones`,
    fa: `\u{631}\u{627}\u{647} \u{62D}\u{644}`,
    fil: `Mga Solusyon`,
    fr: `Solutions`,
    hi: `\u{938}\u{92E}\u{93E}\u{927}\u{93E}\u{928}`,
    ht: `Solisyon`,
    it: `Soluzioni`,
    ja: `\u{30BD}\u{30EA}\u{30E5}\u{30FC}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{C194}\u{B8E8}\u{C158}`,
    mww: `tov`,
    ps: `\u{62D}\u{644} \u{644}\u{627}\u{631}\u{6D0}`,
    pt: `Solu\xe7\xf5es`,
    "pt-pt": `Solu\xe7\xf5es`,
    ru: `\u{420}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Fofo`,
    so: `Solutions`,
    th: `\u{E42}\u{E0B} \u{E25}\u{E39} \u{E0A}\u{E31}\u{E48}\u{E19}`,
    ur: `\u{62D}\u{644}`,
    vi: `Gi\u{1EA3}i ph\xe1p`,
    "zh-hans": `\u{89E3}\u{51B3} \u{65B9}\u{6848}`,
    "zh-hant": `\u{89E3}\u{6C7A}\u{65B9}\u{6848}`,
    en: `Solutions`
};
const $2868cc1235412e16$export$4cd024432c2a933c = {
    ar: (cumulus)=>`\u{623}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{634}\u{631}\u{648}\u{637} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} ${cumulus}`,
    de: (cumulus)=>`Ich stimme den ${cumulus} zu`,
    es: (cumulus)=>`Acepto los T\xe9rminos de uso de ${cumulus}`,
    fa: (cumulus)=>`\u{645}\u{646} \u{628}\u{627} \u{634}\u{631}\u{627}\u{6CC}\u{637} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} ${cumulus} \u{645}\u{648}\u{627}\u{641}\u{642}\u{645}`,
    fil: (cumulus)=>`Sumasang-ayon ako sa Mga Tuntunin ng Paggamit ${cumulus}`,
    fr: (cumulus)=>`J\u{2019}accepte les conditions d\u{2019}utilisation de ${cumulus}`,
    hi: (cumulus)=>`\u{92E}\u{948}\u{902} ${cumulus} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{940} \u{936}\u{930}\u{94D}\u{924}\u{94B}\u{902} \u{938}\u{947} \u{938}\u{939}\u{92E}\u{924} \u{939}\u{942}\u{902}`,
    ht: (cumulus)=>`Mwen dak\xf2 ak Kondisyon ${cumulus} pou Itilize`,
    it: (cumulus)=>`Accetto le Condizioni d'uso di ${cumulus}`,
    ja: (cumulus)=>`${cumulus} \u{306E}\u{5229}\u{7528}\u{898F}\u{7D04}\u{306B}\u{540C}\u{610F}\u{3057}\u{307E}\u{3059}`,
    ko: (cumulus)=>`${cumulus} \u{C774}\u{C6A9} \u{C57D}\u{AD00}\u{C5D0} \u{B3D9}\u{C758}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (cumulus)=>`Kuv pom zoo rau lub ${cumulus} cov ntsiab lus uas siv`,
    ps: (cumulus)=>`\u{632}\u{647} \u{62F} ${cumulus} \u{62F} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{62F} \u{634}\u{631}\u{627}\u{6CC}\u{637}\u{648} \u{633}\u{631}\u{647} \u{645}\u{648}\u{627}\u{641}\u{642} \u{6CC}\u{645}`,
    pt: (cumulus)=>`Eu concordo com os Termos de Uso da ${cumulus}`,
    "pt-pt": (cumulus)=>`Concordo com os Termos de ${cumulus}`,
    ru: (cumulus)=>`\u{42F} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{435}\u{43D} \u{441} \u{423}\u{441}\u{43B}\u{43E}\u{432}\u{438}\u{44F}\u{43C}\u{438} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} ${cumulus}`,
    sm: (cumulus)=>`Ou te ioe i tuutuuga o le fa'aaogaina o ${cumulus}`,
    so: (cumulus)=>`Waan ogolaaday in ${cumulus} ee Isticmaalka`,
    th: (cumulus)=>`\u{E09}\u{E31}\u{E19}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E02}\u{E49}\u{E2D}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19} ${cumulus}`,
    ur: (cumulus)=>`\u{645}\u{6CC}\u{6BA} ${cumulus} \u{6A9}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{6CC} \u{634}\u{631}\u{627}\u{626}\u{637} \u{633}\u{6D2} \u{627}\u{62A}\u{641}\u{627}\u{642} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA}`,
    vi: (cumulus)=>`T\xf4i \u{111}\u{1ED3}ng \xfd v\u{1EDB}i \u{110}i\u{1EC1}u kho\u{1EA3}n s\u{1EED} d\u{1EE5}ng ${cumulus}`,
    "zh-hans": (cumulus)=>`\u{6211}\u{540C}\u{610F} ${cumulus} \u{4F7F}\u{7528}\u{6761}\u{6B3E}`,
    "zh-hant": (cumulus)=>`\u{6211}\u{540C}\u{610F} ${cumulus} \u{4F7F}\u{7528}\u{689D}\u{6B3E}`,
    en: (cumulus)=>`I agree to the ${cumulus} Terms of Use`
};
const $2868cc1235412e16$export$35a00d15fe7d4e8 = {
    ar: `\u{634}\u{631}\u{648}\u{637} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645}`,
    de: `Nutzungsbedingungen`,
    es: `Condiciones de uso`,
    fa: `\u{634}\u{631}\u{627}\u{6CC}\u{637} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647}`,
    fil: `Mga Tuntunin ng Paggamit`,
    fr: `Conditions d\u{2019}utilisation`,
    hi: `\u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{940} \u{936}\u{930}\u{94D}\u{924}\u{947}\u{902}`,
    ht: `Regleman pou Itilize`,
    it: `Condizioni d'uso`,
    ja: `\u{5229}\u{7528}\u{898F}\u{7D04}`,
    ko: `\u{C774}\u{C6A9} \u{C57D}\u{AD00}`,
    mww: `Siv Cov Ntsiab Lus Uas Siv`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631}\u{648}\u{646}\u{6D0} \u{634}\u{631}\u{627}\u{6CC}\u{637}`,
    pt: `Termos de Uso`,
    "pt-pt": `Termos de Utiliza\xe7\xe3o`,
    ru: `\u{423}\u{441}\u{43B}\u{43E}\u{432}\u{438}\u{44F} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Tuutuuga o le Faaaogaina`,
    so: `Terms of Use`,
    th: `\u{E40}\u{E07}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E02}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{6CC} \u{634}\u{631}\u{627}\u{626}\u{637}`,
    vi: `\u{110}i\u{1EC1}u kho\u{1EA3}n s\u{1EED} d\u{1EE5}ng`,
    "zh-hans": `\u{4F7F}\u{7528}\u{6761}\u{6B3E}`,
    "zh-hant": `\u{4F7F}\u{7528}\u{689D}\u{6B3E}`,
    en: `Terms of Use`
};
const $2868cc1235412e16$export$24834e47a9adf0a8 = {
    ar: `\u{627}\u{644}\u{62E}\u{635}\u{648}\u{635}\u{64A}\u{647}`,
    de: `Privatsph\xe4re`,
    es: `Privacidad`,
    fa: `\u{62D}\u{631}\u{6CC}\u{645} \u{62E}\u{635}\u{648}\u{635}\u{6CC}`,
    fil: `Pagkapribado`,
    fr: `Vie priv\xe9e`,
    hi: `\u{917}\u{94B}\u{92A}\u{928}\u{940}\u{92F}\u{924}\u{93E}`,
    ht: `konfidansyalite`,
    it: `Privacy`,
    ja: `\u{30D7}\u{30E9}\u{30A4}\u{30D0}\u{30B7}\u{30FC}`,
    ko: `\u{C0AC}\u{C0DD}\u{D65C}`,
    mww: `Tsis Pub Twg Paub`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{648}\u{631}\u{646}\u{6CC}\u{648} \u{686}\u{627}\u{631}\u{648} \u{648}\u{632}\u{627}\u{631}\u{62A} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Privacidade`,
    "pt-pt": `Privacidade`,
    ru: `\u{41A}\u{43E}\u{43D}\u{444}\u{438}\u{434}\u{435}\u{43D}\u{446}\u{438}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Le faalauaiteleina`,
    so: `Privacy`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{631}\u{627}\u{632}\u{62F}\u{627}\u{631}\u{6CC}`,
    vi: `S\u{1EF1} ri\xeang t\u{1B0}`,
    "zh-hans": `\u{9690}\u{79C1}`,
    "zh-hant": `\u{96B1}\u{79C1}`,
    en: `Privacy`
};
const $2868cc1235412e16$export$13fb84c97e52f39c = {
    ar: (href)=>$2868cc1235412e16$var$html`لقد قمنا بتحديث <a href="${href}">شروط الاستخدام</a> الخاصة بنا.`,
    de: (href)=>$2868cc1235412e16$var$html`Wir haben unsere <a href="${href}">Nutzungsbedingungen</a> aktualisiert.`,
    es: (href)=>$2868cc1235412e16$var$html`Hemos actualizado nuestros <a href="${href}">Términos de uso</a>.`,
    fa: (href)=>$2868cc1235412e16$var$html`شرایط <a href="${href}">استفاده</a> خود را به روزرسانی کرده ایم.`,
    fil: (href)=>$2868cc1235412e16$var$html`Na-update namin ang aming <a href="${href}">Mga Tuntunin sa Paggamit</a>.`,
    fr: (href)=>$2868cc1235412e16$var$html`Nous avons mis à jour nos <a href="${href}">conditions d’utilisation</a>.`,
    hi: (href)=>$2868cc1235412e16$var$html`हमने अपनी <a href="${href}">उपयोग की शर्तों</a> को अपडेट कर दिया है।`,
    ht: (href)=>$2868cc1235412e16$var$html`Nou te mete ajou <a href="${href}">kondisyon nou yo nan Itilize</a>.`,
    it: (href)=>$2868cc1235412e16$var$html`Abbiamo aggiornato i nostri <a href="${href}">Termini di utilizzo</a>.`,
    ja: (href)=>$2868cc1235412e16$var$html`<a href="${href}">利用規約</a>を更新しました。`,
    ko: (href)=>$2868cc1235412e16$var$html`<a href="${href}">이용 약관을</a> 업데이트했습니다.`,
    mww: (href)=>$2868cc1235412e16$var$html`Peb twb muab kho peb <a href="${href}">cov ntsiab lus uas siv</a>.`,
    ps: (href)=>$2868cc1235412e16$var$html`موږ خپل <a href="${href}">د کارونې شرایط</a> تازه کړی دی.`,
    pt: (href)=>$2868cc1235412e16$var$html`Atualizamos nossos <a href="${href}">Termos de Uso</a>.`,
    "pt-pt": (href)=>$2868cc1235412e16$var$html`Atualizámos os nossos <a href="${href}">Termos de Utilização</a>.`,
    ru: (href)=>$2868cc1235412e16$var$html`Мы обновили наши <a href="${href}">Условия использования</a>.`,
    sm: (href)=>$2868cc1235412e16$var$html`Ua matou fa'afouina a matou <a href="${href}">tuutuuga o fa'aaogaina</a>.`,
    so: (href)=>$2868cc1235412e16$var$html`Waxaan cusbooneysiinnay <a href="${href}">Shuruucda isticmaalka</a>.`,
    th: (href)=>$2868cc1235412e16$var$html`เราได้อัปเดต <a href="${href}">ข้อกําหนดการใช้งาน</a>ของเรา`,
    ur: (href)=>$2868cc1235412e16$var$html`ہم نے اپنے استعمال کی <a href="${href}">شرائط</a> کو اپ ڈیٹ کیا ہے.`,
    vi: (href)=>$2868cc1235412e16$var$html`Chúng tôi đã cập nhật <a href="${href}">Điều khoản sử dụng</a> của mình.`,
    "zh-hans": (href)=>$2868cc1235412e16$var$html`我们更新了 <a href="${href}">我们的使用条款</a>。`,
    "zh-hant": (href)=>$2868cc1235412e16$var$html`我們更新了 <a href="${href}">我們的使用條款</a>。`,
    en: (href)=>$2868cc1235412e16$var$html`We've updated our <a href="${href}">Terms of Use</a>.`
};
const $2868cc1235412e16$export$5fd36fc41845e8c = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{625}\u{643}\u{645}\u{627}\u{644} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{623}\u{62B}\u{646}\u{627}\u{621} \u{627}\u{633}\u{62A}\u{645}\u{631}\u{627}\u{631} \u{623}\u{646}\u{634}\u{637}\u{62A}\u{647} \u{627}\u{644}\u{641}\u{631}\u{639}\u{64A}\u{629} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{629} \u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}. \u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{639}\u{644}\u{627}\u{645}\u{629} \u{627}\u{644}\u{62A}\u{628}\u{648}\u{64A}\u{628} "\u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{631}\u{62A}\u{628}\u{637}\u{629}" \u{648}\u{623}\u{643}\u{645}\u{644} \u{623}\u{648} \u{623}\u{644}\u{63A}\u{64A} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{645}\u{62F}\u{631}\u{62C}\u{629} \u{647}\u{646}\u{627}\u{643} \u{642}\u{628}\u{644} \u{625}\u{643}\u{645}\u{627}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}.`,
    de: `Eine Aktivit\xe4t kann nicht abgeschlossen werden, solange sich die untergeordneten Aktivit\xe4ten noch im Status "Offen" befinden. Navigieren Sie zur Registerkarte "Zugeh\xf6rige Aktivit\xe4ten" und schlie\xdfen Sie die dort aufgef\xfchrten Aktivit\xe4ten ab oder brechen Sie sie ab, bevor Sie diese Aktivit\xe4t abschlie\xdfen.`,
    es: `Una actividad no se puede completar mientras sus actividades secundarias a\xfan est\xe9n en estado abierto. Vaya a la pesta\xf1a "Actividades asociadas" y complete o cancele las actividades enumeradas all\xed antes de completar esta actividad.`,
    fa: `\u{6CC}\u{6A9} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646} \u{62F}\u{631} \u{62D}\u{627}\u{644}\u{6CC} \u{6A9}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{631}\u{632}\u{646}\u{62F} \u{622}\u{646} \u{647}\u{646}\u{648}\u{632} \u{62F}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{628}\u{627}\u{632} \u{627}\u{633}\u{62A}\u{60C} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6A9}\u{631}\u{62F}. \u{628}\u{647} \u{628}\u{631}\u{6AF}\u{647} \xab\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{645}\u{631}\u{62A}\u{628}\u{637}\xbb \u{628}\u{631}\u{648}\u{6CC}\u{62F} \u{648} \u{642}\u{628}\u{644} \u{627}\u{632} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{60C} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{622}\u{646}\u{62C}\u{627} \u{631}\u{627} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{6CC}\u{627} \u{644}\u{63A}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ang isang aktibidad ay hindi maaaring makumpleto habang ang mga aktibidad ng bata ay nasa bukas na katayuan pa rin. Mag-navigate sa tab na "Mga Kaugnay na Aktibidad" at kumpletuhin o kanselahin ang mga aktibidad na nakalista doon bago makumpleto ang aktibidad na ito.`,
    fr: `Une activit\xe9 ne peut pas \xeatre termin\xe9e tant que ses activit\xe9s enfants sont toujours ouvertes. Acc\xe9dez \xe0 l\u{2019}onglet \xab Activit\xe9s associ\xe9es \xbb et terminez ou annulez les activit\xe9s qui y sont \xe9num\xe9r\xe9es avant de terminer cette activit\xe9.`,
    hi: `\u{90F}\u{915} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{942}\u{930}\u{940} \u{928}\u{939}\u{940}\u{902} \u{915}\u{940} \u{91C}\u{93E} \u{938}\u{915}\u{924}\u{940} \u{939}\u{948} \u{91C}\u{92C} \u{924}\u{915} \u{915}\u{93F} \u{909}\u{938}\u{915}\u{940} \u{92C}\u{93E}\u{932} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901} \u{905}\u{92D}\u{940} \u{92D}\u{940} \u{916}\u{941}\u{932}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{902} \u{939}\u{948}\u{902}\u{964} "\u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{901}" \u{91F}\u{948}\u{92C} \u{92A}\u{930} \u{928}\u{947}\u{935}\u{93F}\u{917}\u{947}\u{91F} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{93E} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{935}\u{939}\u{93E}\u{901} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{92A}\u{942}\u{930}\u{93E} \u{92F}\u{93E} \u{930}\u{926}\u{94D}\u{926} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Yon aktivite pa ka ranpli pandan aktivite timoun li yo toujou nan yon estati ouv\xe8. Navige nan "aktivite ki asosye" tab ak konpl\xe8 oswa anile aktivite yo ki nan lis la anvan yo ranpli aktivite sa a.`,
    it: `Impossibile completare un'attivit\xe0 mentre le relative attivit\xe0 figlio sono ancora in uno stato aperto. Vai alla scheda "Attivit\xe0 associate" e completa o annulla le attivit\xe0 elencate prima di completare questa attivit\xe0.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306F}\u{3001}\u{305D}\u{306E}\u{5B50}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{304C}\u{307E}\u{3060}\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{306B}\u{3042}\u{308B}\u{9593}\u{306F}\u{5B8C}\u{4E86}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}\u{300C}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{305F}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{300D}\u{30BF}\u{30D6}\u{306B}\u{79FB}\u{52D5}\u{3057}\u{3001}\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{5B8C}\u{4E86}\u{3059}\u{308B}\u{524D}\u{306B}\u{3001}\u{305D}\u{3053}\u{306B}\u{30EA}\u{30B9}\u{30C8}\u{3055}\u{308C}\u{3066}\u{3044}\u{308B}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{5B8C}\u{4E86}\u{307E}\u{305F}\u{306F}\u{30AD}\u{30E3}\u{30F3}\u{30BB}\u{30EB}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D558}\u{C704} \u{D65C}\u{B3D9}\u{C774} \u{C5EC}\u{C804}\u{D788} \u{C5F4}\u{B9B0} \u{C0C1}\u{D0DC}\u{C77C} \u{B54C}\u{B294} \u{D65C}\u{B3D9}\u{C744} \u{C644}\u{B8CC}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}. "\u{AD00}\u{B828} \u{D65C}\u{B3D9}" \u{D0ED}\u{C73C}\u{B85C} \u{C774}\u{B3D9}\u{D558}\u{C5EC} \u{C774} \u{D65C}\u{B3D9}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{AE30} \u{C804}\u{C5D0} \u{B098}\u{C5F4}\u{B41C} \u{D65C}\u{B3D9}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{AC70}\u{B098} \u{CDE8}\u{C18C}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Ib qho kev ua ub no yuav ua tsis tau kom tiav thaum nws cov kev ua ub no tseem nyob rau hauv ib qho kev qhib raws li txoj cai. Navigate rau cov "Associated activities" tab sis ua tiav los yog muab cov kev ua ub no uas teev muaj ua ntej yuav ua tiav qhov kev ua no.`,
    ps: `\u{6CC}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62A}\u{631} \u{647}\u{63A}\u{647} \u{648}\u{62E}\u{62A}\u{647} \u{628}\u{634}\u{67E}\u{693} \u{646}\u{634}\u{6CC} \u{686}\u{6D0} \u{62F} \u{645}\u{627}\u{634}\u{648}\u{645} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{6CC}\u{6D0} \u{644}\u{627} \u{647}\u{645} \u{67E}\u{647} \u{62E}\u{644}\u{627}\u{635} \u{62D}\u{627}\u{644}\u{62A} \u{6A9}\u{6D0} \u{648}\u{6CC}. \u{62F} "\u{627}\u{693}\u{648}\u{646}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648}" \u{67C}\u{628} \u{62A}\u{647} \u{648}\u{644}\u{627}\u{693} \u{634}\u{626} \u{627}\u{648} \u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{644}\u{647} \u{628}\u{634}\u{67E}\u{693}\u{648}\u{644}\u{648} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{633}\u{62A} \u{634}\u{648}\u{6CC} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{634}\u{67E}\u{693} \u{6CC}\u{627} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{626}.`,
    pt: `Uma atividade n\xe3o pode ser conclu\xedda enquanto suas atividades secund\xe1rias ainda estiverem em um status aberto. Navegue at\xe9 a guia "Atividades associadas" e conclua ou cancele as atividades listadas antes de concluir esta atividade.`,
    "pt-pt": `Uma atividade n\xe3o pode ser conclu\xedda enquanto suas atividades filhas ainda estiverem em um status aberto. Navegue at\xe9 a guia "Atividades associadas" e conclua ou cancele as atividades listadas antes de concluir esta atividade.`,
    ru: `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{43E}, \u{43F}\u{43E}\u{43A}\u{430} \u{435}\u{433}\u{43E} \u{434}\u{43E}\u{447}\u{435}\u{440}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{432}\u{441}\u{435} \u{435}\u{449}\u{435} \u{43D}\u{430}\u{445}\u{43E}\u{434}\u{44F}\u{442}\u{441}\u{44F} \u{432} \u{441}\u{43E}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{438} \u{43E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{438}\u{44F}. \u{41F}\u{435}\u{440}\u{435}\u{439}\u{434}\u{438}\u{442}\u{435} \u{43D}\u{430} \u{432}\u{43A}\u{43B}\u{430}\u{434}\u{43A}\u{443} \xab\u{421}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}\xbb \u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{438}\u{442}\u{435} \u{438}\u{43B}\u{438} \u{43E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{442}\u{430}\u{43C} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{434}\u{43E} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{438}\u{44F} \u{44D}\u{442}\u{43E}\u{433}\u{43E} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}.`,
    sm: `E le mafai ona faamaeaina se gaoioiga a o tatala pea ana gaoioiga a tamaiti. Alu i le faailoga o "Gaoioiga e faatatau i ai" ma faamaea pe faaleaogaina ia gaoioiga o loo lisiina iina a o lei faamaeaina lenei gaoioiga.`,
    so: `Howlahaas lama dhammeysiin karo, inta howsha carruurtu ay weli ku jirto si furan. In aad u sii marto tababka "Howlaha la xiriira", lana dhammeystiro ama laga joojiyo hawlaha halkaas ku qoran ka hor inta aan la dhamaystirin howlahan.`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E17}\u{E4D}\u{E32}\u{E44}\u{E14}\u{E49}\u{E43}\u{E19}\u{E02}\u{E13}\u{E30}\u{E17}\u{E35}\u{E48}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E22}\u{E48}\u{E2D}\u{E22}\u{E22}\u{E31}\u{E07}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E44}\u{E1B}\u{E17}\u{E35}\u{E48}\u{E41}\u{E17}\u{E47}\u{E1A} "\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}" \u{E41}\u{E25}\u{E30}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E22}\u{E01}\u{E40}\u{E25}\u{E34}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E44}\u{E27}\u{E49}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E34}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{633}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62A}\u{6A9} \u{645}\u{6A9}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627}\u{633}\u{6A9}\u{62A}\u{627} \u{62C}\u{628} \u{62A}\u{6A9} \u{6A9}\u{6C1} \u{627}\u{633} \u{6A9}\u{6CC} \u{628}\u{686}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{627}\u{628} \u{628}\u{6BE}\u{6CC} \u{6A9}\u{6BE}\u{644}\u{6CC} \u{62D}\u{627}\u{644}\u{62A} \u{645}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{6BA}\u{6D4} "\u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}" \u{679}\u{6CC}\u{628} \u{67E}\u{631} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{648} \u{645}\u{6A9}\u{645}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{648}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{648} \u{645}\u{6A9}\u{645}\u{644} \u{6CC}\u{627} \u{645}\u{646}\u{633}\u{648}\u{62E} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Kh\xf4ng th\u{1EC3} ho\xe0n th\xe0nh m\u{1ED9}t ho\u{1EA1}t \u{111}\u{1ED9}ng trong khi c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng con c\u{1EE7}a n\xf3 v\u{1EAB}n \u{1EDF} tr\u{1EA1}ng th\xe1i m\u{1EDF}. \u{110}i\u{1EC1}u h\u{1B0}\u{1EDB}ng \u{111}\u{1EBF}n tab "Ho\u{1EA1}t \u{111}\u{1ED9}ng li\xean k\u{1EBF}t" v\xe0 ho\xe0n th\xe0nh ho\u{1EB7}c h\u{1EE7}y c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea \u{1EDF} \u{111}\xf3 tr\u{1B0}\u{1EDB}c khi ho\xe0n th\xe0nh ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y.`,
    "zh-hans": `\u{5F53} Activity \u{7684}\u{5B50} Activity \u{4ECD}\u{5904}\u{4E8E} open \u{72B6}\u{6001}\u{65F6}\u{FF0C}\u{65E0}\u{6CD5}\u{5B8C}\u{6210}\u{8BE5} Activity\u{3002}\u{5BFC}\u{822A}\u{5230}\u{201C}Associated activities\u{201D}\u{9009}\u{9879}\u{5361}\u{FF0C}\u{5E76}\u{5728}\u{5B8C}\u{6210}\u{6B64}\u{6D3B}\u{52A8}\u{4E4B}\u{524D}\u{5B8C}\u{6210}\u{6216}\u{53D6}\u{6D88}\u{6B64}\u{5904}\u{5217}\u{51FA}\u{7684}\u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": `\u{7576} Activity \u{7684}\u{5B50} Activity \u{4ECD}\u{8655}\u{65BC} open \u{72C0}\u{614B}\u{6642}\u{FF0C}\u{7121}\u{6CD5}\u{5B8C}\u{6210}\u{8A72} Activity\u{3002}\u{5C0E}\u{822A}\u{5230}\u{201C}Associated activities\u{201D}\u{9078}\u{9805}\u{5361}\u{FF0C}\u{4E26}\u{5728}\u{5B8C}\u{6210}\u{6B64}\u{6D3B}\u{52D5}\u{4E4B}\u{524D}\u{5B8C}\u{6210}\u{6216}\u{53D6}\u{6D88}\u{6B64}\u{8655}\u{5217}\u{51FA}\u{7684}\u{6D3B}\u{52D5}\u{3002}`,
    en: `An activity cannot be completed while its child activities are still in an open status. Navigate to the "Associated activities" tab and complete or cancel the activities listed there prior to completing this activity.`
};
const $2868cc1235412e16$export$de23dc6ad7910785 = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{635}\u{64A}\u{647}`,
    de: `Empfehlung`,
    es: `Recomendaci\xf3n`,
    fa: `\u{62A}\u{648}\u{635}\u{6CC}\u{647}`,
    fil: `Rekomendasyon`,
    fr: `Recommandation`,
    hi: `\u{938}\u{93F}\u{92B}\u{93C}\u{93E}\u{930}\u{93F}\u{936}`,
    ht: `Rek\xf2mandasyon`,
    it: `Raccomandazione`,
    ja: `\u{52E7}\u{544A}`,
    ko: `\u{CD94}\u{CC9C}`,
    mww: `pom zoo`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{647}`,
    pt: `Recomenda\xe7\xe3o`,
    "pt-pt": `Recomenda\xe7\xe3o`,
    ru: `\u{420}\u{435}\u{43A}\u{43E}\u{43C}\u{435}\u{43D}\u{434}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fautuaga`,
    so: `Soo jeedin`,
    th: `\u{E01}\u{E32}\u{E23}\u{E41}\u{E19}\u{E30}\u{E19}\u{E4D}\u{E32}`,
    ur: `\u{633}\u{641}\u{627}\u{631}\u{634}`,
    vi: `Khuy\u{1EBF}n ngh\u{1ECB}`,
    "zh-hans": `\u{5EFA}\u{8BAE}`,
    "zh-hant": `\u{5EFA}\u{8B70}`,
    en: `Recommendation`
};
const $2868cc1235412e16$export$6af53a849aeeeae9 = {
    ar: `\u{645}\u{648}\u{627}\u{631}\u{62F}`,
    de: `Betriebsmittel`,
    es: `Recursos`,
    fa: `\u{645}\u{646}\u{627}\u{628}\u{639}`,
    fil: `Mga Mapagkukunan`,
    fr: `Ressources`,
    hi: `\u{938}\u{902}\u{938}\u{93E}\u{927}\u{928}`,
    ht: `Resous`,
    it: `Risorse`,
    ja: `\u{30EA}\u{30BD}\u{30FC}\u{30B9}`,
    ko: `\u{B9AC}\u{C18C}\u{C2A4}`,
    mww: `Cov Chaw Muab Kev Pab`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Recursos`,
    "pt-pt": `Recursos`,
    ru: `\u{420}\u{435}\u{441}\u{443}\u{440}\u{441}\u{44B}`,
    sm: `Punaoa`,
    so: `Khayraadka`,
    th: `\u{E17}\u{E23}\u{E31}\u{E1E}\u{E22}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{648}\u{633}\u{627}\u{626}\u{644}`,
    vi: `T\xe0i nguy\xean`,
    "zh-hans": `\u{8D44}\u{6E90}`,
    "zh-hant": `\u{8CC7}\u{6E90}`,
    en: `Resources`
};
const $2868cc1235412e16$export$8cff90f8fc359b41 = {
    ar: `\u{627}\u{62A}\u{635}\u{644} \u{628}\u{627}\u{644}\u{645}\u{628}\u{64A}\u{639}\u{627}\u{62A}`,
    de: `Vertrieb kontaktieren`,
    es: `P\xf3ngase en contacto con el departamento de`,
    fa: `\u{62A}\u{645}\u{627}\u{633} \u{628}\u{627} \u{641}\u{631}\u{648}\u{634}`,
    fil: `Makipag-ugnay sa mga benta`,
    fr: `Contacter le service commercial`,
    hi: `\u{92C}\u{93F}\u{915}\u{94D}\u{930}\u{940} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Lavant kontak`,
    it: `Contatta l'ufficio vendite`,
    ja: `\u{8CA9}\u{58F2}\u{62C5}\u{5F53}\u{306B}\u{9023}\u{7D61}`,
    ko: `\u{AD6C}\u{B9E4} \u{BB38}\u{C758} \u{BC0F} \u{C0C1}\u{B2F4}`,
    mww: `Hu rau muag khoom`,
    ps: `\u{62F} \u{62E}\u{631}\u{685}\u{644}\u{627}\u{648} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}`,
    pt: `Entre em contato com a equipe de vendas`,
    "pt-pt": `Entre em contato com o departamento de vendas`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{441} \u{43E}\u{442}\u{434}\u{435}\u{43B}\u{43E}\u{43C} \u{43F}\u{440}\u{43E}\u{434}\u{430}\u{436}`,
    sm: `Fa'afeso'ota'i tagata fa'`,
    so: `iibka Contact`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E1D}\u{E48}\u{E32}\u{E22}\u{E02}\u{E32}\u{E22}`,
    ur: `\u{641}\u{631}\u{648}\u{62E}\u{62A} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Li\xean h\u{1EC7} b\xe1n h\xe0ng`,
    "zh-hans": `\u{8054}\u{7CFB}\u{9500}\u{552E}\u{4EBA}\u{5458}`,
    "zh-hant": `\u{806F}\u{7E6B}\u{92B7}\u{552E}\u{4EBA}\u{54E1}`,
    en: `Contact sales`
};
const $2868cc1235412e16$export$622bc2fa47b3620 = {
    ar: $2868cc1235412e16$var$html`يتم تعطيل تحرير ملف التعريف في موقع التدريب. قم بتحرير ملف التعريف الخاص بك على <a href="https://cumulus.care/settings/profile">موقع الإنتاج</a> وستتم مزامنة التغييرات الخاصة بك مع موقع التدريب في غضون عشر دقائق.`,
    de: $2868cc1235412e16$var$html`Die Profilbearbeitung ist auf der Schulungswebsite deaktiviert. Bearbeiten Sie Ihr Profil auf der <a href="https://cumulus.care/settings/profile">Produktionsseite</a> und Ihre Änderungen werden innerhalb von zehn Minuten mit der Schulungsseite synchronisiert.`,
    es: $2868cc1235412e16$var$html`La edición de perfiles está deshabilitada en el sitio de capacitación. Edite su perfil en el <a href="https://cumulus.care/settings/profile">sitio de producción</a> y sus cambios se sincronizarán con el sitio de capacitación en diez minutos.`,
    fa: $2868cc1235412e16$var$html`ویرایش نمایه در سایت آموزشی غیرفعال است. پروفایل خود را در <a href="https://cumulus.care/settings/profile">سایت تولید</a> ویرایش کنید و تغییرات شما در عرض ده دقیقه با سایت آموزشی همگام سازی می شود.`,
    fil: $2868cc1235412e16$var$html`Hindi pinagana ang pag-edit ng profile sa site ng pagsasanay. I-edit ang iyong profile sa <a href="https://cumulus.care/settings/profile">site ng produksyon</a> at ang iyong mga pagbabago ay mai-synchronize sa site ng pagsasanay sa loob ng sampung minuto.`,
    fr: $2868cc1235412e16$var$html`L’édition du profil est désactivée sur le site de formation. Modifiez votre profil sur le <a href="https://cumulus.care/settings/profile">site de production</a> et vos modifications seront synchronisées avec le site de formation dans les dix minutes.`,
    hi: $2868cc1235412e16$var$html`प्रशिक्षण साइट पर प्रोफ़ाइल संपादन अक्षम किया गया है. <a href="https://cumulus.care/settings/profile">उत्पादन साइट</a> पर अपनी प्रोफ़ाइल संपादित करें और आपके परिवर्तन दस मिनट के भीतर प्रशिक्षण साइट पर सिंक्रनाइज़ हो जाएंगे।`,
    ht: $2868cc1235412e16$var$html`Pwofil koreksyon enfim sou sit la fòmasyon. Edit pwofil ou sou <a href="https://cumulus.care/settings/profile">sit pwodiksyon</a> an ak chanjman ou yo pral senkronize nan sit la fòmasyon nan dis minit.`,
    it: $2868cc1235412e16$var$html`La modifica del profilo è disabilitata sul sito di formazione. Modifica il tuo profilo sul <a href="https://cumulus.care/settings/profile">sito di produzione</a> e le tue modifiche verranno sincronizzate con il sito di formazione entro dieci minuti.`,
    ja: $2868cc1235412e16$var$html`トレーニングサイトでプロファイルの編集が無効になっています。 <a href="https://cumulus.care/settings/profile">本番サイトで</a> プロファイルを編集すると、変更内容が10分以内にトレーニングサイトに同期されます。`,
    ko: $2868cc1235412e16$var$html`교육 사이트에서 프로필 편집이 비활성화되어 있습니다. <a href="https://cumulus.care/settings/profile">생산 현장에서</a> 프로필을 편집하면 변경 사항이 10분 이내에 교육 현장에 동기화됩니다.`,
    mww: $2868cc1235412e16$var$html`Profile editing yog xiam oob khab rau txoj kev kawm. Edit koj profile rau qhov <a href="https://cumulus.care/settings/profile">chaw ntau lawm</a> thiab koj kev hloov yuav synchronized rau txoj kev kawm nyob rau hauv kaum feeb.`,
    ps: $2868cc1235412e16$var$html`د پروفایل ایډیټ د روزنې په سایټ کې غیر فعال دی. د <a href="https://cumulus.care/settings/profile">تولید په سایټ</a> کې خپل پروفایل سمون کړئ او ستاسو بدلونونه به په لسو دقیقو کې د روزنې ځای سره همغږی شی.`,
    pt: $2868cc1235412e16$var$html`A edição de perfil está desativada no site de treinamento. Edite seu perfil no <a href="https://cumulus.care/settings/profile">site de produção</a> e suas alterações serão sincronizadas com o site de treinamento em dez minutos.`,
    "pt-pt": $2868cc1235412e16$var$html`A edição de perfil está desativada no site de treinamento. Edite seu perfil no <a href="https://cumulus.care/settings/profile">local de produção</a> e suas alterações serão sincronizadas com o local de treinamento em dez minutos.`,
    ru: $2868cc1235412e16$var$html`Редактирование профиля на обучающем сайте отключено. Отредактируйте свой профиль на <a href="https://cumulus.care/settings/profile">производственной площадке</a> и ваши изменения будут синхронизированы с учебным сайтом в течение десяти минут.`,
    sm: $2868cc1235412e16$var$html`E le mafai ona faasa'oina le talaaga otooto i luga o le saite o aoaoga. Faasa'o lou talaaga otooto i luga o le <a href="https://cumulus.care/settings/profile">saite o le gaosiga</a> ma o le a faalaugatasia au suiga i le saite o aoaoga i totonu o le sefulu minute.`,
    so: $2868cc1235412e16$var$html`Tafatirka profileku wuxuu ku naafo ka yahay goobta tababarka. Edit your profile on the <a href="https://cumulus.care/settings/profile">production site</a> and your changes benes in synchronized to the training site within ten minuteses gudahood.`,
    th: $2868cc1235412e16$var$html`การแก้ไขโปรไฟล์ถูกปิดใช้งานบนไซต์การฝึกอบรม แก้ไขโปรไฟล์ของคุณบน <a href="https://cumulus.care/settings/profile">ไซต์การผลิต</a> และการเปลี่ยนแปลงของคุณจะถูกซิงโครไนซ์กับไซต์การฝึกอบรมภายในสิบนาที`,
    ur: $2868cc1235412e16$var$html`تربیتی سائٹ پر پروفائل ایڈیٹنگ غیر فعال ہے۔ <a href="https://cumulus.care/settings/profile">پروڈکشن سائٹ</a> پر اپنے پروفائل میں ترمیم کریں اور آپ کی تبدیلیاں دس منٹ کے اندر تربیتی سائٹ سے مطابقت پذیر ہوں گی۔`,
    vi: $2868cc1235412e16$var$html`Chỉnh sửa hồ sơ bị vô hiệu hóa trên trang web đào tạo. Chỉnh sửa hồ sơ của bạn trên <a href="https://cumulus.care/settings/profile">trang web sản xuất</a> và các thay đổi của bạn sẽ được đồng bộ hóa với trang web đào tạo trong vòng mười phút.`,
    "zh-hans": $2868cc1235412e16$var$html`配置文件编辑在培训网站上被禁用。在 <a href="https://cumulus.care/settings/profile">生产站点</a> 上编辑您的配置文件，您的更改将在 10 分钟内同步到培训站点。`,
    "zh-hant": $2868cc1235412e16$var$html`配置文件編輯在培訓網站上被禁用。在 <a href="https://cumulus.care/settings/profile">生產網站</a> 上編輯您的配置檔，您的更改將在 10 分鐘內同步到培訓網站。`,
    en: $2868cc1235412e16$var$html`Profile editing is disabled on the training site. Edit your profile on the <a href="https://cumulus.care/settings/profile">production site</a> and your changes will be synchronized to the training site within ten minutes.`
};
const $2868cc1235412e16$export$7a4cb986ff99752 = {
    ar: $2868cc1235412e16$var$html`تم تعطيل تسجيل حساب جديد في موقع التدريب. قم بالتسجيل في <a href="https://cumulus.care/sign-up">موقع الإنتاج</a> وسيتم مزامنة حسابك مع موقع التدريب في غضون عشر دقائق.`,
    de: $2868cc1235412e16$var$html`Die Registrierung eines neuen Kontos ist auf der Schulungsseite deaktiviert. Melden Sie sich auf der <a href="https://cumulus.care/sign-up">Produktionsseite</a> an und Ihr Konto wird innerhalb von zehn Minuten mit der Schulungsseite synchronisiert.`,
    es: $2868cc1235412e16$var$html`El registro de una nueva cuenta está deshabilitado en el sitio de capacitación. Regístrese en el sitio de <a href="https://cumulus.care/sign-up">producción</a> y su cuenta se sincronizará con el sitio de capacitación en diez minutos.`,
    fa: $2868cc1235412e16$var$html`ثبت نام حساب جدید در سایت آموزشی غیرفعال است. در <a href="https://cumulus.care/sign-up">سایت تولید</a> ثبت نام کنید و حساب شما در عرض ده دقیقه با سایت آموزشی همگام سازی می شود.`,
    fil: $2868cc1235412e16$var$html`Hindi pinagana ang pagpaparehistro ng bagong account sa site ng pagsasanay. Mag-sign up sa <a href="https://cumulus.care/sign-up">site ng produksyon</a> at ang iyong account ay mai-synchronize sa site ng pagsasanay sa loob ng sampung minuto.`,
    fr: $2868cc1235412e16$var$html`L’enregistrement d’un nouveau compte est désactivé sur le site de formation. Inscrivez-vous sur le <a href="https://cumulus.care/sign-up">site de production</a> et votre compte sera synchronisé avec le site de formation dans les dix minutes.`,
    hi: $2868cc1235412e16$var$html`प्रशिक्षण साइट पर नया खाता पंजीकरण अक्षम है। <a href="https://cumulus.care/sign-up">उत्पादन साइट</a> पर साइन अप करें और आपका खाता दस मिनट के भीतर प्रशिक्षण स्थल पर सिंक्रनाइज़ हो जाएगा।`,
    ht: $2868cc1235412e16$var$html`Nouvo enskripsyon kont enfim sou sit la fòmasyon. Enskri sou <a href="https://cumulus.care/sign-up">sit la pwodiksyon</a> ak kont ou yo pral senkronize nan sit la fòmasyon nan dis minit.`,
    it: $2868cc1235412e16$var$html`La registrazione di un nuovo account è disabilitata sul sito di formazione. Registrati sul <a href="https://cumulus.care/sign-up">sito di produzione</a> e il tuo account verrà sincronizzato con il sito di formazione entro dieci minuti.`,
    ja: $2868cc1235412e16$var$html`トレーニングサイトでの新規アカウント登録が無効になります。 <a href="https://cumulus.care/sign-up">本番サイトに</a> サインアップすると、10分以内にアカウントがトレーニングサイトに同期されます。`,
    ko: $2868cc1235412e16$var$html`교육 사이트에서 새 계정 등록이 비활성화되어 있습니다. <a href="https://cumulus.care/sign-up">생산 현장에서</a> 등록하면 계정이 10분 이내에 교육 현장과 동기화됩니다.`,
    mww: $2868cc1235412e16$var$html`Tus account tshiab yog xiam oob khab rau txoj kev kawm. Kos npe rau ntawm <a href="https://cumulus.care/sign-up">qhov chaw ntau lawm</a> thiab koj tus account yuav synchronized rau txoj kev kawm nyob rau hauv kaum feeb.`,
    ps: $2868cc1235412e16$var$html`د نوی حساب ثبتول د روزنې په ساحه کې غیر فعال دی. د <a href="https://cumulus.care/sign-up">تولید په سایټ</a> کې نوم لیکنه وکړئ او ستاسو حساب به په لسو دقیقو کې د روزنې ځای سره همغږی شی.`,
    pt: $2868cc1235412e16$var$html`O registro de nova conta está desabilitado no site de treinamento. Inscreva-se no <a href="https://cumulus.care/sign-up">site de produção</a> e sua conta será sincronizada com o site de treinamento em dez minutos.`,
    "pt-pt": $2868cc1235412e16$var$html`O registo de uma nova conta está desativado no site de formação. Inscreva-se no <a href="https://cumulus.care/sign-up">site de produção</a> e sua conta será sincronizada com o local de treinamento em dez minutos.`,
    ru: $2868cc1235412e16$var$html`Регистрация нового аккаунта на обучающем сайте отключена. Зарегистрируйтесь на <a href="https://cumulus.care/sign-up">производственном сайте</a> , и ваша учетная запись будет синхронизирована с учебным сайтом в течение десяти минут.`,
    sm: $2868cc1235412e16$var$html`O le lesitalaina o le faitotoa fou e le mafai ona lesitalaina i luga o le saite o aoaoga. Saini i luga o le <a href="https://cumulus.care/sign-up">'upega tafa'ilagi o le gaosiga</a> ma o lau teuga tupe o le a fa'afeso'ota'i i le nofoaga o a'oa'oga i totonu o le sefulu minute.`,
    so: $2868cc1235412e16$var$html`Iska diiwaangelinta akawn cusub waxay ku naafo ka tahay goobta tababarka. Isku qor <a href="https://cumulus.care/sign-up">goobta wax soo saarka</a> iyo akoonkaaga waafaqsaneyn goobta tababarka toban daqiiqo gudahood.`,
    th: $2868cc1235412e16$var$html`การลงทะเบียนบัญชีใหม่ถูกปิดใช้งานบนไซต์การฝึกอบรม ลงทะเบียนบนเว็บไซต์ <a href="https://cumulus.care/sign-up">การผลิต</a> และบัญชีของคุณจะถูกซิงโครไนซ์กับไซต์การฝึกอบรมภายในสิบนาที`,
    ur: $2868cc1235412e16$var$html`تربیتی سائٹ پر نیا اکاؤنٹ رجسٹریشن غیر فعال ہے۔ <a href="https://cumulus.care/sign-up">پروڈکشن سائٹ</a> پر سائن اپ کریں اور آپ کا اکاؤنٹ دس منٹ کے اندر تربیتی سائٹ سے مطابقت پذیر ہوجائے گا۔`,
    vi: $2868cc1235412e16$var$html`Đăng ký tài khoản mới bị vô hiệu hóa trên trang web đào tạo. Đăng ký trên <a href="https://cumulus.care/sign-up">trang web sản xuất</a> và tài khoản của bạn sẽ được đồng bộ hóa với địa điểm đào tạo trong vòng mười phút.`,
    "zh-hans": $2868cc1235412e16$var$html`新帐户注册在培训网站上被禁用。在 <a href="https://cumulus.care/sign-up">生产站点</a> 上注册，您的帐户将在 10 分钟内同步到培训站点。`,
    "zh-hant": $2868cc1235412e16$var$html`新帳戶註冊在培訓網站上被禁用。在 <a href="https://cumulus.care/sign-up">生產網站</a> 上註冊，您的帳戶將在 10 分鐘內同步到培訓網站。`,
    en: $2868cc1235412e16$var$html`New account registration is disabled on the training site. Sign up on the <a href="https://cumulus.care/sign-up">production site</a> and your account will be synchronized to the training site within ten minutes.`
};
const $2868cc1235412e16$export$e2256549c43609c6 = {
    ar: $2868cc1235412e16$var$html`<span class="text-bold">هذا الموقع لأغراض التدريب فقط.</span> ارجع إلى <a href="/docs/training-site">الوثائق</a> للحصول على مزيد من المعلومات أو انتقل إلى <a href="https://cumulus.care/">موقع الإنتاج</a>.`,
    de: $2868cc1235412e16$var$html`<span class="text-bold">Diese Website dient nur zu Schulungszwecken.</span> Weitere Informationen finden Sie in der <a href="/docs/training-site">Dokumentation</a> oder am <a href="https://cumulus.care/">Produktionsstandort</a>.`,
    es: $2868cc1235412e16$var$html`<span class="text-bold">Este sitio es solo para fines de capacitación.</span> Consulte la <a href="/docs/training-site">documentación</a> para obtener más información o vaya al sitio de <a href="https://cumulus.care/">producción</a>.`,
    fa: $2868cc1235412e16$var$html`<span class="text-bold">این سایت فقط برای اهداف آموزشی است.</span> برای اطلاعات بیشتر به <a href="/docs/training-site">مستندات</a> مراجعه کنید یا به <a href="https://cumulus.care/">سایت تولید</a> بروید.`,
    fil: $2868cc1235412e16$var$html`<span class="text-bold">Ang site na ito ay para sa mga layunin ng pagsasanay lamang.</span> Sumangguni sa <a href="/docs/training-site">dokumentasyon</a> para sa karagdagang impormasyon o pumunta sa <a href="https://cumulus.care/">site ng produksyon</a>.`,
    fr: $2868cc1235412e16$var$html`<span class="text-bold">Ce site est uniquement destiné à des fins de formation.</span> Reportez-vous à la <a href="/docs/training-site">documentation</a> pour plus d’informations ou rendez-vous sur le <a href="https://cumulus.care/">site de production</a>.`,
    hi: $2868cc1235412e16$var$html`<span class="text-bold">यह साइट केवल प्रशिक्षण उद्देश्यों के लिए है।</span> अधिक जानकारी के लिए <a href="/docs/training-site">दस्तावेज़ीकरण</a> देखें या <a href="https://cumulus.care/">उत्पादन साइट</a> पर जाएं।`,
    ht: $2868cc1235412e16$var$html`<span class="text-bold">Sit sa a se pou rezon fòmasyon sèlman.</span> Gade nan <a href="/docs/training-site">dokiman</a> an pou plis enfòmasyon oswa ale nan <a href="https://cumulus.care/">sit pwodiksyon</a> an.`,
    it: $2868cc1235412e16$var$html`<span class="text-bold">Questo sito è solo a scopo formativo.</span> Per ulteriori informazioni, consultare la <a href="/docs/training-site">documentazione</a> o visitare il <a href="https://cumulus.care/">sito di produzione</a>.`,
    ja: $2868cc1235412e16$var$html`<span class="text-bold">このサイトはトレーニングのみを目的としています。</span> 詳細については、 <a href="/docs/training-site">ドキュメント</a> を参照するか、 <a href="https://cumulus.care/">運用サイト</a>にアクセスしてください。`,
    ko: $2868cc1235412e16$var$html`<span class="text-bold">이 사이트는 교육 목적으로만 사용됩니다.</span> 자세한 내용은 <a href="/docs/training-site">설명서를</a> 참조하거나 <a href="https://cumulus.care/">프로덕션 사이트로</a> 이동합니다.`,
    mww: $2868cc1235412e16$var$html`<span class="text-bold">Qhov chaw no yog rau txoj kev kawm xwb.</span> Xa mus rau cov <a href="/docs/training-site">ntaub ntawv</a> yog xav paub ntxiv los yog mus rau qhov <a href="https://cumulus.care/">chaw ntau lawm</a>.`,
    ps: $2868cc1235412e16$var$html`<span class="text-bold">دا سایټ یوازې د روزنې د موخو لپاره دی.</span> د نورو معلوماتو لپاره <a href="/docs/training-site">اسنادو</a> ته مراجعه وکړئ یا <a href="https://cumulus.care/">د تولید ځای</a> ته لاړ شئ.`,
    pt: $2868cc1235412e16$var$html`<span class="text-bold">Este site é apenas para fins de treinamento.</span> Consulte a <a href="/docs/training-site">documentação</a> para obter mais informações ou vá para o <a href="https://cumulus.care/">local de produção</a>.`,
    "pt-pt": $2868cc1235412e16$var$html`<span class="text-bold">Este site é apenas para fins de formação.</span> Consulte a <a href="/docs/training-site">documentação</a> para obter mais informações ou vá para o <a href="https://cumulus.care/">local de produção</a>.`,
    ru: $2868cc1235412e16$var$html`<span class="text-bold">Этот сайт предназначен только для учебных целей.</span> Обратитесь к <a href="/docs/training-site">документации</a> для получения дополнительной информации или перейдите на <a href="https://cumulus.care/">производственную площадку</a>.`,
    sm: $2868cc1235412e16$var$html`<span class="text-bold">O lenei 'upega tafa'ilagi e mo na'o a'oa'oga fa'amoemoega.</span> Va'ai i le <a href="/docs/training-site">fa'amaumauga</a> mo nisi fa'amatalaga pe alu i le <a href="https://cumulus.care/">nofoaga o gaosiga</a>.`,
    so: $2868cc1235412e16$var$html`<span class="text-bold">This site is for training purposes is only.</span> Tixraac <a href="/docs/training-site">dukumentiyada</a> aad ka helayso macluumaad dheeraad ah ama tag <a href="https://cumulus.care/">goobta wax soo saarka</a>.`,
    th: $2868cc1235412e16$var$html`<span class="text-bold">เว็บไซต์นี้มีวัตถุประสงค์เพื่อการฝึกอบรมเท่านั้น</span> โปรดดู<a href="/docs/training-site">เอกสารประกอบ</a>สําหรับข้อมูลเพิ่มเติมหรือไปที่<a href="https://cumulus.care/">ไซต์การผลิต</a>`,
    ur: $2868cc1235412e16$var$html`<span class="text-bold">یہ سائٹ صرف تربیتی مقاصد کے لئے ہے.</span> مزید معلومات کے لئے <a href="/docs/training-site">دستاویزات</a> کا حوالہ دیں یا <a href="https://cumulus.care/">پروڈکشن سائٹ</a> پر جائیں.`,
    vi: $2868cc1235412e16$var$html`<span class="text-bold">Trang web này chỉ dành cho mục đích đào tạo.</span> Tham khảo <a href="/docs/training-site">tài liệu</a> để biết thêm thông tin hoặc truy cập <a href="https://cumulus.care/">trang web sản xuất</a>.`,
    "zh-hans": $2868cc1235412e16$var$html`<span class="text-bold">本网站仅用于培训目的。</span> 有关更多信息，请参阅 <a href="/docs/training-site">文档</a> 或转到 <a href="https://cumulus.care/">生产站点</a>。`,
    "zh-hant": $2868cc1235412e16$var$html`<span class="text-bold">本網站僅用於培訓目的。</span> 有關更多資訊，請參閱 <a href="/docs/training-site">文檔</a> 或轉到 <a href="https://cumulus.care/">生產網站</a>。`,
    en: $2868cc1235412e16$var$html`<span class="text-bold">This site is for training purposes only.</span> Refer to the <a href="/docs/training-site">documentation</a> for more information or go to the <a href="https://cumulus.care/">production site</a>.`
};
const $2868cc1235412e16$export$f6962c03b9511845 = {
    ar: (cumulus)=>`\u{645}\u{631}\u{62D}\u{628}\u{627} \u{628}\u{643}\u{645} \u{641}\u{64A} \u{645}\u{648}\u{642}\u{639} \u{62A}\u{62F}\u{631}\u{64A}\u{628} ${cumulus} !`,
    de: (cumulus)=>`Willkommen auf der ${cumulus} !`,
    es: (cumulus)=>`\xa1Bienvenidos al sitio de entrenamiento de ${cumulus} !`,
    fa: (cumulus)=>`\u{628}\u{647} \u{633}\u{627}\u{6CC}\u{62A} \u{622}\u{645}\u{648}\u{632}\u{634} ${cumulus} \u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{62F}!`,
    fil: (cumulus)=>`Maligayang pagdating sa site ng pagsasanay ${cumulus} !`,
    fr: (cumulus)=>`Bienvenue sur le site de formation ${cumulus} !`,
    hi: (cumulus)=>`${cumulus} \u{92A}\u{94D}\u{930}\u{936}\u{93F}\u{915}\u{94D}\u{937}\u{923} \u{938}\u{93E}\u{907}\u{91F} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{93E} \u{938}\u{94D}\u{935}\u{93E}\u{917}\u{924} \u{939}\u{948}!`,
    ht: (cumulus)=>`Byenveni nan sit la F\xf2masyon ${cumulus} !`,
    it: (cumulus)=>`Benvenuti nel sito di formazione ${cumulus} !`,
    ja: (cumulus)=>`${cumulus} \u{30C8}\u{30EC}\u{30FC}\u{30CB}\u{30F3}\u{30B0}\u{30B5}\u{30A4}\u{30C8}\u{3078}\u{3088}\u{3046}\u{3053}\u{305D}!`,
    ko: (cumulus)=>`${cumulus} \u{AD50}\u{C721} \u{C0AC}\u{C774}\u{D2B8}\u{C5D0} \u{C624}\u{C2E0} \u{AC83}\u{C744} \u{D658}\u{C601}\u{D569}\u{B2C8}\u{B2E4}!`,
    mww: (cumulus)=>`Txais ${cumulus} kawm site!`,
    ps: (cumulus)=>`\u{62F} ${cumulus} \u{631}\u{648}\u{632}\u{646}\u{6D0} \u{681}\u{627}\u{6CC} \u{62A}\u{647} \u{69A}\u{647} \u{631}\u{627}\u{63A}\u{644}\u{627}\u{633}\u{62A}!`,
    pt: (cumulus)=>`Bem-vindo ao site de treinamento ${cumulus} !`,
    "pt-pt": (cumulus)=>`Bem-vindo ao site de forma\xe7\xe3o ${cumulus} !`,
    ru: (cumulus)=>`\u{414}\u{43E}\u{431}\u{440}\u{43E} \u{43F}\u{43E}\u{436}\u{430}\u{43B}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43D}\u{430} \u{43E}\u{431}\u{443}\u{447}\u{430}\u{44E}\u{449}\u{438}\u{439} \u{441}\u{430}\u{439}\u{442} ${cumulus} !`,
    sm: (cumulus)=>`Fa'afeiloa'i i le 'upega tafa'ilagi a'oa'oga ${cumulus} !`,
    so: (cumulus)=>`Ku soo dhawow goobta tababarka ${cumulus} ah!`,
    th: (cumulus)=>`\u{E22}\u{E34}\u{E19}\u{E14}\u{E35}\u{E15}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E31}\u{E1A}\u{E2A}\u{E39}\u{E48}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}\u{E1D}\u{E36}\u{E01}\u{E2D}\u{E1A}\u{E23}\u{E21} ${cumulus} !`,
    ur: (cumulus)=>`${cumulus} \u{62A}\u{631}\u{628}\u{6CC}\u{62A}\u{6CC} \u{633}\u{627}\u{626}\u{679} \u{645}\u{6CC}\u{6BA} \u{62E}\u{648}\u{634} \u{622}\u{645}\u{62F}\u{6CC}\u{62F}!`,
    vi: (cumulus)=>`Ch\xe0o m\u{1EEB}ng b\u{1EA1}n \u{111}\u{1EBF}n v\u{1EDB}i trang web \u{111}\xe0o t\u{1EA1}o ${cumulus} !`,
    "zh-hans": (cumulus)=>`\u{6B22}\u{8FCE}\u{6765}\u{5230} ${cumulus} \u{57F9}\u{8BAD}\u{7F51}\u{7AD9}\u{FF01}`,
    "zh-hant": (cumulus)=>`\u{6B61}\u{8FCE}\u{4F86}\u{5230} ${cumulus} \u{57F9}\u{8A13}\u{7DB2}\u{7AD9}\u{FF01}`,
    en: (cumulus)=>`Welcome to the ${cumulus} training site!`
};
const $2868cc1235412e16$export$20662d46cbc0efe7 = {
    ar: `\u{623}\u{641}\u{647}\u{645}`,
    de: `Ich verstehe`,
    es: `Entiendo`,
    fa: `\u{645}\u{6CC}\u{200C}\u{641}\u{647}\u{645}\u{645}`,
    fil: `Naiintindihan ko`,
    fr: `Je comprends`,
    hi: `\u{92E}\u{941}\u{91D}\u{947} \u{938}\u{92E}\u{91D} \u{906} \u{930}\u{939}\u{93E} \u{939}\u{948}`,
    ht: `Mwen konprann`,
    it: `Capisco`,
    ja: `\u{5206}\u{304B}\u{308A}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C774}\u{D574}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: `Kuv nkag siab`,
    ps: `\u{632}\u{647} \u{67E}\u{648}\u{647}\u{6D0}\u{696}\u{645}`,
    pt: `Eu entendo`,
    "pt-pt": `Eu entendo`,
    ru: `\u{42F} \u{43F}\u{43E}\u{43D}\u{438}\u{43C}\u{430}\u{44E}`,
    sm: `Oute malamalama`,
    so: `Waan ku fahmaa`,
    th: `\u{E09}\u{E31}\u{E19}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E08}`,
    ur: `\u{645}\u{64A}\u{6BA} \u{633}\u{645}\u{62C}\u{6BE} \u{633}\u{6A9}\u{62A}\u{6CC} \u{6C1}\u{648}\u{6BA}`,
    vi: `T\xf4i hi\u{1EC3}u`,
    "zh-hans": `\u{6211}\u{7406}\u{89E3}`,
    "zh-hant": `\u{6211}\u{7406}\u{89E3}`,
    en: `I understand`
};
const $2868cc1235412e16$export$a059c6be0ddd76be = {
    ar: `\u{645}\u{648}\u{642}\u{639} \u{627}\u{644}\u{625}\u{646}\u{62A}\u{627}\u{62C}`,
    de: `Produktionsort`,
    es: `Planta de producci\xf3n`,
    fa: `\u{633}\u{627}\u{6CC}\u{62A} \u{62A}\u{648}\u{644}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Site de production`,
    hi: `\u{909}\u{924}\u{94D}\u{92A}\u{93E}\u{926}\u{928} \u{938}\u{94D}\u{925}\u{932}`,
    ht: `Sit Pwodiksyon`,
    it: `Sito produttivo`,
    ja: `\u{751F}\u{7523}\u{62E0}\u{70B9}`,
    ko: `\u{C0DD}\u{C0B0} \u{D604}\u{C7A5}`,
    mww: `Ntau lawm qhov chaw`,
    ps: `\u{62F} \u{62A}\u{648}\u{644}\u{6CC}\u{62F} \u{681}\u{627}\u{6CC}`,
    pt: `Local de produ\xe7\xe3o`,
    "pt-pt": `Local de produ\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{43E}\u{438}\u{437}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43B}\u{43E}\u{449}\u{430}\u{434}\u{43A}\u{430}`,
    sm: `Nofoaga o gaosiga`,
    so: `Goobta wax soo saarka`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E25}\u{E34}\u{E15}`,
    ur: `\u{67E}\u{6CC}\u{62F}\u{627}\u{648}\u{627}\u{631} \u{6A9}\u{6CC} \u{62C}\u{6AF}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a \u{111}i\u{1EC3}m s\u{1EA3}n xu\u{1EA5}t`,
    "zh-hans": `\u{751F}\u{4EA7}\u{73B0}\u{573A}`,
    "zh-hant": `\u{751F}\u{7522}\u{73FE}\u{5834}`,
    en: `Production site`
};
const $2868cc1235412e16$export$aaee57b9a7bca4d4 = {
    ar: `\u{627}\u{633}\u{62A}\u{643}\u{634}\u{641}`,
    de: `Erforschen`,
    es: `Explorar`,
    fa: `\u{6A9}\u{634}\u{641}`,
    fil: `Galugarin`,
    fr: `Explorer`,
    hi: `\u{92A}\u{924}\u{93E} \u{932}\u{917}\u{93E}\u{928}\u{93E}`,
    ht: `Eksplore`,
    it: `Esplorare`,
    ja: `\u{63A2}\u{308B}`,
    ko: `\u{D0D0}\u{D5D8}\u{D558}\u{B2E4}`,
    mww: `Tshawb xyuas`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Explorar`,
    "pt-pt": `Explorar`,
    ru: `\u{418}\u{441}\u{441}\u{43B}\u{435}\u{434}\u{43E}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Su'esu'e`,
    so: `Baadh`,
    th: `\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08}`,
    ur: `\u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Kh\xe1m ph\xe1`,
    "zh-hans": `\u{63A2}\u{8BA8}`,
    "zh-hant": `\u{63A2}\u{8A0E}`,
    en: `Explore`
};
const $2868cc1235412e16$export$58fcd031c5120426 = {
    ar: `\u{627}\u{62D}\u{635}\u{644} \u{639}\u{644}\u{649} \u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Mehr Informationen`,
    es: `M\xe1s informaci\xf3n`,
    fa: `\u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{628}\u{6CC}\u{634}\u{62A}\u{631} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Kumuha ng karagdagang impormasyon`,
    fr: `Obtenir plus d\u{2019}informations`,
    hi: `\u{905}\u{927}\u{93F}\u{915} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Jwenn plis enf\xf2masyon`,
    it: `Richiedi maggiori informazioni`,
    ja: `\u{8A73}\u{7D30}\u{60C5}\u{5831}`,
    ko: `\u{C790}\u{C138}\u{D55C} \u{C815}\u{BCF4} \u{C5BB}\u{AE30}`,
    mww: `Yog xav paub ntxiv`,
    ps: `\u{62F} \u{646}\u{648}\u{631}\u{648} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}\u{648} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Obtenha mais informa\xe7\xf5es`,
    "pt-pt": `Obtenha mais informa\xe7\xf5es`,
    ru: `\u{41F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{434}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{443}\u{44E} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44E}`,
    sm: `Maua nisi fa'amatalaga`,
    so: `Hel macluumaad dheeraad ah`,
    th: `\u{E14}\u{E39}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E15}\u{E34}\u{E21}`,
    ur: `\u{645}\u{632}\u{6CC}\u{62F} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Xem th\xeam th\xf4ng tin`,
    "zh-hans": `\u{83B7}\u{53D6}\u{66F4}\u{591A}\u{4FE1}\u{606F}`,
    "zh-hant": `\u{7372}\u{53D6}\u{66F4}\u{591A}\u{8CC7}\u{8A0A}`,
    en: `Get more information`
};
const $2868cc1235412e16$export$20bb97b417f71755 = {
    ar: `\u{627}\u{630}\u{647}\u{628} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Zur Veranstaltung`,
    es: `Ir al evento`,
    fa: `\u{628}\u{647} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{628}\u{631}\u{648}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Aller \xe0 l\u{2019}\xe9v\xe9nement`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{915}\u{94D}\u{930}\u{92E} \u{92A}\u{930} \u{91C}\u{93E}\u{90F}\u{901}`,
    ht: `Ale nan ev\xe8nman`,
    it: `Vai all'evento`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306B}\u{79FB}\u{52D5}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8} \u{BC14}\u{B85C}\u{AC00}\u{AE30}`,
    mww: `Mus kev tshwm sim`,
    ps: `\u{627}\u{6CC}\u{648}\u{646}\u{67C} \u{62A}\u{647} \u{644}\u{627}\u{693} \u{634}\u{626}`,
    pt: `Ir para o evento`,
    "pt-pt": `Ir para o evento`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{43A} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44E}`,
    sm: `Alu i le mea na tupu`,
    so: `Tag dhacdo`,
    th: `\u{E44}\u{E1B}\u{E17}\u{E35}\u{E48}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{62A}\u{642}\u{631}\u{6CC}\u{628} \u{645}\u{6CC}\u{6BA} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `\u{110}i \u{111}\u{1EBF}n s\u{1EF1} ki\u{1EC7}n`,
    "zh-hans": `\u{524D}\u{5F80}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{524D}\u{5F80}\u{6D3B}\u{52D5}`,
    en: `Go to event`
};
const $2868cc1235412e16$export$e6992f8339cfa0f6 = {
    ar: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">أضف ${activityTitle}</a> إلى <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    de: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Fügen Sie eine weitere ${activityTitle}</a> zur <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> hinzu.`,
    es: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Agregue otra ${activityTitle}</a> al <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    fa: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">یک ${activityTitle} دیگر</a> را به <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> اضافه کنید.`,
    fil: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Magdagdag ng isa pang ${activityTitle}</a> sa <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    fr: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Ajoutez un autre ${activityTitle}</a> à l’événement <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    hi: (parentHref, parentActivityTitle, addNextHref, activityTitle)=>$2868cc1235412e16$var$html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> में <a class="text-bold" href="${addNextHref}">एक और ${activityTitle} जोड़ें</a>।`,
    ht: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Ajoute yon lòt ${activityTitle}</a> nan <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    it: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Aggiungi un altro ${activityTitle}</a> <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    ja: (parentHref, parentActivityTitle, addNextHref, activityTitle)=>$2868cc1235412e16$var$html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>に<a class="text-bold" href="${addNextHref}">別の${activityTitle}を追加します</a>。`,
    ko: (parentHref, parentActivityTitle, addNextHref, activityTitle)=>$2868cc1235412e16$var$html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>에 <a class="text-bold" href="${addNextHref}">${activityTitle}를 추가합니다</a>.`,
    mww: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Ntxiv lwm ${activityTitle}</a> rau <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    ps: (parentHref, parentActivityTitle, addNextHref, activityTitle)=>$2868cc1235412e16$var$html`په <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> کې <a class="text-bold" href="${addNextHref}">د ${activityTitle}</a> اضافه کړئ.`,
    pt: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Adicione outra ${activityTitle}</a> ao <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    "pt-pt": (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Adicione outra ${activityTitle}</a> ao <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    ru: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Добавьте еще один ${activityTitle}</a> в <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    sm: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Fa'aopopo se isi ${activityTitle}</a> i le <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    so: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Ku dar ${activityTitle}</a> ah <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    th: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">เพิ่ม${activityTitle}อีกครั้งใน</a><a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>`,
    ur: (parentHref, parentActivityTitle, addNextHref, activityTitle)=>$2868cc1235412e16$var$html`<a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a> <a class="text-bold" href="${addNextHref}">ایک اور ${activityTitle} شامل کریں</a>۔`,
    vi: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Thêm một ${activityTitle} khác</a> vào <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`,
    "zh-hans": (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">将另一个${activityTitle}添加到</a><a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>中。`,
    "zh-hant": (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">將另一個${activityTitle}添加到</a><a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>中。`,
    en: (addNextHref, activityTitle, parentHref, parentActivityTitle)=>$2868cc1235412e16$var$html`<a class="text-bold" href="${addNextHref}">Add another ${activityTitle}</a> to <a href="${parentHref}" class="Link--primary">${parentActivityTitle}</a>.`
};
const $2868cc1235412e16$export$3638f35b5780d612 = {
    ar: `\u{627}\u{646}\u{634}\u{627}\u{621}`,
    de: `Erstellt`,
    es: `Creado`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F}`,
    fil: `Nilikha`,
    fr: `Cr\xe9\xe9`,
    hi: `\u{92C}\u{928}\u{93E}\u{92F}\u{93E}`,
    ht: `Te kreye`,
    it: `Creato`,
    ja: `\u{4F5C}\u{6210}`,
    ko: `\u{B9CC}\u{B4E0}`,
    mww: `Tsim`,
    ps: `\u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado`,
    "pt-pt": `Criado`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `Foafoaina`,
    so: `Wuxuu abuuray`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{628}\u{646}\u{627}\u{626}\u{6CC}`,
    vi: `T\u{1EA1}o`,
    "zh-hans": `\u{521B}\u{5EFA}`,
    "zh-hant": `\u{5275}\u{5EFA}`,
    en: `Created`
};
const $2868cc1235412e16$export$d1befcb33b768152 = {
    ar: `\u{627}\u{648}\u{635}\u{62A}`,
    de: `Empfohlen`,
    es: `Recomendado`,
    fa: `\u{62A}\u{648}\u{635}\u{6CC}\u{647}`,
    fil: `Inirerekumenda`,
    fr: `Recommand\xe9`,
    hi: `\u{905}\u{928}\u{941}\u{936}\u{902}\u{938}\u{93F}\u{924}`,
    ht: `Rek\xf2mande`,
    it: `Raccomandato`,
    ja: `\u{63A8}\u{5968}`,
    ko: `\u{AD8C}\u{C7A5}`,
    mww: `pom zoo`,
    ps: `\u{633}\u{67E}\u{627}\u{631}\u{69A}\u{62A}\u{646}\u{647}`,
    pt: `Recomendado`,
    "pt-pt": `Recomendado`,
    ru: `\u{420}\u{435}\u{43A}\u{43E}\u{43C}\u{435}\u{43D}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `Fautuaina`,
    so: `Talinayo`,
    th: `\u{E41}\u{E19}\u{E30} \u{E19}\u{E33}`,
    ur: `\u{62A}\u{62C}\u{648}\u{6CC}\u{632}`,
    vi: `Khuy\u{1EBF}n c\xe1o`,
    "zh-hans": `\u{63A8}\u{8350}`,
    "zh-hant": `\u{63A8}\u{85A6}`,
    en: `Recommended`
};
const $2868cc1235412e16$export$bb1915d7c58e991 = {
    ar: `\u{623}\u{643}\u{62B}\u{631}`,
    de: `Mehr`,
    es: `M\xe1s`,
    fa: `\u{628}\u{6CC}\u{634}\u{62A}\u{631}`,
    fil: `Higit pa`,
    fr: `Plus`,
    hi: `\u{905}\u{927}\u{93F}\u{915}`,
    ht: `Plis`,
    it: `Pi\xf9`,
    ja: `\u{3082}\u{3063}\u{3068}\u{305D}\u{306E}`,
    ko: `\u{B354}`,
    mww: `Ntau`,
    ps: `\u{646}\u{648}\u{631}`,
    pt: `Mais`,
    "pt-pt": `Saber mais`,
    ru: `\u{411}\u{43E}\u{43B}\u{44C}\u{448}\u{435}`,
    sm: `Sili atu`,
    so: `Inbadan`,
    th: `\u{E2D}\u{E35}\u{E01}`,
    ur: `\u{632}\u{6CC}\u{627}\u{62F}\u{6C1}`,
    vi: `Nhi\u{1EC1}u h\u{1A1}n`,
    "zh-hans": `\u{66F4}\u{591A}`,
    "zh-hant": `\u{66F4}\u{591A}`,
    en: `More`
};
const $2868cc1235412e16$export$fb5986ba5dcfdda3 = {
    ar: `\u{627}\u{644}\u{631}\u{62C}\u{648}\u{639} \u{644}\u{644}\u{62E}\u{644}\u{641}`,
    de: `Zur\xfcck`,
    es: `Volver`,
    fa: `\u{628}\u{631}\u{6AF}\u{631}\u{62F}`,
    fil: `Bumalik`,
    fr: `Retour`,
    hi: `\u{92A}\u{938} \u{91C}\u{93E}\u{913}`,
    ht: `Tounen`,
    it: `Indietro`,
    ja: `\u{623B}\u{3063}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`,
    ko: `\u{B3CC}\u{C544} \u{AC00}`,
    mww: `Mus rov qab`,
    ps: `\u{628}\u{6CC}\u{631}\u{62A}\u{647} \u{644}\u{627}\u{693} \u{634}\u{647}`,
    pt: `Voltar`,
    "pt-pt": `Volta`,
    ru: `\u{412}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}\u{441}\u{44F}`,
    sm: `Toe fo'i`,
    so: `Soo laabo`,
    th: `\u{E22}\u{E49}\u{E2D}\u{E19}\u{E01}\u{E25}\u{E31}\u{E1A}`,
    ur: `\u{648}\u{627}\u{67E}\u{633} \u{62C}\u{627}\u{624}`,
    vi: `Quay l\u{1EA1}i`,
    "zh-hans": `\u{56DE}\u{53BB}`,
    "zh-hant": `\u{56DE}\u{53BB}`,
    en: `Go back`
};
const $2868cc1235412e16$export$9f1bef56f6a3904b = {
    ar: `\u{627}\u{62F}\u{627}\u{621}`,
    de: `Leistung`,
    es: `Rendimiento`,
    fa: `\u{639}\u{645}\u{644}\u{6A9}\u{631}\u{62F}`,
    fil: `Pagganap`,
    fr: `Performance`,
    hi: `\u{92A}\u{94D}\u{930}\u{926}\u{930}\u{94D}\u{936}\u{928}`,
    ht: `P\xe8f\xf2mans`,
    it: `Prestazione`,
    ja: `\u{30D1}\u{30D5}\u{30A9}\u{30FC}\u{30DE}\u{30F3}\u{30B9}`,
    ko: `\u{ACF5}\u{C5F0}`,
    mww: `Kev Kawm Txog Yam Xeeb`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Desempenho`,
    "pt-pt": `Desempenho`,
    ru: `\u{41F}\u{440}\u{43E}\u{438}\u{437}\u{432}\u{43E}\u{434}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Fa'atinoga`,
    so: `Performance`,
    th: `\u{E01}\u{E32}\u{E23}\u{E41}\u{E2A}\u{E14}\u{E07}`,
    ur: `\u{6A9}\u{627}\u{631}\u{6A9}\u{631}\u{62F}\u{6AF}\u{6CC}`,
    vi: `Hi\u{1EC7}u n\u{103}ng`,
    "zh-hans": `\u{6027}\u{80FD}`,
    "zh-hant": `\u{6027}\u{80FD}`,
    en: `Performance`
};
const $2868cc1235412e16$export$12cf1b7764815e0f = {
    ar: `\u{62D}\u{627}\u{644}\u{629}`,
    de: `Status`,
    es: `Estado`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    fil: `Katayuan`,
    fr: `Statut`,
    hi: `\u{913}\u{939}\u{926}\u{93E}`,
    ht: `Estati`,
    it: `Stato`,
    ja: `\u{5730}\u{4F4D}`,
    ko: `\u{C0C1}\u{D0DC}`,
    mww: `txheej xwm`,
    ps: `\u{648}\u{636}\u{639}\u{6CC}\u{62A}`,
    pt: `Estado`,
    "pt-pt": `Situa\xe7\xe3o`,
    ru: `\u{421}\u{442}\u{430}\u{442}\u{443}\u{441}`,
    sm: `Tulaga`,
    so: `Status`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}`,
    ur: `\u{67E}\u{627}\u{6CC}\u{6C1}`,
    vi: `T\xecnh tr\u{1EA1}ng`,
    "zh-hans": `\u{5730}\u{4F4D}`,
    "zh-hant": `\u{5730}\u{4F4D}`,
    en: `Status`
};
const $2868cc1235412e16$export$7b385c33eaf64565 = {
    ar: `\u{646}\u{634}\u{627}\u{637}`,
    de: `Aktivit\xe4t`,
    es: `Actividad`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `Aktibidad`,
    fr: `Activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `Aktivite`,
    it: `Attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}`,
    ko: `\u{D65C}\u{B3D9}`,
    mww: `kev ua ub no`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Atividade`,
    "pt-pt": `Atividade`,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Gaoioiga`,
    so: `Waxqabad`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{6D3B}\u{52D5}`,
    en: `Activity`
};
const $2868cc1235412e16$export$d66da69c1b21f144 = {
    ar: `\u{62E}\u{627}\u{644}\u{642}`,
    de: `Sch\xf6pfer`,
    es: `Creador`,
    fa: `\u{62E}\u{627}\u{644}\u{642}`,
    fil: `Lumikha`,
    fr: `Cr\xe9ateur`,
    hi: `\u{938}\u{943}\u{91C}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Kreyat\xe8`,
    it: `Creatore`,
    ja: `\u{9020}\u{7269}\u{4E3B}`,
    ko: `\u{CC3D}\u{C870}\u{C790}`,
    mww: `Tswv tsim`,
    ps: `\u{62E}\u{627}\u{644}\u{642}`,
    pt: `Criador`,
    "pt-pt": `Criador`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Foafoa`,
    so: `abuuraha`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62E}\u{627}\u{644}\u{642}`,
    vi: `Ng\u{1B0}\u{1EDD}i s\xe1ng t\u{1EA1}o`,
    "zh-hans": `\u{9020}\u{7269}\u{4E3B}`,
    "zh-hant": `\u{9020}\u{7269}\u{4E3B}`,
    en: `Creator`
};
const $2868cc1235412e16$export$6a34f8e82a464786 = {
    ar: `\u{64A}\u{630}\u{643}\u{631}`,
    de: `Erw\xe4hnungen`,
    es: `Menciona`,
    fa: `\u{627}\u{634}\u{627}\u{631}\u{647}`,
    fil: `Mga pagbanggit`,
    fr: `Mentionne`,
    hi: `\u{909}\u{932}\u{94D}\u{932}\u{947}\u{916}`,
    ht: `Mansyone`,
    it: `Cita`,
    ja: `\u{8A00}\u{53CA}`,
    ko: `\u{C5B8}\u{AE09}`,
    mww: `Pav`,
    ps: `\u{6CC}\u{627}\u{62F}\u{648}\u{646}\u{647}`,
    pt: `Menciona`,
    "pt-pt": `Men\xe7\xf5es`,
    ru: `\u{423}\u{43F}\u{43E}\u{43C}\u{438}\u{43D}\u{430}\u{435}\u{442}`,
    sm: `Ta'ua`,
    so: `ku xuso`,
    th: `\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{630}\u{6A9}\u{631}`,
    vi: `Mentions`,
    "zh-hans": `\u{63D0}\u{5230}`,
    "zh-hant": `\u{63D0}\u{5230}`,
    en: `Mentions`
};
const $2868cc1235412e16$export$199f6a9e175b2ff9 = {
    ar: `\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projekt`,
    es: `Proyecto`,
    fa: `\u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Proyekto`,
    fr: `Projet`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E}`,
    ht: `Pwoj\xe8`,
    it: `Progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8}`,
    mww: `peb tes num`,
    ps: `\u{67E}\u{631}\u{648}\u{698}\u{647}`,
    pt: `Projeto`,
    "pt-pt": `Projeto`,
    ru: `\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442}`,
    sm: `Galuega faatino`,
    so: `Mashruuca`,
    th: `\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{67E}\u{631}\u{627}\u{62C}\u{6CC}\u{6A9}\u{679}`,
    vi: `D\u{1EF1} \xe1n`,
    "zh-hans": `\u{9879}\u{76EE}`,
    "zh-hant": `\u{5C08}\u{6848}`,
    en: `Project`
};
const $2868cc1235412e16$export$c740e03774633827 = {
    ar: `\u{646}\u{648}\u{639}`,
    de: `Art`,
    es: `Tipo`,
    fa: `\u{646}\u{648}\u{639}`,
    fil: `Uri`,
    fr: `Type`,
    hi: `\u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930}`,
    ht: `Tip`,
    it: `Digitare`,
    ja: `\u{7A2E}\u{985E}`,
    ko: `\u{D615}`,
    mww: `Yam`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Tipo`,
    "pt-pt": `Tipo`,
    ru: `\u{422}\u{438}\u{43F}`,
    sm: `Ituaiga`,
    so: `Nooca`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}`,
    ur: `\u{642}\u{633}\u{645}`,
    vi: `Ki\u{1EC3}u`,
    "zh-hans": `\u{7C7B}\u{578B}`,
    "zh-hant": `\u{985E}\u{578B}`,
    en: `Type`
};
const $2868cc1235412e16$export$e68caf1d725bc48e = {
    ar: `\u{627}\u{644}\u{641}\u{644}\u{627}\u{62A}\u{631} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629}`,
    de: `Schnellfilter`,
    es: `Filtros r\xe1pidos`,
    fa: `\u{641}\u{6CC}\u{644}\u{62A}\u{631}\u{647}\u{627}\u{6CC} \u{633}\u{631}\u{6CC}\u{639}`,
    fil: `Mabilis na mga filter`,
    fr: `Filtres rapides`,
    hi: `\u{924}\u{94D}\u{935}\u{930}\u{93F}\u{924} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930}`,
    ht: `Filt\xe8 rapid`,
    it: `Filtri rapidi`,
    ja: `\u{30AF}\u{30A4}\u{30C3}\u{30AF}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}`,
    ko: `\u{BE60}\u{B978} \u{D544}\u{D130}`,
    mww: `lim dej`,
    ps: `\u{686}\u{67C}\u{6A9} \u{641}\u{644}\u{67C}\u{631}\u{648}\u{646}\u{647}`,
    pt: `Filtros r\xe1pidos`,
    "pt-pt": `Filtros r\xe1pidos`,
    ru: `\u{411}\u{44B}\u{441}\u{442}\u{440}\u{44B}\u{435} \u{444}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{44B}`,
    sm: `Faamama vave`,
    so: `filtarrada Quick`,
    th: `\u{E15}\u{E31}\u{E27}\u{E01}\u{E23}\u{E2D}\u{E07}\u{E14}\u{E48}\u{E27}\u{E19}`,
    ur: `\u{641}\u{648}\u{631}\u{6CC} \u{641}\u{644}\u{679}\u{631}\u{632}`,
    vi: `B\u{1ED9} l\u{1ECD}c nhanh`,
    "zh-hans": `\u{5FEB}\u{901F}\u{8FC7}\u{6EE4}\u{5668}`,
    "zh-hant": `\u{5FEB}\u{901F}\u{7BE9}\u{6AA2}\u{7A0B}\u{5F0F}`,
    en: `Quick filters`
};
const $2868cc1235412e16$export$3d47969f22871c3a = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `Aktivit\xe4t ausw\xe4hlen`,
    es: `Elegir actividad`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng aktibidad`,
    fr: `Choisissez l\u{2019}activit\xe9`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi aktivite`,
    it: `Scegli l'attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{D65C}\u{B3D9} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov kev ua ub no`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Escolha a atividade`,
    "pt-pt": `Escolha a atividade`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{437}\u{430}\u{43D}\u{44F}\u{442}\u{438}\u{435}`,
    sm: `Filifili gaoioiga`,
    so: `Dooro waxqabad`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{9009}\u{62E9}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{9078}\u{64C7}\u{6D3B}\u{52D5}`,
    en: `Choose activity`
};
const $2868cc1235412e16$export$2e5611c44d7e00ce = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{646}\u{648}\u{639}`,
    de: `Typ w\xe4hlen`,
    es: `Elegir tipo`,
    fa: `\u{646}\u{648}\u{639} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang uri`,
    fr: `Choisissez le type`,
    hi: `\u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kalite`,
    it: `Scegli il tipo`,
    ja: `\u{30BF}\u{30A4}\u{30D7}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{C720}\u{D615} \u{C120}\u{D0DD}`,
    mww: `Xaiv hom`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Escolha o tipo`,
    "pt-pt": `Escolha o tipo`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{438}\u{43F}`,
    sm: `Filifili le ituaiga`,
    so: `Dooro nooca`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}`,
    ur: `\u{642}\u{633}\u{645} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n lo\u{1EA1}i`,
    "zh-hans": `\u{9009}\u{62E9}\u{7C7B}\u{578B}`,
    "zh-hant": `\u{9078}\u{64C7}\u{985E}\u{578B}`,
    en: `Choose type`
};
const $2868cc1235412e16$export$d58c1dcaf781d61 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projekt ausw\xe4hlen`,
    es: `Elegir proyecto`,
    fa: `\u{67E}\u{631}\u{648}\u{698}\u{647} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang proyekto`,
    fr: `Choisissez un projet`,
    hi: `\u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi pwoj\xe8`,
    it: `Scegli il progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{C120}\u{D0DD}`,
    mww: `Xaiv yaam project`,
    ps: `\u{67E}\u{631}\u{648}\u{698}\u{647}`,
    pt: `Escolha o projeto`,
    "pt-pt": `Escolher projeto`,
    ru: `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}`,
    sm: `Filifili le galuega faatino`,
    so: `Dooro mashruuca`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n d\u{1EF1} \xe1n`,
    "zh-hans": `\u{9009}\u{62E9}\u{9879}\u{76EE}`,
    "zh-hant": `\u{9078}\u{64C7}\u{5C08}\u{6848}`,
    en: `Choose project`
};
const $2868cc1235412e16$export$adc83afbd0334463 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{631}\u{641}\u{642}\u{627}\u{62A}`,
    de: `Anh\xe4nge ausw\xe4hlen`,
    es: `Elegir archivos adjuntos`,
    fa: `\u{67E}\u{6CC}\u{648}\u{633}\u{62A} \u{647}\u{627} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng mga attachment`,
    fr: `Choisir les pi\xe8ces jointes`,
    hi: `\u{905}\u{928}\u{941}\u{932}\u{917}\u{94D}\u{928}\u{915} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi atachman`,
    it: `Scegli gli allegati`,
    ja: `\u{6DFB}\u{4ED8}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}`,
    ko: `\u{CCA8}\u{BD80} \u{D30C}\u{C77C} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov kev rhais nrog rau`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Escolha anexos`,
    "pt-pt": `Escolher anexos`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43D}\u{430}\u{432}\u{435}\u{441}\u{43D}\u{43E}\u{435} \u{43E}\u{431}\u{43E}\u{440}\u{443}\u{434}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Filifili mea fa'apipi'i`,
    so: `Dooro lifaaqyada`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E41}\u{E19}\u{E1A}`,
    ur: `\u{627}\u{679}\u{6CC}\u{686}\u{645}\u{646}\u{679} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n t\u{1EC7}p \u{111}\xednh k\xe8m`,
    "zh-hans": `\u{9009}\u{62E9}\u{9644}\u{4EF6}`,
    "zh-hant": `\u{9078}\u{64C7}\u{9644}\u{4EF6}`,
    en: `Choose attachments`
};
const $2868cc1235412e16$export$eebe030e6f9fc49 = {
    ar: `\u{635}\u{646}\u{641}`,
    de: `Sortieren`,
    es: `Ordenar`,
    fa: `\u{646}\u{648}\u{639}`,
    fil: `Ayusin`,
    fr: `Trier`,
    hi: `\u{91C}\u{93E}\u{924}\u{93F}`,
    ht: `Klase`,
    it: `Sorta`,
    ja: `\u{30BD}\u{30FC}\u{30C8}`,
    ko: `\u{C885}\u{B958}`,
    mww: `tsawm tsawv thiab`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{645}\u{644}\u{6CC} \u{627}\u{645}\u{646}\u{6CC}\u{62A} \u{631}\u{6CC}\u{627}\u{633}\u{62A} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{645}\u{644}\u{6CC} \u{627}\u{645}\u{646}\u{6CC}\u{62A}`,
    pt: `Ordenar`,
    "pt-pt": `Ordenar`,
    ru: `\u{421}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Fa'avasega`,
    so: `Kala sooc`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}`,
    ur: `\u{642}\u{633}\u{645}`,
    vi: `S\u{1EAF}p x\u{1EBF}p`,
    "zh-hans": `\u{6392}\u{5E8F}`,
    "zh-hant": `\u{6392}\u{5E8F}`,
    en: `Sort`
};
const $2868cc1235412e16$export$a6d146c40c1e2681 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{641}\u{631}\u{632}`,
    de: `Sortierung w\xe4hlen`,
    es: `Elegir ordenar`,
    fa: `\u{645}\u{631}\u{62A}\u{628} \u{633}\u{627}\u{632}\u{6CC} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang pag-uuri`,
    fr: `Choisir le tri`,
    hi: `\u{938}\u{949}\u{930}\u{94D}\u{91F} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi s\xf2t`,
    it: `Scegli l'ordinamento`,
    ja: `\u{30BD}\u{30FC}\u{30C8}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{C815}\u{B82C} \u{C120}\u{D0DD}`,
    mww: `Xaiv tsawm tsawv thiab`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{645}\u{644}\u{6CC} \u{627}\u{645}\u{646}\u{6CC}\u{62A} \u{631}\u{6CC}\u{627}\u{633}\u{62A} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{645}\u{644}\u{6CC} \u{627}\u{645}\u{646}\u{6CC}\u{62A}`,
    pt: `Escolha classificar`,
    "pt-pt": `Escolher ordena\xe7\xe3o`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{43A}\u{443}`,
    sm: `Filifili le fa'avasegaina`,
    so: `Dooro sort`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E08}\u{E31}\u{E14}\u{E40}\u{E23}\u{E35}\u{E22}\u{E07}`,
    ur: `\u{642}\u{633}\u{645} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n s\u{1EAF}p x\u{1EBF}p`,
    "zh-hans": `\u{9009}\u{62E9} sort`,
    "zh-hant": `\u{9078}\u{64C7} sort`,
    en: `Choose sort`
};
const $2868cc1235412e16$export$765b926830e4f6a5 = {
    ar: `\u{623}\u{642}\u{631}\u{628} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621}`,
    de: `Fr\xfchester Starttermin`,
    es: `Fecha de inicio m\xe1s temprana`,
    fa: `\u{627}\u{648}\u{644}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639}`,
    fil: `Pinakamaagang petsa ng pagsisimula`,
    fr: `Date de d\xe9but au plus t\xf4t`,
    hi: `\u{91C}\u{932}\u{94D}\u{926} \u{938}\u{947} \u{91C}\u{932}\u{94D}\u{926} \u{936}\u{941}\u{930}\u{942} \u{939}\u{94B}\u{928}\u{947} \u{915}\u{940} \u{924}\u{93E}\u{930}\u{940}\u{916}`,
    ht: `Dat k\xf2mansman pi bon\xe8`,
    it: `Prima data di inizio`,
    ja: `\u{6700}\u{3082}\u{65E9}\u{3044}\u{958B}\u{59CB}\u{65E5}`,
    ko: `\u{AC00}\u{C7A5} \u{BE60}\u{B978} \u{C2DC}\u{C791} \u{B0A0}\u{C9DC}`,
    mww: `Hnub pib ua ntej pib`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} \u{62A}\u{631} \u{67C}\u{648}\u{644}\u{648} \u{644}\u{648}\u{645}\u{693}\u{646}\u{6CD} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de in\xedcio mais pr\xf3xima`,
    "pt-pt": `Data de in\xedcio mais antiga`,
    ru: `\u{421}\u{430}\u{43C}\u{430}\u{44F} \u{440}\u{430}\u{43D}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    sm: `Aso amata muamua`,
    so: `Taariikhda biloowga hore`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E40}\u{E23}\u{E47}\u{E27}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{622}\u{63A}\u{627}\u{632} \u{6A9}\u{6CC} \u{627}\u{628}\u{62A}\u{62F}\u{627}\u{626}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u s\u{1EDB}m nh\u{1EA5}t`,
    "zh-hans": `\u{6700}\u{65E9}\u{7684}\u{5F00}\u{59CB}\u{65E5}\u{671F}`,
    "zh-hant": `\u{6700}\u{65E9}\u{7684}\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    en: `Earliest start date`
};
const $2868cc1235412e16$export$10c6e283027663f4 = {
    ar: `\u{622}\u{62E}\u{631} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621}`,
    de: `Sp\xe4tester Starttermin`,
    es: `\xdaltima fecha de inicio`,
    fa: `\u{622}\u{62E}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639}`,
    fil: `Pinakabagong petsa ng pagsisimula`,
    fr: `Date de d\xe9but au plus tard`,
    hi: `\u{928}\u{935}\u{940}\u{928}\u{924}\u{92E} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}`,
    ht: `D\xe8nye dat k\xf2manse`,
    it: `Ultima data di inizio`,
    ja: `\u{6700}\u{3082}\u{9045}\u{3044}\u{958B}\u{59CB}\u{65E5}`,
    ko: `\u{AC00}\u{C7A5} \u{B2A6}\u{C740} \u{C2DC}\u{C791} \u{B0A0}\u{C9DC}`,
    mww: `Tseeb pib hnub`,
    ps: `\u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC} \u{67E}\u{6CC}\u{644} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de in\xedcio mais recente`,
    "pt-pt": `Data de in\xedcio mais recente`,
    ru: `\u{41F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430}`,
    sm: `Aso amata lata mai`,
    so: `Taariikhda cusub ee ugu dambeysa`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{622}\u{63A}\u{627}\u{632} \u{6A9}\u{6CC} \u{62A}\u{627}\u{632}\u{6C1} \u{62A}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u mu\u{1ED9}n nh\u{1EA5}t`,
    "zh-hans": `\u{6700}\u{665A}\u{5F00}\u{59CB}\u{65E5}\u{671F}`,
    "zh-hant": `\u{6700}\u{665A}\u{958B}\u{59CB}\u{65E5}\u{671F}`,
    en: `Latest start date`
};
const $2868cc1235412e16$export$68ee5e97498a5881 = {
    ar: `\u{623}\u{642}\u{631}\u{628} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    de: `Fr\xfchestes Enddatum`,
    es: `Fecha de finalizaci\xf3n m\xe1s temprana`,
    fa: `\u{627}\u{648}\u{644}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Pinakamaagang petsa ng pagtatapos`,
    fr: `Date de fin la plus proche`,
    hi: `\u{91C}\u{932}\u{94D}\u{926} \u{938}\u{947} \u{91C}\u{932}\u{94D}\u{926} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{924}\u{93F}\u{925}\u{93F}`,
    ht: `Dat fen pi bon\xe8`,
    it: `Prima data di fine`,
    ja: `\u{6700}\u{3082}\u{65E9}\u{3044}\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{AC00}\u{C7A5} \u{BE60}\u{B978} \u{C885}\u{B8CC} \u{B0A0}\u{C9DC}`,
    mww: `Hnub xaus rau hnub kawg`,
    ps: `\u{62A}\u{631} \u{67C}\u{648}\u{644}\u{648} \u{644}\u{648}\u{645}\u{693}\u{646}\u{6CC} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de t\xe9rmino mais pr\xf3xima`,
    "pt-pt": `Data de fim mais antiga`,
    ru: `\u{421}\u{430}\u{43C}\u{430}\u{44F} \u{440}\u{430}\u{43D}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso fa'amutaina muamua`,
    so: `Taariikhda dhamaadka hore`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E40}\u{E23}\u{E47}\u{E27}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{633}\u{628} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y k\u{1EBF}t th\xfac s\u{1EDB}m nh\u{1EA5}t`,
    "zh-hans": `\u{6700}\u{65E9}\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "zh-hant": `\u{6700}\u{65E9}\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Earliest end date`
};
const $2868cc1235412e16$export$86b7c879f7775f06 = {
    ar: `\u{622}\u{62E}\u{631} \u{62A}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    de: `Sp\xe4testes Enddatum`,
    es: `\xdaltima fecha de finalizaci\xf3n`,
    fa: `\u{622}\u{62E}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Pinakabagong petsa ng pagtatapos`,
    fr: `Date de fin au plus tard`,
    hi: `\u{928}\u{935}\u{940}\u{928}\u{924}\u{92E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}`,
    ht: `D\xe8nye dat fen`,
    it: `Ultima data di fine`,
    ja: `\u{6700}\u{3082}\u{9045}\u{3044}\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{AC00}\u{C7A5} \u{B2A6}\u{C740} \u{C885}\u{B8CC} \u{B0A0}\u{C9DC}`,
    mww: `Tseeb hnub kawg`,
    ps: `\u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{647}`,
    pt: `Data de t\xe9rmino mais recente`,
    "pt-pt": `Data de fim mais recente`,
    ru: `\u{41F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{44F}\u{44F} \u{434}\u{430}\u{442}\u{430} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso lata mai e faamuta ai`,
    so: `Taariikhda dhamaadka Latest`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{632}\u{6C1} \u{62A}\u{631}\u{6CC}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y k\u{1EBF}t th\xfac mu\u{1ED9}n nh\u{1EA5}t`,
    "zh-hans": `\u{6700}\u{665A}\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "zh-hant": `\u{6700}\u{665A}\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Latest end date`
};
const $2868cc1235412e16$export$7e0f74c500a6d00 = {
    ar: `\u{62A}\u{645} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `K\xfcrzlich aktualisiert`,
    es: `Actualizado recientemente`,
    fa: `\u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{628}\u{647} \u{631}\u{648}\u{632} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Kamakailan-lamang na na-update`,
    fr: `R\xe9cemment mis \xe0 jour`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `D\xe8ny\xe8man mete ajou`,
    it: `Aggiornato di recente`,
    ja: `\u{6700}\u{8FD1}\u{306E}\u{66F4}\u{65B0}`,
    ko: `\u{CD5C}\u{ADFC} \u{C5C5}\u{B370}\u{C774}\u{D2B8}`,
    mww: `Nyuam qhuav kho tshiab`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62A}\u{627}\u{632}\u{647} \u{634}\u{648}\u{6CC}`,
    pt: `Atualizado recentemente`,
    "pt-pt": `Atualizado recentemente`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E}`,
    sm: `Fa'afouina talu ai nei`,
    so: `Recently updated`,
    th: `\u{E2D}\u{E31}\u{E1E}\u{E40}\u{E14}\u{E17}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t g\u{1EA7}n \u{111}\xe2y`,
    "zh-hans": `\u{6700}\u{8FD1}\u{66F4}\u{65B0}`,
    "zh-hant": `\u{6700}\u{8FD1}\u{66F4}\u{65B0}`,
    en: `Recently updated`
};
const $2868cc1235412e16$export$bda66586c2970932 = {
    ar: `\u{623}\u{642}\u{644} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `Zuletzt aktualisiert`,
    es: `Actualizaci\xf3n menos reciente`,
    fa: `\u{6A9}\u{645}\u{62A}\u{631}\u{6CC}\u{646} \u{628}\u{647} \u{631}\u{648}\u{632} \u{631}\u{633}\u{627}\u{646}\u{6CC} \u{627}\u{62E}\u{6CC}\u{631}`,
    fil: `Hindi bababa sa kamakailan-lamang na na-update`,
    fr: `Derni\xe8re mise \xe0 jour`,
    hi: `\u{938}\u{92C}\u{938}\u{947} \u{915}\u{92E} \u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Omwen d\xe8ny\xe8man mete ajou`,
    it: `Aggiornato meno di recente`,
    ja: `\u{6700}\u{3082}\u{6700}\u{8FD1}\u{66F4}\u{65B0}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}`,
    ko: `\u{AC00}\u{C7A5} \u{CD5C}\u{ADFC}\u{C5D0} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{B428}`,
    mww: `Tsawg nyuam qhuav muab kho tshiab`,
    ps: `\u{644}\u{696} \u{62A}\u{631} \u{644}\u{696}\u{647} \u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62A}\u{627}\u{632}\u{647} \u{634}\u{648}\u{6CC}`,
    pt: `Atualizado menos recentemente`,
    "pt-pt": `Atualizado menos recentemente`,
    ru: `\u{41E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43E} \u{441}\u{43E}\u{432}\u{441}\u{435}\u{43C} \u{43D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E}`,
    sm: `Fa'afouina talu ai nei`,
    so: `ugu yaraan dhawaan la cusbooneysiiyay`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{6A9}\u{645} \u{627}\u{632} \u{6A9}\u{645} \u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `C\u{1EAD}p nh\u{1EAD}t g\u{1EA7}n \u{111}\xe2y nh\u{1EA5}t`,
    "zh-hans": `\u{6700}\u{8FD1}\u{66F4}\u{65B0}\u{6700}\u{5C11}`,
    "zh-hant": `\u{6700}\u{8FD1}\u{66F4}\u{65B0}\u{6700}\u{5C11}`,
    en: `Least recently updated`
};
const $2868cc1235412e16$export$6fd132dad37489aa = {
    ar: `\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `K\xfcrzlich erstellt`,
    es: `De reciente creaci\xf3n`,
    fa: `\u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Kamakailan-lamang na nilikha`,
    fr: `R\xe9cemment cr\xe9\xe9`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `d\xe8ny\xe8man te kreye`,
    it: `Creato di recente`,
    ja: `\u{6700}\u{8FD1}\u{4F5C}\u{6210}\u{3057}\u{305F}\u{3082}\u{306E}`,
    ko: `\u{CD5C}\u{ADFC}\u{C5D0} \u{C0DD}\u{C131}\u{B428}`,
    mww: `Nyuam qhuav tsim`,
    ps: `\u{627}\u{62E}\u{6CC}\u{631}\u{627}\u{64B} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    pt: `Criado recentemente`,
    "pt-pt": `Recentemente criado`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}`,
    sm: `Talu ai nei na foafoaina`,
    so: `Recently abuuray`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{628}\u{646}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c t\u{1EA1}o g\u{1EA7}n \u{111}\xe2y`,
    "zh-hans": `\u{6700}\u{8FD1}\u{521B}\u{5EFA}`,
    "zh-hant": `\u{6700}\u{8FD1}\u{5275}\u{5EFA}`,
    en: `Recently created`
};
const $2868cc1235412e16$export$86d05dcef079cc14 = {
    ar: `\u{623}\u{642}\u{644} \u{645}\u{627} \u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `Am wenigsten k\xfcrzlich erstellt`,
    es: `Menos reciente`,
    fa: `\u{6A9}\u{645}\u{62A}\u{631}\u{6CC}\u{646} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647} \u{627}\u{62E}\u{6CC}\u{631}`,
    fil: `Hindi bababa sa kamakailan-lamang na nilikha`,
    fr: `Moins r\xe9cemment cr\xe9\xe9`,
    hi: `\u{938}\u{92C}\u{938}\u{947} \u{915}\u{92E} \u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Omwen d\xe8ny\xe8man te kreye`,
    it: `Creato meno di recente`,
    ja: `\u{6700}\u{3082}\u{6700}\u{8FD1}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}`,
    ko: `\u{AC00}\u{C7A5} \u{C624}\u{B798} \u{C804}\u{C5D0} \u{C0DD}\u{C131}\u{B428}`,
    mww: `Tsis ntev los no nyuam qhuav tsim`,
    ps: `\u{644}\u{696} \u{62A}\u{631} \u{644}\u{696}\u{647} \u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado menos recentemente`,
    "pt-pt": `Menos recentemente criado`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{432} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{435}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{44F}`,
    sm: `E le'i leva ona faia`,
    so: `Dhawaan la abuuray`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{633}\u{628} \u{633}\u{6D2} \u{6A9}\u{645} \u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{628}\u{646}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c t\u{1EA1}o g\u{1EA7}n \u{111}\xe2y nh\u{1EA5}t`,
    "zh-hans": `\u{6700}\u{8FD1}\u{521B}\u{5EFA}\u{7684}\u{6700}\u{5C11}`,
    "zh-hant": `\u{6700}\u{8FD1}\u{5275}\u{5EFA}\u{7684}\u{6700}\u{5C11}`,
    en: `Least recently created`
};
const $2868cc1235412e16$export$f56cee0972c07638 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{62D}\u{627}\u{644} \u{625}\u{644}\u{64A}\u{647}`,
    de: `Beauftragten ausw\xe4hlen`,
    es: `Elegir persona asignada`,
    fa: `\u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6AF}\u{6CC}\u{631}\u{646}\u{62F}\u{647} \u{648}\u{627}\u{6AF}\u{630}\u{627}\u{631} \u{634}\u{62F}\u{647}`,
    fil: `Piliin ang tagapag-atas`,
    fr: `Choisir la personne assign\xe9e`,
    hi: `\u{905}\u{938}\u{93E}\u{907}\u{928}\u{940} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi plase`,
    it: `Scegli assegnatario`,
    ja: `\u{62C5}\u{5F53}\u{8005}\u{306E}\u{9078}\u{629E}`,
    ko: `\u{B2F4}\u{B2F9}\u{C790} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov xaiv ntsej xaiv`,
    ps: `\u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Escolher respons\xe1vel`,
    "pt-pt": `Escolha o cession\xe1rio`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Filifili le tagata ua tofia`,
    so: `Dooro xildhiban`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: `\u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c chuy\u{1EC3}n nh\u{1B0}\u{1EE3}ng`,
    "zh-hans": `\u{9009}\u{62E9}\u{4EFB}\u{52A1}\u{5206}\u{914D}\u{5BF9}\u{8C61}`,
    "zh-hant": `\u{9078}\u{64C7}\u{4EFB}\u{52D9}\u{5206}\u{914D}\u{7269}\u{4EF6}`,
    en: `Choose assignee`
};
const $2868cc1235412e16$export$fa932f10b592a16 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{645}\u{646}\u{634}\u{626} \u{627}\u{644}\u{645}\u{62D}\u{62A}\u{648}\u{649}`,
    de: `Ersteller ausw\xe4hlen`,
    es: `Elegir creador`,
    fa: `\u{633}\u{627}\u{632}\u{646}\u{62F}\u{647} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang tagalikha`,
    fr: `Choisir le cr\xe9ateur`,
    hi: `\u{928}\u{93F}\u{930}\u{94D}\u{92E}\u{93E}\u{924}\u{93E} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kreyat\xe8`,
    it: `Scegli il creatore`,
    ja: `\u{30AF}\u{30EA}\u{30A8}\u{30A4}\u{30BF}\u{30FC}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{D06C}\u{B9AC}\u{C5D0}\u{C774}\u{D130} \u{C120}\u{D0DD}`,
    mww: `Xaiv tus tswv tsim`,
    ps: `\u{62E}\u{627}\u{644}\u{642} \u{648}\u{67C}\u{627}\u{6A9}\u{626}`,
    pt: `Escolha o criador`,
    "pt-pt": `Escolha o criador`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Filifili le foafoa`,
    so: `Dooro abuure`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1C}\u{E39}\u{E49}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{62A}\u{62E}\u{644}\u{6CC}\u{642} \u{6A9}\u{627}\u{631} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\u{1B0}\u{1EDD}i s\xe1ng t\u{1EA1}o`,
    "zh-hans": `\u{9009}\u{62E9} creator`,
    "zh-hant": `\u{9078}\u{64C7} creator`,
    en: `Choose creator`
};
const $2868cc1235412e16$export$88c2845785c80e49 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{627}\u{644}\u{645}\u{630}\u{643}\u{648}\u{631}`,
    de: `Erw\xe4hnten Benutzer ausw\xe4hlen`,
    es: `Elija el usuario mencionado`,
    fa: `\u{6A9}\u{627}\u{631}\u{628}\u{631} \u{630}\u{6A9}\u{631} \u{634}\u{62F}\u{647} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang nabanggit na tagagamit`,
    fr: `Choisissez l\u{2019}utilisateur mentionn\xe9`,
    hi: `\u{909}\u{932}\u{94D}\u{932}\u{947}\u{916}\u{93F}\u{924} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi itilizat\xe8 mansyone`,
    it: `Scegli l'utente menzionato`,
    ja: `\u{30E1}\u{30F3}\u{30B7}\u{30E7}\u{30F3}\u{3055}\u{308C}\u{305F}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{C5B8}\u{AE09}\u{B41C} \u{C0AC}\u{C6A9}\u{C790} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov neeg siv`,
    ps: `\u{6CC}\u{627}\u{62F} \u{634}\u{648}\u{6CC} \u{6A9}\u{627}\u{631}\u{646} \u{63A}\u{648}\u{631}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha o usu\xe1rio mencionado`,
    "pt-pt": `Escolha o usu\xe1rio mencionado`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}`,
    sm: `Filifili tagata faaaoga ua ta'ua`,
    so: `Dooro user sheegay`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E35}\u{E48}\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{630}\u{6A9}\u{631} \u{6A9}\u{631}\u{62F}\u{6C1} \u{635}\u{627}\u{631}\u{641} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n ng\u{1B0}\u{1EDD}i d\xf9ng \u{111}\u{1B0}\u{1EE3}c \u{111}\u{1EC1} c\u{1EAD}p`,
    "zh-hans": `\u{9009}\u{62E9}\u{63D0}\u{53CA}\u{7684}\u{7528}\u{6237}`,
    "zh-hant": `\u{9078}\u{64C7}\u{63D0}\u{53CA}\u{7684}\u{4F7F}\u{7528}\u{8005}`,
    en: `Choose mentioned user`
};
const $2868cc1235412e16$export$b9b36d40df6756f8 = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{641}\u{62A}\u{648}\u{62D}\u{629}`,
    de: `Offene Status`,
    es: `Estados abiertos`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{627}\u{632}`,
    fil: `Mga Bukas na Katayuan`,
    fr: `Statuts ouverts`,
    hi: `\u{916}\u{941}\u{932}\u{947} \u{939}\u{941}\u{90F} \u{938}\u{94D}\u{91F}\u{947}\u{91F}\u{938}`,
    ht: `Estati louvri`,
    it: `Stati aperti`,
    ja: `\u{30AA}\u{30FC}\u{30D7}\u{30F3}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}`,
    ko: `\u{C5F4}\u{AE30} \u{C0C1}\u{D0DC}`,
    mww: `Qhib raws li txoj cai`,
    ps: `\u{67E}\u{631}\u{627}\u{646}\u{6CC}\u{633}\u{62A}\u{6CC} \u{62D}\u{627}\u{644}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Status em aberto`,
    "pt-pt": `Abrir estados`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{44B}`,
    sm: `Tatala tulaga`,
    so: `Xaaladda furan`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E17}\u{E35}\u{E48}\u{E40}\u{E1B}\u{E34}\u{E14}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `Open statuses`,
    vi: `Tr\u{1EA1}ng th\xe1i m\u{1EDF}`,
    "zh-hans": `\u{6253}\u{5F00}\u{72B6}\u{6001}`,
    "zh-hant": `\u{6253}\u{958B}\u{72C0}\u{614B}`,
    en: `Open statuses`
};
const $2868cc1235412e16$export$caeb5e6004a803ab = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{63A}\u{644}\u{642}\u{629}`,
    de: `Geschlossene Status`,
    es: `Estados cerrados`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{628}\u{633}\u{62A}\u{647}`,
    fil: `Email Address *`,
    fr: `Statuts ferm\xe9s`,
    hi: `\u{92C}\u{902}\u{926} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: `Estati f\xe8men`,
    it: `Stati chiusi`,
    ja: `\u{30AF}\u{30ED}\u{30FC}\u{30BA}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}`,
    ko: `\u{B2EB}\u{D78C} \u{C0C1}\u{D0DC}`,
    mww: `Kaw raws li txoj cai`,
    ps: `\u{62A}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{62D}\u{627}\u{644}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Status fechados`,
    "pt-pt": `Status fechado`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{44B}`,
    sm: `Tulaga tapunia`,
    so: `Xaaladaha xiran`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E34}\u{E14}`,
    ur: `Closed statuses`,
    vi: `Tr\u{1EA1}ng th\xe1i \u{111}\xe3 \u{111}\xf3ng`,
    "zh-hans": `\u{5DF2}\u{5173}\u{95ED}\u{72B6}\u{6001}`,
    "zh-hant": `\u{5DF2}\u{95DC}\u{9589}\u{72C0}\u{614B}`,
    en: `Closed statuses`
};
const $2868cc1235412e16$export$cb6ce79010bc6290 = {
    ar: `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{643}\u{644}`,
    de: `Alle l\xf6schen`,
    es: `Borrar todo`,
    fa: `\u{67E}\u{627}\u{6A9} \u{6A9}\u{631}\u{62F}\u{646} \u{647}\u{645}\u{647}`,
    fil: `I-clear ang lahat`,
    fr: `Effacer tout`,
    hi: `\u{938}\u{92D}\u{940} \u{938}\u{93E}\u{92B} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kl\xe8 tout`,
    it: `Cancella tutto`,
    ja: `\u{3059}\u{3079}\u{3066}\u{30AF}\u{30EA}\u{30A2}`,
    ko: `\u{BAA8}\u{B450} \u{C9C0}\u{C6B0}\u{AE30}`,
    mww: `Tseeb tag nrho`,
    ps: `\u{67C}\u{648}\u{644} \u{67E}\u{627}\u{6A9} \u{6A9}\u{693}\u{647}`,
    pt: `Apagar tudo`,
    "pt-pt": `Apagar tudo`,
    ru: `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    sm: `T\u{101}p\u{113} uma`,
    so: `Dhammaan tirtir`,
    th: `\u{E25}\u{E49}\u{E32}\u{E07}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{633}\u{628} \u{635}\u{627}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a t\u{1EA5}t c\u{1EA3}`,
    "zh-hans": `\u{5168}\u{90E8}\u{6E05}\u{9664}`,
    "zh-hant": `\u{5168}\u{90E8}\u{6E05}\u{9664}`,
    en: `Clear all`
};
const $2868cc1235412e16$export$5db0ace58855f4c0 = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647} \u{644}\u{643}`,
    de: `Ihnen zugewiesen`,
    es: `Asignados a usted`,
    fa: `\u{628}\u{647} \u{634}\u{645}\u{627} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Itinalaga sa iyo`,
    fr: `Attribu\xe9 \xe0 vous`,
    hi: `\u{906}\u{92A}\u{915}\u{94B} \u{938}\u{94C}\u{902}\u{92A}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Asiyen ou`,
    it: `Assegnato a te`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306B}\u{5272}\u{308A}\u{5F53}\u{3066}\u{6E08}\u{307F}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790}\u{C5D0}\u{AC8C} \u{D560}\u{B2F9}\u{B428}`,
    mww: `Txib kom koj ua raws li koj tau cog tseg`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Atribu\xeddo a voc\xea`,
    "pt-pt": `Atribu\xeddo a voc\xea`,
    ru: `\u{417}\u{430}\u{43A}\u{440}\u{435}\u{43F}\u{43B}\u{435}\u{43D}\u{43E} \u{437}\u{430} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `Tofia ia te oe`,
    so: `Astaamo laguu dhiibay`,
    th: `\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{648} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c giao cho b\u{1EA1}n`,
    "zh-hans": `\u{5206}\u{914D}\u{7ED9}\u{60A8}`,
    "zh-hant": `\u{5206}\u{914D}\u{7D66}\u{60A8}`,
    en: `Assigned to you`
};
const $2868cc1235412e16$export$1dc36e4b6908af26 = {
    ar: `\u{62A}\u{645} \u{62A}\u{639}\u{64A}\u{64A}\u{646}\u{647} \u{644}\u{645}\u{624}\u{633}\u{633}\u{62A}\u{643}`,
    de: `Ihrer Organisation zugewiesen`,
    es: `Asignado a su organizaci\xf3n`,
    fa: `\u{628}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Itinalaga sa Iyong Organisasyon`,
    fr: `Attribu\xe9 \xe0 votre organisation`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{94B} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Asiyen nan \xf2ganizasyon w lan`,
    it: `Assegnato alla tua organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{306B}\u{5272}\u{308A}\u{5F53}\u{3066}\u{3089}\u{308C}\u{3066}\u{3044}\u{308B}`,
    ko: `\u{C870}\u{C9C1}\u{C5D0} \u{D560}\u{B2F9}\u{B428}`,
    mww: `Txib koj lub koom haum mus rau lub koom haum`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62A}\u{647} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC}`,
    pt: `Atribu\xeddo \xe0 sua organiza\xe7\xe3o`,
    "pt-pt": `Atribu\xeddo \xe0 sua organiza\xe7\xe3o`,
    ru: `\u{41D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43E} \u{432}\u{430}\u{448}\u{435}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Tofia i lau faalapotopotoga`,
    so: `Laguu daray ururkaaga`,
    th: `\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{648} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c ch\u{1EC9} \u{111}\u{1ECB}nh cho t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n`,
    "zh-hans": `\u{5206}\u{914D}\u{7ED9}\u{60A8}\u{7684}\u{7EC4}\u{7EC7}`,
    "zh-hant": `\u{5206}\u{914D}\u{7D66}\u{60A8}\u{7684}\u{7D44}\u{7E54}`,
    en: `Assigned to your organization`
};
const $2868cc1235412e16$export$71c4c52d4f37ac21 = {
    ar: `\u{64A}\u{630}\u{643}\u{631}\u{643}`,
    de: `Erw\xe4hnt Sie`,
    es: `Te menciona`,
    fa: `\u{627}\u{632} \u{634}\u{645}\u{627} \u{646}\u{627}\u{645} \u{645}\u{6CC} \u{628}\u{631}\u{62F}`,
    fil: `Binanggit ka`,
    fr: `Vous mentionne`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{909}\u{932}\u{94D}\u{932}\u{947}\u{916} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}`,
    ht: `Mansyone ou`,
    it: `Ti menziona`,
    ja: `\u{3042}\u{306A}\u{305F}\u{3092}\u{30E1}\u{30F3}\u{30B7}\u{30E7}\u{30F3}\u{3059}\u{308B}`,
    ko: `\u{B2F9}\u{C2E0}\u{C744} \u{C5B8}\u{AE09}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Koj hais li no:`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{6CC}\u{627}\u{62F}\u{648}\u{646}\u{647}`,
    pt: `Menciona voc\xea`,
    "pt-pt": `Menciona-o`,
    ru: `\u{423}\u{43F}\u{43E}\u{43C}\u{438}\u{43D}\u{430}\u{435}\u{442} \u{432}\u{430}\u{441}`,
    sm: `Ta'ua oe`,
    so: `aad ku xuso`,
    th: `\u{E01}\u{E25}\u{E48}\u{E32}\u{E27}\u{E16}\u{E36}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{627} \u{630}\u{6A9}\u{631} \u{6A9}\u{631}\u{62A}\u{627} \u{6C1}\u{6D2}`,
    vi: `\u{110}\u{1EC1} c\u{1EAD}p \u{111}\u{1EBF}n b\u{1EA1}n`,
    "zh-hans": `\u{63D0}\u{53CA}\u{60A8}`,
    "zh-hant": `\u{63D0}\u{53CA}\u{60A8}`,
    en: `Mentions you`
};
const $2868cc1235412e16$export$905a4a015f56885d = {
    ar: `\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{628}\u{648}\u{627}\u{633}\u{637}\u{62A}\u{643}`,
    de: `Von Ihnen erstellt`,
    es: `Creado por ti`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627}`,
    fil: `Nilikha Mo`,
    fr: `Cr\xe9\xe9 par vos soins`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Kreye pa ou`,
    it: `Creato da te`,
    ja: `\u{3042}\u{306A}\u{305F}\u{304C}\u{4F5C}\u{6210}\u{3057}\u{305F}\u{3082}\u{306E}`,
    ko: `\u{B0B4}\u{AC00} \u{B9CC}\u{B4E0} \u{AC83}`,
    mww: `Tsim los ntawm koj`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{644}\u{647} \u{62E}\u{648}\u{627} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado por voc\xea`,
    "pt-pt": `Criado por voc\xea`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `Faauta, sa ia lei faia ea mo oe se faataitaiga lelei?`,
    so: `Sidaana waxaad tihiin addoommuhu.`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E42}\u{E14}\u{E22}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6C1} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `T\u{1EA1}o b\u{1EDF}i b\u{1EA1}n`,
    "zh-hans": `\u{7531}\u{60A8}\u{521B}\u{5EFA}`,
    "zh-hant": `\u{7531}\u{60A8}\u{5275}\u{5EFA}`,
    en: `Created by you`
};
const $2868cc1235412e16$export$40ea98e2465fefe1 = {
    ar: `\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{628}\u{648}\u{627}\u{633}\u{637}\u{629} \u{645}\u{624}\u{633}\u{633}\u{62A}\u{643}`,
    de: `Von Ihrer Organisation erstellt`,
    es: `Creado por su organizaci\xf3n`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627}`,
    fil: `Nilikha ng Iyong Organisasyon`,
    fr: `Cr\xe9\xe9 par votre organisation`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Kreye pa \xf2ganizasyon ou`,
    it: `Creato dalla tua organizzazione`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{7D44}\u{7E54}\u{306B}\u{3088}\u{3063}\u{3066}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C870}\u{C9C1}\u{C5D0}\u{C11C} \u{B9CC}\u{B4E0} \u{D56D}\u{BAA9}`,
    mww: `Tsim los ntawm koj lub koom haum`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{627}\u{62F}\u{627}\u{631}\u{6D0} \u{644}\u{62E}\u{648}\u{627} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado por sua organiza\xe7\xe3o`,
    "pt-pt": `Criado pela sua organiza\xe7\xe3o`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43E} \u{432}\u{430}\u{448}\u{435}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{435}\u{439}`,
    sm: `Fausiaina e lau fa'alapotopotoga`,
    so: `Waxaa abuuray ururkaaga`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E42}\u{E14}\u{E22}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{637}\u{631}\u{641} \u{633}\u{6D2} \u{628}\u{646}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c t\u{1EA1}o b\u{1EDF}i t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n`,
    "zh-hans": `\u{7531}\u{60A8}\u{7684}\u{7EC4}\u{7EC7}\u{521B}\u{5EFA}`,
    "zh-hant": `\u{7531}\u{60A8}\u{7684}\u{7D44}\u{7E54}\u{5275}\u{5EFA}`,
    en: `Created by your organization`
};
const $2868cc1235412e16$export$a0032eac4d6b29e7 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{641}\u{639}\u{627}\u{644}\u{64A}\u{627}\u{62A}`,
    de: `Alle Veranstaltungen`,
    es: `Todos los eventos`,
    fa: `\u{647}\u{645}\u{647} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627}`,
    fil: `Lahat ng mga kaganapan`,
    fr: `Tous les \xe9v\xe9nements`,
    hi: `\u{938}\u{92D}\u{940} \u{918}\u{91F}\u{928}\u{93E}\u{90F}\u{901}`,
    ht: `Tout ev\xe8nman`,
    it: `Tutti gli eventi`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}`,
    ko: `\u{BAA8}\u{B4E0} \u{C774}\u{BCA4}\u{D2B8}`,
    mww: `Tag nrho cov txheej xwm`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0}`,
    pt: `Todos os eventos`,
    "pt-pt": `Todos os eventos`,
    ru: `\u{412}\u{441}\u{435} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}`,
    sm: `Mea uma na tutupu`,
    so: `Dhammaan dhacdooyinka`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{648}\u{627}\u{642}\u{639}\u{627}\u{62A}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c s\u{1EF1} ki\u{1EC7}n`,
    "zh-hans": `\u{6240}\u{6709}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{6240}\u{6709}\u{6D3B}\u{52D5}`,
    en: `All events`
};
const $2868cc1235412e16$export$4d9501c486d51939 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Alle Aktivit\xe4ten`,
    es: `Todas las actividades`,
    fa: `\u{647}\u{645}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}`,
    fil: `Lahat ng Aktibidad`,
    fr: `Toutes les activit\xe9s`,
    hi: `\u{938}\u{92D}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: `Tout aktivite yo`,
    it: `Tutte le attivit\xe0`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}`,
    ko: `\u{BAA8}\u{B4E0} \u{D65C}\u{B3D9}`,
    mww: `Tag nrho cov kev ua ub no`,
    ps: `\u{67C}\u{648}\u{644} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Todas as atividades`,
    "pt-pt": `Todas as atividades`,
    ru: `\u{412}\u{441}\u{435} \u{432}\u{438}\u{434}\u{44B} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}`,
    sm: `Gaoioiga uma`,
    so: `Dhammaan Hawlaha`,
    th: `\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{6240}\u{6709}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{6240}\u{6709}\u{6D3B}\u{52D5}`,
    en: `All activities`
};
const $2868cc1235412e16$export$d6400e97e0c26987 = {
    ar: `\u{633}\u{627}\u{628}\u{642}`,
    de: `Vorhergehend`,
    es: `Anterior`,
    fa: `\u{642}\u{628}\u{644}\u{6CC}`,
    fil: `Nakaraan`,
    fr: `Pr\xe9c\xe9dent`,
    hi: `\u{92A}\u{93F}\u{91B}\u{932}\u{93E}`,
    ht: `Ansyen`,
    it: `Precedente`,
    ja: `\u{5148}\u{306E}`,
    ko: `\u{C774}\u{C804}\u{C758}`,
    mww: `yav dhau los`,
    ps: `\u{67E}\u{62E}\u{648}\u{627}\u{646}\u{6CD}`,
    pt: `Anterior`,
    "pt-pt": `Anterior`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{438}\u{439}`,
    sm: `Muamua`,
    so: `Hore`,
    th: `\u{E01}\u{E48}\u{E2D}\u{E19}`,
    ur: `\u{67E}\u{686}\u{6BE}\u{644}\u{627}`,
    vi: `Tr\u{1B0}\u{1EDB}c`,
    "zh-hans": `\u{4EE5}\u{524D}`,
    "zh-hant": `\u{4EE5}\u{524D}`,
    en: `Previous`
};
const $2868cc1235412e16$export$726aa351c1c86373 = {
    ar: `\u{645}\u{642}\u{628}\u{644}`,
    de: `N\xe4chster`,
    es: `Pr\xf3ximo`,
    fa: `\u{628}\u{639}\u{62F}\u{6CC}`,
    fil: `Susunod`,
    fr: `Prochain`,
    hi: `\u{905}\u{917}\u{932}\u{93E}`,
    ht: `Pwochen`,
    it: `Prossimo`,
    ja: `\u{6B21}\u{306B}`,
    ko: `\u{B2E4}\u{C74C}`,
    mww: `Lwm`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0}`,
    pt: `Pr\xf3ximo`,
    "pt-pt": `Seguinte`,
    ru: `\u{421}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{439}`,
    sm: `Sosoo ai`,
    so: `Xiga`,
    th: `\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{627}`,
    vi: `Sau`,
    "zh-hans": `\u{4E0B}\u{4E00}\u{4E2A}`,
    "zh-hant": `\u{4E0B}\u{4E00}\u{500B}`,
    en: `Next`
};
const $2868cc1235412e16$export$7a315f334a00da32 = {
    ar: `\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{633}\u{627}\u{628}\u{642}\u{629}`,
    de: `Vorherige Seite`,
    es: `P\xe1gina anterior`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{642}\u{628}\u{644}\u{6CC}`,
    fil: `Nakaraang pahina`,
    fr: `Page pr\xe9c\xe9dente`,
    hi: `\u{92A}\u{93F}\u{91B}\u{932}\u{93E} \u{92A}\u{943}\u{937}\u{94D}\u{920}`,
    ht: `Paj anvan`,
    it: `Pagina precedente`,
    ja: `\u{524D}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{3078}`,
    ko: `\u{C774}\u{C804} \u{D398}\u{C774}\u{C9C0}`,
    mww: `nplooj ntawv yav dhau los`,
    ps: `\u{62A}\u{6D0}\u{631}\u{647} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `P\xe1gina anterior`,
    "pt-pt": `P\xe1gina anterior`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{44B}\u{434}\u{443}\u{449}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`,
    sm: `Itulau talu ai`,
    so: `Sidan hore`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{67E}\u{686}\u{6BE}\u{644}\u{627} \u{635}\u{641}\u{62D}\u{6C1}`,
    vi: `Trang tr\u{1B0}\u{1EDB}c`,
    "zh-hans": `\u{4E0A}\u{4E00}\u{9875}`,
    "zh-hant": `\u{4E0A}\u{4E00}\u{9801}`,
    en: `Previous page`
};
const $2868cc1235412e16$export$2a0609f6de79c668 = {
    ar: `\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}`,
    de: `N\xe4chste Seite`,
    es: `P\xe1gina siguiente`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{628}\u{639}\u{62F}\u{6CC}`,
    fil: `Susunod na pahina`,
    fr: `Page suivante`,
    hi: `\u{905}\u{917}\u{932}\u{93E} \u{92A}\u{943}\u{937}\u{94D}\u{920}`,
    ht: `Pwochen paj`,
    it: `Pagina successiva`,
    ja: `\u{6B21}\u{306E}\u{30DA}\u{30FC}\u{30B8}`,
    ko: `\u{B2E4}\u{C74C} \u{D398}\u{C774}\u{C9C0}`,
    mww: `nplooj ntawv tom ntej no ntxiv`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Pr\xf3xima p\xe1gina`,
    "pt-pt": `P\xe1gina seguinte`,
    ru: `\u{421}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`,
    sm: `Itulau e sosoo ai`,
    so: `Sida xigta`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{627} \u{635}\u{641}\u{62D}\u{6C1}`,
    vi: `Trang ti\u{1EBF}p theo`,
    "zh-hans": `\u{4E0B}\u{4E00}\u{9875}`,
    "zh-hant": `\u{4E0B}\u{4E00}\u{9801}`,
    en: `Next page`
};
const $2868cc1235412e16$export$322db104d06f2add = {
    ar: `\u{62A}\u{642}\u{633}\u{64A}\u{645}`,
    de: `Paginierung`,
    es: `Paginaci\xf3n`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{628}\u{646}\u{62F}\u{6CC}`,
    fil: `Pagination`,
    fr: `Pagination`,
    hi: `\u{92A}\u{943}\u{937}\u{94D}\u{920}\u{93E}\u{902}\u{915}\u{928}`,
    ht: `Peginasyon`,
    it: `Impaginazione`,
    ja: `\u{30DA}\u{30FC}\u{30B8}\u{30CD}\u{30FC}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{D398}\u{C774}\u{C9C0} \u{B9E4}\u{AE40}`,
    mww: `pagination`,
    ps: `\u{635}\u{641}\u{62D}\u{647} \u{628}\u{646}\u{62F}\u{6CC}`,
    pt: `Pagina\xe7\xe3o`,
    "pt-pt": `Pagina\xe7\xe3o`,
    ru: `\u{41D}\u{443}\u{43C}\u{435}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}`,
    sm: `Itulau`,
    so: `Pagination`,
    th: `\u{E40}\u{E25}\u{E02}\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `Pagination`,
    vi: `Pagination`,
    "zh-hans": `\u{5206}\u{9875}`,
    "zh-hant": `\u{5206}\u{9801}`,
    en: `Pagination`
};
const $2868cc1235412e16$export$334596baad7ddd4b = {
    ar: `\u{623}\u{646}\u{62B}\u{649}`,
    de: `Weiblich`,
    es: `Femenino`,
    fa: `\u{632}\u{646}`,
    fil: `Babae`,
    fr: `Femelle`,
    hi: `\u{92E}\u{93E}\u{926}\u{93E}`,
    ht: `Fem\xe8l`,
    it: `Femmina`,
    ja: `\u{5973}\u{6027}`,
    ko: `\u{C5EC}\u{C131}`,
    mww: `Poj`,
    ps: `\u{69A}\u{681}\u{6CC}\u{646}\u{647}`,
    pt: `F\xeamea`,
    "pt-pt": `Feminino`,
    ru: `\u{416}\u{435}\u{43D}\u{441}\u{43A}\u{438}\u{439}`,
    sm: `Tama'ita'i`,
    so: `Haweenka`,
    th: `\u{E2B}\u{E0D}\u{E34}\u{E07}`,
    ur: `\u{645}\u{627}\u{62F}\u{6C1}`,
    vi: `C\xe1i`,
    "zh-hans": `\u{5973}\u{6027}`,
    "zh-hant": `\u{5973}\u{6027}`,
    en: `Female`
};
const $2868cc1235412e16$export$6f6a6bca1bcd46f9 = {
    ar: `\u{639}\u{645}\u{644} \u{646}\u{633}\u{62E}\u{629}`,
    de: `Kopie erstellen`,
    es: `Hacer una copia`,
    fa: `\u{6CC}\u{6A9} \u{6A9}\u{67E}\u{6CC} \u{62A}\u{647}\u{6CC}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Gumawa ng kopya`,
    fr: `Faire une copie`,
    hi: `\u{90F}\u{915} \u{915}\u{949}\u{92A}\u{940} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `F\xe8 yon kopi`,
    it: `Crea una copia`,
    ja: `\u{30B3}\u{30D4}\u{30FC}\u{3092}\u{4F5C}\u{6210}`,
    ko: `\u{C0AC}\u{BCF8} \u{B9CC}\u{B4E4}\u{AE30}`,
    mww: `Luam ib daim qauv ntawm daim qauv`,
    ps: `\u{6CC}\u{648}\u{647} \u{6A9}\u{627}\u{67E}\u{6CC} \u{62C}\u{648}\u{693}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Fa\xe7a uma c\xf3pia`,
    "pt-pt": `Fazer uma c\xf3pia`,
    ru: `\u{421}\u{434}\u{435}\u{43B}\u{430}\u{442}\u{44C} \u{43A}\u{43E}\u{43F}\u{438}\u{44E}`,
    sm: `Fai se kopi`,
    so: `Samee nuqul`,
    th: `\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E32}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{6A9}\u{627}\u{67E}\u{6CC} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o m\u{1ED9}t b\u{1EA3}n sao`,
    "zh-hans": `\u{5236}\u{4F5C}\u{526F}\u{672C}`,
    "zh-hant": `\u{88FD}\u{4F5C}\u{526F}\u{672C}`,
    en: `Make a copy`
};
const $2868cc1235412e16$export$593663fd92e22ab4 = {
    ar: `\u{627}\u{644}\u{633}\u{645}\u{627}\u{62D} \u{628}\u{627}\u{644}\u{646}\u{633}\u{62E}`,
    de: `Kopieren erlauben`,
    es: `Permitir copia`,
    fa: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{6A9}\u{67E}\u{6CC} \u{6A9}\u{631}\u{62F}\u{646}`,
    fil: `Payagan ang pagkopya`,
    fr: `Autoriser la copie`,
    hi: `\u{915}\u{949}\u{92A}\u{940} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}`,
    ht: `P\xe8m\xe8t kopye`,
    it: `Consenti copia`,
    ja: `\u{30B3}\u{30D4}\u{30FC}\u{3092}\u{8A31}\u{53EF}\u{3059}\u{308B}`,
    ko: `\u{BCF5}\u{C0AC} \u{D5C8}\u{C6A9}`,
    mww: `Luam ib daim qauv ntawm daim qauv`,
    ps: `\u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{648}\u{644}\u{648} \u{627}\u{62C}\u{627}\u{632}\u{647}`,
    pt: `Permitir c\xf3pia`,
    "pt-pt": `Permitir c\xf3pia`,
    ru: `\u{420}\u{430}\u{437}\u{440}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Faataga le kopiina`,
    so: `U ogolaada nuqul ka mid ah`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E01}\u{E32}\u{E23}\u{E04}\u{E31}\u{E14}\u{E25}\u{E2D}\u{E01}`,
    ur: `\u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{6BA}`,
    vi: `Cho ph\xe9p sao ch\xe9p`,
    "zh-hans": `\u{5141}\u{8BB8}\u{590D}\u{5236}`,
    "zh-hant": `\u{5141}\u{8A31}\u{8907}\u{88FD}`,
    en: `Allow copying`
};
const $2868cc1235412e16$export$114824f4784b2ef6 = {
    ar: `\u{627}\u{644}\u{633}\u{645}\u{627}\u{62D} \u{644}\u{644}\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{64A}\u{646} \u{628}\u{639}\u{645}\u{644} \u{646}\u{633}\u{62E}\u{629} \u{645}\u{646} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}\u{61F}`,
    de: `Benutzern erlauben, eine Kopie dieser Aktivit\xe4t zu erstellen?`,
    es: `\xbfPermitir que los usuarios hagan una copia de esta actividad?`,
    fa: `\u{628}\u{647} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{627}\u{646} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{645}\u{6CC} \u{62F}\u{647}\u{6CC}\u{62F} \u{627}\u{632} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{67E}\u{6CC} \u{6A9}\u{646}\u{646}\u{62F}\u{61F}`,
    fil: `Papayagan ba ang mga gumagamit na gumawa ng kopya ng aktibidad na ito?`,
    fr: `Autoriser les utilisateurs \xe0 faire une copie de cette activit\xe9 ?`,
    hi: `\u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}\u{913}\u{902} \u{915}\u{94B} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{915}\u{940} \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{932}\u{93F}\u{92A}\u{93F} \u{92C}\u{928}\u{93E}\u{928}\u{947} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{926}\u{947}\u{902}?`,
    ht: `Kite itilizat\xe8 yo f\xe8 yon kopi aktivite sa a?`,
    it: `Consentire agli utenti di creare una copia di questa attivit\xe0?`,
    ja: `\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{304C}\u{3053}\u{306E}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{30B3}\u{30D4}\u{30FC}\u{3092}\u{4F5C}\u{6210}\u{3067}\u{304D}\u{308B}\u{3088}\u{3046}\u{306B}\u{3057}\u{307E}\u{3059}\u{304B}?`,
    ko: `\u{C0AC}\u{C6A9}\u{C790}\u{AC00} \u{C774} \u{D65C}\u{B3D9}\u{C758} \u{C0AC}\u{BCF8}\u{C744} \u{B9CC}\u{B4E4} \u{C218} \u{C788}\u{B3C4}\u{B85D} \u{D5C8}\u{C6A9}\u{D558}\u{C2DC}\u{ACA0}\u{C2B5}\u{B2C8}\u{AE4C}?`,
    mww: `Tso cai rau cov neeg siv kom tau ib daim qauv ntawm txoj kev ua no?`,
    ps: `\u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6CC}\u{648}\u{647} \u{6A9}\u{627}\u{67E}\u{6CC} \u{62C}\u{648}\u{693}\u{647} \u{6A9}\u{693}\u{6CC}\u{61F}`,
    pt: `Permitir que os usu\xe1rios fa\xe7am uma c\xf3pia dessa atividade?`,
    "pt-pt": `Permitir que os usu\xe1rios fa\xe7am uma c\xf3pia dessa atividade?`,
    ru: `\u{420}\u{430}\u{437}\u{440}\u{435}\u{448}\u{438}\u{442}\u{44C} \u{43B}\u{438} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}\u{43C} \u{434}\u{435}\u{43B}\u{430}\u{442}\u{44C} \u{43A}\u{43E}\u{43F}\u{438}\u{438} \u{44D}\u{442}\u{43E}\u{433}\u{43E} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}?`,
    sm: `E mafai e tagata fa'aaoga ona faia se kopi o lenei gaoioiga?`,
    so: `U oggolow isticmaalayaasha in ay sameeyaan nuqul ka mid ah waxqabadkan?`,
    th: `\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E4D}\u{E32}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E44}\u{E14}\u{E49}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}`,
    ur: `\u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646} \u{6A9}\u{648} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{6A9}\u{627}\u{67E}\u{6CC} \u{628}\u{646}\u{627}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{62F}\u{6CC}\u{6BA}\u{61F}`,
    vi: `Cho ph\xe9p ng\u{1B0}\u{1EDD}i d\xf9ng t\u{1EA1}o m\u{1ED9}t b\u{1EA3}n sao c\u{1EE7}a ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y?`,
    "zh-hans": `\u{662F}\u{5426}\u{5141}\u{8BB8}\u{7528}\u{6237}\u{590D}\u{5236}\u{6B64}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{662F}\u{5426}\u{5141}\u{8A31}\u{4F7F}\u{7528}\u{8005}\u{8907}\u{88FD}\u{6B64}\u{6D3B}\u{52D5}`,
    en: `Allow users to make a copy of this activity?`
};
const $2868cc1235412e16$export$147e2816670703ab = {
    ar: `\u{642}\u{645} \u{628}\u{625}\u{631}\u{641}\u{627}\u{642} \u{627}\u{644}\u{645}\u{644}\u{641}\u{627}\u{62A} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{633}\u{62D}\u{628}\u{647}\u{627} \u{648}\u{625}\u{641}\u{644}\u{627}\u{62A}\u{647}\u{627} \u{623}\u{648} \u{62A}\u{62D}\u{62F}\u{64A}\u{62F}\u{647}\u{627} \u{623}\u{648} \u{644}\u{635}\u{642}\u{647}\u{627}.`,
    de: `H\xe4ngen Sie Dateien an, indem Sie sie per Drag & Drop, Ausw\xe4hlen oder Einf\xfcgen verschieben.`,
    es: `Adjunte archivos arrastr\xe1ndolos y solt\xe1ndolos, seleccion\xe1ndolos o peg\xe1ndolos.`,
    fa: `\u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627} \u{631}\u{627} \u{628}\u{627} \u{6A9}\u{634}\u{6CC}\u{62F}\u{646} \u{648} \u{631}\u{647}\u{627} \u{6A9}\u{631}\u{62F}\u{646}\u{60C} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6CC}\u{627} \u{686}\u{633}\u{628}\u{627}\u{646}\u{62F}\u{646} \u{622}\u{646}\u{647}\u{627} \u{67E}\u{6CC}\u{648}\u{633}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ilakip ang mga file sa pamamagitan ng pag-drag at pag-drop, pagpili, o pag-paste ng mga ito.`,
    fr: `Joignez des fichiers par glisser-d\xe9poser, s\xe9lectionner ou coller.`,
    hi: `\u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{94B}\u{902} \u{915}\u{94B} \u{916}\u{940}\u{902}\u{91A}\u{915}\u{930} \u{914}\u{930} \u{91B}\u{94B}\u{921}\u{93C} \u{915}\u{930}, \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{915}\u{947} \u{92F}\u{93E} \u{91A}\u{93F}\u{92A}\u{915}\u{93E}\u{915}\u{930} \u{905}\u{928}\u{941}\u{932}\u{917}\u{94D}\u{928} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Tache dosye pa trennen &ale jete, chwazi, oswa kole yo.`,
    it: `Allega i file trascinandoli, selezionandoli o incollandoli.`,
    ja: `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30C9}\u{30E9}\u{30C3}\u{30B0}&\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3001}\u{9078}\u{629E}\u{3001}\u{307E}\u{305F}\u{306F}\u{8CBC}\u{308A}\u{4ED8}\u{3051}\u{3066}\u{6DFB}\u{4ED8}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D30C}\u{C77C}\u{C744} \u{B4DC}\u{B798}\u{ADF8} \u{C564} \u{B4DC}\u{B86D}, \u{C120}\u{D0DD} \u{B610}\u{B294} \u{BD99}\u{C5EC}\u{B123}\u{AE30}\u{B85C} \u{CCA8}\u{BD80}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Txuas cov ntaub ntawv los dragging & xa me nyuam rov, xaiv, los yog yav tas los lawv.`,
    ps: `\u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{62F} \u{631}\u{627}\u{69A}\u{6A9}\u{644}\u{648} \u{627}\u{648} \u{63A}\u{648}\u{631}\u{681}\u{648}\u{644}\u{648}\u{60C} \u{63A}\u{648}\u{631}\u{647} \u{6A9}\u{648}\u{644}\u{648} \u{6CC}\u{627} \u{67E}\u{6CC}\u{633}\u{67C} \u{6A9}\u{648}\u{644}\u{648} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{636}\u{645}\u{6CC}\u{645}\u{647} \u{6A9}\u{693}\u{626}.`,
    pt: `Anexe arquivos arrastando e soltando, selecionando ou colando-os.`,
    "pt-pt": `Anexe arquivos arrastando & soltando, selecionando ou colando-os.`,
    ru: `\u{41F}\u{440}\u{438}\u{43A}\u{440}\u{435}\u{43F}\u{43B}\u{44F}\u{439}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B}\u{44B}, \u{43F}\u{435}\u{440}\u{435}\u{442}\u{430}\u{441}\u{43A}\u{438}\u{432}\u{430}\u{44F}, \u{432}\u{44B}\u{431}\u{438}\u{440}\u{430}\u{44F} \u{438}\u{43B}\u{438} \u{432}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{44F} \u{438}\u{445}.`,
    sm: `Fa'apipi'i faila e ala i le tosoina ma pa'u, filifilia, pe fa'apipi'i i latou.`,
    so: `Ku lifaaq files by jiidaya & hoos, xulashada, ama ku dhejinta iyaga.`,
    th: `\u{E41}\u{E19}\u{E1A}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E42}\u{E14}\u{E22}\u{E01}\u{E32}\u{E23}\u{E25}\u{E32}\u{E01}\u{E41}\u{E25}\u{E30}\u{E27}\u{E32}\u{E07} \u{E40}\u{E25}\u{E37}\u{E2D}\u{E01} \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E27}\u{E32}\u{E07}`,
    ur: `\u{641}\u{627}\u{626}\u{644}\u{648}\u{6BA} \u{6A9}\u{648} \u{6AF}\u{6BE}\u{633}\u{6CC}\u{679} \u{6A9}\u{631} \u{627}\u{648}\u{631} \u{686}\u{6BE}\u{648}\u{691} \u{6A9}\u{631} \u{60C} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6A9}\u{6D2} \u{60C} \u{6CC}\u{627} \u{686}\u{633}\u{67E}\u{627}\u{6BA} \u{6A9}\u{631}\u{6A9}\u{6D2} \u{645}\u{646}\u{633}\u{644}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\xednh k\xe8m t\u{1EC7}p b\u{1EB1}ng c\xe1ch k\xe9o v\xe0 th\u{1EA3}, ch\u{1ECD}n ho\u{1EB7}c d\xe1n ch\xfang.`,
    "zh-hans": `\u{901A}\u{8FC7}\u{62D6}\u{653E}\u{3001}\u{9009}\u{62E9}\u{6216}\u{7C98}\u{8D34}\u{6765}\u{9644}\u{52A0}\u{6587}\u{4EF6}\u{3002}`,
    "zh-hant": `\u{901A}\u{904E}\u{62D6}\u{653E}\u{3001}\u{9078}\u{64C7}\u{6216}\u{7C98}\u{8CBC}\u{4F86}\u{9644}\u{52A0}\u{6A94}\u{3002}`,
    en: `Attach files by dragging & dropping, selecting, or pasting them.`
};
const $2868cc1235412e16$export$91e9ba9f3f646b82 = {
    ar: (filename)=>`\u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D}: "${filename}".`,
    de: (filename)=>`Ung\xfcltiger Dateiname: "${filename}".`,
    es: (filename)=>`Nombre de archivo no v\xe1lido: "${filename}".`,
    fa: (filename)=>`\u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: "${filename}".`,
    fil: (filename)=>`Hindi wastong pangalan ng file: "${filename}".`,
    fr: (filename)=>`Nom de fichier non valide : \xab\xa0${filename}\xa0\xbb.`,
    hi: (filename)=>`\u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E}: "${filename}"\u{964}`,
    ht: (filename)=>`Invalid dosye: "${filename}".`,
    it: (filename)=>`Nome file non valido: "${filename}".`,
    ja: (filename)=>`\u{7121}\u{52B9}\u{306A}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}: "${filename}"\u{3002}`,
    ko: (filename)=>`\u{C798}\u{BABB}\u{B41C} \u{D30C}\u{C77C} \u{C774}\u{B984}: "${filename}".`,
    mww: (filename)=>`Invalid filename: "${filename}".`,
    ps: (filename)=>`\u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{62F}\u{648}\u{633}\u{6CC}\u{647} \u{646}\u{648}\u{645}: "${filename}".`,
    pt: (filename)=>`Nome de arquivo inv\xe1lido: "${filename}".`,
    "pt-pt": (filename)=>`Nome do ficheiro inv\xe1lido: "${filename}".`,
    ru: (filename)=>`\u{41D}\u{435}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{435} \u{438}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430}: "${filename}".`,
    sm: (filename)=>`Igoa faila e le aoga: "${filename}".`,
    so: (filename)=>`Magaca faylka aan saxda ahayn: "${filename}".`,
    th: (filename)=>`\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: "${filename}"`,
    ur: (filename)=>`\u{63A}\u{6CC}\u{631} \u{642}\u{627}\u{646}\u{648}\u{646}\u{6CC} \u{641}\u{627}\u{626}\u{644} \u{6A9}\u{627} \u{646}\u{627}\u{645}: "${filename}".`,
    vi: (filename)=>`T\xean t\u{1EC7}p kh\xf4ng h\u{1EE3}p l\u{1EC7}: "${filename}".`,
    "zh-hans": (filename)=>`\u{6587}\u{4EF6}\u{540D}\u{65E0}\u{6548}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}`,
    "zh-hant": (filename)=>`\u{6A94}\u{540D}\u{7121}\u{6548}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}`,
    en: (filename)=>`Invalid filename: "${filename}".`
};
const $2868cc1235412e16$export$d508f7bb704b781f = {
    ar: (filename, maxLength)=>`\u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{637}\u{648}\u{64A}\u{644} \u{62C}\u{62F}\u{627}: "${filename}". \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{62A}\u{643}\u{648}\u{646} \u{623}\u{633}\u{645}\u{627}\u{621} \u{627}\u{644}\u{645}\u{644}\u{641}\u{627}\u{62A} ${maxLength} \u{62D}\u{631}\u{641} \u{623}\u{648} \u{623}\u{642}\u{644}.`,
    de: (filename, maxLength)=>`Dateiname zu lang: "${filename}". Dateinamen d\xfcrfen ${maxLength} Zeichen lang sein.`,
    es: (filename, maxLength)=>`Nombre de archivo demasiado largo: "${filename}". Los nombres de archivo deben tener ${maxLength} caracteres o menos.`,
    fa: (filename, maxLength)=>`\u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{6CC}\u{644}\u{6CC} \u{637}\u{648}\u{644}\u{627}\u{646}\u{6CC}: "${filename}". \u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627} \u{628}\u{627}\u{6CC}\u{62F} ${maxLength} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{6CC}\u{627} \u{6A9}\u{645}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (filename, maxLength)=>`Masyadong mahaba ang filename: "${filename}". Ang mga pangalan ng file ay dapat na ${maxLength} character o mas mababa.`,
    fr: (filename, maxLength)=>`Nom de fichier trop long : \xab\xa0${filename}\xa0\xbb. Les noms de fichiers doivent comporter ${maxLength} caract\xe8res ou moins.`,
    hi: (filename, maxLength)=>`\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E} \u{92C}\u{939}\u{941}\u{924} \u{932}\u{902}\u{92C}\u{93E}: "${filename}"\u{964} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E} ${maxLength} \u{935}\u{930}\u{94D}\u{923}\u{94B}\u{902} \u{92F}\u{93E} \u{909}\u{938}\u{938}\u{947} \u{915}\u{92E} \u{935}\u{930}\u{94D}\u{923}\u{94B}\u{902} \u{915}\u{947} \u{939}\u{94B}\u{928}\u{947} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}.`,
    ht: (filename, maxLength)=>`Filename tw\xf2 lontan: "${filename}". Filenames dwe ${maxLength} karakt\xe8 oswa mwens.`,
    it: (filename, maxLength)=>`Nome del file troppo lungo: "${filename}". I nomi dei file devono contenere al massimo ${maxLength} caratteri.`,
    ja: (filename, maxLength)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}\u{304C}\u{9577}\u{3059}\u{304E}\u{307E}\u{3059}: "${filename}"\u{3002}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}\u{306F} ${maxLength} \u{6587}\u{5B57}\u{4EE5}\u{4E0B}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (filename, maxLength)=>`\u{D30C}\u{C77C} \u{C774}\u{B984}\u{C774} \u{B108}\u{BB34} \u{AE41}\u{B2C8}\u{B2E4}: "${filename}". \u{D30C}\u{C77C} \u{C774}\u{B984}\u{C740} ${maxLength} \u{C790} \u{C774}\u{D558}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (filename, maxLength)=>`Filename ntev dhau lawm: "${filename}". Cov ntaub ntawv yuav tsum ${maxLength} cim los yog tsawg dua.`,
    ps: (filename, maxLength)=>`Filename too long: "${filename}". \u{62F} \u{62F}\u{648}\u{633}\u{6CC}\u{648} \u{646}\u{648}\u{645}\u{648}\u{646}\u{647} \u{628}\u{627}\u{6CC}\u{62F} ${maxLength} \u{62A}\u{648}\u{631}\u{6CC} \u{6CC}\u{627} \u{6A9}\u{645} \u{648}\u{6CC}.`,
    pt: (filename, maxLength)=>`Nome do arquivo muito longo: "${filename}". Os nomes dos arquivos devem ter ${maxLength} caracteres ou menos.`,
    "pt-pt": (filename, maxLength)=>`Nome do ficheiro demasiado longo: "${filename}". Os nomes dos arquivos devem ter ${maxLength} caracteres ou menos.`,
    ru: (filename, maxLength)=>`\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{434}\u{43B}\u{438}\u{43D}\u{43D}\u{43E}\u{435} \u{438}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430}: "${filename}". \u{418}\u{43C}\u{435}\u{43D}\u{430} \u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{44B} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} ${maxLength} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}.`,
    sm: (filename, maxLength)=>`Igoa o le faila e umi tele: "${filename}". O igoa o faila e tatau ona ${maxLength} mataitusi pe itiiti ifo.`,
    so: (filename, maxLength)=>`Magaca faylka aad u dheer: "${filename}". 100 talephere waa in ay ahaadaan ${maxLength} xaraf ama ka yar.`,
    th: (filename, maxLength)=>`\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E22}\u{E32}\u{E27}\u{E40}\u{E01}\u{E34}\u{E19}\u{E44}\u{E1B}: "${filename}" \u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E2D}\u{E31}\u{E01}\u{E02}\u{E23}\u{E30}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${maxLength} \u{E15}\u{E31}\u{E27}`,
    ur: (filename, maxLength)=>`\u{641}\u{627}\u{626}\u{644} \u{6A9}\u{627} \u{646}\u{627}\u{645} \u{628}\u{6C1}\u{62A} \u{644}\u{645}\u{628}\u{627} \u{6C1}\u{6D2}: "${filename}". \u{641}\u{627}\u{626}\u{644} \u{6A9}\u{6D2} \u{646}\u{627}\u{645} ${maxLength} \u{62D}\u{631}\u{648}\u{641} \u{6CC}\u{627} \u{627}\u{633} \u{633}\u{6D2} \u{6A9}\u{645} \u{6C1}\u{648}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (filename, maxLength)=>`T\xean t\u{1EC7}p qu\xe1 d\xe0i: "${filename}". T\xean t\u{1EC7}p ph\u{1EA3}i t\u{1EEB} ${maxLength} k\xfd t\u{1EF1} tr\u{1EDF} xu\u{1ED1}ng.`,
    "zh-hans": (filename, maxLength)=>`\u{6587}\u{4EF6}\u{540D}\u{592A}\u{957F}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}\u{6587}\u{4EF6}\u{540D}\u{4E0D}\u{5F97}\u{8D85}\u{8FC7} ${maxLength} \u{4E2A}\u{5B57}\u{7B26}\u{3002}`,
    "zh-hant": (filename, maxLength)=>`\u{6A94}\u{540D}\u{592A}\u{9577}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}\u{3002}\u{6A94}\u{540D}\u{4E0D}\u{5F97}\u{8D85}\u{904E} ${maxLength} \u{500B}\u{5B57}\u{5143}\u{3002}`,
    en: (filename, maxLength)=>`Filename too long: "${filename}". Filenames must be ${maxLength} characters or less.`
};
const $2868cc1235412e16$export$df24ac9db9ed80e4 = {
    ar: (filename)=>`\u{627}\u{633}\u{645} \u{645}\u{644}\u{641} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D}: "${filename}". \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62A}\u{636}\u{645}\u{646} \u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{627}\u{645}\u{62A}\u{62F}\u{627}\u{62F}\u{627}.`,
    de: (filename)=>`Ung\xfcltiger Dateiname: "${filename}". Der Dateiname muss eine Erweiterung enthalten.`,
    es: (filename)=>`Nombre de archivo no v\xe1lido: "${filename}". El nombre del archivo debe incluir una extensi\xf3n.`,
    fa: (filename)=>`\u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: "${filename} \u{646}\u{627}\u{645} \u{641}\u{627}\u{6CC}\u{644} \u{628}\u{627}\u{6CC}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{6CC}\u{6A9} \u{67E}\u{633}\u{648}\u{646}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: (filename)=>`Hindi wastong pangalan ng file: "${filename}". Ang pangalan ng file ay dapat magsama ng isang extension.`,
    fr: (filename)=>`Nom de fichier non valide : \xab\xa0${filename}\xa0\xbb. Le nom de fichier doit inclure une extension.`,
    hi: (filename)=>`\u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E}: "${filename}"\u{964} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{928}\u{93E}\u{92E} \u{92E}\u{947}\u{902} \u{90F}\u{915}\u{94D}\u{938}\u{91F}\u{947}\u{902}\u{936}\u{928} \u{936}\u{93E}\u{92E}\u{93F}\u{932} \u{939}\u{94B}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}.`,
    ht: (filename)=>`Invalid dosye: "${filename}". Filenam dwe gen ladan yon ekstansyon.`,
    it: (filename)=>`Nome file non valido: "${filename}". Il nome del file deve includere un'estensione.`,
    ja: (filename)=>`\u{7121}\u{52B9}\u{306A}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}: "${filename}"\u{3002}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{540D}\u{306B}\u{306F}\u{62E1}\u{5F35}\u{5B50}\u{3092}\u{542B}\u{3081}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: (filename)=>`\u{C798}\u{BABB}\u{B41C} \u{D30C}\u{C77C} \u{C774}\u{B984}: "${filename}". \u{D30C}\u{C77C} \u{C774}\u{B984}\u{C5D0}\u{B294} \u{D655}\u{C7A5}\u{C790}\u{AC00} \u{D3EC}\u{D568}\u{B418}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (filename)=>`Invalid filename: "${filename}". Cov ntaub ntawv yuav tsum muaj ib qho extension.`,
    ps: (filename)=>`\u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{62F}\u{648}\u{633}\u{6CC}\u{647} \u{646}\u{648}\u{645}: "${filename} \u{62F} \u{62F}\u{648}\u{633}\u{6CC}\u{647} \u{646}\u{648}\u{645} \u{628}\u{627}\u{6CC}\u{62F} \u{6CC}\u{648} \u{67E}\u{631}\u{627}\u{62E}\u{648}\u{627}\u{644}\u{6CC} \u{648}\u{644}\u{631}\u{6CC}.`,
    pt: (filename)=>`Nome de arquivo inv\xe1lido: "${filename}". O nome do arquivo deve incluir uma extens\xe3o.`,
    "pt-pt": (filename)=>`Nome do ficheiro inv\xe1lido: "${filename}". Nome do arquivo deve incluir uma extens\xe3o.`,
    ru: (filename)=>`\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{438}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430}: "${filename}". \u{418}\u{43C}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{430} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435}.`,
    sm: (filename)=>`Igoa faila e le aoga: "${filename}". O le igoa o le faila e tatau ona aofia ai se faaopoopoga.`,
    so: (filename)=>`Magaca faylka aan saxneyn: "${filename}". Magaca faylka waa in lagu daraa muddo kordhin.`,
    th: (filename)=>`\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: "${filename}" \u{E0A}\u{E37}\u{E48}\u{E2D}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E19}\u{E32}\u{E21}\u{E2A}\u{E01}\u{E38}\u{E25}`,
    ur: (filename)=>`\u{63A}\u{6CC}\u{631} \u{642}\u{627}\u{646}\u{648}\u{646}\u{6CC} \u{641}\u{627}\u{626}\u{644} \u{6A9}\u{627} \u{646}\u{627}\u{645}: "${filename}". \u{641}\u{627}\u{626}\u{644} \u{646}\u{627}\u{645} \u{645}\u{6CC}\u{6BA} \u{627}\u{6CC}\u{6A9} \u{62A}\u{648}\u{633}\u{6CC}\u{639} \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{648}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: (filename)=>`T\xean t\u{1EC7}p kh\xf4ng h\u{1EE3}p l\u{1EC7}: "${filename}". T\xean t\u{1EC7}p ph\u{1EA3}i bao g\u{1ED3}m ph\u{1EA7}n m\u{1EDF} r\u{1ED9}ng.`,
    "zh-hans": (filename)=>`\u{6587}\u{4EF6}\u{540D}\u{65E0}\u{6548}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}\u{6587}\u{4EF6}\u{540D}\u{5FC5}\u{987B}\u{5305}\u{542B}\u{6269}\u{5C55}\u{540D}\u{3002}`,
    "zh-hant": (filename)=>`\u{6A94}\u{540D}\u{7121}\u{6548}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}\u{6A94}\u{540D}\u{5FC5}\u{9808}\u{5305}\u{542B}\u{64F4}\u{5C55}\u{540D}\u{3002}`,
    en: (filename)=>`Invalid filename: "${filename}". Filename must include an extension.`
};
const $2868cc1235412e16$export$a61f4000938e5ea3 = {
    ar: (extension, filename, supportedExtensions)=>`\u{627}\u{644}\u{627}\u{645}\u{62A}\u{62F}\u{627}\u{62F} \u{63A}\u{64A}\u{631} \u{627}\u{644}\u{635}\u{627}\u{644}\u{62D} "${extension}" \u{641}\u{64A} "${filename}". \u{627}\u{644}\u{627}\u{645}\u{62A}\u{62F}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62F}\u{639}\u{648}\u{645}\u{629} \u{647}\u{64A} ${supportedExtensions}.`,
    de: (extension, filename, supportedExtensions)=>`Ung\xfcltige Erweiterung "${extension}" in "${filename}". Unterst\xfctzte Erweiterungen sind ${supportedExtensions}.`,
    es: (extension, filename, supportedExtensions)=>`Extensi\xf3n "${extension}" no v\xe1lida en "${filename}". Las extensiones admitidas son ${supportedExtensions}.`,
    fa: (extension, filename, supportedExtensions)=>`\u{67E}\u{633}\u{648}\u{646}\u{62F} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} "${extension}" \u{62F}\u{631} "${filename}". \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{647}\u{627}\u{6CC} \u{627}\u{641}\u{632}\u{648}\u{62F}\u{646}\u{6CC} \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{634}\u{62F}\u{647} ${supportedExtensions} \u{647}\u{633}\u{62A}\u{646}\u{62F}.`,
    fil: (extension, filename, supportedExtensions)=>`Hindi wastong extension na "${extension}" sa "${filename}". Ang mga suportadong extension ay ${supportedExtensions}.`,
    fr: (extension, filename, supportedExtensions)=>`Extension \xab\xa0${extension}\xa0\xbb incorrecte dans \xab\xa0${filename}\xa0\xbb. Les extensions prises en charge sont ${supportedExtensions}.`,
    hi: (extension, filename, supportedExtensions)=>`"${extension}" \u{92E}\u{947}\u{902} \u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F} \u{90F}\u{915}\u{94D}\u{938}\u{91F}\u{947}\u{902}\u{936}\u{928} "${filename}"\u{964} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{93F}\u{924} \u{90F}\u{915}\u{94D}\u{938}\u{91F}\u{947}\u{902}\u{936}\u{928} ${supportedExtensions} \u{939}\u{948}\u{902}\u{964}`,
    ht: (extension, filename, supportedExtensions)=>`Ekstansyon envalid "${extension}" nan "${filename}". Sip\xf2te ekstansyon yo ${supportedExtensions}.`,
    it: (extension, filename, supportedExtensions)=>`Estensione "${extension}" non valida in "${filename}". Le estensioni supportate sono ${supportedExtensions}.`,
    ja: (filename, extension, supportedExtensions)=>`"${filename}" \u{306E}\u{62E1}\u{5F35}\u{5B50} "${extension}" \u{304C}\u{7121}\u{52B9}\u{3067}\u{3059}\u{3002}\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{3055}\u{308C}\u{3066}\u{3044}\u{308B}\u{62E1}\u{5F35}\u{5B50}\u{306F}${supportedExtensions}\u{3067}\u{3059}\u{3002}`,
    ko: (filename, extension, supportedExtensions)=>`"${filename}"\u{C758} "${extension}" \u{D655}\u{C7A5}\u{C774} \u{C798}\u{BABB}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C9C0}\u{C6D0}\u{B418}\u{B294} \u{D655}\u{C7A5}\u{C790}\u{B294} ${supportedExtensions}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (extension, filename, supportedExtensions)=>`Invalid extension "${extension}" nyob rau hauv "${filename}". Txaus siab extensions yog ${supportedExtensions}.`,
    ps: (filename, extension, supportedExtensions)=>`\u{67E}\u{647} "${filename}" \u{6A9}\u{6D0} "${extension}" \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{62F}\u{6CC}. \u{645}\u{644}\u{627}\u{62A}\u{693}\u{6CC} \u{67E}\u{631}\u{627}\u{62E}\u{62A}\u{6CC}\u{627}\u{648}\u{6D0} ${supportedExtensions} \u{62F}\u{6CC}.`,
    pt: (extension, filename, supportedExtensions)=>`Extens\xe3o inv\xe1lida "${extension}" em "${filename}". As extens\xf5es suportadas s\xe3o ${supportedExtensions}.`,
    "pt-pt": (extension, filename, supportedExtensions)=>`Extens\xe3o inv\xe1lida "${extension}" em "${filename}". As extens\xf5es suportadas s\xe3o ${supportedExtensions}.`,
    ru: (extension, filename, supportedExtensions)=>`\u{41D}\u{435}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{435} "${extension}" \u{432} "${filename}". \u{41F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{435}\u{43C}\u{44B}\u{435} \u{440}\u{430}\u{441}\u{448}\u{438}\u{440}\u{435}\u{43D}\u{438}\u{44F}: ${supportedExtensions}.`,
    sm: (extension, filename, supportedExtensions)=>`Fa'aopoopoga le aoga "${extension}" i le "${filename}". Lagolagoina fa'aopoopoga o ${supportedExtensions}.`,
    so: (extension, filename, supportedExtensions)=>`Fidinta aan midka ahayn "${extension}" ee ${filename}". Extensions taageerayaan yihiin ${supportedExtensions}.`,
    th: (extension, filename, supportedExtensions)=>`\u{E19}\u{E32}\u{E21}\u{E2A}\u{E01}\u{E38}\u{E25} "${extension}" \u{E43}\u{E19} "${filename}" \u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07} \u{E19}\u{E32}\u{E21}\u{E2A}\u{E01}\u{E38}\u{E25}\u{E17}\u{E35}\u{E48}\u{E23}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E1A} \u{E44}\u{E14}\u{E49}\u{E41}\u{E01}\u{E48} ${supportedExtensions}`,
    ur: (extension, filename, supportedExtensions)=>`"${extension}" \u{645}\u{6CC}\u{6BA} \u{63A}\u{6CC}\u{631} \u{642}\u{627}\u{646}\u{648}\u{646}\u{6CC} \u{62A}\u{648}\u{633}\u{6CC}\u{639} "${filename}". \u{62D}\u{645}\u{627}\u{6CC}\u{62A} \u{6CC}\u{627}\u{641}\u{62A}\u{6C1} \u{62A}\u{648}\u{633}\u{6CC}\u{639}\u{6CC}\u{6BA} ${supportedExtensions}\u{6D4}`,
    vi: (extension, filename, supportedExtensions)=>`Ph\u{1EA7}n m\u{1EDF} r\u{1ED9}ng "${extension}" kh\xf4ng h\u{1EE3}p l\u{1EC7} trong "${filename}". C\xe1c ti\u{1EC7}n \xedch m\u{1EDF} r\u{1ED9}ng \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} l\xe0 ${supportedExtensions}.`,
    "zh-hans": (extension, filename, supportedExtensions)=>`\u{201C}${extension}\u{201D}\u{4E2D}\u{7684}\u{6269}\u{5C55}\u{540D}\u{201C}${filename}\u{201D}\u{65E0}\u{6548}\u{3002}\u{652F}\u{6301}\u{7684}\u{6269}\u{5C55}\u{540D}\u{5305}\u{62EC} ${supportedExtensions}\u{3002}`,
    "zh-hant": (extension, filename, supportedExtensions)=>`\u{201C}${extension}\u{201D}\u{4E2D}\u{7684}\u{64F4}\u{5C55}\u{540D}\u{201C}${filename}\u{201D}\u{7121}\u{6548}\u{3002}\u{652F}\u{6301}\u{7684}\u{64F4}\u{5C55}\u{540D}\u{5305}\u{62EC} ${supportedExtensions}\u{3002}`,
    en: (extension, filename, supportedExtensions)=>`Invalid extension "${extension}" in "${filename}". Supported extensions are ${supportedExtensions}.`
};
const $2868cc1235412e16$export$20aa924aeb55054c = {
    ar: (filename, extension, maxSize)=>`\u{645}\u{644}\u{641} \u{643}\u{628}\u{64A}\u{631} \u{62C}\u{62F}\u{627}: "${filename}". \u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} \u{644}\u{62D}\u{62C}\u{645} \u{627}\u{644}\u{645}\u{644}\u{641} \u{644}\u{644}\u{645}\u{644}\u{641}\u{627}\u{62A} "${extension}" \u{647}\u{648} ${maxSize}.`,
    de: (filename, extension, maxSize)=>`Datei zu gro\xdf: "${filename}". Die maximale Dateigr\xf6\xdfe f\xfcr "${extension}"-Dateien betr\xe4gt ${maxSize}.`,
    es: (filename, extension, maxSize)=>`Archivo demasiado grande: "${filename}". El tama\xf1o m\xe1ximo de archivo para los archivos "${extension}" es de ${maxSize}.`,
    fa: (filename, extension, maxSize)=>`\u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF}: "${filename}". \u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} \u{627}\u{646}\u{62F}\u{627}\u{632}\u{647} \u{641}\u{627}\u{6CC}\u{644} \u{628}\u{631}\u{627}\u{6CC} \u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627}\u{6CC} "${extension}" ${maxSize} \u{627}\u{633}\u{62A}.`,
    fil: (filename, extension, maxSize)=>`File masyadong malaki: "${filename}". Ang maximum na laki ng file para sa "${extension}" na mga file ay ${maxSize}.`,
    fr: (filename, extension, maxSize)=>`Fichier trop volumineux : \xab\xa0${filename}\xa0\xbb. La taille maximale des fichiers \xab\xa0${extension}\xa0\xbb est de ${maxSize}.`,
    hi: (filename, extension, maxSize)=>`\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{92C}\u{939}\u{941}\u{924} \u{92C}\u{921}\u{93C}\u{940} \u{939}\u{948}: "${filename}". "${extension}" \u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{94B}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{905}\u{927}\u{93F}\u{915}\u{924}\u{92E} \u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{906}\u{915}\u{93E}\u{930} ${maxSize} \u{939}\u{948}\u{964}`,
    ht: (filename, extension, maxSize)=>`Dosye tw\xf2 gwo: "${filename}". Gwos\xe8 a dosye maksim\xf2m pou "${extension}" dosye se ${maxSize}.`,
    it: (filename, extension, maxSize)=>`File troppo grande: "${filename}". La dimensione massima del file "${extension}" \xe8 ${maxSize}.`,
    ja: (filename, extension, maxSize)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{304C}\u{5927}\u{304D}\u{3059}\u{304E}\u{307E}\u{3059}: "${filename}"\u{3002}\u{300C}${extension}\u{300D}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{306E}\u{6700}\u{5927}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{30B5}\u{30A4}\u{30BA}\u{306F} ${maxSize}\u{3067}\u{3059}\u{3002}`,
    ko: (filename, extension, maxSize)=>`\u{D30C}\u{C77C}\u{C774} \u{B108}\u{BB34} \u{D07C}: "${filename}". "${extension}" \u{D30C}\u{C77C}\u{C758} \u{CD5C}\u{B300} \u{D30C}\u{C77C} \u{D06C}\u{AE30}\u{B294} ${maxSize}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: (filename, extension, maxSize)=>`Ntaub ntawv loj heev: "${filename}". Qhov ntau npaum li cas rau "${extension}" ntaub ntawv yog ${maxSize}.`,
    ps: (filename, extension, maxSize)=>`\u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AB}: "${filename}". \u{62F} "${extension}" \u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{641}\u{627}\u{6CC}\u{644} \u{627}\u{639}\u{638}\u{645}\u{6CC} \u{627}\u{646}\u{62F}\u{627}\u{632}\u{647} ${maxSize} \u{62F}\u{647}.`,
    pt: (filename, extension, maxSize)=>`Arquivo muito grande: "${filename}". O tamanho m\xe1ximo do arquivo para arquivos "${extension}" \xe9 ${maxSize}.`,
    "pt-pt": (filename, extension, maxSize)=>`Arquivo muito grande: "${filename}". O tamanho m\xe1ximo do ficheiro para ficheiros "${extension}" \xe9 ${maxSize}.`,
    ru: (filename, extension, maxSize)=>`\u{424}\u{430}\u{439}\u{43B} \u{441}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{439}: "${filename}". \u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{439} \u{440}\u{430}\u{437}\u{43C}\u{435}\u{440} \u{444}\u{430}\u{439}\u{43B}\u{430} "${extension}" \u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{442} ${maxSize}.`,
    sm: (filename, extension, maxSize)=>`Faila tele tele: "${filename}". O le lapo'a faila aupito maualuga mo faila "${extension}" o ${maxSize}.`,
    so: (filename, extension, maxSize)=>`Faylka aad u weyn: "${filename}". size file ugu badan ee files "${extension}" waa ${maxSize}.`,
    th: (filename, extension, maxSize)=>`\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E43}\u{E2B}\u{E0D}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19}\u{E44}\u{E1B}: "${filename}" \u{E02}\u{E19}\u{E32}\u{E14}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E2A}\u{E39}\u{E07}\u{E2A}\u{E38}\u{E14}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E44}\u{E1F}\u{E25}\u{E4C} "${extension}" \u{E04}\u{E37}\u{E2D} ${maxSize}`,
    ur: (filename, extension, maxSize)=>`\u{641}\u{627}\u{626}\u{644} \u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{6CC} \u{6C1}\u{6D2}: "${filename}". ".xml" \u{641}\u{627}\u{626}\u{644}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} ${extension} \u{632}\u{6CC}\u{627}\u{62F}\u{6C1} \u{641}\u{627}\u{626}\u{644} \u{633}\u{627}\u{626}\u{632} ${maxSize} \u{6C1}\u{6D2}.`,
    vi: (filename, extension, maxSize)=>`T\u{1EAD}p tin qu\xe1 l\u{1EDB}n: "${filename}". K\xedch th\u{1B0}\u{1EDB}c t\u{1EC7}p t\u{1ED1}i \u{111}a cho t\u{1EC7}p "${extension}" l\xe0 ${maxSize}.`,
    "zh-hans": (filename, extension, maxSize)=>`\u{6587}\u{4EF6}\u{592A}\u{5927}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}\u{201C}${extension}\u{201D}\u{6587}\u{4EF6}\u{7684}\u{6700}\u{5927}\u{6587}\u{4EF6}\u{5927}\u{5C0F}\u{4E3A} ${maxSize}\u{3002}`,
    "zh-hant": (filename, extension, maxSize)=>`\u{6A94}\u{592A}\u{5927}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}\u{3002}\u{201C}${extension}\u{201D}\u{6A94}\u{7684}\u{6700}\u{5927}\u{6A94}\u{5927}\u{5C0F}\u{70BA} ${maxSize}\u{3002}`,
    en: (filename, extension, maxSize)=>`File too large: "${filename}". The maximum file size for "${extension}" files is ${maxSize}.`
};
const $2868cc1235412e16$export$c4b05ddd15bcedcd = {
    ar: (filename)=>`\u{627}\u{644}\u{645}\u{644}\u{641} \u{641}\u{627}\u{631}\u{63A}: "${filename}".`,
    de: (filename)=>`Datei ist leer: "${filename}".`,
    es: (filename)=>`El archivo est\xe1 vac\xedo: "${filename}".`,
    fa: (filename)=>`\u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{627}\u{644}\u{6CC} \u{627}\u{633}\u{62A}: "${filename}".`,
    fil: (filename)=>`Walang laman ang file: "${filename}".`,
    fr: (filename)=>`Le fichier est vide : \xab\xa0${filename}\xa0\xbb.`,
    hi: (filename)=>`\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{916}\u{93E}\u{932}\u{940} \u{939}\u{948}: "${filename}"\u{964}`,
    ht: (filename)=>`Dosye se annmp: "${filename}".`,
    it: (filename)=>`Il file \xe8 vuoto: "${filename}".`,
    ja: (filename)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{304C}\u{7A7A}\u{3067}\u{3059}: "${filename}"\u{3002}`,
    ko: (filename)=>`\u{D30C}\u{C77C}\u{C774} \u{BE44}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4} : "${filename}".`,
    mww: (filename)=>`Ntaub ntawv yog tas: "${filename}".`,
    ps: (filename)=>`\u{641}\u{627}\u{6CC}\u{644} \u{62E}\u{627}\u{644}\u{6CC} \u{62F}\u{6CC}: "${filename}".`,
    pt: (filename)=>`O arquivo est\xe1 vazio: "${filename}".`,
    "pt-pt": (filename)=>`O ficheiro est\xe1 vazio: "${filename}".`,
    ru: (filename)=>`\u{424}\u{430}\u{439}\u{43B} \u{43F}\u{443}\u{441}\u{442}\u{43E}\u{439}: "${filename}".`,
    sm: (filename)=>`E gaogao le faila: "${filename}".`,
    so: (filename)=>`Faylka wuu madhan yahay: "${filename}".`,
    th: (filename)=>`\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E27}\u{E48}\u{E32}\u{E07}\u{E40}\u{E1B}\u{E25}\u{E48}\u{E32}: "${filename}"`,
    ur: (filename)=>`\u{641}\u{627}\u{626}\u{644} \u{62E}\u{627}\u{644}\u{6CC} \u{6C1}\u{6D2}: "${filename}".`,
    vi: (filename)=>`T\u{1EC7}p tr\u{1ED1}ng: "${filename}".`,
    "zh-hans": (filename)=>`\u{6587}\u{4EF6}\u{4E3A}\u{7A7A}\u{FF1A}\u{201C}${filename}\u{201D}\u{3002}`,
    "zh-hant": (filename)=>`\u{6A94}\u{70BA}\u{7A7A}\u{FF1A}\u{300C}${filename}\u{300D}\u{3002}\u{3002}`,
    en: (filename)=>`File is empty: "${filename}".`
};
const $2868cc1235412e16$export$7f449188bb84ac2c = {
    ar: (index, length)=>`\u{62A}\u{62D}\u{645}\u{64A}\u{644} \u{645}\u{644}\u{641}\u{627}\u{62A}\u{643}... (${index}/${length})`,
    de: (index, length)=>`Hochladen Ihrer Dateien... (${index}/${length})`,
    es: (index, length)=>`Subiendo tus archivos... (${index}/${length})`,
    fa: (index, length)=>`\u{622}\u{67E}\u{644}\u{648}\u{62F} \u{641}\u{627}\u{6CC}\u{644} \u{647}\u{627}\u{6CC} \u{634}\u{645}\u{627}... (${index}/${length})`,
    fil: (index, length)=>`I-upload ang Iyong Mga File ... (${index}/${length})`,
    fr: (index, length)=>`T\xe9l\xe9chargement de vos fichiers... (${index}/${length})`,
    hi: (index, length)=>`\u{905}\u{92A}\u{928}\u{940} \u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{947}\u{902} \u{905}\u{92A}\u{932}\u{94B}\u{921} \u{915}\u{930} \u{930}\u{939}\u{93E} \u{939}\u{948}... (${index}/${length})`,
    ht: (index, length)=>`Telechaje dosye ou ... (${index}/${length})`,
    it: (index, length)=>`Caricamento dei file... (${index}/${length})`,
    ja: (index, length)=>`\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}...(${index}\u{6708}${length}\u{65E5})`,
    ko: (index, length)=>`\u{D30C}\u{C77C} \u{C5C5}\u{B85C}\u{B4DC} \u{C911}... (${index}/${length})`,
    mww: (index, length)=>`Uploading koj cov ntaub ntawv... (${index}/${length})`,
    ps: (index, length)=>`\u{62E}\u{67E}\u{644} \u{641}\u{627}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{622}\u{67E}\u{644}\u{648}\u{62F} \u{6A9}\u{648}\u{644} ... (${index}/${length})`,
    pt: (index, length)=>`Carregando seus arquivos... (${index}/${length})`,
    "pt-pt": (index, length)=>`A carregar os seus ficheiros... (${index}/${length})`,
    ru: (index, length)=>`\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430} \u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432}... (${index}/${length})`,
    sm: (index, length)=>`Fa'apipi'i lau 'upega tafa'ilagi ... (${index}/${length})`,
    so: (index, length)=>`Galinta files aad... (${index}/${length})`,
    th: (index, length)=>`\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}... (${index}/${length})`,
    ur: (index, length)=>`\u{627}\u{67E}\u{646}\u{6CC} \u{641}\u{627}\u{626}\u{644}\u{6CC}\u{6BA} \u{627}\u{67E} \u{644}\u{648}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA}... (${index}/${length})`,
    vi: (index, length)=>`T\u{1EA3}i l\xean t\u{1EC7}p c\u{1EE7}a b\u{1EA1}n... (${index} th\xe1ng ${length})`,
    "zh-hans": (index, length)=>`\u{6B63}\u{5728}\u{4E0A}\u{4F20}\u{60A8}\u{7684}\u{6587}\u{4EF6}...\u{FF08}${index}/${length}\u{FF09}`,
    "zh-hant": (index, length)=>`\u{6B63}\u{5728}\u{4E0A}\u{50B3}\u{60A8}\u{7684}\u{6A94}\u{6848}...\u{FF08}${index}/${length}\u{FF09}`,
    en: (index, length)=>`Uploading your files... (${index}/${length})`
};
const $2868cc1235412e16$export$abc1de427b12d946 = {
    ar: (filename)=>`\u{62E}\u{637}\u{623} \u{641}\u{64A} \u{62A}\u{62D}\u{645}\u{64A}\u{644} "${filename}".`,
    de: (filename)=>`Fehler beim Hochladen von "${filename}".`,
    es: (filename)=>`Error al cargar "${filename}".`,
    fa: (filename)=>`\u{62E}\u{637}\u{627} \u{62F}\u{631} \u{622}\u{67E}\u{644}\u{648}\u{62F} "${filename}".`,
    fil: (filename)=>`Error sa pag-upload ng "${filename}".`,
    fr: (filename)=>`Erreur lors du t\xe9l\xe9chargement de \xab\xa0${filename}\xa0\xbb.`,
    hi: (filename)=>`"${filename}" \u{905}\u{92A}\u{932}\u{94B}\u{921} \u{915}\u{930}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}\u{964}`,
    ht: (filename)=>`Er\xe8 uploading "${filename}".`,
    it: (filename)=>`Errore durante il caricamento di "${filename}".`,
    ja: (filename)=>`\u{300C}${filename}\u{300D}\u{306E}\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}\u{4E2D}\u{306B}\u{30A8}\u{30E9}\u{30FC}\u{304C}\u{767A}\u{751F}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: (filename)=>`"${filename}"\u{B97C} \u{C5C5}\u{B85C}\u{B4DC}\u{D558}\u{B294} \u{B3D9}\u{C548} \u{C624}\u{B958}\u{AC00} \u{BC1C}\u{C0DD}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (filename)=>`Yuam kev uploading "${filename}".`,
    ps: (filename)=>`\u{62F} "${filename}" \u{67E}\u{647} \u{622}\u{67E}\u{644}\u{648}\u{62F} \u{6A9}\u{6D0} \u{63A}\u{644}\u{637}\u{6CC} \u{62F}\u{647}.`,
    pt: (filename)=>`Erro ao carregar "${filename}".`,
    "pt-pt": (filename)=>`Erro ao carregar "${filename}".`,
    ru: (filename)=>`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{43F}\u{440}\u{438} \u{437}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{435} "${filename}".`,
    sm: (filename)=>`Error uploading "${filename}".`,
    so: (filename)=>`Soosaarista qalad "${filename}".`,
    th: (filename)=>`\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14} "${filename}"`,
    ur: (filename)=>`"records.csv" \u{627}\u{67E} \u{644}\u{648}\u{688} \u{6A9}\u{631}\u{646}\u{6D2} ${filename} \u{63A}\u{644}\u{637}\u{6CC}\u{6D4}`,
    vi: (filename)=>`L\u{1ED7}i t\u{1EA3}i l\xean "${filename}".`,
    "zh-hans": (filename)=>`\u{4E0A}\u{4F20} \u{201C}${filename}\u{201D} \u{65F6}\u{51FA}\u{9519}\u{3002}`,
    "zh-hant": (filename)=>`\u{4E0A}\u{50B3} \u{300C}${filename}\u{300D} \u{6642}\u{51FA}\u{932F}\u{3002}`,
    en: (filename)=>`Error uploading "${filename}".`
};
const $2868cc1235412e16$export$6a584c99ae610576 = {
    ar: `\u{635}\u{648}\u{631}\u{629}`,
    de: `Bild`,
    es: `Imagen`,
    fa: `\u{62A}\u{635}\u{648}\u{6CC}\u{631}`,
    fil: `Imahe`,
    fr: `Image`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92C}\u{93F}\u{902}\u{92C}`,
    ht: `Imaj`,
    it: `Immagine`,
    ja: `\u{753B}\u{50CF}`,
    ko: `\u{C774}\u{BBF8}\u{C9C0}`,
    mww: `duab`,
    ps: `\u{627}\u{646}\u{681}\u{648}\u{631}`,
    pt: `Imagem`,
    "pt-pt": `Imagem`,
    ru: `\u{41E}\u{431}\u{440}\u{430}\u{437}`,
    sm: `Ata`,
    so: `Sawir`,
    th: `\u{E20}\u{E32}\u{E1E}`,
    ur: `\u{631}\u{648}\u{67E}`,
    vi: `\u{1EA2}nh`,
    "zh-hans": `\u{56FE}\u{50CF}`,
    "zh-hant": `\u{5716}\u{50CF}`,
    en: `Image`
};
const $2868cc1235412e16$export$cfeaf0cdb33173c8 = {
    ar: `\u{641}\u{64A}\u{62F}\u{64A}\u{648}`,
    de: `Video`,
    es: `V\xeddeo`,
    fa: `\u{648}\u{6CC}\u{62F}\u{626}\u{648}`,
    fil: `Video`,
    fr: `Vid\xe9o`,
    hi: `\u{935}\u{940}\u{921}\u{93F}\u{92F}\u{94B}`,
    ht: `Videyo`,
    it: `Video`,
    ja: `\u{30D3}\u{30C7}\u{30AA}`,
    ko: `\u{BE44}\u{B514}\u{C624}`,
    mww: `Yees duab`,
    ps: `\u{648}\u{6CC}\u{689}\u{6CC}\u{648}`,
    pt: `V\xeddeo`,
    "pt-pt": `V\xeddeo`,
    ru: `\u{412}\u{438}\u{434}\u{435}\u{43E}`,
    sm: `Vitio`,
    so: `Muuqaalo`,
    th: `\u{E27}\u{E35}\u{E14}\u{E34}\u{E17}\u{E31}\u{E28}\u{E19}\u{E4C}`,
    ur: `\u{648}\u{6CC}\u{688}\u{6CC}\u{648}`,
    vi: `Video`,
    "zh-hans": `\u{89C6}\u{9891}`,
    "zh-hant": `\u{8996}\u{983B}`,
    en: `Video`
};
const $2868cc1235412e16$export$b0a5b2684ddaafba = {
    ar: `\u{646}\u{635}`,
    de: `Text`,
    es: `Mensaje de texto`,
    fa: `\u{67E}\u{6CC}\u{627}\u{645}\u{6A9}`,
    fil: `Text`,
    fr: `SMS`,
    hi: `\u{91F}\u{947}\u{915}\u{94D}\u{938}\u{94D}\u{91F}`,
    ht: `Mesaj t\xe8ks`,
    it: `Testo`,
    ja: `\u{30C6}\u{30AD}\u{30B9}\u{30C8}`,
    ko: `\u{BB38}\u{C790} \u{BA54}\u{C2DC}\u{C9C0}`,
    mww: `Sau ntawv saum xov tooj`,
    ps: `\u{645}\u{62A}\u{646}`,
    pt: `Texto`,
    "pt-pt": `Texto`,
    ru: `\u{421}\u{41C}\u{421}`,
    sm: `Tusitusiga`,
    so: `Qoraalka`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`,
    ur: `\u{645}\u{62A}\u{646}`,
    vi: `Nh\u{1EAF}n tin`,
    "zh-hans": `\u{53D1}\u{77ED}\u{4FE1}`,
    "zh-hant": `\u{767C}\u{7C21}\u{8A0A}`,
    en: `Text`
};
const $2868cc1235412e16$export$bd981c29cbdf2d7a = {
    ar: `\u{623}\u{64A}`,
    de: `Jegliche`,
    es: `Cualquier`,
    fa: `\u{647}\u{631}`,
    fil: `Anumang`,
    fr: `Quelconque`,
    hi: `\u{915}\u{94B}\u{908}`,
    ht: `Okenn`,
    it: `Qualunque`,
    ja: `\u{4EFB}\u{610F}`,
    ko: `\u{C5B4}\u{B5A4}`,
    mww: `Txhua yam`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Qualquer`,
    "pt-pt": `Qualquer`,
    ru: `\u{41B}\u{44E}\u{431}\u{43E}\u{439}`,
    sm: `So'o se`,
    so: `Qof kasta`,
    th: `\u{E43}\u{E14}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC}`,
    vi: `B\u{1EA5}t k\xec`,
    "zh-hans": `\u{4EFB}\u{4F55}`,
    "zh-hant": `\u{4EFB}\u{4F55}`,
    en: `Any`
};
const $2868cc1235412e16$export$3b2da883f08c50ff = {
    ar: (activityTitle, org)=>`\u{623}\u{646}\u{634}\u{637}\u{629} ${activityTitle} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629} \u{645}\u{646} \u{642}\u{628}\u{644} ${org} \u{60C} \u{645}\u{631}\u{62A}\u{628}\u{629} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{645}\u{633}\u{627}\u{641}\u{629} \u{645}\u{646} \u{645}\u{648}\u{642}\u{639}\u{643}.`,
    de: (activityTitle, org)=>`Aktuelle und kommende ${activityTitle} von ${org}, sortiert nach Entfernung von Ihrem Standort.`,
    es: (activityTitle, org)=>`Actividades actuales y futuras de ${activityTitle} de ${org}, ordenadas por distancia desde su ubicaci\xf3n.`,
    fa: (activityTitle, org)=>`\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{639}\u{644}\u{6CC} \u{648} ${activityTitle} \u{62A}\u{648}\u{633}\u{637} ${org}\u{60C} \u{628}\u{631} \u{627}\u{633}\u{627}\u{633} \u{641}\u{627}\u{635}\u{644}\u{647} \u{627}\u{632} \u{645}\u{6A9}\u{627}\u{646} \u{634}\u{645}\u{627} \u{645}\u{631}\u{62A}\u{628} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (activityTitle, org)=>`Kasalukuyan at paparating na mga aktibidad sa ${activityTitle} ng ${org}, na pinagsunod-sunod ayon sa distansya mula sa iyong lokasyon.`,
    fr: (activityTitle, org)=>`Activit\xe9s actuelles et \xe0 venir ${activityTitle} de ${org}, class\xe9es par distance de votre emplacement.`,
    hi: (org, activityTitle)=>`${org} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{914}\u{930} \u{906}\u{917}\u{93E}\u{92E}\u{940} ${activityTitle} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{902}, \u{906}\u{92A}\u{915}\u{947} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{938}\u{947} \u{926}\u{942}\u{930}\u{940} \u{915}\u{947} \u{905}\u{928}\u{941}\u{938}\u{93E}\u{930} \u{915}\u{94D}\u{930}\u{92E}\u{92C}\u{926}\u{94D}\u{927}\u{964}`,
    ht: (activityTitle, org)=>`Aktivite ${activityTitle} pa ${org}, klase pa distans soti nan kote ou ye a.`,
    it: (activityTitle, org)=>`Attivit\xe0 attuali e future di ${activityTitle} di ${org}, ordinate in base alla distanza dalla tua posizione.`,
    ja: (org, activityTitle)=>`${org}\u{306B}\u{3088}\u{308B}\u{73FE}\u{5728}\u{304A}\u{3088}\u{3073}\u{4ECA}\u{5F8C}\u{306E}${activityTitle}\u{306E}\u{6D3B}\u{52D5}\u{3092}\u{3001}\u{73FE}\u{5728}\u{5730}\u{304B}\u{3089}\u{306E}\u{8DDD}\u{96E2}\u{3067}\u{4E26}\u{3079}\u{66FF}\u{3048}\u{3066}\u{63B2}\u{8F09}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: (org, activityTitle)=>`${org}\u{C758} \u{D604}\u{C7AC} \u{BC0F} \u{D5A5}\u{D6C4} ${activityTitle} \u{D65C}\u{B3D9}\u{C740} \u{ADC0}\u{D558}\u{C758} \u{C704}\u{CE58}\u{B85C}\u{BD80}\u{D130}\u{C758} \u{AC70}\u{B9AC}\u{BCC4}\u{B85C} \u{C815}\u{B82C}\u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (activityTitle, org)=>`Tam sim no thiab yavtom ntej ${activityTitle} los ntawm ${org}, sorted nyob deb ntawm koj qhov chaw nyob.`,
    ps: (activityTitle, org)=>`\u{62F} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646} ${activityTitle} \u{627}\u{648}\u{633}\u{646}\u{6CC} \u{627}\u{648} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{62F} ${org} \u{644}\u{62E}\u{648}\u{627} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{644}\u{647} \u{681}\u{627}\u{6CC} \u{685}\u{62E}\u{647} \u{62F} \u{648}\u{627}\u{67C}\u{646} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: (activityTitle, org)=>`Atividades cl\xednicas de ${activityTitle} atuais e futuras da ${org}, classificadas por dist\xe2ncia de sua localiza\xe7\xe3o.`,
    "pt-pt": (activityTitle, org)=>`Atividades atuais e futuras da ${activityTitle} da ${org}, ordenadas por dist\xe2ncia da sua localiza\xe7\xe3o.`,
    ru: (activityTitle, org)=>`\u{422}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{435} \u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F} ${activityTitle} \u{43E}\u{442} ${org}, \u{43E}\u{442}\u{441}\u{43E}\u{440}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{43F}\u{43E} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{43E}\u{442} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: (activityTitle, org)=>`O lo'o i ai nei ma le lumana'i o gaioiga a le ${activityTitle} e ${org}, fa'avasegaina i le mamao mai lou nofoaga.`,
    so: (activityTitle, org)=>`Hawlaha ${activityTitle} ee hadda la socda ee ay qabto ${org}, oo laga soocay meel ka fog meesha aad joogto.`,
    th: (activityTitle, org)=>`\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01} ${activityTitle} \u{E43}\u{E19}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}\u{E41}\u{E25}\u{E30}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}\u{E42}\u{E14}\u{E22} ${org} \u{E42}\u{E14}\u{E22}\u{E40}\u{E23}\u{E35}\u{E22}\u{E07}\u{E15}\u{E32}\u{E21}\u{E23}\u{E30}\u{E22}\u{E30}\u{E17}\u{E32}\u{E07}\u{E08}\u{E32}\u{E01}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: (org, activityTitle)=>`${org} \u{6A9}\u{6CC} \u{637}\u{631}\u{641} \u{633}\u{6D2} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1} \u{627}\u{648}\u{631} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} ${activityTitle} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{60C} \u{622}\u{67E} \u{6A9}\u{6D2} \u{645}\u{642}\u{627}\u{645} \u{633}\u{6D2} \u{641}\u{627}\u{635}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{62D}\u{627}\u{638} \u{633}\u{6D2} \u{62A}\u{631}\u{62A}\u{6CC}\u{628} \u{62F}\u{6CC} \u{62C}\u{627}\u{62A}\u{6CC} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (activityTitle, org)=>`C\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng ${activityTitle} hi\u{1EC7}n t\u{1EA1}i v\xe0 s\u{1EAF}p t\u{1EDB}i c\u{1EE7}a ${org}, \u{111}\u{1B0}\u{1EE3}c s\u{1EAF}p x\u{1EBF}p theo kho\u{1EA3}ng c\xe1ch t\u{1EEB} v\u{1ECB} tr\xed c\u{1EE7}a b\u{1EA1}n.`,
    "zh-hans": (org, activityTitle)=>`${org} \u{5F53}\u{524D}\u{548C}\u{5373}\u{5C06}\u{8FDB}\u{884C}\u{7684}${activityTitle}\u{6D3B}\u{52A8}\u{FF0C}\u{6309}\u{4E0E}\u{60A8}\u{6240}\u{5728}\u{4F4D}\u{7F6E}\u{7684}\u{8DDD}\u{79BB}\u{6392}\u{5E8F}\u{3002}`,
    "zh-hant": (org, activityTitle)=>`${org} \u{7576}\u{524D}\u{548C}\u{5373}\u{5C07}\u{9032}\u{884C}\u{7684}${activityTitle}\u{6D3B}\u{52D5}\u{FF0C}\u{6309}\u{8207}\u{60A8}\u{6240}\u{5728}\u{4F4D}\u{7F6E}\u{7684}\u{8DDD}\u{96E2}\u{6392}\u{5E8F}\u{3002}`,
    en: (activityTitle, org)=>`Current and upcoming ${activityTitle} activities by ${org}, sorted by distance from your location.`
};
const $2868cc1235412e16$export$5815e44228ccc787 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{62D}\u{62F}\u{627}\u{62B} \u{646}\u{634}\u{637}\u{629} \u{623}\u{648} \u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Keine aktiven oder bevorstehenden Veranstaltungen`,
    es: `No hay eventos activos o pr\xf3ximos`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F} \u{641}\u{639}\u{627}\u{644} \u{6CC}\u{627} \u{622}\u{6CC}\u{646}\u{62F}\u{647}`,
    fil: `Walang aktibo o paparating na mga kaganapan`,
    fr: `Aucun \xe9v\xe9nement actif ou \xe0 venir`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{92F}\u{93E} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{908}\u{935}\u{947}\u{902}\u{91F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen aktif oswa ev\xe8nman kap vini yo`,
    it: `Nessun evento attivo o imminente`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D6}\u{306A}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{3084}\u{4ECA}\u{5F8C}\u{306E}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C9C4}\u{D589} \u{C911}\u{C774}\u{AC70}\u{B098} \u{C608}\u{C815}\u{B41C} \u{C774}\u{BCA4}\u{D2B8}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj yam los yog yavtom ntej`,
    ps: `\u{646}\u{647} \u{641}\u{639}\u{627}\u{644} \u{6CC}\u{627} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{67E}\u{6CC}\u{69A}\u{6D0}`,
    pt: `Nenhum evento ativo ou futuro`,
    "pt-pt": `Sem eventos ativos ou futuros`,
    ru: `\u{41D}\u{435}\u{442} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{445} \u{438}\u{43B}\u{438} \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{445} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{439}`,
    sm: `Leai ni mea e tutupu pe o lo'o lumana'i`,
    so: `Majiraan dhacdooyin firfircoon ama kuwo soo socda`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{641}\u{639}\u{627}\u{644} \u{6CC}\u{627} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{648}\u{627}\u{642}\u{639}\u{627}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 s\u{1EF1} ki\u{1EC7}n \u{111}ang di\u{1EC5}n ra ho\u{1EB7}c s\u{1EAF}p t\u{1EDB}i`,
    "zh-hans": `\u{6CA1}\u{6709}\u{6D3B}\u{52A8}\u{6216}\u{5373}\u{5C06}\u{53D1}\u{751F}\u{7684}\u{4E8B}\u{4EF6}`,
    "zh-hant": `\u{6C92}\u{6709}\u{6D3B}\u{52D5}\u{6216}\u{5373}\u{5C07}\u{767C}\u{751F}\u{7684}\u{4E8B}\u{4EF6}`,
    en: `No active or upcoming events`
};
const $2868cc1235412e16$export$6a1c2e563a22c4e0 = {
    ar: `\u{645}\u{648}\u{642}\u{639}\u{64A}`,
    de: `Mein Standort`,
    es: `Mi ubicaci\xf3n`,
    fa: `\u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{645}\u{6A9}\u{627}\u{646}\u{6CC} \u{645}\u{646}`,
    fil: `Ang aking lokasyon`,
    fr: `Ma localisation`,
    hi: `\u{92E}\u{947}\u{930}\u{93E} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote mwen ye`,
    it: `La mia posizione`,
    ja: `\u{79C1}\u{306E}\u{4F4D}\u{7F6E}\u{60C5}\u{5831}`,
    ko: `\u{B0B4} \u{C704}\u{CE58}`,
    mww: `Kuv qhov chaw nyob`,
    ps: `\u{632}\u{645}\u{627} \u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A}`,
    pt: `Minha localiza\xe7\xe3o`,
    "pt-pt": `A minha localiza\xe7\xe3o`,
    ru: `\u{41C}\u{43E}\u{435} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `O lo'u nofoaga`,
    so: `My goobta`,
    th: `\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E09}\u{E31}\u{E19}`,
    ur: `\u{645}\u{6CC}\u{631}\u{627} \u{645}\u{62D}\u{644} \u{648}\u{642}\u{648}\u{639}`,
    vi: `V\u{1ECB} tr\xed c\u{1EE7}a t\xf4i`,
    "zh-hans": `\u{6211}\u{7684}\u{4F4D}\u{7F6E}`,
    "zh-hant": `\u{6211}\u{7684}\u{4F4D}\u{7F6E}`,
    en: `My location`
};
const $2868cc1235412e16$export$41b540ca56b46291 = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{62D}\u{62F}\u{62B}`,
    de: `Ablauf der Veranstaltung`,
    es: `Calendario del evento`,
    fa: `\u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}`,
    fil: `Iskedyul ng kaganapan`,
    fr: `Calendrier des \xe9v\xe9nements`,
    hi: `\u{918}\u{91F}\u{928}\u{93E} \u{905}\u{928}\u{941}\u{938}\u{942}\u{91A}\u{940}`,
    ht: `Or\xe8 ev\xe8nman`,
    it: `Programma dell'evento`,
    ja: `\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{30B9}\u{30B1}\u{30B8}\u{30E5}\u{30FC}\u{30EB}`,
    ko: `\u{C774}\u{BCA4}\u{D2B8} \u{C2A4}\u{CF00}\u{C904}`,
    mww: `Cov Sij Hawm Hawm Tuaj Rau Kev Tshwm`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{69A}\u{6D0} \u{645}\u{647}\u{627}\u{644} \u{648}\u{6CC}\u{634}`,
    pt: `Programa\xe7\xe3o do evento`,
    "pt-pt": `Programa\xe7\xe3o do evento`,
    ru: `\u{420}\u{430}\u{441}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{439}`,
    sm: `Faasologa o mea na tutupu`,
    so: `Jadwalka event`,
    th: `\u{E15}\u{E32}\u{E23}\u{E32}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{627}\u{6CC}\u{648}\u{646}\u{679} \u{6A9}\u{627} \u{634}\u{6CC}\u{688}\u{648}\u{644}`,
    vi: `L\u{1ECB}ch tr\xecnh s\u{1EF1} ki\u{1EC7}n`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{65F6}\u{95F4}\u{8868}`,
    "zh-hant": `\u{555F}\u{7528}\u{6642}\u{7A0B}\u{8868}`,
    en: `Event schedule`
};
const $2868cc1235412e16$export$5810e207609e8996 = {
    ar: (org, activityTitle)=>`\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} ${org} \u{623}\u{64A} \u{623}\u{646}\u{634}\u{637}\u{629} ${activityTitle} \u{645}\u{62C}\u{62F}\u{648}\u{644}\u{629}.`,
    de: (org, activityTitle)=>`${org} hat keine Aktivit\xe4ten in ${activityTitle} geplant.`,
    es: (org, activityTitle)=>`${org} no tiene programadas actividades en la ${activityTitle} .`,
    fa: (org, activityTitle)=>`${org} \u{647}\u{6CC}\u{686} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} ${activityTitle} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{631}\u{6CC}\u{632}\u{6CC} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: (org, activityTitle)=>`Ang ${org} ay walang naka-iskedyul na mga aktibidad sa ${activityTitle}.`,
    fr: (org, activityTitle)=>`${org} n\u{2019}a pas d\u{2019}activit\xe9s pr\xe9vues ${activityTitle} .`,
    hi: (org, activityTitle)=>`${org} \u{92E}\u{947}\u{902} \u{915}\u{94B}\u{908} ${activityTitle} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{93F}\u{930}\u{94D}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: (org, activityTitle)=>`${org} pa gen okenn aktivite ${activityTitle} .`,
    it: (org, activityTitle)=>`${org} non ha in programma attivit\xe0 ${activityTitle} .`,
    ja: (org, activityTitle)=>`${org} \u{3067}\u{306F}\u{3001} ${activityTitle} \u{306E}\u{6D3B}\u{52D5}\u{306F}\u{4E88}\u{5B9A}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: (org, activityTitle)=>`${org} \u{C740} ${activityTitle} \u{D65C}\u{B3D9}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (org, activityTitle)=>`${org} twb tsis muaj ${activityTitle} teem tseg.`,
    ps: (org, activityTitle)=>`${org} \u{62F} ${activityTitle} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{67E}\u{647} \u{67E}\u{627}\u{645} \u{6A9}\u{6D0} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: (org, activityTitle)=>`${org} n\xe3o tem atividades ${activityTitle} agendadas.`,
    "pt-pt": (org, activityTitle)=>`${org} n\xe3o tem atividades ${activityTitle} .`,
    ru: (org, activityTitle)=>`${org} \u{43D}\u{435} \u{437}\u{430}\u{43F}\u{43B}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{44B} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{44F} ${activityTitle} .`,
    sm: (org, activityTitle)=>`${org} e leai ni gaioiga a le ${activityTitle} o tui ua fa'atulagaina.`,
    so: (org, activityTitle)=>`${org} ma laha wax ${activityTitle} ah oo loo qoondeeyay.`,
    th: (org, activityTitle)=>`${org} \u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E01}\u{E32}\u{E23}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}${activityTitle}`,
    ur: (org, activityTitle)=>`${org} \u{645}\u{6CC}\u{6BA} ${activityTitle} \u{6A9}\u{6CC} \u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA} \u{634}\u{6CC}\u{688}\u{648}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (org, activityTitle)=>`${org} kh\xf4ng c\xf3 c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng ph\xf2ng ${activityTitle} \u{111}\u{1B0}\u{1EE3}c l\xean l\u{1ECB}ch.`,
    "zh-hans": (org, activityTitle)=>`${org} \u{6CA1}\u{6709}\u{5B89}\u{6392} ${activityTitle} \u{6D3B}\u{52A8}\u{3002}`,
    "zh-hant": (org, activityTitle)=>`${org} \u{6C92}\u{6709}\u{5B89}\u{6392} ${activityTitle} \u{6D3B}\u{52D5}\u{3002}`,
    en: (org, activityTitle)=>`${org} has no ${activityTitle} activities scheduled.`
};
const $2868cc1235412e16$export$ad71bb6288618a96 = {
    ar: (distance)=>`${distance} \u{645}\u{64A}\u{644} \u{645}\u{646} \u{645}\u{648}\u{642}\u{639}\u{643}`,
    de: (distance)=>`${distance} Meilen von Ihrem Standort entfernt`,
    es: (distance)=>`${distance} millas de su ubicaci\xf3n`,
    fa: (distance)=>`${distance} \u{645}\u{627}\u{6CC}\u{644} \u{627}\u{632} \u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} \u{645}\u{6A9}\u{627}\u{646}\u{6CC} \u{634}\u{645}\u{627}`,
    fil: (distance)=>`${distance} km mula sa iyong lokasyon`,
    fr: (distance)=>`${distance} miles de votre emplacement`,
    hi: (distance)=>`\u{905}\u{92A}\u{928}\u{947} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{938}\u{947} ${distance} \u{92E}\u{940}\u{932} \u{926}\u{942}\u{930}`,
    ht: (distance)=>`${distance} kilom\xe8t nan kote ou ye a`,
    it: (distance)=>`${distance} miglia dalla tua posizione`,
    ja: (distance)=>`\u{73FE}\u{5728}\u{5730}\u{304B}\u{3089}${distance}\u{30DE}\u{30A4}\u{30EB}`,
    ko: (distance)=>`\u{D604}\u{C7AC} \u{C704}\u{CE58}\u{C5D0}\u{C11C} ${distance}\u{B9C8}\u{C77C}`,
    mww: (distance)=>`${distance} mais ntawm koj qhov chaw nyob`,
    ps: (distance)=>`\u{633}\u{62A}\u{627}\u{633}\u{648} \u{644}\u{647} \u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A} ${distance} \u{645}\u{627}\u{6CC}\u{644}\u{647}`,
    pt: (distance)=>`${distance} milhas da sua localiza\xe7\xe3o`,
    "pt-pt": (distance)=>`${distance} milhas da sua localiza\xe7\xe3o`,
    ru: (distance)=>`${distance} \u{43C}\u{438}\u{43B}\u{44C} \u{43E}\u{442} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: (distance)=>`${distance} maila mai lou nofoaga`,
    so: (distance)=>`${distance} miles u jirta meesha aad degan tahay`,
    th: (distance)=>`${distance} \u{E01}\u{E21}. \u{E08}\u{E32}\u{E01}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: (distance)=>`\u{622}\u{67E} \u{6A9}\u{6D2} \u{645}\u{642}\u{627}\u{645} \u{633}\u{6D2} ${distance} \u{645}\u{6CC}\u{644} \u{62F}\u{648}\u{631}`,
    vi: (distance)=>`${distance} d\u{1EB7}m t\u{1EEB} v\u{1ECB} tr\xed c\u{1EE7}a b\u{1EA1}n`,
    "zh-hans": (distance)=>`\u{8DDD}\u{79BB}\u{60A8}\u{7684}\u{4F4D}\u{7F6E} ${distance} \u{82F1}\u{91CC}`,
    "zh-hant": (distance)=>`\u{8DDD}\u{96E2}\u{60A8}\u{7684}\u{4F4D}\u{7F6E} ${distance} \u{82F1}\u{91CC}`,
    en: (distance)=>`${distance} miles from your location`
};
const $2868cc1235412e16$export$574566b924107962 = {
    ar: `\u{645}\u{648}\u{642}\u{639}\u{643}`,
    de: `Ihr Standort`,
    es: `Su ubicaci\xf3n`,
    fa: `\u{645}\u{6A9}\u{627}\u{646} \u{634}\u{645}\u{627}`,
    fil: `Email Address *`,
    fr: `Votre emplacement`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote ou ye a`,
    it: `La tua posizione`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{5834}\u{6240}`,
    ko: `\u{B0B4} \u{C704}\u{CE58}`,
    mww: `Koj qhov chaw nyob`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{645}\u{648}\u{642}\u{639}\u{6CC}\u{62A}`,
    pt: `Sua localiza\xe7\xe3o`,
    "pt-pt": `A sua localiza\xe7\xe3o`,
    ru: `\u{412}\u{430}\u{448}\u{435} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Lou nofoaga`,
    so: `Goobtaada`,
    th: `\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{627} \u{645}\u{62D}\u{644} \u{648}\u{642}\u{648}\u{639}`,
    vi: `V\u{1ECB} tr\xed c\u{1EE7}a b\u{1EA1}n`,
    "zh-hans": `\u{60A8}\u{7684}\u{4F4D}\u{7F6E}`,
    "zh-hant": `\u{60A8}\u{7684}\u{4F4D}\u{7F6E}`,
    en: `Your location`
};
const $2868cc1235412e16$export$1057386d3f63b416 = {
    ar: `\u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{647}`,
    de: `Kommend`,
    es: `Pr\xf3ximo`,
    fa: `\u{622}\u{6CC}\u{646}\u{62F}\u{647}`,
    fil: `Paparating na`,
    fr: `Prochain`,
    hi: `\u{918}\u{91F}\u{93F}\u{924}`,
    ht: `vini`,
    it: `Prossimo`,
    ja: `\u{4ECA}\u{5F8C}`,
    ko: `\u{B2E4}\u{AC00}\u{C624}\u{B294}`,
    mww: `yavtom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0}`,
    pt: `Pr\xf3ximo`,
    "pt-pt": `Pr\xf3ximos passos`,
    ru: `\u{420}\u{430}\u{437}\u{432}\u{438}\u{432}\u{430}\u{44E}\u{449}\u{438}\u{439}\u{441}\u{44F}`,
    sm: `O le a sosoo ai`,
    so: `Soo socda`,
    th: `\u{E40}\u{E01}\u{E34}\u{E14} \u{E02}\u{E36}\u{E49}\u{E19}`,
    ur: `\u{622}\u{626}\u{646}\u{62F}\u{6C1}`,
    vi: `S\u{1EAF}p t\u{1EDB}i`,
    "zh-hans": `\u{5373}\u{5C06} \u{5230}\u{6765}`,
    "zh-hant": `\u{5373}\u{5C07}\u{5230}\u{4F86}`,
    en: `Upcoming`
};
const $2868cc1235412e16$export$42dfd041112bce24 = {
    ar: `\u{646}\u{634}\u{637}`,
    de: `Aktiv`,
    es: `Activo`,
    fa: `\u{641}\u{639}\u{627}\u{644}`,
    fil: `Aktibo`,
    fr: `Actif`,
    hi: `\u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F}`,
    ht: `Aktif`,
    it: `Attivo`,
    ja: `\u{80FD}\u{52D5}`,
    ko: `\u{D65C}\u{B3D9}\u{C801}\u{C778}`,
    mww: `Active`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Ativo`,
    "pt-pt": `Ativo`,
    ru: `\u{410}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{439}`,
    sm: `Toaga`,
    so: `Firfircoon`,
    th: `\u{E01}\u{E23}\u{E30}\u{E1B}\u{E23}\u{E35}\u{E49}\u{E01}\u{E23}\u{E30}\u{E40}\u{E1B}\u{E23}\u{E48}\u{E32}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}`,
    vi: `Ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{79EF}\u{6781}`,
    "zh-hant": `\u{7A4D}\u{6975}`,
    en: `Active`
};
const $2868cc1235412e16$export$27b7da156abe137b = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{62D}\u{633}\u{628} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Suche nach Titel`,
    es: `B\xfasqueda por t\xedtulo`,
    fa: `\u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{628}\u{631} \u{627}\u{633}\u{627}\u{633} \u{639}\u{646}\u{648}\u{627}\u{646}`,
    fil: `Maghanap ayon sa pamagat`,
    fr: `Recherche par titre`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937}\u{915} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Rech\xe8ch pa`,
    it: `Ricerca per titolo`,
    ja: `\u{30BF}\u{30A4}\u{30C8}\u{30EB}\u{304B}\u{3089}\u{63A2}\u{3059}`,
    ko: `\u{C81C}\u{BAA9}\u{C73C}\u{B85C} \u{AC80}\u{C0C9}`,
    mww: `Nrhiav lub npe`,
    ps: `\u{62F} \u{639}\u{646}\u{648}\u{627}\u{646} \u{644}\u{647} \u{645}\u{62E}\u{6D0} \u{67E}\u{644}\u{67C}\u{646}\u{647}`,
    pt: `Pesquisar por t\xedtulo`,
    "pt-pt": `Pesquisa por t\xedtulo`,
    ru: `\u{41F}\u{43E}\u{438}\u{441}\u{43A} \u{43F}\u{43E} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Saili i le ulutala`,
    so: `Raadi adigoo title ah`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E15}\u{E32}\u{E21}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{6A9}\u{6D2} \u{644}\u{62D}\u{627}\u{638} \u{633}\u{6D2} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm ki\u{1EBF}m theo ti\xeau \u{111}\u{1EC1}`,
    "zh-hans": `\u{6309}\u{6807}\u{9898}\u{641C}\u{7D22}`,
    "zh-hant": `\u{6309}\u{6A19}\u{984C}\u{641C}\u{7D22}`,
    en: `Search by title`
};
const $2868cc1235412e16$export$57996bf9020b996b = {
    ar: `\u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{644}\u{642}\u{627}\u{62D}\u{627}\u{62A} \u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Kommende Impfkliniken`,
    es: `Pr\xf3ximas cl\xednicas de vacunaci\xf3n`,
    fa: `\u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9} \u{647}\u{627}\u{6CC} \u{648}\u{627}\u{6A9}\u{633}\u{646} \u{622}\u{6CC}\u{646}\u{62F}\u{647}`,
    fil: `Mga paparating na klinika sa bakuna`,
    fr: `Prochaines cliniques de vaccination`,
    hi: `\u{906}\u{917}\u{93E}\u{92E}\u{940} \u{935}\u{948}\u{915}\u{94D}\u{938}\u{940}\u{928} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915}`,
    ht: `Klinik vaksen k ap vini yo`,
    it: `Prossime cliniche per i vaccini`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{30EF}\u{30AF}\u{30C1}\u{30F3}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}`,
    ko: `\u{B2E4}\u{AC00}\u{C624}\u{B294} \u{BC31}\u{C2E0} \u{D074}\u{B9AC}\u{B2C9}`,
    mww: `Yavtom ntej cov chaw txhaj tshuaj yavtom`,
    ps: `\u{62F} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `Pr\xf3ximas cl\xednicas de vacinas`,
    "pt-pt": `Pr\xf3ximas cl\xednicas de vacina\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{435} \u{432}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{44B}\u{435} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}\u{438}`,
    sm: `Falema'i o tui o lo'o lumana'i`,
    so: `Xarumo caafimaad oo talaal oo soo socda`,
    th: `\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9}`,
    vi: `C\xe1c ph\xf2ng kh\xe1m v\u{1EAF}c-xin s\u{1EAF}p t\u{1EDB}i`,
    "zh-hans": `\u{5373}\u{5C06}\u{6210}\u{7ACB}\u{7684}\u{75AB}\u{82D7}\u{8BCA}\u{6240}`,
    "zh-hant": `\u{5373}\u{5C07}\u{6210}\u{7ACB}\u{7684}\u{75AB}\u{82D7}\u{8A3A}\u{6240}`,
    en: `Upcoming vaccine clinics`
};
const $2868cc1235412e16$export$628276daeb5dfc7e = {
    ar: `\u{645}\u{643}\u{627}\u{646}`,
    de: `Ort`,
    es: `Ubicaci\xf3n`,
    fa: `\u{645}\u{62D}\u{644}`,
    fil: `Lokasyon`,
    fr: `Emplacement`,
    hi: `\u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote`,
    it: `Ubicazione`,
    ja: `\u{5834}\u{6240}`,
    ko: `\u{C704}\u{CE58}`,
    mww: `qhov chaw`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Localiza\xe7\xe3o`,
    "pt-pt": `Localiza\xe7\xe3o`,
    ru: `\u{41C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Nofoaga`,
    so: `Goobta`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{62C}\u{6AF}\u{6C1}`,
    vi: `V\u{1ECB} tr\xed`,
    "zh-hans": `\u{4F4D}\u{7F6E}`,
    "zh-hant": `\u{4F4D}\u{7F6E}`,
    en: `Location`
};
const $2868cc1235412e16$export$5c435af30e2c59d2 = {
    ar: `\u{627}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{639}\u{646}\u{648}\u{627}\u{646} \u{623}\u{648} \u{645}\u{62F}\u{64A}\u{646}\u{629} \u{623}\u{648} \u{648}\u{644}\u{627}\u{64A}\u{629} \u{623}\u{648} \u{631}\u{645}\u{632} \u{628}\u{631}\u{64A}\u{62F}\u{64A} \u{623}\u{648} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{645}\u{648}\u{642}\u{639}\u{643} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{64A}.`,
    de: `Suchen Sie nach einer Adresse, einer Stadt, einem Bundesland, einer Postleitzahl oder verwenden Sie Ihren aktuellen Standort.`,
    es: `Busque una direcci\xf3n, ciudad, estado, c\xf3digo postal o use su ubicaci\xf3n actual.`,
    fa: `\u{622}\u{62F}\u{631}\u{633}\u{60C} \u{634}\u{647}\u{631}\u{60C} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{60C} \u{641}\u{627}\u{6CC}\u{644} \u{641}\u{634}\u{631}\u{62F}\u{647} \u{631}\u{627} \u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6CC}\u{627} \u{627}\u{632} \u{645}\u{6A9}\u{627}\u{646} \u{641}\u{639}\u{644}\u{6CC} \u{62E}\u{648}\u{62F} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Maghanap para sa isang address, lungsod, estado, zip o gamitin ang iyong kasalukuyang lokasyon.`,
    fr: `Recherchez une adresse, une ville, un \xe9tat, un code postal ou utilisez votre emplacement actuel.`,
    hi: `\u{90F}\u{915} \u{92A}\u{924}\u{93E}, \u{936}\u{939}\u{930}, \u{930}\u{93E}\u{91C}\u{94D}\u{92F}, \u{91C}\u{93C}\u{93F}\u{92A} \u{916}\u{94B}\u{91C}\u{947}\u{902} \u{92F}\u{93E} \u{905}\u{92A}\u{928}\u{947} \u{935}\u{930}\u{94D}\u{924}\u{92E}\u{93E}\u{928} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Ch\xe8che yon adr\xe8s, vil, eta, zip oswa itilize kote ou ye kounye a.`,
    it: `Cerca un indirizzo, una citt\xe0, uno stato, un codice postale o usa la tua posizione attuale.`,
    ja: `\u{4F4F}\u{6240}\u{3001}\u{90FD}\u{5E02}\u{3001}\u{5DDE}\u{3001}\u{90F5}\u{4FBF}\u{756A}\u{53F7}\u{3092}\u{691C}\u{7D22}\u{3059}\u{308B}\u{304B}\u{3001}\u{73FE}\u{5728}\u{5730}\u{3092}\u{4F7F}\u{7528}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C8FC}\u{C18C}, \u{B3C4}\u{C2DC}, \u{C8FC}, \u{C6B0}\u{D3B8}\u{BC88}\u{D638}\u{B97C} \u{AC80}\u{C0C9}\u{D558}\u{AC70}\u{B098} \u{D604}\u{C7AC} \u{C704}\u{CE58}\u{B97C} \u{C0AC}\u{C6A9}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Nrhiav ib qhov chaw nyob, nroog, xeev, zip los yog siv koj qhov chaw nyob tam sim no.`,
    ps: `\u{6CC}\u{648} \u{67E}\u{62A}\u{647}\u{60C} \u{69A}\u{627}\u{631}\u{60C} \u{627}\u{6CC}\u{627}\u{644}\u{62A}\u{60C} \u{632}\u{67E} \u{648}\u{6AB}\u{648}\u{631}\u{626} \u{6CC}\u{627} \u{62E}\u{67E}\u{644} \u{627}\u{648}\u{633}\u{646}\u{6CC} \u{681}\u{627}\u{6CC} \u{648}\u{6A9}\u{627}\u{631}\u{648}\u{626}.`,
    pt: `Pesquise um endere\xe7o, cidade, estado, CEP ou use sua localiza\xe7\xe3o atual.`,
    "pt-pt": `Procure um endere\xe7o, cidade, estado, zip ou use sua localiza\xe7\xe3o atual.`,
    ru: `\u{412}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435} \u{43F}\u{43E}\u{438}\u{441}\u{43A} \u{43F}\u{43E} \u{430}\u{434}\u{440}\u{435}\u{441}\u{443}, \u{433}\u{43E}\u{440}\u{43E}\u{434}\u{443}, \u{448}\u{442}\u{430}\u{442}\u{443}, \u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{43E}\u{43C}\u{443} \u{438}\u{43D}\u{434}\u{435}\u{43A}\u{441}\u{443} \u{438}\u{43B}\u{438} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{435} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{435}\u{435} \u{43C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}.`,
    sm: `Saili mo se tuatusi, taulaga, setete, zip pe fa'aaoga lou nofoaga o lo'o i ai nei.`,
    so: `Raadi cinwaan, magaalo, gobol, zip ama isticmaal meesha aad hadda joogto.`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E40}\u{E21}\u{E37}\u{E2D}\u{E07} \u{E23}\u{E31}\u{E10} zip \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E43}\u{E0A}\u{E49}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{67E}\u{62A}\u{6C1} \u{60C} \u{634}\u{6C1}\u{631} \u{60C} \u{631}\u{6CC}\u{627}\u{633}\u{62A} \u{60C} \u{632}\u{67E} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{6CC}\u{627} \u{627}\u{67E}\u{646}\u{6D2} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{6C1} \u{645}\u{642}\u{627}\u{645} \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xecm ki\u{1EBF}m \u{111}\u{1ECB}a ch\u{1EC9}, th\xe0nh ph\u{1ED1}, ti\u{1EC3}u bang, zip ho\u{1EB7}c s\u{1EED} d\u{1EE5}ng v\u{1ECB} tr\xed hi\u{1EC7}n t\u{1EA1}i c\u{1EE7}a b\u{1EA1}n.`,
    "zh-hans": `\u{641C}\u{7D22}\u{5730}\u{5740}\u{3001}\u{57CE}\u{5E02}\u{3001}\u{5DDE}\u{3001}\u{90AE}\u{653F}\u{7F16}\u{7801}\u{6216}\u{4F7F}\u{7528}\u{60A8}\u{5F53}\u{524D}\u{7684}\u{4F4D}\u{7F6E}\u{3002}`,
    "zh-hant": `\u{641C}\u{7D22}\u{4F4D}\u{5740}\u{3001}\u{57CE}\u{5E02}\u{3001}\u{5DDE}\u{3001}\u{90F5}\u{905E}\u{5340}\u{865F}\u{6216}\u{4F7F}\u{7528}\u{60A8}\u{7576}\u{524D}\u{7684}\u{4F4D}\u{7F6E}\u{3002}`,
    en: `Search for an address, city, state, zip or use your current location.`
};
const $2868cc1235412e16$export$4567b664cc755c4d = {
    ar: `\u{646}\u{637}\u{627}\u{642}`,
    de: `Bereich`,
    es: `Gama`,
    fa: `\u{645}\u{62D}\u{62F}\u{648}\u{62F}\u{647}`,
    fil: `Saklaw`,
    fr: `Gamme`,
    hi: `\u{936}\u{94D}\u{930}\u{947}\u{923}\u{940}`,
    ht: `P\xf2te`,
    it: `Gamma`,
    ja: `\u{7BC4}\u{56F2}`,
    ko: `\u{B808}\u{C778}\u{C9C0}`,
    mww: `Ntau yam`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Gama`,
    "pt-pt": `Gama`,
    ru: `\u{414}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}`,
    sm: `Tele`,
    so: `Range`,
    th: `\u{E40}\u{E17}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{631}\u{6CC}\u{646}\u{62C}`,
    vi: `Ph\u{1EA1}m vi`,
    "zh-hans": `\u{8303}\u{56F4}`,
    "zh-hant": `\u{7BC4}\u{570D}`,
    en: `Range`
};
const $2868cc1235412e16$export$c06f7f206b1f633e = {
    ar: `50 \u{645}\u{64A}\u{644}\u{627}`,
    de: `50 Meilen`,
    es: `50 millas`,
    fa: `50 \u{645}\u{627}\u{6CC}\u{644}`,
    fil: `50 milya`,
    fr: `50 milles`,
    hi: `50 \u{92E}\u{940}\u{932} \u{915}\u{940} \u{926}\u{942}\u{930}\u{940}`,
    ht: `50 kilom\xe8t`,
    it: `50 miglia`,
    ja: `50\u{30DE}\u{30A4}\u{30EB}`,
    ko: `50 \u{B9C8}\u{C77C}`,
    mww: `50 mais`,
    ps: `50 \u{645}\u{6CC}\u{644}\u{647}`,
    pt: `50 milhas`,
    "pt-pt": `50 milhas`,
    ru: `50 \u{43C}\u{438}\u{43B}\u{44C}`,
    sm: `50 maila`,
    so: `50 miles`,
    th: `80.1 \u{E01}\u{E21}.`,
    ur: `50 \u{645}\u{6CC}\u{644}`,
    vi: `50 d\u{1EB7}m`,
    "zh-hans": `50 \u{82F1}\u{91CC}`,
    "zh-hant": `50 \u{82F1}\u{91CC}`,
    en: `50 miles`
};
const $2868cc1235412e16$export$7619abd293e6c35f = {
    ar: `100 \u{645}\u{64A}\u{644}`,
    de: `100 Meilen`,
    es: `100 millas`,
    fa: `100 \u{645}\u{627}\u{6CC}\u{644}`,
    fil: `100 milya`,
    fr: `100 milles`,
    hi: `100 \u{92E}\u{940}\u{932}`,
    ht: `100 kilom\xe8t`,
    it: `100 miglia`,
    ja: `100\u{30DE}\u{30A4}\u{30EB}`,
    ko: `100 \u{B9C8}\u{C77C}`,
    mww: `100 mais`,
    ps: `100 \u{645}\u{6CC}\u{644}\u{647}`,
    pt: `100 milhas`,
    "pt-pt": `100 milhas`,
    ru: `100 \u{43C}\u{438}\u{43B}\u{44C}`,
    sm: `100 maila`,
    so: `100 miles`,
    th: `160 \u{E01}\u{E21}.`,
    ur: `100 \u{645}\u{6CC}\u{644}`,
    vi: `100 d\u{1EB7}m`,
    "zh-hans": `100 \u{82F1}\u{91CC}`,
    "zh-hant": `100 \u{82F1}\u{91CC}`,
    en: `100 miles`
};
const $2868cc1235412e16$export$5f69a1e589fa8200 = {
    ar: `\u{645}\u{648}\u{642}\u{639} \u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
    de: `Nicht n\xe4her bezeichneter Ort`,
    es: `Ubicaci\xf3n no especificada`,
    fa: `\u{645}\u{6A9}\u{627}\u{646} \u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Hindi tinukoy na lokasyon`,
    fr: `Emplacement non sp\xe9cifi\xe9`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F} \u{938}\u{94D}\u{925}\u{93E}\u{928}`,
    ht: `Kote ki pa espesifye`,
    it: `Localit\xe0 non specificata`,
    ja: `\u{5834}\u{6240}\u{4E0D}\u{660E}`,
    ko: `\u{C9C0}\u{C815}\u{B418}\u{C9C0} \u{C54A}\u{C740} \u{C704}\u{CE58}`,
    mww: `Unspecified qhov chaw`,
    ps: `\u{646}\u{627}\u{645}\u{634}\u{62E}\u{635} \u{681}\u{627}\u{6CC}`,
    pt: `Localiza\xe7\xe3o n\xe3o especificada`,
    "pt-pt": `Localiza\xe7\xe3o n\xe3o especificada`,
    ru: `\u{41C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{43D}\u{435} \u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{43E}`,
    sm: `Nofoaga e le'i fa'amaonia`,
    so: `Goob aan la cayimin`,
    th: `\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{645}\u{62A}\u{639}\u{6CC}\u{646} \u{645}\u{642}\u{627}\u{645}`,
    vi: `V\u{1ECB} tr\xed kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{672A}\u{6307}\u{5B9A}\u{4F4D}\u{7F6E}`,
    "zh-hant": `\u{672A}\u{6307}\u{5B9A}\u{4F4D}\u{7F6E}`,
    en: `Unspecified location`
};
const $2868cc1235412e16$export$43611afc6ffa7128 = {
    ar: (distance)=>`\u{639}\u{644}\u{649} \u{628}\u{639}\u{62F} ${distance} \u{623}\u{645}\u{64A}\u{627}\u{644}`,
    de: (distance)=>`${distance} Meilen entfernt`,
    es: (distance)=>`${distance} millas de distancia`,
    fa: (distance)=>`${distance} \u{645}\u{627}\u{6CC}\u{644} \u{62F}\u{648}\u{631}\u{62A}\u{631}`,
    fil: (distance)=>`${distance} km ang layo`,
    fr: (distance)=>`${distance} milles`,
    hi: (distance)=>`${distance} \u{92E}\u{940}\u{932} \u{926}\u{942}\u{930}`,
    ht: (distance)=>`${distance} kilom\xe8t lwen`,
    it: (distance)=>`${distance} miglia di distanza`,
    ja: (distance)=>`${distance} \u{30DE}\u{30A4}\u{30EB}\u{96E2}\u{308C}\u{3066}`,
    ko: (distance)=>`${distance} \u{B5A8}\u{C5B4}\u{C9D0}`,
    mww: (distance)=>`${distance} mais tam sim ntawd`,
    ps: (distance)=>`${distance} \u{645}\u{6CC}\u{644}\u{647} \u{644}\u{631}\u{6D0}`,
    pt: (distance)=>`${distance} milhas de dist\xe2ncia`,
    "pt-pt": (distance)=>`${distance} milhas de dist\xe2ncia`,
    ru: (distance)=>`${distance} \u{43A}\u{43C}`,
    sm: (distance)=>`${distance} maila le mamao`,
    so: (distance)=>`${distance} miles aways`,
    th: (distance)=>`\u{E2B}\u{E48}\u{E32}\u{E07}\u{E2D}\u{E2D}\u{E01}\u{E44}\u{E1B} ${distance} \u{E01}\u{E21}.`,
    ur: (distance)=>`${distance} \u{645}\u{6CC}\u{644} \u{62F}\u{648}\u{631}`,
    vi: (distance)=>`C\xe1ch ${distance} d\u{1EB7}m`,
    "zh-hans": (distance)=>`${distance} \u{82F1}\u{91CC}`,
    "zh-hant": (distance)=>`${distance} \u{82F1}\u{91CC}`,
    en: (distance)=>`${distance} miles away`
};
const $2868cc1235412e16$export$d9ef83e0281253ed = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A} \u{644}\u{642}\u{627}\u{62D} \u{642}\u{627}\u{62F}\u{645}\u{629}`,
    de: `Keine bevorstehenden Impfkliniken`,
    es: `No hay pr\xf3ximas cl\xednicas de vacunaci\xf3n`,
    fa: `\u{647}\u{6CC}\u{686} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9} \u{648}\u{627}\u{6A9}\u{633}\u{646} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang paparating na mga klinika sa bakuna`,
    fr: `Pas de cliniques de vaccination \xe0 venir`,
    hi: `\u{915}\u{94B}\u{908} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{935}\u{948}\u{915}\u{94D}\u{938}\u{940}\u{928} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen klinik vaksen k ap vini`,
    it: `Nessuna clinica per i vaccini in arrivo`,
    ja: `\u{4ECA}\u{5F8C}\u{306E}\u{30EF}\u{30AF}\u{30C1}\u{30F3}\u{63A5}\u{7A2E}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C608}\u{C815}\u{B41C} \u{BC31}\u{C2E0} \u{D074}\u{B9AC}\u{B2C9} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj tshuaj yavtom ntej`,
    ps: `\u{627}\u{633}\u{67C}\u{631}\u{627}\u{644}\u{6CC}\u{627} \u{6A9}\u{6D0} \u{62F} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9} \u{634}\u{62A}\u{648}\u{646} \u{646}\u{647} \u{644}\u{631}\u{6CC}`,
    pt: `Nenhuma cl\xednica de vacinas futura`,
    "pt-pt": `N\xe3o h\xe1 pr\xf3ximas cl\xednicas de vacina\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{43E}\u{44F}\u{449}\u{438}\u{445} \u{432}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{44B}\u{445} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A} \u{43D}\u{435}\u{442}`,
    sm: `Leai se falema'i tui o lo'o lumana'i`,
    so: `Majiraan xarumo talaal oo soo socda`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{622}\u{626}\u{646}\u{62F}\u{6C1} \u{6A9}\u{648}\u{626}\u{6CC} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ph\xf2ng kh\xe1m v\u{1EAF}c-xin s\u{1EAF}p t\u{1EDB}i`,
    "zh-hans": `\u{6CA1}\u{6709}\u{5373}\u{5C06}\u{5230}\u{6765}\u{7684}\u{75AB}\u{82D7}\u{8BCA}\u{6240}`,
    "zh-hant": `\u{6C92}\u{6709}\u{5373}\u{5C07}\u{5230}\u{4F86}\u{7684}\u{75AB}\u{82D7}\u{8A3A}\u{6240}`,
    en: `No upcoming vaccine clinics`
};
const $2868cc1235412e16$export$bb4351fd313d52e7 = {
    ar: `\u{633}\u{64A}\u{62A}\u{645} \u{633}\u{631}\u{62F} \u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{644}\u{642}\u{627}\u{62D}\u{627}\u{62A} \u{627}\u{644}\u{642}\u{627}\u{62F}\u{645}\u{629} \u{636}\u{645}\u{646} \u{627}\u{644}\u{646}\u{637}\u{627}\u{642} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F} \u{647}\u{646}\u{627}.`,
    de: `Kommende Impfkliniken innerhalb des ausgew\xe4hlten Sortiments werden hier aufgelistet.`,
    es: `Las pr\xf3ximas cl\xednicas de vacunaci\xf3n dentro del rango seleccionado se enumerar\xe1n aqu\xed.`,
    fa: `\u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9} \u{647}\u{627}\u{6CC} \u{648}\u{627}\u{6A9}\u{633}\u{646} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{62F}\u{631} \u{645}\u{62D}\u{62F}\u{648}\u{62F}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646}\u{62C}\u{627} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: `Ang mga paparating na klinika ng bakuna sa loob ng napiling saklaw ay nakalista dito.`,
    fr: `Les prochaines cliniques de vaccination dans la plage s\xe9lectionn\xe9e seront r\xe9pertori\xe9es ici.`,
    hi: `\u{91A}\u{92F}\u{928}\u{93F}\u{924} \u{938}\u{940}\u{92E}\u{93E} \u{915}\u{947} \u{92D}\u{940}\u{924}\u{930} \u{906}\u{917}\u{93E}\u{92E}\u{940} \u{935}\u{948}\u{915}\u{94D}\u{938}\u{940}\u{928} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915} \u{92F}\u{939}\u{93E}\u{902} \u{938}\u{942}\u{91A}\u{940}\u{92C}\u{926}\u{94D}\u{927} \u{915}\u{93F}\u{90F} \u{91C}\u{93E}\u{90F}\u{902}\u{917}\u{947}\u{964}`,
    ht: `Klinik vaksen k ap vini nan seri a chwazi yo pral ki nan lis isit la.`,
    it: `Le prossime cliniche per i vaccini all'interno dell'intervallo selezionato saranno elencate qui.`,
    ja: `\u{9078}\u{629E}\u{3057}\u{305F}\u{7BC4}\u{56F2}\u{5185}\u{3067}\u{4ECA}\u{5F8C}\u{958B}\u{50AC}\u{3055}\u{308C}\u{308B}\u{30EF}\u{30AF}\u{30C1}\u{30F3}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}\u{306F}\u{3001}\u{3053}\u{3053}\u{306B}\u{30EA}\u{30B9}\u{30C8}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C120}\u{D0DD}\u{D55C} \u{BC94}\u{C704} \u{B0B4}\u{C5D0}\u{C11C} \u{C608}\u{C815}\u{B41C} \u{BC31}\u{C2E0} \u{D074}\u{B9AC}\u{B2C9}\u{C774} \u{C5EC}\u{AE30}\u{C5D0} \u{B098}\u{C5F4}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Yavtom ntej cov chaw kho mob nyob rau hauv cov kev xaiv ntau yam yuav muaj nyob ntawm no.`,
    ps: `\u{62F} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{628}\u{647} \u{67E}\u{647} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{644}\u{693} \u{6A9}\u{6D0} \u{62F}\u{644}\u{62A}\u{647} \u{644}\u{633}\u{62A} \u{634}\u{6CC}.`,
    pt: `As pr\xf3ximas cl\xednicas de vacinas dentro da faixa selecionada ser\xe3o listadas aqui.`,
    "pt-pt": `As pr\xf3ximas cl\xednicas de vacina\xe7\xe3o dentro da faixa selecionada ser\xe3o listadas aqui.`,
    ru: `\u{411}\u{43B}\u{438}\u{436}\u{430}\u{439}\u{448}\u{438}\u{435} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}\u{438} \u{432}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}\u{446}\u{438}\u{438} \u{432} \u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{430}\u{445} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{430} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{44B} \u{437}\u{434}\u{435}\u{441}\u{44C}.`,
    sm: `O falema'i o lo'o lumana'i i totonu o le vaega filifilia o le a lisiina iinei.`,
    so: `Xarumaha caafimaad ee soo socda ee talaalka ee soo socda ee ku guda jiro qaybta laga soo xulay ayaa lagu soo dari doonaa halkan.`,
    th: `\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E08}\u{E30}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E17}\u{E35}\u{E48}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E08}\u{E30}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}`,
    ur: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{62F}\u{6C1} \u{631}\u{6CC}\u{646}\u{62C} \u{6A9}\u{6D2} \u{627}\u{646}\u{62F}\u{631} \u{622}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9} \u{6CC}\u{6C1}\u{627}\u{6BA} \u{62F}\u{631}\u{62C} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627}\u{626}\u{6CC}\u{6BA} \u{6AF}\u{6D2}\u{6D4}`,
    vi: `C\xe1c ph\xf2ng kh\xe1m v\u{1EAF}c-xin s\u{1EAF}p t\u{1EDB}i trong ph\u{1EA1}m vi \u{111}\xe3 ch\u{1ECD}n s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c li\u{1EC7}t k\xea t\u{1EA1}i \u{111}\xe2y.`,
    "zh-hans": `\u{6B64}\u{5904}\u{5C06}\u{5217}\u{51FA}\u{6240}\u{9009}\u{8303}\u{56F4}\u{5185}\u{5373}\u{5C06}\u{6210}\u{7ACB}\u{7684}\u{75AB}\u{82D7}\u{8BCA}\u{6240}\u{3002}`,
    "zh-hant": `\u{6B64}\u{8655}\u{5C07}\u{5217}\u{51FA}\u{6240}\u{9078}\u{7BC4}\u{570D}\u{5167}\u{5373}\u{5C07}\u{6210}\u{7ACB}\u{7684}\u{75AB}\u{82D7}\u{8A3A}\u{6240}\u{3002}`,
    en: `Upcoming vaccine clinics within the selected range will be listed here.`
};
const $2868cc1235412e16$export$7619b24364f89159 = {
    ar: `\u{639}\u{64A}\u{627}\u{62F}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629}`,
    de: `Eine Klinik`,
    es: `Una cl\xednica`,
    fa: `\u{6CC}\u{6A9} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}`,
    fil: `Isang klinika`,
    fr: `Une clinique`,
    hi: `\u{90F}\u{915} \u{915}\u{94D}\u{932}\u{93F}\u{928}\u{93F}\u{915}`,
    ht: `Yon klinik`,
    it: `Una clinica`,
    ja: `1\u{3064}\u{306E}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}`,
    ko: `\u{D558}\u{B098}\u{C758} \u{D074}\u{B9AC}\u{B2C9}`,
    mww: `ib lub tsev kho mob`,
    ps: `\u{6CC}\u{648} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}`,
    pt: `Uma cl\xednica`,
    "pt-pt": `Uma cl\xednica`,
    ru: `\u{41E}\u{434}\u{43D}\u{430} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}\u{430}`,
    sm: `Tasi le falema'i`,
    so: `Hal taliinik`,
    th: `\u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9}`,
    vi: `M\u{1ED9}t ph\xf2ng kh\xe1m`,
    "zh-hans": `\u{4E00}\u{5BB6}\u{8BCA}\u{6240}`,
    "zh-hant": `\u{4E00}\u{5BB6}\u{8A3A}\u{6240}`,
    en: `One clinic`
};
const $2868cc1235412e16$export$350b3a9617100f99 = {
    ar: (count)=>`${count} \u{639}\u{64A}\u{627}\u{62F}\u{627}\u{62A}`,
    de: (count)=>`${count} Kliniken`,
    es: (count)=>`${count} cl\xednicas`,
    fa: (count)=>`${count} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}`,
    fil: (count)=>`${count} Mga klinika`,
    fr: (count)=>`${count} cliniques`,
    hi: (count)=>`${count} \u{915}\u{94D}\u{932}\u{940}\u{928}\u{93F}\u{915}`,
    ht: (count)=>`${count} klinik`,
    it: (count)=>`${count} cliniche`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{30AF}\u{30EA}\u{30CB}\u{30C3}\u{30AF}`,
    ko: (count)=>`${count} \u{D074}\u{B9AC}\u{B2C9}`,
    mww: (count)=>`${count} lub tsev kho mob`,
    ps: (count)=>`${count} \u{6A9}\u{644}\u{6CC}\u{646}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} cl\xednicas`,
    "pt-pt": (count)=>`${count} cl\xednicas`,
    ru: (count)=>`${count} \u{43A}\u{43B}\u{438}\u{43D}\u{438}\u{43A}`,
    sm: (count)=>`${count} falema'i`,
    so: (count)=>`${count} kiliinikada`,
    th: (count)=>`${count} \u{E04}\u{E25}\u{E34}\u{E19}\u{E34}\u{E01}`,
    ur: (count)=>`${count} \u{6A9}\u{644}\u{6CC}\u{646}\u{6A9}\u{633}`,
    vi: (count)=>`${count} ph\xf2ng kh\xe1m`,
    "zh-hans": (count)=>`${count} \u{5BB6}\u{8BCA}\u{6240}`,
    "zh-hant": (count)=>`${count} \u{5BB6}\u{8A3A}\u{6240}`,
    en: (count)=>`${count} clinics`
};
const $2868cc1235412e16$export$ac7cf36c103be088 = {
    ar: `\u{623}\u{64A} \u{645}\u{633}\u{627}\u{641}\u{629}`,
    de: `Beliebige Entfernung`,
    es: `Cualquier distancia`,
    fa: `\u{647}\u{631} \u{641}\u{627}\u{635}\u{644}\u{647} \u{627}\u{6CC}`,
    fil: `Anumang distansya`,
    fr: `N\u{2019}importe quelle distance`,
    hi: `\u{915}\u{94B}\u{908} \u{92D}\u{940} \u{926}\u{942}\u{930}\u{940}`,
    ht: `Nenp\xf2t distans`,
    it: `Qualsiasi distanza`,
    ja: `\u{4EFB}\u{610F}\u{306E}\u{8DDD}\u{96E2}`,
    ko: `\u{BAA8}\u{B4E0} \u{AC70}\u{B9AC}`,
    mww: `nyob deb li cas`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Qualquer dist\xe2ncia`,
    "pt-pt": `Qualquer dist\xe2ncia`,
    ru: `\u{41B}\u{44E}\u{431}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}`,
    sm: `So'o se mamao`,
    so: `Meel kasta oo u fog`,
    th: `\u{E23}\u{E30}\u{E22}\u{E30}\u{E17}\u{E32}\u{E07}\u{E43}\u{E14}\u{E01}\u{E47}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{641}\u{627}\u{635}\u{644}\u{6C1}`,
    vi: `B\u{1EA5}t k\u{1EF3} kho\u{1EA3}ng c\xe1ch n\xe0o`,
    "zh-hans": `\u{4EFB}\u{4F55}\u{8DDD}\u{79BB}`,
    "zh-hant": `\u{4EFB}\u{4F55}\u{8DDD}\u{96E2}`,
    en: `Any distance`
};
const $2868cc1235412e16$export$52b278509a791a5 = {
    ar: (distance, location)=>`${distance} \u{645}\u{646} ${location}`,
    de: (distance, location)=>`${distance} von ${location}`,
    es: (distance, location)=>`${distance} de ${location}`,
    fa: (distance, location)=>`${distance} \u{627}\u{632} ${location}`,
    fil: (distance, location)=>`${distance} mula sa ${location}`,
    fr: (distance, location)=>`${distance} de ${location}`,
    hi: (location, distance)=>`${location} \u{938}\u{947} ${distance}`,
    ht: (distance, location)=>`${distance} soti nan ${location}`,
    it: (distance, location)=>`${distance} da ${location}`,
    ja: (location, distance)=>`${location}\u{304B}\u{3089}${distance}`,
    ko: (location, distance)=>`${location}\u{C5D0}\u{C11C} ${distance}`,
    mww: (distance, location)=>`${distance} ntawm ${location}`,
    ps: (distance, location)=>`${distance} from ${location}`,
    pt: (distance, location)=>`${distance} de ${location}`,
    "pt-pt": (distance, location)=>`${distance} de ${location}`,
    ru: (distance, location)=>`${distance} \u{43E}\u{442} ${location}`,
    sm: (distance, location)=>`${distance} mai le ${location}`,
    so: (distance, location)=>`${distance} u ${location}`,
    th: (distance, location)=>`${distance} \u{E08}\u{E32}\u{E01} ${location}`,
    ur: (location, distance)=>`${location} \u{633}\u{6D2} ${distance}`,
    vi: (distance, location)=>`${distance} t\u{1EEB} ${location}`,
    "zh-hans": (location, distance)=>`\u{8DDD}\u{79BB} ${location} ${distance}`,
    "zh-hant": (location, distance)=>`\u{8DDD}\u{96E2} ${location} ${distance}`,
    en: (distance, location)=>`${distance} from ${location}`
};
const $2868cc1235412e16$export$3417ff84b5e88121 = {
    ar: `10 \u{623}\u{645}\u{64A}\u{627}\u{644}`,
    de: `10 Meilen`,
    es: `10 millas`,
    fa: `10 \u{645}\u{627}\u{6CC}\u{644}`,
    fil: `10 milya`,
    fr: `10 milles`,
    hi: `10 \u{92E}\u{940}\u{932}`,
    ht: `10 kilom\xe8t`,
    it: `10 miglia`,
    ja: `10\u{30DE}\u{30A4}\u{30EB}`,
    ko: `10 \u{B9C8}\u{C77C}`,
    mww: `10 mais`,
    ps: `10 \u{645}\u{6CC}\u{644}\u{647}`,
    pt: `10 milhas`,
    "pt-pt": `10 milhas`,
    ru: `10 \u{43C}\u{438}\u{43B}\u{44C}`,
    sm: `10 maila`,
    so: `10 miles`,
    th: `16.1 \u{E01}\u{E21}.`,
    ur: `10 \u{645}\u{6CC}\u{644}`,
    vi: `10 d\u{1EB7}m`,
    "zh-hans": `10 \u{82F1}\u{91CC}`,
    "zh-hant": `10 \u{82F1}\u{91CC}`,
    en: `10 miles`
};
const $2868cc1235412e16$export$a71a2b68f9dc2327 = {
    ar: `\u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Datum`,
    es: `Fecha`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    fil: `Petsa`,
    fr: `Date`,
    hi: `\u{916}\u{91C}\u{942}\u{930}`,
    ht: `Dat`,
    it: `Dattero`,
    ja: `\u{65E5}\u{4ED8}`,
    ko: `\u{B0A0}\u{C9DC}`,
    mww: `Hnub`,
    ps: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    pt: `Data`,
    "pt-pt": `Data`,
    ru: `\u{414}\u{430}\u{442}\u{430}`,
    sm: `Aso`,
    so: `Date`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    vi: `Ng\xe0y`,
    "zh-hans": `\u{65E5}\u{671F}`,
    "zh-hant": `\u{65E5}\u{671F}`,
    en: `Date`
};
const $2868cc1235412e16$export$9b48d93bf8321532 = {
    ar: `\u{628}\u{648}\u{646}`,
    de: `Abstand`,
    es: `Distancia`,
    fa: `\u{641}\u{627}\u{635}\u{644}\u{647}`,
    fil: `Distansya`,
    fr: `Distance`,
    hi: `\u{926}\u{942}\u{930}\u{940}`,
    ht: `Distans`,
    it: `Distanza`,
    ja: `\u{8DDD}\u{96E2}`,
    ko: `\u{AC70}\u{B9AC}`,
    mww: `nyob deb li cas`,
    ps: `\u{648}\u{627}\u{67C}\u{646}`,
    pt: `Dist\xe2ncia`,
    "pt-pt": `Dist\xe2ncia`,
    ru: `\u{420}\u{430}\u{441}\u{441}\u{442}\u{43E}\u{44F}\u{43D}\u{438}\u{435}`,
    sm: `Mamao`,
    so: `Distance`,
    th: `\u{E23}\u{E30}\u{E22}\u{E30}\u{E17}\u{E32}\u{E07}`,
    ur: `\u{641}\u{627}\u{635}\u{644}\u{6C1}`,
    vi: `Kho\u{1EA3}ng c\xe1ch`,
    "zh-hans": `\u{8DDD}\u{79BB}`,
    "zh-hant": `\u{8DDD}\u{96E2}`,
    en: `Distance`
};
const $2868cc1235412e16$export$6526f51dd1e52ad2 = {
    ar: `\u{643}\u{633}\u{644}\u{627}\u{646}`,
    de: `Inaktiv`,
    es: `Inactivo`,
    fa: `\u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644}`,
    fil: `Hindi aktibo`,
    fr: `Inactif`,
    hi: `\u{928}\u{93F}\u{937}\u{94D}\u{915}\u{94D}\u{930}\u{93F}\u{92F}`,
    ht: `Inaktif`,
    it: `Inattivo`,
    ja: `\u{4E0D}\u{6D3B}\u{767A}\u{306A}`,
    ko: `\u{AC8C}\u{C73C}\u{B978}`,
    mww: `ua tsis taus pa`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Inativo`,
    "pt-pt": `Inativo`,
    ru: `\u{41D}\u{435}\u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{439}`,
    sm: `Le toaga`,
    so: `Inactive`,
    th: `\u{E40}\u{E01}\u{E35}\u{E22}\u{E08}\u{E04}\u{E23}\u{E49}\u{E32}\u{E19}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{641}\u{639}\u{627}\u{644}`,
    vi: `Kh\xf4ng ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{65E0}\u{6548}`,
    "zh-hant": `\u{7121}\u{6548}`,
    en: `Inactive`
};
const $2868cc1235412e16$export$5f3f16f9a09161d9 = {
    ar: `\u{639}\u{642}\u{62F}`,
    de: `Vertrag`,
    es: `Contrato`,
    fa: `\u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F}`,
    fil: `Kontrata`,
    fr: `Contrat`,
    hi: `\u{907}\u{915}\u{93C}\u{930}\u{93E}\u{930}\u{928}\u{93E}\u{92E}\u{93E} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Kontra`,
    it: `Contratto`,
    ja: `\u{5951}\u{7D04}`,
    ko: `\u{ACC4}\u{C57D}`,
    mww: `daim ntawv cog lus`,
    ps: `\u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F}`,
    pt: `Contrato`,
    "pt-pt": `Contrato`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{440}\u{430}\u{43A}\u{442}`,
    sm: `Konekarate`,
    so: `Heshiiska`,
    th: `\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}`,
    ur: `\u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6C1}`,
    vi: `H\u{1EE3}p \u{111}\u{1ED3}ng`,
    "zh-hans": `\u{5408}\u{540C}`,
    "zh-hant": `\u{5408}\u{540C}`,
    en: `Contract`
};
const $2868cc1235412e16$export$e02e892747becbe2 = {
    ar: `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{648}\u{627}\u{636}\u{62D}`,
    de: `Auswahl aufheben`,
    es: `Borrar selecci\xf3n`,
    fa: `\u{67E}\u{627}\u{6A9} \u{6A9}\u{631}\u{62F}\u{646} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}`,
    fil: `I-clear ang pagpili`,
    fr: `Effacer la s\xe9lection`,
    hi: `\u{91A}\u{92F}\u{928} \u{938}\u{93E}\u{92B}\u{93C} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Seleksyon kl\xe8`,
    it: `Cancella selezione`,
    ja: `\u{9078}\u{629E}\u{3092}\u{30AF}\u{30EA}\u{30A2}`,
    ko: `\u{C120}\u{D0DD} \u{C601}\u{C5ED} \u{C9C0}\u{C6B0}\u{AE30}`,
    mww: `xaiv tsa`,
    ps: `\u{62F} \u{67C}\u{627}\u{6A9}\u{646}\u{6D0} \u{67E}\u{627}\u{6A9}\u{648}\u{644}`,
    pt: `Limpar sele\xe7\xe3o`,
    "pt-pt": `Sele\xe7\xe3o clara`,
    ru: `\u{41E}\u{447}\u{438}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{43E}\u{440}`,
    sm: `Filifiliga manino`,
    so: `Xulashada clear`,
    th: `\u{E25}\u{E49}\u{E32}\u{E07}\u{E01}\u{E32}\u{E23}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{648}\u{627}\u{636}\u{62D} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}`,
    vi: `L\u{1EF1}a ch\u{1ECD}n r\xf5 r\xe0ng`,
    "zh-hans": `\u{6E05}\u{9664}\u{9009}\u{62E9}`,
    "zh-hant": `\u{6E05}\u{9664}\u{9078}\u{64C7}`,
    en: `Clear selection`
};
const $2868cc1235412e16$export$323c96d727586c01 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{648}\u{62C}\u{648}\u{62F}`,
    de: `Zur Zeit nicht gefunden`,
    es: `No encontrado`,
    fa: `\u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F}`,
    fil: `Hindi natagpuan`,
    fr: `Non trouv\xe9`,
    hi: `\u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa jwenn`,
    it: `Non trovato`,
    ja: `\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{CC3E}\u{C744} \u{C218} \u{C5C6}\u{C74C}`,
    mww: `nrhiav tsis tau`,
    ps: `\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}`,
    pt: `N\xe3o encontrado`,
    "pt-pt": `N\xe3o encontrado`,
    ru: `\u{41D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43E}`,
    sm: `E le'i maua`,
    so: `Lama helin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}`,
    ur: `\u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{627}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y`,
    "zh-hans": `\u{672A}\u{627E}\u{5230}`,
    "zh-hant": `\u{672A}\u{627E}\u{5230}`,
    en: `Not found`
};
const $2868cc1235412e16$export$6c160a05a0ea4da0 = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{637}\u{644}\u{628}\u{62A}\u{647}\u{627}.`,
    de: `Die von Ihnen angeforderte Seite kann nicht gefunden werden.`,
    es: `No se puede encontrar la p\xe1gina que solicit\xf3.`,
    fa: `\u{635}\u{641}\u{62D}\u{647} \u{627}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F} \u{67E}\u{6CC}\u{62F}\u{627} \u{646}\u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Hindi matagpuan ang pahinang hiniling mo.`,
    fr: `La page que vous avez demand\xe9e est introuvable.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927}\u{93F}\u{924} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932} \u{938}\u{915}\u{93E}.`,
    ht: `Paj ou te mande a pa ka jwenn.`,
    it: `Impossibile trovare la pagina richiesta.`,
    ja: `\u{30EA}\u{30AF}\u{30A8}\u{30B9}\u{30C8}\u{3057}\u{305F}\u{30DA}\u{30FC}\u{30B8}\u{304C}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C694}\u{CCAD}\u{D55C} \u{D398}\u{C774}\u{C9C0}\u{B97C} \u{CC3E}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Nplooj ntawv koj thov tsis tau.`,
    ps: `\u{647}\u{63A}\u{647} \u{67E}\u{627}\u{6BC}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{6A9}\u{693}\u{6D0} \u{62F}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{646}\u{647} \u{634}\u{6CC}.`,
    pt: `A p\xe1gina que voc\xea solicitou n\xe3o pode ser encontrada.`,
    "pt-pt": `A p\xe1gina solicitada n\xe3o pode ser encontrada.`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{43E}\u{448}\u{435}\u{43D}\u{43D}\u{430}\u{44F} \u{432}\u{430}\u{43C}\u{438} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430} \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{430}.`,
    sm: `E le mafai ona maua le itulau na e talosagaina.`,
    so: `Bogga aad codsatay lama heli karo.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E23}\u{E49}\u{E2D}\u{E07}\u{E02}\u{E2D}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{631}\u{62F}\u{6C1} \u{635}\u{641}\u{62D}\u{6C1} \u{62A}\u{644}\u{627}\u{634} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627} \u{633}\u{6A9}\u{62A}\u{627}\u{6D4}`,
    vi: `Kh\xf4ng th\u{1EC3} t\xecm th\u{1EA5}y trang b\u{1EA1}n y\xeau c\u{1EA7}u.`,
    "zh-hans": `\u{627E}\u{4E0D}\u{5230}\u{60A8}\u{8BF7}\u{6C42}\u{7684}\u{9875}\u{9762}\u{3002}`,
    "zh-hant": `\u{627E}\u{4E0D}\u{5230}\u{60A8}\u{8ACB}\u{6C42}\u{7684}\u{9801}\u{9762}\u{3002}`,
    en: `The page you requested cannot be found.`
};
const $2868cc1235412e16$export$1621713e0e89d236 = {
    ar: `\u{642}\u{62F} \u{64A}\u{643}\u{648}\u{646} \u{639}\u{646}\u{648}\u{627}\u{646} URL \u{628}\u{647} \u{623}\u{62E}\u{637}\u{627}\u{621} \u{625}\u{645}\u{644}\u{627}\u{626}\u{64A}\u{629} \u{623}\u{648} \u{644}\u{645} \u{62A}\u{639}\u{62F} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{628}\u{62D}\u{62B} \u{639}\u{646}\u{647}\u{627} \u{645}\u{62A}\u{627}\u{62D}\u{629}.`,
    de: `M\xf6glicherweise ist die URL falsch geschrieben oder die gesuchte Seite ist nicht mehr verf\xfcgbar.`,
    es: `Es posible que la URL est\xe9 mal escrita o que la p\xe1gina que est\xe1s buscando ya no est\xe9 disponible.`,
    fa: `\u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{646}\u{634}\u{627}\u{646}\u{6CC} \u{648}\u{628} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{627}\u{645}\u{644}\u{627}\u{6CC}\u{6CC} \u{628}\u{627}\u{634}\u{62F} \u{6CC}\u{627} \u{635}\u{641}\u{62D}\u{647} \u{645}\u{648}\u{631}\u{62F} \u{646}\u{638}\u{631} \u{634}\u{645}\u{627} \u{62F}\u{6CC}\u{6AF}\u{631} \u{62F}\u{631}\u{62F}\u{633}\u{62A}\u{631}\u{633} \u{646}\u{628}\u{627}\u{634}\u{62F}.`,
    fil: `Maaaring mali ang spelling ng URL o hindi na available ang pahinang hinahanap mo.`,
    fr: `Il se peut que l\u{2019}URL soit mal orthographi\xe9e ou que la page que vous recherchez ne soit plus disponible.`,
    hi: `\u{939}\u{94B} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{915}\u{93F} URL \u{915}\u{940} \u{935}\u{930}\u{94D}\u{924}\u{928}\u{940} \u{917}\u{932}\u{924} \u{939}\u{94B} \u{92F}\u{93E} \u{906}\u{92A} \u{91C}\u{93F}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{915}\u{94B} \u{916}\u{94B}\u{91C} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902} \u{935}\u{939} \u{905}\u{92C} \u{909}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{928} \u{939}\u{94B}.`,
    ht: `URL la ka dispar\xe8t oswa paj la w ap ch\xe8che pou pa disponib ank\xf2.`,
    it: `L'URL potrebbe essere stato digitato in modo errato o la pagina che stai cercando non \xe8 pi\xf9 disponibile.`,
    ja: `URL\u{306E}\u{30B9}\u{30DA}\u{30EB}\u{304C}\u{9593}\u{9055}\u{3063}\u{3066}\u{3044}\u{308B}\u{304B}\u{3001}\u{63A2}\u{3057}\u{3066}\u{3044}\u{308B}\u{30DA}\u{30FC}\u{30B8}\u{304C}\u{5229}\u{7528}\u{3067}\u{304D}\u{306A}\u{304F}\u{306A}\u{3063}\u{3066}\u{3044}\u{308B}\u{53EF}\u{80FD}\u{6027}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `URL\u{C758} \u{CCA0}\u{C790}\u{AC00} \u{D2C0}\u{B838}\u{AC70}\u{B098} \u{CC3E}\u{ACE0} \u{C788}\u{B294} \u{D398}\u{C774}\u{C9C0}\u{B97C} \u{B354} \u{C774}\u{C0C1} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Lub URL tej zaum yuav misspelled los yog nplooj ntawv uas koj nyob nraum nrhiav tsis muaj.`,
    ps: `\u{645}\u{645}\u{6A9}\u{646} \u{6CC}\u{648} \u{622}\u{631} \u{627}\u{6CC}\u{644} \u{63A}\u{644}\u{637} \u{627}\u{645}\u{644}\u{627} \u{634}\u{648}\u{6CC} \u{648}\u{6CC} \u{6CC}\u{627} \u{647}\u{63A}\u{647} \u{67E}\u{627}\u{6BC}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{6CC}\u{6D0} \u{644}\u{67C}\u{648}\u{626} \u{646}\u{648}\u{631} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{646}\u{647} \u{648}\u{6CC}.`,
    pt: `O URL pode estar incorreto ou a p\xe1gina que voc\xea est\xe1 procurando n\xe3o est\xe1 mais dispon\xedvel.`,
    "pt-pt": `O URL pode estar escrito incorretamente ou a p\xe1gina que voc\xea est\xe1 procurando n\xe3o est\xe1 mais dispon\xedvel.`,
    ru: `URL-\u{430}\u{434}\u{440}\u{435}\u{441} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{430}\u{43F}\u{438}\u{441}\u{430}\u{43D} \u{441} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{43E}\u{439} \u{438}\u{43B}\u{438} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{443}\u{44E} \u{432}\u{44B} \u{438}\u{449}\u{435}\u{442}\u{435}, \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430}.`,
    sm: `E mafai ona sese le sipelaga o le URL pe o le itulau o lo'o e sailia e le o toe maua.`,
    so: `Waxaa laga yaabaa in si qaldan loo iibiyo URL ama bogga aad raadineysid aan la heli karin.`,
    th: `URL \u{E2D}\u{E32}\u{E08}\u{E2A}\u{E30}\u{E01}\u{E14}\u{E1C}\u{E34}\u{E14}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E44}\u{E21}\u{E48}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{6C1}\u{648}\u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2} \u{6A9}\u{6C1} \u{6CC}\u{648} \u{622}\u{631} \u{627}\u{6CC}\u{644} \u{6A9}\u{627} \u{63A}\u{644}\u{637} \u{627}\u{645}\u{644}\u{627} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{648} \u{6CC}\u{627} \u{62C}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{6A9}\u{6CC} \u{622}\u{67E} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{648}\u{6C1} \u{627}\u{628} \u{62F}\u{633}\u{62A}\u{6CC}\u{627}\u{628} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `URL c\xf3 th\u{1EC3} sai ch\xednh t\u{1EA3} ho\u{1EB7}c trang b\u{1EA1}n \u{111}ang t\xecm ki\u{1EBF}m kh\xf4ng c\xf2n n\u{1EEF}a.`,
    "zh-hans": `URL \u{53EF}\u{80FD}\u{62FC}\u{5199}\u{9519}\u{8BEF}\u{FF0C}\u{6216}\u{8005}\u{60A8}\u{8981}\u{67E5}\u{627E}\u{7684}\u{9875}\u{9762}\u{4E0D}\u{518D}\u{53EF}\u{7528}\u{3002}`,
    "zh-hant": `URL \u{53EF}\u{80FD}\u{62FC}\u{5BEB}\u{932F}\u{8AA4}\u{FF0C}\u{6216}\u{8005}\u{60A8}\u{8981}\u{67E5}\u{627E}\u{7684}\u{9801}\u{9762}\u{4E0D}\u{518D}\u{53EF}\u{7528}\u{3002}`,
    en: `The URL may be misspelled or the page you're looking for is no longer available.`
};
const $2868cc1235412e16$export$3b461b3cd4146c7b = {
    ar: `\u{62E}\u{637}\u{623} \u{641}\u{64A} \u{627}\u{644}\u{62E}\u{627}\u{62F}\u{645} \u{627}\u{644}\u{62F}\u{627}\u{62E}\u{644}\u{64A}`,
    de: `Interner Serverfehler`,
    es: `Error interno del servidor`,
    fa: `\u{62E}\u{637}\u{627}\u{6CC} \u{633}\u{631}\u{648}\u{631} \u{62F}\u{627}\u{62E}\u{644}\u{6CC}`,
    fil: `Error sa panloob na server`,
    fr: `Erreur de serveur interne`,
    hi: `\u{906}\u{902}\u{924}\u{930}\u{93F}\u{915} \u{938}\u{930}\u{94D}\u{935}\u{930} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F}`,
    ht: `Internal s\xe8v\xe8 er\xe8`,
    it: `Errore interno del server`,
    ja: `\u{5185}\u{90E8}\u{30B5}\u{30FC}\u{30D0}\u{30FC}\u{30A8}\u{30E9}\u{30FC}`,
    ko: `\u{B0B4}\u{BD80} \u{C11C}\u{BC84} \u{C624}\u{B958}`,
    mww: `Internal server yuam kev`,
    ps: `\u{62F}\u{627}\u{62E}\u{644}\u{6CC} \u{633}\u{631}\u{648}\u{631} \u{63A}\u{644}\u{637}\u{6CC}`,
    pt: `Erro interno do servidor`,
    "pt-pt": `Erro interno do servidor`,
    ru: `\u{412}\u{43D}\u{443}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{44F}\u{44F} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{441}\u{435}\u{440}\u{432}\u{435}\u{440}\u{430}`,
    sm: `Mea sese i totonu o le server`,
    so: `Qalad server-ga gudaha ah`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E0B}\u{E34}\u{E23}\u{E4C}\u{E1F}\u{E40}\u{E27}\u{E2D}\u{E23}\u{E4C}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{648}\u{646}\u{6CC} \u{633}\u{631}\u{648}\u{631} \u{6A9}\u{6CC} \u{63A}\u{644}\u{637}\u{6CC}`,
    vi: `L\u{1ED7}i m\xe1y ch\u{1EE7} n\u{1ED9}i b\u{1ED9}`,
    "zh-hans": `\u{5185}\u{90E8}\u{670D}\u{52A1}\u{5668}\u{9519}\u{8BEF}`,
    "zh-hant": `\u{5167}\u{90E8}\u{4F3A}\u{670D}\u{5668}\u{932F}\u{8AA4}`,
    en: `Internal server error`
};
const $2868cc1235412e16$export$851426c3646bd4c5 = {
    ar: `\u{62D}\u{62F}\u{62B} \u{62E}\u{637}\u{623} \u{645}\u{627} \u{645}\u{646} \u{62C}\u{627}\u{646}\u{628}\u{646}\u{627}.`,
    de: `Irgendetwas ist auf unserer Seite schief gelaufen.`,
    es: `Algo sali\xf3 mal por nuestra parte.`,
    fa: `\u{645}\u{634}\u{6A9}\u{644}\u{6CC} \u{627}\u{632} \u{637}\u{631}\u{641} \u{645}\u{627} \u{67E}\u{6CC}\u{634} \u{622}\u{645}\u{62F}.`,
    fil: `May mali sa dulo namin.`,
    fr: `Quelque chose s\u{2019}est mal pass\xe9 de notre c\xf4t\xe9.`,
    hi: `\u{939}\u{92E}\u{93E}\u{930}\u{940} \u{913}\u{930} \u{938}\u{947} \u{915}\u{941}\u{91B} \u{917}\u{932}\u{924} \u{939}\u{941}\u{906}\u{964}`,
    ht: `Gen yon bagay ki te mal nan fen nou.`,
    it: `Qualcosa \xe8 andato storto da parte nostra.`,
    ja: `\u{79C1}\u{305F}\u{3061}\u{306E}\u{5074}\u{3067}\u{4F55}\u{304B}\u{304C}\u{3046}\u{307E}\u{304F}\u{3044}\u{304B}\u{306A}\u{304B}\u{3063}\u{305F}\u{3002}`,
    ko: `\u{C6B0}\u{B9AC} \u{CABD}\u{C5D0}\u{C11C} \u{BB54}\u{AC00} \u{C798}\u{BABB}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tej yam mus tsis ncaj ncees lawm rau peb kawg.`,
    ps: `\u{632}\u{645}\u{648}\u{696} \u{67E}\u{647} \u{627}\u{693}\u{62E} \u{6A9}\u{6D0} \u{685}\u{647} \u{63A}\u{644}\u{637} \u{648}\u{648}.`,
    pt: `Algo deu errado do nosso lado.`,
    "pt-pt": `Algo correu mal do nosso lado.`,
    ru: `\u{427}\u{442}\u{43E}-\u{442}\u{43E} \u{43F}\u{43E}\u{448}\u{43B}\u{43E} \u{43D}\u{435} \u{442}\u{430}\u{43A} \u{441} \u{43D}\u{430}\u{448}\u{435}\u{439} \u{441}\u{442}\u{43E}\u{440}\u{43E}\u{43D}\u{44B}.`,
    sm: `Sa i ai se mea na sese i lo matou itu.`,
    so: `Wax baa khaldamay dhamaadkeennii.`,
    th: `\u{E21}\u{E35}\u{E1A}\u{E32}\u{E07}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E43}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E17}\u{E49}\u{E32}\u{E22}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E32}`,
    ur: `\u{6C1}\u{645}\u{627}\u{631}\u{6CC} \u{637}\u{631}\u{641} \u{633}\u{6D2} \u{6A9}\u{686}\u{6BE} \u{63A}\u{644}\u{637} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}.`,
    vi: `C\xf3 \u{111}i\u{1EC1}u g\xec \u{111}\xf3 kh\xf4ng \u{1ED5}n v\u{1EC1} ph\xeda ch\xfang t\xf4i.`,
    "zh-hans": `\u{6211}\u{4EEC}\u{8FD9}\u{8FB9}\u{51FA}\u{4E86}\u{70B9}\u{95EE}\u{9898}\u{3002}`,
    "zh-hant": `\u{6211}\u{5011}\u{9019}\u{908A}\u{51FA}\u{4E86}\u{9EDE}\u{554F}\u{984C}\u{3002}`,
    en: `Something went wrong on our end.`
};
const $2868cc1235412e16$export$9377a6ec42555e17 = {
    ar: `\u{62D}\u{62F}\u{62B} \u{62E}\u{637}\u{623} \u{623}\u{62B}\u{646}\u{627}\u{621} \u{645}\u{639}\u{627}\u{644}\u{62C}\u{629} \u{637}\u{644}\u{628}\u{643}. \u{62A}\u{645} \u{62A}\u{646}\u{628}\u{64A}\u{647} \u{641}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{631}\u{643}\u{627}\u{645}. \u{625}\u{630}\u{627} \u{627}\u{633}\u{62A}\u{645}\u{631}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{643}\u{644}\u{629} \u{623}\u{648} \u{643}\u{627}\u{646} \u{644}\u{62F}\u{64A}\u{643} \u{623}\u{64A} \u{623}\u{633}\u{626}\u{644}\u{629}\u{60C} \u{641}\u{64A}\u{631}\u{62C}\u{649} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644} \u{628}\u{627}\u{644}\u{62F}\u{639}\u{645}.`,
    de: `Bei der Bearbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Das Cumulus-Team wurde alarmiert. Wenn das Problem weiterhin besteht oder Sie Fragen haben, wenden Sie sich bitte an den Support.`,
    es: `Se ha producido un error al procesar su solicitud. El equipo de Cumulus ha sido alertado. Si el problema persiste o tiene alguna pregunta, p\xf3ngase en contacto con el servicio de asistencia.`,
    fa: `\u{647}\u{646}\u{6AF}\u{627}\u{645} \u{67E}\u{631}\u{62F}\u{627}\u{632}\u{634} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{634}\u{645}\u{627} \u{62E}\u{637}\u{627}\u{6CC}\u{6CC} \u{631}\u{62E} \u{62F}\u{627}\u{62F}. \u{628}\u{647} \u{62A}\u{6CC}\u{645} \u{6A9}\u{648}\u{645}\u{648}\u{644}\u{648}\u{633} \u{647}\u{634}\u{62F}\u{627}\u{631} \u{62F}\u{627}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{627}\u{6AF}\u{631} \u{645}\u{634}\u{6A9}\u{644} \u{647}\u{645}\u{686}\u{646}\u{627}\u{646} \u{627}\u{62F}\u{627}\u{645}\u{647} \u{62F}\u{627}\u{634}\u{62A} \u{6CC}\u{627} \u{633}\u{648}\u{627}\u{644}\u{6CC} \u{62F}\u{627}\u{631}\u{6CC}\u{62F}\u{60C} \u{644}\u{637}\u{641}\u{627} \u{628}\u{627} \u{67E}\u{634}\u{62A}\u{6CC}\u{628}\u{627}\u{646}\u{6CC} \u{62A}\u{645}\u{627}\u{633} \u{628}\u{6AF}\u{6CC}\u{631}\u{6CC}\u{62F}.`,
    fil: `Nagkaroon ng error habang pinoproseso ang iyong kahilingan. Inalerto na ang Cumulus team. Kung ang problema ay nagpapatuloy o mayroon kang anumang mga katanungan, mangyaring makipag-ugnay sa suporta.`,
    fr: `Une erreur s\u{2019}est produite lors du traitement de votre demande. L\u{2019}\xe9quipe Cumulus a \xe9t\xe9 alert\xe9e. Si le probl\xe8me persiste ou si vous avez des questions, veuillez contacter le support.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{94B} \u{938}\u{902}\u{938}\u{93E}\u{927}\u{93F}\u{924} \u{915}\u{930}\u{924}\u{947} \u{938}\u{92E}\u{92F} \u{915}\u{94B}\u{908} \u{924}\u{94D}\u{930}\u{941}\u{91F}\u{93F} \u{909}\u{924}\u{94D}\u{92A}\u{928}\u{94D}\u{928} \u{939}\u{941}\u{908}. \u{915}\u{94D}\u{92F}\u{942}\u{92E}\u{94D}\u{92F}\u{932}\u{938} \u{91F}\u{940}\u{92E} \u{915}\u{94B} \u{905}\u{932}\u{930}\u{94D}\u{91F} \u{915}\u{930} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}\u{964} \u{92F}\u{926}\u{93F} \u{938}\u{92E}\u{938}\u{94D}\u{92F}\u{93E} \u{92C}\u{928}\u{940} \u{930}\u{939}\u{924}\u{940} \u{939}\u{948} \u{92F}\u{93E} \u{906}\u{92A}\u{915}\u{947} \u{915}\u{94B}\u{908} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928} \u{939}\u{948}\u{902}, \u{924}\u{94B} \u{915}\u{943}\u{92A}\u{92F}\u{93E} \u{938}\u{92E}\u{930}\u{94D}\u{925}\u{928} \u{938}\u{947} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Yon er\xe8 ki te f\xe8t pandan y ap trete demann ou an. Ekip Culus la te av\xe8ti. Si pwobl\xe8m nan p\xe8siste oswa ou gen nenp\xf2t kesyon, tanpri kontakte sip\xf2.`,
    it: `Si \xe8 verificato un errore durante l'elaborazione della richiesta. Il team di Cumulus \xe8 stato allertato. Se il problema persiste o hai domande, contatta l'assistenza.`,
    ja: `\u{30EA}\u{30AF}\u{30A8}\u{30B9}\u{30C8}\u{306E}\u{51E6}\u{7406}\u{4E2D}\u{306B}\u{30A8}\u{30E9}\u{30FC}\u{304C}\u{767A}\u{751F}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}Cumulus \u{30C1}\u{30FC}\u{30E0}\u{306B}\u{30A2}\u{30E9}\u{30FC}\u{30C8}\u{304C}\u{9001}\u{4FE1}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}\u{554F}\u{984C}\u{304C}\u{89E3}\u{6C7A}\u{3057}\u{306A}\u{3044}\u{5834}\u{5408}\u{3001}\u{307E}\u{305F}\u{306F}\u{3054}\u{4E0D}\u{660E}\u{306A}\u{70B9}\u{304C}\u{3054}\u{3056}\u{3044}\u{307E}\u{3057}\u{305F}\u{3089}\u{3001}\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{307E}\u{3067}\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C694}\u{CCAD}\u{C744} \u{CC98}\u{B9AC}\u{D558}\u{B294} \u{B3D9}\u{C548} \u{C624}\u{B958}\u{AC00} \u{BC1C}\u{C0DD}\u{D588}\u{C2B5}\u{B2C8}\u{B2E4}. Cumulus \u{D300}\u{C5D0} \u{ACBD}\u{BCF4}\u{AC00} \u{C6B8}\u{B838}\u{C2B5}\u{B2C8}\u{B2E4}. \u{BB38}\u{C81C}\u{AC00} \u{C9C0}\u{C18D}\u{B418}\u{AC70}\u{B098} \u{C9C8}\u{BB38}\u{C774} \u{C788}\u{B294} \u{ACBD}\u{C6B0} \u{C9C0}\u{C6D0}\u{D300}\u{C5D0} \u{BB38}\u{C758}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    mww: `Ib qho yuam kev tshwm sim thaum uas koj thov. Pab neeg Cumulus muaj tau alerted. Yog hais tias qhov teeb meem persists los yog koj muaj lus nug, thov hu rau kev them nyiaj yug.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{62F} \u{67E}\u{631}\u{648}\u{633}\u{633} \u{6A9}\u{648}\u{644}\u{648} \u{67E}\u{631} \u{645}\u{647}\u{627}\u{644} \u{6CC}\u{648}\u{647} \u{63A}\u{644}\u{637}\u{6CC} \u{631}\u{627}\u{645}\u{646}\u{681}\u{62A}\u{647} \u{634}\u{648}\u{647}. \u{62F} \u{6A9}\u{648}\u{645}\u{648}\u{644}\u{648}\u{633} \u{67C}\u{6CC}\u{645} \u{62A}\u{647} \u{62E}\u{628}\u{631} \u{648}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}. \u{6A9}\u{647} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{647} \u{647}\u{645}\u{62F}\u{627}\u{633}\u{6D0} \u{62F}\u{648}\u{627}\u{645} \u{644}\u{631}\u{6CC} \u{627}\u{648} \u{6CC}\u{627} \u{62A}\u{627}\u{633}\u{648} \u{6A9}\u{648}\u{645}\u{647} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{644}\u{631}\u{626} \u{646}\u{648} \u{645}\u{647}\u{631}\u{628}\u{627}\u{646}\u{6CC} \u{648}\u{6A9}\u{693}\u{626} \u{644}\u{647} \u{645}\u{644}\u{627}\u{62A}\u{693} \u{633}\u{631}\u{647} \u{627}\u{693}\u{6CC}\u{6A9}\u{647} \u{648}\u{646}\u{6CC}\u{633}\u{626}.`,
    pt: `Ocorreu um erro durante o processamento de sua solicita\xe7\xe3o. A equipe do Cumulus foi alertada. Se o problema persistir ou voc\xea tiver alguma d\xfavida, entre em contato com o suporte.`,
    "pt-pt": `Ocorreu um erro durante o processamento do seu pedido. A equipa da Cumulus foi alertada. Se o problema persistir ou se tiver alguma d\xfavida, contacte o suporte.`,
    ru: `\u{41F}\u{440}\u{43E}\u{438}\u{437}\u{43E}\u{448}\u{43B}\u{430} \u{43E}\u{448}\u{438}\u{431}\u{43A}\u{430} \u{43F}\u{440}\u{438} \u{43E}\u{431}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{435} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430}. \u{41A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430} Cumulus \u{431}\u{44B}\u{43B}\u{430} \u{43F}\u{440}\u{435}\u{434}\u{443}\u{43F}\u{440}\u{435}\u{436}\u{434}\u{435}\u{43D}\u{430}. \u{415}\u{441}\u{43B}\u{438} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{430} \u{43D}\u{435} \u{443}\u{441}\u{442}\u{440}\u{430}\u{43D}\u{435}\u{43D}\u{430} \u{438}\u{43B}\u{438} \u{443} \u{432}\u{430}\u{441} \u{432}\u{43E}\u{437}\u{43D}\u{438}\u{43A}\u{43B}\u{438} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{44B}, \u{43E}\u{431}\u{440}\u{430}\u{442}\u{438}\u{442}\u{435}\u{441}\u{44C} \u{432} \u{441}\u{43B}\u{443}\u{436}\u{431}\u{443} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{438}.`,
    sm: `Sa i ai se mea sese a o faagaoioia lau talosaga. Ua lapataia le 'au a Cumulus. Afai o lo'o fa'aauau pea le fa'afitauli pe ei ai ni au fesili, fa'amolemole fa'afeso'ota'i le lagolago.`,
    so: `Qalad ayaa dhacay iyada oo laga baaraandegayey codsigaaga. Kooxda Cumulus ayaa loo soo gudbiyay feejignayn. Haddii dhibaatadu ay socoto ama aad wax su\u{2BC}aalo ah qabtid, fadlan la soo xiriir taageero.`,
    th: `\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E49}\u{E2D}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}\u{E02}\u{E13}\u{E30}\u{E1B}\u{E23}\u{E30}\u{E21}\u{E27}\u{E25}\u{E1C}\u{E25}\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13} \u{E17}\u{E35}\u{E21} Cumulus \u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E41}\u{E08}\u{E49}\u{E07}\u{E40}\u{E15}\u{E37}\u{E2D}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27} \u{E2B}\u{E32}\u{E01}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E22}\u{E31}\u{E07}\u{E04}\u{E07}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E04}\u{E38}\u{E13}\u{E21}\u{E35}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E43}\u{E14}\u{E46} \u{E42}\u{E1B}\u{E23}\u{E14}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E1D}\u{E48}\u{E32}\u{E22}\u{E2A}\u{E19}\u{E31}\u{E1A}\u{E2A}\u{E19}\u{E38}\u{E19}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{67E}\u{631} \u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC} \u{6A9}\u{631}\u{62A}\u{6D2} \u{648}\u{642}\u{62A} \u{627}\u{6CC}\u{6A9} \u{646}\u{642}\u{635} \u{648}\u{627}\u{642}\u{639} \u{6C1}\u{648}\u{627}\u{6D4} \u{6A9}\u{645}\u{648}\u{644}\u{633} \u{679}\u{6CC}\u{645} \u{6A9}\u{648} \u{627}\u{644}\u{631}\u{679} \u{6A9}\u{631} \u{62F}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{6AF}\u{631} \u{645}\u{633}\u{626}\u{644}\u{6C1} \u{628}\u{631}\u{642}\u{631}\u{627}\u{631} \u{631}\u{6C1}\u{62A}\u{627} \u{6C1}\u{6D2} \u{6CC}\u{627} \u{622}\u{67E} \u{6A9}\u{6D2} \u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{648}\u{627}\u{644}\u{627}\u{62A} \u{6C1}\u{6CC}\u{6BA} \u{62A}\u{648}\u{60C} \u{628}\u{631}\u{627}\u{6C1} \u{645}\u{6C1}\u{631}\u{628}\u{627}\u{646}\u{6CC} \u{645}\u{62F}\u{62F} \u{633}\u{6D2} \u{631}\u{627}\u{628}\u{637}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}.`,
    vi: `\u{110}\xe3 x\u{1EA3}y ra l\u{1ED7}i trong khi x\u{1EED} l\xfd y\xeau c\u{1EA7}u c\u{1EE7}a b\u{1EA1}n. Nh\xf3m Cumulus \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c c\u{1EA3}nh b\xe1o. N\u{1EBF}u s\u{1EF1} c\u{1ED1} v\u{1EAB}n ti\u{1EBF}p di\u{1EC5}n ho\u{1EB7}c b\u{1EA1}n c\xf3 b\u{1EA5}t k\u{1EF3} c\xe2u h\u{1ECF}i n\xe0o, vui l\xf2ng li\xean h\u{1EC7} v\u{1EDB}i b\u{1ED9} ph\u{1EAD}n h\u{1ED7} tr\u{1EE3}.`,
    "zh-hans": `\u{5904}\u{7406}\u{60A8}\u{7684}\u{8BF7}\u{6C42}\u{65F6}\u{51FA}\u{9519}\u{3002}Cumulus \u{56E2}\u{961F}\u{5DF2}\u{6536}\u{5230}\u{8B66}\u{62A5}\u{3002}\u{5982}\u{679C}\u{95EE}\u{9898}\u{4ECD}\u{7136}\u{5B58}\u{5728}\u{6216}\u{60A8}\u{6709}\u{4EFB}\u{4F55}\u{7591}\u{95EE}\u{FF0C}\u{8BF7}\u{8054}\u{7CFB}\u{652F}\u{6301}\u{4EBA}\u{5458}\u{3002}`,
    "zh-hant": `\u{8655}\u{7406}\u{60A8}\u{7684}\u{8ACB}\u{6C42}\u{6642}\u{767C}\u{751F}\u{932F}\u{8AA4}\u{3002}Cumulus \u{5718}\u{968A}\u{5DF2}\u{6536}\u{5230}\u{8B66}\u{5831}\u{3002}\u{5982}\u{679C}\u{554F}\u{984C}\u{4ECD}\u{7136}\u{5B58}\u{5728}\u{6216}\u{60A8}\u{6709}\u{4EFB}\u{4F55}\u{7591}\u{554F}\u{FF0C}\u{8ACB}\u{806F}\u{7E6B}\u{652F}\u{6301}\u{4EBA}\u{54E1}\u{3002}`,
    en: `An error occurred while processing your request. The Cumulus team has been alerted. If the problem persists or you have any questions, please contact support.`
};
const $2868cc1235412e16$export$c7ba48ed86b7d220 = {
    ar: `\u{645}\u{645}\u{646}\u{648}\u{639}`,
    de: `Verboten`,
    es: `Prohibido`,
    fa: `\u{645}\u{645}\u{646}\u{648}\u{639}`,
    fil: `Ipinagbabawal`,
    fr: `Interdit`,
    hi: `\u{935}\u{930}\u{94D}\u{91C}\u{93F}\u{924}`,
    ht: `Ent\xe8di`,
    it: `Vietato`,
    ja: `\u{7981}\u{3058}\u{3089}\u{308C}\u{305F}`,
    ko: `\u{AE08}\u{C9C0}\u{B41C}`,
    mww: `Forbidden`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Proibido`,
    "pt-pt": `Proibido`,
    ru: `\u{417}\u{430}\u{43F}\u{440}\u{435}\u{442}\u{43D}\u{44B}\u{439}`,
    sm: `Faasaina`,
    so: `Reebay`,
    th: `\u{E15}\u{E49}\u{E2D}\u{E07}\u{E2B}\u{E49}\u{E32}\u{E21}`,
    ur: `\u{645}\u{646}\u{639}`,
    vi: `B\u{1ECB} c\u{1EA5}m`,
    "zh-hans": `\u{7981}\u{6B62}`,
    "zh-hant": `\u{7981}\u{6B62}`,
    en: `Forbidden`
};
const $2868cc1235412e16$export$a0198b98f746600d = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}.`,
    de: `Sie haben keinen Zugriff auf diese Seite.`,
    es: `Usted no tiene acceso a esta p\xe1gina.`,
    fa: `\u{634}\u{645}\u{627} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{646}\u{62F}\u{627}\u{631}\u{6CC}\u{62F}.`,
    fil: `Wala kang access sa pahinang ito.`,
    fr: `Vous n\u{2019}avez pas acc\xe8s \xe0 cette page.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{92A}\u{93E}\u{938} \u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Ou pa gen aks\xe8 a paj sa a.`,
    it: `Non hai accesso a questa pagina.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{C561}\u{C138}\u{C2A4}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj tsis tas yuav mus saib tau nplooj ntawv no.`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62A}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{646}\u{644}\u{631}\u{6CC}.`,
    pt: `Voc\xea n\xe3o tem acesso a esta p\xe1gina.`,
    "pt-pt": `Voc\xea n\xe3o tem acesso a esta p\xe1gina.`,
    ru: `\u{423} \u{432}\u{430}\u{441} \u{43D}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435}.`,
    sm: `E le mafai ona e ulufale i lenei itulau.`,
    so: `Ma lihid galitaanka boggan.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}.`,
    vi: `B\u{1EA1}n kh\xf4ng c\xf3 quy\u{1EC1}n truy c\u{1EAD}p v\xe0o trang n\xe0y.`,
    "zh-hans": `\u{60A8}\u{65E0}\u{6743}\u{8BBF}\u{95EE}\u{6B64}\u{9875}\u{9762}\u{3002}`,
    "zh-hant": `\u{60A8}\u{7121}\u{6B0A}\u{8A2A}\u{554F}\u{6B64}\u{9801}\u{9762}\u{3002}`,
    en: `You do not have access to this page.`
};
const $2868cc1235412e16$export$17d11b1f539b6085 = {
    ar: `\u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{629} \u{648}\u{644}\u{643}\u{646} \u{62F}\u{648}\u{631}\u{643} \u{623}\u{648} \u{639}\u{636}\u{648}\u{64A}\u{629} \u{645}\u{624}\u{633}\u{633}\u{62A}\u{643} \u{644}\u{627} \u{62A}\u{645}\u{646}\u{62D}\u{643} \u{625}\u{630}\u{646}\u{627} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{64A}\u{647}\u{627}.`,
    de: `Diese Seite ist vorhanden, aber Ihre Rolle oder Organisationsmitgliedschaft gew\xe4hrt Ihnen keine Zugriffsberechtigung darauf.`,
    es: `Esta p\xe1gina existe, pero su rol o pertenencia a la organizaci\xf3n no le concede permisos de acceso a ella.`,
    fa: `\u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{627}\u{631}\u{62F} \u{627}\u{645}\u{627} \u{646}\u{642}\u{634} \u{6CC}\u{627} \u{639}\u{636}\u{648}\u{6CC}\u{62A} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{628}\u{647} \u{634}\u{645}\u{627} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{622}\u{646} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Umiiral ang pahinang ito ngunit ang iyong tungkulin o pagiging miyembro ng organisasyon ay hindi nagbibigay sa iyo ng pahintulot na ma-access ito.`,
    fr: `Cette page existe, mais votre r\xf4le ou votre appartenance \xe0 l\u{2019}organisation ne vous autorise pas \xe0 y acc\xe9der.`,
    hi: `\u{92F}\u{939} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{92E}\u{94C}\u{91C}\u{942}\u{926} \u{939}\u{948} \u{932}\u{947}\u{915}\u{93F}\u{928} \u{906}\u{92A}\u{915}\u{940} \u{92D}\u{942}\u{92E}\u{93F}\u{915}\u{93E} \u{92F}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938} \u{92A}\u{930} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{92A}\u{939}\u{941}\u{901}\u{91A} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{928}\u{939}\u{940}\u{902} \u{915}\u{930}\u{924}\u{940} \u{939}\u{948}.`,
    ht: `Paj sa egziste men w\xf2l ou jwe oswa manm \xf2ganizasyon an pa ba ou p\xe8misyon aks\xe8 a li.`,
    it: `Questa pagina esiste, ma l'appartenenza al ruolo o all'organizzazione non concede l'autorizzazione di accesso.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306F}\u{5B58}\u{5728}\u{3057}\u{307E}\u{3059}\u{304C}\u{3001}\u{30ED}\u{30FC}\u{30EB}\u{307E}\u{305F}\u{306F}\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{30B7}\u{30C3}\u{30D7}\u{306B}\u{3088}\u{3063}\u{3066}\u{3001}\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{3078}\u{306E}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{6A29}\u{304C}\u{4ED8}\u{4E0E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{AC00} \u{C874}\u{C7AC}\u{D558}\u{C9C0}\u{B9CC} \u{C5ED}\u{D560} \u{B610}\u{B294} \u{C870}\u{C9C1} \u{BA64}\u{BC84}\u{C2ED}\u{C774} \u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{B300}\u{D55C} \u{C561}\u{C138}\u{C2A4} \u{AD8C}\u{D55C}\u{C744} \u{BD80}\u{C5EC}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Nplooj ntawv no tshwm sim tab sis koj lub luag hauj lwm los yog koom haum ua tswv cuab tsis tso cai rau koj tso cai rau nws.`,
    ps: `\u{62F}\u{627} \u{67E}\u{627}\u{6BC}\u{647} \u{634}\u{62A}\u{648}\u{646} \u{644}\u{631}\u{6CC} \u{62E}\u{648} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{631}\u{648}\u{644} \u{6CC}\u{627} \u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC}\u{62A}\u{648}\u{628} \u{62A}\u{627}\u{633}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{62F}\u{631}\u{6A9}\u{648}\u{6CC}.`,
    pt: `Esta p\xe1gina existe, mas sua fun\xe7\xe3o ou associa\xe7\xe3o \xe0 organiza\xe7\xe3o n\xe3o concede a voc\xea permiss\xe3o de acesso a ela.`,
    "pt-pt": `Esta p\xe1gina existe, mas a sua fun\xe7\xe3o ou associa\xe7\xe3o \xe0 organiza\xe7\xe3o n\xe3o lhe concede permiss\xe3o de acesso \xe0 mesma.`,
    ru: `\u{42D}\u{442}\u{430} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430} \u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}, \u{43D}\u{43E} \u{432}\u{430}\u{448}\u{430} \u{440}\u{43E}\u{43B}\u{44C} \u{438}\u{43B}\u{438} \u{447}\u{43B}\u{435}\u{43D}\u{441}\u{442}\u{432}\u{43E} \u{432} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43D}\u{435} \u{434}\u{430}\u{435}\u{442} \u{432}\u{430}\u{43C} \u{43F}\u{440}\u{430}\u{432}\u{430} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{43D}\u{435}\u{439}.`,
    sm: `O loo i ai le itulau lenei, ae o lau matafaioi po o le avea ma sui auai o le faalapotopotoga e le tuuina atu ia te oe se faatagaga e faaaoga ai.`,
    so: `Boggan waa mid ka jira laakiin kaalintaada ama xubinnimada ururku kuma siinayo ogolaanshaha gelitaankaaga.`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}\u{E21}\u{E35}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E41}\u{E15}\u{E48}\u{E1A}\u{E17}\u{E1A}\u{E32}\u{E17}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E02}\u{E2D}\u{E07}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E43}\u{E2B}\u{E49}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`,
    ur: `\u{6CC}\u{6C1} \u{635}\u{641}\u{62D}\u{6C1} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{6C1}\u{6D2} \u{644}\u{6CC}\u{6A9}\u{646} \u{622}\u{67E} \u{6A9}\u{627} \u{6A9}\u{631}\u{62F}\u{627}\u{631} \u{6CC}\u{627} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6CC} \u{631}\u{6A9}\u{646}\u{6CC}\u{62A} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Trang n\xe0y t\u{1ED3}n t\u{1EA1}i nh\u{1B0}ng t\u{1B0} c\xe1ch th\xe0nh vi\xean vai tr\xf2 ho\u{1EB7}c t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n kh\xf4ng c\u{1EA5}p cho b\u{1EA1}n quy\u{1EC1}n truy c\u{1EAD}p v\xe0o trang \u{111}\xf3.`,
    "zh-hans": `\u{6B64}\u{9875}\u{9762}\u{5B58}\u{5728}\u{FF0C}\u{4F46}\u{60A8}\u{7684}\u{89D2}\u{8272}\u{6216}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{8EAB}\u{4EFD}\u{672A}\u{6388}\u{4E88}\u{60A8}\u{8BBF}\u{95EE}\u{8BE5}\u{9875}\u{9762}\u{7684}\u{6743}\u{9650}\u{3002}`,
    "zh-hant": `\u{6B64}\u{9801}\u{9762}\u{5B58}\u{5728}\u{FF0C}\u{4F46}\u{60A8}\u{7684}\u{89D2}\u{8272}\u{6216}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{8EAB}\u{4EFD}\u{672A}\u{6388}\u{4E88}\u{60A8}\u{8A2A}\u{554F}\u{8A72}\u{9801}\u{9762}\u{7684}\u{8A31}\u{53EF}\u{6B0A}\u{3002}`,
    en: `This page exists but your role or organization membership does not grant you permission access to it.`
};
const $2868cc1235412e16$export$fe098bb3d98d7f63 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{635}\u{631}\u{62D} \u{628}\u{647}`,
    de: `Nicht autorisiert`,
    es: `No autorizado`,
    fa: `\u{645}\u{62C}\u{627}\u{632} \u{646}\u{6CC}\u{633}\u{62A}`,
    fil: `Hindi awtorisado`,
    fr: `Non autoris\xe9`,
    hi: `\u{905}\u{927}\u{93F}\u{915}\u{943}\u{924} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa otorize`,
    it: `Non autorizzato`,
    ja: `\u{8A8D}\u{8A3C}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C2B9}\u{C778}\u{B418}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Tsis tso cai`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `N\xe3o autorizado`,
    "pt-pt": `N\xe3o autorizado`,
    ru: `\u{41D}\u{435} \u{430}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{43E}`,
    sm: `E le faatagaina`,
    so: `Lama oggola`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}`,
    ur: `\u{645}\u{62C}\u{627}\u{632} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng \u{111}\u{1B0}\u{1EE3}c ph\xe9p`,
    "zh-hans": `\u{672A}\u{6388}\u{6743}`,
    "zh-hant": `\u{672A}\u{6388}\u{6B0A}`,
    en: `Not authorized`
};
const $2868cc1235412e16$export$5b8670ede2f40912 = {
    ar: `\u{642}\u{645} \u{628}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}.`,
    de: `Melden Sie sich an, um auf diese Seite zuzugreifen.`,
    es: `Inicie sesi\xf3n para acceder a esta p\xe1gina.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: `Mag-sign in upang ma-access ang pahinang ito.`,
    fr: `Connectez-vous pour acc\xe9der \xe0 cette page.`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}.`,
    ht: `Siyen pou jwenn aks\xe8 nan paj sa a.`,
    it: `Effettua l'accesso per accedere a questa pagina.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{C561}\u{C138}\u{C2A4}\u{D558}\u{B824}\u{BA74} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: `Kos npe rau ntawm nplooj ntawv no.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62F} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{646}\u{648}\u{681}\u{626}.`,
    pt: `Fa\xe7a login para acessar esta p\xe1gina.`,
    "pt-pt": `Inicie sess\xe3o para aceder a esta p\xe1gina.`,
    ru: `\u{412}\u{43E}\u{439}\u{434}\u{438}\u{442}\u{435} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435}.`,
    sm: `Saini i totonu e ulufale ai i lenei itulau.`,
    so: `Gali si aad u hesho boggan.`,
    th: `\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\u{103}ng nh\u{1EAD}p \u{111}\u{1EC3} truy c\u{1EAD}p trang n\xe0y.`,
    "zh-hans": `\u{767B}\u{5F55}\u{4EE5}\u{8BBF}\u{95EE}\u{6B64}\u{9875}\u{9762}\u{3002}`,
    "zh-hant": `\u{767B}\u{9304}\u{4EE5}\u{8A2A}\u{554F}\u{6B64}\u{9801}\u{9762}\u{3002}`,
    en: `Sign in to access this page.`
};
const $2868cc1235412e16$export$1a76e3b764e36082 = {
    ar: `\u{64A}\u{62C}\u{628} \u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}.`,
    de: `Sie m\xfcssen angemeldet sein, um auf diese Seite zugreifen zu k\xf6nnen.`,
    es: `Debe iniciar sesi\xf3n para acceder a esta p\xe1gina.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{628}\u{627}\u{6CC}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{633}\u{6CC}\u{633}\u{62A}\u{645} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: `Kailangan mong mag-sign in upang ma-access ang pahinang ito.`,
    fr: `Vous devez \xeatre connect\xe9 pour acc\xe9der \xe0 cette page.`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{906}\u{92A}\u{915}\u{94B} \u{938}\u{93E}\u{907}\u{928}-\u{907}\u{928} \u{939}\u{94B}\u{928}\u{93E} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948}.`,
    ht: `Ou dwe siyen pou jwenn aks\xe8 nan paj sa a.`,
    it: `Per accedere a questa pagina \xe8 necessario aver effettuato l'accesso.`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{C561}\u{C138}\u{C2A4}\u{D558}\u{B824}\u{BA74} \u{B85C}\u{ADF8}\u{C778}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Koj yuav tsum kos npe rau daim ntawv no kom muaj nyob hauv phab ntawv no.`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{628}\u{627}\u{6CC}\u{62F} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62A}\u{647} \u{62F} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{648}\u{644}\u{631}\u{626}.`,
    pt: `Voc\xea deve estar conectado para acessar esta p\xe1gina.`,
    "pt-pt": `Tem de ter sess\xe3o iniciada para aceder a esta p\xe1gina.`,
    ru: `\u{414}\u{43B}\u{44F} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{43E} \u{432}\u{43E}\u{439}\u{442}\u{438} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}.`,
    sm: `E tatau ona e saini i totonu e ulufale ai i lenei itulau.`,
    so: `Waa in aad saxiixdaa-in si aad u hesho boggan.`,
    th: `\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{622}\u{67E} \u{6A9}\u{627} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6C1}\u{648}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `B\u{1EA1}n ph\u{1EA3}i \u{111}\u{103}ng nh\u{1EAD}p \u{111}\u{1EC3} truy c\u{1EAD}p trang n\xe0y.`,
    "zh-hans": `\u{60A8}\u{5FC5}\u{987B}\u{767B}\u{5F55}\u{624D}\u{80FD}\u{8BBF}\u{95EE}\u{6B64}\u{9875}\u{9762}\u{3002}`,
    "zh-hant": `\u{60A8}\u{5FC5}\u{9808}\u{767B}\u{9304}\u{624D}\u{80FD}\u{5B58}\u{53D6}\u{6B64}\u{9801}\u{9762}\u{3002}`,
    en: `You must be signed-in to access this page.`
};
const $2868cc1235412e16$export$d4871e941f765117 = {
    ar: (cumulus)=>`\u{62D}\u{62F}\u{62F} \u{623}\u{62D}\u{62F} \u{627}\u{644}\u{631}\u{648}\u{627}\u{628}\u{637} \u{623}\u{62F}\u{646}\u{627}\u{647} \u{644}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{645}\u{646}\u{637}\u{642}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{645}\u{646} ${cumulus}.`,
    de: (cumulus)=>`W\xe4hlen Sie einen der untenstehenden Links, um auf einen anderen Bereich von ${cumulus} zuzugreifen.`,
    es: (cumulus)=>`Seleccione uno de los enlaces a continuaci\xf3n para acceder a otra \xe1rea de ${cumulus}.`,
    fa: (cumulus)=>`\u{6CC}\u{6A9}\u{6CC} \u{627}\u{632} \u{67E}\u{6CC}\u{648}\u{646}\u{62F}\u{647}\u{627}\u{6CC} \u{632}\u{6CC}\u{631} \u{631}\u{627} \u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{628}\u{647} \u{645}\u{646}\u{637}\u{642}\u{647} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{627}\u{632} ${cumulus} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (cumulus)=>`Pumili ng isa sa mga link sa ibaba upang ma-access ang isa pang lugar ng ${cumulus}.`,
    fr: (cumulus)=>`S\xe9lectionnez l\u{2019}un des liens ci-dessous pour acc\xe9der \xe0 une autre zone de ${cumulus}.`,
    hi: (cumulus)=>`${cumulus} \u{915}\u{947} \u{915}\u{93F}\u{938}\u{940} \u{905}\u{928}\u{94D}\u{92F} \u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930} \u{924}\u{915} \u{92A}\u{939}\u{941}\u{901}\u{91A}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{928}\u{940}\u{91A}\u{947} \u{926}\u{93F}\u{90F} \u{917}\u{90F} \u{932}\u{93F}\u{902}\u{915} \u{92E}\u{947}\u{902} \u{938}\u{947} \u{90F}\u{915} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: (cumulus)=>`Chwazi youn nan lyen ki anba yo jwenn aks\xe8 nan yon l\xf2t z\xf2n nan ${cumulus}.`,
    it: (cumulus)=>`Seleziona uno dei link sottostanti per accedere a un'altra area di ${cumulus}.`,
    ja: (cumulus)=>`\u{4EE5}\u{4E0B}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{306E}\u{3044}\u{305A}\u{308C}\u{304B}\u{3092}\u{9078}\u{629E}\u{3057}\u{3066}\u{3001} ${cumulus} \u{306E}\u{5225}\u{306E}\u{9818}\u{57DF}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: (cumulus)=>`\u{C544}\u{B798} \u{B9C1}\u{D06C} \u{C911} \u{D558}\u{B098}\u{B97C} \u{C120}\u{D0DD}\u{D558}\u{C5EC} ${cumulus}\u{C758} \u{B2E4}\u{B978} \u{C601}\u{C5ED}\u{C5D0} \u{C561}\u{C138}\u{C2A4}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    mww: (cumulus)=>`Xaiv ib qhov txuas hauv qab no mus saib tau lwm cheeb tsam ntawm ${cumulus}.`,
    ps: (cumulus)=>`\u{62F} ${cumulus} \u{6CC}\u{648}\u{6D0} \u{628}\u{644}\u{6D0} \u{633}\u{6CC}\u{645}\u{6D0} \u{62A}\u{647} \u{62F} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{644}\u{6CC}\u{646}\u{6A9}\u{648}\u{646}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}.`,
    pt: (cumulus)=>`Selecione um dos links abaixo para acessar outra \xe1rea do ${cumulus}.`,
    "pt-pt": (cumulus)=>`Selecione um dos links abaixo para acessar outra \xe1rea do ${cumulus}.`,
    ru: (cumulus)=>`\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43E}\u{434}\u{43D}\u{443} \u{438}\u{437} \u{441}\u{441}\u{44B}\u{43B}\u{43E}\u{43A} \u{43D}\u{438}\u{436}\u{435}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{439} \u{43E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{438} ${cumulus}.`,
    sm: (cumulus)=>`Filifili se tasi o feso'ota'iga o lo'o i lalo e ulufale ai i se isi vaega o ${cumulus}.`,
    so: (cumulus)=>`Xulo mid ka mid ah isku xirayaasha hoose si aad u hesho meel kale oo ${cumulus} ah.`,
    th: (cumulus)=>`\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E43}\u{E19}\u{E25}\u{E34}\u{E07}\u{E04}\u{E4C}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1E}\u{E37}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E02}\u{E2D}\u{E07} ${cumulus}`,
    ur: (cumulus)=>`\u{6A9}\u{645}\u{648}\u{644}\u{633} \u{6A9}\u{6D2} \u{62F}\u{648}\u{633}\u{631}\u{6D2} \u{639}\u{644}\u{627}\u{642}\u{6D2} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{646}\u{6CC}\u{686}\u{6D2} \u{62F}\u{6CC}\u{626}\u{6D2} \u{6AF}\u{626}\u{6D2} \u{644}\u{646}\u{6A9}\u{633} \u{645}\u{6CC}\u{6BA} \u{633}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{6A9}\u{648} \u{645}\u{646}\u{62A}\u{62E}\u{628} ${cumulus}\u{6D4}`,
    vi: (cumulus)=>`Ch\u{1ECD}n m\u{1ED9}t trong c\xe1c li\xean k\u{1EBF}t b\xean d\u{1B0}\u{1EDB}i \u{111}\u{1EC3} truy c\u{1EAD}p m\u{1ED9}t khu v\u{1EF1}c kh\xe1c c\u{1EE7}a ${cumulus}.`,
    "zh-hans": (cumulus)=>`\u{9009}\u{62E9}\u{4E0B}\u{9762}\u{7684}\u{94FE}\u{63A5}\u{4E4B}\u{4E00}\u{4EE5}\u{8BBF}\u{95EE} ${cumulus} \u{7684}\u{53E6}\u{4E00}\u{4E2A}\u{533A}\u{57DF}\u{3002}`,
    "zh-hant": (cumulus)=>`\u{9078}\u{64C7}\u{4E0B}\u{9762}\u{7684}\u{9023}\u{7D50}\u{4E4B}\u{4E00}\u{4EE5}\u{8A2A}\u{554F} ${cumulus} \u{7684}\u{53E6}\u{4E00}\u{500B}\u{5340}\u{57DF}\u{3002}`,
    en: (cumulus)=>`Select one of the links below to access another area of ${cumulus}.`
};
const $2868cc1235412e16$export$2a0324215672f5c = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{645}\u{624}\u{633}\u{633}\u{627}\u{62A} \u{644}\u{62F}\u{64A}\u{647}\u{627} \u{639}\u{642}\u{62F} \u{646}\u{634}\u{637} \u{645}\u{639} \u{627}\u{644}\u{645}\u{62D}\u{627}\u{644} \u{625}\u{644}\u{64A}\u{647} \u{627}\u{644}\u{645}\u{62D}\u{62F}\u{62F}.`,
    de: `Keine Organisation hat einen aktiven Vertrag mit dem ausgew\xe4hlten Beauftragten.`,
    es: `Ninguna organizaci\xf3n tiene un contrato activo con la persona asignada seleccionada.`,
    fa: `\u{647}\u{6CC}\u{686} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC} \u{628}\u{627} \u{648}\u{627}\u{6AF}\u{630}\u{627}\u{631} \u{6A9}\u{646}\u{646}\u{62F}\u{647} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{634}\u{62F}\u{647} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Walang organisasyon ang may aktibong kontrata sa napiling assignee.`,
    fr: `Aucune organisation n\u{2019}a de contrat actif avec le cessionnaire s\xe9lectionn\xe9.`,
    hi: `\u{91A}\u{92F}\u{928}\u{93F}\u{924} \u{938}\u{92E}\u{928}\u{941}\u{926}\u{947}\u{936}\u{93F}\u{924}\u{940} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{915}\u{93F}\u{938}\u{940} \u{92D}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{93E} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{905}\u{928}\u{941}\u{92C}\u{902}\u{927} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Pa gen okenn \xf2ganizasyon ki gen yon kontra aktif ak asiyen yo chwazi.`,
    it: `Nessuna organizzazione ha un contratto attivo con l'assegnatario selezionato.`,
    ja: `\u{9078}\u{629E}\u{3057}\u{305F}\u{62C5}\u{5F53}\u{8005}\u{3068}\u{6709}\u{52B9}\u{306A}\u{5951}\u{7D04}\u{3092}\u{7D50}\u{3093}\u{3067}\u{3044}\u{308B}\u{7D44}\u{7E54}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C120}\u{D0DD}\u{D55C} \u{B2F4}\u{B2F9}\u{C790}\u{C640} \u{D65C}\u{C131} \u{ACC4}\u{C57D}\u{C744} \u{CCB4}\u{ACB0}\u{D55C} \u{C870}\u{C9C1}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj koom haum muaj ib daim ntawv cog lus nrog xaiv cov neeg xaiv.`,
    ps: `\u{647}\u{6CC}\u{685} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{633}\u{67E}\u{627}\u{631}\u{644} \u{634}\u{648}\u{6CC} \u{633}\u{631}\u{647} \u{641}\u{639}\u{627}\u{644} \u{642}\u{631}\u{627}\u{631}\u{62F}\u{627}\u{62F} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Nenhuma organiza\xe7\xe3o tem um contrato ativo com o destinat\xe1rio selecionado.`,
    "pt-pt": `Nenhuma organiza\xe7\xe3o tem um contrato ativo com o cession\xe1rio selecionado.`,
    ru: `\u{41D}\u{438} \u{43E}\u{434}\u{43D}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43D}\u{435} \u{438}\u{43C}\u{435}\u{435}\u{442} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{435}\u{433}\u{43E} \u{434}\u{43E}\u{433}\u{43E}\u{432}\u{43E}\u{440}\u{430} \u{441} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{44B}\u{43C} \u{446}\u{435}\u{441}\u{441}\u{438}\u{43E}\u{43D}\u{430}\u{440}\u{438}\u{435}\u{43C}.`,
    sm: `E leai se fa'alapotopotoga o lo'o i ai se konekarate fa'apitoa ma le tagata ua filifilia.`,
    so: `Majiraan ururo heshiis firfircoon oo lala galay shaqsiyihi loo xushay.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E43}\u{E14}\u{E21}\u{E35}\u{E2A}\u{E31}\u{E0D}\u{E0D}\u{E32}\u{E17}\u{E35}\u{E48}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E01}\u{E31}\u{E1A}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E17}\u{E35}\u{E48}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}`,
    ur: `\u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{62F}\u{6C1} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{646}\u{646}\u{62F}\u{6C1} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{6A9}\u{633}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627} \u{641}\u{639}\u{627}\u{644} \u{645}\u{639}\u{627}\u{6C1}\u{62F}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 t\u{1ED5} ch\u{1EE9}c n\xe0o c\xf3 h\u{1EE3}p \u{111}\u{1ED3}ng \u{111}ang ho\u{1EA1}t \u{111}\u{1ED9}ng v\u{1EDB}i ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c chuy\u{1EC3}n nh\u{1B0}\u{1EE3}ng \u{111}\xe3 ch\u{1ECD}n.`,
    "zh-hans": `\u{6CA1}\u{6709}\u{7EC4}\u{7EC7}\u{4E0E}\u{6240}\u{9009}\u{53D7}\u{7406}\u{4EBA}\u{7B7E}\u{8BA2}\u{6709}\u{6548}\u{5408}\u{540C}\u{3002}`,
    "zh-hant": `\u{6C92}\u{6709}\u{7D44}\u{7E54}\u{8207}\u{6240}\u{9078}\u{53D7}\u{7406}\u{4EBA}\u{7C3D}\u{8A02}\u{6709}\u{6548}\u{5408}\u{540C}\u{3002}`,
    en: `No organizations have an active contract with the selected assignee.`
};
const $2868cc1235412e16$export$d40a07ba4f2615ca = {
    ar: `\u{62C}\u{62F}\u{648}\u{644} \u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}`,
    de: `Nicht spezifizierter Zeitplan`,
    es: `Horario no especificado`,
    fa: `\u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Hindi tinukoy na iskedyul`,
    fr: `Horaire non pr\xe9cis\xe9`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F} \u{905}\u{928}\u{941}\u{938}\u{942}\u{91A}\u{940}`,
    ht: `Or\xe8 ki pa espesifye`,
    it: `Orario non specificato`,
    ja: `\u{30B9}\u{30B1}\u{30B8}\u{30E5}\u{30FC}\u{30EB}\u{4E0D}\u{8A73}`,
    ko: `\u{C9C0}\u{C815}\u{B418}\u{C9C0} \u{C54A}\u{C740} \u{C77C}\u{C815}`,
    mww: `Unspecified sij hawm`,
    ps: `\u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    pt: `Hor\xe1rio n\xe3o especificado`,
    "pt-pt": `Hor\xe1rio n\xe3o especificado`,
    ru: `\u{41D}\u{435}\u{443}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{43D}\u{43E}\u{435} \u{440}\u{430}\u{441}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Fa'asologa e le'i fa'amaonia`,
    so: `Jadwal aan la cayimin`,
    th: `\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{645}\u{62A}\u{639}\u{6CC}\u{646} \u{634}\u{6CC}\u{688}\u{648}\u{644}`,
    vi: `L\u{1ECB}ch tr\xecnh kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{672A}\u{6307}\u{5B9A}\u{7684}\u{65F6}\u{95F4}\u{8868}`,
    "zh-hant": `\u{672A}\u{6307}\u{5B9A}\u{7684}\u{6642}\u{7A0B}\u{8868}`,
    en: `Unspecified schedule`
};
const $2868cc1235412e16$export$5c09508cd75a09a2 = {
    ar: `\u{62A}\u{637}\u{639}\u{64A}\u{645}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{62D}\u{62F}\u{62F}\u{629} \u{62A}\u{642}\u{631}\u{64A}\u{628}\u{627}`,
    de: `Nicht n\xe4her bezeichnete Impfungen`,
    es: `Vacunas no especificadas`,
    fa: `\u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646}\u{627}\u{633}\u{6CC}\u{648}\u{646} \u{647}\u{627}\u{6CC} \u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Mga hindi natukoy na pagbabakuna`,
    fr: `Vaccinations non sp\xe9cifi\xe9es`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F} \u{91F}\u{940}\u{915}\u{93E}\u{915}\u{930}\u{923}`,
    ht: `Vaksen ki pa espesifye yo`,
    it: `Vaccinazioni non specificate`,
    ja: `\u{4E0D}\u{7279}\u{5B9A}\u{306E}\u{4E88}\u{9632}\u{63A5}\u{7A2E}`,
    ko: `\u{BD88}\u{D2B9}\u{C815} \u{BC31}\u{C2E0} \u{C811}\u{C885}`,
    mww: `Txhaj tshuaj tiv thaiv kab mob`,
    ps: `\u{646}\u{627}\u{645}\u{634}\u{62E}\u{635} \u{648}\u{627}\u{6A9}\u{633}\u{6CC}\u{646}`,
    pt: `Vacinas n\xe3o especificadas`,
    "pt-pt": `Vacinas n\xe3o especificadas`,
    ru: `\u{41D}\u{435}\u{443}\u{442}\u{43E}\u{447}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{43F}\u{440}\u{438}\u{432}\u{438}\u{432}\u{43A}\u{438}`,
    sm: `Tui e le'i fa'amaonia`,
    so: `Talaalo aan la cayimin`,
    th: `\u{E01}\u{E32}\u{E23}\u{E09}\u{E35}\u{E14}\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{648}\u{627}\u{636}\u{62D} \u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646}\u{6CC}\u{634}\u{646}`,
    vi: `Ti\xeam ch\u{1EE7}ng kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{672A}\u{6307}\u{5B9A}\u{7684}\u{75AB}\u{82D7}\u{63A5}\u{79CD}`,
    "zh-hant": `\u{672A}\u{6307}\u{5B9A}\u{7684}\u{75AB}\u{82D7}\u{63A5}\u{7A2E}`,
    en: `Unspecified vaccinations`
};
const $2868cc1235412e16$export$c91311ccbb68ea57 = {
    ar: `\u{644}\u{642}\u{627}\u{62D}`,
    de: `Impfstoff`,
    es: `Vacuna`,
    fa: `\u{648}\u{627}\u{6A9}\u{633}\u{646}`,
    fil: `Bakuna`,
    fr: `Vaccin`,
    hi: `\u{91F}\u{940}\u{915}\u{93E}`,
    ht: `Vaksen`,
    it: `Vaccino`,
    ja: `\u{30EF}\u{30AF}\u{30C1}\u{30F3}`,
    ko: `\u{BC31}\u{C2E0}`,
    mww: `txhaj tshuaj tiv thaiv`,
    ps: `\u{648}\u{627}\u{6A9}\u{633}\u{64A}\u{646}`,
    pt: `Vacina`,
    "pt-pt": `Vacina`,
    ru: `\u{412}\u{430}\u{43A}\u{446}\u{438}\u{43D}\u{430}`,
    sm: `Tui`,
    so: `Talaalka`,
    th: `\u{E27}\u{E31}\u{E04}\u{E0B}\u{E35}\u{E19}`,
    ur: `\u{648}\u{6CC}\u{6A9}\u{633}\u{6CC}\u{646}`,
    vi: `Vaccine`,
    "zh-hans": `\u{75AB}\u{82D7}`,
    "zh-hant": `\u{75AB}\u{82D7}`,
    en: `Vaccine`
};
const $2868cc1235412e16$export$6896487a24fde326 = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{62C}\u{644}\u{633}\u{62A}\u{643}. \u{633}\u{62C}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{644}\u{645}\u{62A}\u{627}\u{628}\u{639}\u{629} \u{62C}\u{644}\u{633}\u{62A}\u{643}.`,
    de: `Ihre Sitzung ist abgelaufen. Melden Sie sich an, um Ihre Sitzung fortzusetzen.`,
    es: `Su sesi\xf3n ha caducado. Inicie sesi\xf3n para continuar la sesi\xf3n.`,
    fa: `\u{62C}\u{644}\u{633}\u{647} \u{634}\u{645}\u{627} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{62F}\u{627}\u{645}\u{647} \u{62C}\u{644}\u{633}\u{647} \u{628}\u{647} \u{633}\u{6CC}\u{633}\u{62A}\u{645} \u{648}\u{627}\u{631}\u{62F} \u{634}\u{648}\u{6CC}\u{62F}.`,
    fil: `Nag-expire na ang session mo. Mag-sign in upang ipagpatuloy ang iyong sesyon.`,
    fr: `Votre session a expir\xe9. Connectez-vous pour poursuivre votre session.`,
    hi: `\u{906}\u{92A}\u{915}\u{93E} \u{938}\u{924}\u{94D}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{92F}\u{93E}\u{964} \u{905}\u{92A}\u{928}\u{93E} \u{938}\u{924}\u{94D}\u{930} \u{91C}\u{93E}\u{930}\u{940} \u{930}\u{916}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{938}\u{93E}\u{907}\u{928} \u{907}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Sesyon ou ekspirasyon. Siyen pou kontinye sesyon ou an.`,
    it: `La sessione \xe8 scaduta. Accedi per continuare la sessione.`,
    ja: `\u{30BB}\u{30C3}\u{30B7}\u{30E7}\u{30F3}\u{306E}\u{6709}\u{52B9}\u{671F}\u{9650}\u{304C}\u{5207}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}\u{30B5}\u{30A4}\u{30F3}\u{30A4}\u{30F3}\u{3057}\u{3066}\u{30BB}\u{30C3}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{7D9A}\u{884C}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C138}\u{C158}\u{C774} \u{B9CC}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C138}\u{C158}\u{C744} \u{ACC4}\u{C18D}\u{D558}\u{B824}\u{BA74} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{C138}\u{C694}.`,
    mww: `Koj qhib qhov kev sib kho. Kos npe rau qhov chaw qhib kev sib kho kom haum.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62C}\u{644}\u{633}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{631}\u{633}\u{6CC}\u{62F}\u{647}. \u{62F} \u{62E}\u{67E}\u{644}\u{6D0} \u{63A}\u{648}\u{646}\u{689}\u{6D0} \u{62F} \u{62F}\u{648}\u{627}\u{645} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{646}\u{646}\u{648}\u{681}\u{626}.`,
    pt: `Sua sess\xe3o expirou. Fa\xe7a login para continuar sua sess\xe3o.`,
    "pt-pt": `A sua sess\xe3o expirou. Inicie sess\xe3o para continuar a sua sess\xe3o.`,
    ru: `\u{421}\u{440}\u{43E}\u{43A} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{441}\u{435}\u{430}\u{43D}\u{441}\u{430} \u{438}\u{441}\u{442}\u{435}\u{43A}. \u{412}\u{43E}\u{439}\u{434}\u{438}\u{442}\u{435} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}, \u{447}\u{442}\u{43E}\u{431}\u{44B} \u{43F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{438}\u{442}\u{44C} \u{441}\u{435}\u{430}\u{43D}\u{441}.`,
    sm: `Ua uma le aoga o lau sauniga. Saini i totonu e faaauau ai lau sauniga.`,
    so: `Kulankaaguna waa uu dhacay. Gali si aad u sii socoto fadhigaaga.`,
    th: `\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38} \u{E25}\u{E07}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{627} \u{633}\u{6CC}\u{634}\u{646} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}\u{6D4} \u{627}\u{67E}\u{646}\u{627} \u{633}\u{6CC}\u{634}\u{646} \u{62C}\u{627}\u{631}\u{6CC} \u{631}\u{6A9}\u{6BE}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{633}\u{627}\u{626}\u{646} \u{627}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Phi\xean c\u{1EE7}a b\u{1EA1}n \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n. \u{110}\u{103}ng nh\u{1EAD}p \u{111}\u{1EC3} ti\u{1EBF}p t\u{1EE5}c phi\xean c\u{1EE7}a b\u{1EA1}n.`,
    "zh-hans": `\u{60A8}\u{7684}\u{4F1A}\u{8BDD}\u{5DF2}\u{8FC7}\u{671F}\u{3002}\u{767B}\u{5F55}\u{4EE5}\u{7EE7}\u{7EED}\u{60A8}\u{7684}\u{4F1A}\u{8BDD}\u{3002}`,
    "zh-hant": `\u{60A8}\u{7684}\u{5DE5}\u{4F5C}\u{968E}\u{6BB5}\u{5DF2}\u{904E}\u{671F}\u{3002}\u{767B}\u{9304}\u{4EE5}\u{7E7C}\u{7E8C}\u{60A8}\u{7684}\u{6703}\u{8A71}\u{3002}`,
    en: `Your session expired. Sign in to continue your session.`
};
const $2868cc1235412e16$export$403a32688f6224ee = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{627}\u{644}\u{62C}\u{644}\u{633}\u{629}`,
    de: `Sitzung abgelaufen`,
    es: `Sesi\xf3n caducada`,
    fa: `\u{62C}\u{644}\u{633}\u{647} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Nag-expire na ang sesyon`,
    fr: `Session expir\xe9e`,
    hi: `\u{938}\u{924}\u{94D}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{92F}\u{93E}`,
    ht: `Sesyon ekspirasyon`,
    it: `Sessione scaduta`,
    ja: `\u{30BB}\u{30C3}\u{30B7}\u{30E7}\u{30F3}\u{306E}\u{6709}\u{52B9}\u{671F}\u{9650}\u{304C}\u{5207}\u{308C}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C138}\u{C158}\u{C774} \u{B9CC}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhib expired`,
    ps: `\u{633}\u{6CC}\u{634}\u{646} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6CC}\u{62F}`,
    pt: `Sess\xe3o expirada`,
    "pt-pt": `Sess\xe3o expirada`,
    ru: `\u{421}\u{435}\u{430}\u{43D}\u{441} \u{438}\u{441}\u{442}\u{435}\u{43A}`,
    sm: `Ua uma le aoga o le sauniga`,
    so: `Fadhigii oo dhacay`,
    th: `\u{E40}\u{E0B}\u{E2A}\u{E0A}\u{E31}\u{E19}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{627}\u{62C}\u{644}\u{627}\u{633} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}`,
    vi: `Phi\xean \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n`,
    "zh-hans": `\u{4F1A}\u{8BDD}\u{5DF2}\u{8FC7}\u{671F}`,
    "zh-hant": `\u{6703}\u{8A71}\u{5DF2}\u{904E}\u{671F}`,
    en: `Session expired`
};
const $2868cc1235412e16$export$d23eb164d6900aed = {
    ar: `\u{639}\u{631}\u{636} \u{627}\u{644}\u{643}\u{644}`,
    de: `Alle anzeigen`,
    es: `Ver todo`,
    fa: `\u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{647}\u{645}\u{647}`,
    fil: `Tingnan ang lahat`,
    fr: `Voir tout`,
    hi: `\u{938}\u{92D}\u{940} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `Gade tout`,
    it: `Vedi tutto`,
    ja: `\u{3059}\u{3079}\u{3066}\u{8868}\u{793A}`,
    ko: `\u{C804}\u{CCB4}\u{BCF4}\u{AE30}`,
    mww: `Saib tag nrho`,
    ps: `\u{67C}\u{648}\u{644} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Ver tudo`,
    "pt-pt": `Ver tudo`,
    ru: `\u{41F}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{442}\u{44C} \u{432}\u{441}\u{435}`,
    sm: `Va'ai uma`,
    so: `View alle`,
    th: `\u{E14}\u{E39}\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{633}\u{628} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Xem t\u{1EA5}t c\u{1EA3}`,
    "zh-hans": `\u{67E5}\u{770B}\u{5168}\u{90E8}`,
    "zh-hant": `\u{67E5}\u{770B}\u{5168}\u{90E8}`,
    en: `View all`
};
const $2868cc1235412e16$export$e81e1f6da08081e8 = {
    ar: `\u{634}\u{62E}\u{635}`,
    de: `Person`,
    es: `Persona`,
    fa: `\u{641}\u{631}\u{62F}`,
    fil: `Tao`,
    fr: `Personne`,
    hi: `\u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}`,
    ht: `Moun`,
    it: `Persona`,
    ja: `\u{4EBA}`,
    ko: `\u{C0AC}\u{B78C}`,
    mww: `Neeg`,
    ps: `\u{62F} \u{647}\u{631}\u{627}\u{62A} \u{648}\u{644}\u{627}\u{6CC}\u{62A} \u{62F} \u{6A9}\u{631}\u{647}\u{6BC}\u{6D0} \u{62F} \u{631}\u{6CC}\u{627}\u{633}\u{62A}`,
    pt: `Pessoa`,
    "pt-pt": `Pessoa`,
    ru: `\u{427}\u{435}\u{43B}\u{43E}\u{432}\u{435}\u{43A}`,
    sm: `Tagata`,
    so: `Qofka`,
    th: `\u{E04}\u{E19}`,
    ur: `\u{634}\u{62E}\u{635}`,
    vi: `Ng\u{1B0}\u{1EDD}i`,
    "zh-hans": `\u{4EBA}`,
    "zh-hant": `\u{4EBA}`,
    en: `Person`
};
const $2868cc1235412e16$export$4b66abb8fbd01da6 = {
    ar: `\u{625}\u{646}\u{634}\u{627}\u{621} \u{639}\u{645}\u{64A}\u{644} / \u{645}\u{631}\u{64A}\u{636} / \u{639}\u{636}\u{648} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Erstellen eines neuen Kunden / Patienten / Mitglieds`,
    es: `Crear un nuevo cliente / paciente / miembro`,
    fa: `\u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6CC} / \u{628}\u{6CC}\u{645}\u{627}\u{631} / \u{639}\u{636}\u{648} \u{62C}\u{62F}\u{6CC}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Lumikha ng isang bagong kliyente / pasyente / miyembro`,
    fr: `Cr\xe9er un nouveau client / patient / membre`,
    hi: `\u{90F}\u{915} \u{928}\u{92F}\u{93E} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915} / \u{930}\u{94B}\u{917}\u{940} / \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Kreye yon nouvo kliyan / pasyan / manm`,
    it: `Crea un nuovo cliente/paziente/membro`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}/\u{60A3}\u{8005}/\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}`,
    ko: `\u{C0C8} \u{ACE0}\u{AC1D}/\u{D658}\u{C790}/\u{AD6C}\u{C131}\u{C6D0} \u{B9CC}\u{B4E4}\u{AE30}`,
    mww: `Tsim ib tug neeg muaj mob / tus neeg mob / tus neeg mob`,
    ps: `\u{6CC}\u{648} \u{646}\u{648}\u{6CC} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{647} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} / \u{646}\u{627}\u{631}\u{648}\u{63A} / \u{63A}\u{693}\u{6CC} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}`,
    pt: `Criar um novo cliente / paciente / membro`,
    "pt-pt": `Criar um novo cliente / paciente / membro`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{435} \u{43D}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430} / \u{43F}\u{430}\u{446}\u{438}\u{435}\u{43D}\u{442}\u{430} / \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430}`,
    sm: `Fausia se tagata fou / tagata ma'i / tagata`,
    so: `Abuuri macmiil cusub / bukaan / xubin`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32}\u{E43}\u{E2B}\u{E21}\u{E48} / \u{E1C}\u{E39}\u{E49}\u{E1B}\u{E48}\u{E27}\u{E22} / \u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{646}\u{6CC}\u{627} \u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} / \u{645}\u{631}\u{6CC}\u{636} / \u{645}\u{645}\u{628}\u{631} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o kh\xe1ch h\xe0ng / b\u{1EC7}nh nh\xe2n / th\xe0nh vi\xean m\u{1EDB}i`,
    "zh-hans": `\u{521B}\u{5EFA}\u{65B0}\u{5BA2}\u{6237} / \u{60A3}\u{8005} / \u{4F1A}\u{5458}`,
    "zh-hant": `\u{5275}\u{5EFA}\u{65B0}\u{5BA2}\u{6236} / \u{60A3}\u{8005} / \u{6703}\u{54E1}`,
    en: `Create a new client / patient / member`
};
const $2868cc1235412e16$export$bddf96b1b6d3652a = {
    ar: `\u{631}\u{627}\u{648}\u{648}\u{642}...`,
    de: `Filter...`,
    es: `Filtro...`,
    fa: `\u{641}\u{6CC}\u{644}\u{62A}\u{631}...`,
    fil: `Filter ...`,
    fr: `Filtre...`,
    hi: `\u{91B}\u{93E}\u{928}\u{928}\u{93E}\u{964}\u{964}\u{964}`,
    ht: `Filt\xe8 ...`,
    it: `Filtro...`,
    ja: `\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}\u{3002}\u{3002}\u{3002}`,
    ko: `\u{D544}\u{D130}...`,
    mww: `Lim...`,
    ps: `\u{641}\u{644}\u{67C}\u{631} ...`,
    pt: `Filtro...`,
    "pt-pt": `Filtrar...`,
    ru: `\u{424}\u{438}\u{43B}\u{44C}\u{442}\u{440}...`,
    sm: `Faamama ...`,
    so: `Filter...`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E07}   `,
    ur: `\u{641}\u{644}\u{679}\u{631}...`,
    vi: `B\u{1ED9} l\u{1ECD}c...`,
    "zh-hans": `\u{6EE4}\u{6CE2}\u{5668}\u{3002}\u{3002}\u{3002}`,
    "zh-hant": `\u{6FFE}\u{6CE2}\u{5668}\u{3002}\u{3002}\u{3002}`,
    en: `Filter...`
};
const $2868cc1235412e16$export$ca5f05f951113039 = {
    ar: `\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{62A}\u{635}\u{641}\u{64A}\u{629}`,
    de: `Filtern von Aktivit\xe4ten`,
    es: `Filtrar actividades`,
    fa: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{641}\u{6CC}\u{644}\u{62A}\u{631}`,
    fil: `I-filter ang mga aktibidad`,
    fr: `Filtrer les activit\xe9s`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Aktivite filtre`,
    it: `Filtrare le attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30EA}\u{30F3}\u{30B0}`,
    ko: `\u{D65C}\u{B3D9} \u{D544}\u{D130}\u{B9C1}`,
    mww: `Lim dej ua si`,
    ps: `\u{641}\u{644}\u{67C}\u{631} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Filtrar atividades`,
    "pt-pt": `Filtrar atividades`,
    ru: `\u{424}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{439}`,
    sm: `Gaoioiga faamama`,
    so: `Shaqooyin filter`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{641}\u{644}\u{679}\u{631} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{627}\u{6BA}`,
    vi: `L\u{1ECD}c ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `Filter \u{6D3B}\u{52A8}`,
    "zh-hant": `Filter \u{6D3B}\u{52D5}`,
    en: `Filter activities`
};
const $2868cc1235412e16$export$4d733303d0e71344 = {
    ar: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} جديدة</strong>: ابحث عن شخص`,
    de: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Neue ${activityTitle}</strong>: Suche nach einer Person`,
    es: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nueva ${activityTitle}</strong>: búsqueda de una persona`,
    fa: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} جدید</strong>: یک شخص را جستجو کنید`,
    fil: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Bagong ${activityTitle}</strong>: Paghahanap ng Isang Tao`,
    fr: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nouvelle ${activityTitle}</strong> : recherche d’une personne`,
    hi: (activityTitle)=>$2868cc1235412e16$var$html`<strong>नया ${activityTitle}</strong>: किसी व्यक्ति की खोज करें`,
    ht: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nouvo ${activityTitle}</strong>: rechèch pou yon moun`,
    it: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nuovo ${activityTitle}</strong>: cerca una persona`,
    ja: (activityTitle)=>$2868cc1235412e16$var$html`<strong>新規 ${activityTitle}</strong>:人を探す`,
    ko: (activityTitle)=>$2868cc1235412e16$var$html`<strong>새 ${activityTitle}</strong>: 사람 검색`,
    mww: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}</strong> tshiab: nrhiav ib tug neeg`,
    ps: (activityTitle)=>$2868cc1235412e16$var$html`<strong>نوی ${activityTitle}</strong> کول: د یو کس لټون وکړئ`,
    pt: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nova ${activityTitle}</strong>: procurar uma pessoa`,
    "pt-pt": (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nova ${activityTitle}</strong>: procurar uma pessoa`,
    ru: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Новый ${activityTitle}</strong>: поиск человека`,
    sm: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}</strong>: Saili se Tagata`,
    so: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} cusub</strong>: Raadinta qofka`,
    th: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}ใหม่</strong>: ค้นหาบุคคล`,
    ur: (activityTitle)=>$2868cc1235412e16$var$html`<strong>نیا ${activityTitle}</strong>: کسی شخص کی تلاش`,
    vi: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} mới</strong>: tìm kiếm một người`,
    "zh-hans": (activityTitle)=>$2868cc1235412e16$var$html`<strong>新 ${activityTitle}</strong>人：搜索人员`,
    "zh-hant": (activityTitle)=>$2868cc1235412e16$var$html`<strong>新 ${activityTitle}</strong>人：搜索人員`,
    en: (activityTitle)=>$2868cc1235412e16$var$html`<strong>New ${activityTitle}</strong>: search for a person`
};
const $2868cc1235412e16$export$5a1b1a4071572031 = {
    ar: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} جديدة</strong>: إنشاء شخص جديد`,
    de: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Neue ${activityTitle}</strong>: Erstellen Sie eine neue Person`,
    es: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nueva ${activityTitle}</strong>: crear una nueva persona`,
    fa: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} جدید</strong>: یک شخص جدید ایجاد کنید`,
    fil: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Bagong ${activityTitle}</strong>: Lumikha ng Bagong Tao`,
    fr: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nouvelle ${activityTitle}</strong> : créer une nouvelle personne`,
    hi: (activityTitle)=>$2868cc1235412e16$var$html`<strong>नया ${activityTitle}</strong>: एक नया व्यक्ति बनाएं`,
    ht: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nouvo ${activityTitle}</strong>: kreye yon nouvo moun`,
    it: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nuovo ${activityTitle}</strong>: crea una nuova persona`,
    ja: (activityTitle)=>$2868cc1235412e16$var$html`<strong>新しい ${activityTitle}</strong>:新しい人を作成します`,
    ko: (activityTitle)=>$2868cc1235412e16$var$html`<strong>새 ${activityTitle}</strong>: 새 사용자 만들기`,
    mww: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}</strong> tsim ib tug neeg tshiab`,
    ps: (activityTitle)=>$2868cc1235412e16$var$html`<strong>نوی ${activityTitle}</strong> کول: یو نوی کس جوړ کړئ`,
    pt: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nova ${activityTitle}</strong>: criar uma nova pessoa`,
    "pt-pt": (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nova ${activityTitle}</strong>: crie uma nova pessoa`,
    ru: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Новый ${activityTitle}</strong>: создать нового человека`,
    sm: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}</strong>: Fausia se Tagata Fou`,
    so: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} cusub</strong>: In la abuuro qof cusub`,
    th: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}ใหม่</strong>: สร้างบุคคลใหม่`,
    ur: (activityTitle)=>$2868cc1235412e16$var$html`<strong>نیا ${activityTitle}</strong>: ایک نیا شخص بنائیں`,
    vi: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} mới</strong>: tạo người mới`,
    "zh-hans": (activityTitle)=>$2868cc1235412e16$var$html`<strong>新 ${activityTitle}</strong>人：创建新人员`,
    "zh-hant": (activityTitle)=>$2868cc1235412e16$var$html`<strong>新 ${activityTitle}</strong>人：創建新人員`,
    en: (activityTitle)=>$2868cc1235412e16$var$html`<strong>New ${activityTitle}</strong>: create a new person`
};
const $2868cc1235412e16$export$1746a150ab2ffbf4 = {
    ar: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} الجديدة</strong>: حدد النشاط الذي سيتم ربط ${activityTitle} الجديدة به`,
    de: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Neue ${activityTitle}</strong>: Wählen Sie die Aktivität aus, mit der die neue ${activityTitle} verknüpft werden soll`,
    es: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nueva ${activityTitle}</strong>: seleccione la actividad a la que se asociará la nueva ${activityTitle}`,
    fa: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} جدید</strong>: فعالیتی را که ${activityTitle} جدید با آن مرتبط است انتخاب کنید`,
    fil: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Bagong ${activityTitle}</strong>: piliin ang aktibidad na maiuugnay sa bagong ${activityTitle}`,
    fr: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nouveau ${activityTitle}</strong> : sélectionnez l’activité à laquelle le nouveau ${activityTitle} sera associé`,
    hi: (activityTitle)=>$2868cc1235412e16$var$html`<strong>नया ${activityTitle}</strong>: उस गतिविधि का चयन करें जिससे नया ${activityTitle} संबद्ध होगा`,
    ht: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nouvo ${activityTitle}</strong>: chwazi aktivite a nouvo ${activityTitle} lan pral asosye ak`,
    it: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nuovo ${activityTitle}</strong>: seleziona l'attività a cui sarà associato il nuovo ${activityTitle}`,
    ja: (activityTitle)=>$2868cc1235412e16$var$html`<strong>新しい ${activityTitle}</strong>: 新しい ${activityTitle} が関連付けられるアクティビティを選択します`,
    ko: (activityTitle)=>$2868cc1235412e16$var$html`<strong>새 ${activityTitle}</strong>: 새 ${activityTitle} 이 연결될 활동을 선택합니다.`,
    mww: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}</strong> xaiv qhov kev ${activityTitle} yuav raug mob nrog`,
    ps: (activityTitle)=>$2868cc1235412e16$var$html`<strong>نوی ${activityTitle}</strong> کول: هغه فعالیت غوره کړئ چې نوی ${activityTitle} به ورسره تړاو ولری`,
    pt: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nova ${activityTitle}</strong>: selecione a atividade à qual a nova ${activityTitle} será associada`,
    "pt-pt": (activityTitle)=>$2868cc1235412e16$var$html`<strong>Nova ${activityTitle}</strong>: selecione a atividade à qual a nova ${activityTitle} será associada`,
    ru: (activityTitle)=>$2868cc1235412e16$var$html`<strong>Новый ${activityTitle}</strong>: выберите активность, с которой будет связан новый ${activityTitle}`,
    sm: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} fou</strong>: filifili le gaioiga o le a feso'ota'i ma le ${activityTitle} fou`,
    so: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} cusub</strong>: dooro dhaqdhaqaaqa ${activityTitle} cusub ee lala xiriirin doono`,
    th: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle}ใหม่</strong>: เลือกกิจกรรมที่จะเชื่อมโยงกับ${activityTitle}ใหม่`,
    ur: (activityTitle)=>$2868cc1235412e16$var$html`<strong>نیا ${activityTitle}</strong>: اس سرگرمی کا انتخاب کریں جس سے نیا ${activityTitle} وابستہ ہوگا`,
    vi: (activityTitle)=>$2868cc1235412e16$var$html`<strong>${activityTitle} mới</strong>: chọn hoạt động mà ${activityTitle} mới sẽ được liên kết`,
    "zh-hans": (activityTitle)=>$2868cc1235412e16$var$html`<strong>New ${activityTitle}</strong>：选择新 ${activityTitle} 将与之关联的活动`,
    "zh-hant": (activityTitle)=>$2868cc1235412e16$var$html`<strong>New ${activityTitle}</strong>：選擇新 ${activityTitle} 將與之關聯的活動`,
    en: (activityTitle)=>$2868cc1235412e16$var$html`<strong>New ${activityTitle}</strong>: select the activity the new ${activityTitle} will be associated with`
};
const $2868cc1235412e16$export$5ed4ca5ae1852886 = {
    ar: `\u{62A}\u{634}\u{64A}\u{631}`,
    de: `Verweisen`,
    es: `Recomienda`,
    fa: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Sumangguni`,
    fr: `Parrainer`,
    hi: `\u{938}\u{94C}\u{902}\u{92A}\u{928}\u{93E}`,
    ht: `Refere`,
    it: `Segnalare`,
    ja: `\u{53C2}\u{7167}`,
    ko: `\u{C5B8}\u{AE09}\u{D558}\u{B2E4}`,
    mww: `Xa mus rau`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Referir`,
    "pt-pt": `Consultar`,
    ru: `\u{41E}\u{442}\u{441}\u{44B}\u{43B}\u{430}\u{442}\u{44C}`,
    sm: `Fa'asino`,
    so: `Tixraac`,
    th: `\u{E2D}\u{E49}\u{E32}\u{E07}\u{E16}\u{E36}\u{E07}`,
    ur: `\u{62D}\u{648}\u{627}\u{644}\u{6C1} \u{62F}\u{6CC}\u{6BA}`,
    vi: `Tham kh\u{1EA3}o`,
    "zh-hans": `\u{6307}`,
    "zh-hant": `\u{6307}`,
    en: `Refer`
};
const $2868cc1235412e16$export$d34624142074fad = {
    ar: `\u{625}\u{646}\u{634}\u{627}\u{621} \u{625}\u{62D}\u{627}\u{644}\u{629} \u{62C}\u{62F}\u{64A}\u{62F}\u{629}`,
    de: `Erstellen einer neuen Empfehlung`,
    es: `Crear una nueva referencia`,
    fa: `\u{6CC}\u{6A9} \u{627}\u{631}\u{62C}\u{627}\u{639} \u{62C}\u{62F}\u{6CC}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Lumikha ng Bagong Referral`,
    fr: `Cr\xe9er une nouvelle r\xe9f\xe9rence`,
    hi: `\u{90F}\u{915} \u{928}\u{92F}\u{93E} \u{930}\u{947}\u{92B}\u{93C}\u{930}\u{932} \u{92C}\u{928}\u{93E}\u{90F}\u{901}`,
    ht: `Kreye yon nouvo rek\xf2mandasyon`,
    it: `Crea un nuovo referral`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{7D39}\u{4ECB}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}`,
    ko: `\u{C0C8} \u{CD94}\u{CC9C} \u{B9CC}\u{B4E4}\u{AE30}`,
    mww: `Tsim ib tug xa mus cuag tshiab`,
    ps: `\u{6CC}\u{648} \u{646}\u{648}\u{6CC} \u{62D}\u{648}\u{627}\u{644}\u{647} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}`,
    pt: `Criar uma nova indica\xe7\xe3o`,
    "pt-pt": `Criar uma nova refer\xeancia`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435} \u{43D}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{440}\u{435}\u{444}\u{435}\u{440}\u{430}\u{43B}\u{430}`,
    sm: `Fausia se fa'asino fou`,
    so: `Loo abuuro gudbin cusub`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{646}\u{6CC}\u{627} \u{62D}\u{648}\u{627}\u{644}\u{6C1} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o gi\u{1EDB}i thi\u{1EC7}u m\u{1EDB}i`,
    "zh-hans": `\u{521B}\u{5EFA}\u{65B0}\u{7684}\u{5F15}\u{8350}`,
    "zh-hant": `\u{5275}\u{5EFA}\u{65B0}\u{7684}\u{5F15}\u{85A6}`,
    en: `Create a new referral`
};
const $2868cc1235412e16$export$40913c340b574d55 = {
    ar: `\u{631}\u{641}\u{639}`,
    de: `Hochladen`,
    es: `Subir`,
    fa: `\u{622}\u{67E}\u{644}\u{648}\u{62F}`,
    fil: `Email Address *`,
    fr: `T\xe9l\xe9charger`,
    hi: `\u{905}\u{92A}\u{932}\u{94B}\u{921}`,
    ht: `Upload`,
    it: `Caricare`,
    ja: `\u{30A2}\u{30C3}\u{30D7}\u{30ED}\u{30FC}\u{30C9}`,
    ko: `\u{C5C5}\u{B85C}\u{B4DC}`,
    mww: `upload`,
    ps: `\u{67E}\u{648}\u{631}\u{62A}\u{647} \u{6A9}\u{648}\u{644}`,
    pt: `Carregar`,
    "pt-pt": `Carregar`,
    ru: `\u{417}\u{430}\u{43A}\u{430}\u{447}\u{430}\u{442}\u{44C}`,
    sm: `Fa'apipi'i`,
    so: `Hore`,
    th: `\u{E2D}\u{E31}\u{E1B}\u{E42}\u{E2B}\u{E25}\u{E14}`,
    ur: `\u{627}\u{67E} \u{644}\u{648}\u{688}`,
    vi: `T\u{1EA3}i l\xean`,
    "zh-hans": `\u{4E0A}\u{4F20}`,
    "zh-hant": `\u{4E0A}\u{50B3}`,
    en: `Upload`
};
const $2868cc1235412e16$export$4e7f15e54ab2c37d = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{645}\u{644}\u{641}`,
    de: `Datei ausw\xe4hlen`,
    es: `Elegir archivo`,
    fa: `\u{641}\u{627}\u{6CC}\u{644} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Email:`,
    fr: `Choisissez un fichier`,
    hi: `\u{92B}\u{93C}\u{93E}\u{907}\u{932} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi dosye`,
    it: `Scegli il file`,
    ja: `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{D30C}\u{C77C} \u{C120}\u{D0DD}`,
    mww: `Xaiv cov ntaub ntawv xaiv`,
    ps: `\u{62F}\u{648}\u{633}\u{6CC}\u{647}`,
    pt: `Escolher arquivo`,
    "pt-pt": `Escolher ficheiro`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B}`,
    sm: `Filifili le faila`,
    so: `Dooro file`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `\u{641}\u{627}\u{626}\u{644} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n t\u{1EC7}p`,
    "zh-hans": `\u{9009}\u{62E9}\u{6587}\u{4EF6}`,
    "zh-hant": `\u{9078}\u{64C7}\u{6A94}\u{6848}`,
    en: `Choose file`
};
const $2868cc1235412e16$export$9c74c928b7f96fab = {
    ar: `1 \u{645}\u{644}\u{641}`,
    de: `1 Datei`,
    es: `1 fichero`,
    fa: `1 \u{641}\u{627}\u{6CC}\u{644}`,
    fil: `1 file`,
    fr: `1 fichier`,
    hi: `1 \u{92B}\u{93C}\u{93E}\u{907}\u{932}`,
    ht: `1 dosye`,
    it: `1 fascicolo`,
    ja: `1\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: `\u{D30C}\u{C77C} 1\u{AC1C}`,
    mww: `1 ntaub ntawv`,
    ps: `1 \u{641}\u{627}\u{6CC}\u{644}`,
    pt: `1 arquivo`,
    "pt-pt": `1 ficheiro`,
    ru: `1 \u{444}\u{430}\u{439}\u{43B}`,
    sm: `1 faila`,
    so: `1 loox file`,
    th: `1 \u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: `1 \u{641}\u{627}\u{626}\u{644}`,
    vi: `1 t\u{1EAD}p tin`,
    "zh-hans": `1 \u{4E2A}\u{6587}\u{4EF6}`,
    "zh-hant": `1 \u{500B}\u{6A94}`,
    en: `1 file`
};
const $2868cc1235412e16$export$a9eeb925e66f3fef = {
    ar: (count)=>`${count} \u{645}\u{644}\u{641}\u{627}\u{62A}`,
    de: (count)=>`${count} Dateien`,
    es: (count)=>`${count} archivos`,
    fa: (count)=>`${count} \u{641}\u{627}\u{6CC}\u{644}`,
    fil: (count)=>`${count} Mga File`,
    fr: (count)=>`${count} fichiers`,
    hi: (count)=>`${count} \u{92B}\u{93C}\u{93E}\u{907}\u{932}\u{947}\u{902}`,
    ht: (count)=>`${count} dosye`,
    it: (count)=>`${count} file`,
    ja: (count)=>`${count} \u{500B}\u{306E}\u{30D5}\u{30A1}\u{30A4}\u{30EB}`,
    ko: (count)=>`${count} \u{AC1C}`,
    mww: (count)=>`${count} cov ntaub ntawv`,
    ps: (count)=>`${count} \u{62F}\u{648}\u{62A}\u{646}\u{6D0}`,
    pt: (count)=>`${count} arquivos`,
    "pt-pt": (count)=>`${count} ficheiros`,
    ru: (count)=>`${count} \u{444}\u{430}\u{439}\u{43B}\u{430}`,
    sm: (count)=>`${count} faila`,
    so: (count)=>`${count} files`,
    th: (count)=>`${count} \u{E44}\u{E1F}\u{E25}\u{E4C}`,
    ur: (count)=>`${count} \u{641}\u{627}\u{626}\u{644}\u{6CC}\u{6BA}`,
    vi: (count)=>`${count} t\u{1EAD}p tin`,
    "zh-hans": (count)=>`${count} \u{4E2A}\u{6587}\u{4EF6}`,
    "zh-hant": (count)=>`${count} \u{500B}\u{6A94}`,
    en: (count)=>`${count} files`
};
const $2868cc1235412e16$export$deaf0532c0f7c33c = {
    ar: `\u{648}\u{642}\u{639}`,
    de: `Zeichen`,
    es: `Firmar`,
    fa: `\u{646}\u{634}\u{627}\u{646}\u{647}`,
    fil: `Mag-sign`,
    fr: `Signe`,
    hi: `\u{938}\u{902}\u{915}\u{947}\u{924}`,
    ht: `Siyen`,
    it: `Segno`,
    ja: `\u{770B}\u{677F}`,
    ko: `\u{AE30}\u{D638}`,
    mww: `Kos`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Sinal`,
    "pt-pt": `Assinar`,
    ru: `\u{417}\u{43D}\u{430}\u{43A}`,
    sm: `Saini`,
    so: `Saxiix`,
    th: `\u{E2A}\u{E31}\u{E0D}\u{E25}\u{E31}\u{E01}\u{E29}\u{E13}\u{E4C}`,
    ur: `\u{639}\u{644}\u{627}\u{645}\u{62A}`,
    vi: `D\u{1EA5}u`,
    "zh-hans": `\u{6807}\u{5FD7}`,
    "zh-hant": `\u{6A19}\u{8A8C}`,
    en: `Sign`
};
const $2868cc1235412e16$export$903fdd498f951277 = {
    ar: `\u{642}\u{628}\u{648}\u{644} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Unterschrift akzeptieren`,
    es: `Aceptar firma`,
    fa: `\u{627}\u{645}\u{636}\u{627} \u{631}\u{627} \u{628}\u{67E}\u{630}\u{6CC}\u{631}\u{6CC}\u{62F}`,
    fil: `Tanggapin ang lagda`,
    fr: `Accepter la signature`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Siyati aksepte`,
    it: `Accetta firma`,
    ja: `\u{7F72}\u{540D}\u{306E}\u{53D7}\u{7406}`,
    ko: `\u{C11C}\u{BA85} \u{C218}\u{B77D}`,
    mww: `Kos npe`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Aceitar assinatura`,
    "pt-pt": `Aceitar assinatura`,
    ru: `\u{41F}\u{440}\u{438}\u{43D}\u{44F}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Talia le saini`,
    so: `Aqbasho saxiixa`,
    th: `\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{642}\u{628}\u{648}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EA5}p nh\u{1EAD}n ch\u{1EEF} k\xfd`,
    "zh-hans": `\u{63A5}\u{53D7}\u{7B7E}\u{540D}`,
    "zh-hant": `\u{63A5}\u{53D7}\u{7C3D}\u{540D}`,
    en: `Accept signature`
};
const $2868cc1235412e16$export$afc2b2276166ee6e = {
    ar: `\u{62A}\u{631}\u{627}\u{62C}\u{639}`,
    de: `Aufmachen`,
    es: `Deshacer`,
    fa: `\u{62E}\u{646}\u{62B}\u{6CC}\u{633}\u{627}\u{632}\u{6CC}`,
    fil: `I-undo`,
    fr: `D\xe9faire`,
    hi: `\u{916}\u{94B}\u{932}\u{928}\u{93E}`,
    ht: `Def\xe8t`,
    it: `Disfare`,
    ja: `\u{5916}\u{3059}`,
    ko: `\u{CDE8}\u{C18C}`,
    mww: `undo`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Desfazer`,
    "pt-pt": `Desfazer`,
    ru: `\u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{44C}`,
    sm: `Toe fa'afo'i`,
    so: `Undo`,
    th: `\u{E41}\u{E01}\u{E49}`,
    ur: `\u{6A9}\u{627}\u{644}\u{639}\u{62F}\u{645}`,
    vi: `Ho\xe0n t\xe1c`,
    "zh-hans": `\u{64A4}\u{6D88}`,
    "zh-hant": `\u{6062}\u{5FA9}`,
    en: `Undo`
};
const $2868cc1235412e16$export$120f8f20e674504b = {
    ar: `\u{628}\u{642}\u{628}\u{648}\u{644} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{60C} \u{641}\u{625}\u{646}\u{643} \u{62A}\u{648}\u{627}\u{641}\u{642} \u{639}\u{644}\u{649} \u{623}\u{646}\u{647} \u{64A}\u{645}\u{643}\u{646} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{627} \u{648}\u{623}\u{646} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{638}\u{647}\u{631} \u{641}\u{64A} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{647}\u{64A} \u{646}\u{641}\u{633} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{643}\u{62A}\u{648}\u{628}\u{629} \u{628}\u{62E}\u{637} \u{627}\u{644}\u{64A}\u{62F} \u{644}\u{623}\u{63A}\u{631}\u{627}\u{636} \u{627}\u{644}\u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{62A}\u{646}\u{641}\u{64A}\u{630} \u{648}\u{627}\u{644}\u{645}\u{642}\u{628}\u{648}\u{644}\u{64A}\u{629}.`,
    de: `Indem Sie diese Signatur akzeptieren, erkl\xe4ren Sie sich damit einverstanden, dass diese Aktivit\xe4t elektronisch signiert werden kann und dass die elektronischen Signaturen, die auf dieser Aktivit\xe4t erscheinen, zum Zwecke der G\xfcltigkeit, Durchsetzbarkeit und Zul\xe4ssigkeit mit handschriftlichen Unterschriften identisch sind.`,
    es: `Al aceptar esta firma, usted acepta que esta actividad puede estar firmada electr\xf3nicamente y que las firmas electr\xf3nicas que aparecen en esta actividad son las mismas que las firmas manuscritas a efectos de validez, aplicabilidad y admisibilidad.`,
    fa: `\u{628}\u{627} \u{67E}\u{630}\u{6CC}\u{631}\u{634} \u{627}\u{6CC}\u{646} \u{627}\u{645}\u{636}\u{627}\u{60C} \u{634}\u{645}\u{627} \u{645}\u{648}\u{627}\u{641}\u{642}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{6A9}\u{647} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{645}\u{6A9}\u{646} \u{627}\u{633}\u{62A} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{627}\u{645}\u{636}\u{627} \u{634}\u{648}\u{62F} \u{648} \u{627}\u{645}\u{636}\u{627}\u{647}\u{627}\u{6CC} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{638}\u{627}\u{647}\u{631} \u{634}\u{62F}\u{647} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{627}\u{646}\u{646}\u{62F} \u{627}\u{645}\u{636}\u{627}\u{647}\u{627}\u{6CC} \u{62F}\u{633}\u{62A} \u{646}\u{648}\u{6CC}\u{633} \u{628}\u{647} \u{645}\u{646}\u{638}\u{648}\u{631} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631}\u{60C} \u{642}\u{627}\u{628}\u{644}\u{6CC}\u{62A} \u{627}\u{62C}\u{631}\u{627} \u{648} \u{642}\u{627}\u{628}\u{644} \u{642}\u{628}\u{648}\u{644} \u{628}\u{648}\u{62F}\u{646} \u{647}\u{633}\u{62A}\u{646}\u{62F}.`,
    fil: `Sa pamamagitan ng pagtanggap ng lagda na ito, sumasang-ayon ka na ang aktibidad na ito ay maaaring lagdaan nang elektroniko at ang mga elektronikong lagda na lumilitaw sa aktibidad na ito ay kapareho ng mga sulat-kamay na lagda para sa mga layunin ng bisa, pagpapatupad, at katanggap-tanggap.`,
    fr: `En acceptant cette signature, vous acceptez que cette activit\xe9 puisse \xeatre sign\xe9e \xe9lectroniquement et que les signatures \xe9lectroniques apparaissant sur cette activit\xe9 soient les m\xeames que les signatures manuscrites aux fins de validit\xe9, d\u{2019}applicabilit\xe9 et d\u{2019}admissibilit\xe9.`,
    hi: `\u{907}\u{938} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{94B} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930} \u{915}\u{930}\u{915}\u{947} \u{906}\u{92A} \u{938}\u{939}\u{92E}\u{924} \u{939}\u{948}\u{902} \u{915}\u{93F} \u{92F}\u{939} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{907}\u{932}\u{947}\u{915}\u{94D}\u{91F}\u{94D}\u{930}\u{949}\u{928}\u{93F}\u{915} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930}\u{93F}\u{924} \u{939}\u{94B} \u{938}\u{915}\u{924}\u{940} \u{939}\u{948} \u{914}\u{930} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{930} \u{92A}\u{94D}\u{930}\u{926}\u{930}\u{94D}\u{936}\u{93F}\u{924} \u{939}\u{94B}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{907}\u{932}\u{947}\u{915}\u{94D}\u{91F}\u{94D}\u{930}\u{949}\u{928}\u{93F}\u{915} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{935}\u{948}\u{927}\u{924}\u{93E}, \u{92A}\u{94D}\u{930}\u{935}\u{930}\u{94D}\u{924}\u{928}\u{940}\u{92F}\u{924}\u{93E} \u{914}\u{930} \u{938}\u{94D}\u{935}\u{940}\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{924}\u{93E} \u{915}\u{947} \u{909}\u{926}\u{94D}\u{926}\u{947}\u{936}\u{94D}\u{92F}\u{94B}\u{902} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{939}\u{938}\u{94D}\u{924}\u{932}\u{93F}\u{916}\u{93F}\u{924} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{947} \u{938}\u{92E}\u{93E}\u{928} \u{939}\u{948}\u{902}\u{964}`,
    ht: `Pa aksepte siyati sa a ou dak\xf2 ke aktivite sa a ka elektwonikman siyen e ke siyati elektwonik yo par\xe8t sou aktivite sa a se menm bagay la k\xf2m siyati ekri alamen pou rezon validite, ranf\xf2se, ak admisibilite.`,
    it: `Accettando questa firma, l'utente accetta che questa attivit\xe0 possa essere firmata elettronicamente e che le firme elettroniche che appaiono su questa attivit\xe0 siano le stesse delle firme autografe ai fini della validit\xe0, dell'esecutivit\xe0 e dell'ammissibilit\xe0.`,
    ja: `\u{3053}\u{306E}\u{7F72}\u{540D}\u{3092}\u{53D7}\u{7406}\u{3059}\u{308B}\u{3053}\u{3068}\u{306B}\u{3088}\u{308A}\u{3001}\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{304C}\u{96FB}\u{5B50}\u{7F72}\u{540D}\u{3055}\u{308C}\u{308B}\u{3053}\u{3068}\u{3001}\u{304A}\u{3088}\u{3073}\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{306B}\u{8868}\u{793A}\u{3055}\u{308C}\u{308B}\u{96FB}\u{5B50}\u{7F72}\u{540D}\u{304C}\u{6709}\u{52B9}\u{6027}\u{3001}\u{57F7}\u{884C}\u{53EF}\u{80FD}\u{6027}\u{3001}\u{304A}\u{3088}\u{3073}\u{8A31}\u{5BB9}\u{6027}\u{306E}\u{76EE}\u{7684}\u{3067}\u{624B}\u{66F8}\u{304D}\u{306E}\u{7F72}\u{540D}\u{3068}\u{540C}\u{3058}\u{3067}\u{3042}\u{308B}\u{3053}\u{3068}\u{306B}\u{540C}\u{610F}\u{3059}\u{308B}\u{3082}\u{306E}\u{3068}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{C11C}\u{BA85}\u{C744} \u{C218}\u{B77D}\u{D568}\u{C73C}\u{B85C}\u{C368} \u{ADC0}\u{D558}\u{B294} \u{C774} \u{D65C}\u{B3D9}\u{C774} \u{C804}\u{C790}\u{C801}\u{C73C}\u{B85C} \u{C11C}\u{BA85}\u{B420} \u{C218} \u{C788}\u{C73C}\u{BA70} \u{C774} \u{D65C}\u{B3D9}\u{C5D0} \u{B098}\u{D0C0}\u{B098}\u{B294} \u{C804}\u{C790} \u{C11C}\u{BA85}\u{C774} \u{C720}\u{D6A8}\u{C131}, \u{C9D1}\u{D589} \u{AC00}\u{B2A5}\u{C131} \u{BC0F} \u{D5C8}\u{C6A9} \u{AC00}\u{B2A5}\u{C131}\u{C744} \u{C704}\u{D574} \u{C218}\u{AE30} \u{C11C}\u{BA85}\u{ACFC} \u{B3D9}\u{C77C}\u{D558}\u{B2E4}\u{B294} \u{B370} \u{B3D9}\u{C758}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Yog txais qhov kos npe no koj pom zoo tias qhov kev ua no tej zaum yuav tau electronically kos npe thiab tias cov kos npe kos npe hnyuj hnyo rau qhov kev ua no yog tib yam li handwritten kos npe rau lub hom phiaj ntawm validity, enforceability, thiab admissibility.`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{67E}\u{647} \u{645}\u{646}\u{644}\u{648} \u{633}\u{631}\u{647} \u{62A}\u{627}\u{633}\u{648} \u{645}\u{648}\u{627}\u{641}\u{642} \u{6CC}\u{627}\u{633}\u{62A} \u{686}\u{6D0} \u{62F}\u{627} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6CC}\u{62F}\u{627}\u{6CC} \u{634}\u{6CC} \u{67E}\u{647} \u{628}\u{631}\u{6CC}\u{69A}\u{646}\u{627}\u{6CC}\u{6CC} \u{62A}\u{648}\u{6AB}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{634}\u{6CC} \u{627}\u{648} \u{62F}\u{627} \u{686}\u{6D0} \u{647}\u{63A}\u{647} \u{628}\u{631}\u{6CC}\u{69A}\u{646}\u{627}\u{6CC}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D0} \u{69A}\u{6A9}\u{627}\u{631}\u{647} \u{6A9}\u{6CC}\u{696}\u{6CC} \u{62F} \u{627}\u{639}\u{62A}\u{628}\u{627}\u{631} \u{60C} \u{62A}\u{646}\u{641}\u{6CC}\u{630} \u{627}\u{648} \u{645}\u{646}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{62F} \u{644}\u{627}\u{633} \u{644}\u{6CC}\u{6A9}\u{644} \u{634}\u{648}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{648} \u{633}\u{631}\u{647} \u{648}\u{631}\u{62A}\u{647} \u{62F}\u{6CC}.`,
    pt: `Ao aceitar esta assinatura, voc\xea concorda que esta atividade pode ser assinada eletronicamente e que as assinaturas eletr\xf4nicas que aparecem nesta atividade s\xe3o as mesmas que as assinaturas manuscritas para fins de validade, aplicabilidade e admissibilidade.`,
    "pt-pt": `Ao aceitar esta assinatura, voc\xea concorda que esta atividade pode ser assinada eletronicamente e que as assinaturas eletr\xf4nicas que aparecem nesta atividade s\xe3o as mesmas que as assinaturas manuscritas para fins de validade, executoriedade e admissibilidade.`,
    ru: `\u{41F}\u{440}\u{438}\u{43D}\u{438}\u{43C}\u{430}\u{44F} \u{44D}\u{442}\u{443} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}, \u{432}\u{44B} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{448}\u{430}\u{435}\u{442}\u{435}\u{441}\u{44C} \u{441} \u{442}\u{435}\u{43C}, \u{447}\u{442}\u{43E} \u{44D}\u{442}\u{43E} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{43C} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431}\u{43E}\u{43C} \u{438} \u{447}\u{442}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438}, \u{43E}\u{442}\u{43E}\u{431}\u{440}\u{430}\u{436}\u{430}\u{435}\u{43C}\u{44B}\u{435} \u{43D}\u{430} \u{44D}\u{442}\u{43E}\u{43C} \u{43C}\u{435}\u{440}\u{43E}\u{43F}\u{440}\u{438}\u{44F}\u{442}\u{438}\u{438}, \u{44F}\u{432}\u{43B}\u{44F}\u{44E}\u{442}\u{441}\u{44F} \u{442}\u{430}\u{43A}\u{438}\u{43C}\u{438} \u{436}\u{435}, \u{43A}\u{430}\u{43A} \u{441}\u{43E}\u{431}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{43E}\u{440}\u{443}\u{447}\u{43D}\u{44B}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{432} \u{446}\u{435}\u{43B}\u{44F}\u{445} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{438}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{438} \u{438} \u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{438}.`,
    sm: `E ala i le taliaina o lenei saini ua e malilie ai o lenei gaioiga e mafai ona sainia faaeletonika ma o saini faaeletonika o lo'o aliali mai i luga o lenei gaioiga e tutusa ma saini tusilima mo le fa'amoemoe o le aoga, fa'amalosia, ma le taliaina.`,
    so: `Markaad aqbasho saxiixan waxaad ogolaataa in howshan laga yaabo in si elektaroonik ah loo saxiixo iyo in saxiixyada elektaroonigga ah ee ka soo muuqanaya howshan ay la mid yihiin saxiixyada farta lagu qoray oo loogu talo galay ujeeddooyinka ansaxnimada, fulinta, iyo is-aqbalka.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E19}\u{E35}\u{E49}\u{E41}\u{E2A}\u{E14}\u{E07}\u{E27}\u{E48}\u{E32}\u{E04}\u{E38}\u{E13}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A}\u{E27}\u{E48}\u{E32}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E2D}\u{E32}\u{E08}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E40}\u{E25}\u{E47}\u{E01}\u{E17}\u{E23}\u{E2D}\u{E19}\u{E34}\u{E01}\u{E2A}\u{E4C} \u{E41}\u{E25}\u{E30}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E2D}\u{E34}\u{E40}\u{E25}\u{E47}\u{E01}\u{E17}\u{E23}\u{E2D}\u{E19}\u{E34}\u{E01}\u{E2A}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E1B}\u{E23}\u{E32}\u{E01}\u{E0F}\u{E43}\u{E19}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E40}\u{E2B}\u{E21}\u{E37}\u{E2D}\u{E19}\u{E01}\u{E31}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E35}\u{E22}\u{E19}\u{E14}\u{E49}\u{E27}\u{E22}\u{E25}\u{E32}\u{E22}\u{E21}\u{E37}\u{E2D}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E27}\u{E31}\u{E15}\u{E16}\u{E38}\u{E1B}\u{E23}\u{E30}\u{E2A}\u{E07}\u{E04}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{627}\u{633} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{648} \u{642}\u{628}\u{648}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{622}\u{67E} \u{627}\u{633} \u{628}\u{627}\u{62A} \u{633}\u{6D2} \u{627}\u{62A}\u{641}\u{627}\u{642} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6C1} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{67E}\u{631} \u{627}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{627}\u{646}\u{6A9} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC}\u{6D2} \u{62C}\u{627}\u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{67E}\u{631} \u{638}\u{627}\u{6C1}\u{631} \u{6C1}\u{648}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{627}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{627}\u{646}\u{6A9} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{648}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{62C}\u{648} \u{62F}\u{631}\u{633}\u{62A}\u{6AF}\u{6CC} \u{60C} \u{646}\u{641}\u{627}\u{630} \u{627}\u{648}\u{631} \u{642}\u{628}\u{648}\u{644}\u{6CC}\u{62A} \u{6A9}\u{6D2} \u{645}\u{642}\u{627}\u{635}\u{62F} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{6C1}\u{627}\u{62A}\u{6BE} \u{633}\u{6D2} \u{644}\u{6A9}\u{6BE}\u{6D2} \u{6AF}\u{626}\u{6D2} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `B\u{1EB1}ng c\xe1ch ch\u{1EA5}p nh\u{1EAD}n ch\u{1EEF} k\xfd n\xe0y, b\u{1EA1}n \u{111}\u{1ED3}ng \xfd r\u{1EB1}ng ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y c\xf3 th\u{1EC3} \u{111}\u{1B0}\u{1EE3}c k\xfd \u{111}i\u{1EC7}n t\u{1EED} v\xe0 ch\u{1EEF} k\xfd \u{111}i\u{1EC7}n t\u{1EED} xu\u{1EA5}t hi\u{1EC7}n trong ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y gi\u{1ED1}ng nh\u{1B0} ch\u{1EEF} k\xfd vi\u{1EBF}t tay cho m\u{1EE5}c \u{111}\xedch h\u{1EE3}p l\u{1EC7}, kh\u{1EA3} thi v\xe0 kh\u{1EA3} n\u{103}ng ch\u{1EA5}p nh\u{1EAD}n.`,
    "zh-hans": `\u{63A5}\u{53D7}\u{6B64}\u{7B7E}\u{540D}\u{FF0C}\u{5373}\u{8868}\u{793A}\u{60A8}\u{540C}\u{610F}\u{6B64}\u{6D3B}\u{52A8}\u{53EF}\u{4EE5}\u{8FDB}\u{884C}\u{7535}\u{5B50}\u{7B7E}\u{540D}\u{FF0C}\u{5E76}\u{4E14}\u{6B64}\u{6D3B}\u{52A8}\u{4E0A}\u{663E}\u{793A}\u{7684}\u{7535}\u{5B50}\u{7B7E}\u{540D}\u{5728}\u{6709}\u{6548}\u{6027}\u{3001}\u{53EF}\u{6267}\u{884C}\u{6027}\u{548C}\u{53EF}\u{63A5}\u{53D7}\u{6027}\u{65B9}\u{9762}\u{4E0E}\u{624B}\u{5199}\u{7B7E}\u{540D}\u{76F8}\u{540C}\u{3002}`,
    "zh-hant": `\u{63A5}\u{53D7}\u{6B64}\u{7C3D}\u{540D}\u{FF0C}\u{5373}\u{8868}\u{793A}\u{60A8}\u{540C}\u{610F}\u{6B64}\u{6D3B}\u{52D5}\u{53EF}\u{4EE5}\u{9032}\u{884C}\u{96FB}\u{5B50}\u{7C3D}\u{540D}\u{FF0C}\u{4E26}\u{4E14}\u{6B64}\u{6D3B}\u{52D5}\u{4E0A}\u{986F}\u{793A}\u{7684}\u{96FB}\u{5B50}\u{7C3D}\u{540D}\u{5728}\u{6709}\u{6548}\u{6027}\u{3001}\u{53EF}\u{57F7}\u{884C}\u{6027}\u{548C}\u{53EF}\u{63A5}\u{53D7}\u{6027}\u{65B9}\u{9762}\u{8207}\u{624B}\u{5BEB}\u{7C3D}\u{540D}\u{76F8}\u{540C}\u{3002}`,
    en: `By accepting this signature you agree that this activity may be electronically signed and that the electronic signatures appearing on this activity are the same as handwritten signatures for the purposes of validity, enforceability, and admissibility.`
};
const $2868cc1235412e16$export$5dfe3e64e45bfc48 = {
    ar: `\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Unterschrift`,
    es: `Firma`,
    fa: `\u{627}\u{645}\u{636}\u{627}`,
    fil: `Lagda`,
    fr: `Signature`,
    hi: `\u{926}\u{938}\u{94D}\u{200D}\u{924}\u{916}\u{93C}\u{924} \u{926}\u{947}\u{916}\u{93F}\u{90F}\u{964}`,
    ht: `Siyati`,
    it: `Firma`,
    ja: `\u{7F72}\u{540D}`,
    ko: `\u{C11C}\u{BA85}`,
    mww: `kos npe`,
    ps: `\u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}`,
    pt: `Assinatura`,
    "pt-pt": `Assinatura`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Saini`,
    so: `saxiixa`,
    th: `\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637}`,
    vi: `Ch\u{1EEF} k\xfd`,
    "zh-hans": `\u{7B7E}\u{540D}`,
    "zh-hant": `\u{7C3D}\u{540D}`,
    en: `Signature`
};
const $2868cc1235412e16$export$e50c34f3203f75cb = {
    ar: `\u{627}\u{633}\u{645}`,
    de: `Name`,
    es: `Nombre`,
    fa: `\u{646}\u{627}\u{645}`,
    fil: `Pangalan`,
    fr: `Nom`,
    hi: `\u{928}\u{93E}\u{92E}`,
    ht: `Fe-apel`,
    it: `Nome`,
    ja: `\u{540D}\u{524D}`,
    ko: `\u{C774}\u{B984}`,
    mww: `Npe`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Nome`,
    "pt-pt": `Designa\xe7\xe3o`,
    ru: `\u{418}\u{43C}\u{44F}`,
    sm: `Igoa`,
    so: `magaca`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D}`,
    ur: `\u{646}\u{627}\u{645}`,
    vi: `T\xean`,
    "zh-hans": `\u{540D}\u{5B57}`,
    "zh-hant": `\u{540D}\u{5B57}`,
    en: `Name`
};
const $2868cc1235412e16$export$31a34480861da9d9 = {
    ar: `\u{62D}\u{630}\u{641} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Signatur l\xf6schen`,
    es: `Eliminar firma`,
    fa: `\u{62D}\u{630}\u{641} \u{627}\u{645}\u{636}\u{627}`,
    fil: `Tanggalin ang lagda`,
    fr: `Supprimer la signature`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{939}\u{91F}\u{93E}\u{90F}\u{902}`,
    ht: `Efase siyati`,
    it: `Elimina firma`,
    ja: `\u{7F72}\u{540D}\u{306E}\u{524A}\u{9664}`,
    ko: `\u{C11C}\u{BA85} \u{C0AD}\u{C81C}`,
    mww: `Delete kos npe`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Excluir assinatura`,
    "pt-pt": `Excluir assinatura`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Tape le saini`,
    so: `Saxeexa Delete`,
    th: `\u{E25}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a ch\u{1EEF} k\xfd`,
    "zh-hans": `\u{5220}\u{9664}\u{7B7E}\u{540D}`,
    "zh-hant": `\u{522A}\u{9664}\u{7C3D}\u{540D}`,
    en: `Delete signature`
};
const $2868cc1235412e16$export$30aaf2514f0013cf = {
    ar: `\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{645}\u{646} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{62D}\u{630}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}\u{61F}`,
    de: `Sind Sie sicher, dass Sie diese Signatur l\xf6schen m\xf6chten?`,
    es: `\xbfEst\xe1 seguro de que desea eliminar esta firma?`,
    fa: `\u{622}\u{6CC}\u{627} \u{645}\u{637}\u{645}\u{626}\u{646} \u{647}\u{633}\u{62A}\u{6CC}\u{62F} \u{6A9}\u{647} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{627}\u{6CC}\u{646} \u{627}\u{645}\u{636}\u{627} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
    fil: `Sigurado ka bang nais mong tanggalin ang lagda na ito?`,
    fr: `\xcates-vous s\xfbr de vouloir supprimer cette signature ?`,
    hi: `\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} \u{907}\u{938} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{94B} \u{939}\u{91F}\u{93E}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: `\xc8ske ou s\xe8ten ou vle efase siyati sa a?`,
    it: `Sei sicuro di voler eliminare questa firma?`,
    ja: `\u{3053}\u{306E}\u{7F72}\u{540D}\u{3092}\u{524A}\u{9664}\u{3057}\u{3066}\u{3082}\u{3088}\u{308D}\u{3057}\u{3044}\u{3067}\u{3059}\u{304B}?`,
    ko: `\u{C774} \u{C11C}\u{BA85}\u{C744} \u{C0AD}\u{C81C}\u{D558}\u{C2DC}\u{ACA0}\u{C2B5}\u{B2C8}\u{AE4C}?`,
    mww: `Koj puas xav delete kos npe no?`,
    ps: `\u{622}\u{6CC}\u{627} \u{62A}\u{627}\u{633}\u{648} \u{689}\u{627}\u{689}\u{647} \u{6CC}\u{627}\u{633}\u{62A} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{63A}\u{648}\u{627}\u{693}\u{626} \u{62F}\u{627} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{626}\u{61F}`,
    pt: `Tem certeza de que deseja excluir esta assinatura?`,
    "pt-pt": `Tem a certeza de que pretende eliminar esta assinatura?`,
    ru: `\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}?`,
    sm: `E te mautinoa e te manao e tapeese lenei saini?`,
    so: `Ma hubtaa in aad rabto in aad tirtirto saxiixan?`,
    th: `\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E19}\u{E35}\u{E49}?`,
    ur: `\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} \u{627}\u{633} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: `B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n x\xf3a ch\u{1EEF} k\xfd n\xe0y kh\xf4ng?`,
    "zh-hans": `\u{662F}\u{5426}\u{786E}\u{5B9E}\u{8981}\u{5220}\u{9664}\u{6B64}\u{7B7E}\u{540D}\u{FF1F}`,
    "zh-hant": `\u{662F}\u{5426}\u{78BA}\u{5BE6}\u{8981}\u{522A}\u{9664}\u{6B64}\u{7C3D}\u{540D}\u{FF1F}`,
    en: `Are you sure you want to delete this signature?`
};
const $2868cc1235412e16$export$5b2dff051546c71 = {
    ar: `1 \u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `1 Unterschrift`,
    es: `1 firma`,
    fa: `1 \u{627}\u{645}\u{636}\u{627}`,
    fil: `1 lagda`,
    fr: `1 signature`,
    hi: `1 \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930}`,
    ht: `1 siyati`,
    it: `1 firma`,
    ja: `1\u{3064}\u{306E}\u{7F72}\u{540D}`,
    ko: `\u{C11C}\u{BA85} 1\u{AC1C}`,
    mww: `kos npe`,
    ps: `1 \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}`,
    pt: `1 assinatura`,
    "pt-pt": `1 assinatura`,
    ru: `1 \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `1 saini`,
    so: `1 saxiixa`,
    th: `1 \u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `1 \u{62F}\u{633}\u{62A}\u{62E}\u{637}`,
    vi: `1 ch\u{1EEF} k\xfd`,
    "zh-hans": `1 \u{4E2A}\u{7B7E}\u{540D}`,
    "zh-hant": `1 \u{500B}\u{7C3D}\u{540D}`,
    en: `1 signature`
};
const $2868cc1235412e16$export$88044af7e8639ccb = {
    ar: (count)=>`${count} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{627}\u{62A}`,
    de: (count)=>`${count} Unterschriften`,
    es: (count)=>`${count} firmas`,
    fa: (count)=>`${count} \u{627}\u{645}\u{636}\u{627}`,
    fil: (count)=>`${count} lagda`,
    fr: (count)=>`${count} signatures`,
    hi: (count)=>`${count} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930}`,
    ht: (count)=>`${count} siyati`,
    it: (count)=>`${count} firme`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{7F72}\u{540D}`,
    ko: (count)=>`${count} \u{AC1C}`,
    mww: (count)=>`${count} kos npe`,
    ps: (count)=>`${count} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} assinaturas`,
    "pt-pt": (count)=>`${count} assinaturas`,
    ru: (count)=>`${count} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438}`,
    sm: (count)=>`${count} saini`,
    so: (count)=>`${count}`,
    th: (count)=>`${count} \u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: (count)=>`${count} \u{62F}\u{633}\u{62A}\u{62E}\u{637}`,
    vi: (count)=>`${count} ch\u{1EEF} k\xfd`,
    "zh-hans": (count)=>`${count} \u{4E2A}\u{7B7E}\u{540D}`,
    "zh-hant": (count)=>`${count} \u{500B}\u{7C3D}\u{540D}`,
    en: (count)=>`${count} signatures`
};
const $2868cc1235412e16$export$9f7401092d07c779 = {
    ar: `\u{627}\u{62C}\u{639}\u{644} \u{647}\u{630}\u{627} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{64A} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Dies als Standardsignatur festlegen`,
    es: `Hacer de esta mi firma predeterminada`,
    fa: `\u{627}\u{6CC}\u{646} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{645}\u{646} \u{631}\u{627} \u{642}\u{631}\u{627}\u{631} \u{62F}\u{647}\u{6CC}\u{62F}`,
    fil: `Gawin itong default na lagda ko`,
    fr: `Faites-en ma signature par d\xe9faut`,
    hi: `\u{907}\u{938}\u{947} \u{92E}\u{947}\u{930}\u{93E} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{92C}\u{928}\u{93E}\u{913}`,
    ht: `F\xe8 siyati default mwen`,
    it: `Imposta questa come firma predefinita`,
    ja: `\u{3053}\u{308C}\u{3092}\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{306E}\u{7F72}\u{540D}\u{306B}\u{3059}\u{308B}`,
    ko: `\u{C774} \u{C11C}\u{BA85}\u{C744} \u{AE30}\u{BCF8} \u{C11C}\u{BA85}\u{C73C}\u{B85C} \u{C124}\u{C815}`,
    mww: `Ua qhov no kuv default kos npe`,
    ps: `\u{62F}\u{627} \u{632}\u{645}\u{627} \u{62F} \u{627}\u{635}\u{644}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{648}\u{6AB}\u{631}\u{681}\u{648}\u{626}`,
    pt: `Tornar esta minha assinatura padr\xe3o`,
    "pt-pt": `Tornar esta a minha assinatura predefinida`,
    ru: `\u{421}\u{434}\u{435}\u{43B}\u{430}\u{439}\u{442}\u{435} \u{44D}\u{442}\u{443} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C} \u{43C}\u{43E}\u{435}\u{439} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}\u{44E} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Fai lenei mea o la'u saini faaletonu`,
    so: `Samee this saxiixa default`,
    th: `\u{E17}\u{E4D}\u{E32}\u{E43}\u{E2B}\u{E49}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E09}\u{E31}\u{E19}`,
    ur: `\u{627}\u{633}\u{6D2} \u{645}\u{6CC}\u{631}\u{627} \u{67E}\u{6C1}\u{644}\u{6D2} \u{633}\u{6D2} \u{637}\u{6D2} \u{634}\u{62F}\u{6C1} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `\u{110}\u{1EB7}t \u{111}\xe2y l\xe0 ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh c\u{1EE7}a t\xf4i`,
    "zh-hans": `\u{5C06}\u{6B64}\u{7B7E}\u{540D}\u{8BBE}\u{4E3A}\u{6211}\u{7684}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}`,
    "zh-hant": `\u{5C07}\u{6B64}\u{7C3D}\u{540D}\u{8A2D}\u{70BA}\u{6211}\u{7684}\u{9810}\u{8A2D}\u{7C3D}\u{540D}`,
    en: `Make this my default signature`
};
const $2868cc1235412e16$export$cd19dd7fc7738c62 = {
    ar: `\u{646}\u{645}\u{637}`,
    de: `Stil`,
    es: `Estilo`,
    fa: `\u{633}\u{628}\u{6A9}`,
    fil: `Estilo`,
    fr: `Style`,
    hi: `\u{935}\u{930}\u{94D}\u{924}\u{93F}\u{915}\u{93E}`,
    ht: `Style`,
    it: `Stile`,
    ja: `\u{30B9}\u{30BF}\u{30A4}\u{30EB}`,
    ko: `\u{C2A4}\u{D0C0}\u{C77C}`,
    mww: `Style`,
    ps: `\u{633}\u{628}\u{6A9}`,
    pt: `Estilo`,
    "pt-pt": `Estilo`,
    ru: `\u{421}\u{442}\u{438}\u{43B}\u{44C}`,
    sm: `Sitaili`,
    so: `Marka`,
    th: `\u{E25}\u{E35}\u{E25}\u{E32}`,
    ur: `\u{637}\u{631}\u{632}`,
    vi: `Phong c\xe1ch`,
    "zh-hans": `\u{98CE}\u{683C}`,
    "zh-hant": `\u{98A8}\u{683C}`,
    en: `Style`
};
const $2868cc1235412e16$export$c3b2af361dc85df7 = {
    ar: `\u{644}\u{627} \u{64A}\u{648}\u{62C}\u{62F} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Keine Standardsignatur`,
    es: `Sin firma predeterminada`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636}`,
    fil: `Walang default na lagda`,
    fr: `Pas de signature par d\xe9faut`,
    hi: `\u{915}\u{94B}\u{908} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen siyati default`,
    it: `Nessuna firma predefinita`,
    ja: `\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{306E}\u{7F72}\u{540D}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{AE30}\u{BCF8} \u{C11C}\u{BA85} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj default kos npe`,
    ps: `\u{62F} \u{689}\u{6CC}\u{641}\u{627}\u{644}\u{67C} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem assinatura padr\xe3o`,
    "pt-pt": `Sem assinatura padr\xe3o`,
    ru: `\u{41D}\u{435}\u{442} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `E leai se saini faaletonu`,
    so: `No saxiixa default`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{637}\u{6D2} \u{634}\u{62F}\u{6C1} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{65E0}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}`,
    "zh-hant": `\u{7121}\u{9810}\u{8A2D}\u{7C3D}\u{540D}`,
    en: `No default signature`
};
const $2868cc1235412e16$export$4f405bdda60d10a2 = {
    ar: $2868cc1235412e16$var$html`ليس لديك توقيع افتراضي حتى الآن. استخدم زر التوقيع لتوقيع النشاط وحدد مربع <em>جعل هذا توقيعي الافتراضي</em> لحفظ التوقيع لاستخدامه في المستقبل.`,
    de: $2868cc1235412e16$var$html`Sie haben noch keine Standardsignatur. Verwenden Sie die Schaltfläche "Signieren", um die Aktivität zu signieren, und aktivieren Sie das Kontrollkästchen <em>"Diese als Standardsignatur festlegen</em> ", um die Signatur für die zukünftige Verwendung zu speichern.`,
    es: $2868cc1235412e16$var$html`Todavía no tiene una firma predeterminada. Use el botón de firmar para firmar la actividad y marque la casilla <em>hacer que esta sea mi firma predeterminada</em> para guardar la firma para usarla en el futuro.`,
    fa: $2868cc1235412e16$var$html`شما هنوز امضای پیش فرض ندارید. از دکمه امضا برای امضای فعالیت استفاده کنید و کادر <em>Make this my default signature</em> را علامت بزنید تا امضا برای استفاده در آینده ذخیره شود.`,
    fil: $2868cc1235412e16$var$html`Wala ka pa ring default signature. Gamitin ang sign button para lagdaan ang aktibidad at lagyan ng tsek ang <em>kahon na gawing default kong lagda ito</em> para mai-save ang lagda para magamit sa hinaharap.`,
    fr: $2868cc1235412e16$var$html`Vous n’avez pas encore de signature par défaut. Utilisez le bouton Signer pour signer l’activité et cochez la case <em>Définir comme signature par défaut</em> pour enregistrer la signature pour une utilisation ultérieure.`,
    hi: $2868cc1235412e16$var$html`आपके पास अभी तक कोई डिफ़ॉल्ट हस्ताक्षर नहीं है. गतिविधि पर हस्ताक्षर करने के लिए साइन बटन का उपयोग करें और भविष्य में उपयोग के लिए हस्ताक्षर सहेजने के लिए <em>इसे मेरा डिफ़ॉल्ट हस्ताक्षर बनाएं</em> बॉक्स चेक करें।`,
    ht: $2868cc1235412e16$var$html`Ou pa gen yon siyati default ankò. Sèvi ak bouton an siyen aktivite a epi tcheke <em>fè sa a bwat siyati default mwen</em> pou konsève pou siyati a pou itilize nan lavni.`,
    it: $2868cc1235412e16$var$html`Non hai ancora una firma predefinita. Usa il pulsante Firma per firmare l'attività e seleziona la casella <em>Imposta come firma predefinita</em> per salvare la firma per un uso futuro.`,
    ja: $2868cc1235412e16$var$html`デフォルトの署名がまだありません。署名ボタンを使用してアクティビティに署名し、[ <em>これをデフォルトの署名にする</em> ]チェックボックスをオンにして、後で使用するために署名を保存します。`,
    ko: $2868cc1235412e16$var$html`아직 기본 서명이 없습니다. 서명 버튼을 사용하여 활동에 서명하고 <em>이를 내 기본 서명으로 설정</em> 상자를 선택하여 나중에 사용할 수 있도록 서명을 저장합니다.`,
    mww: $2868cc1235412e16$var$html`Koj tsis muaj ib tug default kos npe tsis tau. Siv lub pob khawm kos npe rau daim ntawv thiab kos npe <em>rau qhov no kuv default kos npe</em> rau lub thawv txuag lub kos npe rau yav tom ntej.`,
    ps: $2868cc1235412e16$var$html`تاسو لا تر اوسه د ډیفالټ لاسلیک نه لری. د فعالیت لاسلیک کولو لپاره د لاسلیک تڼۍ وکاروئ او دا زما <em>د ډیفالټ لاسلیک</em> بکس وګورئ ترڅو لاسلیک د راتلونکی کارولو لپاره خوندی کړئ.`,
    pt: $2868cc1235412e16$var$html`Você ainda não tem uma assinatura padrão. Use o botão de assinatura para assinar a atividade e marque a caixa <em>tornar esta minha assinatura padrão</em> para salvar a assinatura para uso futuro.`,
    "pt-pt": $2868cc1235412e16$var$html`Você ainda não tem uma assinatura padrão. Use o botão de assinatura para assinar a atividade e marque a caixa <em>Tornar esta minha assinatura padrão</em> para salvar a assinatura para uso futuro.`,
    ru: $2868cc1235412e16$var$html`У вас еще нет подписи по умолчанию. Используйте кнопку «Подписать», чтобы подписать действие, и установите флажок « <em>Сделать это моей подписью по умолчанию</em> », чтобы сохранить подпись для использования в будущем.`,
    sm: $2868cc1235412e16$var$html`E te le'i mauaina se saini faaletonu i le taimi nei. Faaaoga le faamau faailoga e saini ai le gaoioiga ma siaki le pusa ia <em>avea lenei ma la'u saini faaletonu</em> e sefe ai le saini mo le faaaogaina i le lumanai.`,
    so: $2868cc1235412e16$var$html`Weli ma lihid saxiix default ah. Isticmaal badhanka calaamadaha si aad u saxiixdo dhaqdhaqaaqa oo aad u hubiso <em>in ay ka dhigto sanduuqaan saxiixa saxiixa</em> si aad u badbaadiso saxiixa isticmaalka mustaqbalka.`,
    th: $2868cc1235412e16$var$html`คุณยังไม่มีลายเซ็นเริ่มต้น ใช้ปุ่มลงนามเพื่อลงนามในกิจกรรมและทําเครื่องหมายที่ช่อง <em>กําหนดให้เป็นลายเซ็นเริ่มต้นของฉัน</em> เพื่อบันทึกลายเซ็นเพื่อใช้ในอนาคต`,
    ur: $2868cc1235412e16$var$html`آپ کے پاس ابھی تک پہلے سے طے شدہ دستخط نہیں ہیں۔ سرگرمی پر دستخط کرنے کے لئے سائن بٹن کا استعمال کریں اور مستقبل کے استعمال کے لئے دستخط کو محفوظ کرنے کے لئے <em>اس کو میرا ڈیفالٹ دستخط باکس بنائیں چیک کریں</em> ۔`,
    vi: $2868cc1235412e16$var$html`Bạn chưa có chữ ký mặc định. Sử dụng nút ký để ký hoạt động và chọn hộp <em>đặt đây là chữ ký mặc định của tôi</em> để lưu chữ ký để sử dụng trong tương lai.`,
    "zh-hans": $2868cc1235412e16$var$html`您还没有默认签名。使用签名按钮对活动进行签名，并选中 <em>将此设为我的默认签名</em> 框以保存签名以供将来使用。`,
    "zh-hant": $2868cc1235412e16$var$html`您還沒有預設簽名。使用簽名按鈕對活動進行簽名，並選中 <em>將此設為我的預設簽名</em> 框以保存簽名以供將來使用。`,
    en: $2868cc1235412e16$var$html`You don't have a default signature yet. Use the sign button to sign the activity and check the <em>make this my default signature</em> box to save the signature for future use.`
};
const $2868cc1235412e16$export$d590014f0ce29ae9 = {
    ar: `\u{631}\u{633}\u{645}`,
    de: `Zeichnen`,
    es: `Dibujar`,
    fa: `\u{631}\u{633}\u{645}`,
    fil: `Gumuhit`,
    fr: `Dessiner`,
    hi: `\u{906}\u{915}\u{930}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Trase`,
    it: `Disegnare`,
    ja: `\u{63CF}\u{304F}`,
    ko: `\u{ADF8}\u{B9AC}\u{B2E4}`,
    mww: `kos`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Desenhar`,
    "pt-pt": `Sorteio`,
    ru: `\u{420}\u{438}\u{441}\u{43E}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Ata`,
    so: `Sawiro`,
    th: `\u{E27}\u{E32}\u{E14}`,
    ur: `\u{6A9}\u{6BE}\u{6CC}\u{646}\u{686}\u{646}\u{627}`,
    vi: `V\u{1EBD}`,
    "zh-hans": `\u{753B}`,
    "zh-hant": `\u{756B}`,
    en: `Draw`
};
const $2868cc1235412e16$export$51e87c4ec4bfa4c8 = {
    ar: `\u{625}\u{639}\u{627}\u{62F}\u{629} \u{62A}\u{639}\u{64A}\u{64A}\u{646} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Standardsignatur zur\xfccksetzen`,
    es: `Restablecer firma predeterminada`,
    fa: `\u{628}\u{627}\u{632}\u{646}\u{634}\u{627}\u{646}\u{6CC} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636}`,
    fil: `I-reset ang default na lagda`,
    fr: `R\xe9initialiser la signature par d\xe9faut`,
    hi: `\u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{930}\u{940}\u{938}\u{947}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Reset default siyati`,
    it: `Reimposta la firma predefinita`,
    ja: `\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{306E}\u{7F72}\u{540D}\u{3092}\u{30EA}\u{30BB}\u{30C3}\u{30C8}\u{3059}\u{308B}`,
    ko: `\u{AE30}\u{BCF8} \u{C11C}\u{BA85} \u{C7AC}\u{C124}\u{C815}`,
    mww: `Reset default kos npe`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6CC} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Redefinir assinatura padr\xe3o`,
    "pt-pt": `Redefinir assinatura padr\xe3o`,
    ru: `\u{421}\u{431}\u{440}\u{43E}\u{441}\u{438}\u{442}\u{44C} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Toe seti le saini faaletonu`,
    so: `Dib-u-celin saxiixa default`,
    th: `\u{E23}\u{E35}\u{E40}\u{E0B}\u{E47}\u{E15}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{67E}\u{6C1}\u{644}\u{6D2} \u{633}\u{6D2} \u{637}\u{6D2} \u{634}\u{62F}\u{6C1} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{648} \u{631}\u{6CC} \u{633}\u{6CC}\u{679}`,
    vi: `\u{110}\u{1EB7}t l\u{1EA1}i ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{91CD}\u{7F6E}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}`,
    "zh-hant": `\u{91CD}\u{7F6E}\u{9810}\u{8A2D}\u{7C3D}\u{540D}`,
    en: `Reset default signature`
};
const $2868cc1235412e16$export$989066564c2ca33b = {
    ar: `\u{62D}\u{642}\u{648}\u{644}`,
    de: `Felder`,
    es: `Campos`,
    fa: `\u{632}\u{645}\u{6CC}\u{646}\u{647}`,
    fil: `Mga patlang`,
    fr: `Champs`,
    hi: `\u{92B}\u{93C}\u{940}\u{932}\u{94D}\u{921}`,
    ht: `T\xe8ren yo`,
    it: `Campi`,
    ja: `\u{7530}\u{7551}`,
    ko: `\u{D544}\u{B4DC}`,
    mww: `teb`,
    ps: `\u{67E}\u{67C}\u{6CC}`,
    pt: `Campos`,
    "pt-pt": `Campos`,
    ru: `\u{41F}\u{43E}\u{43B}\u{44F}`,
    sm: `Fanua`,
    so: `fields`,
    th: `\u{E1F}\u{E34}\u{E25}\u{E14}\u{E4C}`,
    ur: `\u{642}\u{637}\u{639}\u{627}\u{62A}`,
    vi: `L\u{129}nh v\u{1EF1}c`,
    "zh-hans": `\u{9886}\u{57DF}`,
    "zh-hant": `\u{9818}\u{57DF}`,
    en: `Fields`
};
const $2868cc1235412e16$export$d47944b58a508bad = {
    ar: `\u{645}\u{648}\u{627}\u{641}\u{642}\u{647}`,
    de: `Einwilligen`,
    es: `Consentimiento`,
    fa: `\u{631}\u{636}\u{627}\u{6CC}\u{62A}`,
    fil: `Pahintulot`,
    fr: `Consentement`,
    hi: `\u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F}`,
    ht: `Konsantman`,
    it: `Consenso`,
    ja: `\u{540C}\u{610F}`,
    ko: `\u{C2B9}\u{B099}`,
    mww: `Kev Tso Cai`,
    ps: `\u{631}\u{636}\u{627}\u{6CC}\u{62A}`,
    pt: `Consentimento`,
    "pt-pt": `Consentimento`,
    ru: `\u{421}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{435}`,
    sm: `Maliega`,
    so: `Ogolaanshaha`,
    th: `\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A}`,
    vi: `\u{110}\u{1ED3}ng \xfd`,
    "zh-hans": `\u{540C}\u{610F}`,
    "zh-hant": `\u{540C}\u{610F}`,
    en: `Consent`
};
const $2868cc1235412e16$export$1ff6720e765bd764 = {
    ar: `\u{62F}\u{648}\u{627}\u{621} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `Ein Medikament`,
    es: `Un medicamento`,
    fa: `\u{6CC}\u{6A9} \u{62F}\u{627}\u{631}\u{648}`,
    fil: `Isang gamot`,
    fr: `Un m\xe9dicament`,
    hi: `\u{90F}\u{915} \u{926}\u{935}\u{93E}`,
    ht: `Yon renm\xe8d`,
    it: `Un farmaco`,
    ja: `1\u{3064}\u{306E}\u{85AC}`,
    ko: `\u{D558}\u{B098}\u{C758} \u{C57D}\u{BB3C}`,
    mww: `ib cov tshuaj noj`,
    ps: `\u{6CC}\u{648} \u{62F}\u{631}\u{645}\u{644}`,
    pt: `Um medicamento`,
    "pt-pt": `Um medicamento`,
    ru: `\u{41E}\u{434}\u{438}\u{43D} \u{43F}\u{440}\u{435}\u{43F}\u{430}\u{440}\u{430}\u{442}`,
    sm: `Tasi le vaila'au`,
    so: `Hal daawo`,
    th: `\u{E22}\u{E32}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{62F}\u{648}\u{627}`,
    vi: `M\u{1ED9}t lo\u{1EA1}i thu\u{1ED1}c`,
    "zh-hans": `\u{4E00}\u{79CD}\u{836F}\u{7269}`,
    "zh-hant": `\u{4E00}\u{7A2E}\u{85E5}\u{7269}`,
    en: `One medication`
};
const $2868cc1235412e16$export$814fd764a5b35e2f = {
    ar: (count)=>`${count} \u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: (count)=>`${count} Medikamente`,
    es: (count)=>`${count} medicamentos`,
    fa: (count)=>`${count} \u{62F}\u{627}\u{631}\u{648}`,
    fil: (count)=>`${count} gamot`,
    fr: (count)=>`${count} m\xe9dicaments`,
    hi: (count)=>`${count} \u{926}\u{935}\u{93E}\u{90F}\u{902}`,
    ht: (count)=>`${count} redisyon`,
    it: (count)=>`${count} farmaci`,
    ja: (count)=>`${count} \u{3064}\u{306E}\u{85AC}`,
    ko: (count)=>`${count} \u{AC00}\u{C9C0} \u{C57D}\u{BB3C}`,
    mww: (count)=>`${count} tshuaj noj`,
    ps: (count)=>`${count} \u{62F}\u{631}\u{645}\u{644}`,
    pt: (count)=>`${count} medicamentos`,
    "pt-pt": (count)=>`${count} medicamentos`,
    ru: (count)=>`${count} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{430}`,
    sm: (count)=>`${count} vaila'au`,
    so: (count)=>`${count} daawooyin ah`,
    th: (count)=>`${count} \u{E0A}\u{E19}\u{E34}\u{E14}`,
    ur: (count)=>`${count} \u{62F}\u{648}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: (count)=>`${count} lo\u{1EA1}i thu\u{1ED1}c`,
    "zh-hans": (count)=>`${count} \u{79CD}\u{836F}\u{7269}`,
    "zh-hant": (count)=>`${count} \u{7A2E}\u{85E5}\u{7269}`,
    en: (count)=>`${count} medications`
};
const $2868cc1235412e16$export$145bab8279e1c23d = {
    ar: `\u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621} \u{627}\u{644}\u{645}\u{637}\u{644}\u{648}\u{628}`,
    de: `Handlungsbedarf`,
    es: `Acci\xf3n requerida`,
    fa: `\u{627}\u{642}\u{62F}\u{627}\u{645} \u{644}\u{627}\u{632}\u{645} \u{627}\u{633}\u{62A}`,
    fil: `Kinakailangan ang aksyon`,
    fr: `Action requise`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{930}\u{935}\u{93E}\u{908} \u{915}\u{930}\u{928}\u{93E} \u{91C}\u{93C}\u{930}\u{942}\u{930}\u{940} \u{939}\u{948}`,
    ht: `Aksyon obligatwa`,
    it: `Azione richiesta`,
    ja: `\u{5FC5}\u{8981}\u{306A}\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    ko: `\u{D544}\u{C694}\u{D55C} \u{C791}\u{C5C5}`,
    mww: `yuav tsum tau ua`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `A\xe7\xe3o necess\xe1ria`,
    "pt-pt": `A\xe7\xe3o necess\xe1ria`,
    ru: `\u{41D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{44B}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    sm: `Faatinoga e manaomia`,
    so: `Action baahan yahay`,
    th: `\u{E15}\u{E49}\u{E2D}\u{E07}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6A9}\u{627}\u{631}\u{631}\u{648}\u{627}\u{626}\u{6CC} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{6D2}`,
    vi: `H\xe0nh \u{111}\u{1ED9}ng c\u{1EA7}n thi\u{1EBF}t`,
    "zh-hans": `\u{9700}\u{8981}\u{91C7}\u{53D6}\u{7684}\u{63AA}\u{65BD}`,
    "zh-hant": `\u{9700}\u{8981}\u{63A1}\u{53D6}\u{7684}\u{63AA}\u{65BD}`,
    en: `Action required`
};
const $2868cc1235412e16$export$71ed7fbcb5f2fe37 = {
    ar: `\u{627}\u{646}\u{62A}\u{642}\u{644} \u{625}\u{644}\u{649} \u{627}\u{644}\u{623}\u{639}\u{644}\u{649}`,
    de: `Nach oben scrollen`,
    es: `Despl\xe1zate hacia arriba`,
    fa: `\u{631}\u{641}\u{62A}\u{646} \u{628}\u{647} \u{628}\u{627}\u{644}\u{627}`,
    fil: `Mag-scroll sa itaas`,
    fr: `Faire d\xe9filer vers le haut`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937} \u{924}\u{915} \u{938}\u{94D}\u{915}\u{94D}\u{930}\u{949}\u{932} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Woulo t\xe8t`,
    it: `Scorrere verso l'alto`,
    ja: `\u{30C8}\u{30C3}\u{30D7}\u{306B}\u{30B9}\u{30AF}\u{30ED}\u{30FC}\u{30EB}`,
    ko: `\u{B9E8} \u{C704}\u{B85C} \u{C2A4}\u{D06C}\u{B864}`,
    mww: `Scroll saum toj kawg nkaus`,
    ps: `\u{67E}\u{648}\u{631}\u{62A}\u{647} \u{62A}\u{647} \u{648}\u{644}\u{648}\u{644}\u{626}`,
    pt: `Rolar para cima`,
    "pt-pt": `Voltar ao topo`,
    ru: `\u{41F}\u{440}\u{43E}\u{43A}\u{440}\u{443}\u{442}\u{438}\u{442}\u{44C} \u{43D}\u{430}\u{432}\u{435}\u{440}\u{445}`,
    sm: `Tusi i le pito i luga`,
    so: `Hore`,
    th: `\u{E40}\u{E25}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E1B}\u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}`,
    ur: `\u{627}\u{648}\u{67E}\u{631} \u{633}\u{6A9}\u{631}\u{648}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Cu\u{1ED9}n l\xean \u{111}\u{1EA7}u trang`,
    "zh-hans": `\u{6EDA}\u{52A8}\u{5230}\u{9876}\u{90E8}`,
    "zh-hant": `\u{6EFE}\u{52D5}\u{5230}\u{9802}\u{90E8}`,
    en: `Scroll to top`
};
const $2868cc1235412e16$export$8227558ec81276c = {
    ar: `\u{645}\u{62D}\u{62F}\u{62F}`,
    de: `Unspezifiziert`,
    es: `No especificado`,
    fa: `\u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    fil: `Hindi tinukoy`,
    fr: `Quelconque`,
    hi: `\u{905}\u{928}\u{93F}\u{930}\u{94D}\u{926}\u{93F}\u{937}\u{94D}\u{91F}`,
    ht: `Pa espesifye`,
    it: `Specificato`,
    ja: `\u{672A}\u{6307}\u{5B9A}`,
    ko: `\u{BD88}\u{D2B9}\u{C815}`,
    mww: `Unspecified`,
    ps: `\u{646}\u{627}\u{645}\u{634}\u{62E}\u{635}`,
    pt: `Unspecified`,
    "pt-pt": `N\xe3o especificado`,
    ru: `\u{41D}\u{435}\u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{43E}\u{435}`,
    sm: `E le'i fa'amaonia`,
    so: `Aan la cayimin`,
    th: `\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{648}\u{627}\u{636}\u{62D}`,
    vi: `Kh\xf4ng x\xe1c \u{111}\u{1ECB}nh`,
    "zh-hans": `\u{672A}\u{6307}\u{5B9A}`,
    "zh-hant": `\u{672A}\u{6307}\u{5B9A}`,
    en: `Unspecified`
};
const $2868cc1235412e16$export$271900c637039020 = {
    ar: `\u{631}\u{642}\u{645} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641}`,
    de: `Telefonnummer`,
    es: `N\xfamero de tel\xe9fono`,
    fa: `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646}`,
    fil: `Numero ng telepono`,
    fr: `Num\xe9ro de t\xe9l\xe9phone`,
    hi: `\u{92B}\u{94B}\u{928} \u{938}\u{902}\u{916}\u{94D}\u{92F}\u{93E}`,
    ht: `Nimewo telef\xf2n`,
    it: `Numero di telefono`,
    ja: `\u{96FB}\u{8A71}\u{756A}\u{53F7}`,
    ko: `\u{C804}\u{D654}\u{BC88}\u{D638}`,
    mww: `xov tooj`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Telefone`,
    "pt-pt": `N\xfamero de telefone`,
    ru: `\u{41D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430}`,
    sm: `Numera o le telefoni`,
    so: `lambarka telefoonka`,
    th: `\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631}`,
    vi: `S\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    "zh-hans": `\u{7535}\u{8BDD}\u{53F7}\u{7801}`,
    "zh-hant": `\u{96FB}\u{8A71}\u{865F}\u{78BC}`,
    en: `Phone number`
};
const $2868cc1235412e16$export$9e1fe7d7fd318c28 = {
    ar: $2868cc1235412e16$var$html`توسيع<span class="sr-only"></span>`,
    de: $2868cc1235412e16$var$html`Erweiterung<span class="sr-only"></span>`,
    es: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    fa: $2868cc1235412e16$var$html`گسترش<span class="sr-only"></span>`,
    fil: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    fr: $2868cc1235412e16$var$html`Extension<span class="sr-only"></span>`,
    hi: $2868cc1235412e16$var$html`एक्सटेंशन<span class="sr-only">एंशन</span>`,
    ht: $2868cc1235412e16$var$html`<span class="sr-only">èkspas</span>`,
    it: $2868cc1235412e16$var$html`Estensione<span class="sr-only"></span>`,
    ja: $2868cc1235412e16$var$html`エクス<span class="sr-only">テント</span>`,
    ko: $2868cc1235412e16$var$html`확장<span class="sr-only">ension</span>`,
    mww: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    ps: $2868cc1235412e16$var$html`پراخه<span class="sr-only">انسیون</span>`,
    pt: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    "pt-pt": $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    ru: $2868cc1235412e16$var$html`Расширение<span class="sr-only"></span>`,
    sm: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    so: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    th: $2868cc1235412e16$var$html`ขยายความ<span class="sr-only"></span>`,
    ur: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    vi: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    "zh-hans": $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    "zh-hant": $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`,
    en: $2868cc1235412e16$var$html`Ext<span class="sr-only">ension</span>`
};
const $2868cc1235412e16$export$c860bd028d704467 = {
    ar: `\u{627}\u{628}\u{62A}\u{62F}\u{627}\u{626}\u{64A}`,
    de: `Prim\xe4r`,
    es: `Primario`,
    fa: `\u{627}\u{648}\u{644}\u{6CC}\u{647}`,
    fil: `Pangunahin`,
    fr: `Primaire`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915}`,
    ht: `Pwensipal`,
    it: `Primario`,
    ja: `\u{539F}\u{767A}`,
    ko: `\u{BCF8}\u{B798}\u{C758}`,
    mww: `thawj`,
    ps: `\u{644}\u{648}\u{645}\u{693}\u{646}\u{6CC}`,
    pt: `Prim\xe1rio`,
    "pt-pt": `Prim\xe1rio`,
    ru: `\u{41F}\u{435}\u{440}\u{432}\u{438}\u{447}\u{43D}\u{44B}\u{439}`,
    sm: `Peraimeri`,
    so: `Primary`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E16}\u{E21}`,
    ur: `\u{627}\u{635}\u{644}\u{6CC}`,
    vi: `Ch\xednh`,
    "zh-hans": `\u{4E3B}\u{8981}`,
    "zh-hant": `\u{4E3B}\u{8981}`,
    en: `Primary`
};
const $2868cc1235412e16$export$32b271f200228df1 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{647}\u{648}\u{627}\u{62A}\u{641}`,
    de: `Es gibt keine Telefone`,
    es: `No hay tel\xe9fonos`,
    fa: `\u{647}\u{6CC}\u{686} \u{62A}\u{644}\u{641}\u{646}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang Mga Telepono`,
    fr: `Il n\u{2019}y a pas de t\xe9l\xe9phone`,
    hi: `\u{915}\u{94B}\u{908} \u{92B}\u{94B}\u{928} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen telef\xf2n`,
    it: `Non ci sono telefoni`,
    ja: `\u{96FB}\u{8A71}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C804}\u{D654}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Yog tsis muaj tes`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 telefones`,
    "pt-pt": `N\xe3o h\xe1 telefones`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{43E}\u{432} \u{43D}\u{435}\u{442}`,
    sm: `E leai ni telefoni feavea'i`,
    so: `Ma jiraan telefoono`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{641}\u{648}\u{646} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}`,
    vi: `Kh\xf4ng c\xf3 \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    "zh-hans": `\u{6CA1}\u{6709}\u{7535}\u{8BDD}`,
    "zh-hant": `\u{6C92}\u{6709}\u{96FB}\u{8A71}`,
    en: `There are no phones`
};
const $2868cc1235412e16$export$36658e29488b888c = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{647}\u{627}\u{62A}\u{641}`,
    de: `Telefon hinzuf\xfcgen`,
    es: `Agregar tel\xe9fono`,
    fa: `\u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{631}\u{62F}\u{646} \u{62A}\u{644}\u{641}\u{646}`,
    fil: `Email Address *`,
    fr: `Ajouter un t\xe9l\xe9phone`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute telef\xf2n`,
    it: `Aggiungi telefono`,
    ja: `\u{96FB}\u{8A71}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C804}\u{D654} \u{BC88}\u{D638} \u{CD94}\u{AC00}`,
    mww: `Ntxiv xov tooj`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}`,
    pt: `Adicionar telefone`,
    "pt-pt": `Adicionar telefone`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}`,
    sm: `Fa'aopopo le telefoni`,
    so: `Add telefoonka`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    "zh-hans": `\u{6DFB}\u{52A0}\u{7535}\u{8BDD}`,
    "zh-hant": `\u{6DFB}\u{52A0}\u{96FB}\u{8A71}`,
    en: `Add phone`
};
const $2868cc1235412e16$export$b1dbe6dbf0b8b848 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641}`,
    de: `Telefon entfernen`,
    es: `Quitar el tel\xe9fono`,
    fa: `\u{628}\u{631}\u{62F}\u{627}\u{634}\u{62A}\u{646} \u{62A}\u{644}\u{641}\u{646}`,
    fil: `Tanggalin ang telepono`,
    fr: `Retirer le t\xe9l\xe9phone`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{93F}\u{915}\u{93E}\u{932}\u{947}\u{902}`,
    ht: `Retire telef\xf2n`,
    it: `Rimuovi telefono`,
    ja: `\u{96FB}\u{8A71}\u{3092}\u{53D6}\u{308A}\u{5916}\u{3059}`,
    ko: `\u{C804}\u{D654} \u{BC88}\u{D638} \u{C81C}\u{AC70}`,
    mww: `Tshem tawm xov tooj`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646}`,
    pt: `Remover telefone`,
    "pt-pt": `Remover telefone`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}`,
    sm: `Aveese le telefoni`,
    so: `Ka saar telefoonka`,
    th: `\u{E16}\u{E2D}\u{E14}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}\u{E2D}\u{E2D}\u{E01}`,
    ur: `\u{641}\u{648}\u{646} \u{6C1}\u{679}\u{627} \u{62F}\u{6CC}\u{6BA}`,
    vi: `X\xf3a \u{111}i\u{1EC7}n tho\u{1EA1}i`,
    "zh-hans": `\u{5220}\u{9664}\u{624B}\u{673A}`,
    "zh-hant": `\u{522A}\u{9664}\u{624B}\u{6A5F}`,
    en: `Remove phone`
};
const $2868cc1235412e16$export$a70d58ffe5e7000d = {
    ar: `\u{627}\u{644}\u{647}\u{627}\u{62A}\u{641}`,
    de: `Telefon`,
    es: `Tel\xe9fono`,
    fa: `\u{62A}\u{644}\u{641}\u{646}`,
    fil: `Telepono`,
    fr: `T\xe9l\xe9phone`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928}`,
    ht: `Telef\xf2n`,
    it: `Telefono`,
    ja: `\u{96FB}\u{8A71}`,
    ko: `\u{C804}\u{D654}`,
    mww: `Xov tooj`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Telefone`,
    "pt-pt": `Telefone`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}`,
    sm: `Telefoni`,
    so: `Telefoon`,
    th: `\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646}`,
    vi: `\u{110}i\u{1EC7}n tho\u{1EA1}i`,
    "zh-hans": `\u{7535}\u{8BDD}`,
    "zh-hant": `\u{96FB}\u{8A71}`,
    en: `Phone`
};
const $2868cc1235412e16$export$97029ce3bcf4d498 = {
    ar: `\u{627}\u{644}\u{647}\u{648}\u{627}\u{62A}\u{641}`,
    de: `Telefone`,
    es: `Tel\xe9fonos`,
    fa: `\u{62A}\u{644}\u{641}\u{646}`,
    fil: `Mga Telepono`,
    fr: `T\xe9l\xe9phones`,
    hi: `\u{92B}\u{94B}\u{928}`,
    ht: `Telef\xf2n yo`,
    it: `Telefoni`,
    ja: `\u{643A}\u{5E2F} \u{96FB}\u{8A71}`,
    ko: `\u{C804}\u{D654}`,
    mww: `tes`,
    ps: `\u{67C}\u{6CC}\u{644}\u{6CC}\u{641}\u{648}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Telefones`,
    "pt-pt": `Telefones`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{44B}`,
    sm: `Telefoni`,
    so: `Telefoonada`,
    th: `\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} \u{E21}\u{E37}\u{E2D} \u{E16}\u{E37}\u{E2D}`,
    ur: `\u{641}\u{648}\u{646}\u{632}`,
    vi: `\u{110}i\u{1EC7}n tho\u{1EA1}i`,
    "zh-hans": `\u{624B}\u{673A}`,
    "zh-hant": `\u{624B}\u{6A5F}`,
    en: `Phones`
};
const $2868cc1235412e16$export$535dc873d3acbcb5 = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mail`,
    es: `Correo electr\xf3nico`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email`,
    fr: `Messagerie \xe9lectronique`,
    hi: `\u{908}\u{92E}\u{947}\u{932}`,
    ht: `Imel`,
    it: `E-mail`,
    ja: `\u{96FB}\u{5B50}\u{30E1}\u{30FC}\u{30EB}`,
    ko: `\u{BA54}\u{C77C}\xa0\u{C8FC}\u{C18C}`,
    mww: `Tus email`,
    ps: `\u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9}`,
    pt: `Email`,
    "pt-pt": `Email`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43F}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{435}`,
    sm: `Imeli`,
    so: `Email`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644}`,
    vi: `Email`,
    "zh-hans": `\u{7535}\u{5B50}\u{90AE}\u{4EF6}`,
    "zh-hant": `\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Email`
};
const $2868cc1235412e16$export$86381633ec82cace = {
    ar: `\u{631}\u{633}\u{627}\u{626}\u{644} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mails`,
    es: `Correos electr\xf3nicos`,
    fa: `\u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email Address *`,
    fr: `Courriels`,
    hi: `\u{908}\u{92E}\u{947}\u{932}`,
    ht: `Im\xe8l`,
    it: `E-mail`,
    ja: `\u{30E1}\u{30FC}\u{30EB}`,
    ko: `\u{C774}\u{BA54}\u{C77C}`,
    mww: `Emails`,
    ps: `\u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `E-mails`,
    "pt-pt": `E-mails`,
    ru: `\u{42D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430}`,
    sm: `Imeli`,
    so: `Emails`,
    th: `\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632}`,
    vi: `Th\u{1B0} \u{111}i\u{1EC7}n t\u{1EED}`,
    "zh-hans": `\u{7535}\u{5B50}\u{90AE}\u{4EF6}`,
    "zh-hant": `\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Emails`
};
const $2868cc1235412e16$export$ebd631caeab7ad4a = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{628}\u{631}\u{64A}\u{62F} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mail hinzuf\xfcgen`,
    es: `Agregar correo electr\xf3nico`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email Address`,
    fr: `Ajouter une adresse e-mail`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute im\xe8l`,
    it: `Aggiungi email`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C774}\u{BA54}\u{C77C} \u{CD94}\u{AC00}`,
    mww: `Ntxiv email`,
    ps: `\u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9}`,
    pt: `Adicionar e-mail`,
    "pt-pt": `Adicionar e-mail`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{447}\u{442}\u{443}`,
    sm: `Fa'aopopo imeli`,
    so: `Ku dar email`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam email`,
    "zh-hans": `\u{6DFB}\u{52A0}\u{7535}\u{5B50}\u{90AE}\u{4EF6}`,
    "zh-hant": `\u{6DFB}\u{52A0}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Add email`
};
const $2868cc1235412e16$export$70463e241666d488 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `E-Mail entfernen`,
    es: `Eliminar correo electr\xf3nico`,
    fa: `\u{628}\u{631}\u{62F}\u{627}\u{634}\u{62A}\u{646} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email Address *`,
    fr: `Supprimer l\u{2019}e-mail`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{928}\u{93F}\u{915}\u{93E}\u{932}\u{947}\u{902}`,
    ht: `Retire im\xe8l`,
    it: `Rimuovi email`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{3092}\u{524A}\u{9664}`,
    ko: `\u{C774}\u{BA54}\u{C77C} \u{C0AD}\u{C81C}`,
    mww: `Tshem tawm email`,
    ps: `\u{62F} \u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9} \u{67E}\u{647} \u{627}\u{693}\u{647} \u{62F} \u{628}\u{631}\u{6D0}`,
    pt: `Remover e-mail`,
    "pt-pt": `Remover e-mail`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{447}\u{442}\u{443}`,
    sm: `Aveese imeli`,
    so: `Ka saar email`,
    th: `\u{E25}\u{E1A}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a email`,
    "zh-hans": `\u{79FB}\u{9664}\u{7535}\u{5B50}\u{90AE}\u{4EF6}`,
    "zh-hant": `\u{62FF}\u{6389}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `Remove email`
};
const $2868cc1235412e16$export$9dba77cebd8c56e2 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{631}\u{633}\u{627}\u{626}\u{644} \u{628}\u{631}\u{64A}\u{62F} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `Es gibt keine E-Mails`,
    es: `No hay correos electr\xf3nicos`,
    fa: `\u{647}\u{6CC}\u{686} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga email`,
    fr: `Il n\u{2019}y a pas d\u{2019}e-mails`,
    hi: `\u{915}\u{94B}\u{908} \u{908}\u{92E}\u{947}\u{932} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn Im\xe8l`,
    it: `Non ci sono e-mail`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C774}\u{BA54}\u{C77C}\u{C774} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Yog tsis muaj emails`,
    ps: `\u{647}\u{6CC}\u{685} \u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 e-mails`,
    "pt-pt": `N\xe3o h\xe1 e-mails`,
    ru: `\u{41D}\u{435}\u{442} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{445} \u{43F}\u{438}\u{441}\u{435}\u{43C}`,
    sm: `E leai ni imeli`,
    so: `Waxaa jira emails lahayn`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 email`,
    "zh-hans": `\u{6CA1}\u{6709}\u{7535}\u{5B50}\u{90AE}\u{4EF6}`,
    "zh-hant": `\u{6C92}\u{6709}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}`,
    en: `There are no emails`
};
const $2868cc1235412e16$export$e02107cc34dfe9c5 = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adresse hinzuf\xfcgen`,
    es: `Agregar direcci\xf3n`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{622}\u{62F}\u{631}\u{633}`,
    fil: `Email Address`,
    fr: `Ajouter une adresse`,
    hi: `\u{92A}\u{924}\u{93E} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Adr\xe8s`,
    it: `Aggiungi indirizzo`,
    ja: `\u{4F4F}\u{6240}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C8FC}\u{C18C} \u{CD94}\u{AC00}`,
    mww: `Chaw nyob`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Adicionar endere\xe7o`,
    "pt-pt": `Adicionar endere\xe7o`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Fa'aopopo le tuatusi`,
    so: `Ku dar cinwaanka`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam \u{111}\u{1ECB}a ch\u{1EC9}`,
    "zh-hans": `\u{6DFB}\u{52A0}\u{5730}\u{5740}`,
    "zh-hant": `\u{6DFB}\u{52A0}\u{4F4D}\u{5740}`,
    en: `Add address`
};
const $2868cc1235412e16$export$ec21648e7732b648 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adresse entfernen`,
    es: `Eliminar direcci\xf3n`,
    fa: `\u{628}\u{631}\u{62F}\u{627}\u{634}\u{62A}\u{646} \u{622}\u{62F}\u{631}\u{633}`,
    fil: `Tanggalin ang address`,
    fr: `Supprimer l\u{2019}adresse`,
    hi: `\u{92A}\u{924}\u{93E} \u{928}\u{93F}\u{915}\u{93E}\u{932}\u{947}\u{902}`,
    ht: `Retire adr\xe8s`,
    it: `Rimuovi indirizzo`,
    ja: `\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{306E}\u{524A}\u{9664}`,
    ko: `\u{C8FC}\u{C18C} \u{C0AD}\u{C81C}`,
    mww: `Tshem tawm qhov chaw nyob`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Remover endere\xe7o`,
    "pt-pt": `Remover endere\xe7o`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Aveese le tuatusi`,
    so: `Ka saar cinwaanka`,
    th: `\u{E25}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a \u{111}\u{1ECB}a ch\u{1EC9}`,
    "zh-hans": `\u{5220}\u{9664}\u{5730}\u{5740}`,
    "zh-hant": `\u{522A}\u{9664}\u{4F4D}\u{5740}`,
    en: `Remove address`
};
const $2868cc1235412e16$export$15f9ff29d697867d = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{639}\u{646}\u{627}\u{648}\u{64A}\u{646}`,
    de: `Es gibt keine Adressen`,
    es: `No hay direcciones`,
    fa: `\u{647}\u{6CC}\u{686} \u{622}\u{62F}\u{631}\u{633}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang Address`,
    fr: `Il n\u{2019}y a pas d\u{2019}adresses`,
    hi: `\u{915}\u{94B}\u{908} \u{92A}\u{924}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Pa gen okenn adr\xe8s`,
    it: `Non ci sono indirizzi`,
    ja: `\u{4F4F}\u{6240}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C8FC}\u{C18C}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj chaw nyob`,
    ps: `\u{647}\u{6CC}\u{685} \u{622}\u{62F}\u{631}\u{633} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 endere\xe7os`,
    "pt-pt": `N\xe3o h\xe1 endere\xe7os`,
    ru: `\u{41D}\u{435}\u{442} \u{430}\u{434}\u{440}\u{435}\u{441}\u{43E}\u{432}`,
    sm: `E leai ni tuatusi`,
    so: `Cinwaano ma leh.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{67E}\u{62A}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}`,
    vi: `Kh\xf4ng c\xf3 \u{111}\u{1ECB}a ch\u{1EC9}`,
    "zh-hans": `\u{6CA1}\u{6709}\u{5730}\u{5740}`,
    "zh-hant": `\u{6C92}\u{6709}\u{4F4D}\u{5740}`,
    en: `There are no addresses`
};
const $2868cc1235412e16$export$7a733e8549484409 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{634}\u{627}\u{631}\u{639}`,
    de: `Stra\xdfe`,
    es: `Direcci\xf3n`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{62E}\u{6CC}\u{627}\u{628}\u{627}\u{646}`,
    fil: `Email Address`,
    fr: `Adresse postale`,
    hi: `\u{938}\u{921}\u{93C}\u{915} \u{915}\u{93E} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s lari`,
    it: `Indirizzo`,
    ja: `\u{4F4F}\u{6240}`,
    ko: `\u{C8FC}\u{C18C}`,
    mww: `Txoj kev chaw nyob`,
    ps: `\u{62F} \u{6A9}\u{648}\u{685}\u{6D0} \u{62F} \u{6A9}\u{648}\u{685}\u{6D0} \u{67E}\u{647} \u{627}\u{693}\u{647}`,
    pt: `Endere\xe7o`,
    "pt-pt": `Endere\xe7o`,
    ru: `\u{41F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi o le auala`,
    so: `cinwaanka Street`,
    th: `\u{E17}\u{E35}\u{E48}\u{E15}\u{E31}\u{E49}\u{E07}`,
    ur: `\u{633}\u{691}\u{6A9} \u{6A9}\u{627} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} \u{111}\u{1B0}\u{1EDD}ng ph\u{1ED1}`,
    "zh-hans": `\u{8857}\u{9053}\u{5730}\u{5740}`,
    "zh-hant": `\u{8857}\u{9053}\u{4F4D}\u{5740}`,
    en: `Street address`
};
const $2868cc1235412e16$export$1867f1fb86ca52 = {
    ar: `\u{634}\u{642}\u{629} / \u{62C}\u{646}\u{627}\u{62D} / \u{648}\u{62D}\u{62F}\u{629}`,
    de: `Appartement / Suite / Einheit`,
    es: `Apartamento / suite / unidad`,
    fa: `\u{622}\u{67E}\u{627}\u{631}\u{62A}\u{645}\u{627}\u{646} / \u{633}\u{648}\u{626}\u{6CC}\u{62A} / \u{648}\u{627}\u{62D}\u{62F}`,
    fil: `Apartment / suite / unit`,
    fr: `Appartement / suite / unit\xe9`,
    hi: `\u{905}\u{92A}\u{93E}\u{930}\u{94D}\u{91F}\u{92E}\u{947}\u{902}\u{91F}/\u{938}\u{941}\u{907}\u{91F}/\u{92F}\u{942}\u{928}\u{93F}\u{91F}`,
    ht: `Apatman / admin f\xf2 / inite`,
    it: `Appartamento / suite / unit\xe0`,
    ja: `\u{30A2}\u{30D1}\u{30FC}\u{30C8}\u{30E1}\u{30F3}\u{30C8}/\u{30B9}\u{30A4}\u{30FC}\u{30C8}/\u{30E6}\u{30CB}\u{30C3}\u{30C8}`,
    ko: `\u{C544}\u{D30C}\u{D2B8} / \u{C2A4}\u{C704}\u{D2B8} / \u{C720}\u{B2DB}`,
    mww: `Chav Tsev / Suite / Chav Tsev`,
    ps: `\u{627}\u{67E}\u{627}\u{631}\u{62A}\u{645}\u{627}\u{646} / \u{633}\u{648}\u{67C} / \u{648}\u{627}\u{62D}\u{62F}`,
    pt: `Apartamento / su\xedte / unidade`,
    "pt-pt": `Apartamento / suite / unidade`,
    ru: `\u{410}\u{43F}\u{430}\u{440}\u{442}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{44B} / \u{43B}\u{44E}\u{43A}\u{441}\u{44B} / \u{430}\u{43F}\u{430}\u{440}\u{442}\u{430}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Fale mautotogi / suite / iunite`,
    so: `Apartment / suite / unit`,
    th: `\u{E2D}\u{E1E}\u{E32}\u{E23}\u{E4C}\u{E17}\u{E40}\u{E21}\u{E49}\u{E19}\u{E17}\u{E4C} / \u{E2B}\u{E49}\u{E2D}\u{E07}\u{E2A}\u{E27}\u{E35}\u{E17} / \u{E22}\u{E39}\u{E19}\u{E34}\u{E15}`,
    ur: `\u{627}\u{67E}\u{627}\u{631}\u{679}\u{645}\u{646}\u{679} / \u{633}\u{648}\u{6CC}\u{679} / \u{6CC}\u{648}\u{646}\u{679}`,
    vi: `C\u{103}n h\u{1ED9} / suite / c\u{103}n`,
    "zh-hans": `\u{516C}\u{5BD3} / \u{5957}\u{623F} / \u{5355}\u{5143}`,
    "zh-hant": `\u{516C}\u{5BD3} / \u{5957}\u{623F} / \u{55AE}\u{5143}`,
    en: `Apartment / suite / unit`
};
const $2868cc1235412e16$export$da83d15bfc8b67f1 = {
    ar: `\u{645}\u{62F}\u{64A}\u{646}\u{629}`,
    de: `Stadt`,
    es: `Ciudad`,
    fa: `\u{634}\u{647}\u{631}`,
    fil: `Lungsod`,
    fr: `Ville`,
    hi: `\u{936}\u{939}\u{930}`,
    ht: `Vil`,
    it: `Citt\xe0`,
    ja: `\u{90FD}\u{5E02}`,
    ko: `\u{B3C4}\u{C2DC}`,
    mww: `Zos`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Cidade`,
    "pt-pt": `Cidade`,
    ru: `\u{413}\u{43E}\u{440}\u{43E}\u{434}`,
    sm: `Aai`,
    so: `Magaalada`,
    th: `\u{E40}\u{E21}\u{E37}\u{E2D}\u{E07}`,
    ur: `\u{634}\u{6C1}\u{631}`,
    vi: `Th\xe0nh ph\u{1ED1}`,
    "zh-hans": `\u{57CE}\u{5E02}`,
    "zh-hant": `\u{57CE}\u{5E02}`,
    en: `City`
};
const $2868cc1235412e16$export$d5c4d5d164503cfb = {
    ar: `\u{62D}\u{627}\u{644}\u{629}`,
    de: `Zustand`,
    es: `Estado`,
    fa: `\u{62F}\u{648}\u{644}\u{62A}`,
    fil: `Estado`,
    fr: `\xc9tat`,
    hi: `\u{930}\u{93E}\u{91C}\u{94D}\u{92F}`,
    ht: `Leta`,
    it: `Stato`,
    ja: `\u{72B6}\u{614B}`,
    ko: `\u{C0C1}\u{D0DC}`,
    mww: `Xeev`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Estado`,
    "pt-pt": `Estado`,
    ru: `\u{413}\u{43E}\u{441}\u{443}\u{434}\u{430}\u{440}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Setete`,
    so: `Dowladda`,
    th: `\u{E2A}\u{E20}\u{E32}\u{E1E}`,
    ur: `\u{62D}\u{627}\u{644}\u{62A}`,
    vi: `Ti\u{1EC3}u bang`,
    "zh-hans": `\u{5DDE}`,
    "zh-hant": `\u{5DDE}`,
    en: `State`
};
const $2868cc1235412e16$export$14d9ba8651bf485 = {
    ar: `\u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F}\u{64A}`,
    de: `PLZ`,
    es: `C\xf3digo postal`,
    fa: `\u{6A9}\u{62F} \u{67E}\u{633}\u{62A}\u{6CC}`,
    fil: `Email Address *`,
    fr: `Code postal`,
    hi: `\u{91C}\u{93C}\u{93F}\u{92A} \u{915}\u{94B}\u{921}`,
    ht: `K\xf2d postal`,
    it: `CAP`,
    ja: `\u{90F5}\u{4FBF}\u{756A}\u{53F7}`,
    ko: `\u{C6B0}\u{D3B8}\u{BC88}\u{D638}`,
    mww: `Tsib tug leb qhia thaj tsam yus nyob`,
    ps: `\u{632}\u{6CC}\u{67E} \u{634}\u{641}\u{631}`,
    pt: `C\xf3digo Postal`,
    "pt-pt": `C\xf3digo Postal`,
    ru: `\u{41F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{44B}\u{439} \u{438}\u{43D}\u{434}\u{435}\u{43A}\u{441}`,
    sm: `Numera o le pusa meli`,
    so: `Lanbarka furaha`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E44}\u{E1B}\u{E23}\u{E29}\u{E13}\u{E35}\u{E22}\u{E4C}`,
    ur: `\u{639}\u{644}\u{627}\u{642}\u{627}\u{626} \u{646}\u{645}\u{628}\u{631}`,
    vi: `M\xe3 b\u{1B0}u \u{111}i\u{1EC7}n`,
    "zh-hans": `\u{90AE}\u{653F}\u{7F16}\u{7801}`,
    "zh-hant": `\u{90F5}\u{905E}\u{5340}\u{865F}`,
    en: `Zip code`
};
const $2868cc1235412e16$export$b13ba07885d8373d = {
    ar: $2868cc1235412e16$var$html`<span class="sr-only">الرمز البريدي </span>توسيع<span class="sr-only"></span>`,
    de: $2868cc1235412e16$var$html`<span class="sr-only">PLZ </span>Erweiterung<span class="sr-only"></span>`,
    es: $2868cc1235412e16$var$html`<span class="sr-only">Código postal </span>Ext<span class="sr-only">ension</span>`,
    fa: $2868cc1235412e16$var$html`<span class="sr-only">کد پستی </span>گسترش<span class="sr-only"></span>`,
    fil: $2868cc1235412e16$var$html`<span class="sr-only">Email </span> Address *Ext<span class="sr-only">ension</span>`,
    fr: $2868cc1235412e16$var$html`<span class="sr-only">Code postal </span>Extension<span class="sr-only"></span>`,
    hi: $2868cc1235412e16$var$html`<span class="sr-only">ज़िप कोड </span>एक्सटेंशन<span class="sr-only">एंशन</span>`,
    ht: $2868cc1235412e16$var$html`<span class="sr-only">Kòd postal </span><span class="sr-only">èkspas</span>`,
    it: $2868cc1235412e16$var$html`<span class="sr-only">CAP </span>Estensione<span class="sr-only"></span>`,
    ja: $2868cc1235412e16$var$html`<span class="sr-only">郵便番号 </span>エクス<span class="sr-only">テント</span>`,
    ko: $2868cc1235412e16$var$html`<span class="sr-only">우편번호 </span>확장<span class="sr-only">ension</span>`,
    mww: $2868cc1235412e16$var$html`<span class="sr-only">Tsib tug leb qhia thaj tsam yus nyob </span>Ext<span class="sr-only">ension</span>`,
    ps: $2868cc1235412e16$var$html`<span class="sr-only">زیپ شفر </span>پراخه<span class="sr-only">انسیون</span>`,
    pt: $2868cc1235412e16$var$html`<span class="sr-only">Código Postal </span>Ext<span class="sr-only">ension</span>`,
    "pt-pt": $2868cc1235412e16$var$html`<span class="sr-only">Código Postal </span>Ext<span class="sr-only">ension</span>`,
    ru: $2868cc1235412e16$var$html`<span class="sr-only">Почтовый индекс </span>Расширение<span class="sr-only"></span>`,
    sm: $2868cc1235412e16$var$html`<span class="sr-only">Numera o le pusa meli </span>Ext<span class="sr-only">ension</span>`,
    so: $2868cc1235412e16$var$html`<span class="sr-only">Lanbarka furaha </span>Ext<span class="sr-only">ension</span>`,
    th: $2868cc1235412e16$var$html`<span class="sr-only">รหัสไปรษณีย์ </span>ขยายความ<span class="sr-only"></span>`,
    ur: $2868cc1235412e16$var$html`<span class="sr-only">علاقائ نمبر </span>Ext<span class="sr-only">ension</span>`,
    vi: $2868cc1235412e16$var$html`<span class="sr-only">Mã bưu điện </span>Ext<span class="sr-only">ension</span>`,
    "zh-hans": $2868cc1235412e16$var$html`<span class="sr-only">邮政编码 </span>Ext<span class="sr-only">ension</span>`,
    "zh-hant": $2868cc1235412e16$var$html`<span class="sr-only">郵遞區號 </span>Ext<span class="sr-only">ension</span>`,
    en: $2868cc1235412e16$var$html`<span class="sr-only">Zip code </span>Ext<span class="sr-only">ension</span>`
};
const $2868cc1235412e16$export$b71244072853bd35 = {
    ar: `\u{645}\u{642}\u{627}\u{637}\u{639}\u{647}`,
    de: `Bezirk`,
    es: `Condado`,
    fa: `\u{634}\u{647}\u{631}\u{633}\u{62A}\u{627}\u{646}`,
    fil: `County`,
    fr: `Comt\xe9`,
    hi: `\u{915}\u{93E}\u{909}\u{902}\u{91F}\u{940}`,
    ht: `Konte`,
    it: `Contea`,
    ja: `\u{90E1}`,
    ko: `\u{AD70}`,
    mww: `County`,
    ps: `\u{648}\u{644}\u{633}\u{648}\u{627}\u{644}\u{6CC}`,
    pt: `Condado`,
    "pt-pt": `Concelho`,
    ru: `\u{413}\u{440}\u{430}\u{444}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Itumalo`,
    so: `Gobolka`,
    th: `\u{E40}\u{E02}\u{E15}`,
    ur: `\u{6A9}\u{627}\u{624}\u{646}\u{679}\u{6CC}`,
    vi: `Qu\u{1EAD}n`,
    "zh-hans": `\u{53BF}`,
    "zh-hant": `\u{7E23}`,
    en: `County`
};
const $2868cc1235412e16$export$88423193c62995c6 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{641}\u{639}\u{644}\u{64A} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A}`,
    de: `Prim\xe4re physische Adresse`,
    es: `Direcci\xf3n f\xedsica principal`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{641}\u{6CC}\u{632}\u{6CC}\u{6A9}\u{6CC} \u{627}\u{648}\u{644}\u{6CC}\u{647}`,
    fil: `Pangunahing pisikal na address`,
    fr: `Adresse physique principale`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{92D}\u{94C}\u{924}\u{93F}\u{915} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s fizik prensipal`,
    it: `Indirizzo fisico principale`,
    ja: `\u{30D7}\u{30E9}\u{30A4}\u{30DE}\u{30EA}\u{7269}\u{7406}\u{30A2}\u{30C9}\u{30EC}\u{30B9}`,
    ko: `\u{AE30}\u{BCF8} \u{BB3C}\u{B9AC}\u{C801} \u{C8FC}\u{C18C}`,
    mww: `Lub cev qhov chaw nyob`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Endere\xe7o f\xedsico principal`,
    "pt-pt": `Endere\xe7o f\xedsico principal`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{444}\u{438}\u{437}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi faaletino o le Peraimeri`,
    so: `Ciwaanka aasaasiga ah ee jirka`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E32}\u{E07}\u{E01}\u{E32}\u{E22}\u{E20}\u{E32}\u{E1E}\u{E2B}\u{E25}\u{E31}\u{E01}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{62C}\u{633}\u{645}\u{627}\u{646}\u{6CC} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} th\u{1EF1}c t\u{1EBF} ch\xednh`,
    "zh-hans": `\u{4E3B}\u{8981}\u{7269}\u{7406}\u{5730}\u{5740}`,
    "zh-hant": `\u{4E3B}\u{8981}\u{7269}\u{7406}\u{4F4D}\u{5740}`,
    en: `Primary physical address`
};
const $2868cc1235412e16$export$f6414b5b24376f44 = {
    ar: `\u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F}\u{64A} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A}`,
    de: `Prim\xe4re Postanschrift`,
    es: `Direcci\xf3n postal principal`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{67E}\u{633}\u{62A}\u{6CC} \u{627}\u{635}\u{644}\u{6CC}`,
    fil: `Pangunahing address ng koreo`,
    fr: `Adresse postale principale`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{921}\u{93E}\u{915} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s poste prensipal`,
    it: `Indirizzo postale principale`,
    ja: `\u{4E3B}\u{306A}\u{90F5}\u{9001}\u{5148}\u{4F4F}\u{6240}`,
    ko: `\u{AE30}\u{BCF8} \u{C6B0}\u{D3B8} \u{C8FC}\u{C18C}`,
    mww: `Primary chaw nyob`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6CC} \u{62A}\u{647}`,
    pt: `Endere\xe7o de correspond\xeancia principal`,
    "pt-pt": `Endere\xe7o postal principal`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi meli autu`,
    so: `Cinwaanka boostada aasaasiga ah`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E32}\u{E07}\u{E44}\u{E1B}\u{E23}\u{E29}\u{E13}\u{E35}\u{E22}\u{E4C}\u{E2B}\u{E25}\u{E31}\u{E01}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{645}\u{6CC}\u{644}\u{646}\u{6AF} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} g\u{1EED}i th\u{1B0} ch\xednh`,
    "zh-hans": `\u{4E3B}\u{8981}\u{90AE}\u{5BC4}\u{5730}\u{5740}`,
    "zh-hant": `\u{4E3B}\u{8981}\u{90F5}\u{5BC4}\u{4F4D}\u{5740}`,
    en: `Primary mailing address`
};
const $2868cc1235412e16$export$9a65256abc3742fe = {
    ar: `\u{631}\u{648}\u{641} \u{627}\u{644}\u{633}\u{637}\u{62D} X`,
    de: `Dachterrasse X`,
    es: `Azotea X`,
    fa: `\u{67E}\u{634}\u{62A} \u{628}\u{627}\u{645} X`,
    fil: `Bubong X`,
    fr: `Toit X`,
    hi: `\u{930}\u{942}\u{92B}\u{91F}\u{949}\u{92A} X`,
    ht: `Twati X`,
    it: `Tetto X`,
    ja: `\u{30EB}\u{30FC}\u{30D5}\u{30C8}\u{30C3}\u{30D7}X`,
    ko: `\u{B8E8}\u{D504}\u{D0D1} X`,
    mww: `Rooftop X`,
    ps: `\u{628}\u{627}\u{645} X`,
    pt: `Telhado X`,
    "pt-pt": `Telhado X`,
    ru: `\u{41A}\u{440}\u{44B}\u{448}\u{430} X`,
    sm: `Taualuga X`,
    so: `Rooftop X`,
    th: `\u{E23}\u{E39}\u{E1F}\u{E17}\u{E47}\u{E2D}\u{E1B} X`,
    ur: `\u{686}\u{6BE}\u{62A} X`,
    vi: `T\u{1EA7}ng th\u{1B0}\u{1EE3}ng X`,
    "zh-hans": `\u{5C4B}\u{9876} X`,
    "zh-hant": `\u{5C4B}\u{9802} X`,
    en: `Rooftop X`
};
const $2868cc1235412e16$export$2b1f8eb454fd1c67 = {
    ar: `\u{631}\u{648}\u{641} \u{627}\u{644}\u{633}\u{637}\u{62D} Y`,
    de: `Dachterrasse Y`,
    es: `Azotea Y`,
    fa: `\u{67E}\u{634}\u{62A} \u{628}\u{627}\u{645} Y`,
    fil: `Bubong Y`,
    fr: `Toit Y`,
    hi: `\u{930}\u{942}\u{92B}\u{91F}\u{949}\u{92A} Y`,
    ht: `Twati Y`,
    it: `Tetto Y`,
    ja: `\u{5C4B}\u{4E0A}Y`,
    ko: `\u{B8E8}\u{D504}\u{D0D1} Y`,
    mww: `Rooftop Y`,
    ps: `\u{628}\u{627}\u{645} Y`,
    pt: `Telhado Y`,
    "pt-pt": `Telhado Y`,
    ru: `\u{41A}\u{440}\u{44B}\u{448}\u{430} Y`,
    sm: `Taualuga Y`,
    so: `Rooftop Y`,
    th: `\u{E23}\u{E39}\u{E1F}\u{E17}\u{E47}\u{E2D}\u{E1B} Y`,
    ur: `\u{686}\u{6BE}\u{62A} Y`,
    vi: `S\xe2n th\u{1B0}\u{1EE3}ng Y`,
    "zh-hans": `\u{5C4B}\u{9876} Y`,
    "zh-hant": `\u{5C4B}\u{9802} Y`,
    en: `Rooftop Y`
};
const $2868cc1235412e16$export$6f53e2157c028eb0 = {
    ar: `\u{627}\u{644}\u{645}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{639}\u{627}\u{634}\u{631}`,
    de: `Eintrag X`,
    es: `Entrada X`,
    fa: `\u{648}\u{631}\u{648}\u{62F}\u{6CC} X`,
    fil: `Entry X`,
    fr: `Entr\xe9e X`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{947}\u{936} X`,
    ht: `Antre X`,
    it: `Voce X`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}X`,
    ko: `\u{D56D}\u{BAA9} X`,
    mww: `Nkag teb chaws X`,
    ps: `\u{627}\u{646}\u{67C}\u{631}\u{646}\u{6D0}\u{67C} X`,
    pt: `Entrada X`,
    "pt-pt": `Entrada X`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} X`,
    sm: `Ulufale X`,
    so: `Galitaanka X`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23} X`,
    ur: `Entry X`,
    vi: `M\u{1EE5}c X`,
    "zh-hans": `\u{6761}\u{76EE} X`,
    "zh-hant": `\u{689D}\u{76EE} X`,
    en: `Entry X`
};
const $2868cc1235412e16$export$b107d9e8ea84b92a = {
    ar: `\u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} Y`,
    de: `Eintrag Y`,
    es: `Entrada Y`,
    fa: `\u{648}\u{631}\u{648}\u{62F}\u{6CC} Y`,
    fil: `Entry Y`,
    fr: `Entr\xe9e Y`,
    hi: `\u{92A}\u{94D}\u{930}\u{935}\u{93F}\u{937}\u{94D}\u{91F}\u{93F} Y`,
    ht: `Antre y`,
    it: `Voce Y`,
    ja: `\u{30A8}\u{30F3}\u{30C8}\u{30EA}\u{30FC}Y`,
    ko: `\u{D56D}\u{BAA9} Y`,
    mww: `Nkag Teb Chaws Y`,
    ps: `\u{646}\u{646}\u{648}\u{62A}\u{646}\u{6D0} Y`,
    pt: `Entrada Y`,
    "pt-pt": `Entrada Y`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{44C} Y`,
    sm: `Ulufale Y`,
    so: `Entry Y`,
    th: `\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23} Y`,
    ur: `Entry Y`,
    vi: `M\u{1EE5}c Y`,
    "zh-hans": `\u{6761}\u{76EE} Y`,
    "zh-hant": `\u{689D}\u{76EE} Y`,
    en: `Entry Y`
};
const $2868cc1235412e16$export$45aff9897ef243bc = {
    ar: `\u{642}\u{637}\u{631}`,
    de: `Bezirk`,
    es: `Distrito`,
    fa: `\u{645}\u{646}\u{637}\u{642}\u{647}`,
    fil: `Distrito`,
    fr: `District`,
    hi: `\u{91C}\u{93F}\u{932}\u{93E}`,
    ht: `Distri`,
    it: `Quartiere`,
    ja: `\u{533A}`,
    ko: `\u{C9C0}\u{AD6C}`,
    mww: `Cheeb Tsam Tsev Kawm Ntawv`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{639}\u{627}\u{645}\u{6D0} \u{631}\u{648}\u{63A}\u{62A}\u{6CC}\u{627} \u{648}\u{632}\u{627}\u{631}\u{62A} \u{648}\u{627}\u{6CC}\u{6CC}`,
    pt: `Distrito`,
    "pt-pt": `Distrito`,
    ru: `\u{420}\u{430}\u{439}\u{43E}\u{43D}`,
    sm: `Itumalo`,
    so: `Degmada`,
    th: `\u{E40}\u{E02}\u{E15}`,
    ur: `\u{639}\u{644}\u{627}\u{642}\u{6C1}`,
    vi: `Huy\u{1EC7}n`,
    "zh-hans": `\u{533A}`,
    "zh-hant": `\u{5340}`,
    en: `District`
};
const $2868cc1235412e16$export$d4f90ee0b10e05d4 = {
    ar: `\u{645}\u{646}\u{637}\u{642}\u{629} \u{627}\u{644}\u{645}\u{62A}\u{631}\u{648}`,
    de: `Metropolregion`,
    es: `\xc1rea metropolitana`,
    fa: `\u{645}\u{646}\u{637}\u{642}\u{647} \u{645}\u{62A}\u{631}\u{648}`,
    fil: `Lugar ng Metro`,
    fr: `R\xe9gion m\xe9tropolitaine`,
    hi: `\u{92E}\u{947}\u{91F}\u{94D}\u{930}\u{94B} \u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}`,
    ht: `Z\xf2n metro`,
    it: `Area metropolitana`,
    ja: `\u{30E1}\u{30C8}\u{30ED}\u{30A8}\u{30EA}\u{30A2}`,
    ko: `\u{B300}\u{B3C4}\u{C2DC} \u{C9C0}\u{C5ED}`,
    mww: `Xov cheeb tsam`,
    ps: `\u{645}\u{6CC}\u{67C}\u{631}\u{648} \u{633}\u{6CC}\u{645}\u{647}`,
    pt: `\xc1rea metropolitana`,
    "pt-pt": `\xc1rea metropolitana`,
    ru: `\u{420}\u{430}\u{439}\u{43E}\u{43D} \u{43C}\u{435}\u{442}\u{440}\u{43E}`,
    sm: `Eria o le metro`,
    so: `Agagaarka Metrooga`,
    th: `\u{E40}\u{E02}\u{E15}\u{E40}\u{E21}\u{E37}\u{E2D}\u{E07}\u{E43}\u{E2B}\u{E0D}\u{E48}`,
    ur: `\u{645}\u{6CC}\u{679}\u{631}\u{648} \u{6A9}\u{627} \u{639}\u{644}\u{627}\u{642}\u{6C1}`,
    vi: `Khu v\u{1EF1}c t\xe0u \u{111}i\u{1EC7}n ng\u{1EA7}m`,
    "zh-hans": `\u{90FD}\u{4F1A}\u{533A}`,
    "zh-hant": `\u{90FD}\u{6703}\u{5340}`,
    en: `Metro area`
};
const $2868cc1235412e16$export$5e3c89a229d55fe9 = {
    ar: `\u{62D}\u{64A}`,
    de: `Nachbarschaft`,
    es: `Vecindario`,
    fa: `\u{645}\u{62D}\u{644}\u{647}`,
    fil: `Kapitbahayan`,
    fr: `Quartier`,
    hi: `\u{92A}\u{921}\u{93C}\u{94B}\u{938}`,
    ht: `Katye`,
    it: `Quartiere`,
    ja: `\u{8FD1}\u{6240}`,
    ko: `\u{C774}\u{C6C3}`,
    mww: `neeg zej zog`,
    ps: `\u{6AB}\u{627}\u{648}\u{646}\u{689}\u{6CC}`,
    pt: `Vizinhan\xe7a`,
    "pt-pt": `Bairro`,
    ru: `\u{421}\u{43E}\u{441}\u{435}\u{434}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Tuaoi`,
    so: `xaafadda`,
    th: `\u{E22}\u{E48}\u{E32}\u{E19}`,
    ur: `\u{67E}\u{691}\u{648}\u{633}`,
    vi: `Neighborhood`,
    "zh-hans": `\u{9644}\u{8FD1}`,
    "zh-hant": `\u{9644}\u{8FD1}`,
    en: `Neighborhood`
};
const $2868cc1235412e16$export$d48f93ace41e530 = {
    ar: `\u{642}\u{637}\u{631}`,
    de: `Region`,
    es: `Regi\xf3n`,
    fa: `\u{645}\u{646}\u{637}\u{642}\u{647}`,
    fil: `Rehiyon`,
    fr: `R\xe9gion`,
    hi: `\u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}`,
    ht: `Rejyon`,
    it: `Regione`,
    ja: `\u{5730}\u{57DF}`,
    ko: `\u{BD80}\u{C704}`,
    mww: `thaj av ntawd`,
    ps: `\u{62F} \u{647}\u{631}\u{627}\u{62A} \u{648}\u{644}\u{627}\u{6CC}\u{62A} \u{62F} \u{6A9}\u{631}\u{647}\u{6BC}`,
    pt: `Regi\xe3o`,
    "pt-pt": `Regi\xe3o`,
    ru: `\u{41E}\u{431}\u{43B}\u{430}\u{441}\u{442}\u{44C}`,
    sm: `Itulagi`,
    so: `Gobolka`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E40}\u{E27}\u{E13}`,
    ur: `\u{639}\u{644}\u{627}\u{642}\u{6C1}`,
    vi: `V\xf9ng`,
    "zh-hans": `\u{5730}\u{533A}`,
    "zh-hant": `\u{5730}\u{5340}`,
    en: `Region`
};
const $2868cc1235412e16$export$861cff1ec844001d = {
    ar: `\u{62F}\u{642}\u{629}`,
    de: `Pr\xe4zision`,
    es: `Precisi\xf3n`,
    fa: `\u{62F}\u{642}\u{62A}`,
    fil: `Katumpakan`,
    fr: `Pr\xe9cision`,
    hi: `\u{92F}\u{925}\u{93E}\u{930}\u{94D}\u{925}\u{924}\u{93E}`,
    ht: `Presizyon`,
    it: `Precisione`,
    ja: `\u{7CBE}\u{5EA6}`,
    ko: `\u{C815}\u{BC00}`,
    mww: `precision`,
    ps: `\u{62F}\u{642}\u{62A}`,
    pt: `Precis\xe3o`,
    "pt-pt": `Precis\xe3o`,
    ru: `\u{422}\u{43E}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Sa'o`,
    so: `Sax`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: `Precision`,
    vi: `Ch\xednh x\xe1c`,
    "zh-hans": `\u{7CBE}\u{5EA6}`,
    "zh-hant": `\u{7CBE}\u{5EA6}`,
    en: `Precision`
};
const $2868cc1235412e16$export$684753ce26f19e56 = {
    ar: `\u{628}\u{644}\u{62F}`,
    de: `Land`,
    es: `Pa\xeds`,
    fa: `\u{6A9}\u{634}\u{648}\u{631}`,
    fil: `Bansa`,
    fr: `Pays`,
    hi: `\u{92D}\u{942}\u{915}\u{94D}\u{937}\u{947}\u{924}\u{94D}\u{930}`,
    ht: `Peyi`,
    it: `Paese`,
    ja: `\u{56FD}`,
    ko: `\u{B098}\u{B77C}`,
    mww: `Teb`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Pa\xeds`,
    "pt-pt": `Pa\xeds`,
    ru: `\u{421}\u{442}\u{440}\u{430}\u{43D}\u{430}`,
    sm: `Atunuu`,
    so: `Maad`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E17}\u{E28}`,
    ur: `\u{645}\u{644}\u{6A9}`,
    vi: `Qu\u{1ED1}c gia`,
    "zh-hans": `\u{56FD}\u{5BB6}`,
    "zh-hant": `\u{570B}\u{5BB6}`,
    en: `Country`
};
const $2868cc1235412e16$export$5c704772b04618d5 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{62A}\u{645} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646}\u{647}`,
    de: `Verifizierte Adresse`,
    es: `Direcci\xf3n verificada`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F}\u{634}\u{62F}\u{647}`,
    fil: `Email Address`,
    fr: `Adresse v\xe9rifi\xe9e`,
    hi: `\u{938}\u{924}\u{94D}\u{92F}\u{93E}\u{92A}\u{93F}\u{924} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s verifye`,
    it: `Indirizzo verificato`,
    ja: `\u{78BA}\u{8A8D}\u{6E08}\u{307F}\u{306E}\u{4F4F}\u{6240}`,
    ko: `\u{D655}\u{C778}\u{B41C} \u{C8FC}\u{C18C}`,
    mww: `Qhov chaw nyob muaj tseeb`,
    ps: `\u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{634}\u{648}\u{6CC} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o verificado`,
    "pt-pt": `Endere\xe7o verificado`,
    ru: `\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi faamaonia`,
    so: `Cinwaanka la xaqiijiyey`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{634}\u{62F}\u{6C1} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} \u{111}\xe3 x\xe1c minh`,
    "zh-hans": `\u{5DF2}\u{9A8C}\u{8BC1}\u{5730}\u{5740}`,
    "zh-hant": `\u{5DF2}\u{9A57}\u{8B49}\u{4F4D}\u{5740}`,
    en: `Verified address`
};
const $2868cc1235412e16$export$ebe06c687744d6e6 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646}\u{647}`,
    de: `Nicht verifizierte Adresse`,
    es: `Direcci\xf3n no verificada`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F}\u{646}\u{634}\u{62F}\u{647}`,
    fil: `Hindi na-verify na address`,
    fr: `Adresse non v\xe9rifi\xe9e`,
    hi: `\u{905}\u{938}\u{924}\u{94D}\u{92F}\u{93E}\u{92A}\u{93F}\u{924} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s ki pa verifye`,
    it: `Indirizzo non verificato`,
    ja: `\u{672A}\u{78BA}\u{8A8D}\u{306E}\u{30A2}\u{30C9}\u{30EC}\u{30B9}`,
    ko: `\u{D655}\u{C778}\u{B418}\u{C9C0} \u{C54A}\u{C740} \u{C8FC}\u{C18C}`,
    mww: `Chaw nyob unverified chaw nyob`,
    ps: `\u{62F} \u{627}\u{645}\u{631}\u{6CC}\u{6A9}\u{627} \u{62F} \u{645}\u{62A}\u{62D}\u{62F}\u{647} \u{627}\u{6CC}\u{627}\u{644}\u{627}\u{62A}\u{648}`,
    pt: `Endere\xe7o n\xe3o verificado`,
    "pt-pt": `Endere\xe7o n\xe3o verificado`,
    ru: `\u{41D}\u{435}\u{43F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{436}\u{434}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}`,
    sm: `Tuatusi e le'i faamaonia`,
    so: `Ciwaanka oo aan la xaqiijin`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}`,
    ur: `\u{63A}\u{6CC}\u{631} \u{645}\u{635}\u{62F}\u{642}\u{6C1} \u{67E}\u{62A}\u{6C1}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} ch\u{1B0}a \u{111}\u{1B0}\u{1EE3}c x\xe1c minh`,
    "zh-hans": `\u{672A}\u{9A8C}\u{8BC1}\u{7684}\u{5730}\u{5740}`,
    "zh-hant": `\u{672A}\u{9A57}\u{8B49}\u{7684}\u{4F4D}\u{5740}`,
    en: `Unverified address`
};
const $2868cc1235412e16$export$9b9ce1ed1bbddcb8 = {
    ar: `\u{628}\u{62F}\u{646}\u{64A}`,
    de: `Physisch`,
    es: `F\xedsico`,
    fa: `\u{641}\u{6CC}\u{632}\u{6CC}\u{6A9}\u{6CC}`,
    fil: `Pisikal`,
    fr: `Physique`,
    hi: `\u{936}\u{93E}\u{930}\u{940}\u{930}\u{93F}\u{915}`,
    ht: `Fizik`,
    it: `Fisico`,
    ja: `\u{5F62}\u{800C}\u{4E0B}`,
    ko: `\u{C721}\u{CCB4}\u{C758}`,
    mww: `lub cev`,
    ps: `\u{641}\u{632}\u{6CC}\u{6A9}\u{6CC}`,
    pt: `F\xedsico`,
    "pt-pt": `F\xedsica`,
    ru: `\u{424}\u{438}\u{437}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{439}`,
    sm: `Faaletino`,
    so: `Jirka`,
    th: `\u{E17}\u{E32}\u{E07}\u{E01}\u{E32}\u{E22}\u{E20}\u{E32}\u{E1E}`,
    ur: `\u{62C}\u{633}\u{645}\u{627}\u{646}\u{6CC}`,
    vi: `V\u{1EAD}t l\xfd`,
    "zh-hans": `\u{7269}\u{7406}\u{7684}`,
    "zh-hant": `\u{7269}\u{7406}\u{7684}`,
    en: `Physical`
};
const $2868cc1235412e16$export$4aff0780a4d562fe = {
    ar: `\u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F}\u{64A}\u{647}`,
    de: `Abschickend`,
    es: `Mailing`,
    fa: `\u{67E}\u{633}\u{62A}\u{6CC}`,
    fil: `Email Address *`,
    fr: `Publipostage`,
    hi: `\u{921}\u{93E}\u{915}`,
    ht: `Poste`,
    it: `Mailing list`,
    ja: `\u{90F5}\u{9001}`,
    ko: `\u{C6B0}\u{D3B8}\u{BB3C}`,
    mww: `xa ntawv`,
    ps: `\u{67E}\u{648}\u{633}\u{62A}\u{6CC}`,
    pt: `Mailing`,
    "pt-pt": `Envio por correspond\xeancia`,
    ru: `\u{420}\u{430}\u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{430}`,
    sm: `Meli`,
    so: `Boostada`,
    th: `\u{E40}\u{E21}\u{E25}`,
    ur: `\u{62A}\u{631}\u{633}\u{6CC}\u{644}\u{6CC}`,
    vi: `G\u{1EED}i th\u{1B0}`,
    "zh-hans": `\u{90AE}\u{4EF6}`,
    "zh-hant": `\u{90F5}\u{4EF6}`,
    en: `Mailing`
};
const $2868cc1235412e16$export$16e4a72732f4def6 = {
    ar: (cumulus)=>`\u{627}\u{628}\u{62F}\u{623} \u{641}\u{64A} \u{643}\u{62A}\u{627}\u{628}\u{629} \u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{634}\u{627}\u{631}\u{639} \u{648}\u{633}\u{64A}\u{642}\u{648}\u{645} ${cumulus} \u{628}\u{645}\u{644}\u{621} \u{627}\u{644}\u{628}\u{627}\u{642}\u{64A}`,
    de: (cumulus)=>`Beginnen Sie mit der Eingabe einer Adresse und ${cumulus} f\xfcllt den Rest aus`,
    es: (cumulus)=>`Comience a escribir una direcci\xf3n y ${cumulus} completar\xe1 el resto`,
    fa: (cumulus)=>`\u{634}\u{631}\u{648}\u{639} \u{628}\u{647} \u{62A}\u{627}\u{6CC}\u{67E} \u{622}\u{62F}\u{631}\u{633} \u{62E}\u{6CC}\u{627}\u{628}\u{627}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} ${cumulus} \u{628}\u{642}\u{6CC}\u{647} \u{631}\u{627} \u{67E}\u{631} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F}`,
    fil: (cumulus)=>`Simulan ang pag-type ng address ng kalye at ${cumulus} ang natitira`,
    fr: (cumulus)=>`Commencez \xe0 taper une adresse postale et ${cumulus} remplira le reste`,
    hi: (cumulus)=>`\u{90F}\u{915} \u{938}\u{921}\u{93C}\u{915} \u{915}\u{93E} \u{92A}\u{924}\u{93E} \u{91F}\u{93E}\u{907}\u{92A} \u{915}\u{930}\u{928}\u{93E} \u{936}\u{941}\u{930}\u{942} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} ${cumulus} \u{92C}\u{93E}\u{915}\u{940} \u{915}\u{94B} \u{92D}\u{930} \u{926}\u{947}\u{917}\u{93E}`,
    ht: (cumulus)=>`K\xf2manse tape yon adr\xe8s lari ak ${cumulus} pral ranpli nan r\xe8s la`,
    it: (cumulus)=>`Inizia a digitare un indirizzo e ${cumulus} compiler\xe0 il resto`,
    ja: (cumulus)=>`\u{4F4F}\u{6240}\u{306E}\u{5165}\u{529B}\u{3092}\u{958B}\u{59CB}\u{3059}\u{308B}\u{3068}\u{3001} ${cumulus} \u{304C}\u{6B8B}\u{308A}\u{3092}\u{57CB}\u{3081}\u{307E}\u{3059}`,
    ko: (cumulus)=>`\u{C8FC}\u{C18C}\u{B97C} \u{C785}\u{B825}\u{D558}\u{AE30} \u{C2DC}\u{C791}\u{D558}\u{BA74} ${cumulus} \u{AC00} \u{B098}\u{BA38}\u{C9C0}\u{B97C} \u{CC44}\u{C6C1}\u{B2C8}\u{B2E4}.`,
    mww: (cumulus)=>`Pib typing ib txoj kev chaw nyob thiab ${cumulus} yuav sau nyob rau hauv tas`,
    ps: (cumulus)=>`\u{62F} \u{6A9}\u{648}\u{685}\u{6D0} \u{67E}\u{62A}\u{647} \u{67C}\u{627}\u{6CC}\u{67E} \u{6A9}\u{648}\u{644} \u{67E}\u{6CC}\u{644} \u{6A9}\u{693}\u{626} \u{627}\u{648} ${cumulus} \u{628}\u{647} \u{67E}\u{627}\u{62A}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{689}\u{6A9}\u{647} \u{6A9}\u{693}\u{6CC}`,
    pt: (cumulus)=>`Comece a digitar um endere\xe7o e o ${cumulus} preencher\xe1 o resto`,
    "pt-pt": (cumulus)=>`Comece a digitar um endere\xe7o e ${cumulus} preencher\xe1 o restante`,
    ru: (cumulus)=>`\u{41D}\u{430}\u{447}\u{43D}\u{438}\u{442}\u{435} \u{432}\u{432}\u{43E}\u{434}\u{438}\u{442}\u{44C} \u{430}\u{434}\u{440}\u{435}\u{441}, \u{430} ${cumulus} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442} \u{43E}\u{441}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435}`,
    sm: (cumulus)=>`Amata ona taina se tuatusi o le auala ma o le a faatumuina e ${cumulus} le vaega o totoe`,
    so: (cumulus)=>`Bilow makiinada cinwaan wadada ah iyo ${cumulus} wuxuu buuxin doonaa inta kale`,
    th: (cumulus)=>`\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E41}\u{E25}\u{E30} ${cumulus} \u{E08}\u{E30}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}`,
    ur: (cumulus)=>`\u{6AF}\u{644}\u{6CC} \u{6A9}\u{627} \u{67E}\u{62A}\u{6C1} \u{679}\u{627}\u{626}\u{67E} \u{6A9}\u{631}\u{646}\u{627} \u{634}\u{631}\u{648}\u{639} ${cumulus} \u{628}\u{627}\u{642}\u{6CC} \u{6A9}\u{648} \u{628}\u{6BE}\u{631} \u{62F}\u{6D2} \u{6AF}\u{627}`,
    vi: (cumulus)=>`B\u{1EAF}t \u{111}\u{1EA7}u nh\u{1EAD}p \u{111}\u{1ECB}a ch\u{1EC9} \u{111}\u{1B0}\u{1EDD}ng ph\u{1ED1} v\xe0 ${cumulus} s\u{1EBD} \u{111}i\u{1EC1}n ph\u{1EA7}n c\xf2n l\u{1EA1}i`,
    "zh-hans": (cumulus)=>`\u{5F00}\u{59CB}\u{8F93}\u{5165}\u{8857}\u{9053}\u{5730}\u{5740}\u{FF0C} ${cumulus} \u{5C06}\u{586B}\u{5199}\u{5176}\u{4F59}\u{90E8}\u{5206}`,
    "zh-hant": (cumulus)=>`\u{958B}\u{59CB}\u{8F38}\u{5165}\u{8857}\u{9053}\u{4F4D}\u{5740}\u{FF0C} ${cumulus} \u{5C07}\u{586B}\u{5BEB}\u{5176}\u{9918}\u{90E8}\u{5206}`,
    en: (cumulus)=>`Start typing a street address and ${cumulus} will fill in the rest`
};
const $2868cc1235412e16$export$5b1aa37b1a35964c = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{646}\u{64A} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{623}\u{648} \u{623}\u{628}\u{62D}\u{62B} \u{639}\u{646}\u{647}. \u{623}\u{62D}\u{62A}\u{627}\u{62C} \u{625}\u{644}\u{649} \u{625}\u{62F}\u{62E}\u{627}\u{644} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646} \u{64A}\u{62F}\u{648}\u{64A}\u{627}.`,
    de: `Ich kann die Adresse nicht finden oder suche sie. Ich muss die Adresse manuell eingeben.`,
    es: `No encuentro la direcci\xf3n que busco. Necesito ingresar la direcci\xf3n manualmente.`,
    fa: `\u{645}\u{646} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{645} \u{622}\u{62F}\u{631}\u{633} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{645} \u{6CC}\u{627} \u{628}\u{647} \u{62F}\u{646}\u{628}\u{627}\u{644} \u{622}\u{646} \u{647}\u{633}\u{62A}\u{645}. \u{628}\u{627}\u{6CC}\u{62F} \u{622}\u{62F}\u{631}\u{633} \u{631}\u{627} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{62F}\u{633}\u{62A}\u{6CC} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{645}.`,
    fil: `Hindi ko mahanap ang address o hinahanap ko. Kailangan kong manu-manong ipasok ang address.`,
    fr: `Je ne trouve pas l\u{2019}adresse ou je la cherche. Je dois saisir l\u{2019}adresse manuellement.`,
    hi: `\u{92E}\u{941}\u{91D}\u{947} \u{935}\u{939} \u{92A}\u{924}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932} \u{930}\u{939}\u{93E} \u{939}\u{948} \u{92F}\u{93E} \u{92E}\u{948}\u{902} \u{922}\u{942}\u{902}\u{922} \u{930}\u{939}\u{93E} \u{939}\u{942}\u{901}. \u{92E}\u{941}\u{91D}\u{947} \u{92E}\u{948}\u{928}\u{94D}\u{92F}\u{941}\u{905}\u{932} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{92A}\u{924}\u{93E} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Mwen pa ka jwenn adr\xe8s la oswa mwen ap ch\xe8che pou. Mwen bezwen antre nan adr\xe8s la many\xe8lman.`,
    it: `Non riesco a trovare l'indirizzo o lo sto cercando. Devo inserire l'indirizzo manualmente.`,
    ja: `\u{4F4F}\u{6240}\u{304C}\u{898B}\u{3064}\u{304B}\u{3089}\u{306A}\u{3044}\u{3001}\u{307E}\u{305F}\u{306F}\u{63A2}\u{3057}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{4F4F}\u{6240}\u{3092}\u{624B}\u{52D5}\u{3067}\u{5165}\u{529B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C8FC}\u{C18C}\u{B97C} \u{CC3E}\u{C744} \u{C218} \u{C5C6}\u{AC70}\u{B098} \u{CC3E}\u{ACE0} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C8FC}\u{C18C}\u{B97C} \u{C218}\u{B3D9}\u{C73C}\u{B85C} \u{C785}\u{B825}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Kuv nrhiav tsis tau qhov chaw nyob los yog kuv tab tom nrhiav. Kuv yuav tsum tau sau qhov chaw nyob manually.`,
    ps: `\u{632}\u{647} \u{622}\u{62F}\u{631}\u{633} \u{646}\u{647} \u{634}\u{645} \u{645}\u{648}\u{646}\u{62F}\u{644}\u{6CC} \u{6CC}\u{627} \u{632}\u{647} \u{67E}\u{647} \u{644}\u{67C}\u{647} \u{6A9}\u{6D0} \u{6CC}\u{645}. \u{645}\u{646} \u{628}\u{627}\u{6CC}\u{62F} \u{622}\u{62F}\u{631}\u{633} \u{631}\u{627} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{62F}\u{633}\u{62A}\u{6CC} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{645}.`,
    pt: `N\xe3o consigo encontrar o endere\xe7o ou estou procurando. Preciso inserir o endere\xe7o manualmente.`,
    "pt-pt": `N\xe3o consigo encontrar o endere\xe7o ou estou procurando. Preciso inserir o endere\xe7o manualmente.`,
    ru: `\u{42F} \u{43D}\u{435} \u{43C}\u{43E}\u{433}\u{443} \u{43D}\u{430}\u{439}\u{442}\u{438} \u{430}\u{434}\u{440}\u{435}\u{441} \u{438}\u{43B}\u{438} \u{438}\u{449}\u{443}. \u{41C}\u{43D}\u{435} \u{43D}\u{443}\u{436}\u{43D}\u{43E} \u{432}\u{432}\u{435}\u{441}\u{442}\u{438} \u{430}\u{434}\u{440}\u{435}\u{441} \u{432}\u{440}\u{443}\u{447}\u{43D}\u{443}\u{44E}.`,
    sm: `E le mafai ona ou mauaina le tuatusi pe o lo'o ou sailia. E tatau ona ou ulufale i le tuatusi i le lima.`,
    so: `Cinwaanka ma heli karo ama waan raadinayaa. Waxaan u baahanahay in aan cinwaanka ku soo galo gacanta.`,
    th: `\u{E09}\u{E31}\u{E19}\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E09}\u{E31}\u{E19}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E21}\u{E2D}\u{E07}\u{E2B}\u{E32} \u{E09}\u{E31}\u{E19}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E14}\u{E49}\u{E27}\u{E22}\u{E15}\u{E19}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{645}\u{62C}\u{6BE}\u{6D2} \u{67E}\u{62A}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644} \u{631}\u{6C1}\u{627} \u{6C1}\u{6D2} \u{6CC}\u{627} \u{645}\u{6CC}\u{6BA} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631} \u{631}\u{6C1}\u{627} \u{6C1}\u{648}\u{6BA}. \u{645}\u{62C}\u{6BE}\u{6D2} \u{62F}\u{633}\u{62A}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{67E}\u{62A}\u{6C1} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `T\xf4i kh\xf4ng th\u{1EC3} t\xecm th\u{1EA5}y \u{111}\u{1ECB}a ch\u{1EC9} ho\u{1EB7}c t\xf4i \u{111}ang t\xecm ki\u{1EBF}m. T\xf4i c\u{1EA7}n nh\u{1EAD}p \u{111}\u{1ECB}a ch\u{1EC9} theo c\xe1ch th\u{1EE7} c\xf4ng.`,
    "zh-hans": `\u{6211}\u{627E}\u{4E0D}\u{5230}\u{5730}\u{5740}\u{6216}\u{6211}\u{6B63}\u{5728}\u{5BFB}\u{627E}\u{3002}\u{6211}\u{9700}\u{8981}\u{624B}\u{52A8}\u{8F93}\u{5165}\u{5730}\u{5740}\u{3002}`,
    "zh-hant": `\u{6211}\u{627E}\u{4E0D}\u{5230}\u{4F4D}\u{5740}\u{6216}\u{6211}\u{6B63}\u{5728}\u{5C0B}\u{627E}\u{3002}\u{6211}\u{9700}\u{8981}\u{624B}\u{52D5}\u{8F38}\u{5165}\u{4F4D}\u{5740}\u{3002}`,
    en: `I can't find the address or I'm looking for. I need to enter the address manually.`
};
const $2868cc1235412e16$export$24912d79cf581cbb = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{627}\u{644}\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `Adressdaten`,
    es: `Detalles de la direcci\xf3n`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{622}\u{62F}\u{631}\u{633}`,
    fil: `Mga detalye ng address`,
    fr: `Coordonn\xe9es`,
    hi: `\u{92A}\u{924}\u{947} \u{915}\u{93E} \u{935}\u{93F}\u{935}\u{930}\u{923}`,
    ht: `Detay adr\xe8s`,
    it: `Dettagli dell'indirizzo`,
    ja: `\u{4F4F}\u{6240}\u{306E}\u{8A73}\u{7D30}`,
    ko: `\u{C8FC}\u{C18C} \u{C138}\u{BD80} \u{C815}\u{BCF4}`,
    mww: `Hais kom paub meej`,
    ps: `\u{62F} \u{67E}\u{62A}\u{647} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes do endere\xe7o`,
    "pt-pt": `Detalhes do endere\xe7o`,
    ru: `\u{410}\u{434}\u{440}\u{435}\u{441}\u{43D}\u{430}\u{44F} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Faamatalaga o le tuatusi`,
    so: `Faahfaahinta cinwaanka`,
    th: `\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633} \u{6A9}\u{6CC} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    vi: `Chi ti\u{1EBF}t \u{111}\u{1ECB}a ch\u{1EC9}`,
    "zh-hans": `\u{5730}\u{5740}\u{8BE6}\u{60C5}`,
    "zh-hant": `\u{5730}\u{5740}\u{8A73}\u{60C5}`,
    en: `Address details`
};
const $2868cc1235412e16$export$c5f031247cf9cf4d = {
    ar: `\u{62C}\u{647}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakte`,
    es: `Contactos`,
    fa: `\u{645}\u{62E}\u{627}\u{637}\u{628}\u{6CC}\u{646}`,
    fil: `Email Address *`,
    fr: `Contacts`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Kontak`,
    it: `Contatti`,
    ja: `\u{9023}\u{7D61}\u{5148}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Kev sib cuag`,
    ps: `\u{627}\u{693}\u{6CC}\u{6A9}\u{6D0}`,
    pt: `Contatos`,
    "pt-pt": `Contatos`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{44B}`,
    sm: `Fa'afeso'ota'iga`,
    so: `Xiriirada`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{648}\u{627}\u{628}\u{637}`,
    vi: `Li\xean h\u{1EC7}`,
    "zh-hans": `\u{63A5}\u{89E6}`,
    "zh-hant": `\u{63A5}\u{89F8}`,
    en: `Contacts`
};
const $2868cc1235412e16$export$e7fbeb47337d498d = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{62C}\u{647}\u{629} \u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakt hinzuf\xfcgen`,
    es: `Agregar contacto`,
    fa: `\u{627}\u{641}\u{632}\u{648}\u{62F}\u{646} \u{645}\u{62E}\u{627}\u{637}\u{628}`,
    fil: `Email Address *`,
    fr: `Ajouter un contact`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute kontak`,
    it: `Aggiungi contatto`,
    ja: `\u{9023}\u{7D61}\u{5148}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98} \u{CD94}\u{AC00}`,
    mww: `Sib cuag tau`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Adicionar contato`,
    "pt-pt": `Adicionar contacto`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}`,
    sm: `Fa'aopopo le feso'ota'iga`,
    so: `Ku dar xiriir`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam li\xean h\u{1EC7}`,
    "zh-hans": `\u{6DFB}\u{52A0}\u{8054}\u{7CFB}\u{4EBA}`,
    "zh-hant": `\u{6DFB}\u{52A0}\u{9023}\u{7D61}\u{4EBA}`,
    en: `Add contact`
};
const $2868cc1235412e16$export$6ffe635ef5e99d9d = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{62C}\u{647}\u{629} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Kontakt entfernen`,
    es: `Eliminar el contacto`,
    fa: `\u{628}\u{631}\u{62F}\u{627}\u{634}\u{62A}\u{646} \u{645}\u{62E}\u{627}\u{637}\u{628}`,
    fil: `Tanggalin ang contact`,
    fr: `Supprimer le contact`,
    hi: `\u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{939}\u{91F}\u{93E}\u{90F}\u{902}`,
    ht: `Retire kontak`,
    it: `Rimuovi contatto`,
    ja: `\u{9023}\u{7D61}\u{5148}\u{306E}\u{524A}\u{9664}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98} \u{C81C}\u{AC70}`,
    mww: `Tshem tawm cov kev sib cuag`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6CC} \u{62F}`,
    pt: `Remover contato`,
    "pt-pt": `Remover contacto`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}`,
    sm: `Aveese le fesootaiga`,
    so: `Ka saar xiriir`,
    th: `\u{E25}\u{E1A}\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{631}\u{627}\u{628}\u{637}\u{6C1} \u{62E}\u{62A}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a li\xean h\u{1EC7}`,
    "zh-hans": `\u{5220}\u{9664}\u{8054}\u{7CFB}\u{4EBA}`,
    "zh-hant": `\u{522A}\u{9664}\u{9023}\u{7D61}\u{4EBA}`,
    en: `Remove contact`
};
const $2868cc1235412e16$export$4f27b1c5b8f8a4ef = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{62C}\u{647}\u{627}\u{62A} \u{627}\u{62A}\u{635}\u{627}\u{644}`,
    de: `Es gibt keine Kontakte`,
    es: `No hay contactos`,
    fa: `\u{647}\u{6CC}\u{686} \u{645}\u{62E}\u{627}\u{637}\u{628}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga contact`,
    fr: `Il n\u{2019}y a pas de contacts`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn kontak`,
    it: `Non ci sono contatti`,
    ja: `\u{9023}\u{7D61}\u{5148}\u{304C}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C5F0}\u{B77D}\u{CC98}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj kev sib cuag`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `N\xe3o h\xe1 contatos`,
    "pt-pt": `N\xe3o existem contactos`,
    ru: `\u{41D}\u{435}\u{442} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43E}\u{432}`,
    sm: `E leai ni feso'ota'iga`,
    so: `Ma jiraan xiriiro`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{631}\u{627}\u{628}\u{637}\u{6D2} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 \u{111}\u{1ECB}a ch\u{1EC9} li\xean h\u{1EC7}`,
    "zh-hans": `\u{6CA1}\u{6709}\u{8054}\u{7CFB}\u{4EBA}`,
    "zh-hant": `\u{6C92}\u{6709}\u{806F}\u{7E6B}\u{4EBA}`,
    en: `There are no contacts`
};
const $2868cc1235412e16$export$230e1efc20c8172a = {
    ar: `\u{645}\u{62C}\u{647}\u{648}\u{644}`,
    de: `Unbekannt`,
    es: `Desconocido`,
    fa: `\u{646}\u{627}\u{634}\u{646}\u{627}\u{62E}\u{62A}\u{647}`,
    fil: `Hindi kilala`,
    fr: `Inconnu`,
    hi: `\u{905}\u{92A}\u{94D}\u{930}\u{938}\u{93F}\u{926}\u{94D}\u{918} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F}`,
    ht: `Enkoni`,
    it: `Sconosciuto`,
    ja: `\u{4E0D}\u{660E}`,
    ko: `\u{C54C}\u{B824}\u{C9C0}\u{C9C0} \u{C54A}\u{C740}`,
    mww: `tsis paub`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646}`,
    pt: `Desconhecido`,
    "pt-pt": `Desconhecido`,
    ru: `\u{41D}\u{435}\u{438}\u{437}\u{432}\u{435}\u{441}\u{442}\u{43D}\u{44B}\u{439}`,
    sm: `E le iloa`,
    so: `Aan la garaneynin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E04}\u{E38}\u{E49}\u{E19}\u{E40}\u{E04}\u{E22}`,
    ur: `\u{646}\u{627}\u{645}\u{639}\u{644}\u{648}\u{645}`,
    vi: `Kh\xf4ng bi\u{1EBF}t`,
    "zh-hans": `\u{672A}\u{77E5}`,
    "zh-hant": `\u{672A}\u{77E5}`,
    en: `Unknown`
};
const $2868cc1235412e16$export$c9238058729ccab6 = {
    ar: `\u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{637}\u{648}\u{627}\u{631}\u{626}`,
    de: `Prim\xe4rer Notfallkontakt`,
    es: `Contacto Primario de Emergencia`,
    fa: `\u{62A}\u{645}\u{627}\u{633} \u{627}\u{636}\u{637}\u{631}\u{627}\u{631}\u{6CC} \u{627}\u{648}\u{644}\u{6CC}\u{647}`,
    fil: `Pangunahing Emergency Contact`,
    fr: `Personne-ressource principale en cas d\u{2019}urgence`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{906}\u{92A}\u{93E}\u{924}\u{915}\u{93E}\u{932}\u{940}\u{928} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Kontak Ijans Prensipal`,
    it: `Contatto di emergenza primario`,
    ja: `\u{4E3B}\u{306A}\u{7DCA}\u{6025}\u{9023}\u{7D61}\u{5148}`,
    ko: `\u{AE30}\u{BCF8} \u{BE44}\u{C0C1} \u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Thawj Cov Kev Kub Ntxhov Hu Rau Tus Kheej`,
    ps: `\u{644}\u{648}\u{645}\u{693}\u{646}\u{6CD} \u{628}\u{6CC}\u{693}\u{646}\u{6CD} \u{627}\u{693}\u{6CC}\u{6A9}\u{647}`,
    pt: `Contato de emerg\xeancia prim\xe1rio`,
    "pt-pt": `Contacto de Emerg\xeancia Principal`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{435} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43D}\u{43E}\u{435} \u{43B}\u{438}\u{446}\u{43E} \u{434}\u{43B}\u{44F} \u{441}\u{432}\u{44F}\u{437}\u{438} \u{432} \u{447}\u{440}\u{435}\u{437}\u{432}\u{44B}\u{447}\u{430}\u{439}\u{43D}\u{44B}\u{445} \u{441}\u{438}\u{442}\u{443}\u{430}\u{446}\u{438}\u{44F}\u{445}`,
    sm: `Tagata e Faafesootai i le Peraimeri mo Faalavelave Tutupu Faafuasei`,
    so: `Primary Emergency Contact`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E09}\u{E38}\u{E01}\u{E40}\u{E09}\u{E34}\u{E19}\u{E2B}\u{E25}\u{E31}\u{E01}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{6C1}\u{646}\u{6AF}\u{627}\u{645}\u{6CC} \u{631}\u{627}\u{628}\u{637}\u{6C1}`,
    vi: `Li\xean h\u{1EC7} kh\u{1EA9}n c\u{1EA5}p ch\xednh`,
    "zh-hans": `\u{4E3B}\u{8981}\u{7D27}\u{6025}\u{8054}\u{7CFB}\u{4EBA}`,
    "zh-hant": `\u{4E3B}\u{8981}\u{7DCA}\u{6025}\u{806F}\u{7E6B}\u{4EBA}`,
    en: `Primary Emergency Contact`
};
const $2868cc1235412e16$export$e6d3bbcb6498fe45 = {
    ar: `\u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644} \u{641}\u{64A} \u{62D}\u{627}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{637}\u{648}\u{627}\u{631}\u{626}`,
    de: `Notfall-Kontakt`,
    es: `Contacto de emergencia`,
    fa: `\u{62A}\u{645}\u{627}\u{633} \u{627}\u{636}\u{637}\u{631}\u{627}\u{631}\u{6CC}`,
    fil: `Pakikipag-ugnay sa Emergency`,
    fr: `Contact d\u{2019}urgence`,
    hi: `\u{906}\u{92A}\u{93E}\u{924}\u{915}\u{93E}\u{932}\u{940}\u{928} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915}`,
    ht: `Kontak Ijans`,
    it: `Contatto di emergenza`,
    ja: `\u{7DCA}\u{6025}\u{9023}\u{7D61}\u{5148}`,
    ko: `\u{BE44}\u{C0C1} \u{C5F0}\u{B77D}\u{CC98}`,
    mww: `Kev Kub Ntxhov Ceev`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Contato de emerg\xeancia`,
    "pt-pt": `Contacto de Emerg\xeancia`,
    ru: `\u{41A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43D}\u{430}\u{44F} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F} \u{434}\u{43B}\u{44F} \u{44D}\u{43A}\u{441}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{44B}\u{445} \u{441}\u{43B}\u{443}\u{447}\u{430}\u{435}\u{432}`,
    sm: `Fa'afeso'ota'iga mo Fa'alavelave`,
    so: `Xiriirka Gargaarka Degdega ah`,
    th: `\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E09}\u{E38}\u{E01}\u{E40}\u{E09}\u{E34}\u{E19}`,
    ur: `\u{6C1}\u{646}\u{6AF}\u{627}\u{645}\u{6CC} \u{631}\u{627}\u{628}\u{637}\u{6C1}`,
    vi: `Li\xean h\u{1EC7} kh\u{1EA9}n c\u{1EA5}p`,
    "zh-hans": `\u{7D27}\u{6025}\u{8054}\u{7CFB}\u{4EBA}`,
    "zh-hant": `\u{7DCA}\u{6025}\u{806F}\u{7E6B}\u{4EBA}`,
    en: `Emergency Contact`
};
const $2868cc1235412e16$export$f26cbd52422ea099 = {
    ar: `\u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}`,
    de: `Arbeitgeber`,
    es: `Empleador`,
    fa: `\u{6A9}\u{627}\u{631}\u{641}\u{631}\u{645}\u{627}`,
    fil: `Tagapag-empleyo`,
    fr: `Employeur`,
    hi: `\u{92E}\u{93E}\u{932}\u{93F}\u{915}`,
    ht: `Anplway\xe8`,
    it: `Datore di lavoro`,
    ja: `\u{96C7}\u{3044}\u{4E3B}`,
    ko: `\u{ACE0}\u{C6A9}\u{C8FC}`,
    mww: `tswv num`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Empregador`,
    "pt-pt": `Empregador`,
    ru: `\u{420}\u{430}\u{431}\u{43E}\u{442}\u{43E}\u{434}\u{430}\u{442}\u{435}\u{43B}\u{44C}`,
    sm: `Pule o le galuega`,
    so: `Shaqo-bixiyaha`,
    th: `\u{E19}\u{E32}\u{E22}\u{E08}\u{E49}\u{E32}\u{E07}`,
    ur: `\u{622}\u{62C}\u{631}`,
    vi: `Tuy\u{1EC3}n d\u{1EE5}ng`,
    "zh-hans": `\u{96C7}\u{4E3B}`,
    "zh-hant": `\u{96C7}\u{4E3B}`,
    en: `Employer`
};
const $2868cc1235412e16$export$70154fb96da70b31 = {
    ar: `\u{627}\u{644}\u{648}\u{643}\u{627}\u{644}\u{629} \u{627}\u{644}\u{627}\u{62A}\u{62D}\u{627}\u{62F}\u{64A}\u{629}`,
    de: `Bundesagentur`,
    es: `Agencia Federal`,
    fa: `\u{622}\u{698}\u{627}\u{646}\u{633} \u{641}\u{62F}\u{631}\u{627}\u{644}`,
    fil: `Ahensya ng Pederal`,
    fr: `Agence f\xe9d\xe9rale`,
    hi: `\u{938}\u{902}\u{918}\u{940}\u{92F} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{940}`,
    ht: `Ajans federal`,
    it: `Agenzia federale`,
    ja: `\u{9023}\u{90A6}\u{653F}\u{5E9C}\u{6A5F}\u{95A2}`,
    ko: `\u{C5F0}\u{BC29} \u{AE30}\u{AD00}`,
    mww: `Tsoom fwv teb chaws cov chaw ua hauj`,
    ps: `\u{641}\u{62F}\u{631}\u{627}\u{644}\u{6CC} \u{627}\u{62F}\u{627}\u{631}\u{647}`,
    pt: `Ag\xeancia Federal`,
    "pt-pt": `Ag\xeancia Federal`,
    ru: `\u{424}\u{435}\u{434}\u{435}\u{440}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{430}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Ofisa Feterale`,
    so: `Hay'adda Federaalka`,
    th: `\u{E2B}\u{E19}\u{E48}\u{E27}\u{E22}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}\u{E1A}\u{E32}\u{E25}\u{E01}\u{E25}\u{E32}\u{E07}`,
    ur: `\u{648}\u{641}\u{627}\u{642}\u{6CC} \u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}`,
    vi: `C\u{1A1} quan li\xean bang`,
    "zh-hans": `\u{8054}\u{90A6}\u{673A}\u{6784}`,
    "zh-hant": `\u{806F}\u{90A6}\u{6A5F}\u{69CB}`,
    en: `Federal Agency`
};
const $2868cc1235412e16$export$df8757b11bea02f0 = {
    ar: `\u{634}\u{631}\u{643}\u{629} \u{62A}\u{623}\u{645}\u{64A}\u{646}`,
    de: `Versicherungsgesellschaft`,
    es: `Compa\xf1\xeda de seguros`,
    fa: `\u{634}\u{631}\u{6A9}\u{62A} \u{628}\u{6CC}\u{645}\u{647}`,
    fil: `Kumpanya ng Seguro`,
    fr: `Compagnie d\u{2019}assurances`,
    hi: `\u{92C}\u{940}\u{92E}\u{93E} \u{915}\u{902}\u{92A}\u{928}\u{940}`,
    ht: `Konpayi asirans`,
    it: `Compagnia di assicurazioni`,
    ja: `\u{4FDD}\u{967A}\u{4F1A}\u{793E}`,
    ko: `\u{BCF4}\u{D5D8} \u{D68C}\u{C0AC}`,
    mww: `Tuam txhab tuav pov hwm`,
    ps: `\u{62F} \u{628}\u{6CC}\u{645}\u{6D0} \u{634}\u{631}\u{6A9}\u{62A}`,
    pt: `Seguradora`,
    "pt-pt": `Companhia de Seguros`,
    ru: `\u{421}\u{442}\u{440}\u{430}\u{445}\u{43E}\u{432}\u{430}\u{44F} \u{43A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Kamupani Inisiua`,
    so: `Shirkadda caymiska`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E29}\u{E31}\u{E17}\u{E1B}\u{E23}\u{E30}\u{E01}\u{E31}\u{E19}\u{E20}\u{E31}\u{E22}`,
    ur: `\u{627}\u{646}\u{634}\u{648}\u{631}\u{646}\u{633} \u{6A9}\u{645}\u{67E}\u{646}\u{6CC}`,
    vi: `C\xf4ng ty b\u{1EA3}o hi\u{1EC3}m`,
    "zh-hans": `\u{4FDD}\u{9669}\u{516C}\u{53F8}`,
    "zh-hant": `\u{4FDD}\u{96AA}\u{516C}\u{53F8}`,
    en: `Insurance Company`
};
const $2868cc1235412e16$export$f5494529e20e3385 = {
    ar: `\u{623}\u{642}\u{631}\u{628} \u{627}\u{644}\u{623}\u{642}\u{627}\u{631}\u{628}`,
    de: `Angeh\xf6rige`,
    es: `Pariente m\xe1s cercano`,
    fa: `\u{62E}\u{648}\u{6CC}\u{634}\u{627}\u{648}\u{646}\u{62F}\u{627}\u{646} \u{628}\u{639}\u{62F}\u{6CC}`,
    fil: `Susunod na kamag-anak`,
    fr: `Proches parents`,
    hi: `\u{928}\u{947}\u{915}\u{94D}\u{938}\u{94D}\u{91F}-\u{911}\u{92B}-\u{915}\u{93F}\u{928}`,
    ht: `pwochen-of-Kin`,
    it: `Parente prossimo`,
    ja: `\u{8FD1}\u{89AA}\u{8005}`,
    ko: `\u{CE5C}\u{C778}\u{C871} (Next-of-Kin)`,
    mww: `Tom ntej-ntawm-Kin`,
    ps: `\u{646}\u{696}\u{62F}\u{6D0} \u{62E}\u{67E}\u{644}\u{648}\u{627}\u{646}`,
    pt: `Parentes pr\xf3ximos`,
    "pt-pt": `Parentes mais pr\xf3ximos`,
    ru: `\u{411}\u{43B}\u{438}\u{436}\u{430}\u{439}\u{448}\u{438}\u{435} \u{440}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{438}\u{43A}\u{438}`,
    sm: `Aiga e sosoo ai`,
    so: `Next-of-Kin`,
    th: `\u{E0D}\u{E32}\u{E15}\u{E34}\u{E04}\u{E19}\u{E43}\u{E01}\u{E25}\u{E49}\u{E0A}\u{E34}\u{E14}`,
    ur: `\u{631}\u{634}\u{62A}\u{6C1} \u{62F}\u{627}\u{631}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{627}\u{6AF}\u{644}\u{6D2} \u{627}\u{641}\u{631}\u{627}\u{62F}`,
    vi: `Ng\u{1B0}\u{1EDD}i th\xe2n g\u{1EA7}n \u{111}\xe2y`,
    "zh-hans": `\u{8FD1}\u{4EB2}`,
    "zh-hant": `\u{8FD1}\u{89AA}`,
    en: `Next-of-Kin`
};
const $2868cc1235412e16$export$51027e8a6e256ee6 = {
    ar: `\u{648}\u{643}\u{627}\u{644}\u{629} \u{627}\u{644}\u{62F}\u{648}\u{644}\u{629}`,
    de: `Staatliche Agentur`,
    es: `Agencia Estatal`,
    fa: `\u{622}\u{698}\u{627}\u{646}\u{633} \u{62F}\u{648}\u{644}\u{62A}\u{6CC}`,
    fil: `Ahensya ng Estado`,
    fr: `Agence de l\u{2019}\xc9tat`,
    hi: `\u{930}\u{93E}\u{91C}\u{94D}\u{92F} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{940}`,
    ht: `Ajans leta`,
    it: `Agenzia statale`,
    ja: `\u{56FD}\u{5BB6}\u{6A5F}\u{95A2}`,
    ko: `\u{AD6D}\u{AC00} \u{AE30}\u{AD00}`,
    mww: `Xeev Lub Xeev Qhov Chaw Ua Hauj Lwm`,
    ps: `\u{62F}\u{648}\u{644}\u{62A}\u{6CC} \u{627}\u{62F}\u{627}\u{631}\u{647}`,
    pt: `Ag\xeancia Estadual`,
    "pt-pt": `Ag\xeancia do Estado`,
    ru: `\u{413}\u{43E}\u{441}\u{443}\u{434}\u{430}\u{440}\u{441}\u{442}\u{432}\u{435}\u{43D}\u{43D}\u{43E}\u{435} \u{430}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Ofisa o le Setete`,
    so: `Hay'adda Gobolka`,
    th: `\u{E2B}\u{E19}\u{E48}\u{E27}\u{E22}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E23}\u{E31}\u{E10}`,
    ur: `\u{631}\u{6CC}\u{627}\u{633}\u{62A}\u{6CC} \u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}`,
    vi: `C\u{1A1} quan nh\xe0 n\u{1B0}\u{1EDB}c`,
    "zh-hans": `\u{56FD}\u{5BB6}\u{673A}\u{6784}`,
    "zh-hant": `\u{570B}\u{5BB6}\u{6A5F}\u{69CB}`,
    en: `State Agency`
};
const $2868cc1235412e16$export$ef7806003a9d6713 = {
    ar: `\u{648}\u{635}\u{641}`,
    de: `Beschreibung`,
    es: `Descripci\xf3n`,
    fa: `\u{62A}\u{648}\u{636}\u{6CC}\u{62D}\u{627}\u{62A}`,
    fil: `Paglalarawan`,
    fr: `Description`,
    hi: `\u{92F}\u{93E} \u{915}\u{93C}\u{93F}\u{938}\u{94D}\u{200D}\u{92E}`,
    ht: `Deskripsyon`,
    it: `Descrizione`,
    ja: `\u{5F62}\u{5BB9}`,
    ko: `\u{BB18}\u{C0AC}`,
    mww: `piav qhia`,
    ps: `\u{62A}\u{648}\u{636}\u{6CC}\u{62D}\u{627}\u{62A}`,
    pt: `Descri\xe7\xe3o`,
    "pt-pt": `Descri\xe7\xe3o`,
    ru: `\u{41E}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `Faamatalaga`,
    so: `Tilmaan`,
    th: `\u{E04}\u{E33}\u{E2D}\u{E18}\u{E34}\u{E1A}\u{E32}\u{E22}`,
    ur: `\u{628}\u{6CC}\u{627}\u{646}`,
    vi: `S\u{1EF1} mi\xeau t\u{1EA3}`,
    "zh-hans": `\u{63CF}\u{8FF0}`,
    "zh-hant": `\u{63CF}\u{8FF0}`,
    en: `Description`
};
const $2868cc1235412e16$export$4b88cb26e2f74b1c = {
    ar: (org)=>$2868cc1235412e16$var$html`<span>المزيد من برامج ${org}</span>`,
    de: (org)=>$2868cc1235412e16$var$html`<span>Weitere ${org}</span>`,
    es: (org)=>$2868cc1235412e16$var$html`<span>Más programas ${org}</span>`,
    fa: (org)=>$2868cc1235412e16$var$html`<span>برنامه های ${org} بیشتر</span>`,
    fil: (org)=>$2868cc1235412e16$var$html`<span>Higit pang mga programa ${org}</span>`,
    fr: (org)=>$2868cc1235412e16$var$html`<span>Plus ${org}</span>`,
    hi: (org)=>$2868cc1235412e16$var$html`<span>अधिक ${org} कार्यक्रम</span>`,
    ht: (org)=>$2868cc1235412e16$var$html`<span>Plis pwogram ${org}</span>`,
    it: (org)=>$2868cc1235412e16$var$html`<span>Altri programmi ${org}</span>`,
    ja: (org)=>$2868cc1235412e16$var$html`<span>その他の ${org} プログラム</span>`,
    ko: (org)=>$2868cc1235412e16$var$html`<span>더 많은 ${org} 프로그램</span>`,
    mww: (org)=>$2868cc1235412e16$var$html`<span>NcoA cov kev pab cuam ${org}</span>`,
    ps: (org)=>$2868cc1235412e16$var$html`<span>د ${org} نور پروګرامونه</span>`,
    pt: (org)=>$2868cc1235412e16$var$html`<span>Mais programas ${org}</span>`,
    "pt-pt": (org)=>$2868cc1235412e16$var$html`<span>Mais programas ${org}</span>`,
    ru: (org)=>$2868cc1235412e16$var$html`<span>Другие программы ${org}</span>`,
    sm: (org)=>$2868cc1235412e16$var$html`<span>Isi polokalame ${org}</span>`,
    so: (org)=>$2868cc1235412e16$var$html`<span>Barnaamijyada ${org}</span>`,
    th: (org)=>$2868cc1235412e16$var$html`<span>โปรแกรม ${org} เพิ่มเติม</span>`,
    ur: (org)=>$2868cc1235412e16$var$html`<span>${org} پروگرام</span>`,
    vi: (org)=>$2868cc1235412e16$var$html`<span>Các chương trình ${org} khác</span>`,
    "zh-hans": (org)=>$2868cc1235412e16$var$html`<span>更多 ${org} 计划</span>`,
    "zh-hant": (org)=>$2868cc1235412e16$var$html`<span>更多 ${org} 計劃</span>`,
    en: (org)=>$2868cc1235412e16$var$html`<span>More ${org} programs</span>`
};
const $2868cc1235412e16$export$ef35e69eecb4ff92 = {
    ar: `\u{645}\u{644}\u{627}\u{62D}\u{638}\u{627}\u{62A} \u{627}\u{644}\u{625}\u{635}\u{62F}\u{627}\u{631}`,
    de: `Versionshinweise`,
    es: `Notas`,
    fa: `\u{6CC}\u{627}\u{62F}\u{62F}\u{627}\u{634}\u{62A} \u{647}\u{627}\u{6CC} \u{627}\u{646}\u{62A}\u{634}\u{627}\u{631}`,
    fil: `Mga tala ng paglabas`,
    fr: `Notes de mise \xe0 jour`,
    hi: `\u{930}\u{93F}\u{932}\u{940}\u{91C} \u{928}\u{94B}\u{91F}\u{94D}\u{938}`,
    ht: `Liberasyon n\xf2t yo`,
    it: `Note di rilascio`,
    ja: `\u{30EA}\u{30EA}\u{30FC}\u{30B9}\u{30CE}\u{30FC}\u{30C8}`,
    ko: `\u{B9B4}\u{B9AC}\u{C2A4} \u{B178}\u{D2B8}`,
    mww: `Tso tawm cov ntawv ceeb toom`,
    ps: `\u{62F} \u{62E}\u{67E}\u{631}\u{648}\u{646}\u{6D0} \u{6CC}\u{627}\u{62F}\u{69A}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Notas de vers\xe3o`,
    "pt-pt": `Notas de vers\xe3o`,
    ru: `\u{41F}\u{440}\u{438}\u{43C}\u{435}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{43A} \u{432}\u{44B}\u{43F}\u{443}\u{441}\u{43A}\u{443}`,
    sm: `Fa'amatalaga fa'asalalau`,
    so: `Qoraalada Release`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E08}\u{E4D}\u{E32}\u{E23}\u{E38}\u{E48}\u{E19}`,
    ur: `\u{646}\u{648}\u{679} \u{62C}\u{627}\u{631}\u{6CC} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ghi ch\xfa ph\xe1t h\xe0nh`,
    "zh-hans": `\u{53D1}\u{884C}\u{8BF4}\u{660E}`,
    "zh-hant": `\u{767C}\u{884C}\u{8AAA}\u{660E}`,
    en: `Release notes`
};
const $2868cc1235412e16$export$bb3c71098daa2c51 = {
    ar: `\u{642}\u{627}\u{628}\u{644}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{634}\u{63A}\u{64A}\u{644} \u{627}\u{644}\u{628}\u{64A}\u{646}\u{64A}`,
    de: `Interoperabilit\xe4t`,
    es: `Interoperabilidad`,
    fa: `\u{642}\u{627}\u{628}\u{644}\u{6CC}\u{62A} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC}`,
    fil: `Interoperability`,
    fr: `Interop\xe9rabilit\xe9`,
    hi: `\u{907}\u{902}\u{91F}\u{930}\u{94B}\u{911}\u{92A}\u{930}\u{947}\u{92C}\u{93F}\u{932}\u{93F}\u{91F}\u{940}`,
    ht: `Ki pa operasyon`,
    it: `Interoperabilit\xe0`,
    ja: `\u{76F8}\u{4E92}\u{904B}\u{7528}\u{6027}`,
    ko: `\u{C0C1}\u{D638} \u{C6B4}\u{C6A9}\u{C131}`,
    mww: `interoperability`,
    ps: `\u{645}\u{62A}\u{642}\u{627}\u{628}\u{644} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A}`,
    pt: `Interoperabilidade`,
    "pt-pt": `Interoperabilidade`,
    ru: `\u{424}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{441}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Feso'ota'iga`,
    so: `Interoperability`,
    th: `\u{E01}\u{E32}\u{E23}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}`,
    ur: `Interoperability`,
    vi: `Kh\u{1EA3} n\u{103}ng t\u{1B0}\u{1A1}ng t\xe1c`,
    "zh-hans": `\u{4E92}\u{4F5C}\u{6027}`,
    "zh-hant": `\u{4E92}\u{4F5C}\u{6027}`,
    en: `Interoperability`
};
const $2868cc1235412e16$export$e4eac9e9c050fc35 = {
    ar: `\u{62D}\u{627}\u{635}\u{644} \u{627}\u{644}\u{636}\u{631}\u{628}`,
    de: `Produkt`,
    es: `Producto`,
    fa: `\u{645}\u{62D}\u{635}\u{648}\u{644}`,
    fil: `Produkto`,
    fr: `Produit`,
    hi: `\u{917}\u{941}\u{923}\u{928}\u{92B}\u{932}`,
    ht: `Pwodwi`,
    it: `Prodotto`,
    ja: `\u{7A4D}`,
    ko: `\u{C81C}\u{D488}`,
    mww: `Khoom`,
    ps: `\u{645}\u{62D}\u{635}\u{648}\u{644}`,
    pt: `Produto`,
    "pt-pt": `Produto`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{443}\u{43A}\u{442}`,
    sm: `Oloa`,
    so: `Product`,
    th: `\u{E1C}\u{E25}\u{E34}\u{E15}\u{E20}\u{E31}\u{E13}\u{E11}\u{E4C}`,
    ur: `\u{62D}\u{627}\u{635}\u{644} \u{636}\u{631}\u{628}`,
    vi: `S\u{1EA3}n ph\u{1EA9}m`,
    "zh-hans": `\u{4EA7}\u{54C1}`,
    "zh-hant": `\u{7522}\u{54C1}`,
    en: `Product`
};
const $2868cc1235412e16$export$e4f377e71a52d72f = {
    ar: `\u{634}\u{631}\u{643}\u{629}`,
    de: `Firma`,
    es: `Compa\xf1\xeda`,
    fa: `\u{634}\u{631}\u{6A9}\u{62A}`,
    fil: `Kumpanya`,
    fr: `Compagnie`,
    hi: `\u{905}\u{924}\u{93F}\u{925}\u{93F}`,
    ht: `Konpayi`,
    it: `Societ\xe0`,
    ja: `\u{4F1A}\u{793E}`,
    ko: `\u{D68C}\u{C0AC}`,
    mww: `tuam txhab`,
    ps: `\u{6A9}\u{645}\u{67E}\u{646}\u{6CD}`,
    pt: `Companhia`,
    "pt-pt": `Companhia`,
    ru: `\u{41A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Kamupani`,
    so: `Company`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E29}\u{E31}\u{E17}`,
    ur: `\u{6A9}\u{645}\u{67E}\u{646}\u{6CC}`,
    vi: `C\xf4ng ty`,
    "zh-hans": `\u{516C}\u{53F8}`,
    "zh-hant": `\u{516C}\u{53F8}`,
    en: `Company`
};
const $2868cc1235412e16$export$48f5de395b14c85a = {
    ar: `\u{627}\u{644}\u{631}\u{648}\u{627}\u{628}\u{637} \u{639}\u{644}\u{649} \u{645}\u{633}\u{62A}\u{648}\u{649} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639}`,
    de: `Links auf der gesamten Website`,
    es: `Enlaces a todo el sitio`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{647}\u{627}\u{6CC} \u{6AF}\u{633}\u{62A}\u{631}\u{62F}\u{647} \u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Mga link sa buong site`,
    fr: `Liens \xe0 l\u{2019}\xe9chelle du site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F}-\u{935}\u{94D}\u{92F}\u{93E}\u{92A}\u{940} \u{932}\u{93F}\u{902}\u{915}`,
    ht: `lyen site-laj\xe8`,
    it: `Collegamenti a livello di sito`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{5168}\u{4F53}\u{306E}\u{30EA}\u{30F3}\u{30AF}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8} \u{C804}\u{CCB4} \u{B9C1}\u{D06C}`,
    mww: `Site-wide links`,
    ps: `\u{62F} \u{633}\u{627}\u{6CC}\u{67C} \u{67E}\u{647} \u{6A9}\u{686}\u{647} \u{644}\u{6CC}\u{646}\u{6A9}\u{648}\u{646}\u{647}`,
    pt: `Links para todo o site`,
    "pt-pt": `Links para todo o site`,
    ru: `\u{421}\u{441}\u{44B}\u{43B}\u{43A}\u{438} \u{43D}\u{430} \u{432}\u{435}\u{441}\u{44C} \u{441}\u{430}\u{439}\u{442}`,
    sm: `Feso'ota'iga lautele`,
    so: `Site-ballaaran links`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E17}\u{E31}\u{E48}\u{E27}\u{E17}\u{E31}\u{E49}\u{E07}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{633}\u{627}\u{626}\u{679}-\u{648}\u{633}\u{6CC}\u{639} \u{644}\u{646}\u{6A9}\u{633}`,
    vi: `Li\xean k\u{1EBF}t tr\xean to\xe0n trang web`,
    "zh-hans": `\u{7AD9}\u{70B9}\u{8303}\u{56F4}\u{7684}\u{94FE}\u{63A5}`,
    "zh-hant": `\u{7DB2}\u{7AD9}\u{7BC4}\u{570D}\u{7684}\u{9023}\u{7D50}`,
    en: `Site-wide links`
};
const $2868cc1235412e16$export$3c5d839e22f29bf6 = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{631}\u{641} \u{639}\u{644}\u{649} \u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}`,
    de: `Weitere Informationen`,
    es: `Aprende m\xe1s`,
    fa: `\u{628}\u{6CC}\u{634}\u{62A}\u{631} \u{628}\u{62F}\u{627}\u{646}\u{6CC}\u{62F}`,
    fil: `Email Address *`,
    fr: `Pour en savoir plus`,
    hi: `\u{914}\u{930} \u{91C}\u{93E}\u{928}\u{94B}`,
    ht: `Aprann plis`,
    it: `Ulteriori informazioni`,
    ja: `\u{8A73}\u{7D30}\u{60C5}\u{5831}`,
    ko: `\u{B354} \u{C54C}\u{C544}\u{BCF4}\u{C138}\u{C694}`,
    mww: `Kawm ntxiv`,
    ps: `\u{646}\u{648}\u{631} \u{632}\u{62F}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Saiba Mais`,
    "pt-pt": `Saiba mais`,
    ru: `\u{41F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{435}\u{435}`,
    sm: `Su'esu'e atili`,
    so: `Waxbadan baro`,
    th: `\u{E28}\u{E36}\u{E01}\u{E29}\u{E32}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E15}\u{E34}\u{E21}`,
    ur: `\u{627}\u{648}\u{631} \u{633}\u{64A}\u{6A9}\u{6BE}\u{648}`,
    vi: `T\xecm hi\u{1EC3}u th\xeam`,
    "zh-hans": `\u{4E86}\u{89E3}\u{66F4}\u{591A}\u{4FE1}\u{606F}`,
    "zh-hant": `\u{77AD}\u{89E3}\u{66F4}\u{591A}\u{8CC7}\u{8A0A}`,
    en: `Learn more`
};
const $2868cc1235412e16$export$aeb30d0c2a766d3 = {
    ar: (cumulus)=>`\u{645}\u{627} \u{627}\u{644}\u{630}\u{64A} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} ${cumulus} \u{645}\u{646} \u{623}\u{62C}\u{644}\u{647}\u{61F}`,
    de: (cumulus)=>`Wof\xfcr k\xf6nnen Sie ${cumulus} sonst noch verwenden?`,
    es: (cumulus)=>`\xbfPara qu\xe9 m\xe1s podr\xedas usar ${cumulus} ?`,
    fa: (cumulus)=>`\u{628}\u{631}\u{627}\u{6CC} \u{686}\u{647} \u{686}\u{6CC}\u{632} \u{62F}\u{6CC}\u{6AF}\u{631}\u{6CC} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{627}\u{632} ${cumulus} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
    fil: (cumulus)=>`Ano pa ang maaari mong gamitin ang ${cumulus} para sa?`,
    fr: (cumulus)=>`\xc0 quoi d\u{2019}autre pourriez-vous utiliser ${cumulus} ?`,
    hi: (cumulus)=>`\u{906}\u{92A} ${cumulus} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: (cumulus)=>`Ki l\xf2t bagay ou ta ka itilize ${cumulus} pou?`,
    it: (cumulus)=>`Per cos'altro potresti usare ${cumulus} ?`,
    ja: (cumulus)=>`${cumulus} \u{306F}\u{4ED6}\u{306B}\u{4F55}\u{306B}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{3059}\u{304B}?`,
    ko: (cumulus)=>`${cumulus}\u{B97C} \u{B2E4}\u{B978} \u{C5B4}\u{B5A4} \u{C6A9}\u{B3C4}\u{B85C} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{AE4C}?`,
    mww: (cumulus)=>`Dab tsi ntxiv koj yuav siv ${cumulus} rau?`,
    ps: (cumulus)=>`\u{62A}\u{627}\u{633}\u{648} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{626} ${cumulus} \u{62F} \u{685}\u{647} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{648}\u{6A9}\u{627}\u{631}\u{648}\u{626}\u{61F}`,
    pt: (cumulus)=>`Para que mais voc\xea poderia usar o ${cumulus} ?`,
    "pt-pt": (cumulus)=>`Para que mais voc\xea poderia usar ${cumulus} ?`,
    ru: (cumulus)=>`\u{414}\u{43B}\u{44F} \u{447}\u{435}\u{433}\u{43E} \u{435}\u{449}\u{435} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{44C} ${cumulus} ?`,
    sm: (cumulus)=>`O le a se isi mea e mafai ona e fa'aaogaina ${cumulus} mo?`,
    so: (cumulus)=>`Maxaa kale oo aad u isticmaali kartaa ${cumulus} ?`,
    th: (cumulus)=>`\u{E04}\u{E38}\u{E13}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E43}\u{E0A}\u{E49} ${cumulus} \u{E17}\u{E4D}\u{E32}\u{E2D}\u{E30}\u{E44}\u{E23}\u{E44}\u{E14}\u{E49}\u{E2D}\u{E35}\u{E01}\u{E1A}\u{E49}\u{E32}\u{E07}?`,
    ur: (cumulus)=>`\u{622}\u{67E} \u{6A9}\u{645}\u{648}\u{644}\u{633} \u{6A9}\u{648} \u{627}\u{648}\u{631} \u{6A9}\u{633} \u{686}\u{6CC}\u{632} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} ${cumulus} \u{61F}`,
    vi: (cumulus)=>`B\u{1EA1}n c\xf3 th\u{1EC3} s\u{1EED} d\u{1EE5}ng ${cumulus} \u{111}\u{1EC3} l\xe0m g\xec kh\xe1c?`,
    "zh-hans": (cumulus)=>`\u{60A8}\u{8FD8}\u{53EF}\u{4EE5}\u{4F7F}\u{7528} ${cumulus} \u{505A}\u{4EC0}\u{4E48}\u{FF1F}`,
    "zh-hant": (cumulus)=>`\u{60A8}\u{9084}\u{53EF}\u{4EE5}\u{4F7F}\u{7528} ${cumulus} \u{505A}\u{4EC0}\u{9EBC}\u{FF1F}`,
    en: (cumulus)=>`What else could you use ${cumulus} for?`
};
const $2868cc1235412e16$export$471961a7c731b50b = {
    ar: (cumulus)=>`\u{642}\u{645} \u{628}\u{62A}\u{648}\u{635}\u{64A}\u{644} \u{627}\u{644}\u{634}\u{631}\u{643}\u{627}\u{621} \u{648}\u{627}\u{644}\u{641}\u{631}\u{642} \u{648}\u{645}\u{634}\u{627}\u{631}\u{643}\u{629} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{648}\u{625}\u{62F}\u{627}\u{631}\u{629} \u{627}\u{644}\u{639}\u{645}\u{644}\u{627}\u{621} \u{648}\u{625}\u{62C}\u{631}\u{627}\u{621} \u{627}\u{644}\u{62A}\u{642}\u{64A}\u{64A}\u{645}\u{627}\u{62A} \u{648}\u{625}\u{62C}\u{631}\u{627}\u{621} \u{627}\u{644}\u{625}\u{62D}\u{627}\u{644}\u{627}\u{62A} \u{648}\u{62A}\u{62A}\u{628}\u{639} \u{627}\u{644}\u{623}\u{62D}\u{62F}\u{627}\u{62B} \u{648}\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F}. \u{627}\u{633}\u{62A}\u{628}\u{62F}\u{644} \u{62C}\u{62F}\u{627}\u{648}\u{644} \u{627}\u{644}\u{628}\u{64A}\u{627}\u{646}\u{627}\u{62A} \u{648}\u{627}\u{644}\u{648}\u{631}\u{642} \u{648}\u{631}\u{633}\u{627}\u{626}\u{644} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{628}\u{645}\u{647}\u{627}\u{645} \u{633}\u{64A}\u{631} \u{639}\u{645}\u{644} ${cumulus} \u{648}\u{627}\u{644}\u{646}\u{645}\u{627}\u{630}\u{62C} \u{627}\u{644}\u{62A}\u{644}\u{642}\u{627}\u{626}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{627}\u{633}\u{62A}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{648}\u{627}\u{644}\u{645}\u{647}\u{627}\u{645}.`,
    de: (cumulus)=>`Verbinden Sie Partner und Teams, tauschen Sie Informationen aus, verwalten Sie Kunden, f\xfchren Sie Bewertungen durch, geben Sie Empfehlungen ab, verfolgen Sie Veranstaltungen und vieles mehr. Ersetzen Sie Tabellenkalkulationen, Papier und E-Mails durch ${cumulus} , automatisierte Formulare, Umfragen und Aufgaben.`,
    es: (cumulus)=>`Conecte socios y equipos, comparta informaci\xf3n, administre clientes, realice evaluaciones, haga referencias, realice un seguimiento de eventos y m\xe1s. Reemplace las hojas de c\xe1lculo, el papel y los correos electr\xf3nicos con flujos de trabajo, formularios automatizados, encuestas y tareas de ${cumulus} .`,
    fa: (cumulus)=>`\u{634}\u{631}\u{6A9}\u{627} \u{648} \u{62A}\u{6CC}\u{645} \u{647}\u{627} \u{631}\u{627} \u{628}\u{647} \u{647}\u{645} \u{645}\u{62A}\u{635}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{631}\u{627} \u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{628}\u{6AF}\u{630}\u{627}\u{631}\u{6CC}\u{62F}\u{60C} \u{645}\u{634}\u{62A}\u{631}\u{6CC}\u{627}\u{646} \u{631}\u{627} \u{645}\u{62F}\u{6CC}\u{631}\u{6CC}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{627}\u{631}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{647}\u{627} \u{631}\u{627} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{62F}\u{647}\u{6CC}\u{62F}\u{60C} \u{627}\u{631}\u{62C}\u{627}\u{639} \u{62F}\u{647}\u{6CC}\u{62F}\u{60C} \u{631}\u{648}\u{6CC}\u{62F}\u{627}\u{62F}\u{647}\u{627} \u{631}\u{627} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{645}\u{648}\u{627}\u{631}\u{62F} \u{62F}\u{6CC}\u{6AF}\u{631}. \u{635}\u{641}\u{62D}\u{627}\u{62A} \u{6AF}\u{633}\u{62A}\u{631}\u{62F}\u{647}\u{60C} \u{6A9}\u{627}\u{63A}\u{630} \u{648} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{647}\u{627} \u{631}\u{627} \u{628}\u{627} \u{6AF}\u{631}\u{62F}\u{634} \u{6A9}\u{627}\u{631} ${cumulus} \u{60C} \u{641}\u{631}\u{645} \u{647}\u{627}\u{6CC} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631}\u{60C} \u{646}\u{638}\u{631}\u{633}\u{646}\u{62C}\u{6CC} \u{647}\u{627} \u{648} \u{648}\u{638}\u{627}\u{6CC}\u{641} \u{62C}\u{627}\u{6CC}\u{6AF}\u{632}\u{6CC}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (cumulus)=>`Ikonekta ang mga kasosyo at koponan, magbahagi ng impormasyon, pamahalaan ang mga kliyente, magsagawa ng mga pagtatasa, gumawa ng mga referral, subaybayan ang mga kaganapan, at marami pa. Palitan ang mga spreadsheet, papel, at email ng mga daloy ng trabaho ${cumulus} , awtomatikong mga form, survey, at gawain.`,
    fr: (cumulus)=>`Connectez les partenaires et les \xe9quipes, partagez des informations, g\xe9rez des clients, effectuez des \xe9valuations, effectuez des r\xe9f\xe9rences, suivez des \xe9v\xe9nements, etc. Remplacez les feuilles de calcul, le papier et les e-mails par des flux de travail ${cumulus} , des formulaires automatis\xe9s, des enqu\xeates et des t\xe2ches.`,
    hi: (cumulus)=>`\u{92D}\u{93E}\u{917}\u{940}\u{926}\u{93E}\u{930}\u{94B}\u{902} \u{914}\u{930} \u{91F}\u{940}\u{92E}\u{94B}\u{902} \u{915}\u{94B} \u{915}\u{928}\u{947}\u{915}\u{94D}\u{91F} \u{915}\u{930}\u{947}\u{902}, \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{930}\u{947}\u{902}, \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}\u{94B}\u{902} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92C}\u{902}\u{927}\u{928} \u{915}\u{930}\u{947}\u{902}, \u{906}\u{915}\u{932}\u{928} \u{915}\u{930}\u{947}\u{902}, \u{930}\u{947}\u{92B}\u{930}\u{932} \u{92C}\u{928}\u{93E}\u{90F}\u{902}, \u{918}\u{91F}\u{928}\u{93E}\u{913}\u{902} \u{915}\u{94B} \u{91F}\u{94D}\u{930}\u{948}\u{915} \u{915}\u{930}\u{947}\u{902}, \u{914}\u{930} \u{92C}\u{939}\u{941}\u{924} \u{915}\u{941}\u{91B}\u{964} \u{938}\u{94D}\u{92A}\u{94D}\u{930}\u{947}\u{921}\u{936}\u{940}\u{91F}, \u{915}\u{93E}\u{917}\u{93C}\u{91C}\u{93C} \u{914}\u{930} \u{908}\u{92E}\u{947}\u{932} \u{915}\u{94B} ${cumulus} \u{935}\u{930}\u{94D}\u{915}\u{92B}\u{93C}\u{94D}\u{932}\u{94B}\u{91C}\u{93C}, \u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{93F}\u{924} \u{92A}\u{94D}\u{930}\u{92A}\u{924}\u{94D}\u{930}, \u{938}\u{930}\u{94D}\u{935}\u{947}\u{915}\u{94D}\u{937}\u{923} \u{914}\u{930} \u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{94B}\u{902} \u{938}\u{947} \u{92C}\u{926}\u{932}\u{947}\u{902}.`,
    ht: (cumulus)=>`Patn\xe8 konekte ak ekip, pataje enf\xf2masyon, jere kliyan, evalyasyon kondwit, f\xe8 referans, ev\xe8nman swiv, ak plis ank\xf2. Ranplase pwopagasyon, papye, ak Im\xe8l ak ${cumulus} , f\xf2m otomatik, sondaj, ak travay.`,
    it: (cumulus)=>`Connetti partner e team, condividi informazioni, gestisci i clienti, conduci valutazioni, fai referenze, monitora gli eventi e altro ancora. Sostituisci fogli di calcolo, carta ed e-mail con i flussi di lavoro, i moduli automatizzati, i sondaggi e le attivit\xe0 ${cumulus} .`,
    ja: (cumulus)=>`\u{30D1}\u{30FC}\u{30C8}\u{30CA}\u{30FC}\u{3068}\u{30C1}\u{30FC}\u{30E0}\u{306E}\u{63A5}\u{7D9A}\u{3001}\u{60C5}\u{5831}\u{306E}\u{5171}\u{6709}\u{3001}\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{306E}\u{7BA1}\u{7406}\u{3001}\u{8A55}\u{4FA1}\u{306E}\u{5B9F}\u{65BD}\u{3001}\u{7D39}\u{4ECB}\u{3001}\u{30A4}\u{30D9}\u{30F3}\u{30C8}\u{306E}\u{8FFD}\u{8DE1}\u{306A}\u{3069}\u{3092}\u{884C}\u{3044}\u{307E}\u{3059}\u{3002}\u{30B9}\u{30D7}\u{30EC}\u{30C3}\u{30C9}\u{30B7}\u{30FC}\u{30C8}\u{3001}\u{7D19}\u{3001}\u{30E1}\u{30FC}\u{30EB}\u{3092} ${cumulus} \u{30EF}\u{30FC}\u{30AF}\u{30D5}\u{30ED}\u{30FC}\u{3001}\u{81EA}\u{52D5}\u{30D5}\u{30A9}\u{30FC}\u{30E0}\u{3001}\u{30A2}\u{30F3}\u{30B1}\u{30FC}\u{30C8}\u{3001}\u{30BF}\u{30B9}\u{30AF}\u{306B}\u{7F6E}\u{304D}\u{63DB}\u{3048}\u{307E}\u{3059}\u{3002}`,
    ko: (cumulus)=>`\u{D30C}\u{D2B8}\u{B108}\u{C640} \u{D300}\u{C744} \u{C5F0}\u{ACB0}\u{D558}\u{ACE0}, \u{C815}\u{BCF4}\u{B97C} \u{ACF5}\u{C720}\u{D558}\u{ACE0}, \u{ACE0}\u{AC1D}\u{C744} \u{AD00}\u{B9AC}\u{D558}\u{ACE0}, \u{D3C9}\u{AC00}\u{B97C} \u{C218}\u{D589}\u{D558}\u{ACE0}, \u{CD94}\u{CC9C}\u{D558}\u{ACE0}, \u{C774}\u{BCA4}\u{D2B8}\u{B97C} \u{CD94}\u{C801}\u{D558}\u{B294} \u{B4F1}\u{C758} \u{C791}\u{C5C5}\u{C744} \u{C218}\u{D589}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C2A4}\u{D504}\u{B808}\u{B4DC}\u{C2DC}\u{D2B8}, \u{C885}\u{C774} \u{BC0F} \u{C774}\u{BA54}\u{C77C}\u{C744} ${cumulus} \u{C6CC}\u{D06C}\u{D50C}\u{B85C}\u{C6B0}, \u{C790}\u{B3D9}\u{D654}\u{B41C} \u{C591}\u{C2DD}, \u{C124}\u{BB38}\u{C870}\u{C0AC} \u{BC0F} \u{C791}\u{C5C5}\u{C73C}\u{B85C} \u{B300}\u{CCB4}\u{D558}\u{C138}\u{C694}.`,
    mww: (cumulus)=>`Txuas nrog ib tug neeg thiab paab, muab cov lus qhia, tswj cov neeg tau, kev soj ntsuam, ua referrals, khiav txheej xwm, thiab ntau dua. Hloov kis tau, ntawv, thiab emails nrog ${cumulus} workflows, automated ntaub ntawv, kev sojntsuam, thiab cov hauj lwm.`,
    ps: (cumulus)=>`\u{634}\u{631}\u{6CC}\u{6A9}\u{627}\u{646} \u{627}\u{648} \u{67C}\u{6CC}\u{645}\u{648}\u{646}\u{647} \u{633}\u{631}\u{647} \u{646}\u{69A}\u{644}\u{648}\u{644} \u{60C} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{634}\u{631}\u{6CC}\u{6A9} \u{6A9}\u{693}\u{626} \u{60C} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{6CC}\u{646} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{6A9}\u{693}\u{626} \u{60C} \u{627}\u{631}\u{632}\u{648}\u{646}\u{647} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{693}\u{626} \u{60C} \u{62D}\u{648}\u{627}\u{644}\u{647} \u{6A9}\u{693}\u{626} \u{60C} \u{67E}\u{6D0}\u{69A}\u{6D0} \u{62A}\u{639}\u{642}\u{6CC}\u{628} \u{6A9}\u{693}\u{626} \u{60C} \u{627}\u{648} \u{646}\u{648}\u{631}. \u{627}\u{633}\u{67E}\u{631}\u{6CC}\u{689}\u{634}\u{6CC}\u{67C}\u{632}\u{60C} \u{6A9}\u{627}\u{63A}\u{630}\u{60C} \u{627}\u{648} \u{628}\u{631}\u{6CC}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{62F} ${cumulus} \u{6A9}\u{627}\u{631}\u{6CC} \u{6A9}\u{627}\u{631}\u{60C} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631} \u{641}\u{648}\u{631}\u{645}\u{60C} \u{633}\u{631}\u{648}\u{6D0} \u{627}\u{648} \u{62F}\u{646}\u{62F}\u{648} \u{633}\u{631}\u{647} \u{628}\u{62F}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: (cumulus)=>`Conecte parceiros e equipes, compartilhe informa\xe7\xf5es, gerencie clientes, conduza avalia\xe7\xf5es, fa\xe7a refer\xeancias, rastreie eventos e muito mais. Substitua planilhas, pap\xe9is e e-mails por fluxos de trabalho, formul\xe1rios automatizados, pesquisas e tarefas do ${cumulus} .`,
    "pt-pt": (cumulus)=>`Conecte parceiros e equipes, compartilhe informa\xe7\xf5es, gerencie clientes, realize avalia\xe7\xf5es, fa\xe7a indica\xe7\xf5es, acompanhe eventos e muito mais. Substitua planilhas, papel e e-mails por fluxos de trabalho ${cumulus} , formul\xe1rios automatizados, pesquisas e tarefas.`,
    ru: (cumulus)=>`\u{41F}\u{43E}\u{434}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{439}\u{442}\u{435} \u{43F}\u{430}\u{440}\u{442}\u{43D}\u{435}\u{440}\u{43E}\u{432} \u{438} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{44B}, \u{43E}\u{431}\u{43C}\u{435}\u{43D}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435}\u{441}\u{44C} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{435}\u{439}, \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{439}\u{442}\u{435} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{43C}\u{438}, \u{43F}\u{440}\u{43E}\u{432}\u{43E}\u{434}\u{438}\u{442}\u{435} \u{43E}\u{446}\u{435}\u{43D}\u{43A}\u{438}, \u{434}\u{435}\u{43B}\u{430}\u{439}\u{442}\u{435} \u{440}\u{435}\u{43A}\u{43E}\u{43C}\u{435}\u{43D}\u{434}\u{430}\u{446}\u{438}\u{438}, \u{43E}\u{442}\u{441}\u{43B}\u{435}\u{436}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F} \u{438} \u{43C}\u{43D}\u{43E}\u{433}\u{43E}\u{435} \u{434}\u{440}\u{443}\u{433}\u{43E}\u{435}. \u{417}\u{430}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{44B}\u{435} \u{442}\u{430}\u{431}\u{43B}\u{438}\u{446}\u{44B}, \u{431}\u{443}\u{43C}\u{430}\u{433}\u{443} \u{438} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43E}\u{447}\u{442}\u{443} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{43C}\u{438} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{430}\u{43C}\u{438} ${cumulus} , \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{43D}\u{44B}\u{43C}\u{438} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{43C}\u{438}, \u{43E}\u{43F}\u{440}\u{43E}\u{441}\u{430}\u{43C}\u{438} \u{438} \u{437}\u{430}\u{434}\u{430}\u{447}\u{430}\u{43C}\u{438}.`,
    sm: (cumulus)=>`Fa'afeso'ota'i pa'aga ma 'au, fefa'asoaa'i fa'amatalaga, fa'atautaia tagata fa'atau, fa'atautaia iloiloga, faia fa'asino mea, siaki mea na tutupu, ma sili atu. Suia spreadsheets, pepa, ma imeli i ${cumulus} workflows, otometi fomu, su'esu'ega, ma galuega.`,
    so: (cumulus)=>`Isku xirka la-hawlgalayaasha iyo kooxaha, macluumaadka wadaagaan, maareeyaan macaamiisha, qiimaynta la sameeyo, samee gudbinta, dhacdooyinka track, iyo in ka badan. Badal waraaqaha waraaqaha, warqad, iyo emails socodka shaqada ${cumulus} , foomamka automated, sahan, iyo hawlaha.`,
    th: (cumulus)=>`\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E15}\u{E48}\u{E2D}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E21}\u{E34}\u{E15}\u{E23}\u{E41}\u{E25}\u{E30}\u{E17}\u{E35}\u{E21} \u{E41}\u{E1A}\u{E48}\u{E07}\u{E1B}\u{E31}\u{E19}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25} \u{E08}\u{E31}\u{E14}\u{E01}\u{E32}\u{E23}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32} \u{E17}\u{E4D}\u{E32}\u{E01}\u{E32}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E21}\u{E34}\u{E19} \u{E01}\u{E32}\u{E23}\u{E2D}\u{E49}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E07} \u{E15}\u{E34}\u{E14}\u{E15}\u{E32}\u{E21}\u{E40}\u{E2B}\u{E15}\u{E38}\u{E01}\u{E32}\u{E23}\u{E13}\u{E4C} \u{E41}\u{E25}\u{E30}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E46} \u{E41}\u{E17}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E40}\u{E1B}\u{E23}\u{E14}\u{E0A}\u{E35}\u{E15} \u{E01}\u{E23}\u{E30}\u{E14}\u{E32}\u{E29} \u{E41}\u{E25}\u{E30}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E14}\u{E49}\u{E27}\u{E22}\u{E40}\u{E27}\u{E34}\u{E23}\u{E4C}\u{E01}\u{E42}\u{E1F}\u{E25}\u{E27}\u{E4C} ${cumulus} \u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34} \u{E41}\u{E1A}\u{E1A}\u{E2A}\u{E4D}\u{E32}\u{E23}\u{E27}\u{E08} \u{E41}\u{E25}\u{E30}\u{E07}\u{E32}\u{E19}`,
    ur: (cumulus)=>`\u{634}\u{631}\u{627}\u{6A9}\u{62A} \u{62F}\u{627}\u{631}\u{648}\u{6BA} \u{627}\u{648}\u{631} \u{679}\u{6CC}\u{645}\u{648}\u{6BA} \u{6A9}\u{648} \u{645}\u{631}\u{628}\u{648}\u{637} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{60C} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{6A9}\u{627} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{60C} \u{6AF}\u{627}\u{6C1}\u{6A9}\u{648}\u{6BA} \u{6A9}\u{627} \u{627}\u{646}\u{62A}\u{638}\u{627}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{60C} \u{62A}\u{634}\u{62E}\u{6CC}\u{635} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{60C} \u{62D}\u{648}\u{627}\u{644}\u{6C1} \u{62C}\u{627}\u{62A} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA} \u{60C} \u{648}\u{627}\u{642}\u{639}\u{627}\u{62A} \u{6A9}\u{648} \u{679}\u{631}\u{6CC}\u{6A9} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{60C} \u{627}\u{648}\u{631} \u{628}\u{6C1}\u{62A} \u{6A9}\u{686}\u{6BE}\u{6D4} \u{627}\u{633}\u{67E}\u{631}\u{6CC}\u{688} \u{634}\u{6CC}\u{679}\u{633} \u{60C} \u{6A9}\u{627}\u{63A}\u{630} \u{60C} \u{627}\u{648}\u{631} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632} ${cumulus} \u{648}\u{631}\u{6A9} \u{641}\u{644}\u{648}\u{632} \u{60C} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631} \u{641}\u{627}\u{631}\u{645} \u{60C} \u{633}\u{631}\u{648}\u{6D2} \u{627}\u{648}\u{631} \u{6A9}\u{627}\u{645}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{62A}\u{628}\u{62F}\u{6CC}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (cumulus)=>`K\u{1EBF}t n\u{1ED1}i \u{111}\u{1ED1}i t\xe1c v\xe0 nh\xf3m, chia s\u{1EBB} th\xf4ng tin, qu\u{1EA3}n l\xfd kh\xe1ch h\xe0ng, ti\u{1EBF}n h\xe0nh \u{111}\xe1nh gi\xe1, gi\u{1EDB}i thi\u{1EC7}u, theo d\xf5i s\u{1EF1} ki\u{1EC7}n, v.v. Thay th\u{1EBF} b\u{1EA3}ng t\xednh, gi\u{1EA5}y v\xe0 email b\u{1EB1}ng quy tr\xecnh l\xe0m vi\u{1EC7}c ${cumulus} , bi\u{1EC3}u m\u{1EAB}u t\u{1EF1} \u{111}\u{1ED9}ng, kh\u{1EA3}o s\xe1t v\xe0 nhi\u{1EC7}m v\u{1EE5}.`,
    "zh-hans": (cumulus)=>`\u{8FDE}\u{63A5}\u{5408}\u{4F5C}\u{4F19}\u{4F34}\u{548C}\u{56E2}\u{961F}\u{3001}\u{5171}\u{4EAB}\u{4FE1}\u{606F}\u{3001}\u{7BA1}\u{7406}\u{5BA2}\u{6237}\u{3001}\u{8FDB}\u{884C}\u{8BC4}\u{4F30}\u{3001}\u{8FDB}\u{884C}\u{63A8}\u{8350}\u{3001}\u{8DDF}\u{8E2A}\u{4E8B}\u{4EF6}\u{7B49}\u{3002}\u{5C06}\u{7535}\u{5B50}\u{8868}\u{683C}\u{3001}\u{7EB8}\u{5F20}\u{548C}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{66FF}\u{6362}\u{4E3A} ${cumulus} \u{5DE5}\u{4F5C}\u{6D41}\u{3001}\u{81EA}\u{52A8}\u{5316}\u{8868}\u{5355}\u{3001}\u{8C03}\u{67E5}\u{548C}\u{4EFB}\u{52A1}\u{3002}`,
    "zh-hant": (cumulus)=>`\u{9023}\u{63A5}\u{5408}\u{4F5C}\u{5925}\u{4F34}\u{548C}\u{5718}\u{968A}\u{3001}\u{5171}\u{7528}\u{8CC7}\u{8A0A}\u{3001}\u{7BA1}\u{7406}\u{5BA2}\u{6236}\u{3001}\u{9032}\u{884C}\u{8A55}\u{4F30}\u{3001}\u{9032}\u{884C}\u{63A8}\u{85A6}\u{3001}\u{8DDF}\u{8E64}\u{4E8B}\u{4EF6}\u{7B49}\u{3002}\u{5C07}\u{96FB}\u{5B50}\u{9336}\u{683C}\u{3001}\u{7D19}\u{5F35}\u{548C}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{66FF}\u{63DB}\u{70BA} ${cumulus} \u{5DE5}\u{4F5C}\u{6D41}\u{3001}\u{81EA}\u{52D5}\u{5316}\u{8868}\u{55AE}\u{3001}\u{8ABF}\u{67E5}\u{548C}\u{4EFB}\u{52D9}\u{3002}`,
    en: (cumulus)=>`Connect partners and teams, share information, manage clients, conduct assessments, make referrals, track events, and more. Replace spreadsheets, paper, and emails with ${cumulus} workflows, automated forms, surveys, and tasks.`
};
const $2868cc1235412e16$export$e1839d6b7af6839 = {
    ar: (cumulus, org)=>$2868cc1235412e16$var$html`<span>هل تريد استخدام ${cumulus} لبرامج ${org} الأخرى؟</span>`,
    de: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Möchten Sie ${cumulus} auch für andere ${org} nutzen?</span>`,
    es: (cumulus, org)=>$2868cc1235412e16$var$html`<span>¿Desea usar ${cumulus} para otros programas ${org} ?</span>`,
    fa: (cumulus, org)=>$2868cc1235412e16$var$html`<span>آیا می خواهید از ${cumulus} برای سایر برنامه ${org} استفاده کنید؟</span>`,
    fil: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Gusto mo bang gamitin ang ${cumulus} para sa iba pang mga programa ng ${org}</span>`,
    fr: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Vous souhaitez utiliser ${cumulus} pour d’autres programmes ${org} ?</span>`,
    hi: (org, cumulus)=>$2868cc1235412e16$var$html`<span>अन्य ${org} कार्यक्रमों के लिए ${cumulus} का उपयोग करना चाहते हैं?</span>`,
    ht: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Vle itilize ${cumulus} pou lòt pwogram ${org} ?</span>`,
    it: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Vuoi utilizzare ${cumulus} per altri programmi ${org} ?</span>`,
    ja: (cumulus, org)=>$2868cc1235412e16$var$html`<span>${cumulus} を他の ${org} プログラムに使用したいですか?</span>`,
    ko: (org, cumulus)=>$2868cc1235412e16$var$html`<span>다른 ${org} 프로그램에 ${cumulus}를 사용하고 싶으십니까?</span>`,
    mww: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Xav siv ${cumulus} rau lwm ${org} cov kev pab cuam?</span>`,
    ps: (cumulus, org)=>$2868cc1235412e16$var$html`<span>آیا غواړئ چې ${cumulus} د نورو ${org} پروګرامونو لپاره وکاروئ؟</span>`,
    pt: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Quer usar o ${cumulus} para outros programas ${org} ?</span>`,
    "pt-pt": (cumulus, org)=>$2868cc1235412e16$var$html`<span>Quer usar o ${cumulus} para outros programas ${org} ?</span>`,
    ru: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Хотите использовать ${cumulus} для других программ ${org} ?</span>`,
    sm: (cumulus, org)=>$2868cc1235412e16$var$html`<span>E te mana'o e ${cumulus} mo isi ${org}</span>`,
    so: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Ma dooneysaa inaad ${cumulus} u isticmaasho barnaamijyada kale ${org} ?</span>`,
    th: (cumulus, org)=>$2868cc1235412e16$var$html`<span>ต้องการใช้ ${cumulus} สําหรับโปรแกรม ${org} อื่น ๆ หรือไม่?</span>`,
    ur: (org, cumulus)=>$2868cc1235412e16$var$html`<span>دوسرے ${org} ${cumulus} استعمال کرنا چاہتے ہیں؟</span>`,
    vi: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Bạn muốn sử dụng ${cumulus} cho các chương trình ${org} khác?</span>`,
    "zh-hans": (cumulus, org)=>$2868cc1235412e16$var$html`<span>想要将 ${cumulus} 用于其他 ${org} 计划？</span>`,
    "zh-hant": (cumulus, org)=>$2868cc1235412e16$var$html`<span>想要將 ${cumulus} 用於其他 ${org} 計劃？</span>`,
    en: (cumulus, org)=>$2868cc1235412e16$var$html`<span>Want to use ${cumulus} for other ${org} programs?</span>`
};
const $2868cc1235412e16$export$7a2f179ce2201367 = {
    ar: `\u{62A}\u{639}\u{62F}\u{64A}\u{644} \u{627}\u{644}\u{62A}\u{631}\u{643}\u{64A}\u{628}\u{629} \u{627}\u{644}\u{633}\u{643}\u{627}\u{646}\u{64A}\u{629}`,
    de: `Demografische Daten bearbeiten`,
    es: `Editar datos demogr\xe1ficos`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{62C}\u{645}\u{639}\u{6CC}\u{62A} \u{634}\u{646}\u{627}\u{633}\u{6CC}`,
    fil: `I-edit ang demograpiko`,
    fr: `Modifier les donn\xe9es d\xe9mographiques`,
    hi: `\u{91C}\u{928}\u{938}\u{93E}\u{902}\u{916}\u{94D}\u{92F}\u{93F}\u{915}\u{940} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit demografik`,
    it: `Modifica i dati demografici`,
    ja: `\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{306E}\u{7DE8}\u{96C6}`,
    ko: `\u{C778}\u{AD6C} \u{D1B5}\u{ACC4} \u{D3B8}\u{C9D1}`,
    mww: `Edit demographics`,
    ps: `\u{62F} \u{62C}\u{645}\u{639}\u{6CC}\u{62A} \u{67E}\u{6CC}\u{698}\u{646}\u{62F}\u{646}\u{6D0} \u{633}\u{645}\u{648}\u{646}`,
    pt: `Editar dados demogr\xe1ficos`,
    "pt-pt": `Editar dados demogr\xe1ficos`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{434}\u{435}\u{43C}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{445} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}`,
    sm: `Fa'asa'o le faitau aofa'i o tagata`,
    so: `Edit dadka`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{688}\u{6CC}\u{645}\u{648}\u{6AF}\u{631}\u{627}\u{641}\u{6A9}\u{633} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a th\xf4ng tin nh\xe2n kh\u{1EA9}u h\u{1ECD}c`,
    "zh-hans": `\u{7F16}\u{8F91}\u{53D7}\u{4F17}\u{7279}\u{5F81}`,
    "zh-hant": `\u{7DE8}\u{8F2F}\u{53D7}\u{773E}\u{7279}\u{5FB5}`,
    en: `Edit demographics`
};
const $2868cc1235412e16$export$c34792aaa3afdd0c = {
    ar: `\u{62C}\u{646}\u{633}`,
    de: `Geschlecht`,
    es: `G\xe9nero`,
    fa: `\u{62C}\u{646}\u{633}\u{6CC}\u{62A}`,
    fil: `Kasarian`,
    fr: `Genre`,
    hi: `\u{932}\u{93F}\u{902}\u{917}`,
    ht: `S\xe8ks`,
    it: `Genere`,
    ja: `\u{30B8}\u{30A7}\u{30F3}\u{30C0}\u{30FC}`,
    ko: `\u{C131}\u{BCC4}`,
    mww: `tub los ntxhais`,
    ps: `\u{62C}\u{646}\u{633}\u{6CC}\u{62A}`,
    pt: `G\xeanero`,
    "pt-pt": `G\xe9nero`,
    ru: `\u{420}\u{43E}\u{434}`,
    sm: `Itupa`,
    so: `Jinsiga`,
    th: `\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{62C}\u{646}\u{633}`,
    vi: `Gi\u{1ED1}ng`,
    "zh-hans": `\u{6027}`,
    "zh-hant": `\u{6027}`,
    en: `Gender`
};
const $2868cc1235412e16$export$4277e4cc1c707d62 = {
    ar: `\u{62F}\u{648}\u{628}`,
    de: `ROHDIAMANT`,
    es: `DOB`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{646}\u{6AF}\u{627}\u{631}\u{634}`,
    fil: `Tangga ng Batas`,
    fr: `DOB`,
    hi: `\u{91C}\u{928}\u{94D}\u{92E} \u{924}\u{93F}\u{925}\u{93F}`,
    ht: `DOB`,
    it: `DOB`,
    ja: `\u{751F}\u{5E74}\u{6708}\u{65E5}`,
    ko: `\u{C0DD}\u{B144}\u{C6D4}\u{C77C}`,
    mww: `DOB`,
    ps: `\u{689}\u{6CC} \u{627}\u{648} \u{689}\u{6CC} \u{627}\u{6D0}`,
    pt: `DOB`,
    "pt-pt": `Data de nascimento`,
    ru: `\u{414}\u{430}\u{442}\u{430} \u{440}\u{43E}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Aso o le Fanau`,
    so: `DOB`,
    th: `\u{E27}\u{E31}\u{E19}\u{E40}\u{E01}\u{E34}\u{E14}`,
    ur: `DOB`,
    vi: `Ng\xe0y sinh`,
    "zh-hans": `\u{51FA}\u{751F}\u{65E5}\u{671F}`,
    "zh-hant": `\u{51FA}\u{751F}\u{65E5}\u{671F}`,
    en: `DOB`
};
const $2868cc1235412e16$export$ab5742ac4d4c8094 = {
    ar: `\u{627}\u{644}\u{639}\u{631}\u{642}`,
    de: `Ethnizit\xe4t`,
    es: `Origen \xe9tnico`,
    fa: `\u{642}\u{648}\u{645}\u{6CC}\u{62A}`,
    fil: `Etnisidad`,
    fr: `Ethnicit\xe9`,
    hi: `\u{91C}\u{93E}\u{924}\u{940}\u{92F}\u{924}\u{93E}`,
    ht: `Etnisite`,
    it: `Etnicit\xe0`,
    ja: `\u{30A8}\u{30B9}\u{30CB}\u{30B7}\u{30C6}\u{30A3}`,
    ko: `\u{BBFC}\u{C871}\u{C131}`,
    mww: `Haiv neeg tsawg`,
    ps: `\u{642}\u{648}\u{645}\u{6CC}\u{62A}`,
    pt: `Etnia`,
    "pt-pt": `Etnicidade`,
    ru: `\u{42D}\u{442}\u{43D}\u{43E}\u{441}`,
    sm: `Ituaiga`,
    so: `Ethnicity`,
    th: `\u{E40}\u{E0A}\u{E37}\u{E49}\u{E2D}\u{E0A}\u{E32}\u{E15}\u{E34}`,
    ur: `\u{646}\u{633}\u{644}\u{6CC} \u{62A}\u{641}\u{631}\u{6CC}\u{642}`,
    vi: `S\u{1EAF}c t\u{1ED9}c`,
    "zh-hans": `\u{79CD}\u{65CF}`,
    "zh-hant": `\u{7A2E}\u{65CF}`,
    en: `Ethnicity`
};
const $2868cc1235412e16$export$32a9f9c862497dc6 = {
    ar: `\u{633}\u{628}\u{627}\u{642}`,
    de: `Rennen`,
    es: `Raza`,
    fa: `\u{645}\u{633}\u{627}\u{628}\u{642}\u{647}`,
    fil: `Lahi`,
    fr: `Course`,
    hi: `\u{91C}\u{93E}\u{924}\u{93F}`,
    ht: `kous`,
    it: `Razza`,
    ja: `\u{7AF6}\u{8D70}`,
    ko: `\u{C778}\u{C885}`,
    mww: `haiv neeg`,
    ps: `\u{646}\u{698}\u{627}\u{62F}`,
    pt: `Ra\xe7a`,
    "pt-pt": `Ra\xe7a`,
    ru: `\u{420}\u{430}\u{441}\u{430}`,
    sm: `Tuuga`,
    so: `Race`,
    th: `\u{E41}\u{E02}\u{E48}\u{E07}`,
    ur: `\u{646}\u{633}\u{644}`,
    vi: `Ch\u{1EE7}ng t\u{1ED9}c`,
    "zh-hans": `\u{6BD4}\u{8D5B}`,
    "zh-hant": `\u{6BD4}\u{8CFD}`,
    en: `Race`
};
const $2868cc1235412e16$export$5461db7cc7c84cd = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{62C}\u{647} \u{627}\u{644}\u{62C}\u{646}\u{633}\u{64A}`,
    de: `Sexuelle Orientierung`,
    es: `Orientaci\xf3n sexual`,
    fa: `\u{6AF}\u{631}\u{627}\u{6CC}\u{634} \u{62C}\u{646}\u{633}\u{6CC}`,
    fil: `Sekswal na oryentasyon`,
    fr: `Orientation sexuelle`,
    hi: `\u{938}\u{947}\u{915}\u{94D}\u{936}\u{941}\u{905}\u{932} \u{913}\u{930}\u{93F}\u{90F}\u{902}\u{91F}\u{947}\u{936}\u{928}`,
    ht: `Annary\xe8 seksy\xe8l`,
    it: `Orientamento sessuale`,
    ja: `\u{6027}\u{7684}\u{6307}\u{5411}`,
    ko: `\u{C131}\u{C801} \u{C9C0}\u{D5A5}`,
    mww: `kev ua niam txiv orientation`,
    ps: `\u{62C}\u{646}\u{633}\u{6CC} \u{645}\u{6CC}\u{644}\u{627}\u{646}`,
    pt: `Orienta\xe7\xe3o sexual`,
    "pt-pt": `Orienta\xe7\xe3o sexual`,
    ru: `\u{421}\u{435}\u{43A}\u{441}\u{443}\u{430}\u{43B}\u{44C}\u{43D}\u{430}\u{44F} \u{43E}\u{440}\u{438}\u{435}\u{43D}\u{442}\u{430}\u{446}\u{438}\u{44F}`,
    sm: `Fa'afeusuaiga`,
    so: `Jihada galmada`,
    th: `\u{E23}\u{E2A}\u{E19}\u{E34}\u{E22}\u{E21}\u{E17}\u{E32}\u{E07}\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{62C}\u{646}\u{633}\u{6CC} \u{631}\u{62C}\u{62D}\u{627}\u{646}`,
    vi: `Xu h\u{1B0}\u{1EDB}ng t\xecnh d\u{1EE5}c`,
    "zh-hans": `\u{6027}\u{53D6}\u{5411}`,
    "zh-hant": `\u{6027}\u{53D6}\u{5411}`,
    en: `Sexual orientation`
};
const $2868cc1235412e16$export$2a2eee6a115fe8fd = {
    ar: `\u{627}\u{644}\u{644}\u{63A}\u{629} \u{627}\u{644}\u{623}\u{633}\u{627}\u{633}\u{64A}\u{629}`,
    de: `Prim\xe4re Sprache`,
    es: `Lengua materna`,
    fa: `\u{632}\u{628}\u{627}\u{646} \u{627}\u{635}\u{644}\u{6CC}`,
    fil: `Pangunahing wika`,
    fr: `Langue principale`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{925}\u{92E}\u{93F}\u{915} \u{92D}\u{93E}\u{937}\u{93E}`,
    ht: `Lang prensipal`,
    it: `Lingua principale`,
    ja: `\u{4E3B}\u{8981}\u{8A00}\u{8A9E}`,
    ko: `\u{AE30}\u{BCF8} \u{C5B8}\u{C5B4}`,
    mww: `Hom lus ua ntej`,
    ps: `\u{644}\u{648}\u{645}\u{693}\u{646}\u{6CD} \u{698}\u{628}\u{647}`,
    pt: `L\xedngua principal`,
    "pt-pt": `L\xedngua principal`,
    ru: `\u{41E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{439} \u{44F}\u{437}\u{44B}\u{43A}`,
    sm: `Gagana autu`,
    so: `Luqada aasaasiga ah`,
    th: `\u{E20}\u{E32}\u{E29}\u{E32}\u{E2B}\u{E25}\u{E31}\u{E01}`,
    ur: `\u{628}\u{646}\u{6CC}\u{627}\u{62F}\u{6CC} \u{632}\u{628}\u{627}\u{646}`,
    vi: `Ng\xf4n ng\u{1EEF} ch\xednh`,
    "zh-hans": `\u{4E3B}\u{8981}\u{8BED}\u{8A00}`,
    "zh-hant": `\u{4E3B}\u{8981}\u{8A9E}\u{8A00}`,
    en: `Primary language`
};
const $2868cc1235412e16$export$c36fb3befca1b570 = {
    ar: `\u{627}\u{644}\u{62D}\u{627}\u{644}\u{629} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}\u{64A}\u{629}`,
    de: `Familienstand`,
    es: `Estado civil`,
    fa: `\u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{62A}\u{623}\u{647}\u{644}`,
    fil: `Katayuan sa pag-aasawa`,
    fr: `Situation de famille`,
    hi: `\u{935}\u{948}\u{935}\u{93E}\u{939}\u{93F}\u{915} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F}`,
    ht: `Eta sivil, kondisyon matris`,
    it: `Stato civile`,
    ja: `\u{5A5A}\u{59FB}\u{72B6}\u{6CC1}`,
    ko: `\u{ACB0}\u{D63C} \u{C5EC}\u{BD80}`,
    mww: `Cuab yeej ob leeg tsim muaj`,
    ps: `\u{627}\u{632}\u{62F}\u{648}\u{627}\u{62C}\u{6CC} \u{62D}\u{627}\u{644}\u{62A}`,
    pt: `Estado civil`,
    "pt-pt": `Estado civil`,
    ru: `\u{421}\u{435}\u{43C}\u{435}\u{439}\u{43D}\u{43E}\u{435} \u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}`,
    sm: `Tulaga fa'aipoipo`,
    so: `Xaaladda guurka`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E20}\u{E32}\u{E1E}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E21}\u{E23}\u{E2A}`,
    ur: `\u{627}\u{632}\u{62F}\u{648}\u{627}\u{62C}\u{6CC} \u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A}`,
    vi: `T\xecnh tr\u{1EA1}ng h\xf4n nh\xe2n`,
    "zh-hans": `\u{5A5A}\u{59FB}\u{72B6}\u{51B5}`,
    "zh-hant": `\u{5A5A}\u{59FB}\u{72C0}\u{6CC1}`,
    en: `Marital status`
};
const $2868cc1235412e16$export$b0002ad409eb5cbd = {
    ar: `\u{634}\u{628}\u{643}\u{629} \u{627}\u{644}\u{636}\u{645}\u{627}\u{646} \u{627}\u{644}\u{627}\u{62C}\u{62A}\u{645}\u{627}\u{639}\u{64A}`,
    de: `SSN`,
    es: `SSN`,
    fa: `Ssn`,
    fil: `SSN`,
    fr: `SSN`,
    hi: `\u{90F}\u{938}\u{90F}\u{938}\u{90F}\u{928}`,
    ht: `oblije`,
    it: `SSN`,
    ja: `SSN\u{306E}`,
    ko: `\u{C99D}\u{AD8C} \u{C2DC}\u{C138} \u{D45C}\u{C2DC}\u{AE30}`,
    mww: `SSN`,
    ps: `SSN`,
    pt: `SSN`,
    "pt-pt": `SSN`,
    ru: `\u{421}\u{421}\u{41D}`,
    sm: `SSN`,
    so: `SSN`,
    th: `\u{E40}\u{E2D}\u{E2A}\u{E40}\u{E2D}\u{E2A}\u{E40}\u{E2D}\u{E47}\u{E19}`,
    ur: `SSN`,
    vi: `SSN`,
    "zh-hans": `SSN`,
    "zh-hant": `SSN`,
    en: `SSN`
};
const $2868cc1235412e16$export$efe5565d4cb41e84 = {
    ar: `\u{645}\u{639}\u{631}\u{641} \u{645}\u{64A}\u{62F}\u{64A}\u{643}\u{64A}\u{62F}`,
    de: `Medicaid-Kennung`,
    es: `Identificaci\xf3n de Medicaid`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} Medicaid`,
    fil: `Medicaid ID`,
    fr: `Identifiant Medicaid`,
    hi: `\u{92E}\u{947}\u{921}\u{93F}\u{915}\u{947}\u{921} \u{906}\u{908}\u{921}\u{940}`,
    ht: `Medicaid ID`,
    it: `Medicaid ID`,
    ja: `\u{30E1}\u{30C7}\u{30A3}\u{30B1}\u{30A4}\u{30C9}ID`,
    ko: `\u{BA54}\u{B514}\u{CF00}\u{C774}\u{B4DC} ID`,
    mww: `Medicaid ID`,
    ps: `\u{645}\u{6CC}\u{689}\u{6CC}\u{6A9}\u{6CC}\u{689} \u{622}\u{6CC} \u{689}\u{6CC}`,
    pt: `Medicaid ID`,
    "pt-pt": `Medicaid ID`,
    ru: `\u{418}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} Medicaid`,
    sm: `Medicaid ID`,
    so: `Medicaid ID`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E40}\u{E21}\u{E14}\u{E34}\u{E40}\u{E04}\u{E14}`,
    ur: `Medicaid ID`,
    vi: `Medicaid ID`,
    "zh-hans": `\u{533B}\u{7597}\u{8865}\u{52A9} ID`,
    "zh-hant": `\u{91AB}\u{7642}\u{88DC}\u{52A9}ID`,
    en: `Medicaid ID`
};
const $2868cc1235412e16$export$59779707d88725c3 = {
    ar: `\u{647}\u{648}\u{64A}\u{629} \u{627}\u{644}\u{645}\u{62E}\u{636}\u{631}\u{645}`,
    de: `Veteranen-ID`,
    es: `Identificaci\xf3n de veterano`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{62C}\u{627}\u{646}\u{628}\u{627}\u{632}`,
    fil: `ID ng Beterano`,
    fr: `Carte d\u{2019}identit\xe9 d\u{2019}ancien combattant`,
    hi: `\u{935}\u{92F}\u{94B}\u{935}\u{943}\u{926}\u{94D}\u{927} \u{906}\u{908}\u{921}\u{940}`,
    ht: `Veteran ID`,
    it: `Tessera da veterano`,
    ja: `\u{9000}\u{5F79}\u{8ECD}\u{4EBA}ID`,
    ko: `\u{C7AC}\u{D5A5} \u{AD70}\u{C778} ID`,
    mww: `Veteran ID`,
    ps: `\u{62A}\u{62C}\u{631}\u{628}\u{647} \u{6A9}\u{627}\u{631} \u{622}\u{6CC} \u{689}\u{6CC}`,
    pt: `Identifica\xe7\xe3o de veterano`,
    "pt-pt": `ID de veterano`,
    ru: `\u{423}\u{434}\u{43E}\u{441}\u{442}\u{43E}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{438}\u{435} \u{432}\u{435}\u{442}\u{435}\u{440}\u{430}\u{43D}\u{430}`,
    sm: `Veteran ID`,
    so: `Veteran ID`,
    th: `\u{E1A}\u{E31}\u{E15}\u{E23}\u{E1B}\u{E23}\u{E30}\u{E08}\u{E4D}\u{E32}\u{E15}\u{E31}\u{E27}\u{E17}\u{E2B}\u{E32}\u{E23}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E28}\u{E36}\u{E01}`,
    ur: `\u{62A}\u{62C}\u{631}\u{628}\u{6C1} \u{6A9}\u{627}\u{631} ID`,
    vi: `Th\u{1EBB} c\u{1EF1}u chi\u{1EBF}n binh`,
    "zh-hans": `\u{9000}\u{4F0D}\u{519B}\u{4EBA} ID`,
    "zh-hant": `\u{9000}\u{4F0D}\u{8ECD}\u{4EBA}ID`,
    en: `Veteran ID`
};
const $2868cc1235412e16$export$735af97578f62fd7 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{62D}\u{644}\u{642}\u{627}\u{62A} / \u{627}\u{644}\u{62D}\u{627}\u{644}\u{627}\u{62A}`,
    de: `Alle Episoden / F\xe4lle`,
    es: `Todos los episodios / casos`,
    fa: `\u{647}\u{645}\u{647} \u{642}\u{633}\u{645}\u{62A} \u{647}\u{627} / \u{645}\u{648}\u{627}\u{631}\u{62F}`,
    fil: `Lahat ng mga episode / kaso`,
    fr: `Tous les \xe9pisodes / cas`,
    hi: `\u{938}\u{92D}\u{940} \u{90F}\u{92A}\u{93F}\u{938}\u{94B}\u{921}/\u{92E}\u{93E}\u{92E}\u{932}\u{947}`,
    ht: `Tout epiz\xf2d / ka`,
    it: `Tutti gli episodi / casi`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{30A8}\u{30D4}\u{30BD}\u{30FC}\u{30C9}/\u{30B1}\u{30FC}\u{30B9}`,
    ko: `\u{BAA8}\u{B4E0} \u{C5D0}\u{D53C}\u{C18C}\u{B4DC} / \u{C0AC}\u{B840}`,
    mww: `Txhua lub sijhawm uas nws rov / tej zaum`,
    ps: `\u{67C}\u{648}\u{644} \u{67E}\u{6D0}\u{69A}\u{6D0} / \u{642}\u{636}\u{6CC}\u{6D0}`,
    pt: `Todos os epis\xf3dios / casos`,
    "pt-pt": `Todos os epis\xf3dios / casos`,
    ru: `\u{412}\u{441}\u{435} \u{44D}\u{43F}\u{438}\u{437}\u{43E}\u{434}\u{44B} / \u{43A}\u{435}\u{439}\u{441}\u{44B}`,
    sm: `Vaega uma / mataupu`,
    so: `Dhammaan dhacdooyinka / kiisaska`,
    th: `\u{E17}\u{E38}\u{E01}\u{E15}\u{E2D}\u{E19} / \u{E04}\u{E14}\u{E35}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{627}\u{642}\u{633}\u{627}\u{637} / \u{645}\u{639}\u{627}\u{645}\u{644}\u{627}\u{62A}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c t\u{1EAD}p / tr\u{1B0}\u{1EDD}ng h\u{1EE3}p`,
    "zh-hans": `\u{6240}\u{6709}\u{5267}\u{96C6}/\u{6848}\u{4F8B}`,
    "zh-hant": `\u{6240}\u{6709}\u{5287}\u{96C6}/\u{6848}\u{4F8B}`,
    en: `All episodes / cases`
};
const $2868cc1235412e16$export$21f7f01186ae91a2 = {
    ar: `\u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}\u{627}\u{62A}`,
    de: `Telekommunikation`,
    es: `Telecomunicaciones`,
    fa: `\u{645}\u{62E}\u{627}\u{628}\u{631}\u{627}\u{62A}`,
    fil: `Email Address *`,
    fr: `T\xe9l\xe9communications`,
    hi: `\u{926}\u{942}\u{930}\u{938}\u{902}\u{91A}\u{93E}\u{930}`,
    ht: `Telekominikasyon`,
    it: `Telecomunicazioni`,
    ja: `\u{30C6}\u{30EC}\u{30B3}\u{30E0}`,
    ko: `\u{D154}\u{B808}\u{CF64}`,
    mww: `Telecom`,
    ps: `\u{645}\u{62E}\u{627}\u{628}\u{631}\u{627}\u{62A}`,
    pt: `Telecomunica\xe7\xf5es`,
    "pt-pt": `Telecomunica\xe7\xf5es`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{43A}\u{43E}\u{43C}`,
    sm: `Feso'ota'iga`,
    so: `Telecom`,
    th: `\u{E42}\u{E17}\u{E23}\u{E04}\u{E21}\u{E19}\u{E32}\u{E04}\u{E21}`,
    ur: `Telecom`,
    vi: `Vi\u{1EC5}n th\xf4ng`,
    "zh-hans": `\u{7535}\u{4FE1}`,
    "zh-hant": `\u{96FB}\u{4FE1}`,
    en: `Telecom`
};
const $2868cc1235412e16$export$fd9f456d77941a4 = {
    ar: `\u{645}\u{644}\u{62E}\u{635}`,
    de: `Zusammenfassung`,
    es: `Resumen`,
    fa: `\u{62E}\u{644}\u{627}\u{635}\u{647}`,
    fil: `Buod`,
    fr: `R\xe9sum\xe9`,
    hi: `\u{938}\u{93E}\u{930}\u{93E}\u{902}\u{936}`,
    ht: `Rezime`,
    it: `Sommario`,
    ja: `\u{6982}\u{8981}`,
    ko: `\u{C694}\u{C57D}`,
    mww: `Kev Xaus Lub Neej`,
    ps: `\u{644}\u{646}\u{689}\u{6CC}\u{632}`,
    pt: `Resumo`,
    "pt-pt": `Resumo`,
    ru: `\u{421}\u{432}\u{43E}\u{434}\u{43A}\u{430}`,
    sm: `Aotelega`,
    so: `Kooban`,
    th: `\u{E2A}\u{E23}\u{E38}\u{E1B}`,
    ur: `\u{62E}\u{644}\u{627}\u{635}\u{6C1}`,
    vi: `T\xf3m t\u{1EAF}t`,
    "zh-hans": `\u{603B}\u{7ED3}`,
    "zh-hant": `\u{7E3D}\u{7D50}`,
    en: `Summary`
};
const $2868cc1235412e16$export$fab6bcf1e8d90e76 = {
    ar: `\u{646}\u{638}\u{631}\u{647} \u{639}\u{627}\u{645}\u{647}`,
    de: `\xdcberblick`,
    es: `Visi\xf3n general`,
    fa: `\u{645}\u{631}\u{648}\u{631}\u{6CC}`,
    fil: `Pangkalahatang-ideya`,
    fr: `Aper\xe7u`,
    hi: `\u{935}\u{93F}\u{939}\u{902}\u{917}\u{93E}\u{935}\u{932}\u{94B}\u{915}\u{928}`,
    ht: `Rezime`,
    it: `Panoramica`,
    ja: `\u{6982}\u{8981}`,
    ko: `\u{AC1C}\u{C694}`,
    mww: `Overview`,
    ps: `\u{644}\u{646}\u{689}\u{647} \u{6A9}\u{62A}\u{646}\u{647}`,
    pt: `Vis\xe3o geral`,
    "pt-pt": `Vis\xe3o geral`,
    ru: `\u{41E}\u{431}\u{437}\u{43E}\u{440}`,
    sm: `Aotelega`,
    so: `Tilmaam`,
    th: `\u{E20}\u{E32}\u{E1E}\u{E23}\u{E27}\u{E21}`,
    ur: `\u{62C}\u{627}\u{626}\u{632}\u{6C1}`,
    vi: `T\u{1ED5}ng quan`,
    "zh-hans": `\u{6982}\u{8FF0}`,
    "zh-hant": `\u{6982}\u{8FF0}`,
    en: `Overview`
};
const $2868cc1235412e16$export$49059a112cc2b793 = {
    ar: `\u{62A}\u{62D}\u{631}\u{64A}\u{631} \u{627}\u{644}\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644}`,
    de: `Details bearbeiten`,
    es: `Editar detalles`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A}`,
    fil: `I-edit ang mga detalye`,
    fr: `Modifier les d\xe9tails`,
    hi: `\u{935}\u{93F}\u{935}\u{930}\u{923} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Detay edit`,
    it: `Modifica dettagli`,
    ja: `\u{8A73}\u{7D30}\u{306E}\u{7DE8}\u{96C6}`,
    ko: `\u{C138}\u{BD80} \u{C815}\u{BCF4} \u{D3B8}\u{C9D1}`,
    mww: `Edit paub meej`,
    ps: `\u{633}\u{645}\u{648}\u{646} \u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A}`,
    pt: `Editar detalhes`,
    "pt-pt": `Editar detalhes`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{434}\u{435}\u{442}\u{430}\u{43B}\u{438}`,
    sm: `Fa'asa'o auiliiliga`,
    so: `faahfaahinta edit`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}`,
    ur: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a chi ti\u{1EBF}t`,
    "zh-hans": `\u{7F16}\u{8F91}\u{8BE6}\u{7EC6}\u{4FE1}\u{606F}`,
    "zh-hant": `\u{7DE8}\u{8F2F}\u{8A73}\u{7D30}\u{8CC7}\u{8A0A}`,
    en: `Edit details`
};
const $2868cc1235412e16$export$cba9aac5ce5c5768 = {
    ar: `\u{627}\u{633}\u{648}\u{634}\u{64A}\u{62A}\u{62F}`,
    de: `Assoziiert`,
    es: `Asociado`,
    fa: `\u{645}\u{631}\u{62A}\u{628}\u{637}`,
    fil: `Nauugnay`,
    fr: `Associ\xe9`,
    hi: `\u{938}\u{902}\u{92C}\u{902}\u{927}\u{93F}\u{924}`,
    ht: `Asosye`,
    it: `Associato`,
    ja: `\u{95A2}\u{9023}\u{4ED8}\u{3051} \u{3089}\u{308C}\u{305F}`,
    ko: `\u{C5F0}\u{ACB0}`,
    mww: `Associated`,
    ps: `\u{62A}\u{693}\u{644}`,
    pt: `Associado`,
    "pt-pt": `Associados`,
    ru: `\u{421}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{44B}\u{439}`,
    sm: `Feso'ota'iga`,
    so: `associated`,
    th: `\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21} \u{E42}\u{E22}\u{E07}`,
    ur: `\u{648}\u{627}\u{628}\u{633}\u{62A}\u{6C1}`,
    vi: `Li\xean k\u{1EBF}t`,
    "zh-hans": `\u{76F8}\u{5173}`,
    "zh-hant": `\u{76F8}\u{95DC}`,
    en: `Associated`
};
const $2868cc1235412e16$export$2d2b792cc2ae3e56 = {
    ar: `\u{645}\u{644}\u{62E}\u{635} \u{627}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629}`,
    de: `Zusammenfassung drucken`,
    es: `Imprimir resumen`,
    fa: `\u{62E}\u{644}\u{627}\u{635}\u{647} \u{686}\u{627}\u{67E}`,
    fil: `I-print ang buod`,
    fr: `Imprimer le r\xe9sum\xe9`,
    hi: `\u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{938}\u{93E}\u{930}\u{93E}\u{902}\u{936}`,
    ht: `Rezime enprime`,
    it: `Stampa sommario`,
    ja: `\u{6982}\u{8981}\u{3092}\u{5370}\u{5237}`,
    ko: `\u{C694}\u{C57D} \u{C778}\u{C1C4}`,
    mww: `Sau kom meej`,
    ps: `\u{62F} \u{686}\u{627}\u{67E} \u{644}\u{646}\u{689}\u{6CC}\u{632}`,
    pt: `Resumo da impress\xe3o`,
    "pt-pt": `Imprimir resumo`,
    ru: `\u{420}\u{430}\u{441}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{430}\u{442}\u{44C} \u{440}\u{435}\u{437}\u{44E}\u{43C}\u{435}`,
    sm: `Lolomi le aotelega`,
    so: `Kooban Daabac`,
    th: `\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E2A}\u{E23}\u{E38}\u{E1B}`,
    ur: `\u{62E}\u{644}\u{627}\u{635}\u{6C1} \u{67E}\u{631}\u{646}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `In t\xf3m t\u{1EAF}t`,
    "zh-hans": `\u{6253}\u{5370}\u{6458}\u{8981}`,
    "zh-hant": `\u{5217}\u{5370}\u{6458}\u{8981}`,
    en: `Print summary`
};
const $2868cc1235412e16$export$637e72f98a969f91 = {
    ar: `\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644} \u{627}\u{644}\u{637}\u{628}\u{627}\u{639}\u{629}`,
    de: `Details drucken`,
    es: `Detalles de impresi\xf3n`,
    fa: `\u{62C}\u{632}\u{626}\u{6CC}\u{627}\u{62A} \u{686}\u{627}\u{67E}`,
    fil: `Email Address *`,
    fr: `Imprimer les d\xe9tails`,
    hi: `\u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{935}\u{93F}\u{935}\u{930}\u{923}`,
    ht: `Detay enprime`,
    it: `Stampa dettagli`,
    ja: `\u{5370}\u{5237}\u{5185}\u{5BB9}`,
    ko: `\u{C138}\u{BD80} \u{C815}\u{BCF4} \u{C778}\u{C1C4}`,
    mww: `Sau kom paub meej`,
    ps: `\u{62F} \u{686}\u{627}\u{67E} \u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A}`,
    pt: `Detalhes da impress\xe3o`,
    "pt-pt": `Imprimir detalhes`,
    ru: `\u{420}\u{430}\u{441}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{430}\u{442}\u{44C} \u{434}\u{435}\u{442}\u{430}\u{43B}\u{438}`,
    sm: `Lolomi auiliiliga`,
    so: `Daabac faahfaahinta`,
    th: `\u{E23}\u{E32}\u{E22}\u{E25}\u{E30}\u{E40}\u{E2D}\u{E35}\u{E22}\u{E14}\u{E01}\u{E32}\u{E23}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}`,
    ur: `\u{62A}\u{641}\u{635}\u{6CC}\u{644}\u{627}\u{62A} \u{67E}\u{631}\u{646}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `In chi ti\u{1EBF}t`,
    "zh-hans": `\u{6253}\u{5370}\u{8BE6}\u{7EC6}\u{4FE1}\u{606F}`,
    "zh-hant": `\u{5217}\u{5370}\u{8A73}\u{7D30}\u{8CC7}\u{8A0A}`,
    en: `Print details`
};
const $2868cc1235412e16$export$a3e65ac984ddaa02 = {
    ar: (label)=>`${label} \u{645}\u{637}\u{644}\u{648}\u{628}\u{629}. \u{623}\u{62F}\u{62E}\u{644} \u{639}\u{646}\u{648}\u{627}\u{646} \u{627}\u{644}\u{634}\u{627}\u{631}\u{639} \u{648}\u{633}\u{64A}\u{62A}\u{645} \u{645}\u{644}\u{621} \u{627}\u{644}\u{628}\u{627}\u{642}\u{64A} \u{62A}\u{644}\u{642}\u{627}\u{626}\u{64A}\u{627}.`,
    de: (label)=>`${label} ist erforderlich. Geben Sie eine Adresse ein und der Rest wird automatisch ausgef\xfcllt.`,
    es: (label)=>`${label} . Ingrese una direcci\xf3n y el resto se completar\xe1 autom\xe1ticamente.`,
    fa: (label)=>`${label} \u{627}\u{644}\u{632}\u{627}\u{645}\u{6CC} \u{627}\u{633}\u{62A}. \u{622}\u{62F}\u{631}\u{633} \u{62E}\u{6CC}\u{627}\u{628}\u{627}\u{646} \u{631}\u{627} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{628}\u{642}\u{6CC}\u{647} \u{628}\u{647} \u{637}\u{648}\u{631} \u{62E}\u{648}\u{62F}\u{6A9}\u{627}\u{631} \u{67E}\u{631} \u{645}\u{6CC} \u{634}\u{648}\u{646}\u{62F}.`,
    fil: (label)=>`Kinakailangan ang ${label}. Magpasok ng isang address ng kalye at ang natitira ay awtomatikong punan.`,
    fr: (label)=>`${label} est requis. Entrez une adresse postale et le reste se remplira automatiquement.`,
    hi: (label)=>`${label} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948}\u{964} \u{90F}\u{915} \u{938}\u{921}\u{93C}\u{915} \u{915}\u{93E} \u{92A}\u{924}\u{93E} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{92C}\u{93E}\u{915}\u{940} \u{938}\u{94D}\u{935}\u{91A}\u{93E}\u{932}\u{93F}\u{924} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{92D}\u{930} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: (label)=>`${label} obligatwa. Antre nan yon adr\xe8s lari ak r\xe8s la ap ranpli nan otomatikman.`,
    it: (label)=>`${label} \xe8 obbligatorio. Inserisci un indirizzo e il resto verr\xe0 compilato automaticamente.`,
    ja: (label)=>`${label} \u{306F}\u{5FC5}\u{9808}\u{3067}\u{3059}\u{3002}\u{4F4F}\u{6240}\u{3092}\u{5165}\u{529B}\u{3059}\u{308B}\u{3068}\u{3001}\u{6B8B}\u{308A}\u{306F}\u{81EA}\u{52D5}\u{7684}\u{306B}\u{5165}\u{529B}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: (label)=>`${label} \u{B294} \u{D544}\u{C218}\u{C785}\u{B2C8}\u{B2E4}. \u{C8FC}\u{C18C}\u{B97C} \u{C785}\u{B825}\u{D558}\u{BA74} \u{B098}\u{BA38}\u{C9C0}\u{B294} \u{C790}\u{B3D9}\u{C73C}\u{B85C} \u{CC44}\u{C6CC}\u{C9D1}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} yuav tsum tau muaj. Sau ib txoj kev chaw nyob thiab tas yuav sau nyob rau hauv.`,
    ps: (label)=>`${label} \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC}. \u{62F} \u{6A9}\u{648}\u{685}\u{6D0} \u{67E}\u{62A}\u{647} \u{648}\u{644}\u{6CC}\u{6A9}\u{626} \u{627}\u{648} \u{67E}\u{627}\u{62A}\u{6D0} \u{628}\u{647} \u{67E}\u{647} \u{627}\u{62A}\u{648}\u{645}\u{627}\u{62A} \u{689}\u{648}\u{644} \u{689}\u{6A9} \u{634}\u{6CC}.`,
    pt: (label)=>`${label} \xe9 necess\xe1rio. Digite um endere\xe7o e o restante ser\xe1 preenchido automaticamente.`,
    "pt-pt": (label)=>`${label} \xe9 obrigat\xf3rio. Digite um endere\xe7o e o restante ser\xe1 preenchido automaticamente.`,
    ru: (label)=>`${label} . \u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43F}\u{43E}\u{447}\u{442}\u{43E}\u{432}\u{44B}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441}, \u{430} \u{43E}\u{441}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{441}\u{44F} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}.`,
    sm: (label)=>`E mana'omia le ${label}. Ulufale i se tuatusi auala ma o le a otometi lava ona fa'atumu le vaega o totoe.`,
    so: (label)=>`${label} ayaa loo baahan yahay. Ku qor cinwaanka wadada inta kalena si toos ah ayey u buuxinayaan.`,
    th: (label)=>`${label} \u{E1B}\u{E49}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E41}\u{E25}\u{E30}\u{E2A}\u{E48}\u{E27}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}\u{E08}\u{E30}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E42}\u{E14}\u{E22}\u{E2D}\u{E31}\u{E15}\u{E42}\u{E19}\u{E21}\u{E31}\u{E15}\u{E34}`,
    ur: (label)=>`${label} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{6D2}. \u{6AF}\u{644}\u{6CC} \u{6A9}\u{627} \u{67E}\u{62A}\u{6C1} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{628}\u{627}\u{642}\u{6CC} \u{62E}\u{648}\u{62F} \u{628}\u{62E}\u{648}\u{62F} \u{628}\u{6BE}\u{631} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627}\u{6D4}`,
    vi: (label)=>`${label} l\xe0 b\u{1EAF}t bu\u{1ED9}c. Nh\u{1EAD}p \u{111}\u{1ECB}a ch\u{1EC9} \u{111}\u{1B0}\u{1EDD}ng ph\u{1ED1} v\xe0 ph\u{1EA7}n c\xf2n l\u{1EA1}i s\u{1EBD} t\u{1EF1} \u{111}\u{1ED9}ng \u{111}i\u{1EC1}n.`,
    "zh-hans": (label)=>`${label} \u{662F}\u{5FC5}\u{9700}\u{7684}\u{3002}\u{8F93}\u{5165}\u{8857}\u{9053}\u{5730}\u{5740}\u{FF0C}\u{5176}\u{4F59}\u{5730}\u{5740}\u{5C06}\u{81EA}\u{52A8}\u{586B}\u{5199}\u{3002}`,
    "zh-hant": (label)=>`${label} \u{662F}\u{5FC5}\u{9700}\u{7684}\u{3002}\u{8F38}\u{5165}\u{8857}\u{9053}\u{5730}\u{5740}\u{FF0C}\u{5176}\u{9918}\u{4F4D}\u{5740}\u{5C07}\u{81EA}\u{52D5}\u{586B}\u{5BEB}\u{3002}`,
    en: (label)=>`${label} is required. Enter a street address and the rest will fill in automatically.`
};
const $2868cc1235412e16$export$80b56597ed9748d5 = {
    ar: `\u{635}\u{641}\u{62D}\u{629}`,
    de: `Seite`,
    es: `P\xe1gina`,
    fa: `\u{635}\u{641}\u{62D}\u{647}`,
    fil: `Pahina`,
    fr: `Page`,
    hi: `\u{92A}\u{943}\u{937}\u{94D}\u{920}`,
    ht: `Paj`,
    it: `Pagina`,
    ja: `\u{30DA}\u{30FC}\u{30B8}`,
    ko: `\u{D398}\u{C774}\u{C9C0}`,
    mww: `Phab`,
    ps: `\u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `P\xe1gina`,
    "pt-pt": `P\xe1gina`,
    ru: `\u{421}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{430}`,
    sm: `Itulau`,
    so: `sida`,
    th: `\u{E2B}\u{E19}\u{E49}\u{E32}`,
    ur: `\u{635}\u{641}\u{62D}\u{6C1}`,
    vi: `Trang`,
    "zh-hans": `\u{9875}`,
    "zh-hant": `\u{9801}`,
    en: `Page`
};
const $2868cc1235412e16$export$f0da3073951c1479 = {
    ar: (label)=>`"${label}" \u{645}\u{637}\u{644}\u{648}\u{628} \u{648}\u{64A}\u{62C}\u{628} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{642}\u{628}\u{644} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{62D}\u{627}\u{644}\u{629} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}. \u{627}\u{644}\u{62A}\u{631}\u{627}\u{62C}\u{639} \u{639}\u{646} \u{627}\u{644}\u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62D}\u{627}\u{644}\u{629}\u{60C} \u{627}\u{62D}\u{641}\u{638}\u{60C} \u{62B}\u{645} \u{623}\u{646}\u{634}\u{626} "${label}" \u{642}\u{628}\u{644} \u{645}\u{62D}\u{627}\u{648}\u{644}\u{629} \u{62A}\u{62D}\u{62F}\u{64A}\u{62B} \u{62D}\u{627}\u{644}\u{629} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}.`,
    de: (label)=>`Eine ${label}" ist erforderlich und muss erstellt werden, bevor der Status dieses Datensatzes aktualisiert werden kann. Machen Sie die Status\xe4nderung r\xfcckg\xe4ngig, speichern Sie sie und erstellen Sie dann "${label}", bevor Sie versuchen, den Status dieses Datensatzes zu aktualisieren.`,
    es: (label)=>`Se requiere una "${label}" y debe crearse antes de que se pueda actualizar el estado de este registro. Deshaga el cambio de estado, guarde y, a continuaci\xf3n, cree "${label}" antes de intentar actualizar el estado de este registro.`,
    fa: (label)=>`"${label} \u{628}\u{648}\u{62F}\u{646}" \u{645}\u{648}\u{631}\u{62F} \u{646}\u{6CC}\u{627}\u{632} \u{627}\u{633}\u{62A} \u{648} \u{628}\u{627}\u{6CC}\u{62F} \u{642}\u{628}\u{644} \u{627}\u{632} \u{628}\u{647} \u{631}\u{648}\u{632} \u{631}\u{633}\u{627}\u{646}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{648}\u{62F}. \u{642}\u{628}\u{644} \u{627}\u{632} \u{62A}\u{644}\u{627}\u{634} \u{628}\u{631}\u{627}\u{6CC} \u{628}\u{647} \u{631}\u{648}\u{632}\u{631}\u{633}\u{627}\u{646}\u{6CC} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F}\u{60C} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{648}\u{636}\u{639}\u{6CC}\u{62A} \u{631}\u{627} \u{644}\u{63A}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{630}\u{62E}\u{6CC}\u{631}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{633}\u{67E}\u{633} \xab${label} \u{628}\u{648}\u{62F}\u{646}\xbb \u{631}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (label)=>`Kinakailangan ang "${label}" at dapat likhain bago ma-update ang katayuan ng rekord na ito. I-undo ang pagbabago sa katayuan, i-save, pagkatapos ay lumikha ${label}" bago subukang i-update ang katayuan ng rekord na ito.`,
    fr: (label)=>`${label} \xbb est requise et doit \xeatre cr\xe9\xe9e avant que le statut de ce dossier puisse \xeatre mis \xe0 jour. Annulez la modification du statut, enregistrez, puis cr\xe9ez \xab ${label} \xbb avant de tenter de mettre \xe0 jour le statut de cet enregistrement.`,
    hi: (label)=>`"${label}" \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{939}\u{948} \u{914}\u{930} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{915}\u{94B} \u{905}\u{926}\u{94D}\u{92F}\u{924}\u{928} \u{915}\u{93F}\u{90F} \u{91C}\u{93E}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{91C}\u{93E}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{93F}\u{90F}\u{964} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{92E}\u{947}\u{902} \u{92A}\u{930}\u{93F}\u{935}\u{930}\u{94D}\u{924}\u{928} \u{92A}\u{942}\u{930}\u{94D}\u{935}\u{935}\u{924} \u{915}\u{930}\u{947}\u{902}, \u{938}\u{939}\u{947}\u{91C}\u{947}\u{902}, \u{92B}\u{93F}\u{930} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{940} \u{938}\u{94D}\u{925}\u{93F}\u{924}\u{93F} \u{915}\u{94B} \u{905}\u{92A}\u{921}\u{947}\u{91F} \u{915}\u{930}\u{928}\u{947} \u{915}\u{93E} \u{92A}\u{94D}\u{930}\u{92F}\u{93E}\u{938} \u{915}\u{930}\u{928}\u{947} \u{938}\u{947} \u{92A}\u{939}\u{932}\u{947} "${label}" \u{92C}\u{928}\u{93E}\u{90F}\u{902}\u{964}`,
    ht: (label)=>`"${label} epi yo dwe kreye anvan estati dosye sa a ka mete ajou. Def\xe8t chanjman nan estati, sove, L\xe8 sa a, kreye "${label}" anvan ou eseye mete ajou estati dosye sa a.`,
    it: (label)=>`La "${label}" \xe8 richiesta e deve essere creata prima che lo stato di questo record possa essere aggiornato. Annulla la modifica dello stato, salva, quindi crea "${label}" prima di tentare di aggiornare lo stato di questo record.`,
    ja: (label)=>`\u{300C}${label}\u{300D}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3042}\u{308A}\u{3001}\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306E}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{3092}\u{66F4}\u{65B0}\u{3059}\u{308B}\u{524D}\u{306B}\u{4F5C}\u{6210}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306E}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{3092}\u{66F4}\u{65B0}\u{3059}\u{308B}\u{524D}\u{306B}\u{3001}\u{30B9}\u{30C6}\u{30FC}\u{30BF}\u{30B9}\u{3078}\u{306E}\u{5909}\u{66F4}\u{3092}\u{5143}\u{306B}\u{623B}\u{3057}\u{3066}\u{4FDD}\u{5B58}\u{3057}\u{3001}\u{300C}${label}\u{300D}\u{3092}\u{4F5C}\u{6210}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: (label)=>`"${label}"\u{C774} \u{D544}\u{C694}\u{D558}\u{BA70} \u{C774} \u{B808}\u{CF54}\u{B4DC}\u{C758} \u{C0C1}\u{D0DC}\u{B97C} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{D558}\u{AE30} \u{C804}\u{C5D0} \u{C0DD}\u{C131}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}. \u{C0C1}\u{D0DC} \u{BCC0}\u{ACBD}\u{C744} \u{C2E4}\u{D589} \u{CDE8}\u{C18C}\u{D558}\u{ACE0} \u{C800}\u{C7A5}\u{D55C} \u{B2E4}\u{C74C} \u{C774} \u{B808}\u{CF54}\u{B4DC}\u{C758} \u{C0C1}\u{D0DC}\u{B97C} \u{C5C5}\u{B370}\u{C774}\u{D2B8}\u{D558}\u{AE30} \u{C804}\u{C5D0} "${label}"\u{C744} \u{B9CC}\u{B4ED}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`"${label}" yuav tsum muaj thiab yuav tsum tau tsim ua ntej raws li txoj cai ntawm daim ntawv no yuav muab kho dua. Undo hloov raws li txoj cai, txuag, ces tsim "${label}" ua ntej yuav sim hloov cov ntaub ntawv no raws li txoj cai.`,
    ps: (label)=>`"\u{62F} ${label} \u{6A9}\u{648}\u{644}" \u{627}\u{693}\u{6CC}\u{646} \u{62F}\u{6CC} \u{627}\u{648} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{647} \u{62F}\u{6D0} \u{686}\u{6D0} \u{62F} \u{62F}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62D}\u{627}\u{644}\u{62A} \u{62A}\u{627}\u{632}\u{647} \u{634}\u{6CC} \u{62C}\u{648}\u{693} \u{634}\u{6CC}. \u{62D}\u{627}\u{644}\u{62A} \u{62A}\u{647} \u{628}\u{62F}\u{644}\u{648}\u{646} \u{644}\u{63A}\u{648}\u{647} \u{6A9}\u{693}\u{626}\u{60C} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{693}\u{626}\u{60C} \u{628}\u{6CC}\u{627} \u{62F} \u{62F}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62F} \u{62D}\u{627}\u{644}\u{62A} \u{62F} \u{62A}\u{627}\u{632}\u{647} \u{6A9}\u{648}\u{644}\u{648} \u{647}\u{685}\u{647} \u{6A9}\u{648}\u{644}\u{648} \u{685}\u{62E}\u{647} \u{645}\u{62E}\u{6A9}\u{6D0} "${label} \u{6A9}\u{648}\u{644}" \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}.`,
    pt: (label)=>`${label}" \xe9 necess\xe1ria e deve ser criada antes que o status desse registro possa ser atualizado. Desfa\xe7a a altera\xe7\xe3o no status, salve e crie "${label}" antes de tentar atualizar o status desse registro.`,
    "pt-pt": (label)=>`A "${label}" \xe9 necess\xe1ria e deve ser criada antes que o status deste registro possa ser atualizado. Desfa\xe7a a altera\xe7\xe3o de status, salve e crie "${label}" antes de tentar atualizar o status deste registro.`,
    ru: (label)=>`${label}\xbb \u{44F}\u{432}\u{43B}\u{44F}\u{435}\u{442}\u{441}\u{44F} \u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{439} \u{438} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{430} \u{434}\u{43E} \u{442}\u{43E}\u{433}\u{43E}, \u{43A}\u{430}\u{43A} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}. \u{41E}\u{442}\u{43C}\u{435}\u{43D}\u{438}\u{442}\u{435} \u{438}\u{437}\u{43C}\u{435}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441}\u{430}, \u{441}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{435}, \u{430} \u{437}\u{430}\u{442}\u{435}\u{43C} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{439}\u{442}\u{435} \xab${label}\xbb, \u{43F}\u{440}\u{435}\u{436}\u{434}\u{435} \u{447}\u{435}\u{43C} \u{43F}\u{44B}\u{442}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43E}\u{431}\u{43D}\u{43E}\u{432}\u{438}\u{442}\u{44C} \u{441}\u{442}\u{430}\u{442}\u{443}\u{441} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438}.`,
    sm: (label)=>`E mana'omia le "${label}" ma e tatau ona fatuina a'o le'i mafai ona fa'afouina le tulaga o lenei fa'amaumauga. Faaleaogaina le suiga i le tulaga, sefe, ona fatu lea o le "${label} agavaa" a o lei taumafai e faafou le tulaga o lenei faamaumauga.`,
    so: (label)=>`"${label}" ayaa loo baahan yahay waana in la abuuraa ka hor inta aan xaaladda diiwaankaan la cusbooneysiin karin. Undo change to status, save, then create "${label}" ka hor inta aan la isku dayin in la cusboonaysiiyo xaaladda diiwaanka this ee.`,
    th: (label)=>`\u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35} "${label}" \u{E41}\u{E25}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E02}\u{E36}\u{E49}\u{E19}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E08}\u{E36}\u{E07}\u{E08}\u{E30}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E02}\u{E2D}\u{E07}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E19}\u{E35}\u{E49}\u{E44}\u{E14}\u{E49} \u{E40}\u{E25}\u{E34}\u{E01}\u{E17}\u{E4D}\u{E32}\u{E01}\u{E32}\u{E23}\u{E40}\u{E1B}\u{E25}\u{E35}\u{E48}\u{E22}\u{E19}\u{E41}\u{E1B}\u{E25}\u{E07}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30} \u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01} \u{E08}\u{E32}\u{E01}\u{E19}\u{E31}\u{E49}\u{E19}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07} "${label}" \u{E01}\u{E48}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E08}\u{E30}\u{E1E}\u{E22}\u{E32}\u{E22}\u{E32}\u{E21}\u{E2D}\u{E31}\u{E1B}\u{E40}\u{E14}\u{E15}\u{E2A}\u{E16}\u{E32}\u{E19}\u{E30}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}`,
    ur: (label)=>`"${label}" \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2} \u{627}\u{648}\u{631} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6CC} \u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A} \u{6A9}\u{648} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{627}\u{633}\u{6D2} \u{628}\u{646}\u{627}\u{646}\u{627} \u{636}\u{631}\u{648}\u{631}\u{6CC} \u{6C1}\u{6D2}\u{6D4} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{6CC} \u{62D}\u{6CC}\u{62B}\u{6CC}\u{62A} \u{6A9}\u{648} \u{627}\u{67E} \u{688}\u{6CC}\u{679} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{6A9}\u{648}\u{634}\u{634} \u{6A9}\u{631}\u{646}\u{6D2} \u{633}\u{6D2} \u{67E}\u{6C1}\u{644}\u{6D2} \u{627}\u{633}\u{679}\u{6CC}\u{679}\u{633} \u{645}\u{6CC}\u{6BA} \u{62A}\u{628}\u{62F}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648} \u{62E}\u{62A}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{60C} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{60C} \u{67E}\u{6BE}\u{631} "${label}" \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (label)=>`"${label}" l\xe0 b\u{1EAF}t bu\u{1ED9}c v\xe0 ph\u{1EA3}i \u{111}\u{1B0}\u{1EE3}c t\u{1EA1}o tr\u{1B0}\u{1EDB}c khi c\xf3 th\u{1EC3} c\u{1EAD}p nh\u{1EAD}t tr\u{1EA1}ng th\xe1i c\u{1EE7}a h\u{1ED3} s\u{1A1} n\xe0y. Ho\xe0n t\xe1c thay \u{111}\u{1ED5}i tr\u{1EA1}ng th\xe1i, l\u{1B0}u, sau \u{111}\xf3 t\u{1EA1}o "${label}" tr\u{1B0}\u{1EDB}c khi c\u{1ED1} g\u{1EAF}ng c\u{1EAD}p nh\u{1EAD}t tr\u{1EA1}ng th\xe1i c\u{1EE7}a b\u{1EA3}n ghi n\xe0y.`,
    "zh-hans": (label)=>`\u{201C}${label}\u{201D}\u{662F}\u{5FC5}\u{9700}\u{7684}\u{FF0C}\u{5E76}\u{4E14}\u{5FC5}\u{987B}\u{5728}\u{66F4}\u{65B0}\u{6B64}\u{8BB0}\u{5F55}\u{7684}\u{72B6}\u{6001}\u{4E4B}\u{524D}\u{521B}\u{5EFA}\u{3002}\u{64A4}\u{6D88}\u{5BF9}\u{72B6}\u{6001}\u{7684}\u{66F4}\u{6539}\u{FF0C}\u{4FDD}\u{5B58}\u{FF0C}\u{7136}\u{540E}\u{521B}\u{5EFA}\u{201C}${label}\u{201D}\u{FF0C}\u{7136}\u{540E}\u{518D}\u{5C1D}\u{8BD5}\u{66F4}\u{65B0}\u{6B64}\u{8BB0}\u{5F55}\u{7684}\u{72B6}\u{6001}\u{3002}`,
    "zh-hant": (label)=>`\u{201C}${label}\u{201D}\u{662F}\u{5FC5}\u{9700}\u{7684}\u{FF0C}\u{4E26}\u{4E14}\u{5FC5}\u{9808}\u{5728}\u{66F4}\u{65B0}\u{6B64}\u{8A18}\u{9304}\u{7684}\u{72C0}\u{614B}\u{4E4B}\u{524D}\u{5275}\u{5EFA}\u{3002}\u{64A4}\u{92B7}\u{5C0D}\u{72C0}\u{614B}\u{7684}\u{66F4}\u{6539}\u{FF0C}\u{4FDD}\u{5B58}\u{FF0C}\u{7136}\u{5F8C}\u{5275}\u{5EFA}\u{201C}${label}\u{201D}\u{FF0C}\u{7136}\u{5F8C}\u{518D}\u{5617}\u{8A66}\u{66F4}\u{65B0}\u{6B64}\u{8A18}\u{9304}\u{7684}\u{72C0}\u{614B}\u{3002}`,
    en: (label)=>`"${label}" is required and must be created before the status of this record can be updated. Undo change to status, save, then create "${label}" before attempting to update this record's status.`
};
const $2868cc1235412e16$export$e57aa8d203496d61 = {
    ar: (label)=>`${label} \u{645}\u{624}\u{633}\u{633}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{64A}\u{645}\u{643}\u{646}\u{647}\u{627} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629}`,
    de: (label)=>`${label} weitere Organisationen haben Zugriff per Einwilligung`,
    es: (label)=>`${label} organizaciones m\xe1s tienen acceso a trav\xe9s del consentimiento`,
    fa: (label)=>`${label} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{6CC}\u{6AF}\u{631} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{62F}\u{627}\u{631}\u{646}\u{62F}`,
    fil: (label)=>`${label} higit pang mga organisasyon ang may access sa pamamagitan ng pahintulot`,
    fr: (label)=>`${label} autres organisations ont acc\xe8s via le consentement`,
    hi: (label)=>`${label} \u{914}\u{930} \u{938}\u{902}\u{917}\u{920}\u{928}\u{94B}\u{902} \u{915}\u{940} \u{938}\u{939}\u{92E}\u{924}\u{93F} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{902}\u{91A} \u{939}\u{948}`,
    ht: (label)=>`${label} plis \xf2ganizasyon gen aks\xe8 atrav\xe8 konsantman`,
    it: (label)=>`Altre ${label} organizzazioni hanno accesso tramite consenso`,
    ja: (label)=>`\u{3055}\u{3089}\u{306B}${label}\u{306E}\u{7D44}\u{7E54}\u{304C}\u{540C}\u{610F}\u{306B}\u{3088}\u{3063}\u{3066}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3067}\u{304D}\u{307E}\u{3059}`,
    ko: (label)=>`${label} \u{AC1C} \u{C774}\u{C0C1}\u{C758} \u{C870}\u{C9C1}\u{C774} \u{B3D9}\u{C758}\u{B97C} \u{D1B5}\u{D574} \u{C561}\u{C138}\u{C2A4}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (label)=>`${label} ntau lub koom haum tau saib ntawm kev tso cai`,
    ps: (label)=>`${label} \u{646}\u{648}\u{631} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647} \u{62F} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{631}\u{6CC}`,
    pt: (label)=>`${label} organiza\xe7\xf5es t\xeam acesso via consentimento`,
    "pt-pt": (label)=>`${label} organiza\xe7\xf5es t\xeam acesso via consentimento`,
    ru: (label)=>`${label} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{439} \u{438}\u{43C}\u{435}\u{44E}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{447}\u{435}\u{440}\u{435}\u{437} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{435}`,
    sm: (label)=>`${label} isi fa'alapotopotoga e mafai ona maua e ala i le maliega`,
    so: (label)=>`${label} urur oo dheeraad ah ayaa ku hela helitaanka ogolaansho`,
    th: (label)=>`\u{E2D}\u{E35}\u{E01} ${label} \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E21}\u{E35}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: (label)=>`${label} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{648}\u{6BA} \u{6A9}\u{648} \u{631}\u{636}\u{627}\u{645}\u{646}\u{62F}\u{6CC} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6C1}\u{6D2}`,
    vi: (label)=>`${label} t\u{1ED5} ch\u{1EE9}c c\xf3 quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua s\u{1EF1} \u{111}\u{1ED3}ng \xfd`,
    "zh-hans": (label)=>`\u{53E6}\u{6709} ${label} \u{4E2A}\u{7EC4}\u{7EC7}\u{53EF}\u{4EE5}\u{901A}\u{8FC7}\u{540C}\u{610F}\u{8FDB}\u{884C}\u{8BBF}\u{95EE}`,
    "zh-hant": (label)=>`\u{53E6}\u{6709}${label}\u{500B}\u{7D44}\u{7E54}\u{53EF}\u{4EE5}\u{901A}\u{904E}\u{540C}\u{610F}\u{9032}\u{884C}\u{8A2A}\u{554F}`,
    en: (label)=>`${label} more organizations have access via consent`
};
const $2868cc1235412e16$export$894700ab5cf52639 = {
    ar: `1 \u{645}\u{624}\u{633}\u{633}\u{629} \u{623}\u{62E}\u{631}\u{649} \u{644}\u{62F}\u{64A}\u{647}\u{627} \u{62D}\u{642} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{639}\u{646} \u{637}\u{631}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{648}\u{627}\u{641}\u{642}\u{629}`,
    de: `1 weitere Organisation hat Zugriff per Einwilligung`,
    es: `1 organizaci\xf3n m\xe1s tiene acceso a trav\xe9s del consentimiento`,
    fa: `1 \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{6CC}\u{6AF}\u{631} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{62F}\u{627}\u{631}\u{62F}`,
    fil: `1 higit pang organisasyon ang may access sa pamamagitan ng pahintulot`,
    fr: `1 organisation de plus a acc\xe8s via le consentement`,
    hi: `1 \u{914}\u{930} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{92A}\u{93E}\u{938} \u{938}\u{939}\u{92E}\u{924}\u{93F} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92A}\u{939}\u{941}\u{902}\u{91A} \u{939}\u{948}`,
    ht: `1 plis \xf2ganizasyon gen aks\xe8 atrav\xe8 konsantman`,
    it: `1 altra organizzazione ha accesso tramite consenso`,
    ja: `\u{3055}\u{3089}\u{306B} 1 \u{3064}\u{306E}\u{7D44}\u{7E54}\u{304C}\u{540C}\u{610F}\u{306B}\u{3088}\u{3063}\u{3066}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3067}\u{304D}\u{307E}\u{3059}`,
    ko: `1\u{AC1C} \u{C774}\u{C0C1}\u{C758} \u{C870}\u{C9C1}\u{C774} \u{B3D9}\u{C758}\u{B97C} \u{D1B5}\u{D574} \u{C561}\u{C138}\u{C2A4}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `1 ntau lub koom haum tau saib ntawm kev tso cai`,
    ps: `1 \u{646}\u{648}\u{631} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F} \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{644}\u{631}\u{6CC}`,
    pt: `Mais 1 organiza\xe7\xe3o tem acesso via consentimento`,
    "pt-pt": `Mais 1 organiza\xe7\xe3o tem acesso via consentimento`,
    ru: `1 \u{415}\u{449}\u{435} \u{43E}\u{434}\u{43D}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{438}\u{43C}\u{435}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{447}\u{435}\u{440}\u{435}\u{437} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{438}\u{435}`,
    sm: `1 isi fa'alapotopotoga e mafai ona fa'aaogaina e ala i le maliega`,
    so: `1 urur dheeraad ah ayaa helitaanka via ogolaansho`,
    th: `\u{E2D}\u{E35}\u{E01} 1 \u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E21}\u{E35}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E34}\u{E19}\u{E22}\u{E2D}\u{E21}`,
    ur: `1 \u{645}\u{632}\u{6CC}\u{62F} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{648} \u{631}\u{636}\u{627}\u{645}\u{646}\u{62F}\u{6CC} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6C1}\u{6D2}`,
    vi: `Th\xeam 1 t\u{1ED5} ch\u{1EE9}c c\xf3 quy\u{1EC1}n truy c\u{1EAD}p th\xf4ng qua s\u{1EF1} \u{111}\u{1ED3}ng \xfd`,
    "zh-hans": `\u{53E6}\u{5916} 1 \u{4E2A}\u{7EC4}\u{7EC7}\u{53EF}\u{4EE5}\u{901A}\u{8FC7}\u{540C}\u{610F}\u{8FDB}\u{884C}\u{8BBF}\u{95EE}`,
    "zh-hant": `\u{53E6}\u{5916}1\u{500B}\u{7D44}\u{7E54}\u{53EF}\u{4EE5}\u{901A}\u{904E}\u{540C}\u{610F}\u{9032}\u{884C}\u{8A2A}\u{554F}`,
    en: `1 more organization has access via consent`
};
const $2868cc1235412e16$export$3a9d0270e8a39565 = {
    ar: `\u{645}\u{648}\u{642}\u{639}`,
    de: `Platz`,
    es: `Sitio`,
    fa: `\u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Email Address *`,
    fr: `Site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F}`,
    ht: `Sit konpl\xe8ks`,
    it: `Sito`,
    ja: `\u{6577}\u{5730}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8}`,
    mww: `Qhov Chaw Kawm Ntawv`,
    ps: `\u{633}\u{627}\u{6CC}\u{67C}`,
    pt: `Local`,
    "pt-pt": `S\xedtio`,
    ru: `\u{41C}\u{435}\u{441}\u{442}\u{43E}`,
    sm: `Nofoaga`,
    so: `Site`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{633}\u{627}\u{626}\u{679}`,
    vi: `Site`,
    "zh-hans": `\u{7F51}\u{7AD9}`,
    "zh-hant": `\u{7DB2}\u{7AD9}`,
    en: `Site`
};
const $2868cc1235412e16$export$47be4670711d8c15 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639}`,
    de: `Lagen`,
    es: `Sitios`,
    fa: `\u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Mga Site`,
    fr: `Sites`,
    hi: `\u{938}\u{93E}\u{907}\u{91F}\u{94B}\u{902}`,
    ht: `Sit`,
    it: `Siti`,
    ja: `\u{30B5}\u{30A4}\u{30C8}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8}`,
    mww: `Tej Chaw`,
    ps: `\u{633}\u{627}\u{6CC}\u{67C}\u{648}\u{646}\u{647}`,
    pt: `Sites`,
    "pt-pt": `S\xedtios`,
    ru: `\u{421}\u{430}\u{439}\u{442}\u{43E}\u{432}`,
    sm: `Nofoaga`,
    so: `Goobaha`,
    th: `\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{633}\u{627}\u{626}\u{679}\u{633}`,
    vi: `Trang web`,
    "zh-hans": `\u{7F51}\u{7AD9}`,
    "zh-hant": `\u{7DB2}\u{7AD9}`,
    en: `Sites`
};
const $2868cc1235412e16$export$f0481c89dafc20ec = {
    ar: `\u{625}\u{636}\u{627}\u{641}\u{629} \u{645}\u{648}\u{642}\u{639}`,
    de: `Website hinzuf\xfcgen`,
    es: `Agregar sitio`,
    fa: `\u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{631}\u{62F}\u{646} \u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Email Address *`,
    fr: `Ajouter un site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute sit`,
    it: `Aggiungi sito`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{3092}\u{8FFD}\u{52A0}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8} \u{CD94}\u{AC00}`,
    mww: `Ntxiv qhov chaw`,
    ps: `\u{648}\u{6CC}\u{628} \u{67E}\u{627}\u{6BC}\u{647} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Adicionar site`,
    "pt-pt": `Adicionar site`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{441}\u{430}\u{439}\u{442}`,
    sm: `Fa'aopopo le 'upega tafa'ilagi`,
    so: `Add site`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{633}\u{627}\u{626}\u{679} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam trang web`,
    "zh-hans": `\u{6DFB}\u{52A0}\u{7AD9}\u{70B9}`,
    "zh-hant": `\u{6DFB}\u{52A0}\u{7DB2}\u{7AD9}`,
    en: `Add site`
};
const $2868cc1235412e16$export$70f2a6d0b7f693e7 = {
    ar: `\u{625}\u{632}\u{627}\u{644}\u{629} \u{627}\u{644}\u{645}\u{648}\u{642}\u{639}`,
    de: `Website entfernen`,
    es: `Eliminar sitio`,
    fa: `\u{628}\u{631}\u{62F}\u{627}\u{634}\u{62A}\u{646} \u{633}\u{627}\u{6CC}\u{62A}`,
    fil: `Tanggalin ang site`,
    fr: `Supprimer le site`,
    hi: `\u{938}\u{93E}\u{907}\u{91F} \u{928}\u{93F}\u{915}\u{93E}\u{932}\u{947}\u{902}`,
    ht: `Retire sit`,
    it: `Rimuovi sito`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{3092}\u{524A}\u{9664}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8} \u{C0AD}\u{C81C}`,
    mww: `Tshem tawm qhov chaw`,
    ps: `\u{62F} \u{633}\u{627}\u{6CC}\u{67C} \u{644}\u{631}\u{6D0} \u{6A9}\u{648}\u{644}`,
    pt: `Remover site`,
    "pt-pt": `Remover site`,
    ru: `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{441}\u{430}\u{439}\u{442}`,
    sm: `Aveese le saite`,
    so: `saar site`,
    th: `\u{E25}\u{E1A}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{633}\u{627}\u{626}\u{679} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xf3a trang web`,
    "zh-hans": `\u{5220}\u{9664}\u{7AD9}\u{70B9}`,
    "zh-hant": `\u{522A}\u{9664}\u{7DB2}\u{7AD9}`,
    en: `Remove site`
};
const $2868cc1235412e16$export$f1da8d88446217e5 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{645}\u{648}\u{627}\u{642}\u{639}`,
    de: `Es gibt keine Seiten`,
    es: `No hay sitios`,
    fa: `\u{647}\u{6CC}\u{686} \u{633}\u{627}\u{6CC}\u{62A}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang mga site`,
    fr: `Il n\u{2019}y a pas de sites`,
    hi: `\u{915}\u{94B}\u{908} \u{938}\u{93E}\u{907}\u{91F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}`,
    ht: `Pa gen okenn sit`,
    it: `Non ci sono siti`,
    ja: `\u{30B5}\u{30A4}\u{30C8}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C0AC}\u{C774}\u{D2B8}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj chaw`,
    ps: `\u{647}\u{6CC}\u{685} \u{633}\u{627}\u{6CC}\u{67C}\u{648}\u{646}\u{647} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 sites`,
    "pt-pt": `N\xe3o existem sites`,
    ru: `\u{421}\u{430}\u{439}\u{442}\u{43E}\u{432} \u{43D}\u{435}\u{442}`,
    sm: `E leai ni nofoaga`,
    so: `Ma jiraan goobo`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E40}\u{E27}\u{E47}\u{E1A}\u{E44}\u{E0B}\u{E15}\u{E4C}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{627}\u{626}\u{679}\u{633} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 trang web`,
    "zh-hans": `\u{6CA1}\u{6709}\u{7F51}\u{7AD9}`,
    "zh-hant": `\u{6C92}\u{6709}\u{7DB2}\u{7AD9}`,
    en: `There are no sites`
};
const $2868cc1235412e16$export$ed143b7c52257e6c = {
    ar: `\u{627}\u{644}\u{647}\u{648}\u{64A}\u{629} \u{627}\u{644}\u{62C}\u{646}\u{633}\u{64A}\u{629}`,
    de: `Geschlechtsidentit\xe4t`,
    es: `Identidad de g\xe9nero`,
    fa: `\u{647}\u{648}\u{6CC}\u{62A} \u{62C}\u{646}\u{633}\u{6CC}\u{62A}\u{6CC}`,
    fil: `Pagkakakilanlan ng kasarian`,
    fr: `Identit\xe9 sexuelle`,
    hi: `\u{932}\u{93F}\u{902}\u{917} \u{92A}\u{939}\u{91A}\u{93E}\u{928}`,
    ht: `Idantite seksy\xe8l`,
    it: `Identit\xe0 di genere`,
    ja: `\u{81EA}\u{8A8D}`,
    ko: `\u{C131} \u{C815}\u{CCB4}\u{C131}`,
    mww: `Yog leejtwg tiag`,
    ps: `\u{62C}\u{646}\u{633}\u{6CC}\u{62A}\u{6CC} \u{647}\u{648}\u{6CC}\u{62A}`,
    pt: `Identidade de g\xeanero`,
    "pt-pt": `Identidade de g\xe9nero`,
    ru: `\u{413}\u{435}\u{43D}\u{434}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{438}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Fa'asinomaga o itupa`,
    so: `Aqoonsiga jinsiga`,
    th: `\u{E2D}\u{E31}\u{E15}\u{E25}\u{E31}\u{E01}\u{E29}\u{E13}\u{E4C}\u{E17}\u{E32}\u{E07}\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{635}\u{646}\u{641}\u{6CC} \u{634}\u{646}\u{627}\u{62E}\u{62A}`,
    vi: `B\u{1EA3}n d\u{1EA1}ng gi\u{1EDB}i`,
    "zh-hans": `\u{6027}\u{522B}\u{8BA4}\u{540C}`,
    "zh-hant": `\u{6027}\u{5225}\u{8A8D}\u{540C}`,
    en: `Gender identity`
};
const $2868cc1235412e16$export$58faafdea4528c0c = {
    ar: `\u{627}\u{644}\u{641}\u{648}\u{627}\u{62A}\u{64A}\u{631}`,
    de: `Abrechnung`,
    es: `Facturaci\xf3n`,
    fa: `\u{635}\u{62F}\u{648}\u{631} \u{635}\u{648}\u{631}\u{62A} \u{62D}\u{633}\u{627}\u{628}`,
    fil: `Email Address *`,
    fr: `Facturation`,
    hi: `\u{92C}\u{93F}\u{932}\u{93F}\u{902}\u{917}`,
    ht: `Fakti`,
    it: `Fatturazione`,
    ja: `\u{8ACB}\u{6C42}`,
    ko: `\u{ACFC}\u{AE08}`,
    mww: `Billing`,
    ps: `\u{628}\u{644}\u{646}\u{6AB}`,
    pt: `Faturamento`,
    "pt-pt": `Fatura\xe7\xe3o`,
    ru: `\u{412}\u{44B}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{441}\u{447}\u{435}\u{442}\u{43E}\u{432}`,
    sm: `Pili`,
    so: `Billing`,
    th: `\u{E40}\u{E23}\u{E35}\u{E22}\u{E01} \u{E40}\u{E01}\u{E47}\u{E1A} \u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `Billing`,
    vi: `Thanh to\xe1n`,
    "zh-hans": `\u{8BA1}\u{8D39}`,
    "zh-hant": `\u{8A08}\u{8CBB}`,
    en: `Billing`
};
const $2868cc1235412e16$export$3bd695ac39288245 = {
    ar: `\u{627}\u{62F}\u{627}\u{631}\u{64A}`,
    de: `Administrativ`,
    es: `Administrativo`,
    fa: `\u{627}\u{62F}\u{627}\u{631}\u{6CC}`,
    fil: `Administratibo`,
    fr: `Administratif`,
    hi: `\u{938}\u{902}\u{91A}\u{93E}\u{932}\u{928}-\u{938}\u{902}\u{92C}\u{902}\u{927}\u{940}`,
    ht: `Administratif`,
    it: `Amministrativo`,
    ja: `\u{884C}\u{653F}`,
    ko: `\u{D589}\u{C815}\u{C0C1}\u{C758}`,
    mww: `Administrative Administrative`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Administrativo`,
    "pt-pt": `Administrativo`,
    ru: `\u{410}\u{434}\u{43C}\u{438}\u{43D}\u{438}\u{441}\u{442}\u{440}\u{430}\u{442}\u{438}\u{432}\u{43D}\u{44B}\u{439}`,
    sm: `Pulega`,
    so: `administrative`,
    th: `\u{E14}\u{E39}\u{E41}\u{E25}`,
    ur: `\u{627}\u{646}\u{62A}\u{638}\u{627}\u{645}\u{6CC}`,
    vi: `Qu\u{1EA3}n tr\u{1ECB}`,
    "zh-hans": `\u{884C}\u{653F}`,
    "zh-hant": `\u{884C}\u{653F}`,
    en: `Administrative`
};
const $2868cc1235412e16$export$66ac5ac68c1dcca4 = {
    ar: `\u{627}\u{644}\u{645}\u{648}\u{627}\u{631}\u{62F} \u{627}\u{644}\u{628}\u{634}\u{631}\u{64A}\u{629}`,
    de: `Personalabteilung`,
    es: `Recursos humanos`,
    fa: `\u{645}\u{646}\u{627}\u{628}\u{639} \u{627}\u{646}\u{633}\u{627}\u{646}\u{6CC}`,
    fil: `Mga mapagkukunan ng tao`,
    fr: `Ressources humaines`,
    hi: `\u{92E}\u{93E}\u{928}\u{935} \u{938}\u{902}\u{938}\u{93E}\u{927}\u{928}`,
    ht: `Resous imen`,
    it: `Risorse umane`,
    ja: `\u{4EBA}\u{7684}\u{8CC7}\u{6E90}`,
    ko: `\u{C778}\u{C0AC}`,
    mww: `Tib neeg cov chaw muab kev pab`,
    ps: `\u{628}\u{634}\u{631}\u{6CC} \u{681}\u{648}\u{627}\u{6A9}`,
    pt: `Recursos humanos`,
    "pt-pt": `Recursos humanos`,
    ru: `\u{423}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435} \u{43F}\u{435}\u{440}\u{441}\u{43E}\u{43D}\u{430}\u{43B}\u{43E}\u{43C}`,
    sm: `Punaoa a tagata`,
    so: `Human resources`,
    th: `\u{E17}\u{E23}\u{E31}\u{E1E}\u{E22}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{627}\u{646}\u{633}\u{627}\u{646}\u{6CC} \u{648}\u{633}\u{627}\u{626}\u{644}`,
    vi: `Ngu\u{1ED3}n nh\xe2n l\u{1EF1}c`,
    "zh-hans": `\u{4EBA}\u{529B}\u{8D44}\u{6E90}`,
    "zh-hant": `\u{4EBA}\u{529B}\u{8CC7}\u{6E90}`,
    en: `Human resources`
};
const $2868cc1235412e16$export$2cea9b5b0a64eca3 = {
    ar: `\u{627}\u{644}\u{62F}\u{627}\u{641}\u{639}`,
    de: `Kostentr\xe4ger`,
    es: `Pagador`,
    fa: `Payor`,
    fil: `Nagbabayad`,
    fr: `Payeur`,
    hi: `\u{92D}\u{941}\u{917}\u{924}\u{93E}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Pey\xe8`,
    it: `Pagatore`,
    ja: `\u{652F}\u{6255}\u{4EBA}`,
    ko: `Payor (\u{C9C0}\u{AE09}\u{C778})`,
    mww: `Them`,
    ps: `\u{62A}\u{627}\u{62F}\u{6CC}\u{647} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Pagador`,
    "pt-pt": `Pagador`,
    ru: `\u{41F}\u{43B}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{449}\u{438}\u{43A}`,
    sm: `Tagata totogi`,
    so: `Payor`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E08}\u{E48}\u{E32}\u{E22}\u{E40}\u{E07}\u{E34}\u{E19}`,
    ur: `Payor`,
    vi: `Ng\u{1B0}\u{1EDD}i thanh to\xe1n`,
    "zh-hans": `\u{4ED8}\u{6B3E}\u{4EBA}`,
    "zh-hant": `\u{4ED8}\u{6B3E}\u{4EBA}`,
    en: `Payor`
};
const $2868cc1235412e16$export$ab57077c7aa64ad3 = {
    ar: `\u{627}\u{644}\u{639}\u{645}\u{644}\u{627}\u{621}`,
    de: `Klienten`,
    es: `Clientes`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6CC}\u{627}\u{646}`,
    fil: `Mga kliyente`,
    fr: `Client\xe8le`,
    hi: `\u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}\u{94B}\u{902}`,
    ht: `Kliyan yo`,
    it: `Clienti`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}`,
    ko: `\u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}`,
    mww: `Cov neeg tau txais kev`,
    ps: `\u{645}\u{631}\u{627}\u{62C}\u{639}\u{6CC}\u{646}`,
    pt: `Clientes`,
    "pt-pt": `Clientes`,
    ru: `\u{41A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
    sm: `Tagata fa'atau`,
    so: `Macaamiisha`,
    th: `\u{E44}\u{E04}\u{E25} \u{E40}\u{E2D}\u{E19}\u{E15}\u{E4C}`,
    ur: `\u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679}\u{633}`,
    vi: `Kh\xe1ch h\xe0ng`,
    "zh-hans": `\u{5BA2}\u{6237}`,
    "zh-hant": `\u{5BA2}\u{6236}`,
    en: `Clients`
};
const $2868cc1235412e16$export$f8432d94cae4776c = {
    ar: `\u{643}\u{628}\u{633}`,
    de: `Presse`,
    es: `Prensa`,
    fa: `\u{645}\u{637}\u{628}\u{648}\u{639}\u{627}\u{62A}`,
    fil: `Pindutin`,
    fr: `Presser`,
    hi: `\u{926}\u{92C}\u{93E}\u{928}\u{93E}`,
    ht: `Pr\xe8s`,
    it: `Passeggiata`,
    ja: `\u{62BC}\u{3059}`,
    ko: `\u{B204}\u{B974}\u{B2E4}`,
    mww: `xovxwm`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Imprensa`,
    "pt-pt": `Imprensa`,
    ru: `\u{414}\u{430}\u{432}\u{438}\u{442}\u{44C}`,
    sm: `Fa'asalalau`,
    so: `Press`,
    th: `\u{E01}\u{E14}`,
    ur: `\u{62F}\u{628}\u{627}\u{646}\u{627}`,
    vi: `B\xe1o ch\xed`,
    "zh-hans": `\u{538B}`,
    "zh-hant": `\u{58D3}`,
    en: `Press`
};
const $2868cc1235412e16$export$57bf9fa377c63d51 = {
    ar: (membersHref)=>$2868cc1235412e16$var$html`سجل جهات الاتصال الإدارية والفوترة وأنواع أخرى من جهات الاتصال. استخدم <a class="Link--secondary text-bold" href="${membersHref}">قسم الأعضاء</a> لإضافة مستخدمين إلى مؤسستك.`,
    de: (membersHref)=>$2868cc1235412e16$var$html`Erfassen Sie Verwaltungs-, Abrechnungs- und andere Arten von Kontakten. Verwenden Sie den <a class="Link--secondary text-bold" href="${membersHref}">Abschnitt Mitglieder,</a> um Benutzer zu Ihrer Organisation hinzuzufügen.`,
    es: (membersHref)=>$2868cc1235412e16$var$html`Registre los contactos administrativos, de facturación y de otro tipo. Use la <a class="Link--secondary text-bold" href="${membersHref}">sección de miembros</a> para agregar usuarios a su organización.`,
    fa: (membersHref)=>$2868cc1235412e16$var$html`مخاطبین اداری، صورتحساب و سایر مخاطبین را ضبط کنید. از <a class="Link--secondary text-bold" href="${membersHref}">بخش اعضا</a> برای افزودن کاربران به سازمان خود استفاده کنید.`,
    fil: (membersHref)=>$2868cc1235412e16$var$html`I-record ang mga administratibo, pagsingil, at iba pang mga uri ng mga contact. Gamitin ang <a class="Link--secondary text-bold" href="${membersHref}">seksyon ng mga miyembro</a> upang magdagdag ng mga gumagamit sa iyong samahan.`,
    fr: (membersHref)=>$2868cc1235412e16$var$html`Enregistrez les contacts administratifs, de facturation et autres. Utilisez la <a class="Link--secondary text-bold" href="${membersHref}">section des membres</a> pour ajouter des utilisateurs à votre organisation.`,
    hi: (membersHref)=>$2868cc1235412e16$var$html`व्यवस्थापक, बिलिंग और अन्य प्रकार के संपर्कों को रिकॉर्ड करें. अपने संगठन में उपयोगकर्ताओं को जोड़ने के लिए <a class="Link--secondary text-bold" href="${membersHref}">सदस्य अनुभाग</a> का उपयोग करें.`,
    ht: (membersHref)=>$2868cc1235412e16$var$html`Dosye administratif, bòdwo, ak lòt kalite kontak. Sèvi ak <a class="Link--secondary text-bold" href="${membersHref}">seksyon manm yo</a> pou ajoute itilizatè yo nan òganizasyon w lan.`,
    it: (membersHref)=>$2868cc1235412e16$var$html`Registra contatti amministrativi, di fatturazione e di altro tipo. Utilizza la <a class="Link--secondary text-bold" href="${membersHref}">sezione membri</a> per aggiungere utenti alla tua organizzazione.`,
    ja: (membersHref)=>$2868cc1235412e16$var$html`管理、請求、およびその他の種類の連絡先を記録します。 <a class="Link--secondary text-bold" href="${membersHref}">メンバー セクション</a> を使用して、組織にユーザーを追加します。`,
    ko: (membersHref)=>$2868cc1235412e16$var$html`관리, 청구 및 기타 유형의 연락처를 기록합니다. <a class="Link--secondary text-bold" href="${membersHref}">구성원 섹션을</a> 사용하여 조직에 사용자를 추가합니다.`,
    mww: (membersHref)=>$2868cc1235412e16$var$html`Cov ntaub ntawv administrative, billing, thiab lwm hom kev sib cuag. Siv cov <a class="Link--secondary text-bold" href="${membersHref}">tswv cuab</a> ntxiv rau koj lub koom haum.`,
    ps: (membersHref)=>$2868cc1235412e16$var$html`اداری ، بیلنګ ، او د اړیکو نور ډولونه ریکارډ کړئ. د <a class="Link--secondary text-bold" href="${membersHref}">غړو برخه</a> وکاروئ ترڅو خپل سازمان ته کاروونکی اضافه کړئ.`,
    pt: (membersHref)=>$2868cc1235412e16$var$html`Registre contatos administrativos, de cobrança e outros tipos de contatos. Use a <a class="Link--secondary text-bold" href="${membersHref}">seção de membros</a> para adicionar usuários à sua organização.`,
    "pt-pt": (membersHref)=>$2868cc1235412e16$var$html`Registre contatos administrativos, de cobrança e outros tipos de contatos. Use a <a class="Link--secondary text-bold" href="${membersHref}">seção de membros</a> para adicionar usuários à sua organização.`,
    ru: (membersHref)=>$2868cc1235412e16$var$html`Записывайте административные, биллинговые и другие типы контактов. Используйте <a class="Link--secondary text-bold" href="${membersHref}">раздел участники</a> для добавления пользователей в свою организацию.`,
    sm: (membersHref)=>$2868cc1235412e16$var$html`Faamaumau faamaumauga o le pulega, pili, ma isi ituaiga o fesootaiga. Faaaoga le vaega o tagata <a class="Link--secondary text-bold" href="${membersHref}">o le ekalesia</a> e faaopoopo ai tagata faaaoga i lau faalapotopotoga.`,
    so: (membersHref)=>$2868cc1235412e16$var$html`Record maamulka, biilasha, iyo noocyada kale ee xiriirada. Isticmaal <a class="Link--secondary text-bold" href="${membersHref}">qaybta xubnaha</a> si aad ugu darto dadka isticmaala ururkaaga.`,
    th: (membersHref)=>$2868cc1235412e16$var$html`บันทึกผู้ติดต่อด้านการดูแลระบบ การเรียกเก็บเงิน และประเภทอื่นๆ ใช้ <a class="Link--secondary text-bold" href="${membersHref}">ส่วนสมาชิก</a> เพื่อเพิ่มผู้ใช้ในองค์กรของคุณ`,
    ur: (membersHref)=>$2868cc1235412e16$var$html`انتظامی ، بلنگ ، اور دیگر قسم کے رابطوں کو ریکارڈ کریں۔ صارفین کو اپنی تنظیم میں شامل کرنے کے لئے <a class="Link--secondary text-bold" href="${membersHref}">ممبرز سیکشن</a> کا استعمال کریں۔`,
    vi: (membersHref)=>$2868cc1235412e16$var$html`Ghi lại các loại liên hệ quản trị, thanh toán và các loại liên hệ khác. Sử dụng <a class="Link--secondary text-bold" href="${membersHref}">phần thành viên</a> để thêm người dùng vào tổ chức của bạn.`,
    "zh-hans": (membersHref)=>$2868cc1235412e16$var$html`记录管理、计费和其他类型的联系人。使用 <a class="Link--secondary text-bold" href="${membersHref}">members 部分</a> 将用户添加到您的组织。`,
    "zh-hant": (membersHref)=>$2868cc1235412e16$var$html`記錄管理、計費和其他類型的聯繫人。使用 <a class="Link--secondary text-bold" href="${membersHref}">members 部分</a> 將使用者添加到您的組織。`,
    en: (membersHref)=>$2868cc1235412e16$var$html`Record administrative, billing, and other types of contacts. Use the <a class="Link--secondary text-bold" href="${membersHref}">members section</a> to add users to your organization.`
};
const $2868cc1235412e16$export$979ca5d8ff2b59d0 = {
    ar: `\u{633}\u{62C}\u{644} \u{627}\u{633}\u{645} \u{627}\u{644}\u{645}\u{648}\u{627}\u{642}\u{639} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{639}\u{645}\u{644} \u{641}\u{64A}\u{647}\u{627} \u{645}\u{624}\u{633}\u{633}\u{62A}\u{643} \u{648}\u{631}\u{642}\u{645} \u{647}\u{627}\u{62A}\u{641}\u{647}\u{627} \u{648}\u{639}\u{646}\u{648}\u{627}\u{646}\u{647}\u{627}.`,
    de: `Notieren Sie sich den Namen, die Telefonnummer und die Adresse der Websites, an denen Ihre Organisation t\xe4tig ist.`,
    es: `Registre el nombre, el n\xfamero de tel\xe9fono y la direcci\xf3n de los sitios en los que opera su organizaci\xf3n.`,
    fa: `\u{646}\u{627}\u{645}\u{60C} \u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646} \u{648} \u{622}\u{62F}\u{631}\u{633} \u{633}\u{627}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC}\u{6CC} \u{631}\u{627} \u{6A9}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{62F}\u{631} \u{622}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F} \u{62B}\u{628}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Itala ang pangalan, numero ng telepono, at address ng mga site kung saan nagpapatakbo ang iyong samahan.`,
    fr: `Notez le nom, le num\xe9ro de t\xe9l\xe9phone et l\u{2019}adresse des sites o\xf9 votre organisation exerce ses activit\xe9s.`,
    hi: `\u{909}\u{928} \u{938}\u{93E}\u{907}\u{91F}\u{94D}\u{938} \u{915}\u{93E} \u{928}\u{93E}\u{92E}, \u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{902}\u{92C}\u{930} \u{914}\u{930} \u{92A}\u{924}\u{93E} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{930}\u{947}\u{902} \u{91C}\u{939}\u{93E}\u{901} \u{906}\u{92A}\u{915}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928} \u{938}\u{902}\u{91A}\u{93E}\u{932}\u{93F}\u{924} \u{939}\u{94B}\u{924}\u{93E} \u{939}\u{948}.`,
    ht: `Ekri non, nimewo telef\xf2n, ak adr\xe8s nan sit kote \xf2ganizasyon ou fonksyone.`,
    it: `Registra il nome, il numero di telefono e l'indirizzo dei siti in cui opera la tua organizzazione.`,
    ja: `\u{7D44}\u{7E54}\u{304C}\u{904B}\u{55B6}\u{3059}\u{308B}\u{30B5}\u{30A4}\u{30C8}\u{306E}\u{540D}\u{524D}\u{3001}\u{96FB}\u{8A71}\u{756A}\u{53F7}\u{3001}\u{4F4F}\u{6240}\u{3092}\u{8A18}\u{9332}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C870}\u{C9C1}\u{C774} \u{C6B4}\u{C601}\u{B418}\u{B294} \u{C0AC}\u{C774}\u{D2B8}\u{C758} \u{C774}\u{B984}, \u{C804}\u{D654} \u{BC88}\u{D638} \u{BC0F} \u{C8FC}\u{C18C}\u{B97C} \u{AE30}\u{B85D}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Sau lub npe, xov tooj, thiab chaw nyob ntawm qhov chaw uas koj lub koom haum koomtxoos.`,
    ps: `\u{62F} \u{647}\u{63A}\u{648} \u{633}\u{627}\u{6CC}\u{67C}\u{648}\u{646}\u{648} \u{646}\u{648}\u{645}\u{60C} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{634}\u{645}\u{6D0}\u{631}\u{647}\u{60C} \u{627}\u{648} \u{67E}\u{62A}\u{647} \u{62B}\u{628}\u{62A} \u{6A9}\u{693}\u{626} \u{686}\u{6D0}\u{631}\u{62A}\u{647} \u{686}\u{6D0} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Registre o nome, o n\xfamero de telefone e o endere\xe7o dos sites em que sua organiza\xe7\xe3o opera.`,
    "pt-pt": `Registe o nome, n\xfamero de telefone e endere\xe7o dos sites onde a sua organiza\xe7\xe3o opera.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{448}\u{438}\u{442}\u{435} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435}, \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430} \u{438} \u{430}\u{434}\u{440}\u{435}\u{441} \u{441}\u{430}\u{439}\u{442}\u{43E}\u{432}, \u{43D}\u{430} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{445} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{435}\u{442} \u{432}\u{430}\u{448}\u{430} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}.`,
    sm: `Faamaumau le igoa, numera o le telefoni, ma le tuatusi o nofoaga o loo faagaoioia ai lau faalapotopotoga.`,
    so: `Ku qor magaca, lambarka telefoonka, iyo cinwaanka goobaha uu ururku ka shaqeeyo.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E0A}\u{E37}\u{E48}\u{E2D} \u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} \u{E41}\u{E25}\u{E30}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E02}\u{E2D}\u{E07}\u{E44}\u{E0B}\u{E15}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E22}\u{E39}\u{E48}`,
    ur: `\u{627}\u{646} \u{633}\u{627}\u{626}\u{679}\u{648}\u{6BA} \u{6A9}\u{627} \u{646}\u{627}\u{645} \u{60C} \u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631} \u{627}\u{648}\u{631} \u{67E}\u{62A}\u{6C1} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{62C}\u{6C1}\u{627}\u{6BA} \u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{627}\u{645} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ghi l\u{1EA1}i t\xean, s\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i v\xe0 \u{111}\u{1ECB}a ch\u{1EC9} c\u{1EE7}a c\xe1c trang web n\u{1A1}i t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n ho\u{1EA1}t \u{111}\u{1ED9}ng.`,
    "zh-hans": `\u{8BB0}\u{5F55}\u{60A8}\u{7684}\u{7EC4}\u{7EC7}\u{8FD0}\u{8425}\u{7684}\u{7AD9}\u{70B9}\u{7684}\u{540D}\u{79F0}\u{3001}\u{7535}\u{8BDD}\u{53F7}\u{7801}\u{548C}\u{5730}\u{5740}\u{3002}`,
    "zh-hant": `\u{8A18}\u{9304}\u{60A8}\u{7684}\u{7D44}\u{7E54}\u{904B}\u{71DF}\u{7684}\u{7DB2}\u{7AD9}\u{7684}\u{540D}\u{7A31}\u{3001}\u{96FB}\u{8A71}\u{865F}\u{78BC}\u{548C}\u{4F4D}\u{5740}\u{3002}`,
    en: `Record the name, phone number, and address of sites where your organization operates.`
};
const $2868cc1235412e16$export$cc22a6e93b844310 = {
    ar: (type)=>`\u{644}\u{627} \u{62A}\u{633}\u{645}\u{62D} ${type} \u{628}\u{623}\u{646}\u{634}\u{637}\u{629} \u{627}\u{644}\u{623}\u{637}\u{641}\u{627}\u{644}`,
    de: (type)=>`${type} erlaubt keine Aktivit\xe4ten f\xfcr Kinder`,
    es: (type)=>`La ${type} no permite actividades infantiles`,
    fa: (type)=>`${type} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{6A9}\u{648}\u{62F}\u{6A9} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}`,
    fil: (type)=>`Hindi pinapayagan ng ${type} ang mga aktibidad ng bata`,
    fr: (type)=>`${type} ne permet pas les activit\xe9s des enfants`,
    hi: (type)=>`${type} \u{92C}\u{93E}\u{932} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{926}\u{947}\u{924}\u{93E} \u{939}\u{948}`,
    ht: (type)=>`${type} p\xe8m\xe8t aktivite timoun yo`,
    it: (type)=>`${type} non consente attivit\xe0 per bambini`,
    ja: (type)=>`${type} \u{3067}\u{306F}\u{3001}\u{5B50}\u{4F9B}\u{306E}\u{6D3B}\u{52D5}\u{306F}\u{8A31}\u{53EF}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}`,
    ko: (type)=>`${type} \u{C740} \u{C544}\u{B3D9} \u{D65C}\u{B3D9}\u{C744} \u{D5C8}\u{C6A9}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: (type)=>`${type} tsis pub cov kev ua ub no`,
    ps: (type)=>`\u{67E}\u{647} ${type} \u{62F} \u{645}\u{627}\u{634}\u{648}\u{645}\u{627}\u{646}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{648}\u{631}\u{6A9}\u{648}\u{6CC}`,
    pt: (type)=>`${type} n\xe3o permite atividades infantis`,
    "pt-pt": (type)=>`${type} n\xe3o permite atividades infantis`,
    ru: (type)=>`${type} \u{43D}\u{435} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{430}\u{435}\u{442} \u{434}\u{435}\u{442}\u{44F}\u{43C} \u{437}\u{430}\u{43D}\u{438}\u{43C}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{441}\u{432}\u{43E}\u{438}\u{43C}\u{438} \u{434}\u{435}\u{43B}\u{430}\u{43C}\u{438}`,
    sm: (type)=>`E le fa'atagaina e le ${type} gaioiga a tamaiti`,
    so: (type)=>`${type} ma ogola waxqabadka caruurta`,
    th: (type)=>`${type} \u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E40}\u{E14}\u{E47}\u{E01}`,
    ur: (type)=>`${type} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{62A}\u{627} \u{6C1}\u{6D2}`,
    vi: (type)=>`${type} kh\xf4ng cho ph\xe9p c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng c\u{1EE7}a tr\u{1EBB} em`,
    "zh-hans": (type)=>`${type} \u{4E0D}\u{5141}\u{8BB8}\u{513F}\u{7AE5}\u{6D3B}\u{52A8}`,
    "zh-hant": (type)=>`${type} \u{4E0D}\u{5141}\u{8A31}\u{5152}\u{7AE5}\u{6D3B}\u{52D5}`,
    en: (type)=>`${type} does not permit child activities`
};
const $2868cc1235412e16$export$a4ed9e70242756ec = {
    ar: (parentHref, parentType)=>$2868cc1235412e16$var$html`ربما تقصد إنشاء سجل طفل من <a href="${parentHref}">${parentType}</a>؟`,
    de: (parentHref, parentType)=>$2868cc1235412e16$var$html`Vielleicht wollten Sie einen untergeordneten Datensatz aus der <a href="${parentHref}">${parentType}</a> erstellen?`,
    es: (parentHref, parentType)=>$2868cc1235412e16$var$html`¿Quizás tenía la intención de crear un registro de niño a partir de la <a href="${parentHref}">${parentType}</a>?`,
    fa: (parentHref, parentType)=>$2868cc1235412e16$var$html`شاید قصد داشتید از <a href="${parentHref}">${parentType}</a> یک رکورد کودک ایجاد کنید؟`,
    fil: (parentHref, parentType)=>$2868cc1235412e16$var$html`Marahil ay sinadya mong lumikha ng isang talaan ng bata mula sa <a href="${parentHref}">${parentType}</a>?`,
    fr: (parentHref, parentType)=>$2868cc1235412e16$var$html`Peut-être vouliez-vous créer un dossier d’enfant à partir de la <a href="${parentHref}">${parentType}</a> ?`,
    hi: (parentHref, parentType)=>$2868cc1235412e16$var$html`शायद आप <a href="${parentHref}">${parentType}</a> से एक बच्चे का रिकॉर्ड बनाना चाहते थे?`,
    ht: (parentHref, parentType)=>$2868cc1235412e16$var$html`Petèt ou te vle di kreye yon dosye timoun nan <a href="${parentHref}">${parentType}</a> la?`,
    it: (parentHref, parentType)=>$2868cc1235412e16$var$html`Forse intendevi creare un record figlio dal <a href="${parentHref}">${parentType}</a>?`,
    ja: (parentHref, parentType)=>$2868cc1235412e16$var$html`もしかしたら、 <a href="${parentHref}">${parentType}</a>から子レコードを作成するつもりだったのでしょうか?`,
    ko: (parentHref, parentType)=>$2868cc1235412e16$var$html`<a href="${parentHref}">${parentType}</a>에서 하위 레코드를 만들려고 했습니까?`,
    mww: (parentHref, parentType)=>$2868cc1235412e16$var$html`Kab tias koj meant los tsim ib tug me nyuam ntaub ntawv los ntawm cov <a href="${parentHref}">${parentType}</a>`,
    ps: (parentHref, parentType)=>$2868cc1235412e16$var$html`شاید ستاسو موخه دا وه چې د <a href="${parentHref}">${parentType}</a> څخه د ماشوم ریکارډ جوړ کړئ؟`,
    pt: (parentHref, parentType)=>$2868cc1235412e16$var$html`Talvez você quisesse criar um registro filho a partir da <a href="${parentHref}">${parentType}</a>?`,
    "pt-pt": (parentHref, parentType)=>$2868cc1235412e16$var$html`Talvez você pretendesse criar um registro de criança a partir da <a href="${parentHref}">${parentType}</a>?`,
    ru: (parentHref, parentType)=>$2868cc1235412e16$var$html`Возможно, вы имели в виду создать дочернюю запись из <a href="${parentHref}">${parentType}</a>?`,
    sm: (parentHref, parentType)=>$2868cc1235412e16$var$html`Atonu na e mana'o e fatuina se fa'amaumauga a le tamaititi mai le <a href="${parentHref}">${parentType}</a>?`,
    so: (parentHref, parentType)=>$2868cc1235412e16$var$html`Waxaa laga yaabaa in aad loogu tala galay in lagu abuuro diiwaanka ilmaha ee <a href="${parentHref}">${parentType}</a>?`,
    th: (parentHref, parentType)=>$2868cc1235412e16$var$html`บางทีคุณอาจตั้งใจจะสร้างบันทึกเด็กจาก <a href="${parentHref}">${parentType}</a>?`,
    ur: (parentHref, parentType)=>$2868cc1235412e16$var$html`شاید آپ <a href="${parentHref}">${parentType}</a> سے بچے کا ریکارڈ بنانا چاہتے تھے؟`,
    vi: (parentHref, parentType)=>$2868cc1235412e16$var$html`Có lẽ bạn muốn tạo một hồ sơ trẻ em từ <a href="${parentHref}">${parentType}</a>?`,
    "zh-hans": (parentHref, parentType)=>$2868cc1235412e16$var$html`也许您打算从 <a href="${parentHref}">${parentType}</a>创建子记录？`,
    "zh-hant": (parentHref, parentType)=>$2868cc1235412e16$var$html`也許您打算從 <a href="${parentHref}">${parentType}</a>創建子記錄？`,
    en: (parentHref, parentType)=>$2868cc1235412e16$var$html`Perhaps you meant to create a child record from the <a href="${parentHref}">${parentType}</a>?`
};
const $2868cc1235412e16$export$da467b70cb2c174f = {
    ar: `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{625}\u{646}\u{634}\u{627}\u{621} \u{633}\u{62C}\u{644}\u{627}\u{62A} \u{62A}\u{627}\u{628}\u{639}\u{629} \u{645}\u{646} \u{647}\u{630}\u{627} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}`,
    de: `Sie k\xf6nnen keine untergeordneten Datens\xe4tze aus dieser Aktivit\xe4t erstellen`,
    es: `No se pueden crear registros secundarios a partir de esta actividad`,
    fa: `\u{634}\u{645}\u{627} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{631}\u{6A9}\u{648}\u{631}\u{62F}\u{647}\u{627}\u{6CC} \u{641}\u{631}\u{632}\u{646}\u{62F} \u{631}\u{627} \u{627}\u{632} \u{627}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Hindi ka maaaring lumikha ng mga talaan ng bata mula sa aktibidad na ito`,
    fr: `Vous ne pouvez pas cr\xe9er d\u{2019}enregistrements enfants \xe0 partir de cette activit\xe9`,
    hi: `\u{906}\u{92A} \u{907}\u{938} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{938}\u{947} \u{91A}\u{93E}\u{907}\u{932}\u{94D}\u{921} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{928}\u{939}\u{940}\u{902} \u{92C}\u{928}\u{93E} \u{938}\u{915}\u{924}\u{947}`,
    ht: `Ou pa ka kreye dosye timoun nan aktivite sa a`,
    it: `Non \xe8 possibile creare record figlio da questa attivit\xe0`,
    ja: `\u{3053}\u{306E}\u{6D3B}\u{52D5}\u{304B}\u{3089}\u{5B50}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C774} \u{D65C}\u{B3D9}\u{C5D0}\u{C11C}\u{B294} \u{D558}\u{C704} \u{B808}\u{CF54}\u{B4DC}\u{B97C} \u{B9CC}\u{B4E4} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Koj yuav tsim tau cov ntaub ntawv los ntawm txoj kev ua no`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{646}\u{634}\u{626} \u{6A9}\u{648}\u{644}\u{6CC} \u{686}\u{6D0} \u{644}\u{647} \u{62F}\u{6D0} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{685}\u{62E}\u{647} \u{62F} \u{645}\u{627}\u{634}\u{648}\u{645} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}\u{648}\u{646}\u{647} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}`,
    pt: `N\xe3o \xe9 poss\xedvel criar registros filhos a partir dessa atividade`,
    "pt-pt": `N\xe3o \xe9 poss\xedvel criar registos filho a partir desta atividade`,
    ru: `\u{412}\u{44B} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442}\u{435} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C} \u{434}\u{43E}\u{447}\u{435}\u{440}\u{43D}\u{438}\u{435} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} \u{44D}\u{442}\u{43E}\u{433}\u{43E} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    sm: `E le mafai ona e fatuina ni faamaumauga a tamaiti mai lenei gaoioiga`,
    so: `Adigu ma abuuri kartid qoraalka ilmaha ee howshan`,
    th: `\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E23}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E19}\u{E35}\u{E49}\u{E44}\u{E14}\u{E49}`,
    ur: `\u{622}\u{67E} \u{627}\u{633} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{633}\u{6D2} \u{628}\u{686}\u{648}\u{6BA} \u{6A9}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{628}\u{646}\u{627} \u{633}\u{6A9}\u{62A}\u{6D2}`,
    vi: `B\u{1EA1}n kh\xf4ng th\u{1EC3} t\u{1EA1}o b\u{1EA3}n ghi con t\u{1EEB} ho\u{1EA1}t \u{111}\u{1ED9}ng n\xe0y`,
    "zh-hans": `\u{60A8}\u{65E0}\u{6CD5}\u{4ECE}\u{6B64}\u{6D3B}\u{52A8}\u{521B}\u{5EFA}\u{5B50}\u{8BB0}\u{5F55}`,
    "zh-hant": `\u{60A8}\u{7121}\u{6CD5}\u{5F9E}\u{6B64}\u{6D3B}\u{52D5}\u{5EFA}\u{7ACB}\u{5B50}\u{8A18}\u{9304}`,
    en: `You cannot create child records from this activity`
};
const $2868cc1235412e16$export$fb65fe225f63a528 = {
    ar: `\u{644}\u{644}\u{642}\u{631}\u{627}\u{621}\u{629} \u{641}\u{642}\u{637} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{637}\u{629}`,
    de: `Bedingt schreibgesch\xfctzt`,
    es: `Condicionalmente de solo lectura`,
    fa: `\u{641}\u{642}\u{637} \u{62E}\u{648}\u{627}\u{646}\u{62F}\u{646}\u{6CC} \u{645}\u{634}\u{631}\u{648}\u{637}`,
    fil: `Kundisyonal na basahin lamang`,
    fr: `Lecture seule conditionnelle`,
    hi: `\u{938}\u{936}\u{930}\u{94D}\u{924} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{915}\u{947}\u{935}\u{932} \u{92A}\u{922}\u{93C}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}`,
    ht: `Kondisyon\xe8lman li-s\xe8lman`,
    it: `Sola lettura condizionale`,
    ja: `\u{6761}\u{4EF6}\u{4ED8}\u{304D}\u{8AAD}\u{307F}\u{53D6}\u{308A}\u{5C02}\u{7528}`,
    ko: `\u{C870}\u{AC74}\u{BD80} \u{C77D}\u{AE30} \u{C804}\u{C6A9}`,
    mww: `Conditionally nyeem-xwb`,
    ps: `\u{645}\u{634}\u{631}\u{648}\u{637} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{644}\u{648}\u{633}\u{62A}\u{644}`,
    pt: `Somente leitura condicional`,
    "pt-pt": `Somente leitura condicional`,
    ru: `\u{423}\u{441}\u{43B}\u{43E}\u{432}\u{43D}\u{43E} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{434}\u{43B}\u{44F} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Faitau na'o tuutuuga`,
    so: `Shuruudaha akhriska kaliya`,
    th: `\u{E2D}\u{E48}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E15}\u{E32}\u{E21}\u{E40}\u{E07}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E02}`,
    ur: `\u{645}\u{634}\u{631}\u{648}\u{637} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{635}\u{631}\u{641} \u{67E}\u{691}\u{6BE}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9} \u{111}\u{1ECD}c c\xf3 \u{111}i\u{1EC1}u ki\u{1EC7}n`,
    "zh-hans": `\u{6709}\u{6761}\u{4EF6}\u{53EA}\u{8BFB}`,
    "zh-hant": `\u{6709}\u{689D}\u{4EF6}\u{552F}\u{8B80}`,
    en: `Conditionally read-only`
};
const $2868cc1235412e16$export$6532cc8711b7a07d = {
    ar: `\u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{644}\u{644}\u{642}\u{631}\u{627}\u{621}\u{629} \u{641}\u{642}\u{637} \u{628}\u{633}\u{628}\u{628} \u{627}\u{644}\u{634}\u{631}\u{648}\u{637} \u{627}\u{644}\u{62A}\u{64A} \u{62D}\u{62F}\u{62F}\u{647}\u{627} \u{645}\u{633}\u{624}\u{648}\u{644} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}.`,
    de: `Dieser Datensatz ist aufgrund von Bedingungen, die vom Projektadministrator festgelegt wurden, schreibgesch\xfctzt.`,
    es: `Este registro es de solo lectura debido a las condiciones establecidas por el administrador del proyecto.`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{628}\u{647} \u{62F}\u{644}\u{6CC}\u{644} \u{634}\u{631}\u{627}\u{6CC}\u{637} \u{62A}\u{639}\u{6CC}\u{6CC}\u{646} \u{634}\u{62F}\u{647} \u{62A}\u{648}\u{633}\u{637} \u{645}\u{62F}\u{6CC}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{641}\u{642}\u{637} \u{62E}\u{648}\u{627}\u{646}\u{62F}\u{646}\u{6CC} \u{627}\u{633}\u{62A}.`,
    fil: `Ang rekord na ito ay read-only dahil sa mga kondisyon na itinakda ng tagapangasiwa ng proyekto.`,
    fr: `Cet enregistrement est en lecture seule en raison des conditions d\xe9finies par l\u{2019}administrateur du projet.`,
    hi: `\u{92F}\u{939} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{935}\u{94D}\u{92F}\u{935}\u{938}\u{94D}\u{925}\u{93E}\u{92A}\u{915} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{938}\u{947}\u{91F} \u{915}\u{940} \u{917}\u{908} \u{936}\u{930}\u{94D}\u{924}\u{94B}\u{902} \u{915}\u{947} \u{915}\u{93E}\u{930}\u{923} \u{915}\u{947}\u{935}\u{932} \u{92A}\u{922}\u{93C}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{939}\u{948}.`,
    ht: `Dosye sa a li-s\xe8lman ak\xf2z kondisyon mete pa administrat\xe8 pwoj\xe8 a.`,
    it: `Questo record \xe8 di sola lettura a causa delle condizioni impostate dall'amministratore del progetto.`,
    ja: `\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306F}\u{3001}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{7BA1}\u{7406}\u{8005}\u{306B}\u{3088}\u{3063}\u{3066}\u{8A2D}\u{5B9A}\u{3055}\u{308C}\u{305F}\u{6761}\u{4EF6}\u{306B}\u{3088}\u{308A}\u{3001}\u{8AAD}\u{307F}\u{53D6}\u{308A}\u{5C02}\u{7528}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{B808}\u{CF54}\u{B4DC}\u{B294} \u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{AD00}\u{B9AC}\u{C790}\u{AC00} \u{C124}\u{C815}\u{D55C} \u{C870}\u{AC74}\u{C73C}\u{B85C} \u{C778}\u{D574} \u{C77D}\u{AE30} \u{C804}\u{C6A9}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntaub ntawv no yog nyeem tsuas yog vim muaj tej yam mob uas teev cia los ntawm tus thawj tswj tes num.`,
    ps: `\u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{62F} \u{645}\u{62F}\u{6CC}\u{631} \u{644}\u{62E}\u{648}\u{627} \u{62F} \u{67C}\u{627}\u{6A9}\u{644} \u{634}\u{648}\u{6CC}\u{648} \u{634}\u{631}\u{627}\u{6CC}\u{637}\u{648} \u{644}\u{647} \u{627}\u{645}\u{644}\u{647} \u{6CC}\u{648}\u{627}\u{632}\u{6D0} \u{644}\u{648}\u{633}\u{62A}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `Esse registro \xe9 somente leitura devido \xe0s condi\xe7\xf5es definidas pelo administrador do projeto.`,
    "pt-pt": `Esse registro \xe9 somente leitura devido \xe0s condi\xe7\xf5es definidas pelo administrador do projeto.`,
    ru: `\u{42D}\u{442}\u{430} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{430} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{434}\u{43B}\u{44F} \u{447}\u{442}\u{435}\u{43D}\u{438}\u{44F} \u{432} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{438}\u{438} \u{441} \u{443}\u{441}\u{43B}\u{43E}\u{432}\u{438}\u{44F}\u{43C}\u{438}, \u{443}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{43C}\u{438} \u{430}\u{434}\u{43C}\u{438}\u{43D}\u{438}\u{441}\u{442}\u{440}\u{430}\u{442}\u{43E}\u{440}\u{43E}\u{43C} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}.`,
    sm: `O lenei faamaumauga e na o le faitauina ona o tuutuuga ua setiina e le pule o le galuega faatino.`,
    so: `Diiwaankaan waxaa loo aqrinayaa oo keliya sababtoo ah shuruudaha uu dejiyay maamulaha mashruuca.`,
    th: `\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E2D}\u{E48}\u{E32}\u{E19}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E08}\u{E32}\u{E01}\u{E40}\u{E07}\u{E37}\u{E48}\u{E2D}\u{E19}\u{E44}\u{E02}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E42}\u{E14}\u{E22}\u{E1C}\u{E39}\u{E49}\u{E14}\u{E39}\u{E41}\u{E25}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{6CC}\u{6C1} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{635}\u{631}\u{641} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{627}\u{6CC}\u{688}\u{645}\u{646}\u{633}\u{679}\u{631}\u{6CC}\u{679}\u{631} \u{6A9}\u{6CC} \u{637}\u{631}\u{641} \u{633}\u{6D2} \u{645}\u{642}\u{631}\u{631} \u{6A9}\u{631}\u{62F}\u{6C1} \u{634}\u{631}\u{627}\u{626}\u{637} \u{6A9}\u{6CC} \u{648}\u{62C}\u{6C1} \u{633}\u{6D2} \u{67E}\u{691}\u{6BE}\u{627} \u{62C}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `B\u{1EA3}n ghi n\xe0y l\xe0 ch\u{1EC9} \u{111}\u{1ECD}c do c\xe1c \u{111}i\u{1EC1}u ki\u{1EC7}n do qu\u{1EA3}n tr\u{1ECB} vi\xean d\u{1EF1} \xe1n \u{111}\u{1EB7}t ra.`,
    "zh-hans": `\u{7531}\u{4E8E}\u{9879}\u{76EE}\u{7BA1}\u{7406}\u{5458}\u{8BBE}\u{7F6E}\u{7684}\u{6761}\u{4EF6}\u{FF0C}\u{6B64}\u{8BB0}\u{5F55}\u{662F}\u{53EA}\u{8BFB}\u{7684}\u{3002}`,
    "zh-hant": `\u{7531}\u{65BC}\u{5C08}\u{6848}\u{7BA1}\u{7406}\u{54E1}\u{8A2D}\u{7F6E}\u{7684}\u{689D}\u{4EF6}\u{FF0C}\u{6B64}\u{8A18}\u{9304}\u{662F}\u{552F}\u{8B80}\u{7684}\u{3002}`,
    en: `This record is read-only due to conditions set by the project administrator.`
};
const $2868cc1235412e16$export$7f180462ad092f82 = {
    ar: `\u{644}\u{627} \u{64A}\u{633}\u{645}\u{62D} \u{644}\u{643} \u{62F}\u{648}\u{631}\u{643} \u{628}\u{62A}\u{62D}\u{631}\u{64A}\u{631} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}.`,
    de: `Ihre Rolle erlaubt es Ihnen nicht, diesen Datensatz zu bearbeiten.`,
    es: `Su rol no le permite editar este registro.`,
    fa: `\u{646}\u{642}\u{634} \u{634}\u{645}\u{627} \u{628}\u{647} \u{634}\u{645}\u{627} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{646}\u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Hindi ka pinapayagan ng iyong tungkulin na i-edit ang talaang ito.`,
    fr: `Votre r\xf4le ne vous permet pas de modifier cet enregistrement.`,
    hi: `\u{906}\u{92A}\u{915}\u{940} \u{92D}\u{942}\u{92E}\u{93F}\u{915}\u{93E} \u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{94B} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{905}\u{928}\u{941}\u{92E}\u{924}\u{93F} \u{928}\u{939}\u{940}\u{902} \u{926}\u{947}\u{924}\u{940}.`,
    ht: `W\xf2l ou pa p\xe8m\xe8t ou edite dosye sa a.`,
    it: `Il ruolo non consente di modificare questo record.`,
    ja: `\u{3042}\u{306A}\u{305F}\u{306E}\u{30ED}\u{30FC}\u{30EB}\u{3067}\u{306F}\u{3001}\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306E}\u{7DE8}\u{96C6}\u{306F}\u{8A31}\u{53EF}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790}\u{C758} \u{C5ED}\u{D560}\u{C740} \u{C774} \u{B808}\u{CF54}\u{B4DC}\u{B97C} \u{D3B8}\u{C9D1}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Koj lub luag hauj lwm tsis pub koj edit cov ntaub ntawv no.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{631}\u{648}\u{644} \u{62A}\u{627}\u{633}\u{648} \u{62A}\u{647} \u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{647} \u{62F}\u{631}\u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{633}\u{645}\u{648}\u{646} \u{648}\u{6A9}\u{693}\u{626}.`,
    pt: `Sua fun\xe7\xe3o n\xe3o permite que voc\xea edite esse registro.`,
    "pt-pt": `A sua fun\xe7\xe3o n\xe3o lhe permite editar este registo.`,
    ru: `\u{412}\u{430}\u{448}\u{430} \u{440}\u{43E}\u{43B}\u{44C} \u{43D}\u{435} \u{43F}\u{43E}\u{437}\u{432}\u{43E}\u{43B}\u{44F}\u{435}\u{442} \u{432}\u{430}\u{43C} \u{440}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}.`,
    sm: `E le faatagaina oe e lau matafaioi ona faasa'o lenei faamaumauga.`,
    so: `Doorkaagu kuuma ogola in aad tafatirto rikoorkan.`,
    th: `\u{E1A}\u{E17}\u{E1A}\u{E32}\u{E17}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E04}\u{E38}\u{E13}\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{627} \u{6A9}\u{631}\u{62F}\u{627}\u{631} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{62F}\u{6CC}\u{62A}\u{627}\u{6D4}`,
    vi: `Vai tr\xf2 c\u{1EE7}a b\u{1EA1}n kh\xf4ng cho ph\xe9p b\u{1EA1}n ch\u{1EC9}nh s\u{1EED}a b\u{1EA3}n ghi n\xe0y.`,
    "zh-hans": `\u{60A8}\u{7684}\u{89D2}\u{8272}\u{4E0D}\u{5141}\u{8BB8}\u{60A8}\u{7F16}\u{8F91}\u{6B64}\u{8BB0}\u{5F55}\u{3002}`,
    "zh-hant": `\u{60A8}\u{7684}\u{89D2}\u{8272}\u{4E0D}\u{5141}\u{8A31}\u{60A8}\u{7DE8}\u{8F2F}\u{6B64}\u{8A18}\u{9304}\u{3002}`,
    en: `Your role does not permit you to edit this record.`
};
const $2868cc1235412e16$export$8f5daf951e994b77 = {
    ar: `\u{643}\u{644}`,
    de: `Alle`,
    es: `Todo`,
    fa: `\u{647}\u{645}\u{647}`,
    fil: `Lahat`,
    fr: `Tout`,
    hi: `\u{938}\u{92C}`,
    ht: `Tout`,
    it: `Tutto`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}`,
    ko: `\u{BAA8}\u{B450}`,
    mww: `Tag nrho`,
    ps: `\u{62F} \u{627}\u{645}\u{631}\u{6CC}\u{6A9}\u{627} \u{62F} \u{62F}\u{641}\u{627}\u{639} \u{648}\u{632}\u{627}\u{631}\u{62A} \u{648}\u{627}\u{6CC}\u{6CC} \u{686}\u{6D0} \u{62F}`,
    pt: `Todo`,
    "pt-pt": `Tudo`,
    ru: `\u{412}\u{441}\u{435}`,
    sm: `Uma`,
    so: `Alle`,
    th: `\u{E17}\u{E31}\u{E49}\u{E07}\u{E2B}\u{E21}\u{E14}`,
    ur: `\u{62A}\u{645}\u{627}\u{645}`,
    vi: `T\u{1EA5}t c\u{1EA3}`,
    "zh-hans": `\u{90FD}`,
    "zh-hant": `\u{90FD}`,
    en: `All`
};
const $2868cc1235412e16$export$8d7a72727b917368 = {
    ar: `\u{648}\u{643}\u{627}\u{644}\u{629}`,
    de: `Agentur`,
    es: `Agencia`,
    fa: `\u{622}\u{698}\u{627}\u{646}\u{633}`,
    fil: `Ahensya`,
    fr: `Agence`,
    hi: `\u{938}\u{930}\u{915}\u{93E}\u{930}\u{940} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{940}`,
    ht: `Ajans`,
    it: `Agenzia`,
    ja: `\u{30A8}\u{30FC}\u{30B8}\u{30A7}\u{30F3}\u{30B7}\u{30FC}`,
    ko: `\u{AE30}\u{AD00}`,
    mww: `Chaw ua hauj lwm`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Ag\xeancia`,
    "pt-pt": `Ag\xeancia`,
    ru: `\u{410}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Faitalia`,
    so: `Hay'adda`,
    th: `\u{E1A}\u{E23}\u{E34}\u{E29}\u{E31}\u{E17}\u{E15}\u{E31}\u{E27}\u{E41}\u{E17}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}`,
    vi: `C\u{1A1} quan`,
    "zh-hans": `\u{673A}\u{6784}`,
    "zh-hant": `\u{6A5F}\u{69CB}`,
    en: `Agency`
};
const $2868cc1235412e16$export$c679b7129661e5e0 = {
    ar: `\u{645}\u{624}\u{633}\u{633}\u{629} \u{645}\u{634}\u{627}\u{631}\u{643}\u{629} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639} \u{644}\u{627} \u{64A}\u{645}\u{62A}\u{644}\u{643} \u{645}\u{633}\u{62A}\u{62E}\u{62F}\u{645}\u{648}\u{647}\u{627} \u{62D}\u{633}\u{627}\u{628}\u{627}\u{62A} Cumulus.`,
    de: `Eine Organisation, die an dem Projekt beteiligt ist und deren Benutzer kein Cumulus-Konto haben.`,
    es: `Una organizaci\xf3n que participa en el proyecto cuyos usuarios no tienen cuentas de Cumulus.`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{634}\u{631}\u{6A9}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{62F} \u{648} \u{6A9}\u{627}\u{631}\u{628}\u{631}\u{627}\u{646} \u{622}\u{646} \u{62D}\u{633}\u{627}\u{628} \u{6A9}\u{648}\u{645}\u{648}\u{644}\u{648}\u{633} \u{646}\u{62F}\u{627}\u{631}\u{646}\u{62F}.`,
    fil: `Isang organisasyon na lumahok sa proyekto na ang mga gumagamit ay walang Cumulus account.`,
    fr: `Une organisation participant au projet dont les utilisateurs n\u{2019}ont pas de compte Cumulus.`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{92E}\u{947}\u{902} \u{92D}\u{93E}\u{917} \u{932}\u{947}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{91C}\u{93F}\u{938}\u{915}\u{947} \u{909}\u{92A}\u{92F}\u{94B}\u{917}\u{915}\u{930}\u{94D}\u{924}\u{93E}\u{913}\u{902} \u{915}\u{947} \u{92A}\u{93E}\u{938} Cumulus \u{916}\u{93E}\u{924}\u{947} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{902}.`,
    ht: `Yon \xf2ganizasyon k ap patisipe nan pwoj\xe8 a ki gen itilizat\xe8 yo pa gen kont Culus.`,
    it: `Un'organizzazione che partecipa al progetto i cui utenti non dispongono di account Cumulus.`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{306B}\u{53C2}\u{52A0}\u{3057}\u{3066}\u{3044}\u{308B}\u{7D44}\u{7E54}\u{3067}\u{3001}\u{30E6}\u{30FC}\u{30B6}\u{304C} Cumulus \u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{6301}\u{3063}\u{3066}\u{3044}\u{306A}\u{3044}\u{4EBA}\u{3002}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790}\u{C5D0}\u{AC8C} Cumulus \u{ACC4}\u{C815}\u{C774} \u{C5C6}\u{B294} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{C5D0} \u{CC38}\u{C5EC}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib lub koom haum koom tes hauv peb tes num uas nws cov neeg siv tsis muaj Cumulus nyiaj.`,
    ps: `\u{6CC}\u{648}\u{647} \u{627}\u{62F}\u{627}\u{631}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{6A9}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{627}\u{62E}\u{644}\u{6CC} \u{627}\u{648} \u{6A9}\u{627}\u{631}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{6CC}\u{6D0} \u{6A9}\u{648}\u{645}\u{648}\u{644}\u{648}\u{633} \u{627}\u{6A9}\u{627}\u{648}\u{646}\u{67C}\u{648}\u{646}\u{647} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `Uma organiza\xe7\xe3o participante do projeto cujos usu\xe1rios n\xe3o t\xeam contas Cumulus.`,
    "pt-pt": `Uma organiza\xe7\xe3o participante do projeto cujos usu\xe1rios n\xe3o t\xeam contas Cumulus.`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F}, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{432} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{435}, \u{443} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{439} \u{43D}\u{435}\u{442} \u{443}\u{447}\u{435}\u{442}\u{43D}\u{44B}\u{445} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{435}\u{439} Cumulus.`,
    sm: `O se fa'alapotopotoga o lo'o auai i le poloketi o ona tagata fa'aoga e leai ni teuga tupe a Cumulus.`,
    so: `Hay'ad ka qaybqaadanaysa mashruuca oo dadka isticmaala aysan laheyn xisaabaadka Cumulus.`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}\u{E43}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E39}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35} Cumulus`,
    ur: `\u{627}\u{633} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{62D}\u{635}\u{6C1} \u{644}\u{6CC}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6CC} \u{627}\u{6CC}\u{6A9} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{62C}\u{633} \u{6A9}\u{6D2} \u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646} \u{6A9}\u{6D2} \u{67E}\u{627}\u{633} \u{6A9}\u{645}\u{648}\u{644}\u{633} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `M\u{1ED9}t t\u{1ED5} ch\u{1EE9}c tham gia d\u{1EF1} \xe1n c\xf3 ng\u{1B0}\u{1EDD}i d\xf9ng kh\xf4ng c\xf3 t\xe0i kho\u{1EA3}n Cumulus.`,
    "zh-hans": `\u{53C2}\u{4E0E}\u{9879}\u{76EE}\u{7684}\u{7EC4}\u{7EC7}\u{FF0C}\u{5176}\u{7528}\u{6237}\u{6CA1}\u{6709} Cumulus \u{8D26}\u{6237}\u{3002}`,
    "zh-hant": `\u{53C3}\u{8207}\u{9805}\u{76EE}\u{7684}\u{7D44}\u{7E54}\u{FF0C}\u{5176}\u{7528}\u{6236}\u{6C92}\u{6709} Cumulus \u{5E33}\u{6236}\u{3002}`,
    en: `An organization participating in the project whose users do not have Cumulus accounts.`
};
const $2868cc1235412e16$export$8a207254b784b0a6 = {
    ar: `\u{645}\u{648}\u{642}\u{639} \u{62A}\u{62C}\u{631}\u{64A} \u{641}\u{64A}\u{647} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629} \u{639}\u{645}\u{644}\u{64A}\u{627}\u{62A}.`,
    de: `Ein Ort, an dem eine Organisation Operationen durchf\xfchrt.`,
    es: `Ubicaci\xf3n en la que una organizaci\xf3n lleva a cabo operaciones.`,
    fa: `\u{645}\u{6A9}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{6CC}\u{6A9} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{62F}\u{631} \u{622}\u{646} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{645}\u{6CC} \u{62F}\u{647}\u{62F}.`,
    fil: `Isang lugar kung saan ang isang organisasyon ay nagsasagawa ng mga operasyon.`,
    fr: `Lieu o\xf9 une organisation exerce ses activit\xe9s.`,
    hi: `\u{935}\u{939} \u{938}\u{94D}\u{925}\u{93E}\u{928} \u{91C}\u{939}\u{93E}\u{901} \u{90F}\u{915} \u{938}\u{902}\u{917}\u{920}\u{928} \u{938}\u{902}\u{91A}\u{93E}\u{932}\u{928} \u{915}\u{930}\u{924}\u{93E} \u{939}\u{948}\u{964}`,
    ht: `Yon kote yon \xf2ganizasyon ap f\xe8 operasyon.`,
    it: `Luogo in cui un'organizzazione esegue operazioni.`,
    ja: `\u{7D44}\u{7E54}\u{304C}\u{696D}\u{52D9}\u{3092}\u{884C}\u{3046}\u{5834}\u{6240}\u{3002}`,
    ko: `\u{C870}\u{C9C1}\u{C774} \u{C791}\u{C5C5}\u{C744} \u{C218}\u{D589}\u{D558}\u{B294} \u{C704}\u{CE58}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib qhov chaw uas ib lub koom haum ua haujlwm.`,
    ps: `\u{647}\u{63A}\u{647} \u{681}\u{627}\u{6CC} \u{686}\u{6D0} \u{6CC}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{67E}\u{6A9}\u{6D0} \u{639}\u{645}\u{644}\u{6CC}\u{627}\u{62A} \u{62A}\u{631}\u{633}\u{631}\u{647} \u{6A9}\u{648}\u{6CC}.`,
    pt: `Um local onde uma organiza\xe7\xe3o realiza opera\xe7\xf5es.`,
    "pt-pt": `Um local onde uma organiza\xe7\xe3o realiza opera\xe7\xf5es.`,
    ru: `\u{41C}\u{435}\u{441}\u{442}\u{43E}\u{43F}\u{43E}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}, \u{432} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{43C} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43E}\u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{43B}\u{44F}\u{435}\u{442} \u{441}\u{432}\u{43E}\u{44E} \u{434}\u{435}\u{44F}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C}.`,
    sm: `O se nofoaga e fa'atautaia ai e se fa'alapotopotoga gaioiga.`,
    so: `Goob ay hay\u{2BC}ad howlgalo ka fuliso.`,
    th: `\u{E2A}\u{E16}\u{E32}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E14}\u{E4D}\u{E32}\u{E40}\u{E19}\u{E34}\u{E19}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633}\u{6CC} \u{62C}\u{6AF}\u{6C1} \u{62C}\u{6C1}\u{627}\u{6BA} \u{6A9}\u{648}\u{626}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{622}\u{67E}\u{631}\u{6CC}\u{634}\u{646} \u{6A9}\u{631}\u{62A}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `M\u{1ED9}t \u{111}\u{1ECB}a \u{111}i\u{1EC3}m m\xe0 m\u{1ED9}t t\u{1ED5} ch\u{1EE9}c ti\u{1EBF}n h\xe0nh c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng.`,
    "zh-hans": `\u{7EC4}\u{7EC7}\u{6267}\u{884C}\u{4F5C}\u{7684}\u{4F4D}\u{7F6E}\u{3002}`,
    "zh-hant": `\u{7D44}\u{7E54}\u{57F7}\u{884C}\u{4F5C}\u{7684}\u{4F4D}\u{7F6E}\u{3002}`,
    en: `A location where an organization conducts operations.`
};
const $2868cc1235412e16$export$6d10fa154c9a0e20 = {
    ar: `\u{625}\u{637}\u{627}\u{631} \u{632}\u{645}\u{646}\u{64A} \u{64A}\u{633}\u{62A}\u{62E}\u{62F}\u{645} \u{644}\u{645}\u{62D}\u{627}\u{630}\u{627}\u{629} \u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{628}\u{62F}\u{621} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637} \u{648}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{626}\u{647} \u{645}\u{639} \u{646}\u{637}\u{627}\u{642} \u{632}\u{645}\u{646}\u{64A} \u{645}\u{639}\u{64A}\u{646}.`,
    de: `Ein Zeitrahmen, der verwendet wird, um das Start- und Enddatum der Aktivit\xe4t an einem bestimmten Zeitraum auszurichten.`,
    es: `Un per\xedodo de tiempo que se utiliza para alinear las fechas de inicio y finalizaci\xf3n de la actividad con un intervalo de fechas espec\xedfico.`,
    fa: `\u{6CC}\u{6A9} \u{628}\u{627}\u{632}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{628}\u{631}\u{627}\u{6CC} \u{62A}\u{631}\u{627}\u{632} \u{6A9}\u{631}\u{62F}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{627} \u{6CC}\u{6A9} \u{645}\u{62D}\u{62F}\u{648}\u{62F}\u{647} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{62E}\u{627}\u{635} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Isang time-frame na ginagamit upang ihanay ang mga petsa ng pagsisimula at pagtatapos ng aktibidad sa isang tiyak na hanay ng petsa.`,
    fr: `Plage horaire utilis\xe9e pour aligner les dates de d\xe9but et de fin d\u{2019}activit\xe9 sur une plage de dates sp\xe9cifique.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}\u{94B}\u{902} \u{915}\u{94B} \u{90F}\u{915} \u{935}\u{93F}\u{936}\u{93F}\u{937}\u{94D}\u{91F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915} \u{938}\u{940}\u{92E}\u{93E} \u{92E}\u{947}\u{902} \u{938}\u{902}\u{930}\u{947}\u{916}\u{93F}\u{924} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{940} \u{91C}\u{93E}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{940} \u{938}\u{92E}\u{92F}-\u{938}\u{940}\u{92E}\u{93E}.`,
    ht: `Yon ankram al\xe8 itilize nan aliyen aktivite k\xf2manse ak fen dat nan yon seri dat espesifik.`,
    it: `Un intervallo di tempo utilizzato per allineare le date di inizio e fine dell'attivit\xe0 a un intervallo di date specifico.`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}\u{306E}\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}\u{3092}\u{7279}\u{5B9A}\u{306E}\u{65E5}\u{4ED8}\u{7BC4}\u{56F2}\u{306B}\u{5408}\u{308F}\u{305B}\u{308B}\u{305F}\u{3081}\u{306B}\u{4F7F}\u{7528}\u{3055}\u{308C}\u{308B}\u{6642}\u{9593}\u{67A0}\u{3002}`,
    ko: `\u{D65C}\u{B3D9} \u{C2DC}\u{C791} \u{B0A0}\u{C9DC}\u{C640} \u{C885}\u{B8CC} \u{B0A0}\u{C9DC}\u{B97C} \u{D2B9}\u{C815} \u{B0A0}\u{C9DC} \u{BC94}\u{C704}\u{C5D0} \u{B9DE}\u{CD94}\u{B294} \u{B370} \u{C0AC}\u{C6A9}\u{B418}\u{B294} \u{C2DC}\u{AC04} \u{D504}\u{B808}\u{C784}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Ib lub sij hawm uas siv los align kev ua ub no pib thiab xaus rau ib hnub twg.`,
    ps: `\u{6CC}\u{648} \u{648}\u{62E}\u{62A} \u{686}\u{648}\u{6A9}\u{627}\u{67C} \u{686}\u{6D0} \u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{6D0} \u{62F} \u{6CC}\u{648}\u{6D0} \u{645}\u{634}\u{62E}\u{635}\u{6D0} \u{646}\u{6CC}\u{67C}\u{6D0} \u{633}\u{631}\u{647} \u{628}\u{631}\u{627}\u{628}\u{631}\u{648}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644} \u{6A9}\u{6CC}\u{696}\u{6CC}.`,
    pt: `Um per\xedodo de tempo usado para alinhar as datas de in\xedcio e t\xe9rmino da atividade a um intervalo de datas espec\xedfico.`,
    "pt-pt": `Um per\xedodo de tempo usado para alinhar as datas de in\xedcio e t\xe9rmino da atividade a um intervalo de datas espec\xedfico.`,
    ru: `\u{412}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{439} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{435}\u{43C}\u{44B}\u{439} \u{434}\u{43B}\u{44F} \u{43F}\u{440}\u{438}\u{432}\u{44F}\u{437}\u{43A}\u{438} \u{434}\u{430}\u{442} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{43A} \u{43E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{435}\u{43D}\u{43D}\u{43E}\u{43C}\u{443} \u{434}\u{438}\u{430}\u{43F}\u{430}\u{437}\u{43E}\u{43D}\u{443} \u{434}\u{430}\u{442}.`,
    sm: `O se taimi fa'atulagaina e fa'aaoga e fa'afetaui ai aso amata ma fa'ai'u o gaioiga i se aso fa'apitoa.`,
    so: `Waqti-go'an oo loo isticmaalo in lays waafajiyo bilawga dhaqdhaqaaqa iyo gabagabeyn taariikheed ilaa taariikh gaar ah.`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E1A}\u{E40}\u{E27}\u{E25}\u{E32}\u{E17}\u{E35}\u{E48}\u{E43}\u{E0A}\u{E49}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E08}\u{E31}\u{E14}\u{E15}\u{E4D}\u{E32}\u{E41}\u{E2B}\u{E19}\u{E48}\u{E07}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}\u{E02}\u{E2D}\u{E07}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E43}\u{E2B}\u{E49}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E38}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{679}\u{627}\u{626}\u{645} \u{641}\u{631}\u{6CC}\u{645} \u{62C}\u{648} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{6D2} \u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{648}\u{6BA} \u{6A9}\u{648} \u{627}\u{6CC}\u{6A9} \u{645}\u{62E}\u{635}\u{648}\u{635} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{6CC} \u{62D}\u{62F} \u{633}\u{6D2} \u{6C1}\u{645} \u{622}\u{6C1}\u{646}\u{6AF} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6C1}\u{648}\u{62A}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Khung th\u{1EDD}i gian \u{111}\u{1B0}\u{1EE3}c s\u{1EED} d\u{1EE5}ng \u{111}\u{1EC3} c\u{103}n ch\u{1EC9}nh ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac ho\u{1EA1}t \u{111}\u{1ED9}ng v\u{1EDB}i m\u{1ED9}t ph\u{1EA1}m vi ng\xe0y c\u{1EE5} th\u{1EC3}.`,
    "zh-hans": `\u{7528}\u{4E8E}\u{5C06}\u{6D3B}\u{52A8}\u{5F00}\u{59CB}\u{65E5}\u{671F}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}\u{4E0E}\u{7279}\u{5B9A}\u{65E5}\u{671F}\u{8303}\u{56F4}\u{5BF9}\u{9F50}\u{7684}\u{65F6}\u{95F4}\u{8303}\u{56F4}\u{3002}`,
    "zh-hant": `\u{7528}\u{65BC}\u{5C07}\u{6D3B}\u{52D5}\u{958B}\u{59CB}\u{65E5}\u{671F}\u{548C}\u{7D50}\u{675F}\u{65E5}\u{671F}\u{8207}\u{7279}\u{5B9A}\u{65E5}\u{671F}\u{7BC4}\u{570D}\u{5C0D}\u{9F4A}\u{7684}\u{6642}\u{9593}\u{7BC4}\u{570D}\u{3002}`,
    en: `A time-frame used to align activity start and end dates to a specific date range.`
};
const $2868cc1235412e16$export$c2d146f46bb77f34 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{648}\u{643}\u{627}\u{644}\u{627}\u{62A}`,
    de: `Alle Agenturen`,
    es: `Todas las agencias`,
    fa: `\u{647}\u{645}\u{647} \u{622}\u{698}\u{627}\u{646}\u{633} \u{647}\u{627}`,
    fil: `Lahat ng mga ahensya`,
    fr: `Toutes les agences`,
    hi: `\u{938}\u{92D}\u{940} \u{90F}\u{91C}\u{947}\u{902}\u{938}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: `Tout ajans yo`,
    it: `Tutte le agenzie`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{4EE3}\u{7406}\u{5E97}`,
    ko: `\u{BAA8}\u{B4E0} \u{C5D0}\u{C774}\u{C804}\u{C2DC}`,
    mww: `Tag nrho cov koom haum`,
    ps: `\u{67C}\u{648}\u{644}\u{6D0} \u{627}\u{62F}\u{627}\u{631}\u{6D0}`,
    pt: `Todas as ag\xeancias`,
    "pt-pt": `Todas as ag\xeancias`,
    ru: `\u{412}\u{441}\u{435} \u{430}\u{433}\u{435}\u{43D}\u{442}\u{441}\u{442}\u{432}\u{430}`,
    sm: `Ofisa uma`,
    so: `Dhamaan hay'adaha`,
    th: `\u{E17}\u{E38}\u{E01}\u{E2B}\u{E19}\u{E48}\u{E27}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{627}\u{6CC}\u{62C}\u{646}\u{633}\u{6CC}\u{627}\u{6BA}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c c\u{1A1} quan`,
    "zh-hans": `\u{6240}\u{6709}\u{673A}\u{6784}`,
    "zh-hant": `\u{6240}\u{6709}\u{6A5F}\u{69CB}`,
    en: `All agencies`
};
const $2868cc1235412e16$export$2bcd46d6d21f9b9e = {
    ar: `1 \u{646}\u{634}\u{627}\u{637}`,
    de: `1 Aktivit\xe4t`,
    es: `1 actividad`,
    fa: `1 \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `1 aktibidad`,
    fr: `1 activit\xe9`,
    hi: `1 \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}`,
    ht: `1 aktivite`,
    it: `1 attivit\xe0`,
    ja: `\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D3}\u{30C6}\u{30A3}1`,
    ko: `1 \u{D65C}\u{B3D9}`,
    mww: `1 yam kev ua ub no`,
    ps: `1 \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `1 atividade`,
    "pt-pt": `1 atividade`,
    ru: `1 \u{437}\u{430}\u{434}\u{430}\u{43D}\u{438}\u{435}`,
    sm: `1 Gaoioiga`,
    so: `1 shaqo`,
    th: `1 \u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `1 \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}`,
    vi: `1 ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `1 \u{6B21}\u{6D3B}\u{52A8}`,
    "zh-hant": `1 \u{6B21}\u{6D3B}\u{52D5}`,
    en: `1 activity`
};
const $2868cc1235412e16$export$3a7601aff7973201 = {
    ar: (count)=>`${count} \u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: (count)=>`${count} Aktivit\xe4ten`,
    es: (count)=>`${count} actividades`,
    fa: (count)=>`${count} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: (count)=>`${count} Mga Aktibidad`,
    fr: (count)=>`${count} activit\xe9s`,
    hi: (count)=>`${count} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{93E}\u{902}`,
    ht: (count)=>`${count} aktivite`,
    it: (count)=>`${count} attivit\xe0`,
    ja: (count)=>`${count} \u{4EF6}`,
    ko: (count)=>`${count} \u{AC1C} \u{C561}\u{D2F0}\u{BE44}\u{D2F0}`,
    mww: (count)=>`${count} kev ua ub no`,
    ps: (count)=>`${count} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647}`,
    pt: (count)=>`${count} atividades`,
    "pt-pt": (count)=>`${count} atividades`,
    ru: (count)=>`${count}`,
    sm: (count)=>`${count} Gaoioiga`,
    so: (count)=>`${count}`,
    th: (count)=>`${count} \u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: (count)=>`${count}`,
    vi: (count)=>`${count} ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": (count)=>`${count} \u{6D3B}\u{52A8}`,
    "zh-hant": (count)=>`${count} \u{6D3B}\u{52D5}`,
    en: (count)=>`${count} activities`
};
const $2868cc1235412e16$export$cabc58d813df6052 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{646}\u{634}\u{637}\u{629}`,
    de: `Keine Aktivit\xe4ten`,
    es: `Ninguna actividad`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    fil: `Walang mga aktibidad`,
    fr: `Aucune activit\xe9`,
    hi: `\u{915}\u{94B}\u{908} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen aktivite`,
    it: `Nessuna attivit\xe0`,
    ja: `\u{6D3B}\u{52D5}\u{306A}\u{3057}`,
    ko: `\u{D65C}\u{B3D9} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj kev ua ub no`,
    ps: `\u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}`,
    pt: `Sem atividades`,
    "pt-pt": `Sem atividades`,
    ru: `\u{41D}\u{435}\u{442} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439}`,
    sm: `Leai ni gaoioiga`,
    so: `Wax shaqo ahna ma qabanqaab`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 ho\u{1EA1}t \u{111}\u{1ED9}ng`,
    "zh-hans": `\u{65E0}\u{6D3B}\u{52A8}`,
    "zh-hant": `\u{7121}\u{6D3B}\u{52D5}`,
    en: `No activities`
};
const $2868cc1235412e16$export$94c8daae5f9ab256 = {
    ar: `\u{645}\u{631}\u{62D}\u{644}\u{629} \u{632}\u{645}\u{646}\u{64A}\u{629}`,
    de: `Periode`,
    es: `Periodo`,
    fa: `\u{62F}\u{648}\u{631}\u{647}`,
    fil: `Panahon`,
    fr: `P\xe9riode`,
    hi: `\u{915}\u{93E}\u{932}`,
    ht: `Pery\xf2d`,
    it: `Periodo`,
    ja: `\u{6642}\u{4EE3}`,
    ko: `\u{B9C8}\u{CE68}\u{D45C}`,
    mww: `caij`,
    ps: `\u{62F}\u{648}\u{631}\u{647}`,
    pt: `Per\xedodo`,
    "pt-pt": `Ponto final`,
    ru: `\u{41F}\u{435}\u{440}\u{438}\u{43E}\u{434}`,
    sm: `Vaitaimi`,
    so: `Mudada`,
    th: `\u{E0A}\u{E48}\u{E27}\u{E07}`,
    ur: `\u{62F}\u{648}\u{631}`,
    vi: `Th\xec`,
    "zh-hans": `\u{65F6}\u{671F}`,
    "zh-hant": `\u{6642}\u{671F}`,
    en: `Period`
};
const $2868cc1235412e16$export$42922b4d18e68d58 = {
    ar: `\u{62C}\u{645}\u{64A}\u{639} \u{627}\u{644}\u{641}\u{62A}\u{631}\u{627}\u{62A}`,
    de: `Alle Zeitr\xe4ume`,
    es: `Todos los per\xedodos`,
    fa: `\u{647}\u{645}\u{647} \u{62F}\u{648}\u{631}\u{647} \u{647}\u{627}`,
    fil: `Lahat ng mga panahon`,
    fr: `Toutes les p\xe9riodes`,
    hi: `\u{938}\u{92D}\u{940} \u{905}\u{935}\u{927}\u{93F}`,
    ht: `Tout pery\xf2d`,
    it: `Tutti i periodi`,
    ja: `\u{3059}\u{3079}\u{3066}\u{306E}\u{671F}\u{9593}`,
    ko: `\u{BAA8}\u{B4E0} \u{AE30}\u{AC04}`,
    mww: `Txhua lub sij hawm`,
    ps: `\u{67C}\u{648}\u{644} \u{62F}\u{648}\u{631}\u{6D0}`,
    pt: `Todos os per\xedodos`,
    "pt-pt": `Todos os per\xedodos`,
    ru: `\u{412}\u{441}\u{435} \u{43F}\u{435}\u{440}\u{438}\u{43E}\u{434}\u{44B}`,
    sm: `Vaitaimi uma`,
    so: `Dhammaan muddooyinka`,
    th: `\u{E17}\u{E38}\u{E01}\u{E0A}\u{E48}\u{E27}\u{E07}\u{E40}\u{E27}\u{E25}\u{E32}`,
    ur: `\u{62A}\u{645}\u{627}\u{645} \u{627}\u{62F}\u{648}\u{627}\u{631}`,
    vi: `T\u{1EA5}t c\u{1EA3} c\xe1c giai \u{111}o\u{1EA1}n`,
    "zh-hans": `\u{6240}\u{6709}\u{671F}\u{95F4}`,
    "zh-hant": `\u{6240}\u{6709}\u{671F}\u{9593}`,
    en: `All periods`
};
const $2868cc1235412e16$export$f3b2c456a689c995 = {
    ar: `\u{637}\u{628}\u{627}\u{639}\u{629} \u{627}\u{644}\u{645}\u{644}\u{62E}\u{635} \u{645}\u{639} \u{627}\u{644}\u{645}\u{62D}\u{641}\u{648}\u{638}\u{627}\u{62A}`,
    de: `Zusammenfassung mit Historie drucken`,
    es: `Imprimir resumen con historial`,
    fa: `\u{62E}\u{644}\u{627}\u{635}\u{647} \u{631}\u{627} \u{628}\u{627} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647} \u{686}\u{627}\u{67E} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-print ang buod na may kasaysayan`,
    fr: `Imprimer le r\xe9sum\xe9 avec l\u{2019}historique`,
    hi: `\u{907}\u{924}\u{93F}\u{939}\u{93E}\u{938} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{93E}\u{930}\u{93E}\u{902}\u{936} \u{92A}\u{94D}\u{930}\u{93F}\u{902}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rezime enprime ak istwa`,
    it: `Stampa il riepilogo con la cronologia`,
    ja: `\u{5C65}\u{6B74}\u{4ED8}\u{304D}\u{306E}\u{8981}\u{7D04}\u{306E}\u{5370}\u{5237}`,
    ko: `\u{AE30}\u{B85D}\u{ACFC} \u{D568}\u{AED8} \u{C694}\u{C57D} \u{C778}\u{C1C4}`,
    mww: `Sau ntawv nrog keeb kwm`,
    ps: `\u{62F} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{633}\u{631}\u{647} \u{644}\u{646}\u{689}\u{6CC}\u{632} \u{686}\u{627}\u{67E} \u{6A9}\u{693}\u{626}`,
    pt: `Imprimir resumo com hist\xf3rico`,
    "pt-pt": `Imprimir resumo com hist\xf3rico`,
    ru: `\u{420}\u{430}\u{441}\u{43F}\u{435}\u{447}\u{430}\u{442}\u{430}\u{442}\u{44C} \u{441}\u{432}\u{43E}\u{434}\u{43A}\u{443} \u{441} \u{438}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{435}\u{439}`,
    sm: `Lolomi le aotelega ma le talafaasolopito`,
    so: `Kooban kooban oo leh taariikh`,
    th: `\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E2A}\u{E23}\u{E38}\u{E1B}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{62E}\u{644}\u{627}\u{635}\u{6C1} \u{67E}\u{631}\u{646}\u{679} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `In t\xf3m t\u{1EAF}t l\u{1ECB}ch s\u{1EED}`,
    "zh-hans": `\u{6253}\u{5370}\u{5E26}\u{5386}\u{53F2}\u{8BB0}\u{5F55}\u{7684}\u{6458}\u{8981}`,
    "zh-hant": `\u{5217}\u{5370}\u{5E36}\u{6B77}\u{53F2}\u{8A18}\u{9304}\u{7684}\u{6458}\u{8981}`,
    en: `Print summary with history`
};
const $2868cc1235412e16$export$ea478d0e3175475c = {
    ar: `\u{625}\u{631}\u{633}\u{627}\u{644} \u{644}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Zur Signatur senden`,
    es: `Enviar para firmar`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{645}\u{636}\u{627}`,
    fil: `Email Address *`,
    fr: `Envoyer pour signature`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye pou siyati`,
    it: `Invia per firma`,
    ja: `\u{7F72}\u{540D}\u{7528}\u{306B}\u{9001}\u{4FE1}`,
    ko: `\u{C11C}\u{BA85}\u{C744} \u{C704}\u{D574} \u{C804}\u{C1A1}`,
    mww: `Xa npe rau kos npe`,
    ps: `\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644}`,
    pt: `Enviar para assinatura`,
    "pt-pt": `Enviar para assinatura`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}`,
    sm: `Auina atu mo le saini`,
    so: `U dir saxiix`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i \u{111}\u{1EC3} xin ch\u{1EEF} k\xfd`,
    "zh-hans": `\u{53D1}\u{9001}\u{4EE5}\u{4F9B}\u{7B7E}\u{540D}`,
    "zh-hant": `\u{767C}\u{9001}\u{4EE5}\u{4F9B}\u{7C3D}\u{540D}`,
    en: `Send for signature`
};
const $2868cc1235412e16$export$e76dfe62b7986ed9 = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{631}\u{627}\u{628}\u{637}\u{627} \u{644}\u{634}\u{62E}\u{635} \u{645}\u{627} \u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}\u{627}.`,
    de: `Senden Sie jemandem einen Link, um diesen Datensatz elektronisch zu signieren.`,
    es: `Env\xede a alguien un enlace para firmar este registro electr\xf3nicamente.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{627}\u{644}\u{6A9}\u{62A}\u{631}\u{648}\u{646}\u{6CC}\u{6A9}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{6A9}\u{633}\u{6CC} \u{67E}\u{6CC}\u{648}\u{646}\u{62F} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Magpadala ng link sa isang tao para lagdaan ang talaang ito sa elektronikong paraan.`,
    fr: `Envoyez \xe0 quelqu\u{2019}un un lien pour signer ce document \xe9lectroniquement.`,
    hi: `\u{907}\u{932}\u{947}\u{915}\u{94D}\u{91F}\u{94D}\u{930}\u{949}\u{928}\u{93F}\u{915} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{930} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{93F}\u{938}\u{940} \u{915}\u{94B} \u{932}\u{93F}\u{902}\u{915} \u{92D}\u{947}\u{91C}\u{947}\u{902}.`,
    ht: `Voye yon moun yon lyen pou siyen dosye sa a elektwonikman.`,
    it: `Invia a qualcuno un link per firmare questo record elettronicamente.`,
    ja: `\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306B}\u{96FB}\u{5B50}\u{7F72}\u{540D}\u{3059}\u{308B}\u{305F}\u{3081}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{4ED6}\u{306E}\u{30E6}\u{30FC}\u{30B6}\u{30FC}\u{306B}\u{9001}\u{4FE1}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{AE30}\u{B85D}\u{C5D0} \u{C804}\u{C790}\u{C801}\u{C73C}\u{B85C} \u{C11C}\u{BA85}\u{D560} \u{C218} \u{C788}\u{B294} \u{B9C1}\u{D06C}\u{B97C} \u{B2E4}\u{B978} \u{C0AC}\u{B78C}\u{C5D0}\u{AC8C} \u{BCF4}\u{B0C5}\u{B2C8}\u{B2E4}.`,
    mww: `Xa ib qhov txuas mus kos npe rau daim ntawv no electronically.`,
    ps: `\u{6CC}\u{648} \u{686}\u{627} \u{62A}\u{647} \u{6CC}\u{648} \u{644}\u{6CC}\u{646}\u{6A9} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{626} \u{62A}\u{631}\u{685}\u{648} \u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{67E}\u{647} \u{628}\u{631}\u{6CC}\u{69A}\u{646}\u{627}\u{6CC}\u{6CC} \u{62A}\u{648}\u{6AB}\u{647} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{6A9}\u{693}\u{6CC}.`,
    pt: `Envie a algu\xe9m um link para assinar este registro eletronicamente.`,
    "pt-pt": `Envie a algu\xe9m um link para assinar este registro eletronicamente.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{44C}\u{442}\u{435} \u{43A}\u{43E}\u{43C}\u{443}-\u{43D}\u{438}\u{431}\u{443}\u{434}\u{44C} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{44F} \u{44D}\u{442}\u{43E}\u{439} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{432} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{43C} \u{432}\u{438}\u{434}\u{435}.`,
    sm: `Auina atu i se tasi se sootaga e saini faaeletonika ai lenei faamaumauga.`,
    so: `U dir qof isku xir si aad u saxiixdo rikoodhkan elektaroonik ahaan.`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E43}\u{E2B}\u{E49}\u{E1C}\u{E39}\u{E49}\u{E2D}\u{E37}\u{E48}\u{E19}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E43}\u{E19}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E19}\u{E35}\u{E49}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E34}\u{E40}\u{E25}\u{E47}\u{E01}\u{E17}\u{E23}\u{E2D}\u{E19}\u{E34}\u{E01}\u{E2A}\u{E4C}`,
    ur: `\u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{67E}\u{631} \u{627}\u{644}\u{6CC}\u{6A9}\u{679}\u{631}\u{627}\u{646}\u{6A9} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{6A9}\u{633}\u{6CC} \u{6A9}\u{648} \u{644}\u{646}\u{6A9} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `G\u{1EED}i cho ai \u{111}\xf3 m\u{1ED9}t li\xean k\u{1EBF}t \u{111}\u{1EC3} k\xfd v\xe0o h\u{1ED3} s\u{1A1} n\xe0y b\u{1EB1}ng \u{111}i\u{1EC7}n t\u{1EED}.`,
    "zh-hans": `\u{5411}\u{67D0}\u{4EBA}\u{53D1}\u{9001}\u{94FE}\u{63A5}\u{4EE5}\u{7535}\u{5B50}\u{65B9}\u{5F0F}\u{7B7E}\u{7F72}\u{6B64}\u{8BB0}\u{5F55}\u{3002}`,
    "zh-hant": `\u{5411}\u{67D0}\u{4EBA}\u{767C}\u{9001}\u{9023}\u{7D50}\u{4EE5}\u{96FB}\u{5B50}\u{65B9}\u{5F0F}\u{7C3D}\u{7F72}\u{6B64}\u{8A18}\u{9304}\u{3002}`,
    en: `Send someone a link to sign this record electronically.`
};
const $2868cc1235412e16$export$9feabe39d774db92 = {
    ar: `\u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{643} \u{627}\u{644}\u{627}\u{641}\u{62A}\u{631}\u{627}\u{636}\u{64A}`,
    de: `Signieren Sie mit Ihrer Standardsignatur`,
    es: `Firmar con su firma predeterminada`,
    fa: `\u{628}\u{627} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{67E}\u{6CC}\u{634} \u{641}\u{631}\u{636} \u{62E}\u{648}\u{62F} \u{627}\u{645}\u{636}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Mag-sign gamit ang iyong default na lagda`,
    fr: `Signez avec votre signature par d\xe9faut`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{921}\u{93F}\u{92B}\u{93C}\u{949}\u{932}\u{94D}\u{91F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Siyen ak siyati default ou`,
    it: `Firma con la tua firma predefinita`,
    ja: `\u{30C7}\u{30D5}\u{30A9}\u{30EB}\u{30C8}\u{306E}\u{7F72}\u{540D}\u{3067}\u{7F72}\u{540D}\u{3059}\u{308B}`,
    ko: `\u{AE30}\u{BCF8} \u{C11C}\u{BA85}\u{C73C}\u{B85C} \u{C11C}\u{BA85}`,
    mww: `Kos npe rau koj cov default kos npe`,
    ps: `\u{62F} \u{62E}\u{67E}\u{644} \u{627}\u{635}\u{644}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{6A9}\u{693}\u{626}`,
    pt: `Assinar com sua assinatura padr\xe3o`,
    "pt-pt": `Assine com sua assinatura padr\xe3o`,
    ru: `\u{41F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{438}\u{435} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{43F}\u{43E} \u{443}\u{43C}\u{43E}\u{43B}\u{447}\u{430}\u{43D}\u{438}\u{44E}`,
    sm: `Saini i lau saini faaletonu`,
    so: `Saxiix la saxiixa default aad`,
    th: `\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E14}\u{E49}\u{E27}\u{E22}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{637}\u{6D2} \u{634}\u{62F}\u{6C1} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `K\xfd b\u{1EB1}ng ch\u{1EEF} k\xfd m\u{1EB7}c \u{111}\u{1ECB}nh c\u{1EE7}a b\u{1EA1}n`,
    "zh-hans": `\u{4F7F}\u{7528}\u{60A8}\u{7684}\u{9ED8}\u{8BA4}\u{7B7E}\u{540D}\u{7B7E}\u{540D}`,
    "zh-hant": `\u{4F7F}\u{7528}\u{60A8}\u{7684}\u{9810}\u{8A2D}\u{7C3D}\u{540D}\u{7C3D}\u{540D}`,
    en: `Sign with your default signature`
};
const $2868cc1235412e16$export$4334bd49e607fffd = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637}`,
    de: `Link abgelaufen`,
    es: `Enlace caducado`,
    fa: `\u{644}\u{6CC}\u{646}\u{6A9} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Nag-expire na ang link`,
    fr: `Lien expir\xe9`,
    hi: `\u{932}\u{93F}\u{902}\u{915} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908}`,
    ht: `Lyen ekspirasyon`,
    it: `Link scaduto`,
    ja: `\u{30EA}\u{30F3}\u{30AF}\u{306E}\u{6709}\u{52B9}\u{671F}\u{9650}\u{304C}\u{5207}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}`,
    ko: `\u{B9C1}\u{D06C}\u{AC00} \u{B9CC}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Txuas ntxiv mus`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Link expirado`,
    "pt-pt": `Link expirado`,
    ru: `\u{421}\u{440}\u{43E}\u{43A} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{438} \u{438}\u{441}\u{442}\u{435}\u{43A}`,
    sm: `Ua mae'a le feso'ota'iga`,
    so: `Link-ka dhacay`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{644}\u{646}\u{6A9} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{6CC}\u{627}`,
    vi: `Li\xean k\u{1EBF}t \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n`,
    "zh-hans": `\u{94FE}\u{63A5}\u{5DF2}\u{8FC7}\u{671F}`,
    "zh-hant": `\u{9023}\u{7D50}\u{5DF2}\u{904E}\u{671F}`,
    en: `Link expired`
};
const $2868cc1235412e16$export$14f8ee10fb1dede3 = {
    ar: (when)=>$2868cc1235412e16$var$html`<span>انتهت صلاحية الرابط ${when}</span>`,
    de: (when)=>$2868cc1235412e16$var$html`<span>Link ${when}</span>`,
    es: (when)=>$2868cc1235412e16$var$html`<span>El enlace caducó ${when}</span>`,
    fa: (when)=>$2868cc1235412e16$var$html`<span>لینک منقضی ${when}</span>`,
    fil: (when)=>$2868cc1235412e16$var$html`<span>Nag-expire ang link ${when}</span>`,
    fr: (when)=>$2868cc1235412e16$var$html`<span>Lien expiré ${when}</span>`,
    hi: (when)=>$2868cc1235412e16$var$html`<span>लिंक की समय सीमा समाप्त ${when}</span>`,
    ht: (when)=>$2868cc1235412e16$var$html`<span>Lyen ${when}</span>`,
    it: (when)=>$2868cc1235412e16$var$html`<span>Link scaduto ${when}</span>`,
    ja: (when)=>$2868cc1235412e16$var$html`<span>リンクの有効期限が切れました ${when}</span>`,
    ko: (when)=>$2868cc1235412e16$var$html`<span>링크가 ${when} 만료되었습니다.</span>`,
    mww: (when)=>$2868cc1235412e16$var$html`<span>Txuas expired ${when}</span>`,
    ps: (when)=>$2868cc1235412e16$var$html`<span>لینک 5 ${when} پای ته ورسید</span>`,
    pt: (when)=>$2868cc1235412e16$var$html`<span>Link expirou ${when}</span>`,
    "pt-pt": (when)=>$2868cc1235412e16$var$html`<span>Link expirou ${when}</span>`,
    ru: (when)=>$2868cc1235412e16$var$html`<span>Срок действия ссылки истек ${when}</span>`,
    sm: (when)=>$2868cc1235412e16$var$html`<span>Link expired ${when}</span>`,
    so: (when)=>$2868cc1235412e16$var$html`<span>Link-ku wuxuu dhacay ${when}</span>`,
    th: (when)=>$2868cc1235412e16$var$html`<span>ลิงก์หมดอายุเมื่อ ${when}</span>`,
    ur: (when)=>$2868cc1235412e16$var$html`<span>لنک ${when} ختم ہو گیا</span>`,
    vi: (when)=>$2868cc1235412e16$var$html`<span>Liên kết hết hạn cách ${when}</span>`,
    "zh-hans": (when)=>$2868cc1235412e16$var$html`<span>链接在 ${when}过期</span>`,
    "zh-hant": (when)=>$2868cc1235412e16$var$html`<span>連結在 ${when}過期</span>`,
    en: (when)=>$2868cc1235412e16$var$html`<span>Link expired ${when}</span>`
};
const $2868cc1235412e16$export$461c419fb0e50d24 = {
    ar: `\u{627}\u{646}\u{633}\u{62E} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637}`,
    de: `Link kopieren`,
    es: `Copiar enlace`,
    fa: `\u{6A9}\u{67E}\u{6CC} \u{644}\u{6CC}\u{646}\u{6A9}`,
    fil: `Email Address *`,
    fr: `Copier le lien`,
    hi: `\u{932}\u{93F}\u{902}\u{915} \u{915}\u{949}\u{92A}\u{940} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Kopi lyen`,
    it: `Copia link`,
    ja: `\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{30B3}\u{30D4}\u{30FC}`,
    ko: `\u{B9C1}\u{D06C} \u{BCF5}\u{C0AC}`,
    mww: `Luam ib daim qauv ntawm daim qauv`,
    ps: `\u{644}\u{6CC}\u{646}\u{6A9} \u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{693}\u{626}`,
    pt: `Copiar link`,
    "pt-pt": `Copiar link`,
    ru: `\u{421}\u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}`,
    sm: `Kopi sootaga`,
    so: `Koobi link`,
    th: `\u{E04}\u{E31}\u{E14}\u{E25}\u{E2D}\u{E01}\u{E25}\u{E34}\u{E07}\u{E04}\u{E4C}`,
    ur: `\u{6A9}\u{627}\u{67E}\u{6CC} \u{644}\u{646}\u{6A9}`,
    vi: `Sao ch\xe9p li\xean k\u{1EBF}t`,
    "zh-hans": `\u{590D}\u{5236}\u{94FE}\u{63A5}`,
    "zh-hant": `\u{8907}\u{88FD}\u{9023}\u{7D50}`,
    en: `Copy link`
};
const $2868cc1235412e16$export$83664f80d17a8cfa = {
    ar: `\u{62E}\u{637}\u{623}`,
    de: `Fehler`,
    es: `Error`,
    fa: `\u{62E}\u{637}\u{627}`,
    fil: `Error`,
    fr: `Erreur`,
    hi: `\u{91A}\u{942}\u{915}`,
    ht: `Er\xe8`,
    it: `Errore`,
    ja: `\u{30A8}\u{30E9}\u{30FC}`,
    ko: `\u{C624}\u{B958}`,
    mww: `Yuam kev`,
    ps: `\u{62E}\u{637}\u{627}`,
    pt: `Erro`,
    "pt-pt": `Erro`,
    ru: `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    sm: `Mea sese`,
    so: `Khalad`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E1C}\u{E34}\u{E14}\u{E1E}\u{E25}\u{E32}\u{E14}`,
    ur: `\u{63A}\u{644}\u{637}\u{6CC}`,
    vi: `L\u{1ED7}i`,
    "zh-hans": `\u{9519}\u{8BEF}`,
    "zh-hant": `\u{932F}\u{8AA4}`,
    en: `Error`
};
const $2868cc1235412e16$export$48582d35b48df56b = {
    ar: `\u{645}\u{647}\u{645}`,
    de: `Wichtig`,
    es: `Importante`,
    fa: `\u{645}\u{647}\u{645}`,
    fil: `Mahalaga`,
    fr: `Important`,
    hi: `\u{92E}\u{939}\u{924}\u{94D}\u{935}\u{92A}\u{942}\u{930}\u{94D}\u{923}`,
    ht: `Enp\xf2tan`,
    it: `Importante`,
    ja: `\u{5927}\u{4E8B}\u{306A}`,
    ko: `\u{C911}\u{C694}\u{D558}\u{B2E4}`,
    mww: `Tseem ceeb`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}`,
    pt: `Importante`,
    "pt-pt": `Importante`,
    ru: `\u{412}\u{430}\u{436}\u{43D}\u{44B}\u{439}`,
    sm: `Taua`,
    so: `Muhiim`,
    th: `\u{E2A}\u{E4D}\u{E32}\u{E04}\u{E31}\u{E0D}`,
    ur: `\u{627}\u{6C1}\u{645}`,
    vi: `Quan tr\u{1ECD}ng`,
    "zh-hans": `\u{91CD}\u{8981}`,
    "zh-hant": `\u{91CD}\u{8981}`,
    en: `Important`
};
const $2868cc1235412e16$export$41a9ee080c52dfb4 = {
    ar: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`أرسل ${senderName} هذا النموذج للتوقيع. راجع المعلومات أدناه <a href="#sign-button">ووقع في الأسفل</a>. إذا كانت لديك أسئلة ، فاتصل ${senderGivenName} عبر البريد الإلكتروني على <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. ستنتهي صلاحية هذا النموذج ${expires}`,
    de: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} hat Ihnen dieses Formular zur Unterschrift zugesandt. Überprüfen Sie die Informationen unten und <a href="#sign-button">unterschreiben Sie unten</a>. Wenn Sie Fragen haben, wenden Sie sich bitte per E-Mail an ${senderGivenName} <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Dieses Formular läuft ${expires} ab.`,
    es: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} le envió este formulario para que lo firmara. Revise la información a continuación y <a href="#sign-button">firme en la parte inferior</a>. Si tiene preguntas, comuníquese con ${senderGivenName} por correo electrónico a <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulario caducará ${expires}`,
    fa: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} این فرم را برای شما ارسال کرد تا امضا کنید. اطلاعات زیر را مرور کنید و <a href="#sign-button">در پایین امضا</a> کنید. اگر سوالی دارید ${senderGivenName} ایمیل با <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. این فرم ${expires} منقضی می شود.`,
    fil: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`Ipinadala sa iyo ${senderName} ang form na ito upang pirmahan. Suriin ang impormasyon sa ibaba at <a href="#sign-button">mag-sign sa ibaba</a>. Kung mayroon kang mga katanungan, makipag-ugnay kay ${senderGivenName} sa pamamagitan ng email sa <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ang form na ito ay mag-e-expire ${expires}`,
    fr: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} vous a envoyé ce formulaire à signer. Vérifiez les informations ci-dessous et <a href="#sign-button">signez en bas</a>. Si vous avez des questions, contactez ${senderGivenName} par e-mail à <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Ce formulaire expirera ${expires}`,
    hi: (senderName, senderEmail, senderGivenName, expires)=>$2868cc1235412e16$var$html`${senderName} ने आपको हस्ताक्षर करने के लिए यह फॉर्म भेजा था। नीचे दी गई जानकारी की समीक्षा करें और <a href="#sign-button">नीचे हस्ताक्षर करें</a>। यदि आपके कोई प्रश्न हैं, तो <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> पर ईमेल के माध्यम से ${senderGivenName} से संपर्क करें। यह फॉर्म ${expires} समाप्त हो जाएगा।`,
    ht: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} te voye ou fòm sa a pou siyen. Revize enfòmasyon ki anba a epi <a href="#sign-button">siyen nan pati anba a</a>. Si ou gen kesyon, kontakte ${senderGivenName} atravè imèl nan <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Fòm sa a pral ekspilse ${expires}.`,
    it: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} ti ha inviato questo modulo da firmare. Rivedi le informazioni di seguito e <a href="#sign-button">firma in fondo</a>. In caso di domande, contattare ${senderGivenName} via e-mail <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Questo modulo scadrà ${expires}`,
    ja: (senderName, senderEmail, senderGivenName, expires)=>$2868cc1235412e16$var$html`${senderName}、署名のためにこのフォームを送った。以下の情報を確認し、<a href="#sign-button">下部に署名してください</a>。ご不明な点がございましたら、<a class="Link--primary" href="${senderEmail}">${senderEmail}</a> までメールで${senderGivenName}。このフォームの有効期限は${expires} です。`,
    ko: (senderName, senderEmail, senderGivenName, expires)=>$2868cc1235412e16$var$html`${senderName}가 서명을 위해 이 양식을 보냈습니다. 아래 정보를 검토하고 <a href="#sign-button">맨 아래에 서명합니다</a>. 질문이 있는 경우 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> 로 이메일을 보내 ${senderGivenName}에게 문의하십시오. 이 양식은 ${expires}에 만료됩니다.`,
    mww: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} xa koj daim ntawv no kos npe. Saib cov lus hauv qab no thiab <a href="#sign-button">kos npe rau hauv qab</a> no. Yog koj muaj lus nug, hu ${senderGivenName} ntawm email ntawm <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Daim ntawv no yuav tshwm sim ${expires}.`,
    ps: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} تاسو ته دا فورمه د لاسلیک لپاره لیږلې ده. لاندې معلومات وګورئ او <a href="#sign-button">په لاندینۍ برخه کې لاسلیک</a> کړئ. که تاسو پوښتنې لرئ ، د ${senderGivenName} سره د برېښنالیک له لارې <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> اړیکه ونیسئ. دا فورمه ${expires} پای ته رسیږی.`,
    pt: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} enviou-lhe este formulário para assinar. Revise as informações abaixo e <a href="#sign-button">assine na parte inferior</a>. Se você tiver dúvidas, entre em contato com ${senderGivenName} por e-mail em <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expirará ${expires}`,
    "pt-pt": (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} enviou-lhe este formulário para assinar. Reveja as informações abaixo e <a href="#sign-button">assine na parte inferior</a>. Em caso de dúvidas, entre em contato com ${senderGivenName} por e-mail no <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Este formulário expira ${expires}`,
    ru: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} отправил вам эту форму для подписи. Ознакомьтесь с приведенной ниже информацией и <a href="#sign-button">подпишитесь внизу</a>. Если у вас есть вопросы, свяжитесь с ${senderGivenName} по электронной почте <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Срок действия этой формы истекает ${expires}`,
    sm: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`Na auina atu ${senderName} te oe lenei fomu e saini ai. Toe iloilo le faamatalaga o loo i lalo ma <a href="#sign-button">saini i le pito i lalo</a>. Afai ei ai ni au fesili, fa'afeso'ota'i ${senderGivenName} e ala i le imeli i le <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. O lenei fomu o le a muta ${expires}`,
    so: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} ayaa qaabkan kuu soo diray inaad saxiixdo. Dib u eegis macluumaadka hoose iyo <a href="#sign-button">calaamad ugu hooseysa</a>. Haddii aad qabto su'aalo, la xiriir ${senderGivenName} via email <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Foomkani wuxuu dhacayaa ${expires}.`,
    th: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName}แบบฟอร์มนี้ให้คุณลงนาม ตรวจสอบข้อมูลด้านล่างและ<a href="#sign-button">ลงชื่อที่ด้านล่าง</a> หากคุณมีคําถาม โปรดติดต่อ${senderGivenName}ทางอีเมลที่ <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> แบบฟอร์มนี้จะหมดอายุในวัน${expires}`,
    ur: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} نے آپ کو دستخط کرنے کے لئے یہ فارم بھیجا تھا۔ نیچے دی گئی معلومات کا جائزہ لیں اور <a href="#sign-button">نیچے دستخط کریں</a>۔ اگر آپ کے سوالات ہیں تو، john.smith@example.com پر ای میل کے ذریعہ ${senderGivenName} سے رابطہ <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. یہ فارم ${expires} ختم ہو جائے گا۔`,
    vi: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} đã gửi cho bạn mẫu đơn này để ký. Xem lại thông tin bên dưới và <a href="#sign-button">ký ở dưới cùng</a>. Nếu bạn có thắc mắc, hãy liên hệ với ${senderGivenName} qua email tại <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. Biểu mẫu này sẽ hết hạn vào ${expires}`,
    "zh-hans": (senderName, senderEmail, senderGivenName, expires)=>$2868cc1235412e16$var$html`${senderName} 将这份表格发送给您签名。查看以下信息并在<a href="#sign-button">底部签名</a>。如果您有任何疑问，请发送电子邮件至 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> 联系 ${senderGivenName}。此表格将于${expires}）到期。`,
    "zh-hant": (senderName, senderEmail, senderGivenName, expires)=>$2868cc1235412e16$var$html`${senderName} 將這份表格發送給您簽名。查看以下資訊並在<a href="#sign-button">底部簽名</a>。如果您有任何疑問，請發送電子郵件至 <a class="Link--primary" href="${senderEmail}">${senderEmail}</a> 聯繫 ${senderGivenName}。此表格將於${expires}）到期。`,
    en: (senderName, senderGivenName, senderEmail, expires)=>$2868cc1235412e16$var$html`${senderName} sent you this form to sign. Review the information below and <a href="#sign-button">sign at the bottom</a>. If you have questions, contact ${senderGivenName} via email at <a class="Link--primary" href="${senderEmail}">${senderEmail}</a>. This form will expire ${expires}.`
};
const $2868cc1235412e16$export$99349eb448fe574e = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{647} \u{627}\u{644}\u{635}\u{641}\u{62D}\u{629}`,
    de: `Hilfe zu dieser Seite`,
    es: `Ayuda con esta p\xe1gina`,
    fa: `\u{62F}\u{631} \u{645}\u{648}\u{631}\u{62F} \u{627}\u{6CC}\u{646} \u{635}\u{641}\u{62D}\u{647} \u{6A9}\u{645}\u{6A9} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Tulong sa pahinang ito`,
    fr: `Aide pour cette page`,
    hi: `\u{907}\u{938} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{92E}\u{926}\u{926}`,
    ht: `Ede av\xe8k paj sa a`,
    it: `Aiuto con questa pagina`,
    ja: `\u{3053}\u{306E}\u{30DA}\u{30FC}\u{30B8}\u{306E}\u{30D8}\u{30EB}\u{30D7}`,
    ko: `\u{C774} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{B300}\u{D55C} \u{B3C4}\u{C6C0}\u{B9D0}`,
    mww: `Pab nrog rau phab ntawv no`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{67E}\u{627}\u{6BC}\u{647} \u{6A9}\u{6D0} \u{645}\u{631}\u{633}\u{62A}\u{647}`,
    pt: `Ajuda com esta p\xe1gina`,
    "pt-pt": `Ajuda com esta p\xe1gina`,
    ru: `\u{41F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C} \u{441} \u{44D}\u{442}\u{43E}\u{439} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435}\u{439}`,
    sm: `Fesoasoani i lenei itulau`,
    so: `Caawimada boggan`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E40}\u{E2B}\u{E25}\u{E37}\u{E2D}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E01}\u{E31}\u{E1A}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{635}\u{641}\u{62D}\u{6D2} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{645}\u{62F}\u{62F} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Tr\u{1EE3} gi\xfap v\u{1EDB}i trang n\xe0y`,
    "zh-hans": `\u{6B64}\u{9875}\u{9762}\u{7684}\u{5E2E}\u{52A9}`,
    "zh-hant": `\u{6B64}\u{9801}\u{9762}\u{7684}\u{8AAC}\u{660E}`,
    en: `Help with this page`
};
const $2868cc1235412e16$export$29e6fca9e5c058b6 = {
    ar: `\u{634}\u{643}\u{631}\u{627} \u{644}\u{643} \u{639}\u{644}\u{649} \u{627}\u{644}\u{631}\u{62F}!`,
    de: `Vielen Dank f\xfcr Ihre Antwort!`,
    es: `\xa1Gracias por responder!`,
    fa: `\u{645}\u{645}\u{646}\u{648}\u{646} \u{6A9}\u{647} \u{67E}\u{627}\u{633}\u{62E} \u{62F}\u{627}\u{62F}\u{6CC}\u{62F}!`,
    fil: `Salamat sa pagtugon!`,
    fr: `Merci d\u{2019}avoir r\xe9pondu !`,
    hi: `\u{91C}\u{935}\u{93E}\u{92C} \u{926}\u{947}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{927}\u{928}\u{94D}\u{92F}\u{935}\u{93E}\u{926}!`,
    ht: `M\xe8si pou reponn!`,
    it: `Grazie per aver risposto!`,
    ja: `\u{3054}\u{56DE}\u{7B54}\u{3044}\u{305F}\u{3060}\u{304D}\u{3042}\u{308A}\u{304C}\u{3068}\u{3046}\u{3054}\u{3056}\u{3044}\u{307E}\u{3059}!`,
    ko: `\u{C751}\u{B2F5}\u{D574} \u{C8FC}\u{C154}\u{C11C} \u{AC10}\u{C0AC}\u{D569}\u{B2C8}\u{B2E4}!`,
    mww: `Ua tsaug rau koj teb!`,
    ps: `\u{644}\u{647} \u{681}\u{648}\u{627}\u{628} \u{648}\u{631}\u{6A9}\u{648}\u{644}\u{648} \u{685}\u{62E}\u{647} \u{645}\u{646}\u{646}\u{647} !`,
    pt: `Obrigado por responder!`,
    "pt-pt": `Obrigado por responder!`,
    ru: `\u{421}\u{43F}\u{430}\u{441}\u{438}\u{431}\u{43E}, \u{447}\u{442}\u{43E} \u{43E}\u{442}\u{432}\u{435}\u{442}\u{438}\u{43B}\u{438}!`,
    sm: `Fa'afetai mo le tali mai!`,
    so: `Waad ku mahadsan tahay jawaabtaada!`,
    th: `\u{E02}\u{E2D}\u{E1A}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E15}\u{E2D}\u{E1A}\u{E01}\u{E25}\u{E31}\u{E1A}!`,
    ur: `\u{62C}\u{648}\u{627}\u{628} \u{62F}\u{6CC}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{622}\u{67E} \u{6A9}\u{627} \u{634}\u{6A9}\u{631}\u{6CC}\u{6C1}!`,
    vi: `C\u{1EA3}m \u{1A1}n b\u{1EA1}n \u{111}\xe3 tr\u{1EA3} l\u{1EDD}i!`,
    "zh-hans": `\u{611F}\u{8C22}\u{60A8}\u{7684}\u{56DE}\u{590D}\u{FF01}`,
    "zh-hant": `\u{611F}\u{8B1D}\u{60A8}\u{7684}\u{56DE}\u{5FA9}\u{FF01}`,
    en: `Thank you for responding!`
};
const $2868cc1235412e16$export$6277c530245ba075 = {
    ar: `\u{648}\u{642}\u{62F} \u{62A}\u{645} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644} \u{62A}\u{642}\u{62F}\u{64A}\u{645} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{639}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{624}\u{627}\u{644}. \u{644}\u{637}\u{644}\u{628} \u{62A}\u{648}\u{642}\u{64A}\u{639} \u{62C}\u{62F}\u{64A}\u{62F}\u{60C} \u{627}\u{62D}\u{630}\u{641} \u{623}\u{648}\u{644}\u{627} \u{623}\u{64A} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{627}\u{62A} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{629} \u{641}\u{64A} \u{647}\u{630}\u{627} `,
    de: `F\xfcr diese Frage wurde bereits eine Unterschrift bereitgestellt. Um eine neue Signatur anzufordern, l\xf6schen Sie zun\xe4chst alle vorhandenen Signaturen in diesem `,
    es: `Ya se ha proporcionado una firma para esta pregunta. Para solicitar una nueva firma, primero elimine las firmas existentes en este `,
    fa: `\u{627}\u{645}\u{636}\u{627}\u{6CC}\u{6CC} \u{628}\u{631}\u{627}\u{6CC} \u{627}\u{6CC}\u{646} \u{633}\u{648}\u{627}\u{644} \u{642}\u{628}\u{644}\u{627} \u{627}\u{631}\u{627}\u{626}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{628}\u{631}\u{627}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6CC}\u{6A9} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F}\u{60C} \u{627}\u{628}\u{62A}\u{62F}\u{627} \u{627}\u{645}\u{636}\u{627}\u{647}\u{627}\u{6CC} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{62F}\u{631} \u{627}\u{6CC}\u{646} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F} `,
    fil: `Isang lagda ang ibinigay para sa tanong na ito. Upang humiling ng bagong lagda, tanggalin muna ang anumang umiiral na lagda dito `,
    fr: `Une signature a d\xe9j\xe0 \xe9t\xe9 fournie pour cette question. Pour demander une nouvelle signature, supprimez d\u{2019}abord toutes les signatures existantes dans ce `,
    hi: `\u{907}\u{938} \u{92A}\u{94D}\u{930}\u{936}\u{94D}\u{928} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{92A}\u{939}\u{932}\u{947} \u{939}\u{940} \u{92A}\u{94D}\u{930}\u{926}\u{93E}\u{928} \u{915}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E} \u{91A}\u{941}\u{915}\u{93E} \u{939}\u{948}\u{964} \u{928}\u{90F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{93E} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}, \u{92A}\u{939}\u{932}\u{947} \u{907}\u{938}\u{92E}\u{947}\u{902} \u{915}\u{93F}\u{938}\u{940} \u{92D}\u{940} \u{92E}\u{94C}\u{91C}\u{942}\u{926}\u{93E} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{94B} \u{939}\u{91F}\u{93E} \u{926}\u{947}\u{902} `,
    ht: `Yon siyati te deja bay pou kesyon sa a. Pou mande yon nouvo siyati, premye efase nenp\xf2t siyati ki deja egziste nan sa a `,
    it: `Per questa domanda \xe8 gi\xe0 stata fornita una firma. Per richiedere una nuova firma, eliminare prima tutte le firme esistenti in questo `,
    ja: `\u{3053}\u{306E}\u{8CEA}\u{554F}\u{306B}\u{306F}\u{3001}\u{3059}\u{3067}\u{306B}\u{7F72}\u{540D}\u{304C}\u{63D0}\u{4F9B}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}\u{65B0}\u{3057}\u{3044}\u{7F72}\u{540D}\u{3092}\u{8981}\u{6C42}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{307E}\u{305A}\u{3053}\u{306E}\u{7F72}\u{540D}\u{5185}\u{306E}\u{65E2}\u{5B58}\u{306E}\u{7F72}\u{540D}\u{3092}\u{3059}\u{3079}\u{3066}\u{524A}\u{9664}\u{3057}\u{307E}\u{3059} `,
    ko: `\u{C774} \u{C9C8}\u{BB38}\u{C5D0} \u{B300}\u{D55C} \u{C11C}\u{BA85}\u{C774} \u{C774}\u{BBF8} \u{C81C}\u{ACF5}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{C0C8} \u{C11C}\u{BA85}\u{C744} \u{C694}\u{CCAD}\u{D558}\u{B824}\u{BA74} \u{BA3C}\u{C800} \u{C774} \u{C11C}\u{BA85}\u{C758} \u{AE30}\u{C874} \u{C11C}\u{BA85}\u{C744} \u{BAA8}\u{B450} \u{C0AD}\u{C81C}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}. `,
    mww: `Ib kos npe muaj twb tau muab rau lo lus nug no. Xav thov ib daim ntawv kos npe tshiab, ua ntej delete tej kos npe rau hauv no `,
    ps: `\u{62F} \u{62F}\u{6D0} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{6CC}\u{648} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{648}\u{693}\u{627}\u{646}\u{62F}\u{6D0} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}. \u{62F} \u{646}\u{648}\u{6CC} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{62F} \u{63A}\u{648}\u{69A}\u{62A}\u{646}\u{6D0} \u{644}\u{67E}\u{627}\u{631}\u{647}\u{60C} \u{644}\u{648}\u{645}\u{693}\u{6CC} \u{67E}\u{647} \u{62F}\u{6D0} \u{6A9}\u{6D0} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9}\u{648}\u{646}\u{647} \u{62D}\u{630}\u{641} \u{6A9}\u{693}\u{626} `,
    pt: `Uma assinatura j\xe1 foi fornecida para esta pergunta. Para solicitar uma nova assinatura, primeiro exclua todas as assinaturas existentes neste `,
    "pt-pt": `J\xe1 foi fornecida uma assinatura para esta pergunta. Para solicitar uma nova assinatura, primeiro exclua todas as assinaturas existentes neste `,
    ru: `\u{41D}\u{430} \u{44D}\u{442}\u{43E}\u{442} \u{432}\u{43E}\u{43F}\u{440}\u{43E}\u{441} \u{443}\u{436}\u{435} \u{43F}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}. \u{427}\u{442}\u{43E}\u{431}\u{44B} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{438}\u{442}\u{44C} \u{43D}\u{43E}\u{432}\u{443}\u{44E} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}, \u{441}\u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{435} \u{432}\u{441}\u{435} \u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{44E}\u{449}\u{438}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{432} \u{44D}\u{442}\u{43E}\u{43C} `,
    sm: `Ua uma ona tuuina atu se saini mo lenei fesili. Ina ia talosagaina se saini fou, tape muamua soo se saini o loo i ai i lenei `,
    so: `Su'aashan horey ayaa loo bixiyay saxiix. Si aad u codsato saxiix cusub, marka hore tirtirto wixii saxiixyo ah ee jira `,
    th: `\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E08}\u{E31}\u{E14}\u{E40}\u{E15}\u{E23}\u{E35}\u{E22}\u{E21}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E2A}\u{E4D}\u{E32}\u{E2B}\u{E23}\u{E31}\u{E1A}\u{E04}\u{E4D}\u{E32}\u{E16}\u{E32}\u{E21}\u{E19}\u{E35}\u{E49}\u{E41}\u{E25}\u{E49}\u{E27} \u{E2B}\u{E32}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48} \u{E43}\u{E2B}\u{E49}\u{E25}\u{E1A}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E17}\u{E35}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E19}\u{E35}\u{E49}\u{E01}\u{E48}\u{E2D}\u{E19} `,
    ur: `\u{627}\u{633} \u{633}\u{648}\u{627}\u{644} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{6CC}\u{627} \u{62C}\u{627} \u{686}\u{6A9}\u{627} \u{6C1}\u{6D2}. \u{646}\u{626}\u{6D2} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2}\u{60C} \u{67E}\u{6C1}\u{644}\u{6D2} \u{627}\u{633} \u{645}\u{6CC}\u{6BA} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{6A9}\u{633}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{6CC}\u{6BA} `,
    vi: `M\u{1ED9}t ch\u{1EEF} k\xfd \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c cung c\u{1EA5}p cho c\xe2u h\u{1ECF}i n\xe0y. \u{110}\u{1EC3} y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd m\u{1EDB}i, tr\u{1B0}\u{1EDB}c ti\xean h\xe3y x\xf3a m\u{1ECD}i ch\u{1EEF} k\xfd hi\u{1EC7}n c\xf3 trong `,
    "zh-hans": `\u{8FD9}\u{4E2A}\u{95EE}\u{9898}\u{5DF2}\u{7ECF}\u{63D0}\u{4F9B}\u{4E86}\u{7B7E}\u{540D}\u{3002}\u{8981}\u{8BF7}\u{6C42}\u{65B0}\u{7B7E}\u{540D}\u{FF0C}\u{8BF7}\u{5148}\u{5220}\u{9664}\u{6B64} `,
    "zh-hant": `\u{9019}\u{500B}\u{554F}\u{984C}\u{5DF2}\u{7D93}\u{63D0}\u{4F9B}\u{4E86}\u{7C3D}\u{540D}\u{3002}\u{8981}\u{8ACB}\u{6C42}\u{65B0}\u{7C3D}\u{540D}\u{FF0C}\u{8ACB}\u{5148}\u{522A}\u{9664}\u{6B64} `,
    en: `A signature has already been provided for this question. To request a new signature, first delete any existing signatures in this `
};
const $2868cc1235412e16$export$52f5c9f1417c37d7 = {
    ar: `\u{644}\u{644}\u{625}\u{631}\u{633}\u{627}\u{644} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{647}\u{627}\u{62A}\u{641}\u{643} \u{60C} \u{627}\u{645}\u{633}\u{62D} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629} \u{636}\u{648}\u{626}\u{64A}\u{627} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{643}\u{627}\u{645}\u{64A}\u{631}\u{627}.`,
    de: `Um mit Ihrem Telefon zu senden, scannen Sie den QR-Code mit Ihrer Kamera-App.`,
    es: `Para enviar usando tu tel\xe9fono, escanea el c\xf3digo QR con la aplicaci\xf3n de tu c\xe1mara.`,
    fa: `\u{628}\u{631}\u{627}\u{6CC} \u{627}\u{631}\u{633}\u{627}\u{644} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{62A}\u{644}\u{641}\u{646}\u{60C} \u{6A9}\u{62F} QR \u{631}\u{627} \u{628}\u{627} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{62F}\u{648}\u{631}\u{628}\u{6CC}\u{646} \u{627}\u{633}\u{6A9}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Upang magpadala gamit ang iyong telepono, i-scan ang QR code gamit ang iyong camera app.`,
    fr: `Pour envoyer des messages \xe0 l\u{2019}aide de votre t\xe9l\xe9phone, scannez le code QR avec votre application appareil photo.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{92B}\u{93C}\u{94B}\u{928} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{92D}\u{947}\u{91C}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F}, \u{905}\u{92A}\u{928}\u{947} \u{915}\u{948}\u{92E}\u{930}\u{93E} \u{910}\u{92A} \u{938}\u{947} QR \u{915}\u{94B}\u{921} \u{938}\u{94D}\u{915}\u{948}\u{928} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Pou voye l\xe8 l s\xe8vi av\xe8k telef\xf2n ou, analysis k\xf2d la QR ak app kamera ou.`,
    it: `Per inviare utilizzando il telefono, scansiona il codice QR con l'app della fotocamera.`,
    ja: `\u{30B9}\u{30DE}\u{30FC}\u{30C8}\u{30D5}\u{30A9}\u{30F3}\u{3092}\u{4F7F}\u{7528}\u{3057}\u{3066}\u{9001}\u{4FE1}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}\u{30AB}\u{30E1}\u{30E9}\u{30A2}\u{30D7}\u{30EA}\u{3067}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{30B9}\u{30AD}\u{30E3}\u{30F3}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{D734}\u{B300}\u{C804}\u{D654}\u{B97C} \u{C0AC}\u{C6A9}\u{D558}\u{C5EC} \u{C804}\u{C1A1}\u{D558}\u{B824}\u{BA74} \u{CE74}\u{BA54}\u{B77C} \u{C571}\u{C73C}\u{B85C} QR \u{CF54}\u{B4DC}\u{B97C} \u{C2A4}\u{CE94}\u{D558}\u{C138}\u{C694}.`,
    mww: `Xa koj lub xov tooj, scan lub QR code nrog koj lub koob yees duab app.`,
    ps: `\u{62F} \u{62E}\u{67E}\u{644} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{633}\u{631}\u{647} \u{62F} \u{644}\u{6CC}\u{696}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647}\u{60C} \u{62F} \u{62E}\u{67E}\u{644} \u{6A9}\u{6CC}\u{645}\u{631}\u{6D0} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{633}\u{631}\u{647} QR \u{6A9}\u{648}\u{689} \u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{693}\u{626}.`,
    pt: `Para enviar usando seu telefone, escaneie o c\xf3digo QR com o aplicativo da c\xe2mera.`,
    "pt-pt": `Para enviar usando seu telefone, digitalize o c\xf3digo QR com seu aplicativo de c\xe2mera.`,
    ru: `\u{427}\u{442}\u{43E}\u{431}\u{44B} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430}, \u{43E}\u{442}\u{441}\u{43A}\u{430}\u{43D}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} QR-\u{43A}\u{43E}\u{434} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{43A}\u{430}\u{43C}\u{435}\u{440}\u{44B}.`,
    sm: `Ina ia lafoina e fa'aaoga ai lau telefoni, fa'ata'ita'i le QR code ma lau mea pu'eata polokalama.`,
    so: `Si aad u dirto adiga oo isticmaalaya telefoonkaaga, iskaan QR code-ka app-kaaga camera.`,
    th: `\u{E2B}\u{E32}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} \u{E43}\u{E2B}\u{E49}\u{E2A}\u{E41}\u{E01}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A} QR \u{E14}\u{E49}\u{E27}\u{E22}\u{E41}\u{E2D}\u{E1B}\u{E01}\u{E25}\u{E49}\u{E2D}\u{E07}\u{E16}\u{E48}\u{E32}\u{E22}\u{E23}\u{E39}\u{E1B}`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{641}\u{648}\u{646} \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{60C} \u{627}\u{67E}\u{646}\u{6D2} \u{6A9}\u{6CC}\u{645}\u{631}\u{6C1} \u{627}\u{6CC}\u{67E} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{688} \u{627}\u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `\u{110}\u{1EC3} g\u{1EED}i b\u{1EB1}ng \u{111}i\u{1EC7}n tho\u{1EA1}i c\u{1EE7}a b\u{1EA1}n, h\xe3y qu\xe9t m\xe3 QR b\u{1EB1}ng \u{1EE9}ng d\u{1EE5}ng m\xe1y \u{1EA3}nh c\u{1EE7}a b\u{1EA1}n.`,
    "zh-hans": `\u{8981}\u{4F7F}\u{7528}\u{624B}\u{673A}\u{53D1}\u{9001}\u{FF0C}\u{8BF7}\u{4F7F}\u{7528}\u{76F8}\u{673A}\u{5E94}\u{7528}\u{7A0B}\u{5E8F}\u{626B}\u{63CF} QR \u{7801}\u{3002}`,
    "zh-hant": `\u{8981}\u{4F7F}\u{7528}\u{624B}\u{6A5F}\u{767C}\u{9001}\u{FF0C}\u{8ACB}\u{4F7F}\u{7528}\u{76F8}\u{6A5F}\u{61C9}\u{7528}\u{7A0B}\u{5F0F}\u{6383}\u{63CF} QR \u{78BC}\u{3002}`,
    en: `To send using your phone, scan the QR code with your camera app.`
};
const $2868cc1235412e16$export$ca7425fc94b55c26 = {
    ar: `\u{623}\u{631}\u{633}\u{644} \u{639}\u{628}\u{631} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A}`,
    de: `Per E-Mail versenden`,
    es: `Enviar por correo electr\xf3nico`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}`,
    fil: `Email:`,
    fr: `Envoyer par e-mail`,
    hi: `\u{908}\u{92E}\u{947}\u{932} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye atrav\xe8 Im\xe8l`,
    it: `Invia via e-mail`,
    ja: `\u{30E1}\u{30FC}\u{30EB}\u{3067}\u{9001}\u{4FE1}`,
    ko: `\u{C774}\u{BA54}\u{C77C}\u{B85C} \u{BCF4}\u{B0B4}\u{AE30}`,
    mww: `Xa ntawm Email`,
    ps: `\u{62F} \u{628}\u{631}\u{6D0}\u{69A}\u{646}\u{627}\u{644}\u{6CC}\u{6A9} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644}`,
    pt: `Enviar por e-mail`,
    "pt-pt": `Enviar por e-mail`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43F}\u{43E} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{435}`,
    sm: `Auina atu e ala i le imeli`,
    so: `U dir email`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E17}\u{E32}\u{E07}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}`,
    ur: `\u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i qua email`,
    "zh-hans": `\u{901A}\u{8FC7}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{53D1}\u{9001}`,
    "zh-hant": `\u{901A}\u{904E}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{767C}\u{9001}`,
    en: `Send via Email`
};
const $2868cc1235412e16$export$bb196278a1e8147e = {
    ar: `\u{625}\u{631}\u{633}\u{627}\u{644} \u{639}\u{628}\u{631} \u{631}\u{633}\u{627}\u{644}\u{629} \u{646}\u{635}\u{64A}\u{629}`,
    de: `Per SMS senden`,
    es: `Enviar por mensaje de texto`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644} \u{627}\u{632} \u{637}\u{631}\u{6CC}\u{642} \u{67E}\u{6CC}\u{627}\u{645} \u{645}\u{62A}\u{646}\u{6CC}`,
    fil: `Email: Text Message`,
    fr: `Envoyer par SMS`,
    hi: `\u{92A}\u{93E}\u{920} \u{938}\u{902}\u{926}\u{947}\u{936} \u{915}\u{947} \u{92E}\u{93E}\u{927}\u{94D}\u{92F}\u{92E} \u{938}\u{947} \u{92D}\u{947}\u{91C}\u{947}\u{902}`,
    ht: `Voye atrav\xe8 Mesaj t\xe8ks`,
    it: `Invia tramite messaggio di testo`,
    ja: `\u{30C6}\u{30AD}\u{30B9}\u{30C8}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{3067}\u{9001}\u{4FE1}`,
    ko: `\u{BB38}\u{C790} \u{BA54}\u{C2DC}\u{C9C0}\u{B85C} \u{BCF4}\u{B0B4}\u{AE30}`,
    mww: `Xa ntawm Text Lus`,
    ps: `\u{62F} \u{644}\u{6CC}\u{6A9}\u{644}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{644}\u{647} \u{644}\u{627}\u{631}\u{6D0} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644}`,
    pt: `Enviar por mensagem de texto`,
    "pt-pt": `Enviar via mensagem de texto`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Auina atu e ala i feau tusitusia`,
    so: `U dir via Fariin Qoraalka`,
    th: `\u{E2A}\u{E48}\u{E07}\u{E17}\u{E32}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`,
    ur: `\u{679}\u{6CC}\u{6A9}\u{633}\u{679} \u{645}\u{6CC}\u{633}\u{62C} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6D2} \u{628}\u{6BE}\u{6CC}\u{62C}\u{6CC}\u{6BA}`,
    vi: `G\u{1EED}i qua tin nh\u{1EAF}n v\u{103}n b\u{1EA3}n`,
    "zh-hans": `\u{901A}\u{8FC7}\u{77ED}\u{4FE1}\u{53D1}\u{9001}`,
    "zh-hant": `\u{901A}\u{904E}\u{7C21}\u{8A0A}\u{767C}\u{9001}`,
    en: `Send via Text Message`
};
const $2868cc1235412e16$export$1da1e429a8e76bf5 = {
    ar: `\u{631}\u{642}\u{645} \u{647}\u{627}\u{62A}\u{641} \u{645}\u{62E}\u{635}\u{635}`,
    de: `Benutzerdefinierte Telefonnummer`,
    es: `N\xfamero de tel\xe9fono personalizado`,
    fa: `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646} \u{633}\u{641}\u{627}\u{631}\u{634}\u{6CC}`,
    fil: `Pasadyang numero ng telepono`,
    fr: `Num\xe9ro de t\xe9l\xe9phone personnalis\xe9`,
    hi: `\u{915}\u{938}\u{94D}\u{91F}\u{92E} \u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{902}\u{92C}\u{930}`,
    ht: `Nimewo telef\xf2n koutim`,
    it: `Numero di telefono personalizzato`,
    ja: `\u{30AB}\u{30B9}\u{30BF}\u{30E0}\u{96FB}\u{8A71}\u{756A}\u{53F7}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790} \u{C9C0}\u{C815} \u{C804}\u{D654} \u{BC88}\u{D638}`,
    mww: `Xov Tooj`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `N\xfamero de telefone personalizado`,
    "pt-pt": `N\xfamero de telefone personalizado`,
    ru: `\u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{43A}\u{438}\u{439} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430}`,
    sm: `Numera telefoni masani`,
    so: `lambarka telefoonka Custom`,
    th: `\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{627}\u{67E}\u{646}\u{6CC} \u{645}\u{631}\u{636}\u{6CC} \u{6A9}\u{6D2} \u{645}\u{637}\u{627}\u{628}\u{642} \u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631}`,
    vi: `S\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i t\xf9y ch\u{1EC9}nh`,
    "zh-hans": `\u{81EA}\u{5B9A}\u{4E49}\u{7535}\u{8BDD}\u{53F7}\u{7801}`,
    "zh-hant": `\u{81EA}\u{8A02}\u{96FB}\u{8A71}\u{865F}\u{78BC}`,
    en: `Custom phone number`
};
const $2868cc1235412e16$export$aef7b42ff8a126b3 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646} \u{628}\u{631}\u{64A}\u{62F} \u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{645}\u{62E}\u{635}\u{635}`,
    de: `Benutzerdefinierte E-Mail-Adresse`,
    es: `Direcci\xf3n de correo electr\xf3nico personalizada`,
    fa: `\u{622}\u{62F}\u{631}\u{633} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{633}\u{641}\u{627}\u{631}\u{634}\u{6CC}`,
    fil: `Pasadyang email address`,
    fr: `Adresse e-mail personnalis\xe9e`,
    hi: `\u{915}\u{938}\u{94D}\u{91F}\u{92E} \u{908}\u{92E}\u{947}\u{932} \u{92A}\u{924}\u{93E}`,
    ht: `Adr\xe8s im\xe8l koutim`,
    it: `Indirizzo e-mail personalizzato`,
    ja: `\u{30AB}\u{30B9}\u{30BF}\u{30E0}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}`,
    ko: `\u{C0AC}\u{C6A9}\u{C790} \u{C9C0}\u{C815} \u{C774}\u{BA54}\u{C77C} \u{C8FC}\u{C18C}`,
    mww: `Kev lis kev cai email chaw nyob`,
    ps: `\u{6AB}\u{645}\u{631}\u{6A9} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{67E}\u{62A}\u{647}`,
    pt: `Endere\xe7o de e-mail personalizado`,
    "pt-pt": `Endere\xe7o de e-mail personalizado`,
    ru: `\u{41F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{43A}\u{438}\u{439} \u{430}\u{434}\u{440}\u{435}\u{441} \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{43E}\u{439} \u{43F}\u{43E}\u{447}\u{442}\u{44B}`,
    sm: `Tuatusi imeli masani`,
    so: `cinwaanka email Custom`,
    th: `\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2D}\u{E35}\u{E40}\u{E21}\u{E25}\u{E17}\u{E35}\u{E48}\u{E01}\u{E4D}\u{E32}\u{E2B}\u{E19}\u{E14}\u{E40}\u{E2D}\u{E07}`,
    ur: `\u{627}\u{67E}\u{646}\u{6CC} \u{645}\u{631}\u{636}\u{6CC} \u{6A9}\u{6D2} \u{645}\u{637}\u{627}\u{628}\u{642} \u{627}\u{6CC} \u{645}\u{6CC}\u{644} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633}`,
    vi: `\u{110}\u{1ECB}a ch\u{1EC9} email t\xf9y ch\u{1EC9}nh`,
    "zh-hans": `\u{81EA}\u{5B9A}\u{4E49}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{5730}\u{5740}`,
    "zh-hant": `\u{81EA}\u{8A02}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{4F4D}\u{5740}`,
    en: `Custom email address`
};
const $2868cc1235412e16$export$2ad44f7b3aea488a = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{637}\u{631}\u{64A}\u{642}\u{629} \u{627}\u{644}\u{625}\u{631}\u{633}\u{627}\u{644}`,
    de: `W\xe4hlen Sie aus, wie Sie senden m\xf6chten`,
    es: `Elige c\xf3mo enviar`,
    fa: `\u{646}\u{62D}\u{648}\u{647} \u{627}\u{631}\u{633}\u{627}\u{644} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin kung paano magpadala`,
    fr: `Choisissez comment envoyer`,
    hi: `\u{92D}\u{947}\u{91C}\u{928}\u{947} \u{915}\u{93E} \u{924}\u{930}\u{940}\u{915}\u{93E} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kijan pou voye`,
    it: `Scegli la modalit\xe0 di invio`,
    ja: `\u{9001}\u{4FE1}\u{65B9}\u{6CD5}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}`,
    ko: `\u{C804}\u{C1A1} \u{BC29}\u{BC95} \u{C120}\u{D0DD}`,
    mww: `Xaiv seb yuav xa li cas`,
    ps: `\u{62F} \u{644}\u{6CC}\u{696}\u{644}\u{648} \u{637}\u{631}\u{6CC}\u{642}\u{647} \u{63A}\u{648}\u{631}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Escolha como enviar`,
    "pt-pt": `Escolha como enviar`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{441}\u{43F}\u{43E}\u{441}\u{43E}\u{431} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43A}\u{438}`,
    sm: `Filifili pe fa'afefea ona lafoina`,
    so: `Dooro sida loo diro`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E27}\u{E34}\u{E18}\u{E35}\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{628}\u{6BE}\u{6CC}\u{62C}\u{646}\u{6D2} \u{6A9}\u{627} \u{637}\u{631}\u{6CC}\u{642}\u{6C1} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n c\xe1ch g\u{1EED}i`,
    "zh-hans": `\u{9009}\u{62E9}\u{53D1}\u{9001}\u{65B9}\u{5F0F}`,
    "zh-hant": `\u{9078}\u{64C7}\u{767C}\u{9001}\u{65B9}\u{5F0F}`,
    en: `Choose how to send`
};
const $2868cc1235412e16$export$8c5b118cdadf3b75 = {
    ar: `\u{627}\u{631}\u{633}\u{644}`,
    de: `Senden`,
    es: `Enviar`,
    fa: `\u{627}\u{631}\u{633}\u{627}\u{644}`,
    fil: `Email Address *`,
    fr: `Envoyer`,
    hi: `\u{92D}\u{947}\u{91C}\u{928}\u{93E}`,
    ht: `Voye`,
    it: `Invia`,
    ja: `\u{9001}\u{4FE1}`,
    ko: `\u{BCF4}\u{B0B4}\u{AE30}`,
    mww: `Xa`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Enviar`,
    "pt-pt": `Enviar`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{44C}`,
    sm: `Auina atu`,
    so: `U dir`,
    th: `\u{E2A}\u{E48}\u{E07}`,
    ur: `\u{628}\u{6BE}\u{6CC}\u{62C}\u{646}\u{627}`,
    vi: `G\u{1EED}i`,
    "zh-hans": `\u{53D1}\u{9001}`,
    "zh-hant": `\u{767C}\u{9001}`,
    en: `Send`
};
const $2868cc1235412e16$export$7d65561be707926c = {
    ar: `\u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{645}\u{641}\u{642}\u{648}\u{62F}.`,
    de: `Berechtigung fehlt.`,
    es: `Falta autorizaci\xf3n.`,
    fa: `\u{645}\u{62C}\u{648}\u{632} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Nawawala ang awtorisasyon.`,
    fr: `Autorisation manquante.`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{905}\u{928}\u{941}\u{92A}\u{932}\u{92C}\u{94D}\u{927}\u{964}`,
    ht: `Otorizasyon ki dispar\xe8t.`,
    it: `Autorizzazione mancante.`,
    ja: `\u{8A8D}\u{8A3C}\u{304C}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C778}\u{C99D}\u{C774} \u{B204}\u{B77D}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kev tso cai uas ploj lawm.`,
    ps: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{648}\u{631}\u{6A9}\u{647} \u{62F}\u{647}.`,
    pt: `Autoriza\xe7\xe3o ausente.`,
    "pt-pt": `Autoriza\xe7\xe3o em falta.`,
    ru: `\u{410}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43E}\u{442}\u{441}\u{443}\u{442}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}.`,
    sm: `Ua misi le faatagaga.`,
    so: `Oggolaansho la'yahay.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{627}\u{645}\u{6C1} \u{63A}\u{627}\u{626}\u{628} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Thi\u{1EBF}u \u{1EE7}y quy\u{1EC1}n.`,
    "zh-hans": `\u{7F3A}\u{5C11}\u{6388}\u{6743}\u{3002}`,
    "zh-hant": `\u{7F3A}\u{5C11}\u{6388}\u{6B0A}\u{3002}`,
    en: `Authorization missing.`
};
const $2868cc1235412e16$export$d1ea8bcea30c0fe = {
    ar: `\u{627}\u{646}\u{62A}\u{647}\u{62A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{637}\u{644}\u{628} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}`,
    de: `Signaturanforderung abgelaufen`,
    es: `Solicitud de firma caducada`,
    fa: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{627}\u{645}\u{636}\u{627} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Nag-expire na ang kahilingan sa lagda`,
    fr: `Demande de signature expir\xe9e`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{905}\u{928}\u{941}\u{930}\u{94B}\u{927} \u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{917}\u{908} \u{939}\u{948}`,
    ht: `Demann siyati ekspire`,
    it: `Richiesta di firma scaduta`,
    ja: `\u{7F72}\u{540D}\u{30EA}\u{30AF}\u{30A8}\u{30B9}\u{30C8}\u{306E}\u{6709}\u{52B9}\u{671F}\u{9650}\u{304C}\u{5207}\u{308C}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C11C}\u{BA85} \u{C694}\u{CCAD}\u{C774} \u{B9CC}\u{B8CC}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kos npe thov expired`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6CC} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6CC}`,
    pt: `Solicita\xe7\xe3o de assinatura expirada`,
    "pt-pt": `O pedido de assinatura expirou`,
    ru: `\u{421}\u{440}\u{43E}\u{43A} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{437}\u{430}\u{43F}\u{440}\u{43E}\u{441}\u{430} \u{43D}\u{430} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C} \u{438}\u{441}\u{442}\u{435}\u{43A}`,
    sm: `Ua uma le aoga o le talosaga mo saini`,
    so: `Codsiga saxiixa ahi waa dhacay`,
    th: `\u{E04}\u{E4D}\u{E32}\u{E02}\u{E2D}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A} \u{62E}\u{62A}\u{645} \u{6C1}\u{648} \u{6AF}\u{626}\u{6CC}`,
    vi: `Y\xeau c\u{1EA7}u ch\u{1EEF} k\xfd \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n`,
    "zh-hans": `\u{7B7E}\u{540D}\u{8BF7}\u{6C42}\u{5DF2}\u{8FC7}\u{671F}`,
    "zh-hant": `\u{7C3D}\u{540D}\u{8ACB}\u{6C42}\u{5DF2}\u{904E}\u{671F}`,
    en: `Signature request expired`
};
const $2868cc1235412e16$export$c8e972f46484194e = {
    ar: (when)=>$2868cc1235412e16$var$html`<p>انتهت صلاحية طلب التوقيع ${when}.</p>`,
    de: (when)=>$2868cc1235412e16$var$html`<p>Diese Anforderung zur Unterschrift ist ${when} abgelaufen.</p>`,
    es: (when)=>$2868cc1235412e16$var$html`<p>Esta solicitud de firma caducó ${when}.</p>`,
    fa: (when)=>$2868cc1235412e16$var$html`<p>این درخواست امضا ${when} منقضی شده است.</p>`,
    fil: (when)=>$2868cc1235412e16$var$html`<p>Ang kahilingan na ito para sa lagda ay nag-expire ${when}.</p>`,
    fr: (when)=>$2868cc1235412e16$var$html`<p>Cette demande de signature a expiré ${when}.</p>`,
    hi: (when)=>$2868cc1235412e16$var$html`<p>हस्ताक्षर के लिए यह अनुरोध ${when}।</p>`,
    ht: (when)=>$2868cc1235412e16$var$html`<p>Demann sa a pou siyati ${when} sa.</p>`,
    it: (when)=>$2868cc1235412e16$var$html`<p>Questa richiesta di firma è scaduta ${when}.</p>`,
    ja: (when)=>$2868cc1235412e16$var$html`<p>この署名リクエストは ${when}期限切れになりました。</p>`,
    ko: (when)=>$2868cc1235412e16$var$html`<p>이 서명 요청은 ${when} 만료되었습니다.</p>`,
    mww: (when)=>$2868cc1235412e16$var$html`<p>Qhov kev thov kos npe rau ${when}.</p>`,
    ps: (when)=>$2868cc1235412e16$var$html`<p>د لاسلیک غوښتنه ${when} پای ته ورسېده.</p>`,
    pt: (when)=>$2868cc1235412e16$var$html`<p>Este pedido de assinatura expirou ${when}.</p>`,
    "pt-pt": (when)=>$2868cc1235412e16$var$html`<p>Este pedido de assinatura expirou ${when}.</p>`,
    ru: (when)=>$2868cc1235412e16$var$html`<p>Срок действия этого запроса на подпись истек ${when}.</p>`,
    sm: (when)=>$2868cc1235412e16$var$html`<p>O lenei talosaga mo le saini na faamutaina ${when}.</p>`,
    so: (when)=>$2868cc1235412e16$var$html`<p>Codsigaan saxiixa saxiixa ah wuxuu dhacay ${when}.</p>`,
    th: (when)=>$2868cc1235412e16$var$html`<p>คําขอลายเซ็นนี้หมดอายุเมื่อ ${when}</p>`,
    ur: (when)=>$2868cc1235412e16$var$html`<p>دستخط کی اس درخواست کی ${when} ختم ہو گئی تھی۔</p>`,
    vi: (when)=>$2868cc1235412e16$var$html`<p>Yêu cầu chữ ký này đã hết hạn cách ${when}.</p>`,
    "zh-hans": (when)=>$2868cc1235412e16$var$html`<p>此签名请求 ${when}过期。</p>`,
    "zh-hant": (when)=>$2868cc1235412e16$var$html`<p>此簽名請求 ${when}過期。</p>`,
    en: (when)=>$2868cc1235412e16$var$html`<p>This request for signature expired ${when}.</p>`
};
const $2868cc1235412e16$export$e9238169b157a165 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{645}\u{633}\u{62A}\u{646}\u{62F} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639}.`,
    de: `Signaturdokument nicht gefunden.`,
    es: `No se ha encontrado el documento de firma.`,
    fa: `\u{633}\u{646}\u{62F} \u{627}\u{645}\u{636}\u{627} \u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F}.`,
    fil: `Hindi natagpuan ang dokumento ng lagda.`,
    fr: `Document de signature introuvable.`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}.`,
    ht: `Dokiman siyati pa jwenn.`,
    it: `Documento di firma non trovato.`,
    ja: `\u{7F72}\u{540D}\u{30C9}\u{30AD}\u{30E5}\u{30E1}\u{30F3}\u{30C8}\u{304C}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C11C}\u{BA85} \u{BB38}\u{C11C}\u{B97C} \u{CC3E}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kos npe tsis pom muaj.`,
    ps: `\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{633}\u{646}\u{62F} \u{648}\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}.`,
    pt: `Documento de assinatura n\xe3o encontrado.`,
    "pt-pt": `Documento de assinatura n\xe3o encontrado.`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{441} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{44C}\u{44E} \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}.`,
    sm: `E le o maua le pepa o faamatalaga o le saini.`,
    so: `Dokumentiga saxeexa lama helin.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6CC} \u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{6CC}\u{6D4}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y t\xe0i li\u{1EC7}u ch\u{1EEF} k\xfd.`,
    "zh-hans": `\u{627E}\u{4E0D}\u{5230}\u{7B7E}\u{540D}\u{6587}\u{6863}\u{3002}`,
    "zh-hant": `\u{627E}\u{4E0D}\u{5230}\u{7C3D}\u{540D}\u{6587}\u{4EF6}\u{3002}`,
    en: `Signature document not found.`
};
const $2868cc1235412e16$export$e806b319d1de2b0f = {
    ar: `\u{627}\u{644}\u{62A}\u{641}\u{648}\u{64A}\u{636} \u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D}.`,
    de: `Autorisierung ung\xfcltig.`,
    es: `La autorizaci\xf3n no es v\xe1lida.`,
    fa: `\u{645}\u{62C}\u{648}\u{632} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{627}\u{633}\u{62A}.`,
    fil: `Hindi wasto ang awtorisasyon.`,
    fr: `Autorisation non valide.`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{927}\u{93F}\u{915}\u{930}\u{923} \u{905}\u{92E}\u{93E}\u{928}\u{94D}\u{92F}\u{964}`,
    ht: `Otorizasyon envalid.`,
    it: `Autorizzazione non valida.`,
    ja: `\u{8A8D}\u{8A3C}\u{304C}\u{7121}\u{52B9}\u{3067}\u{3059}\u{3002}`,
    ko: `\u{AD8C}\u{D55C}\u{C774} \u{C798}\u{BABB}\u{B418}\u{C5C8}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Kev tso cai.`,
    ps: `\u{627}\u{62C}\u{627}\u{632}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}\u{647} \u{62F}\u{647}.`,
    pt: `Autoriza\xe7\xe3o inv\xe1lida.`,
    "pt-pt": `Autoriza\xe7\xe3o inv\xe1lida.`,
    ru: `\u{410}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43D}\u{435}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{430}.`,
    sm: `E le aoga le faatagaga.`,
    so: `Ogolaanshaha sharci darro.`,
    th: `\u{E01}\u{E32}\u{E23}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{627}\u{62C}\u{627}\u{632}\u{62A} \u{646}\u{627}\u{645}\u{6C1} \u{63A}\u{6CC}\u{631} \u{642}\u{627}\u{646}\u{648}\u{646}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `\u{1EE6}y quy\u{1EC1}n kh\xf4ng h\u{1EE3}p l\u{1EC7}.`,
    "zh-hans": `\u{6388}\u{6743}\u{65E0}\u{6548}\u{3002}`,
    "zh-hant": `\u{6388}\u{6B0A}\u{7121}\u{6548}\u{3002}`,
    en: `Authorization invalid.`
};
const $2868cc1235412e16$export$857dd38e1c47f95d = {
    ar: `\u{648}\u{642}\u{62F} \u{62A}\u{645} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{639}\u{644}\u{649} \u{627}\u{644}\u{648}\u{62B}\u{64A}\u{642}\u{629} \u{628}\u{627}\u{644}\u{641}\u{639}\u{644}.`,
    de: `Das Dokument wurde bereits signiert.`,
    es: `El documento ya ha sido firmado.`,
    fa: `\u{633}\u{646}\u{62F} \u{642}\u{628}\u{644}\u{627} \u{627}\u{645}\u{636}\u{627} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Nilagdaan na ang dokumento.`,
    fr: `Le document a d\xe9j\xe0 \xe9t\xe9 sign\xe9.`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{92A}\u{930} \u{92A}\u{939}\u{932}\u{947} \u{939}\u{940} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{915}\u{93F}\u{90F} \u{91C}\u{93E} \u{91A}\u{941}\u{915}\u{947} \u{939}\u{948}\u{902}.`,
    ht: `Dokiman an deja siyen.`,
    it: `Il documento \xe8 gi\xe0 stato firmato.`,
    ja: `\u{30C9}\u{30AD}\u{30E5}\u{30E1}\u{30F3}\u{30C8}\u{306F}\u{65E2}\u{306B}\u{7F72}\u{540D}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{BB38}\u{C11C}\u{C5D0} \u{C774}\u{BBF8} \u{C11C}\u{BA85}\u{C774} \u{B418}\u{C5B4} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntaub ntawv muaj twb tau kos npe.`,
    ps: `\u{633}\u{646}\u{62F} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{647} \u{645}\u{62E}\u{6A9}\u{6D0} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC} \u{62F}\u{6CC}.`,
    pt: `O documento j\xe1 foi assinado.`,
    "pt-pt": `O documento j\xe1 foi assinado.`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{443}\u{436}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}.`,
    sm: `Ua uma ona sainia le pepa.`,
    so: `Qoraalka horey ayaa loo saxiixay.`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{67E}\u{631} \u{67E}\u{6C1}\u{644}\u{6D2} \u{6C1}\u{6CC} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6C1}\u{648} \u{686}\u{6A9}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\xe0i li\u{1EC7}u \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c k\xfd.`,
    "zh-hans": `\u{6587}\u{4EF6}\u{5DF2}\u{7B7E}\u{540D}\u{3002}`,
    "zh-hant": `\u{6A94}\u{5DF2}\u{7C3D}\u{540D}\u{3002}`,
    en: `The document has already been signed.`
};
const $2868cc1235412e16$export$c7cc0c1336c98071 = {
    ar: `\u{644}\u{645} \u{64A}\u{639}\u{62F} \u{627}\u{644}\u{645}\u{631}\u{633}\u{644} \u{646}\u{634}\u{637}\u{627} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}.`,
    de: `Der Absender ist im Projekt nicht mehr aktiv.`,
    es: `El remitente ya no est\xe1 activo en el proyecto.`,
    fa: `\u{641}\u{631}\u{633}\u{62A}\u{646}\u{62F}\u{647} \u{62F}\u{6CC}\u{6AF}\u{631} \u{62F}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6CC}\u{633}\u{62A}.`,
    fil: `Hindi na aktibo sa proyekto ang Tagalog.`,
    fr: `L\u{2019}exp\xe9diteur n\u{2019}est plus actif dans le projet.`,
    hi: `\u{92A}\u{94D}\u{930}\u{947}\u{937}\u{915} \u{905}\u{92C} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{92E}\u{947}\u{902} \u{938}\u{915}\u{94D}\u{930}\u{93F}\u{92F} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Sansib pa aktif ank\xf2 nan pwoj\xe8 a ank\xf2.`,
    it: `Il mittente non \xe8 pi\xf9 attivo nel progetto.`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3067}\u{30BB}\u{30F3}\u{30C0}\u{304C}\u{30A2}\u{30AF}\u{30C6}\u{30A3}\u{30D6}\u{3067}\u{306A}\u{304F}\u{306A}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{BCF4}\u{B0B8} \u{C0AC}\u{B78C}\u{C774} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{C5D0}\u{C11C} \u{B354} \u{C774}\u{C0C1} \u{D65C}\u{C131} \u{C0C1}\u{D0DC}\u{AC00} \u{C544}\u{B2D9}\u{B2C8}\u{B2E4}.`,
    mww: `Xa tsis txawj dhia hauv peb tes num.`,
    ps: `\u{644}\u{6CC}\u{696}\u{648}\u{646}\u{6A9}\u{6CC} \u{646}\u{648}\u{631} \u{67E}\u{647} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{6A9}\u{6D0} \u{641}\u{639}\u{627}\u{644} \u{646}\u{647} \u{62F}\u{6CC}.`,
    pt: `O remetente n\xe3o est\xe1 mais ativo no projeto.`,
    "pt-pt": `O remetente n\xe3o est\xe1 mais ativo no projeto.`,
    ru: `\u{41E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{435}\u{43D} \u{432} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{435}.`,
    sm: `E le o toe toaga le tagata auina atu i le galuega faatino.`,
    so: `Sender mar dambe firfircoon mashruuca.`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E43}\u{E0A}\u{E49}\u{E07}\u{E32}\u{E19}\u{E43}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{645}\u{631}\u{633}\u{644} \u{627}\u{628} \u{627}\u{633} \u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{641}\u{639}\u{627}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ng\u{1B0}\u{1EDD}i g\u{1EED}i kh\xf4ng c\xf2n ho\u{1EA1}t \u{111}\u{1ED9}ng trong d\u{1EF1} \xe1n.`,
    "zh-hans": `\u{53D1}\u{4EF6}\u{4EBA}\u{5728}\u{9879}\u{76EE}\u{4E2D}\u{4E0D}\u{518D}\u{5904}\u{4E8E}\u{6D3B}\u{52A8}\u{72B6}\u{6001}\u{3002}`,
    "zh-hant": `\u{5BC4}\u{4EF6}\u{4EBA}\u{5728}\u{5C08}\u{6848}\u{4E2D}\u{4E0D}\u{518D}\u{8655}\u{65BC}\u{6D3B}\u{52D5}\u{72C0}\u{614B}\u{3002}`,
    en: `Sender no longer active in the project.`
};
const $2868cc1235412e16$export$b011bc40a80b195d = {
    ar: `\u{644}\u{645} \u{64A}\u{639}\u{62F} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F} \u{645}\u{648}\u{62C}\u{648}\u{62F}\u{627}.`,
    de: `Das Dokument existiert nicht mehr.`,
    es: `El documento ya no existe.`,
    fa: `\u{633}\u{646}\u{62F} \u{62F}\u{6CC}\u{6AF}\u{631} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`,
    fil: `Hindi na umiiral ang dokumento.`,
    fr: `Le document n\u{2019}existe plus.`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{905}\u{92C} \u{92E}\u{94C}\u{91C}\u{942}\u{926} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}.`,
    ht: `Dokiman an pa egziste ank\xf2.`,
    it: `Il documento non esiste pi\xf9.`,
    ja: `\u{30C9}\u{30AD}\u{30E5}\u{30E1}\u{30F3}\u{30C8}\u{306F}\u{5B58}\u{5728}\u{3057}\u{306A}\u{304F}\u{306A}\u{308A}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{BB38}\u{C11C}\u{AC00} \u{B354} \u{C774}\u{C0C1} \u{C874}\u{C7AC}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Cov ntaub ntawv lawm tshwm sim.`,
    ps: `\u{633}\u{646}\u{62F} \u{646}\u{648}\u{631} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{647} \u{644}\u{631}\u{6CC}.`,
    pt: `O documento n\xe3o existe mais.`,
    "pt-pt": `O documento j\xe1 n\xe3o existe.`,
    ru: `\u{414}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{435} \u{441}\u{443}\u{449}\u{435}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}.`,
    sm: `E le o toe i ai le pepa.`,
    so: `Dukumentiga mar dambe ma jiro.`,
    th: `\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E2D}\u{E35}\u{E01}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632} \u{627}\u{628} \u{645}\u{648}\u{62C}\u{648}\u{62F} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `T\xe0i li\u{1EC7}u kh\xf4ng c\xf2n t\u{1ED3}n t\u{1EA1}i.`,
    "zh-hans": `\u{8BE5}\u{6587}\u{6863}\u{4E0D}\u{518D}\u{5B58}\u{5728}\u{3002}`,
    "zh-hant": `\u{8A72}\u{6587}\u{4EF6}\u{4E0D}\u{518D}\u{5B58}\u{5728}\u{3002}`,
    en: `The document no longer exists.`
};
const $2868cc1235412e16$export$bfbd4dde5c6712ef = {
    ar: `\u{633}\u{62A}\u{646}\u{62A}\u{647}\u{64A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{629} \u{631}\u{627}\u{628}\u{637} \u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{628}\u{639}\u{62F} 12 \u{633}\u{627}\u{639}\u{629}. \u{633}\u{64A}\u{62A}\u{645}\u{643}\u{646} \u{623}\u{64A} \u{634}\u{62E}\u{635} \u{64A}\u{62A}\u{644}\u{642}\u{649} \u{627}\u{644}\u{631}\u{627}\u{628}\u{637} \u{645}\u{646} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{635}\u{641}\u{62D}\u{629} \u{627}\u{644}\u{62A}\u{648}\u{642}\u{64A}\u{639} \u{62D}\u{62A}\u{649} \u{62A}\u{646}\u{62A}\u{647}\u{64A} \u{635}\u{644}\u{627}\u{62D}\u{64A}\u{62A}\u{647}\u{627} \u{623}\u{648} \u{64A}\u{62A}\u{645} \u{62A}\u{648}\u{642}\u{64A}\u{639}\u{647}\u{627}.`,
    de: `Der Link zur Signaturseite l\xe4uft nach 12 Stunden ab. Jeder, der den Link erh\xe4lt, kann auf die Signaturseite zugreifen, bis sie abl\xe4uft oder signiert ist.`,
    es: `El enlace de la p\xe1gina de firma caducar\xe1 despu\xe9s de 12 horas. Cualquier persona que reciba el enlace podr\xe1 acceder a la p\xe1gina de firma hasta que caduque o se firme.`,
    fa: `\u{67E}\u{6CC}\u{648}\u{646}\u{62F} \u{635}\u{641}\u{62D}\u{647} \u{627}\u{645}\u{636}\u{627} \u{67E}\u{633} \u{627}\u{632} 12 \u{633}\u{627}\u{639}\u{62A} \u{645}\u{646}\u{642}\u{636}\u{6CC} \u{645}\u{6CC} \u{634}\u{648}\u{62F}. \u{647}\u{631} \u{6A9}\u{633}\u{6CC} \u{6A9}\u{647} \u{67E}\u{6CC}\u{648}\u{646}\u{62F} \u{631}\u{627} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{646}\u{62F}\u{60C} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{62A}\u{627} \u{632}\u{645}\u{627}\u{646} \u{627}\u{646}\u{642}\u{636}\u{627}\u{6CC} \u{6CC}\u{627} \u{627}\u{645}\u{636}\u{627}\u{6CC} \u{635}\u{641}\u{62D}\u{647} \u{627}\u{645}\u{636}\u{627} \u{628}\u{647} \u{622}\u{646} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{62F}\u{627}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{62F}.`,
    fil: `Ang link ng pahina ng lagda ay mag-e-expire pagkatapos ng 12 oras. Ang sinumang makakatanggap ng link ay maaaring ma-access ang pahina ng lagda hanggang sa mag-expire ito o mapirmahan.`,
    fr: `Le lien de la page de signature expirera apr\xe8s 12 heures. Toute personne recevant le lien pourra acc\xe9der \xe0 la page de signature jusqu\u{2019}\xe0 ce qu\u{2019}elle expire ou soit sign\xe9e.`,
    hi: `\u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{932}\u{93F}\u{902}\u{915} 12 \u{918}\u{902}\u{91F}\u{947} \u{915}\u{947} \u{92C}\u{93E}\u{926} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{939}\u{94B} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964} \u{932}\u{93F}\u{902}\u{915} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{93E} \u{915}\u{94B}\u{908} \u{92D}\u{940} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{92A}\u{943}\u{937}\u{94D}\u{920} \u{915}\u{94B} \u{924}\u{92C} \u{924}\u{915} \u{90F}\u{915}\u{94D}\u{938}\u{947}\u{938} \u{915}\u{930} \u{938}\u{915}\u{947}\u{917}\u{93E} \u{91C}\u{92C} \u{924}\u{915} \u{915}\u{93F} \u{909}\u{938}\u{915}\u{940} \u{938}\u{92E}\u{92F} \u{938}\u{940}\u{92E}\u{93E} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{91C}\u{93E}\u{924}\u{940} \u{92F}\u{93E} \u{909}\u{938} \u{92A}\u{930} \u{939}\u{938}\u{94D}\u{924}\u{93E}\u{915}\u{94D}\u{937}\u{930} \u{928}\u{939}\u{940}\u{902} \u{939}\u{94B} \u{91C}\u{93E}\u{924}\u{947}\u{964}`,
    ht: `Lyen paj siyati a ap ekspire apre 12 \xe8dtan. Nenp\xf2t moun k ap resevwa lyen an yo pral kapab jwenn aks\xe8 nan paj la siyati jiskaske li ekspire oswa siyen.`,
    it: `Il link alla pagina della firma scadr\xe0 dopo 12 ore. Chiunque riceva il link potr\xe0 accedere alla pagina della firma fino alla scadenza o alla firma.`,
    ja: `\u{7F72}\u{540D}\u{30DA}\u{30FC}\u{30B8}\u{306E}\u{30EA}\u{30F3}\u{30AF}\u{306F} 12 \u{6642}\u{9593}\u{5F8C}\u{306B}\u{671F}\u{9650}\u{5207}\u{308C}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}\u{30EA}\u{30F3}\u{30AF}\u{3092}\u{53D7}\u{3051}\u{53D6}\u{3063}\u{305F}\u{4EBA}\u{306F}\u{8AB0}\u{3067}\u{3082}\u{3001}\u{7F72}\u{540D}\u{30DA}\u{30FC}\u{30B8}\u{306E}\u{6709}\u{52B9}\u{671F}\u{9650}\u{304C}\u{5207}\u{308C}\u{308B}\u{304B}\u{7F72}\u{540D}\u{3055}\u{308C}\u{308B}\u{307E}\u{3067}\u{3001}\u{7F72}\u{540D}\u{30DA}\u{30FC}\u{30B8}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C11C}\u{BA85} \u{D398}\u{C774}\u{C9C0} \u{B9C1}\u{D06C}\u{B294} 12\u{C2DC}\u{AC04} \u{D6C4}\u{C5D0} \u{B9CC}\u{B8CC}\u{B429}\u{B2C8}\u{B2E4}. \u{B9C1}\u{D06C}\u{B97C} \u{BC1B}\u{B294} \u{C0AC}\u{B78C}\u{C740} \u{B204}\u{AD6C}\u{B098} \u{C11C}\u{BA85}\u{C774} \u{B9CC}\u{B8CC}\u{B418}\u{AC70}\u{B098} \u{C11C}\u{BA85}\u{B420} \u{B54C}\u{AE4C}\u{C9C0} \u{C11C}\u{BA85} \u{D398}\u{C774}\u{C9C0}\u{C5D0} \u{C561}\u{C138}\u{C2A4}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Qhov kos npe yuav tshwm sim tom qab 12 teev. Leej twg los tau qhov txuas yuav tau mus saib tau cov nplooj ntawv kos npe mus txog rau thaum nws expires los yog kos npe.`,
    ps: `\u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{67E}\u{627}\u{6BC}\u{6D0} \u{644}\u{6CC}\u{646}\u{6A9} \u{628}\u{647} \u{62F} 12 \u{633}\u{627}\u{639}\u{62A}\u{648}\u{646}\u{648} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6CC}\u{696}\u{6CC}. \u{647}\u{631} \u{685}\u{648}\u{6A9} \u{686}\u{6D0} \u{644}\u{6CC}\u{646}\u{6A9} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{648}\u{6CC} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{6CC} \u{62F} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{67E}\u{627}\u{6BC}\u{6D0} \u{62A}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{648}\u{644}\u{631}\u{6CC} \u{62A}\u{631} \u{685}\u{648} \u{686}\u{6D0} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{6D0}\u{696}\u{6CC} \u{6CC}\u{627} \u{644}\u{627}\u{633}\u{644}\u{6CC}\u{6A9} \u{646}\u{647} \u{634}\u{6CC}.`,
    pt: `O link da p\xe1gina de assinatura expirar\xe1 ap\xf3s 12 horas. Qualquer pessoa que receber o link poder\xe1 acessar a p\xe1gina de assinatura at\xe9 que ela expire ou seja assinada.`,
    "pt-pt": `O link da p\xe1gina de assinatura expirar\xe1 ap\xf3s 12 horas. Qualquer pessoa que receba o link poder\xe1 acessar a p\xe1gina de assinatura at\xe9 que ela expire ou seja assinada.`,
    ru: `\u{421}\u{440}\u{43E}\u{43A} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{438} \u{43D}\u{430} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{443} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{438}\u{441}\u{442}\u{435}\u{447}\u{435}\u{442} \u{447}\u{435}\u{440}\u{435}\u{437} 12 \u{447}\u{430}\u{441}\u{43E}\u{432}. \u{41B}\u{44E}\u{431}\u{43E}\u{439}, \u{43A}\u{442}\u{43E} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442} \u{441}\u{441}\u{44B}\u{43B}\u{43A}\u{443}, \u{441}\u{43C}\u{43E}\u{436}\u{435}\u{442} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{438}\u{442}\u{44C} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{441}\u{442}\u{440}\u{430}\u{43D}\u{438}\u{446}\u{435} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{438} \u{434}\u{43E} \u{442}\u{435}\u{445} \u{43F}\u{43E}\u{440}, \u{43F}\u{43E}\u{43A}\u{430} \u{441}\u{440}\u{43E}\u{43A} \u{435}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{43D}\u{435} \u{438}\u{441}\u{442}\u{435}\u{447}\u{435}\u{442} \u{438}\u{43B}\u{438} \u{43E}\u{43D}\u{430} \u{43D}\u{435} \u{431}\u{443}\u{434}\u{435}\u{442} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{430}.`,
    sm: `O le sootaga o le itulau saini o le a muta pe a mavae le 12 itula. So'o se tasi e mauaina le feso'ota'iga o le a mafai ona ulufale i le itulau saini se'ia mae'a pe sainia.`,
    so: `Bogga saxiixa linkiga wuxuu dhici doonaa 12 saacadood ka dib. Qof kasta oo helaya link-ka wuxuu awoodi doonaa inuu galo bogga saxiixa ilaa uu ka dhaco ama la saxiixayo.`,
    th: `\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E08}\u{E30}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E44}\u{E1B} 12 \u{E0A}\u{E31}\u{E48}\u{E27}\u{E42}\u{E21}\u{E07} \u{E43}\u{E04}\u{E23}\u{E01}\u{E47}\u{E15}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E08}\u{E30}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E25}\u{E32}\u{E22}\u{E40}\u{E0B}\u{E47}\u{E19}\u{E44}\u{E14}\u{E49}\u{E08}\u{E19}\u{E01}\u{E27}\u{E48}\u{E32}\u{E08}\u{E30}\u{E2B}\u{E21}\u{E14}\u{E2D}\u{E32}\u{E22}\u{E38}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E25}\u{E07}\u{E19}\u{E32}\u{E21}`,
    ur: `\u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6D2} \u{635}\u{641}\u{62D}\u{6D2} \u{6A9}\u{627} \u{644}\u{646}\u{6A9} 12 \u{6AF}\u{6BE}\u{646}\u{679}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{628}\u{639}\u{62F} \u{62E}\u{62A}\u{645} \u{6C1}\u{648}\u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627}\u{6D4} \u{644}\u{646}\u{6A9} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627} \u{6A9}\u{648}\u{626}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{634}\u{62E}\u{635} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{6A9}\u{6D2} \u{635}\u{641}\u{62D}\u{6D2} \u{62A}\u{6A9} \u{627}\u{633} \u{648}\u{642}\u{62A} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{62D}\u{627}\u{635}\u{644} \u{6A9}\u{631}\u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{6D2} \u{62C}\u{628} \u{62A}\u{6A9} \u{6A9}\u{6C1} \u{627}\u{633} \u{6A9}\u{6CC} \u{645}\u{6CC}\u{639}\u{627}\u{62F} \u{62E}\u{62A}\u{645} \u{646}\u{6C1} \u{6C1}\u{648}\u{62C}\u{627}\u{626}\u{6D2} \u{6CC}\u{627} \u{627}\u{633} \u{67E}\u{631} \u{62F}\u{633}\u{62A}\u{62E}\u{637} \u{646}\u{6C1} \u{6C1}\u{648}\u{62C}\u{627}\u{626}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Li\xean k\u{1EBF}t trang ch\u{1EEF} k\xfd s\u{1EBD} h\u{1EBF}t h\u{1EA1}n sau 12 gi\u{1EDD}. B\u{1EA5}t k\u{1EF3} ai nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t s\u{1EBD} c\xf3 th\u{1EC3} truy c\u{1EAD}p trang ch\u{1EEF} k\xfd cho \u{111}\u{1EBF}n khi n\xf3 h\u{1EBF}t h\u{1EA1}n ho\u{1EB7}c \u{111}\u{1B0}\u{1EE3}c k\xfd.`,
    "zh-hans": `\u{7B7E}\u{540D}\u{9875}\u{94FE}\u{63A5}\u{5C06}\u{5728} 12 \u{5C0F}\u{65F6}\u{540E}\u{8FC7}\u{671F}\u{3002}\u{6536}\u{5230}\u{8BE5}\u{94FE}\u{63A5}\u{7684}\u{4EFB}\u{4F55}\u{4EBA}\u{90FD}\u{53EF}\u{4EE5}\u{8BBF}\u{95EE}\u{8BE5}\u{7B7E}\u{540D}\u{9875}\u{FF0C}\u{76F4}\u{5230}\u{8BE5}\u{9875}\u{8FC7}\u{671F}\u{6216}\u{88AB}\u{7B7E}\u{540D}\u{4E3A}\u{6B62}\u{3002}`,
    "zh-hant": `\u{7C3D}\u{540D}\u{9801}\u{9023}\u{7D50}\u{5C07}\u{5728}12\u{5C0F}\u{6642}\u{5F8C}\u{904E}\u{671F}\u{3002}\u{6536}\u{5230}\u{8A72}\u{9023}\u{7D50}\u{7684}\u{4EFB}\u{4F55}\u{4EBA}\u{90FD}\u{53EF}\u{4EE5}\u{8A2A}\u{554F}\u{8A72}\u{7C3D}\u{540D}\u{9801}\u{FF0C}\u{76F4}\u{5230}\u{8A72}\u{9801}\u{904E}\u{671F}\u{6216}\u{88AB}\u{7C3D}\u{540D}\u{70BA}\u{6B62}\u{3002}`,
    en: `The signature page link will expire after 12 hours. Anyone receiving the link will be able to access the signature page until it expires or is signed.`
};
const $2868cc1235412e16$export$71ec55e0d6f09dfe = {
    ar: `\u{62F}\u{645}\u{62C}`,
    de: `Verschmelzen`,
    es: `Fusionar`,
    fa: `\u{627}\u{62F}\u{63A}\u{627}\u{645}`,
    fil: `Pagsamahin`,
    fr: `Fusionner`,
    hi: `\u{921}\u{941}\u{92C}\u{94B}`,
    ht: `Fonn`,
    it: `Fondersi`,
    ja: `\u{30DE}\u{30FC}\u{30B8}`,
    ko: `\u{BCD1}\u{D569}`,
    mww: `merge`,
    ps: `\u{6CC}\u{648} \u{681}\u{627}\u{6CC} \u{6A9}\u{648}\u{644}`,
    pt: `Fundir`,
    "pt-pt": `Mesclar`,
    ru: `\u{421}\u{43B}\u{438}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Tuufaatasi`,
    so: `Merge`,
    th: `\u{E04}\u{E27}\u{E1A}`,
    ur: `\u{636}\u{645}`,
    vi: `Merge`,
    "zh-hans": `\u{5408}\u{5E76}`,
    "zh-hant": `\u{5408}\u{4F75}`,
    en: `Merge`
};
const $2868cc1235412e16$export$5603a2ca1ae8c068 = {
    ar: (title)=>`\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{645}\u{646} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{62F}\u{645}\u{62C} "${title}"\u{61F} \u{633}\u{64A}\u{62A}\u{645} \u{62D}\u{630}\u{641} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{648}\u{633}\u{64A}\u{62A}\u{645} \u{646}\u{642}\u{644} \u{623}\u{646}\u{634}\u{637}\u{62A}\u{647} \u{625}\u{644}\u{649} \u{627}\u{644}\u{633}\u{62C}\u{644} \u{627}\u{644}\u{647}\u{62F}\u{641}.`,
    de: (title)=>`Sind Sie sicher, dass Sie "${title}" zusammenf\xfchren m\xf6chten? Dieser Datensatz wird gel\xf6scht und seine Aktivit\xe4ten werden in den Zieldatensatz verschoben.`,
    es: (title)=>`\xbfEst\xe1s seguro de que quieres fusionar "${title}"? Este registro se eliminar\xe1 y sus actividades se mover\xe1n al registro de destino.`,
    fa: (title)=>`\u{622}\u{6CC}\u{627} \u{645}\u{637}\u{645}\u{626}\u{646} \u{647}\u{633}\u{62A}\u{6CC}\u{62F} \u{6A9}\u{647} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} "${title} \u{631}\u{627} \u{627}\u{62F}\u{63A}\u{627}\u{645} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F} \u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{62D}\u{630}\u{641} \u{645}\u{6CC} \u{634}\u{648}\u{62F} \u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{647}\u{627}\u{6CC} \u{622}\u{646} \u{628}\u{647} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{647}\u{62F}\u{641} \u{645}\u{646}\u{62A}\u{642}\u{644} \u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: (title)=>`Sigurado ka bang gusto mong i-merge ang "${title}"? Ang rekord na ito ay tatanggalin at ang mga aktibidad nito ay ililipat sa target na talaan.`,
    fr: (title)=>`\xcates-vous s\xfbr de vouloir fusionner \xab\xa0${title}\xa0\xbb ? Cet enregistrement sera supprim\xe9 et ses activit\xe9s seront d\xe9plac\xe9es vers l\u{2019}enregistrement cible.`,
    hi: (title)=>`\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} "${title}" \u{92E}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}? \u{92F}\u{939} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{939}\u{91F}\u{93E} \u{926}\u{93F}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E} \u{914}\u{930} \u{907}\u{938}\u{915}\u{940} \u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{932}\u{915}\u{94D}\u{937}\u{94D}\u{92F} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{92A}\u{930} \u{932}\u{947} \u{91C}\u{93E}\u{92F}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}.`,
    ht: (title)=>`\xc8ske ou s\xe8ten ou vle rantre nan "${title}"? Dosye sa a pral efase ak aktivite li yo pral deplase nan dosye a sib.`,
    it: (title)=>`Sei sicuro di voler unire "${title}"? Questo record verr\xe0 eliminato e le relative attivit\xe0 verranno spostate nel record di destinazione.`,
    ja: (title)=>`\u{300C}${title}\u{300D}\u{3092}\u{7D71}\u{5408}\u{3057}\u{3066}\u{3082}\u{3088}\u{308D}\u{3057}\u{3044}\u{3067}\u{3059}\u{304B}?\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306F}\u{524A}\u{9664}\u{3055}\u{308C}\u{3001}\u{305D}\u{306E}\u{6D3B}\u{52D5}\u{306F}\u{30BF}\u{30FC}\u{30B2}\u{30C3}\u{30C8} \u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{306B}\u{79FB}\u{52D5}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: (title)=>`"${title}"\u{B97C} \u{BCD1}\u{D569}\u{D558}\u{C2DC}\u{ACA0}\u{C2B5}\u{B2C8}\u{AE4C}? \u{C774} \u{B808}\u{CF54}\u{B4DC}\u{AC00} \u{C0AD}\u{C81C}\u{B418}\u{ACE0} \u{D574}\u{B2F9} \u{D65C}\u{B3D9}\u{C774} \u{B300}\u{C0C1} \u{B808}\u{CF54}\u{B4DC}\u{B85C} \u{C774}\u{B3D9}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: (title)=>`Koj puas paub tseeb tias koj xav merge "${title}"? Cov ntaub ntawv no yuav tau deleted thiab nws cov kev ua ub no yuav tau tsiv mus nyob rau lub hom phaj.`,
    ps: (title)=>`\u{622}\u{6CC}\u{627} \u{645}\u{637}\u{645}\u{626}\u{646}\u{626} \u{686}\u{6D0} \u{63A}\u{648}\u{627}\u{693}\u{626} "${title}" \u{633}\u{631}\u{647} \u{6CC}\u{648} \u{681}\u{627}\u{6CC} \u{6A9}\u{693}\u{626}\u{61F} \u{62F}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{628}\u{647} \u{62D}\u{630}\u{641} \u{634}\u{6CC} \u{627}\u{648} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{646}\u{647} \u{628}\u{647} \u{6CC}\u{6D0} \u{647}\u{62F}\u{641} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{62A}\u{647} \u{648}\u{644}\u{6CC}\u{696}\u{62F}\u{648}\u{644} \u{634}\u{6CC}.`,
    pt: (title)=>`Tem certeza de que deseja mesclar "${title}"? Esse registro ser\xe1 exclu\xeddo e suas atividades ser\xe3o movidas para o registro de destino.`,
    "pt-pt": (title)=>`Tem certeza de que deseja mesclar "${title}"? Esse registro ser\xe1 exclu\xeddo e suas atividades ser\xe3o movidas para o registro de destino.`,
    ru: (title)=>`\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{43E}\u{431}\u{44A}\u{435}\u{434}\u{438}\u{43D}\u{438}\u{442}\u{44C} "${title}"? \u{42D}\u{442}\u{430} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{431}\u{443}\u{434}\u{435}\u{442} \u{443}\u{434}\u{430}\u{43B}\u{435}\u{43D}\u{430}, \u{430} \u{435}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{431}\u{443}\u{434}\u{443}\u{442} \u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{449}\u{435}\u{43D}\u{44B} \u{432} \u{446}\u{435}\u{43B}\u{435}\u{432}\u{443}\u{44E} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C}.`,
    sm: (title)=>`E te mautinoa e te mana'o e tu'ufa'atasia le "${title}"? O lenei faamaumauga o le a aveesea ma o le a siitia ana gaoioiga i le faamaumauga faamoemoeina.`,
    so: (title)=>`Ma hubtaa inaad rabto inaad isku darsato "${title}"? Diiwaankaas ayaa la tirtiri doonaa, waxaana howlaheedii loo gudbinayaa diiwaankii lagu bartilmaameedsaday.`,
    th: (title)=>`\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E23}\u{E27}\u{E21} "${title}" \u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E25}\u{E1A}\u{E41}\u{E25}\u{E30}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21}\u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E22}\u{E49}\u{E32}\u{E22}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E40}\u{E23}\u{E01}\u{E04}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E40}\u{E1B}\u{E49}\u{E32}\u{E2B}\u{E21}\u{E32}\u{E22}`,
    ur: (title)=>`\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} "\u{62C}\u{627}\u{646} \u{688}\u{648}" \u{6A9}\u{648} \u{636}\u{645} \u{6A9}\u{631}\u{646}\u{627} ${title}\u{61F} \u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{648} \u{62D}\u{630}\u{641} \u{6A9}\u{631}\u{62F}\u{6CC}\u{627} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627} \u{627}\u{648}\u{631} \u{627}\u{633} \u{6A9}\u{6CC} \u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{648} \u{6C1}\u{62F}\u{641} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{645}\u{6CC}\u{6BA} \u{645}\u{646}\u{62A}\u{642}\u{644} \u{6A9}\u{631}\u{62F}\u{6CC}\u{627} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627}\u{6D4}`,
    vi: (title)=>`B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n h\u{1EE3}p nh\u{1EA5}t "${title}" kh\xf4ng? B\u{1EA3}n ghi n\xe0y s\u{1EBD} b\u{1ECB} x\xf3a v\xe0 c\xe1c ho\u{1EA1}t \u{111}\u{1ED9}ng c\u{1EE7}a n\xf3 s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c chuy\u{1EC3}n \u{111}\u{1EBF}n b\u{1EA3}n ghi \u{111}\xedch.`,
    "zh-hans": (title)=>`\u{60A8}\u{786E}\u{5B9A}\u{8981}\u{5408}\u{5E76} \u{201C}${title}\u{201D} \u{5417}\u{FF1F}\u{6B64}\u{8BB0}\u{5F55}\u{5C06}\u{88AB}\u{5220}\u{9664}\u{FF0C}\u{5176}\u{6D3B}\u{52A8}\u{5C06}\u{79FB}\u{52A8}\u{5230}\u{76EE}\u{6807}\u{8BB0}\u{5F55}\u{3002}`,
    "zh-hant": (title)=>`\u{60A8}\u{78BA}\u{5B9A}\u{8981}\u{5408}\u{4F75} \u{300C}${title}\u{300D} \u{55CE}\u{FF1F}\u{6B64}\u{8A18}\u{9304}\u{5C07}\u{88AB}\u{522A}\u{9664}\u{FF0C}\u{5176}\u{6D3B}\u{52D5}\u{5C07}\u{79FB}\u{52D5}\u{5230}\u{76EE}\u{6A19}\u{8A18}\u{9304}\u{3002}`,
    en: (title)=>`Are you sure you want to merge "${title}"? This record will be deleted and its activities will be moved to the target record.`
};
const $2868cc1235412e16$export$1bfba6da06977d47 = {
    ar: `\u{62A}\u{623}\u{643}\u{64A}\u{62F} \u{627}\u{644}\u{62F}\u{645}\u{62C}`,
    de: `Zusammenf\xfchrung best\xe4tigen`,
    es: `Confirmar combinaci\xf3n`,
    fa: `\u{627}\u{62F}\u{63A}\u{627}\u{645} \u{631}\u{627} \u{62A}\u{623}\u{6CC}\u{6CC}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Kumpirmahin ang pagsasanib`,
    fr: `Confirmer la fusion`,
    hi: `\u{92E}\u{930}\u{94D}\u{91C} \u{915}\u{940} \u{92A}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Konfime ke`,
    it: `Conferma l'unione`,
    ja: `\u{30DE}\u{30FC}\u{30B8}\u{306E}\u{78BA}\u{8A8D}`,
    ko: `\u{BCD1}\u{D569} \u{D655}\u{C778}`,
    mww: `Paub tseeb hais tias merge`,
    ps: `\u{62F} \u{627}\u{62F}\u{63A}\u{627}\u{645} \u{62A}\u{627}\u{626}\u{6CC}\u{62F}`,
    pt: `Confirmar mesclagem`,
    "pt-pt": `Confirmar mesclagem`,
    ru: `\u{41F}\u{43E}\u{434}\u{442}\u{432}\u{435}\u{440}\u{434}\u{438}\u{442}\u{435} \u{441}\u{43B}\u{438}\u{44F}\u{43D}\u{438}\u{435}`,
    sm: `Fa'amaonia le tu'ufa'atasia`,
    so: `Xaqiiji inay ku midoobaan`,
    th: `\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E01}\u{E32}\u{E23}\u{E1C}\u{E2A}\u{E32}\u{E19}`,
    ur: `\u{636}\u{645} \u{6C1}\u{648}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xe1c nh\u{1EAD}n h\u{1EE3}p nh\u{1EA5}t`,
    "zh-hans": `\u{786E}\u{8BA4}\u{5408}\u{5E76}`,
    "zh-hant": `\u{78BA}\u{8A8D}\u{5408}\u{4F75}`,
    en: `Confirm merge`
};
const $2868cc1235412e16$export$c76e75bd8a6bfedf = {
    ar: `\u{633}\u{62C}\u{644} \u{627}\u{644}\u{628}\u{62D}\u{62B}...`,
    de: `Verlauf der Suche...`,
    es: `Historial de b\xfasqueda...`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647} \u{62C}\u{633}\u{62A}\u{62C}\u{648}...`,
    fil: `Kasaysayan ng Paghahanap ...`,
    fr: `Historique de recherche...`,
    hi: `\u{916}\u{94B}\u{91C} \u{907}\u{924}\u{93F}\u{939}\u{93E}\u{938}...`,
    ht: `Istwa rech\xe8ch ...`,
    it: `Cronologia delle ricerche...`,
    ja: `\u{691C}\u{7D22}\u{5C65}\u{6B74}...`,
    ko: `\u{AC80}\u{C0C9} \u{AE30}\u{B85D}...`,
    mww: `Nrhiav keeb kwm...`,
    ps: `\u{62F} \u{644}\u{67C}\u{648}\u{646} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647}...`,
    pt: `Pesquisar no hist\xf3rico...`,
    "pt-pt": `Hist\xf3rico de pesquisas...`,
    ru: `\u{418}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{44F} \u{43F}\u{43E}\u{438}\u{441}\u{43A}\u{430}...`,
    sm: `Su'esu'e talafa'asolopito ...`,
    so: `Raadi taariikhda ...`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E27}\u{E31}\u{E15}\u{E34}\u{E01}\u{E32}\u{E23}\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}...`,
    ur: `\u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}...`,
    vi: `L\u{1ECB}ch s\u{1EED} t\xecm ki\u{1EBF}m...`,
    "zh-hans": `\u{641C}\u{7D22}\u{5386}\u{53F2}...`,
    "zh-hant": `\u{641C}\u{5C0B}\u{6B77}\u{53F2}...`,
    en: `Search history...`
};
const $2868cc1235412e16$export$5b0a88ee249e8720 = {
    ar: `\u{623}\u{628}\u{639}\u{62F}`,
    de: `Entfernen`,
    es: `Eliminar`,
    fa: `\u{62D}\u{630}\u{641}`,
    fil: `Alisin`,
    fr: `Enlever`,
    hi: `\u{939}\u{91F}\u{93E}\u{928}\u{93E}`,
    ht: `Deplase`,
    it: `Togliere`,
    ja: `\u{53D6}\u{308A}\u{53BB}\u{308B}`,
    ko: `\u{C81C}\u{AC70}\u{D558}\u{B2E4}`,
    mww: `Tshem`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Retirar`,
    "pt-pt": `Remover`,
    ru: `\u{423}\u{431}\u{438}\u{440}\u{430}\u{442}\u{44C}`,
    sm: `Aveese`,
    so: `ka saar`,
    th: `\u{E16}\u{E2D}\u{E14}`,
    ur: `\u{6C1}\u{679}\u{627}\u{646}\u{627}`,
    vi: `Tri\u{1EC7}t`,
    "zh-hans": `\u{5220}\u{9664}`,
    "zh-hant": `\u{522A}\u{9664}`,
    en: `Remove`
};
const $2868cc1235412e16$export$a6918c6011afcb74 = {
    ar: (title)=>`\u{647}\u{644} \u{623}\u{646}\u{62A} \u{645}\u{62A}\u{623}\u{643}\u{62F} \u{645}\u{646} \u{623}\u{646}\u{643} \u{62A}\u{631}\u{64A}\u{62F} \u{625}\u{632}\u{627}\u{644}\u{629} ${title}\u{61F}`,
    de: (title)=>`Sind Sie sicher, dass Sie ${title} entfernen m\xf6chten?`,
    es: (title)=>`\xbfEst\xe1s seguro de que quieres eliminar ${title}?`,
    fa: (title)=>`\u{622}\u{6CC}\u{627} \u{645}\u{637}\u{645}\u{626}\u{646} \u{647}\u{633}\u{62A}\u{6CC}\u{62F} \u{6A9}\u{647} \u{645}\u{6CC} \u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} ${title} \u{631}\u{627} \u{62D}\u{630}\u{641} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
    fil: (title)=>`Sigurado ka bang nais mong tanggalin ang ${title}?`,
    fr: (title)=>`\xcates-vous s\xfbr de vouloir supprimer ${title} ?`,
    hi: (title)=>`\u{915}\u{94D}\u{92F}\u{93E} \u{906}\u{92A} \u{935}\u{93E}\u{915}\u{908} ${title} \u{928}\u{93F}\u{915}\u{93E}\u{932}\u{928}\u{93E} \u{91A}\u{93E}\u{939}\u{924}\u{947} \u{939}\u{948}\u{902}?`,
    ht: (title)=>`\xc8ske ou s\xe8ten ou vle retire ${title}?`,
    it: (title)=>`Sei sicuro di voler rimuovere ${title}?`,
    ja: (title)=>`${title}\u{3082}\u{3088}\u{308D}\u{3057}\u{3044}\u{3067}\u{3059}\u{304B}?`,
    ko: (title)=>`${title} \u{C81C}\u{AC70}\u{D558}\u{C2DC}\u{ACA0}\u{C2B5}\u{B2C8}\u{AE4C}?`,
    mww: (title)=>`Koj puas paub tseeb tias koj xav tshem ${title}?`,
    ps: (title)=>`\u{622}\u{6CC}\u{627} \u{62A}\u{627}\u{633}\u{648} \u{689}\u{627}\u{689}\u{647} \u{6CC}\u{627}\u{633}\u{62A} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{63A}\u{648}\u{627}\u{693}\u{626} ${title} \u{644}\u{631}\u{6D0} \u{6A9}\u{693}\u{626}\u{61F}`,
    pt: (title)=>`Tem certeza de que deseja remover o ${title}?`,
    "pt-pt": (title)=>`Tem certeza de que deseja remover ${title}?`,
    ru: (title)=>`\u{412}\u{44B} \u{443}\u{432}\u{435}\u{440}\u{435}\u{43D}\u{44B}, \u{447}\u{442}\u{43E} \u{445}\u{43E}\u{442}\u{438}\u{442}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} ${title}?`,
    sm: (title)=>`E te mautinoa e te mana'o e aveese le ${title}?`,
    so: (title)=>`Ma hubtaa inaad rabtid inaad ka saarto ${title}?`,
    th: (title)=>`\u{E04}\u{E38}\u{E13}\u{E41}\u{E19}\u{E48}\u{E43}\u{E08}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E44}\u{E21}\u{E48}\u{E27}\u{E48}\u{E32}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E25}\u{E1A}${title}`,
    ur: (title)=>`\u{6A9}\u{6CC}\u{627} \u{622}\u{67E} \u{648}\u{627}\u{642}\u{639}\u{6CC} ${title} \u{6A9}\u{648} \u{6C1}\u{679}\u{627}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{61F}`,
    vi: (title)=>`B\u{1EA1}n c\xf3 ch\u{1EAF}c ch\u{1EAF}n mu\u{1ED1}n x\xf3a ${title} kh\xf4ng?`,
    "zh-hans": (title)=>`\u{60A8}\u{786E}\u{5B9A}\u{8981}\u{5220}\u{9664} ${title}\u{5417}\u{FF1F}`,
    "zh-hant": (title)=>`\u{60A8}\u{78BA}\u{5B9A}\u{8981}\u{522A}\u{9664} ${title}\u{55CE}\u{FF1F}`,
    en: (title)=>`Are you sure you want to remove ${title}?`
};
const $2868cc1235412e16$export$9ccc96e97b65b30b = {
    ar: `\u{62A}\u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Erneuern`,
    es: `Regenerar`,
    fa: `\u{628}\u{627}\u{632}\u{633}\u{627}\u{632}\u{6CC}`,
    fil: `Muling Pagbuo`,
    fr: `R\xe9g\xe9n\xe9rer`,
    hi: `\u{92A}\u{941}\u{928}\u{930}\u{94D}\u{91C}\u{928}\u{94D}\u{92E}`,
    ht: `Rejenerasyon`,
    it: `Rigenerare`,
    ja: `\u{518D}\u{751F}`,
    ko: `\u{C7AC}\u{C0DD}\u{C131}`,
    mww: `Regenerate`,
    ps: `\u{628}\u{6CC}\u{627} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F}`,
    pt: `Regenerar`,
    "pt-pt": `Regenerar`,
    ru: `\u{420}\u{435}\u{433}\u{435}\u{43D}\u{435}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Toe fa'afouina`,
    so: `Dib u soo noolaada`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{627}\u{635}\u{644}\u{627}\u{62D} \u{6A9}\u{631}\u{646}\u{627}`,
    vi: `T\xe1i t\u{1EA1}o`,
    "zh-hans": `\u{518D}\u{751F}`,
    "zh-hant": `\u{518D}\u{751F}`,
    en: `Regenerate`
};
const $2868cc1235412e16$export$612e5b9f7a9c488d = {
    ar: `\u{625}\u{639}\u{627}\u{62F}\u{629} \u{625}\u{646}\u{634}\u{627}\u{621} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{631}\u{62F}\u{627}\u{62F}`,
    de: `Wiederherstellungscode neu generieren`,
    es: `Volver a generar el c\xf3digo de recuperaci\xf3n`,
    fa: `\u{6A9}\u{62F} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{631}\u{627} \u{628}\u{627}\u{632}\u{633}\u{627}\u{632}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Muling buuin ang code ng pagbawi`,
    fr: `R\xe9g\xe9n\xe9rer le code de r\xe9cup\xe9ration`,
    hi: `\u{92A}\u{941}\u{928}\u{930}\u{94D}\u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{915}\u{94B}\u{921} \u{92A}\u{941}\u{928}: \u{909}\u{924}\u{94D}\u{92A}\u{928}\u{94D}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rejenerasyon k\xf2d rekiperasyon`,
    it: `Rigenera il codice di ripristino`,
    ja: `\u{30EA}\u{30AB}\u{30D0}\u{30EA}\u{30B3}\u{30FC}\u{30C9}\u{306E}\u{518D}\u{751F}\u{6210}`,
    ko: `\u{BCF5}\u{AD6C} \u{CF54}\u{B4DC} \u{B2E4}\u{C2DC} \u{C0DD}\u{C131}`,
    mww: `Regenerate rov qab code`,
    ps: `\u{62F} \u{628}\u{6CC}\u{627} \u{631}\u{63A}\u{648}\u{646}\u{6D0} \u{6A9}\u{648}\u{689} \u{628}\u{6CC}\u{627} \u{62A}\u{648}\u{644}\u{6CC}\u{62F}`,
    pt: `Regenerar c\xf3digo de recupera\xe7\xe3o`,
    "pt-pt": `Regenerar o c\xf3digo de recupera\xe7\xe3o`,
    ru: `\u{41F}\u{43E}\u{432}\u{442}\u{43E}\u{440}\u{43D}\u{43E}\u{435} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{435} \u{43A}\u{43E}\u{434}\u{430} \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Toe faafouina le numera o le toe faaleleia`,
    so: `Dib u soo kabashada code`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E32}\u{E23}\u{E01}\u{E39}\u{E49}\u{E04}\u{E37}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `Regenerate \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{648}\u{688}`,
    vi: `T\u{1EA1}o l\u{1EA1}i m\xe3 kh\xf4i ph\u{1EE5}c`,
    "zh-hans": `\u{91CD}\u{65B0}\u{751F}\u{6210}\u{6062}\u{590D}\u{4EE3}\u{7801}`,
    "zh-hant": `\u{91CD}\u{65B0}\u{751F}\u{6210}\u{6062}\u{5FA9}\u{4EE3}\u{78BC}`,
    en: `Regenerate recovery code`
};
const $2868cc1235412e16$export$f9f8f2d1914b7cf3 = {
    ar: `\u{623}\u{639}\u{62F} \u{625}\u{646}\u{634}\u{627}\u{621} \u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{630}\u{64A} \u{64A}\u{645}\u{643}\u{646}\u{643} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645}\u{647} \u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{639}\u{646}\u{62F}\u{645}\u{627} \u{644}\u{627} \u{64A}\u{643}\u{648}\u{646} \u{644}\u{62F}\u{64A}\u{643} \u{62D}\u{642} \u{627}\u{644}\u{648}\u{635}\u{648}\u{644} \u{625}\u{644}\u{649} \u{62C}\u{647}\u{627}\u{632} (\u{623}\u{62C}\u{647}\u{632}\u{629}) \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{62E}\u{627}\u{635}\u{629} \u{628}\u{643}.`,
    de: `Generieren Sie den Code neu, mit dem Sie sich anmelden k\xf6nnen, wenn Sie keinen Zugriff auf Ihr(e) Authentifizierungsger\xe4t(e) haben.`,
    es: `Vuelva a generar el c\xf3digo que puede usar para iniciar sesi\xf3n cuando no tenga acceso a su(s) dispositivo(s) de autenticaci\xf3n.`,
    fa: `\u{6A9}\u{62F}\u{6CC} \u{631}\u{627} \u{6A9}\u{647} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{6CC}\u{62F} \u{628}\u{631}\u{627}\u{6CC} \u{648}\u{631}\u{648}\u{62F} \u{628}\u{647} \u{633}\u{6CC}\u{633}\u{62A}\u{645} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}\u{60C} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{6A9}\u{647} \u{628}\u{647} \u{62F}\u{633}\u{62A}\u{6AF}\u{627}\u{647}(\u{647}\u{627}\u{6CC}) \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{62E}\u{648}\u{62F} \u{62F}\u{633}\u{62A}\u{631}\u{633}\u{6CC} \u{646}\u{62F}\u{627}\u{631}\u{6CC}\u{62F}\u{60C} \u{628}\u{627}\u{632}\u{633}\u{627}\u{632}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `I-regenerate ang code na maaari mong gamitin upang mag-login kapag wala kang access sa iyong (mga) authenticator device.`,
    fr: `R\xe9g\xe9n\xe9rez le code que vous pouvez utiliser pour vous connecter lorsque vous n\u{2019}avez pas acc\xe8s \xe0 votre ou vos appareils d\u{2019}authentification.`,
    hi: `\u{909}\u{938} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{92A}\u{941}\u{928}: \u{909}\u{924}\u{94D}\u{92A}\u{928}\u{94D}\u{928} \u{915}\u{930}\u{947}\u{902} \u{91C}\u{93F}\u{938}\u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{906}\u{92A} \u{932}\u{949}\u{917}\u{93F}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{915}\u{930} \u{938}\u{915}\u{924}\u{947} \u{939}\u{948}\u{902} \u{91C}\u{92C} \u{906}\u{92A}\u{915}\u{947} \u{92A}\u{93E}\u{938} \u{905}\u{92A}\u{928}\u{947} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{921}\u{93F}\u{935}\u{93E}\u{907}\u{938} (\u{909}\u{92A}\u{915}\u{930}\u{923}\u{94B}\u{902}) \u{924}\u{915} \u{92A}\u{939}\u{941}\u{902}\u{91A} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}\u{964}`,
    ht: `Rejenerasyon k\xf2d la ou ka itilize yo konekte l\xe8 ou pa gen aks\xe8 a apar\xe8y natif natal ou (yo).`,
    it: `Rigenera il codice che puoi utilizzare per accedere quando non hai accesso ai tuoi dispositivi di autenticazione.`,
    ja: `\u{8A8D}\u{8A3C}\u{30C7}\u{30D0}\u{30A4}\u{30B9}\u{306B}\u{30A2}\u{30AF}\u{30BB}\u{30B9}\u{3067}\u{304D}\u{306A}\u{3044}\u{5834}\u{5408}\u{306B}\u{30ED}\u{30B0}\u{30A4}\u{30F3}\u{3059}\u{308B}\u{305F}\u{3081}\u{306B}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{308B}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{518D}\u{751F}\u{6210}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C778}\u{C99D} \u{C7A5}\u{CE58}\u{C5D0} \u{C561}\u{C138}\u{C2A4}\u{D560} \u{C218} \u{C5C6}\u{B294} \u{ACBD}\u{C6B0} \u{B85C}\u{ADF8}\u{C778}\u{D558}\u{B294} \u{B370} \u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C788}\u{B294} \u{CF54}\u{B4DC}\u{B97C} \u{B2E4}\u{C2DC} \u{C0DD}\u{C131}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Regenerate qhov chaws uas koj yuav siv tau login thaum koj tsis tau mus saib rau koj authenticator ntaus(s).`,
    ps: `\u{647}\u{63A}\u{647} \u{6A9}\u{648}\u{689} \u{628}\u{6CC}\u{627} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{626} \u{62F} \u{646}\u{646}\u{648}\u{62A}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{648}\u{6A9}\u{627}\u{631}\u{648}\u{626} \u{6A9}\u{644}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62E}\u{67E}\u{644} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{622}\u{644}\u{647} \u{62A}\u{647} \u{644}\u{627}\u{633}\u{631}\u{633}\u{6CC} \u{646}\u{644}\u{631}\u{6CC}.`,
    pt: `Gere novamente o c\xf3digo que voc\xea pode usar para fazer login quando n\xe3o tiver acesso ao(s) seu(s) dispositivo(s) autenticador(es).`,
    "pt-pt": `Regenere o c\xf3digo que pode utilizar para iniciar sess\xe3o quando n\xe3o tiver acesso ao(s) seu(s) dispositivo(s) autenticador(es).`,
    ru: `\u{41F}\u{43E}\u{432}\u{442}\u{43E}\u{440}\u{43D}\u{43E} \u{441}\u{433}\u{435}\u{43D}\u{435}\u{440}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} \u{43A}\u{43E}\u{434}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{439} \u{43C}\u{43E}\u{436}\u{43D}\u{43E} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{434}\u{43B}\u{44F} \u{432}\u{445}\u{43E}\u{434}\u{430} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443}, \u{435}\u{441}\u{43B}\u{438} \u{443} \u{432}\u{430}\u{441} \u{43D}\u{435}\u{442} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{430} \u{43A} \u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{430}\u{43C} \u{434}\u{43B}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `Toe fa'afouina le code e mafai ona e fa'aaogaina e login ai pe a leai sau avanoa i lau masini fa'amaonia.`,
    so: `Dib u soo noolee koodhka aad isticmaali karto si aad u gasho marka aadan u helin aaladdaada authenticator(s).`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E43}\u{E2B}\u{E21}\u{E48}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E43}\u{E0A}\u{E49}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E40}\u{E02}\u{E49}\u{E32}\u{E2A}\u{E39}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E40}\u{E21}\u{E37}\u{E48}\u{E2D}\u{E04}\u{E38}\u{E13}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E02}\u{E49}\u{E32}\u{E16}\u{E36}\u{E07}\u{E2D}\u{E38}\u{E1B}\u{E01}\u{E23}\u{E13}\u{E4C}\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E2A}\u{E34}\u{E17}\u{E18}\u{E34}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{62C}\u{628} \u{622}\u{67E} \u{6A9}\u{6D2} \u{67E}\u{627}\u{633} \u{627}\u{67E}\u{646}\u{6D2} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{646}\u{646}\u{62F}\u{6C1} \u{622}\u{644}\u{6C1} \u{62A}\u{6A9} \u{631}\u{633}\u{627}\u{626}\u{6CC} \u{646}\u{6C1} \u{6C1}\u{648} \u{62A}\u{648} \u{644}\u{627}\u{6AF} \u{627}\u{646} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{622}\u{67E} \u{62C}\u{633} \u{6A9}\u{648}\u{688} \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{633}\u{6A9}\u{62A}\u{6D2} \u{6C1}\u{6CC}\u{6BA} \u{627}\u{633}\u{6D2} \u{62F}\u{648}\u{628}\u{627}\u{631}\u{6C1} \u{62A}\u{6CC}\u{627}\u{631} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `T\u{1EA1}o l\u{1EA1}i m\xe3 b\u{1EA1}n c\xf3 th\u{1EC3} s\u{1EED} d\u{1EE5}ng \u{111}\u{1EC3} \u{111}\u{103}ng nh\u{1EAD}p khi b\u{1EA1}n kh\xf4ng c\xf3 quy\u{1EC1}n truy c\u{1EAD}p v\xe0o (c\xe1c) thi\u{1EBF}t b\u{1ECB} x\xe1c th\u{1EF1}c c\u{1EE7}a m\xecnh.`,
    "zh-hans": `\u{91CD}\u{65B0}\u{751F}\u{6210}\u{60A8}\u{5728}\u{65E0}\u{6CD5}\u{8BBF}\u{95EE}\u{8EAB}\u{4EFD}\u{9A8C}\u{8BC1}\u{5668}\u{8BBE}\u{5907}\u{65F6}\u{53EF}\u{7528}\u{4E8E}\u{767B}\u{5F55}\u{7684}\u{4EE3}\u{7801}\u{3002}`,
    "zh-hant": `\u{91CD}\u{65B0}\u{751F}\u{6210}\u{60A8}\u{5728}\u{7121}\u{6CD5}\u{5B58}\u{53D6}\u{8EAB}\u{4EFD}\u{9A57}\u{8B49}\u{5668}\u{8A2D}\u{5099}\u{6642}\u{53EF}\u{7528}\u{65BC}\u{767B}\u{9304}\u{7684}\u{4EE3}\u{78BC}\u{3002}`,
    en: `Regenerate the code you can use to login when you do not have access to your authenticator device(s).`
};
const $2868cc1235412e16$export$11b12d95aadca158 = {
    ar: `\u{627}\u{646}\u{633}\u{62E} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{631}\u{62F}\u{627}\u{62F} \u{647}\u{630}\u{627} \u{648}\u{627}\u{62D}\u{62A}\u{641}\u{638} \u{628}\u{647} \u{641}\u{64A} \u{645}\u{643}\u{627}\u{646} \u{622}\u{645}\u{646}. \u{633}\u{62A}\u{62D}\u{62A}\u{627}\u{62C} \u{625}\u{644}\u{64A}\u{647} \u{625}\u{630}\u{627} \u{627}\u{62D}\u{62A}\u{62C}\u{62A} \u{641}\u{64A} \u{623}\u{64A} \u{648}\u{642}\u{62A} \u{625}\u{644}\u{649} \u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{627}\u{644}\u{62F}\u{62E}\u{648}\u{644} \u{628}\u{62F}\u{648}\u{646} \u{62C}\u{647}\u{627}\u{632}\u{643}.`,
    de: `Kopieren Sie diesen Wiederherstellungscode, und bewahren Sie ihn an einem sicheren Ort auf. Sie werden es brauchen, wenn Sie sich jemals ohne Ihr Ger\xe4t anmelden m\xfcssen.`,
    es: `Copie este c\xf3digo de recuperaci\xf3n y gu\xe1rdelo en un lugar seguro. Lo necesitar\xe1s si alguna vez necesitas iniciar sesi\xf3n sin tu dispositivo.`,
    fa: `\u{627}\u{6CC}\u{646} \u{6A9}\u{62F} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{631}\u{627} \u{6A9}\u{67E}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{622}\u{646} \u{631}\u{627} \u{62F}\u{631} \u{62C}\u{627}\u{6CC}\u{6CC} \u{627}\u{645}\u{646} \u{646}\u{6AF}\u{647} \u{62F}\u{627}\u{631}\u{6CC}\u{62F}. \u{627}\u{6AF}\u{631} \u{646}\u{6CC}\u{627}\u{632} \u{628}\u{647} \u{648}\u{631}\u{648}\u{62F} \u{628}\u{62F}\u{648}\u{646} \u{62F}\u{633}\u{62A}\u{6AF}\u{627}\u{647} \u{62E}\u{648}\u{62F} \u{62F}\u{627}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{6CC}\u{62F}\u{60C} \u{628}\u{647} \u{622}\u{646} \u{646}\u{6CC}\u{627}\u{632} \u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{62F}\u{627}\u{634}\u{62A}.`,
    fil: `Kopyahin ang recovery code na ito at itago ito sa isang lugar na ligtas. Kakailanganin mo ito kung sakaling kailangan mong mag-log in nang wala ang iyong aparato.`,
    fr: `Copiez ce code de r\xe9cup\xe9ration et conservez-le dans un endroit s\xfbr. Vous en aurez besoin si vous devez vous connecter sans votre appareil.`,
    hi: `\u{907}\u{938} \u{92A}\u{941}\u{928}\u{930}\u{94D}\u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{915}\u{949}\u{92A}\u{940} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{907}\u{938}\u{947} \u{915}\u{939}\u{940}\u{902} \u{938}\u{941}\u{930}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{930}\u{916}\u{947}\u{902}\u{964} \u{92F}\u{926}\u{93F} \u{906}\u{92A}\u{915}\u{94B} \u{915}\u{92D}\u{940} \u{92D}\u{940} \u{905}\u{92A}\u{928}\u{947} \u{921}\u{93F}\u{935}\u{93E}\u{907}\u{938} \u{915}\u{947} \u{92C}\u{93F}\u{928}\u{93E} \u{932}\u{949}\u{917} \u{907}\u{928} \u{915}\u{930}\u{928}\u{947} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{948} \u{924}\u{94B} \u{906}\u{92A}\u{915}\u{94B} \u{907}\u{938}\u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `Kopi k\xf2d rekiperasyon sa a epi kenbe li yon kote ki an sekirite. Ou pral bezwen li si ou janm bezwen ouvri sesyon an san apar\xe8y ou an.`,
    it: `Copia questo codice di ripristino e conservalo in un luogo sicuro. Ne avrai bisogno se hai bisogno di accedere senza il tuo dispositivo.`,
    ja: `\u{3053}\u{306E}\u{30EA}\u{30AB}\u{30D0}\u{30EA}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{30B3}\u{30D4}\u{30FC}\u{3057}\u{3066}\u{3001}\u{5B89}\u{5168}\u{306A}\u{5834}\u{6240}\u{306B}\u{4FDD}\u{7BA1}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}\u{30C7}\u{30D0}\u{30A4}\u{30B9}\u{306A}\u{3057}\u{3067}\u{30ED}\u{30B0}\u{30A4}\u{30F3}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308B}\u{5834}\u{5408}\u{306B}\u{5FC5}\u{8981}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C774} \u{BCF5}\u{AD6C} \u{CF54}\u{B4DC}\u{B97C} \u{BCF5}\u{C0AC}\u{D558}\u{C5EC} \u{C548}\u{C804}\u{D55C} \u{ACF3}\u{C5D0} \u{BCF4}\u{AD00}\u{D558}\u{C2ED}\u{C2DC}\u{C624}. \u{C7A5}\u{CE58} \u{C5C6}\u{C774} \u{B85C}\u{ADF8}\u{C778}\u{D574}\u{C57C} \u{D558}\u{B294} \u{ACBD}\u{C6B0} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Luam daim ntawv rov qab no thiab khaws nws qhov chaw zoo. Koj yuav tau nws yog hais tias koj puas yuav tsum tau log nyob rau hauv tsis tau koj ntaus ntawv.`,
    ps: `\u{62F}\u{627} \u{62F} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{648}\u{689} \u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{67E}\u{647} \u{6CC}\u{648} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{681}\u{627}\u{6CC} \u{6A9}\u{6D0} \u{6CC}\u{6D0} \u{648}\u{633}\u{627}\u{62A}\u{626}. \u{62A}\u{627}\u{633}\u{648} \u{628}\u{647} \u{647}\u{63A}\u{647} \u{62A}\u{647} \u{627}\u{693}\u{62A}\u{6CC}\u{627} \u{648}\u{644}\u{631}\u{626} \u{6A9}\u{647} \u{686}\u{6CC}\u{631}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62F} \u{62E}\u{67E}\u{644} \u{622}\u{644}\u{6D0} \u{67E}\u{631}\u{62A}\u{647} \u{644}\u{627}\u{6AB} \u{627}\u{646} \u{6A9}\u{648}\u{644}\u{648} \u{62A}\u{647} \u{627}\u{693}\u{62A}\u{6CC}\u{627} \u{648}\u{644}\u{631}\u{626}.`,
    pt: `Copie este c\xf3digo de recupera\xe7\xe3o e mantenha-o em algum lugar seguro. Voc\xea precisar\xe1 dele se precisar fazer login sem o seu dispositivo.`,
    "pt-pt": `Copie este c\xf3digo de recupera\xe7\xe3o e mantenha-o em algum lugar seguro. Voc\xea precisar\xe1 dele se precisar fazer login sem seu dispositivo.`,
    ru: `\u{421}\u{43A}\u{43E}\u{43F}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} \u{44D}\u{442}\u{43E}\u{442} \u{43A}\u{43E}\u{434} \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F} \u{438} \u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{435} \u{435}\u{433}\u{43E} \u{432} \u{431}\u{435}\u{437}\u{43E}\u{43F}\u{430}\u{441}\u{43D}\u{43E}\u{43C} \u{43C}\u{435}\u{441}\u{442}\u{435}. \u{41E}\u{43D} \u{432}\u{430}\u{43C} \u{43F}\u{43E}\u{43D}\u{430}\u{434}\u{43E}\u{431}\u{438}\u{442}\u{441}\u{44F}, \u{435}\u{441}\u{43B}\u{438} \u{432}\u{430}\u{43C} \u{43A}\u{43E}\u{433}\u{434}\u{430}-\u{43D}\u{438}\u{431}\u{443}\u{434}\u{44C} \u{43F}\u{43E}\u{43D}\u{430}\u{434}\u{43E}\u{431}\u{438}\u{442}\u{441}\u{44F} \u{432}\u{43E}\u{439}\u{442}\u{438} \u{432} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443} \u{431}\u{435}\u{437} \u{432}\u{430}\u{448}\u{435}\u{433}\u{43E} \u{443}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{441}\u{442}\u{432}\u{430}.`,
    sm: `Kopi lenei numera laiti toe faaleleia ma teu i se mea saogalemu. O le ae manaomia ai pe afai e te manaomia e alu i totonu e aunoa ma lau masini.`,
    so: `Nuqul ka dhig lambarkan ka soo kabashada oo meel ammaan ah ka ilaali. Waad u baahan doontaa haddii aad marnaba u baahan tahay inaad gasho qalab la'aanteed.`,
    th: `\u{E04}\u{E31}\u{E14}\u{E25}\u{E2D}\u{E01}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E32}\u{E23}\u{E01}\u{E39}\u{E49}\u{E04}\u{E37}\u{E19}\u{E19}\u{E35}\u{E49}\u{E41}\u{E25}\u{E30}\u{E40}\u{E01}\u{E47}\u{E1A}\u{E44}\u{E27}\u{E49}\u{E43}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1B}\u{E25}\u{E2D}\u{E14}\u{E20}\u{E31}\u{E22} \u{E04}\u{E38}\u{E13}\u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E0A}\u{E49}\u{E21}\u{E31}\u{E19}\u{E2B}\u{E32}\u{E01}\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E40}\u{E02}\u{E49}\u{E32}\u{E2A}\u{E39}\u{E48}\u{E23}\u{E30}\u{E1A}\u{E1A}\u{E42}\u{E14}\u{E22}\u{E44}\u{E21}\u{E48}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E0A}\u{E49}\u{E2D}\u{E38}\u{E1B}\u{E01}\u{E23}\u{E13}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{627}\u{633} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{648}\u{688} \u{6A9}\u{648} \u{6A9}\u{627}\u{67E}\u{6CC} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{633}\u{6D2} \u{6A9}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{631}\u{6A9}\u{6BE}\u{6CC}\u{6BA}\u{6D4} \u{627}\u{6AF}\u{631} \u{622}\u{67E} \u{6A9}\u{648} \u{6A9}\u{628}\u{6BE}\u{6CC} \u{628}\u{6BE}\u{6CC} \u{627}\u{67E}\u{646}\u{6D2} \u{622}\u{644}\u{6D2} \u{6A9}\u{6D2} \u{628}\u{63A}\u{6CC}\u{631} \u{644}\u{627}\u{6AF} \u{627}\u{646} \u{6A9}\u{631}\u{646}\u{6D2} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{648} \u{62A}\u{648} \u{622}\u{67E} \u{6A9}\u{648} \u{627}\u{633} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{648}\u{6AF}\u{6CC}\u{6D4}`,
    vi: `Sao ch\xe9p m\xe3 kh\xf4i ph\u{1EE5}c n\xe0y v\xe0 gi\u{1EEF} n\xf3 \u{1EDF} n\u{1A1}i an to\xe0n. B\u{1EA1}n s\u{1EBD} c\u{1EA7}n n\xf3 n\u{1EBF}u b\u{1EA1}n c\u{1EA7}n \u{111}\u{103}ng nh\u{1EAD}p m\xe0 kh\xf4ng c\u{1EA7}n thi\u{1EBF}t b\u{1ECB} c\u{1EE7}a m\xecnh.`,
    "zh-hans": `\u{590D}\u{5236}\u{6B64}\u{6062}\u{590D}\u{4EE3}\u{7801}\u{5E76}\u{5C06}\u{5176}\u{4FDD}\u{5B58}\u{5728}\u{5B89}\u{5168}\u{7684}\u{5730}\u{65B9}\u{3002}\u{5982}\u{679C}\u{60A8}\u{9700}\u{8981}\u{5728}\u{6CA1}\u{6709}\u{8BBE}\u{5907}\u{7684}\u{60C5}\u{51B5}\u{4E0B}\u{767B}\u{5F55}\u{FF0C}\u{60A8}\u{5C06}\u{9700}\u{8981}\u{5B83}\u{3002}`,
    "zh-hant": `\u{8907}\u{88FD}\u{6B64}\u{6062}\u{5FA9}\u{4EE3}\u{78BC}\u{4E26}\u{5C07}\u{5176}\u{4FDD}\u{5B58}\u{5728}\u{5B89}\u{5168}\u{7684}\u{5730}\u{65B9}\u{3002}\u{5982}\u{679C}\u{60A8}\u{9700}\u{8981}\u{5728}\u{6C92}\u{6709}\u{8A2D}\u{5099}\u{7684}\u{60C5}\u{6CC1}\u{4E0B}\u{767B}\u{9304}\u{FF0C}\u{60A8}\u{5C07}\u{9700}\u{8981}\u{5B83}\u{3002}`,
    en: `Copy this recovery code and keep it somewhere safe. You\u{2019}ll need it if you ever need to log in without your device.`
};
const $2868cc1235412e16$export$e4d3ce7fbdaf370e = {
    ar: `\u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{631}\u{62F}\u{627}\u{62F}`,
    de: `Wiederherstellungscode`,
    es: `C\xf3digo de recuperaci\xf3n`,
    fa: `\u{6A9}\u{62F} \u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC}`,
    fil: `Code ng pagbawi`,
    fr: `Code de r\xe9cup\xe9ration`,
    hi: `\u{930}\u{93F}\u{915}\u{935}\u{930}\u{940} \u{915}\u{94B}\u{921}`,
    ht: `K\xf2d rekiperasyon`,
    it: `Codice di ripristino`,
    ja: `\u{30EA}\u{30AB}\u{30D0}\u{30EA}\u{30FC}\u{30B3}\u{30FC}\u{30C9}`,
    ko: `\u{BCF5}\u{AD6C} \u{CF54}\u{B4DC}`,
    mww: `Rov ua hauj lwm dua`,
    ps: `\u{62F} \u{628}\u{6CC}\u{627} \u{631}\u{63A}\u{648}\u{646}\u{6D0} \u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo de recupera\xe7\xe3o`,
    "pt-pt": `C\xf3digo de recupera\xe7\xe3o`,
    ru: `\u{41A}\u{43E}\u{434} \u{432}\u{43E}\u{441}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Numera o le toe faaleleia`,
    so: `Recovery code`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E32}\u{E23}\u{E01}\u{E39}\u{E49}\u{E04}\u{E37}\u{E19}`,
    ur: `\u{628}\u{627}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{627} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 kh\xf4i ph\u{1EE5}c`,
    "zh-hans": `\u{6062}\u{590D}\u{4EE3}\u{7801}`,
    "zh-hant": `\u{6062}\u{5FA9}\u{4EE3}\u{78BC}`,
    en: `Recovery code`
};
const $2868cc1235412e16$export$35a92ba66af9f452 = {
    ar: `\u{62A}\u{633}\u{62C}\u{64A}\u{644}`,
    de: `Einschreiben`,
    es: `Inscribirse`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645}`,
    fil: `Email Address *`,
    fr: `Inscrire`,
    hi: `\u{92D}\u{930}\u{94D}\u{924}\u{940} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Anwole`,
    it: `Iscriversi`,
    ja: `\u{5165}\u{308B}`,
    ko: `\u{B4F1}\u{B85D}`,
    mww: `Muaj Npe Muaj Npe`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Inscrever`,
    "pt-pt": `Inscrever-se`,
    ru: `\u{417}\u{430}\u{447}\u{438}\u{441}\u{43B}\u{44F}\u{442}\u{44C}`,
    sm: `Lesitala`,
    so: `isdiiwaangalin`,
    th: `\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    "zh-hans": `\u{6CE8}\u{518C}`,
    "zh-hant": `\u{8A3B}\u{518A}`,
    en: `Enroll`
};
const $2868cc1235412e16$export$f3aeac60053b3d5 = {
    ar: `\u{647}\u{627}\u{62A}\u{641} (SMS)`,
    de: `Telefon (SMS)`,
    es: `Tel\xe9fono (SMS)`,
    fa: `\u{62A}\u{644}\u{641}\u{646} (\u{67E}\u{6CC}\u{627}\u{645}\u{6A9})`,
    fil: `Telepono (SMS)`,
    fr: `T\xe9l\xe9phone (SMS)`,
    hi: `\u{92B}\u{94B}\u{928} (\u{90F}\u{938}\u{90F}\u{92E}\u{90F}\u{938})`,
    ht: `Telef\xf2n (SMS)`,
    it: `Telefono (SMS)`,
    ja: `\u{96FB}\u{8A71}(SMS)`,
    ko: `\u{C804}\u{D654}(SMS)`,
    mww: `Xov Tooj (SMS)`,
    ps: `\u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} (\u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633})`,
    pt: `Telefone (SMS)`,
    "pt-pt": `Telefone (SMS)`,
    ru: `\u{422}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D} (SMS)`,
    sm: `Telefoni (SMS)`,
    so: `Telefoonka (SMS)`,
    th: `\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} (SMS)`,
    ur: `\u{641}\u{648}\u{646} (\u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633})`,
    vi: `\u{110}i\u{1EC7}n tho\u{1EA1}i (SMS)`,
    "zh-hans": `\u{7535}\u{8BDD} \u{FF08}SMS\u{FF09}`,
    "zh-hant": `\u{96FB}\u{8A71} \u{FF08}SMS\u{FF09}`,
    en: `Phone (SMS)`
};
const $2868cc1235412e16$export$9e24ad1ff1e71692 = {
    ar: `\u{63A}\u{64A}\u{631} \u{645}\u{633}\u{62C}\u{644}`,
    de: `Nicht eingeschrieben`,
    es: `No inscritos`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Hindi nakatala`,
    fr: `Non inscrit`,
    hi: `\u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{93F}\u{924} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa enskri`,
    it: `Non iscritto`,
    ja: `\u{672A}\u{767B}\u{9332}`,
    ko: `\u{B4F1}\u{B85D}\u{B418}\u{C9C0} \u{C54A}\u{C74C}`,
    mww: `Tsis muaj npe tau txais kev pab`,
    ps: `\u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{646}\u{647} \u{62F}\u{647} \u{634}\u{648}\u{6D0}`,
    pt: `N\xe3o inscrito`,
    "pt-pt": `N\xe3o inscrito`,
    ru: `\u{41D}\u{435} \u{437}\u{430}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}`,
    sm: `E le'i lesitala`,
    so: `Lama qorin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E44}\u{E14}\u{E49}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{648}\u{627}`,
    vi: `Ch\u{1B0}a \u{111}\u{103}ng k\xfd`,
    "zh-hans": `\u{672A}\u{6CE8}\u{518C}`,
    "zh-hant": `\u{672A}\u{8A3B}\u{518A}`,
    en: `Not enrolled`
};
const $2868cc1235412e16$export$61168040ae64a77d = {
    ar: `\u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{645}\u{62A}\u{639}\u{62F}\u{62F}\u{629} \u{627}\u{644}\u{639}\u{648}\u{627}\u{645}\u{644} (MFA)`,
    de: `Multi-Faktor-Authentifizierung (MFA)`,
    es: `Autenticaci\xf3n multifactor (MFA)`,
    fa: `\u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{686}\u{646}\u{62F} \u{639}\u{627}\u{645}\u{644}\u{6CC} (MFA)`,
    fil: `Multi-factor na pagpapatunay (MFA)`,
    fr: `Authentification multifacteur (MFA)`,
    hi: `\u{92C}\u{939}\u{941}-\u{915}\u{93E}\u{930}\u{915} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{940}\u{915}\u{930}\u{923} (\u{90F}\u{92E}\u{90F}\u{92B}\u{90F})`,
    ht: `Milti-fakt\xe8 otantifikasyon (MFA)`,
    it: `Autenticazione a pi\xf9 fattori (MFA)`,
    ja: `\u{591A}\u{8981}\u{7D20}\u{8A8D}\u{8A3C}(MFA)`,
    ko: `\u{B2E4}\u{B2E8}\u{ACC4} \u{C778}\u{C99D}(MFA)`,
    mww: `Tej yam authentication (MFA)`,
    ps: `\u{685}\u{648} \u{641}\u{6A9}\u{62A}\u{648}\u{631}\u{648}\u{646}\u{647} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} (MFA)`,
    pt: `Autentica\xe7\xe3o multifator (MFA)`,
    "pt-pt": `Autentica\xe7\xe3o multifator (MFA)`,
    ru: `\u{41C}\u{43D}\u{43E}\u{433}\u{43E}\u{444}\u{430}\u{43A}\u{442}\u{43E}\u{440}\u{43D}\u{430}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{44F} (MFA)`,
    sm: `Fa'amaoniga Fa'apitoa (MFA)`,
    so: `Aqoonsiga Multi-factor (MFA)`,
    th: `\u{E01}\u{E32}\u{E23}\u{E23}\u{E31}\u{E1A}\u{E23}\u{E2D}\u{E07}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E41}\u{E1A}\u{E1A}\u{E2B}\u{E25}\u{E32}\u{E22}\u{E1B}\u{E31}\u{E08}\u{E08}\u{E31}\u{E22} (MFA)`,
    ur: `\u{645}\u{644}\u{679}\u{6CC} \u{641}\u{6CC}\u{6A9}\u{679}\u{631} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} (\u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{641} \u{627}\u{6D2})`,
    vi: `X\xe1c th\u{1EF1}c \u{111}a y\u{1EBF}u t\u{1ED1} (MFA)`,
    "zh-hans": `\u{591A}\u{91CD}\u{8EAB}\u{4EFD}\u{9A8C}\u{8BC1} \u{FF08}MFA\u{FF09}`,
    "zh-hant": `\u{591A}\u{91CD}\u{8EAB}\u{4EFD}\u{9A57}\u{8B49} \u{FF08}MFA\u{FF09}`,
    en: `Multi-factor authentication (MFA)`
};
const $2868cc1235412e16$export$89940308ff58a7f9 = {
    ar: `\u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F}\u{629} \u{625}\u{644}\u{649} \u{627}\u{644}\u{648}\u{642}\u{62A} (TOTP)`,
    de: `Zeitbasiertes Einmalpasswort (TOTP)`,
    es: `Contrase\xf1a de un solo uso basada en el tiempo (TOTP)`,
    fa: `\u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{6CC}\u{6A9}\u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{645}\u{628}\u{62A}\u{646}\u{6CC} \u{628}\u{631} \u{632}\u{645}\u{627}\u{646} (TOTP)`,
    fil: `Time-based One-Time Password (TOTP)`,
    fr: `Mot de passe \xe0 usage unique bas\xe9 sur le temps (TOTP)`,
    hi: `\u{938}\u{92E}\u{92F}-\u{906}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} (TOTP)`,
    ht: `Modpas Yon s\xe8l-fwa (TOTP)`,
    it: `Password monouso basata sul tempo (TOTP)`,
    ja: `\u{6642}\u{9593}\u{30D9}\u{30FC}\u{30B9}\u{306E}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}(TOTP)`,
    ko: `\u{C2DC}\u{AC04} \u{AE30}\u{BC18} \u{C77C}\u{D68C}\u{C6A9} \u{BE44}\u{BC00}\u{BC88}\u{D638}(TOTP)`,
    mww: `Sij hawm kuas ib-lub sij hawm Password (TOTP)`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{631} \u{628}\u{646}\u{633}\u{67C} \u{6CC}\u{648} \u{681}\u{644} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} (TOTP)`,
    pt: `Senha de uso \xfanico baseada em tempo (TOTP)`,
    "pt-pt": `Senha \xfanica baseada no tempo (TOTP)`,
    ru: `\u{41E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44C} \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} (TOTP)`,
    sm: `Taimi Fa'avae Tasi-Taimi Fa'aupuga (TOTP)`,
    so: `Waqtiga ku salaysan Hal-Time Password (TOTP)`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E15}\u{E32}\u{E21}\u{E40}\u{E27}\u{E25}\u{E32} (TOTP)`,
    ur: `\u{648}\u{642}\u{62A} \u{67E}\u{631} \u{645}\u{628}\u{646}\u{6CC} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} (\u{679}\u{6CC} \u{627}\u{648} \u{679}\u{6CC} \u{67E}\u{6CC})`,
    vi: `M\u{1EAD}t kh\u{1EA9}u m\u{1ED9}t l\u{1EA7}n d\u{1EF1}a tr\xean th\u{1EDD}i gian (TOTP)`,
    "zh-hans": `\u{57FA}\u{4E8E}\u{65F6}\u{95F4}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{7801} \u{FF08}TOTP\u{FF09}`,
    "zh-hant": `\u{57FA}\u{65BC}\u{6642}\u{9593}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{78BC} \u{FF08}TOTP\u{FF09}`,
    en: `Time-based One-Time Password (TOTP)`
};
const $2868cc1235412e16$export$8b2e65d03b9395df = {
    ar: `\u{627}\u{644}\u{645}\u{633}\u{62C}\u{644}\u{64A}\u{646}`,
    de: `Eingeschrieben`,
    es: `Inscrito`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645}`,
    fil: `Nagpatala`,
    fr: `Inscrits`,
    hi: `\u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{93F}\u{924}`,
    ht: `Anwole`,
    it: `Iscritto`,
    ja: `\u{767B}\u{9332}`,
    ko: `\u{B4F1}\u{B85D}`,
    mww: `Muaj Npe Muaj Npe Kawm`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Matriculado`,
    "pt-pt": `Inscritos`,
    ru: `\u{417}\u{430}\u{447}\u{438}\u{441}\u{43B}\u{435}\u{43D}\u{44B}`,
    sm: `Lesitala`,
    so: `Dadka la isku qoray`,
    th: `\u{E25}\u{E07} \u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}`,
    ur: `\u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C}`,
    vi: `\u{110}\u{103}ng k\xfd`,
    "zh-hans": `\u{767B}\u{8BB0}`,
    "zh-hant": `\u{767B}\u{8A18}`,
    en: `Enrolled`
};
const $2868cc1235412e16$export$65672aeb85122938 = {
    ar: (name)=>`\u{645}\u{633}\u{62C}\u{644} \u{641}\u{64A} ${name}`,
    de: (name)=>`Registriert bei ${name}`,
    es: (name)=>`Inscrito con ${name}`,
    fa: (name)=>`\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{628}\u{627} ${name}`,
    fil: (name)=>`Email: ${name}`,
    fr: (name)=>`Inscrit au ${name}`,
    hi: (name)=>`${name} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{93F}\u{924}`,
    ht: (name)=>`Enskri ak ${name}`,
    it: (name)=>`Iscritto con ${name}`,
    ja: (name)=>`${name}\u{306B}\u{767B}\u{9332}\u{6E08}\u{307F}`,
    ko: (name)=>`${name}\u{C5D0} \u{B4F1}\u{B85D}\u{B428}`,
    mww: (name)=>`Muaj npe zwm rau ${name}`,
    ps: (name)=>`\u{62F} ${name} \u{633}\u{631}\u{647} \u{62B}\u{628}\u{62A} \u{634}\u{648}\u{6CC}`,
    pt: (name)=>`Inscrito com ${name}`,
    "pt-pt": (name)=>`Inscrito com ${name}`,
    ru: (name)=>`\u{417}\u{430}\u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D} \u{43F}\u{43E} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{443} ${name}`,
    sm: (name)=>`Lesitala i le ${name}`,
    so: (name)=>`Ku qoran ${name}`,
    th: (name)=>`\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E01}\u{E31}\u{E1A} ${name}`,
    ur: (name)=>`${name} \u{633}\u{627}\u{62A}\u{6BE} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: (name)=>`\u{110}\u{103}ng k\xfd v\u{1EDB}i ${name}`,
    "zh-hans": (name)=>`\u{6CE8}\u{518C}\u{7535}\u{8BDD} ${name}`,
    "zh-hant": (name)=>`\u{8A3B}\u{518A}\u{96FB}\u{8A71} ${name}`,
    en: (name)=>`Enrolled with ${name}`
};
const $2868cc1235412e16$export$d1b8bb849ba247c6 = {
    ar: `\u{627}\u{633}\u{62A}\u{645}\u{631}`,
    de: `Fortsetzen`,
    es: `Continuar`,
    fa: `\u{627}\u{62F}\u{627}\u{645}\u{647}`,
    fil: `Magpatuloy`,
    fr: `Continuer`,
    hi: `\u{91C}\u{93E}\u{930}\u{940} \u{930}\u{916}\u{928}\u{93E}`,
    ht: `Kontinye`,
    it: `Continuare`,
    ja: `\u{7D9A}\u{3051}\u{308B}`,
    ko: `\u{ACC4}\u{C18D}\u{D558}\u{B2E4}`,
    mww: `Mus`,
    ps: `\u{627}\u{62F}\u{627}\u{645}\u{647}`,
    pt: `Continuar`,
    "pt-pt": `Continuar`,
    ru: `\u{41F}\u{440}\u{43E}\u{434}\u{43E}\u{43B}\u{436}\u{430}\u{442}\u{44C}`,
    sm: `Fa'aauau`,
    so: `Sii wad`,
    th: `\u{E15}\u{E48}\u{E2D}\u{E40}\u{E19}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{62C}\u{627}\u{631}\u{6CC} \u{631}\u{6A9}\u{6BE}\u{646}\u{627}`,
    vi: `Ti\u{1EBF}p t\u{1EE5}c`,
    "zh-hans": `\u{7EE7}\u{7EED}`,
    "zh-hant": `\u{7E7C}\u{7E8C}`,
    en: `Continue`
};
const $2868cc1235412e16$export$853cb2674bffdf8f = {
    ar: `\u{62A}\u{623}\u{645}\u{64A}\u{646} \u{62D}\u{633}\u{627}\u{628}\u{643} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641} (SMS)`,
    de: `Sichern Sie Ihr Konto per Telefon (SMS)`,
    es: `Asegure su cuenta mediante el tel\xe9fono (SMS)`,
    fa: `\u{627}\u{6CC}\u{645}\u{646} \u{633}\u{627}\u{632}\u{6CC} \u{62D}\u{633}\u{627}\u{628} \u{62E}\u{648}\u{62F} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{62A}\u{644}\u{641}\u{646} (\u{67E}\u{6CC}\u{627}\u{645}\u{6A9})`,
    fil: `I-secure ang iyong account gamit ang Telepono (SMS)`,
    fr: `S\xe9curisez votre compte \xe0 l\u{2019}aide du t\xe9l\xe9phone (SMS)`,
    hi: `\u{92B}\u{93C}\u{94B}\u{928} (SMS) \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{905}\u{92A}\u{928}\u{93E} \u{916}\u{93E}\u{924}\u{93E} \u{938}\u{941}\u{930}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Sekirite kont ou l\xe8 l s\xe8vi av\xe8k Telef\xf2n (SMS)`,
    it: `Proteggi il tuo account tramite telefono (SMS)`,
    ja: `\u{96FB}\u{8A71}(SMS)\u{3092}\u{4F7F}\u{7528}\u{3057}\u{3066}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{4FDD}\u{8B77}\u{3059}\u{308B}`,
    ko: `\u{C804}\u{D654}(SMS)\u{B97C} \u{C0AC}\u{C6A9}\u{D558}\u{C5EC} \u{ACC4}\u{C815} \u{BCF4}\u{D638}`,
    mww: `Ruaj ntseg koj tus account siv Xov Tooj (SMS)`,
    ps: `\u{62F} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} (\u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633}) \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{633}\u{631}\u{647} \u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{693}\u{626}`,
    pt: `Proteja sua conta usando Telefone (SMS)`,
    "pt-pt": `Proteja sua conta usando Telefone (SMS)`,
    ru: `\u{417}\u{430}\u{449}\u{438}\u{442}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{44E} \u{443}\u{447}\u{435}\u{442}\u{43D}\u{443}\u{44E} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430} (SMS)`,
    sm: `Malupuipuia lau teuga tupe e ala i le Telefoni (SMS)`,
    so: `Xaji akoonkaaga adoo isticmaalaya Phone (SMS)`,
    th: `\u{E23}\u{E31}\u{E01}\u{E29}\u{E32}\u{E04}\u{E27}\u{E32}\u{E21}\u{E1B}\u{E25}\u{E2D}\u{E14}\u{E20}\u{E31}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E31}\u{E1A}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} (SMS)`,
    ur: `\u{641}\u{648}\u{646} (SMS) \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{648} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA3}o m\u{1EAD}t t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n b\u{1EB1}ng \u{110}i\u{1EC7}n tho\u{1EA1}i (SMS)`,
    "zh-hans": `\u{4F7F}\u{7528}\u{7535}\u{8BDD} \u{FF08}SMS\u{FF09} \u{4FDD}\u{62A4}\u{60A8}\u{7684}\u{5E10}\u{6237}`,
    "zh-hant": `\u{4F7F}\u{7528}\u{96FB}\u{8A71} \u{FF08}SMS\u{FF09} \u{4FDD}\u{8B77}\u{60A8}\u{7684}\u{5E33}\u{6236}`,
    en: `Secure your account using Phone (SMS)`
};
const $2868cc1235412e16$export$65e55a627c6c5408 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{631}\u{642}\u{645} \u{647}\u{627}\u{62A}\u{641}\u{643} \u{623}\u{62F}\u{646}\u{627}\u{647}. \u{633}\u{64A}\u{62A}\u{645} \u{625}\u{631}\u{633}\u{627}\u{644} \u{631}\u{633}\u{627}\u{644}\u{629} \u{646}\u{635}\u{64A}\u{629} \u{642}\u{635}\u{64A}\u{631}\u{629} \u{625}\u{644}\u{649} \u{647}\u{630}\u{627} \u{627}\u{644}\u{631}\u{642}\u{645} \u{645}\u{639} \u{631}\u{645}\u{632} \u{644}\u{625}\u{62F}\u{62E}\u{627}\u{644}\u{647} \u{641}\u{64A} \u{627}\u{644}\u{634}\u{627}\u{634}\u{629} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}.`,
    de: `Geben Sie unten Ihre Telefonnummer ein. An diese Nummer wird eine SMS mit einem Code gesendet, den Sie auf dem n\xe4chsten Bildschirm eingeben m\xfcssen.`,
    es: `Ingrese su n\xfamero de tel\xe9fono a continuaci\xf3n. Se enviar\xe1 un SMS a ese n\xfamero con un c\xf3digo para ingresar en la siguiente pantalla.`,
    fa: `\u{634}\u{645}\u{627}\u{631}\u{647} \u{62A}\u{644}\u{641}\u{646}\u{62A}\u{627}\u{646} \u{631}\u{627} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}. \u{67E}\u{6CC}\u{627}\u{645}\u{6A9}\u{6CC} \u{628}\u{647} \u{622}\u{646} \u{634}\u{645}\u{627}\u{631}\u{647} \u{628}\u{627} \u{6CC}\u{6A9} \u{6A9}\u{62F} \u{628}\u{631}\u{627}\u{6CC} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{631}\u{62F}\u{646} \u{62F}\u{631} \u{635}\u{641}\u{62D}\u{647} \u{628}\u{639}\u{62F}\u{6CC} \u{627}\u{631}\u{633}\u{627}\u{644} \u{645}\u{6CC} \u{634}\u{648}\u{62F}.`,
    fil: `Ipasok ang iyong numero ng telepono sa ibaba. Isang SMS ang ipapadala sa numerong iyon na may code na ipasok sa susunod na screen.`,
    fr: `Entrez votre num\xe9ro de t\xe9l\xe9phone ci-dessous. Un SMS sera envoy\xe9 \xe0 ce num\xe9ro avec un code \xe0 saisir sur l\u{2019}\xe9cran suivant.`,
    hi: `\u{928}\u{940}\u{91A}\u{947} \u{905}\u{92A}\u{928}\u{93E} \u{92B}\u{93C}\u{94B}\u{928} \u{928}\u{902}\u{92C}\u{930} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964} \u{905}\u{917}\u{932}\u{940} \u{938}\u{94D}\u{915}\u{94D}\u{930}\u{940}\u{928} \u{92A}\u{930} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{928}\u{947} \u{915}\u{947} \u{932}\u{93F}\u{90F} \u{90F}\u{915} \u{915}\u{94B}\u{921} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{909}\u{938} \u{928}\u{902}\u{92C}\u{930} \u{92A}\u{930} \u{90F}\u{915} \u{90F}\u{938}\u{90F}\u{92E}\u{90F}\u{938} \u{92D}\u{947}\u{91C}\u{93E} \u{91C}\u{93E}\u{90F}\u{917}\u{93E}\u{964}`,
    ht: `Antre nimewo telef\xf2n ou anba a. Yo pral voye yon SMS bay nimewo sa a ak yon k\xf2d antre nan ekran kap vini an.`,
    it: `Inserisci il tuo numero di telefono qui sotto. A quel numero verr\xe0 inviato un SMS con un codice da inserire nella schermata successiva.`,
    ja: `\u{4EE5}\u{4E0B}\u{306B}\u{96FB}\u{8A71}\u{756A}\u{53F7}\u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}\u{305D}\u{306E}\u{756A}\u{53F7}\u{306B}SMS\u{304C}\u{9001}\u{4FE1}\u{3055}\u{308C}\u{3001}\u{6B21}\u{306E}\u{753B}\u{9762}\u{3067}\u{5165}\u{529B}\u{3059}\u{308B}\u{30B3}\u{30FC}\u{30C9}\u{304C}\u{9001}\u{4FE1}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C544}\u{B798}\u{C5D0} \u{C804}\u{D654}\u{BC88}\u{D638}\u{B97C} \u{C785}\u{B825}\u{D558}\u{C138}\u{C694}. \u{B2E4}\u{C74C} \u{D654}\u{BA74}\u{C5D0}\u{C11C} \u{C785}\u{B825}\u{D560} \u{C218} \u{C788}\u{B294} \u{CF54}\u{B4DC}\u{C640} \u{D568}\u{AED8} SMS\u{AC00} \u{D574}\u{B2F9} \u{BC88}\u{D638}\u{B85C} \u{C804}\u{C1A1}\u{B429}\u{B2C8}\u{B2E4}.`,
    mww: `Sau koj tus xov tooj hauv qab no. Tus SMS yuav muab xa mus rau ntawd tus xov tooj uas muaj ib tug code nkag mus rau ntawm qhov screen tom ntej no.`,
    ps: `\u{62E}\u{67E}\u{644} \u{62F} \u{62A}\u{644}\u{6CC}\u{641}\u{648}\u{646} \u{634}\u{645}\u{6D0}\u{631}\u{647} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{648}\u{644}\u{6CC}\u{6A9}\u{626}. \u{67E}\u{647} \u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{633}\u{6A9}\u{631}\u{6CC}\u{646} \u{6A9}\u{6D0} \u{62F} \u{646}\u{646}\u{648}\u{62A}\u{644}\u{648} \u{644}\u{67E}\u{627}\u{631}\u{647} \u{628}\u{647} \u{647}\u{63A}\u{647} \u{634}\u{645}\u{6CC}\u{631}\u{6D0} \u{62A}\u{647} \u{6CC}\u{648} \u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633} \u{648}\u{627}\u{633}\u{62A}\u{648}\u{644} \u{634}\u{6CC}.`,
    pt: `Digite seu n\xfamero de telefone abaixo. Um SMS ser\xe1 enviado para esse n\xfamero com um c\xf3digo para inserir na pr\xf3xima tela.`,
    "pt-pt": `Introduza o seu n\xfamero de telefone abaixo. Um SMS ser\xe1 enviado para esse n\xfamero com um c\xf3digo para inserir na pr\xf3xima tela.`,
    ru: `\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{439} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{430} \u{43D}\u{438}\u{436}\u{435}. \u{41D}\u{430} \u{44D}\u{442}\u{43E}\u{442} \u{43D}\u{43E}\u{43C}\u{435}\u{440} \u{431}\u{443}\u{434}\u{435}\u{442} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43E} SMS-\u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{441} \u{43A}\u{43E}\u{434}\u{43E}\u{43C} \u{434}\u{43B}\u{44F} \u{432}\u{432}\u{43E}\u{434}\u{430} \u{43D}\u{430} \u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{435}\u{43C} \u{44D}\u{43A}\u{440}\u{430}\u{43D}\u{435}.`,
    sm: `Ulu atu i lau numera telefoni o loo i lalo. O le a lafoina se SMS i lena numera ma se code e ulufale ai i le isi lau.`,
    so: `Nambarka telefoonkaaga hoose ku qor. SMS ayaa loo diri doonaa lambarkaas oo leh code si ay ugu galaan shaashadda xigta.`,
    th: `\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07} SMS \u{E08}\u{E30}\u{E16}\u{E39}\u{E01}\u{E2A}\u{E48}\u{E07}\u{E44}\u{E1B}\u{E22}\u{E31}\u{E07}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E40}\u{E25}\u{E02}\u{E19}\u{E31}\u{E49}\u{E19}\u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E43}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E08}\u{E2D}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{646}\u{6CC}\u{686}\u{6D2} \u{627}\u{67E}\u{646}\u{627} \u{641}\u{648}\u{646} \u{646}\u{645}\u{628}\u{631} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4} \u{627}\u{6AF}\u{644}\u{6CC} \u{627}\u{633}\u{6A9}\u{631}\u{6CC}\u{646} \u{67E}\u{631} \u{62F}\u{627}\u{62E}\u{644} \u{6C1}\u{648}\u{646}\u{6D2} \u{6A9}\u{6D2} \u{644}\u{626}\u{6D2} \u{6A9}\u{648}\u{688} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{627}\u{633} \u{646}\u{645}\u{628}\u{631} \u{67E}\u{631} \u{627}\u{6CC}\u{6A9} \u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633} \u{628}\u{6BE}\u{6CC}\u{62C}\u{627} \u{62C}\u{627}\u{626}\u{6D2} \u{6AF}\u{627}\u{6D4}`,
    vi: `Nh\u{1EAD}p s\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i c\u{1EE7}a b\u{1EA1}n b\xean d\u{1B0}\u{1EDB}i. M\u{1ED9}t tin nh\u{1EAF}n SMS s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c g\u{1EED}i \u{111}\u{1EBF}n s\u{1ED1} \u{111}\xf3 v\u{1EDB}i m\u{1ED9}t m\xe3 \u{111}\u{1EC3} nh\u{1EAD}p v\xe0o m\xe0n h\xecnh ti\u{1EBF}p theo.`,
    "zh-hans": `\u{5728}\u{4E0B}\u{9762}\u{8F93}\u{5165}\u{60A8}\u{7684}\u{7535}\u{8BDD}\u{53F7}\u{7801}\u{3002}\u{5C06}\u{5411}\u{8BE5}\u{53F7}\u{7801}\u{53D1}\u{9001}\u{4E00}\u{6761}\u{77ED}\u{4FE1}\u{FF0C}\u{5176}\u{4E2D}\u{5305}\u{542B}\u{53EF}\u{5728}\u{4E0B}\u{4E00}\u{4E2A}\u{5C4F}\u{5E55}\u{4E0A}\u{8F93}\u{5165}\u{7684}\u{4EE3}\u{7801}\u{3002}`,
    "zh-hant": `\u{5728}\u{4E0B}\u{9762}\u{8F38}\u{5165}\u{60A8}\u{7684}\u{96FB}\u{8A71}\u{865F}\u{78BC}\u{3002}\u{5C07}\u{5411}\u{8A72}\u{865F}\u{78BC}\u{767C}\u{9001}\u{4E00}\u{689D}\u{77ED}\u{4FE1}\u{FF0C}\u{5176}\u{4E2D}\u{5305}\u{542B}\u{53EF}\u{5728}\u{4E0B}\u{4E00}\u{500B}\u{87A2}\u{5E55}\u{4E0A}\u{8F38}\u{5165}\u{7684}\u{4EE3}\u{78BC}\u{3002}`,
    en: `Enter your phone number below. An SMS will be sent to that number with a code to enter on the next screen.`
};
const $2868cc1235412e16$export$6b387f31c62c31e2 = {
    ar: (phone_number)=>`\u{644}\u{642}\u{62F} \u{623}\u{631}\u{633}\u{644}\u{646}\u{627} \u{631}\u{633}\u{627}\u{644}\u{629} \u{646}\u{635}\u{64A}\u{629} \u{625}\u{644}\u{649} +1 ${phone_number}. \u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{645}\u{643}\u{648}\u{646} \u{645}\u{646} 6 \u{623}\u{631}\u{642}\u{627}\u{645} \u{645}\u{646} \u{627}\u{644}\u{631}\u{633}\u{627}\u{644}\u{629} \u{627}\u{644}\u{646}\u{635}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{644}\u{642}\u{64A}\u{62A}\u{647}\u{627}.`,
    de: (phone_number)=>`Wir haben eine SMS an +1 ${phone_number} gesendet. Geben Sie den 6-stelligen Code aus der SMS ein, die Sie erhalten haben.`,
    es: (phone_number)=>`Hemos enviado un mensaje de texto al +1 ${phone_number}. Ingresa el c\xf3digo de 6 d\xedgitos del mensaje de texto que recibiste.`,
    fa: (phone_number)=>`\u{645}\u{627} \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{627}\u{645} \u{645}\u{62A}\u{646}\u{6CC} \u{628}\u{647} + ${phone_number} \u{627}\u{631}\u{633}\u{627}\u{644} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{645}. \u{6A9}\u{62F} \u{6F6} \u{631}\u{642}\u{645}\u{6CC} \u{631}\u{627} \u{627}\u{632} \u{67E}\u{6CC}\u{627}\u{645}\u{6A9}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{6A9}\u{631}\u{62F}\u{647} \u{627}\u{6CC}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: (phone_number)=>`Nagpadala kami ng text message sa +1 ${phone_number}. Ipasok ang 6-digit na code mula sa text message na natanggap mo.`,
    fr: (phone_number)=>`Nous avons envoy\xe9 un SMS au +1 ${phone_number}. Entrez le code \xe0 6 chiffres du SMS que vous avez re\xe7u.`,
    hi: (phone_number)=>`\u{939}\u{92E}\u{928}\u{947} +1 ${phone_number} \u{92A}\u{930} \u{90F}\u{915} \u{91F}\u{947}\u{915}\u{94D}\u{938}\u{94D}\u{91F} \u{938}\u{902}\u{926}\u{947}\u{936} \u{92D}\u{947}\u{91C}\u{93E} \u{939}\u{948}\u{964} \u{906}\u{92A}\u{915}\u{94B} \u{92A}\u{94D}\u{930}\u{93E}\u{92A}\u{94D}\u{924} \u{92A}\u{93E}\u{920} \u{938}\u{902}\u{926}\u{947}\u{936} \u{938}\u{947} 6-\u{905}\u{902}\u{915}\u{940}\u{92F} \u{915}\u{94B}\u{921} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: (phone_number)=>`Nou te voye yon mesaj t\xe8ks bay + 1 ${phone_number}. Antre k\xf2d la 6-chif nan mesaj t\xe8ks ou te resevwa a.`,
    it: (phone_number)=>`Abbiamo inviato un messaggio di testo al numero +1 ${phone_number}. Inserisci il codice a 6 cifre del messaggio di testo che hai ricevuto.`,
    ja: (phone_number)=>`+1 ${phone_number} \u{306B}\u{30C6}\u{30AD}\u{30B9}\u{30C8} \u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{3092}\u{9001}\u{4FE1}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}\u{53D7}\u{4FE1}\u{3057}\u{305F}\u{30C6}\u{30AD}\u{30B9}\u{30C8}\u{30E1}\u{30C3}\u{30BB}\u{30FC}\u{30B8}\u{306B}\u{8A18}\u{8F09}\u{3055}\u{308C}\u{3066}\u{3044}\u{308B}6\u{6841}\u{306E}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: (phone_number)=>`+1 ${phone_number}\u{B85C} \u{BB38}\u{C790} \u{BA54}\u{C2DC}\u{C9C0}\u{B97C} \u{BCF4}\u{B0C8}\u{C2B5}\u{B2C8}\u{B2E4}. \u{BC1B}\u{C740} \u{BB38}\u{C790} \u{BA54}\u{C2DC}\u{C9C0}\u{C758} 6\u{C790}\u{B9AC} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: (phone_number)=>`Peb twb xa ib phau ntawv lus rau +1 ${phone_number}. Sau tus 6-digit code ntawm cov ntawv nyeem uas koj tau txais.`,
    ps: (phone_number)=>`\u{645}\u{648}\u{696} +1 ${phone_number} \u{62A}\u{647} \u{6CC}\u{648} \u{644}\u{6CC}\u{6A9}\u{644}\u{6CC} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{627}\u{633}\u{62A}\u{648}\u{644}\u{6CC} \u{62F}\u{6CC}. \u{62F} \u{647}\u{63A}\u{647} \u{645}\u{62A}\u{646} \u{67E}\u{6CC}\u{63A}\u{627}\u{645} \u{685}\u{62E}\u{647} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{6A9}\u{693}\u{6CC} 6 \u{631}\u{642}\u{645}\u{6CC} \u{6A9}\u{648}\u{689} \u{648}\u{644}\u{6CC}\u{6A9}\u{626}.`,
    pt: (phone_number)=>`Enviamos uma mensagem de texto para +1 ${phone_number}. Digite o c\xf3digo de 6 d\xedgitos da mensagem de texto que voc\xea recebeu.`,
    "pt-pt": (phone_number)=>`Enviamos uma mensagem de texto para +1 ${phone_number}. Introduza o c\xf3digo de 6 d\xedgitos da mensagem de texto que recebeu.`,
    ru: (phone_number)=>`\u{41C}\u{44B} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{438} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{435} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{435} \u{43D}\u{430} \u{43D}\u{43E}\u{43C}\u{435}\u{440} +1 ${phone_number}. \u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} 6-\u{437}\u{43D}\u{430}\u{447}\u{43D}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{438}\u{437} \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{432}\u{430}\u{43C}\u{438} \u{442}\u{435}\u{43A}\u{441}\u{442}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{441}\u{43E}\u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F}.`,
    sm: (phone_number)=>`Na matou lafoina se feau tusitusia i le +1 ${phone_number}. Ulu atu i le numera numera 6-digit mai le feau tusitusia na e mauaina.`,
    so: (phone_number)=>`Waxaan fariin qoraal ah u dirnay +1 ${phone_number}. Ku qor nambarka 6-lambar ee fariintii qoraalka ahaa ee aad heshay ku qor.`,
    th: (phone_number)=>`\u{E40}\u{E23}\u{E32}\u{E44}\u{E14}\u{E49}\u{E2A}\u{E48}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E44}\u{E1B}\u{E17}\u{E35}\u{E48} +1 ${phone_number} \u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A} 6 \u{E2B}\u{E25}\u{E31}\u{E01}\u{E08}\u{E32}\u{E01}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A}`,
    ur: (phone_number)=>`\u{6C1}\u{645} \u{646}\u{6D2} +1 ${phone_number} \u{67E}\u{631} \u{679}\u{6CC}\u{6A9}\u{633}\u{679} \u{645}\u{6CC}\u{633}\u{62C} \u{628}\u{6BE}\u{6CC}\u{62C}\u{627} \u{6C1}\u{6D2}\u{6D4} \u{622}\u{67E} \u{6A9}\u{648} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{6D2} \u{679}\u{6CC}\u{6A9}\u{633}\u{679} \u{645}\u{6CC}\u{633}\u{62C} \u{633}\u{6D2} 6 \u{6C1}\u{646}\u{62F}\u{633}\u{648}\u{6BA} \u{6A9}\u{627} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: (phone_number)=>`Ch\xfang t\xf4i \u{111}\xe3 g\u{1EED}i tin nh\u{1EAF}n v\u{103}n b\u{1EA3}n \u{111}\u{1EBF}n +1 ${phone_number}. Nh\u{1EAD}p m\xe3 g\u{1ED3}m 6 ch\u{1EEF} s\u{1ED1} t\u{1EEB} tin nh\u{1EAF}n v\u{103}n b\u{1EA3}n b\u{1EA1}n nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c.`,
    "zh-hans": (phone_number)=>`\u{6211}\u{4EEC}\u{5DF2}\u{53D1}\u{9001}\u{77ED}\u{4FE1}\u{81F3} +1 ${phone_number}\u{3002}\u{8F93}\u{5165}\u{60A8}\u{6536}\u{5230}\u{7684}\u{77ED}\u{4FE1}\u{4E2D}\u{7684} 6 \u{4F4D}\u{4EE3}\u{7801}\u{3002}`,
    "zh-hant": (phone_number)=>`\u{6211}\u{5011}\u{5DF2}\u{767C}\u{9001}\u{7C21}\u{8A0A}\u{81F3} +1 ${phone_number}\u{3002}\u{8F38}\u{5165}\u{60A8}\u{6536}\u{5230}\u{7684}\u{7C21}\u{8A0A}\u{4E2D}\u{7684}6\u{4F4D}\u{4EE3}\u{78BC}\u{3002}`,
    en: (phone_number)=>`We've sent a text message to +1 ${phone_number}. Enter the 6-digit code from the text message you received.`
};
const $2868cc1235412e16$export$a2c4e850ecd3273f = {
    ar: `\u{643}\u{648}\u{62F} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629}`,
    de: `Einmaliger Code`,
    es: `C\xf3digo de un solo uso`,
    fa: `\u{6A9}\u{62F} \u{6CC}\u{6A9}\u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641}`,
    fil: `Isang beses na code`,
    fr: `Code \xe0 usage unique`,
    hi: `\u{90F}\u{915} \u{92C}\u{93E}\u{930} \u{915}\u{93E} \u{915}\u{94B}\u{921}`,
    ht: `K\xf2d yon s\xe8l fwa`,
    it: `Codice monouso`,
    ja: `\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30B3}\u{30FC}\u{30C9}`,
    ko: `\u{C77C}\u{D68C}\u{C131} \u{CF54}\u{B4DC}`,
    mww: `Ib-lub sij hawm code`,
    ps: `\u{6CC}\u{648} \u{648}\u{62E}\u{62A} \u{6A9}\u{648}\u{689}`,
    pt: `C\xf3digo \xfanico`,
    "pt-pt": `C\xf3digo de uso \xfanico`,
    ru: `\u{41E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43A}\u{43E}\u{434}`,
    sm: `Tasi le taimi code`,
    so: `Hal-mar code`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}`,
    ur: `\u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{648}\u{688}`,
    vi: `M\xe3 d\xf9ng m\u{1ED9}t l\u{1EA7}n`,
    "zh-hans": `\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{7801}`,
    "zh-hant": `\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{78BC}`,
    en: `One-time code`
};
const $2868cc1235412e16$export$6ce1ba6fa10570bc = {
    ar: `\u{62A}\u{623}\u{645}\u{64A}\u{646} \u{62D}\u{633}\u{627}\u{628}\u{643} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F}\u{629} \u{625}\u{644}\u{649} \u{627}\u{644}\u{648}\u{642}\u{62A} (TOTP)`,
    de: `Sichern Sie Ihr Konto mit dem zeitbasierten Einmalpasswort (TOTP)`,
    es: `Proteja su cuenta con una contrase\xf1a de un solo uso basada en el tiempo (TOTP)`,
    fa: `\u{62D}\u{633}\u{627}\u{628} \u{62E}\u{648}\u{62F} \u{631}\u{627} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{6CC}\u{6A9}\u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{645}\u{628}\u{62A}\u{646}\u{6CC} \u{628}\u{631} \u{632}\u{645}\u{627}\u{646} (TOTP) \u{627}\u{6CC}\u{645}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-secure ang iyong account gamit ang Time-based One-Time Password (TOTP)`,
    fr: `S\xe9curisez votre compte \xe0 l\u{2019}aide d\u{2019}un mot de passe \xe0 usage unique bas\xe9 sur le temps (TOTP)`,
    hi: `\u{938}\u{92E}\u{92F}-\u{906}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} (TOTP) \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{905}\u{92A}\u{928}\u{93E} \u{916}\u{93E}\u{924}\u{93E} \u{938}\u{941}\u{930}\u{915}\u{94D}\u{937}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Sekirite kont ou l\xe8 l s\xe8vi av\xe8k Modpas One-Time (TOTP)`,
    it: `Proteggi il tuo account utilizzando la password monouso a tempo (TOTP)`,
    ja: `\u{6642}\u{9593}\u{30D9}\u{30FC}\u{30B9}\u{306E}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30D1}\u{30B9}\u{30EF}\u{30FC}\u{30C9}(TOTP)\u{3092}\u{4F7F}\u{7528}\u{3057}\u{3066}\u{30A2}\u{30AB}\u{30A6}\u{30F3}\u{30C8}\u{3092}\u{4FDD}\u{8B77}\u{3057}\u{307E}\u{3059}`,
    ko: `\u{C2DC}\u{AC04} \u{AE30}\u{BC18} \u{C77C}\u{D68C}\u{C6A9} \u{BE44}\u{BC00}\u{BC88}\u{D638}(TOTP)\u{B97C} \u{C0AC}\u{C6A9}\u{D558}\u{C5EC} \u{ACC4}\u{C815}\u{C744} \u{BCF4}\u{D638}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
    mww: `Ruaj ntseg koj tus account siv sij hawm ib-lub sij hawm Password (TOTP)`,
    ps: `\u{62E}\u{67E}\u{644} \u{62D}\u{633}\u{627}\u{628} \u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{631} \u{628}\u{646}\u{633}\u{67C} \u{6CC}\u{648} \u{681}\u{644} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} (TOTP) \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{633}\u{631}\u{647} \u{62E}\u{648}\u{646}\u{62F}\u{6CC} \u{6A9}\u{693}\u{626}`,
    pt: `Proteja sua conta usando a senha de uso \xfanico baseada em tempo (TOTP)`,
    "pt-pt": `Proteja sua conta usando a senha \xfanica baseada no tempo (TOTP)`,
    ru: `\u{417}\u{430}\u{449}\u{438}\u{442}\u{438}\u{442}\u{435} \u{441}\u{432}\u{43E}\u{44E} \u{443}\u{447}\u{435}\u{442}\u{43D}\u{443}\u{44E} \u{437}\u{430}\u{43F}\u{438}\u{441}\u{44C} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F} \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} (TOTP)`,
    sm: `Fa'amautu lau teuga tupe e fa'aaoga ai le Time-Based One-Time Password (TOTP)`,
    so: `Xafido aad account isticmaalaya Time-ku salaysan One-Time Password (TOTP)`,
    th: `\u{E23}\u{E31}\u{E01}\u{E29}\u{E32}\u{E04}\u{E27}\u{E32}\u{E21}\u{E1B}\u{E25}\u{E2D}\u{E14}\u{E20}\u{E31}\u{E22}\u{E1A}\u{E31}\u{E0D}\u{E0A}\u{E35}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E15}\u{E32}\u{E21}\u{E40}\u{E27}\u{E25}\u{E32} (TOTP)`,
    ur: `\u{648}\u{642}\u{62A} \u{67E}\u{631} \u{645}\u{628}\u{646}\u{6CC} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} (\u{679}\u{6CC} \u{627}\u{648} \u{679}\u{6CC} \u{67E}\u{6CC}) \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{627}\u{67E}\u{646}\u{6D2} \u{627}\u{6A9}\u{627}\u{624}\u{646}\u{679} \u{6A9}\u{648} \u{645}\u{62D}\u{641}\u{648}\u{638} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA3}o m\u{1EAD}t t\xe0i kho\u{1EA3}n c\u{1EE7}a b\u{1EA1}n b\u{1EB1}ng m\u{1EAD}t kh\u{1EA9}u m\u{1ED9}t l\u{1EA7}n d\u{1EF1}a tr\xean th\u{1EDD}i gian (TOTP)`,
    "zh-hans": `\u{4F7F}\u{7528}\u{57FA}\u{4E8E}\u{65F6}\u{95F4}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{7801} \u{FF08}TOTP\u{FF09} \u{4FDD}\u{62A4}\u{60A8}\u{7684}\u{5E10}\u{6237}`,
    "zh-hant": `\u{4F7F}\u{7528}\u{57FA}\u{65BC}\u{6642}\u{9593}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{78BC} \u{FF08}TOTP\u{FF09} \u{4FDD}\u{8B77}\u{60A8}\u{7684}\u{5E33}\u{6236}`,
    en: `Secure your account using Time-based One-Time Password (TOTP)`
};
const $2868cc1235412e16$export$c387a5524a2ac6b3 = {
    ar: `\u{627}\u{645}\u{633}\u{62D} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629} \u{623}\u{639}\u{644}\u{627}\u{647} \u{628}\u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{645}\u{641}\u{636}\u{644} \u{644}\u{62F}\u{64A}\u{643} \u{62B}\u{645} \u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{642}\u{62F}\u{645} \u{623}\u{62F}\u{646}\u{627}\u{647}.`,
    de: `Scannen Sie den obigen QR-Code mit Ihrer bevorzugten Authentifizierungs-App und geben Sie dann den unten angegebenen Einmalcode ein.`,
    es: `Escanee el c\xf3digo QR de arriba con su aplicaci\xf3n de autenticaci\xf3n preferida y luego ingrese el c\xf3digo de un solo uso que se proporciona a continuaci\xf3n.`,
    fa: `\u{6A9}\u{62F} QR \u{628}\u{627}\u{644}\u{627} \u{631}\u{627} \u{628}\u{627} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{62F}\u{644}\u{62E}\u{648}\u{627}\u{647} \u{62E}\u{648}\u{62F} \u{627}\u{633}\u{6A9}\u{646} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{633}\u{67E}\u{633} \u{6A9}\u{62F} \u{6CC}\u{6A9}\u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{627}\u{631}\u{627}\u{626}\u{647} \u{634}\u{62F}\u{647} \u{631}\u{627} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `I-scan ang QR Code sa itaas gamit ang iyong ginustong authenticator app at pagkatapos ay ipasok ang ibinigay na one-time code sa ibaba.`,
    fr: `Scannez le code QR ci-dessus \xe0 l\u{2019}aide de votre application d\u{2019}authentification pr\xe9f\xe9r\xe9e, puis entrez le code \xe0 usage unique fourni ci-dessous.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{92A}\u{938}\u{902}\u{926}\u{940}\u{926}\u{93E} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{910}\u{92A} \u{915}\u{93E} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{915}\u{947} \u{90A}\u{92A}\u{930} \u{926}\u{93F}\u{90F} \u{917}\u{90F} \u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{915}\u{94B} \u{938}\u{94D}\u{915}\u{948}\u{928} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{92B}\u{93F}\u{930} \u{928}\u{940}\u{91A}\u{947} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{915}\u{94B}\u{921} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Analysis k\xf2d la QR pi wo a l\xe8 l s\xe8vi av\xe8k app otantifikat\xe8 pi pito ou ak L\xe8 sa a, antre nan k\xf2d la bay yon s\xe8l-fwa anba a.`,
    it: `Scansiona il codice QR qui sopra utilizzando la tua app di autenticazione preferita, quindi inserisci il codice monouso fornito di seguito.`,
    ja: `\u{304A}\u{597D}\u{307F}\u{306E}\u{8A8D}\u{8A3C}\u{30A2}\u{30D7}\u{30EA}\u{3092}\u{4F7F}\u{7528}\u{3057}\u{3066}\u{4E0A}\u{8A18}\u{306E}QR\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{30B9}\u{30AD}\u{30E3}\u{30F3}\u{3057}\u{3001}\u{4EE5}\u{4E0B}\u{306B}\u{63D0}\u{4F9B}\u{3055}\u{308C}\u{305F}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C120}\u{D638}\u{D558}\u{B294} \u{C778}\u{C99D} \u{C571}\u{C744} \u{C0AC}\u{C6A9}\u{D558}\u{C5EC} \u{C704}\u{C758} QR \u{CF54}\u{B4DC}\u{B97C} \u{C2A4}\u{CE94}\u{D55C} \u{B2E4}\u{C74C} \u{C544}\u{B798}\u{C5D0} \u{C81C}\u{ACF5}\u{B41C} \u{C77C}\u{D68C}\u{C131} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Scan lub QR Code saum toj no siv koj najnpawb authenticator app thiab ces nkag mus rau hauv qab no.`,
    ps: `\u{67E}\u{648}\u{631}\u{62A}\u{647} QR \u{6A9}\u{648}\u{689} \u{62F} \u{62E}\u{67E}\u{644}\u{6D0} \u{62E}\u{648}\u{69A}\u{6D0} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{67E}\u{647} \u{6A9}\u{627}\u{631}\u{648}\u{644}\u{648} \u{633}\u{631}\u{647} \u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{628}\u{6CC}\u{627} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{648}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{6CC}\u{648} \u{681}\u{644} \u{6A9}\u{648}\u{689} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: `Digitalize o QR Code acima usando seu aplicativo autenticador preferido e insira o c\xf3digo \xfanico fornecido abaixo.`,
    "pt-pt": `Digitalize o QR Code acima usando seu aplicativo autenticador preferido e, em seguida, insira o c\xf3digo \xfanico fornecido abaixo.`,
    ru: `\u{41E}\u{442}\u{441}\u{43A}\u{430}\u{43D}\u{438}\u{440}\u{443}\u{439}\u{442}\u{435} QR-\u{43A}\u{43E}\u{434} \u{432}\u{44B}\u{448}\u{435} \u{441} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{44C}\u{44E} \u{43F}\u{440}\u{435}\u{434}\u{43F}\u{43E}\u{447}\u{438}\u{442}\u{430}\u{435}\u{43C}\u{43E}\u{433}\u{43E} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{434}\u{43B}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}, \u{430} \u{437}\u{430}\u{442}\u{435}\u{43C} \u{432}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{43D}\u{438}\u{436}\u{435}.`,
    sm: `Fa'ata'ita'i le QR Code i luga e fa'aaoga ai lau authenticator app e te fiafia i ai ona ulufale lea i le code e tasi le taimi o lo'o i lalo.`,
    so: `Iskaanka QR Code-ka ee kor ku xusan adigoo isticmaalaya app-ka authenticator aad doorbidayso ka dibna ku qor lambarka hal mar ee la bixiyey ee hoose.`,
    th: `\u{E2A}\u{E41}\u{E01}\u{E19} QR Code \u{E14}\u{E49}\u{E32}\u{E19}\u{E1A}\u{E19}\u{E42}\u{E14}\u{E22}\u{E43}\u{E0A}\u{E49}\u{E41}\u{E2D}\u{E1B}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23} \u{E08}\u{E32}\u{E01}\u{E19}\u{E31}\u{E49}\u{E19}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E17}\u{E35}\u{E48}\u{E43}\u{E2B}\u{E49}\u{E44}\u{E27}\u{E49}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{627}\u{67E}\u{646}\u{6CC} \u{67E}\u{633}\u{646}\u{62F}\u{6CC}\u{62F}\u{6C1} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{627}\u{631} \u{627}\u{6CC}\u{67E} \u{6A9}\u{627} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{631}\u{62A}\u{6D2} \u{6C1}\u{648}\u{626}\u{6D2} \u{627}\u{648}\u{67E}\u{631} \u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{688} \u{627}\u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{67E}\u{6BE}\u{631} \u{646}\u{6CC}\u{686}\u{6D2} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{62F}\u{6C1} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Qu\xe9t M\xe3 QR \u{1EDF} tr\xean b\u{1EB1}ng \u{1EE9}ng d\u{1EE5}ng x\xe1c th\u{1EF1}c \u{1B0}a th\xedch c\u{1EE7}a b\u{1EA1}n, sau \u{111}\xf3 nh\u{1EAD}p m\xe3 m\u{1ED9}t l\u{1EA7}n \u{111}\u{1B0}\u{1EE3}c cung c\u{1EA5}p b\xean d\u{1B0}\u{1EDB}i.`,
    "zh-hans": `\u{4F7F}\u{7528}\u{60A8}\u{9996}\u{9009}\u{7684}\u{8EAB}\u{4EFD}\u{9A8C}\u{8BC1}\u{5668}\u{5E94}\u{7528}\u{7A0B}\u{5E8F}\u{626B}\u{63CF}\u{4E0A}\u{9762}\u{7684}\u{4E8C}\u{7EF4}\u{7801}\u{FF0C}\u{7136}\u{540E}\u{5728}\u{4E0B}\u{9762}\u{8F93}\u{5165}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{7801}\u{3002}`,
    "zh-hant": `\u{4F7F}\u{7528}\u{60A8}\u{9996}\u{9078}\u{7684}\u{8EAB}\u{4EFD}\u{9A57}\u{8B49}\u{5668}\u{61C9}\u{7528}\u{7A0B}\u{5E8F}\u{6383}\u{63CF}\u{4E0A}\u{9762}\u{7684}\u{4E8C}\u{7DAD}\u{78BC}\u{FF0C}\u{7136}\u{5F8C}\u{5728}\u{4E0B}\u{9762}\u{8F38}\u{5165}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{78BC}\u{3002}`,
    en: `Scan the QR Code above using your preferred authenticator app and then enter the provided one-time code below.`
};
const $2868cc1235412e16$export$cf852b8d22fa3909 = {
    ar: `\u{647}\u{644} \u{62A}\u{648}\u{627}\u{62C}\u{647} \u{645}\u{634}\u{643}\u{644}\u{629} \u{641}\u{64A} \u{645}\u{633}\u{62D} \u{631}\u{645}\u{632} \u{627}\u{644}\u{627}\u{633}\u{62A}\u{62C}\u{627}\u{628}\u{629} \u{627}\u{644}\u{633}\u{631}\u{64A}\u{639}\u{629}\u{61F}`,
    de: `Probleme beim Scannen des QR-Codes?`,
    es: `\xbfTienes problemas para escanear el c\xf3digo QR?`,
    fa: `\u{62F}\u{631} \u{627}\u{633}\u{6A9}\u{646} \u{6A9}\u{62F} QR \u{645}\u{634}\u{6A9}\u{644} \u{62F}\u{627}\u{631}\u{6CC}\u{62F}\u{61F}`,
    fil: `Problema sa pag-scan ng QR code?`,
    fr: `Vous avez du mal \xe0 scanner le code QR ?`,
    hi: `\u{915}\u{94D}\u{92F}\u{942}\u{906}\u{930} \u{915}\u{94B}\u{921} \u{938}\u{94D}\u{915}\u{948}\u{928} \u{915}\u{930}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{92A}\u{930}\u{947}\u{936}\u{93E}\u{928}\u{940} \u{939}\u{94B} \u{930}\u{939}\u{940} \u{939}\u{948}?`,
    ht: `Pwobl\xe8m pou optik k\xf2d la QR?`,
    it: `Problemi con la scansione del codice QR?`,
    ja: `QR\u{30B3}\u{30FC}\u{30C9}\u{306E}\u{30B9}\u{30AD}\u{30E3}\u{30F3}\u{306B}\u{554F}\u{984C}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{304B}?`,
    ko: `QR \u{CF54}\u{B4DC}\u{B97C} \u{C2A4}\u{CE94}\u{D558}\u{B294} \u{B370} \u{BB38}\u{C81C}\u{AC00} \u{C788}\u{C2B5}\u{B2C8}\u{AE4C}?`,
    mww: `Teeb meem scanning lub QR code?`,
    ps: `\u{62F} \u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{689} \u{67E}\u{647} \u{633}\u{6A9}\u{646} \u{6A9}\u{648}\u{644}\u{648} \u{6A9}\u{6D0} \u{633}\u{62A}\u{648}\u{646}\u{632}\u{647} \u{644}\u{631}\u{6CC}\u{61F}`,
    pt: `Problemas para escanear o c\xf3digo QR?`,
    "pt-pt": `Problemas para escanear o c\xf3digo QR?`,
    ru: `\u{41F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{44B} \u{441}\u{43E} \u{441}\u{43A}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} QR-\u{43A}\u{43E}\u{434}\u{430}?`,
    sm: `Fa'afitauli i le su'esu'eina o le QR code?`,
    so: `Dhib inaad iska baarto lambarka QR?`,
    th: `\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E41}\u{E01}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A} QR \u{E43}\u{E0A}\u{E48}\u{E44}\u{E2B}\u{E21}`,
    ur: `\u{6A9}\u{6CC}\u{648} \u{622}\u{631} \u{6A9}\u{648}\u{688} \u{627}\u{633}\u{6A9}\u{6CC}\u{646} \u{6A9}\u{631}\u{646}\u{6D2} \u{645}\u{6CC}\u{6BA} \u{62F}\u{634}\u{648}\u{627}\u{631}\u{6CC}\u{61F}`,
    vi: `S\u{1EF1} c\u{1ED1} khi qu\xe9t m\xe3 QR?`,
    "zh-hans": `\u{626B}\u{63CF} QR \u{7801}\u{65F6}\u{9047}\u{5230}\u{95EE}\u{9898}\u{FF1F}`,
    "zh-hant": `\u{6383}\u{63CF} QR \u{78BC}\u{6642}\u{9047}\u{5230}\u{554F}\u{984C}\u{FF1F}`,
    en: `Trouble scanning the QR code?`
};
const $2868cc1235412e16$export$1238033b1df59ed5 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{645}\u{646} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{62E}\u{627}\u{635} \u{628}\u{643}.`,
    de: `Geben Sie den Einmalcode aus Ihrer Authentifizierungs-App ein.`,
    es: `Ingresa el c\xf3digo de un solo uso de tu aplicaci\xf3n de autenticaci\xf3n.`,
    fa: `\u{6A9}\u{62F} \u{6CC}\u{6A9}\u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{631}\u{627} \u{627}\u{632} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{62E}\u{648}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Ipasok ang one-time code mula sa iyong authenticator app.`,
    fr: `Entrez le code \xe0 usage unique de votre application d\u{2019}authentification.`,
    hi: `\u{905}\u{92A}\u{928}\u{947} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{910}\u{92A}\u{94D}\u{932}\u{93F}\u{915}\u{947}\u{936}\u{928} \u{938}\u{947} \u{90F}\u{915} \u{92C}\u{93E}\u{930} \u{915}\u{93E} \u{915}\u{94B}\u{921} \u{921}\u{93E}\u{932}\u{947}\u{902}.`,
    ht: `Antre k\xf2d la yon s\xe8l-fwa soti nan app natif natal ou.`,
    it: `Inserisci il codice monouso dall'app di autenticazione.`,
    ja: `\u{8A8D}\u{8A3C}\u{30A2}\u{30D7}\u{30EA}\u{304B}\u{3089}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C778}\u{C99D} \u{C571}\u{C5D0}\u{C11C} \u{C77C}\u{D68C}\u{C6A9} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Sau ib-time code ntawm koj authenticator app.`,
    ps: `\u{62F} \u{62E}\u{67E}\u{644} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{685}\u{62E}\u{647} \u{6CC}\u{648} \u{681}\u{644} \u{6A9}\u{648}\u{689} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: `Insira o c\xf3digo \xfanico do seu aplicativo autenticador.`,
    "pt-pt": `Insira o c\xf3digo \xfanico do seu aplicativo autenticador.`,
    ru: `\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43A}\u{43E}\u{434} \u{438}\u{437} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{434}\u{43B}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}.`,
    sm: `Ulu atu i le code e tasi le taimi mai lau authenticator app.`,
    so: `Ka qor hal mar lambarkii aad ka heshay app-ka Authenticator.ka.`,
    th: `\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E08}\u{E32}\u{E01}\u{E41}\u{E2D}\u{E1B}\u{E15}\u{E31}\u{E27}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{627}\u{67E}\u{646}\u{6D2} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{646}\u{646}\u{62F}\u{6C1} \u{627}\u{6CC}\u{67E} \u{633}\u{6D2} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Nh\u{1EAD}p m\xe3 d\xf9ng m\u{1ED9}t l\u{1EA7}n t\u{1EEB} \u{1EE9}ng d\u{1EE5}ng x\xe1c th\u{1EF1}c c\u{1EE7}a b\u{1EA1}n.`,
    "zh-hans": `\u{8F93}\u{5165}\u{9A8C}\u{8BC1}\u{5668}\u{5E94}\u{7528}\u{7A0B}\u{5E8F}\u{4E2D}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{7801}\u{3002}`,
    "zh-hant": `\u{8F38}\u{5165}\u{9A57}\u{8B49}\u{5668}\u{61C9}\u{7528}\u{7A0B}\u{5F0F}\u{4E2D}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{78BC}\u{3002}`,
    en: `Enter the one-time code from your authenticator app.`
};
const $2868cc1235412e16$export$bf9fe1d3dbe2373c = {
    ar: `\u{627}\u{643}\u{62A}\u{645}\u{644} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{641}\u{64A} \u{643}\u{644}\u{645}\u{629} \u{627}\u{644}\u{645}\u{631}\u{648}\u{631} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} (TOTP) \u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F}\u{629} \u{625}\u{644}\u{649} \u{627}\u{644}\u{648}\u{642}\u{62A}!`,
    de: `Die Registrierung f\xfcr Time-based One-Time Password (TOTP) abgeschlossen!`,
    es: `\xa1Se complet\xf3 la inscripci\xf3n de contrase\xf1a de un solo uso (TOTP) basada en el tiempo!`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{631}\u{645}\u{632} \u{639}\u{628}\u{648}\u{631} \u{6CC}\u{6A9}\u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} (TOTP) \u{645}\u{628}\u{62A}\u{646}\u{6CC} \u{628}\u{631} \u{632}\u{645}\u{627}\u{646} \u{62A}\u{6A9}\u{645}\u{6CC}\u{644} \u{634}\u{62F}!`,
    fil: `Kumpleto na ang pagpapatala ng One-Time Password (TOTP) na nakabatay sa oras!`,
    fr: `L\u{2019}inscription au mot de passe \xe0 usage unique (TOTP) bas\xe9 sur le temps est termin\xe9e !`,
    hi: `\u{938}\u{92E}\u{92F}-\u{906}\u{927}\u{93E}\u{930}\u{93F}\u{924} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{92A}\u{93E}\u{938}\u{935}\u{930}\u{94D}\u{921} (TOTP) \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{92A}\u{942}\u{930}\u{94D}\u{923}!`,
    ht: `Modpas Yon s\xe8l-fwa (TOTP) enskripsyon konpl\xe8!`,
    it: `L'iscrizione alla Time-Based One-Time Password (TOTP) \xe8 stata completata!`,
    ja: `TOTP(Time-based One-Time Password)\u{306E}\u{767B}\u{9332}\u{304C}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}\u{3002}`,
    ko: `\u{C2DC}\u{AC04} \u{AE30}\u{BC18} \u{C77C}\u{D68C}\u{C6A9} \u{BE44}\u{BC00}\u{BC88}\u{D638}(TOTP) \u{B4F1}\u{B85D} \u{C644}\u{B8CC}!`,
    mww: `Sij hawm raws li ib-lub sij hawm Password (TOTP) sau npe ua tiav!`,
    ps: `\u{62F} \u{648}\u{62E}\u{62A} \u{67E}\u{631} \u{628}\u{646}\u{633}\u{67C} \u{6CC}\u{648} \u{681}\u{644} \u{67E}\u{627}\u{633}\u{648}\u{631}\u{689} (TOTP) \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{628}\u{634}\u{67E}\u{693}\u{647} \u{634}\u{648}\u{647}!`,
    pt: `Inscri\xe7\xe3o de senha de uso \xfanico baseada em tempo (TOTP) conclu\xedda!`,
    "pt-pt": `Inscri\xe7\xe3o One-Time Password (TOTP) baseada no tempo conclu\xedda!`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{43E}\u{433}\u{43E} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44F} (TOTP) \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{430}!`,
    sm: `Ua mae'a le lesitalaina o le Time-Based One-Time Password (TOTP)!`,
    so: `Time-ku salaysan Hal-Time Password (TOTP) diiwaangelin dhameystiran!`,
    th: `\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27} (TOTP) \u{E15}\u{E32}\u{E21}\u{E40}\u{E27}\u{E25}\u{E32}\u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}!`,
    ur: `\u{648}\u{642}\u{62A} \u{67E}\u{631} \u{645}\u{628}\u{646}\u{6CC} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{67E}\u{627}\u{633} \u{648}\u{631}\u{688} (\u{679}\u{6CC} \u{627}\u{648} \u{679}\u{6CC} \u{67E}\u{6CC}) \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{645}\u{6A9}\u{645}\u{644}!`,
    vi: `\u{110}\u{103}ng k\xfd M\u{1EAD}t kh\u{1EA9}u m\u{1ED9}t l\u{1EA7}n d\u{1EF1}a tr\xean th\u{1EDD}i gian (TOTP) ho\xe0n t\u{1EA5}t!`,
    "zh-hans": `\u{57FA}\u{4E8E}\u{65F6}\u{95F4}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{7801} \u{FF08}TOTP\u{FF09} \u{6CE8}\u{518C}\u{5B8C}\u{6210}\u{FF01}`,
    "zh-hant": `\u{57FA}\u{65BC}\u{6642}\u{9593}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{5BC6}\u{78BC} \u{FF08}TOTP\u{FF09} \u{8A3B}\u{518A}\u{5B8C}\u{6210}\u{FF01}`,
    en: `Time-based One-Time Password (TOTP) enrollment complete!`
};
const $2868cc1235412e16$export$7cdd8cc46aec9c24 = {
    ar: `\u{627}\u{643}\u{62A}\u{645}\u{644} \u{627}\u{644}\u{62A}\u{633}\u{62C}\u{64A}\u{644} \u{639}\u{628}\u{631} \u{627}\u{644}\u{647}\u{627}\u{62A}\u{641} (SMS)`,
    de: `Registrierung per Telefon (SMS) abgeschlossen`,
    es: `Inscripci\xf3n por tel\xe9fono (SMS) completada`,
    fa: `\u{62B}\u{628}\u{62A} \u{646}\u{627}\u{645} \u{62A}\u{644}\u{641}\u{646} (\u{67E}\u{6CC}\u{627}\u{645}\u{6A9}) \u{628}\u{647} \u{67E}\u{627}\u{6CC}\u{627}\u{646} \u{631}\u{633}\u{6CC}\u{62F}`,
    fil: `Nakumpleto ang pagpapatala sa telepono (SMS)`,
    fr: `Inscription par t\xe9l\xe9phone (SMS) termin\xe9e`,
    hi: `\u{92B}\u{94B}\u{928} (\u{90F}\u{938}\u{90F}\u{92E}\u{90F}\u{938}) \u{928}\u{93E}\u{92E}\u{93E}\u{902}\u{915}\u{928} \u{92A}\u{942}\u{930}\u{93E} \u{939}\u{941}\u{906}`,
    ht: `Telef\xf2n (SMS) enskripsyon ranpli`,
    it: `Registrazione telefonica (SMS) completata`,
    ja: `\u{96FB}\u{8A71}(SMS)\u{306E}\u{767B}\u{9332}\u{304C}\u{5B8C}\u{4E86}\u{3057}\u{307E}\u{3057}\u{305F}`,
    ko: `\u{C804}\u{D654}(SMS) \u{B4F1}\u{B85D} \u{C644}\u{B8CC}`,
    mww: `Xov tooj (SMS) sau npe ua tiav`,
    ps: `\u{62F} \u{67C}\u{644}\u{6CC}\u{641}\u{648}\u{646} (SMS) \u{646}\u{648}\u{645} \u{644}\u{6CC}\u{6A9}\u{646}\u{647} \u{628}\u{634}\u{67E}\u{693}\u{647} \u{634}\u{648}\u{647}`,
    pt: `Inscri\xe7\xe3o por telefone (SMS) conclu\xedda`,
    "pt-pt": `Inscri\xe7\xe3o por telefone (SMS) conclu\xedda`,
    ru: `\u{420}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{43E} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{443} (SMS) \u{437}\u{430}\u{432}\u{435}\u{440}\u{448}\u{435}\u{43D}\u{430}`,
    sm: `Ua maea le lesitala i le telefoni (SMS)`,
    so: `Phone (SMS) diiwaangelin la dhammeystiray`,
    th: `\u{E01}\u{E32}\u{E23}\u{E25}\u{E07}\u{E17}\u{E30}\u{E40}\u{E1A}\u{E35}\u{E22}\u{E19}\u{E17}\u{E32}\u{E07}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C} (SMS) \u{E40}\u{E2A}\u{E23}\u{E47}\u{E08}\u{E2A}\u{E21}\u{E1A}\u{E39}\u{E23}\u{E13}\u{E4C}`,
    ur: `\u{641}\u{648}\u{646} (\u{627}\u{6CC}\u{633} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{633}) \u{6A9}\u{627} \u{627}\u{646}\u{62F}\u{631}\u{627}\u{62C} \u{645}\u{6A9}\u{645}\u{644}`,
    vi: `\u{110}\u{103}ng k\xfd qua \u{111}i\u{1EC7}n tho\u{1EA1}i (SMS) \u{111}\xe3 ho\xe0n t\u{1EA5}t`,
    "zh-hans": `\u{7535}\u{8BDD} \u{FF08}SMS\u{FF09} \u{6CE8}\u{518C}\u{5DF2}\u{5B8C}\u{6210}`,
    "zh-hant": `\u{96FB}\u{8A71} \u{FF08}SMS\u{FF09} \u{8A3B}\u{518A}\u{5DF2}\u{5B8C}\u{6210}`,
    en: `Phone (SMS) enrollment completed`
};
const $2868cc1235412e16$export$f857c2eb7655a729 = {
    ar: `\u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A} \u{64A}\u{62F}\u{648}\u{64A}\u{627} \u{641}\u{64A} \u{62A}\u{637}\u{628}\u{64A}\u{642} \u{627}\u{644}\u{645}\u{635}\u{627}\u{62F}\u{642}\u{629} \u{627}\u{644}\u{645}\u{641}\u{636}\u{644} \u{644}\u{62F}\u{64A}\u{643} \u{62B}\u{645} \u{623}\u{62F}\u{62E}\u{644} \u{627}\u{644}\u{631}\u{645}\u{632} \u{644}\u{645}\u{631}\u{629} \u{648}\u{627}\u{62D}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{642}\u{62F}\u{645} \u{623}\u{62F}\u{646}\u{627}\u{647}.`,
    de: `Geben Sie den folgenden Code manuell in Ihre bevorzugte Authentifizierungs-App ein und geben Sie dann den unten angegebenen einmaligen Code ein.`,
    es: `Ingrese manualmente el siguiente c\xf3digo en su aplicaci\xf3n de autenticaci\xf3n preferida y luego ingrese el c\xf3digo de un solo uso proporcionado a continuaci\xf3n.`,
    fa: `\u{6A9}\u{62F} \u{632}\u{6CC}\u{631} \u{631}\u{627} \u{628}\u{647} \u{635}\u{648}\u{631}\u{62A} \u{62F}\u{633}\u{62A}\u{6CC} \u{62F}\u{631} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647} \u{627}\u{62D}\u{631}\u{627}\u{632} \u{647}\u{648}\u{6CC}\u{62A} \u{62F}\u{644}\u{62E}\u{648}\u{627}\u{647} \u{62E}\u{648}\u{62F} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F} \u{648} \u{633}\u{67E}\u{633} \u{6A9}\u{62F} \u{6CC}\u{6A9}\u{628}\u{627}\u{631} \u{645}\u{635}\u{631}\u{641} \u{627}\u{631}\u{627}\u{626}\u{647} \u{634}\u{62F}\u{647} \u{631}\u{627} \u{62F}\u{631} \u{632}\u{6CC}\u{631} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
    fil: `Manu-manong ipasok ang sumusunod na code sa iyong ginustong authenticator app at pagkatapos ay ipasok ang ibinigay na one-time code sa ibaba.`,
    fr: `Entrez manuellement le code suivant dans votre application d\u{2019}authentification pr\xe9f\xe9r\xe9e, puis entrez le code \xe0 usage unique fourni ci-dessous.`,
    hi: `\u{92E}\u{948}\u{928}\u{94D}\u{92F}\u{941}\u{905}\u{932} \u{930}\u{942}\u{92A} \u{938}\u{947} \u{905}\u{92A}\u{928}\u{947} \u{92A}\u{938}\u{902}\u{926}\u{940}\u{926}\u{93E} \u{92A}\u{94D}\u{930}\u{92E}\u{93E}\u{923}\u{915} \u{910}\u{92A} \u{92E}\u{947}\u{902} \u{928}\u{93F}\u{92E}\u{94D}\u{928} \u{915}\u{94B}\u{921} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902} \u{914}\u{930} \u{92B}\u{93F}\u{930} \u{928}\u{940}\u{91A}\u{947} \u{926}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{935}\u{928}-\u{91F}\u{93E}\u{907}\u{92E} \u{915}\u{94B}\u{921} \u{926}\u{930}\u{94D}\u{91C} \u{915}\u{930}\u{947}\u{902}\u{964}`,
    ht: `Many\xe8lman antre nan k\xf2d sa a nan app otantifikat\xe8 pi pito ou ak L\xe8 sa a, antre nan k\xf2d la bay yon s\xe8l-fwa anba a.`,
    it: `Inserisci manualmente il seguente codice nella tua app di autenticazione preferita, quindi inserisci il codice monouso fornito di seguito.`,
    ja: `\u{512A}\u{5148}\u{3059}\u{308B}\u{8A8D}\u{8A3C}\u{30A2}\u{30D7}\u{30EA}\u{306B}\u{6B21}\u{306E}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{624B}\u{52D5}\u{3067}\u{5165}\u{529B}\u{3057}\u{3001}\u{4EE5}\u{4E0B}\u{306B}\u{63D0}\u{4F9B}\u{3055}\u{308C}\u{3066}\u{3044}\u{308B}\u{30EF}\u{30F3}\u{30BF}\u{30A4}\u{30E0}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{5165}\u{529B}\u{3057}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{C120}\u{D638}\u{D558}\u{B294} \u{C778}\u{C99D} \u{C571}\u{C5D0} \u{B2E4}\u{C74C} \u{CF54}\u{B4DC}\u{B97C} \u{C218}\u{B3D9}\u{C73C}\u{B85C} \u{C785}\u{B825}\u{D55C} \u{B2E4}\u{C74C}, \u{C544}\u{B798}\u{C5D0} \u{C81C}\u{ACF5}\u{B41C} \u{C77C}\u{D68C}\u{C131} \u{CF54}\u{B4DC}\u{B97C} \u{C785}\u{B825}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `Manually nkag mus rau hauv qab no code rau koj najnpawb authenticator app thiab ces nkag mus rau hauv qab no.`,
    ps: `\u{67E}\u{647} \u{644}\u{627}\u{633}\u{6CC} \u{62A}\u{648}\u{6AB}\u{647} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{6A9}\u{648}\u{689} \u{67E}\u{647} \u{62E}\u{67E}\u{644} \u{62E}\u{648}\u{69A}\u{647} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC} \u{627}\u{67E}\u{644}\u{6CC}\u{6A9}\u{6CC}\u{634}\u{646} \u{6A9}\u{6D0} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626} \u{627}\u{648} \u{628}\u{6CC}\u{627} \u{644}\u{627}\u{646}\u{62F}\u{6D0} \u{648}\u{631}\u{6A9}\u{693}\u{644} \u{634}\u{648}\u{6CC} \u{6CC}\u{648} \u{681}\u{644} \u{6A9}\u{648}\u{689} \u{62F}\u{627}\u{62E}\u{644} \u{6A9}\u{693}\u{626}.`,
    pt: `Insira manualmente o c\xf3digo a seguir em seu aplicativo autenticador preferido e, em seguida, insira o c\xf3digo \xfanico fornecido abaixo.`,
    "pt-pt": `Introduza manualmente o seguinte c\xf3digo na sua aplica\xe7\xe3o autenticadora preferida e, em seguida, introduza o c\xf3digo \xfanico fornecido abaixo.`,
    ru: `\u{412}\u{440}\u{443}\u{447}\u{43D}\u{443}\u{44E} \u{432}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{441}\u{43B}\u{435}\u{434}\u{443}\u{44E}\u{449}\u{438}\u{439} \u{43A}\u{43E}\u{434} \u{432} \u{43F}\u{440}\u{435}\u{434}\u{43F}\u{43E}\u{447}\u{438}\u{442}\u{430}\u{435}\u{43C}\u{43E}\u{435} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43B}\u{44F} \u{430}\u{443}\u{442}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{438}, \u{430} \u{437}\u{430}\u{442}\u{435}\u{43C} \u{432}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{43D}\u{438}\u{436}\u{435} \u{43E}\u{434}\u{43D}\u{43E}\u{440}\u{430}\u{437}\u{43E}\u{432}\u{44B}\u{439} \u{43A}\u{43E}\u{434}.`,
    sm: `Ulufale lima i le code lenei i lau authenticator app e te fiafia i ai ona ulu atu lea i le code e tasi le taimi o loo i lalo.`,
    so: `Joogu gali code soo socda galay app authenticator aad doorbidayso ka dibna gali la siiyay code hal mar hoos.`,
    th: `\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E15}\u{E48}\u{E2D}\u{E44}\u{E1B}\u{E19}\u{E35}\u{E49}\u{E25}\u{E07}\u{E43}\u{E19}\u{E41}\u{E2D}\u{E1B}\u{E15}\u{E31}\u{E27}\u{E22}\u{E37}\u{E19}\u{E22}\u{E31}\u{E19}\u{E15}\u{E31}\u{E27}\u{E15}\u{E19}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}\u{E14}\u{E49}\u{E27}\u{E22}\u{E15}\u{E19}\u{E40}\u{E2D}\u{E07} \u{E08}\u{E32}\u{E01}\u{E19}\u{E31}\u{E49}\u{E19}\u{E1B}\u{E49}\u{E2D}\u{E19}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E41}\u{E1A}\u{E1A}\u{E43}\u{E0A}\u{E49}\u{E04}\u{E23}\u{E31}\u{E49}\u{E07}\u{E40}\u{E14}\u{E35}\u{E22}\u{E27}\u{E17}\u{E35}\u{E48}\u{E43}\u{E2B}\u{E49}\u{E44}\u{E27}\u{E49}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}`,
    ur: `\u{62F}\u{633}\u{62A}\u{6CC} \u{637}\u{648}\u{631} \u{67E}\u{631} \u{645}\u{646}\u{62F}\u{631}\u{62C}\u{6C1} \u{630}\u{6CC}\u{644} \u{6A9}\u{648}\u{688} \u{6A9}\u{648} \u{627}\u{67E}\u{646}\u{6D2} \u{67E}\u{633}\u{646}\u{62F}\u{6CC}\u{62F}\u{6C1} \u{62A}\u{635}\u{62F}\u{6CC}\u{642} \u{6A9}\u{627}\u{631} \u{627}\u{6CC}\u{67E} \u{645}\u{6CC}\u{6BA} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA} \u{627}\u{648}\u{631} \u{67E}\u{6BE}\u{631} \u{646}\u{6CC}\u{686}\u{6D2} \u{641}\u{631}\u{627}\u{6C1}\u{645} \u{6A9}\u{631}\u{62F}\u{6C1} \u{648}\u{646} \u{679}\u{627}\u{626}\u{645} \u{6A9}\u{648}\u{688} \u{62F}\u{631}\u{62C} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `Nh\u{1EAD}p th\u{1EE7} c\xf4ng m\xe3 sau v\xe0o \u{1EE9}ng d\u{1EE5}ng x\xe1c th\u{1EF1}c \u{1B0}a th\xedch c\u{1EE7}a b\u{1EA1}n, sau \u{111}\xf3 nh\u{1EAD}p m\xe3 m\u{1ED9}t l\u{1EA7}n \u{111}\u{1B0}\u{1EE3}c cung c\u{1EA5}p b\xean d\u{1B0}\u{1EDB}i.`,
    "zh-hans": `\u{5728}\u{60A8}\u{9996}\u{9009}\u{7684}\u{8EAB}\u{4EFD}\u{9A8C}\u{8BC1}\u{5668}\u{5E94}\u{7528}\u{7A0B}\u{5E8F}\u{4E2D}\u{624B}\u{52A8}\u{8F93}\u{5165}\u{4EE5}\u{4E0B}\u{4EE3}\u{7801}\u{FF0C}\u{7136}\u{540E}\u{5728}\u{4E0B}\u{9762}\u{8F93}\u{5165}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{7801}\u{3002}`,
    "zh-hant": `\u{5728}\u{60A8}\u{9996}\u{9078}\u{7684}\u{8EAB}\u{4EFD}\u{9A57}\u{8B49}\u{5668}\u{61C9}\u{7528}\u{7A0B}\u{5F0F}\u{4E2D}\u{624B}\u{52D5}\u{8F38}\u{5165}\u{4EE5}\u{4E0B}\u{4EE3}\u{78BC}\u{FF0C}\u{7136}\u{5F8C}\u{5728}\u{4E0B}\u{9762}\u{8F38}\u{5165}\u{63D0}\u{4F9B}\u{7684}\u{4E00}\u{6B21}\u{6027}\u{4EE3}\u{78BC}\u{3002}`,
    en: `Manually enter the following code into your preferred authenticator app and then enter the provided one-time code below.`
};
const $2868cc1235412e16$export$4dc1171ed58e1ff2 = {
    ar: `\u{1F512} \u{633}\u{62A}\u{643}\u{648}\u{646} MFA \u{645}\u{637}\u{644}\u{648}\u{628}\u{629} \u{641}\u{64A} 11/13.`,
    de: `\u{1F512} MFA wird am 13.11. erforderlich sein.`,
    es: `\u{1F512} Se requerir\xe1 MFA el 13/11.`,
    fa: `\u{1F512} MFA \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} 11/13 \u{645}\u{648}\u{631}\u{62F} \u{646}\u{6CC}\u{627}\u{632} \u{62E}\u{648}\u{627}\u{647}\u{62F} \u{628}\u{648}\u{62F}.`,
    fil: `\u{1F512} Kinakailangan ang MFA sa 11/13.`,
    fr: `\u{1F512} L\u{2019}authentification multifacteur sera exig\xe9e le 13/11.`,
    hi: `\u{1F512} 11/13 \u{915}\u{94B} \u{90F}\u{92E}\u{90F}\u{92B}\u{90F} \u{915}\u{940} \u{906}\u{935}\u{936}\u{94D}\u{92F}\u{915}\u{924}\u{93E} \u{939}\u{94B}\u{917}\u{940}\u{964}`,
    ht: `\u{1F512} MFA ap obligatwa sou 11/13.`,
    it: `\u{1F512} L'MFA sar\xe0 richiesto il 13/11.`,
    ja: `\u{1F512} MFA\u{306F}11/13\u{306B}\u{5FC5}\u{8981}\u{306B}\u{306A}\u{308A}\u{307E}\u{3059}\u{3002}`,
    ko: `\u{1F512} MFA\u{B294} 11/13\u{C5D0} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}.`,
    mww: `\u{1F512} MFA yuav tsum tau rau 11/13.`,
    ps: `\u{1F512} MFA \u{628}\u{647} \u{67E}\u{647} 11/13 \u{627}\u{693}\u{6CC}\u{646} \u{648}\u{6CC}.`,
    pt: `\u{1F512} O MFA ser\xe1 exigido em 13/11.`,
    "pt-pt": `\u{1F512} O MFA ser\xe1 requerido em 13/11.`,
    ru: `\u{1F512} MFA \u{43F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F} 13/11.`,
    sm: `\u{1F512} MFA o le a mana'omia i le 11/13.`,
    so: `\u{1F512} MFA waxaa laga doonayaa inay ku 11/13.`,
    th: `\u{1F512} \u{E08}\u{E4D}\u{E32}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35} MFA \u{E43}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} 11/13`,
    ur: `\u{1F512} 11/13 \u{6A9}\u{648} \u{627}\u{6CC}\u{645} \u{627}\u{6CC}\u{641} \u{627}\u{6D2} \u{6A9}\u{6CC} \u{636}\u{631}\u{648}\u{631}\u{62A} \u{6C1}\u{648}\u{6AF}\u{6CC}\u{6D4}`,
    vi: `\u{1F512} MFA s\u{1EBD} \u{111}\u{1B0}\u{1EE3}c y\xeau c\u{1EA7}u v\xe0o ng\xe0y 13/11.`,
    "zh-hans": `\u{1F512} 11 \u{6708} 13 \u{65E5}\u{5C06}\u{9700}\u{8981} MFA\u{3002}`,
    "zh-hant": `\u{1F512} 11 \u{6708} 13 \u{65E5}\u{5C07}\u{9700}\u{8981} MFA\u{3002}`,
    en: `\u{1F512} MFA will be required on 11/13.`
};
const $2868cc1235412e16$export$7ea5605264efeacf = {
    ar: `\u{641}\u{643}\u{631}`,
    de: `Denken`,
    es: `Pensamiento`,
    fa: `\u{62A}\u{641}\u{6A9}\u{631}`,
    fil: `Pag-iisip`,
    fr: `Pens\xe9e`,
    hi: `\u{938}\u{94B}\u{91A} \u{930}\u{939}\u{947}`,
    ht: `Panse`,
    it: `Pensante`,
    ja: `\u{601D}\u{7D22}`,
    ko: `\u{C0DD}\u{AC01}`,
    mww: `xav`,
    ps: `\u{62A}\u{641}\u{6A9}\u{631}`,
    pt: `Pensante`,
    "pt-pt": `Pensamento`,
    ru: `\u{41C}\u{44B}\u{441}\u{43B}\u{44F}\u{449}\u{438}\u{439}`,
    sm: `Mafaufau`,
    so: `Fikirka`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E34}\u{E14}`,
    ur: `\u{633}\u{648}\u{686}`,
    vi: `Suy ngh\u{129}`,
    "zh-hans": `\u{601D}\u{7EF4}`,
    "zh-hant": `\u{601D}\u{7DAD}`,
    en: `Thinking`
};
const $2868cc1235412e16$export$1108f562936cb617 = {
    ar: `\u{623}\u{646}\u{62A}`,
    de: `Du`,
    es: `T\xfa`,
    fa: `\u{634}\u{645}\u{627}`,
    fil: `Ikaw`,
    fr: `Vous`,
    hi: `\u{924}\u{941}\u{92E}`,
    ht: `Ou`,
    it: `Tu`,
    ja: `\u{3042}\u{306A}\u{305F}\u{304C}`,
    ko: `\u{B108}`,
    mww: `Koj`,
    ps: `\u{62A}\u{627}\u{633}\u{648}`,
    pt: `Voc\xea`,
    "pt-pt": `Voc\xea`,
    ru: `\u{422}\u{44B}`,
    sm: `O oe`,
    so: `waxaad`,
    th: `\u{E17}\u{E48}\u{E32}\u{E19}`,
    ur: `\u{62A}\u{645}`,
    vi: `M\xe0y`,
    "zh-hans": `\u{4F60}`,
    "zh-hant": `\u{4F60}`,
    en: `You`
};
const $2868cc1235412e16$export$5f486e535de293fa = {
    ar: `\u{646}\u{633}\u{62E}`,
    de: `Kopieren`,
    es: `Copiar`,
    fa: `\u{6A9}\u{67E}\u{6CC}`,
    fil: `Kopyahin`,
    fr: `Copier`,
    hi: `\u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{932}\u{93F}\u{92A}\u{93F}`,
    ht: `Kopi`,
    it: `Copiare`,
    ja: `\u{5199}\u{3057}`,
    ko: `\u{BCF5}\u{C0AC}`,
    mww: `Luam ib daim qauv`,
    ps: `\u{6A9}\u{627}\u{67E}\u{6CC}`,
    pt: `Copiar`,
    "pt-pt": `Copiar`,
    ru: `\u{41A}\u{43E}\u{43F}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C}`,
    sm: `Kopi`,
    so: `Nuqul`,
    th: `\u{E25}\u{E2D}\u{E01}`,
    ur: `\u{646}\u{642}\u{644}`,
    vi: `B\u{1EA3}n sao`,
    "zh-hans": `\u{590D}\u{5236}`,
    "zh-hant": `\u{8907}\u{88FD}`,
    en: `Copy`
};
const $2868cc1235412e16$export$6ad4e1f26ee3fd98 = {
    ar: `\u{62A}\u{644}\u{62E}\u{64A}\u{635} \u{647}\u{630}\u{627} \u{627}\u{644}\u{633}\u{62C}\u{644}`,
    de: `Fassen Sie diesen Datensatz zusammen`,
    es: `Resumir este registro`,
    fa: `\u{627}\u{6CC}\u{646} \u{631}\u{6A9}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{62E}\u{644}\u{627}\u{635}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Ibuod ang talaang ito`,
    fr: `R\xe9sumer ce record`,
    hi: `\u{907}\u{938} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921} \u{915}\u{94B} \u{938}\u{93E}\u{930}\u{93E}\u{902}\u{936}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rezime dosye sa a`,
    it: `Riassumi questo record`,
    ja: `\u{3053}\u{306E}\u{30EC}\u{30B3}\u{30FC}\u{30C9}\u{3092}\u{8981}\u{7D04}\u{3059}\u{308B}`,
    ko: `\u{C774} \u{B808}\u{CF54}\u{B4DC} \u{C694}\u{C57D}`,
    mww: `Sau tsab ntawv no`,
    ps: `\u{62F} \u{62F}\u{6D0} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689} \u{644}\u{646}\u{689}\u{6CC}\u{632}`,
    pt: `Resumir este registro`,
    "pt-pt": `Resumir este registo`,
    ru: `\u{41F}\u{43E}\u{434}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{438}\u{442}\u{43E}\u{433}\u{438} \u{44D}\u{442}\u{43E}\u{439} \u{43B}\u{435}\u{442}\u{43E}\u{43F}\u{438}\u{441}\u{438}`,
    sm: `Otooto le faamaumauga lenei`,
    so: `Soo koobi rikoorkan`,
    th: `\u{E2A}\u{E23}\u{E38}\u{E1B}\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{6A9}\u{627} \u{62E}\u{644}\u{627}\u{635}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xf3m t\u{1EAF}t h\u{1ED3} s\u{1A1} n\xe0y`,
    "zh-hans": `\u{603B}\u{7ED3}\u{6B64}\u{8BB0}\u{5F55}`,
    "zh-hant": `\u{7E3D}\u{7D50}\u{6B64}\u{8A18}\u{9304}`,
    en: `Summarize this record`
};
const $2868cc1235412e16$export$170d4e08b9b91ae4 = {
    ar: `\u{62A}\u{62D}\u{62F}\u{64A}\u{62F} \u{627}\u{644}\u{62E}\u{637}\u{648}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{627}\u{644}\u{64A}\u{629}`,
    de: `Identifizieren Sie die n\xe4chsten Schritte`,
    es: `Identificar los pr\xf3ximos pasos`,
    fa: `\u{645}\u{631}\u{627}\u{62D}\u{644} \u{628}\u{639}\u{62F}\u{6CC} \u{631}\u{627} \u{634}\u{646}\u{627}\u{633}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Tukuyin ang mga susunod na hakbang`,
    fr: `Identifier les prochaines \xe9tapes`,
    hi: `\u{905}\u{917}\u{932}\u{947} \u{91A}\u{930}\u{923}\u{94B}\u{902} \u{915}\u{940} \u{92A}\u{939}\u{91A}\u{93E}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Idantifye pwochen etap yo`,
    it: `Identificare i passaggi successivi`,
    ja: `\u{6B21}\u{306E}\u{30B9}\u{30C6}\u{30C3}\u{30D7}\u{3092}\u{7279}\u{5B9A}\u{3059}\u{308B}`,
    ko: `\u{B2E4}\u{C74C} \u{B2E8}\u{ACC4} \u{C2DD}\u{BCC4}`,
    mww: `Taw cov kauj ruam tom ntej`,
    ps: `\u{631}\u{627}\u{62A}\u{644}\u{648}\u{646}\u{6A9}\u{6D0} \u{6AB}\u{627}\u{645}\u{648}\u{646}\u{647} \u{648}\u{67E}\u{6CC}\u{698}\u{646}\u{626}`,
    pt: `Identifique as pr\xf3ximas etapas`,
    "pt-pt": `Identificar as pr\xf3ximas etapas`,
    ru: `\u{41E}\u{43F}\u{440}\u{435}\u{434}\u{435}\u{43B}\u{438}\u{442}\u{435} \u{434}\u{430}\u{43B}\u{44C}\u{43D}\u{435}\u{439}\u{448}\u{438}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    sm: `Faailoa laasaga e sosoo ai`,
    so: `Aqoonso tallaabooyinka xiga`,
    th: `\u{E23}\u{E30}\u{E1A}\u{E38}\u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}`,
    ur: `\u{627}\u{6AF}\u{644}\u{6D2} \u{627}\u{642}\u{62F}\u{627}\u{645}\u{627}\u{62A} \u{6A9}\u{6CC} \u{646}\u{634}\u{627}\u{646}\u{62F}\u{6C1}\u{6CC} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `X\xe1c \u{111}\u{1ECB}nh c\xe1c b\u{1B0}\u{1EDB}c ti\u{1EBF}p theo`,
    "zh-hans": `\u{786E}\u{5B9A}\u{540E}\u{7EED}\u{6B65}\u{9AA4}`,
    "zh-hant": `\u{78BA}\u{5B9A}\u{5F8C}\u{7E8C}\u{6B65}\u{9A5F}`,
    en: `Identify next steps`
};
const $2868cc1235412e16$export$7aebbc760fcb6d39 = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{639}\u{644}\u{627}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{62D}\u{645}\u{631}\u{627}\u{621} \u{623}\u{648} \u{627}\u{644}\u{645}\u{634}\u{643}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{639}\u{627}\u{62C}\u{644}\u{629}`,
    de: `Finden Sie Warnsignale oder dringende Probleme`,
    es: `Encuentre se\xf1ales de alerta o problemas urgentes`,
    fa: `\u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{631}\u{62F}\u{646} \u{67E}\u{631}\u{686}\u{645} \u{647}\u{627}\u{6CC} \u{642}\u{631}\u{645}\u{632} \u{6CC}\u{627} \u{645}\u{633}\u{627}\u{626}\u{644} \u{641}\u{648}\u{631}\u{6CC}`,
    fil: `Maghanap ng mga pulang bandila o mga kagyat na isyu`,
    fr: `Trouvez des signaux d\u{2019}alarme ou des probl\xe8mes urgents`,
    hi: `\u{932}\u{93E}\u{932} \u{91D}\u{902}\u{921}\u{947} \u{92F}\u{93E} \u{905}\u{924}\u{94D}\u{92F}\u{93E}\u{935}\u{936}\u{94D}\u{92F}\u{915} \u{938}\u{92E}\u{938}\u{94D}\u{92F}\u{93E}\u{90F}\u{902} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Jwenn drafig wouj oswa pwobl\xe8m ijan`,
    it: `Trova bandiere rosse o problemi urgenti`,
    ja: `\u{5371}\u{967A}\u{4FE1}\u{53F7}\u{3084}\u{7DCA}\u{6025}\u{306E}\u{554F}\u{984C}\u{3092}\u{898B}\u{3064}\u{3051}\u{308B}`,
    ko: `\u{C704}\u{D5D8} \u{C2E0}\u{D638} \u{B610}\u{B294} \u{AE34}\u{AE09}\u{D55C} \u{BB38}\u{C81C} \u{CC3E}\u{AE30}`,
    mww: `Nrhiav chij liab los yog ceev tej teeb meem`,
    ps: `\u{633}\u{648}\u{631} \u{628}\u{6CC}\u{631}\u{63A}\u{648}\u{646}\u{647} \u{6CC}\u{627} \u{639}\u{627}\u{62C}\u{644}\u{6D0} \u{645}\u{633}\u{644}\u{6D0} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{693}\u{626}`,
    pt: `Encontre sinais de alerta ou problemas urgentes`,
    "pt-pt": `Encontre sinais de alerta ou problemas urgentes`,
    ru: `\u{41D}\u{430}\u{445}\u{43E}\u{434}\u{438}\u{442}\u{435} \u{442}\u{440}\u{435}\u{432}\u{43E}\u{436}\u{43D}\u{44B}\u{435} \u{441}\u{438}\u{433}\u{43D}\u{430}\u{43B}\u{44B} \u{438}\u{43B}\u{438} \u{441}\u{440}\u{43E}\u{447}\u{43D}\u{44B}\u{435} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{44B}`,
    sm: `Saili fu'a mumu po'o fa'afitauli faanatinati`,
    so: `Raadi calaamado gaduudan ama arimo deg deg ah`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E18}\u{E07}\u{E2A}\u{E35}\u{E41}\u{E14}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E40}\u{E23}\u{E48}\u{E07}\u{E14}\u{E48}\u{E27}\u{E19}`,
    ur: `\u{633}\u{631}\u{62E} \u{62C}\u{6BE}\u{646}\u{688}\u{6D2} \u{6CC}\u{627} \u{641}\u{648}\u{631}\u{6CC} \u{645}\u{633}\u{627}\u{626}\u{644} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm c\u{1EDD} \u{111}\u{1ECF} ho\u{1EB7}c c\xe1c v\u{1EA5}n \u{111}\u{1EC1} kh\u{1EA9}n c\u{1EA5}p`,
    "zh-hans": `\u{67E5}\u{627E}\u{5371}\u{9669}\u{4FE1}\u{53F7}\u{6216}\u{7D27}\u{6025}\u{95EE}\u{9898}`,
    "zh-hant": `\u{67E5}\u{627E}\u{5371}\u{96AA}\u{4FE1}\u{865F}\u{6216}\u{7DCA}\u{6025}\u{554F}\u{984C}`,
    en: `Find red flags or urgent issues`
};
const $2868cc1235412e16$export$7855d74a051318c3 = {
    ar: `\u{642}\u{627}\u{626}\u{645}\u{629} \u{628}\u{627}\u{644}\u{62A}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{631}\u{626}\u{64A}\u{633}\u{64A}\u{629} \u{648}\u{622}\u{62B}\u{627}\u{631}\u{647}\u{627}`,
    de: `Liste der wichtigsten Interventionen und ihrer Auswirkungen`,
    es: `Enumerar las intervenciones clave y sus efectos`,
    fa: `\u{645}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A} \u{6A9}\u{644}\u{6CC}\u{62F}\u{6CC} \u{648} \u{62A}\u{627}\u{62B}\u{6CC}\u{631}\u{627}\u{62A} \u{622}\u{646}\u{647}\u{627} \u{631}\u{627} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Ilista ang mga pangunahing interbensyon at ang kanilang mga epekto`,
    fr: `\xc9num\xe9rer les principales interventions et leurs effets`,
    hi: `\u{92A}\u{94D}\u{930}\u{92E}\u{941}\u{916} \u{939}\u{938}\u{94D}\u{924}\u{915}\u{94D}\u{937}\u{947}\u{92A}\u{94B}\u{902} \u{914}\u{930} \u{909}\u{928}\u{915}\u{947} \u{92A}\u{94D}\u{930}\u{92D}\u{93E}\u{935}\u{94B}\u{902} \u{915}\u{940} \u{938}\u{942}\u{91A}\u{940} \u{92C}\u{928}\u{93E}\u{90F}\u{902}`,
    ht: `Lis ent\xe8vansyon kle ak ef\xe8 yo`,
    it: `Elencare gli interventi chiave e i loro effetti`,
    ja: `\u{4E3B}\u{306A}\u{4ECB}\u{5165}\u{7B56}\u{3068}\u{305D}\u{306E}\u{52B9}\u{679C}\u{3092}\u{6319}\u{3052}\u{308B}`,
    ko: `\u{C8FC}\u{C694} \u{C911}\u{C7AC} \u{BC0F} \u{ADF8} \u{D6A8}\u{ACFC} \u{B098}\u{C5F4}`,
    mww: `Daim ntawv teev cov kev pab tseem ceeb thiab lawv cov teebmeem`,
    ps: `\u{6A9}\u{644}\u{6CC}\u{62F}\u{6CC} \u{645}\u{62F}\u{627}\u{62E}\u{644}\u{6D0} \u{627}\u{648} \u{62F} \u{647}\u{63A}\u{648} \u{627}\u{63A}\u{6CC}\u{632}\u{6D0} \u{644}\u{633}\u{62A} \u{6A9}\u{693}\u{626}`,
    pt: `Liste as principais interven\xe7\xf5es e seus efeitos`,
    "pt-pt": `Listar as principais interven\xe7\xf5es e seus efeitos`,
    ru: `\u{41F}\u{435}\u{440}\u{435}\u{447}\u{438}\u{441}\u{43B}\u{438}\u{442}\u{435} \u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{432}\u{44B}\u{435} \u{432}\u{43C}\u{435}\u{448}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{441}\u{442}\u{432}\u{430} \u{438} \u{438}\u{445} \u{44D}\u{444}\u{444}\u{435}\u{43A}\u{442}\u{44B}`,
    sm: `Lisi o fa'alavelave fa'afuase'i ma o latou a'afiaga`,
    so: `Liiska waxqabadyada muhiimka ah iyo saamaynta ay saameynta`,
    th: `\u{E41}\u{E2A}\u{E14}\u{E07}\u{E23}\u{E32}\u{E22}\u{E01}\u{E32}\u{E23}\u{E01}\u{E32}\u{E23}\u{E41}\u{E17}\u{E23}\u{E01}\u{E41}\u{E0B}\u{E07}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E4D}\u{E32}\u{E04}\u{E31}\u{E0D}\u{E41}\u{E25}\u{E30}\u{E1C}\u{E25}\u{E01}\u{E23}\u{E30}\u{E17}\u{E1A}`,
    ur: `\u{627}\u{6C1}\u{645} \u{645}\u{62F}\u{627}\u{62E}\u{644}\u{62A}\u{648}\u{6BA} \u{627}\u{648}\u{631} \u{627}\u{646} \u{6A9}\u{6D2} \u{627}\u{62B}\u{631}\u{627}\u{62A} \u{6A9}\u{6CC} \u{641}\u{6C1}\u{631}\u{633}\u{62A}`,
    vi: `Li\u{1EC7}t k\xea c\xe1c can thi\u{1EC7}p ch\xednh v\xe0 t\xe1c d\u{1EE5}ng c\u{1EE7}a ch\xfang`,
    "zh-hans": `\u{5217}\u{51FA}\u{5173}\u{952E}\u{5E72}\u{9884}\u{63AA}\u{65BD}\u{53CA}\u{5176}\u{6548}\u{679C}`,
    "zh-hant": `\u{5217}\u{51FA}\u{95DC}\u{9375}\u{5E72}\u{9810}\u{63AA}\u{65BD}\u{53CA}\u{5176}\u{6548}\u{679C}`,
    en: `List key interventions and their effects`
};
const $2868cc1235412e16$export$d3e6e2f9776d6812 = {
    ar: `\u{62A}\u{62D}\u{644}\u{64A}\u{644} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{645}\u{648}\u{627}\u{631}\u{62F}`,
    de: `Analysieren der Ressourcenauslastung`,
    es: `Analice la utilizaci\xf3n de recursos`,
    fa: `\u{62A}\u{62C}\u{632}\u{6CC}\u{647} \u{648} \u{62A}\u{62D}\u{644}\u{6CC}\u{644} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{627}\u{632} \u{645}\u{646}\u{627}\u{628}\u{639}`,
    fil: `Suriin ang paggamit ng mapagkukunan`,
    fr: `Analyser l\u{2019}utilisation des ressources`,
    hi: `\u{938}\u{902}\u{938}\u{93E}\u{927}\u{928} \u{909}\u{92A}\u{92F}\u{94B}\u{917} \u{915}\u{93E} \u{935}\u{93F}\u{936}\u{94D}\u{932}\u{947}\u{937}\u{923} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Analyze resous itilize`,
    it: `Analizzare l'utilizzo delle risorse`,
    ja: `\u{30EA}\u{30BD}\u{30FC}\u{30B9}\u{4F7F}\u{7528}\u{7387}\u{306E}\u{5206}\u{6790}`,
    ko: `\u{B9AC}\u{C18C}\u{C2A4} \u{C0AC}\u{C6A9}\u{B960} \u{BD84}\u{C11D}`,
    mww: `Tsom xam cov chaw muab kev pab utilization`,
    ps: `\u{62F} \u{633}\u{631}\u{686}\u{6CC}\u{646}\u{648} \u{685}\u{62E}\u{647} \u{62F} \u{6AB}\u{67C}\u{6D0} \u{627}\u{62E}\u{6CC}\u{633}\u{62A}\u{646}\u{6D0} \u{62A}\u{62D}\u{644}\u{6CC}\u{644}`,
    pt: `Analisar a utiliza\xe7\xe3o de recursos`,
    "pt-pt": `Analise a utiliza\xe7\xe3o de recursos`,
    ru: `\u{410}\u{43D}\u{430}\u{43B}\u{438}\u{437} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{440}\u{435}\u{441}\u{443}\u{440}\u{441}\u{43E}\u{432}`,
    sm: `Iloilo le faaaogaina o punaoa`,
    so: `Falanqaynta isticmaalka ilaha`,
    th: `\u{E27}\u{E34}\u{E40}\u{E04}\u{E23}\u{E32}\u{E30}\u{E2B}\u{E4C}\u{E01}\u{E32}\u{E23}\u{E43}\u{E0A}\u{E49}\u{E17}\u{E23}\u{E31}\u{E1E}\u{E22}\u{E32}\u{E01}\u{E23}`,
    ur: `\u{648}\u{633}\u{627}\u{626}\u{644} \u{6A9}\u{6D2} \u{627}\u{633}\u{62A}\u{639}\u{645}\u{627}\u{644} \u{6A9}\u{627} \u{62A}\u{62C}\u{632}\u{6CC}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ph\xe2n t\xedch vi\u{1EC7}c s\u{1EED} d\u{1EE5}ng t\xe0i nguy\xean`,
    "zh-hans": `\u{5206}\u{6790}\u{8D44}\u{6E90}\u{5229}\u{7528}\u{7387}`,
    "zh-hant": `\u{5206}\u{6790}\u{8CC7}\u{6E90}\u{5229}\u{7528}\u{7387}`,
    en: `Analyze resource utilization`
};
const $2868cc1235412e16$export$7d76bfe38189f305 = {
    ar: `\u{627}\u{644}\u{628}\u{62D}\u{62B} \u{639}\u{646} \u{627}\u{644}\u{62B}\u{63A}\u{631}\u{627}\u{62A} \u{623}\u{648} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{641}\u{642}\u{648}\u{62F}\u{629}`,
    de: `L\xfccken oder fehlende Informationen finden`,
    es: `Encontrar lagunas o informaci\xf3n faltante`,
    fa: `\u{634}\u{6A9}\u{627}\u{641} \u{647}\u{627} \u{6CC}\u{627} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{6AF}\u{645}\u{634}\u{62F}\u{647} \u{631}\u{627} \u{67E}\u{6CC}\u{62F}\u{627} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Maghanap ng mga puwang o nawawalang impormasyon`,
    fr: `Trouver des lacunes ou des informations manquantes`,
    hi: `\u{905}\u{902}\u{924}\u{930}\u{93E}\u{932} \u{92F}\u{93E} \u{905}\u{928}\u{941}\u{92A}\u{932}\u{92C}\u{94D}\u{927} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{916}\u{94B}\u{91C}\u{947}\u{902}`,
    ht: `Jwenn espas oswa enf\xf2masyon ki manke`,
    it: `Trova lacune o informazioni mancanti`,
    ja: `\u{30AE}\u{30E3}\u{30C3}\u{30D7}\u{3084}\u{4E0D}\u{8DB3}\u{3057}\u{3066}\u{3044}\u{308B}\u{60C5}\u{5831}\u{3092}\u{898B}\u{3064}\u{3051}\u{308B}`,
    ko: `\u{BE48}\u{D2C8} \u{B610}\u{B294} \u{B204}\u{B77D}\u{B41C} \u{C815}\u{BCF4} \u{CC3E}\u{AE30}`,
    mww: `Nrhiav gaps los yog uas ploj lawm`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6CC} \u{62A}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F}`,
    pt: `Encontrar lacunas ou informa\xe7\xf5es ausentes`,
    "pt-pt": `Encontrar lacunas ou informa\xe7\xf5es em falta`,
    ru: `\u{41D}\u{430}\u{439}\u{434}\u{438}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{44B} \u{438}\u{43B}\u{438} \u{43D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{44E}\u{449}\u{443}\u{44E} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44E}`,
    sm: `Saili avanoa po o faamatalaga o loo misi`,
    so: `Raadi labada meelood oo ay faraha ka maqan yihiin ama macluumaad maqan`,
    th: `\u{E04}\u{E49}\u{E19}\u{E2B}\u{E32}\u{E0A}\u{E48}\u{E2D}\u{E07}\u{E27}\u{E48}\u{E32}\u{E07}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E17}\u{E35}\u{E48}\u{E02}\u{E32}\u{E14}\u{E2B}\u{E32}\u{E22}\u{E44}\u{E1B}`,
    ur: `\u{62E}\u{644}\u{627} \u{6CC}\u{627} \u{6AF}\u{645} \u{634}\u{62F}\u{6C1} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62A}\u{644}\u{627}\u{634} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `T\xecm kho\u{1EA3}ng tr\u{1ED1}ng ho\u{1EB7}c th\xf4ng tin c\xf2n thi\u{1EBF}u`,
    "zh-hans": `\u{67E5}\u{627E}\u{5DEE}\u{8DDD}\u{6216}\u{7F3A}\u{5931}\u{4FE1}\u{606F}`,
    "zh-hant": `\u{67E5}\u{627E}\u{5DEE}\u{8DDD}\u{6216}\u{7F3A}\u{5931}\u{8CC7}\u{8A0A}`,
    en: `Find gaps or missing information`
};
const $2868cc1235412e16$export$4573cdd5f888d123 = {
    ar: `\u{62A}\u{62D}\u{642}\u{642} \u{645}\u{646} \u{627}\u{644}\u{645}\u{634}\u{627}\u{639}\u{631} / \u{627}\u{644}\u{631}\u{636}\u{627}`,
    de: `\xdcberpr\xfcfen Sie die Stimmung/Zufriedenheit`,
    es: `Comprobar el sentimiento/satisfacci\xf3n`,
    fa: `\u{627}\u{62D}\u{633}\u{627}\u{633}\u{627}\u{62A}/\u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{631}\u{631}\u{633}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Suriin ang damdamin/kasiyahan`,
    fr: `V\xe9rifier le sentiment/la satisfaction`,
    hi: `\u{92D}\u{93E}\u{935}\u{928}\u{93E}/\u{938}\u{902}\u{924}\u{941}\u{937}\u{94D}\u{91F}\u{93F} \u{915}\u{940} \u{91C}\u{93E}\u{901}\u{91A} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Tcheke santiman/satisfaksyon`,
    it: `Controlla il sentiment/la soddisfazione`,
    ja: `\u{30BB}\u{30F3}\u{30C1}\u{30E1}\u{30F3}\u{30C8}/\u{6E80}\u{8DB3}\u{5EA6}\u{3092}\u{78BA}\u{8A8D}\u{3059}\u{308B}`,
    ko: `\u{AC10}\u{C815}/\u{B9CC}\u{C871}\u{B3C4} \u{D655}\u{C778}`,
    mww: `Ntsuam xyuas sentiment/siab`,
    ps: `\u{627}\u{62D}\u{633}\u{627}\u{633}\u{627}\u{62A} / \u{631}\u{636}\u{627}\u{6CC}\u{62A} \u{648}\u{6AB}\u{648}\u{631}\u{626}`,
    pt: `Verifique o sentimento/satisfa\xe7\xe3o`,
    "pt-pt": `Verificar sentimento/satisfa\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{43E}\u{432}\u{435}\u{440}\u{44C}\u{442}\u{435} \u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{435}\u{43D}\u{438}\u{44F}/\u{443}\u{434}\u{43E}\u{432}\u{43B}\u{435}\u{442}\u{432}\u{43E}\u{440}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Siaki lagona / faamalieina`,
    so: `Hubi caadifad / qanacsanaan`,
    th: `\u{E15}\u{E23}\u{E27}\u{E08}\u{E2A}\u{E2D}\u{E1A}\u{E04}\u{E27}\u{E32}\u{E21}\u{E40}\u{E0A}\u{E37}\u{E48}\u{E2D}\u{E21}\u{E31}\u{E48}\u{E19}/\u{E04}\u{E27}\u{E32}\u{E21}\u{E1E}\u{E36}\u{E07}\u{E1E}\u{E2D}\u{E43}\u{E08}`,
    ur: `\u{62C}\u{630}\u{628}\u{627}\u{62A} / \u{627}\u{637}\u{645}\u{6CC}\u{646}\u{627}\u{646} \u{6A9}\u{6CC} \u{62C}\u{627}\u{646}\u{686} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ki\u{1EC3}m tra c\u{1EA3}m x\xfac/s\u{1EF1} h\xe0i l\xf2ng`,
    "zh-hans": `\u{68C0}\u{67E5}\u{60C5}\u{7EEA}/\u{6EE1}\u{610F}\u{5EA6}`,
    "zh-hant": `\u{6AA2}\u{67E5}\u{60C5}\u{7DD2}/\u{6EFF}\u{610F}\u{5EA6}`,
    en: `Check sentiment/satisfaction`
};
const $2868cc1235412e16$export$36e250b70ea85db6 = {
    ar: `\u{62A}\u{642}\u{64A}\u{64A}\u{645} \u{62A}\u{642}\u{62F}\u{645} \u{627}\u{644}\u{639}\u{645}\u{64A}\u{644}`,
    de: `Bewerten Sie den Fortschritt des Kunden`,
    es: `Evaluar el progreso del cliente`,
    fa: `\u{67E}\u{6CC}\u{634}\u{631}\u{641}\u{62A} \u{645}\u{634}\u{62A}\u{631}\u{6CC} \u{631}\u{627} \u{627}\u{631}\u{632}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Suriin ang pag-unlad ng kliyente`,
    fr: `\xc9valuer les progr\xe8s du client`,
    hi: `\u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915} \u{915}\u{940} \u{92A}\u{94D}\u{930}\u{917}\u{924}\u{93F} \u{915}\u{93E} \u{92E}\u{942}\u{932}\u{94D}\u{92F}\u{93E}\u{902}\u{915}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Evalye pwogr\xe8 kliyan an`,
    it: `Valutare l'andamento del cliente`,
    ja: `\u{30AF}\u{30E9}\u{30A4}\u{30A2}\u{30F3}\u{30C8}\u{306E}\u{9032}\u{6357}\u{72B6}\u{6CC1}\u{3092}\u{8A55}\u{4FA1}\u{3059}\u{308B}`,
    ko: `\u{D074}\u{B77C}\u{C774}\u{C5B8}\u{D2B8}\u{C758} \u{C9C4}\u{D589} \u{C0C1}\u{D669} \u{D3C9}\u{AC00}`,
    mww: `Soj ntsuam tus neeg tau txais kev pab`,
    ps: `\u{62F} \u{645}\u{631}\u{627}\u{62C}\u{639}\u{6CC}\u{646}\u{648} \u{67E}\u{631}\u{645}\u{62E}\u{62A}\u{6AB} \u{627}\u{631}\u{632}\u{648}\u{646}\u{647} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: `Avalie o progresso do cliente`,
    "pt-pt": `Avaliar o progresso do cliente`,
    ru: `\u{41E}\u{446}\u{435}\u{43D}\u{438}\u{432}\u{430}\u{439}\u{442}\u{435} \u{43F}\u{440}\u{43E}\u{433}\u{440}\u{435}\u{441}\u{441} \u{43A}\u{43B}\u{438}\u{435}\u{43D}\u{442}\u{430}`,
    sm: `Iloilo le alualu i luma o le tagata fa'atau`,
    so: `Qiime horumarka macmiilka`,
    th: `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E21}\u{E34}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E04}\u{E37}\u{E1A}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E02}\u{E2D}\u{E07}\u{E25}\u{E39}\u{E01}\u{E04}\u{E49}\u{E32}`,
    ur: `\u{6A9}\u{644}\u{627}\u{626}\u{646}\u{679} \u{6A9}\u{6CC} \u{67E}\u{6CC}\u{634}\u{631}\u{641}\u{62A} \u{6A9}\u{627} \u{62C}\u{627}\u{626}\u{632}\u{6C1} \u{644}\u{6CC}\u{6BA}`,
    vi: `\u{110}\xe1nh gi\xe1 ti\u{1EBF}n \u{111}\u{1ED9} c\u{1EE7}a kh\xe1ch h\xe0ng`,
    "zh-hans": `\u{8BC4}\u{4F30}\u{5BA2}\u{6237}\u{7684}\u{8FDB}\u{5C55}`,
    "zh-hant": `\u{8A55}\u{4F30}\u{5BA2}\u{6236}\u{7684}\u{9032}\u{5C55}`,
    en: `Evaluate the client's progress`
};
const $2868cc1235412e16$export$d941f7fe21e3e76c = {
    ar: `\u{62A}\u{633}\u{644}\u{64A}\u{637} \u{627}\u{644}\u{636}\u{648}\u{621} \u{639}\u{644}\u{649} \u{642}\u{635}\u{635} \u{627}\u{644}\u{646}\u{62C}\u{627}\u{62D}`,
    de: `Heben Sie Erfolgsgeschichten hervor`,
    es: `Destacar casos de \xe9xito`,
    fa: `\u{62F}\u{627}\u{633}\u{62A}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{645}\u{648}\u{641}\u{642}\u{6CC}\u{62A} \u{631}\u{627} \u{628}\u{631}\u{62C}\u{633}\u{62A}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-highlight ang mga kwento ng tagumpay`,
    fr: `Mettez en \xe9vidence les r\xe9ussites`,
    hi: `\u{938}\u{92B}\u{932}\u{924}\u{93E} \u{915}\u{940} \u{915}\u{939}\u{93E}\u{928}\u{93F}\u{92F}\u{94B}\u{902} \u{915}\u{94B} \u{939}\u{93E}\u{907}\u{932}\u{93E}\u{907}\u{91F} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Mete aksan sou istwa siks\xe8`,
    it: `Metti in evidenza le storie di successo`,
    ja: `\u{6210}\u{529F}\u{4E8B}\u{4F8B}\u{3092}\u{5F37}\u{8ABF}\u{3059}\u{308B}`,
    ko: `\u{C131}\u{ACF5} \u{C0AC}\u{B840} \u{AC15}\u{C870}`,
    mww: `Highlight zoo dab neeg`,
    ps: `\u{62F} \u{628}\u{631}\u{6CC}\u{627}\u{644}\u{6CC}\u{62A}\u{648}\u{628} \u{6A9}\u{6CC}\u{633}\u{6D0} \u{628}\u{631}\u{62C}\u{633}\u{62A}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Destaque hist\xf3rias de sucesso`,
    "pt-pt": `Destaque hist\xf3rias de sucesso`,
    ru: `\u{41E}\u{441}\u{432}\u{435}\u{449}\u{430}\u{439}\u{442}\u{435} \u{438}\u{441}\u{442}\u{43E}\u{440}\u{438}\u{438} \u{443}\u{441}\u{43F}\u{435}\u{445}\u{430}`,
    sm: `Fa'ailoa tala manuia`,
    so: `Muujiya sheekooyinka guul`,
    th: `\u{E40}\u{E19}\u{E49}\u{E19}\u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}\u{E23}\u{E32}\u{E27}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E4D}\u{E32}\u{E40}\u{E23}\u{E47}\u{E08}`,
    ur: `\u{6A9}\u{627}\u{645}\u{6CC}\u{627}\u{628}\u{6CC} \u{6A9}\u{6CC} \u{6A9}\u{6C1}\u{627}\u{646}\u{6CC}\u{648}\u{6BA} \u{6A9}\u{648} \u{646}\u{645}\u{627}\u{6CC}\u{627}\u{6BA} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `L\xe0m n\u{1ED5}i b\u{1EAD}t nh\u{1EEF}ng c\xe2u chuy\u{1EC7}n th\xe0nh c\xf4ng`,
    "zh-hans": `\u{7A81}\u{51FA}\u{6210}\u{529F}\u{6848}\u{4F8B}`,
    "zh-hant": `\u{7A81}\u{51FA}\u{6210}\u{529F}\u{6848}\u{4F8B}`,
    en: `Highlight success stories`
};
const $2868cc1235412e16$export$1ed86efeb5e4ad45 = {
    ar: `\u{645}\u{627} \u{627}\u{644}\u{630}\u{64A} \u{64A}\u{645}\u{643}\u{646}\u{646}\u{64A} \u{627}\u{644}\u{645}\u{633}\u{627}\u{639}\u{62F}\u{629} \u{641}\u{64A}\u{647}\u{61F}`,
    de: `Womit kann ich helfen?`,
    es: `\xbfEn qu\xe9 puedo ayudar?`,
    fa: `\u{62F}\u{631} \u{686}\u{647} \u{686}\u{6CC}\u{632}\u{6CC} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{645} \u{6A9}\u{645}\u{6A9} \u{6A9}\u{646}\u{645}\u{61F}`,
    fil: `Ano ang maaari kong makatulong?`,
    fr: `En quoi puis-je vous aider\xa0?`,
    hi: `\u{92E}\u{948}\u{902} \u{915}\u{94D}\u{92F}\u{93E} \u{92E}\u{926}\u{926} \u{915}\u{930} \u{938}\u{915}\u{924}\u{93E} \u{939}\u{942}\u{901}?`,
    ht: `Kisa mwen ka ede av\xe8k?`,
    it: `In cosa posso aiutare?`,
    ja: `\u{4F55}\u{304B}\u{304A}\u{624B}\u{4F1D}\u{3044}\u{3067}\u{304D}\u{308B}\u{3053}\u{3068}\u{306F}\u{3042}\u{308A}\u{307E}\u{3059}\u{304B}?`,
    ko: `\u{BB34}\u{C5C7}\u{C744} \u{B3C4}\u{C6B8} \u{C218} \u{C788}\u{B098}\u{C694}?`,
    mww: `Kuv yuav pab kuv li cas?`,
    ps: `\u{632}\u{647} \u{67E}\u{647} \u{685}\u{647} \u{6A9}\u{6D0} \u{645}\u{631}\u{633}\u{62A}\u{647} \u{6A9}\u{648}\u{644}\u{6CC} \u{634}\u{645}\u{61F}`,
    pt: `Em que posso ajudar?`,
    "pt-pt": `Em que posso ajudar?`,
    ru: `\u{412} \u{447}\u{435}\u{43C} \u{44F} \u{43C}\u{43E}\u{433}\u{443} \u{43F}\u{43E}\u{43C}\u{43E}\u{447}\u{44C}?`,
    sm: `O le a se mea e mafai ona ou fesoasoani i ai?`,
    so: `Maxaan ka caawin karaa?`,
    th: `\u{E09}\u{E31}\u{E19}\u{E08}\u{E30}\u{E0A}\u{E48}\u{E27}\u{E22}\u{E2D}\u{E30}\u{E44}\u{E23}\u{E44}\u{E14}\u{E49}\u{E1A}\u{E49}\u{E32}\u{E07}?`,
    ur: `\u{645}\u{6CC}\u{6BA} \u{6A9}\u{633} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{645}\u{62F}\u{62F} \u{6A9}\u{631} \u{633}\u{6A9}\u{62A}\u{627} \u{6C1}\u{648}\u{6BA}\u{61F}`,
    vi: `T\xf4i c\xf3 th\u{1EC3} gi\xfap g\xec?`,
    "zh-hans": `\u{6211}\u{80FD}\u{5E2E}\u{5FD9}\u{505A}\u{4EC0}\u{4E48}\u{FF1F}`,
    "zh-hant": `\u{6211}\u{80FD}\u{5E6B}\u{5FD9}\u{505A}\u{4EC0}\u{9EBC}\u{FF1F}`,
    en: `What can I help with?`
};
const $2868cc1235412e16$export$763476d2854d42f5 = {
    ar: (cumulusAssistant)=>`\u{627}\u{633}\u{623}\u{644} ${cumulusAssistant}`,
    de: (cumulusAssistant)=>`Fragen Sie ${cumulusAssistant}`,
    es: (cumulusAssistant)=>`Preg\xfantale ${cumulusAssistant}`,
    fa: (cumulusAssistant)=>`\u{627}\u{632} ${cumulusAssistant} \u{628}\u{67E}\u{631}\u{633}\u{6CC}\u{62F}`,
    fil: (cumulusAssistant)=>`Magtanong ${cumulusAssistant}`,
    fr: (cumulusAssistant)=>`Demandez \xe0 ${cumulusAssistant}`,
    hi: (cumulusAssistant)=>`${cumulusAssistant} \u{938}\u{947} \u{92A}\u{942}\u{91B}\u{947}\u{902}`,
    ht: (cumulusAssistant)=>`${cumulusAssistant}`,
    it: (cumulusAssistant)=>`Chiedi ${cumulusAssistant}`,
    ja: (cumulusAssistant)=>`${cumulusAssistant}\u{306B}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{308B}`,
    ko: (cumulusAssistant)=>`${cumulusAssistant}\u{C5D0}\u{AC8C} \u{BB3C}\u{C5B4}\u{BCF4}\u{C138}\u{C694}`,
    mww: (cumulusAssistant)=>`Nug ${cumulusAssistant}`,
    ps: (cumulusAssistant)=>`\u{62F} ${cumulusAssistant} \u{685}\u{62E}\u{647} \u{67E}\u{648}\u{69A}\u{62A}\u{646}\u{647} \u{648}\u{6A9}\u{693}\u{626}`,
    pt: (cumulusAssistant)=>`Pergunte ao ${cumulusAssistant}`,
    "pt-pt": (cumulusAssistant)=>`Pergunte ao ${cumulusAssistant}`,
    ru: (cumulusAssistant)=>`\u{417}\u{430}\u{434}\u{430}\u{442}\u{44C} ${cumulusAssistant}`,
    sm: (cumulusAssistant)=>`Fesili ${cumulusAssistant}`,
    so: (cumulusAssistant)=>`Weydii ${cumulusAssistant}`,
    th: (cumulusAssistant)=>`\u{E16}\u{E32}\u{E21} ${cumulusAssistant}`,
    ur: (cumulusAssistant)=>`${cumulusAssistant}`,
    vi: (cumulusAssistant)=>`H\u{1ECF}i ${cumulusAssistant}`,
    "zh-hans": (cumulusAssistant)=>`\u{8BE2}\u{95EE} ${cumulusAssistant}`,
    "zh-hant": (cumulusAssistant)=>`\u{8A62}\u{554F} ${cumulusAssistant}`,
    en: (cumulusAssistant)=>`Ask ${cumulusAssistant}`
};
const $2868cc1235412e16$export$d0872991fee7ddcf = {
    ar: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`يمكنك طرح أشياء مثل "${chatPrompt1}" و"${chatPrompt2}" و"${chatPrompt3}" و <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">أكثر</button>.<br>يتم تشغيل <a href="/docs/assistant">${cumulusAssistant}</a> بواسطة الذكاء الاصطناعي ، لذا فإن الأخطاء ممكنة. راجع الإخراج بعناية قبل الاستخدام.`,
    de: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Sie können Fragen stellen wie "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" und <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">mehr</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> wird von KI unterstützt, so dass Fehler möglich sind. Überprüfen Sie die Ausgabe vor der Verwendung sorgfältig.`,
    es: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Puede preguntar cosas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" y <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">más</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> funciona con IA, por lo que es posible que se cometan errores. Revise la salida cuidadosamente antes de usar.`,
    fa: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`می توانید مواردی مانند «${chatPrompt1}»، «${chatPrompt2}»، «${chatPrompt3}» و <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">بیشتر</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> از هوش مصنوعی پشتیبانی می کند، بنابراین اشتباهات ممکن است. قبل از استفاده، خروجی را به دقت بررسی کنید.`,
    fil: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Maaari kang magtanong ng mga bagay tulad ng "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", at <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">higit pa</button>.<br>Ang <a href="/docs/assistant">${cumulusAssistant}</a> ay pinapatakbo ng AI, kaya posible ang mga pagkakamali. Suriin nang mabuti ang output bago gamitin.`,
    fr: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Vous pouvez demander des choses comme « ${chatPrompt1} », « ${chatPrompt2} », « ${chatPrompt3} », et <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">plus</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> est alimenté par l’IA, il est donc possible que des erreurs soient commises. Examinez attentivement la sortie avant utilisation.`,
    hi: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`आप "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" जैसी चीज़ें पूछ सकते हैं, और <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">अधिक</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> AI द्वारा संचालित है, इसलिए गलतियाँ संभव हैं। पुन:view उपयोग करने से पहले आउटपुट काजीपूर्वक करें।`,
    ht: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Ou ka mande bagay tankou "${chatPrompt1}", "${chatPrompt2}, "${chatPrompt3}", ak <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Plis</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> patwone pa AI, se konsa erè yo posib. Revize pwodiksyon ak anpil atansyon anvan ou itilize.`,
    it: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Puoi chiedere cose come "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">più</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> è alimentato dall'intelligenza artificiale, quindi gli errori sono possibili. Review l'output attentamente prima dell'uso.`,
    ja: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`「${chatPrompt1}する」、「${chatPrompt2}」、「${chatPrompt3}」などを尋ねることができます。 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">もっとその</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> は AI を利用しているため、ミスを犯す可能性があります。よくview 使用する前に出力をよく。`,
    ko: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`"${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" 등과 같은 질문을 할 수 있습니다. <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">더</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 는 AI로 구동되므로 실수가 발생할 수 있습니다. Review 사용하기 전에 출력을 주의 깊게 검토하십시오.`,
    mww: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Koj muaj peev xwm nug tau tej yam xws li "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", thiab <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Ntau</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> yog powered los AI, ces yuam kev yog tau. Muab tso zis tso zis ua ntej yuav siv.`,
    ps: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`تاسو کولی شئ داسې شیان وپوښتئ لکه "${chatPrompt1} کړئ"، "${chatPrompt2}"، "${chatPrompt3} کړئ"، او <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">په دې وروستیو کې د افغانستان د کر</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> د AI لخوا ځواک لری، نو غلطۍ امکان لری. د کارولو څخه مخکې محصول په احتیاط سره وګورئ`,
    pt: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Você pode perguntar coisas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">mais</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> é alimentado por IA, portanto, erros são possíveis. Review a saída cuidadosamente antes de usar.`,
    "pt-pt": (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Você pode perguntar coisas como "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}" e <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">Saber mais</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> é alimentado por IA, por isso erros são possíveis. Revise cuidadosamente a saída antes de usar.`,
    ru: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Вы можете задать такие вопросы, как «${chatPrompt1}», «${chatPrompt2}», «${chatPrompt3}» и <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">больше</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> работает на основе искусственного интеллекта, поэтому возможны ошибки. Внимательно просмотрите выходные данные перед использованием.`,
    sm: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`E mafai ona e fesili atu i mea e pei o le "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", ma <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">sili atu</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> e fa'amalosia e AI, o lea e mafai ai ona faia ni mea sese. Iloilo ma le faaeteete le galuega faatino a o lei faaaogaina.`,
    so: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Waxaad weydiin kartaa waxyaabaha ay ka midka yihiin "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", iyo <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">hore</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> waxaa ku shaqeeya AI, sidaas darteed qaladaadku waa suurtogal. Dib u eegista saarka si taxadar leh ka hor inta aan la isticmaalin.`,
    th: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`คุณสามารถถามสิ่งต่างๆ เช่น "${chatPrompt1}" "${chatPrompt2}" "${chatPrompt3}" และ <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">อีก</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> ขับเคลื่อนโดย AI ดังนั้นจึงอาจเกิดข้อผิดพลาดได้ Review ผลลัพธ์อย่างระมัดระวังก่อนใช้งาน`,
    ur: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`آپ "${chatPrompt1} کریں"، "${chatPrompt2}"، "${chatPrompt3}" جیسی چیزیں پوچھ سکتے ہیں، اور <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">زیادہ</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> اے آئی کے ذریعہ چلایا جاتا ہے ، لہذا غلطیاں ممکن ہیں۔ استعمال سے پہلے آؤٹ پٹ کا احتیاط سے جائزہ لیں۔`,
    vi: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`Bạn có thể hỏi những thứ như "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", và <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">nhiều hơn</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> được hỗ trợ bởi AI, vì vậy có thể xảy ra sai lầm. Review đầu ra cẩn thận trước khi sử dụng.`,
    "zh-hans": (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`您可以询问诸如“${chatPrompt1}”、“${chatPrompt2}”、“${chatPrompt3}”等问题，以及 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">更多</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 由 AI 提供支持，因此可能会出现错误。使用前请仔细查看输出。`,
    "zh-hant": (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`您可以詢問諸如「${chatPrompt1}」、「${chatPrompt2}」、「${chatPrompt3}」等問題，以及 <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">更多</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> 由 AI 提供支援，因此可能會出現錯誤。使用前請仔細查看輸出。`,
    en: (chatPrompt1, chatPrompt2, chatPrompt3, cumulusAssistant)=>$2868cc1235412e16$var$html`You can ask things like "${chatPrompt1}", "${chatPrompt2}", "${chatPrompt3}", and <button class="btn-link" type="button" data-toggle-for="assistant-chat-prompt-menu">more</button>.<br><a href="/docs/assistant">${cumulusAssistant}</a> is powered by AI, so mistakes are possible. Review output carefully before use.`
};
const $2868cc1235412e16$export$db187209f2aa905e = {
    ar: `\u{625}\u{646}\u{634}\u{627}\u{621} \u{62A}\u{627}\u{631}\u{64A}\u{62E}`,
    de: `Erstellungsdatum`,
    es: `Fecha de creaci\xf3n`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}`,
    fil: `Email Address *`,
    fr: `Date de cr\xe9ation`,
    hi: `\u{924}\u{93E}\u{930}\u{940}\u{916} \u{92C}\u{928}\u{93E}\u{928}\u{93E}`,
    ht: `Dat kreye`,
    it: `Crea data`,
    ja: `\u{4F5C}\u{6210}\u{65E5}`,
    ko: `\u{B0A0}\u{C9DC} \u{B9CC}\u{B4E4}\u{AE30}`,
    mww: `Tsim hnub`,
    ps: `\u{646}\u{6CC}\u{67C}\u{647} \u{62C}\u{648}\u{693}\u{648}\u{644}`,
    pt: `Criar data`,
    "pt-pt": `Data de cria\xe7\xe3o`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{442}\u{44C} \u{434}\u{430}\u{442}\u{443}`,
    sm: `Fatu aso`,
    so: `In la abuuro taariikh`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}`,
    ur: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o ng\xe0y`,
    "zh-hans": `\u{521B}\u{5EFA}\u{65E5}\u{671F}`,
    "zh-hant": `\u{5275}\u{5EFA}\u{65E5}\u{671F}`,
    en: `Create date`
};
const $2868cc1235412e16$export$96e776fd723fc349 = {
    ar: `\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A}`,
    de: `Einfuhren`,
    es: `Importaciones`,
    fa: `\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A}`,
    fil: `Mga Pag-import`,
    fr: `Importations`,
    hi: `\u{906}\u{92F}\u{93E}\u{924}`,
    ht: `Enp\xf2tasyon`,
    it: `Importazioni`,
    ja: `\u{30A4}\u{30F3}\u{30DD}\u{30FC}\u{30C8}`,
    ko: `\u{AC00}\u{C838}\u{C635}\u{B2C8}\u{B2E4}`,
    mww: `Imports`,
    ps: `\u{648}\u{627}\u{631}\u{62F}\u{627}\u{62A}`,
    pt: `Importa\xe7\xf5es`,
    "pt-pt": `Importa\xe7\xf5es`,
    ru: `\u{418}\u{43C}\u{43F}\u{43E}\u{440}\u{442}`,
    sm: `Fa'aulufale mai`,
    so: `Soo-dejinta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E19}\u{E4D}\u{E32}\u{E40}\u{E02}\u{E49}\u{E32}`,
    ur: `\u{62F}\u{631}\u{622}\u{645}\u{62F}`,
    vi: `Nh\u{1EAD}p kh\u{1EA9}u`,
    "zh-hans": `\u{8FDB}\u{53E3}`,
    "zh-hant": `\u{9032}\u{53E3}`,
    en: `Imports`
};
const $2868cc1235412e16$export$436322b83076ec62 = {
    ar: `\u{627}\u{644}\u{62C}\u{62F}\u{648}\u{644} \u{627}\u{644}\u{632}\u{645}\u{646}\u{64A} \u{627}\u{644}\u{641}\u{627}\u{631}\u{63A} SCSEP`,
    de: `Leeres SCSEP-Zeitblatt`,
    es: `Hoja de horas SCSEP en blanco`,
    fa: `\u{628}\u{631}\u{6AF}\u{647} \u{632}\u{645}\u{627}\u{646}\u{6CC} \u{62E}\u{627}\u{644}\u{6CC} SCSEP`,
    fil: `Blangko SCSEP timesheet`,
    fr: `Feuille de temps SCSEP vierge`,
    hi: `\u{930}\u{93F}\u{915}\u{94D}\u{924} SCSEP \u{938}\u{92E}\u{92F} \u{92A}\u{924}\u{94D}\u{930}\u{915}`,
    ht: `Blank SCSEP timeshet`,
    it: `Scheda attivit\xe0 SCSEP vuota`,
    ja: `\u{7A7A}\u{767D}\u{306E} SCSEP \u{30BF}\u{30A4}\u{30E0}\u{30B7}\u{30FC}\u{30C8}`,
    ko: `\u{BE48} SCSEP \u{C791}\u{C5C5}\u{D45C}`,
    mww: `Blank SCSEP timesheet`,
    ps: `\u{62E}\u{627}\u{644}\u{6CC} SCSEP \u{648}\u{62E}\u{62A} \u{67E}\u{627}\u{6BC}\u{647}`,
    pt: `Quadro de hor\xe1rios SCSEP em branco`,
    "pt-pt": `Quadro de hor\xe1rios SCSEP em branco`,
    ru: `\u{41F}\u{443}\u{441}\u{442}\u{43E}\u{439} \u{442}\u{430}\u{431}\u{435}\u{43B}\u{44C} \u{443}\u{447}\u{435}\u{442}\u{430} \u{440}\u{430}\u{431}\u{43E}\u{447}\u{435}\u{433}\u{43E} \u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{438} SCSEP`,
    sm: `Avanoa SCSEP timesheet`,
    so: `Mareegaha SCSEP`,
    th: `\u{E44}\u{E17}\u{E21}\u{E4C}\u{E0A}\u{E35}\u{E17} SCSEP \u{E40}\u{E1B}\u{E25}\u{E48}\u{E32}`,
    ur: `\u{62E}\u{627}\u{644}\u{6CC} SCSEP \u{679}\u{627}\u{626}\u{645} \u{634}\u{6CC}\u{679}`,
    vi: `B\u{1EA3}ng ch\u{1EA5}m c\xf4ng SCSEP tr\u{1ED1}ng`,
    "zh-hans": `\u{7A7A}\u{767D} SCSEP \u{65F6}\u{95F4}\u{8868}`,
    "zh-hant": `\u{7A7A}\u{767D} SCSEP \u{6642}\u{7A0B}\u{8868}`,
    en: `Blank SCSEP timesheet`
};
const $2868cc1235412e16$export$41e323ff2c7efe95 = {
    ar: `\u{645}\u{641}\u{62A}\u{648}\u{62D}`,
    de: `Offen`,
    es: `Abrir`,
    fa: `\u{628}\u{627}\u{632}`,
    fil: `Buksan`,
    fr: `Ouvrir`,
    hi: `\u{916}\u{94B}\u{932}\u{928}\u{93E}`,
    ht: `Louvri`,
    it: `Aperto`,
    ja: `\u{958B}\u{3051}\u{308B}`,
    ko: `\u{C5F4}\u{B2E4}`,
    mww: `Qhib`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Abrir`,
    "pt-pt": `Aberto`,
    ru: `\u{41E}\u{442}\u{43A}\u{440}\u{44B}\u{442}\u{44B}\u{439}`,
    sm: `Tatala`,
    so: `Wuxuu furan yahay`,
    th: `\u{E40}\u{E1B}\u{E34}\u{E14}`,
    ur: `\u{6A9}\u{6BE}\u{648}\u{644}\u{646}\u{627}`,
    vi: `M\u{1EDF}`,
    "zh-hans": `\u{6253}\u{5F00}`,
    "zh-hant": `\u{6253}\u{958B}`,
    en: `Open`
};
const $2868cc1235412e16$export$acaa6c92d3a7e6ea = {
    ar: `\u{641}\u{631}\u{64A}\u{642}\u{646}\u{627}`,
    de: `Unser Team`,
    es: `Nuestro equipo`,
    fa: `\u{62A}\u{6CC}\u{645} \u{645}\u{627}`,
    fil: `Ang aming koponan`,
    fr: `Notre \xe9quipe`,
    hi: `\u{939}\u{92E}\u{93E}\u{930}\u{940} \u{91F}\u{940}\u{92E}`,
    ht: `Ekip nou an`,
    it: `Il nostro team`,
    ja: `\u{79C1}\u{305F}\u{3061}\u{306E}\u{30C1}\u{30FC}\u{30E0}`,
    ko: `\u{C6B0}\u{B9AC} \u{D300}`,
    mww: `Peb pab neeg no`,
    ps: `\u{632}\u{645}\u{648}\u{696} \u{67C}\u{6CC}\u{645}`,
    pt: `Nossa equipe`,
    "pt-pt": `A nossa equipa`,
    ru: `\u{41D}\u{430}\u{448}\u{430} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430}`,
    sm: `O la matou 'au`,
    so: `Our kooxda`,
    th: `\u{E17}\u{E35}\u{E21}\u{E07}\u{E32}\u{E19}\u{E02}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E32}`,
    ur: `\u{6C1}\u{645}\u{627}\u{631}\u{6CC} \u{679}\u{6CC}\u{645}`,
    vi: `\u{110}\u{1ED9}i ng\u{169} c\u{1EE7}a ch\xfang t\xf4i`,
    "zh-hans": `\u{6211}\u{4EEC}\u{7684}\u{56E2}\u{961F}`,
    "zh-hant": `\u{6211}\u{5011}\u{7684}\u{5718}\u{968A}`,
    en: `Our team`
};
const $2868cc1235412e16$export$48721beab27c0258 = {
    ar: `\u{644}\u{648}\u{62D}\u{627}\u{62A}`,
    de: `Armaturenbretter`,
    es: `Paneles`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}`,
    fil: `Mga Dashboard`,
    fr: `Tableaux`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921}\u{94D}\u{938}`,
    ht: `Tablodb\xf2`,
    it: `Dashboard`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5} \u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}`,
    mww: `Dashboards`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689}`,
    pt: `Pain\xe9is`,
    "pt-pt": `Pain\xe9is`,
    ru: `\u{41F}\u{430}\u{43D}\u{435}\u{43B}\u{438} \u{43C}\u{43E}\u{43D}\u{438}\u{442}\u{43E}\u{440}\u{438}\u{43D}\u{433}\u{430}`,
    sm: `Dashboard`,
    so: `Dashboards`,
    th: `\u{E41}\u{E14} \u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `Dashboards`,
    vi: `Dashboards`,
    "zh-hans": `\u{4EEA}\u{8868} \u{677F}`,
    "zh-hant": `\u{5100}\u{9336}\u{677F}`,
    en: `Dashboards`
};
const $2868cc1235412e16$export$440dea32dee3ec02 = {
    ar: `\u{634}\u{627}\u{647}\u{62F}\u{62A}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627}`,
    de: `Zuletzt von Ihnen angesehen`,
    es: `Visto recientemente por usted`,
    fa: `\u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Kamakailan lamang ay tiningnan mo`,
    fr: `R\xe9cemment consult\xe9 par vous`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{926}\u{947}\u{916}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `D\xe8ny\xe8man te konsidere pa ou`,
    it: `Visti di recente da te`,
    ja: `\u{3042}\u{306A}\u{305F}\u{304C}\u{6700}\u{8FD1}\u{95B2}\u{89A7}\u{3057}\u{305F}\u{30B3}\u{30F3}\u{30C6}\u{30F3}\u{30C4}`,
    ko: `\u{CD5C}\u{ADFC}\u{C5D0} \u{BCF8} \u{D56D}\u{BAA9}`,
    mww: `Tsis ntev los no saib los ntawm koj`,
    ps: `\u{627}\u{62E}\u{6CC}\u{631}\u{627}\u{64B} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    pt: `Visto recentemente por voc\xea`,
    "pt-pt": `Visualizado recentemente por voc\xea`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{44B}\u{435} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `Talu ai nei na e va'ai ai`,
    so: `Recently viewed by you`,
    th: `\u{E14}\u{E39}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}\u{E42}\u{E14}\u{E22}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{622}\u{67E} \u{646}\u{6D2} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{627}`,
    vi: `B\u{1EA1}n \u{111}\xe3 xem g\u{1EA7}n \u{111}\xe2y`,
    "zh-hans": `\u{60A8}\u{6700}\u{8FD1}\u{67E5}\u{770B}\u{8FC7}`,
    "zh-hant": `\u{60A8}\u{6700}\u{8FD1}\u{67E5}\u{770B}\u{904E}`,
    en: `Recently viewed by you`
};
const $2868cc1235412e16$export$67815b20c800fa3f = {
    ar: `\u{64A}\u{634}\u{627}\u{647}\u{62F}\u{647}\u{627} \u{628}\u{634}\u{643}\u{644} \u{645}\u{62A}\u{643}\u{631}\u{631} \u{645}\u{646} \u{642}\u{628}\u{644}\u{643}`,
    de: `H\xe4ufig von Ihnen angesehen`,
    es: `Visto con frecuencia por usted`,
    fa: `\u{627}\u{63A}\u{644}\u{628} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}`,
    fil: `Madalas mong panoorin`,
    fr: `Fr\xe9quemment consult\xe9 par vous`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{905}\u{915}\u{94D}\u{938}\u{930} \u{926}\u{947}\u{916}\u{93E} \u{91C}\u{93E}\u{924}\u{93E} \u{939}\u{948}`,
    ht: `Souvan w\xe8 pa ou`,
    it: `Visualizzati frequentemente da te`,
    ja: `\u{3042}\u{306A}\u{305F}\u{304C}\u{3088}\u{304F}\u{898B}\u{308B}\u{3082}\u{306E}`,
    ko: `\u{C790}\u{C8FC} \u{BCF4}\u{B294} \u{D56D}\u{BAA9}`,
    mww: `Feem ntau saib koj`,
    ps: `\u{627}\u{63A}\u{644}\u{628} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}`,
    pt: `Visualizado com frequ\xeancia por voc\xea`,
    "pt-pt": `Frequentemente visualizado por si`,
    ru: `\u{427}\u{430}\u{441}\u{442}\u{43E} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{430}\u{442}\u{440}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{412}\u{430}\u{43C}\u{438}`,
    sm: `E masani ona e va'ai i ai`,
    so: `Si joogta ah ayaad u aragtaa`,
    th: `\u{E04}\u{E38}\u{E13}\u{E14}\u{E39}\u{E1A}\u{E48}\u{E2D}\u{E22}`,
    ur: `\u{627}\u{6A9}\u{62B}\u{631} \u{622}\u{67E} \u{6A9}\u{6CC} \u{637}\u{631}\u{641} \u{633}\u{6D2} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{627} \u{62C}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2}`,
    vi: `B\u{1EA1}n th\u{1B0}\u{1EDD}ng xem`,
    "zh-hans": `\u{60A8}\u{7ECF}\u{5E38}\u{67E5}\u{770B}`,
    "zh-hant": `\u{60A8}\u{7D93}\u{5E38}\u{67E5}\u{770B}`,
    en: `Frequently viewed by you`
};
const $2868cc1235412e16$export$8740f991b7b1acd8 = {
    ar: (date)=>$2868cc1235412e16$var$html`شوهدت <span>${date}</span>`,
    de: (date)=>$2868cc1235412e16$var$html`Zuletzt angesehen <span>${date}</span>`,
    es: (date)=>$2868cc1235412e16$var$html`Visto <span>${date}</span>`,
    fa: (date)=>$2868cc1235412e16$var$html`مشاهده <span>${date}</span>`,
    fil: (date)=>$2868cc1235412e16$var$html`Tiningnan <span>${date}</span>`,
    fr: (date)=>$2868cc1235412e16$var$html`Consulté <span>${date}</span>`,
    hi: (date)=>$2868cc1235412e16$var$html`<span>${date}</span>`,
    ht: (date)=>$2868cc1235412e16$var$html`Gade <span>${date}</span>`,
    it: (date)=>$2868cc1235412e16$var$html`Visto <span>${date}</span>`,
    ja: (date)=>$2868cc1235412e16$var$html`<span>${date}閲覧</span>`,
    ko: (date)=>$2868cc1235412e16$var$html`조회일 <span>${date}</span>`,
    mww: (date)=>$2868cc1235412e16$var$html`Saib <span>${date}</span>`,
    ps: (date)=>$2868cc1235412e16$var$html`مشاهده <span>${date}</span>`,
    pt: (date)=>$2868cc1235412e16$var$html`Visto <span>${date}</span>`,
    "pt-pt": (date)=>$2868cc1235412e16$var$html`Visto <span>${date}</span>`,
    ru: (date)=>$2868cc1235412e16$var$html`Просмотрено <span>${date}</span>`,
    sm: (date)=>$2868cc1235412e16$var$html`Maimoaina <span>${date}</span>`,
    so: (date)=>$2868cc1235412e16$var$html`Viewed <span>${date}</span>`,
    th: (date)=>$2868cc1235412e16$var$html`ดูเมื่อ <span>${date}</span>`,
    ur: (date)=>$2868cc1235412e16$var$html`<span>${date}</span>`,
    vi: (date)=>$2868cc1235412e16$var$html`Đã xem <span>${date}</span>`,
    "zh-hans": (date)=>$2868cc1235412e16$var$html`浏览 <span>${date}</span>`,
    "zh-hant": (date)=>$2868cc1235412e16$var$html`流覽 <span>${date}</span>`,
    en: (date)=>$2868cc1235412e16$var$html`Viewed <span>${date}</span>`
};
const $2868cc1235412e16$export$882b48c7f78937db = {
    ar: `\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{624}\u{647} \u{645}\u{624}\u{62E}\u{631}\u{627} \u{628}\u{648}\u{627}\u{633}\u{637}\u{62A}\u{643}`,
    de: `K\xfcrzlich von Ihnen erstellt`,
    es: `Creado recientemente por ti`,
    fa: `\u{627}\u{62E}\u{6CC}\u{631}\u{627} \u{62A}\u{648}\u{633}\u{637} \u{634}\u{645}\u{627} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}`,
    fil: `Kamakailan lamang ay nilikha mo`,
    fr: `R\xe9cemment cr\xe9\xe9 par vous`,
    hi: `\u{939}\u{93E}\u{932} \u{939}\u{940} \u{92E}\u{947}\u{902} \u{906}\u{92A}\u{915}\u{947} \u{926}\u{94D}\u{935}\u{93E}\u{930}\u{93E} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `D\xe8ny\xe8man ki te kreye pa ou`,
    it: `Creato di recente da te`,
    ja: `\u{3042}\u{306A}\u{305F}\u{304C}\u{6700}\u{8FD1}\u{4F5C}\u{6210}\u{3057}\u{305F}\u{3082}\u{306E}`,
    ko: `\u{CD5C}\u{ADFC}\u{C5D0} \u{B0B4}\u{AC00} \u{B9CC}\u{B4E0} \u{ACBD}\u{C6B0}`,
    mww: `Tsis ntev los no tsim los ntawm koj`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{633}\u{62A}\u{627}\u{633}\u{648} \u{644}\u{62E}\u{648}\u{627} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}`,
    pt: `Criado recentemente por voc\xea`,
    "pt-pt": `Recentemente criado por si`,
    ru: `\u{41D}\u{435}\u{434}\u{430}\u{432}\u{43D}\u{43E} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{432}\u{430}\u{43C}\u{438}`,
    sm: `Faauta, sa ia lei faia ea mo oe se faataitaiga lelei?`,
    so: `Rely dhawaanahan idinka abuuray by`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E25}\u{E48}\u{E32}\u{E2A}\u{E38}\u{E14}\u{E42}\u{E14}\u{E22}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{62D}\u{627}\u{644} \u{6C1}\u{6CC} \u{645}\u{6CC}\u{6BA} \u{622}\u{67E} \u{6A9}\u{6D2} \u{630}\u{631}\u{6CC}\u{639}\u{6C1} \u{628}\u{646}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}`,
    vi: `B\u{1EA1}n t\u{1EA1}o g\u{1EA7}n \u{111}\xe2y`,
    "zh-hans": `\u{6700}\u{8FD1}\u{7531}\u{60A8}\u{521B}\u{5EFA}`,
    "zh-hant": `\u{6700}\u{8FD1}\u{7531}\u{60A8}\u{5275}\u{5EFA}`,
    en: `Recently created by you`
};
const $2868cc1235412e16$export$9244b719ec504ae6 = {
    ar: (date)=>$2868cc1235412e16$var$html`تم الإنشاؤه <span>${date}</span>`,
    de: (date)=>$2868cc1235412e16$var$html`Erstellt <span>${date}</span>`,
    es: (date)=>$2868cc1235412e16$var$html`Creado <span>${date}</span>`,
    fa: (date)=>$2868cc1235412e16$var$html`ایجاد <span>${date}</span>`,
    fil: (date)=>$2868cc1235412e16$var$html`Nilikha <span>${date}</span>`,
    fr: (date)=>$2868cc1235412e16$var$html`Créé <span>${date}</span>`,
    hi: (date)=>$2868cc1235412e16$var$html`<span>${date} बनाई गई</span>`,
    ht: (date)=>$2868cc1235412e16$var$html`Kreye <span>${date}</span>`,
    it: (date)=>$2868cc1235412e16$var$html`Creato <span>${date}</span>`,
    ja: (date)=>$2868cc1235412e16$var$html`<span>${date}作成</span>`,
    ko: (date)=>$2868cc1235412e16$var$html`최신 <span>${date}</span>`,
    mww: (date)=>$2868cc1235412e16$var$html`Tsim <span>${date}</span>`,
    ps: (date)=>$2868cc1235412e16$var$html`ایجاد <span>${date}</span>`,
    pt: (date)=>$2868cc1235412e16$var$html`Criado <span>${date}</span>`,
    "pt-pt": (date)=>$2868cc1235412e16$var$html`Criado <span>${date}</span>`,
    ru: (date)=>$2868cc1235412e16$var$html`Создано <span>${date}</span>`,
    sm: (date)=>$2868cc1235412e16$var$html`Foafoaina <span>${date}</span>`,
    so: (date)=>$2868cc1235412e16$var$html`Created <span>${date}</span>`,
    th: (date)=>$2868cc1235412e16$var$html`สร้างเมื่อ <span>${date}</span>`,
    ur: (date)=>$2868cc1235412e16$var$html`<span>${date}</span>`,
    vi: (date)=>$2868cc1235412e16$var$html`Đã tạo <span>${date}</span>`,
    "zh-hans": (date)=>$2868cc1235412e16$var$html`创建 <span>${date}</span>`,
    "zh-hant": (date)=>$2868cc1235412e16$var$html`創建 <span>${date}</span>`,
    en: (date)=>$2868cc1235412e16$var$html`Created <span>${date}</span>`
};
const $2868cc1235412e16$export$a368b07bc550762f = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{627}\u{647}\u{62F}\u{629} \u{627}\u{644}\u{645}\u{62A}\u{643}\u{631}\u{631}\u{629}`,
    de: `H\xe4ufig angesehen`,
    es: `Visto con frecuencia`,
    fa: `\u{627}\u{63A}\u{644}\u{628} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{647} \u{645}\u{6CC} \u{634}\u{648}\u{62F}`,
    fil: `Madalas na tiningnan`,
    fr: `Consult\xe9 fr\xe9quemment`,
    hi: `\u{905}\u{915}\u{94D}\u{938}\u{930} \u{926}\u{947}\u{916}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Souvan w\xe8`,
    it: `Visti di frequente`,
    ja: `\u{3088}\u{304F}\u{898B}\u{3089}\u{308C}\u{308B}`,
    ko: `\u{C790}\u{C8FC} \u{BCF4}\u{B294} \u{D654}\u{BA74}`,
    mww: `Feem ntau saib`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{6D0} \u{62F} \u{6A9}\u{631}`,
    pt: `Visualizado com frequ\xeancia`,
    "pt-pt": `Visualizados com frequ\xeancia`,
    ru: `\u{427}\u{430}\u{441}\u{442}\u{43E} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{430}\u{442}\u{440}\u{438}\u{432}\u{430}\u{435}\u{43C}\u{44B}\u{435}`,
    sm: `E masani ona va'aia`,
    so: `Badanaa la arki karo`,
    th: `\u{E14}\u{E39}\u{E1A}\u{E48}\u{E2D}\u{E22}`,
    ur: `\u{627}\u{6A9}\u{62B}\u{631} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{627} \u{62C}\u{627}\u{62A}\u{627} \u{6C1}\u{6D2}`,
    vi: `Th\u{1B0}\u{1EDD}ng xem`,
    "zh-hans": `\u{7ECF}\u{5E38}\u{67E5}\u{770B}`,
    "zh-hant": `\u{7D93}\u{5E38}\u{67E5}\u{770B}`,
    en: `Frequently viewed`
};
const $2868cc1235412e16$export$a3f3aa51d56b0179 = {
    ar: (count)=>`${count} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{627}\u{62A} \u{627}\u{644}\u{634}\u{647}\u{631} \u{627}\u{644}\u{645}\u{627}\u{636}\u{64A}`,
    de: (count)=>`${count} Aufrufe im letzten Monat`,
    es: (count)=>`${count} vistas el mes pasado`,
    fa: (count)=>`${count} \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{645}\u{627}\u{647} \u{6AF}\u{630}\u{634}\u{62A}\u{647}`,
    fil: (count)=>`${count} views nakaraang buwan`,
    fr: (count)=>`${count} vues le mois dernier`,
    hi: (count)=>`${count} \u{935}\u{93F}\u{91A}\u{93E}\u{930}\u{94B}\u{902} \u{92A}\u{93F}\u{91B}\u{932}\u{947} \u{92E}\u{939}\u{940}\u{928}\u{947}`,
    ht: (count)=>`${count} opinyon mwa ki sot pase yo`,
    it: (count)=>`${count} visualizzazioni il mese scorso`,
    ja: (count)=>`${count} \u{30D3}\u{30E5}\u{30FC} \u{904E}\u{53BB} 1 \u{304B}\u{6708}`,
    ko: (count)=>`\u{C870}\u{D68C}\u{C218} ${count} \u{C9C0}\u{B09C} \u{B2EC}`,
    mww: (count)=>`${count} views lub hli tas los`,
    ps: (count)=>`${count} \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{62A}\u{6CC}\u{631}\u{647} \u{645}\u{6CC}\u{627}\u{634}\u{62A}`,
    pt: (count)=>`${count} visualiza\xe7\xf5es no m\xeas passado`,
    "pt-pt": (count)=>`${count} visualiza\xe7\xf5es no m\xeas passado`,
    ru: (count)=>`${count} \u{437}\u{430} \u{43F}\u{440}\u{43E}\u{448}\u{43B}\u{44B}\u{439} \u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    sm: (count)=>`${count} manatu i le masina talu ai`,
    so: (count)=>`${count} views bishii la soo dhaafay`,
    th: (count)=>`${count} views \u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E21}\u{E32}`,
    ur: (count)=>`\u{6AF}\u{632}\u{634}\u{62A}\u{6C1} \u{645}\u{627}\u{6C1} ${count} \u{628}\u{627}\u{631} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: (count)=>`${count} l\u{1B0}\u{1EE3}t xem th\xe1ng qua`,
    "zh-hans": (count)=>`\u{8FC7}\u{53BB}\u{4E00}\u{4E2A}\u{6708}\u{6709} ${count} \u{6B21}\u{6D4F}\u{89C8}`,
    "zh-hant": (count)=>`\u{904E}\u{53BB}\u{4E00}\u{500B}\u{6708}\u{6709} ${count} \u{6B21}\u{6D41}\u{89BD}`,
    en: (count)=>`${count} views past month`
};
const $2868cc1235412e16$export$27a0f09f35c8868f = {
    ar: (date, user)=>$2868cc1235412e16$var$html`<span>تم إنشاؤه ${date} بواسطة ${user}</span>`,
    de: (date, user)=>$2868cc1235412e16$var$html`<span>Erstellt ${date} von ${user}</span>`,
    es: (date, user)=>$2868cc1235412e16$var$html`<span>Creado ${date} por ${user}</span>`,
    fa: (date, user)=>$2868cc1235412e16$var$html`<span>ایجاد ${date} توسط ${user}</span>`,
    fil: (date, user)=>$2868cc1235412e16$var$html`<span>Nilikha 5 ${date} sa pamamagitan ng ${user}</span>`,
    fr: (date, user)=>$2868cc1235412e16$var$html`<span>Créé ${date} par ${user}</span>`,
    hi: (date, user)=>$2868cc1235412e16$var$html`<span>5 ${date} जॉन ${user} द्वारा बनाया गया</span>`,
    ht: (date, user)=>$2868cc1235412e16$var$html`<span>Kreye ${date} sa pa ${user}</span>`,
    it: (date, user)=>$2868cc1235412e16$var$html`<span>Creato ${date} da ${user}</span>`,
    ja: (date, user)=>$2868cc1235412e16$var$html`<span>${date} ${user} によって作成されました</span>`,
    ko: (date, user)=>$2868cc1235412e16$var$html`<span>만든 ${date} ${user}가</span>`,
    mww: (date, user)=>$2868cc1235412e16$var$html`<span>Tsim ${date} los ntawm ${user}</span>`,
    ps: (date, user)=>$2868cc1235412e16$var$html`<span>ایجاد ${date} ${user}</span>`,
    pt: (date, user)=>$2868cc1235412e16$var$html`<span>Criado ${date} por ${user}</span>`,
    "pt-pt": (date, user)=>$2868cc1235412e16$var$html`<span>Criado ${date} por ${user}</span>`,
    ru: (date, user)=>$2868cc1235412e16$var$html`<span>Создано ${date} ${user}</span>`,
    sm: (date, user)=>$2868cc1235412e16$var$html`<span>Faia 5 ${date} e ${user}</span>`,
    so: (date, user)=>$2868cc1235412e16$var$html`<span>Waxaa la abuuray ${date} ${user}</span>`,
    th: (date, user)=>$2868cc1235412e16$var$html`<span>สร้างเมื่อ ${date} โดย ${user}</span>`,
    ur: (user, date)=>$2868cc1235412e16$var$html`<span>${user} کی طرف سے ${date} تخلیق کیا گیا</span>`,
    vi: (date, user)=>$2868cc1235412e16$var$html`<span>Được tạo 5 ${date} bởi ${user}</span>`,
    "zh-hans": (user, date)=>$2868cc1235412e16$var$html`<span>由 ${user} 于 ${date} 创建</span>`,
    "zh-hant": (user, date)=>$2868cc1235412e16$var$html`<span>由 ${user} 於 ${date} 創建</span>`,
    en: (date, user)=>$2868cc1235412e16$var$html`<span>Created ${date} by ${user}</span>`
};
const $2868cc1235412e16$export$e2af1ceb767bc9f2 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{621} \u{623}\u{64A} \u{644}\u{648}\u{62D}\u{627}\u{62A} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62D}\u{62A}\u{649} \u{627}\u{644}\u{622}\u{646}.`,
    de: `Es wurden noch keine Dashboards erstellt.`,
    es: `Todav\xeda no se han creado paneles.`,
    fa: `\u{647}\u{646}\u{648}\u{632} \u{647}\u{6CC}\u{686} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{6CC} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Wala pang mga dashboard na nilikha.`,
    fr: `Aucun tableau de bord n\u{2019}a encore \xe9t\xe9 cr\xe9\xe9.`,
    hi: `\u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{94B}\u{908} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{928}\u{939}\u{940}\u{902} \u{92C}\u{928}\u{93E}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}.`,
    ht: `Pa gen tablodb\xf2 ki te kreye ank\xf2.`,
    it: `Non \xe8 stata ancora creata alcuna dashboard.`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{306F}\u{307E}\u{3060}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{B294} \u{C544}\u{C9C1} \u{B9CC}\u{B4E4}\u{C5B4}\u{C9C0}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj dashboards muaj tau tsim tsis tau.`,
    ps: `\u{644}\u{627} \u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{647}\u{6CC}\u{685} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{689} \u{646}\u{647} \u{62F}\u{6CC} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}.`,
    pt: `Nenhum painel foi criado ainda.`,
    "pt-pt": `Nenhum painel foi criado ainda.`,
    ru: `\u{414}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}\u{44B} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{44B}.`,
    sm: `E le'i faia ni dashboard i le taimi nei.`,
    so: `Lama abuurin boorar la sameeyay weli.`,
    th: `\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{648}\u{626}\u{6CC} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{628}\u{646}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ch\u{1B0}a c\xf3 b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n n\xe0o \u{111}\u{1B0}\u{1EE3}c t\u{1EA1}o.`,
    "zh-hans": `\u{5C1A}\u{672A}\u{521B}\u{5EFA}\u{4EFB}\u{4F55}\u{63A7}\u{5236}\u{9762}\u{677F}\u{3002}`,
    "zh-hant": `\u{5C1A}\u{672A}\u{5275}\u{5EFA}\u{4EFB}\u{4F55}\u{63A7}\u{5236}\u{9762}\u{677F}\u{3002}`,
    en: `No dashboards have been created yet.`
};
const $2868cc1235412e16$export$74bd8576c7833637 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{625}\u{646}\u{634}\u{627}\u{621} \u{623}\u{64A} \u{62A}\u{642}\u{627}\u{631}\u{64A}\u{631} \u{628}\u{639}\u{62F}.`,
    de: `Es wurden noch keine Berichte erstellt.`,
    es: `Todav\xeda no se ha creado ning\xfan informe.`,
    fa: `\u{647}\u{646}\u{648}\u{632} \u{647}\u{6CC}\u{686} \u{6AF}\u{632}\u{627}\u{631}\u{634}\u{6CC} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Wala pang mga ulat na nabuo.`,
    fr: `Aucun rapport n\u{2019}a encore \xe9t\xe9 cr\xe9\xe9.`,
    hi: `\u{905}\u{92D}\u{940} \u{924}\u{915} \u{915}\u{94B}\u{908} \u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{928}\u{939}\u{940}\u{902} \u{92C}\u{928}\u{93E}\u{908} \u{917}\u{908} \u{939}\u{948}\u{964}`,
    ht: `Pat gen rap\xf2 ki te kreye ank\xf2.`,
    it: `Non sono ancora stati creati report.`,
    ja: `\u{30EC}\u{30DD}\u{30FC}\u{30C8}\u{306F}\u{307E}\u{3060}\u{4F5C}\u{6210}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{C544}\u{C9C1} \u{C0DD}\u{C131}\u{B41C} \u{BCF4}\u{ACE0}\u{C11C}\u{AC00} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj ntaub ntawv muaj tau tsim tsis tau.`,
    ps: `\u{62A}\u{631} \u{627}\u{648}\u{633}\u{647} \u{6A9}\u{648}\u{645} \u{631}\u{627}\u{67E}\u{648}\u{631} \u{646}\u{647} \u{62F}\u{6CC} \u{62C}\u{648}\u{693} \u{634}\u{648}\u{6CC}.`,
    pt: `Nenhum relat\xf3rio foi criado ainda.`,
    "pt-pt": `Ainda n\xe3o foram criados relat\xf3rios.`,
    ru: `\u{41E}\u{442}\u{447}\u{435}\u{442}\u{44B} \u{435}\u{449}\u{435} \u{43D}\u{435} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{44B}.`,
    sm: `E le'i faia ni lipoti i le taimi nei.`,
    so: `Wax war ah wali kama soo bixin.`,
    th: `\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{627}\u{628}\u{6BE}\u{6CC} \u{62A}\u{6A9} \u{6A9}\u{648}\u{626}\u{6CC} \u{631}\u{67E}\u{648}\u{631}\u{679} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{628}\u{646}\u{627}\u{626}\u{6CC} \u{6AF}\u{626}\u{6CC} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Ch\u{1B0}a c\xf3 b\xe1o c\xe1o n\xe0o \u{111}\u{1B0}\u{1EE3}c t\u{1EA1}o.`,
    "zh-hans": `\u{5C1A}\u{672A}\u{521B}\u{5EFA}\u{4EFB}\u{4F55}\u{62A5}\u{8868}\u{3002}`,
    "zh-hant": `\u{5C1A}\u{672A}\u{5275}\u{5EFA}\u{4EFB}\u{4F55}\u{5831}\u{8868}\u{3002}`,
    en: `No reports have been created yet.`
};
const $2868cc1235412e16$export$73296539e54235cd = {
    ar: `\u{644}\u{648}\u{62D}\u{629} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{62C}\u{62F}\u{64A}\u{62F}\u{629}`,
    de: `Neues Dashboard`,
    es: `Nuevo panel de control`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong dashboard`,
    fr: `Nouveau tableau de bord`,
    hi: `\u{928}\u{92F}\u{93E} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921}`,
    ht: `Nouvo tablodb\xf2`,
    it: `Nuova dashboard`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{C0C8} \u{B300}\u{C2DC}\u{BCF4}\u{B4DC}`,
    mww: `dashboard tshiab`,
    ps: `\u{646}\u{648}\u{6CC} \u{689}\u{634}\u{628}\u{648}\u{631}\u{689}`,
    pt: `Novo painel`,
    "pt-pt": `Novo painel`,
    ru: `\u{41D}\u{43E}\u{432}\u{430}\u{44F} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`,
    sm: `Dashboard fou`,
    so: `Dashboard New`,
    th: `\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{6CC}\u{627} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688}`,
    vi: `B\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n m\u{1EDB}i`,
    "zh-hans": `\u{65B0}\u{4EEA}\u{8868}\u{677F}`,
    "zh-hant": `\u{65B0}\u{5100}\u{9336}\u{677F}`,
    en: `New dashboard`
};
const $2868cc1235412e16$export$c68bdfe37180f9da = {
    ar: `\u{62A}\u{642}\u{631}\u{64A}\u{631} \u{62C}\u{62F}\u{64A}\u{62F}`,
    de: `Neuer Bericht`,
    es: `Nuevo informe`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634} \u{62C}\u{62F}\u{6CC}\u{62F}`,
    fil: `Bagong ulat`,
    fr: `Nouveau rapport`,
    hi: `\u{928}\u{908} \u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: `Nouvo rap\xf2`,
    it: `Nuovo rapporto`,
    ja: `\u{65B0}\u{3057}\u{3044}\u{30EC}\u{30DD}\u{30FC}\u{30C8}`,
    ko: `\u{C0C8} \u{BCF4}\u{ACE0}\u{C11C}`,
    mww: `Daim ntawv qhia tshiab`,
    ps: `\u{646}\u{648}\u{6CC} \u{631}\u{67E}\u{648}\u{631}\u{67C}`,
    pt: `Novo relat\xf3rio`,
    "pt-pt": `Novo relat\xf3rio`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{439} \u{43E}\u{442}\u{447}\u{435}\u{442}`,
    sm: `Lipoti fou`,
    so: `Warbixin cusub`,
    th: `\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}\u{E43}\u{E2B}\u{E21}\u{E48}`,
    ur: `\u{646}\u{626}\u{6CC} \u{631}\u{67E}\u{648}\u{631}\u{679}`,
    vi: `B\xe1o c\xe1o m\u{1EDB}i`,
    "zh-hans": `\u{65B0}\u{62A5}\u{544A}`,
    "zh-hant": `\u{65B0}\u{5831}\u{544A}`,
    en: `New report`
};
const $2868cc1235412e16$export$5d8f4ce75feb8c2f = {
    ar: `\u{62A}\u{635}\u{641}\u{64A}\u{629} \u{644}\u{648}\u{62D}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Filtern von Dashboards`,
    es: `Filtrar paneles`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}\u{647}\u{627}\u{6CC} \u{641}\u{6CC}\u{644}\u{62A}\u{631}`,
    fil: `I-filter ang mga dashboard`,
    fr: `Filtrer les tableaux de bord`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Tablodb\xf2 filtre`,
    it: `Filtrare i dashboard`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{306E}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30EA}\u{30F3}\u{30B0}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC} \u{D544}\u{D130}\u{B9C1}`,
    mww: `Filter dashboards`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{641}\u{644}\u{67C}\u{631}`,
    pt: `Filtrar pain\xe9is`,
    "pt-pt": `Filtrar pain\xe9is`,
    ru: `\u{424}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{435}\u{439} \u{43C}\u{43E}\u{43D}\u{438}\u{442}\u{43E}\u{440}\u{438}\u{43D}\u{433}\u{430}`,
    sm: `Faamama dashboards`,
    so: `Filter dashboards`,
    th: `\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E15}\u{E31}\u{E27}\u{E01}\u{E23}\u{E2D}\u{E07}`,
    ur: `Filter dashboards`,
    vi: `B\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n l\u{1ECD}c`,
    "zh-hans": `\u{7B5B}\u{9009}\u{4EEA}\u{8868}\u{677F}`,
    "zh-hant": `\u{7BE9}\u{9078}\u{5100}\u{9336}\u{677F}`,
    en: `Filter dashboards`
};
const $2868cc1235412e16$export$e21476f0b13ef471 = {
    ar: `\u{62A}\u{635}\u{641}\u{64A}\u{629} \u{627}\u{644}\u{62A}\u{642}\u{627}\u{631}\u{64A}\u{631}`,
    de: `Filtern von Berichten`,
    es: `Filtrar informes`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634} \u{647}\u{627} \u{631}\u{627} \u{641}\u{6CC}\u{644}\u{62A}\u{631} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-filter ang mga ulat`,
    fr: `Filtrer les rapports`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{92B}\u{93C}\u{93F}\u{932}\u{94D}\u{91F}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Rap\xf2 filtre`,
    it: `Filtrare i rapporti`,
    ja: `\u{30EC}\u{30DD}\u{30FC}\u{30C8}\u{306E}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30EA}\u{30F3}\u{30B0}`,
    ko: `\u{BCF4}\u{ACE0}\u{C11C} \u{D544}\u{D130}\u{B9C1}`,
    mww: `Filter ntaub ntawv qhia txog`,
    ps: `\u{62F} \u{631}\u{627}\u{67E}\u{648}\u{631}\u{648}\u{646}\u{648} \u{641}\u{644}\u{67C}\u{631} \u{6A9}\u{648}\u{644}`,
    pt: `Filtrar relat\xf3rios`,
    "pt-pt": `Filtrar relat\xf3rios`,
    ru: `\u{424}\u{438}\u{43B}\u{44C}\u{442}\u{440}\u{430}\u{446}\u{438}\u{44F} \u{43E}\u{442}\u{447}\u{435}\u{442}\u{43E}\u{432}`,
    sm: `Faamama lipoti`,
    so: `Warbixinnada Filter`,
    th: `\u{E01}\u{E23}\u{E2D}\u{E07}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{641}\u{644}\u{679}\u{631} \u{631}\u{67E}\u{648}\u{631}\u{679}\u{633}`,
    vi: `L\u{1ECD}c b\xe1o c\xe1o`,
    "zh-hans": `\u{7B5B}\u{9009}\u{62A5}\u{8868}`,
    "zh-hant": `\u{7BE9}\u{9078}\u{5831}\u{8868}`,
    en: `Filter reports`
};
const $2868cc1235412e16$export$b3813783e354bd5f = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{646}\u{62A}\u{627}\u{626}\u{62C}`,
    de: `Keine Ergebnisse gefunden`,
    es: `No se han encontrado resultados`,
    fa: `\u{647}\u{6CC}\u{686} \u{646}\u{62A}\u{6CC}\u{62C}\u{647} \u{627}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F}`,
    fil: `Walang natagpuang resulta`,
    fr: `Aucun r\xe9sultat trouv\xe9`,
    hi: `\u{915}\u{94B}\u{908} \u{92A}\u{930}\u{93F}\u{923}\u{93E}\u{92E} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa gen rezilta yo te jwenn`,
    it: `Nessun risultato trovato`,
    ja: `\u{7D50}\u{679C}\u{304C}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{ACB0}\u{ACFC}\u{B97C} \u{CC3E}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis tau pom muaj`,
    ps: `\u{647}\u{6CC}\u{685} \u{67E}\u{627}\u{6CC}\u{644}\u{647} \u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}\u{647}`,
    pt: `Nenhum resultado encontrado`,
    "pt-pt": `Nenhum resultado encontrado`,
    ru: `\u{41D}\u{438}\u{447}\u{435}\u{433}\u{43E} \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{43E}`,
    sm: `E leai ni taunuuga na maua`,
    so: `Natiijada lama helin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E1C}\u{E25}\u{E25}\u{E31}\u{E1E}\u{E18}\u{E4C}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{646}\u{62A}\u{6CC}\u{62C}\u{6C1} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{645}\u{644}\u{627}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y k\u{1EBF}t qu\u{1EA3}`,
    "zh-hans": `\u{672A}\u{627E}\u{5230}\u{7ED3}\u{679C}`,
    "zh-hant": `\u{672A}\u{627E}\u{5230}\u{7D50}\u{679C}`,
    en: `No results found`
};
const $2868cc1235412e16$export$4f97e0fce8f146d7 = {
    ar: `\u{627}\u{62E}\u{62A}\u{631} \u{646}\u{648}\u{639} \u{627}\u{644}\u{62A}\u{642}\u{631}\u{64A}\u{631}`,
    de: `W\xe4hlen Sie den Berichtstyp`,
    es: `Elegir el tipo de informe`,
    fa: `\u{646}\u{648}\u{639} \u{6AF}\u{632}\u{627}\u{631}\u{634} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Pumili ng uri ng ulat`,
    fr: `Choisir le type de rapport`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F} \u{92A}\u{94D}\u{930}\u{915}\u{93E}\u{930} \u{91A}\u{941}\u{928}\u{947}\u{902}`,
    ht: `Chwazi kalite rap\xf2`,
    it: `Scegli il tipo di rapporto`,
    ja: `\u{30EC}\u{30DD}\u{30FC}\u{30C8}\u{306E}\u{7A2E}\u{985E}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{BCF4}\u{ACE0}\u{C11C} \u{C720}\u{D615} \u{C120}\u{D0DD}`,
    mww: `Xaiv daim ntawv qhia txog hom kev xaiv`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Escolher tipo de relat\xf3rio`,
    "pt-pt": `Escolher tipo de relat\xf3rio`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{442}\u{438}\u{43F} \u{43E}\u{442}\u{447}\u{435}\u{442}\u{430}`,
    sm: `Filifili le ituaiga lipoti`,
    so: `Dooro nooca warbixinta`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{631}\u{67E}\u{648}\u{631}\u{679} \u{6A9}\u{6CC} \u{642}\u{633}\u{645} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n lo\u{1EA1}i b\xe1o c\xe1o`,
    "zh-hans": `\u{9009}\u{62E9}\u{62A5}\u{544A}\u{7C7B}\u{578B}`,
    "zh-hant": `\u{9078}\u{64C7}\u{5831}\u{544A}\u{985E}\u{578B}`,
    en: `Choose report type`
};
const $2868cc1235412e16$export$1465cd6a5dc70bb9 = {
    ar: `\u{645}\u{646}\u{638}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639}`,
    de: `Projektorganisationen`,
    es: `Organizaciones del proyecto`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Mga organisasyon ng proyekto`,
    fr: `Organisations de projet`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon pwoj\xe8 yo`,
    it: `Organizzazioni del progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{7D44}\u{7E54}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{C870}\u{C9C1}`,
    mww: `Tej koom haum hauv lub koom haum`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647}`,
    pt: `Organiza\xe7\xf5es do projeto`,
    "pt-pt": `Organiza\xe7\xf5es do projeto`,
    ru: `\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{43D}\u{44B}\u{435} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Fa'alapotopotoga o Poloketi`,
    so: `Ururada mashruuca`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA}`,
    vi: `T\u{1ED5} ch\u{1EE9}c d\u{1EF1} \xe1n`,
    "zh-hans": `\u{9879}\u{76EE}\u{7EC4}\u{7EC7}`,
    "zh-hant": `\u{9805}\u{76EE}\u{7D44}\u{7E54}`,
    en: `Project organizations`
};
const $2868cc1235412e16$export$875c8af227bd90db = {
    ar: `\u{623}\u{639}\u{636}\u{627}\u{621} \u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{629}`,
    de: `Mitglieder der Organisation`,
    es: `Miembros de la organizaci\xf3n`,
    fa: `\u{627}\u{639}\u{636}\u{627}\u{6CC} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Mga miyembro ng organisasyon`,
    fr: `Membres de l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}`,
    ht: `manm \xf2ganizasyon yo`,
    it: `Membri dell'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}`,
    ko: `\u{C870}\u{C9C1} \u{AD6C}\u{C131}\u{C6D0}`,
    mww: `Koom haum`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC}`,
    pt: `Membros da organiza\xe7\xe3o`,
    "pt-pt": `Membros da organiza\xe7\xe3o`,
    ru: `\u{427}\u{43B}\u{435}\u{43D}\u{44B} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Sui o le faalapotopotoga`,
    so: `xubnaha ururka`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{627}\u{631}\u{6A9}\u{627}\u{646}`,
    vi: `Th\xe0nh vi\xean t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{7EC4}\u{7EC7}\u{6210}\u{5458}`,
    "zh-hant": `\u{7D44}\u{7E54}\u{6210}\u{54E1}`,
    en: `Organization members`
};
const $2868cc1235412e16$export$2a505cf562ed1f0f = {
    ar: `\u{62A}\u{646}\u{638}\u{64A}\u{645} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639}`,
    de: `Projektorganisation`,
    es: `Organizaci\xf3n del proyecto`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{62F}\u{647}\u{6CC} \u{67E}\u{631}\u{648}\u{698}\u{647}`,
    fil: `Organisasyon ng proyekto`,
    fr: `Organisation du projet`,
    hi: `\u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{938}\u{902}\u{917}\u{920}\u{928}`,
    ht: `\xd2ganizasyon pwoj\xe8`,
    it: `Organizzazione del progetto`,
    ja: `\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{7D44}\u{7E54}`,
    ko: `\u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{AD6C}\u{C131}`,
    mww: `Koom tes nrog peb tes num`,
    ps: `\u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    pt: `Organiza\xe7\xe3o do projeto`,
    "pt-pt": `Organiza\xe7\xe3o do projeto`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}`,
    sm: `Fa'alapotopotoga o poloketi`,
    so: `urur Mashruuca`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{645}\u{646}\u{635}\u{648}\u{628}\u{6D2} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645}`,
    vi: `T\u{1ED5} ch\u{1EE9}c d\u{1EF1} \xe1n`,
    "zh-hans": `\u{9879}\u{76EE}\u{7EC4}\u{7EC7}`,
    "zh-hant": `\u{9805}\u{76EE}\u{7D44}\u{7E54}`,
    en: `Project organization`
};
const $2868cc1235412e16$export$8e4ca99cc58f6f3e = {
    ar: `\u{633}\u{62C}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{646}\u{634}\u{627}\u{637}\u{60C} \u{628}\u{627}\u{644}\u{625}\u{636}\u{627}\u{641}\u{629} \u{625}\u{644}\u{649} \u{627}\u{644}\u{62A}\u{631}\u{643}\u{64A}\u{628}\u{629} \u{627}\u{644}\u{633}\u{643}\u{627}\u{646}\u{64A}\u{629} \u{644}\u{644}\u{634}\u{62E}\u{635} \u{627}\u{644}\u{645}\u{631}\u{62A}\u{628}\u{637} \u{648}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{627}\u{62A}\u{635}\u{627}\u{644}.`,
    de: `Aktivit\xe4tsdatens\xe4tze zusammen mit den demografischen Daten und Kontaktinformationen der zugeordneten Person.`,
    es: `Registros de actividad, junto con los datos demogr\xe1ficos y la informaci\xf3n de contacto de la persona asociada.`,
    fa: `\u{633}\u{648}\u{627}\u{628}\u{642} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A}\u{60C} \u{628}\u{647} \u{647}\u{645}\u{631}\u{627}\u{647} \u{627}\u{637}\u{644}\u{627}\u{639}\u{627}\u{62A} \u{62C}\u{645}\u{639}\u{6CC}\u{62A}\u{6CC} \u{648} \u{62A}\u{645}\u{627}\u{633} \u{634}\u{62E}\u{635} \u{645}\u{631}\u{62A}\u{628}\u{637}.`,
    fil: `Mga talaan ng aktibidad, kasama ang demograpiko at impormasyon sa pakikipag-ugnay ng nauugnay na tao.`,
    fr: `Enregistrements d\u{2019}activit\xe9, ainsi que les donn\xe9es d\xe9mographiques et les coordonn\xe9es de la personne associ\xe9e.`,
    hi: `\u{917}\u{924}\u{93F}\u{935}\u{93F}\u{927}\u{93F} \u{930}\u{93F}\u{915}\u{949}\u{930}\u{94D}\u{921}, \u{938}\u{902}\u{92C}\u{926}\u{94D}\u{927} \u{935}\u{94D}\u{92F}\u{915}\u{94D}\u{924}\u{93F} \u{915}\u{940} \u{91C}\u{928}\u{938}\u{93E}\u{902}\u{916}\u{94D}\u{92F}\u{93F}\u{915}\u{940} \u{914}\u{930} \u{938}\u{902}\u{92A}\u{930}\u{94D}\u{915} \u{91C}\u{93E}\u{928}\u{915}\u{93E}\u{930}\u{940} \u{915}\u{947} \u{938}\u{93E}\u{925}\u{964}`,
    ht: `Dosye aktivite, ansanm ak demografik moun ki asosye ak enf\xf2masyon pou kontakte.`,
    it: `Record di attivit\xe0, insieme ai dati demografici e alle informazioni di contatto della persona associata.`,
    ja: `\u{6D3B}\u{52D5}\u{8A18}\u{9332}\u{3068}\u{3001}\u{95A2}\u{9023}\u{4ED8}\u{3051}\u{3089}\u{308C}\u{305F}\u{500B}\u{4EBA}\u{306E}\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{304A}\u{3088}\u{3073}\u{9023}\u{7D61}\u{5148}\u{60C5}\u{5831}\u{3002}`,
    ko: `\u{D65C}\u{B3D9} \u{AE30}\u{B85D}, \u{AD00}\u{B828} \u{AC1C}\u{C778}\u{C758} \u{C778}\u{AD6C} \u{D1B5}\u{ACC4} \u{BC0F} \u{C5F0}\u{B77D}\u{CC98} \u{C815}\u{BCF4}\u{C640} \u{D568}\u{AED8}.`,
    mww: `Cov ntaub ntawv, nrog rau tus neeg ntawd demographics thiab hu rau cov ntaub ntawv.`,
    ps: `\u{62F} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{689}\u{60C} \u{633}\u{631}\u{647} \u{62F} \u{627}\u{693}\u{648}\u{646}\u{62F} \u{634}\u{62E}\u{635} \u{689}\u{6CC}\u{645}\u{648}\u{6AB}\u{631}\u{627}\u{641}\u{6CC}\u{6A9} \u{627}\u{648} \u{62F} \u{627}\u{693}\u{6CC}\u{6A9}\u{648} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}.`,
    pt: `Registros de atividades, juntamente com dados demogr\xe1ficos e informa\xe7\xf5es de contato da pessoa associada.`,
    "pt-pt": `Registos de atividade, juntamente com dados demogr\xe1ficos e informa\xe7\xf5es de contacto da pessoa associada.`,
    ru: `\u{417}\u{430}\u{43F}\u{438}\u{441}\u{438} \u{43E} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}\u{445}, \u{430} \u{442}\u{430}\u{43A}\u{436}\u{435} \u{434}\u{435}\u{43C}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435} \u{438} \u{43A}\u{43E}\u{43D}\u{442}\u{430}\u{43A}\u{442}\u{43D}\u{430}\u{44F} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F} \u{441}\u{432}\u{44F}\u{437}\u{430}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{43B}\u{438}\u{446}\u{430}.`,
    sm: `Faamaumauga o gaoioiga, faatasi ai ma le faitau aofai o tagata e fesootai ma faamatalaga e faafesootai ai.`,
    so: `Diiwaanka waxqabadyada, oo ay weheliso tirakoobka dadka ee qofka la xiriira iyo macluumaadkiisa la xiriira.`,
    th: `\u{E1A}\u{E31}\u{E19}\u{E17}\u{E36}\u{E01}\u{E01}\u{E34}\u{E08}\u{E01}\u{E23}\u{E23}\u{E21} \u{E1E}\u{E23}\u{E49}\u{E2D}\u{E21}\u{E01}\u{E31}\u{E1A}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}\u{E01}\u{E23}\u{E41}\u{E25}\u{E30}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E15}\u{E34}\u{E14}\u{E15}\u{E48}\u{E2D}\u{E02}\u{E2D}\u{E07}\u{E1A}\u{E38}\u{E04}\u{E04}\u{E25}\u{E17}\u{E35}\u{E48}\u{E40}\u{E01}\u{E35}\u{E48}\u{E22}\u{E27}\u{E02}\u{E49}\u{E2D}\u{E07}`,
    ur: `\u{633}\u{631}\u{6AF}\u{631}\u{645}\u{6CC} \u{6A9}\u{627} \u{631}\u{6CC}\u{6A9}\u{627}\u{631}\u{688} \u{60C} \u{645}\u{62A}\u{639}\u{644}\u{642}\u{6C1} \u{634}\u{62E}\u{635} \u{6A9}\u{6CC} \u{622}\u{628}\u{627}\u{62F}\u{6CC} \u{627}\u{648}\u{631} \u{631}\u{627}\u{628}\u{637}\u{6D2} \u{6A9}\u{6CC} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE}\u{6D4}`,
    vi: `H\u{1ED3} s\u{1A1} ho\u{1EA1}t \u{111}\u{1ED9}ng, c\xf9ng v\u{1EDB}i th\xf4ng tin li\xean h\u{1EC7} v\xe0 nh\xe2n kh\u{1EA9}u h\u{1ECD}c c\u{1EE7}a ng\u{1B0}\u{1EDD}i \u{111}\u{1B0}\u{1EE3}c li\xean k\u{1EBF}t.`,
    "zh-hans": `\u{6D3B}\u{52A8}\u{8BB0}\u{5F55}\u{FF0C}\u{4EE5}\u{53CA}\u{5173}\u{8054}\u{4EBA}\u{5458}\u{7684}\u{4EBA}\u{53E3}\u{7EDF}\u{8BA1}\u{6570}\u{636E}\u{548C}\u{8054}\u{7CFB}\u{4FE1}\u{606F}\u{3002}`,
    "zh-hant": `\u{6D3B}\u{52D5}\u{8A18}\u{9304}\u{FF0C}\u{4EE5}\u{53CA}\u{95DC}\u{806F}\u{4EBA}\u{54E1}\u{7684}\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{6578}\u{64DA}\u{548C}\u{806F}\u{7E6B}\u{8CC7}\u{8A0A}\u{3002}`,
    en: `Activity records, along with the associated person's demographics and contact information.`
};
const $2868cc1235412e16$export$60f60aa90d727a55 = {
    ar: `\u{627}\u{644}\u{645}\u{646}\u{638}\u{645}\u{627}\u{62A} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{62A}\u{639}\u{627}\u{648}\u{646} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{64A}\u{639} \u{627}\u{644}\u{62A}\u{64A} \u{62A}\u{634}\u{627}\u{631}\u{643} \u{641}\u{64A}\u{647}\u{627}.`,
    de: `Organisationen, die an Projekten zusammenarbeiten, an denen Sie teilnehmen.`,
    es: `Organizaciones que colaboran en proyectos en los que participa.`,
    fa: `\u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{647}\u{627}\u{6CC}\u{6CC} \u{6A9}\u{647} \u{62F}\u{631} \u{622}\u{646}\u{647}\u{627} \u{634}\u{631}\u{6A9}\u{62A} \u{645}\u{6CC} \u{6A9}\u{646}\u{6CC}\u{62F} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{645}\u{6CC} \u{6A9}\u{646}\u{646}\u{62F}.`,
    fil: `Mga organisasyong nakikipagtulungan sa mga proyektong iyong kinabibilangan.`,
    fr: `Les organisations qui collaborent aux projets auxquels vous participez.`,
    hi: `\u{91C}\u{93F}\u{928} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E}\u{913}\u{902} \u{92E}\u{947}\u{902} \u{906}\u{92A} \u{92D}\u{93E}\u{917} \u{932}\u{947} \u{930}\u{939}\u{947} \u{939}\u{948}\u{902}, \u{909}\u{928} \u{92A}\u{930} \u{938}\u{939}\u{92F}\u{94B}\u{917} \u{915}\u{930}\u{928}\u{947} \u{935}\u{93E}\u{932}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928}\u{964}`,
    ht: `\xd2ganizasyon ki kolabore sou pwoj\xe8 w ap patisipe nan.`,
    it: `Organizzazioni che collaborano a progetti a cui stai partecipando.`,
    ja: `\u{53C2}\u{52A0}\u{3057}\u{3066}\u{3044}\u{308B}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3067}\u{5171}\u{540C}\u{4F5C}\u{696D}\u{3057}\u{3066}\u{3044}\u{308B}\u{7D44}\u{7E54}\u{3002}`,
    ko: `\u{CC38}\u{C5EC} \u{C911}\u{C778} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{C5D0}\u{C11C} \u{D611}\u{C5C5}\u{D558}\u{B294} \u{C870}\u{C9C1}\u{C785}\u{B2C8}\u{B2E4}.`,
    mww: `Koom haum collaborating rau tej yaam num uas koj koom hauv.`,
    ps: `\u{647}\u{63A}\u{647} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{647} \u{686}\u{6D0} \u{67E}\u{647} \u{647}\u{63A}\u{648} \u{67E}\u{631}\u{648}\u{698}\u{648} \u{6A9}\u{6D0} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{6CC} \u{6A9}\u{648}\u{6CC} \u{686}\u{6D0} \u{62A}\u{627}\u{633}\u{648} \u{67E}\u{6A9}\u{6D0} \u{628}\u{631}\u{62E}\u{647} \u{627}\u{62E}\u{644}\u{6CC}.`,
    pt: `Organiza\xe7\xf5es que colaboram em projetos dos quais voc\xea est\xe1 participando.`,
    "pt-pt": `Organiza\xe7\xf5es que colaboram em projetos em que est\xe1 a participar.`,
    ru: `\u{41E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}, \u{441}\u{43E}\u{442}\u{440}\u{443}\u{434}\u{43D}\u{438}\u{447}\u{430}\u{44E}\u{449}\u{438}\u{435} \u{43D}\u{430}\u{434} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}\u{43C}\u{438}, \u{432} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{445} \u{432}\u{44B} \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{443}\u{435}\u{442}\u{435}.`,
    sm: `Fa'alapotopotoga o lo'o galulue fa'atasi i poloketi o lo'o e auai.`,
    so: `Hay\u{2BC}adaha iskaashanaya mashaariicda aad ka qayb qaadanaysid.`,
    th: `\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E17}\u{E35}\u{E48}\u{E17}\u{E4D}\u{E32}\u{E07}\u{E32}\u{E19}\u{E23}\u{E48}\u{E27}\u{E21}\u{E01}\u{E31}\u{E19}\u{E43}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E17}\u{E35}\u{E48}\u{E04}\u{E38}\u{E13}\u{E01}\u{E4D}\u{E32}\u{E25}\u{E31}\u{E07}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21}`,
    ur: `\u{648}\u{6C1} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{6CC}\u{6BA} \u{62C}\u{648} \u{627}\u{646} \u{645}\u{646}\u{635}\u{648}\u{628}\u{648}\u{6BA} \u{67E}\u{631} \u{62A}\u{639}\u{627}\u{648}\u{646} \u{6A9}\u{631} \u{631}\u{6C1}\u{6CC} \u{6C1}\u{6CC}\u{6BA} \u{62C}\u{646} \u{645}\u{6CC}\u{6BA} \u{622}\u{67E} \u{62D}\u{635}\u{6C1} \u{644}\u{6D2} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}\u{6D4}`,
    vi: `C\xe1c t\u{1ED5} ch\u{1EE9}c c\u{1ED9}ng t\xe1c trong c\xe1c d\u{1EF1} \xe1n m\xe0 b\u{1EA1}n \u{111}ang tham gia.`,
    "zh-hans": `\u{5728}\u{60A8}\u{53C2}\u{4E0E}\u{7684}\u{9879}\u{76EE}\u{4E0A}\u{8FDB}\u{884C}\u{534F}\u{4F5C}\u{7684}\u{7EC4}\u{7EC7}\u{3002}`,
    "zh-hant": `\u{5728}\u{60A8}\u{53C3}\u{8207}\u{7684}\u{9805}\u{76EE}\u{4E0A}\u{9032}\u{884C}\u{5354}\u{4F5C}\u{7684}\u{7D44}\u{7E54}\u{3002}`,
    en: `Organizations collaborating on projects you are participating in.`
};
const $2868cc1235412e16$export$90a412476a587834 = {
    ar: `\u{627}\u{644}\u{62A}\u{631}\u{643}\u{64A}\u{628}\u{629} \u{627}\u{644}\u{633}\u{643}\u{627}\u{646}\u{64A}\u{629} \u{648}\u{627}\u{644}\u{639}\u{646}\u{627}\u{648}\u{64A}\u{646} \u{648}\u{631}\u{633}\u{627}\u{626}\u{644} \u{627}\u{644}\u{628}\u{631}\u{64A}\u{62F} \u{627}\u{644}\u{625}\u{644}\u{643}\u{62A}\u{631}\u{648}\u{646}\u{64A} \u{648}\u{627}\u{644}\u{647}\u{648}\u{627}\u{62A}\u{641}.`,
    de: `Demografische Daten, Adressen, E-Mails und Telefonnummern.`,
    es: `Datos demogr\xe1ficos, direcciones, correos electr\xf3nicos y tel\xe9fonos.`,
    fa: `\u{62C}\u{645}\u{639}\u{6CC}\u{62A} \u{634}\u{646}\u{627}\u{633}\u{6CC}\u{60C} \u{622}\u{62F}\u{631}\u{633} \u{647}\u{627}\u{60C} \u{627}\u{6CC}\u{645}\u{6CC}\u{644} \u{647}\u{627} \u{648} \u{62A}\u{644}\u{641}\u{646} \u{647}\u{627}.`,
    fil: `Demograpiko, address, email, at telepono.`,
    fr: `Donn\xe9es d\xe9mographiques, adresses, e-mails et t\xe9l\xe9phones.`,
    hi: `\u{91C}\u{928}\u{938}\u{93E}\u{902}\u{916}\u{94D}\u{92F}\u{93F}\u{915}\u{940}, \u{92A}\u{924}\u{947}, \u{908}\u{92E}\u{947}\u{932} \u{914}\u{930} \u{92B}\u{94B}\u{928}\u{964}`,
    ht: `Demografik, adr\xe8s, Im\xe8l, ak telef\xf2n.`,
    it: `Dati demografici, indirizzi, e-mail e telefoni.`,
    ja: `\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{3001}\u{4F4F}\u{6240}\u{3001}\u{96FB}\u{5B50}\u{30E1}\u{30FC}\u{30EB}\u{3001}\u{96FB}\u{8A71}\u{756A}\u{53F7}\u{3002}`,
    ko: `\u{C778}\u{AD6C} \u{D1B5}\u{ACC4}, \u{C8FC}\u{C18C}, \u{C774}\u{BA54}\u{C77C} \u{BC0F} \u{C804}\u{D654} \u{BC88}\u{D638}.`,
    mww: `Demographics, chaw nyob, emails, thiab tes.`,
    ps: `\u{62C}\u{645}\u{639}\u{6CC}\u{62A} \u{634}\u{646}\u{627}\u{633}\u{6CC}\u{60C} \u{67E}\u{62A}\u{633}\u{60C} \u{627}\u{6CC}\u{645}\u{6CC}\u{644}\u{648}\u{646}\u{647} \u{627}\u{648} \u{67C}\u{6CC}\u{644}\u{6CC}\u{641}\u{648}\u{646}.`,
    pt: `Dados demogr\xe1ficos, endere\xe7os, e-mails e telefones.`,
    "pt-pt": `Dados demogr\xe1ficos, endere\xe7os, e-mails e telefones.`,
    ru: `\u{414}\u{435}\u{43C}\u{43E}\u{433}\u{440}\u{430}\u{444}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}, \u{430}\u{434}\u{440}\u{435}\u{441}\u{430}, \u{44D}\u{43B}\u{435}\u{43A}\u{442}\u{440}\u{43E}\u{43D}\u{43D}\u{430}\u{44F} \u{43F}\u{43E}\u{447}\u{442}\u{430} \u{438} \u{442}\u{435}\u{43B}\u{435}\u{444}\u{43E}\u{43D}\u{44B}.`,
    sm: `Faitau aofai o tagata, tuatusi, imeli, ma telefoni.`,
    so: `Tiraka dadka, cinwaanada, emails, iyo telefoonada.`,
    th: `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E1B}\u{E23}\u{E30}\u{E0A}\u{E32}\u{E01}\u{E23} \u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48} \u{E2D}\u{E35}\u{E40}\u{E21}\u{E25} \u{E41}\u{E25}\u{E30}\u{E42}\u{E17}\u{E23}\u{E28}\u{E31}\u{E1E}\u{E17}\u{E4C}`,
    ur: `\u{688}\u{6CC}\u{645}\u{648}\u{6AF}\u{631}\u{627}\u{641}\u{6A9}\u{633}\u{60C} \u{627}\u{6CC}\u{688}\u{631}\u{6CC}\u{633}\u{632}\u{60C} \u{627}\u{6CC} \u{645}\u{6CC}\u{644}\u{632}\u{60C} \u{627}\u{648}\u{631} \u{641}\u{648}\u{646}.`,
    vi: `Nh\xe2n kh\u{1EA9}u h\u{1ECD}c, \u{111}\u{1ECB}a ch\u{1EC9}, email v\xe0 \u{111}i\u{1EC7}n tho\u{1EA1}i.`,
    "zh-hans": `\u{4EBA}\u{53E3}\u{7EDF}\u{8BA1}\u{3001}\u{5730}\u{5740}\u{3001}\u{7535}\u{5B50}\u{90AE}\u{4EF6}\u{548C}\u{7535}\u{8BDD}\u{3002}`,
    "zh-hant": `\u{4EBA}\u{53E3}\u{7D71}\u{8A08}\u{3001}\u{5730}\u{5740}\u{3001}\u{96FB}\u{5B50}\u{90F5}\u{4EF6}\u{548C}\u{96FB}\u{8A71}\u{3002}`,
    en: `Demographics, addresses, emails, and phones.`
};
const $2868cc1235412e16$export$383ccceb9623a9e8 = {
    ar: `\u{623}\u{639}\u{636}\u{627}\u{621} \u{645}\u{624}\u{633}\u{633}\u{62A}\u{643} \u{648}\u{627}\u{644}\u{645}\u{62A}\u{639}\u{627}\u{648}\u{646}\u{648}\u{646} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{634}\u{631}\u{648}\u{639} \u{645}\u{646} \u{62E}\u{627}\u{631}\u{62C} \u{627}\u{644}\u{645}\u{624}\u{633}\u{633}\u{627}\u{62A}.`,
    de: `Mitglieder Ihrer Organisation und Projektmitarbeiter aus externen Organisationen.`,
    es: `Miembros de su organizaci\xf3n y colaboradores del proyecto de organizaciones externas.`,
    fa: `\u{627}\u{639}\u{636}\u{627}\u{6CC} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{634}\u{645}\u{627} \u{648} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{627}\u{646} \u{67E}\u{631}\u{648}\u{698}\u{647} \u{627}\u{632} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{647}\u{627}\u{6CC} \u{62E}\u{627}\u{631}\u{62C}\u{6CC}.`,
    fil: `Mga miyembro ng iyong organisasyon at mga nakikipagtulungan sa proyekto mula sa mga panlabas na organisasyon.`,
    fr: `Les membres de votre organisation et les collaborateurs du projet provenant d\u{2019}organisations externes.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F} \u{914}\u{930} \u{92C}\u{93E}\u{939}\u{930}\u{940} \u{938}\u{902}\u{917}\u{920}\u{928}\u{94B}\u{902} \u{915}\u{947} \u{92A}\u{94D}\u{930}\u{94B}\u{91C}\u{947}\u{915}\u{94D}\u{91F} \u{938}\u{939}\u{92F}\u{94B}\u{917}\u{940}.`,
    ht: `Manm \xf2ganizasyon ou ak kolaborat\xe8 pwoj\xe8 ki soti nan \xf2ganizasyon andey\xf2 yo.`,
    it: `Membri dell'organizzazione e collaboratori di progetto di organizzazioni esterne.`,
    ja: `\u{7D44}\u{7E54}\u{306E}\u{30E1}\u{30F3}\u{30D0}\u{30FC}\u{3068}\u{5916}\u{90E8}\u{7D44}\u{7E54}\u{306E}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{5354}\u{529B}\u{8005}\u{3002}`,
    ko: `\u{C870}\u{C9C1}\u{C758} \u{AD6C}\u{C131}\u{C6D0} \u{BC0F} \u{C678}\u{BD80} \u{C870}\u{C9C1}\u{C758} \u{D504}\u{B85C}\u{C81D}\u{D2B8} \u{ACF5}\u{B3D9} \u{C791}\u{C5C5}\u{C790}.`,
    mww: `Cov tswv cuab ntawm koj lub koom haum thiab peb tes num collaborators sab nraum lub koom haum sab nraud.`,
    ps: `\u{633}\u{62A}\u{627}\u{633}\u{648} \u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{63A}\u{693}\u{6CC} \u{627}\u{648} \u{62F} \u{628}\u{647}\u{631}\u{646}\u{6CC}\u{648} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}\u{648}\u{646}\u{648} \u{62F} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{647}\u{645}\u{6A9}\u{627}\u{631}\u{627}\u{646}.`,
    pt: `Membros de sua organiza\xe7\xe3o e colaboradores do projeto de organiza\xe7\xf5es externas.`,
    "pt-pt": `Membros da sua organiza\xe7\xe3o e colaboradores do projeto de organiza\xe7\xf5es externas.`,
    ru: `\u{423}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{438} \u{432}\u{430}\u{448}\u{435}\u{439} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{438} \u{441}\u{43E}\u{430}\u{432}\u{442}\u{43E}\u{440}\u{44B} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430} \u{438}\u{437} \u{434}\u{440}\u{443}\u{433}\u{438}\u{445} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{439}.`,
    sm: `Tagata o lau fa'alapotopotoga ma tagata galulue fa'atasi mai fa'alapotopotoga i fafo.`,
    so: `Xubno ka mid ah ururkiinna iyo iskaashatada mashruuca oo ka socda ururo ka baxsan.`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E43}\u{E19}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}\u{E41}\u{E25}\u{E30}\u{E1C}\u{E39}\u{E49}\u{E23}\u{E48}\u{E27}\u{E21}\u{E07}\u{E32}\u{E19}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23}\u{E08}\u{E32}\u{E01}\u{E20}\u{E32}\u{E22}\u{E19}\u{E2D}\u{E01}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{627}\u{631}\u{6A9}\u{627}\u{646} \u{627}\u{648}\u{631} \u{628}\u{6CC}\u{631}\u{648}\u{646}\u{6CC} \u{62A}\u{646}\u{638}\u{6CC}\u{645}\u{648}\u{6BA} \u{6A9}\u{6D2} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{6A9}\u{6D2} \u{645}\u{639}\u{627}\u{648}\u{646}\u{6CC}\u{646}.`,
    vi: `C\xe1c th\xe0nh vi\xean trong t\u{1ED5} ch\u{1EE9}c c\u{1EE7}a b\u{1EA1}n v\xe0 c\u{1ED9}ng t\xe1c vi\xean d\u{1EF1} \xe1n t\u{1EEB} c\xe1c t\u{1ED5} ch\u{1EE9}c b\xean ngo\xe0i.`,
    "zh-hans": `\u{60A8}\u{7684}\u{7EC4}\u{7EC7}\u{6210}\u{5458}\u{548C}\u{6765}\u{81EA}\u{5916}\u{90E8}\u{7EC4}\u{7EC7}\u{7684}\u{9879}\u{76EE}\u{534F}\u{4F5C}\u{8005}\u{3002}`,
    "zh-hant": `\u{60A8}\u{7684}\u{7D44}\u{7E54}\u{6210}\u{54E1}\u{548C}\u{4F86}\u{81EA}\u{5916}\u{90E8}\u{7D44}\u{7E54}\u{7684}\u{9805}\u{76EE}\u{5354}\u{4F5C}\u{8005}\u{3002}`,
    en: `Members of your organization and project collaborators from outside organizations.`
};
const $2868cc1235412e16$export$b389af0af99fc043 = {
    ar: (type)=>`\u{645}\u{62C}\u{627}\u{644} ${type}`,
    de: (type)=>`Feld ${type}`,
    es: (type)=>`${type}`,
    fa: (type)=>`\u{62D}\u{648}\u{632}\u{647} ${type}`,
    fil: (type)=>`Larangan ${type}`,
    fr: (type)=>`${type}`,
    hi: (type)=>`${type} \u{92B}\u{93C}\u{940}\u{932}\u{94D}\u{921}`,
    ht: (type)=>`t\xe8ren ${type}`,
    it: (type)=>`${type}`,
    ja: (type)=>`${type} \u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{30C9}`,
    ko: (type)=>`${type} \u{D544}\u{B4DC}`,
    mww: (type)=>`${type} teb`,
    ps: (type)=>`${type} \u{633}\u{627}\u{62D}\u{647}`,
    pt: (type)=>`${type}`,
    "pt-pt": (type)=>`Campo ${type}`,
    ru: (type)=>`${type} \u{441}\u{444}\u{435}\u{440}\u{430}`,
    sm: (type)=>`${type} fanua`,
    so: (type)=>`${type}`,
    th: (type)=>`\u{E1F}\u{E34}\u{E25}\u{E14}\u{E4C}${type}`,
    ur: (type)=>`${type} \u{634}\u{639}\u{628}\u{6D2}`,
    vi: (type)=>`L\u{129}nh v\u{1EF1}c ${type}`,
    "zh-hans": (type)=>`${type} \u{5B57}\u{6BB5}`,
    "zh-hant": (type)=>`${type} \u{5B57}\u{6BB5}`,
    en: (type)=>`${type} field`
};
const $2868cc1235412e16$export$52452736f47d9d32 = {
    ar: (type)=>`\u{62A}\u{642}\u{631}\u{64A}\u{631} ${type}`,
    de: (type)=>`${type}`,
    es: (type)=>`Informe de ${type}`,
    fa: (type)=>`\u{6AF}\u{632}\u{627}\u{631}\u{634} ${type}`,
    fil: (type)=>`Ulat ng ${type}`,
    fr: (type)=>`Rapport ${type}`,
    hi: (type)=>`${type} \u{915}\u{940} \u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: (type)=>`rap\xf2 ${type}`,
    it: (type)=>`${type}`,
    ja: (type)=>`${type} \u{30EC}\u{30DD}\u{30FC}\u{30C8}`,
    ko: (type)=>`${type} \u{BCF4}\u{ACE0}\u{C11C}`,
    mww: (type)=>`${type} qhia txog`,
    ps: (type)=>`\u{62F} ${type} \u{631}\u{627}\u{67E}\u{648}\u{631}`,
    pt: (type)=>`${type}`,
    "pt-pt": (type)=>`${type}`,
    ru: (type)=>`${type}`,
    sm: (type)=>`Lipoti a ${type}`,
    so: (type)=>`Warbixinta ${type}`,
    th: (type)=>`\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}${type}`,
    ur: (type)=>`${type} \u{631}\u{67E}\u{648}\u{631}\u{679}`,
    vi: (type)=>`B\xe1o c\xe1o ${type}`,
    "zh-hans": (type)=>`${type} \u{62A5}\u{544A}`,
    "zh-hant": (type)=>`${type} \u{5831}\u{544A}`,
    en: (type)=>`${type} report`
};
const $2868cc1235412e16$export$462717a398ee94f9 = {
    ar: `\u{62A}\u{645}\u{62A} \u{645}\u{634}\u{627}\u{631}\u{643}\u{62A}\u{647}\u{627} \u{645}\u{639} \u{627}\u{644}\u{645}\u{624}\u{633}\u{633}\u{629}`,
    de: `Mit Organisation geteilt`,
    es: `Compartido con la organizaci\xf3n`,
    fa: `\u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{634}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{628}\u{627} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646}`,
    fil: `Ibinahagi sa organisasyon`,
    fr: `Partag\xe9 avec l\u{2019}organisation`,
    hi: `\u{938}\u{902}\u{917}\u{920}\u{928} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: `Pataje av\xe8k \xf2ganizasyon`,
    it: `Condiviso con l'organizzazione`,
    ja: `\u{7D44}\u{7E54}\u{3068}\u{5171}\u{6709}`,
    ko: `\u{AE30}\u{AD00}\u{ACFC} \u{ACF5}\u{C720}\u{B428}`,
    mww: `Koom nrog koom haum`,
    ps: `\u{62F} \u{633}\u{627}\u{632}\u{645}\u{627}\u{646} \u{633}\u{631}\u{647} \u{634}\u{631}\u{6CC}\u{6A9}`,
    pt: `Compartilhado com a organiza\xe7\xe3o`,
    "pt-pt": `Partilhado com a organiza\xe7\xe3o`,
    ru: `\u{41E}\u{431}\u{449}\u{438}\u{439} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{434}\u{43B}\u{44F} \u{43E}\u{440}\u{433}\u{430}\u{43D}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438}`,
    sm: `Fa'asoa ma le fa'alapotopotoga`,
    so: `Lala wadaago ururka`,
    th: `\u{E41}\u{E0A}\u{E23}\u{E4C}\u{E01}\u{E31}\u{E1A}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E01}\u{E23}`,
    ur: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9}`,
    vi: `\u{110}\u{1B0}\u{1EE3}c chia s\u{1EBB} v\u{1EDB}i t\u{1ED5} ch\u{1EE9}c`,
    "zh-hans": `\u{4E0E}\u{7EC4}\u{7EC7}\u{5171}\u{4EAB}`,
    "zh-hant": `\u{8207}\u{7D44}\u{7E54}\u{5171}\u{7528}`,
    en: `Shared with organization`
};
const $2868cc1235412e16$export$f0d24def9ad4e77b = {
    ar: (project)=>`\u{645}\u{634}\u{62A}\u{631}\u{643} \u{645}\u{639} \u{645}\u{634}\u{631}\u{648}\u{639} ${project}`,
    de: (project)=>`Gemeinsam mit ${project}`,
    es: (project)=>`Compartido con ${project}`,
    fa: (project)=>`\u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{634}\u{62A}\u{647} \u{634}\u{62F}\u{647} \u{628}\u{627} \u{67E}\u{631}\u{648}\u{698}\u{647} ${project}`,
    fil: (project)=>`Ibinahagi sa proyekto ${project}`,
    fr: (project)=>`Partag\xe9 avec le projet ${project}`,
    hi: (project)=>`${project} \u{92A}\u{930}\u{93F}\u{92F}\u{94B}\u{91C}\u{928}\u{93E} \u{915}\u{947} \u{938}\u{93E}\u{925} \u{938}\u{93E}\u{91D}\u{93E} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E}`,
    ht: (project)=>`Pataje ak ${project}`,
    it: (project)=>`Condiviso con ${project}`,
    ja: (project)=>`${project}\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}\u{3068}\u{5171}\u{6709}`,
    ko: (project)=>`${project} \u{D504}\u{B85C}\u{C81D}\u{D2B8}\u{C640} \u{ACF5}\u{C720}\u{B428}`,
    mww: (project)=>`Sib koom nrog ${project} peb tes num`,
    ps: (project)=>`\u{62F} ${project} \u{67E}\u{631}\u{648}\u{698}\u{6D0} \u{633}\u{631}\u{647} \u{634}\u{631}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC}`,
    pt: (project)=>`Compartilhado com ${project}`,
    "pt-pt": (project)=>`Partilhado com o projeto ${project}`,
    ru: (project)=>`\u{421}\u{43E}\u{432}\u{43C}\u{435}\u{441}\u{442}\u{43D}\u{43E} \u{441} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{43E}\u{43C} ${project}`,
    sm: (project)=>`Fa'asoa ma ${project}`,
    so: (project)=>`Mashruuca ${project} la wadaago`,
    th: (project)=>`\u{E41}\u{E0A}\u{E23}\u{E4C}\u{E01}\u{E31}\u{E1A}\u{E42}\u{E04}\u{E23}\u{E07}\u{E01}\u{E32}\u{E23} ${project}`,
    ur: (project)=>`${project} \u{67E}\u{631}\u{648}\u{62C}\u{6CC}\u{6A9}\u{679} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: (project)=>`Chia s\u{1EBB} v\u{1EDB}i d\u{1EF1} \xe1n ${project}`,
    "zh-hans": (project)=>`\u{4E0E} ${project} \u{9879}\u{76EE}\u{5171}\u{4EAB}`,
    "zh-hant": (project)=>`\u{8207} ${project} \u{9805}\u{76EE}\u{5171}\u{7528}`,
    en: (project)=>`Shared with ${project} project`
};
const $2868cc1235412e16$export$359e6d3e2f449197 = {
    ar: (views)=>`${views} \u{645}\u{634}\u{627}\u{647}\u{62F}\u{629} \u{641}\u{64A} \u{627}\u{644}\u{634}\u{647}\u{631} \u{627}\u{644}\u{645}\u{627}\u{636}\u{64A}`,
    de: (views)=>`${views} Aufrufe im letzten Monat`,
    es: (views)=>`${views} vistas en el \xfaltimo mes`,
    fa: (views)=>`${views} \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{62F}\u{631} \u{645}\u{627}\u{647} \u{6AF}\u{630}\u{634}\u{62A}\u{647}`,
    fil: (views)=>`${views} views sa nakaraang buwan`,
    fr: (views)=>`${views} vues au cours du dernier mois`,
    hi: (views)=>`${views} \u{935}\u{93F}\u{91A}\u{93E}\u{930}\u{94B}\u{902} \u{92A}\u{93F}\u{91B}\u{932}\u{947} \u{92E}\u{939}\u{940}\u{928}\u{947} \u{92E}\u{947}\u{902}`,
    ht: (views)=>`${views} opinyon nan mwa ki sot pase a`,
    it: (views)=>`${views} visualizzazioni nell'ultimo mese`,
    ja: (views)=>`\u{904E}\u{53BB}1\u{30F6}\u{6708}\u{9593}\u{306E}${views}`,
    ko: (views)=>`\u{C9C0}\u{B09C}\u{B2EC} \u{C870}\u{D68C}\u{C218} ${views}\u{D68C}`,
    mww: (views)=>`${views} views lub hli dhau los`,
    ps: (views)=>`${views} \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{62F}\u{631} \u{645}\u{627}\u{647} \u{6AB}\u{630}\u{634}\u{62A}\u{647}`,
    pt: (views)=>`${views} visualiza\xe7\xf5es no m\xeas passado`,
    "pt-pt": (views)=>`${views} visualiza\xe7\xf5es no m\xeas passado`,
    ru: (views)=>`${views} \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440}\u{43E}\u{432} \u{437}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{438}\u{439} \u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    sm: (views)=>`${views} manatu i le masina talu ai`,
    so: (views)=>`${views} views bishii la soo dhaafay`,
    th: (views)=>`${views} \u{E21}\u{E38}\u{E21}\u{E21}\u{E2D}\u{E07}\u{E43}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E21}\u{E32}`,
    ur: (views)=>`\u{6AF}\u{632}\u{634}\u{62A}\u{6C1} \u{645}\u{627}\u{6C1} ${views} \u{645}\u{631}\u{62A}\u{628}\u{6C1} \u{62F}\u{6CC}\u{6A9}\u{6BE}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: (views)=>`${views} l\u{1B0}\u{1EE3}t xem trong th\xe1ng qua`,
    "zh-hans": (views)=>`\u{8FC7}\u{53BB}\u{4E00}\u{4E2A}\u{6708}\u{6709} ${views} \u{6B21}\u{6D4F}\u{89C8}`,
    "zh-hant": (views)=>`\u{904E}\u{53BB}\u{4E00}\u{500B}\u{6708}\u{6709}${views}\u{6B21}\u{6D41}\u{89BD}`,
    en: (views)=>`${views} views in past month`
};
const $2868cc1235412e16$export$5d983b2e23c4cd6 = {
    ar: `1 \u{645}\u{634}\u{627}\u{647}\u{62F}\u{629} \u{641}\u{64A} \u{627}\u{644}\u{634}\u{647}\u{631} \u{627}\u{644}\u{645}\u{627}\u{636}\u{64A}`,
    de: `1 Ansicht im letzten Monat`,
    es: `1 vista en el \xfaltimo mes`,
    fa: `1 \u{628}\u{627}\u{632}\u{62F}\u{6CC}\u{62F} \u{62F}\u{631} \u{645}\u{627}\u{647} \u{6AF}\u{630}\u{634}\u{62A}\u{647}`,
    fil: `1 view sa nakaraang buwan`,
    fr: `1 vue au cours du dernier mois`,
    hi: `1 \u{92A}\u{93F}\u{91B}\u{932}\u{947} \u{92E}\u{939}\u{940}\u{928}\u{947} \u{92E}\u{947}\u{902} \u{926}\u{947}\u{916}\u{947}\u{902}`,
    ht: `1 gade nan mwa ki sot pase a`,
    it: `1 vista nell'ultimo mese`,
    ja: `\u{904E}\u{53BB}1\u{30F6}\u{6708}\u{306E}\u{95B2}\u{89A7}\u{56DE}\u{6570}`,
    ko: `\u{C9C0}\u{B09C}\u{B2EC}\u{C5D0} \u{C870}\u{D68C}\u{C218} 1\u{D68C}`,
    mww: `1 saib lub hli dhau los`,
    ps: `1 \u{644}\u{6CC}\u{62F}\u{646}\u{647} \u{67E}\u{647} \u{62A}\u{6CC}\u{631}\u{647} \u{645}\u{6CC}\u{627}\u{634}\u{62A} \u{6A9}\u{6D0}`,
    pt: `1 visualiza\xe7\xe3o no m\xeas passado`,
    "pt-pt": `1 vista no m\xeas passado`,
    ru: `1 \u{43F}\u{440}\u{43E}\u{441}\u{43C}\u{43E}\u{442}\u{440} \u{437}\u{430} \u{43F}\u{43E}\u{441}\u{43B}\u{435}\u{434}\u{43D}\u{438}\u{439} \u{43C}\u{435}\u{441}\u{44F}\u{446}`,
    sm: `1 vaaiga i le masina talu ai`,
    so: `1 view bisha la soo dhaafay`,
    th: `1 \u{E14}\u{E39}\u{E43}\u{E19}\u{E40}\u{E14}\u{E37}\u{E2D}\u{E19}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E21}\u{E32}`,
    ur: `\u{67E}\u{686}\u{6BE}\u{644}\u{6D2} \u{645}\u{6C1}\u{6CC}\u{646}\u{6D2} \u{645}\u{6CC}\u{6BA} 1 \u{646}\u{638}\u{627}\u{631}\u{6C1}`,
    vi: `1 l\u{1B0}\u{1EE3}t xem trong th\xe1ng qua`,
    "zh-hans": `\u{8FC7}\u{53BB}\u{4E00}\u{4E2A}\u{6708}\u{6709} 1 \u{6B21}\u{6D4F}\u{89C8}`,
    "zh-hant": `\u{904E}\u{53BB}\u{4E00}\u{500B}\u{6708}\u{6709}1\u{6B21}\u{6D41}\u{89BD}`,
    en: `1 view in past month`
};
const $2868cc1235412e16$export$eda36b340a683f39 = {
    ar: `\u{623}\u{646}\u{62A} \u{645}\u{634}\u{62A}\u{631}\u{643}`,
    de: `Sie sind abonniert`,
    es: `Est\xe1s suscrito`,
    fa: `\u{634}\u{645}\u{627} \u{645}\u{634}\u{62A}\u{631}\u{6A9} \u{647}\u{633}\u{62A}\u{6CC}\u{62F}`,
    fil: `Ikaw ay naka-subscribe`,
    fr: `Vous \xeates abonn\xe9`,
    hi: `\u{906}\u{92A}\u{928}\u{947} \u{938}\u{926}\u{938}\u{94D}\u{92F}\u{924}\u{93E} \u{932}\u{940} \u{939}\u{948}`,
    ht: `Ou enskri`,
    it: `Sei iscritto`,
    ja: `\u{8CFC}\u{8AAD}\u{3057}\u{3066}\u{3044}\u{308B}`,
    ko: `\u{AD6C}\u{B3C5}\u{D558}\u{C168}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Koj subscribed`,
    ps: `\u{62A}\u{627}\u{633}\u{648} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{634}\u{648}\u{6CC} \u{6CC}\u{627}\u{633}\u{62A}`,
    pt: `Voc\xea est\xe1 inscrito`,
    "pt-pt": `Voc\xea est\xe1 inscrito`,
    ru: `\u{412}\u{44B} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{430}\u{43D}\u{44B}`,
    sm: `Ua e lesitala`,
    so: `Waxaad tahay kuwa la soo goostay`,
    th: `\u{E04}\u{E38}\u{E13}\u{E2A}\u{E21}\u{E31}\u{E04}\u{E23}\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E41}\u{E25}\u{E49}\u{E27}`,
    ur: `\u{622}\u{67E} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628} \u{6A9}\u{631} \u{631}\u{6C1}\u{6D2} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `B\u{1EA1}n \u{111}\xe3 \u{111}\u{103}ng k\xfd`,
    "zh-hans": `\u{60A8}\u{5DF2}\u{8BA2}\u{9605}`,
    "zh-hant": `\u{60A8}\u{5DF2}\u{8A02}\u{95B1}`,
    en: `You are subscribed`
};
const $2868cc1235412e16$export$f9a7fd5427e6dd0b = {
    ar: `\u{645}\u{634}\u{62A}\u{631}\u{643} \u{648}\u{627}\u{62D}\u{62F}`,
    de: `Ein Abonnent`,
    es: `Un suscriptor`,
    fa: `\u{6CC}\u{6A9} \u{645}\u{634}\u{62A}\u{631}\u{6A9}`,
    fil: `Isang tagasuskribi`,
    fr: `Un abonn\xe9`,
    hi: `\u{90F}\u{915} \u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}`,
    ht: `Yon ab\xf2nen`,
    it: `Un abbonato`,
    ja: `1 \u{4EBA}\u{306E}\u{52A0}\u{5165}\u{8005}`,
    ko: `\u{AD6C}\u{B3C5}\u{C790} 1\u{BA85}`,
    mww: `Ib tug subscriber`,
    ps: `\u{6CC}\u{648} \u{6AB}\u{689}\u{648}\u{646} \u{6A9}\u{648}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Um assinante`,
    "pt-pt": `Um assinante`,
    ru: `\u{41E}\u{434}\u{438}\u{43D} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{447}\u{438}\u{43A}`,
    sm: `Tasi le tagata fai saofaga`,
    so: `Hal macaamiil`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E04}\u{E19}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{633}\u{628}\u{633}\u{6A9}\u{631}\u{627}\u{626}\u{628}\u{631}`,
    vi: `M\u{1ED9}t ng\u{1B0}\u{1EDD}i \u{111}\u{103}ng k\xfd`,
    "zh-hans": `\u{4E00}\u{4E2A}\u{8BA2}\u{9605}\u{8005}`,
    "zh-hant": `\u{4E00}\u{500B}\u{8A02}\u{95B1}\u{8005}`,
    en: `One subscriber`
};
const $2868cc1235412e16$export$83683a52fe785bc5 = {
    ar: (count)=>`${count} \u{645}\u{634}\u{62A}\u{631}\u{643}`,
    de: (count)=>`${count} Abonnenten`,
    es: (count)=>`${count} suscriptores`,
    fa: (count)=>`${count} \u{645}\u{634}\u{62A}\u{631}\u{6A9}`,
    fil: (count)=>`${count} mga tagasuskribi`,
    fr: (count)=>`${count} abonn\xe9s`,
    hi: (count)=>`${count} \u{938}\u{92C}\u{94D}\u{938}\u{915}\u{94D}\u{930}\u{93E}\u{907}\u{92C}\u{930}`,
    ht: (count)=>`${count} abonn\xe9s`,
    it: (count)=>`${count} iscritti`,
    ja: (count)=>`${count} \u{4EBA}\u{306E}\u{767B}\u{9332}\u{8005}`,
    ko: (count)=>`${count} \u{BA85}`,
    mww: (count)=>`${count} subscribers`,
    ps: (count)=>`${count} \u{645}\u{634}\u{62A}\u{631}\u{6A9}\u{6CC}\u{646}`,
    pt: (count)=>`${count} assinantes`,
    "pt-pt": (count)=>`${count} assinantes`,
    ru: (count)=>`${count} \u{43F}\u{43E}\u{434}\u{43F}\u{438}\u{441}\u{447}\u{438}\u{43A}\u{43E}\u{432}`,
    sm: (count)=>`${count} tagata fai saofaga`,
    so: (count)=>`${count} macaamiil`,
    th: (count)=>`\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01} ${count} \u{E04}\u{E19}`,
    ur: (count)=>`${count} \u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646}`,
    vi: (count)=>`${count} ng\u{1B0}\u{1EDD}i \u{111}\u{103}ng k\xfd`,
    "zh-hans": (count)=>`${count} \u{4F4D}\u{8BA2}\u{9605}\u{8005}`,
    "zh-hant": (count)=>`${count} \u{4F4D}\u{8A02}\u{95B1}\u{8005}`,
    en: (count)=>`${count} subscribers`
};
const $2868cc1235412e16$export$c35d6441a1e5a3ac = {
    ar: (entity)=>$2868cc1235412e16$var$html`لا يمكن ${entity} المشتركة إلا من قبل منشئها أو أعضاء مؤسسة منشئ المحتوى الذين لديهم دور <strong>المالك</strong> أو <strong>المشرف</strong> .`,
    de: (entity)=>$2868cc1235412e16$var$html`Freigegebene ${entity} können nur von ihrem Ersteller oder Mitgliedern der Organisation des Erstellers mit der Rolle <strong>"Besitzer</strong> " oder <strong>"Administrator"</strong> bearbeitet werden.`,
    es: (entity)=>$2868cc1235412e16$var$html`Los ${entity} compartidos solo pueden ser editados por su creador o por los miembros de la organización del creador con el rol de <strong>propietario</strong> o <strong>administrador</strong> .`,
    fa: (entity)=>$2868cc1235412e16$var$html`${entity} های هم رسانی شده فقط توسط سازنده آن ها یا اعضای سازمان سازنده با نقش <strong>مالک</strong> یا <strong>سرپرست</strong> قابل ویرایش هستند.`,
    fil: (entity)=>$2868cc1235412e16$var$html`Ang mga ibinahaging ${entity} ay maaaring i-edit lamang ng tagalikha nito o ng mga miyembro ng organisasyon ng tagalikha na may papel na <strong>May-ari</strong> o <strong>Admin</strong> .`,
    fr: (entity)=>$2868cc1235412e16$var$html`Les ${entity} partagés ne peuvent être modifiés que par leur créateur ou par les membres de l’organisation du créateur disposant du rôle <strong>Propriétaire</strong> ou <strong>Administrateur</strong> .`,
    hi: (entity)=>$2868cc1235412e16$var$html`शेयर की ${entity} सिर्फ़ उनके क्रिएटर या <strong>मालिक</strong> या <strong>एडमिन</strong> भूमिका वाले क्रिएटर के संगठन के सदस्यों द्वारा संपादित की जा सकती हैं.`,
    ht: (entity)=>$2868cc1235412e16$var$html`${entity} pataje yo sèlman editab pa kreyatè yo oswa manm nan òganizasyon kreyatè a ak <strong>Mèt kay</strong> la oswa wòl <strong>Admin</strong>.`,
    it: (entity)=>$2868cc1235412e16$var$html`I ${entity} condivisi possono essere modificati solo dall'autore o dai membri dell'organizzazione dell'autore con il ruolo <strong>di Proprietario</strong> o <strong>Amministratore</strong> .`,
    ja: (entity)=>$2868cc1235412e16$var$html`共有 ${entity} 、その作成者、または作成者の組織で <strong>オーナー</strong> または <strong>管理者</strong> の役割を持つメンバーのみが編集できます。`,
    ko: (entity)=>$2868cc1235412e16$var$html`공유 ${entity} 작성자 또는 <strong>작성자 조직의 구성원 또는 소유자</strong> 또는 <strong>관리자</strong> 역할만 편집할 수 있습니다.`,
    mww: (entity)=>$2868cc1235412e16$var$html`Qhia ${entity} no tsuas editable los ntawm lawv creator los yog cov tswv cuab ntawm lub koom haum creator lub koom haum nrog tus <strong>tswv tsev</strong> los yog <strong>Admin</strong> luag hauj lwm.`,
    ps: (entity)=>$2868cc1235412e16$var$html`شریک ${entity} یوازې د هغوی د خالق یا د جوړونکی د سازمان د غړو لخوا د <strong>مالک</strong> یا <strong>مدیر</strong> رول سره د سمون وړ دی.`,
    pt: (entity)=>$2868cc1235412e16$var$html`Os ${entity} compartilhados só podem ser editados pelo criador ou pelos membros da organização do criador com a função <strong>de proprietário</strong> ou <strong>administrador</strong> .`,
    "pt-pt": (entity)=>$2868cc1235412e16$var$html`Os ${entity} partilhados só podem ser editados pelo criador ou pelos membros da organização do criador com a função <strong>de Proprietário</strong> ou <strong>Administrador</strong> .`,
    ru: (entity)=>$2868cc1235412e16$var$html`Общие ${entity} могут редактировать только их создатели или участники организации автора с ролью <strong>владельца</strong> или <strong>администратора</strong> .`,
    sm: (entity)=>$2868cc1235412e16$var$html`O ${entity} fa'asoa e na'o le mafai ona fa'asa'oina e le latou foafoa po'o sui o le fa'alapotopotoga a le foafoa ma le <strong>Matafaioi</strong> a le Pule po'o le <strong>Pule.</strong>`,
    so: (entity)=>$2868cc1235412e16$var$html`${entity} la wadaago waxaa keliya oo lagu hagaajin karo oo ay sameeyeen abuurahooda ama xubno ka tirsan ururka abuuraha oo leh doorka <strong>Milkiilaha</strong> ama <strong>Admin</strong>.`,
    th: (entity)=>$2868cc1235412e16$var$html`${entity}แชร์จะแก้ไขได้โดยผู้สร้างหรือสมาชิกในองค์กรของครีเอเตอร์ที่มีบทบาท<strong>เจ้าของ</strong>หรือ<strong>ผู้ดูแลระบบ</strong>เท่านั้น`,
    ur: (entity)=>$2868cc1235412e16$var$html`مشترکہ ${entity} صرف ان کے تخلیق کار یا تخلیق کار کی تنظیم کے ارکان کے ذریعہ <strong>مالک</strong> یا <strong>ایڈمن</strong> کے کردار کے ساتھ ترمیم کے قابل ہیں۔`,
    vi: (entity)=>$2868cc1235412e16$var$html`Báo ${entity} chia sẻ chỉ có thể chỉnh sửa bởi người tạo hoặc thành viên trong tổ chức của người sáng tạo có vai trò <strong>Chủ sở hữu</strong> hoặc <strong>Quản trị viên</strong> .`,
    "zh-hans": (entity)=>$2868cc1235412e16$var$html`共享 ${entity} 只能由其创建者或具有 <strong>Owner</strong> 或 <strong>Admin</strong> 角色的创建者组织的成员进行编辑。`,
    "zh-hant": (entity)=>$2868cc1235412e16$var$html`共用 ${entity} 只能由其建立者或具有 <strong>Owner</strong> 或 <strong>Admin</strong> 角色的建立者組織的成員進行編輯。`,
    en: (entity)=>$2868cc1235412e16$var$html`Shared ${entity} are only editable by their creator or members of the creator's organization with the <strong>Owner</strong> or <strong>Admin</strong> role.`
};
const $2868cc1235412e16$export$e57713d0322a6cbc = {
    ar: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} غير قابل للتحرير لأن دورك في <strong>${organization}</strong> هو <strong>${role}</strong>`,
    de: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} kann nicht bearbeitet werden, da Ihre Rolle in <strong>${organization}</strong> <strong>${role}</strong>" lautet.`,
    es: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} no se puede editar porque su rol en <strong>${organization}</strong> es <strong>${role}</strong>`,
    fa: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} قابل ویرایش نیست زیرا نقش شما در <strong>${organization}</strong> <strong>${role}</strong> است`,
    fil: (entity, organization, role)=>$2868cc1235412e16$var$html`Hindi mai-edit ang ${entity} dahil ang papel mo sa <strong>${organization}</strong> ay <strong>${role}</strong>`,
    fr: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} n’est pas modifiable, car votre rôle dans <strong>${organization}</strong> est <strong>${role}</strong>`,
    hi: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} संपादन योग्य नहीं है क्योंकि <strong>${organization}</strong> में आपकी भूमिका <strong>${role}</strong> है`,
    ht: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} editab paske wòl ou nan <strong>${organization}</strong> se <strong>${role}</strong>`,
    it: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} non è modificabile perché il tuo ruolo in <strong>${organization}</strong> è <strong>${role}</strong>`,
    ja: (organization, role, entity)=>$2868cc1235412e16$var$html`<strong>${organization}</strong> でのロールが<strong>${role}</strong>であるため、${entity}編集できません`,
    ko: (organization, role, entity)=>$2868cc1235412e16$var$html`<strong>${organization}</strong>에서 사용자의 역할은 <strong>${role}</strong>이므로 ${entity} 편집할 수 없습니다.`,
    mww: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} tsis editable vim koj lub luag hauj lwm nyob rau hauv <strong>${organization}</strong> yog <strong>${role}</strong>`,
    ps: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} د سمون وړ نه دی ځکه چې ستاسو رول په <strong>${organization}</strong> کې <strong>${role}</strong> دی`,
    pt: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} não é editável porque sua função no <strong>${organization}</strong> é <strong>${role}</strong>`,
    "pt-pt": (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} não é editável porque o seu papel no <strong>${organization}</strong> é <strong>${role}</strong>`,
    ru: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} недоступен для редактирования, так как ваша роль в <strong>${organization}</strong> — <strong>${role}</strong>`,
    sm: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} le mafai ona fa'asa'oina le lipoti aua o lau matafaioi i <strong>${organization}</strong> o <strong>${role}</strong>`,
    so: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} ma ahan wax laga bedeli karo sababtoo ah doorkaaga <strong>${organization}</strong> waa <strong>${role}</strong>`,
    th: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} ไม่สามารถแก้ไขได้เนื่องจากบทบาทของคุณใน <strong>${organization}</strong> คือ <strong>${role}</strong>`,
    ur: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} قابل تدوین نہیں ہے کیونکہ <strong>${organization}</strong> میں آپ کا کردار <strong>${role}</strong> ہے`,
    vi: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} không thể chỉnh sửa vì vai trò của bạn trong <strong>${organization}</strong> là <strong>${role}</strong>`,
    "zh-hans": (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} 不可编辑，因为您在 <strong>${organization}</strong> 中的角色是 <strong>${role}</strong>`,
    "zh-hant": (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} 不可編輯，因為您在 <strong>${organization}</strong> 中的角色是 <strong>${role}</strong>`,
    en: (entity, organization, role)=>$2868cc1235412e16$var$html`${entity} is not editable because your role in <strong>${organization}</strong> is <strong>${role}</strong>`
};
const $2868cc1235412e16$export$95c55fc320a5b72c = {
    ar: `\u{644}\u{648}\u{62D}\u{647} \u{627}\u{644}\u{642}\u{64A}\u{627}\u{62F}\u{647}`,
    de: `Instrumententafel`,
    es: `Salpicadero`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}`,
    fil: `Dashboard`,
    fr: `Tableau de bord`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921}`,
    ht: `tablodb\xf2`,
    it: `Cruscotto`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}`,
    mww: `Dashboard`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689}`,
    pt: `Painel`,
    "pt-pt": `Painel de instrumentos`,
    ru: `\u{429}\u{438}\u{442}\u{43E}\u{43A}`,
    sm: `Dashboard`,
    so: `Dashboard`,
    th: `\u{E41}\u{E1C}\u{E07}\u{E2B}\u{E19}\u{E49}\u{E32}\u{E1B}\u{E31}\u{E14}`,
    ur: `Dashboard`,
    vi: `B\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    "zh-hans": `\u{6321}\u{6CE5}\u{677F}`,
    "zh-hant": `\u{64CB}\u{6CE5}\u{677F}`,
    en: `Dashboard`
};
const $2868cc1235412e16$export$684321e2b70e9dca = {
    ar: `\u{62A}\u{642}\u{631}\u{64A}\u{631}`,
    de: `Bericht`,
    es: `Informe`,
    fa: `\u{6AF}\u{632}\u{627}\u{631}\u{634}`,
    fil: `Ulat`,
    fr: `Rapport`,
    hi: `\u{930}\u{93F}\u{92A}\u{94B}\u{930}\u{94D}\u{91F}`,
    ht: `Rap\xf2`,
    it: `Rapporto`,
    ja: `\u{5831}\u{544A}`,
    ko: `\u{BCF4}\u{ACE0}\u{C11C}`,
    mww: `Qhia`,
    ps: `\u{631}\u{627}\u{67E}\u{648}\u{631}`,
    pt: `Relat\xf3rio`,
    "pt-pt": `Relat\xf3rio`,
    ru: `\u{421}\u{43E}\u{43E}\u{431}\u{449}\u{430}\u{442}\u{44C}`,
    sm: `Lipoti`,
    so: `Warbixin`,
    th: `\u{E23}\u{E32}\u{E22}\u{E07}\u{E32}\u{E19}`,
    ur: `\u{631}\u{67E}\u{648}\u{631}\u{679}`,
    vi: `B\xe1o c\xe1o`,
    "zh-hans": `\u{62A5}\u{544A}`,
    "zh-hant": `\u{5831}\u{544A}`,
    en: `Report`
};
const $2868cc1235412e16$export$2f17416cb5918cc2 = {
    ar: `\u{633}\u{62C}\u{644}`,
    de: `Log`,
    es: `Registro`,
    fa: `\u{648}\u{631}\u{648}\u{62F}`,
    fil: `Email Address *`,
    fr: `Rapport`,
    hi: `\u{932}\u{91F}\u{94D}\u{920}\u{93E}`,
    ht: `Bout\xe8y demere`,
    it: `Registro`,
    ja: `\u{4E38}\u{592A}`,
    ko: `\u{B85C}\u{ADF8}`,
    mww: `log`,
    ps: `\u{644}\u{6CC}\u{6A9}\u{646}\u{647}`,
    pt: `Tora`,
    "pt-pt": `Registo`,
    ru: `\u{416}\u{443}\u{440}\u{43D}\u{430}\u{43B}`,
    sm: `Ogalaau`,
    so: `Log`,
    th: `\u{E0B}\u{E38}\u{E07}`,
    ur: `\u{644}\u{627}\u{6AF}`,
    vi: `Nh\u{1EAD}t tr\xecnh`,
    "zh-hans": `\u{65E5}\u{5FD7}`,
    "zh-hant": `\u{65E5}\u{8A8C}`,
    en: `Log`
};
const $2868cc1235412e16$export$820673857d24e132 = {
    ar: `\u{627}\u{644}\u{645}\u{634}\u{62A}\u{631}\u{643}\u{64A}\u{646}`,
    de: `Abonnenten`,
    es: `Suscriptores`,
    fa: `\u{645}\u{634}\u{62A}\u{631}\u{6A9}\u{6CC}\u{646}`,
    fil: `Mga Tagasuskribi`,
    fr: `Abonn\xe9s`,
    hi: `\u{917}\u{94D}\u{930}\u{93E}\u{939}\u{915}\u{94B}\u{902}`,
    ht: `Abonn\xe9s`,
    it: `Abbonati`,
    ja: `\u{30B5}\u{30D6}\u{30B9}\u{30AF}\u{30E9}\u{30A4}\u{30D0}\u{30FC}`,
    ko: `\u{AD6C}\u{B3C5}\u{C790}`,
    mww: `Subscribers`,
    ps: `\u{645}\u{634}\u{62A}\u{631}\u{6A9}\u{6CC}\u{646}`,
    pt: `Assinantes`,
    "pt-pt": `Subscritores`,
    ru: `\u{410}\u{431}\u{43E}\u{43D}\u{435}\u{43D}\u{442}\u{44B}`,
    sm: `Tagata fai saofaga`,
    so: `Macaamiisha`,
    th: `\u{E2A}\u{E21}\u{E32}\u{E0A}\u{E34}\u{E01}`,
    ur: `\u{635}\u{627}\u{631}\u{641}\u{6CC}\u{646}`,
    vi: `Thu\xea bao`,
    "zh-hans": `\u{7528}\u{6237}`,
    "zh-hant": `\u{4F7F}\u{7528}\u{8005}`,
    en: `Subscribers`
};
const $2868cc1235412e16$export$a1f1f7c132479018 = {
    ar: `\u{645}\u{62A}\u{631}\u{64A}`,
    de: `Metrik`,
    es: `M\xe9trico`,
    fa: `\u{645}\u{62A}\u{631}\u{6CC}\u{6A9}`,
    fil: `Sukatan`,
    fr: `M\xe9trique`,
    hi: `\u{92A}\u{930}\u{93F}\u{92E}\u{93E}\u{923}\u{93E}\u{924}\u{94D}\u{200D}\u{92E}\u{915}`,
    ht: `Metrik`,
    it: `Metrico`,
    ja: `\u{30E1}\u{30C8}\u{30EA}\u{30C3}\u{30AF}`,
    ko: `\u{BA54}\u{D2B8}\u{B9AD}`,
    mww: `Metric`,
    ps: `\u{645}\u{6CC}\u{67C}\u{631}\u{6CC}\u{6A9}`,
    pt: `M\xe9trica`,
    "pt-pt": `M\xe9trica`,
    ru: `\u{41C}\u{435}\u{442}\u{440}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{439}`,
    sm: `Metric`,
    so: `Metric`,
    th: `\u{E40}\u{E21}\u{E15}\u{E23}\u{E34}\u{E01}`,
    ur: `\u{645}\u{6CC}\u{679}\u{631}\u{6A9}`,
    vi: `M\xe9t`,
    "zh-hans": `\u{5EA6}\u{91CF}`,
    "zh-hant": `\u{5EA6}\u{91CF}`,
    en: `Metric`
};
const $2868cc1235412e16$export$5b428e0e41cc0f54 = {
    ar: `\u{62A}\u{62E}\u{641}\u{64A}\u{636} \u{627}\u{644}\u{633}\u{639}\u{631}`,
    de: `Abschlag`,
    es: `Descuento`,
    fa: `\u{639}\u{644}\u{627}\u{645}\u{62A} \u{6AF}\u{630}\u{627}\u{631}\u{6CC}`,
    fil: `Markdown`,
    fr: `Markdown`,
    hi: `\u{92E}\u{93E}\u{930}\u{94D}\u{915}\u{921}\u{93E}\u{909}\u{928}`,
    ht: `Makdown`,
    it: `Markdown`,
    ja: `\u{5024}\u{4E0B}\u{3052}`,
    ko: `\u{C778}\u{D558}`,
    mww: `Markdown`,
    ps: `\u{645}\u{627}\u{631}\u{6A9} \u{689}\u{627}\u{648}\u{646}`,
    pt: `Redu\xe7\xe3o de pre\xe7o`,
    "pt-pt": `Marca\xe7\xe3o`,
    ru: `\u{423}\u{446}\u{435}\u{43D}\u{43A}\u{430}`,
    sm: `Markdown`,
    so: `Markdown`,
    th: `\u{E21}\u{E32}\u{E23}\u{E4C}\u{E04}\u{E14}\u{E32}\u{E27}\u{E19}\u{E4C}`,
    ur: `Markdown`,
    vi: `\u{110}\xe1nh d\u{1EA5}u`,
    "zh-hans": `Markdown`,
    "zh-hant": `Markdown`,
    en: `Markdown`
};
const $2868cc1235412e16$export$2763be9aeff0aa97 = {
    ar: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    de: `\xdcberschrift`,
    es: `Encabezado`,
    fa: `\u{639}\u{646}\u{648}\u{627}\u{646}`,
    fil: `Pamagat`,
    fr: `Rubrique`,
    hi: `\u{936}\u{940}\u{930}\u{94D}\u{937}\u{915}`,
    ht: ``,
    it: `Intestazione`,
    ja: `\u{898B}\u{51FA}\u{3057}`,
    ko: `\u{C81C}\u{BAA9}`,
    mww: `Nqe lus hais txog`,
    ps: `\u{633}\u{631}\u{644}\u{6CC}\u{6A9}`,
    pt: `Rubrica`,
    "pt-pt": `Designa\xe7\xe3o`,
    ru: `\u{417}\u{430}\u{433}\u{43E}\u{43B}\u{43E}\u{432}\u{43E}\u{43A}`,
    sm: `Ulutala`,
    so: `Haku`,
    th: `\u{E2B}\u{E31}\u{E27} \u{E40}\u{E23}\u{E37}\u{E48}\u{E2D}\u{E07}`,
    ur: `\u{633}\u{631}\u{62E}\u{6CC}`,
    vi: `Ti\xeau \u{111}\u{1EC1}`,
    "zh-hans": `\u{6807}\u{9898}`,
    "zh-hant": `\u{6A19}\u{984C}`,
    en: `Heading`
};
const $2868cc1235412e16$export$84d2a03f81848e1 = {
    ar: `\u{645}\u{62D}\u{631}\u{631}`,
    de: `Redakteur`,
    es: `Editor`,
    fa: `\u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634}\u{6AF}\u{631}`,
    fil: `Editor`,
    fr: `\xc9diteur`,
    hi: `\u{938}\u{902}\u{92A}\u{93E}\u{926}\u{915}`,
    ht: `Edit\xe8`,
    it: `Editore`,
    ja: `\u{7DE8}\u{96C6}\u{8005}`,
    ko: `\u{D3B8}\u{C9D1}\u{C790}`,
    mww: `Editor`,
    ps: `\u{627}\u{6CC}\u{689}\u{6CC}\u{67C}\u{631}`,
    pt: `Editor`,
    "pt-pt": `Dire\xe7\xe3o`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{43E}\u{440}`,
    sm: `Faatonu`,
    so: `Tifaftire`,
    th: `\u{E1A}\u{E23}\u{E23}\u{E13}\u{E32}\u{E18}\u{E34}\u{E01}\u{E32}\u{E23}`,
    ur: `\u{645}\u{62F}\u{6CC}\u{631}`,
    vi: `Bi\xean t\u{1EAD}p vi\xean`,
    "zh-hans": `\u{7F16}\u{8F91} \u{5668}`,
    "zh-hant": `\u{7DE8}\u{8F2F}\u{5668}`,
    en: `Editor`
};
const $2868cc1235412e16$export$11bac38300b66c09 = {
    ar: `\u{62A}\u{62D}\u{631}\u{64A}\u{631} \u{627}\u{644}\u{639}\u{646}\u{635}\u{631}`,
    de: `Element bearbeiten`,
    es: `Elemento de edici\xf3n`,
    fa: `\u{639}\u{646}\u{635}\u{631} \u{631}\u{627} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-edit ang elemento`,
    fr: `Modifier l\u{2019}\xe9l\xe9ment`,
    hi: `\u{924}\u{924}\u{94D}\u{935} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Eleman Edit`,
    it: `Modifica elemento`,
    ja: `\u{7DE8}\u{96C6}\u{8981}\u{7D20}`,
    ko: `\u{C694}\u{C18C} \u{D3B8}\u{C9D1}`,
    mww: `Edit caij`,
    ps: `\u{633}\u{645}\u{648}\u{646} \u{639}\u{646}\u{635}\u{631}`,
    pt: `Editar elemento`,
    "pt-pt": `Editar elemento`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    sm: `Fa'asa'o elemene`,
    so: `Edit element`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E4C}\u{E1B}\u{E23}\u{E30}\u{E01}\u{E2D}\u{E1A}`,
    ur: `\u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{639}\u{646}\u{635}\u{631}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a ph\u{1EA7}n t\u{1EED}`,
    "zh-hans": `\u{7F16}\u{8F91}\u{5143}\u{7D20}`,
    "zh-hant": `\u{7DE8}\u{8F2F}\u{5143}\u{7D20}`,
    en: `Edit element`
};
const $2868cc1235412e16$export$5a0ce4614252dcd9 = {
    ar: `\u{639}\u{633}\u{643}\u{631}\u{64A}`,
    de: `Privat`,
    es: `Privado`,
    fa: `\u{62E}\u{635}\u{648}\u{635}\u{6CC}`,
    fil: `Pribado`,
    fr: `Priv\xe9`,
    hi: `\u{92E}\u{93E}\u{92E}\u{942}\u{932}\u{940} \u{938}\u{93F}\u{92A}\u{93E}\u{939}\u{940}`,
    ht: `Pwive`,
    it: `Privato`,
    ja: `\u{30D7}\u{30E9}\u{30A4}\u{30D9}\u{30FC}\u{30C8}`,
    ko: `\u{BBFC}\u{AC04}\u{C758}`,
    mww: `ntiav`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Privado`,
    "pt-pt": `Privado`,
    ru: `\u{427}\u{430}\u{441}\u{442}\u{43D}\u{44B}\u{439}`,
    sm: `Tumaoti`,
    so: `Private`,
    th: `\u{E2A}\u{E48}\u{E27}\u{E19}\u{E15}\u{E31}\u{E27}`,
    ur: `\u{646}\u{62C}\u{6CC}`,
    vi: `T\u{1B0}`,
    "zh-hans": `\u{79C1}\u{4EBA}`,
    "zh-hant": `\u{79C1}\u{4EBA}`,
    en: `Private`
};
const $2868cc1235412e16$export$75570ba51b29968f = {
    ar: (date)=>$2868cc1235412e16$var$html`<span>تم التحديث ${date}</span>`,
    de: (date)=>$2868cc1235412e16$var$html`<span>Vor ${date} aktualisiert</span>`,
    es: (date)=>$2868cc1235412e16$var$html`<span>Actualizado ${date}</span>`,
    fa: (date)=>$2868cc1235412e16$var$html`<span>به روز ${date}</span>`,
    fil: (date)=>$2868cc1235412e16$var$html`<span>Nai-update ${date}</span>`,
    fr: (date)=>$2868cc1235412e16$var$html`<span>Mis à jour ${date}</span>`,
    hi: (date)=>$2868cc1235412e16$var$html`<span>अपडेटेड ${date}</span>`,
    ht: (date)=>$2868cc1235412e16$var$html`<span>Mizajou ${date}</span>`,
    it: (date)=>$2868cc1235412e16$var$html`<span>Aggiornato ${date}</span>`,
    ja: (date)=>$2868cc1235412e16$var$html`<span>${date}更新</span>`,
    ko: (date)=>$2868cc1235412e16$var$html`<span>마지막 업데이트 ${date}</span>`,
    mww: (date)=>$2868cc1235412e16$var$html`<span>Kho tshiab ${date}</span>`,
    ps: (date)=>$2868cc1235412e16$var$html`<span>تازه ${date}</span>`,
    pt: (date)=>$2868cc1235412e16$var$html`<span>Atualizado ${date}</span>`,
    "pt-pt": (date)=>$2868cc1235412e16$var$html`<span>Atualizado ${date}</span>`,
    ru: (date)=>$2868cc1235412e16$var$html`<span>Обновлено ${date}</span>`,
    sm: (date)=>$2868cc1235412e16$var$html`<span>Fa'afouina ${date}</span>`,
    so: (date)=>$2868cc1235412e16$var$html`<span>Updated ${date}</span>`,
    th: (date)=>$2868cc1235412e16$var$html`<span>อัพเดทเมื่อ ${date}</span>`,
    ur: (date)=>$2868cc1235412e16$var$html`<span>${date} اپ ڈیٹ کیا گیا</span>`,
    vi: (date)=>$2868cc1235412e16$var$html`<span>Cập nhật ${date}</span>`,
    "zh-hans": (date)=>$2868cc1235412e16$var$html`<span>3${date}更新</span>`,
    "zh-hant": (date)=>$2868cc1235412e16$var$html`<span>3${date}更新</span>`,
    en: (date)=>$2868cc1235412e16$var$html`<span>Updated ${date}</span>`
};
const $2868cc1235412e16$export$f679e9a796dab31c = {
    ar: `\u{627}\u{644}\u{62C}\u{646}\u{633}`,
    de: `Geschlecht`,
    es: `Sexo`,
    fa: ``,
    fil: `Kasarian`,
    fr: `Sexe `,
    hi: `\u{932}\u{93F}\u{902}\u{917}`,
    ht: `S\xe8ks`,
    it: `Sesso`,
    ja: `\u{6027}\u{5225}`,
    ko: `\u{C131}\u{BCC4} `,
    mww: `Pw ua ke`,
    ps: `\u{62C}\u{646}\u{633}`,
    pt: `Sexo`,
    "pt-pt": `Sexo`,
    ru: `\u{41F}\u{43E}\u{43B}`,
    sm: `Feusuaiga`,
    so: `Sex`,
    th: `\u{E40}\u{E1E}\u{E28}`,
    ur: `\u{62C}\u{646}\u{633}`,
    vi: `Gi\u{1EDB}i t\xednh`,
    "zh-hans": `\u{6027}\u{522B}`,
    "zh-hant": `\u{6027}\u{5225}`,
    en: `Sex`
};
const $2868cc1235412e16$export$61a240d3d3e2bc6c = {
    ar: `\u{62A}\u{62D}\u{631}\u{64A}\u{631} \u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{647}\u{630}\u{647}`,
    de: `Bearbeiten Sie dieses Dashboard`,
    es: `Editar este panel`,
    fa: `\u{627}\u{6CC}\u{646} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{648}\u{6CC}\u{631}\u{627}\u{6CC}\u{634} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `I-edit ang dashboard na ito`,
    fr: `Modifier ce tableau de bord`,
    hi: `\u{907}\u{938} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{915}\u{94B} \u{938}\u{902}\u{92A}\u{93E}\u{926}\u{93F}\u{924} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Edit tablodb\xf2 sa a`,
    it: `Modifica questa dashboard`,
    ja: `\u{3053}\u{306E}\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{3092}\u{7DE8}\u{96C6}`,
    ko: `\u{C774} \u{B300}\u{C2DC}\u{BCF4}\u{B4DC} \u{D3B8}\u{C9D1}`,
    mww: `Edit no dashboard`,
    ps: `\u{62F}\u{627} \u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{633}\u{645}\u{648}\u{646}`,
    pt: `Editar este painel`,
    "pt-pt": `Editar este painel`,
    ru: `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{44D}\u{442}\u{443} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{43C}\u{43E}\u{43D}\u{438}\u{442}\u{43E}\u{440}\u{438}\u{43D}\u{433}\u{430}`,
    sm: `Fa'asa'o lenei dashboard`,
    so: `Wax ka bedela isbeddelkaan`,
    th: `\u{E41}\u{E01}\u{E49}\u{E44}\u{E02}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E19}\u{E35}\u{E49}`,
    ur: `\u{627}\u{633} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{645}\u{6CC}\u{6BA} \u{62A}\u{631}\u{645}\u{6CC}\u{645} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9}nh s\u{1EED}a b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n n\xe0y`,
    "zh-hans": `\u{7F16}\u{8F91}\u{6B64}\u{4EEA}\u{8868}\u{677F}`,
    "zh-hant": `\u{7DE8}\u{8F2F}\u{6B64}\u{5100}\u{9336}\u{677F}`,
    en: `Edit this dashboard`
};
const $2868cc1235412e16$export$e527bc53a502a71e = {
    ar: `\u{62D}\u{62F}\u{62F} \u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Dashboard ausw\xe4hlen`,
    es: `Seleccionar panel de control`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Piliin ang dashboard`,
    fr: `S\xe9lectionner le tableau de bord`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{915}\u{93E} \u{91A}\u{92F}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Chwazi tablodb\xf2`,
    it: `Seleziona dashboard`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{3092}\u{9078}\u{629E}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{B97C} \u{C120}\u{D0DD}\u{D569}\u{B2C8}\u{B2E4}`,
    mww: `Xaiv dashboard`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{63A}\u{648}\u{631}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Selecione o painel`,
    "pt-pt": `Selecionar painel`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{434}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}`,
    sm: `Filifili le dashboard`,
    so: `Dooro dashboard`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `dashboard \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1ECD}n b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    "zh-hans": `\u{9009}\u{62E9}\u{4EEA}\u{8868}\u{677F}`,
    "zh-hant": `\u{9078}\u{64C7}\u{5100}\u{9336}\u{677F}`,
    en: `Select dashboard`
};
const $2868cc1235412e16$export$2bd44f364b60a031 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{644}\u{648}\u{62D}\u{627}\u{62A} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Keine Dashboards`,
    es: `Sin cuadros de mando`,
    fa: `\u{628}\u{62F}\u{648}\u{646} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}`,
    fil: `Walang mga dashboard`,
    fr: `Pas de tableaux de bord`,
    hi: `\u{915}\u{94B}\u{908} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Pa gen tablodb\xf2`,
    it: `Nessuna dashboard`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{306A}\u{3057}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC} \u{C5C6}\u{C74C}`,
    mww: `Tsis muaj dashboards`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `Sem pain\xe9is`,
    "pt-pt": `Sem pain\xe9is`,
    ru: `\u{41D}\u{435}\u{442} \u{434}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}\u{43E}\u{432}`,
    sm: `Leai ni dashboard`,
    so: `No dashboards`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} dashboards`,
    vi: `Kh\xf4ng c\xf3 b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    "zh-hans": `\u{65E0}\u{63A7}\u{5236}\u{9762}\u{677F}`,
    "zh-hant": `\u{7121}\u{63A7}\u{5236}\u{9762}\u{677F}`,
    en: `No dashboards`
};
const $2868cc1235412e16$export$31d8741dfa1c43a7 = {
    ar: `\u{644}\u{645} \u{62A}\u{62A}\u{645} \u{645}\u{634}\u{627}\u{631}\u{643}\u{629} \u{623}\u{64A} \u{644}\u{648}\u{62D}\u{627}\u{62A} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A} \u{645}\u{639}\u{643}.`,
    de: `Es wurden keine Dashboards f\xfcr Sie freigegeben.`,
    es: `No se ha compartido ning\xfan panel con usted.`,
    fa: `\u{647}\u{6CC}\u{686} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}\u{6CC} \u{628}\u{627} \u{634}\u{645}\u{627} \u{628}\u{647} \u{627}\u{634}\u{62A}\u{631}\u{627}\u{6A9} \u{6AF}\u{630}\u{627}\u{634}\u{62A}\u{647} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
    fil: `Walang mga dashboard na ibinahagi sa iyo.`,
    fr: `Aucun tableau de bord n\u{2019}a \xe9t\xe9 partag\xe9 avec vous.`,
    hi: `\u{906}\u{92A}\u{915}\u{947} \u{938}\u{93E}\u{925} \u{915}\u{94B}\u{908} \u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{938}\u{93E}\u{91D}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{915}\u{93F}\u{92F}\u{93E} \u{917}\u{92F}\u{93E} \u{939}\u{948}.`,
    ht: `Pa gen tablodb\xf2 yo te pataje av\xe8k ou.`,
    it: `Non \xe8 stata condivisa alcuna dashboard con l'utente.`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{304C}\u{5171}\u{6709}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{AC00} \u{ACF5}\u{C720}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj dashboards muaj tau muab qhia rau koj.`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{689} \u{644}\u{647} \u{62A}\u{627}\u{633}\u{648} \u{633}\u{631}\u{647} \u{634}\u{631}\u{6CC}\u{6A9} \u{634}\u{648}\u{6CC} \u{646}\u{647} \u{62F}\u{6CC}.`,
    pt: `Nenhum painel foi compartilhado com voc\xea.`,
    "pt-pt": `Nenhum painel foi compartilhado com voc\xea.`,
    ru: `\u{412}\u{430}\u{43C} \u{43D}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{435}\u{43D} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F} \u{43A} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44F}\u{43C} \u{43C}\u{43E}\u{43D}\u{438}\u{442}\u{43E}\u{440}\u{438}\u{43D}\u{433}\u{430}.`,
    sm: `E leai ni fa'ata'ita'iga na tufatufaina atu ia te oe.`,
    so: `No dashboards ayaa lala wadaago aad.`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E01}\u{E32}\u{E23}\u{E41}\u{E0A}\u{E23}\u{E4C}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}\u{E01}\u{E31}\u{E1A}\u{E04}\u{E38}\u{E13}`,
    ur: `\u{622}\u{67E} \u{6A9}\u{6D2} \u{633}\u{627}\u{62A}\u{6BE} \u{6A9}\u{648}\u{626}\u{6CC} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{634}\u{6CC}\u{626}\u{631} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6A9}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627} \u{6C1}\u{6D2}\u{6D4}`,
    vi: `Kh\xf4ng c\xf3 b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n n\xe0o \u{111}\u{1B0}\u{1EE3}c chia s\u{1EBB} v\u{1EDB}i b\u{1EA1}n.`,
    "zh-hans": `\u{5C1A}\u{672A}\u{4E0E}\u{60A8}\u{5171}\u{4EAB}\u{4EFB}\u{4F55}\u{63A7}\u{5236}\u{9762}\u{677F}\u{3002}`,
    "zh-hant": `\u{5C1A}\u{672A}\u{8207}\u{60A8}\u{5171}\u{7528}\u{4EFB}\u{4F55}\u{63A7}\u{5236}\u{9762}\u{677F}\u{3002}`,
    en: `No dashboards have been shared with you.`
};
const $2868cc1235412e16$export$8a05c018a7add2a1 = {
    ar: `\u{625}\u{646}\u{634}\u{627}\u{621} \u{644}\u{648}\u{62D}\u{629} \u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    de: `Erstellen eines Dashboards`,
    es: `Crear un panel de control`,
    fa: `\u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F}`,
    fil: `Email Address *`,
    fr: `Cr\xe9er un tableau de bord`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{92C}\u{928}\u{93E}\u{90F}\u{901}`,
    ht: `Kreye yon tablodb\xf2`,
    it: `Creare un dashboard`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{3092}\u{4F5C}\u{6210}\u{3059}\u{308B}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC} \u{B9CC}\u{B4E4}\u{AE30}`,
    mww: `Tsim ib dashboard`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{62C}\u{648}\u{693} \u{6A9}\u{693}\u{626}`,
    pt: `Criar um painel`,
    "pt-pt": `Criar um painel`,
    ru: `\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{435} \u{434}\u{430}\u{448}\u{431}\u{43E}\u{440}\u{434}\u{430}`,
    sm: `Fausia se dashboard`,
    so: `Samee shaashadda`,
    th: `\u{E2A}\u{E23}\u{E49}\u{E32}\u{E07}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14}`,
    ur: `\u{627}\u{6CC}\u{6A9} \u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{628}\u{646}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `T\u{1EA1}o b\u{1EA3}ng \u{111}i\u{1EC1}u khi\u{1EC3}n`,
    "zh-hans": `\u{521B}\u{5EFA}\u{63A7}\u{5236}\u{9762}\u{677F}`,
    "zh-hant": `\u{5275}\u{5EFA}\u{63A7}\u{5236}\u{9762}\u{677F}`,
    en: `Create a dashboard`
};
const $2868cc1235412e16$export$28f2b51f2446468e = {
    ar: `\u{62D}\u{62F}\u{62F} \u{644}\u{648}\u{62D}\u{629} \u{627}\u{644}\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}. \u{62D}\u{627}\u{644}\u{64A}:`,
    de: `W\xe4hlen Sie Dashboard aus. Str\xf6mung:`,
    es: `Seleccione el panel de control. Actual:`,
    fa: `\u{62F}\u{627}\u{634}\u{628}\u{648}\u{631}\u{62F} \u{631}\u{627} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{646}\u{6CC}\u{62F}. \u{641}\u{639}\u{644}\u{6CC}:`,
    fil: `Piliin ang dashboard. Kasalukuyang:`,
    fr: `S\xe9lectionnez le tableau de bord. Courant:`,
    hi: `\u{921}\u{948}\u{936}\u{92C}\u{94B}\u{930}\u{94D}\u{921} \u{91A}\u{941}\u{928}\u{947}\u{902}. \u{92A}\u{94D}\u{930}\u{935}\u{93E}\u{939}:`,
    ht: `Chwazi tablodb\xf2. Kouran:`,
    it: `Seleziona dashboard. Corrente:`,
    ja: `\u{30C0}\u{30C3}\u{30B7}\u{30E5}\u{30DC}\u{30FC}\u{30C9}\u{3092}\u{9078}\u{629E}\u{3057}\u{307E}\u{3059}\u{3002}\u{73FE}\u{5728}\u{306E}\u{FF1A}`,
    ko: `\u{B300}\u{C2DC}\u{BCF4}\u{B4DC}\u{B97C} \u{C120}\u{D0DD}\u{D569}\u{B2C8}\u{B2E4}. \u{C804}\u{B958}:`,
    mww: `Xaiv dashboard. Tam sim no:`,
    ps: `\u{689}\u{634}\u{628}\u{648}\u{631}\u{689} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{6A9}\u{693}\u{626}. \u{627}\u{648}\u{633}\u{646}\u{6CC}:`,
    pt: `Selecione o painel. Atual:`,
    "pt-pt": `Selecione painel. Atual:`,
    ru: `\u{412}\u{44B}\u{431}\u{435}\u{440}\u{438}\u{442}\u{435} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{44C} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{44F}. \u{422}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439}:`,
    sm: `Filifili le dashboard. Taimi nei:`,
    so: `Dooro dashboard. Hadda:`,
    th: `\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E41}\u{E14}\u{E0A}\u{E1A}\u{E2D}\u{E23}\u{E4C}\u{E14} \u{E1B}\u{E31}\u{E08}\u{E08}\u{E38}\u{E1A}\u{E31}\u{E19}:`,
    ur: `\u{688}\u{6CC}\u{634} \u{628}\u{648}\u{631}\u{688} \u{645}\u{646}\u{62A}\u{62E}\u{628} \u{6A9}\u{631}\u{6CC}\u{6BA}\u{6D4} \u{631}\u{648}:`,
    vi: `Ch\u{1ECD}n b\u{1EA3}ng th\xf4ng tin. D\xf2ng:`,
    "zh-hans": `\u{9009}\u{62E9} dashboard \u{FF08}\u{63A7}\u{5236}\u{9762}\u{677F}\u{FF09}\u{3002}\u{5F53}\u{524D}\u{FF1A}`,
    "zh-hant": `\u{9078}\u{64C7} dashboard \u{FF08}\u{63A7}\u{5236}\u{9762}\u{677F}\u{FF09}\u{3002}\u{76EE}\u{524D}\u{FF1A}`,
    en: `Select dashboard. Current:`
};
const $2868cc1235412e16$export$4712ee0299255910 = {
    ar: `\u{637}\u{628}\u{642}`,
    de: `Anwenden`,
    es: `Aplicar`,
    fa: `\u{62F}\u{631}\u{62E}\u{648}\u{627}\u{633}\u{62A}`,
    fil: `Mag-aplay`,
    fr: `Appliquer`,
    hi: `\u{932}\u{93E}\u{917}\u{942} \u{915}\u{930}\u{928}\u{93E}`,
    ht: `Aplike`,
    it: `Applicare`,
    ja: `\u{7533}\u{3057}\u{8FBC}\u{3080}`,
    ko: `\u{C801}\u{C6A9}\u{D558}\u{B2E4}`,
    mww: `Thov`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}`,
    pt: `Aplicar`,
    "pt-pt": `Candidatar-se`,
    ru: `\u{41F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{44F}\u{442}\u{44C}`,
    sm: `Talosaga`,
    so: `Codso`,
    th: `\u{E43}\u{E0A}\u{E49}`,
    ur: `\u{644}\u{6AF}\u{627}\u{626}\u{6CC}\u{6BA}`,
    vi: `\xc1p d\u{1EE5}ng`,
    "zh-hans": `\u{5E94}\u{7528}`,
    "zh-hant": `\u{61C9}\u{7528}`,
    en: `Apply`
};
const $2868cc1235412e16$export$54d71384411eecde = {
    ar: `\u{627}\u{639}\u{627}\u{62F}\u{647} \u{62A}\u{639}\u{64A}\u{64A}\u{646}`,
    de: `Zur\xfccksetzen`,
    es: `Restablecimiento`,
    fa: `\u{62A}\u{646}\u{638}\u{6CC}\u{645} \u{645}\u{62C}\u{62F}\u{62F}`,
    fil: `I-reset`,
    fr: `R\xe9initialisation`,
    hi: `\u{930}\u{940}\u{938}\u{947}\u{91F}`,
    ht: `Reyaji`,
    it: `Resettare`,
    ja: `\u{30EA}\u{30BB}\u{30C3}\u{30C8}`,
    ko: `\u{C7AC}\u{C124}\u{C815}`,
    mww: `reset`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC}`,
    pt: `Repor`,
    "pt-pt": `Repor`,
    ru: `\u{421}\u{431}\u{440}\u{43E}\u{441}`,
    sm: `Toe setiina`,
    so: `Dib u-eegid`,
    th: `\u{E23}\u{E35} \u{E40}\u{E0B}\u{E47}\u{E15}`,
    ur: `\u{633}\u{6CC}\u{679}`,
    vi: `Reset`,
    "zh-hans": `\u{91CD}\u{7F6E}`,
    "zh-hant": `\u{91CD}\u{7F6E}`,
    en: `Reset`
};
const $2868cc1235412e16$export$3ad2c0fa16cc7069 = {
    ar: `\u{627}\u{644}\u{627}\u{62F}\u{648}\u{64A}\u{647}`,
    de: `Medikamente`,
    es: `Medicamentos`,
    fa: `\u{62F}\u{627}\u{631}\u{648}\u{647}\u{627}`,
    fil: `Mga gamot`,
    fr: `M\xe9dicaments`,
    hi: `\u{926}\u{935}\u{93E}\u{913}\u{902}`,
    ht: `Medikaman`,
    it: `Farmaci`,
    ja: `\u{85AC}`,
    ko: `\u{C57D}\u{BB3C}`,
    mww: `Tshuaj`,
    ps: `\u{62F}\u{631}\u{645}\u{644}`,
    pt: `Medicamentos`,
    "pt-pt": `Medicamentos`,
    ru: `\u{41B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{430}`,
    sm: `Vaila'au`,
    so: `Daawooyinka`,
    th: `\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A}`,
    vi: `Thu\u{1ED1}c men`,
    "zh-hans": `\u{836F}\u{7269}`,
    "zh-hant": `\u{85E5}\u{7269}`,
    en: `Medications`
};
const $2868cc1235412e16$export$ce3f596f77dce502 = {
    ar: `\u{62F}\u{648}\u{627}\u{621}`,
    de: `Medikation`,
    es: `Medicaci\xf3n`,
    fa: `\u{62F}\u{627}\u{631}\u{648}`,
    fil: `Gamot`,
    fr: `M\xe9dicament`,
    hi: `\u{926}\u{935}\u{93E}`,
    ht: `Renm\xe8d`,
    it: `Medicazione`,
    ja: `\u{85AC}`,
    ko: `\u{C57D}\u{BB3C} \u{CE58}\u{B8CC}`,
    mww: `Tshuaj`,
    ps: `\u{62F}\u{631}\u{645}\u{644}`,
    pt: `Medica\xe7\xe3o`,
    "pt-pt": `Medica\xe7\xe3o`,
    ru: `\u{41B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Vaila'au`,
    so: `Daawada`,
    th: `\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A}`,
    vi: `Thu\u{1ED1}c`,
    "zh-hans": `\u{836F}\u{7269}`,
    "zh-hant": `\u{85E5}\u{7269}`,
    en: `Medication`
};
const $2868cc1235412e16$export$221f6232852822e8 = {
    ar: `\u{627}\u{644}\u{62C}\u{631}\u{639}\u{629} \u{648}\u{627}\u{644}\u{62A}\u{631}\u{62F}\u{62F}`,
    de: `Dosis & H\xe4ufigkeit`,
    es: `Dosis y frecuencia`,
    fa: `\u{62F}\u{648}\u{632} \u{648} \u{641}\u{631}\u{6A9}\u{627}\u{646}\u{633}`,
    fil: `Dosis at dalas`,
    fr: `Dose et fr\xe9quence`,
    hi: `\u{916}\u{941}\u{930}\u{93E}\u{915} & \u{906}\u{935}\u{943}\u{924}\u{94D}\u{924}\u{93F}`,
    ht: `D\xf2z ak frekans`,
    it: `Dose e frequenza`,
    ja: `\u{6295}\u{4E0E}\u{91CF}\u{3068}\u{983B}\u{5EA6}`,
    ko: `\u{BCF5}\u{C6A9}\u{B7C9} \u{BC0F} \u{BE48}\u{B3C4}`,
    mww: `qhov 10`,
    ps: `\u{689}\u{648}\u{632} \u{627}\u{648} \u{641}\u{631}\u{6CC}\u{6A9}\u{648}\u{646}\u{633}\u{6CC}`,
    pt: `Dose e frequ\xeancia`,
    "pt-pt": `Dose e frequ\xeancia`,
    ru: `\u{414}\u{43E}\u{437}\u{430} \u{438} \u{447}\u{430}\u{441}\u{442}\u{43E}\u{442}\u{430}`,
    sm: `Dose ma taimi`,
    so: `Dose & inta jeer`,
    th: `\u{E1B}\u{E23}\u{E34}\u{E21}\u{E32}\u{E13}\u{E41}\u{E25}\u{E30}\u{E04}\u{E27}\u{E32}\u{E21}\u{E16}\u{E35}\u{E48}`,
    ur: `\u{62E}\u{648}\u{631}\u{627}\u{6A9} \u{627}\u{648}\u{631} \u{641}\u{631}\u{6CC}\u{6A9}\u{648}\u{626}\u{646}\u{633}\u{6CC}`,
    vi: `Li\u{1EC1}u l\u{1B0}\u{1EE3}ng v\xe0 t\u{1EA7}n s\u{1ED1}`,
    "zh-hans": `\u{5242}\u{91CF}\u{548C}\u{9891}\u{7387}`,
    "zh-hant": `\u{5291}\u{91CF}\u{548C}\u{983B}\u{7387}`,
    en: `Dose & frequency`
};
const $2868cc1235412e16$export$e61a58cd3b6c5f7a = {
    ar: `\u{627}\u{644}\u{627}\u{633}\u{645} \u{648}\u{627}\u{644}\u{642}\u{648}\u{629} \u{648}\u{627}\u{644}\u{637}\u{631}\u{64A}\u{642} \u{648}\u{627}\u{644}\u{634}\u{643}\u{644}`,
    de: `Name, St\xe4rke, Strecke, Form`,
    es: `Nombre, fuerza, ruta, forma`,
    fa: `\u{646}\u{627}\u{645}\u{60C} \u{642}\u{62F}\u{631}\u{62A}\u{60C} \u{645}\u{633}\u{6CC}\u{631}\u{60C} \u{641}\u{631}\u{645}`,
    fil: `Pangalan, lakas, ruta, anyo`,
    fr: `Nom, force, parcours, forme`,
    hi: `\u{928}\u{93E}\u{92E}, \u{924}\u{93E}\u{915}\u{924}, \u{92E}\u{93E}\u{930}\u{94D}\u{917}, \u{930}\u{942}\u{92A}`,
    ht: `Non, f\xf2s, wout, f\xf2m`,
    it: `Nome, forza, percorso, forma`,
    ja: `\u{540D}\u{524D}\u{3001}\u{5F37}\u{3055}\u{3001}\u{30EB}\u{30FC}\u{30C8}\u{3001}\u{30D5}\u{30A9}\u{30FC}\u{30E0}`,
    ko: `\u{C774}\u{B984}, \u{D798}, \u{ACBD}\u{B85C}, \u{D615}\u{D0DC}`,
    mww: `Lub npe, lub zog, lawv, daim ntawv`,
    ps: `\u{646}\u{648}\u{645}\u{60C} \u{642}\u{648}\u{62A}\u{60C} \u{645}\u{633}\u{6CC}\u{631}\u{60C} \u{628}\u{6BC}\u{647}`,
    pt: `Nome, for\xe7a, rota, forma`,
    "pt-pt": `Nome, for\xe7a, rota, forma`,
    ru: `\u{41D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435}, \u{43F}\u{440}\u{43E}\u{447}\u{43D}\u{43E}\u{441}\u{442}\u{44C}, \u{43C}\u{430}\u{440}\u{448}\u{440}\u{443}\u{442}, \u{444}\u{43E}\u{440}\u{43C}\u{430}`,
    sm: `Igoa, malosi, auala, fomu`,
    so: `name, xoog, wadada, foomka`,
    th: `\u{E0A}\u{E37}\u{E48}\u{E2D} \u{E08}\u{E38}\u{E14}\u{E41}\u{E02}\u{E47}\u{E07} \u{E40}\u{E2A}\u{E49}\u{E19}\u{E17}\u{E32}\u{E07} \u{E41}\u{E1A}\u{E1A}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}`,
    ur: `\u{646}\u{627}\u{645}\u{60C} \u{637}\u{627}\u{642}\u{62A}\u{60C} \u{631}\u{627}\u{633}\u{62A}\u{6C1}\u{60C} \u{634}\u{6A9}\u{644}`,
    vi: `T\xean, th\u{1EBF} m\u{1EA1}nh, l\u{1ED9} tr\xecnh, h\xecnh th\u{1EE9}c`,
    "zh-hans": `\u{540D}\u{79F0}\u{3001}\u{5F3A}\u{5EA6}\u{3001}\u{8DEF}\u{7EBF}\u{3001}\u{5F62}\u{5F0F}`,
    "zh-hant": `\u{540D}\u{7A31}\u{3001}\u{5F37}\u{5EA6}\u{3001}\u{8DEF}\u{7DDA}\u{3001}\u{5F62}\u{5F0F}`,
    en: `Name, strength, route, form`
};
const $2868cc1235412e16$export$49c950bfab67049 = {
    ar: `\u{627}\u{644}\u{62C}\u{62F}\u{64A}\u{62F}\u{61F}`,
    de: `Neu?`,
    es: `\xbfNuevo?`,
    fa: `\u{62C}\u{62F}\u{6CC}\u{62F}?`,
    fil: `Bago?`,
    fr: `Nouveau?`,
    hi: `\u{928}\u{92F}\u{93E}?`,
    ht: `New?`,
    it: `Nuovo?`,
    ja: `\u{65B0}\u{6A5F}\u{80FD}\u{3002}`,
    ko: `\u{C0C8}\u{B85C}\u{C6B4}?`,
    mww: `Tshiab?`,
    ps: `\u{646}\u{648}\u{6CC}?`,
    pt: `Novo?`,
    "pt-pt": `Novo?`,
    ru: `\u{41D}\u{43E}\u{432}\u{44B}\u{435} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{438}?`,
    sm: `Fou?`,
    so: `Cusub?`,
    th: `\u{E43}\u{E2B}\u{E21}\u{E48} `,
    ur: `\u{646}\u{6CC}\u{627}?`,
    vi: `M\u{1EDB}i?`,
    "zh-hans": `\u{65B0}\u{589E}\u{529F}\u{80FD}\u{FF1F}`,
    "zh-hant": `\u{65B0}\u{589E}\u{529F}\u{80FD}\u{FF1F}`,
    en: `New?`
};
const $2868cc1235412e16$export$ce13d05b1c25268f = {
    ar: `\u{627}\u{644}\u{648}\u{627}\u{635}\u{641}`,
    de: `Arzt`,
    es: `Prescriptor`,
    fa: `\u{62A}\u{62C}\u{648}\u{6CC}\u{632} \u{6A9}\u{646}\u{646}\u{62F}\u{647}`,
    fil: `Tagapagreseta`,
    fr: `Prescripteur`,
    hi: `\u{92A}\u{94D}\u{930}\u{93F}\u{938}\u{94D}\u{915}\u{94D}\u{930}\u{93E}\u{907}\u{92C}\u{930}`,
    ht: `Preskri`,
    it: `Medico`,
    ja: `\u{51E6}\u{65B9}`,
    ko: `\u{CC98}\u{BC29}\u{C790}`,
    mww: `kws kho mob`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `M\xe9dico`,
    "pt-pt": `Prescritor`,
    ru: `\u{412}\u{440}\u{430}\u{447}, \u{43D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{430}\u{44E}\u{449}\u{438}\u{439} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{430}`,
    sm: `Prescriber`,
    so: `prescriber`,
    th: `\u{E1C}\u{E39}\u{E49}\u{E2A}\u{E31}\u{E48}\u{E07}\u{E08}\u{E48}\u{E32}\u{E22}\u{E22}\u{E32}`,
    ur: `\u{62A}\u{62C}\u{648}\u{6CC}\u{632} \u{6A9}\u{631}\u{646}\u{6D2} \u{648}\u{627}\u{644}\u{627}`,
    vi: `Ng\u{1B0}\u{1EDD}i k\xea \u{111}\u{1A1}n`,
    "zh-hans": `\u{5904}\u{65B9}\u{8005}`,
    "zh-hant": `\u{8655}\u{65B9}\u{8005}`,
    en: `Prescriber`
};
const $2868cc1235412e16$export$f3a7249fa8103164 = {
    ar: `\u{633}\u{628}\u{628}`,
    de: `Grund`,
    es: `Raz\xf3n`,
    fa: `\u{62F}\u{644}\u{6CC}\u{644}`,
    fil: `Dahilan`,
    fr: `Raison`,
    hi: `\u{915}\u{93E}\u{930}\u{923}`,
    ht: `Rezon`,
    it: `Ragione`,
    ja: `\u{7406}\u{7531}`,
    ko: `\u{C774}\u{C720}`,
    mww: `yog vim li cas`,
    ps: `\u{62F}\u{644}\u{6CC}\u{644}`,
    pt: `Raz\xe3o`,
    "pt-pt": `Justifica\xe7\xe3o`,
    ru: `\u{41F}\u{440}\u{438}\u{447}\u{438}\u{43D}\u{430}`,
    sm: `Mafua'aga`,
    so: `Sababta`,
    th: `\u{E40}\u{E2B}\u{E15}\u{E38}\u{E1C}\u{E25}`,
    ur: `\u{648}\u{62C}\u{6C1}`,
    vi: `L\xfd do`,
    "zh-hans": `\u{539F}\u{56E0}`,
    "zh-hant": `\u{539F}\u{56E0}`,
    en: `Reason`
};
const $2868cc1235412e16$export$47ed70605e6bc746 = {
    ar: `\u{623}\u{636}\u{641} \u{627}\u{644}\u{62F}\u{648}\u{627}\u{621}`,
    de: `Hinzuf\xfcgen von Medikamenten`,
    es: `Agregar medicamentos`,
    fa: `\u{62F}\u{627}\u{631}\u{648} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}`,
    fil: `Magdagdag ng gamot`,
    fr: `Ajouter des m\xe9dicaments`,
    hi: `\u{926}\u{935}\u{93E} \u{91C}\u{94B}\u{921}\u{93C}\u{947}\u{902}`,
    ht: `Ajoute renm\xe8d`,
    it: `Aggiungere farmaci`,
    ja: `\u{85AC}\u{3092}\u{8FFD}\u{52A0}\u{3059}\u{308B}`,
    ko: `\u{C57D}\u{BB3C} \u{CD94}\u{AC00}`,
    mww: `Ntxiv cov tshuaj noj`,
    ps: `\u{62F}\u{631}\u{645}\u{644} \u{627}\u{636}\u{627}\u{641}\u{647} \u{6A9}\u{693}\u{626}`,
    pt: `Adicionar medica\xe7\xe3o`,
    "pt-pt": `Adicionar medica\xe7\xe3o`,
    ru: `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{43E}`,
    sm: `Fa'aopopo vaila'au`,
    so: `Ku dar daaweynta`,
    th: `\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E22}\u{E32}`,
    ur: `\u{62F}\u{648}\u{627} \u{634}\u{627}\u{645}\u{644} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Th\xeam thu\u{1ED1}c`,
    "zh-hans": `\u{6DFB}\u{52A0}\u{836F}\u{7269}`,
    "zh-hant": `\u{6DFB}\u{52A0}\u{85E5}\u{7269}`,
    en: `Add medication`
};
const $2868cc1235412e16$export$b114e63c46d8a391 = {
    ar: `\u{62A}\u{644}\u{627}\u{62D}\u{638}`,
    de: `Notizen`,
    es: `Notas`,
    fa: `\u{6CC}\u{627}\u{62F}\u{62F}\u{627}\u{634}\u{62A}`,
    fil: `Mga Tala`,
    fr: `Notes`,
    hi: `\u{928}\u{94B}\u{91F}\u{94D}\u{938}`,
    ht: `N\xf2t`,
    it: `Note`,
    ja: `\u{7B46}\u{8A18}`,
    ko: `\u{B178}\u{D2B8}`,
    mww: `ntawv ceeb toom`,
    ps: `\u{6CC}\u{627}\u{62F}\u{69A}\u{62A}\u{648}\u{646}\u{647}`,
    pt: `Anota\xe7\xf5es`,
    "pt-pt": `Observa\xe7\xf5es`,
    ru: `\u{41F}\u{440}\u{438}\u{43C}\u{435}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Faamatalaga`,
    so: `Xigaal`,
    th: `\u{E2B}\u{E21}\u{E32}\u{E22} \u{E40}\u{E2B}\u{E15}\u{E38}`,
    ur: `\u{646}\u{648}\u{679}`,
    vi: `Ghi ch\xfa`,
    "zh-hans": `\u{7B14}\u{8BB0}`,
    "zh-hant": `\u{7B46}\u{8A18}`,
    en: `Notes`
};
const $2868cc1235412e16$export$ebd370d4ef2d3663 = {
    ar: `\u{627}\u{644}\u{627}\u{644}\u{62A}\u{632}\u{627}\u{645}`,
    de: `Einhaltung`,
    es: `Adherencia`,
    fa: `\u{67E}\u{627}\u{6CC}\u{628}\u{646}\u{62F}\u{6CC}`,
    fil: `Pagsunod`,
    fr: `Observance`,
    hi: `\u{92A}\u{93E}\u{932}\u{928}`,
    ht: `Konsperiksyon`,
    it: `Aderenza`,
    ja: `\u{30A2}\u{30C9}\u{30D2}\u{30A2}\u{30E9}\u{30F3}\u{30B9}`,
    ko: `\u{C900}\u{C218}`,
    mww: `Adherance`,
    ps: `\u{67E}\u{6CC}\u{631}\u{648}\u{6CC} \u{6A9}\u{648}\u{644}`,
    pt: `Ades\xe3o`,
    "pt-pt": `Ades\xe3o`,
    ru: `\u{41F}\u{440}\u{438}\u{432}\u{435}\u{440}\u{436}\u{435}\u{43D}\u{43D}\u{43E}\u{441}\u{442}\u{44C}`,
    sm: `Tausisia`,
    so: `hoggaansanaanta`,
    th: `\u{E01}\u{E32}\u{E23}\u{E22}\u{E36}\u{E14}\u{E21}\u{E31}\u{E48}\u{E19}`,
    ur: `\u{627}\u{637}\u{627}\u{639}\u{62A}`,
    vi: `S\u{1EF1} tu\xe2n th\u{1EE7}`,
    "zh-hans": `\u{4F9D}\u{4ECE}\u{6027}`,
    "zh-hant": `\u{4F9D}\u{5F9E}\u{6027}`,
    en: `Adherance`
};
const $2868cc1235412e16$export$491842644a914539 = {
    ar: `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{623}\u{62F}\u{648}\u{64A}\u{629}`,
    de: `Es gibt keine Medikamente`,
    es: `No hay medicamentos`,
    fa: `\u{647}\u{6CC}\u{686} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC} \u{648}\u{62C}\u{648}\u{62F} \u{646}\u{62F}\u{627}\u{631}\u{62F}`,
    fil: `Walang gamot`,
    fr: `Il n\u{2019}y a pas de m\xe9dicaments`,
    hi: `\u{915}\u{94B}\u{908} \u{926}\u{935}\u{93E} \u{928}\u{939}\u{940}\u{902} \u{939}\u{948}`,
    ht: `Pa gen medikaman`,
    it: `Non ci sono farmaci`,
    ja: `\u{85AC}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}`,
    ko: `\u{C57D}\u{C740} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`,
    mww: `Tsis muaj tshuaj noj`,
    ps: `\u{647}\u{6CC}\u{685} \u{62F}\u{631}\u{645}\u{644} \u{646}\u{634}\u{62A}\u{647}`,
    pt: `N\xe3o h\xe1 medicamentos`,
    "pt-pt": `N\xe3o h\xe1 medicamentos`,
    ru: `\u{41D}\u{435}\u{442} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}`,
    sm: `E leai ni vaila'au`,
    so: `Daawooyin malahan`,
    th: `\u{E44}\u{E21}\u{E48}\u{E21}\u{E35}\u{E22}\u{E32}`,
    ur: `\u{6A9}\u{648}\u{626}\u{6CC} \u{62F}\u{648}\u{627}\u{626}\u{6CC}\u{6BA} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng c\xf3 thu\u{1ED1}c`,
    "zh-hans": `\u{6CA1}\u{6709}\u{836F}\u{7269}`,
    "zh-hant": `\u{6C92}\u{6709}\u{85E5}\u{7269}`,
    en: `There are no medications`
};
const $2868cc1235412e16$export$76565219a9d3ec16 = {
    ar: `\u{644}\u{645} \u{64A}\u{62A}\u{645} \u{627}\u{644}\u{639}\u{62B}\u{648}\u{631} \u{639}\u{644}\u{649} \u{62A}\u{641}\u{627}\u{639}\u{644}\u{627}\u{62A} \u{62F}\u{648}\u{627}\u{626}\u{64A}\u{629}`,
    de: `Keine Wechselwirkungen mit Medikamenten gefunden`,
    es: `No se encontraron interacciones medicamentosas`,
    fa: `\u{647}\u{6CC}\u{686} \u{62A}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F}`,
    fil: `Walang natagpuang pakikipag-ugnayan sa gamot`,
    fr: `Aucune interaction m\xe9dicamenteuse n\u{2019}a \xe9t\xe9 constat\xe9e`,
    hi: `\u{915}\u{94B}\u{908} \u{926}\u{935}\u{93E} \u{907}\u{902}\u{91F}\u{930}\u{948}\u{915}\u{94D}\u{936}\u{928} \u{928}\u{939}\u{940}\u{902} \u{92E}\u{93F}\u{932}\u{93E}`,
    ht: `Pa gen ent\xe8raksyon medikaman yo te jwenn`,
    it: `Non sono state trovate interazioni farmacologiche`,
    ja: `\u{85AC}\u{306E}\u{76F8}\u{4E92}\u{4F5C}\u{7528}\u{306F}\u{898B}\u{3064}\u{304B}\u{308A}\u{307E}\u{305B}\u{3093}\u{3067}\u{3057}\u{305F}`,
    ko: `\u{C57D}\u{BB3C} \u{C0C1}\u{D638}\u{C791}\u{C6A9}\u{C774} \u{BC1C}\u{ACAC}\u{B418}\u{C9C0} \u{C54A}\u{C558}\u{C2B5}\u{B2C8}\u{B2E4}.`,
    mww: `Tsis muaj tshuaj kev sib tshuam nyob`,
    ps: `\u{62F} \u{62F}\u{631}\u{645}\u{644}\u{648} \u{647}\u{6CC}\u{685} \u{62A}\u{62F}\u{627}\u{62E}\u{644} \u{648}\u{646}\u{647} \u{645}\u{648}\u{646}\u{62F}\u{644} \u{634}\u{648}`,
    pt: `Nenhuma intera\xe7\xe3o medicamentosa encontrada`,
    "pt-pt": `N\xe3o foram encontradas intera\xe7\xf5es medicamentosas`,
    ru: `\u{412}\u{437}\u{430}\u{438}\u{43C}\u{43E}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F} \u{441} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{430}\u{43C}\u{438} \u{43D}\u{435} \u{43E}\u{431}\u{43D}\u{430}\u{440}\u{443}\u{436}\u{435}\u{43D}\u{43E}`,
    sm: `Leai ni fegalegaleaiga o vailaau na maua`,
    so: `wax daawo ah lama dhexgalin`,
    th: `\u{E44}\u{E21}\u{E48}\u{E1E}\u{E1A}\u{E1B}\u{E0F}\u{E34}\u{E01}\u{E34}\u{E23}\u{E34}\u{E22}\u{E32}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A} \u{6A9}\u{627} \u{6A9}\u{648}\u{626}\u{6CC} \u{62A}\u{639}\u{627}\u{645}\u{644} \u{646}\u{6C1}\u{6CC}\u{6BA} \u{67E}\u{627}\u{6CC}\u{627} \u{6AF}\u{6CC}\u{627}`,
    vi: `Kh\xf4ng t\xecm th\u{1EA5}y t\u{1B0}\u{1A1}ng t\xe1c thu\u{1ED1}c`,
    "zh-hans": `\u{672A}\u{53D1}\u{73B0}\u{836F}\u{7269}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    "zh-hant": `\u{672A}\u{767C}\u{73FE}\u{85E5}\u{7269}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    en: `No medication interactions found`
};
const $2868cc1235412e16$export$882d412b594b2f7f = {
    ar: `\u{627}\u{644}\u{62A}\u{641}\u{627}\u{639}\u{644}\u{627}\u{62A} \u{627}\u{644}\u{62F}\u{648}\u{627}\u{626}\u{64A}\u{629}`,
    de: `Wechselwirkungen mit Medikamenten`,
    es: `Interacciones medicamentosas`,
    fa: `\u{62A}\u{62F}\u{627}\u{62E}\u{644}\u{627}\u{62A} \u{62F}\u{627}\u{631}\u{648}\u{6CC}\u{6CC}`,
    fil: `Mga pakikipag-ugnayan sa gamot`,
    fr: `Interactions m\xe9dicamenteuses`,
    hi: `\u{926}\u{935}\u{93E} \u{92C}\u{93E}\u{924}\u{91A}\u{940}\u{924}`,
    ht: `Ent\xe8raksyon medikaman`,
    it: `Interazioni farmacologiche`,
    ja: `\u{85AC}\u{306E}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    ko: `\u{C57D}\u{BB3C} \u{C0C1}\u{D638} \u{C791}\u{C6A9}`,
    mww: `Cov tshuaj noj`,
    ps: `\u{62F} \u{62F}\u{631}\u{645}\u{644}\u{648} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{627}\u{62A}`,
    pt: `Intera\xe7\xf5es medicamentosas`,
    "pt-pt": `Intera\xe7\xf5es medicamentosas`,
    ru: `\u{412}\u{437}\u{430}\u{438}\u{43C}\u{43E}\u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{435} \u{441} \u{43B}\u{435}\u{43A}\u{430}\u{440}\u{441}\u{442}\u{432}\u{430}\u{43C}\u{438}`,
    sm: `Fegalegaleaiga o vaila'au`,
    so: `Is dhexgalka daawooyinka`,
    th: `\u{E1B}\u{E0F}\u{E34}\u{E01}\u{E34}\u{E23}\u{E34}\u{E22}\u{E32}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E22}\u{E32}`,
    ur: `\u{627}\u{62F}\u{648}\u{6CC}\u{627}\u{62A} \u{6A9}\u{6D2} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{627}\u{62A}`,
    vi: `T\u{1B0}\u{1A1}ng t\xe1c thu\u{1ED1}c`,
    "zh-hans": `\u{836F}\u{7269}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    "zh-hant": `\u{85E5}\u{7269}\u{76F8}\u{4E92}\u{4F5C}\u{7528}`,
    en: `Medication interactions`
};
const $2868cc1235412e16$export$3098cb3a0f5aeabc = {
    ar: `\u{623}\u{628}\u{62F}\u{627}`,
    de: `Nie`,
    es: `Nunca`,
    fa: `\u{647}\u{631}\u{6AF}\u{632}`,
    fil: `Hindi kailanman`,
    fr: `Jamais`,
    hi: `\u{915}\u{92D}\u{940} \u{928}\u{939}\u{940}\u{902}`,
    ht: `Janm`,
    it: `Mai`,
    ja: `\u{4E00}\u{5EA6}\u{3082}\u{306A}\u{3044}`,
    ko: `\u{ACB0}\u{CF54}`,
    mww: `yeej tsis`,
    ps: `\u{67E}\u{647} \u{62F}\u{6D0} \u{648}\u{631}\u{648}\u{633}\u{62A}\u{6CC}\u{648} \u{6A9}\u{6D0} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{648}\u{631}\u{646}\u{6CC}\u{648}`,
    pt: `Nunca`,
    "pt-pt": `Nunca`,
    ru: `\u{41D}\u{438}\u{43A}\u{43E}\u{433}\u{434}\u{430}`,
    sm: `E le'i`,
    so: `Marnaba`,
    th: `\u{E44}\u{E21}\u{E48}\u{E40}\u{E04}\u{E22}`,
    ur: `\u{6A9}\u{628}\u{6BE}\u{6CC} \u{646}\u{6C1}\u{6CC}\u{6BA}`,
    vi: `Kh\xf4ng bao gi\u{1EDD}`,
    "zh-hans": `\u{4ECE}\u{4E0D}`,
    "zh-hant": `\u{5F9E}\u{4E0D}`,
    en: `Never`
};
const $2868cc1235412e16$export$66ca751dbda0aefb = {
    ar: `\u{645}\u{639}\u{631}\u{641}\u{627}\u{62A}`,
    de: `Bezeichner`,
    es: `Identificadores`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647}`,
    fil: `Mga Identifier`,
    fr: `Identificateurs`,
    hi: `\u{92A}\u{939}\u{91A}\u{93E}\u{928}\u{915}\u{930}\u{94D}\u{924}\u{93E}`,
    ht: `Idantifyan`,
    it: `Identificatori`,
    ja: `\u{8B58}\u{5225}\u{5B50}`,
    ko: `\u{C2DD}\u{BCC4}\u{C790}`,
    mww: `Qhia Txog Cov Neeg Paub Txog Cov Neeg`,
    ps: `\u{67E}\u{6D0}\u{698}\u{646}\u{62F}\u{648}\u{646}\u{6A9}\u{6CC}`,
    pt: `Identificadores`,
    "pt-pt": `Identificadores`,
    ru: `\u{418}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440}\u{44B}`,
    sm: `Fa'ailoaina`,
    so: `Wax-garanayaa`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}`,
    ur: `Identifiers`,
    vi: `M\xe3 \u{111}\u{1ECB}nh danh`,
    "zh-hans": `\u{6807}\u{8BC6}\u{7B26}`,
    "zh-hant": `\u{6A19}\u{8B58}\u{78BC}`,
    en: `Identifiers`
};
const $2868cc1235412e16$export$c11b37785f183e45 = {
    ar: `\u{62F}\u{645}\u{62C}...`,
    de: `Verschmelzen...`,
    es: `Fusionar...`,
    fa: `\u{627}\u{62F}\u{63A}\u{627}\u{645}...`,
    fil: `Pagsamahin ...`,
    fr: `Fusionner...`,
    hi: `\u{921}\u{941}\u{92C}\u{94B}\u{964}\u{964}\u{964}`,
    ht: `Fer\xf2s ...`,
    it: `Fondersi...`,
    ja: `\u{30DE}\u{30FC}\u{30B8}\u{3002}\u{3002}\u{3002}`,
    ko: `\u{BCD1}\u{D569}...`,
    mww: `Merge...`,
    ps: `\u{627}\u{62F}\u{63A}\u{627}\u{645}...`,
    pt: `Fundir...`,
    "pt-pt": `Mesclar...`,
    ru: `\u{421}\u{43B}\u{438}\u{432}\u{430}\u{442}\u{44C}...`,
    sm: `Tu'ufa'atasia...`,
    so: `Haku...`,
    th: `\u{E04}\u{E27}\u{E1A}   `,
    ur: `\u{636}\u{645}...`,
    vi: `Merge...`,
    "zh-hans": `\u{5408}\u{5E76}\u{3002}\u{3002}\u{3002}`,
    "zh-hant": `\u{5408}\u{4F75}\u{3002}\u{3002}\u{3002}`,
    en: `Merge...`
};
const $2868cc1235412e16$export$35592e87641eee6 = {
    ar: `\u{645}\u{628}\u{627}\u{62F}\u{644}\u{647}...`,
    de: `Tauschen...`,
    es: `Intercambio...`,
    fa: `\u{645}\u{628}\u{627}\u{62F}\u{644}\u{647}...`,
    fil: `Palitan ...`,
    fr: `\xc9changer...`,
    hi: `\u{935}\u{93F}\u{928}\u{93F}\u{92E}\u{92F} \u{915}\u{930}\u{928}\u{93E}\u{964}\u{964}\u{964}`,
    ht: `Swap ...`,
    it: `Barattare...`,
    ja: `\u{30B9}\u{30EF}\u{30C3}\u{30D7}\u{3002}\u{3002}\u{3002}`,
    ko: `\u{AD50}\u{D658}...`,
    mww: `Swap...`,
    ps: `\u{645}\u{628}\u{627}\u{62F}\u{644}\u{647}...`,
    pt: `Trocar...`,
    "pt-pt": `Trocar...`,
    ru: `\u{41E}\u{431}\u{43C}\u{435}\u{43D}\u{438}\u{432}\u{430}\u{442}\u{44C}...`,
    sm: `Fesuia'i...`,
    so: `Isku bedel...`,
    th: `\u{E41}\u{E25}\u{E01}   `,
    ur: `\u{62A}\u{628}\u{627}\u{62F}\u{644}\u{6C1} \u{6A9}\u{631}\u{6CC}\u{6BA} ...`,
    vi: `Trao \u{111}\u{1ED5}i...`,
    "zh-hans": `\u{4EA4}\u{6362}\u{3002}\u{3002}\u{3002}`,
    "zh-hant": `\u{4EA4}\u{63DB}\u{3002}\u{3002}\u{3002}`,
    en: `Swap...`
};
const $2868cc1235412e16$export$b8208eb80f0d07f4 = {
    ar: `\u{627}\u{644}\u{62A}\u{643}\u{631}\u{627}\u{631}\u{627}\u{62A} \u{623}\u{648} \u{627}\u{644}\u{639}\u{644}\u{627}\u{642}\u{627}\u{62A} \u{627}\u{644}\u{645}\u{62D}\u{62A}\u{645}\u{644}\u{629}`,
    de: `M\xf6gliche Duplikate oder Beziehungen`,
    es: `Posibles duplicados o relaciones`,
    fa: `\u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{6CC} \u{647}\u{627} \u{6CC}\u{627} \u{631}\u{648}\u{627}\u{628}\u{637} \u{628}\u{627}\u{644}\u{642}\u{648}\u{647}`,
    fil: `Mga potensyal na duplicate o relasyon`,
    fr: `Doublons ou relations potentiels`,
    hi: `\u{938}\u{902}\u{92D}\u{93E}\u{935}\u{93F}\u{924} \u{921}\u{941}\u{92A}\u{94D}\u{932}\u{93F}\u{915}\u{947}\u{91F} \u{92F}\u{93E} \u{938}\u{902}\u{92C}\u{902}\u{927}`,
    ht: `Potansy\xe8l kopi oswa relasyon`,
    it: `Potenziali duplicati o relazioni`,
    ja: `\u{91CD}\u{8907}\u{307E}\u{305F}\u{306F}\u{95A2}\u{4FC2}\u{306E}\u{53EF}\u{80FD}\u{6027}`,
    ko: `\u{C7A0}\u{C7AC}\u{C801} \u{C911}\u{BCF5} \u{B610}\u{B294} \u{AD00}\u{ACC4}`,
    mww: `Tej duplicates los yog relations`,
    ps: `\u{645}\u{645}\u{6A9}\u{646}\u{647} \u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{6CC} \u{6CC}\u{627} \u{627}\u{693}\u{6CC}\u{6A9}\u{6D0}`,
    pt: `Duplicatas ou rela\xe7\xf5es potenciais`,
    "pt-pt": `Potenciais duplicados ou rela\xe7\xf5es`,
    ru: `\u{41F}\u{43E}\u{442}\u{435}\u{43D}\u{446}\u{438}\u{430}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{434}\u{443}\u{431}\u{43B}\u{438}\u{43A}\u{430}\u{442}\u{44B} \u{438}\u{43B}\u{438} \u{441}\u{432}\u{44F}\u{437}\u{438}`,
    sm: `Ono fa'aluaina po'o feso'ota'iga`,
    so: `Duplicates ama xiriirka suurtagalka ah`,
    th: `\u{E04}\u{E27}\u{E32}\u{E21}\u{E0B}\u{E49}\u{E4D}\u{E32}\u{E0B}\u{E49}\u{E2D}\u{E19}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E2A}\u{E31}\u{E21}\u{E1E}\u{E31}\u{E19}\u{E18}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E32}\u{E08}\u{E40}\u{E01}\u{E34}\u{E14}\u{E02}\u{E36}\u{E49}\u{E19}`,
    ur: `\u{645}\u{645}\u{6A9}\u{646}\u{6C1} \u{646}\u{642}\u{644} \u{6CC}\u{627} \u{62A}\u{639}\u{644}\u{642}\u{627}\u{62A}`,
    vi: `C\xe1c b\u{1EA3}n sao ho\u{1EB7}c m\u{1ED1}i quan h\u{1EC7} ti\u{1EC1}m \u{1EA9}n`,
    "zh-hans": `\u{53EF}\u{80FD}\u{7684}\u{91CD}\u{590D}\u{9879}\u{6216}\u{5173}\u{7CFB}`,
    "zh-hant": `\u{53EF}\u{80FD}\u{7684}\u{91CD}\u{8907}\u{9805}\u{6216}\u{95DC}\u{4FC2}`,
    en: `Potential duplicates or relations`
};
const $2868cc1235412e16$export$5e1f42c18cafdbb = {
    ar: `\u{645}\u{628}\u{627}\u{631}\u{64A}\u{627}\u{62A}`,
    de: `Streichh\xf6lzer`,
    es: `Partidos`,
    fa: `\u{645}\u{633}\u{627}\u{628}\u{642}\u{627}\u{62A}`,
    fil: `Mga Tugma`,
    fr: `Allumettes`,
    hi: `\u{92E}\u{948}\u{91A}`,
    ht: `Alim\xe8t`,
    it: `Corrisponde`,
    ja: `\u{4E00}\u{81F4}`,
    ko: `\u{C131}\u{B0E5}`,
    mww: `qhov yuam kev`,
    ps: `\u{644}\u{648}\u{628}\u{6D0}`,
    pt: `Corresponde`,
    "pt-pt": `Jogos`,
    ru: `\u{421}\u{43F}\u{438}\u{447}\u{43A}\u{438}`,
    sm: `Ta'aloga`,
    so: `Matches`,
    th: `\u{E44}\u{E21}\u{E49}\u{E02}\u{E35}\u{E14}\u{E44}\u{E1F}`,
    ur: `\u{645}\u{634}\u{627}\u{628}\u{6C1}`,
    vi: `Tr\u{1EAD}n \u{111}\u{1EA5}u`,
    "zh-hans": `\u{6BD4}\u{8D5B}`,
    "zh-hant": `\u{6BD4}\u{8CFD}`,
    en: `Matches`
};
const $2868cc1235412e16$export$3d8419edd48b3be2 = {
    ar: `\u{633}\u{64A}\u{631} \u{627}\u{644}\u{639}\u{645}\u{644}`,
    de: `Arbeitsablauf`,
    es: `Flujo de trabajo`,
    fa: `\u{6AF}\u{631}\u{62F}\u{634}`,
    fil: `Daloy ng Trabaho`,
    fr: `Flux de travail`,
    hi: `\u{915}\u{93E}\u{930}\u{94D}\u{92F}\u{92A}\u{94D}\u{930}\u{935}\u{93E}\u{939}`,
    ht: `Workflow`,
    it: `Flusso di lavoro`,
    ja: `\u{30EF}\u{30FC}\u{30AF}\u{30D5}\u{30ED}\u{30FC}`,
    ko: `\u{C6CC}\u{D06C}\u{D50C}\u{B85C}\u{C6B0}`,
    mww: `ua hauj lwm`,
    ps: `\u{62F} \u{6A9}\u{627}\u{631} \u{62C}\u{631}\u{6CC}\u{627}\u{646}`,
    pt: `Fluxo de trabalho`,
    "pt-pt": `Fluxo de trabalho`,
    ru: `\u{420}\u{430}\u{431}\u{43E}\u{447}\u{438}\u{439} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}`,
    sm: `Fa'agaioiga`,
    so: `Socodka Shaqada`,
    th: `\u{E40}\u{E27}\u{E34}\u{E23}\u{E4C}\u{E01}\u{E42}\u{E1F}\u{E25}\u{E27}\u{E4C}`,
    ur: `\u{648}\u{631}\u{6A9} \u{641}\u{644}\u{648}`,
    vi: `Quy tr\xecnh l\xe0m vi\u{1EC7}c`,
    "zh-hans": `\u{5DE5}\u{4F5C}\u{6D41}`,
    "zh-hant": `\u{5DE5}\u{4F5C}\u{6D41}`,
    en: `Workflow`
};
const $2868cc1235412e16$export$5f39c8ed730140a6 = {
    ar: `\u{62A}\u{648}\u{627}\u{631}\u{64A}\u{62E} \u{627}\u{644}\u{628}\u{62F}\u{621} \u{648}\u{627}\u{644}\u{627}\u{646}\u{62A}\u{647}\u{627}\u{621}`,
    de: `Start- und Enddatum`,
    es: `Fechas de inicio y finalizaci\xf3n`,
    fa: `\u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{634}\u{631}\u{648}\u{639} \u{648} \u{67E}\u{627}\u{6CC}\u{627}\u{646}`,
    fil: `Mga Petsa ng Pagsisimula at Pagtatapos`,
    fr: `Dates de d\xe9but et de fin`,
    hi: `\u{92A}\u{94D}\u{930}\u{93E}\u{930}\u{902}\u{92D} \u{914}\u{930} \u{938}\u{92E}\u{93E}\u{92A}\u{94D}\u{924}\u{93F} \u{926}\u{93F}\u{928}\u{93E}\u{902}\u{915}`,
    ht: `K\xf2manse - dat fen`,
    it: `Date di inizio e fine`,
    ja: `\u{958B}\u{59CB}\u{65E5}\u{3068}\u{7D42}\u{4E86}\u{65E5}`,
    ko: `\u{C2DC}\u{C791} \u{BC0F} \u{C885}\u{B8CC} \u{B0A0}\u{C9DC}`,
    mww: `Hnub Pib Hnub Tim`,
    ps: `\u{62F} \u{67E}\u{6CC}\u{644} \u{627}\u{648} \u{67E}\u{627}\u{6CC} \u{646}\u{6CC}\u{67C}\u{6D0}`,
    pt: `Datas de in\xedcio e t\xe9rmino`,
    "pt-pt": `Datas de in\xedcio e de fim`,
    ru: `\u{414}\u{430}\u{442}\u{44B} \u{43D}\u{430}\u{447}\u{430}\u{43B}\u{430} \u{438} \u{43E}\u{43A}\u{43E}\u{43D}\u{447}\u{430}\u{43D}\u{438}\u{44F}`,
    sm: `Aso amata ma fa'ai'u`,
    so: `Taariikhda Start & dhamaadka`,
    th: `\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E41}\u{E25}\u{E30}\u{E2A}\u{E34}\u{E49}\u{E19}\u{E2A}\u{E38}\u{E14}`,
    ur: `\u{622}\u{63A}\u{627}\u{632} \u{627}\u{648}\u{631} \u{627}\u{62E}\u{62A}\u{62A}\u{627}\u{645} \u{6A9}\u{6CC} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{6CC}\u{6BA}`,
    vi: `Ng\xe0y b\u{1EAF}t \u{111}\u{1EA7}u v\xe0 ng\xe0y k\u{1EBF}t th\xfac`,
    "zh-hans": `\u{5F00}\u{59CB}\u{548C}\u{7ED3}\u{675F}\u{65E5}\u{671F}`,
    "zh-hant": `\u{958B}\u{59CB}\u{548C}\u{7D50}\u{675F}\u{65E5}\u{671F}`,
    en: `Start & end dates`
};
const $2868cc1235412e16$export$82c671dcad5e7ee8 = {
    ar: `\u{627}\u{644}\u{62A}\u{639}\u{64A}\u{64A}\u{646} \u{644}\u{64A}`,
    de: `Mir zuweisen`,
    es: `Asignarme a m\xed`,
    fa: `\u{628}\u{647} \u{645}\u{646} \u{627}\u{62E}\u{62A}\u{635}\u{627}\u{635} \u{62F}\u{647}\u{6CC}\u{62F}`,
    fil: `Atasan mo ako`,
    fr: `Attribuez-moi`,
    hi: `\u{92E}\u{941}\u{91D}\u{947} \u{905}\u{938}\u{93E}\u{907}\u{928} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Asiyen m`,
    it: `Assegna a me`,
    ja: `\u{81EA}\u{5206}\u{306B}\u{5272}\u{308A}\u{5F53}\u{3066}\u{308B}`,
    ko: `\u{B098}\u{C5D0}\u{AC8C} \u{D560}\u{B2F9}`,
    mww: `Txib kuv mus ua haujlwm rau kuv`,
    ps: `\u{645}\u{627} \u{62A}\u{647} \u{633}\u{67E}\u{627}\u{631}\u{644}`,
    pt: `Atribua a mim`,
    "pt-pt": `Atribuir-me`,
    ru: `\u{41D}\u{430}\u{437}\u{43D}\u{430}\u{447}\u{44C}\u{442}\u{435} \u{43C}\u{43D}\u{435}`,
    sm: `Tofi mai ia te a'u`,
    so: `Iina dhaari`,
    th: `\u{E21}\u{E2D}\u{E1A}\u{E2B}\u{E21}\u{E32}\u{E22}\u{E43}\u{E2B}\u{E49}\u{E09}\u{E31}\u{E19}`,
    ur: `\u{645}\u{62C}\u{6BE}\u{6D2} \u{62A}\u{641}\u{648}\u{6CC}\u{636} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Ch\u{1EC9} \u{111}\u{1ECB}nh cho t\xf4i`,
    "zh-hans": `\u{5206}\u{914D}\u{7ED9}\u{6211}`,
    "zh-hant": `\u{5206}\u{914D}\u{7D66}\u{6211}`,
    en: `Assign to me`
};
const $2868cc1235412e16$export$cca989f3b2769926 = {
    ar: `\u{645}\u{639}\u{631}\u{641} \u{627}\u{644}\u{645}\u{634}\u{627}\u{631}\u{643} SCSEP`,
    de: `SCSEP-Teilnehmer-ID`,
    es: `ID de participante de SCSEP`,
    fa: `\u{634}\u{646}\u{627}\u{633}\u{647} \u{634}\u{631}\u{6A9}\u{62A} \u{6A9}\u{646}\u{646}\u{62F}\u{647} SCSEP`,
    fil: `ID ng Kalahok ng SCSEP`,
    fr: `SCSEP Participant ID`,
    hi: `SCSEP \u{92A}\u{94D}\u{930}\u{924}\u{93F}\u{92D}\u{93E}\u{917}\u{940} \u{906}\u{908}\u{921}\u{940}`,
    ht: `SCSEP Patisipan ID`,
    it: `ID partecipante SCSEP`,
    ja: `SCSEP\u{53C2}\u{52A0}\u{8005}ID`,
    ko: `SCSEP \u{CC38}\u{AC00}\u{C790} ID`,
    mww: `SCSEP TUS NEEG KOOM ID`,
    ps: `\u{62F} SCSEP \u{62F} \u{6AB}\u{689}\u{648}\u{646}\u{648}\u{627}\u{644}\u{648} ID`,
    pt: `ID do participante do SCSEP`,
    "pt-pt": `ID do Participante SCSEP`,
    ru: `\u{418}\u{434}\u{435}\u{43D}\u{442}\u{438}\u{444}\u{438}\u{43A}\u{430}\u{442}\u{43E}\u{440} \u{443}\u{447}\u{430}\u{441}\u{442}\u{43D}\u{438}\u{43A}\u{430} SCSEP`,
    sm: `SCSEP ID Tagata Auai`,
    so: `SCSEP ID Kaqeybgalayaasha`,
    th: `\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E1C}\u{E39}\u{E49}\u{E40}\u{E02}\u{E49}\u{E32}\u{E23}\u{E48}\u{E27}\u{E21} SCSEP`,
    ur: `SCSEP \u{634}\u{631}\u{6A9}\u{627}\u{621} ID`,
    vi: `ID ng\u{1B0}\u{1EDD}i tham gia SCSEP`,
    "zh-hans": `SCSEP \u{53C2}\u{4E0E}\u{8005} ID`,
    "zh-hant": `SCSEP \u{53C3}\u{8207}\u{8005}ID`,
    en: `SCSEP Participant ID`
};
const $2868cc1235412e16$export$c9f73a5b7a46c2df = {
    ar: `\u{625}\u{639}\u{62F}\u{627}\u{62F} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{646}\u{62F}\u{627}\u{62A}`,
    de: `Vorbereiten von Dokumenten`,
    es: `Preparar documentos`,
    fa: `\u{62A}\u{647}\u{6CC}\u{647} \u{627}\u{633}\u{646}\u{627}\u{62F}`,
    fil: `Maghanda ng mga dokumento`,
    fr: `Pr\xe9parer des documents`,
    hi: `\u{926}\u{938}\u{94D}\u{924}\u{93E}\u{935}\u{947}\u{91C}\u{93C} \u{924}\u{948}\u{92F}\u{93E}\u{930} \u{915}\u{930}\u{947}\u{902}`,
    ht: `Dokiman prepare yo`,
    it: `Preparare i documenti`,
    ja: `\u{66F8}\u{985E}\u{306E}\u{6E96}\u{5099}`,
    ko: `\u{C11C}\u{B958} \u{C900}\u{BE44}`,
    mww: `Npaj cov ntaub ntawv`,
    ps: `\u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}\u{67C} \u{645}\u{644}\u{6CC} \u{644}\u{648}\u{628}\u{689}\u{644}\u{647} \u{62F} \u{627}\u{641}\u{63A}\u{627}\u{646}\u{633}\u{62A}\u{627}\u{646} \u{62F} \u{6A9}\u{631}\u{6A9}`,
    pt: `Preparar documentos`,
    "pt-pt": `Preparar documentos`,
    ru: `\u{41F}\u{43E}\u{434}\u{433}\u{43E}\u{442}\u{43E}\u{432}\u{43A}\u{430} \u{434}\u{43E}\u{43A}\u{443}\u{43C}\u{435}\u{43D}\u{442}\u{43E}\u{432}`,
    sm: `Saunia pepa aloaia`,
    so: `Diyaari dokumentiyo`,
    th: `\u{E40}\u{E15}\u{E23}\u{E35}\u{E22}\u{E21}\u{E40}\u{E2D}\u{E01}\u{E2A}\u{E32}\u{E23}`,
    ur: `\u{62F}\u{633}\u{62A}\u{627}\u{648}\u{6CC}\u{632}\u{627}\u{62A} \u{62A}\u{6CC}\u{627}\u{631} \u{6A9}\u{631}\u{6CC}\u{6BA}`,
    vi: `Chu\u{1EA9}n b\u{1ECB} h\u{1ED3} s\u{1A1}`,
    "zh-hans": `\u{51C6}\u{5907}\u{6587}\u{4EF6}`,
    "zh-hant": `\u{6E96}\u{5099}\u{6A94}`,
    en: `Prepare documents`
};


/* eslint-disable no-control-regex */ function $c5391a1f4c2c7212$export$2e2bcd8739ae039() {
    return /[<>:"/\\|?*\u0000-\u001F]/g;
}
function $c5391a1f4c2c7212$export$a0701abe10a1ba48() {
    return /^(con|prn|aux|nul|com\d|lpt\d)$/i;
}


// Doesn't make sense to have longer filenames
const $426ea2ef2dc61d30$var$MAX_FILENAME_LENGTH = 100;
const $426ea2ef2dc61d30$var$reRelativePath = /^\.+(\\|\/)|^\.+$/;
const $426ea2ef2dc61d30$var$reTrailingPeriods = /\.+$/;
function $426ea2ef2dc61d30$export$2e2bcd8739ae039(string, options = {}) {
    const reControlChars = /[\u0000-\u001F\u0080-\u009F]/g; // eslint-disable-line no-control-regex
    const reRepeatedReservedCharacters = /([<>:"/\\|?*\u0000-\u001F]){2,}/g; // eslint-disable-line no-control-regex
    if (typeof string !== "string") throw new TypeError("Expected a string");
    const replacement = options.replacement === undefined ? "!" : options.replacement;
    if ((0, $c5391a1f4c2c7212$export$2e2bcd8739ae039)().test(replacement) && reControlChars.test(replacement)) throw new Error("Replacement string cannot contain reserved filename characters");
    if (replacement.length > 0) string = string.replace(reRepeatedReservedCharacters, "$1");
    string = string.normalize("NFD");
    string = string.replace($426ea2ef2dc61d30$var$reRelativePath, replacement);
    string = string.replace((0, $c5391a1f4c2c7212$export$2e2bcd8739ae039)(), replacement);
    string = string.replace(reControlChars, replacement);
    string = string.replace($426ea2ef2dc61d30$var$reTrailingPeriods, "");
    if (replacement.length > 0) {
        const startedWithDot = string[0] === ".";
        // We removed the whole filename
        if (!startedWithDot && string[0] === ".") string = replacement + string;
        // We removed the whole extension
        if (string[string.length - 1] === ".") string += replacement;
    }
    string = (0, $c5391a1f4c2c7212$export$a0701abe10a1ba48)().test(string) ? string + replacement : string;
    const allowedLength = typeof options.maxLength === "number" ? options.maxLength : $426ea2ef2dc61d30$var$MAX_FILENAME_LENGTH;
    if (string.length > allowedLength) {
        const extensionIndex = string.lastIndexOf(".");
        if (extensionIndex === -1) string = string.slice(0, allowedLength);
        else {
            const filename = string.slice(0, extensionIndex);
            const extension = string.slice(extensionIndex);
            string = filename.slice(0, Math.max(1, allowedLength - extension.length)) + extension;
        }
    }
    return string;
}


function $a3570cdd24dfa717$export$3f063810d7bf01bd(array, f) {
    return array.reduce((a, b)=>((a[f(b)] = a[f(b)] || []).push(b), a), {});
}
function $a3570cdd24dfa717$export$e439fc32198f78c5(array, key) {
    return array.reduce((accumulator, current)=>{
        accumulator[current[key]] = current;
        return accumulator;
    }, {});
}
function $a3570cdd24dfa717$export$eeced19e3078b2f(array, k1, k2) {
    return array.reduce((a, b)=>{
        var _a, _b, _c;
        a[_a = b[k1]] ?? (a[_a] = {});
        (_b = a[b[k1]])[_c = b[k2]] ?? (_b[_c] = b);
        return a;
    }, {});
}
function $a3570cdd24dfa717$export$1eac5cf31c6aee74(array, k1, k2, k3) {
    return array.reduce((a, b)=>{
        var _a, _b, _c, _d, _e;
        a[_a = b[k1]] ?? (a[_a] = {});
        (_b = a[b[k1]])[_c = b[k2]] ?? (_b[_c] = {});
        (_d = a[b[k1]][b[k2]])[_e = b[k3]] ?? (_d[_e] = b);
        return a;
    }, {});
}
function $a3570cdd24dfa717$export$c6d5318223f85e84(array, property) {
    if (!array) return array;
    for (const item of array)item[property] ?? (item[property] = []);
    return array;
}


// @ts-ignore
/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ const { replace: $a407f9e3395b9e28$var$replace } = "";
// escape
const $a407f9e3395b9e28$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
const $a407f9e3395b9e28$var$ca = /[&<>'"]/g;
const $a407f9e3395b9e28$var$esca = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "'": "&#39;",
    '"': "&quot;"
};
const $a407f9e3395b9e28$var$pe = (m)=>$a407f9e3395b9e28$var$esca[m];
const $a407f9e3395b9e28$export$4e7f196112fea3c5 = (es)=>$a407f9e3395b9e28$var$replace.call(es, $a407f9e3395b9e28$var$ca, $a407f9e3395b9e28$var$pe);
// unescape
const $a407f9e3395b9e28$var$unes = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"'
};
const $a407f9e3395b9e28$var$cape = (m)=>$a407f9e3395b9e28$var$unes[m];
const $a407f9e3395b9e28$export$e8bacd2802a88316 = (un)=>$a407f9e3395b9e28$var$replace.call(un, $a407f9e3395b9e28$var$es, $a407f9e3395b9e28$var$cape);


const $904f4b114d3dc756$export$acafce1f52201e8f = (0, $a407f9e3395b9e28$export$4e7f196112fea3c5);
const $904f4b114d3dc756$var$TEMPLATE_RESULT = Symbol.for("cumulus.templates.result");
const $904f4b114d3dc756$var$UNSAFE_HTML = Symbol.for("cumulus.templates.unsafe-html");
function $904f4b114d3dc756$export$6b6d145ec2a44ca9(value) {
    return value?.[$904f4b114d3dc756$var$TEMPLATE_RESULT] === true;
}
function $904f4b114d3dc756$export$1c5c14473d9c43aa(value) {
    return value?.[$904f4b114d3dc756$var$UNSAFE_HTML] === true;
}
/*#__NO_SIDE_EFFECTS__*/ function $904f4b114d3dc756$export$c0bb0b647f701bb5(strings, ...values) {
    return {
        [$904f4b114d3dc756$var$TEMPLATE_RESULT]: true,
        strings: strings,
        values: values
    };
}
function $904f4b114d3dc756$export$b3890eb0ae9dca99(value) {
    if (value === null || value === undefined || value === "") return "";
    if (Array.isArray(value)) {
        let result = "";
        for (const item of value)result += $904f4b114d3dc756$export$b3890eb0ae9dca99(item);
        return result;
    }
    if ($904f4b114d3dc756$export$6b6d145ec2a44ca9(value)) {
        const { strings: strings, values: values } = value;
        let result = strings[0];
        for(let i = 1; i < strings.length; i++){
            const value = values[i - 1];
            result += $904f4b114d3dc756$export$b3890eb0ae9dca99(value);
            result += strings[i];
        }
        return result;
    }
    if ($904f4b114d3dc756$export$1c5c14473d9c43aa(value)) return value.value;
    if (typeof value === "function") throw new Error(`Cannot render function "${value.name}"`);
    return $904f4b114d3dc756$export$acafce1f52201e8f(typeof value === "string" ? value : String(value));
}
function $904f4b114d3dc756$export$b6e69390c23686fb(value) {
    return {
        [$904f4b114d3dc756$var$UNSAFE_HTML]: true,
        value: typeof value === "string" ? value : String(value)
    };
}
function $904f4b114d3dc756$export$7aabe8b3a840d2fd(name, value) {
    return value === null || value === undefined || value === "" ? "" : {
        [$904f4b114d3dc756$var$UNSAFE_HTML]: true,
        value: `${$904f4b114d3dc756$export$acafce1f52201e8f(name)}="${$904f4b114d3dc756$export$acafce1f52201e8f(value)}"`
    };
}
function $904f4b114d3dc756$export$65c20e333206336e(name, value) {
    return Boolean(value) ? {
        [$904f4b114d3dc756$var$UNSAFE_HTML]: true,
        value: $904f4b114d3dc756$export$acafce1f52201e8f(name)
    } : "";
} /*
export function renderStream(value: unknown): ReadableStream<Uint8Array> {
  const abortController = new AbortController();
  return new ReadableStream<Uint8Array>({
    async start(controller) {
      const encoder = new TextEncoder();
      await pushValue(value, controller, encoder, abortController.signal);
      controller.close();
    },
    cancel() {
      abortController.abort();
    }
  });
}

async function pushValue(
  value: unknown,
  controller: ReadableStreamController<Uint8Array>,
  encoder: TextEncoder,
  signal: AbortSignal
): Promise<void> {
  if (value === null || value === undefined || value === '' || signal.aborted) {
    return;
  } else if (Array.isArray(value)) {
    for (let i = 0; i < value.length && !signal.aborted; i++) {
      await pushValue(value[i], controller, encoder, signal);
    }
  } else if (isTemplateResult(value)) {
    const { strings, values } = value;
    controller.enqueue(encoder.encode(strings[0]));
    for (let i = 1; i < strings.length; i++) {
      const value = values[i - 1];
      await pushValue(value, controller, encoder, signal);
      controller.enqueue(encoder.encode(strings[i]));
    }
  } else if (value instanceof UnsafeHTML) {
    controller.enqueue(encoder.encode(value.value));
  } else {
    controller.enqueue(
      encoder.encode(
        htmlEncode(typeof value === 'string' ? value : String(value))
      )
    );
  }
}

// async function pushStream(stream: ReadableStream<Uint8Array>, controller: StreamController, cancellationToken: CancellationToken) {
//   const reader = stream.getReader();
//   do {
//     const { value, done } = await reader.read();
//     if (done || cancellationToken.cancelled) {
//       reader.releaseLock();
//       return;
//     }
//     controller.enqueue(value);
//   } while (true);
// }
*/ 


let $5cb959b633531006$var$elementId = 0;
const $5cb959b633531006$var$prefix = "document" in self ? "c" : "s";
function $5cb959b633531006$export$9e1c824dbb29e809() {
    if ($5cb959b633531006$var$elementId > 99999) $5cb959b633531006$var$elementId = 0;
    const time = Date.now().toString().substr(7);
    return `${$5cb959b633531006$var$prefix}-${time}-${$5cb959b633531006$var$elementId++}`;
}


const $2b6d0b8c1c80c786$export$8e47d324a7a20b30 = `<path fill-rule="evenodd" d="M8.22 1.754a.25.25 0 00-.44 0L1.698 13.132a.25.25 0 00.22.368h12.164a.25.25 0 00.22-.368L8.22 1.754zm-1.763-.707c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0114.082 15H1.918a1.75 1.75 0 01-1.543-2.575L6.457 1.047zM9 11a1 1 0 11-2 0 1 1 0 012 0zm-.25-5.25a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5z"></path>`;
const $2b6d0b8c1c80c786$export$8876d4884ff726da = `<path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>`;
const $2b6d0b8c1c80c786$export$72f74af526a6ffa1 = `<path fill-rule="evenodd" d="M13.03 8.22a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06 0L3.47 9.28a.75.75 0 011.06-1.06l2.97 2.97V3.75a.75.75 0 011.5 0v7.44l2.97-2.97a.75.75 0 011.06 0z"></path>`;
const $2b6d0b8c1c80c786$export$b33367dcc885f1a3 = `<path d="M7.78 12.53a.75.75 0 0 1-1.06 0L2.47 8.28a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L4.81 7h7.44a.75.75 0 0 1 0 1.5H4.81l2.97 2.97a.75.75 0 0 1 0 1.06Z"></path>`;
const $2b6d0b8c1c80c786$export$767fa712cf880535 = `<path xmlns="http://www.w3.org/2000/svg" d="M1.078 4A8.05 8.05 0 0 1 4 1.078 7.77 7.77 0 0 1 8 0a7.782 7.782 0 0 1 4.008 1.078A8.061 8.061 0 0 1 14.922 4 7.778 7.778 0 0 1 16 8a7.778 7.778 0 0 1-1.078 4.008 8.061 8.061 0 0 1-2.914 2.914A7.782 7.782 0 0 1 8 16a7.77 7.77 0 0 1-4-1.078A8.05 8.05 0 0 1 1.078 12.008 7.778 7.778 0 0 1 0 8a7.778 7.778 0 0 1 1.078-4ZM2.464 11.2A6.429 6.429 0 0 0 4.8 13.534 6.189 6.189 0 0 0 8 14.4a6.192 6.192 0 0 0 3.2-.864A6.461 6.461 0 0 0 13.534 11.2 6.219 6.219 0 0 0 14.4 8a6.219 6.219 0 0 0-.864-3.2A6.474 6.474 0 0 0 11.2 2.466 6.208 6.208 0 0 0 8 1.6a6.203 6.203 0 0 0-3.2.864A6.424 6.424 0 0 0 2.466 4.8 6.189 6.189 0 0 0 1.6 8a6.202 6.202 0 0 0 .864 3.2Zm4.176-6.162a.8.8 0 1 1 1.12 1.12L6.72 7.2H11.2a.8.8 0 0 1 0 1.6H6.72l1.038 1.038a.792.792 0 0 1 0 1.12.846 .846 0 0 1-.266.179A.763.763 0 0 1 7.2 11.2a.779.779 0 0 1-.306-.062.763 .763 0 0 1-.258-.179l-2.4-2.4a.8.8 0 0 1 0-1.12Z"/>`;
const $2b6d0b8c1c80c786$export$5df4efc90df1058f = `<path d="M8.22 2.97a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l2.97-2.97H3.75a.75.75 0 0 1 0-1.5h7.44L8.22 4.03a.75.75 0 0 1 0-1.06Z"></path>`;
const $2b6d0b8c1c80c786$export$9dd82c5e7dc8bd87 = `<path d="M5.22 14.78a.75.75 0 001.06-1.06L4.56 12h8.69a.75.75 0 000-1.5H4.56l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3a.75.75 0 000 1.06l3 3zm5.56-6.5a.75.75 0 11-1.06-1.06l1.72-1.72H2.75a.75.75 0 010-1.5h8.69L9.72 2.28a.75.75 0 011.06-1.06l3 3a.75.75 0 010 1.06l-3 3z"></path>`;
const $2b6d0b8c1c80c786$export$a1740d5cfdc2be60 = `<path d="M7.28033 3.21967C6.98744 2.92678 6.51256 2.92678 6.21967 3.21967C5.92678 3.51256 5.92678 3.98744 6.21967 4.28033L7.28033 3.21967ZM11 8L11.5303 8.53033C11.8232 8.23744 11.8232 7.76256 11.5303 7.46967L11 8ZM6.21967 11.7197C5.92678 12.0126 5.92678 12.4874 6.21967 12.7803C6.51256 13.0732 6.98744 13.0732 7.28033 12.7803L6.21967 11.7197ZM6.21967 4.28033L10.4697 8.53033L11.5303 7.46967L7.28033 3.21967L6.21967 4.28033ZM10.4697 7.46967L6.21967 11.7197L7.28033 12.7803L11.5303 8.53033L10.4697 7.46967Z" fill="currentColor"></path>        <path d="M1.75 8H11" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"></path>`;
const $2b6d0b8c1c80c786$export$ea7efdf5db05b94a = `<path fill-rule="evenodd" d="M3.47 7.78a.75.75 0 010-1.06l4.25-4.25a.75.75 0 011.06 0l4.25 4.25a.75.75 0 01-1.06 1.06L9 4.81v7.44a.75.75 0 01-1.5 0V4.81L4.53 7.78a.75.75 0 01-1.06 0z"></path>`;
const $2b6d0b8c1c80c786$export$1d14184fc69e8cc4 = `<path d="m14.12 7.66.38-.4zm-.33-1.44-.51-.19zm-.55 5.3-.18-.51zm-10.48 0-.17.53zm.92 1.16-.54.06zm-1.8-5.02-.39-.4zm9.44-4.55-.07-.54zm1.2-.14-.07-.54zm2.46 5.54.38-.4zm-.6 2.63.18.51zm-2.2 2.74.55.06zm-2.42 1.18-.3.46zm-8.14-3.92-.18.51zm-.6-2.63-.39-.4zm.78-3.43-.51.18zm7.08-3.35.64 1.03.93-.58-.64-1.02zm4.86 6.32.85.85.77-.78-.86-.85zm.46 2.57-1.14.39.35 1.04 1.15-.4zm-7.23 3.32-1.02.65.59.93 1.01-.65zm-2.61-.11-.13-1.2-1.1.11.14 1.2zm-1.64-7.8-.4-1.13-1.03.36.4 1.14zm.7-2.52 1.2.15.13-1.09-1.2-.14zm7.96.15 1.2-.15-.13-1.08-1.2.14zm2.3 1.24-.4 1.13 1.03.37.4-1.14zm-1.9 7.73-.14 1.2 1.1.11.12-1.2zm-1.73 1.96-1.02-.65-.59.93 1.02.65zm-7.11-3.58-1.14-.4-.36 1.04 1.15.4zM1.4 8.9l.86-.85-.77-.78-.85.85zm5.08-6.14.64-1.03-.94-.57-.63 1.02zm3.04 0c1.19 1.92 2.6 3.7 4.22 5.29l.76-.78a27.47 27.47 0 0 1-4.05-5.09zm3.76 3.27a28.56 28.56 0 0 0-1.5 6.6l1.08.11c.23-2.16.71-4.29 1.45-6.34zm-.22 4.98a28.57 28.57 0 0 0-6.1 2.93l.6.93a27.46 27.46 0 0 1 5.85-2.82zm-4.03 2.93a28.56 28.56 0 0 0-6.09-2.93l-.35 1.04c2.05.7 4.02 1.65 5.85 2.82zm-4.8-1.31a28.57 28.57 0 0 0-1.5-6.6l-1.04.37a27.47 27.47 0 0 1 1.45 6.34zM2.26 8.05a28.57 28.57 0 0 0 4.22-5.29l-.93-.58a27.47 27.47 0 0 1-4.06 5.09zm2.36-4.4c2.24.27 4.51.27 6.76 0l-.13-1.08c-2.16.26-4.34.26-6.5 0zm7.96-.14c.77-.09 1.36.66 1.1 1.39l1.03.36a2.13 2.13 0 0 0-2.26-2.83zm2.01 5.39c.55.54.34 1.47-.39 1.72l.36 1.03a2.13 2.13 0 0 0 .8-3.53zm-2.95 4.93a1.04 1.04 0 0 1-1.59.76l-.59.93c1.34.85 3.1 0 3.27-1.58zm-5.7.76c-.64.42-1.5 0-1.58-.76l-1.1.11a2.13 2.13 0 0 0 3.28 1.58zM1.8 10.62a1.04 1.04 0 0 1-.4-1.72l-.76-.78a2.13 2.13 0 0 0 .8 3.53zm.52-5.72a1.04 1.04 0 0 1 1.1-1.39l.13-1.08a2.13 2.13 0 0 0-2.26 2.83zm7.5-3.74a2.13 2.13 0 0 0-3.64 0l.94.57c.4-.65 1.36-.65 1.76 0z"/>`; // fill="url(#a)"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.0923 -8.3005 0 8 8.34)" gradientUnits="userSpaceOnUse"><stop stop-color="color(display-p3 0.5783 0.7961 1.0000)" offset=".08"/><stop stop-color="#fff" offset=".22"/><stop stop-color="color(display-p3 1.0000 0.5647 0.0157)" offset=".5"/><stop stop-color="color(display-p3 1.0000 0.1804 0.3294)" offset=".64"/><stop stop-color="color(display-p3 0.7882 0.3490 0.8667)" offset=".79"/><stop stop-color="color(display-p3 0.3652 0.4097 1.0000)" offset=".93"/><stop stop-color="color(display-p3 0.0314 0.5804 1.0000)" offset="1"/></radialGradient></defs>`;
const $2b6d0b8c1c80c786$export$5a60ac14d02c69a0 = `<path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>`;
const $2b6d0b8c1c80c786$export$dba03d59741ce6c8 = `<path d="M8 16c.9 0 1.7-.6 1.9-1.5.1-.3-.1-.5-.4-.5h-3c-.3 0-.5.2-.4.5.2.9 1 1.5 1.9 1.5zM3 5c0-2.8 2.2-5 5-5s5 2.2 5 5v3l1.7 2.6c.2.2.3.5.3.8 0 .8-.7 1.5-1.5 1.5h-11c-.8.1-1.5-.6-1.5-1.4 0-.3.1-.6.3-.8L3 8.1V5z"></path>`;
const $2b6d0b8c1c80c786$export$43ae52d85fcc090c = `<path d="M8 16a2 2 0 001.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 008 16z"></path><path fill-rule="evenodd" d="M8 1.5A3.5 3.5 0 004.5 5v2.947c0 .346-.102.683-.294.97l-1.703 2.556a.018.018 0 00-.003.01l.001.006c0 .002.002.004.004.006a.017.017 0 00.006.004l.007.001h10.964l.007-.001a.016.016 0 00.006-.004.016.016 0 00.004-.006l.001-.007a.017.017 0 00-.003-.01l-1.703-2.554a1.75 1.75 0 01-.294-.97V5A3.5 3.5 0 008 1.5zM3 5a5 5 0 0110 0v2.947c0 .05.015.098.042.139l1.703 2.555A1.518 1.518 0 0113.482 13H2.518a1.518 1.518 0 01-1.263-2.36l1.703-2.554A.25.25 0 003 7.947V5z"></path>`;
const $2b6d0b8c1c80c786$export$86c0dcb57a5f8c32 = `<path fill-rule="evenodd" d="M8 1.5c-.997 0-1.895.416-2.534 1.086A.75.75 0 014.38 1.55 5 5 0 0113 5v2.373a.75.75 0 01-1.5 0V5A3.5 3.5 0 008 1.5zM4.182 4.31L1.19 2.143a.75.75 0 10-.88 1.214L3 5.305v2.642a.25.25 0 01-.042.139L1.255 10.64A1.518 1.518 0 002.518 13h11.108l1.184.857a.75.75 0 10.88-1.214l-1.375-.996a1.196 1.196 0 00-.013-.01L4.198 4.321a.733.733 0 00-.016-.011zm7.373 7.19L4.5 6.391v1.556c0 .346-.102.683-.294.97l-1.703 2.556a.018.018 0 00-.003.01.015.015 0 00.005.012.017.017 0 00.006.004l.007.001h9.037zM8 16a2 2 0 001.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 008 16z"></path>`;
const $2b6d0b8c1c80c786$export$66ee21e7ebe4d5a1 = `<path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z"/>`;
const $2b6d0b8c1c80c786$export$f65a0a3b7c4c12f8 = `<path fill-rule="evenodd" d="M4 2a1 1 0 00-1 1v10a1 1 0 001 1h5.5a3.5 3.5 0 001.852-6.47A3.5 3.5 0 008.5 2H4zm4.5 5a1.5 1.5 0 100-3H5v3h3.5zM5 9v3h4.5a1.5 1.5 0 000-3H5z"></path>`;
const $2b6d0b8c1c80c786$export$a3176a3f11884722 = `<path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434L7.752.066ZM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567L4.25 7.504ZM7.5 9.933l-2.75 1.571v3.134l2.75-1.571V9.933Zm1 3.134 2.75 1.571v-3.134L8.5 9.933v3.134Zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567-2.742 1.567Zm2.242-2.433V3.504L8.5 5.076V8.21l2.75-1.572ZM7.5 8.21V5.076L4.75 3.504v3.134L7.5 8.21ZM5.258 2.643 8 4.21l2.742-1.567L8 1.076 5.258 2.643ZM15 9.933l-2.75 1.571v3.134L15 13.067V9.933ZM3.75 14.638v-3.134L1 9.933v3.134l2.75 1.571Z"/>`;
const $2b6d0b8c1c80c786$export$2809c772b85876db = `<path fill-rule="evenodd" d="M12 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z" /><path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z" />`;
const $2b6d0b8c1c80c786$export$2daa3271a740c7f = `<path fill-rule="evenodd" d="M4.75 0a.75.75 0 01.75.75V2h5V.75a.75.75 0 011.5 0V2h1.25c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0113.25 16H2.75A1.75 1.75 0 011 14.25V3.75C1 2.784 1.784 2 2.75 2H4V.75A.75.75 0 014.75 0zm0 3.5h8.5a.25.25 0 01.25.25V6h-11V3.75a.25.25 0 01.25-.25h2zm-2.25 4v6.75c0 .138.112.25.25.25h10.5a.25.25 0 00.25-.25V7.5h-11z"></path>`;
const $2b6d0b8c1c80c786$export$cfe4c2456a8e9cec = `<path fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zM0 8a8 8 0 1116 0A8 8 0 010 8zm11.78-1.72a.75.75 0 00-1.06-1.06L6.75 9.19 5.28 7.72a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l4.5-4.5z"></path>`;
const $2b6d0b8c1c80c786$export$1d8a03084661a191 = `<path clip-rule="evenodd" d="M13.78 4.22C13.9204 4.36062 13.9993 4.55125 13.9993 4.75C13.9993 4.94875 13.9204 5.13937 13.78 5.28L6.53 12.53C6.38937 12.6704 6.19875 12.7493 6 12.7493C5.80125 12.7493 5.61062 12.6704 5.47 12.53L2.22 9.28C2.08752 9.13782 2.0154 8.94978 2.01882 8.75547C2.02225 8.56117 2.10096 8.37579 2.23838 8.23837C2.37579 8.10096 2.56118 8.02225 2.75548 8.01882C2.94978 8.01539 3.13782 8.08752 3.28 8.22L6 10.94L12.72 4.22C12.8606 4.07955 13.0512 4.00066 13.25 4.00066C13.4487 4.00066 13.6394 4.07955 13.78 4.22Z" fill-rule="evenodd"></path>`;
const $2b6d0b8c1c80c786$export$6c57c2db28ec0463 = `<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"/>`;
const $2b6d0b8c1c80c786$export$67ff0f0b11735e67 = `<path d="M12.78 5.22a.749.749 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.06 0L3.22 6.28a.749.749 0 1 1 1.06-1.06L8 8.939l3.72-3.719a.749.749 0 0 1 1.06 0Z"></path>`;
const $2b6d0b8c1c80c786$export$36dd5cc8453b5c87 = `<path d="M9.78 12.78a.75.75 0 0 1-1.06 0L4.47 8.53a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L6.06 8l3.72 3.72a.75.75 0 0 1 0 1.06Z"></path>`;
const $2b6d0b8c1c80c786$export$8f4ec4b8fe2dedbf = `<path fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 0110.535-5.096l-9.131 9.131A6.472 6.472 0 011.5 8zm2.465 5.096a6.5 6.5 0 009.131-9.131l-9.131 9.131zM8 0a8 8 0 100 16A8 8 0 008 0z"></path>`;
const $2b6d0b8c1c80c786$export$def956fbe4c089ce = `<path d="M8 0a8 8 0 110 16A8 8 0 018 0zM1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm7-3.25v2.992l2.028.812a.75.75 0 01-.557 1.392l-2.5-1A.751.751 0 017 8.25v-3.5a.75.75 0 011.5 0z"></path>`;
const $2b6d0b8c1c80c786$export$8df73a8168f3e24 = `<path fill-rule="evenodd" d="M4.72 3.22a.75.75 0 011.06 1.06L2.06 8l3.72 3.72a.75.75 0 11-1.06 1.06L.47 8.53a.75.75 0 010-1.06l4.25-4.25zm6.56 0a.75.75 0 10-1.06 1.06L13.94 8l-3.72 3.72a.75.75 0 101.06 1.06l4.25-4.25a.75.75 0 000-1.06l-4.25-4.25z"></path>`;
const $2b6d0b8c1c80c786$export$567379feebbba9f8 = `<path fill-rule="evenodd" d="M2 1.75C2 .784 2.784 0 3.75 0h8.5C13.216 0 14 .784 14 1.75v5a1.75 1.75 0 01-1.75 1.75h-8.5A1.75 1.75 0 012 6.75v-5zm1.75-.25a.25.25 0 00-.25.25v5c0 .138.112.25.25.25h8.5a.25.25 0 00.25-.25v-5a.25.25 0 00-.25-.25h-8.5zM0 11.25c0-.966.784-1.75 1.75-1.75h12.5c.966 0 1.75.784 1.75 1.75v3A1.75 1.75 0 0114.25 16H1.75A1.75 1.75 0 010 14.25v-3zM1.75 11a.25.25 0 00-.25.25v3c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25v-3a.25.25 0 00-.25-.25H1.75z"></path><path fill-rule="evenodd" d="M3 12.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zm4 0a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z"></path>`;
const $2b6d0b8c1c80c786$export$8ce8aa57598ad27f = `<path fill-rule="evenodd" d="M2.75 2.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 01.75.75v2.19l2.72-2.72a.75.75 0 01.53-.22h4.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25H2.75zM1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0113.25 12H9.06l-2.573 2.573A1.457 1.457 0 014 13.543V12H2.75A1.75 1.75 0 011 10.25v-7.5z"></path>`;
const $2b6d0b8c1c80c786$export$a3743ca7417fb23c = `<path d="M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016zm6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="m6.94 7.44 4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z"/>`;
const $2b6d0b8c1c80c786$export$e3d4d49f14b4dd60 = `<path fill-rule="evenodd" d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"></path><path fill-rule="evenodd" d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"></path>`;
const $2b6d0b8c1c80c786$export$36e22210a5796abb = `<path d="M2 7.75A.75.75 0 0 1 2.75 7h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2 7.75Z"></path>`;
const $2b6d0b8c1c80c786$export$8b21631039c9cb0f = `<path d="M1.5 3.25c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 5.75 7.5h-2.5A1.75 1.75 0 0 1 1.5 5.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5A1.75 1.75 0 0 1 8.5 5.75Zm-7 7c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75Zm7 0c0-.966.784-1.75 1.75-1.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a1.75 1.75 0 0 1-1.75 1.75h-2.5a1.75 1.75 0 0 1-1.75-1.75ZM3.25 3a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5A.25.25 0 0 0 6 5.75v-2.5A.25.25 0 0 0 5.75 3Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm-7 7a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm7 0a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Z"></path>`;
const $2b6d0b8c1c80c786$export$83e001942a7b7758 = `<path d="M16 3.75v8.5a.75.75 0 0 1-1.136.643L11 10.575v.675A1.75 1.75 0 0 1 9.25 13h-7.5A1.75 1.75 0 0 1 0 11.25v-6.5C0 3.784.784 3 1.75 3h7.5c.966 0 1.75.784 1.75 1.75v.675l3.864-2.318A.75.75 0 0 1 16 3.75Zm-6.5 1a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v6.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-6.5ZM11 8.825l3.5 2.1v-5.85l-3.5 2.1Z"></path>`;
const $2b6d0b8c1c80c786$export$33eb75283052a3f = `<path d="M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"></path><path d="M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z"></path>`;
const $2b6d0b8c1c80c786$export$3b2c6f2708eaa4f9 = `<path d="M10.5 3a.75.75 0 0 1 .75.75v1h1a.75.75 0 0 1 0 1.5h-1v1a.75.75 0 0 1-1.5 0v-1h-1a.75.75 0 0 1 0-1.5h1v-1A.75.75 0 0 1 10.5 3Z"></path><path d="M6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5C5 .784 5.784 0 6.75 0ZM6.5 1.75v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25Z"></path><path d="M1.75 5A1.75 1.75 0 0 0 0 6.75v7.5C0 15.216.784 16 1.75 16h7.5A1.75 1.75 0 0 0 11 14.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.25.25 0 0 1-.25.25h-7.5a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25h1.5a.75.75 0 0 0 0-1.5h-1.5Z"></path>`;
const $2b6d0b8c1c80c786$export$eea9d1a211eff38f = `<path d="M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V5.5zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>`;
const $2b6d0b8c1c80c786$export$be704fe733d78a38 = `<path d="M8 2c1.981 0 3.671.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.62 1.62 0 0 1 0 1.798c-.45.678-1.367 1.932-2.637 3.023C11.67 13.008 9.981 14 8 14c-1.981 0-3.671-.992-4.933-2.078C1.797 10.83.88 9.576.43 8.898a1.62 1.62 0 0 1 0-1.798c.45-.677 1.367-1.931 2.637-3.022C4.33 2.992 6.019 2 8 2ZM1.679 7.932a.12.12 0 0 0 0 .136c.411.622 1.241 1.75 2.366 2.717C5.176 11.758 6.527 12.5 8 12.5c1.473 0 2.825-.742 3.955-1.715 1.124-.967 1.954-2.096 2.366-2.717a.12.12 0 0 0 0-.136c-.412-.621-1.242-1.75-2.366-2.717C10.824 4.242 9.473 3.5 8 3.5c-1.473 0-2.825.742-3.955 1.715-1.124.967-1.954 2.096-2.366 2.717ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Z"></path>`;
const $2b6d0b8c1c80c786$export$cb08b2e60a71aacf = `<path d="M.75 3h14.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"></path>`;
const $2b6d0b8c1c80c786$export$f4b1aa0400680e2f = `<path fill-rule="evenodd" d="M7.998 14.5c2.832 0 5-1.98 5-4.5 0-1.463-.68-2.19-1.879-3.383l-.036-.037c-1.013-1.008-2.3-2.29-2.834-4.434-.322.256-.63.579-.864.953-.432.696-.621 1.58-.046 2.73.473.947.67 2.284-.278 3.232-.61.61-1.545.84-2.403.633a2.788 2.788 0 01-1.436-.874A3.21 3.21 0 003 10c0 2.53 2.164 4.5 4.998 4.5zM9.533.753C9.496.34 9.16.009 8.77.146 7.035.75 4.34 3.187 5.997 6.5c.344.689.285 1.218.003 1.5-.419.419-1.54.487-2.04-.832-.173-.454-.659-.762-1.035-.454C2.036 7.44 1.5 8.702 1.5 10c0 3.512 2.998 6 6.498 6s6.5-2.5 6.5-6c0-2.137-1.128-3.26-2.312-4.438-1.19-1.184-2.436-2.425-2.653-4.81z"></path>`;
const $2b6d0b8c1c80c786$export$3788094f5c0d6ccf = `<path d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" /><path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z" /><path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />`;
const $2b6d0b8c1c80c786$export$58f014c1d6cdb999 = `<path d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" /><path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z" />`;
const $2b6d0b8c1c80c786$export$14c8aea1bc42f2e9 = `<path d="M8.753 1.502C7.07.24 4.659 1.347 4.519 3.445L4.449 4.5H3.75a.75.75 0 0 0 0 1.5h.598l-.42 6.293a1.25 1.25 0 0 1-1.674 1.092l-.247-.09a.75.75 0 0 0-.513 1.41l.248.09a2.75 2.75 0 0 0 3.683-2.402L5.852 6H7.25a.75.75 0 1 0 0-1.5H5.952l.063-.955a1.15 1.15 0 0 1 1.838-.843l.197.148a.75.75 0 1 0 .9-1.2l-.197-.148Z"/><path d="M9.636 7.665a1.5 1.5 0 0 0-2.338-.274l-.328.328a.75.75 0 0 0 1.06 1.06l.329-.328l1.192 1.937L7.22 12.72a.75.75 0 0 0 1.06 1.06l2.079-2.078l1.005 1.633a1.5 1.5 0 0 0 2.338.274l.328-.328a.75.75 0 0 0-1.06-1.06l-.329.328l-1.192-1.937L13.78 8.28a.75.75 0 0 0-1.06-1.06l-2.08 2.077l-1.004-1.632Z"/>`;
const $2b6d0b8c1c80c786$export$9c13049f489fa947 = `<path fill-rule="evenodd" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/>`;
const $2b6d0b8c1c80c786$export$76b310fddb8e746f = `<path d="M11.93 8.5a4.002 4.002 0 0 1-7.86 0H.75a.75.75 0 0 1 0-1.5h3.32a4.002 4.002 0 0 1 7.86 0h3.32a.75.75 0 0 1 0 1.5Zm-1.43-.75a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"></path>`;
const $2b6d0b8c1c80c786$export$2034a2589eecaa5c = `<path fill-rule="evenodd" d="M1.543 7.25h2.733c.144-2.074.866-3.756 1.58-4.948.12-.197.237-.381.353-.552a6.506 6.506 0 00-4.666 5.5zm2.733 1.5H1.543a6.506 6.506 0 004.666 5.5 11.13 11.13 0 01-.352-.552c-.715-1.192-1.437-2.874-1.581-4.948zm1.504 0h4.44a9.637 9.637 0 01-1.363 4.177c-.306.51-.612.919-.857 1.215a9.978 9.978 0 01-.857-1.215A9.637 9.637 0 015.78 8.75zm4.44-1.5H5.78a9.637 9.637 0 011.363-4.177c.306-.51.612-.919.857-1.215.245.296.55.705.857 1.215A9.638 9.638 0 0110.22 7.25zm1.504 1.5c-.144 2.074-.866 3.756-1.58 4.948-.12.197-.237.381-.353.552a6.506 6.506 0 004.666-5.5h-2.733zm2.733-1.5h-2.733c-.144-2.074-.866-3.756-1.58-4.948a11.738 11.738 0 00-.353-.552 6.506 6.506 0 014.666 5.5zM8 0a8 8 0 100 16A8 8 0 008 0z"></path>`;
const $2b6d0b8c1c80c786$export$bc99159476d1c08f = `<path d="M6.368 1.01a.75.75 0 0 1 .623.859L6.57 4.5h3.98l.46-2.868a.75.75 0 0 1 1.48.237L12.07 4.5h2.18a.75.75 0 0 1 0 1.5h-2.42l-.64 4h2.56a.75.75 0 0 1 0 1.5h-2.8l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H5.45l-.46 2.869a.75.75 0 0 1-1.48-.237l.42-2.632H1.75a.75.75 0 0 1 0-1.5h2.42l.64-4H2.25a.75.75 0 0 1 0-1.5h2.8l.46-2.868a.75.75 0 0 1 .858-.622ZM9.67 10l.64-4H6.33l-.64 4Z"></path>`;
const $2b6d0b8c1c80c786$export$4830e9f92637a709 = `<path fill-rule="evenodd" d="M3.75 2a.75.75 0 01.75.75V7h7V2.75a.75.75 0 011.5 0v10.5a.75.75 0 01-1.5 0V8.5h-7v4.75a.75.75 0 01-1.5 0V2.75A.75.75 0 013.75 2z"></path>`;
const $2b6d0b8c1c80c786$export$e672bf1c583698d3 = `<path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"/>`;
const $2b6d0b8c1c80c786$export$9a0f5eb7ce2df097 = `<path fill-rule="evenodd" d="M1.643 3.143L.427 1.927A.25.25 0 000 2.104V5.75c0 .138.112.25.25.25h3.646a.25.25 0 00.177-.427L2.715 4.215a6.5 6.5 0 11-1.18 4.458.75.75 0 10-1.493.154 8.001 8.001 0 101.6-5.684zM7.75 4a.75.75 0 01.75.75v2.992l2.028.812a.75.75 0 01-.557 1.392l-2.5-1A.75.75 0 017 8.25v-3.5A.75.75 0 017.75 4z"></path>`;
const $2b6d0b8c1c80c786$export$2e2deae5fbafd37b = `<path fill-rule="evenodd" d="M8.156 1.835a.25.25 0 00-.312 0l-5.25 4.2a.25.25 0 00-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 01.75-.75h3.5a.75.75 0 01.75.75v5.25h2.75a.25.25 0 00.25-.25V6.23a.25.25 0 00-.094-.195l-5.25-4.2zM6.906.664a1.75 1.75 0 012.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0113.25 15h-3.5a.75.75 0 01-.75-.75V9H7v5.25a.75.75 0 01-.75.75h-3.5A1.75 1.75 0 011 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2h-.001z"></path>`;
const $2b6d0b8c1c80c786$export$9f7f274a907ba860 = `<path d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v9.5A1.75 1.75 0 0 1 14.25 13H8.06l-2.573 2.573A1.458 1.458 0 0 1 3 14.543V13H1.75A1.75 1.75 0 0 1 0 11.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm7 2.25v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path>`;
const $2b6d0b8c1c80c786$export$c0d9370d587dcb77 = `<path fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm6.5-.25A.75.75 0 017.25 7h1a.75.75 0 01.75.75v2.75h.25a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h.25v-2h-.25a.75.75 0 01-.75-.75zM8 6a1 1 0 100-2 1 1 0 000 2z"></path>`;
const $2b6d0b8c1c80c786$export$beb710a60e4fdf8f = `<path fill-rule="evenodd" d="M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.17 4.17 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.5 3.5 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.17 4.17 0 0 1-2.06-.566A5 5 0 0 1 8 13.65a5 5 0 0 1-.44.285 4.17 4.17 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.5 3.5 0 0 0-.436-.294A3.17 3.17 0 0 0 5.5 2.5.5.5 0 0 1 5 2"/><path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"/>`;
const $2b6d0b8c1c80c786$export$4919767267a253b2 = `<path d="M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z"></path><path fill-rule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"></path>`;
const $2b6d0b8c1c80c786$export$206d84bec3b3a5a = `<path fill-rule="evenodd" d="M6.749.097a8.054 8.054 0 012.502 0 .75.75 0 11-.233 1.482 6.554 6.554 0 00-2.036 0A.75.75 0 016.749.097zM4.345 1.693A.75.75 0 014.18 2.74a6.542 6.542 0 00-1.44 1.44.75.75 0 01-1.212-.883 8.042 8.042 0 011.769-1.77.75.75 0 011.048.166zm7.31 0a.75.75 0 011.048-.165 8.04 8.04 0 011.77 1.769.75.75 0 11-1.214.883 6.542 6.542 0 00-1.439-1.44.75.75 0 01-.165-1.047zM.955 6.125a.75.75 0 01.624.857 6.554 6.554 0 000 2.036.75.75 0 01-1.482.233 8.054 8.054 0 010-2.502.75.75 0 01.858-.624zm14.09 0a.75.75 0 01.858.624 8.057 8.057 0 010 2.502.75.75 0 01-1.482-.233 6.55 6.55 0 000-2.036.75.75 0 01.624-.857zm-13.352 5.53a.75.75 0 011.048.165 6.542 6.542 0 001.439 1.44.75.75 0 01-.883 1.212 8.04 8.04 0 01-1.77-1.769.75.75 0 01.166-1.048zm12.614 0a.75.75 0 01.165 1.048 8.038 8.038 0 01-1.769 1.77.75.75 0 11-.883-1.214 6.543 6.543 0 001.44-1.439.75.75 0 011.047-.165zm-8.182 3.39a.75.75 0 01.857-.624 6.55 6.55 0 002.036 0 .75.75 0 01.233 1.482 8.057 8.057 0 01-2.502 0 .75.75 0 01-.624-.858z"></path>`;
const $2b6d0b8c1c80c786$export$d2997daddac9b44 = `<path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path><path d="M8 0a8 8 0 110 16A8 8 0 018 0zM1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0z"></path>`;
const $2b6d0b8c1c80c786$export$f3edcd159701e0e2 = `<path d="M5.029 2.217a6.5 6.5 0 019.437 5.11.75.75 0 101.492-.154 8 8 0 00-14.315-4.03L.427 1.927A.25.25 0 000 2.104V5.75A.25.25 0 00.25 6h3.646a.25.25 0 00.177-.427L2.715 4.215a6.491 6.491 0 012.314-1.998zM1.262 8.169a.75.75 0 00-1.22.658 8.001 8.001 0 0014.315 4.03l1.216 1.216a.25.25 0 00.427-.177V10.25a.25.25 0 00-.25-.25h-3.646a.25.25 0 00-.177.427l1.358 1.358a6.501 6.501 0 01-11.751-3.11.75.75 0 00-.272-.506z"></path><path d="M9.06 9.06a1.5 1.5 0 11-2.12-2.12 1.5 1.5 0 012.12 2.12z"></path>`;
const $2b6d0b8c1c80c786$export$1b7e5fdaff4828f2 = `<path d="M1.5 8a6.5 6.5 0 0113 0A.75.75 0 0016 8a8 8 0 10-8 8 .75.75 0 000-1.5A6.5 6.5 0 011.5 8z"></path><path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.5 1.75a.75.75 0 01.75-.75h5a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75zm2.75 2.25a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z"></path>`;
const $2b6d0b8c1c80c786$export$1d0ebfd290232666 = `<path d="M1.5 8a6.5 6.5 0 0113 0A.75.75 0 0016 8a8 8 0 10-8 8 .75.75 0 000-1.5A6.5 6.5 0 011.5 8z"></path><path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm3.573 5.823l-2.896-2.896a.25.25 0 010-.354l2.896-2.896a.25.25 0 01.427.177V11.5h3.25a.75.75 0 010 1.5H12v2.146a.25.25 0 01-.427.177z"></path>`;
const $2b6d0b8c1c80c786$export$85393e592dc6a8af = `<path fill-rule="evenodd" d="M6 2.75A.75.75 0 016.75 2h6.5a.75.75 0 010 1.5h-2.505l-3.858 9H9.25a.75.75 0 010 1.5h-6.5a.75.75 0 010-1.5h2.505l3.858-9H6.75A.75.75 0 016 2.75z"></path>`;
const $2b6d0b8c1c80c786$export$aaae4cae2110f233 = `<path d="M8 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM1.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm13 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>`;
const $2b6d0b8c1c80c786$export$9adb2e16f4f3e574 = `<path d="M14 13H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1zM2 5v7h12V5Z" style="stroke-width:1"/><path d="M5 10h5.5v1H5ZM3 6h1v1H3ZM5 6h1v1H5ZM7 6h1v1H7ZM9 6h1v1H9ZM3 10h1v1H3ZM3 8h1v1H3ZM5 8h1v1H5ZM7 8h1v1H7ZM11 6h2v1h-2zM11 8h2v1h-2zM9 8h1v1H9ZM11.5 10H13v1h-1.5z" stroke-width="1"/><path d="M0 0h16v16H0Z" fill="none" stroke-width="1" />`;
const $2b6d0b8c1c80c786$export$252cd6b345de9e4c = `<path d="M8 1.5c-2.363 0-4 1.69-4 3.75 0 .984.424 1.625.984 2.304l.214.253c.223.264.47.556.673.848.284.411.537.896.621 1.49a.75.75 0 0 1-1.484.211c-.04-.282-.163-.547-.37-.847a8.456 8.456 0 0 0-.542-.68c-.084-.1-.173-.205-.268-.32C3.201 7.75 2.5 6.766 2.5 5.25 2.5 2.31 4.863 0 8 0s5.5 2.31 5.5 5.25c0 1.516-.701 2.5-1.328 3.259-.095.115-.184.22-.268.319-.207.245-.383.453-.541.681-.208.3-.33.565-.37.847a.751.751 0 0 1-1.485-.212c.084-.593.337-1.078.621-1.489.203-.292.45-.584.673-.848.075-.088.147-.173.213-.253.561-.679.985-1.32.985-2.304 0-2.06-1.637-3.75-4-3.75ZM5.75 12h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM6 15.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"></path>`;
const $2b6d0b8c1c80c786$export$62783f817acd3332 = `<path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>`;
const $2b6d0b8c1c80c786$export$ebcd2be1028c1c9c = `<path fill-rule="evenodd" d="M7.775 3.275a.75.75 0 001.06 1.06l1.25-1.25a2 2 0 112.83 2.83l-2.5 2.5a2 2 0 01-2.83 0 .75.75 0 00-1.06 1.06 3.5 3.5 0 004.95 0l2.5-2.5a3.5 3.5 0 00-4.95-4.95l-1.25 1.25zm-4.69 9.64a2 2 0 010-2.83l2.5-2.5a2 2 0 012.83 0 .75.75 0 001.06-1.06 3.5 3.5 0 00-4.95 0l-2.5 2.5a3.5 3.5 0 004.95 4.95l1.25-1.25a.75.75 0 00-1.06-1.06l-1.25 1.25a2 2 0 01-2.83 0z"></path>`;
const $2b6d0b8c1c80c786$export$67e579042ffeb67e = `<path fill-rule="evenodd" d="M2.003 2.5a.5.5 0 00-.723-.447l-1.003.5a.5.5 0 00.446.895l.28-.14V6H.5a.5.5 0 000 1h2.006a.5.5 0 100-1h-.503V2.5zM5 3.25a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 015 3.25zm0 5a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 015 8.25zm0 5a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zM.924 10.32l.003-.004a.851.851 0 01.144-.153A.66.66 0 011.5 10c.195 0 .306.068.374.146a.57.57 0 01.128.376c0 .453-.269.682-.8 1.078l-.035.025C.692 11.98 0 12.495 0 13.5a.5.5 0 00.5.5h2.003a.5.5 0 000-1H1.146c.132-.197.351-.372.654-.597l.047-.035c.47-.35 1.156-.858 1.156-1.845 0-.365-.118-.744-.377-1.038-.268-.303-.658-.484-1.126-.484-.48 0-.84.202-1.068.392a1.858 1.858 0 00-.348.384l-.007.011-.002.004-.001.002-.001.001a.5.5 0 00.851.525zM.5 10.055l-.427-.26.427.26z"></path>`;
const $2b6d0b8c1c80c786$export$77260bda21a34df7 = `<path fill-rule="evenodd" d="M2 4a1 1 0 100-2 1 1 0 000 2zm3.75-1.5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM3 8a1 1 0 11-2 0 1 1 0 012 0zm-1 6a1 1 0 100-2 1 1 0 000 2z"></path>`;
const $2b6d0b8c1c80c786$export$5c643f429ab0c3b4 = `<path d="m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z"></path>`;
const $2b6d0b8c1c80c786$export$744eeee9ada60bc2 = `<path d="M4 4a4 4 0 0 1 8 0v2h.25c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-5.5C2 6.784 2.784 6 3.75 6H4Zm8.25 3.5h-8.5a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM10.5 6V4a2.5 2.5 0 1 0-5 0v2Z"></path>`;
const $2b6d0b8c1c80c786$export$63cea22b3e24bc8 = `<path fill-rule="evenodd" d="M1.75 2A1.75 1.75 0 000 3.75v.736a.75.75 0 000 .027v7.737C0 13.216.784 14 1.75 14h12.5A1.75 1.75 0 0016 12.25v-8.5A1.75 1.75 0 0014.25 2H1.75zM14.5 4.07v-.32a.25.25 0 00-.25-.25H1.75a.25.25 0 00-.25.25v.32L8 7.88l6.5-3.81zm-13 1.74v6.441c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25V5.809L8.38 9.397a.75.75 0 01-.76 0L1.5 5.809z"></path>`;
const $2b6d0b8c1c80c786$export$7b9d1e4028ead863 = `<path fill-rule="evenodd" d="M14.85 3H1.15C.52 3 0 3.52 0 4.15v7.69C0 12.48.52 13 1.15 13h13.69c.64 0 1.15-.52 1.15-1.15v-7.7C16 3.52 15.48 3 14.85 3zM9 11H7V8L5.5 9.92 4 8v3H2V5h2l1.5 2L7 5h2v6zm2.99.5L9.5 8H11V5h2v3h1.5l-2.51 3.5z"></path>`;
const $2b6d0b8c1c80c786$export$f923afc8635c0b64 = `<path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"></path>`;
const $2b6d0b8c1c80c786$export$c5daf3f2ccb1ea17 = `<path fill-rule="evenodd" d="M4.75 2.37a6.5 6.5 0 006.5 11.26.75.75 0 01.75 1.298 8 8 0 113.994-7.273.754.754 0 01.006.095v1.5a2.75 2.75 0 01-5.072 1.475A4 4 0 1112 8v1.25a1.25 1.25 0 002.5 0V7.867a6.5 6.5 0 00-9.75-5.496V2.37zM10.5 8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"></path>`;
const $2b6d0b8c1c80c786$export$9a2d5e2a3c95aa36 = `<path d="M2.84 13.6.5 11.24 2.84 8.9l.64.64-1.71 1.7 1.7 1.72zm3.03-1.9H1.13v-.9h4.74zm7.29-4.6-.64-.64 1.71-1.7-1.7-1.72.63-.63 2.34 2.34zm1.7-1.9h-4.73v-.9h4.74zm-1.7 8.4-.64-.64 1.71-1.71-1.7-1.71.63-.64 2.34 2.35zM2.84 7.1.5 4.75l2.34-2.34.64.63-1.71 1.71 1.7 1.71zm12.03 4.6h-3.62A3.7 3.7 0 0 1 7.55 8a2.8 2.8 0 0 0-2.8-2.8H1.13v-.9h3.62A3.7 3.7 0 0 1 8.45 8a2.8 2.8 0 0 0 2.8 2.8h3.62z"/>`;
const $2b6d0b8c1c80c786$export$b15a75c898ec5eb4 = `<path fill-rule="evenodd" d="M9.598 1.591a.75.75 0 01.785-.175 7 7 0 11-8.967 8.967.75.75 0 01.961-.96 5.5 5.5 0 007.046-7.046.75.75 0 01.175-.786zm1.616 1.945a7 7 0 01-7.678 7.678 5.5 5.5 0 107.678-7.678z"></path>`;
const $2b6d0b8c1c80c786$export$a71c4501b622420d = `<path d="M7.693 1.066a.747.747 0 0 1 .614 0l7.25 3.25a.75.75 0 0 1 0 1.368L13 6.831v2.794c0 1.024-.81 1.749-1.66 2.173-.893.447-2.075.702-3.34.702-.278 0-.55-.012-.816-.036a.75.75 0 0 1 .133-1.494c.22.02.45.03.683.03 1.082 0 2.025-.221 2.67-.543.69-.345.83-.682.83-.832V7.503L8.307 8.934a.747.747 0 0 1-.614 0L4 7.28v1.663c.296.105.575.275.812.512.438.438.688 1.059.688 1.796v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3c0-.737.25-1.358.688-1.796.237-.237.516-.407.812-.512V6.606L.443 5.684a.75.75 0 0 1 0-1.368ZM2.583 5 8 7.428 13.416 5 8 2.572ZM2.5 11.25v2.25H4v-2.25c0-.388-.125-.611-.25-.735a.697.697 0 0 0-.5-.203.707.707 0 0 0-.5.203c-.125.124-.25.347-.25.735Z"></path>`;
const $2b6d0b8c1c80c786$export$a152de9f43c69821 = `<path d="M8.53 1.22a.749.749 0 0 0-1.06 0L3.72 4.97a.749.749 0 1 0 1.06 1.06l2.47-2.469v6.689a.75.75 0 0 0 1.5 0V3.561l2.47 2.469a.749.749 0 1 0 1.06-1.06L8.53 1.22ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"></path>`;
const $2b6d0b8c1c80c786$export$8c2fa896412d662f = `<path d="M7.47 10.78a.749.749 0 0 0 1.06 0l3.75-3.75a.749.749 0 1 0-1.06-1.06L8.75 8.439V1.75a.75.75 0 0 0-1.5 0v6.689L4.78 5.97a.749.749 0 1 0-1.06 1.06l3.75 3.75ZM3.75 13a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z"></path>`;
const $2b6d0b8c1c80c786$export$82115b98859c1168 = `<path d="M4.25 7.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5z"></path><path d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 10-13 0 6.5 6.5 0 0013 0z"></path>`;
const $2b6d0b8c1c80c786$export$5d50349f0efd9ba2 = `<path d="M8.5.75a.75.75 0 0 0-1.5 0v5.19L4.391 3.33a.75.75 0 1 0-1.06 1.061L5.939 7H.75a.75.75 0 0 0 0 1.5h5.19l-2.61 2.609a.75.75 0 1 0 1.061 1.06L7 9.561v5.189a.75.75 0 0 0 1.5 0V9.56l2.609 2.61a.75.75 0 1 0 1.06-1.061L9.561 8.5h5.189a.75.75 0 0 0 0-1.5H9.56l2.61-2.609a.75.75 0 0 0-1.061-1.06L8.5 5.939V.75Z"></path>`;
const $2b6d0b8c1c80c786$export$ec311e0cee1871f3 = `<path d="M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM3.5 6.25a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm.75 2.25h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5Z"></path>`;
const $2b6d0b8c1c80c786$export$51f878b7e8894ba1 = `<path fill-rule="evenodd" d="M1.5 14.25c0 .138.112.25.25.25H4v-1.25a.75.75 0 01.75-.75h2.5a.75.75 0 01.75.75v1.25h2.25a.25.25 0 00.25-.25V1.75a.25.25 0 00-.25-.25h-8.5a.25.25 0 00-.25.25v12.5zM1.75 16A1.75 1.75 0 010 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 00.25-.25V8.285a.25.25 0 00-.111-.208l-1.055-.703a.75.75 0 11.832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0114.25 16h-3.5a.75.75 0 01-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 01-.75-.75V14h-1v1.25a.75.75 0 01-.75.75h-3zM3 3.75A.75.75 0 013.75 3h.5a.75.75 0 010 1.5h-.5A.75.75 0 013 3.75zM3.75 6a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM3 9.75A.75.75 0 013.75 9h.5a.75.75 0 010 1.5h-.5A.75.75 0 013 9.75zM7.75 9a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM7 6.75A.75.75 0 017.75 6h.5a.75.75 0 010 1.5h-.5A.75.75 0 017 6.75zM7.75 3a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5z"></path>`;
const $2b6d0b8c1c80c786$export$1627e4883d92a099 = `<path d="M12.212 3.02a1.753 1.753 0 0 0-2.478.003l-5.83 5.83a3.007 3.007 0 0 0-.88 2.127c0 .795.315 1.551.88 2.116.567.567 1.333.89 2.126.89.79 0 1.548-.321 2.116-.89l5.48-5.48a.75.75 0 0 1 1.061 1.06l-5.48 5.48a4.492 4.492 0 0 1-3.177 1.33c-1.2 0-2.345-.487-3.187-1.33a4.483 4.483 0 0 1-1.32-3.177c0-1.195.475-2.341 1.32-3.186l5.83-5.83a3.25 3.25 0 0 1 5.553 2.297c0 .863-.343 1.691-.953 2.301L7.439 12.39c-.375.377-.884.59-1.416.593a1.998 1.998 0 0 1-1.412-.593 1.992 1.992 0 0 1 0-2.828l5.48-5.48a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-5.48 5.48a.492.492 0 0 0 0 .707.499.499 0 0 0 .352.154.51.51 0 0 0 .356-.154l5.833-5.827a1.755 1.755 0 0 0 0-2.481Z"></path>`;
const $2b6d0b8c1c80c786$export$adcaf896a7be650b = `<path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"/>`;
const $2b6d0b8c1c80c786$export$f991bf0e9ae7ca12 = `<path fill-rule="evenodd" d="M11.013 1.427a1.75 1.75 0 012.474 0l1.086 1.086a1.75 1.75 0 010 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.251.93a.75.75 0 01-.927-.928l.929-3.25a1.75 1.75 0 01.445-.758l8.61-8.61zm1.414 1.06a.25.25 0 00-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.25.25 0 000-.354l-1.086-1.086zM11.189 6.25L9.75 4.81l-6.286 6.287a.25.25 0 00-.064.108l-.558 1.953 1.953-.558a.249.249 0 00.108-.064l6.286-6.286z"></path>`;
const $2b6d0b8c1c80c786$export$44b16df525422efd = `<path fill-rule="evenodd" d="M5.5 3.5a2 2 0 100 4 2 2 0 000-4zM2 5.5a3.5 3.5 0 115.898 2.549 5.507 5.507 0 013.034 4.084.75.75 0 11-1.482.235 4.001 4.001 0 00-7.9 0 .75.75 0 01-1.482-.236A5.507 5.507 0 013.102 8.05 3.49 3.49 0 012 5.5zM11 4a.75.75 0 100 1.5 1.5 1.5 0 01.666 2.844.75.75 0 00-.416.672v.352a.75.75 0 00.574.73c1.2.289 2.162 1.2 2.522 2.372a.75.75 0 101.434-.44 5.01 5.01 0 00-2.56-3.012A3 3 0 0011 4z"></path>`;
const $2b6d0b8c1c80c786$export$8339901270f1e164 = `<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>`;
const $2b6d0b8c1c80c786$export$7ec3d824126b1aaf = `<path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"/>`;
const $2b6d0b8c1c80c786$export$d8257db44c09a4d8 = `<path fill-rule="evenodd" d="M10.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm.061 3.073a4 4 0 10-5.123 0 6.004 6.004 0 00-3.431 5.142.75.75 0 001.498.07 4.5 4.5 0 018.99 0 .75.75 0 101.498-.07 6.005 6.005 0 00-3.432-5.142z"></path>`;
const $2b6d0b8c1c80c786$export$2cb0e6b6616bbc58 = `<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>`;
const $2b6d0b8c1c80c786$export$ffd16dba7db7e37d = `<path d="M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/><path d="M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1H1Zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1V2Z"/>`;
const $2b6d0b8c1c80c786$export$84fa51e586e7b2e7 = `<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M12.146 5.146a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z"/>`;
const $2b6d0b8c1c80c786$export$818cafb7937913f5 = `<path fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0zM8 0a8 8 0 100 16A8 8 0 008 0zm.75 4.75a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z"></path>`;
const $2b6d0b8c1c80c786$export$3304639b795b6ae = `<path fill-rule="evenodd" d="M7.75 2a.75.75 0 01.75.75V7h4.25a.75.75 0 110 1.5H8.5v4.25a.75.75 0 11-1.5 0V8.5H2.75a.75.75 0 010-1.5H7V2.75A.75.75 0 017.75 2z"></path>`;
const $2b6d0b8c1c80c786$export$6ccb2650cf13729e = `<path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/><path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>`;
const $2b6d0b8c1c80c786$export$b033e2eb4807deba = `<path d="M2 2h2v2H2V2Z"/><path d="M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z"/><path d="M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z"/><path d="M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z"/><path d="M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z"/>`;
const $2b6d0b8c1c80c786$export$c5abb880dda04c02 = `<path d="M0 8a8 8 0 1116 0A8 8 0 010 8zm8-6.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM6.92 6.085h.001a.749.749 0 11-1.342-.67c.169-.339.436-.701.849-.977C6.845 4.16 7.369 4 8 4a2.756 2.756 0 011.637.525c.503.377.863.965.863 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 00-.26.16.952.952 0 00-.276.245.75.75 0 01-1.248-.832c.184-.264.42-.489.692-.661.103-.067.207-.132.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 00.277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 00-.262-.525A1.27 1.27 0 008 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 00-.34.398zM9 11a1 1 0 11-2 0 1 1 0 012 0z"></path>`;
const $2b6d0b8c1c80c786$export$696b0975d17cc695 = `<path fill-rule="evenodd" d="M1.75 2.5a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H1.75zm4 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm0 5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM2.5 7.75a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0v-6z"></path>`;
const $2b6d0b8c1c80c786$export$213ba599ab7d8ec6 = `<path fill-rule="evenodd" d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v3.585a.746.746 0 010 .83v8.085A1.75 1.75 0 0114.25 16H6.309a.748.748 0 01-1.118 0H1.75A1.75 1.75 0 010 14.25V6.165a.746.746 0 010-.83V1.75zM1.5 6.5v7.75c0 .138.112.25.25.25H5v-8H1.5zM5 5H1.5V1.75a.25.25 0 01.25-.25H5V5zm1.5 1.5v8h7.75a.25.25 0 00.25-.25V6.5h-8zm8-1.5h-8V1.5h7.75a.25.25 0 01.25.25V5z"></path>`;
const $2b6d0b8c1c80c786$export$22a44c3490da3c1a = `<path d="M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/><path d="M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/>`;
const $2b6d0b8c1c80c786$export$764331b9206ca92e = `<path d="M14.064 0h.186C15.216 0 16 .784 16 1.75v.186a8.752 8.752 0 0 1-2.564 6.186l-.458.459c-.314.314-.641.616-.979.904v3.207c0 .608-.315 1.172-.833 1.49l-2.774 1.707a.749.749 0 0 1-1.11-.418l-.954-3.102a1.214 1.214 0 0 1-.145-.125L3.754 9.816a1.218 1.218 0 0 1-.124-.145L.528 8.717a.749.749 0 0 1-.418-1.11l1.71-2.774A1.748 1.748 0 0 1 3.31 4h3.204c.288-.338.59-.665.904-.979l.459-.458A8.749 8.749 0 0 1 14.064 0ZM8.938 3.623h-.002l-.458.458c-.76.76-1.437 1.598-2.02 2.5l-1.5 2.317 2.143 2.143 2.317-1.5c.902-.583 1.74-1.26 2.499-2.02l.459-.458a7.25 7.25 0 0 0 2.123-5.127V1.75a.25.25 0 0 0-.25-.25h-.186a7.249 7.249 0 0 0-5.125 2.123ZM3.56 14.56c-.732.732-2.334 1.045-3.005 1.148a.234.234 0 0 1-.201-.064.234.234 0 0 1-.064-.201c.103-.671.416-2.273 1.15-3.003a1.502 1.502 0 1 1 2.12 2.12Zm6.94-3.935c-.088.06-.177.118-.266.175l-2.35 1.521.548 1.783 1.949-1.2a.25.25 0 0 0 .119-.213ZM3.678 8.116 5.2 5.766c.058-.09.117-.178.176-.266H3.309a.25.25 0 0 0-.213.119l-1.2 1.95ZM12 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path>`;
const $2b6d0b8c1c80c786$export$8687ffcdea58e000 = `<path fill-rule="evenodd" d="M11.5 7a4.499 4.499 0 11-8.998 0A4.499 4.499 0 0111.5 7zm-.82 4.74a6 6 0 111.06-1.06l3.04 3.04a.75.75 0 11-1.06 1.06l-3.04-3.04z"></path>`;
const $2b6d0b8c1c80c786$export$1c9c5f58b493da5e = `<path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"/><path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"/>`;
const $2b6d0b8c1c80c786$export$8821ea1545299efc = `<path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/>`;
const $2b6d0b8c1c80c786$export$cf8ed5bb35a34744 = `<path fill-rule="evenodd" d="M7.429 1.525a6.593 6.593 0 011.142 0c.036.003.108.036.137.146l.289 1.105c.147.56.55.967.997 1.189.174.086.341.183.501.29.417.278.97.423 1.53.27l1.102-.303c.11-.03.175.016.195.046.219.31.41.641.573.989.014.031.022.11-.059.19l-.815.806c-.411.406-.562.957-.53 1.456a4.588 4.588 0 010 .582c-.032.499.119 1.05.53 1.456l.815.806c.08.08.073.159.059.19a6.494 6.494 0 01-.573.99c-.02.029-.086.074-.195.045l-1.103-.303c-.559-.153-1.112-.008-1.529.27-.16.107-.327.204-.5.29-.449.222-.851.628-.998 1.189l-.289 1.105c-.029.11-.101.143-.137.146a6.613 6.613 0 01-1.142 0c-.036-.003-.108-.037-.137-.146l-.289-1.105c-.147-.56-.55-.967-.997-1.189a4.502 4.502 0 01-.501-.29c-.417-.278-.97-.423-1.53-.27l-1.102.303c-.11.03-.175-.016-.195-.046a6.492 6.492 0 01-.573-.989c-.014-.031-.022-.11.059-.19l.815-.806c.411-.406.562-.957.53-1.456a4.587 4.587 0 010-.582c.032-.499-.119-1.05-.53-1.456l-.815-.806c-.08-.08-.073-.159-.059-.19a6.44 6.44 0 01.573-.99c.02-.029.086-.075.195-.045l1.103.303c.559.153 1.112.008 1.529-.27.16-.107.327-.204.5-.29.449-.222.851-.628.998-1.189l.289-1.105c.029-.11.101-.143.137-.146zM8 0c-.236 0-.47.01-.701.03-.743.065-1.29.615-1.458 1.261l-.29 1.106c-.017.066-.078.158-.211.224a5.994 5.994 0 00-.668.386c-.123.082-.233.09-.3.071L3.27 2.776c-.644-.177-1.392.02-1.82.63a7.977 7.977 0 00-.704 1.217c-.315.675-.111 1.422.363 1.891l.815.806c.05.048.098.147.088.294a6.084 6.084 0 000 .772c.01.147-.038.246-.088.294l-.815.806c-.474.469-.678 1.216-.363 1.891.2.428.436.835.704 1.218.428.609 1.176.806 1.82.63l1.103-.303c.066-.019.176-.011.299.071.213.143.436.272.668.386.133.066.194.158.212.224l.289 1.106c.169.646.715 1.196 1.458 1.26a8.094 8.094 0 001.402 0c.743-.064 1.29-.614 1.458-1.26l.29-1.106c.017-.066.078-.158.211-.224a5.98 5.98 0 00.668-.386c.123-.082.233-.09.3-.071l1.102.302c.644.177 1.392-.02 1.82-.63.268-.382.505-.789.704-1.217.315-.675.111-1.422-.364-1.891l-.814-.806c-.05-.048-.098-.147-.088-.294a6.1 6.1 0 000-.772c-.01-.147.039-.246.088-.294l.814-.806c.475-.469.679-1.216.364-1.891a7.992 7.992 0 00-.704-1.218c-.428-.609-1.176-.806-1.82-.63l-1.103.303c-.066.019-.176.011-.299-.071a5.991 5.991 0 00-.668-.386c-.133-.066-.194-.158-.212-.224L10.16 1.29C9.99.645 9.444.095 8.701.031A8.094 8.094 0 008 0zm1.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11 8a3 3 0 11-6 0 3 3 0 016 0z"></path>`;
const $2b6d0b8c1c80c786$export$a2dbc589500a2539 = `<path fill-rule="evenodd" d="M13.5 3a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 3a3 3 0 01-5.175 2.066l-3.92 2.179a3.005 3.005 0 010 1.51l3.92 2.179a3 3 0 11-.73 1.31l-3.92-2.178a3 3 0 110-4.133l3.92-2.178A3 3 0 1115 3zm-1.5 10a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-9-5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path>`;
const $2b6d0b8c1c80c786$export$b30eb444abf03cb0 = `<path fill-rule="evenodd" d="M6.823 7.823L4.427 5.427A.25.25 0 004 5.604v4.792c0 .223.27.335.427.177l2.396-2.396a.25.25 0 000-.354z"></path><path fill-rule="evenodd" d="M1.75 0A1.75 1.75 0 000 1.75v12.5C0 15.216.784 16 1.75 16h12.5A1.75 1.75 0 0016 14.25V1.75A1.75 1.75 0 0014.25 0H1.75zM1.5 1.75a.25.25 0 01.25-.25H9.5v13H1.75a.25.25 0 01-.25-.25V1.75zM11 14.5v-13h3.25a.25.25 0 01.25.25v12.5a.25.25 0 01-.25.25H11z"></path>`;
const $2b6d0b8c1c80c786$export$276a6f6a703267d1 = `<path fill-rule="evenodd" d="M4.177 7.823l2.396-2.396A.25.25 0 017 5.604v4.792a.25.25 0 01-.427.177L4.177 8.177a.25.25 0 010-.354z"></path><path fill-rule="evenodd" d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0114.25 16H1.75A1.75 1.75 0 010 14.25V1.75zm1.75-.25a.25.25 0 00-.25.25v12.5c0 .138.112.25.25.25H9.5v-13H1.75zm12.5 13H11v-13h3.25a.25.25 0 01.25.25v12.5a.25.25 0 01-.25.25z"></path>`;
const $2b6d0b8c1c80c786$export$f8913d335ddc81bb = `<path d="M15.58 6.4c-1.3.09-3.14 1.37-4.07 1.79-.73.33-1.36.6-1.9.6-.57 0-.66-.4-.54-1.29.03-.2.3-1.98-1.07-1.9-.63.03-1.6.62-4.24 3.15l1.04-2.6a2.16 2.16 0 0 0-3.24-2.57l-1.38.93a.4.4 0 0 0-.12.55l.43.67a.4.4 0 0 0 .55.13l1.46-.98c.46-.29 1.01.18.81.68L.86 11.7c-.17.43.06 1.1.74 1.1a.8.8 0 0 0 .57-.23 90.97 90.97 0 0 1 5.28-4.9c-.06.71-.06 1.47.51 2.1.38.42.93.63 1.64.63.89 0 1.7-.37 2.56-.75.82-.37 2.47-1.57 3.46-1.65a.4.4 0 0 0 .38-.4v-.8a.4.4 0 0 0-.42-.4z" />`;
const $2b6d0b8c1c80c786$export$8a495e6856ec4c30 = `<path d="M8 0a8 8 0 110 16A8 8 0 018 0zM1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm9.78-2.22l-5.5 5.5a.749.749 0 01-1.275-.326.749.749 0 01.215-.734l5.5-5.5a.751.751 0 011.042.018.751.751 0 01.018 1.042z"></path>`;
const $2b6d0b8c1c80c786$export$a7f606f216bfee52 = `<path fill-rule="evenodd" d="M0 4.25a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5H.75A.75.75 0 010 4.25zm0 4a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5H.75A.75.75 0 010 8.25zm0 4a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75zm12.927-9.677a.25.25 0 00-.354 0l-3 3A.25.25 0 009.75 6H12v6.75a.75.75 0 001.5 0V6h2.25a.25.25 0 00.177-.427l-3-3z"></path>`;
const $2b6d0b8c1c80c786$export$f4b6d034496ffda1 = `<path fill-rule="evenodd" d="M0 4.25a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5H.75A.75.75 0 010 4.25zm0 4a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5H.75A.75.75 0 010 8.25zm0 4a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75z"></path><path d="M13.5 10h2.25a.25.25 0 01.177.427l-3 3a.25.25 0 01-.354 0l-3-3A.25.25 0 019.75 10H12V3.75a.75.75 0 011.5 0V10z"></path>`;
const $2b6d0b8c1c80c786$export$1b9a722e20d6b950 = `<path d="M3.34 7.73A7.05 7.05 0 0 0 0 6.17a7.05 7.05 0 0 0 3.34-1.56A7.06 7.06 0 0 0 4.9 1.27a7.05 7.05 0 0 0 1.56 3.34c.77.77 2.12 1.3 3.34 1.56a7.05 7.05 0 0 0-3.34 1.56 7.06 7.06 0 0 0-1.56 3.34 7.05 7.05 0 0 0-1.56-3.34zM9.51 12.73a4.22 4.22 0 0 0-2-.93 4.21 4.21 0 0 0 2-.93c.46-.46.78-1.26.93-2 .16.74.47 1.54.93 2 .46.46 1.27.78 2 .93-.73.16-1.54.47-2 .93a4.22 4.22 0 0 0-.93 2 4.21 4.21 0 0 0-.93-2zM11.08 4.57c.62-.13 1.3-.4 1.68-.78.39-.38.65-1.06.78-1.67.13.61.4 1.29.78 1.67.39.39 1.07.65 1.68.78-.61.14-1.29.4-1.68.79a3.54 3.54 0 0 0-.78 1.67 3.54 3.54 0 0 0-.78-1.67 3.54 3.54 0 0 0-1.68-.79z"/>`;
const $2b6d0b8c1c80c786$export$df1cad1bb112a50a = `<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>`;
const $2b6d0b8c1c80c786$export$7e54fd101e49f1c7 = `<path d="M1.65.9a.65.65 0 0 0-.65.64v4.3c0 1.93 1.4 3.52 3.23 3.83v.91a4.52 4.52 0 1 0 9.05 0v-.95a2.37 2.37 0 1 0-1.3 0v.95a3.23 3.23 0 1 1-6.46 0v-.91a3.88 3.88 0 0 0 3.23-3.82V1.54a.65.65 0 0 0-.64-.65H6.8a.65.65 0 0 0 0 1.3h.65v3.66a2.58 2.58 0 0 1-5.17 0V2.18h.65a.65.65 0 1 0 0-1.29zm10.98 5.38a1.08 1.08 0 1 1 0 2.15 1.08 1.08 0 0 1 0-2.15z" />`;
const $2b6d0b8c1c80c786$export$d0c2ff82f0790e53 = `<path d="M4.47.22A.749.749 0 015 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 01-.22.53l-4.25 4.25A.749.749 0 0111 16H5a.749.749 0 01-.53-.22L.22 11.53A.749.749 0 010 11V5c0-.199.079-.389.22-.53zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5zM8 4a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 018 4zm0 8a1 1 0 110-2 1 1 0 010 2z"></path>`;
const $2b6d0b8c1c80c786$export$997a3923b24665e5 = `<path fill-rule="evenodd" d="M5.75.75A.75.75 0 016.5 0h3a.75.75 0 010 1.5h-.75v1l-.001.041a6.718 6.718 0 013.464 1.435l.007-.006.75-.75a.75.75 0 111.06 1.06l-.75.75-.006.007a6.75 6.75 0 11-10.548 0L2.72 5.03l-.75-.75a.75.75 0 011.06-1.06l.75.75.007.006A6.718 6.718 0 017.25 2.541a.756.756 0 010-.041v-1H6.5a.75.75 0 01-.75-.75zM8 14.5A5.25 5.25 0 108 4a5.25 5.25 0 000 10.5zm.389-6.7l1.33-1.33a.75.75 0 111.061 1.06L9.45 8.861A1.502 1.502 0 018 10.75a1.5 1.5 0 11.389-2.95z"></path>`;
const $2b6d0b8c1c80c786$export$af0359317e17d389 = `<path fill-rule="evenodd" d="M8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM8 12a4 4 0 100-8 4 4 0 000 8zM8 0a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0V.75A.75.75 0 018 0zm0 13a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5A.75.75 0 018 13zM2.343 2.343a.75.75 0 011.061 0l1.06 1.061a.75.75 0 01-1.06 1.06l-1.06-1.06a.75.75 0 010-1.06zm9.193 9.193a.75.75 0 011.06 0l1.061 1.06a.75.75 0 01-1.06 1.061l-1.061-1.06a.75.75 0 010-1.061zM16 8a.75.75 0 01-.75.75h-1.5a.75.75 0 010-1.5h1.5A.75.75 0 0116 8zM3 8a.75.75 0 01-.75.75H.75a.75.75 0 010-1.5h1.5A.75.75 0 013 8zm10.657-5.657a.75.75 0 010 1.061l-1.061 1.06a.75.75 0 11-1.06-1.06l1.06-1.06a.75.75 0 011.06 0zm-9.193 9.193a.75.75 0 010 1.06l-1.06 1.061a.75.75 0 11-1.061-1.06l1.06-1.061a.75.75 0 011.061 0z"></path>`;
const $2b6d0b8c1c80c786$export$d71853bc7259c595 = `<path d="M1.705 8.005a.75.75 0 0 1 .834.656 5.5 5.5 0 0 0 9.592 2.97l-1.204-1.204a.25.25 0 0 1 .177-.427h3.646a.25.25 0 0 1 .25.25v3.646a.25.25 0 0 1-.427.177l-1.38-1.38A7.002 7.002 0 0 1 1.05 8.84a.75.75 0 0 1 .656-.834ZM8 2.5a5.487 5.487 0 0 0-4.131 1.869l1.204 1.204A.25.25 0 0 1 4.896 6H1.25A.25.25 0 0 1 1 5.75V2.104a.25.25 0 0 1 .427-.177l1.38 1.38A7.002 7.002 0 0 1 14.95 7.16a.75.75 0 0 1-1.49.178A5.5 5.5 0 0 0 8 2.5Z"></path>`;
const $2b6d0b8c1c80c786$export$e5576969d092b404 = `<path d="M15.8 3.35 12.65.2a.68.68 0 1 0-.95.95l.38.39-1.84 1.84-1.6-1.6a.68.68 0 1 0-.95.95l.74.74-6.2 6.2a.68.68 0 0 0 0 .96l1.09 1.1L.2 14.85a.68.68 0 1 0 .95.95l3.12-3.12 1.1 1.1a.68.68 0 0 0 .96 0l6.2-6.2.74.73a.68.68 0 1 0 .95-.95l-1.6-1.6 1.85-1.84.38.38a.68.68 0 1 0 .95-.95zm-9.95 9-2.2-2.2.9-.89.57.57a.68.68 0 0 0 .95-.95L5.5 8.3l.54-.54.57.57a.68.68 0 1 0 .96-.96l-.58-.57.54-.54.58.57a.68.68 0 1 0 .95-.95l-.57-.57.89-.9 2.2 2.2-5.73 5.73zm5.82-7.54-.48-.48 1.85-1.84.47.48-1.84 1.84z"/>`;
const $2b6d0b8c1c80c786$export$f17898899b25b30f = `<path d="M1 7.775V2.75C1 1.784 1.784 1 2.75 1h5.025c.464 0 .91.184 1.238.513l6.25 6.25a1.75 1.75 0 0 1 0 2.474l-5.026 5.026a1.75 1.75 0 0 1-2.474 0l-6.25-6.25A1.752 1.752 0 0 1 1 7.775Zm1.5 0c0 .066.026.13.073.177l6.25 6.25a.25.25 0 0 0 .354 0l5.025-5.025a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.177-.073H2.75a.25.25 0 0 0-.25.25ZM6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"></path>`;
const $2b6d0b8c1c80c786$export$be57f1a2adaba6d9 = `<path fill-rule="evenodd" d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" /><path fill-rule="evenodd" d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3zm4.354 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />`;
const $2b6d0b8c1c80c786$export$3a1c536271d3060a = `<path fill-rule="evenodd" d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" /><path fill-rule="evenodd" d="M9.5 1h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />`;
const $2b6d0b8c1c80c786$export$ce6c9ad0562e53cc = `<path fill-rule="evenodd" d="M14.184 1.143a1.75 1.75 0 00-2.502-.57L.912 7.916a1.75 1.75 0 00-.53 2.32l.447.775a1.75 1.75 0 002.275.702l11.745-5.656a1.75 1.75 0 00.757-2.451l-1.422-2.464zm-1.657.669a.25.25 0 01.358.081l1.422 2.464a.25.25 0 01-.108.35l-2.016.97-1.505-2.605 1.85-1.26zM9.436 3.92l1.391 2.41-5.42 2.61-.942-1.63 4.97-3.39zM3.222 8.157l-1.466 1a.25.25 0 00-.075.33l.447.775a.25.25 0 00.325.1l1.598-.769-.83-1.436zm6.253 2.306a.75.75 0 00-.944-.252l-1.809.87a.75.75 0 00-.293.253L4.38 14.326a.75.75 0 101.238.848l1.881-2.75v2.826a.75.75 0 001.5 0v-2.826l1.881 2.75a.75.75 0 001.238-.848l-2.644-3.863z"></path>`;
const $2b6d0b8c1c80c786$export$19e57992350655e5 = `<path fill-rule="evenodd" d="M1 2.75A.75.75 0 011.75 2h12.5a.75.75 0 110 1.5H1.75A.75.75 0 011 2.75zm0 5A.75.75 0 011.75 7h12.5a.75.75 0 110 1.5H1.75A.75.75 0 011 7.75zM1.75 12a.75.75 0 100 1.5h12.5a.75.75 0 100-1.5H1.75z"></path>`;
const $2b6d0b8c1c80c786$export$42af681e1bc43a8b = `<path d="M7.25 11.68a4.002 4.002 0 0 1 0-7.86V.5a.75.75 0 0 1 1.5 0v3.32a4.002 4.002 0 0 1 0 7.86V15a.75.75 0 0 1-1.5 0v-3.32zM8 10.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>`;
const $2b6d0b8c1c80c786$export$c6e11f163cc2dc47 = `<path fill-rule="evenodd" d="M6.5 1.75a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25V3h-3V1.75zm4.5 0V3h2.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75zM4.496 6.675a.75.75 0 10-1.492.15l.66 6.6A1.75 1.75 0 005.405 15h5.19c.9 0 1.652-.681 1.741-1.576l.66-6.6a.75.75 0 00-1.492-.149l-.66 6.6a.25.25 0 01-.249.225h-5.19a.25.25 0 01-.249-.225l-.66-6.6z"></path>`;
const $2b6d0b8c1c80c786$export$11c52108e5848752 = `<path d="M4.427 7.427l3.396 3.396a.25.25 0 00.354 0l3.396-3.396A.25.25 0 0011.396 7H4.604a.25.25 0 00-.177.427z"></path>`;
const $2b6d0b8c1c80c786$export$65802efd58dbcf80 = `<path d="M4.427 9.573l3.396-3.396a.25.25 0 01.354 0l3.396 3.396a.25.25 0 01-.177.427H4.604a.25.25 0 01-.177-.427z"></path>`;
const $2b6d0b8c1c80c786$export$e789e90053a546bb = `<path d="M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"></path><path d="M11.78 4.72a.749.749 0 1 1-1.06 1.06L8.75 3.811V9.5a.75.75 0 0 1-1.5 0V3.811L5.28 5.78a.749.749 0 1 1-1.06-1.06l3.25-3.25a.749.749 0 0 1 1.06 0l3.25 3.25Z"></path>`;
const $2b6d0b8c1c80c786$export$574b1b76cb8c7ec6 = `<path fill-rule="evenodd" d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828zm-1.8 2.908-3.173.793a.5.5 0 0 0-.358.342l-2.57 8.565 8.567-2.57a.5.5 0 0 0 .34-.357l.794-3.174-3.6-3.6z"/><path fill-rule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1l-4.228 5.168-.026.086z"/>`;
const $2b6d0b8c1c80c786$export$fb6200c7e4bc245b = `<path d="M7.75 14A1.75 1.75 0 0 1 6 12.25v-8.5C6 2.784 6.784 2 7.75 2h6.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14Zm-.25-1.75c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25ZM4.9 3.508a.75.75 0 0 1-.274 1.025.249.249 0 0 0-.126.217v6.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.75 1.75 0 0 1 3 11.25v-6.5c0-.649.353-1.214.874-1.516a.75.75 0 0 1 1.025.274ZM1.625 5.533h.001a.249.249 0 0 0-.126.217v4.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 0 10.25v-4.5a1.748 1.748 0 0 1 .873-1.516.75.75 0 1 1 .752 1.299Z"></path>`;
const $2b6d0b8c1c80c786$export$eebcc95f857de077 = `<path d="M0 1.75C0 .784.784 0 1.75 0h3.5C6.216 0 7 .784 7 1.75v3.5A1.75 1.75 0 0 1 5.25 7H4v4a1 1 0 0 0 1 1h4v-1.25C9 9.784 9.784 9 10.75 9h3.5c.966 0 1.75.784 1.75 1.75v3.5A1.75 1.75 0 0 1 14.25 16h-3.5A1.75 1.75 0 0 1 9 14.25v-.75H5A2.5 2.5 0 0 1 2.5 11V7h-.75A1.75 1.75 0 0 1 0 5.25Zm1.75-.25a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Zm9 9a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25Z"></path>`;
const $2b6d0b8c1c80c786$export$d0029a3ee0c0e03 = `<path fill-rule="evenodd" d="M3.404 12.596a6.5 6.5 0 119.192-9.192 6.5 6.5 0 01-9.192 9.192zM2.344 2.343a8 8 0 1011.313 11.314A8 8 0 002.343 2.343zM6.03 4.97a.75.75 0 00-1.06 1.06L6.94 8 4.97 9.97a.75.75 0 101.06 1.06L8 9.06l1.97 1.97a.75.75 0 101.06-1.06L9.06 8l1.97-1.97a.75.75 0 10-1.06-1.06L8 6.94 6.03 4.97z"></path>`;
const $2b6d0b8c1c80c786$export$4d48f840957dea1b = `<path fill-rule="evenodd" d="M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"></path>`;
const $2b6d0b8c1c80c786$export$4ca6136d62cf903 = `<path fill-rule="evenodd" d="M10.561 1.5a.016.016 0 00-.01.004L3.286 8.571A.25.25 0 003.462 9H6.75a.75.75 0 01.694 1.034l-1.713 4.188 6.982-6.793A.25.25 0 0012.538 7H9.25a.75.75 0 01-.683-1.06l2.008-4.418.003-.006a.02.02 0 00-.004-.009.02.02 0 00-.006-.006L10.56 1.5zM9.504.43a1.516 1.516 0 012.437 1.713L10.415 5.5h2.123c1.57 0 2.346 1.909 1.22 3.004l-7.34 7.142a1.25 1.25 0 01-.871.354h-.302a1.25 1.25 0 01-1.157-1.723L5.633 10.5H3.462c-1.57 0-2.346-1.909-1.22-3.004L9.503.429z"></path>`;
const $2b6d0b8c1c80c786$export$243b99dab5f0afd0 = `<path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>`;
const $2b6d0b8c1c80c786$export$71f13b33cc62760a = `<path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>`;
const $2b6d0b8c1c80c786$export$49a22c2bea0a2976 = `<path d="M13 17.5a1 1 0 11-2 0 1 1 0 012 0zm-.25-8.25a.75.75 0 00-1.5 0v4.5a.75.75 0 001.5 0v-4.5z"></path><path fill-rule="evenodd" d="M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752L9.836 3.244zm3.03.751a1 1 0 00-1.732 0L2.168 19.499A1 1 0 003.034 21h17.932a1 1 0 00.866-1.5L12.866 3.994z"></path>`;
const $2b6d0b8c1c80c786$export$f144ff283e2ca060 = `<path fill-rule="evenodd" d="M18.25 8.5a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-9a.75.75 0 010-1.5h7.19L6.22 7.28a.75.75 0 011.06-1.06L17.5 16.44V9.25a.75.75 0 01.75-.75z"></path>`;
const $2b6d0b8c1c80c786$export$834a4c5733ec0c84 = `<path fill-rule="evenodd" d="M18.25 15.5a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75h-9a.75.75 0 000 1.5h7.19L6.22 16.72a.75.75 0 101.06 1.06L17.5 7.56v7.19c0 .414.336.75.75.75z"></path>`;
const $2b6d0b8c1c80c786$export$57513d500dbb4ea5 = `<path fill-rule="evenodd" d="M12 1C8.318 1 5 3.565 5 7v4.539a3.25 3.25 0 01-.546 1.803l-2.2 3.299A1.518 1.518 0 003.519 19H8.5a3.5 3.5 0 107 0h4.982a1.518 1.518 0 001.263-2.36l-2.2-3.298A3.25 3.25 0 0119 11.539V7c0-3.435-3.319-6-7-6zM6.5 7c0-2.364 2.383-4.5 5.5-4.5s5.5 2.136 5.5 4.5v4.539c0 .938.278 1.854.798 2.635l2.199 3.299a.017.017 0 01.003.01l-.001.006-.004.006-.006.004-.007.001H3.518l-.007-.001-.006-.004-.004-.006-.001-.007.003-.01 2.2-3.298a4.75 4.75 0 00.797-2.635V7zM14 19h-4a2 2 0 104 0z"></path>`;
const $2b6d0b8c1c80c786$export$7f2471dddd951c39 = `<path fill-rule="evenodd" d="M13.152.682a2.25 2.25 0 012.269 0l.007.004 6.957 4.276a2.276 2.276 0 011.126 1.964v7.516c0 .81-.432 1.56-1.133 1.968l-.002.001-11.964 7.037-.004.003a2.276 2.276 0 01-2.284 0l-.026-.015-6.503-4.502a2.268 2.268 0 01-1.096-1.943V9.438c0-.392.1-.77.284-1.1l.003-.006.014-.026a2.28 2.28 0 01.82-.827h.002L13.152.681zm.757 1.295h-.001L2.648 8.616l6.248 4.247a.776.776 0 00.758-.01h.001l11.633-6.804-6.629-4.074a.75.75 0 00-.75.003zM18 9.709l-3.25 1.9v7.548L18 17.245V9.709zm1.5-.878v7.532l2.124-1.25a.777.777 0 00.387-.671V7.363L19.5 8.831zm-9.09 5.316l2.84-1.66v7.552l-3.233 1.902v-7.612c.134-.047.265-.107.391-.18l.002-.002zm-1.893 7.754V14.33a2.277 2.277 0 01-.393-.18l-.023-.014-6.102-4.147v7.003c0 .275.145.528.379.664l.025.014 6.114 4.232z"></path>`;
const $2b6d0b8c1c80c786$export$ecf27b59f07713a6 = `<path fill-rule="evenodd" d="M8.75 8a.75.75 0 00-.75.75v6.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-6.5a.75.75 0 00-.75-.75h-6.5zm.75 6.5v-5h5v5h-5z"></path><path fill-rule="evenodd" d="M15.25 1a.75.75 0 01.75.75V4h2.25c.966 0 1.75.784 1.75 1.75V8h2.25a.75.75 0 010 1.5H20v5h2.25a.75.75 0 010 1.5H20v2.25A1.75 1.75 0 0118.25 20H16v2.25a.75.75 0 01-1.5 0V20h-5v2.25a.75.75 0 01-1.5 0V20H5.75A1.75 1.75 0 014 18.25V16H1.75a.75.75 0 010-1.5H4v-5H1.75a.75.75 0 010-1.5H4V5.75C4 4.784 4.784 4 5.75 4H8V1.75a.75.75 0 011.5 0V4h5V1.75a.75.75 0 01.75-.75zm3 17.5a.25.25 0 00.25-.25V5.75a.25.25 0 00-.25-.25H5.75a.25.25 0 00-.25.25v12.5c0 .138.112.25.25.25h12.5z"></path>`;
const $2b6d0b8c1c80c786$export$10e30f44c09301bc = `<path d="M0 2.75C0 1.783.784 1 1.75 1h12.5c.967 0 1.75.783 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.457 1.457 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.189l2.72-2.719a.747.747 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm20.5 6h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5c.199 0 .39.079.53.22l2.72 2.719V19.25a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25Zm-9.72-3.22-5 5a.747.747 0 0 1-1.06 0l-2.5-2.5a.749.749 0 1 1 1.06-1.06L7 8.689l4.47-4.469a.749.749 0 1 1 1.06 1.06Z"></path>`;
const $2b6d0b8c1c80c786$export$bfbc94b2ece7eb0 = `<path d="M16.944 11h4.306a.75.75 0 0 1 0 1.5h-4.306a5.001 5.001 0 0 1-9.888 0H2.75a.75.75 0 0 1 0-1.5h4.306a5.001 5.001 0 0 1 9.888 0Zm-1.444.75a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Z"></path>`;
const $2b6d0b8c1c80c786$export$33952fbd742aac4 = `<path fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM2.513 11.5h4.745c.1-3.037 1.1-5.49 2.093-7.204.39-.672.78-1.233 1.119-1.673C6.11 3.329 2.746 7 2.513 11.5zm4.77 1.5H2.552a9.505 9.505 0 007.918 8.377 15.698 15.698 0 01-1.119-1.673C8.413 18.085 7.47 15.807 7.283 13zm1.504 0h6.426c-.183 2.48-1.02 4.5-1.862 5.951-.476.82-.95 1.455-1.304 1.88L12 20.89l-.047-.057a13.888 13.888 0 01-1.304-1.88C9.807 17.5 8.969 15.478 8.787 13zm6.454-1.5H8.759c.1-2.708.992-4.904 1.89-6.451.476-.82.95-1.455 1.304-1.88L12 3.11l.047.057c.353.426.828 1.06 1.304 1.88.898 1.548 1.79 3.744 1.89 6.452zm1.476 1.5c-.186 2.807-1.13 5.085-2.068 6.704-.39.672-.78 1.233-1.118 1.673A9.505 9.505 0 0021.447 13h-4.731zm4.77-1.5h-4.745c-.1-3.037-1.1-5.49-2.093-7.204-.39-.672-.78-1.233-1.119-1.673 4.36.706 7.724 4.377 7.957 8.877z"></path>`;
const $2b6d0b8c1c80c786$export$1b5a510674cd8d75 = `<path d="M11.998 2.5A9.503 9.503 0 003.378 8H5.75a.75.75 0 010 1.5H2a1 1 0 01-1-1V4.75a.75.75 0 011.5 0v1.697A10.997 10.997 0 0111.998 1C18.074 1 23 5.925 23 12s-4.926 11-11.002 11C6.014 23 1.146 18.223 1 12.275a.75.75 0 011.5-.037 9.5 9.5 0 009.498 9.262c5.248 0 9.502-4.253 9.502-9.5s-4.254-9.5-9.502-9.5z"></path><path d="M12.5 7.25a.75.75 0 00-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 00.744-1.302L12.5 12.315V7.25z"></path>`;
const $2b6d0b8c1c80c786$export$39a30777d68f6342 = `<path d="M17.28 9.28a.75.75 0 00-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 00-1.06 1.06l3 3a.75.75 0 001.06 0l6.5-6.5z"></path><path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zM2.5 12a9.5 9.5 0 009.5 9.5 9.5 9.5 0 009.5-9.5A9.5 9.5 0 0012 2.5 9.5 9.5 0 002.5 12z"></path>`;
const $2b6d0b8c1c80c786$export$f33c9743f53d9bae = `<path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zM2.5 12a9.5 9.5 0 009.5 9.5 9.5 9.5 0 009.5-9.5A9.5 9.5 0 0012 2.5 9.5 9.5 0 002.5 12zm9.5 2a2 2 0 11-.001-3.999A2 2 0 0112 14z"></path>`;
const $2b6d0b8c1c80c786$export$fd71b7d70947f2b9 = `<path d="M12 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"></path><path d="M19.071 3.429h.001c3.905 3.905 3.905 10.237 0 14.142l-5.403 5.403a2.36 2.36 0 0 1-3.336 0l-5.375-5.375-.028-.028c-3.905-3.905-3.905-10.237 0-14.142 3.904-3.905 10.236-3.905 14.141 0ZM5.99 4.489v.001a8.5 8.5 0 0 0 0 12.02l.023.024.002.002 5.378 5.378a.859.859 0 0 0 1.214 0l5.403-5.404a8.5 8.5 0 0 0-.043-11.977A8.5 8.5 0 0 0 5.99 4.489Z"></path>`;
const $2b6d0b8c1c80c786$export$621c903272307c68 = `<path fill-rule="evenodd" d="M1.75 3A1.75 1.75 0 000 4.75v14c0 .966.784 1.75 1.75 1.75h20.5A1.75 1.75 0 0024 18.75v-14A1.75 1.75 0 0022.25 3H1.75zM1.5 4.75a.25.25 0 01.25-.25h20.5a.25.25 0 01.25.25v.852l-10.36 7a.25.25 0 01-.28 0l-10.36-7V4.75zm0 2.662V18.75c0 .138.112.25.25.25h20.5a.25.25 0 00.25-.25V7.412l-9.52 6.433c-.592.4-1.368.4-1.96 0L1.5 7.412z"></path>`;
const $2b6d0b8c1c80c786$export$cda80d001f0f5043 = `<path d="M12.292 2.06v-.001l11.25 4.75a.749.749 0 0 1 0 1.382L19 10.108V15a.75.75 0 0 1-.11.391h-.001a2.84 2.84 0 0 1-.392.482c-.249.256-.625.58-1.163.896-1.08.638-2.776 1.23-5.334 1.23-.673 0-1.286-.041-1.846-.113a.75.75 0 0 1 .192-1.487c.492.063 1.042.1 1.654.1 2.317 0 3.746-.533 4.572-1.021.31-.178.596-.397.849-.65l.079-.085V10.74l-5.208 2.2a.75.75 0 0 1-.584 0L5.75 10.424v3.17c.502.129.96.391 1.327.758.579.578.923 1.41.923 2.428v4.5a.761.761 0 0 1-.345.634 2.157 2.157 0 0 1-.21.117 3.923 3.923 0 0 1-.52.213A6.121 6.121 0 0 1 5 22.532a6.092 6.092 0 0 1-1.925-.288 4.065 4.065 0 0 1-.52-.213 1.816 1.816 0 0 1-.22-.124.757.757 0 0 1-.335-.624v-4.5c0-1.02.344-1.85.923-2.43a2.904 2.904 0 0 1 1.327-.757V9.793L.458 8.19a.75.75 0 0 1 0-1.38l11.25-4.75a.75.75 0 0 1 .584 0ZM12 11.436 21.322 7.5 12 3.564 2.678 7.5ZM5 15c-.377 0-.745.141-1.017.413-.265.265-.483.7-.483 1.368v4.022c.299.105.797.228 1.5.228s1.201-.123 1.5-.228V16.78c0-.669-.218-1.103-.483-1.368A1.433 1.433 0 0 0 5 15Z"></path>`;
const $2b6d0b8c1c80c786$export$ff9b16d1219fcc0a = `<path d="M7.25 12a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM6.5 9.25a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM7.25 5a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM10 12.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zm.75-4.25a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zM10 5.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM14.25 12a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5zm-.75-2.75a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zM14.25 5a.75.75 0 000 1.5h.5a.75.75 0 000-1.5h-.5z"></path><path fill-rule="evenodd" d="M3 20a2 2 0 002 2h3.75a.75.75 0 00.75-.75V19h3v2.25c0 .414.336.75.75.75H17c.092 0 .183-.006.272-.018a.758.758 0 00.166.018H21.5a2 2 0 002-2v-7.625a2 2 0 00-.8-1.6l-1-.75a.75.75 0 10-.9 1.2l1 .75a.5.5 0 01.2.4V20a.5.5 0 01-.5.5h-2.563c.041-.16.063-.327.063-.5V3a2 2 0 00-2-2H5a2 2 0 00-2 2v17zm2 .5a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h12a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-3v-2.25a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75v2.25H5z"></path>`;
const $2b6d0b8c1c80c786$export$555a75e14f058996 = `<path fill-rule="evenodd" d="M12.876.64a1.75 1.75 0 00-1.75 0l-8.25 4.762a1.75 1.75 0 00-.875 1.515v9.525c0 .625.334 1.203.875 1.515l8.25 4.763a1.75 1.75 0 001.75 0l8.25-4.762a1.75 1.75 0 00.875-1.516V6.917a1.75 1.75 0 00-.875-1.515L12.876.639zm-1 1.298a.25.25 0 01.25 0l7.625 4.402-7.75 4.474-7.75-4.474 7.625-4.402zM3.501 7.64v8.803c0 .09.048.172.125.216l7.625 4.402v-8.947L3.501 7.64zm9.25 13.421l7.625-4.402a.25.25 0 00.125-.216V7.639l-7.75 4.474v8.947z"></path>`;
const $2b6d0b8c1c80c786$export$5a3e17ae14a6e634 = `<path fill-rule="evenodd" d="M12 2.5a5.5 5.5 0 00-3.096 10.047 9.005 9.005 0 00-5.9 8.18.75.75 0 001.5.045 7.5 7.5 0 0114.993 0 .75.75 0 101.499-.044 9.005 9.005 0 00-5.9-8.181A5.5 5.5 0 0012 2.5zM8 8a4 4 0 118 0 4 4 0 01-8 0z"></path>`;
const $2b6d0b8c1c80c786$export$650e6e0bb930af3d = `<path fill-rule="evenodd" d="M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0120.25 22H3.75A1.75 1.75 0 012 20.25V3.75zM3.5 9v11.25c0 .138.112.25.25.25H7.5V9h-4zm4-1.5h-4V3.75a.25.25 0 01.25-.25H7.5v4zM9 9v11.5h11.25a.25.25 0 00.25-.25V9H9zm11.5-1.5H9v-4h11.25a.25.25 0 01.25.25V7.5z"></path>`;
const $2b6d0b8c1c80c786$export$fc296c5b33ee4678 = `<path d="M20 5.5a3.498 3.498 0 0 1-6.062 2.385l-5.112 3.021a3.498 3.498 0 0 1 0 2.188l5.112 3.021a3.5 3.5 0 1 1-.764 1.29l-5.112-3.02a3.499 3.499 0 1 1-3.843-5.642 3.499 3.499 0 0 1 3.843.872l5.112-3.021A3.5 3.5 0 1 1 20 5.5Zm-1.5 13a2 2 0 1 0-3.999-.001 2 2 0 0 0 3.999.001Zm0-13a2 2 0 1 0-3.999-.001A2 2 0 0 0 18.5 5.5ZM5.5 14a2 2 0 1 0 .001-3.999A2 2 0 0 0 5.5 14Z"></path>`;
const $2b6d0b8c1c80c786$export$e2895d44046646a0 = `<path fill-rule="evenodd" d="M.408 15.13a2 2 0 01.59-2.642L17.038 1.33a2 2 0 012.85.602l2.828 4.644a2 2 0 01-.851 2.847l-17.762 8.43a2 2 0 01-2.59-.807L.408 15.13zm5.263-4.066l7.842-5.455 2.857 4.76-8.712 4.135-1.987-3.44zm-1.235.86L1.854 13.72a.5.5 0 00-.147.66l1.105 1.915a.5.5 0 00.648.201l2.838-1.347-1.862-3.225zm13.295-2.2L14.747 4.75l3.148-2.19a.5.5 0 01.713.151l2.826 4.644a.5.5 0 01-.212.712l-3.49 1.656z"></path><path d="M17.155 22.87a.75.75 0 00.226-1.036l-4-6.239a.75.75 0 00-.941-.278l-2.75 1.25a.75.75 0 00-.318.274l-3.25 4.989a.75.75 0 001.256.819l3.131-4.806.51-.232v5.64a.75.75 0 101.5 0v-6.22l3.6 5.613a.75.75 0 001.036.226z"></path>`;
const $2b6d0b8c1c80c786$export$edee47a68ecb4770 = `<path d="M4 20.25V18a.75.75 0 0 1 1.5 0v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25Z"></path><path d="M5.22 9.53a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 1 1-1.06 1.06l-4.97-4.969V16.75a.75.75 0 0 1-1.5 0V4.561L6.28 9.53a.749.749 0 0 1-1.06 0Z"></path>`;
const $2b6d0b8c1c80c786$export$db80f3ef24ef3261 = `<path fill-rule="evenodd" d="M1.757 10.243a6 6 0 118.486-8.486 6 6 0 01-8.486 8.486zM6 4.763l-2-2L2.763 4l2 2-2 2L4 9.237l2-2 2 2L9.237 8l-2-2 2-2L8 2.763l-2 2z"></path>`;
const $2b6d0b8c1c80c786$export$bf3944942cf67ec4 = `<path fill-rule="evenodd" d="M6 0a6 6 0 100 12A6 6 0 006 0zm3 5H3v2h6V5z"></path>`;
const $2b6d0b8c1c80c786$export$58f7cbe4956d191c = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const b = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const c = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return `<linearGradient id="${a}" x1="24" x2="24" y1="6.708" y2="14.977" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#eba600"/><stop offset="1" stop-color="#c28200"/></linearGradient><path fill="url(#${a})" d="M24.414,10.414l-2.536-2.536C21.316,7.316,20.553,7,19.757,7L5,7C3.895,7,3,7.895,3,9l0,30	c0,1.105,0.895,2,2,2l38,0c1.105,0,2-0.895,2-2V13c0-1.105-0.895-2-2-2l-17.172,0C25.298,11,24.789,10.789,24.414,10.414z"/><linearGradient id="${b}" x1="24" x2="24" y1="10.854" y2="40.983" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffd869"/><stop offset="1" stop-color="#fec52b"/></linearGradient><path fill="url(#${b})" d="M21.586,14.414l3.268-3.268C24.947,11.053,25.074,11,25.207,11H43c1.105,0,2,0.895,2,2v26	c0,1.105-0.895,2-2,2H5c-1.105,0-2-0.895-2-2V15.5C3,15.224,3.224,15,3.5,15h16.672C20.702,15,21.211,14.789,21.586,14.414z"/><path fill="#c28200" d="M36,11.5v1c0,0.276-0.224,0.5-0.5,0.5H34c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h1.5	C35.776,11,36,11.224,36,11.5z M34,14c0-0.552-0.448-1-1-1h-1.5c-0.276,0-0.5,0.224-0.5,0.5v1c0,0.276,0.224,0.5,0.5,0.5H33	C33.552,15,34,14.552,34,14z M33,16c0,0.552,0.448,1,1,1h1.5c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5H34	C33.448,15,33,15.448,33,16z M34,18c0-0.552-0.448-1-1-1h-1.5c-0.276,0-0.5,0.224-0.5,0.5v1c0,0.276,0.224,0.5,0.5,0.5H33	C33.552,19,34,18.552,34,18z M33,20c0,0.552,0.448,1,1,1h1.5c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5H34	C33.448,19,33,19.448,33,20z M33,24c0,0.552,0.448,1,1,1h1.5c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5H34	C33.448,23,33,23.448,33,24z M34,22c0-0.552-0.448-1-1-1h-1.5c-0.276,0-0.5,0.224-0.5,0.5v1c0,0.276,0.224,0.5,0.5,0.5H33	C33.552,23,34,22.552,34,22z"/><linearGradient id="${c}" x1="33.5" x2="33.5" y1="25.944" y2="37.581" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4b4b4b"/><stop offset="1" stop-color="#3b3b3b"/></linearGradient><path fill="url(#${c})" d="M36.128,26.848C36.055,26.358,35.635,26,35.139,26h-3.279c-0.495,0-0.915,0.358-0.988,0.848	C30.603,28.65,30,32.761,30,33.5c0,1.933,1.567,3.5,3.5,3.5s3.5-1.567,3.5-3.5C37,32.761,36.397,28.65,36.128,26.848z M33.5,35	c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S34.328,35,33.5,35z"/>`;
};
const $2b6d0b8c1c80c786$export$29cc6e2997da5d20 = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return `<rect width="16" height="9" x="28" y="15" fill="#21a366"/><path fill="#185c37" d="M44,24H12v16c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2V24z"/><rect width="16" height="9" x="28" y="24" fill="#107c42"/><rect width="16" height="9" x="12" y="15" fill="#3fa071"/><path fill="#33c481" d="M42,6H28v9h16V8C44,6.895,43.105,6,42,6z"/><path fill="#21a366" d="M14,6h14v9H12V8C12,6.895,12.895,6,14,6z"/><path d="M22.319,13H12v24h10.319C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z" opacity=".05"/><path d="M22.213,36H12V13.333h10.213c1.724,0,3.121,1.397,3.121,3.121v16.425	C25.333,34.603,23.936,36,22.213,36z" opacity=".07"/><path d="M22.106,35H12V13.667h10.106c1.414,0,2.56,1.146,2.56,2.56V32.44C24.667,33.854,23.52,35,22.106,35z" opacity=".09"/><linearGradient id="${a}" x1="4.725" x2="23.055" y1="14.725" y2="33.055" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#18884f"/><stop offset="1" stop-color="#0b6731"/></linearGradient><path fill="url(#${a})" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"/><path fill="#fff" d="M9.807,19h2.386l1.936,3.754L16.175,19h2.229l-3.071,5l3.141,5h-2.351l-2.11-3.93L11.912,29H9.526	l3.193-5.018L9.807,19z"/>`;
};
const $2b6d0b8c1c80c786$export$d9a0bc075772ac34 = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return `<path fill="#d35230" d="M8,24c0,9.941,8.059,18,18,18s18-8.059,18-18H26H8z"/><path fill="#ff8f6b" d="M26,6v18h18C44,14.059,35.941,6,26,6z"/><path fill="#ed6c47" d="M26,6C16.059,6,8,14.059,8,24h18V6z"/><path d="M26,16.681C26,14.648,24.352,13,22.319,13H11.774C9.417,16.044,8,19.852,8,24	c0,5.116,2.145,9.723,5.571,13h8.747C24.352,37,26,35.352,26,33.319V16.681z" opacity=".05"/><path d="M22.213,13.333H11.525C9.32,16.321,8,20.002,8,24c0,4.617,1.753,8.814,4.611,12h9.602	c1.724,0,3.121-1.397,3.121-3.121V16.454C25.333,14.731,23.936,13.333,22.213,13.333z" opacity=".07"/><path d="M22.106,13.667H11.276C9.218,16.593,8,20.151,8,24c0,4.148,1.417,7.956,3.774,11h10.332	c1.414,0,2.56-1.146,2.56-2.56V16.227C24.667,14.813,23.52,13.667,22.106,13.667z" opacity=".09"/><linearGradient id="${a}" x1="4.586" x2="22.77" y1="14.586" y2="32.77" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ca4e2a"/><stop offset="1" stop-color="#b63016"/></linearGradient><path fill="url(#${a})" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"/><path fill="#fff" d="M14.673,19.012H10v10h2.024v-3.521H14.3c1.876,0,3.397-1.521,3.397-3.397v-0.058	C17.697,20.366,16.343,19.012,14.673,19.012z M15.57,22.358c0,0.859-0.697,1.556-1.556,1.556h-1.99v-3.325h1.99	c0.859,0,1.556,0.697,1.556,1.556V22.358z"/>`;
};
const $2b6d0b8c1c80c786$export$c0a3bce27570b6d0 = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const b = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const c = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const d = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const e = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return `<linearGradient id="${a}" x1="28" x2="28" y1="14.966" y2="6.45" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#42a3f2"/><stop offset="1" stop-color="#42a4eb"/></linearGradient><path fill="url(#${a})" d="M42,6H14c-1.105,0-2,0.895-2,2v7.003h32V8C44,6.895,43.105,6,42,6z"/><linearGradient id="${b}" x1="28" x2="28" y1="42" y2="33.054" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#11408a"/><stop offset="1" stop-color="#103f8f"/></linearGradient><path fill="url(#${b})" d="M12,33.054V40c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2v-6.946H12z"/><linearGradient id="${c}" x1="28" x2="28" y1="-15.46" y2="-15.521" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#3079d6"/><stop offset="1" stop-color="#297cd2"/></linearGradient><path fill="url(#${c})" d="M12,15.003h32v9.002H12V15.003z"/><linearGradient id="${d}" x1="12" x2="44" y1="28.53" y2="28.53" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1d59b3"/><stop offset="1" stop-color="#195bbc"/></linearGradient><path fill="url(#${d})" d="M12,24.005h32v9.05H12V24.005z"/><path d="M22.319,13H12v24h10.319C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z" opacity=".05"/><path d="M22.213,36H12V13.333h10.213c1.724,0,3.121,1.397,3.121,3.121v16.425	C25.333,34.603,23.936,36,22.213,36z" opacity=".07"/><path d="M22.106,35H12V13.667h10.106c1.414,0,2.56,1.146,2.56,2.56V32.44C24.667,33.854,23.52,35,22.106,35z" opacity=".09"/><linearGradient id="${e}" x1="4.744" x2="23.494" y1="14.744" y2="33.493" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#256ac2"/><stop offset="1" stop-color="#1247ad"/></linearGradient><path fill="url(#${e})" d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"/><path fill="#fff" d="M18.403,19l-1.546,7.264L15.144,19h-2.187l-1.767,7.489L9.597,19H7.641l2.344,10h2.352l1.713-7.689	L15.764,29h2.251l2.344-10H18.403z"/>`;
};
const $2b6d0b8c1c80c786$export$159b3fe6c427bb44 = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const b = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return `<linearGradient id="${a}" x1="6.949" x2="35.445" y1="6.949" y2="35.445" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fede00"/><stop offset="1" stop-color="#ffd000"/></linearGradient><path fill="url(#${a})" d="M29,42H8c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h32c1.105,0,2,0.895,2,2v21L29,42z"/><linearGradient id="${b}" x1="29.592" x2="35.671" y1="29.592" y2="35.671" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#4b4b4b"/><stop offset="1" stop-color="#3b3b3b"/></linearGradient><path fill="url(#${b})" d="M31,29h11L29,42V31C29,29.895,29.895,29,31,29z"/><line x1="13" x2="35" y1="18" y2="18" fill="none" stroke="#e8ba13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><line x1="13" x2="35" y1="24" y2="24" fill="none" stroke="#e8ba13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><line x1="13" x2="23" y1="30" y2="30" fill="none" stroke="#e8ba13" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>`;
};
const $2b6d0b8c1c80c786$export$65168b0c06a6c4ec = ()=>{
    // const a =newElementId();
    return `<path fill="#b30b00" d="M38,42H10c-2.209,0-4-1.791-4-4V10c0-2.209,1.791-4,4-4h28c2.209,0,4,1.791,4,4v28	C42,40.209,40.209,42,38,42z"/><path fill="#fff" d="M35.241,26.799c-1.692-1.757-6.314-1.041-7.42-0.911c-1.627-1.562-2.734-3.45-3.124-4.101	c0.586-1.757,0.976-3.515,1.041-5.402c0-1.627-0.651-3.385-2.473-3.385c-0.651,0-1.237,0.391-1.562,0.911	c-0.781,1.367-0.456,4.101,0.781,6.899c-0.716,2.018-1.367,3.97-3.189,7.42c-1.888,0.781-5.858,2.604-6.183,4.556	c-0.13,0.586,0.065,1.172,0.521,1.627C14.088,34.805,14.673,35,15.259,35c2.408,0,4.751-3.32,6.379-6.118	c1.367-0.456,3.515-1.107,5.663-1.497c2.538,2.213,4.751,2.538,5.923,2.538c1.562,0,2.148-0.651,2.343-1.237	C35.892,28.036,35.697,27.32,35.241,26.799z M33.614,27.905c-0.065,0.456-0.651,0.911-1.692,0.651	c-1.237-0.325-2.343-0.911-3.32-1.692c0.846-0.13,2.734-0.325,4.101-0.065C33.224,26.929,33.744,27.254,33.614,27.905z M22.744,14.497c0.13-0.195,0.325-0.325,0.521-0.325c0.586,0,0.716,0.716,0.716,1.302c-0.065,1.367-0.325,2.734-0.781,4.036	C22.224,16.905,22.419,15.083,22.744,14.497z M22.614,27.124c0.521-1.041,1.237-2.864,1.497-3.645	c0.586,0.976,1.562,2.148,2.083,2.669C26.194,26.213,24.176,26.604,22.614,27.124z M18.774,29.728	c-1.497,2.473-3.059,4.036-3.905,4.036c-0.13,0-0.26-0.065-0.391-0.13c-0.195-0.13-0.26-0.325-0.195-0.586	C14.478,32.136,16.17,30.899,18.774,29.728z"/>`;
};
const $2b6d0b8c1c80c786$export$96888ae35506642f = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const b = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return `<path fill="#50e6ff" d="M40,6H8C6.895,6,6,6.895,6,8v30c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V8 C42,6.895,41.105,6,40,6z"/><linearGradient id="${a}" x1="18" x2="42" y1="32.093" y2="32.093" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#3ccbf4"/><stop offset="1" stop-color="#1fa0e5"/></linearGradient><path fill="url(#${a})" d="M32.065,23.065c-1.149-1.149-3.005-1.174-4.185-0.057L18,32.368V42h22c1.105,0,2-0.895,2-2 v-7L32.065,23.065z"/><circle cx="30.5" cy="14.5" r="3.5" fill="#fff8de"/><linearGradient id="${b}" x1="23.91" x2="23.91" y1="18.186" y2="42" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#28afea"/><stop offset="1" stop-color="#0b88da"/></linearGradient><path fill="url(#${b})" d="M8,42h32c0.811,0,1.507-0.485,1.82-1.18L20.065,19.065c-1.149-1.149-3.005-1.174-4.185-0.057 L6,28.368V40C6,41.105,6.895,42,8,42z"/>`;
};
const $2b6d0b8c1c80c786$export$bb84843656fecdd6 = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const b = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return `<radialGradient id="${a}" cx="50.744" cy="33.882" r="23.827" gradientTransform="matrix(1.0244 0 0 1.0645 -1.098 -1.58)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#bd8af5"/><stop offset=".137" stop-color="#b88bf5"/><stop offset=".309" stop-color="#a88ff3"/><stop offset=".499" stop-color="#8f96f2"/><stop offset=".702" stop-color="#6b9eef"/><stop offset=".913" stop-color="#3eaaec"/><stop offset="1" stop-color="#29afea"/></radialGradient><path fill="url(#${a})" d="M43,41H5c-1.105,0-2-0.895-2-2V10c0-1.105,0.895-2,2-2h38c1.105,0,2,0.895,2,2v29	C45,40.105,44.105,41,43,41z"/><linearGradient id="${b}" x1="21" x2="21" y1="20.753" y2="41.352" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#124787"/><stop offset=".923" stop-color="#173b75"/><stop offset="1" stop-color="#173a73"/></linearGradient><path fill="url(#${b})" d="M19.715,21.715c-1.223-1.223-3.206-1.223-4.429,0L3,34v5c0,1.105,0.895,2,2,2h34	L19.715,21.715z"/><path fill="#436dcd" d="M43,41c1.105,0,2-0.895,2-2v-1L32.715,25.715c-1.223-1.223-3.206-1.223-4.429,0L13,41H43z"/><path fill="#fff" d="M41,16h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,15.552,41.552,16,41,16z"/><path fill="#fff" d="M41,23h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,22.552,41.552,23,41,23z"/><path fill="#fff" d="M41,30h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,29.552,41.552,30,41,30z"/><path fill="#fff" d="M41,37h-2c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C42,36.552,41.552,37,41,37z"/><path fill="#fff" d="M9,16H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,15.552,9.552,16,9,16z"/><path fill="#fff" d="M9,23H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,22.552,9.552,23,9,23z"/><path fill="#fff" d="M9,30H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,29.552,9.552,30,9,30z"/><path fill="#fff" d="M9,37H7c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v2	C10,36.552,9.552,37,9,37z"/>`;
};
const $2b6d0b8c1c80c786$export$cfe0d2093124992d = ()=>{
    const a = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const b = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    // return `<linearGradient id="${a}" x1="64" x2="64" y1="36.83" y2="104.33" gradientUnits="userSpaceOnUse"><stop stop-color="#ffc107" offset="0"/><stop stop-color="#ffd54f" offset="1"/></linearGradient><linearGradient id="${a}" x1="64" x2="64" y1="8.46" y2="72.15" gradientUnits="userSpaceOnUse"><stop stop-color="#ffe082" offset="0"/><stop stop-color="#ffca28" offset=".99"/></linearGradient><path d="M120 104H8c-2.2 0-4-1.8-4-4V28c0-2.2 1.8-4 4-4h112c2.2 0 4 1.8 4 4v72c0 2.2-1.8 4-4 4z" fill="url(#${a})" transform="translate(2.67 2.67) scale(.33333)"/><path d="M124 30.2V28c0-2.2-1.8-4-4-4H8c-2.2 0-4 1.8-4 4v2l59.9 46.1z" fill="url(#${b})" transform="translate(2.67 2.67) scale(.33333)"/><g fill="#ffb300" stroke-width="3"><path d="M17.37 23.27 4.67 37.13a1.2 1.2 0 0 1-.6-.83l12.6-13.73zM43.93 36.43c-.1.34-.33.6-.66.77L30.6 23.23l.73-.66z"/><path d="M44 12.33v1.27L23.97 28.67 4 13.53V12.3l19.97 15.13z"/></g><path d="M42.67 11.67c.2 0 .33.16.33.33v24c0 .2-.13.33-.33.33H5.33c-.2 0-.33-.13-.33-.33V12c0-.17.13-.33.33-.33zm0-1H5.33C4.6 10.67 4 11.27 4 12v24c0 .73.6 1.33 1.33 1.33h37.34c.73 0 1.33-.6 1.33-1.33V12c0-.73-.6-1.33-1.33-1.33z" fill="#444" opacity=".2"/>`;
    return `<linearGradient id="${a}" x1="16" x2="16" y2="23.27" gradientTransform="scale(1.25)" gradientUnits="userSpaceOnUse"><stop stop-color="#fac227" offset="0"/><stop stop-color="#faa627" offset="1"/></linearGradient><linearGradient id="${b}" x1="16" x2="16" y2="14.79" gradientTransform="scale(1.25)" gradientUnits="userSpaceOnUse"><stop stop-color="#fce4b1" offset="0"/><stop stop-color="#ffd272" offset="1"/></linearGradient><path d="M36.36 0H3.64C1.63 0 0 1.63 0 3.64v21.81c0 2.01 1.63 3.64 3.64 3.64h32.72c2.01 0 3.64-1.63 3.64-3.64V3.64C40 1.63 38.37 0 36.36 0z" fill="url(#${a})" transform="translate(4 9.45)"/><path d="M36.36 0H3.64a3.6 3.6 0 0 0-2.57 1.07l16.36 16.36a3.6 3.6 0 0 0 3.96.79 3.6 3.6 0 0 0 1.18-.8L38.94 1.08A3.6 3.6 0 0 0 36.36 0z" clip-rule="evenodd" fill="url(#${b})" fill-rule="evenodd" transform="translate(4 9.45)"/>`;
};
function $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27(content, classesOrArgs) {
    let classes;
    let hidden;
    let target;
    let ariaHidden;
    let ariaLabel;
    let size;
    let viewBox;
    let octicon;
    if (classesOrArgs === undefined || typeof classesOrArgs === "string") {
        classes = classesOrArgs || "";
        hidden = false;
        target = "";
        ariaHidden = true;
        ariaLabel = "";
        size = "1em";
        viewBox = 16;
        octicon = true;
    } else {
        classes = classesOrArgs.classes || "";
        hidden = classesOrArgs.hidden || false;
        target = classesOrArgs.target || "";
        ariaHidden = classesOrArgs.ariaHidden || true;
        ariaLabel = classesOrArgs.ariaLabel || "";
        size = classesOrArgs.size ?? "1em";
        viewBox = classesOrArgs.viewBox ?? 16;
        octicon = classesOrArgs.octicon ?? true;
    }
    if (octicon) classes = "octicon " + classes;
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${size}"
    height="${size}"
    class="${classes}"
    viewBox="0 0 ${viewBox} ${viewBox}"
    ${(0, $904f4b114d3dc756$export$65c20e333206336e)("hidden", hidden)}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-hidden", ariaHidden ? "true" : null)}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-label", ariaLabel)}
  >
    ${(0, $904f4b114d3dc756$export$b6e69390c23686fb)(content)}
  </svg>`;
}
const $2b6d0b8c1c80c786$export$22aebbff0935e083 = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1000 1000"
  width="1em"
  height="1em"
  class="octicon"
  aria-hidden="true"
>
  <path
    d="M292.92 3.5c-53.2 2.51-89.53 11-121.29 23.48-32.87 12.81-60.73 30-88.45 57.82s-44.79 55.7-57.51 88.62c-12.31 31.83-20.65 68.19-23 121.42S-.2 365.18.06 500.96.92 653.76 3.5 707.1c2.54 53.19 11 89.51 23.48 121.28 12.83 32.87 30 60.72 57.83 88.45s55.69 44.76 88.69 57.5c31.8 12.29 68.17 20.67 121.39 23s70.35 2.87 206.09 2.61 152.83-.86 206.16-3.39 89.46-11.05 121.24-23.47c32.87-12.86 60.74-30 88.45-57.84s44.77-55.74 57.48-88.68c12.32-31.8 20.69-68.17 23-121.35 2.33-53.37 2.88-70.41 2.62-206.17s-.87-152.78-3.4-206.1-11-89.53-23.47-121.32c-12.85-32.87-30-60.7-57.82-88.45s-55.74-44.8-88.67-57.48c-31.82-12.31-68.17-20.7-121.39-23S634.83-.2 499.04.06 346.25.9 292.92 3.5m5.84 903.88c-48.75-2.12-75.22-10.22-92.86-17-23.36-9-40-19.88-57.58-37.29s-28.38-34.11-37.5-57.42c-6.85-17.64-15.1-44.08-17.38-92.83-2.48-52.69-3-68.51-3.29-202s.22-149.29 2.53-202c2.08-48.71 10.23-75.21 17-92.84 9-23.39 19.84-40 37.29-57.57s34.1-28.39 57.43-37.51c17.62-6.88 44.06-15.06 92.79-17.38 52.73-2.5 68.53-3 202-3.29s149.31.21 202.06 2.53c48.71 2.12 75.22 10.19 92.83 17 23.37 9 40 19.81 57.57 37.29s28.4 34.07 37.52 57.45c6.89 17.57 15.07 44 17.37 92.76 2.51 52.73 3.08 68.54 3.32 202s-.23 149.31-2.54 202c-2.13 48.75-10.21 75.23-17 92.89-9 23.35-19.85 40-37.31 57.56s-34.09 28.38-57.43 37.5c-17.6 6.87-44.07 15.07-92.76 17.39-52.73 2.48-68.53 3-202.05 3.29s-149.27-.25-202-2.53m407.6-674.61a60 60 0 1 0 59.88-60.1 60 60 0 0 0-59.88 60.1M243.27 500.5c.28 141.8 115.44 256.49 257.21 256.22S757.02 641.3 756.75 499.5 641.29 242.98 499.5 243.26 243 358.72 243.27 500.5m90.06-.18a166.67 166.67 0 1 1 167 166.34 166.65 166.65 0 0 1-167-166.34"
  />
</svg>`;
const $2b6d0b8c1c80c786$export$b7f3903a38ca0cb9 = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 248 204"
  width="1em"
  height="1em"
  class="octicon"
  aria-hidden="true"
>
  <path
    d="M221.95 51.29c.15 2.17.15 4.34.15 6.53 0 66.73-50.8 143.69-143.69 143.69v-.04c-27.44.04-54.31-7.82-77.41-22.64 3.99.48 8 .72 12.02.73 22.74.02 44.83-7.61 62.72-21.66-21.61-.41-40.56-14.5-47.18-35.07a50.338 50.338 0 0 0 22.8-.87C27.8 117.2 10.85 96.5 10.85 72.46v-.64a50.18 50.18 0 0 0 22.92 6.32C11.58 63.31 4.74 33.79 18.14 10.71a143.333 143.333 0 0 0 104.08 52.76 50.532 50.532 0 0 1 14.61-48.25c20.34-19.12 52.33-18.14 71.45 2.19 11.31-2.23 22.15-6.38 32.07-12.26a50.69 50.69 0 0 1-22.2 27.93c10.01-1.18 19.79-3.86 29-7.95a102.594 102.594 0 0 1-25.2 26.16z"
  />
</svg>`;


const $de5ef9373ca12f93$export$eaf979886d81968c = [
    "activity",
    "activity_definition",
    "user"
];
const $de5ef9373ca12f93$export$5bccd096041570b4 = [
    "activities",
    "activity-definitions",
    "users"
];
const $de5ef9373ca12f93$export$3b981eac32477b40 = {
    activity: "activities",
    activity_definition: "activity-definitions",
    user: "users"
};
const $de5ef9373ca12f93$export$dc056cc4b4df1c55 = {
    activities: "activity",
    "activity-definitions": "activity_definition",
    users: "user"
};
const $de5ef9373ca12f93$var$oneMb = 1000000;
const $de5ef9373ca12f93$export$e8852085401b0377 = [
    {
        category: (locale)=>(0, $2868cc1235412e16$export$6a584c99ae610576)[locale],
        extensions: [
            "gif"
        ],
        contentType: "image/gif",
        maxBytes: 10 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$96888ae35506642f),
        disposition: "inline"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$6a584c99ae610576)[locale],
        extensions: [
            "jpeg",
            "jpg"
        ],
        contentType: "image/jpeg",
        maxBytes: 10 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$96888ae35506642f),
        disposition: "inline"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$6a584c99ae610576)[locale],
        extensions: [
            "png"
        ],
        contentType: "image/png",
        maxBytes: 10 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$96888ae35506642f),
        disposition: "inline"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$6a584c99ae610576)[locale],
        extensions: [
            "svg"
        ],
        contentType: "image/svg+xml",
        maxBytes: $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$96888ae35506642f),
        disposition: "inline"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$6a584c99ae610576)[locale],
        extensions: [
            "tif",
            "tiff"
        ],
        contentType: "image/tiff",
        maxBytes: 10 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$96888ae35506642f),
        disposition: "inline"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$cfeaf0cdb33173c8)[locale],
        extensions: [
            "mov"
        ],
        contentType: "video/quicktime",
        maxBytes: 100 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$bb84843656fecdd6),
        disposition: "inline"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$cfeaf0cdb33173c8)[locale],
        extensions: [
            "mp4"
        ],
        contentType: "video/mp4",
        maxBytes: 100 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$bb84843656fecdd6),
        disposition: "inline"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$cfeaf0cdb33173c8)[locale],
        extensions: [
            "webm"
        ],
        contentType: "video/webm",
        maxBytes: 100 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$bb84843656fecdd6),
        disposition: "inline"
    },
    {
        category: ()=>"Excel",
        extensions: [
            "csv"
        ],
        contentType: "text/csv",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$29cc6e2997da5d20),
        disposition: "attachment"
    },
    {
        category: ()=>"Word",
        extensions: [
            "doc"
        ],
        contentType: "application/msword",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$c0a3bce27570b6d0),
        disposition: "attachment"
    },
    {
        category: ()=>"Word",
        extensions: [
            "docx"
        ],
        contentType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$c0a3bce27570b6d0),
        disposition: "attachment"
    },
    {
        category: ()=>"PDF",
        extensions: [
            "pdf"
        ],
        contentType: "application/pdf",
        maxBytes: 50 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$65168b0c06a6c4ec),
        disposition: "inline"
    },
    {
        category: ()=>"PowerPoint",
        extensions: [
            "pptx"
        ],
        contentType: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$d9a0bc075772ac34),
        disposition: "attachment"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$b0a5b2684ddaafba)[locale],
        extensions: [
            "txt"
        ],
        contentType: "text/plain",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$159b3fe6c427bb44),
        disposition: "inline"
    },
    {
        category: ()=>"Excel",
        extensions: [
            "xls"
        ],
        contentType: "application/vnd.ms-excel",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$29cc6e2997da5d20),
        disposition: "attachment"
    },
    {
        category: ()=>"Excel",
        extensions: [
            "xlsx"
        ],
        contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$29cc6e2997da5d20),
        disposition: "attachment"
    },
    {
        category: ()=>"Zip",
        extensions: [
            "zip"
        ],
        contentType: "application/zip",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$58f7cbe4956d191c),
        disposition: "attachment"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$535dc873d3acbcb5)[locale],
        extensions: [
            "eml"
        ],
        contentType: "message/rfc822",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$cfe0d2093124992d),
        disposition: "attachment"
    },
    {
        category: (locale)=>(0, $2868cc1235412e16$export$535dc873d3acbcb5)[locale],
        extensions: [
            "msg"
        ],
        contentType: "application/vnd.ms-outlook",
        maxBytes: 25 * $de5ef9373ca12f93$var$oneMb,
        icon48: (0, $2b6d0b8c1c80c786$export$cfe0d2093124992d),
        disposition: "attachment"
    }
];
const $de5ef9373ca12f93$export$5ffdd612119f3f64 = {
    "application/x-zip-compressed": "application/zip",
    "application/zip-compressed": "application/zip"
};
const $de5ef9373ca12f93$export$eeb27369891ab017 = Object.values((0, $a3570cdd24dfa717$export$3f063810d7bf01bd)($de5ef9373ca12f93$export$e8852085401b0377, (x)=>x.category((0, $f2e3bdb9929a0de6$export$d7f512c98c859244)))).sort((a, b)=>a[0].category((0, $f2e3bdb9929a0de6$export$d7f512c98c859244)).localeCompare(b[0].category((0, $f2e3bdb9929a0de6$export$d7f512c98c859244))));
const $de5ef9373ca12f93$export$765f51da3aaa6d7a = (0, $a3570cdd24dfa717$export$e439fc32198f78c5)($de5ef9373ca12f93$export$e8852085401b0377, "contentType");
const $de5ef9373ca12f93$export$1d5ffa38c010beaf = $de5ef9373ca12f93$export$e8852085401b0377.reduce((acc, type)=>{
    for (const extension of type.extensions)acc[extension] = type;
    return acc;
}, {});
const $de5ef9373ca12f93$export$f76cdb99ddb8b1db = $de5ef9373ca12f93$export$e8852085401b0377.reduce((acc, type)=>acc.concat(type.extensions), []).sort();
const $de5ef9373ca12f93$export$900ffc5245513099 = new RegExp(`^/attachments/(?:activities|activity-definitions)/([0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12})/([0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12})\.(?:${$de5ef9373ca12f93$export$f76cdb99ddb8b1db.join("|")})$`);
function $de5ef9373ca12f93$export$e664a7e29bcdaa29(owner_slug, owner_id, attachments, body) {
    return attachments.filter((a)=>a.property_id || body.indexOf(`(/attachments/${owner_slug}/${owner_id}/${a.attachment_id}.`) !== -1);
}
function $de5ef9373ca12f93$export$5f7821c344028c56(basename) {
    const index = basename.lastIndexOf(".");
    if (index === -1) return "";
    return basename.substr(index + 1).toLowerCase();
}
function $de5ef9373ca12f93$export$fa302515f2a866ab(filename) {
    return (0, $426ea2ef2dc61d30$export$2e2bcd8739ae039)(filename, {
        replacement: "-",
        maxLength: 100
    });
}
function $de5ef9373ca12f93$export$85861430feffd419(locale, filename) {
    const sanitized = $de5ef9373ca12f93$export$fa302515f2a866ab(filename);
    if (sanitized.length === 0) return {
        valid: false,
        reason: (0, $2868cc1235412e16$export$91e9ba9f3f646b82)[locale](filename)
    };
    if (sanitized[0] === ".") return {
        valid: false,
        reason: (0, $2868cc1235412e16$export$91e9ba9f3f646b82)[locale](filename)
    };
    const extension = $de5ef9373ca12f93$export$5f7821c344028c56(sanitized);
    if (extension.length === 0) return {
        valid: false,
        reason: (0, $2868cc1235412e16$export$df24ac9db9ed80e4)[locale](filename)
    };
    const type = $de5ef9373ca12f93$export$e8852085401b0377.find((type)=>type.extensions.includes(extension.toLowerCase()));
    if (!type) return {
        valid: false,
        reason: (0, $2868cc1235412e16$export$a61f4000938e5ea3)[locale](extension, filename, $de5ef9373ca12f93$export$f76cdb99ddb8b1db.join(", "))
    };
    return {
        valid: true,
        filename: sanitized,
        extension: extension.toLowerCase(),
        originalFilename: filename,
        type: type
    };
}
function $de5ef9373ca12f93$export$2afbadb17474b14c(locale, filename, type, sizeBytes) {
    if (sizeBytes === 0) return {
        valid: false,
        reason: (0, $2868cc1235412e16$export$c4b05ddd15bcedcd)[locale](filename)
    };
    if (sizeBytes > type.maxBytes) return {
        valid: false,
        reason: (0, $2868cc1235412e16$export$20aa924aeb55054c)[locale](filename, type.extensions[0], `${type.maxBytes / $de5ef9373ca12f93$var$oneMb}MB`)
    };
    return {
        valid: true
    };
}

/// <reference path="declarations.d.ts" />
/**
 * Unexpected response from a dependency.
 */ class $06268db7bba09be5$export$ea86d8b2c6b5cbfd extends Error {
    /**
     * @param {Response} response
     * @param {string?} text
     */ constructor({ url: url, status: status, statusText: statusText, headers: headers }, text){
        super(`${$06268db7bba09be5$var$sanitizeUrl(url)} responded with ${status}: ${statusText}\nHeaders: ${JSON.stringify(Object.fromEntries(headers), null, 2)}${text ? "\n" + text : ""}`);
        this.name = this.constructor.name;
        this.status = status;
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, this.constructor);
    }
}
function $06268db7bba09be5$var$sanitizeUrl(url) {
    try {
        const parsed = new URL(url);
        for (const key of [
            "token",
            "key",
            "access_token",
            "client_id",
            "client_secret"
        ])if (parsed.searchParams.has(key)) parsed.searchParams.set(key, "redacted");
        url = parsed.href;
    } catch  {}
    if (url.length > 2500) return url.substr(0, 2500) + ` [URL truncated to 2500 characters. Original length: ${url.length}]`;
    return url;
}



// keep ref in case user translates page.
const $58ccb23ba1dadd05$var$originalLang = document.documentElement.lang;
function $58ccb23ba1dadd05$export$180605366c04f0cd() {
    return $58ccb23ba1dadd05$var$originalLang;
}





const $c7540adae100fff1$var$sessionExpiredModalId = "session-expired-modal";
function $c7540adae100fff1$var$displaySessionExpiredModal() {
    if (document.getElementById($c7540adae100fff1$var$sessionExpiredModalId)) return;
    const locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
    document.body.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<modal-content id="${$c7540adae100fff1$var$sessionExpiredModalId}" force-submit>
        <div class="Box Box--width-md anim-fade-in fast">
          <div class="Box-header">
            <h3 class="Box-title">${(0, $2868cc1235412e16$export$403a32688f6224ee)[locale]}</h3>
          </div>
          <div class="Box-body">
            <p>${(0, $2868cc1235412e16$export$6896487a24fde326)[locale]}</p>
            ${REQUIRES_AUTHENTICATION === "standard" ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a
                  class="btn btn-primary target-subtle"
                  href="/auth/sign-in?redirect_uri=${location.origin}/auth/signed-in"
                  target="_blank"
                  modal-dismiss
                >
                  ${(0, $2868cc1235412e16$export$df7d62b22f2942d4)[locale]}
                </a>` : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a
                  class="btn btn-primary"
                  href="${location.pathname}${location.search}"
                >
                  ${(0, $2868cc1235412e16$export$df7d62b22f2942d4)[locale]}
                </a>`}
          </div>
        </div>
      </modal-content>`));
}
function $c7540adae100fff1$export$91cdf58e199a84d0({ status: status, url: url }) {
    if (status === 401 && new URL(url, location.origin).origin === location.origin) {
        $c7540adae100fff1$var$displaySessionExpiredModal();
        return true;
    }
    return false;
}
let $c7540adae100fff1$var$checkSessionDebounce = 0;
function $c7540adae100fff1$var$scheduleCheckSession() {
    clearTimeout($c7540adae100fff1$var$checkSessionDebounce);
    $c7540adae100fff1$var$checkSessionDebounce = setTimeout($c7540adae100fff1$var$checkSession, 100);
}
let $c7540adae100fff1$var$checkingSession = false;
async function $c7540adae100fff1$var$checkSession() {
    clearTimeout($c7540adae100fff1$var$checkSessionDebounce);
    if ($c7540adae100fff1$var$checkingSession) return;
    $c7540adae100fff1$var$checkingSession = true;
    try {
        const response = await fetch(new URL("/auth/check-session", location.origin), {
            method: "GET"
        });
        if ($c7540adae100fff1$export$91cdf58e199a84d0(response)) return;
        if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
        document.getElementById($c7540adae100fff1$var$sessionExpiredModalId)?.remove();
    } finally{
        $c7540adae100fff1$var$checkingSession = false;
    }
}
if (REQUIRES_AUTHENTICATION) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
    document.addEventListener("visibilitychange", ()=>{
        if (document.visibilityState === "visible") $c7540adae100fff1$var$checkSession();
    });
    // https://github.com/github/remote-input-element/blob/main/src/index.ts#L144
    addEventListener("remote-input-error", (event)=>{
        if (event.target instanceof Element && event.target.tagName === "REMOTE-INPUT") $c7540adae100fff1$var$scheduleCheckSession();
    });
    // https://github.com/github/include-fragment-element/blob/main/src/include-fragment-element.ts#L261
    // https://github.com/github/auto-complete-element/blob/main/src/autocomplete.ts#L232
    addEventListener("error", (event)=>{
        if (event.target instanceof Element && [
            "INCLUDE-FRAGMENT",
            "AUTO-COMPLETE"
        ].includes(event.target.tagName)) $c7540adae100fff1$var$scheduleCheckSession();
    }, {
        capture: true
    });
}


addEventListener("file-attachment-accept", (event)=>{
    const locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
    for (const attachment of event.detail.attachments){
        const result = (0, $de5ef9373ca12f93$export$85861430feffd419)(locale, attachment.file.name);
        if (!result.valid) {
            event.preventDefault();
            alert(result.reason);
            return;
        }
        // https://developer.mozilla.org/en-US/docs/Web/API/Blob/type
        // Note: Based on the current implementation, browsers won't actually read
        // the bytestream of a file to determine its media type. It is assumed based
        // on the file extension; a PNG image file renamed to .txt would give
        // "text/plain" and not "image/png". Moreover, blob.type is generally reliable
        // only for common file types like images, HTML documents, audio and video.
        // Uncommon file extensions would return an empty string. Client configuration
        // (for instance, the Windows Registry) may result in unexpected values even
        // for common types. Developers are advised not to rely on this property as a
        // sole validation scheme.
        // if (result.type.contentType !== attachment.file.type) {
        //   event.preventDefault();
        //   alert(
        //     `Invalid file content type ${JSON.stringify(
        //       attachment.file.type
        //     )}. Expected: "${result.type.contentType}".`
        //   );
        //   return;
        // }
        const sizeResult = (0, $de5ef9373ca12f93$export$2afbadb17474b14c)(locale, attachment.file.name, result.type, attachment.file.size);
        if (!sizeResult.valid) {
            event.preventDefault();
            alert(sizeResult.reason);
            return;
        }
        attachment.name = result.filename;
    }
});
async function $49d75368cd6df2b4$export$14d3a7d22f26659e({ locale: locale, attachments: attachments, uploadUrl: uploadUrl, attachmentSaved: attachmentSaved, jwt: jwt }) {
    for (const attachment of attachments){
        attachment.saving(0);
        uploadUrl.searchParams.set("filename", attachment.name);
        const headers = new Headers();
        const uploadRequestInit = {
            method: "POST",
            body: attachment.file,
            headers: headers
        };
        if (jwt) headers.set("Authorization", `Bearer ${jwt}`);
        // ensure content-type header is provided in scenarios where browser doesn't compute it automatically.
        if (attachment.file.type === "") {
            const extension = (0, $de5ef9373ca12f93$export$5f7821c344028c56)(attachment.file.name);
            const contentType = (0, $de5ef9373ca12f93$export$1d5ffa38c010beaf)[extension].contentType;
            headers.set("content-type", contentType);
        }
        let response = await fetch(uploadUrl, uploadRequestInit);
        if (response.status >= 500 && response.status < 600) {
            response.text().then((text)=>{
                throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, text);
            });
            await new Promise((resolve)=>setTimeout(resolve, 3000));
            uploadUrl.searchParams.set("retry", "1");
            response = await fetch(uploadUrl, uploadRequestInit);
        }
        if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
        if (!response.ok) {
            alert((0, $2868cc1235412e16$export$abc1de427b12d946)[locale](attachment.name));
            throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
        }
        const { id: id, href: href, download_href: download_href, name: name } = await response.json();
        attachment.saved({
            id: id,
            href: href,
            name: name
        });
        attachmentSaved(attachment, download_href);
    }
} /*
async function uploadAttachment(attachment: Attachment, href: string) {
  const xhr = await new Promise<XMLHttpRequest>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.open('POST', href, true);
    xhr.onloadstart = () => attachment.saving(0);
    xhr.upload.onprogress = e => {
      if (e.lengthComputable) {
        attachment.saving(Math.round((e.loaded / e.total) * 100));
      }
    };
    xhr.onload = () => resolve(xhr);
    xhr.onerror = reject;
    xhr.send(attachment.file);
  });
  if (xhr.status === 201) {
    const { id, href, name } = JSON.parse(xhr.responseText);
    attachment.saved({ id, href, name });
  } else {
    throw new XhrDependencyError(xhr);
  }
}

class XhrDependencyError extends DependencyError {
  constructor(xhr: XMLHttpRequest) {
    super(
      {
        url: xhr.responseURL,
        status: xhr.status,
        statusText: xhr.statusText,
        headers: XhrDependencyError.parseXhrHeaders(xhr)
      },
      xhr.responseText
    );
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  }

  static parseXhrHeaders(xhr: XMLHttpRequest) {
    const headers = new Headers();
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders#examples
    const lines = xhr
      .getAllResponseHeaders()
      .trim()
      .split(/[\r\n]+/);
    for (const line of lines) {
      const [name, ...value] = line.split(': ');
      headers.append(name, value.join(': '));
    }
    return headers;
  }
}
*/ 


const $dbca384612ad025b$export$5c333a116e949cdd = Date.UTC(1900, 0, 1);
const $dbca384612ad025b$export$a75f2bff57811055 = Date.UTC(3000, 11, 31);
function $dbca384612ad025b$export$7660134aa4da2247(value) {
    if (value.trim() === "") return undefined;
    const regex = /^\s*(\d{1,2})\s*[.,-\/]\s*(\d{1,2})(?:\s*[.,-\/]\s*(\d{2,4}))?\s*$/;
    const match = regex.exec(value);
    if (!match) return undefined;
    const [, month, day, year] = match;
    const date = new Date();
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    if (year) {
        let yearn = parseInt(year);
        if (yearn <= date.getFullYear() + 2 - 2000) yearn += 2000;
        else if (yearn < 100) yearn += 1900;
        else if (yearn < 1000) yearn *= 10;
        date.setFullYear(yearn);
    }
    if (month) date.setMonth(parseInt(month) - 1);
    if (day) date.setDate(parseInt(day));
    return date;
}
function $dbca384612ad025b$export$b0932c69ff376ad3(dob, today = new Date()) {
    let years = today.getUTCFullYear() - dob.getUTCFullYear();
    let months = today.getUTCMonth() - dob.getUTCMonth();
    if (months < 0 || months === 0 && today.getUTCDate() < dob.getUTCDate()) years--;
    if (months < 0) months += 12;
    return {
        years: years,
        months: months
    };
}
function $dbca384612ad025b$export$dd412b56f1e4d8aa(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
const $dbca384612ad025b$export$d0bc05622ca27791 = /^(\d{1,4}) days? (ago|from now)$/;
function $dbca384612ad025b$export$aebd7d4ffee5ebdd(value) {
    return value === "Today" || value === "Yesterday" || value === "Tomorrow" || $dbca384612ad025b$export$d0bc05622ca27791.test(value);
}
function $dbca384612ad025b$export$5729bdcef1c036db(today, value) {
    if (value === "Today") return today;
    if (value === "Yesterday") return $dbca384612ad025b$export$dd412b56f1e4d8aa(today, -1).getTime();
    if (value === "Tomorrow") return $dbca384612ad025b$export$dd412b56f1e4d8aa(today, 1).getTime();
    const [, rawN, rawDir] = $dbca384612ad025b$export$d0bc05622ca27791.exec(value) || [];
    const n = parseInt(rawN);
    if (!isFinite(n) || n < 1 || n > 9999) return undefined;
    const dir = rawDir === "ago" ? -1 : 1;
    return $dbca384612ad025b$export$dd412b56f1e4d8aa(today, dir * n).getTime();
}
const $dbca384612ad025b$export$41d8fd8f1a1513f = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "numeric",
    day: "numeric"
});
const $dbca384612ad025b$export$6aa1a8800137fac7 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZone: "UTC"
});
const $dbca384612ad025b$export$faf60e60fca9bed1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long"
});


var $361e59ae979bf6e6$export$821b31be3f8372e3;
(function(PersonOrganizationAssociationType) {
    PersonOrganizationAssociationType[PersonOrganizationAssociationType["Creator"] = 1] = "Creator";
    PersonOrganizationAssociationType[PersonOrganizationAssociationType["Activity"] = 2] = "Activity";
    PersonOrganizationAssociationType[PersonOrganizationAssociationType["Consent"] = 4] = "Consent";
})($361e59ae979bf6e6$export$821b31be3f8372e3 || ($361e59ae979bf6e6$export$821b31be3f8372e3 = {}));
const $361e59ae979bf6e6$export$a9a1eac9c459ab32 = {
    male: 0,
    female: 1,
    other: 2,
    unknown: -1
};
const $361e59ae979bf6e6$export$579409da2a52ea29 = [
    {
        choice_id: 0,
        locale: "en",
        name: "English"
    },
    {
        choice_id: 45,
        locale: "sq",
        name: "Albanian"
    },
    {
        choice_id: 1,
        locale: "ar",
        name: "Arabic"
    },
    {
        choice_id: 2,
        locale: "bn",
        name: "Bengali"
    },
    {
        choice_id: 3,
        locale: "bs",
        name: "Bosnian"
    },
    {
        choice_id: 4,
        locale: "bg",
        name: "Bulgarian"
    },
    {
        choice_id: 5,
        locale: "zh",
        name: "Chinese"
    },
    {
        choice_id: 6,
        locale: "hr",
        name: "Croatian"
    },
    {
        choice_id: 7,
        locale: "cs",
        name: "Czech"
    },
    {
        choice_id: 8,
        locale: "da",
        name: "Danish"
    },
    {
        choice_id: 9,
        locale: "nl",
        name: "Dutch"
    },
    {
        choice_id: 10,
        locale: "et",
        name: "Estonian"
    },
    {
        choice_id: 46,
        locale: "fa",
        name: "Farsi"
    },
    {
        choice_id: 11,
        locale: "fil",
        name: "Filipino"
    },
    {
        choice_id: 12,
        locale: "fi",
        name: "Finnish"
    },
    {
        choice_id: 13,
        locale: "fr",
        name: "French"
    },
    {
        choice_id: 14,
        locale: "fy",
        name: "Frisian"
    },
    {
        choice_id: 15,
        locale: "de",
        name: "German"
    },
    {
        choice_id: 16,
        locale: "el",
        name: "Greek"
    },
    {
        choice_id: 17,
        locale: "ht",
        name: "Haitian Creole"
    },
    {
        choice_id: 18,
        locale: "hi",
        name: "Hindi"
    },
    {
        choice_id: 19,
        locale: "mww",
        name: "Hmong Daw"
    },
    {
        choice_id: 20,
        locale: "is",
        name: "Icelandic"
    },
    {
        choice_id: 21,
        locale: "it",
        name: "Italian"
    },
    {
        choice_id: 22,
        locale: "ja",
        name: "Japanese"
    },
    {
        choice_id: 47,
        locale: "rw",
        name: "Kinyarwanda"
    },
    {
        choice_id: 23,
        locale: "ko",
        name: "Korean"
    },
    {
        choice_id: 24,
        locale: "lv",
        name: "Latvian"
    },
    {
        choice_id: 48,
        locale: "lir",
        name: "Liberian Kreyol"
    },
    {
        choice_id: 49,
        locale: "ln",
        name: "Lingala"
    },
    {
        choice_id: 25,
        locale: "lt",
        name: "Lithuanian"
    },
    {
        choice_id: 26,
        locale: "no",
        name: "Norwegian"
    },
    {
        choice_id: 27,
        locale: "ps",
        name: "Pashto"
    },
    {
        choice_id: 28,
        locale: "fa",
        name: "Persian"
    },
    {
        choice_id: 29,
        locale: "pl",
        name: "Polish"
    },
    {
        choice_id: 30,
        locale: "pt",
        name: "Portuguese"
    },
    {
        choice_id: 31,
        locale: "pa",
        name: "Punjabi"
    },
    {
        choice_id: 32,
        locale: "ro",
        name: "Romanian"
    },
    {
        choice_id: 33,
        locale: "ru",
        name: "Russian"
    },
    {
        choice_id: 34,
        locale: "sm",
        name: "Samoan"
    },
    {
        choice_id: 35,
        locale: "sr",
        name: "Serbian"
    },
    {
        choice_id: 36,
        locale: "sk",
        name: "Slovakian"
    },
    {
        choice_id: 37,
        locale: "sl",
        name: "Slovenian"
    },
    {
        choice_id: 38,
        locale: "so",
        name: "Somali"
    },
    {
        choice_id: 39,
        locale: "es",
        name: "Spanish"
    },
    {
        choice_id: 50,
        locale: "sw",
        name: "Swahili"
    },
    {
        choice_id: 40,
        locale: "sv",
        name: "Swedish"
    },
    {
        choice_id: 41,
        locale: "te",
        name: "Telugu"
    },
    {
        choice_id: 42,
        locale: "th",
        name: "Thai"
    },
    {
        choice_id: 51,
        locale: "tr",
        name: "Turkish"
    },
    {
        choice_id: 52,
        locale: "uk",
        name: "Ukrainian"
    },
    {
        choice_id: 43,
        locale: "ur",
        name: "Urdu"
    },
    {
        choice_id: 44,
        locale: "vi",
        name: "Vietnamese"
    }
];
const $361e59ae979bf6e6$export$f5a9da98b58e894 = 2;
const $361e59ae979bf6e6$export$9657669ee60b4be0 = [
    {
        label: "Female",
        choice_id: 1,
        fhirCode: "female"
    },
    {
        label: "Male",
        choice_id: 0,
        fhirCode: "male"
    },
    {
        label: "Other",
        choice_id: $361e59ae979bf6e6$export$f5a9da98b58e894,
        fhirCode: "oth"
    },
    {
        label: "Prefer not to answer",
        choice_id: 31,
        fhirCode: "asked-declined"
    }
];
const $361e59ae979bf6e6$export$b43c9e3faf0aba5c = [
    {
        label: "Hispanic or Latino",
        choice_id: 1,
        fhirCode: "2135-2"
    },
    {
        label: "Not Hispanic or Latino",
        choice_id: 0,
        fhirCode: "2186-5"
    },
    {
        label: "Prefer not to answer",
        choice_id: 31,
        fhirCode: "ASKU"
    }
];
const $361e59ae979bf6e6$export$4600759e6cedf2ab = [
    {
        label: "American Indian or Alaska Native",
        choice_id: 0,
        exclusive: false,
        fhirCode: "1002-5"
    },
    {
        label: "Asian",
        choice_id: 1,
        exclusive: false,
        fhirCode: "2028-9"
    },
    {
        label: "Black or African American",
        choice_id: 2,
        exclusive: false,
        fhirCode: "2054-5"
    },
    {
        label: "Native Hawaiian or Other Pacific Islander",
        choice_id: 3,
        exclusive: false,
        fhirCode: "2076-8"
    },
    {
        label: "White",
        choice_id: 4,
        exclusive: false,
        fhirCode: "2106-3"
    },
    {
        label: "Prefer not to answer",
        choice_id: 31,
        exclusive: true,
        fhirCode: "ASKU"
    }
];
const $361e59ae979bf6e6$export$41dc40aecf6ed9c3 = [
    {
        label: "Heterosexual",
        choice_id: 0
    },
    {
        label: "Homosexual",
        choice_id: 1
    },
    {
        label: "Bisexual",
        choice_id: 2
    },
    {
        label: "Other",
        choice_id: 3
    },
    {
        label: "Prefer not to answer",
        choice_id: 31
    }
];
const $361e59ae979bf6e6$export$160e4329619a95c1 = [
    {
        label: "Married",
        choice_id: 0,
        fhirCode: "M"
    },
    {
        label: "Never married",
        choice_id: 1,
        fhirCode: "S"
    },
    {
        label: "Separated",
        choice_id: 2,
        fhirCode: "L"
    },
    {
        label: "Divorced",
        choice_id: 3,
        fhirCode: "D"
    },
    {
        label: "Widowed",
        choice_id: 4,
        fhirCode: "W"
    },
    {
        label: "Prefer not to answer",
        choice_id: 31,
        fhirCode: "UNK"
    }
];
const $361e59ae979bf6e6$export$5704fb055ad06540 = [
    {
        label: "Female",
        choice_id: 1
    },
    {
        label: "Male",
        choice_id: 0
    },
    {
        label: "Other",
        choice_id: 2
    },
    {
        label: "Non-binary",
        choice_id: 3
    },
    {
        label: "Transgender female",
        choice_id: 5
    },
    {
        label: "Transgender male",
        choice_id: 4
    },
    {
        label: "Don't know",
        choice_id: 6
    },
    {
        label: "Prefer not to answer",
        choice_id: 31
    }
];


const $834ded10eeb0a740$export$688d13a530c5dcbc = new Intl.NumberFormat("en-us", {});
const $834ded10eeb0a740$export$4670d0ed237a9270 = new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: "USD"
});
const $834ded10eeb0a740$export$82fb8ba313c9dbb0 = new Intl.NumberFormat("en-us", {
    style: "percent"
});
const $834ded10eeb0a740$export$24b6a663def24ecb = new Intl.NumberFormat("en-us", {
    notation: "compact",
    compactDisplay: "short"
});
const $834ded10eeb0a740$export$8ce5ed5e47477d75 = new Intl.NumberFormat("en-us", {
    style: "currency",
    currency: "USD",
    notation: "compact"
});
const $834ded10eeb0a740$export$2918518777706bf8 = new Intl.NumberFormat("en-us", {
    style: "percent",
    notation: "compact"
});
function $834ded10eeb0a740$export$a3992db8dd0fd9e6(value, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = value * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
}


const $0dbabea6e8ef01ef$export$7442465335b8f729 = {
    ORIGINAL_ACTIVITY_STATUS: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    ORIGINAL_ACTIVITY_START_DATE: {
        property_id: 0,
        type: "date",
        choice_type: "none"
    },
    ORIGINAL_ACTIVITY_END_DATE: {
        property_id: 0,
        type: "date",
        choice_type: "none"
    },
    ACTIVITY_STATUS: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    ACTIVITY_CREATE_DATE: {
        property_id: 0,
        type: "date",
        choice_type: "none"
    },
    ACTIVITY_START_DATE: {
        property_id: 0,
        type: "date",
        choice_type: "none"
    },
    ACTIVITY_END_DATE: {
        property_id: 0,
        type: "date",
        choice_type: "none"
    },
    ACTIVITY_CREATE_USER: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    ACTIVITY_CREATE_ORGANIZATION: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    ACTIVITY_ASSIGNEE_USER: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    ACTIVITY_ASSIGNEE_ORGANIZATION: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_LAST_NAME: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_FIRST_NAME: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_MIDDLE_NAME: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_DOB: {
        property_id: 0,
        type: "date",
        choice_type: "none"
    },
    PERSON_SSN: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_VETERAN_ID: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_MEDICAID_ID: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_SCSEP_PARTICIPANT_ID: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_GENDER: {
        property_id: 0,
        type: "int",
        choice_type: "single",
        choices: (0, $361e59ae979bf6e6$export$9657669ee60b4be0).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: "",
                exclusive: false
            }))
    },
    PERSON_SEXUAL_ORIENTATION: {
        property_id: 0,
        type: "int",
        choice_type: "single",
        choices: (0, $361e59ae979bf6e6$export$41dc40aecf6ed9c3).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: "",
                exclusive: false
            }))
    },
    PERSON_RACE: {
        property_id: 0,
        type: "int",
        choice_type: "multiple",
        choices: (0, $361e59ae979bf6e6$export$4600759e6cedf2ab).map(({ choice_id: choice_id, label: label, exclusive: exclusive })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: "",
                exclusive: exclusive
            }))
    },
    PERSON_ETHNICITY: {
        property_id: 0,
        type: "int",
        choice_type: "single",
        choices: (0, $361e59ae979bf6e6$export$b43c9e3faf0aba5c).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: "",
                exclusive: false
            }))
    },
    PERSON_MARITAL_STATUS: {
        property_id: 0,
        type: "int",
        choice_type: "single",
        choices: (0, $361e59ae979bf6e6$export$160e4329619a95c1).map(({ choice_id: choice_id, label: label })=>({
                choice_id: choice_id,
                score: 0,
                label: label,
                prompt: "",
                exclusive: false
            }))
    },
    PERSON_PRIMARY_PHONE_NUMBER: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_EMAIL_ADDRESS: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_RESIDENCE_STREET_ADDRESS: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_RESIDENCE_SUB_ADDRESS: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_RESIDENCE_CITY: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_RESIDENCE_STATE: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_RESIDENCE_ZIP: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_RESIDENCE_ZIP_EXT: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    PERSON_PRIMARY_RESIDENCE_COUNTY: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    CURRENT_USER_LAST_NAME: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    CURRENT_USER_FIRST_NAME: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    CURRENT_USER: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    CURRENT_USER_ROLE: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    },
    CURRENT_ORGANIZATION: {
        property_id: 0,
        type: "varchar100",
        choice_type: "none"
    }
};
const $0dbabea6e8ef01ef$var$standardPropertiesById = {};
Object.keys($0dbabea6e8ef01ef$export$7442465335b8f729).forEach((key, i)=>{
    const property_id = i * -1 - 1;
    $0dbabea6e8ef01ef$export$7442465335b8f729[key].property_id = property_id;
    $0dbabea6e8ef01ef$var$standardPropertiesById[property_id] = $0dbabea6e8ef01ef$export$7442465335b8f729[key];
});
function $0dbabea6e8ef01ef$var$parseExpressionDate(date) {
    if (!date) return new Date(NaN);
    switch(date.length){
        case 23:
            return new Date(date + "Z");
        case 10:
            return new Date(date + "T00:00:00.000Z");
        default:
            return new Date(date);
    }
}
class $0dbabea6e8ef01ef$export$241dc8d30919de44 {
    constructor(standardPropertyValues, responses, properties, rucaLookup, areaOfPersistentUnemployment, identifier_values, canViewActivityTypes){
        this.responses = responses;
        this.properties = properties;
        this.rucaLookup = rucaLookup;
        this.areaOfPersistentUnemployment = areaOfPersistentUnemployment;
        this.identifier_values = identifier_values;
        this.canViewActivityTypes = canViewActivityTypes;
        this.hasVisiblePredecessors = false;
        this.contextualIdentifiers = {
            DAY: 0,
            MONTH: 1,
            YEAR: 2,
            QUARTER: 3,
            WEEK: 4
        };
        this.functions = {
            SELECTED: (property_id, ...codes)=>{
                const response = property_id > 0 ? this.responses[`p${property_id}`] : this.standardResponses[`p${property_id}`];
                if (response === undefined || response === null) return false;
                if (typeof response !== "number") throw new Error(`Expected numeric response. ${JSON.stringify(response)}`);
                const property = this.properties[property_id] ?? $0dbabea6e8ef01ef$var$standardPropertiesById[property_id];
                if (!property) throw new Error(`Expression references ${property_id} but wasn't included in scope.`);
                if (property.choice_type === "multiple") return (codes.reduce((m, shift)=>m + 2 ** shift, 0) & response) !== 0;
                else return codes.some((code)=>response === code);
            },
            COUNTIF: (...args)=>{
                let count = 0;
                for (const arg of args)if (arg) count++;
                return count;
            },
            ANY: (...args)=>{
                return args.some((x)=>x);
            },
            VALUE: (property_id)=>{
                const response = property_id > 0 ? this.responses[`p${property_id}`] : this.standardResponses[`p${property_id}`];
                if (response !== null && response !== undefined) return response;
                else return null;
            },
            ANSWERED: (property_id)=>{
                const response = property_id > 0 ? this.responses[`p${property_id}`] : this.standardResponses[`p${property_id}`];
                return response !== null && response !== undefined && response !== "";
            },
            SCORE: (property_id, ...choice_ids)=>{
                const response = property_id > 0 ? this.responses[`p${property_id}`] : this.standardResponses[`p${property_id}`];
                if (response === undefined || response === null) return NaN;
                if (typeof response !== "number") throw new Error(`Expected numeric response. ${JSON.stringify(response)}`);
                const property = this.properties[property_id] ?? $0dbabea6e8ef01ef$var$standardPropertiesById[property_id];
                if (!property) throw new Error(`Expression references ${property_id} but wasn't included in scope.`);
                if (property.choice_type === "multiple") return property.choices?.filter((c)=>choice_ids.length === 0 || choice_ids.includes(c.choice_id))?.filter((c)=>(2 ** c.choice_id & response) !== 0).reduce((sum, c)=>sum + c.score, 0) ?? NaN;
                else if (property.choice_type === "single") return property.choices?.filter((c)=>choice_ids.length === 0 || choice_ids.includes(c.choice_id))?.find((c)=>c.choice_id === response)?.score ?? NaN;
                else return response;
            },
            ROUND: (value, digits = 0)=>{
                if (typeof value !== "number") return null;
                return (0, $834ded10eeb0a740$export$a3992db8dd0fd9e6)(value, digits);
            },
            FLOOR: (value)=>{
                if (typeof value !== "number") return null;
                return Math.floor(value);
            },
            CEILING: (value)=>{
                if (typeof value !== "number") return null;
                return Math.ceil(value);
            },
            MIN: (v1, v2)=>{
                if (typeof v1 !== "number" || typeof v2 !== "number") return null;
                return Math.min(v1, v2);
            },
            MAX: (v1, v2)=>{
                if (typeof v1 !== "number" || typeof v2 !== "number") return null;
                return Math.max(v1, v2);
            },
            ABS: (value)=>{
                if (typeof value !== "number") return null;
                return Math.abs(value);
            },
            NOW: ()=>new Date(new Date().toLocaleString("en-US", {
                    timeZone: "America/New_York"
                })).toISOString(),
            AGE: (dob, asOf)=>{
                const parsedDob = $0dbabea6e8ef01ef$var$parseExpressionDate(dob);
                const parsedAsOf = $0dbabea6e8ef01ef$var$parseExpressionDate(asOf);
                if (!isFinite(parsedDob.getTime()) || !isFinite(parsedAsOf.getTime())) return null;
                return (0, $dbca384612ad025b$export$b0932c69ff376ad3)(parsedDob, parsedAsOf).years;
            },
            DATEADD: (part, value, date)=>{
                const parsed = $0dbabea6e8ef01ef$var$parseExpressionDate(date);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK
                ].includes(part) || typeof value !== "number" || !Number.isInteger(value) || !isFinite(parsed.getTime())) return null;
                // https://www.npmjs.com/package/dateadd?activeTab=code
                switch(part){
                    case DAY:
                    case WEEK:
                        if (part === WEEK) value *= 7;
                        return new Date(parsed.setUTCDate(parsed.getUTCDate() + value)).toISOString();
                    case MONTH:
                    case QUARTER:
                        if (part === QUARTER) value *= 3;
                        return new Date(parsed.setUTCMonth(parsed.getUTCMonth() + value)).toISOString();
                    case YEAR:
                        return new Date(parsed.setUTCFullYear(parsed.getUTCFullYear() + value)).toISOString();
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            DATEDIFF: (part, start, end)=>{
                const parsedStart = $0dbabea6e8ef01ef$var$parseExpressionDate(start);
                const parsedEnd = $0dbabea6e8ef01ef$var$parseExpressionDate(end);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK
                ].includes(part) || !isFinite(parsedStart.getTime()) || !isFinite(parsedEnd.getTime())) return null;
                switch(part){
                    case DAY:
                        return Math.floor((parsedEnd.getTime() - parsedStart.getTime()) / 86400000);
                    case WEEK:
                        {
                            const weeks = Math.floor((parsedEnd.getTime() - parsedStart.getTime()) / 604800000);
                            return weeks + (parsedStart.getUTCDay() > parsedEnd.getUTCDay() ? 1 : 0);
                        }
                    case MONTH:
                    case QUARTER:
                        {
                            let result = (parsedEnd.getUTCFullYear() - parsedStart.getUTCFullYear()) * 12 + parsedEnd.getUTCMonth() - parsedStart.getUTCMonth();
                            if (part === QUARTER) result = Math.floor(result / 3);
                            return result;
                        }
                    case YEAR:
                        return parsedEnd.getUTCFullYear() - parsedStart.getUTCFullYear();
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            DATEPART: (part, date)=>{
                const parsed = $0dbabea6e8ef01ef$var$parseExpressionDate(date);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK
                ].includes(part) || !isFinite(parsed.getTime())) return null;
                switch(part){
                    case DAY:
                        return parsed.getUTCDate();
                    case WEEK:
                        {
                            const jan1 = new Date(Date.UTC(parsed.getUTCFullYear()));
                            const dayOfYear = (parsed.getTime() - jan1.getTime()) / 86400000;
                            return Math.floor(dayOfYear / 7) + 1 + (jan1.getUTCDay() > parsed.getUTCDay() ? 1 : 0);
                        }
                    case MONTH:
                        return parsed.getUTCMonth() + 1;
                    case QUARTER:
                        return Math.floor(parsed.getUTCMonth() / 3) + 1;
                    case YEAR:
                        return parsed.getUTCFullYear();
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            DATETRUNC: (part, date)=>{
                const parsed = $0dbabea6e8ef01ef$var$parseExpressionDate(date);
                const { DAY: DAY, MONTH: MONTH, QUARTER: QUARTER, YEAR: YEAR, WEEK: WEEK } = this.contextualIdentifiers;
                if (![
                    DAY,
                    MONTH,
                    QUARTER,
                    YEAR,
                    WEEK
                ].includes(part) || !isFinite(parsed.getTime())) return null;
                switch(part){
                    case DAY:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate())).toISOString();
                    case WEEK:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate() - parsed.getUTCDay())).toISOString();
                    case MONTH:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), 1)).toISOString();
                    case QUARTER:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), Math.floor(parsed.getUTCMonth() / 3) * 3, 1)).toISOString();
                    case YEAR:
                        return new Date(Date.UTC(parsed.getUTCFullYear(), 0, 1)).toISOString();
                    default:
                        throw new Error(`Unexpected date part: ${part}`);
                }
            },
            EOMONTH: (date)=>{
                const parsed = $0dbabea6e8ef01ef$var$parseExpressionDate(date);
                if (!isFinite(parsed.getTime())) return null;
                const endOfMonth = new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth() + 1, 0));
                return endOfMonth.toISOString();
            },
            DATE: (value)=>{
                const parsed = $0dbabea6e8ef01ef$var$parseExpressionDate(value);
                if (!isFinite(parsed.getTime())) return null;
                return parsed.toISOString();
            },
            IF: (condition, trueValue, falseValue)=>{
                return condition ? trueValue : falseValue;
            },
            LOWER: (s)=>{
                return s?.toLowerCase() ?? null;
            },
            UPPER: (s)=>{
                return s?.toUpperCase() ?? null;
            },
            RURAL: (date)=>{
                const parsed = $0dbabea6e8ef01ef$var$parseExpressionDate(date);
                if (!isFinite(parsed.getTime())) return null;
                return (this.rucaLookup.find((x)=>$0dbabea6e8ef01ef$var$parseExpressionDate(x.start_date).getTime() <= parsed.getTime())?.primary_code ?? 0) >= 4;
            },
            AREA_OF_PERSISTENT_UNEMPLOYMENT: (date)=>{
                const parsed = $0dbabea6e8ef01ef$var$parseExpressionDate(date);
                if (!isFinite(parsed.getTime())) return null;
                return this.areaOfPersistentUnemployment.find((x)=>$0dbabea6e8ef01ef$var$parseExpressionDate(x.start_date).getTime() <= parsed.getTime())?.persistent_unemployment ?? false;
            },
            HAS_VISIBLE_PREDECESSORS: ()=>{
                // console.log(`HAS_VISIBLE_PREDECESSORS: ${this.hasVisiblePredecessors}`);
                return this.hasVisiblePredecessors;
            },
            DEBUG: (label, value)=>{
                console.log(`EXPRESSION DEBUG ${label}: ${value}`);
                return value;
            },
            CAN_VIEW_ACTIVITY_TYPE: (type)=>{
                return this.canViewActivityTypes?.includes(type) ?? null;
            },
            MID (value, start, length) {
                if (typeof value !== "string") return null;
                if (typeof start !== "number" || !isFinite(start)) return null;
                if (length !== undefined && (typeof length !== "number" || !isFinite(length))) return null;
                if (length !== undefined && length <= 0) return "";
                start = start < 1 ? 1 : start;
                return value.substr(start - 1, length);
            },
            LEFT (value, length) {
                if (typeof value !== "string") return null;
                if (typeof length !== "number" || !isFinite(length)) return null;
                if (length <= 0) return "";
                return value.substr(0, length);
            },
            RIGHT (value, length) {
                if (typeof value !== "string") return null;
                if (typeof length !== "number" || !isFinite(length)) return null;
                if (length <= 0) return "";
                return value.slice(-1 * length);
            },
            MATCH (value, ...args) {
                if (value === null || value === undefined || typeof value !== "string" && typeof value !== "number" || typeof value === "number" && !isFinite(value)) return null;
                return args.includes(value);
            }
        };
        if ("original_activity_status" in standardPropertyValues) this.standardResponses = {
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ORIGINAL_ACTIVITY_STATUS.property_id}`]: standardPropertyValues.original_activity_status,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ORIGINAL_ACTIVITY_START_DATE.property_id}`]: standardPropertyValues.original_activity_start_date,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ORIGINAL_ACTIVITY_END_DATE.property_id}`]: standardPropertyValues.original_activity_end_date,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_STATUS.property_id}`]: standardPropertyValues.activity_status,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_CREATE_DATE.property_id}`]: standardPropertyValues.activity_create_date,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_START_DATE.property_id}`]: standardPropertyValues.activity_start_date,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_END_DATE.property_id}`]: standardPropertyValues.activity_end_date,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_CREATE_USER.property_id}`]: standardPropertyValues.activity_create_user,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_CREATE_ORGANIZATION.property_id}`]: standardPropertyValues.activity_create_organization,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_ASSIGNEE_USER.property_id}`]: standardPropertyValues.activity_assignee_user,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.ACTIVITY_ASSIGNEE_ORGANIZATION.property_id}`]: standardPropertyValues.activity_assignee_organization,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_LAST_NAME.property_id}`]: standardPropertyValues.person_last_name,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_FIRST_NAME.property_id}`]: standardPropertyValues.person_first_name,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_MIDDLE_NAME.property_id}`]: standardPropertyValues.person_middle_name,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_DOB.property_id}`]: standardPropertyValues.person_dob,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_SSN.property_id}`]: standardPropertyValues.person_ssn,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_VETERAN_ID.property_id}`]: standardPropertyValues.person_veteran_id,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_MEDICAID_ID.property_id}`]: standardPropertyValues.person_medicaid_id,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_SCSEP_PARTICIPANT_ID.property_id}`]: standardPropertyValues.person_scsep_participant_id,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_GENDER.property_id}`]: standardPropertyValues.person_gender,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_SEXUAL_ORIENTATION.property_id}`]: standardPropertyValues.person_sexual_orientation,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_RACE.property_id}`]: standardPropertyValues.person_race,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_ETHNICITY.property_id}`]: standardPropertyValues.person_ethnicity,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_MARITAL_STATUS.property_id}`]: standardPropertyValues.person_marital_status,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_PHONE_NUMBER.property_id}`]: standardPropertyValues.person_primary_phone_number,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_EMAIL_ADDRESS.property_id}`]: standardPropertyValues.person_primary_email_address,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_STREET_ADDRESS.property_id}`]: standardPropertyValues.person_primary_residence_street_address,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_SUB_ADDRESS.property_id}`]: standardPropertyValues.person_primary_residence_sub_address,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_CITY.property_id}`]: standardPropertyValues.person_primary_residence_city,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_STATE.property_id}`]: standardPropertyValues.person_primary_residence_region_abbr,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_ZIP.property_id}`]: standardPropertyValues.person_primary_residence_postal_code,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_ZIP_EXT.property_id}`]: standardPropertyValues.person_primary_residence_postal_code_ext,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.PERSON_PRIMARY_RESIDENCE_COUNTY.property_id}`]: standardPropertyValues.person_primary_residence_subregion
        };
        else this.standardResponses = {};
        Object.assign(this.standardResponses, {
            // [`p${standardProperties.CURRENT_USER_LAST_NAME.property_id}`]:
            //   standardPropertyValues.current_user_last_name,
            // [`p${standardProperties.CURRENT_USER_FIRST_NAME.property_id}`]:
            //   standardPropertyValues.current_user_first_name,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.CURRENT_USER.property_id}`]: standardPropertyValues.current_user,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.CURRENT_USER_ROLE.property_id}`]: standardPropertyValues.current_user_role,
            [`p${$0dbabea6e8ef01ef$export$7442465335b8f729.CURRENT_ORGANIZATION.property_id}`]: standardPropertyValues.current_organization
        });
    }
}
function $0dbabea6e8ef01ef$export$61b73397e464436e(propertyType, { type: type, ast: ast }, scope) {
    const result = $0dbabea6e8ef01ef$export$3191fa0ae67b450c(ast, scope);
    if (result === null) return null;
    switch(type){
        case "boolean":
            // int used because there's no boolean/bit response table.
            return Boolean(result) ? 1 : 0;
        case "int":
            {
                const value = Math.floor(Number(result));
                if (!isFinite(value)) return null;
                return value;
            }
        // @ts-ignore
        case "currency":
        case "decimal":
            {
                const value = Number(result);
                if (!isFinite(value)) return null;
                return propertyType === "currency" ? (0, $834ded10eeb0a740$export$a3992db8dd0fd9e6)(value, 2) : value;
            }
        case "string":
            return String(result);
        case "date":
        case "datetime":
            {
                const value = $0dbabea6e8ef01ef$var$parseExpressionDate(result);
                if (!isFinite(value.getTime())) return null;
                return value.toISOString();
            }
        default:
            throw new Error(`unsupported expression type "${type}"`);
    }
}
const $0dbabea6e8ef01ef$var$binops = {
    "||": function(a, b) {
        return a || b;
    },
    "&&": function(a, b) {
        return a && b;
    },
    // '|': function (a, b) {
    //   return a | b;
    // },
    // '^': function (a, b) {
    //   return a ^ b;
    // },
    // '&': function (a, b) {
    //   return a & b;
    // },
    "==": function(a, b) {
        return a == b;
    },
    "!=": function(a, b) {
        return a != b;
    },
    // '===': function (a, b) {
    //   return a === b;
    // },
    // '!==': function (a, b) {
    //   return a !== b;
    // },
    "<": function(a, b) {
        return a < b;
    },
    ">": function(a, b) {
        return a > b;
    },
    "<=": function(a, b) {
        return a <= b;
    },
    ">=": function(a, b) {
        return a >= b;
    },
    // '<<': function (a, b) {
    //   return a << b;
    // },
    // '>>': function (a, b) {
    //   return a >> b;
    // },
    // '>>>': function (a, b) {
    //   return a >>> b;
    // },
    "+": function(a, b) {
        return a + b;
    },
    "-": function(a, b) {
        return a - b;
    },
    "*": function(a, b) {
        return a * b;
    },
    "/": function(a, b) {
        return a / b;
    },
    "%": function(a, b) {
        return a % b;
    }
};
const $0dbabea6e8ef01ef$var$unops = {
    "-": function(a) {
        return -a;
    },
    // '+': function (a) {
    //   return +a;
    // },
    // '~': function (a) {
    //   return ~a;
    // },
    "!": function(a) {
        return !a;
    }
};
function $0dbabea6e8ef01ef$export$3191fa0ae67b450c(node, scope) {
    switch(node.type){
        // case 'ArrayExpression':
        //   return evaluateArray(node.elements, context);
        case "BinaryExpression":
            {
                const left = $0dbabea6e8ef01ef$export$3191fa0ae67b450c(node.left, scope);
                if (node.operator === "||") return left || $0dbabea6e8ef01ef$export$3191fa0ae67b450c(node.right, scope);
                else if (node.operator === "&&") return left && $0dbabea6e8ef01ef$export$3191fa0ae67b450c(node.right, scope);
                if (typeof left === "number" && !isFinite(left) || left === null) return null;
                const right = $0dbabea6e8ef01ef$export$3191fa0ae67b450c(node.right, scope);
                if (typeof right === "number" && !isFinite(right) || right === null) return null;
                {
                    // hack: ensure string comparisons of date strings use equal length strings. Need to use Date instances internally.
                    const dateString = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}\.\d+Z)?$/i;
                    if (typeof left === "string" && typeof right === "string" && left.length !== right.length && dateString.test(left) && dateString.test(right)) return $0dbabea6e8ef01ef$var$binops[node.operator]((left + "T00:00:00.000Z").substr(0, 24), (right + "T00:00:00.000Z").substr(0, 24));
                }
                return $0dbabea6e8ef01ef$var$binops[node.operator](left, right);
            }
        case "CallExpression":
            const callee = node.callee;
            if (callee.type !== "Identifier") return undefined;
            // Coerce callee name to uppercase.
            callee.name = callee.name.toUpperCase();
            const fn = $0dbabea6e8ef01ef$export$3191fa0ae67b450c(callee, scope);
            if (typeof fn !== "function") return undefined;
            return fn.apply(null, node.arguments.map((node)=>$0dbabea6e8ef01ef$export$3191fa0ae67b450c(node, scope)));
        // case 'ConditionalExpression':
        //   return legacyEvaluate(node.test as CoreExpression, context)
        //     ? legacyEvaluate(node.consequent as CoreExpression, context)
        //     : legacyEvaluate(node.alternate as CoreExpression, context);
        case "Identifier":
            {
                const name = node.name.toUpperCase();
                if (Object.hasOwn($0dbabea6e8ef01ef$export$7442465335b8f729, name)) return $0dbabea6e8ef01ef$export$7442465335b8f729[name].property_id;
                if (Object.hasOwn(scope.functions, name)) return scope.functions[name];
                if (Object.hasOwn(scope.contextualIdentifiers, name)) return scope.contextualIdentifiers[name];
                if (Object.hasOwn(scope.identifier_values, name)) return scope.identifier_values[name];
                return null;
            }
        case "Literal":
            return node.value;
        // case 'MemberExpression':
        //   return evaluateMember(node, context)[1];
        // case 'ThisExpression':
        //   return context;
        case "UnaryExpression":
            return $0dbabea6e8ef01ef$var$unops[node.operator]($0dbabea6e8ef01ef$export$3191fa0ae67b450c(node.argument, scope));
        default:
            throw new Error(`Unexpected node type "${node.type}".`);
    }
}




// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $60b0cb81f60b04f1$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    const BASE_MAP = new Uint8Array(256);
    for(let j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(let i = 0; i < ALPHABET.length; i++){
        const x = ALPHABET.charAt(i);
        const xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    const BASE = ALPHABET.length;
    const LEADER = ALPHABET.charAt(0);
    const FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    const iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        // eslint-disable-next-line no-empty
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        let zeroes = 0;
        let length = 0;
        let pbegin = 0;
        const pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        const size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        const b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            let carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            let i = 0;
            for(let it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        let it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        let str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        let psz = 0;
        // Skip and count leading '1's.
        let zeroes = 0;
        let length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        const size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        const b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            const charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            let carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            let i = 0;
            for(let it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        let it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        const vch = new Uint8Array(zeroes + (size - it4));
        let j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        const buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $60b0cb81f60b04f1$export$2e2bcd8739ae039 = $60b0cb81f60b04f1$var$base;


// Why base 58?
// - url safe
// - shortens guids as much as base 62 most of the time
// - no ambiguity with regards to 0 and O
const $a5db82e8fe4c003a$var$base58Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const $a5db82e8fe4c003a$var$base58 = (0, $60b0cb81f60b04f1$export$2e2bcd8739ae039)($a5db82e8fe4c003a$var$base58Alphabet);
function $a5db82e8fe4c003a$export$7077a352e654daea(s) {
    return $a5db82e8fe4c003a$var$base58.encode($a5db82e8fe4c003a$export$5a0d8143a7df2173(s));
}
function $a5db82e8fe4c003a$export$13d9777f790da32(s) {
    return $a5db82e8fe4c003a$export$31b40729666a4ae0($a5db82e8fe4c003a$var$base58.decode(s));
}
/*
const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

export const encode = (uuid: string): string => {
  let b = BigInt('0x' + uuid.replace(/[^a-f0-9]/gi, ''));
  let u58 = '';
  do {
    const index = parseInt((b % BigInt(BASE58_ALPHABET.length)).toString(), 10);
    u58 = BASE58_ALPHABET[index] + u58;
    b = b / BigInt(BASE58_ALPHABET.length);
  } while (b > 0);
  return u58;
};

export const decode = (uuidBase58: string): string => {
  const parts = Array.from(uuidBase58).map((x: string) => BASE58_ALPHABET.indexOf(x));
  if (parts.some((inc) => inc < 0) || uuidBase58.trim() === '') {
    return uuidBase58;
  }
  const max = uuidBase58.length - 1;
  const b = parts.reduce(
    (total, val, index) => (total + BigInt(val)) * (index < max ? BigInt(BASE58_ALPHABET.length) : BigInt(1)),
    BigInt(0),
  );
  const hex = b.toString(16).padStart(32, '0');
  return [0, 8, 12, 16, 20].map((p, i, a) => hex.substring(p, a[i + 1])).join('-');
};

export const valid = (uuidBase58: string): boolean => {
  return decode(uuidBase58).length === 36;
}
*/ const $a5db82e8fe4c003a$var$supportsRandomUUID = typeof crypto.randomUUID === "function";
const $a5db82e8fe4c003a$var$randomArr = new Uint8Array(16);
const $a5db82e8fe4c003a$var$reg = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $a5db82e8fe4c003a$var$separator = "-";
function $a5db82e8fe4c003a$export$31b40729666a4ae0(arr) {
    if (!arr) {
        if ($a5db82e8fe4c003a$var$supportsRandomUUID) return crypto.randomUUID();
        crypto.getRandomValues($a5db82e8fe4c003a$var$randomArr);
        arr = $a5db82e8fe4c003a$var$randomArr;
    }
    // // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    // arr[6] = (arr[6] & 0x0f) | 0x40;
    // arr[8] = (arr[8] & 0x3f) | 0x80;
    const s = ($a5db82e8fe4c003a$var$bth[arr[0]] + $a5db82e8fe4c003a$var$bth[arr[1]] + $a5db82e8fe4c003a$var$bth[arr[2]] + $a5db82e8fe4c003a$var$bth[arr[3]] + $a5db82e8fe4c003a$var$separator + $a5db82e8fe4c003a$var$bth[arr[4]] + $a5db82e8fe4c003a$var$bth[arr[5]] + $a5db82e8fe4c003a$var$separator + $a5db82e8fe4c003a$var$bth[arr[6]] + $a5db82e8fe4c003a$var$bth[arr[7]] + $a5db82e8fe4c003a$var$separator + $a5db82e8fe4c003a$var$bth[arr[8]] + $a5db82e8fe4c003a$var$bth[arr[9]] + $a5db82e8fe4c003a$var$separator + $a5db82e8fe4c003a$var$bth[arr[10]] + $a5db82e8fe4c003a$var$bth[arr[11]] + $a5db82e8fe4c003a$var$bth[arr[12]] + $a5db82e8fe4c003a$var$bth[arr[13]] + $a5db82e8fe4c003a$var$bth[arr[14]] + $a5db82e8fe4c003a$var$bth[arr[15]]).toLowerCase(); // https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4 https://github.com/uuidjs/uuid/pull/434
    if (!$a5db82e8fe4c003a$var$reg.test(s)) throw new TypeError("Invalid uuid");
    return s;
}
function $a5db82e8fe4c003a$export$5a0d8143a7df2173(s) {
    if (!$a5db82e8fe4c003a$var$reg.test(s)) throw new TypeError("Invalid uuid");
    let v;
    const arr = new Uint8Array(16);
    // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(s.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff;
    // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(s.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff;
    // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(s.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff;
    // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(s.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff;
    // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(s.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
/**
 * Byte to hex mapping.
 * @type {string[]}
 */ const $a5db82e8fe4c003a$var$bth = [];
for(let i = 0; i < 256; i++)$a5db82e8fe4c003a$var$bth[i] = (i + 0x100).toString(16).substr(1);


const $0dc330fba39b622a$export$3afeb5d84de67746 = 5000;
const $0dc330fba39b622a$export$6f590997daae8459 = 1000;
const $0dc330fba39b622a$export$c57951f25361d453 = 1460;
function $0dc330fba39b622a$export$16e142ce02215086(text) {
    return `section-` + text.toLowerCase().replace(/[^a-z0-9]+/g, "-");
}
const $0dc330fba39b622a$export$16b104bd64f9fad8 = [
    "individual-referral",
    "individual-task",
    "individual-questionnaire",
    "individual-episode",
    "individual-encounter",
    "individual-consent",
    "organization-agency",
    "organization-site",
    "organization-task",
    "organization-questionnaire",
    "organization-event",
    "organization-period"
];
const $0dc330fba39b622a$var$individualActivityTypes = new Set($0dc330fba39b622a$export$16b104bd64f9fad8.filter((x)=>x.startsWith("individual-")));
function $0dc330fba39b622a$export$f635b8a078bb67e5(type) {
    return !!type && $0dc330fba39b622a$var$individualActivityTypes.has(type);
}
const $0dc330fba39b622a$var$endDateAlwaysRequiredActivityTypes = new Set([
    "organization-event",
    "individual-consent",
    "organization-period"
]);
function $0dc330fba39b622a$export$93b7907fd45b5aca(type) {
    return !!type && $0dc330fba39b622a$var$endDateAlwaysRequiredActivityTypes.has(type);
}
function $0dc330fba39b622a$export$36a3ba8a8d60841d(type) {
    return [
        "organization-event",
        "organization-agency",
        "organization-site",
        "organization-period"
    ].includes(type);
}
function $0dc330fba39b622a$export$a94a7861f82ee3e6(type, status) {
    return status === "completed" || status === "cancelled" || $0dc330fba39b622a$export$93b7907fd45b5aca(type);
}
const $0dc330fba39b622a$var$dueDateActivityTypes = new Set([
    "individual-referral",
    "individual-task",
    "individual-questionnaire",
    "organization-task",
    "organization-questionnaire"
]);
function $0dc330fba39b622a$export$431862b62533b4ed(type) {
    return !!type && $0dc330fba39b622a$var$dueDateActivityTypes.has(type);
}
function $0dc330fba39b622a$export$400fb7d64a2f4fed(type) {
    switch(type){
        case "individual-questionnaire":
            return "QuestionnaireResponse";
        case "individual-referral":
            return "ServiceRequest";
        case "individual-task":
            return "Task";
        case "organization-event":
            return "Task";
        case "organization-agency":
            return "Organization";
        case "organization-questionnaire":
            return "QuestionnaireResponse";
        case "organization-task":
            return "Task";
        default:
            throw new Error(`Unexpected activity type: ${type}`);
    }
}
var $0dc330fba39b622a$export$91d5aadb43f971b9;
(function(ActivityDefinitionFlags) {
    ActivityDefinitionFlags[ActivityDefinitionFlags["Root"] = 1] = "Root";
    ActivityDefinitionFlags[ActivityDefinitionFlags["Child"] = 2] = "Child";
    ActivityDefinitionFlags[ActivityDefinitionFlags["PermitAnonymous"] = 4] = "PermitAnonymous";
    ActivityDefinitionFlags[ActivityDefinitionFlags["Public"] = 8] = "Public";
    ActivityDefinitionFlags[ActivityDefinitionFlags["Copies"] = 16] = "Copies";
    ActivityDefinitionFlags[ActivityDefinitionFlags["OrganizationSpecific"] = 32] = "OrganizationSpecific";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasAddresses"] = 64] = "HasAddresses";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasPhones"] = 128] = "HasPhones";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasEmails"] = 256] = "HasEmails";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasContacts"] = 512] = "HasContacts";
    ActivityDefinitionFlags[ActivityDefinitionFlags["HasDueDate"] = 1024] = "HasDueDate";
})($0dc330fba39b622a$export$91d5aadb43f971b9 || ($0dc330fba39b622a$export$91d5aadb43f971b9 = {}));
function $0dc330fba39b622a$export$b7ad88df7d5fa33a(status) {
    switch(status){
        case "draft":
            return "draft";
        case "ready":
        case "in-progress":
            return "active";
        case "completed":
            return "completed";
        case "on-hold":
            return "on-hold";
        case "cancelled":
            return "revoked";
        default:
            throw new Error(`Unexpected activity status: ${status}`);
    }
}
function $0dc330fba39b622a$export$dbd89b202c05893d(status) {
    switch(status){
        // non-standard
        case "draft":
        case "ready":
        case "on-hold":
        case "cancelled":
            return [
                status
            ];
        // standard
        case "entered-in-error":
            return [
                "cancelled"
            ];
        case "in-progress":
            return [
                "draft",
                "ready",
                "in-progress"
            ];
        case "stopped":
            return [
                "on-hold"
            ];
        case "completed":
            return [
                "completed"
            ];
        default:
            return [];
    }
}
function $0dc330fba39b622a$export$6ba6a38b66086ebc(status) {
    switch(status){
        // non-standard
        case "ready":
        case "in-progress":
        case "cancelled":
            return [
                status
            ];
        // standard
        case "draft":
            return [
                "draft"
            ];
        case "active":
            return [
                "in-progress",
                "ready"
            ];
        case "completed":
            return [
                "completed"
            ];
        case "on-hold":
            return [
                "on-hold"
            ];
        case "revoked":
            return [
                "cancelled"
            ];
        default:
            return [];
    }
}
function $0dc330fba39b622a$export$84050dc6d268062c(status) {
    switch(status){
        case "draft":
            return [
                "draft"
            ];
        case "ready":
            return [
                "ready"
            ];
        case "cancelled":
            return [
                "cancelled"
            ];
        case "in-progress":
            return [
                "in-progress"
            ];
        case "on-hold":
            return [
                "on-hold"
            ];
        case "completed":
            return [
                "completed"
            ];
        default:
            return [];
    }
}
function $0dc330fba39b622a$export$7ee376c5137809a2(status) {
    switch(status){
        // non-standard
        case "draft":
        case "ready":
            return [
                status
            ];
        // standard
        case "planned":
            return [
                "draft"
            ];
        case "in-progress":
            return [
                "in-progress"
            ];
        case "cancelled":
        case "discontinued":
        case "entered-in-error":
            return [
                "cancelled"
            ];
        case "active":
            return [
                "in-progress"
            ];
        case "on-hold":
            return [
                "on-hold"
            ];
        case "discharged":
        case "completed":
            return [
                "completed"
            ];
        default:
            return [];
    }
}
function $0dc330fba39b622a$export$f0276a5d9f64ed8b(status) {
    switch(status){
        // non-standard
        case "draft":
        case "ready":
        case "in-progress":
        case "completed":
            return [
                status
            ];
        // standard
        case "planned":
            return [
                "draft"
            ];
        case "waitlist":
            return [
                "ready"
            ];
        case "entered-in-error":
        case "cancelled":
            return [
                "cancelled"
            ];
        case "active":
            return [
                "in-progress"
            ];
        case "on-hold":
            return [
                "on-hold"
            ];
        case "finished":
            return [
                "completed"
            ];
        default:
            return [];
    }
}
const $0dc330fba39b622a$export$6a8ec8f89e2ebfdf = {
    draft: "muted",
    ready: "open",
    "in-progress": "open",
    completed: "done",
    "on-hold": "attention",
    cancelled: "closed"
};
const $0dc330fba39b622a$export$b59e5e84dadfd247 = {
    draft: "State--draft",
    ready: "State--open",
    "in-progress": "State--open",
    completed: "State--merged",
    "on-hold": "color-bg-attention-emphasis color-fg-on-emphasis",
    cancelled: "State--closed"
};
const $0dc330fba39b622a$export$60edd6b2fdd9764b = {
    draft: (0, $2b6d0b8c1c80c786$export$206d84bec3b3a5a),
    ready: (0, $2b6d0b8c1c80c786$export$d2997daddac9b44),
    "in-progress": (0, $2b6d0b8c1c80c786$export$f3edcd159701e0e2),
    completed: (0, $2b6d0b8c1c80c786$export$4919767267a253b2),
    "on-hold": (0, $2b6d0b8c1c80c786$export$def956fbe4c089ce),
    cancelled: (0, $2b6d0b8c1c80c786$export$8a495e6856ec4c30)
};
const $0dc330fba39b622a$export$3ea354565a224eba = {
    draft: "ready",
    ready: "in-progress",
    "in-progress": "completed",
    completed: "in-progress",
    cancelled: "ready",
    "on-hold": "in-progress"
};
const $0dc330fba39b622a$export$d009ce1991333b4e = [
    {
        id: "draft",
        title: (0, $2868cc1235412e16$export$f3f08f4011de90bf),
        is_open: true,
        description: (0, $2868cc1235412e16$export$dfc3117aefd0fe77)
    },
    // { id: 'requested', title: 'Requested',is_open: true, reasons: [] },
    // { id: 'received', title: 'Received',is_open: true, reasons: [] },
    // { id: 'accepted', title: 'Accepted',is_open: true, reasons: [] },
    // { id: 'rejected', title: 'Rejected',is_open: true, reasons: [] },
    {
        id: "ready",
        title: (0, $2868cc1235412e16$export$f8107b180cdf43b3),
        is_open: true,
        description: (0, $2868cc1235412e16$export$fc65ca123a4d95d5)
    },
    {
        id: "in-progress",
        title: (0, $2868cc1235412e16$export$e3df7b8d35edbd9d),
        is_open: true,
        description: (0, $2868cc1235412e16$export$878e78a909bcb42c)
    },
    {
        id: "completed",
        title: (0, $2868cc1235412e16$export$49b81392f6018765),
        is_open: false,
        description: (0, $2868cc1235412e16$export$ecd960c60eeecfdb)
    },
    {
        id: "cancelled",
        title: (0, $2868cc1235412e16$export$c6aa1bfa918ebf18),
        is_open: false,
        description: (0, $2868cc1235412e16$export$de87c35595e5d750)
    },
    {
        id: "on-hold",
        title: (0, $2868cc1235412e16$export$9f13a839d14cd3a4),
        is_open: true,
        description: (0, $2868cc1235412e16$export$46d49c80898a4f02)
    }
];
const $0dc330fba39b622a$export$cfa4e26f21007dcc = $0dc330fba39b622a$export$d009ce1991333b4e.filter((x)=>x.is_open).map((x)=>x.id);
const $0dc330fba39b622a$export$db8da96cb205ed52 = $0dc330fba39b622a$export$d009ce1991333b4e.reduce((p, c)=>{
    p[c.id] = c.title;
    return p;
}, {});
const $0dc330fba39b622a$export$53da8b8d5cf73999 = "start-asc";
const $0dc330fba39b622a$export$9165947634754ea5 = 30;
var $0dc330fba39b622a$export$ab2f16cb08a3fd18;
(function(ActivityOrganizationAssociationType) {
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Creator"] = 1] = "Creator";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Assignee"] = 2] = "Assignee";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Mentioned"] = 4] = "Mentioned";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["ProjectSupervisor"] = 8] = "ProjectSupervisor";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["OrganizationSupervisor"] = 16] = "OrganizationSupervisor";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Automatic"] = 32] = "Automatic";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Contract"] = 64] = "Contract";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["AssociatedActivity"] = 128] = "AssociatedActivity";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["Consent"] = 256] = "Consent";
    ActivityOrganizationAssociationType[ActivityOrganizationAssociationType["ReferencingActivity"] = 512] = "ReferencingActivity";
})($0dc330fba39b622a$export$ab2f16cb08a3fd18 || ($0dc330fba39b622a$export$ab2f16cb08a3fd18 = {}));
var $0dc330fba39b622a$export$3f127d6e382cc218;
(function(ActivityParticipantType) {
    ActivityParticipantType[ActivityParticipantType["Creator"] = 1] = "Creator";
    ActivityParticipantType[ActivityParticipantType["Updator"] = 2] = "Updator";
    ActivityParticipantType[ActivityParticipantType["Assignee"] = 4] = "Assignee";
    ActivityParticipantType[ActivityParticipantType["Commentor"] = 8] = "Commentor";
    ActivityParticipantType[ActivityParticipantType["Mentioned"] = 16] = "Mentioned";
    ActivityParticipantType[ActivityParticipantType["TeamMentioned"] = 32] = "TeamMentioned";
    ActivityParticipantType[ActivityParticipantType["Manual"] = 64] = "Manual";
    ActivityParticipantType[ActivityParticipantType["Automatic"] = 128] = "Automatic";
})($0dc330fba39b622a$export$3f127d6e382cc218 || ($0dc330fba39b622a$export$3f127d6e382cc218 = {}));
function $0dc330fba39b622a$export$eeeefc19bf3b1d71(locale, type) {
    switch(type){
        case "individual-consent":
            return (0, $2868cc1235412e16$export$7c1b73b3fc2f0159)[locale];
        case "individual-encounter":
            return (0, $2868cc1235412e16$export$1f61287e5d30e3cf)[locale];
        case "individual-episode":
            return (0, $2868cc1235412e16$export$9ea0062ee8a62693)[locale];
        case "individual-questionnaire":
            return (0, $2868cc1235412e16$export$375f6e4643646315)[locale];
        case "individual-referral":
            return (0, $2868cc1235412e16$export$ff6a452cc674d674)[locale];
        case "individual-task":
            return (0, $2868cc1235412e16$export$e31ed6ed548e255b)[locale];
        case "organization-agency":
            return (0, $2868cc1235412e16$export$8d7a72727b917368)[locale];
        case "organization-site":
            return (0, $2868cc1235412e16$export$3a9d0270e8a39565)[locale];
        case "organization-event":
            return (0, $2868cc1235412e16$export$d23e7a1502780659)[locale];
        case "organization-period":
            return (0, $2868cc1235412e16$export$94c8daae5f9ab256)[locale];
        case "organization-questionnaire":
            return (0, $2868cc1235412e16$export$fc6d25d72e8dca9c)[locale];
        case "organization-task":
            return (0, $2868cc1235412e16$export$a38a7850cefdb2b2)[locale];
        default:
            throw new Error(`Unexpected type "${type}".`);
    }
}
function $0dc330fba39b622a$export$ceffb4d349db604e(locale, type) {
    switch(type){
        case "individual-consent":
            return (0, $2868cc1235412e16$export$1aab9202c7b650e6)[locale];
        case "individual-encounter":
            return (0, $2868cc1235412e16$export$aac1b84c33b9a082)[locale];
        case "individual-episode":
            return (0, $2868cc1235412e16$export$b1642650037543f)[locale];
        case "individual-questionnaire":
            return (0, $2868cc1235412e16$export$a9202f9fc8a3c137)[locale];
        case "individual-referral":
            return (0, $2868cc1235412e16$export$90f6380a62d43dd9)[locale];
        case "individual-task":
            return (0, $2868cc1235412e16$export$dad853a619f75d14)[locale];
        case "organization-agency":
            return (0, $2868cc1235412e16$export$c679b7129661e5e0)[locale];
        case "organization-site":
            return (0, $2868cc1235412e16$export$8a207254b784b0a6)[locale];
        case "organization-event":
            return (0, $2868cc1235412e16$export$fd5fa5d7e2f6be5d)[locale];
        case "organization-period":
            return (0, $2868cc1235412e16$export$6d10fa154c9a0e20)[locale];
        case "organization-questionnaire":
            return (0, $2868cc1235412e16$export$d010d50b14e45bda)[locale];
        case "organization-task":
            return (0, $2868cc1235412e16$export$f20156ec63e0a45d)[locale];
        default:
            throw new Error(`Unexpected type "${type}".`);
    }
}
function $0dc330fba39b622a$export$de80be383d29285f(locale, activityType, subscriber) {
    const subscribed = subscriber?.subscribed ?? false;
    const type = subscriber?.type ?? 0;
    const displayType = $0dc330fba39b622a$export$eeeefc19bf3b1d71(locale, activityType).toLocaleLowerCase(locale);
    if (!subscriber) return (0, $2868cc1235412e16$export$a07a7cb78e70dc7)[locale](displayType);
    else if (!subscribed) return (0, $2868cc1235412e16$export$870104d5b672042c)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.Manual) return (0, $2868cc1235412e16$export$a34bc0eefd7e0f6)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.Creator) return (0, $2868cc1235412e16$export$d1d1e7344faf74a9)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.Assignee) return (0, $2868cc1235412e16$export$a9564ee2df9884f7)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.Commentor) return (0, $2868cc1235412e16$export$3f7a9c0c6b45d6d2)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.Mentioned) return (0, $2868cc1235412e16$export$d5792a6242510aa5)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.Updator) return (0, $2868cc1235412e16$export$cc74ec0e2bf1c390)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.TeamMentioned) return (0, $2868cc1235412e16$export$94b61b888e588ac2)[locale](displayType);
    else if (type & $0dc330fba39b622a$export$3f127d6e382cc218.Automatic) return (0, $2868cc1235412e16$export$9e80186c98919fd3)[locale](displayType);
    else throw new Error(`Unexpected subscriber type ${type}`);
}
const $0dc330fba39b622a$export$823653c22c406b00 = {
    status: 1,
    assignee: 2,
    comment: 4
};
const $0dc330fba39b622a$export$6579d67e23b63336 = "activity-subscription-button";
const $0dc330fba39b622a$export$8e709ea29df8a2f1 = "email-notify-status";
const $0dc330fba39b622a$export$e2e1c67e97d17ec2 = "email-notify-assignee";
const $0dc330fba39b622a$export$db83f36fdd193499 = "email-notify-comment";
const $0dc330fba39b622a$var$defaultRequiredExpression = {
    type: "boolean",
    ast: {
        type: "BinaryExpression",
        operator: "==",
        left: {
            type: "CallExpression",
            arguments: [
                {
                    type: "Identifier",
                    name: "ACTIVITY_STATUS"
                }
            ],
            callee: {
                type: "Identifier",
                name: "VALUE"
            }
        },
        right: {
            type: "Literal",
            value: "completed",
            raw: "'completed'"
        }
    }
};
function $0dc330fba39b622a$export$d89c0470e9f1cc7e(elements, scope, callback) {
    let hiddenHeadingLevel = Number.MAX_SAFE_INTEGER;
    let visibleConsecutiveHeadingLevel = Number.MAX_SAFE_INTEGER;
    for (const el of elements){
        const visible = !(el.visibility && !(0, $0dbabea6e8ef01ef$export$61b73397e464436e)("bit", el.visibility, scope));
        // console.log(
        //   `Element ${el.index}, level ${el.level}, visible ${visible} - hiddenHeadingLevel ${hiddenHeadingLevel}`
        // );
        if (el.type === "heading") {
            // when multiple headings of the same level appear consecutively, only one of them has to be visible
            // for the subsequent fields to be visible.
            visibleConsecutiveHeadingLevel = visible || el.level === visibleConsecutiveHeadingLevel ? el.level : Number.MAX_SAFE_INTEGER;
            if (el.level <= hiddenHeadingLevel) hiddenHeadingLevel = visible || el.level === visibleConsecutiveHeadingLevel ? Number.MAX_SAFE_INTEGER : el.level;
        } else visibleConsecutiveHeadingLevel = Number.MAX_SAFE_INTEGER;
        const required = el.required && Boolean((0, $0dbabea6e8ef01ef$export$61b73397e464436e)("bit", el.required_expression ?? $0dc330fba39b622a$var$defaultRequiredExpression, scope));
        const readonly = !!el.readonly_expression && Boolean((0, $0dbabea6e8ef01ef$export$61b73397e464436e)("bit", el.readonly_expression, scope));
        const visibleWithHeading = visible && el.level < hiddenHeadingLevel;
        callback(el, visibleWithHeading, required, readonly);
        if (el.type === "heading") {
            if (visibleWithHeading) scope.hasVisiblePredecessors = false;
        } else scope.hasVisiblePredecessors || (scope.hasVisiblePredecessors = visibleWithHeading);
    // console.log(
    //   `${el.index.toString().padStart(3, ' ')} ${el.type.padEnd(15, ' ')} | visible: ${visibleWithHeading.toString().padEnd(5, ' ')} | hasVisiblePredecessors: ${scope.hasVisiblePredecessors.toString().padEnd(5, ' ')} | ${el.type === 'heading' ? el.text : ''}`
    // );
    }
}
function $0dc330fba39b622a$export$80ddb1e8ba36c18f({ organization_login: organization_login, activityDefinition: { activity_definition_id: activity_definition_id, type: type, flags: flags, parents: parents }, person_id: person_id, associated_activity_id: associated_activity_id, recommendation: recommendation = false, params: params = new URLSearchParams() }) {
    const root = (flags & $0dc330fba39b622a$export$91d5aadb43f971b9.Root) > 0;
    const child = (flags & $0dc330fba39b622a$export$91d5aadb43f971b9.Child) > 0;
    const permitAnonymous = (flags & $0dc330fba39b622a$export$91d5aadb43f971b9.PermitAnonymous) > 0;
    params.set("activity_definition_id", activity_definition_id);
    // INDIVIDUAL
    if ($0dc330fba39b622a$export$f635b8a078bb67e5(type) && !(!person_id && permitAnonymous)) {
        if (person_id) {
            if (root) return `/${organization_login}/people/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(person_id)}/activities/new?${params}`;
            else if (child || recommendation && associated_activity_id) {
                if (associated_activity_id) {
                    params.set("associated_activity_id", associated_activity_id);
                    return `/${organization_login}/people/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(person_id)}/activities/new?${params}`;
                } else if (parents?.find((x)=>$0dc330fba39b622a$export$f635b8a078bb67e5(x.type))) return `/${organization_login}/people/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(person_id)}/activities/?${params}`;
                else return `/${organization_login}/activities/?${params}`;
            } else return "#";
        } else return `/${organization_login}/people/?${params}`;
    }
    // ORGANIZATION (or anonymous)
    if (root) return `/${organization_login}/activities/new?${params}`;
    else if (child || recommendation && associated_activity_id) {
        if (associated_activity_id) {
            params.set("associated_activity_id", associated_activity_id);
            return `/${organization_login}/activities/new?${params}`;
        } else return `/${organization_login}/activities/?${params}`;
    } else return "#";
}
function $0dc330fba39b622a$export$1ff92de98417a845({ activityDefinitionLookup: activityDefinitionLookup, person_id: person_id, associated_activity: associated_activity, require_associated_person: require_associated_person = true, require_associated_activity: require_associated_activity = true }) {
    const associatedActivityDefiniton = activityDefinitionLookup.find((x)=>x.activity_definition_id === associated_activity?.activity_definition_id);
    if (associated_activity && !associatedActivityDefiniton) throw new Error(`Unable to find associated activity definition with id "${associated_activity.activity_definition_id}".`);
    const results = [];
    for (const x of activityDefinitionLookup){
        const individual = $0dc330fba39b622a$export$f635b8a078bb67e5(x.type);
        // individual activity? require person, anonymous, or not require associated.
        if (individual && !person_id && (x.flags & $0dc330fba39b622a$export$91d5aadb43f971b9.PermitAnonymous) === 0 && require_associated_person) continue;
        // organization activity? ensure person is not set.
        if (!individual && person_id) continue;
        // associated activity provided? ensure child and ensure parents permit the specified associated activity.
        if (associated_activity && !(x.flags & $0dc330fba39b622a$export$91d5aadb43f971b9.Child && associated_activity.project_id === x.project_id && x.parents?.find((p)=>p.activity_definition_id === associated_activity.activity_definition_id))) continue;
        // root?
        if ((x.flags & $0dc330fba39b622a$export$91d5aadb43f971b9.Root) > 0 && !associated_activity) {
            results.push(x);
            continue;
        }
        // child?
        if ((x.flags & $0dc330fba39b622a$export$91d5aadb43f971b9.Child) === 0) continue;
        // child, but no parents?
        if (!x.parents?.length) continue;
        // organization child with individual parent?
        if (!$0dc330fba39b622a$export$f635b8a078bb67e5(x.type) && x.parents?.find((p)=>$0dc330fba39b622a$export$f635b8a078bb67e5(p.type))) continue;
        // TEMP: individual child with unknown organization parent?
        // Need to enhance activity list....
        if ($0dc330fba39b622a$export$f635b8a078bb67e5(x.type) && !associated_activity && x.parents?.find((p)=>!$0dc330fba39b622a$export$f635b8a078bb67e5(p.type))) continue;
        // child with associated activity?
        if (associated_activity?.project_id === x.project_id && x.parents?.find((y)=>y.activity_definition_id === associated_activity.activity_definition_id)) {
            results.push(x);
            continue;
        }
        // child without associated activity?
        if (!associated_activity && !require_associated_activity) {
            results.push(x);
            continue;
        }
    }
    const today = new Date(new Date().toLocaleString("en-US", {
        timeZone: "America/New_York"
    })).toISOString().substr(0, 10);
    const active = [];
    const inactive = [];
    for (const x of results)if (x.start_date <= today && x.end_date >= today) active.push(x);
    else inactive.push(x);
    return {
        active: active,
        inactive: inactive
    };
}
function $0dc330fba39b622a$export$1a6824b3d7fd3414(activityDefinitionLookup) {
    let count = 0;
    for (const x of activityDefinitionLookup)if (x.type === "individual-referral") {
        count++;
        if (count > 4) return true;
    }
    return false;
}

function $0f65d914a7138590$export$7ad13431816ff1fa(value) {
    const array = [];
    for(let shift = 0; shift < 32; shift++)if ((value & 2 ** shift) !== 0) array.push(shift);
    return array;
}
function $0f65d914a7138590$export$ad3694445957bc72(array) {
    let value = 0;
    for (const shift of array)value += 2 ** shift;
    return value;
}



function $9dad25ba7a5dc18c$var$computeChartArc(startAngle, endAngle, outerRadius, innerRadius) {
    startAngle = startAngle * Math.PI / 180;
    endAngle = endAngle * Math.PI / 180;
    const sinAlpha = Math.sin(startAngle);
    const cosAlpha = Math.cos(startAngle);
    const sinBeta = Math.sin(endAngle);
    const cosBeta = Math.cos(endAngle);
    const largeArc = endAngle - startAngle > Math.PI;
    const P = {
        x: outerRadius + outerRadius * sinAlpha,
        y: outerRadius - outerRadius * cosAlpha
    };
    const Q = {
        x: outerRadius + outerRadius * sinBeta,
        y: outerRadius - outerRadius * cosBeta
    };
    const R = {
        x: outerRadius + innerRadius * sinBeta,
        y: outerRadius - innerRadius * cosBeta
    };
    const S = {
        x: outerRadius + innerRadius * sinAlpha,
        y: outerRadius - innerRadius * cosAlpha
    };
    return `M${P.x}, ${P.y} A${outerRadius},${outerRadius} 0 ${largeArc ? "1" : "0"} 1 ${Q.x},${Q.y} L${R.x},${R.y} A${innerRadius},${innerRadius} 0 ${largeArc ? "1" : "0"} 0 ${S.x},${S.y} Z`;
}
function $9dad25ba7a5dc18c$export$3194dcd7e2b21417(percentage, backgroundColor = "var(--color-accent-subtle)", innerRadius = 5) {
    const b = $9dad25ba7a5dc18c$var$computeChartArc(0, 359.99, 8, innerRadius);
    const f = $9dad25ba7a5dc18c$var$computeChartArc(0, 359.99 * percentage, 8, innerRadius);
    return `<path fill="${backgroundColor}" d="${b}" /><path fill="currentColor" d="${f}" />`;
}




const $7787380576b51463$export$a5cacc05f5e9f20c = [
    {
        choice_id: 2,
        label: "Non-profit"
    },
    {
        choice_id: 1,
        label: "For-profit"
    },
    {
        choice_id: 0,
        label: "Government"
    }
];
const $7787380576b51463$export$8e77a375f9a5908e = [
    "Owner",
    "Admin",
    "Writer",
    "Reader"
];
const $7787380576b51463$export$c1da4857cafcfd90 = {
    Owner: "a0000000-0000-0000-0000-000000000001",
    Admin: "a0000000-0000-0000-0000-000000000002",
    Writer: "a0000000-0000-0000-0000-000000000003",
    Reader: "a0000000-0000-0000-0000-000000000004"
};
function $7787380576b51463$export$3da2623e77b27bff(user, expected_role) {
    switch(expected_role){
        case "Owner":
            return user.role_id === $7787380576b51463$export$c1da4857cafcfd90.Owner;
        case "Admin":
            return user.role_id === $7787380576b51463$export$c1da4857cafcfd90.Owner || user.role_id === $7787380576b51463$export$c1da4857cafcfd90.Admin;
        case "Writer":
            return user.role_id === $7787380576b51463$export$c1da4857cafcfd90.Owner || user.role_id === $7787380576b51463$export$c1da4857cafcfd90.Admin || user.role_id === $7787380576b51463$export$c1da4857cafcfd90.Writer;
        default:
            throw new Error(`Invalid expected_role: ${JSON.stringify(expected_role)}`);
    }
}
function $7787380576b51463$export$395c839b544cebaf(alias, expected_role) {
    switch(expected_role){
        case "Owner":
            return `[${alias}].role_id = convert(uniqueidentifier, '${$7787380576b51463$export$c1da4857cafcfd90.Owner}')`;
        case "Admin":
            return `[${alias}].role_id in (convert(uniqueidentifier, '${$7787380576b51463$export$c1da4857cafcfd90.Owner}'), convert(uniqueidentifier, '${$7787380576b51463$export$c1da4857cafcfd90.Admin}'))`;
        case "Writer":
            return `[${alias}].role_id <> convert(uniqueidentifier, '${$7787380576b51463$export$c1da4857cafcfd90.Reader}')`;
        default:
            throw new Error(`Invalid expected_role: ${JSON.stringify(expected_role)}`);
    }
}
function $7787380576b51463$export$99a392609bf9c4bc(users) {
    return users.reduce((p, c)=>{
        var _a;
        p[_a = c.user_id] ?? (p[_a] = {});
        p[c.user_id][c.organization_id] = c;
        return p;
    }, {});
}
function $7787380576b51463$export$dfb4b9c7c4ff56e4(users) {
    return users.reduce((p, c)=>{
        var _a;
        p[_a = c.user_id] ?? (p[_a] = {});
        p[c.user_id][c.organization_id] = c;
        return p;
    }, {});
}
function $7787380576b51463$export$dbf22db7e3af8185(entity) {
    return {
        user_id: entity.create_user_id,
        user_login: entity.create_user_login,
        user_name: entity.create_user_name,
        user_avatar_id: entity.create_user_avatar_id,
        organization_id: entity.create_organization_id,
        organization_login: entity.create_organization_login,
        organization_name: entity.create_organization_name,
        organization_avatar_id: entity.create_organization_avatar_id,
        is_active: entity.create_user_is_active,
        is_ooo: entity.create_user_is_ooo
    };
}
function $7787380576b51463$export$6d3fb84f784b8446(entity) {
    return {
        user_id: entity.assignee_user_id,
        user_login: entity.assignee_user_login,
        user_name: entity.assignee_user_name,
        user_avatar_id: entity.assignee_user_avatar_id,
        organization_id: entity.assignee_organization_id,
        organization_login: entity.assignee_organization_login,
        organization_name: entity.assignee_organization_name,
        organization_avatar_id: entity.assignee_organization_avatar_id,
        is_active: entity.assignee_user_is_active,
        is_ooo: entity.assignee_user_is_ooo
    };
}





// https://laurentpayot.github.io/minidenticons/
// https://github.com/laurentpayot/minidenticons/blob/main/minidenticons.js

// density of 4 for the lowest probability of collision
const $49376f0a0c633f4e$var$SQUARE_DENSITY = 4;
// 18 different colors only for easy distinction
const $49376f0a0c633f4e$var$COLORS_NB = 18;
const $49376f0a0c633f4e$var$DEFAULT_SATURATION = 80;
const $49376f0a0c633f4e$var$DEFAULT_LIGHTNESS = 50;
// 32 bit FNV-1a hash parameters
const $49376f0a0c633f4e$var$FNV_PRIME = 16777619;
const $49376f0a0c633f4e$var$OFFSET_BASIS = 2166136261;
// based on the FNV-1a hash algorithm, modified for *signed* 32 bit integers http://www.isthe.com/chongo/tech/comp/fnv/index.html
function $49376f0a0c633f4e$var$simpleHash(str) {
    return str.split("")// >>> 0 for 32 bit unsigned integer conversion https://2ality.com/2012/02/js-integers.html
    .reduce((hash, char)=>((hash ^ char.charCodeAt(0)) >>> 0) * $49376f0a0c633f4e$var$FNV_PRIME, $49376f0a0c633f4e$var$OFFSET_BASIS);
}
function $49376f0a0c633f4e$export$f94e576f8dfe1808(entity, size, classes = null, id = null, fluid = false, saturation = $49376f0a0c633f4e$var$DEFAULT_SATURATION, lightness = $49376f0a0c633f4e$var$DEFAULT_LIGHTNESS) {
    const hash = $49376f0a0c633f4e$var$simpleHash(entity.id);
    // dividing hash by FNV_PRIME to get last XOR result for better color randomness (will be an integer except for empty string hash)
    const hue = hash / $49376f0a0c633f4e$var$FNV_PRIME % $49376f0a0c633f4e$var$COLORS_NB * (360 / $49376f0a0c633f4e$var$COLORS_NB);
    const rects = [
        ...Array(entity.id ? 25 : 0).keys()
    ]// 2 + ((3 * 5 - 1) - modulo) to concentrate squares at the center
    .map((i)=>hash % (16 - i % 15) < $49376f0a0c633f4e$var$SQUARE_DENSITY ? `<rect x="${i > 14 ? 7 - ~~(i / 5) : ~~(i / 5)}" y="${i % 5}" width="1" height="1"/>` : "").join("");
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-1.5 -1.5 8 8"
    style="fill: hsl(${hue} ${saturation}% ${lightness}%)"
    fill="hsl(${hue} ${saturation}% ${lightness}%)"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("class", classes)}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("id", id)}
    alt="${entity.login}"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("width", fluid ? null : size.toFixed())}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("height", fluid ? null : size.toFixed())}
  >
    ${(0, $904f4b114d3dc756$export$b6e69390c23686fb)(rects)}
  </svg>`;
}



function $a40c721193cf9ad8$export$dd0e4d48d7766a39({ size: size, classes: classes, bimi: bimi = false, id: id } = {}) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${bimi ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<?xml version="1.0" encoding="UTF-8" standalone="yes" ?>` : null}<svg
      xmlns="http://www.w3.org/2000/svg"
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("version", bimi ? "1.2" : null)}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("baseProfile", bimi ? "tiny-ps" : null)}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("width", size?.toString())}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("height", size?.toString())}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-hidden", bimi ? null : "true")}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("class", classes)}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("id", id)}
      viewBox="0 0 22.3 22.3"
    >
      ${bimi ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<title>Cumulus</title>` : null}
      <path
        d="m19.95687607 3.4897178-4.15 3.92c-.03-.03-.06-.07-.1-.11a5.407 5.407 0 0 0-1.8-1.2 5.583 5.583 0 0 0-4.1000005 0c-.01.01-.01.01-.02.01l-2.16-5.27999998c.01 0 .02-.01.03-.01a11.167 11.167 0 0 1 8.4000005 0 11.228 11.228 0 0 1 3.69 2.44999998c.07.07.14.14.21.22z"
        fill="#033d8b"
      />
      <path
        d="M9.78687557 6.1097178a5.453 5.453 0 0 0-1.78 1.19 5.413 5.413 0 0 0-1.60001 3.8600002h-5.70999a11.297 11.297 0 0 1 .81999-4.2000002 11.202 11.202 0 0 1 6.11001-6.12999998Z"
        fill="#0969da"
      />
      <path
        d="m9.78687557 16.199718-2.16 5.29a11.394 11.394 0 0 1-3.66001-2.44 11.126 11.126 0 0 1-2.45-3.69 11.298 11.298 0 0 1-.81999-4.2h5.70999a5.348 5.348 0 0 0 .4 2.05 5.506 5.506 0 0 0 2.98001 2.99z"
        fill="#54aeff"
      />
      <path
        d="m19.95487607 18.830718-4.145-3.922c-.03.032-.062.067-.102.104a5.435 5.435 0 0 1-1.8 1.199 5.5 5.5 0 0 1-4.1040005 0l-.015-.008-2.16 5.282.03.012a11.147 11.147 0 0 0 12.0860005-2.45l.002-.003c.067-.067.136-.137.208-.214z"
        fill="#b6e3ff"
      />
    </svg>`;
}


const $5c0b589e3f16bd20$export$754b6febe722cea4 = "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa";
const $5c0b589e3f16bd20$export$c88105ae160deaf9 = "00000000-0000-0000-0000-000000000000";
const $5c0b589e3f16bd20$export$c04e8e4d40520792 = "00000099-0000-0000-0000-000000000000";
const $5c0b589e3f16bd20$export$5ff5ade51e1b8b9d = {
    type: "user",
    anonymous: true,
    id: $5c0b589e3f16bd20$export$754b6febe722cea4,
    auth0_id: "auth0|000000000000000000000000",
    login: "External",
    roles: [],
    email: "external@cumulus.care",
    email_verified: true,
    given_name: "External",
    family_name: "External",
    name: "External",
    avatar_id: "",
    is_ooo: false,
    eula_accepted: new Date().toISOString()
};
const $5c0b589e3f16bd20$export$12ad83c1dd9d429c = {
    status: 1,
    assignee: 2,
    comment: 4
};



const $d4136d8b8326a7e0$export$8e791bf7fac21718 = /@cumulus\.care$/i;
const $d4136d8b8326a7e0$export$f582d29a2accd675 = /@registered-apps\.cumulus\.care$/i;
const $d4136d8b8326a7e0$export$f94a40361869b200 = /^CumulusSupport/i;
const $d4136d8b8326a7e0$export$a2b50cedadabfd42 = `This account belongs to a Cumulus support staff member. It is used to perform updates requested by customers.`;
function $d4136d8b8326a7e0$export$7b636ee1d1553fbd(email, classes) {
    return email.match($d4136d8b8326a7e0$export$8e791bf7fac21718) && !email.includes("+") ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Label Label--sponsors ${classes}">Staff</span>` : email.match($d4136d8b8326a7e0$export$f582d29a2accd675) ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Label Label--attention ${classes}">App</span>` : null;
}



const $0698681c3e411266$export$65bbdb088890cb21 = {
    sizes: [
        16,
        20,
        24,
        32,
        40,
        48,
        64,
        80,
        128,
        160,
        256,
        320,
        512,
        640,
        1024
    ],
    maxSize: 2048,
    type: "image/jpeg"
};
function $0698681c3e411266$export$638a2d9f8df3c648(size) {
    if (size >= 640) return size;
    return size * 2;
}
function $0698681c3e411266$export$345c5736c8054f22(entity, size, classes = null, fluid = false) {
    const id = null;
    let content;
    if (!entity || entity.id === (0, $5c0b589e3f16bd20$export$754b6febe722cea4)) content = $0698681c3e411266$var$anonymousAvatar(size, "Avatar-image", id, fluid);
    else if (entity.id === (0, $5c0b589e3f16bd20$export$c88105ae160deaf9)) content = $0698681c3e411266$var$cumulusBotAvatar(size, "Avatar-image", id, fluid);
    else if (entity.id === (0, $5c0b589e3f16bd20$export$c04e8e4d40520792) || (0, $d4136d8b8326a7e0$export$f94a40361869b200).test(entity.login)) content = (0, $a40c721193cf9ad8$export$dd0e4d48d7766a39)({
        classes: ""
    });
    else if (entity.avatar_id) content = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<img
      class="Avatar-image"
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("id", id)}
      src="${$0698681c3e411266$export$e594fdbb182de2fb(entity.avatar_id, $0698681c3e411266$export$638a2d9f8df3c648(size))}"
      alt="${entity.login}"
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("width", fluid ? null : size.toFixed())}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("height", fluid ? null : size.toFixed())}
      loading="lazy"
    />`;
    else content = (0, $49376f0a0c633f4e$export$f94e576f8dfe1808)(entity, size, "Avatar-image", id, fluid);
    const status = entity?.id === (0, $5c0b589e3f16bd20$export$754b6febe722cea4) || entity?.id === (0, $5c0b589e3f16bd20$export$c88105ae160deaf9) ? "none" : entity?.status ?? "none";
    let statusIcon;
    const statusSize = size === 20 ? "45%" : size <= 48 ? "40%" : size <= 64 ? "30%" : "25%";
    switch(status){
        case "inactive":
            statusIcon = (0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$db80f3ef24ef3261), {
                classes: "Avatar-status color-fg-danger",
                size: statusSize,
                viewBox: 12,
                octicon: false
            });
            break;
        case "out-of-office":
            statusIcon = (0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$767fa712cf880535), {
                classes: "Avatar-status color-fg-ooo",
                size: statusSize,
                octicon: false
            });
            break;
        default:
            statusIcon = null;
    }
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
    class="Avatar ${classes}"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("style", fluid ? null : `width: ${size}px; height: ${size}px`)}
    >${content}${statusIcon}</span
  >`;
}
function $0698681c3e411266$export$e594fdbb182de2fb(avatar_id, size) {
    return `/image-delivery/${avatar_id}/${size}`;
}
function $0698681c3e411266$var$anonymousAvatar(size, classes = null, id = null, fluid = false) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<svg
    viewBox="0 0 16 16"
    class="${classes} color-bg-subtle color-fg-muted"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("id", id)}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    alt="anonymous"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("width", fluid ? null : size.toFixed())}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("height", fluid ? null : size.toFixed())}
    style="padding: 8%"
  >
    <path
      fill-rule="evenodd"
      d="M13 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM3.022 13h9.956a.274.274 0 0 0 .014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 0 0 .022.004zm9.974.056v-.002.002zM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
    ></path>
  </svg>`;
}
function $0698681c3e411266$var$cumulusBotAvatar(size, classes = null, id = null, fluid = false) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<svg
    viewbox="0 0 640 640"
    class="${classes}"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("id", id)}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    alt="Cumulus"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("width", fluid ? null : size.toFixed())}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("height", fluid ? null : size.toFixed())}
  >
    <path fill="none" d="M-1-1h642v642H-1z" />
    <g>
      <path
        fill="#93c7ef"
        d="M367.878 141.818c0-25.707-20.84-46.545-46.545-46.545s-46.545 20.838-46.545 46.545c0 17.225 9.365 32.254 23.273 40.304v83.818h46.545v-83.818c13.908-8.049 23.272-23.079 23.272-40.304z"
      />
      <path
        fill="#5a8bb0"
        d="M321.333 95.273V265.94h23.273v-83.818c13.908-8.049 23.273-23.077 23.273-40.304 0-25.707-20.84-46.545-46.546-46.545z"
      />
      <path
        d="M65.333 312.485h248.242v124.121H65.333V312.485z"
        fill="#93c7ef"
      />
      <path
        d="M329.091 312.485h248.242v124.121H329.091V312.485z"
        fill="#5a8bb0"
      />
      <path
        d="M251.515 436.606h139.636v124.121H251.515V436.606z"
        fill="#93c7ef"
      />
      <path
        d="M321.333 436.606h69.818v124.121h-69.818V436.606z"
        fill="#5a8bb0"
      />
      <path
        d="M111.878 234.909h418.91v279.273h-418.91V234.909z"
        fill="#cce9f9"
      />
      <path
        d="M321.333 234.909h209.455v279.273H321.333V234.909z"
        fill="#93c7ef"
      />
      <path
        fill="#3c5d76"
        d="M251.515 421.091c0 38.558 31.258 69.818 69.818 69.818 38.558 0 69.818-31.26 69.818-69.818H251.515z"
      />
      <path
        fill="#1e2e3b"
        d="M321.333 421.091v69.818c38.558 0 69.818-31.26 69.818-69.818h-69.818z"
      />
      <g stroke="null">
        <path
          fill="#1e73b2"
          d="M416.751 305.214a26.073 26.073 0 00-8.51 5.69 25.882 25.882 0 00-7.651 18.457h-27.302a54.016 54.016 0 013.92-20.083 53.562 53.562 0 0129.215-29.31l10.328 25.246z"
        />
        <path
          fill="#1d479b"
          d="M465.379 292.687l-19.843 18.743c-.144-.143-.287-.335-.479-.526a25.853 25.853 0 00-8.606-5.738 26.695 26.695 0 00-19.604 0c-.048.048-.048.048-.096.048l-10.328-25.246c.048 0 .096-.048.144-.048a53.394 53.394 0 0140.164 0 53.686 53.686 0 0117.643 11.715c.335.335.67.67 1.005 1.052z"
        />
        <path
          fill="#3ba1c9"
          d="M416.751 353.459l-10.328 25.294a54.48 54.48 0 01-17.5-11.667 53.198 53.198 0 01-11.714-17.643 54.02 54.02 0 01-3.921-20.082h27.302a25.571 25.571 0 001.913 9.802 26.327 26.327 0 0014.248 14.296z"
        />
        <path
          fill="#bcdae8"
          d="M465.369 366.039l-19.82-18.753c-.143.153-.296.32-.487.497a25.987 25.987 0 01-8.606 5.733 26.298 26.298 0 01-19.623 0l-.072-.038-10.328 25.256.143.057a53.299 53.299 0 0057.789-11.714l.01-.015c.32-.32.65-.655.994-1.023z"
        />
      </g>
      <g stroke="null">
        <path
          fill="#1e73b2"
          d="M212.751 305.214a26.073 26.073 0 00-8.51 5.69 25.882 25.882 0 00-7.651 18.457h-27.302a54.016 54.016 0 013.92-20.083 53.562 53.562 0 0129.215-29.31l10.328 25.246z"
        />
        <path
          fill="#1d479b"
          d="M261.379 292.687l-19.843 18.743c-.144-.143-.287-.335-.479-.526a25.853 25.853 0 00-8.606-5.738 26.695 26.695 0 00-19.604 0c-.048.048-.048.048-.096.048l-10.328-25.246c.048 0 .096-.048.144-.048a53.394 53.394 0 0140.164 0 53.686 53.686 0 0117.643 11.715c.335.335.67.67 1.005 1.052z"
        />
        <path
          fill="#3ba1c9"
          d="M212.751 353.459l-10.328 25.294a54.48 54.48 0 01-17.5-11.667 53.198 53.198 0 01-11.714-17.643 54.02 54.02 0 01-3.921-20.082h27.302a25.571 25.571 0 001.913 9.802 26.327 26.327 0 0014.248 14.296z"
        />
        <path
          fill="#bcdae8"
          d="M261.369 366.039l-19.82-18.753c-.143.153-.296.32-.487.497a25.987 25.987 0 01-8.606 5.733 26.298 26.298 0 01-19.623 0l-.072-.038-10.328 25.256.143.057a53.299 53.299 0 0057.789-11.714l.01-.015c.32-.32.65-.655.994-1.023z"
        />
      </g>
    </g>
  </svg>`;
}



function $0f10b3ed48c1ca5b$export$c5bed7b44bfbfae7(user, { avatar: renderAvatar = true, organization: organization = false, text: text = true, popoverDirection: popoverDirection = "right", size: size = 20, project_id: project_id = null, activity_id: activity_id = null, muted: muted = false } = {}) {
    if (!user) return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="text-italic">Deleted user</span>`;
    const auser = {
        type: "user",
        id: user.user_id,
        login: user.user_login,
        avatar_id: user.user_avatar_id,
        status: user.is_active ? user.is_ooo ? "out-of-office" : "none" : "inactive"
    };
    const label = user.user_login + (organization ? ` (${user.organization_login})` : "");
    const params = new URLSearchParams();
    if (project_id) params.set("project_id", project_id);
    if (activity_id) params.set("activity_id", activity_id);
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<details
    class="details-reset details-overlay position-relative d-inline-flex color-fg-default"
  >
    <summary
      class="text-bold${muted ? " color-fg-muted" : ""}"
      aria-label="${label}"
    >
      ${renderAvatar ? (0, $0698681c3e411266$export$345c5736c8054f22)(auser, size) : null}
      <span class="Truncate${text ? "" : " sr-only"}">
        <span class="Truncate-text" style="max-width: 140px;"
          >${user.user_login}</span
        >${organization ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Truncate-text" style="max-width: 140px;"
                >(${user.organization_login}</span
              >)` : ""}
      </span>
    </summary>
    <details-menu
      src="/api/organizations/${user.organization_id}/members/${user.user_id}?${params}"
      preload
      class="Popover lh-default ${popoverDirection === "left" ? "right-sm-0" : "left-sm-0"}${text ? "" : popoverDirection === "left" ? " mr-sm-n2" : " ml-sm-n2"}"
      style="top: 100%"
    >
      <div
        class="Popover-message Popover-message--large Popover-message--${popoverDirection === "left" ? "top-right" : "top-left"} p-3 mt-sm-2 Box color-shadow-large d-flex gap-2"
      >
        <include-fragment>
          <div class="py-3 d-flex flex-justify-center">
            <div class="spinner-border f1 color-fg-muted"></div>
          </div>
        </include-fragment>
      </div>
    </details-menu>
  </details>`;
}


function $99a756c897582e70$export$4d926e2ce7d3c83d(status, classes = "") {
    return (0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $0dc330fba39b622a$export$60edd6b2fdd9764b)[status], `color-fg-${(0, $0dc330fba39b622a$export$6a8ec8f89e2ebfdf)[status]} ${classes}`);
}
function $99a756c897582e70$export$76dce95b982175c(status, locale) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a
    class="State State--small ${(0, $0dc330fba39b622a$export$b59e5e84dadfd247)[status]} d-flex flex-items-center gap-1"
    href="#activity-status-field"
    id="activity-status-label"
    activity-behavior="edit-details"
    >${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $0dc330fba39b622a$export$60edd6b2fdd9764b)[status], "f5")}
    ${(0, $0dc330fba39b622a$export$db8da96cb205ed52)[status][locale]}</a
  >`;
}
function $99a756c897582e70$export$d7f64797de8530af({ locale: locale, organization_login: organization_login, status: status, visibleProperties: visibleProperties, answeredProperties: answeredProperties, parentActivity: parentActivity }) {
    const labelClass = "Label Label--large d-flex flex-items-center gap-1";
    const labels = [
        $99a756c897582e70$export$76dce95b982175c(status, locale)
    ];
    if (visibleProperties > 0) labels.push((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
        class="${labelClass} text-lowercase"
        id="activity-progress-label"
        >${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $9dad25ba7a5dc18c$export$3194dcd7e2b21417)(answeredProperties / visibleProperties), "f5 color-fg-accent")}
        ${answeredProperties} of ${visibleProperties}
        ${(0, $2868cc1235412e16$export$989066564c2ca33b)[locale]}</span
      >`);
    if (parentActivity) labels.push((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a
        class="${labelClass} Link--primary"
        id="activity-parent-label"
        href="${$99a756c897582e70$export$620192cfafae60b2(parentActivity, organization_login)}"
        >${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$eebcc95f857de077), "color-fg-accent")}<span
          class="Truncate"
          style="max-width: 12rem"
          ><span class="Truncate-text"
            >${parentActivity.title || parentActivity.definition_title}</span
          ></span
        ></a
      >`);
    return labels;
}
function $99a756c897582e70$export$50a410d93c2a929d(locale, organization_login, today, activity, isReadOnly, modalButton = true, displayPerson = false, compact = true, href) {
    const button = modalButton ? $99a756c897582e70$export$80f9f4cade29226f(locale, organization_login, activity.subject_person_id, activity.activity_id, isReadOnly) : "";
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
    <li class="Box-row d-flex gap-2 flex-items-center">
      ${$99a756c897582e70$export$866e1de5a920f777(locale, organization_login, today, activity, compact, displayPerson, undefined, href)}
      ${button}
    </li>
  `;
}
function $99a756c897582e70$export$866e1de5a920f777(locale, organization_login, today, activity, compact, displayPerson = false, propertyValues, href = $99a756c897582e70$export$620192cfafae60b2(activity, organization_login)) {
    const readyInProgressOnHold = [
        "ready",
        "in-progress",
        "on-hold"
    ].includes(activity.status);
    const statusTitle = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="text-bold color-fg-default"
    >${(0, $0dc330fba39b622a$export$db8da96cb205ed52)[activity.status][locale]}</span
  >`;
    const title = activity.title.length ? `${activity.title} - ${activity.definition_title}` : activity.definition_title;
    let dateInfo;
    if ((0, $0dc330fba39b622a$export$431862b62533b4ed)(activity.type) && (activity.flags & (0, $0dc330fba39b622a$export$91d5aadb43f971b9).HasDueDate) > 0 && readyInProgressOnHold) {
        const due_date = new Date(activity.due_date);
        let dueDateStatusColor = "color-fg-muted";
        if (readyInProgressOnHold && due_date <= today) dueDateStatusColor = "color-fg-severe";
        else if (readyInProgressOnHold && due_date <= (0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, 2)) dueDateStatusColor = "color-fg-attention";
        dateInfo = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="${dueDateStatusColor}"
      >${(0, $2868cc1235412e16$export$8a23b76271eff460)[locale]((0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(new Date(activity.due_date)))}</span
    >`;
    } else dateInfo = activity.start_date === activity.end_date ? (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(new Date(activity.start_date)) : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${(0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(new Date(activity.start_date))} -
          ${activity.end_date ? (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(new Date(activity.end_date)) : (0, $2868cc1235412e16$export$8227558ec81276c)[locale]}`;
    let assignee;
    if (activity.assignee_user_id) assignee = (0, $2868cc1235412e16$export$16256a8f0e357bc4)[locale](compact ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a
            href="/users/${activity.assignee_user_login}"
            class="Link--secondary text-bold"
            >${activity.assignee_user_login}
            (${activity.assignee_organization_login})</a
          >` : (0, $0f10b3ed48c1ca5b$export$c5bed7b44bfbfae7)((0, $7787380576b51463$export$6d3fb84f784b8446)(activity), {
        organization: true,
        project_id: activity.project_id,
        popoverDirection: "left"
    }));
    else assignee = (0, $2868cc1235412e16$export$16256a8f0e357bc4)[locale]((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="text-bold"
        >${activity.assignee_organization_login}</span
      >`);
    const person = displayPerson && activity.subject_person_id ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="${compact ? "f6" : ""}"
          ><a
            class="Link--secondary text-bold"
            href="/${organization_login}/people/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(activity.subject_person_id)}"
            >${activity.subject_person_name}</a
          >
          ${activity.subject_person_primary_physical?.replace(/^(, )+/g, "").replaceAll(", , ", ", ").replaceAll("  ", " ").trim()}</span
        >` : null;
    const address = (0, $0dc330fba39b622a$export$36a3ba8a8d60841d)(activity.type) && activity.primary_physical ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="${compact ? "f6" : ""}"
          >${activity.primary_physical.replace(/^(, )+/g, "").replaceAll(", , ", ", ").replaceAll("  ", " ").trim()}</span
        >` : null;
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
    ${$99a756c897582e70$export$4d926e2ce7d3c83d(activity.status, `f4 align-self-start${compact ? "" : " mt-1"}`)}
    <span class="flex-1 d-flex flex-column gap-1 color-fg-muted">
      <span class="${compact ? "h5" : "h4"}">
        <a class="Link--primary" href="${href}"
          >${title} | ${activity.project_login}</a
        >
        <span class="Label color-fg-default"
          >${(0, $0dc330fba39b622a$export$eeeefc19bf3b1d71)(locale, activity.type)}</span
        >
      </span>
      ${person}${address}
      <span class="${compact ? "f6" : ""}">
        ${statusTitle} · ${dateInfo} · ${assignee}
      </span>
      ${!compact && (activity.comment_count || activity.attachment_count) ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="f6">
            ${activity.comment_count ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${activity.comment_count === 1 ? (0, $2868cc1235412e16$export$e0f8ffeffb71452)[locale] : (0, $2868cc1235412e16$export$abf4bfeea8a809b3)[locale](activity.comment_count)}` : null}
            ${activity.comment_count && activity.attachment_count ? "-" : null}
            ${activity.attachment_count ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${activity.attachment_count === 1 ? (0, $2868cc1235412e16$export$234c584cd96079ce)[locale] : (0, $2868cc1235412e16$export$dd7aa9dbdc015ba1)[locale](activity.attachment_count)}` : null}
          </span>` : null}
      ${propertyValues ? $99a756c897582e70$var$activityListItemBodyPreviewPropertiesTemplate(propertyValues) : null}
    </span>
  `;
}
function $99a756c897582e70$var$activityListItemBodyPreviewPropertiesTemplate(propertyValues) {
    return propertyValues.length ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<table class="PropertyTable color-fg-default">
        <tbody>
          ${propertyValues.map((x)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<tr
                class="DefinitionList-row ${x.value === "Unanswered" ? "color-fg-muted" : ""}"
              >
                <th scope="row" class="DefinitionList-term">${x.label}</th>
                <td class="DefinitionList-definition">${x.value}</td>
              </tr>`)}
        </tbody>
      </table>` : null;
}
function $99a756c897582e70$export$620192cfafae60b2(activity, organization_login) {
    return activity.subject_person_id ? `/${organization_login}/people/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(activity.subject_person_id)}/activities/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(activity.activity_id)}` : `/${organization_login}/activities/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(activity.activity_id)}`;
}
function $99a756c897582e70$export$c6a9dbb9b354dbf9({ locale: locale, organization_login: organization_login, person_id: person_id, associated_activity_id: associated_activity_id, activityDefinition: activityDefinition, recommendation: recommendation = false, elementIndex: elementIndex, requiresSubmit: requiresSubmit }) {
    const src = (0, $0dc330fba39b622a$export$80ddb1e8ba36c18f)({
        organization_login: organization_login,
        activityDefinition: activityDefinition,
        person_id: person_id,
        associated_activity_id: associated_activity_id,
        recommendation: recommendation,
        params: new URLSearchParams({
            modal: "true",
            "element-index": elementIndex.toString()
        })
    });
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<modal-controller
    src="${src}"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-targets", associated_activity_id === "__ACTIVITY_ID__" ? "activity-controller.needsActivityId" : null)}
  >
    <button
      class="btn btn-outline"
      type="button"
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("data-requires-submit", requiresSubmit)}
    >
      <span>${(0, $2868cc1235412e16$export$baff25308003b0cc)[locale]}</span>
    </button>
    <template slot="template"><include-fragment></include-fragment></template>
  </modal-controller>`;
}
function $99a756c897582e70$export$80f9f4cade29226f(locale, organization_login, person_id, activity_id, isReadOnly, classes = "") {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<modal-controller
    src="/${organization_login}/people/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(person_id)}/activities/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(activity_id)}?modal=true"
  >
    <button class="btn btn-sm ${classes}" type="button">
      ${isReadOnly ? (0, $2868cc1235412e16$export$7452b9f476cd7d5e)[locale] : (0, $2868cc1235412e16$export$dad4342a62c89f83)[locale]}
    </button>
    <template slot="template">
      <include-fragment></include-fragment>
    </template>
  </modal-controller>`;
}
function $99a756c897582e70$export$385c659e35a543c6(locale, name, required, label, value) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("class", value ? null : "text-italic color-fg-muted")}
      >${value?.title ?? (0, $2868cc1235412e16$export$13ddb5340ae7eaf3)[locale]}</span
    ><input
      id="${name}"
      class="sr-only"
      type="text"
      name="${name}"
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
      aria-label="${label}"
      value="${value?.activity_id}"
      activity_start_date="${value?.start_date}"
      activity_end_date="${value?.end_date}"
      data-target="activity-select.input"
      data-action="focus:activity-select#inputFocused"
    />`;
}

var $91beb2998e956c83$export$3988ae62b71be9a3;
var $91beb2998e956c83$export$adaa4cf7ef1b65be;
var $91beb2998e956c83$export$ef7acd7185315e22;
var $91beb2998e956c83$var$hasExcape = /~/;
var $91beb2998e956c83$var$escapeMatcher = /~[01]/g;
function $91beb2998e956c83$var$escapeReplacer(m) {
    switch(m){
        case "~1":
            return "/";
        case "~0":
            return "~";
    }
    throw new Error("Invalid tilde escape: " + m);
}
function $91beb2998e956c83$var$untilde(str) {
    if (!$91beb2998e956c83$var$hasExcape.test(str)) return str;
    return str.replace($91beb2998e956c83$var$escapeMatcher, $91beb2998e956c83$var$escapeReplacer);
}
function $91beb2998e956c83$var$setter(obj, pointer, value) {
    var part;
    var hasNextPart;
    for(var p = 1, len = pointer.length; p < len;){
        if (pointer[p] === "constructor" || pointer[p] === "prototype" || pointer[p] === "__proto__") return obj;
        part = $91beb2998e956c83$var$untilde(pointer[p++]);
        hasNextPart = len > p;
        if (typeof obj[part] === "undefined") {
            // support setting of /-
            if (Array.isArray(obj) && part === "-") part = obj.length;
            // support nested objects/array when setting values
            if (hasNextPart) {
                if (pointer[p] !== "" && pointer[p] < Infinity || pointer[p] === "-") obj[part] = [];
                else obj[part] = {};
            }
        }
        if (!hasNextPart) break;
        obj = obj[part];
    }
    var oldValue = obj[part];
    if (value === undefined) delete obj[part];
    else obj[part] = value;
    return oldValue;
}
function $91beb2998e956c83$var$compilePointer(pointer) {
    if (typeof pointer === "string") {
        pointer = pointer.split("/");
        if (pointer[0] === "") return pointer;
        throw new Error("Invalid JSON pointer.");
    } else if (Array.isArray(pointer)) {
        for (const part of pointer){
            if (typeof part !== "string" && typeof part !== "number") throw new Error("Invalid JSON pointer. Must be of type string or number.");
        }
        return pointer;
    }
    throw new Error("Invalid JSON pointer.");
}
function $91beb2998e956c83$var$get(obj, pointer) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = $91beb2998e956c83$var$compilePointer(pointer);
    var len = pointer.length;
    if (len === 1) return obj;
    for(var p = 1; p < len;){
        obj = obj[$91beb2998e956c83$var$untilde(pointer[p++])];
        if (len === p) return obj;
        if (typeof obj !== "object" || obj === null) return undefined;
    }
}
function $91beb2998e956c83$var$set(obj, pointer, value) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = $91beb2998e956c83$var$compilePointer(pointer);
    if (pointer.length === 0) throw new Error("Invalid JSON pointer for set.");
    return $91beb2998e956c83$var$setter(obj, pointer, value);
}
function $91beb2998e956c83$var$compile(pointer) {
    var compiled = $91beb2998e956c83$var$compilePointer(pointer);
    return {
        get: function(object) {
            return $91beb2998e956c83$var$get(object, compiled);
        },
        set: function(object, value) {
            return $91beb2998e956c83$var$set(object, compiled, value);
        }
    };
}
$91beb2998e956c83$export$3988ae62b71be9a3 = $91beb2998e956c83$var$get;
$91beb2998e956c83$export$adaa4cf7ef1b65be = $91beb2998e956c83$var$set;
$91beb2998e956c83$export$ef7acd7185315e22 = $91beb2998e956c83$var$compile;



function $01be4901a49decd2$export$f99d9bd271f9a30e(a, b) {
    const typeofa = typeof a;
    if (typeofa !== typeof b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        const length = a.length;
        if (length !== b.length) return false;
        for(let i = 0; i < length; i++){
            if (!$01be4901a49decd2$export$f99d9bd271f9a30e(a[i], b[i])) return false;
        }
        return true;
    }
    if (typeofa === "object") {
        if (!a || !b) return a === b;
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        const length = aKeys.length;
        if (length !== bKeys.length) return false;
        for (const k of aKeys){
            if (!$01be4901a49decd2$export$f99d9bd271f9a30e(a[k], b[k])) return false;
        }
        return true;
    }
    return a === b;
}


function $15c3a9d0e0e44af6$export$cf01591f74e45a26(p) {
    return encodeURI($15c3a9d0e0e44af6$export$f892d8cbc7e1927d(p));
}
function $15c3a9d0e0e44af6$export$f892d8cbc7e1927d(p) {
    return p.replace(/~/g, "~0").replace(/\//g, "~1");
}


const $628b461cfddf549f$export$cdd7a38695256453 = {
    additionalItems: true,
    unevaluatedItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    unevaluatedProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
const $628b461cfddf549f$export$2acd2b12eada2059 = {
    prefixItems: true,
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
const $628b461cfddf549f$export$e75e529205893455 = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependentSchemas: true
};
const $628b461cfddf549f$export$77628d62a5643601 = {
    id: true,
    $id: true,
    $ref: true,
    $schema: true,
    $anchor: true,
    $vocabulary: true,
    $comment: true,
    default: true,
    enum: true,
    const: true,
    required: true,
    type: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
let $628b461cfddf549f$export$f7916c58665fc533 = typeof self !== "undefined" && self.location && self.location.origin !== "null" ? new URL(self.location.origin + self.location.pathname + location.search) : new URL("https://github.com/cfworker");
function $628b461cfddf549f$export$113cba6086f872e2(schema, lookup = Object.create(null), baseURI = $628b461cfddf549f$export$f7916c58665fc533, basePointer = "") {
    if (schema && typeof schema === "object" && !Array.isArray(schema)) {
        const id = schema.$id || schema.id;
        if (id) {
            const url = new URL(id, baseURI.href);
            if (url.hash.length > 1) lookup[url.href] = schema;
            else {
                url.hash = "";
                if (basePointer === "") baseURI = url;
                else $628b461cfddf549f$export$113cba6086f872e2(schema, lookup, baseURI);
            }
        }
    } else if (schema !== true && schema !== false) return lookup;
    const schemaURI = baseURI.href + (basePointer ? "#" + basePointer : "");
    if (lookup[schemaURI] !== undefined) throw new Error(`Duplicate schema URI "${schemaURI}".`);
    lookup[schemaURI] = schema;
    if (schema === true || schema === false) return lookup;
    if (schema.__absolute_uri__ === undefined) Object.defineProperty(schema, "__absolute_uri__", {
        enumerable: false,
        value: schemaURI
    });
    if (schema.$ref && schema.__absolute_ref__ === undefined) {
        const url = new URL(schema.$ref, baseURI.href);
        url.hash = url.hash;
        Object.defineProperty(schema, "__absolute_ref__", {
            enumerable: false,
            value: url.href
        });
    }
    if (schema.$recursiveRef && schema.__absolute_recursive_ref__ === undefined) {
        const url = new URL(schema.$recursiveRef, baseURI.href);
        url.hash = url.hash;
        Object.defineProperty(schema, "__absolute_recursive_ref__", {
            enumerable: false,
            value: url.href
        });
    }
    if (schema.$anchor) {
        const url = new URL("#" + schema.$anchor, baseURI.href);
        lookup[url.href] = schema;
    }
    for(let key in schema){
        if ($628b461cfddf549f$export$77628d62a5643601[key]) continue;
        const keyBase = `${basePointer}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
        const subSchema = schema[key];
        if (Array.isArray(subSchema)) {
            if ($628b461cfddf549f$export$2acd2b12eada2059[key]) {
                const length = subSchema.length;
                for(let i = 0; i < length; i++)$628b461cfddf549f$export$113cba6086f872e2(subSchema[i], lookup, baseURI, `${keyBase}/${i}`);
            }
        } else if ($628b461cfddf549f$export$e75e529205893455[key]) for(let subKey in subSchema)$628b461cfddf549f$export$113cba6086f872e2(subSchema[subKey], lookup, baseURI, `${keyBase}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(subKey)}`);
        else $628b461cfddf549f$export$113cba6086f872e2(subSchema, lookup, baseURI, keyBase);
    }
    return lookup;
}


const $1ecce3c2faf95ef0$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const $1ecce3c2faf95ef0$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $1ecce3c2faf95ef0$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
const $1ecce3c2faf95ef0$var$HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
const $1ecce3c2faf95ef0$var$URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
const $1ecce3c2faf95ef0$var$URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
const $1ecce3c2faf95ef0$var$URL_ = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
const $1ecce3c2faf95ef0$var$UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const $1ecce3c2faf95ef0$var$JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
const $1ecce3c2faf95ef0$var$JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
const $1ecce3c2faf95ef0$var$RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
const $1ecce3c2faf95ef0$var$EMAIL = (input)=>{
    if (input[0] === '"') return false;
    const [name, host, ...rest] = input.split("@");
    if (!name || !host || rest.length !== 0 || name.length > 64 || host.length > 253) return false;
    if (name[0] === "." || name.endsWith(".") || name.includes("..")) return false;
    if (!/^[a-z0-9.-]+$/i.test(host) || !/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(name)) return false;
    return host.split(".").every((part)=>/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i.test(part));
};
const $1ecce3c2faf95ef0$var$IPV4 = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
const $1ecce3c2faf95ef0$var$IPV6 = /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i;
const $1ecce3c2faf95ef0$var$DURATION = (input)=>input.length > 1 && input.length < 80 && (/^P\d+([.,]\d+)?W$/.test(input) || /^P[\dYMDTHS]*(\d[.,]\d+)?[YMDHS]$/.test(input) && /^P([.,\d]+Y)?([.,\d]+M)?([.,\d]+D)?(T([.,\d]+H)?([.,\d]+M)?([.,\d]+S)?)?$/.test(input));
function $1ecce3c2faf95ef0$var$bind(r) {
    return r.test.bind(r);
}
const $1ecce3c2faf95ef0$export$d9468344d3651243 = {
    date: $1ecce3c2faf95ef0$var$date,
    time: $1ecce3c2faf95ef0$var$time.bind(undefined, false),
    "date-time": $1ecce3c2faf95ef0$var$date_time,
    duration: $1ecce3c2faf95ef0$var$DURATION,
    uri: $1ecce3c2faf95ef0$var$uri,
    "uri-reference": $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$URIREF),
    "uri-template": $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$URITEMPLATE),
    url: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$URL_),
    email: $1ecce3c2faf95ef0$var$EMAIL,
    hostname: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$HOSTNAME),
    ipv4: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$IPV4),
    ipv6: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$IPV6),
    regex: $1ecce3c2faf95ef0$var$regex,
    uuid: $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$UUID),
    "json-pointer": $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$JSON_POINTER),
    "json-pointer-uri-fragment": $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$JSON_POINTER_URI_FRAGMENT),
    "relative-json-pointer": $1ecce3c2faf95ef0$var$bind($1ecce3c2faf95ef0$var$RELATIVE_JSON_POINTER)
};
function $1ecce3c2faf95ef0$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $1ecce3c2faf95ef0$var$date(str) {
    const matches = str.match($1ecce3c2faf95ef0$var$DATE);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && $1ecce3c2faf95ef0$var$isLeapYear(year) ? 29 : $1ecce3c2faf95ef0$var$DAYS[month]);
}
function $1ecce3c2faf95ef0$var$time(full, str) {
    const matches = str.match($1ecce3c2faf95ef0$var$TIME);
    if (!matches) return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = !!matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
const $1ecce3c2faf95ef0$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $1ecce3c2faf95ef0$var$date_time(str) {
    const dateTime = str.split($1ecce3c2faf95ef0$var$DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && $1ecce3c2faf95ef0$var$date(dateTime[0]) && $1ecce3c2faf95ef0$var$time(true, dateTime[1]);
}
const $1ecce3c2faf95ef0$var$NOT_URI_FRAGMENT = /\/|:/;
const $1ecce3c2faf95ef0$var$URI_PATTERN = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function $1ecce3c2faf95ef0$var$uri(str) {
    return $1ecce3c2faf95ef0$var$NOT_URI_FRAGMENT.test(str) && $1ecce3c2faf95ef0$var$URI_PATTERN.test(str);
}
const $1ecce3c2faf95ef0$var$Z_ANCHOR = /[^\\]\\Z/;
function $1ecce3c2faf95ef0$var$regex(str) {
    if ($1ecce3c2faf95ef0$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str, "u");
        return true;
    } catch (e) {
        return false;
    }
}



var $c94ca92c9426a796$export$ed6df354c75a09e0;
(function(OutputFormat) {
    OutputFormat[OutputFormat["Flag"] = 1] = "Flag";
    OutputFormat[OutputFormat["Basic"] = 2] = "Basic";
    OutputFormat[OutputFormat["Detailed"] = 4] = "Detailed";
})($c94ca92c9426a796$export$ed6df354c75a09e0 || ($c94ca92c9426a796$export$ed6df354c75a09e0 = {}));


function $7121b206e03ba7d7$export$e383d1c74f4e3b67(s) {
    let result = 0;
    let length = s.length;
    let index = 0;
    let charCode;
    while(index < length){
        result++;
        charCode = s.charCodeAt(index++);
        if (charCode >= 0xd800 && charCode <= 0xdbff && index < length) {
            charCode = s.charCodeAt(index);
            if ((charCode & 0xfc00) == 0xdc00) index++;
        }
    }
    return result;
}







function $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, schema, draft = "2019-09", lookup = (0, $628b461cfddf549f$export$113cba6086f872e2)(schema), shortCircuit = true, recursiveAnchor = null, instanceLocation = "#", schemaLocation = "#", evaluated = Object.create(null)) {
    if (schema === true) return {
        valid: true,
        errors: []
    };
    if (schema === false) return {
        valid: false,
        errors: [
            {
                instanceLocation: instanceLocation,
                keyword: "false",
                keywordLocation: instanceLocation,
                error: "False boolean schema."
            }
        ]
    };
    const rawInstanceType = typeof instance;
    let instanceType;
    switch(rawInstanceType){
        case "boolean":
        case "number":
        case "string":
            instanceType = rawInstanceType;
            break;
        case "object":
            if (instance === null) instanceType = "null";
            else if (Array.isArray(instance)) instanceType = "array";
            else instanceType = "object";
            break;
        default:
            throw new Error(`Instances of "${rawInstanceType}" type are not supported.`);
    }
    const { $ref: $ref, $recursiveRef: $recursiveRef, $recursiveAnchor: $recursiveAnchor, type: $type, const: $const, enum: $enum, required: $required, not: $not, anyOf: $anyOf, allOf: $allOf, oneOf: $oneOf, if: $if, then: $then, else: $else, format: $format, properties: $properties, patternProperties: $patternProperties, additionalProperties: $additionalProperties, unevaluatedProperties: $unevaluatedProperties, minProperties: $minProperties, maxProperties: $maxProperties, propertyNames: $propertyNames, dependentRequired: $dependentRequired, dependentSchemas: $dependentSchemas, dependencies: $dependencies, prefixItems: $prefixItems, items: $items, additionalItems: $additionalItems, unevaluatedItems: $unevaluatedItems, contains: $contains, minContains: $minContains, maxContains: $maxContains, minItems: $minItems, maxItems: $maxItems, uniqueItems: $uniqueItems, minimum: $minimum, maximum: $maximum, exclusiveMinimum: $exclusiveMinimum, exclusiveMaximum: $exclusiveMaximum, multipleOf: $multipleOf, minLength: $minLength, maxLength: $maxLength, pattern: $pattern, __absolute_ref__: __absolute_ref__, __absolute_recursive_ref__: __absolute_recursive_ref__ } = schema;
    const errors = [];
    if ($recursiveAnchor === true && recursiveAnchor === null) recursiveAnchor = schema;
    if ($recursiveRef === "#") {
        const refSchema = recursiveAnchor === null ? lookup[__absolute_recursive_ref__] : recursiveAnchor;
        const keywordLocation = `${schemaLocation}/$recursiveRef`;
        const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, recursiveAnchor === null ? schema : recursiveAnchor, draft, lookup, shortCircuit, refSchema, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: "$recursiveRef",
            keywordLocation: keywordLocation,
            error: "A subschema had errors."
        }, ...result.errors);
    }
    if ($ref !== undefined) {
        const uri = __absolute_ref__ || $ref;
        const refSchema = lookup[uri];
        if (refSchema === undefined) {
            let message = `Unresolved $ref "${$ref}".`;
            if (__absolute_ref__ && __absolute_ref__ !== $ref) message += `  Absolute URI "${__absolute_ref__}".`;
            message += `\nKnown schemas:\n- ${Object.keys(lookup).join("\n- ")}`;
            throw new Error(message);
        }
        const keywordLocation = `${schemaLocation}/$ref`;
        const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, refSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: "$ref",
            keywordLocation: keywordLocation,
            error: "A subschema had errors."
        }, ...result.errors);
        if (draft === "4" || draft === "7") return {
            valid: errors.length === 0,
            errors: errors
        };
    }
    if (Array.isArray($type)) {
        let length = $type.length;
        let valid = false;
        for(let i = 0; i < length; i++)if (instanceType === $type[i] || $type[i] === "integer" && instanceType === "number" && instance % 1 === 0 && instance === instance) {
            valid = true;
            break;
        }
        if (!valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: "type",
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type.join('", "')}".`
        });
    } else if ($type === "integer") {
        if (instanceType !== "number" || instance % 1 || instance !== instance) errors.push({
            instanceLocation: instanceLocation,
            keyword: "type",
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
        });
    } else if ($type !== undefined && instanceType !== $type) errors.push({
        instanceLocation: instanceLocation,
        keyword: "type",
        keywordLocation: `${schemaLocation}/type`,
        error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
    });
    if ($const !== undefined) {
        if (instanceType === "object" || instanceType === "array") {
            if (!(0, $01be4901a49decd2$export$f99d9bd271f9a30e)(instance, $const)) errors.push({
                instanceLocation: instanceLocation,
                keyword: "const",
                keywordLocation: `${schemaLocation}/const`,
                error: `Instance does not match ${JSON.stringify($const)}.`
            });
        } else if (instance !== $const) errors.push({
            instanceLocation: instanceLocation,
            keyword: "const",
            keywordLocation: `${schemaLocation}/const`,
            error: `Instance does not match ${JSON.stringify($const)}.`
        });
    }
    if ($enum !== undefined) {
        if (instanceType === "object" || instanceType === "array") {
            if (!$enum.some((value)=>(0, $01be4901a49decd2$export$f99d9bd271f9a30e)(instance, value))) errors.push({
                instanceLocation: instanceLocation,
                keyword: "enum",
                keywordLocation: `${schemaLocation}/enum`,
                error: `Instance does not match any of ${JSON.stringify($enum)}.`
            });
        } else if (!$enum.some((value)=>instance === value)) errors.push({
            instanceLocation: instanceLocation,
            keyword: "enum",
            keywordLocation: `${schemaLocation}/enum`,
            error: `Instance does not match any of ${JSON.stringify($enum)}.`
        });
    }
    if ($not !== undefined) {
        const keywordLocation = `${schemaLocation}/not`;
        const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $not, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation);
        if (result.valid) errors.push({
            instanceLocation: instanceLocation,
            keyword: "not",
            keywordLocation: keywordLocation,
            error: 'Instance matched "not" schema.'
        });
    }
    let subEvaluateds = [];
    if ($anyOf !== undefined) {
        const keywordLocation = `${schemaLocation}/anyOf`;
        const errorsLength = errors.length;
        let anyValid = false;
        for(let i = 0; i < $anyOf.length; i++){
            const subSchema = $anyOf[i];
            const subEvaluated = Object.create(evaluated);
            const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            anyValid = anyValid || result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (anyValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation: instanceLocation,
            keyword: "anyOf",
            keywordLocation: keywordLocation,
            error: "Instance does not match any subschemas."
        });
    }
    if ($allOf !== undefined) {
        const keywordLocation = `${schemaLocation}/allOf`;
        const errorsLength = errors.length;
        let allValid = true;
        for(let i = 0; i < $allOf.length; i++){
            const subSchema = $allOf[i];
            const subEvaluated = Object.create(evaluated);
            const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            allValid = allValid && result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (allValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation: instanceLocation,
            keyword: "allOf",
            keywordLocation: keywordLocation,
            error: `Instance does not match every subschema.`
        });
    }
    if ($oneOf !== undefined) {
        const keywordLocation = `${schemaLocation}/oneOf`;
        const errorsLength = errors.length;
        const matches = $oneOf.filter((subSchema, i)=>{
            const subEvaluated = Object.create(evaluated);
            const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            if (result.valid) subEvaluateds.push(subEvaluated);
            return result.valid;
        }).length;
        if (matches === 1) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation: instanceLocation,
            keyword: "oneOf",
            keywordLocation: keywordLocation,
            error: `Instance does not match exactly one subschema (${matches} matches).`
        });
    }
    if (instanceType === "object" || instanceType === "array") Object.assign(evaluated, ...subEvaluateds);
    if ($if !== undefined) {
        const keywordLocation = `${schemaLocation}/if`;
        const conditionResult = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $if, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated).valid;
        if (conditionResult) {
            if ($then !== undefined) {
                const thenResult = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $then, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/then`, evaluated);
                if (!thenResult.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "if",
                    keywordLocation: keywordLocation,
                    error: `Instance does not match "then" schema.`
                }, ...thenResult.errors);
            }
        } else if ($else !== undefined) {
            const elseResult = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $else, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/else`, evaluated);
            if (!elseResult.valid) errors.push({
                instanceLocation: instanceLocation,
                keyword: "if",
                keywordLocation: keywordLocation,
                error: `Instance does not match "else" schema.`
            }, ...elseResult.errors);
        }
    }
    if (instanceType === "object") {
        if ($required !== undefined) {
            for (const key of $required)if (!(key in instance)) errors.push({
                instanceLocation: instanceLocation,
                keyword: "required",
                keywordLocation: `${schemaLocation}/required`,
                error: `Instance does not have required property "${key}".`
            });
        }
        const keys = Object.keys(instance);
        if ($minProperties !== undefined && keys.length < $minProperties) errors.push({
            instanceLocation: instanceLocation,
            keyword: "minProperties",
            keywordLocation: `${schemaLocation}/minProperties`,
            error: `Instance does not have at least ${$minProperties} properties.`
        });
        if ($maxProperties !== undefined && keys.length > $maxProperties) errors.push({
            instanceLocation: instanceLocation,
            keyword: "maxProperties",
            keywordLocation: `${schemaLocation}/maxProperties`,
            error: `Instance does not have at least ${$maxProperties} properties.`
        });
        if ($propertyNames !== undefined) {
            const keywordLocation = `${schemaLocation}/propertyNames`;
            for(const key in instance){
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(key, $propertyNames, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (!result.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "propertyNames",
                    keywordLocation: keywordLocation,
                    error: `Property name "${key}" does not match schema.`
                }, ...result.errors);
            }
        }
        if ($dependentRequired !== undefined) {
            const keywordLocation = `${schemaLocation}/dependantRequired`;
            for(const key in $dependentRequired)if (key in instance) {
                const required = $dependentRequired[key];
                for (const dependantKey of required)if (!(dependantKey in instance)) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "dependentRequired",
                    keywordLocation: keywordLocation,
                    error: `Instance has "${key}" but does not have "${dependantKey}".`
                });
            }
        }
        if ($dependentSchemas !== undefined) for(const key in $dependentSchemas){
            const keywordLocation = `${schemaLocation}/dependentSchemas`;
            if (key in instance) {
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, $dependentSchemas[key], draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`, evaluated);
                if (!result.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "dependentSchemas",
                    keywordLocation: keywordLocation,
                    error: `Instance has "${key}" but does not match dependant schema.`
                }, ...result.errors);
            }
        }
        if ($dependencies !== undefined) {
            const keywordLocation = `${schemaLocation}/dependencies`;
            for(const key in $dependencies)if (key in instance) {
                const propsOrSchema = $dependencies[key];
                if (Array.isArray(propsOrSchema)) {
                    for (const dependantKey of propsOrSchema)if (!(dependantKey in instance)) errors.push({
                        instanceLocation: instanceLocation,
                        keyword: "dependencies",
                        keywordLocation: keywordLocation,
                        error: `Instance has "${key}" but does not have "${dependantKey}".`
                    });
                } else {
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance, propsOrSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`);
                    if (!result.valid) errors.push({
                        instanceLocation: instanceLocation,
                        keyword: "dependencies",
                        keywordLocation: keywordLocation,
                        error: `Instance has "${key}" but does not match dependant schema.`
                    }, ...result.errors);
                }
            }
        }
        const thisEvaluated = Object.create(null);
        let stop = false;
        if ($properties !== undefined) {
            const keywordLocation = `${schemaLocation}/properties`;
            for(const key in $properties){
                if (!(key in instance)) continue;
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], $properties[key], draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`);
                if (result.valid) evaluated[key] = thisEvaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: "properties",
                        keywordLocation: keywordLocation,
                        error: `Property "${key}" does not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if (!stop && $patternProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/patternProperties`;
            for(const pattern in $patternProperties){
                const regex = new RegExp(pattern, "u");
                const subSchema = $patternProperties[pattern];
                for(const key in instance){
                    if (!regex.test(key)) continue;
                    const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], subSchema, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(pattern)}`);
                    if (result.valid) evaluated[key] = thisEvaluated[key] = true;
                    else {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation: instanceLocation,
                            keyword: "patternProperties",
                            keywordLocation: keywordLocation,
                            error: `Property "${key}" matches pattern "${pattern}" but does not match associated schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if (!stop && $additionalProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/additionalProperties`;
            for(const key in instance){
                if (thisEvaluated[key]) continue;
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], $additionalProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: "additionalProperties",
                        keywordLocation: keywordLocation,
                        error: `Property "${key}" does not match additional properties schema.`
                    }, ...result.errors);
                }
            }
        } else if (!stop && $unevaluatedProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedProperties`;
            for(const key in instance)if (!evaluated[key]) {
                const subInstancePointer = `${instanceLocation}/${(0, $15c3a9d0e0e44af6$export$cf01591f74e45a26)(key)}`;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[key], $unevaluatedProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "unevaluatedProperties",
                    keywordLocation: keywordLocation,
                    error: `Property "${key}" does not match unevaluated properties schema.`
                }, ...result.errors);
            }
        }
    } else if (instanceType === "array") {
        if ($maxItems !== undefined && instance.length > $maxItems) errors.push({
            instanceLocation: instanceLocation,
            keyword: "maxItems",
            keywordLocation: `${schemaLocation}/maxItems`,
            error: `Array has too many items (${instance.length} > ${$maxItems}).`
        });
        if ($minItems !== undefined && instance.length < $minItems) errors.push({
            instanceLocation: instanceLocation,
            keyword: "minItems",
            keywordLocation: `${schemaLocation}/minItems`,
            error: `Array has too few items (${instance.length} < ${$minItems}).`
        });
        const length = instance.length;
        let i = 0;
        let stop = false;
        if ($prefixItems !== undefined) {
            const keywordLocation = `${schemaLocation}/prefixItems`;
            const length2 = Math.min($prefixItems.length, length);
            for(; i < length2; i++){
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $prefixItems[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: "prefixItems",
                        keywordLocation: keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if ($items !== undefined) {
            const keywordLocation = `${schemaLocation}/items`;
            if (Array.isArray($items)) {
                const length2 = Math.min($items.length, length);
                for(; i < length2; i++){
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $items[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation: instanceLocation,
                            keyword: "items",
                            keywordLocation: keywordLocation,
                            error: `Items did not match schema.`
                        }, ...result.errors);
                        if (stop) break;
                    }
                }
            } else for(; i < length; i++){
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $items, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: "items",
                        keywordLocation: keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
            if (!stop && $additionalItems !== undefined) {
                const keywordLocation = `${schemaLocation}/additionalItems`;
                for(; i < length; i++){
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $additionalItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation: instanceLocation,
                            keyword: "additionalItems",
                            keywordLocation: keywordLocation,
                            error: `Items did not match additional items schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if ($contains !== undefined) {
            if (length === 0 && $minContains === undefined) errors.push({
                instanceLocation: instanceLocation,
                keyword: "contains",
                keywordLocation: `${schemaLocation}/contains`,
                error: `Array is empty. It must contain at least one item matching the schema.`
            });
            else if ($minContains !== undefined && length < $minContains) errors.push({
                instanceLocation: instanceLocation,
                keyword: "minContains",
                keywordLocation: `${schemaLocation}/minContains`,
                error: `Array has less items (${length}) than minContains (${$minContains}).`
            });
            else {
                const keywordLocation = `${schemaLocation}/contains`;
                const errorsLength = errors.length;
                let contained = 0;
                for(let j = 0; j < length; j++){
                    const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[j], $contains, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${j}`, keywordLocation);
                    if (result.valid) {
                        evaluated[j] = true;
                        contained++;
                    } else errors.push(...result.errors);
                }
                if (contained >= ($minContains || 0)) errors.length = errorsLength;
                if ($minContains === undefined && $maxContains === undefined && contained === 0) errors.splice(errorsLength, 0, {
                    instanceLocation: instanceLocation,
                    keyword: "contains",
                    keywordLocation: keywordLocation,
                    error: `Array does not contain item matching schema.`
                });
                else if ($minContains !== undefined && contained < $minContains) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "minContains",
                    keywordLocation: `${schemaLocation}/minContains`,
                    error: `Array must contain at least ${$minContains} items matching schema. Only ${contained} items were found.`
                });
                else if ($maxContains !== undefined && contained > $maxContains) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "maxContains",
                    keywordLocation: `${schemaLocation}/maxContains`,
                    error: `Array may contain at most ${$maxContains} items matching schema. ${contained} items were found.`
                });
            }
        }
        if (!stop && $unevaluatedItems !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedItems`;
            for(i; i < length; i++){
                if (evaluated[i]) continue;
                const result = $629fab7fb0c19ec3$export$a22775fa5e2eebd9(instance[i], $unevaluatedItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) errors.push({
                    instanceLocation: instanceLocation,
                    keyword: "unevaluatedItems",
                    keywordLocation: keywordLocation,
                    error: `Items did not match unevaluated items schema.`
                }, ...result.errors);
            }
        }
        if ($uniqueItems) for(let j = 0; j < length; j++){
            const a = instance[j];
            const ao = typeof a === "object" && a !== null;
            for(let k = 0; k < length; k++){
                if (j === k) continue;
                const b = instance[k];
                const bo = typeof b === "object" && b !== null;
                if (a === b || ao && bo && (0, $01be4901a49decd2$export$f99d9bd271f9a30e)(a, b)) {
                    errors.push({
                        instanceLocation: instanceLocation,
                        keyword: "uniqueItems",
                        keywordLocation: `${schemaLocation}/uniqueItems`,
                        error: `Duplicate items at indexes ${j} and ${k}.`
                    });
                    j = Number.MAX_SAFE_INTEGER;
                    k = Number.MAX_SAFE_INTEGER;
                }
            }
        }
    } else if (instanceType === "number") {
        if (draft === "4") {
            if ($minimum !== undefined && ($exclusiveMinimum === true && instance <= $minimum || instance < $minimum)) errors.push({
                instanceLocation: instanceLocation,
                keyword: "minimum",
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$exclusiveMinimum ? "or equal to " : ""} ${$minimum}.`
            });
            if ($maximum !== undefined && ($exclusiveMaximum === true && instance >= $maximum || instance > $maximum)) errors.push({
                instanceLocation: instanceLocation,
                keyword: "maximum",
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$exclusiveMaximum ? "or equal to " : ""} ${$maximum}.`
            });
        } else {
            if ($minimum !== undefined && instance < $minimum) errors.push({
                instanceLocation: instanceLocation,
                keyword: "minimum",
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$minimum}.`
            });
            if ($maximum !== undefined && instance > $maximum) errors.push({
                instanceLocation: instanceLocation,
                keyword: "maximum",
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$maximum}.`
            });
            if ($exclusiveMinimum !== undefined && instance <= $exclusiveMinimum) errors.push({
                instanceLocation: instanceLocation,
                keyword: "exclusiveMinimum",
                keywordLocation: `${schemaLocation}/exclusiveMinimum`,
                error: `${instance} is less than ${$exclusiveMinimum}.`
            });
            if ($exclusiveMaximum !== undefined && instance >= $exclusiveMaximum) errors.push({
                instanceLocation: instanceLocation,
                keyword: "exclusiveMaximum",
                keywordLocation: `${schemaLocation}/exclusiveMaximum`,
                error: `${instance} is greater than or equal to ${$exclusiveMaximum}.`
            });
        }
        if ($multipleOf !== undefined) {
            const remainder = instance % $multipleOf;
            if (Math.abs(0 - remainder) >= 1.1920929e-7 && Math.abs($multipleOf - remainder) >= 1.1920929e-7) errors.push({
                instanceLocation: instanceLocation,
                keyword: "multipleOf",
                keywordLocation: `${schemaLocation}/multipleOf`,
                error: `${instance} is not a multiple of ${$multipleOf}.`
            });
        }
    } else if (instanceType === "string") {
        const length = $minLength === undefined && $maxLength === undefined ? 0 : (0, $7121b206e03ba7d7$export$e383d1c74f4e3b67)(instance);
        if ($minLength !== undefined && length < $minLength) errors.push({
            instanceLocation: instanceLocation,
            keyword: "minLength",
            keywordLocation: `${schemaLocation}/minLength`,
            error: `String is too short (${length} < ${$minLength}).`
        });
        if ($maxLength !== undefined && length > $maxLength) errors.push({
            instanceLocation: instanceLocation,
            keyword: "maxLength",
            keywordLocation: `${schemaLocation}/maxLength`,
            error: `String is too long (${length} > ${$maxLength}).`
        });
        if ($pattern !== undefined && !new RegExp($pattern, "u").test(instance)) errors.push({
            instanceLocation: instanceLocation,
            keyword: "pattern",
            keywordLocation: `${schemaLocation}/pattern`,
            error: `String does not match pattern.`
        });
        if ($format !== undefined && (0, $1ecce3c2faf95ef0$export$d9468344d3651243)[$format] && !(0, $1ecce3c2faf95ef0$export$d9468344d3651243)[$format](instance)) errors.push({
            instanceLocation: instanceLocation,
            keyword: "format",
            keywordLocation: `${schemaLocation}/format`,
            error: `String does not match format "${$format}".`
        });
    }
    return {
        valid: errors.length === 0,
        errors: errors
    };
}




class $2c33b4732df8d3ca$export$9eeb22c0bba4ed5e {
    schema;
    draft;
    shortCircuit;
    lookup;
    constructor(schema, draft = "2019-09", shortCircuit = true){
        this.schema = schema;
        this.draft = draft;
        this.shortCircuit = shortCircuit;
        this.lookup = (0, $628b461cfddf549f$export$113cba6086f872e2)(schema);
    }
    validate(instance) {
        return (0, $629fab7fb0c19ec3$export$a22775fa5e2eebd9)(instance, this.schema, this.draft, this.lookup, this.shortCircuit);
    }
    addSchema(schema, id) {
        if (id) schema = {
            ...schema,
            $id: id
        };
        (0, $628b461cfddf549f$export$113cba6086f872e2)(schema, this.lookup);
    }
}






/**
 * @implements {IHooks}
 */ class $cec7b3c0f35c015b$var$Hooks {
    /**
	 * @callback HookCallback
	 * @this {*|Jsep} this
	 * @param {Jsep} env
	 * @returns: void
	 */ /**
	 * Adds the given callback to the list of callbacks for the given hook.
	 *
	 * The callback will be invoked when the hook it is registered for is run.
	 *
	 * One callback function can be registered to multiple hooks and the same hook multiple times.
	 *
	 * @param {string|object} name The name of the hook, or an object of callbacks keyed by name
	 * @param {HookCallback|boolean} callback The callback function which is given environment variables.
	 * @param {?boolean} [first=false] Will add the hook to the top of the list (defaults to the bottom)
	 * @public
	 */ add(name, callback, first) {
        if (typeof arguments[0] != "string") // Multiple hook callbacks, keyed by name
        for(let name in arguments[0])this.add(name, arguments[0][name], arguments[1]);
        else (Array.isArray(name) ? name : [
            name
        ]).forEach(function(name) {
            this[name] = this[name] || [];
            if (callback) this[name][first ? "unshift" : "push"](callback);
        }, this);
    }
    /**
	 * Runs a hook invoking all registered callbacks with the given environment variables.
	 *
	 * Callbacks will be invoked synchronously and in the order in which they were registered.
	 *
	 * @param {string} name The name of the hook.
	 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
	 * @public
	 */ run(name, env) {
        this[name] = this[name] || [];
        this[name].forEach(function(callback) {
            callback.call(env && env.context ? env.context : env, env);
        });
    }
}
/**
 * @implements {IPlugins}
 */ class $cec7b3c0f35c015b$var$Plugins {
    constructor(jsep){
        this.jsep = jsep;
        this.registered = {};
    }
    /**
	 * @callback PluginSetup
	 * @this {Jsep} jsep
	 * @returns: void
	 */ /**
	 * Adds the given plugin(s) to the registry
	 *
	 * @param {object} plugins
	 * @param {string} plugins.name The name of the plugin
	 * @param {PluginSetup} plugins.init The init function
	 * @public
	 */ register(...plugins) {
        plugins.forEach((plugin)=>{
            if (typeof plugin !== "object" || !plugin.name || !plugin.init) throw new Error("Invalid JSEP plugin format");
            if (this.registered[plugin.name]) // already registered. Ignore.
            return;
            plugin.init(this.jsep);
            this.registered[plugin.name] = plugin;
        });
    }
}
//     JavaScript Expression Parser (JSEP) 1.4.0
class $cec7b3c0f35c015b$export$90f6e7cc0133c961 {
    /**
	 * @returns {string}
	 */ static get version() {
        // To be filled in by the template
        return "1.4.0";
    }
    /**
	 * @returns {string}
	 */ static toString() {
        return "JavaScript Expression Parser (JSEP) v" + $cec7b3c0f35c015b$export$90f6e7cc0133c961.version;
    }
    // ==================== CONFIG ================================
    /**
	 * @method addUnaryOp
	 * @param {string} op_name The name of the unary op to add
	 * @returns {Jsep}
	 */ static addUnaryOp(op_name) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = Math.max(op_name.length, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len);
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops[op_name] = 1;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method jsep.addBinaryOp
	 * @param {string} op_name The name of the binary op to add
	 * @param {number} precedence The precedence of the binary op (can be a float). Higher number = higher precedence
	 * @param {boolean} [isRightAssociative=false] whether operator is right-associative
	 * @returns {Jsep}
	 */ static addBinaryOp(op_name, precedence, isRightAssociative) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = Math.max(op_name.length, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len);
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[op_name] = precedence;
        if (isRightAssociative) $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.add(op_name);
        else $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.delete(op_name);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method addIdentifierChar
	 * @param {string} char The additional character to treat as a valid part of an identifier
	 * @returns {Jsep}
	 */ static addIdentifierChar(char) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.additional_identifier_chars.add(char);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method addLiteral
	 * @param {string} literal_name The name of the literal to add
	 * @param {*} literal_value The value of the literal
	 * @returns {Jsep}
	 */ static addLiteral(literal_name, literal_value) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals[literal_name] = literal_value;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeUnaryOp
	 * @param {string} op_name The name of the unary op to remove
	 * @returns {Jsep}
	 */ static removeUnaryOp(op_name) {
        delete $cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops[op_name];
        if (op_name.length === $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len) $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeAllUnaryOps
	 * @returns {Jsep}
	 */ static removeAllUnaryOps() {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops = {};
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = 0;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeIdentifierChar
	 * @param {string} char The additional character to stop treating as a valid part of an identifier
	 * @returns {Jsep}
	 */ static removeIdentifierChar(char) {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.additional_identifier_chars.delete(char);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeBinaryOp
	 * @param {string} op_name The name of the binary op to remove
	 * @returns {Jsep}
	 */ static removeBinaryOp(op_name) {
        delete $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[op_name];
        if (op_name.length === $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len) $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops);
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.delete(op_name);
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeAllBinaryOps
	 * @returns {Jsep}
	 */ static removeAllBinaryOps() {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops = {};
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = 0;
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeLiteral
	 * @param {string} literal_name The name of the literal to remove
	 * @returns {Jsep}
	 */ static removeLiteral(literal_name) {
        delete $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals[literal_name];
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    /**
	 * @method removeAllLiterals
	 * @returns {Jsep}
	 */ static removeAllLiterals() {
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals = {};
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961;
    }
    // ==================== END CONFIG ============================
    /**
	 * @returns {string}
	 */ get char() {
        return this.expr.charAt(this.index);
    }
    /**
	 * @returns {number}
	 */ get code() {
        return this.expr.charCodeAt(this.index);
    }
    /**
	 * @param {string} expr a string with the passed in express
	 * @returns Jsep
	 */ constructor(expr){
        // `index` stores the character number we are currently at
        // All of the gobbles below will modify `index` as we move along
        this.expr = expr;
        this.index = 0;
    }
    /**
	 * static top-level parser
	 * @returns {jsep.Expression}
	 */ static parse(expr) {
        return new $cec7b3c0f35c015b$export$90f6e7cc0133c961(expr).parse();
    }
    /**
	 * Get the longest key length of any object
	 * @param {object} obj
	 * @returns {number}
	 */ static getMaxKeyLen(obj) {
        return Math.max(0, ...Object.keys(obj).map((k)=>k.length));
    }
    /**
	 * `ch` is a character code in the next three functions
	 * @param {number} ch
	 * @returns {boolean}
	 */ static isDecimalDigit(ch) {
        return ch >= 48 && ch <= 57; // 0...9
    }
    /**
	 * Returns the precedence of a binary operator or `0` if it isn't a binary operator. Can be float.
	 * @param {string} op_val
	 * @returns {number}
	 */ static binaryPrecedence(op_val) {
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[op_val] || 0;
    }
    /**
	 * Looks for start of identifier
	 * @param {number} ch
	 * @returns {boolean}
	 */ static isIdentifierStart(ch) {
        return ch >= 65 && ch <= 90 || // A...Z
        ch >= 97 && ch <= 122 || // a...z
        ch >= 128 && !$cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops[String.fromCharCode(ch)] || // any non-ASCII that is not an operator
        $cec7b3c0f35c015b$export$90f6e7cc0133c961.additional_identifier_chars.has(String.fromCharCode(ch)); // additional characters
    }
    /**
	 * @param {number} ch
	 * @returns {boolean}
	 */ static isIdentifierPart(ch) {
        return $cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(ch) || $cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(ch);
    }
    /**
	 * throw error at index of the expression
	 * @param {string} message
	 * @throws
	 */ throwError(message) {
        const error = new Error(message + " at character " + this.index);
        error.index = this.index;
        error.description = message;
        throw error;
    }
    /**
	 * Run a given hook
	 * @param {string} name
	 * @param {jsep.Expression|false} [node]
	 * @returns {?jsep.Expression}
	 */ runHook(name, node) {
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks[name]) {
            const env = {
                context: this,
                node: node
            };
            $cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks.run(name, env);
            return env.node;
        }
        return node;
    }
    /**
	 * Runs a given hook until one returns a node
	 * @param {string} name
	 * @returns {?jsep.Expression}
	 */ searchHook(name) {
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks[name]) {
            const env = {
                context: this
            };
            $cec7b3c0f35c015b$export$90f6e7cc0133c961.hooks[name].find(function(callback) {
                callback.call(env.context, env);
                return env.node;
            });
            return env.node;
        }
    }
    /**
	 * Push `index` up to the next non-space character
	 */ gobbleSpaces() {
        let ch = this.code;
        // Whitespace
        while(ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.SPACE_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.TAB_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.LF_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CR_CODE)ch = this.expr.charCodeAt(++this.index);
        this.runHook("gobble-spaces");
    }
    /**
	 * Top-level method to parse all expressions and returns compound or single node
	 * @returns {jsep.Expression}
	 */ parse() {
        this.runHook("before-all");
        const nodes = this.gobbleExpressions();
        // If there's only one expression just try returning the expression
        const node = nodes.length === 1 ? nodes[0] : {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMPOUND,
            body: nodes
        };
        return this.runHook("after-all", node);
    }
    /**
	 * top-level parser (but can be reused within as well)
	 * @param {number} [untilICode]
	 * @returns {jsep.Expression[]}
	 */ gobbleExpressions(untilICode) {
        let nodes = [], ch_i, node;
        while(this.index < this.expr.length){
            ch_i = this.code;
            // Expressions can be separated by semicolons, commas, or just inferred without any
            // separators
            if (ch_i === $cec7b3c0f35c015b$export$90f6e7cc0133c961.SEMCOL_CODE || ch_i === $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMMA_CODE) this.index++; // ignore separators
            else {
                // Try to gobble each expression individually
                if (node = this.gobbleExpression()) nodes.push(node);
                else if (this.index < this.expr.length) {
                    if (ch_i === untilICode) break;
                    this.throwError('Unexpected "' + this.char + '"');
                }
            }
        }
        return nodes;
    }
    /**
	 * The main parsing function.
	 * @returns {?jsep.Expression}
	 */ gobbleExpression() {
        const node = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
        this.gobbleSpaces();
        return this.runHook("after-expression", node);
    }
    /**
	 * Search for the operation portion of the string (e.g. `+`, `===`)
	 * Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
	 * and move down from 3 to 2 to 1 character until a matching binary operation is found
	 * then, return that binary operation
	 * @returns {string|boolean}
	 */ gobbleBinaryOp() {
        this.gobbleSpaces();
        let to_check = this.expr.substr(this.index, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len);
        let tc_len = to_check.length;
        while(tc_len > 0){
            // Don't accept a binary op when it is an identifier.
            // Binary ops that start with a identifier-valid character must be followed
            // by a non identifier-part valid character
            if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops.hasOwnProperty(to_check) && (!$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
                this.index += tc_len;
                return to_check;
            }
            to_check = to_check.substr(0, --tc_len);
        }
        return false;
    }
    /**
	 * This function is responsible for gobbling an individual expression,
	 * e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
	 * @returns {?jsep.BinaryExpression}
	 */ gobbleBinaryExpression() {
        let node, biop, prec, stack, biop_info, left, right, i, cur_biop;
        // First, try to get the leftmost thing
        // Then, check to see if there's a binary operator operating on that leftmost thing
        // Don't gobbleBinaryOp without a left-hand-side
        left = this.gobbleToken();
        if (!left) return left;
        biop = this.gobbleBinaryOp();
        // If there wasn't a binary operator, just return the leftmost node
        if (!biop) return left;
        // Otherwise, we need to start a stack to properly place the binary operations in their
        // precedence structure
        biop_info = {
            value: biop,
            prec: $cec7b3c0f35c015b$export$90f6e7cc0133c961.binaryPrecedence(biop),
            right_a: $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.has(biop)
        };
        right = this.gobbleToken();
        if (!right) this.throwError("Expected expression after " + biop);
        stack = [
            left,
            biop_info,
            right
        ];
        // Properly deal with precedence using [recursive descent](http://www.engr.mun.ca/~theo/Misc/exp_parsing.htm)
        while(biop = this.gobbleBinaryOp()){
            prec = $cec7b3c0f35c015b$export$90f6e7cc0133c961.binaryPrecedence(biop);
            if (prec === 0) {
                this.index -= biop.length;
                break;
            }
            biop_info = {
                value: biop,
                prec: prec,
                right_a: $cec7b3c0f35c015b$export$90f6e7cc0133c961.right_associative.has(biop)
            };
            cur_biop = biop;
            // Reduce: make a binary expression from the three topmost entries.
            const comparePrev = (prev)=>biop_info.right_a && prev.right_a ? prec > prev.prec : prec <= prev.prec;
            while(stack.length > 2 && comparePrev(stack[stack.length - 2])){
                right = stack.pop();
                biop = stack.pop().value;
                left = stack.pop();
                node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.BINARY_EXP,
                    operator: biop,
                    left: left,
                    right: right
                };
                stack.push(node);
            }
            node = this.gobbleToken();
            if (!node) this.throwError("Expected expression after " + cur_biop);
            stack.push(biop_info, node);
        }
        i = stack.length - 1;
        node = stack[i];
        while(i > 1){
            node = {
                type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.BINARY_EXP,
                operator: stack[i - 1].value,
                left: stack[i - 2],
                right: node
            };
            i -= 2;
        }
        return node;
    }
    /**
	 * An individual part of a binary expression:
	 * e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
	 * @returns {boolean|jsep.Expression}
	 */ gobbleToken() {
        let ch, to_check, tc_len, node;
        this.gobbleSpaces();
        node = this.searchHook("gobble-token");
        if (node) return this.runHook("after-token", node);
        ch = this.code;
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(ch) || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) // Char code 46 is a dot `.` which can start off a numeric literal
        return this.gobbleNumericLiteral();
        if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.SQUOTE_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.DQUOTE_CODE) // Single or double quotes
        node = this.gobbleStringLiteral();
        else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OBRACK_CODE) node = this.gobbleArray();
        else {
            to_check = this.expr.substr(this.index, $cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len);
            tc_len = to_check.length;
            while(tc_len > 0){
                // Don't accept an unary op when it is an identifier.
                // Unary ops that start with a identifier-valid character must be followed
                // by a non identifier-part valid character
                if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops.hasOwnProperty(to_check) && (!$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !$cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
                    this.index += tc_len;
                    const argument = this.gobbleToken();
                    if (!argument) this.throwError("missing unaryOp argument");
                    return this.runHook("after-token", {
                        type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.UNARY_EXP,
                        operator: to_check,
                        argument: argument,
                        prefix: true
                    });
                }
                to_check = to_check.substr(0, --tc_len);
            }
            if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(ch)) {
                node = this.gobbleIdentifier();
                if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.literals.hasOwnProperty(node.name)) node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.LITERAL,
                    value: $cec7b3c0f35c015b$export$90f6e7cc0133c961.literals[node.name],
                    raw: node.name
                };
                else if (node.name === $cec7b3c0f35c015b$export$90f6e7cc0133c961.this_str) node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.THIS_EXP
                };
            } else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OPAREN_CODE) node = this.gobbleGroup();
        }
        if (!node) return this.runHook("after-token", false);
        node = this.gobbleTokenProperty(node);
        return this.runHook("after-token", node);
    }
    /**
	 * Gobble properties of of identifiers/strings/arrays/groups.
	 * e.g. `foo`, `bar.baz`, `foo['bar'].baz`
	 * It also gobbles function calls:
	 * e.g. `Math.acos(obj.angle)`
	 * @param {jsep.Expression} node
	 * @returns {jsep.Expression}
	 */ gobbleTokenProperty(node) {
        this.gobbleSpaces();
        let ch = this.code;
        while(ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OBRACK_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OPAREN_CODE || ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.QUMARK_CODE){
            let optional;
            if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.QUMARK_CODE) {
                if (this.expr.charCodeAt(this.index + 1) !== $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) break;
                optional = true;
                this.index += 2;
                this.gobbleSpaces();
                ch = this.code;
            }
            this.index++;
            if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OBRACK_CODE) {
                node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.MEMBER_EXP,
                    computed: true,
                    object: node,
                    property: this.gobbleExpression()
                };
                if (!node.property) this.throwError('Unexpected "' + this.char + '"');
                this.gobbleSpaces();
                ch = this.code;
                if (ch !== $cec7b3c0f35c015b$export$90f6e7cc0133c961.CBRACK_CODE) this.throwError("Unclosed [");
                this.index++;
            } else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.OPAREN_CODE) // A function call is being made; gobble all the arguments
            node = {
                type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.CALL_EXP,
                "arguments": this.gobbleArguments($cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE),
                callee: node
            };
            else if (ch === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE || optional) {
                if (optional) this.index--;
                this.gobbleSpaces();
                node = {
                    type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.MEMBER_EXP,
                    computed: false,
                    object: node,
                    property: this.gobbleIdentifier()
                };
            }
            if (optional) node.optional = true;
             // else leave undefined for compatibility with esprima
            this.gobbleSpaces();
            ch = this.code;
        }
        return node;
    }
    /**
	 * Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
	 * keep track of everything in the numeric literal and then calling `parseFloat` on that string
	 * @returns {jsep.Literal}
	 */ gobbleNumericLiteral() {
        let number = "", ch, chCode;
        while($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.code))number += this.expr.charAt(this.index++);
        if (this.code === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) {
            number += this.expr.charAt(this.index++);
            while($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.code))number += this.expr.charAt(this.index++);
        }
        ch = this.char;
        if (ch === "e" || ch === "E") {
            number += this.expr.charAt(this.index++);
            ch = this.char;
            if (ch === "+" || ch === "-") number += this.expr.charAt(this.index++);
            while($cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.code))number += this.expr.charAt(this.index++);
            if (!$cec7b3c0f35c015b$export$90f6e7cc0133c961.isDecimalDigit(this.expr.charCodeAt(this.index - 1))) this.throwError("Expected exponent (" + number + this.char + ")");
        }
        chCode = this.code;
        // Check to make sure this isn't a variable name that start with a number (123abc)
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(chCode)) this.throwError("Variable names cannot start with a number (" + number + this.char + ")");
        else if (chCode === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE || number.length === 1 && number.charCodeAt(0) === $cec7b3c0f35c015b$export$90f6e7cc0133c961.PERIOD_CODE) this.throwError("Unexpected period");
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.LITERAL,
            value: parseFloat(number),
            raw: number
        };
    }
    /**
	 * Parses a string literal, staring with single or double quotes with basic support for escape codes
	 * e.g. `"hello world"`, `'this is\nJSEP'`
	 * @returns {jsep.Literal}
	 */ gobbleStringLiteral() {
        let str = "";
        const startIndex = this.index;
        const quote = this.expr.charAt(this.index++);
        let closed = false;
        while(this.index < this.expr.length){
            let ch = this.expr.charAt(this.index++);
            if (ch === quote) {
                closed = true;
                break;
            } else if (ch === "\\") {
                // Check for all of the common escape codes
                ch = this.expr.charAt(this.index++);
                switch(ch){
                    case "n":
                        str += "\n";
                        break;
                    case "r":
                        str += "\r";
                        break;
                    case "t":
                        str += "	";
                        break;
                    case "b":
                        str += "\b";
                        break;
                    case "f":
                        str += "\f";
                        break;
                    case "v":
                        str += "\v";
                        break;
                    default:
                        str += ch;
                }
            } else str += ch;
        }
        if (!closed) this.throwError('Unclosed quote after "' + str + '"');
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.LITERAL,
            value: str,
            raw: this.expr.substring(startIndex, this.index)
        };
    }
    /**
	 * Gobbles only identifiers
	 * e.g.: `foo`, `_value`, `$x1`
	 * Also, this function checks if that identifier is a literal:
	 * (e.g. `true`, `false`, `null`) or `this`
	 * @returns {jsep.Identifier}
	 */ gobbleIdentifier() {
        let ch = this.code, start = this.index;
        if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierStart(ch)) this.index++;
        else this.throwError("Unexpected " + this.char);
        while(this.index < this.expr.length){
            ch = this.code;
            if ($cec7b3c0f35c015b$export$90f6e7cc0133c961.isIdentifierPart(ch)) this.index++;
            else break;
        }
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.IDENTIFIER,
            name: this.expr.slice(start, this.index)
        };
    }
    /**
	 * Gobbles a list of arguments within the context of a function call
	 * or array literal. This function also assumes that the opening character
	 * `(` or `[` has already been gobbled, and gobbles expressions and commas
	 * until the terminator character `)` or `]` is encountered.
	 * e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
	 * @param {number} termination
	 * @returns {jsep.Expression[]}
	 */ gobbleArguments(termination) {
        const args = [];
        let closed = false;
        let separator_count = 0;
        while(this.index < this.expr.length){
            this.gobbleSpaces();
            let ch_i = this.code;
            if (ch_i === termination) {
                closed = true;
                this.index++;
                if (termination === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE && separator_count && separator_count >= args.length) this.throwError("Unexpected token " + String.fromCharCode(termination));
                break;
            } else if (ch_i === $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMMA_CODE) {
                this.index++;
                separator_count++;
                if (separator_count !== args.length) {
                    if (termination === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE) this.throwError("Unexpected token ,");
                    else if (termination === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CBRACK_CODE) for(let arg = args.length; arg < separator_count; arg++)args.push(null);
                }
            } else if (args.length !== separator_count && separator_count !== 0) // NOTE: `&& separator_count !== 0` allows for either all commas, or all spaces as arguments
            this.throwError("Expected comma");
            else {
                const node = this.gobbleExpression();
                if (!node || node.type === $cec7b3c0f35c015b$export$90f6e7cc0133c961.COMPOUND) this.throwError("Expected comma");
                args.push(node);
            }
        }
        if (!closed) this.throwError("Expected " + String.fromCharCode(termination));
        return args;
    }
    /**
	 * Responsible for parsing a group of things within parentheses `()`
	 * that have no identifier in front (so not a function call)
	 * This function assumes that it needs to gobble the opening parenthesis
	 * and then tries to gobble everything within that parenthesis, assuming
	 * that the next thing it should see is the close parenthesis. If not,
	 * then the expression probably doesn't have a `)`
	 * @returns {boolean|jsep.Expression}
	 */ gobbleGroup() {
        this.index++;
        let nodes = this.gobbleExpressions($cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE);
        if (this.code === $cec7b3c0f35c015b$export$90f6e7cc0133c961.CPAREN_CODE) {
            this.index++;
            if (nodes.length === 1) return nodes[0];
            else if (!nodes.length) return false;
            else return {
                type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.SEQUENCE_EXP,
                expressions: nodes
            };
        } else this.throwError("Unclosed (");
    }
    /**
	 * Responsible for parsing Array literals `[1, 2, 3]`
	 * This function assumes that it needs to gobble the opening bracket
	 * and then tries to gobble the expressions as arguments.
	 * @returns {jsep.ArrayExpression}
	 */ gobbleArray() {
        this.index++;
        return {
            type: $cec7b3c0f35c015b$export$90f6e7cc0133c961.ARRAY_EXP,
            elements: this.gobbleArguments($cec7b3c0f35c015b$export$90f6e7cc0133c961.CBRACK_CODE)
        };
    }
}
// Static fields:
const $cec7b3c0f35c015b$var$hooks = new $cec7b3c0f35c015b$var$Hooks();
Object.assign($cec7b3c0f35c015b$export$90f6e7cc0133c961, {
    hooks: $cec7b3c0f35c015b$var$hooks,
    plugins: new $cec7b3c0f35c015b$var$Plugins($cec7b3c0f35c015b$export$90f6e7cc0133c961),
    // Node Types
    // ----------
    // This is the full set of types that any JSEP node can be.
    // Store them here to save space when minified
    COMPOUND: "Compound",
    SEQUENCE_EXP: "SequenceExpression",
    IDENTIFIER: "Identifier",
    MEMBER_EXP: "MemberExpression",
    LITERAL: "Literal",
    THIS_EXP: "ThisExpression",
    CALL_EXP: "CallExpression",
    UNARY_EXP: "UnaryExpression",
    BINARY_EXP: "BinaryExpression",
    ARRAY_EXP: "ArrayExpression",
    TAB_CODE: 9,
    LF_CODE: 10,
    CR_CODE: 13,
    SPACE_CODE: 32,
    PERIOD_CODE: 46,
    COMMA_CODE: 44,
    SQUOTE_CODE: 39,
    DQUOTE_CODE: 34,
    OPAREN_CODE: 40,
    CPAREN_CODE: 41,
    OBRACK_CODE: 91,
    CBRACK_CODE: 93,
    QUMARK_CODE: 63,
    SEMCOL_CODE: 59,
    COLON_CODE: 58,
    // Operations
    // ----------
    // Use a quickly-accessible map to store all of the unary operators
    // Values are set to `1` (it really doesn't matter)
    unary_ops: {
        "-": 1,
        "!": 1,
        "~": 1,
        "+": 1
    },
    // Also use a map for the binary operations but set their values to their
    // binary precedence for quick reference (higher number = higher precedence)
    // see [Order of operations](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence)
    binary_ops: {
        "||": 1,
        "??": 1,
        "&&": 2,
        "|": 3,
        "^": 4,
        "&": 5,
        "==": 6,
        "!=": 6,
        "===": 6,
        "!==": 6,
        "<": 7,
        ">": 7,
        "<=": 7,
        ">=": 7,
        "<<": 8,
        ">>": 8,
        ">>>": 8,
        "+": 9,
        "-": 9,
        "*": 10,
        "/": 10,
        "%": 10,
        "**": 11
    },
    // sets specific binary_ops as right-associative
    right_associative: new Set([
        "**"
    ]),
    // Additional valid identifier chars, apart from a-z, A-Z and 0-9 (except on the starting char)
    additional_identifier_chars: new Set([
        "$",
        "_"
    ]),
    // Literals
    // ----------
    // Store the values to return for the various literals we may encounter
    literals: {
        "true": true,
        "false": false,
        "null": null
    },
    // Except for `this`, which is special. This could be changed to something like `'self'` as well
    this_str: "this"
});
$cec7b3c0f35c015b$export$90f6e7cc0133c961.max_unop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.unary_ops);
$cec7b3c0f35c015b$export$90f6e7cc0133c961.max_binop_len = $cec7b3c0f35c015b$export$90f6e7cc0133c961.getMaxKeyLen($cec7b3c0f35c015b$export$90f6e7cc0133c961.binary_ops);
// Backward Compatibility:
const $cec7b3c0f35c015b$export$2e2bcd8739ae039 = (expr)=>new $cec7b3c0f35c015b$export$90f6e7cc0133c961(expr).parse();
const $cec7b3c0f35c015b$var$stdClassProps = Object.getOwnPropertyNames(class Test {
});
Object.getOwnPropertyNames($cec7b3c0f35c015b$export$90f6e7cc0133c961).filter((prop)=>!$cec7b3c0f35c015b$var$stdClassProps.includes(prop) && $cec7b3c0f35c015b$export$2e2bcd8739ae039[prop] === undefined).forEach((m)=>{
    $cec7b3c0f35c015b$export$2e2bcd8739ae039[m] = $cec7b3c0f35c015b$export$90f6e7cc0133c961[m];
});
$cec7b3c0f35c015b$export$2e2bcd8739ae039.Jsep = $cec7b3c0f35c015b$export$90f6e7cc0133c961; // allows for const { Jsep } = require('jsep');
const $cec7b3c0f35c015b$var$CONDITIONAL_EXP = "ConditionalExpression";
var $cec7b3c0f35c015b$var$ternary = {
    name: "ternary",
    init (jsep) {
        // Ternary expression: test ? consequent : alternate
        jsep.hooks.add("after-expression", function gobbleTernary(env) {
            if (env.node && this.code === jsep.QUMARK_CODE) {
                this.index++;
                const test = env.node;
                const consequent = this.gobbleExpression();
                if (!consequent) this.throwError("Expected expression");
                this.gobbleSpaces();
                if (this.code === jsep.COLON_CODE) {
                    this.index++;
                    const alternate = this.gobbleExpression();
                    if (!alternate) this.throwError("Expected expression");
                    env.node = {
                        type: $cec7b3c0f35c015b$var$CONDITIONAL_EXP,
                        test: test,
                        consequent: consequent,
                        alternate: alternate
                    };
                    // check for operators of higher priority than ternary (i.e. assignment)
                    // jsep sets || at 1, and assignment at 0.9, and conditional should be between them
                    if (test.operator && jsep.binary_ops[test.operator] <= 0.9) {
                        let newTest = test;
                        while(newTest.right.operator && jsep.binary_ops[newTest.right.operator] <= 0.9)newTest = newTest.right;
                        env.node.test = newTest.right;
                        newTest.right = env.node;
                        env.node = test;
                    }
                } else this.throwError("Expected :");
            }
        });
    }
};
// Add default plugins:
$cec7b3c0f35c015b$export$2e2bcd8739ae039.plugins.register($cec7b3c0f35c015b$var$ternary);




const $b78ece0e2b37257d$var$expressionReturnTypes = [
    "boolean",
    "date",
    "datetime",
    "int",
    "decimal",
    "string"
];
function $b78ece0e2b37257d$export$b6b5b1f15bbc92d6(value) {
    return $b78ece0e2b37257d$var$expressionReturnTypes.includes(value);
}
const $b78ece0e2b37257d$export$3b8a04534ed45870 = {
    boolean: [
        "boolean"
    ],
    date: [
        "datetime",
        "date"
    ],
    datetime: [
        "datetime",
        "date"
    ],
    int: [
        "decimal",
        "int"
    ],
    decimal: [
        "decimal",
        "int"
    ],
    string: [
        "string"
    ]
};
const $b78ece0e2b37257d$export$aa217010c5d1d474 = {
    boolean: [
        "bit"
    ],
    date: [
        "date"
    ],
    datetime: [
        "date"
    ],
    int: [
        "int",
        "currency",
        "decimal"
    ],
    decimal: [
        "decimal",
        "currency"
    ],
    string: [
        "varchar100",
        "varcharmax"
    ]
};
function $b78ece0e2b37257d$export$966a32651da2813f({ value: value }) {
    if (typeof value === "boolean") return "boolean";
    if (typeof value === "number") return Number.isInteger(value) ? "int" : "decimal";
    if (typeof value === "string") return "string";
    return null;
}
function $b78ece0e2b37257d$export$ac328571283a1f88(expression) {
    try {
        return {
            valid: true,
            node: (0, $cec7b3c0f35c015b$export$2e2bcd8739ae039)(expression)
        };
    } catch (e) {
        if (e instanceof Error && "description" in e && typeof e.description === "string" && "index" in e && typeof e.index === "number") return {
            valid: false,
            reason: e.description
        };
        return {
            valid: false,
            reason: `Invalid expression "${expression}"`
        };
    }
}
function $b78ece0e2b37257d$var$parenthesize(node, ancestors, opts) {
    const precedence = {
        "!": 14,
        "*": 12,
        "/": 12,
        "%": 12,
        "+": 11,
        "-": 11,
        ">": 9,
        "<": 9,
        ">=": 9,
        "<=": 9,
        "==": 8,
        "!=": 8,
        "&&": 4,
        "||": 3
    };
    const printed = $b78ece0e2b37257d$export$8fc0a65b8428632a(node, ancestors, opts);
    const parent = ancestors[0];
    if (!parent) return printed;
    if (node.type === "BinaryExpression" && (parent.type === "BinaryExpression" || parent.type === "UnaryExpression") && precedence[node.operator] < precedence[parent.operator] || node.type === "BinaryExpression" && parent.type === "BinaryExpression" && (parent.operator === "/" || parent.operator === "%") && parent.right === node && node.operator !== parent.operator) return `(${printed})`;
    return printed;
}
function $b78ece0e2b37257d$export$6d3f45a3236b671b(calleeName, ...args) {
    return `${calleeName}(${args.join(", ")})`;
}
function $b78ece0e2b37257d$export$8fc0a65b8428632a(node, ancestors = [], { printIdentifier: printIdentifier = (node)=>node.name.toUpperCase(), printLiteral: printLiteral = (node)=>typeof node.value === "string" ? `'${node.value.replaceAll(`'`, `\\'`)}'` : node.value.toString(), wrapDenominator: wrapDenominator = (printed)=>printed, printCallExpression: printCallExpression = $b78ece0e2b37257d$export$6d3f45a3236b671b } = {}) {
    switch(node.type){
        case "BinaryExpression":
            {
                const { left: left, right: right, operator: operator } = node;
                const leftResult = $b78ece0e2b37257d$var$parenthesize(left, [
                    node,
                    ...ancestors
                ], {
                    printIdentifier: printIdentifier,
                    printLiteral: printLiteral,
                    wrapDenominator: wrapDenominator,
                    printCallExpression: printCallExpression
                });
                const rightResult = $b78ece0e2b37257d$var$parenthesize(right, [
                    node,
                    ...ancestors
                ], {
                    printIdentifier: printIdentifier,
                    printLiteral: printLiteral,
                    wrapDenominator: wrapDenominator,
                    printCallExpression: printCallExpression
                });
                if (operator === "/" || operator === "%") return `${leftResult} ${operator} ${wrapDenominator(rightResult)}`;
                return `${leftResult} ${operator} ${rightResult}`;
            }
        case "CallExpression":
            {
                const callee = node.callee;
                if (callee.type !== "Identifier") throw new Error(`Expected Identifier, got ${callee.type}.`);
                return printCallExpression(callee.name.toUpperCase(), ...node.arguments.map((arg)=>$b78ece0e2b37257d$export$8fc0a65b8428632a(arg, [
                        node,
                        ...ancestors
                    ], {
                        printIdentifier: printIdentifier,
                        printLiteral: printLiteral,
                        wrapDenominator: wrapDenominator,
                        printCallExpression: printCallExpression
                    })));
            }
        case "Identifier":
            return printIdentifier(node, ancestors);
        case "UnaryExpression":
            {
                const { operator: operator, argument: argument } = node;
                return `${operator}${$b78ece0e2b37257d$var$parenthesize(argument, [
                    node,
                    ...ancestors
                ], {
                    printIdentifier: printIdentifier,
                    printLiteral: printLiteral,
                    wrapDenominator: wrapDenominator,
                    printCallExpression: printCallExpression
                })}`;
            }
        case "Literal":
            return printLiteral(node);
        default:
            throw new Error(`Unexpected node type "${node.type}".`);
    }
}



function $85b8830740b7c142$export$ce555e23b0c0b6f2({ parameter: parameter, properties: properties, parseExpression: parseExpression }) {
    switch(parameter.type){
        case "expression":
            return parseExpression(parameter.expression);
        case "literal-date":
        case "select-date":
            return {
                valid: true,
                type: "date"
            };
        case "literal-number":
            return {
                valid: true,
                type: "decimal"
            };
        case "select-number":
            return {
                valid: true,
                type: parameter.values.every((x)=>Number.isInteger(x.value)) ? "int" : "decimal"
            };
        case "user":
        case "organization":
            return {
                valid: false,
                reason: `Invalid parameter reference "${parameter.name}" - ${parameter.type} parameters are not supported in formulas.`
            };
        case "subquery":
            const { type: type } = (0, $d175770e6e5170f5$export$13d77bb70d7b9d75)(parameter, properties);
            if (type) return {
                valid: true,
                type: type
            };
            return {
                valid: false,
                reason: `Invalid parameter reference "${parameter.name}". Unable to determine data type.`
            };
        default:
            throw new Error(`Unexpected parameter type "${parameter.type}".`);
    }
}


const $d0aca128151552ea$export$44a23670a5e38db4 = [
    "YEAR",
    "QUARTER",
    "MONTH",
    // 'DAYOFYEAR',
    "DAY",
    "WEEK"
];
const $d0aca128151552ea$var$functions = {
    ABS: {
        returnType: (num)=>num.type,
        minArguments: 1,
        arguments: [
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            }
        ]
    },
    DATEADD: {
        returnType: (_part, _num, date)=>date.type,
        minArguments: 3,
        arguments: [
            {
                type: "identifier",
                values: $d0aca128151552ea$export$44a23670a5e38db4
            },
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            },
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            }
        ]
    },
    DATEDIFF: {
        returnType: ()=>"int",
        minArguments: 3,
        arguments: [
            {
                type: "identifier",
                values: $d0aca128151552ea$export$44a23670a5e38db4
            },
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            },
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            }
        ]
    },
    DATEPART: {
        returnType: ()=>"int",
        minArguments: 2,
        arguments: [
            {
                type: "identifier",
                values: $d0aca128151552ea$export$44a23670a5e38db4
            },
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            }
        ]
    },
    DATETRUNC: {
        returnType: ()=>"date",
        minArguments: 2,
        arguments: [
            {
                type: "identifier",
                values: $d0aca128151552ea$export$44a23670a5e38db4
            },
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            }
        ]
    },
    CEILING: {
        returnType: ()=>"int",
        minArguments: 1,
        arguments: [
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            }
        ]
    },
    EOMONTH: {
        returnType: ()=>"date",
        minArguments: 1,
        arguments: [
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            },
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            }
        ]
    },
    DATE: {
        returnType: ()=>"date",
        minArguments: 1,
        arguments: [
            {
                type: "literal",
                validate: (value)=>typeof value === "string" && isFinite(Date.parse(value)) && /^\d{4}-\d{1,2}-\d{1,2}$/.test(value) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string in the format of "YYYY-MM-DD"`
                    }
            }
        ]
    },
    FLOOR: {
        returnType: ()=>"int",
        minArguments: 1,
        arguments: [
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            }
        ]
    },
    NOW: {
        returnType: ()=>"datetime",
        minArguments: 0,
        arguments: []
    },
    ROUND: {
        returnType: (_num, len)=>len?.node.type === "Literal" && len.node.value === 0 ? "int" : "decimal",
        minArguments: 1,
        arguments: [
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            },
            {
                type: "value",
                valueType: [
                    "int"
                ],
                values: [
                    0,
                    1,
                    2,
                    3
                ]
            }
        ]
    },
    MIN: {
        returnType: (...args)=>args.some((x)=>x.type === "decimal") ? "decimal" : "int",
        minArguments: 2,
        arguments: [
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            },
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            }
        ]
    },
    MAX: {
        returnType: (...args)=>args.some((x)=>x.type === "decimal") ? "decimal" : "int",
        minArguments: 2,
        arguments: [
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            },
            {
                type: "value",
                valueType: [
                    "int",
                    "decimal"
                ]
            }
        ]
    },
    AGE: {
        returnType: ()=>"int",
        minArguments: 2,
        arguments: [
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            },
            {
                type: "value",
                valueType: [
                    "date",
                    "datetime"
                ]
            }
        ]
    }
};
function $d0aca128151552ea$var$validateReportExpression({ node: node, context: context }) {
    const expandExpressionReferences = (referenceNode, expression)=>{
        const name = referenceNode.name.toUpperCase();
        const parseResult = (0, $b78ece0e2b37257d$export$ac328571283a1f88)(expression);
        if (!parseResult.valid) return {
            valid: false,
            reason: `Referenced identifier "${name}" has an invalid expression. ${parseResult.reason}`
        };
        Object.keys(referenceNode).forEach((key)=>delete referenceNode[key]);
        Object.assign(referenceNode, parseResult.node);
        const newContext = {
            ...context,
            ancestorNames: [
                ...context.ancestorNames,
                name
            ]
        };
        return $d0aca128151552ea$var$validateReportExpression({
            node: referenceNode,
            context: newContext
        });
    };
    switch(node.type){
        case "BinaryExpression":
            {
                const { left: left, right: right, operator: operator } = node;
                if ([
                    "+",
                    "-",
                    "*",
                    "/",
                    "%"
                ].includes(operator)) {
                    const leftResult = $d0aca128151552ea$var$validateReportExpression({
                        node: left,
                        context: context
                    });
                    if (leftResult.valid === false) return leftResult;
                    if (leftResult.type !== "int" && leftResult.type !== "decimal") return {
                        valid: false,
                        reason: `The expression "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(left, [])}" cannot be used with the "${operator}" operator because it does not evaluate to a number.`
                    };
                    const rightResult = $d0aca128151552ea$var$validateReportExpression({
                        node: right,
                        context: context
                    });
                    if (rightResult.valid === false) return rightResult;
                    if (rightResult.type !== "int" && rightResult.type !== "decimal") return {
                        valid: false,
                        reason: `The expression "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(left, [])}" cannot be used with the "${operator}" operator because it does not evaluate to a number.`
                    };
                    if (operator === "/" || leftResult.type === "decimal" || rightResult.type === "decimal") return {
                        valid: true,
                        type: "decimal"
                    };
                    else return {
                        valid: true,
                        type: leftResult.type
                    };
                }
                return {
                    valid: false,
                    reason: `Invalid expression "${operator}".`
                };
            }
        case "CallExpression":
            {
                const callee = node.callee;
                if (callee.type !== "Identifier") return {
                    valid: false,
                    reason: `Invalid expression.`
                };
                const fn = $d0aca128151552ea$var$functions[callee.name.toUpperCase()];
                if (!fn) return {
                    valid: false,
                    reason: `Invalid expression "${callee.name}".`
                };
                if (fn.minArguments > node.arguments.length) return {
                    valid: false,
                    reason: `Too few arguments for "${callee.name}" function. Expected ${fn.minArguments === fn.arguments.length ? fn.minArguments : `${fn.minArguments} - ${fn.arguments.length}`}.`
                };
                if (node.arguments.length > fn.arguments.length) return {
                    valid: false,
                    reason: `Too many arguments for "${callee.name}" function. Expected ${fn.minArguments === fn.arguments.length ? fn.minArguments : `${fn.minArguments} - ${fn.arguments.length}`}.`
                };
                const argTypes = [];
                for(let i = 0; i < node.arguments.length; i++){
                    const arg = fn.arguments[i];
                    const argNode = node.arguments[i];
                    if (arg.type === "identifier") {
                        if (argNode.type !== "Identifier" || !arg.values.includes(argNode.name.toUpperCase())) return {
                            valid: false,
                            reason: `Invalid argument ${i + 1} for ${callee.name}. Expected ${arg.values.join(", ")}.`
                        };
                        argTypes.push(null);
                    } else if (arg.type === "literal") {
                        if (argNode.type === "UnaryExpression" && argNode.operator === "-" && argNode.argument.type === "Literal" && typeof argNode.argument.value === "number" && Number.isFinite(argNode.argument.value)) {
                            const result = arg.validate(argNode.argument.value * -1);
                            if (!result.valid) return result;
                        } else if (argNode.type !== "Literal") return {
                            valid: false,
                            reason: `Invalid argument "${argNode.raw}" in "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}". Expected a literal value.`
                        };
                        else {
                            const result = arg.validate(argNode.value);
                            if (!result.valid) return result;
                        }
                    } else if (arg.type === "value") {
                        const result = $d0aca128151552ea$var$validateReportExpression({
                            node: argNode,
                            context: context
                        });
                        if (result.valid === false) return result;
                        if (!arg.valueType.includes(result.type)) return {
                            valid: false,
                            reason: `Invalid argument ${i + 1} for ${callee.name}. Expected ${arg.valueType[0]}.`
                        };
                        if (arg.values && (argNode.type !== "Literal" || !arg.values.includes(argNode.value))) return {
                            valid: false,
                            reason: `Invalid argument ${i + 1} for ${callee.name}. Expected ${arg.values.join(", ")}.`
                        };
                        argTypes.push(result.type);
                    } else throw new Error(`Unexpected argument type "${arg.type}".`);
                }
                return {
                    valid: true,
                    type: fn.returnType(...node.arguments.map((node, i)=>({
                            node: node,
                            type: argTypes[i]
                        })))
                };
            }
        case "Identifier":
            {
                const name = node.name.toUpperCase();
                if (context.ancestorNames.includes(name)) return {
                    valid: false,
                    reason: `Reference to "${name}" creates a circular reference.`
                };
                if (/^[A-Z]$/.test(name)) {
                    if (context.ancestorNames.some((x)=>(0, $d175770e6e5170f5$export$99da40ee05a17718).test(x))) return {
                        valid: false,
                        reason: `Column reference "${name}" is invalid. Columns cannot be referenced in a parameter formula.`
                    };
                    const index = name.charCodeAt(0) - "A".charCodeAt(0);
                    if (index >= context.columns.length) return {
                        valid: false,
                        reason: `Invalid column reference "${name}". Column does not exist.`
                    };
                    const column = context.columns[index];
                    if (column.type === "expression") return expandExpressionReferences(node, column.expression);
                    const { type: type, property: property } = $d0aca128151552ea$export$bf02abf02e552bba(column, context.properties);
                    if (type) return {
                        valid: true,
                        type: type
                    };
                    const descriptor = property ? `${column.type === "subquery" ? (0, $d175770e6e5170f5$export$78c94180fed6d79f)[column.aggregate] + " " : ""}"${property.label}"` : `Column ${name}`;
                    return {
                        valid: false,
                        reason: `Invalid column reference "${name}". ${descriptor} is not eligible for use in formulas.`
                    };
                }
                if ((0, $d175770e6e5170f5$export$99da40ee05a17718).test(name)) {
                    const parameter = context.parameters.find((x)=>x.name === name);
                    if (!parameter) return {
                        valid: false,
                        reason: `Invalid parameter reference "${name}".`
                    };
                    return (0, $85b8830740b7c142$export$ce555e23b0c0b6f2)({
                        parameter: parameter,
                        properties: context.properties,
                        parseExpression: (expression)=>expandExpressionReferences(node, expression)
                    });
                }
                return {
                    valid: false,
                    reason: `Invalid expression "${name}".`
                };
            }
        case "UnaryExpression":
            {
                const { operator: operator, argument: argument } = node;
                if (operator !== "-" || argument.type !== "Literal") return {
                    valid: false,
                    reason: `Invalid expression "${operator}".`
                };
                const result = $d0aca128151552ea$var$validateReportExpression({
                    node: argument,
                    context: context
                });
                if (result.valid === false) return result;
                if (result.type !== "decimal" && result.type !== "int") return {
                    valid: false,
                    reason: `Cannot negate ${result.type} expression.`
                };
                return result;
            }
        case "Literal":
            {
                const { value: value, raw: raw } = node;
                if (typeof value === "number" && isFinite(value) && value >= -100000000 && value <= 100000000) return {
                    valid: true,
                    type: Number.isInteger(value) ? "int" : "decimal"
                };
                return {
                    valid: false,
                    reason: `Invalid expression "${raw}".`
                };
            }
        default:
            return {
                valid: false,
                reason: "Invalid expression."
            };
    }
}
function $d0aca128151552ea$export$672971f1d929056c(index) {
    return String.fromCharCode(index + "A".charCodeAt(0));
}
function $d0aca128151552ea$export$9692209d71b8f134({ name: name, expression: expression, getDefinitionInfo: getDefinitionInfo }) {
    const parseResult = (0, $b78ece0e2b37257d$export$ac328571283a1f88)(expression);
    if (!parseResult.valid) return parseResult;
    const { node: node } = parseResult;
    const originalNode = structuredClone(node);
    const result = $d0aca128151552ea$var$validateReportExpression({
        node: node,
        context: {
            ancestorNames: [
                name
            ],
            ...getDefinitionInfo()
        }
    });
    if (!result.valid) return result;
    const permitted = [
        "int",
        "decimal",
        "date",
        "datetime"
    ];
    if (!permitted.includes(result.type)) return {
        valid: false,
        reason: `Expression results of type ${result.type} are not supported. Expected: ${permitted.join(", ")}.`
    };
    return {
        valid: true,
        node: node,
        originalNode: originalNode,
        type: result.type
    };
}
function $d0aca128151552ea$export$49e0f493cc4d655f(value, map) {
    if (value === "") return null;
    let node;
    try {
        node = (0, $cec7b3c0f35c015b$export$2e2bcd8739ae039)(value);
    } catch  {
        return null;
    }
    if ($d0aca128151552ea$var$tryTranslateReportExpressionColumnReferences(node, map)) return node;
    return null;
}
function $d0aca128151552ea$var$tryTranslateReportExpressionColumnReferences(node, map) {
    switch(node.type){
        case "BinaryExpression":
            {
                const { left: left, right: right } = node;
                return $d0aca128151552ea$var$tryTranslateReportExpressionColumnReferences(left, map) && $d0aca128151552ea$var$tryTranslateReportExpressionColumnReferences(right, map);
            }
        case "CallExpression":
            {
                let translated = true;
                for (const arg of node.arguments)translated && (translated = $d0aca128151552ea$var$tryTranslateReportExpressionColumnReferences(arg, map));
                return translated;
            }
        case "Identifier":
            {
                const deletedName = "DELETED";
                if (/^[A-Z]$/.test(node.name.toUpperCase())) {
                    const index = node.name.toUpperCase().charCodeAt(0) - "A".charCodeAt(0);
                    const new_index = map[index];
                    if (new_index === null) node.name = deletedName;
                    else node.name = String.fromCharCode(new_index + "A".charCodeAt(0));
                    return true;
                } else return true;
            }
        case "UnaryExpression":
        case "Literal":
            return true;
        default:
            return false;
    }
}
function $d0aca128151552ea$export$bf02abf02e552bba(column, properties) {
    const getPropertyType = (property)=>{
        switch(property.type){
            case "int":
                return {
                    type: "int",
                    property: property
                };
            case "currency":
            case "decimal":
                return {
                    type: "decimal",
                    property: property
                };
            case "date":
                return {
                    type: "datetime",
                    property: property
                };
            case "bit":
                return {
                    type: "boolean",
                    property: property
                };
            case "varchar100":
            case "varcharmax":
                return {
                    type: "string",
                    property: property
                };
            default:
                return {
                    type: null,
                    property: property
                };
        }
    };
    switch(column.type){
        case "standard":
            {
                const property = properties.find((p)=>p.property_id === column.property_id);
                if (!property) throw new Error(`Unable to find standard property ${column.property_id}.`);
                if ((0, $d175770e6e5170f5$export$2dff0e8aabc7fdcc).includes(property.property_id) || property.choice_type !== "none") return {
                    type: null,
                    property: property
                };
                return getPropertyType(property);
            }
        case "expression":
            return {
                type: null
            };
        case "subquery":
            {
                if (column.aggregate === "count") return {
                    type: "int"
                };
                const aggregateResultType = (0, $d175770e6e5170f5$export$3604b59051dae160)[column.aggregate];
                switch(aggregateResultType){
                    case "decimal":
                        return {
                            type: "decimal"
                        };
                    case "int":
                        return {
                            type: "int"
                        };
                    case "inherit-number":
                    case "inherit":
                        const property = properties.find((p)=>p.property_id === column.subquery_property_id);
                        if (!property) throw new Error(`Unable to find subquery property ${column.subquery_property_id}.`);
                        return getPropertyType(property);
                    default:
                        throw new Error(`Unexpected aggregate result type "${aggregateResultType}" for subquery property ${column.subquery_property_id}.`);
                }
            }
        default:
            throw new Error(`Unexpected column type "${column.type}".`);
    }
}



const $d9fbf6499db8c776$export$a32a6456cc20db71 = {
    type: "string",
    pattern: "^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$" // ensure lower-case
};
const $d9fbf6499db8c776$export$132ea886f1bee90 = {
    type: "object",
    additionalProperties: false,
    required: [
        "id",
        "title"
    ],
    properties: {
        id: $d9fbf6499db8c776$export$a32a6456cc20db71,
        title: {
            type: "string",
            minLength: 1,
            maxLength: 250
        }
    }
};








function $669809489e0e2c7d$export$36f1754b1616884a(type) {
    switch(type){
        case "activity":
            return "activities";
        case "activity_definition":
            return "activity-definitions";
        case "person":
            return "people";
        case "form":
            return "activities";
        case "task":
            return "activities";
        case "organization":
            return "organizations";
        case "report":
        case "dashboard":
            return "reports";
        case "user_organization":
            return "members";
        case "task_definition":
            return "task-definitions";
        case "form_design":
            return "form-designs";
        case "organization_project":
        default:
            throw new Error(`Unexpected type "${type}`);
    }
}
function $669809489e0e2c7d$export$42402a68ff28dfc0(property, value, locale = (0, $f2e3bdb9929a0de6$export$d7f512c98c859244)) {
    if (value === null || value === undefined || value === "") return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<em class="color-fg-muted">${(0, $2868cc1235412e16$export$2f8dde2e869bc7b8)[locale]}</em>`;
    if (property.type === "int" && property.choice_type === "single") {
        const choice = property.choices?.find((c)=>c.choice_id === value);
        return choice?.label ?? value;
    }
    switch(property.type){
        case "bit":
            return value ? (0, $2868cc1235412e16$export$310250c811816278)[locale] : (0, $2868cc1235412e16$export$9692d1a0658a3861)[locale];
        case "currency":
            return typeof value === "number" ? (0, $834ded10eeb0a740$export$4670d0ed237a9270).format(value) : value;
        case "decimal":
            return (0, $834ded10eeb0a740$export$688d13a530c5dcbc).format(value);
        case "int":
            return value >= 1900 || value < 2100 // don't use commas when the int might be a year
             ? value : (0, $834ded10eeb0a740$export$688d13a530c5dcbc).format(value);
        case "date":
            return (0, $dbca384612ad025b$export$6aa1a8800137fac7).format(new Date(value.length === 10 ? value + "T00:00:00.000Z" : value));
        default:
            return value;
    }
}
function $669809489e0e2c7d$export$b69667b9fc24675e({ locale: locale, property: property, value: value, showScore: showScore, activities: activities }) {
    if (value === undefined || value === null) return (0, $2868cc1235412e16$export$2f8dde2e869bc7b8)[locale];
    if (property.calculated) return $669809489e0e2c7d$export$42402a68ff28dfc0(property, value, locale);
    switch(property.choice_type){
        case "single":
            {
                const choices = property.choices;
                if (!choices) throw new Error("Property.choices expected.");
                const choice = choices.find((c)=>c.choice_id === value);
                if (!choice) throw new Error(`Choice not found for choice id ${value} in property "${property.label}" (${property.property_id}).`);
                if (showScore && choices.some((c)=>c.score !== 0)) return `${choice.label} (score ${choice.score})`;
                return choice.label;
            }
        case "multiple":
            {
                const choices = property.choices;
                if (!choices) throw new Error("Property.choices expected.");
                const selected = (Array.isArray(value) ? value : (0, $0f65d914a7138590$export$7ad13431816ff1fa)(value)).map((id)=>choices.find((c)=>c.choice_id === id)).filter((x)=>x);
                const labels = selected.map((c)=>c.label).join(", ");
                if (showScore && choices.some((c)=>c.score !== 0)) return `${labels} (score ${selected.reduce((acc, c)=>acc + c.score, 0)})`;
                return labels;
            }
    }
    switch(property.type){
        case "date":
            return (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(new Date(value));
        case "decimal":
            return (0, $834ded10eeb0a740$export$688d13a530c5dcbc).format(value);
        case "int":
            return value >= 1900 || value < 2100 // don't use commas when the int might be a year
             ? value.toString() : (0, $834ded10eeb0a740$export$688d13a530c5dcbc).format(value);
        case "varchar100":
        case "varcharmax":
            return value;
        case "bit":
            return value ? (0, $2868cc1235412e16$export$310250c811816278)[locale] : (0, $2868cc1235412e16$export$9692d1a0658a3861)[locale];
        case "currency":
            return (0, $834ded10eeb0a740$export$4670d0ed237a9270).format(value);
        case "activity":
            const activity = activities.find((a)=>a.activity_id === value);
            return activity?.title ?? value;
        case "attachment":
            return value === 1 ? (0, $2868cc1235412e16$export$9c74c928b7f96fab)[locale] : (0, $2868cc1235412e16$export$a9eeb925e66f3fef)[locale](value);
        case "signature":
            return value === 1 ? (0, $2868cc1235412e16$export$5b2dff051546c71)[locale] : (0, $2868cc1235412e16$export$88044af7e8639ccb)[locale](value);
        case "medications":
            return value === 1 ? (0, $2868cc1235412e16$export$1ff6720e765bd764)[locale] : (0, $2868cc1235412e16$export$814fd764a5b35e2f)[locale](value);
        default:
            throw new Error(`getPropertyDisplayValue not implemented for type: "${property.type}"; calculated: "${property.calculated}"; choice_type: "${property.choice_type}";`);
    }
}
var $669809489e0e2c7d$export$ac1cd9a3e24492e7;
(function(PropertyFormat) {
    PropertyFormat[PropertyFormat["None"] = 0] = "None";
    PropertyFormat[PropertyFormat["Email"] = 1] = "Email";
    PropertyFormat[PropertyFormat["FEIN"] = 2] = "FEIN";
    PropertyFormat[PropertyFormat["Phone"] = 3] = "Phone";
    PropertyFormat[PropertyFormat["SSN"] = 4] = "SSN";
    PropertyFormat[PropertyFormat["Zip"] = 5] = "Zip";
    PropertyFormat[PropertyFormat["Zip4"] = 6] = "Zip4";
    PropertyFormat[PropertyFormat["Address"] = 7] = "Address";
})($669809489e0e2c7d$export$ac1cd9a3e24492e7 || ($669809489e0e2c7d$export$ac1cd9a3e24492e7 = {}));
const $669809489e0e2c7d$export$73a8cd8fe3f87586 = [
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
        label: "None"
    },
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.Address,
        label: "Address"
    },
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.Email,
        label: "Email"
    },
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.FEIN,
        label: "FEIN"
    },
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.Phone,
        label: "Phone"
    },
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.SSN,
        label: "SSN"
    },
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.Zip,
        label: "Zip"
    },
    {
        value: $669809489e0e2c7d$export$ac1cd9a3e24492e7.Zip4,
        label: "Zip+4"
    }
];
const $669809489e0e2c7d$export$463907730aed6aef = {
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.None]: null,
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.Email]: {
        min: 4,
        max: 100
    },
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.FEIN]: {
        min: 10,
        max: 10,
        mask: "##-#######",
        regex: /^\d{2}-\d{7}$/
    },
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.Phone]: {
        min: 14,
        max: 14
    },
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.SSN]: {
        min: 11,
        max: 11,
        mask: "###-##-####",
        regex: /\d{3}-\d{2}-\d{4}$/
    },
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.Zip]: {
        min: 5,
        max: 5,
        mask: "#####",
        regex: /^\d{5}$/
    },
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.Zip4]: {
        min: 5,
        max: 9,
        mask: "#####-####",
        regex: /^\d{5}(?:-\d{4})?$/
    },
    [$669809489e0e2c7d$export$ac1cd9a3e24492e7.Address]: {
        min: 0,
        max: 100
    }
};
const $669809489e0e2c7d$export$3f9e8a95c406046 = {
    person: {
        last_name: 1,
        first_name: 2,
        middle_name: 3,
        addresses: 4,
        phones: 5,
        emails: 6,
        gender: 7,
        gender_identity: 1990,
        sexual_orientation: 1009,
        race: 1010,
        ethnicity: 1011,
        marital_status: 1085,
        primary_language: 1012,
        dob: 8,
        external_id: 106,
        full_name: 45,
        ssn: 1055,
        veteran_id: 1056,
        medicaid_id: 1092,
        agingis_id: 2705,
        scsep_participant_id: 3826,
        primary_physical: {
            address: 48,
            city: 50,
            region_abbr: 51,
            subregion: 52,
            postal_code: 53,
            street_address: 82,
            sub_address: 83,
            postal_code_ext: 84,
            is_precise: 164
        },
        primary_mailing: {
            address: 49,
            city: 75,
            region_abbr: 76,
            subregion: 77,
            postal_code: 78,
            street_address: 79,
            sub_address: 80,
            postal_code_ext: 81,
            is_precise: 165
        },
        primary_phone: {
            formatted: 85,
            type: 86,
            number: 87,
            extension: 88
        },
        primary_email: {
            formatted: 89,
            type: 90,
            email: 91
        },
        create_date: 54,
        create_organization_id: 55,
        create_user_id: 56,
        update_date: 57,
        update_organization_id: 58,
        update_user_id: 59,
        user_id: 2171
    },
    user_organization: {
        family_name: 168,
        given_name: 169,
        login: 170,
        email: 171,
        projects: 172,
        organization_id: 173,
        role_id: 342,
        primary_phone: {
            formatted: 174,
            type: 175,
            number: 176,
            extension: 177
        }
    },
    activity: {
        activity_definition_id: 243,
        create_date: 244,
        create_organization_id: 245,
        create_user_id: 246,
        start_date: 247,
        end_date: 248,
        status: 251,
        status_date: 252,
        update_date: 253,
        due_date: 2647,
        update_organization_id: 254,
        update_user_id: 255,
        project_id: 257,
        assignee_id: 258,
        assignee_user_id: 259,
        assignee_organization_id: 260,
        assignment_datetime: 1673,
        contract_id: 432,
        type: 261,
        sctid: 262,
        create_dow: 263,
        subscribed: 264,
        comment_create_user_id: 265,
        comment_create_date: 3140,
        comment_mentioned_user_id: 266,
        comment_text: 3141,
        title: 276,
        primary_physical: {
            address: 267,
            city: 268,
            region_abbr: 269,
            subregion: 270,
            postal_code: 271,
            street_address: 272,
            sub_address: 273,
            postal_code_ext: 274,
            is_precise: 275
        },
        primary_phone: {
            formatted: 2535,
            type: 2536,
            number: 2537,
            extension: 2538
        },
        primary_email: {
            formatted: 2539,
            type: 2540,
            email: 2541
        },
        assignee_organization_primary_physical: {
            address: 277,
            city: 278,
            region_abbr: 279,
            subregion: 280,
            postal_code: 281,
            street_address: 282,
            sub_address: 283,
            postal_code_ext: 284,
            is_precise: 285
        },
        assignee_organization_primary_email: {
            formatted: 1086,
            type: 1087,
            email: 1088
        },
        assignee_role_id: 286,
        create_organization_primary_physical: {
            address: 287,
            city: 288,
            region_abbr: 289,
            subregion: 290,
            postal_code: 291,
            street_address: 292,
            sub_address: 293,
            postal_code_ext: 294,
            is_precise: 295
        },
        create_organization_primary_email: {
            formatted: 1089,
            type: 1090,
            email: 1091
        },
        attachment_count: 408,
        consent_granted: 1303
    },
    organization_project: {
        organization_id: 324,
        project_id: 325,
        project_join_date: 326,
        is_active: 327,
        is_admin: 341,
        classification: 2010,
        fein: 2011,
        primary_phone: {
            formatted: 328,
            type: 329,
            number: 330,
            extension: 331
        },
        primary_physical: {
            address: 332,
            city: 333,
            region_abbr: 334,
            subregion: 335,
            postal_code: 336,
            street_address: 337,
            sub_address: 338,
            postal_code_ext: 339,
            is_precise: 340
        }
    }
};
const $669809489e0e2c7d$export$be5da72c1132278d = {};
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_physical).forEach((x)=>$669809489e0e2c7d$export$be5da72c1132278d[x] = $669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_physical);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_physical).forEach((x)=>$669809489e0e2c7d$export$be5da72c1132278d[x] = $669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_physical);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_physical).forEach((x)=>$669809489e0e2c7d$export$be5da72c1132278d[x] = $669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_physical);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.person.primary_physical).forEach((x)=>$669809489e0e2c7d$export$be5da72c1132278d[x] = $669809489e0e2c7d$export$3f9e8a95c406046.person.primary_physical);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.person.primary_mailing).forEach((x)=>$669809489e0e2c7d$export$be5da72c1132278d[x] = $669809489e0e2c7d$export$3f9e8a95c406046.person.primary_mailing);
const $669809489e0e2c7d$export$57f8d18cc41ddb41 = {};
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.person.primary_phone).forEach((x)=>$669809489e0e2c7d$export$57f8d18cc41ddb41[x] = $669809489e0e2c7d$export$3f9e8a95c406046.person.primary_phone);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_phone).forEach((x)=>$669809489e0e2c7d$export$57f8d18cc41ddb41[x] = $669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_phone);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.user_organization.primary_phone).forEach((x)=>$669809489e0e2c7d$export$57f8d18cc41ddb41[x] = $669809489e0e2c7d$export$3f9e8a95c406046.user_organization.primary_phone);
const $669809489e0e2c7d$export$5786dfc88873b340 = {};
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.person.primary_email).forEach((x)=>$669809489e0e2c7d$export$5786dfc88873b340[x] = $669809489e0e2c7d$export$3f9e8a95c406046.person.primary_email);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_email).forEach((x)=>$669809489e0e2c7d$export$5786dfc88873b340[x] = $669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_email);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_email).forEach((x)=>$669809489e0e2c7d$export$5786dfc88873b340[x] = $669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_email);
Object.values($669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_email).forEach((x)=>$669809489e0e2c7d$export$5786dfc88873b340[x] = $669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_email);
$669809489e0e2c7d$export$5786dfc88873b340[$669809489e0e2c7d$export$3f9e8a95c406046.user_organization.email] = {
    email: $669809489e0e2c7d$export$3f9e8a95c406046.user_organization.email
};
const $669809489e0e2c7d$export$cc0d55d7ff08492f = {
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_physical.city]: "City",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_physical.postal_code]: "Primary Postal",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_physical.region_abbr]: "Region",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.primary_physical.subregion]: "Subregion",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.city]: "City",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.postal_code]: "Primary Postal",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.region_abbr]: "Region",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.assignee_organization_primary_physical.subregion]: "Subregion",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_physical.city]: "City",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_physical.postal_code]: "Primary Postal",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_physical.region_abbr]: "Region",
    [$669809489e0e2c7d$export$3f9e8a95c406046.activity.create_organization_primary_physical.subregion]: "Subregion",
    [$669809489e0e2c7d$export$3f9e8a95c406046.person.primary_physical.city]: "City",
    [$669809489e0e2c7d$export$3f9e8a95c406046.person.primary_physical.postal_code]: "Primary Postal",
    [$669809489e0e2c7d$export$3f9e8a95c406046.person.primary_physical.region_abbr]: "Region",
    [$669809489e0e2c7d$export$3f9e8a95c406046.person.primary_physical.subregion]: "Subregion",
    [$669809489e0e2c7d$export$3f9e8a95c406046.organization_project.primary_physical.city]: "City",
    [$669809489e0e2c7d$export$3f9e8a95c406046.organization_project.primary_physical.postal_code]: "Primary Postal",
    [$669809489e0e2c7d$export$3f9e8a95c406046.organization_project.primary_physical.region_abbr]: "Region",
    [$669809489e0e2c7d$export$3f9e8a95c406046.organization_project.primary_physical.subregion]: "Subregion"
};
const $669809489e0e2c7d$export$1497f5791e8774bc = {
    uniqueidentifier: {
        "big-single": {
            display_type: "Single choice (dynamic)",
            type: "uniqueidentifier",
            choice_type: "big-single",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    activity: {
        "big-single": {
            display_type: "Activity field",
            type: "activity",
            choice_type: "big-single",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    attachment: {
        none: {
            display_type: "Attachment",
            type: "attachment",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    signature: {
        none: {
            display_type: "Signature",
            type: "signature",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    medications: {
        none: {
            display_type: "Medications",
            type: "medications",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    varchar100: {
        none: {
            display_type: "Text",
            type: "varchar100",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 100,
            defaultMax: 50
        }
    },
    varcharmax: {
        none: {
            display_type: "Long text",
            type: "varcharmax",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 10000,
            defaultMax: 200
        }
    },
    int: {
        none: {
            display_type: "Integer",
            type: "int",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: -100000000,
            defaultMin: 0,
            max: 100000000,
            defaultMax: 100
        },
        single: {
            display_type: "Single choice",
            type: "int",
            choice_type: "single",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: true,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        },
        multiple: {
            display_type: "Multiple choice",
            type: "int",
            choice_type: "multiple",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: true,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    bit: {
        none: {
            display_type: "Boolean",
            type: "bit",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    currency: {
        none: {
            display_type: "Currency",
            type: "currency",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: -100000000,
            defaultMin: 0,
            max: 100000000,
            defaultMax: 10000
        }
    },
    date: {
        none: {
            display_type: "Date",
            type: "date",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: 0,
            defaultMin: 0,
            max: 0,
            defaultMax: 0
        }
    },
    decimal: {
        none: {
            display_type: "Decimal",
            type: "decimal",
            choice_type: "none",
            format: $669809489e0e2c7d$export$ac1cd9a3e24492e7.None,
            report_column: true,
            report_filter: true,
            report_sort: false,
            uses_choices: false,
            response: true,
            min: -100000000,
            defaultMin: 0,
            max: 100000000,
            defaultMax: 10000
        }
    }
};
const $669809489e0e2c7d$export$d903fab3e128a936 = Object.values($669809489e0e2c7d$export$1497f5791e8774bc).reduce((acc, pt)=>{
    for (const ct of Object.values(pt))acc[ct.display_type] = ct;
    return acc;
}, {});



const $d175770e6e5170f5$export$ba4f7c3b25ff4061 = 5000;
const $d175770e6e5170f5$export$dfbb11200c55b885 = [
    "activity",
    "person",
    "user_organization",
    "organization_project"
];
const $d175770e6e5170f5$export$ffda6d73471681a0 = {
    activity: {
        singular: (0, $2868cc1235412e16$export$7b385c33eaf64565),
        plural: (0, $2868cc1235412e16$export$c649626dc103486),
        description: (0, $2868cc1235412e16$export$8e4ca99cc58f6f3e),
        included: [
            "person"
        ],
        icon: (0, $2b6d0b8c1c80c786$export$d2997daddac9b44),
        subqueries: [
            {
                value: "child-activities",
                text: "Child activities"
            },
            {
                value: "grandchild-activities",
                text: "Grandchild activities"
            },
            {
                value: "person-activities",
                text: `Person's activities`
            },
            {
                value: "sibling-activities",
                text: "Sibling activities"
            },
            {
                value: "parent-activity",
                text: "Parent activity"
            },
            {
                value: "grandparent-activity",
                text: "Grandparent activity"
            }
        ]
    },
    organization_project: {
        singular: (0, $2868cc1235412e16$export$2a505cf562ed1f0f),
        plural: (0, $2868cc1235412e16$export$1465cd6a5dc70bb9),
        description: (0, $2868cc1235412e16$export$60f60aa90d727a55),
        included: [],
        icon: (0, $2b6d0b8c1c80c786$export$51f878b7e8894ba1),
        subqueries: [
            {
                value: "assigned-activities",
                text: "Assigned activities"
            },
            {
                value: "contracted-activities",
                text: "Contracted activities"
            },
            {
                value: "created-activities",
                text: "Created activities"
            }
        ]
    },
    person: {
        singular: (0, $2868cc1235412e16$export$e81e1f6da08081e8),
        plural: (0, $2868cc1235412e16$export$9a0b973819fb310),
        description: (0, $2868cc1235412e16$export$90a412476a587834),
        included: [],
        icon: (0, $2b6d0b8c1c80c786$export$44b16df525422efd),
        subqueries: [
            {
                value: "child-activities",
                text: "Activities"
            }
        ]
    },
    user_organization: {
        singular: (0, $2868cc1235412e16$export$875c8af227bd90db),
        plural: (0, $2868cc1235412e16$export$875c8af227bd90db),
        description: (0, $2868cc1235412e16$export$383ccceb9623a9e8),
        included: [],
        icon: (0, $2b6d0b8c1c80c786$export$ffd16dba7db7e37d),
        subqueries: [
            {
                value: "assigned-activities",
                text: "Assigned activities"
            },
            {
                value: "created-activities",
                text: "Created activities"
            }
        ]
    }
};
var $d175770e6e5170f5$export$fbac3d2f26b21a45;
(function(ReportSharedWith) {
    ReportSharedWith[ReportSharedWith["None"] = 0] = "None";
    ReportSharedWith[ReportSharedWith["Organization"] = 1] = "Organization";
    ReportSharedWith[ReportSharedWith["Project"] = 2] = "Project";
    ReportSharedWith[ReportSharedWith["ProjectContractedOrganizations"] = 3] = "ProjectContractedOrganizations";
    ReportSharedWith[ReportSharedWith["ProjectDirectlyContractedOrganizations"] = 4] = "ProjectDirectlyContractedOrganizations";
    ReportSharedWith[ReportSharedWith["SpecificOrganizations"] = 5] = "SpecificOrganizations";
    ReportSharedWith[ReportSharedWith["SpecificUsers"] = 6] = "SpecificUsers";
})($d175770e6e5170f5$export$fbac3d2f26b21a45 || ($d175770e6e5170f5$export$fbac3d2f26b21a45 = {}));
const $d175770e6e5170f5$export$ec623b127a8c6d17 = [
    "table",
    "dashboard"
];
const $d175770e6e5170f5$export$16e3502ebc32b20f = {
    "=": "Equal to",
    "<>": "Not equal to",
    "<": "Less than",
    "<=": "Less than or equal to",
    ">": "Greater than",
    ">=": "Greater than or equal to",
    in: "Any of",
    "not in": "None of",
    startswith: "Starts with",
    notstartswith: "Does not start with",
    contains: "Contains",
    notcontains: "Does not contain",
    blank: "Is blank/unanswered",
    notblank: "Is not blank/unanswered"
};
const $d175770e6e5170f5$export$cc43c7363164eb92 = Object.assign({}, $d175770e6e5170f5$export$16e3502ebc32b20f, {
    "<": "Before",
    "<=": "On or before",
    ">": "After",
    ">=": "On or after"
});
const $d175770e6e5170f5$export$ccbce4efa7f8029b = /*@__PURE__*/ Object.keys($d175770e6e5170f5$export$16e3502ebc32b20f);
const $d175770e6e5170f5$export$80f624d7e49719a5 = [
    "=",
    "<>",
    ">",
    ">=",
    "<",
    "<="
];
function $d175770e6e5170f5$export$4477c442bd5c2a6d(op) {
    return $d175770e6e5170f5$export$80f624d7e49719a5.includes(op);
}
function $d175770e6e5170f5$export$398604a469f7de9a(op, a, b) {
    if (typeof a !== typeof b) throw new Error(`Expected typeof a "${typeof a}" to match typeof "${typeof b}".`);
    switch(op){
        case "<":
            return a < b;
        case "<=":
            return a <= b;
        case "<>":
            return a !== b;
        case "=":
            return a === b;
        case ">":
            return a > b;
        case ">=":
            return a >= b;
        default:
            throw new Error(`Unexpected operator "${op}"`);
    }
}
const $d175770e6e5170f5$export$f96a750883d122bd = [
    "count",
    "count-distinct",
    "sum",
    "min",
    "max",
    "avg",
    "median",
    "stdev",
    "var",
    "last-created",
    "last-started",
    "last-ended"
];
const $d175770e6e5170f5$export$3604b59051dae160 = {
    count: "int",
    "count-distinct": "int",
    sum: "inherit-number",
    min: "inherit",
    max: "inherit",
    avg: "decimal",
    median: "decimal",
    stdev: "decimal",
    var: "decimal",
    "last-created": "inherit",
    "last-started": "inherit",
    "last-ended": "inherit"
};
const $d175770e6e5170f5$export$b042dddb068285f3 = {
    "last-created": "[create_datetime] desc",
    "last-started": "[start_date] desc",
    "last-ended": "[end_date] desc, [start_date] desc"
};
const $d175770e6e5170f5$export$d49918c49ed303c4 = [
    "count-distinct",
    "sum",
    "avg",
    "median",
    "stdev",
    "var",
    "min",
    "max",
    "last-created",
    "last-started",
    "last-ended"
];
const $d175770e6e5170f5$export$3b6f3277d945000d = [
    "sum",
    "avg",
    "median",
    "stdev",
    "var",
    "min",
    "max"
];
const $d175770e6e5170f5$export$fea7054315128246 = {
    count: [],
    "count-distinct": [
        "uniqueidentifier",
        "varchar100",
        "int",
        "bit",
        "currency",
        "decimal",
        "date",
        "activity"
    ],
    sum: [
        "int",
        "currency",
        "decimal"
    ],
    avg: [
        "int",
        "currency",
        "decimal"
    ],
    median: [
        "int",
        "currency",
        "decimal"
    ],
    stdev: [
        "int",
        "currency",
        "decimal"
    ],
    var: [
        "int",
        "currency",
        "decimal"
    ],
    min: [
        "uniqueidentifier",
        "varchar100",
        "int",
        "bit",
        "currency",
        "decimal",
        "date"
    ],
    max: [
        "uniqueidentifier",
        "varchar100",
        "int",
        "bit",
        "currency",
        "decimal",
        "date"
    ],
    "last-created": [
        "uniqueidentifier",
        "varchar100",
        "varcharmax",
        "int",
        "bit",
        "currency",
        "decimal",
        "date",
        "activity"
    ],
    "last-started": [
        "uniqueidentifier",
        "varchar100",
        "varcharmax",
        "int",
        "bit",
        "currency",
        "decimal",
        "date",
        "activity"
    ],
    "last-ended": [
        "uniqueidentifier",
        "varchar100",
        "varcharmax",
        "int",
        "bit",
        "currency",
        "decimal",
        "date",
        "activity"
    ]
};
const $d175770e6e5170f5$export$78c94180fed6d79f = {
    count: "Count",
    "count-distinct": "Distinct count",
    sum: "Sum",
    min: "Minimum",
    max: "Maximum",
    avg: "Average",
    median: "Median",
    stdev: "Standard deviation",
    var: "Variance",
    "last-created": "Most recently created",
    "last-started": "Most recently started",
    "last-ended": "Most recently ended"
};
const $d175770e6e5170f5$export$2dff0e8aabc7fdcc = [
    // custom:
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.attachment_count,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_id,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_dow,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.subscribed,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.comment_create_user_id,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.comment_mentioned_user_id,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.is_precise,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.is_precise,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.is_precise,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_mailing.is_precise,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.is_precise,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_mailing.is_precise,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.projects,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_physical.is_precise,
    // composite:
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.address,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.address,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.address,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_email.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_email.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_phone.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_email.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.full_name,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.address,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_mailing.address,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_phone.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_email.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.primary_phone.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_phone.formatted,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_physical.address
];
function $d175770e6e5170f5$export$3cb1b09c699eed1(column, property, expressionType) {
    // no grouping for composite props or properties whose choice type is not 'single' or 'none'.
    if ($d175770e6e5170f5$export$2dff0e8aabc7fdcc.includes(property?.property_id ?? NaN) || property?.response && !([
        "none",
        "single",
        "multiple"
    ].includes(property.choice_type) || property.type === "activity")) return [
        "none"
    ];
    // grouping only for activity properties.
    if (property?.type === "activity") return [
        "none",
        "group"
    ];
    if (property?.choice_type === "single") return [
        "none",
        "group",
        ...$d175770e6e5170f5$export$d49918c49ed303c4
    ];
    if (property?.choice_type === "multiple") return [
        "none",
        ...$d175770e6e5170f5$export$d49918c49ed303c4
    ];
    if (property && column.type === "standard" || property && column.type === "subquery" && [
        "min",
        "max",
        "last-created",
        "last-started",
        "last-ended"
    ].includes(column.aggregate)) switch(property.type){
        case "date":
            return [
                "none",
                "group",
                "count",
                "count-distinct",
                "max",
                "min"
            ];
        case "currency":
        case "int":
        case "decimal":
            return [
                "none",
                "group",
                "count",
                "count-distinct",
                "sum",
                "avg",
                "median",
                "stdev",
                "var",
                "max",
                "min"
            ];
        case "varchar100":
            return [
                "none",
                "group",
                "count",
                "count-distinct",
                "max",
                "min"
            ];
        case "varcharmax":
            return [
                "none"
            ];
        case "bit":
            return [
                "none",
                "group"
            ];
        case "uniqueidentifier":
            return [
                "none",
                "group",
                "count",
                "count-distinct",
                "max",
                "min"
            ];
        default:
            return [
                "none"
            ];
    }
    else if (column.type === "subquery") switch(column.aggregate){
        case "sum":
        case "count":
        case "count-distinct":
        case "avg":
        case "median":
        case "stdev":
        case "var":
            return [
                "none",
                "sum",
                "avg",
                "median",
                "stdev",
                "var",
                "max",
                "min"
            ];
        default:
            return [
                "none"
            ];
    }
    else if (column.type === "expression") switch(expressionType){
        case "date":
        case "datetime":
            return [
                "none",
                "group",
                "max",
                "min"
            ];
        case "int":
        case "decimal":
            return [
                "none",
                ...expressionType === "int" ? [
                    "group"
                ] : [],
                "sum",
                "avg",
                "median",
                "stdev",
                "var",
                "max",
                "min"
            ];
        case "string":
            return [
                "none",
                "group"
            ];
        case "boolean":
        default:
            return [
                "none"
            ];
    }
    else return [
        "none"
    ];
}
const $d175770e6e5170f5$export$fd54d9a8ae729fbf = /*@__PURE__*/ new Map([
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.first_name,
        "empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.gender,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.gender_identity,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.sexual_orientation,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.race,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.ethnicity,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.marital_status,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_language,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.dob,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.city,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.region_abbr,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.subregion,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.postal_code,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.ssn,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.veteran_id,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.medicaid_id,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.agingis_id,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.scsep_participant_id,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.user_id,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.end_date,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.due_date,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_user_id,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.city,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.region_abbr,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.subregion,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.postal_code,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.city,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.region_abbr,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.subregion,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.postal_code,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.city,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.region_abbr,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.subregion,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.postal_code,
        "null-or-empty-string"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.classification,
        "null"
    ],
    [
        (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.fein,
        "null"
    ]
]);
function $d175770e6e5170f5$export$fa24b530c7fccc85(property) {
    if (property.response) return "null";
    return $d175770e6e5170f5$export$fd54d9a8ae729fbf.get(property.property_id);
}
const $d175770e6e5170f5$export$f258709b40073be1 = {
    parameters: 30,
    filters: 10,
    sorts: 4,
    columns: 26,
    inItems: 75,
    shares: 10,
    expressionMaxLength: 100,
    parameterSelectItems: 24,
    parameterNameMaxLength: 30,
    parameterLabelMaxLength: 20,
    parameterDescriptionMaxLength: 200
};
const $d175770e6e5170f5$export$578da1e890e33f2 = {
    me: {
        id: "b0000000-0000-0000-0000-000000000000",
        title: "@Me"
    },
    myOrganization: {
        id: "b0000000-0000-0000-0000-000000000001",
        title: "@My Organization"
    },
    createUser: {
        id: "b0000000-0000-0000-0000-000000000002",
        title: "@Creator"
    },
    createOrganization: {
        id: "b0000000-0000-0000-0000-000000000003",
        title: "@Creator Organization"
    },
    allUsers: {
        id: "b0000000-0000-0000-0000-000000000004",
        title: "@All Users"
    },
    allOrganizations: {
        id: "b0000000-0000-0000-0000-000000000005",
        title: "@All Organizations"
    },
    myOrganizationCity: {
        id: "@MyOrganizationCity",
        title: `@My Organization's City`
    },
    myOrganizationState: {
        id: "@MyOrganizationState",
        title: `@My Organization's State`
    },
    myOrganizationCounty: {
        id: "@MyOrganizationCounty",
        title: `@My Organization's County`
    },
    myOrganizationContracts: {
        id: "@MyOrganizationContracts",
        title: `@My Organization's Contracts`
    }
};
const $d175770e6e5170f5$export$40ac6cdb7593af40 = "ffffffff-eeee-dddd-cccc-aaaaaaaaaaaa";
function $d175770e6e5170f5$export$bea42d731e2b5580(report, userOrganization) {
    if (report.create_user_id === userOrganization.user_id && report.create_organization_id === userOrganization.organization_id && (0, $7787380576b51463$export$3da2623e77b27bff)(userOrganization, "Writer")) return false;
    if (report.is_shared !== $d175770e6e5170f5$export$fbac3d2f26b21a45.None && userOrganization.organization_id === report.create_organization_id && (0, $7787380576b51463$export$3da2623e77b27bff)(userOrganization, "Admin")) return false;
    return true;
}
const $d175770e6e5170f5$export$bc527ea0389902ad = [
    "grandparent-activity",
    "parent-activity",
    "child-activities",
    "grandchild-activities",
    "person-activities",
    "sibling-activities",
    "assigned-activities",
    "created-activities",
    "contracted-activities",
    "activity",
    "person",
    "user_organization",
    "organization_project"
];
const $d175770e6e5170f5$export$416b29773ad00249 = {
    "grandparent-activity": "activity",
    "parent-activity": "activity",
    "child-activities": "activity",
    "grandchild-activities": "activity",
    "person-activities": "activity",
    "sibling-activities": "activity",
    "assigned-activities": "activity",
    "created-activities": "activity",
    "contracted-activities": "activity",
    activity: "activity",
    person: "person",
    user_organization: "user_organization",
    organization_project: "organization_project"
};
function $d175770e6e5170f5$export$5c5d0ff25a8e814f(columns) {
    const useGrouping = columns.some((c)=>c.grouping.type !== "none");
    if (useGrouping) {
        for (const column of columns)if (column.grouping.type === "none") column.sort = null;
    }
    columns.filter((x)=>x.sort).sort((a, b)=>+a.sort[0] - +b.sort[0]).slice(0, 4).forEach((x, i)=>{
        x.sort = `${i}/${x.sort.split("/")[1]}`;
    });
    if (!columns.some((x)=>x.sort)) {
        const first = columns.find((x)=>!useGrouping || x.grouping.type !== "none");
        if (first) first.sort = "0/asc";
    }
}
const $d175770e6e5170f5$export$cc1aa38ac6389ee9 = [
    {
        value: "",
        text: "None"
    },
    {
        value: "0/asc",
        text: "Ascending (1)",
        group: "Primary sort"
    },
    {
        value: "0/desc",
        text: "Descending (1)",
        group: "Primary sort"
    },
    {
        value: "1/asc",
        text: "Ascending (2)",
        group: "Secondary sort"
    },
    {
        value: "1/desc",
        text: "Descending (2)",
        group: "Secondary sort"
    },
    {
        value: "2/asc",
        text: "Ascending (3)",
        group: "Third sort"
    },
    {
        value: "2/desc",
        text: "Descending (3)",
        group: "Third sort"
    },
    {
        value: "3/asc",
        text: "Ascending (4)",
        group: "Fourth sort"
    },
    {
        value: "3/desc",
        text: "Descending (4)",
        group: "Fourth sort"
    }
];
function $d175770e6e5170f5$export$52e8fef74ca2c3f(index, column, entity_type, properties) {
    if (column.type === "subquery" || column.type === "expression") return column.label || `Column ${(0, $d0aca128151552ea$export$672971f1d929056c)(index)}`;
    const property = properties[column.property_id];
    return column.label || $d175770e6e5170f5$export$233f7d0145f2eab8(entity_type, property);
}
const $d175770e6e5170f5$export$99da40ee05a17718 = /^\$[A-Z][A-Z0-9_]{0,28}$/;
function $d175770e6e5170f5$export$b73bfbf6fdaaef10(parameter) {
    return parameter.type === "expression" || parameter.type === "subquery";
}
const $d175770e6e5170f5$export$c365c01fc93c1363 = [
    "expression",
    "literal-date",
    "literal-number",
    "select-date",
    "select-number",
    "user",
    "organization",
    "subquery"
];
const $d175770e6e5170f5$export$d03a77ff9f0df745 = {
    expression: "Formula",
    "literal-date": "Date",
    "literal-number": "Number",
    "select-date": "Date pick list",
    "select-number": "Number pick list",
    user: "Users",
    organization: "Organizations",
    subquery: "Data lookup"
};
var $d175770e6e5170f5$export$9df03d41453bd752;
(function(ReportSubscriptionJobState) {
    ReportSubscriptionJobState[ReportSubscriptionJobState["Scheduled"] = 0] = "Scheduled";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Processing"] = 1] = "Processing";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Complete"] = 2] = "Complete";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Exception"] = 3] = "Exception";
    ReportSubscriptionJobState[ReportSubscriptionJobState["Expired"] = 4] = "Expired";
})($d175770e6e5170f5$export$9df03d41453bd752 || ($d175770e6e5170f5$export$9df03d41453bd752 = {}));
const $d175770e6e5170f5$export$f0656e6b02897626 = {
    activity: {
        parameters: [],
        columns: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.activity_definition_id,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.status,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_id,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_user_id,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.start_date,
                grouping: {
                    type: "none"
                },
                sort: "0/desc"
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.end_date,
                grouping: {
                    type: "none"
                },
                sort: null
            }
        ],
        filters: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.status,
                operator: "in",
                value: (0, $0dc330fba39b622a$export$cfa4e26f21007dcc).map((id)=>({
                        id: id,
                        title: (0, $0dc330fba39b622a$export$db8da96cb205ed52)[id][0, $f2e3bdb9929a0de6$export$d7f512c98c859244]
                    }))
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_user_id,
                operator: "in",
                value: [
                    $d175770e6e5170f5$export$578da1e890e33f2.me
                ]
            }
        ],
        dashboard_elements: []
    },
    person: {
        parameters: [],
        columns: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.full_name,
                grouping: {
                    type: "none"
                },
                sort: "0/asc"
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.dob,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.gender,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.address,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.create_user_id,
                grouping: {
                    type: "none"
                },
                sort: null
            }
        ],
        filters: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.create_organization_id,
                operator: "in",
                value: [
                    $d175770e6e5170f5$export$578da1e890e33f2.myOrganization
                ]
            }
        ],
        dashboard_elements: []
    },
    user_organization: {
        parameters: [],
        columns: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.login,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.family_name,
                grouping: {
                    type: "none"
                },
                sort: "0/asc"
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.given_name,
                grouping: {
                    type: "none"
                },
                sort: "1/asc"
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.email,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.primary_phone.formatted,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.projects,
                grouping: {
                    type: "none"
                },
                sort: null
            }
        ],
        filters: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.organization_id,
                operator: "in",
                value: [
                    $d175770e6e5170f5$export$578da1e890e33f2.myOrganization
                ]
            }
        ],
        dashboard_elements: []
    },
    organization_project: {
        parameters: [],
        columns: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.organization_id,
                grouping: {
                    type: "none"
                },
                sort: "0/asc"
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.project_id,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.project_join_date,
                grouping: {
                    type: "none"
                },
                sort: null
            },
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_physical.region_abbr,
                grouping: {
                    type: "none"
                },
                sort: null
            }
        ],
        filters: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.is_active,
                operator: "=",
                value: true
            }
        ],
        dashboard_elements: []
    }
};
const $d175770e6e5170f5$export$e8a3b3d1dac2a917 = ()=>({
        parameters: [
            {
                type: "literal-date",
                name: "$START_DATE",
                label: "Start Date",
                value: `${new Date().getFullYear()}-01-01`
            },
            {
                type: "literal-date",
                name: "$END_DATE",
                label: "End Date",
                value: `${new Date().getFullYear()}-12-31`
            }
        ],
        columns: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.start_date,
                grouping: {
                    type: "none"
                },
                sort: "0/asc"
            }
        ],
        filters: [
            {
                type: "standard",
                property_id: (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.start_date,
                operator: "<",
                value: new Date((0, $dbca384612ad025b$export$5c333a116e949cdd)).toISOString().substr(0, 10)
            }
        ],
        dashboard_elements: []
    });
function $d175770e6e5170f5$export$f91313b44e1447ea(definition) {
    const ids = new Set();
    const add = (item)=>{
        if (item.type === "subquery") {
            if (item.aggregate !== "count") ids.add(item.subquery_property_id);
            item.filters?.forEach(add);
        } else if (item.type === "standard") ids.add(item.property_id);
    };
    definition.filters.forEach(add);
    definition.columns.forEach(add);
    definition.parameters.forEach(add);
    return Array.from(ids).sort();
}
function $d175770e6e5170f5$export$233f7d0145f2eab8(entity, property) {
    let label = property.label;
    if (property.response || property.entity_type === entity) return label;
    if (!/^[A-Z][A-Z]/.test(label)) label = label.toLowerCase();
    const entitySingular = $d175770e6e5170f5$export$ffda6d73471681a0[property.entity_type].singular[0, $f2e3bdb9929a0de6$export$d7f512c98c859244];
    return `${entitySingular} ${label}`;
}
function $d175770e6e5170f5$export$156328d95560793b(filter, property) {
    const aggregate = filter.type === "standard" ? "max" : filter.aggregate;
    const resultType = $d175770e6e5170f5$export$3604b59051dae160[aggregate];
    switch(resultType){
        case "decimal":
        case "int":
        case "inherit-number":
            return [
                ...$d175770e6e5170f5$export$80f624d7e49719a5
            ];
        case "inherit":
            {
                if (!property) return [];
                let ops;
                switch(property.type){
                    case "signature":
                    case "medications":
                    case "attachment":
                        ops = [];
                        break;
                    case "currency":
                    case "date":
                    case "decimal":
                    case "int":
                        if (property.choice_type === "none") ops = [
                            "=",
                            "<",
                            "<=",
                            ">",
                            ">="
                        ];
                        else ops = [
                            "in",
                            "not in"
                        ];
                        break;
                    case "varchar100":
                        if (property.choice_type === "none") ops = [
                            "=",
                            "<",
                            "<=",
                            ">",
                            ">=",
                            "startswith",
                            "notstartswith",
                            "contains",
                            "notcontains"
                        ];
                        else ops = [
                            "in",
                            "not in"
                        ];
                        break;
                    case "varcharmax":
                        ops = [
                            "=",
                            "startswith",
                            "notstartswith",
                            "contains",
                            "notcontains"
                        ];
                        break;
                    case "uniqueidentifier":
                        if (property.choice_type === "none") throw new Error(`Expected uniqueidentifier property to have choice_type ("${property.property_id}").`);
                        ops = [
                            "in",
                            "not in"
                        ];
                        break;
                    case "bit":
                        ops = [
                            "="
                        ];
                        break;
                    case "activity":
                        ops = [
                            "in",
                            "not in"
                        ];
                        break;
                    default:
                        throw new Error(`Unsupported property type "${property.type}".`);
                }
                if ($d175770e6e5170f5$export$fa24b530c7fccc85(property)) ops.push("blank", "notblank");
                return ops;
            }
        default:
            throw new Error(`Unexpected aggregate function result type "${resultType}".`);
    }
}
function $d175770e6e5170f5$export$bce341c22388011b(filter, property, operator) {
    const aggregate = filter.type === "standard" ? "max" : filter.aggregate;
    const resultType = $d175770e6e5170f5$export$3604b59051dae160[aggregate];
    switch(resultType){
        case "decimal":
        case "int":
            return {
                type: resultType,
                choice_type: "none"
            };
        case "inherit-number":
        case "inherit":
            if (!property) return null;
            switch(property.type){
                case "medications":
                case "signature":
                case "attachment":
                    if (operator === "blank" || operator === "notblank") return "blank";
                    return null;
                case "bit":
                case "currency":
                case "date":
                case "decimal":
                case "int":
                case "varchar100":
                case "varcharmax":
                case "uniqueidentifier":
                case "activity":
                    if (operator === "blank" || operator === "notblank") return "blank";
                    return property;
                default:
                    throw new Error(`Unsupported property type "${property.type}".`);
            }
        default:
            throw new Error(`Unexpected aggregate function result type "${resultType}".`);
    }
}
const $d175770e6e5170f5$export$457cf8f69ee54250 = {
    single_choice: "single_choice",
    multiple_choice: "multiple_choice",
    boolean: "boolean",
    date: "date",
    decimal: "decimal",
    currency: "currency",
    int: "int",
    row_href: "row_href",
    composite_address: "composite_address",
    composite_email: "composite_email",
    composite_phone: "composite_phone",
    composite_full_name: "composite_full_name",
    value_map: "value_map"
};
function $d175770e6e5170f5$export$13d77bb70d7b9d75(parameter, properties) {
    if (parameter.aggregate === "count") return {
        type: "int"
    };
    const aggregateResultType = $d175770e6e5170f5$export$3604b59051dae160[parameter.aggregate];
    switch(aggregateResultType){
        case "decimal":
            return {
                type: "decimal"
            };
        case "int":
            return {
                type: "int"
            };
        case "inherit-number":
        case "inherit":
            const property = properties.find((p)=>p.property_id === parameter.subquery_property_id);
            if (!property) throw new Error(`Unable to find subquery property ${parameter.subquery_property_id}.`);
            switch(property.type){
                case "int":
                    return {
                        type: "int",
                        property: property
                    };
                case "currency":
                case "decimal":
                    return {
                        type: "decimal",
                        property: property
                    };
                case "date":
                    return {
                        type: "datetime",
                        property: property
                    };
                case "bit":
                    return {
                        type: "boolean",
                        property: property
                    };
                case "varchar100":
                case "varcharmax":
                    return {
                        type: "string",
                        property: property
                    };
                default:
                    return {
                        type: null,
                        property: property
                    };
            }
        default:
            throw new Error(`Unexpected aggregate result type "${aggregateResultType}" for subquery property ${parameter.subquery_property_id}.`);
    }
}
function $d175770e6e5170f5$export$292a5b8f6eaffa0b(selected_parameter_values, parameter_output_values) {
    return {
        ...selected_parameter_values ?? {},
        ...Object.entries(parameter_output_values).reduce((acc, [key, value])=>{
            if (value !== null) acc[key] = value;
            return acc;
        }, {})
    };
}
function $d175770e6e5170f5$export$619b3092022ea8ea(parent, parameters) {
    const { parameter_types: parameter_types, parameter_values: parameter_values } = parent;
    const inherited = {};
    for (const { name: name, type: type } of parameters){
        if (type === "expression" || type === "subquery") continue;
        if (type === "organization" || type === "user") {
            const match = parent.parameters.find((p)=>p.name === name && p.type === type);
            if (match) inherited[name] = parameter_values[name] ?? match.value;
            continue;
        }
        if ((type === "literal-date" || type === "select-date") && [
            "date",
            "datetime"
        ].includes(parameter_types[name])) {
            inherited[name] = parameter_values[name];
            continue;
        }
        if ((type === "literal-number" || type === "select-number") && [
            "int",
            "decimal"
        ].includes(parameter_types[name])) {
            inherited[name] = parameter_values[name];
            continue;
        }
    }
    return inherited;
}
function $d175770e6e5170f5$export$8731bf6742d09f4c(search, parameter_values) {
    for (const [key, value] of Object.entries(parameter_values)){
        const name = `parameter_${key.substr(1).toLowerCase()}`;
        if (typeof value === "string") search.set(name, value);
        else if (typeof value === "number") search.set(name, value.toString());
        else if (Array.isArray(value)) search.set(name, JSON.stringify(value));
    }
    return search;
}
function $d175770e6e5170f5$export$8e08adbb69aa1ec5(search, parameters) {
    const parameter_values = {};
    const prefix = "parameter_";
    let count = 0;
    for (let [key, value] of search){
        value = value.trim();
        if (!key.toLowerCase().startsWith(prefix) || value === "") continue;
        const name = "$" + key.substr(prefix.length).toUpperCase();
        const parameter = parameters.find((p)=>p.name === name);
        switch(parameter?.type){
            case "literal-date":
            case "select-date":
                if ((0, $629fab7fb0c19ec3$export$a22775fa5e2eebd9)(value, {
                    type: "string",
                    format: "date"
                })) {
                    parameter_values[name] = value;
                    count++;
                }
                continue;
            case "literal-number":
            case "select-number":
                {
                    const number = parseFloat(value);
                    if (isFinite(number)) {
                        parameter_values[name] = number;
                        count++;
                    }
                    continue;
                }
            case "user":
            case "organization":
                {
                    let raw;
                    try {
                        raw = JSON.parse(value);
                    } catch  {
                        continue;
                    }
                    if ((0, $629fab7fb0c19ec3$export$a22775fa5e2eebd9)(raw, {
                        type: "array",
                        minItems: 1,
                        maxItems: $d175770e6e5170f5$export$f258709b40073be1.inItems,
                        items: (0, $d9fbf6499db8c776$export$132ea886f1bee90)
                    }).valid) {
                        parameter_values[name] = raw;
                        count++;
                    }
                    continue;
                }
        }
    }
    return {
        parameter_values: parameter_values,
        count: count
    };
}
const $d175770e6e5170f5$export$16e3170b54ac652e = [
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_phone.type,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_email.type,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_email.type,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_email.type,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.primary_phone.type,
    (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_phone.type
];


const $5ec20dbd8175d55e$var$PARSED = Symbol("PARSED");
function $5ec20dbd8175d55e$export$cbe32539d61674a2(data) {
    if (data[$5ec20dbd8175d55e$var$PARSED]) return data[$5ec20dbd8175d55e$var$PARSED];
    const obj = Object.create(null);
    const accruedMasks = Object.create(null);
    for (const [key, value] of data){
        if (typeof value !== "string") throw new Error(`Unexpected value type: ${value}`);
        let parsedValue = value// https://www.w3.org/MarkUp/html-spec/html-spec_8.html#SEC8.2.1
        // The form field names and values are escaped: space characters are replaced by `+', and then
        // reserved characters are escaped as per [URL]; that is, non-alphanumeric characters are
        // replaced by `%HH', a percent sign and two hexadecimal digits representing the ASCII code of
        // the character. Line breaks, as in multi-line text field values, are represented as CR LF
        // pairs, i.e. `%0D%0A'.
        .replaceAll("\r\n", "\n");
        let [pointer, type, ...args] = key.split(":");
        // temporary, remove after updates have been live for a while
        if (type === "default") type = "";
        type || (type = pointer.endsWith("_id") ? "nullstring" : "string");
        if (args.includes("parametric") && (0, $d175770e6e5170f5$export$99da40ee05a17718).test(value)) {
            parsedValue = value;
            (0, $91beb2998e956c83$export$adaa4cf7ef1b65be)(obj, "/" + pointer, parsedValue);
            continue;
        }
        switch(type){
            case "string":
                parsedValue = value;
                break;
            case "nullstring":
                parsedValue = value === "" ? null : value;
                break;
            case "boolean":
                parsedValue = value === "true";
                break;
            case "number":
                parsedValue = value === "" ? null : parseFloat(value);
                break;
            case "integer":
                parsedValue = value === "" ? null : parseInt(value);
                break;
            case "mask-shift":
                {
                    const current = accruedMasks[pointer] ?? 0;
                    parsedValue = current + 2 ** parseInt(value);
                    accruedMasks[pointer] = parsedValue;
                    break;
                }
            case "mask-sum":
                {
                    const current = accruedMasks[pointer] ?? 0;
                    parsedValue = current + parseInt(value);
                    accruedMasks[pointer] = parsedValue;
                    break;
                }
            case "date":
                {
                    if (value === "") {
                        parsedValue = null;
                        break;
                    }
                    if (args.includes("relative") && (0, $dbca384612ad025b$export$aebd7d4ffee5ebdd)(value)) {
                        parsedValue = value;
                        break;
                    }
                    const d = new Date(value);
                    if (isFinite(d.getTime()) && d.getTime() >= (0, $dbca384612ad025b$export$5c333a116e949cdd) && d.getTime() <= (0, $dbca384612ad025b$export$a75f2bff57811055)) {
                        parsedValue = d.toISOString().substr(0, 10);
                        break;
                    }
                    parsedValue = null;
                    break;
                }
            case "json":
                parsedValue = JSON.parse(value);
                break;
            default:
                throw new Error(`Unexpected type directive "${type}" in "${key}".`);
        }
        (0, $91beb2998e956c83$export$adaa4cf7ef1b65be)(obj, "/" + pointer, parsedValue);
    }
    data[$5ec20dbd8175d55e$var$PARSED] = obj;
    return obj;
}




function $ba5ed3cba264080f$export$10eb477033c32543(locale, responses, propertyMap, dependencies) {
    return dependencies.map((property_id)=>{
        const property = propertyMap[property_id];
        if (!property) return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li class="color-fg-danger">
        Unknown property ${property_id}
      </li>`;
        const label = property.label;
        const response = responses[`p${property_id}`];
        const answered = response !== undefined && response !== null;
        const displayValue = (0, $669809489e0e2c7d$export$b69667b9fc24675e)({
            property: property,
            value: response,
            locale: locale,
            showScore: true,
            activities: []
        });
        return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
      <li class="${answered ? "color-fg-success" : ""}">
        ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$1d8a03084661a191), answered ? "" : "v-hidden")} ${label}:
        <em>${displayValue}</em>
      </li>
    `;
    });
}



const $159e4db42da5d545$var$controllers = new WeakSet();
function $159e4db42da5d545$export$2385a24977818dd0(controller) {
    $159e4db42da5d545$var$controllers.add(controller);
    if (controller.shadowRoot) $159e4db42da5d545$export$f5153ed4b04fdf21(controller.shadowRoot);
    $159e4db42da5d545$var$bindElements(controller);
    $159e4db42da5d545$export$905ee29d742fce(controller.ownerDocument);
}
function $159e4db42da5d545$export$f5153ed4b04fdf21(root) {
    $159e4db42da5d545$var$bindElements(root);
    $159e4db42da5d545$export$905ee29d742fce(root);
}
const $159e4db42da5d545$var$observers = new WeakMap();
function $159e4db42da5d545$export$905ee29d742fce(el = document) {
    if ($159e4db42da5d545$var$observers.has(el)) return $159e4db42da5d545$var$observers.get(el);
    let closed = false;
    const observer = new MutationObserver((mutations)=>{
        for (const mutation of mutations){
            if (mutation.type === "attributes" && mutation.target instanceof Element) $159e4db42da5d545$var$bindActions(mutation.target);
            else if (mutation.type === "childList" && mutation.addedNodes.length) {
                for (const node of mutation.addedNodes)if (node instanceof Element) $159e4db42da5d545$var$bindElements(node);
            }
        }
    });
    observer.observe(el, {
        childList: true,
        subtree: true,
        attributeFilter: [
            "data-action"
        ]
    });
    const subscription = {
        get closed () {
            return closed;
        },
        unsubscribe () {
            closed = true;
            $159e4db42da5d545$var$observers.delete(el);
            observer.disconnect();
        }
    };
    $159e4db42da5d545$var$observers.set(el, subscription);
    return subscription;
}
function $159e4db42da5d545$var$bindElements(root) {
    for (const el of root.querySelectorAll("[data-action]"))$159e4db42da5d545$var$bindActions(el);
    // Also bind the controller to itself
    if (root instanceof Element && root.hasAttribute("data-action")) $159e4db42da5d545$var$bindActions(root);
}
// Bind a single function to all events to avoid anonymous closure performance penalty.
function $159e4db42da5d545$var$handleEvent(event) {
    const el = event.currentTarget;
    for (const binding of $159e4db42da5d545$var$bindings(el))if (event.type === binding.type) {
        const controller = el.closest(binding.tag);
        if ($159e4db42da5d545$var$controllers.has(controller) && typeof controller[binding.method] === "function") controller[binding.method](event);
        const root = el.getRootNode();
        if (root instanceof ShadowRoot && $159e4db42da5d545$var$controllers.has(root.host) && root.host.matches(binding.tag)) {
            const shadowController = root.host;
            if (typeof shadowController[binding.method] === "function") shadowController[binding.method](event);
        }
    }
}
function* $159e4db42da5d545$var$bindings(el) {
    for (const action of (el.getAttribute("data-action") || "").trim().split(/\s+/)){
        const eventSep = action.lastIndexOf(":");
        const methodSep = Math.max(0, action.lastIndexOf("#")) || action.length;
        yield {
            type: action.slice(0, eventSep),
            tag: action.slice(eventSep + 1, methodSep),
            method: action.slice(methodSep + 1) || "handleEvent"
        };
    }
}
function $159e4db42da5d545$var$bindActions(el) {
    for (const binding of $159e4db42da5d545$var$bindings(el))el.addEventListener(binding.type, $159e4db42da5d545$var$handleEvent);
}


const $89c72635121fe752$export$7e9152eee80b168f = (str)=>String(typeof str === "symbol" ? str.description : str).replace(/([A-Z]($|[a-z]))/g, "-$1").replace(/--/g, "-").replace(/^-|-$/, "").toLowerCase();
const $89c72635121fe752$export$6e0977d6448738a4 = (str, type = "property")=>{
    const dashed = $89c72635121fe752$export$7e9152eee80b168f(str);
    if (!dashed.includes("-")) throw new DOMException(`${type}: ${String(str)} is not a valid ${type} name`, "SyntaxError");
    return dashed;
};


function $ffcf580ef90d17f8$export$6503ec6e8aabbaf(classObject) {
    const name = (0, $89c72635121fe752$export$7e9152eee80b168f)(classObject.name).replace(/-element$/, "");
    try {
        window.customElements.define(name, classObject);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window[classObject.name] = customElements.get(name);
    } catch (e) {
        // The only reason for window.customElements.define to throw a `NotSupportedError`
        // is if the element has already been defined.
        if (!(e instanceof DOMException && e.name === "NotSupportedError")) throw e;
    }
    return classObject;
}


/**
 * findTarget will run `querySelectorAll` against the given controller, plus
 * its shadowRoot, returning any the first child that:
 *
 *  - Matches the selector of `[data-target~="tag.name"]` where tag is the
 *  tagName of the given HTMLElement, and `name` is the given `name` argument.
 *
 *  - Closest ascendant of the element, that matches the tagname of the
 *  controller, is the specific instance of the controller itself - in other
 *  words it is not nested in other controllers of the same type.
 *
 */ function $77fe3787e15eb027$export$7b12e7cdde3e579d(controller, name) {
    const tag = controller.tagName.toLowerCase();
    if (controller.shadowRoot) for (const el of controller.shadowRoot.querySelectorAll(`[data-target~="${tag}.${name}"]`)){
        if (!el.closest(tag)) return el;
    }
    for (const el of controller.querySelectorAll(`[data-target~="${tag}.${name}"]`)){
        if (el.closest(tag) === controller) return el;
    }
}
function $77fe3787e15eb027$export$e6c09e60297821e4(controller, name) {
    const tag = controller.tagName.toLowerCase();
    const targets = [];
    if (controller.shadowRoot) {
        for (const el of controller.shadowRoot.querySelectorAll(`[data-targets~="${tag}.${name}"]`))if (!el.closest(tag)) targets.push(el);
    }
    for (const el of controller.querySelectorAll(`[data-targets~="${tag}.${name}"]`))if (el.closest(tag) === controller) targets.push(el);
    return targets;
}





function $b3a0e8a56f0f8cc8$export$8360d16b03002d26(element) {
    for (const template of element.querySelectorAll("template[data-shadowroot]"))if (template.parentElement === element) element.attachShadow({
        mode: template.getAttribute("data-shadowroot") === "closed" ? "closed" : "open"
    }).append(template.content.cloneNode(true));
}




const $eb3c1389b956a11c$var$attrKey = "attr";
function $eb3c1389b956a11c$export$7aabe8b3a840d2fd(proto, key) {
    (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, $eb3c1389b956a11c$var$attrKey).add(key);
}
/**
 * initializeAttrs is called with a set of class property names (if omitted, it
 * will look for any properties tagged with the `@attr` decorator). With this
 * list it defines property descriptors for each property that map to `data-*`
 * attributes on the HTMLElement instance.
 *
 * It works around Native Class Property semantics - which are equivalent to
 * calling `Object.defineProperty` on the instance upon creation, but before
 * `constructor()` is called.
 *
 * If a class property is assigned to the class body, it will infer the type
 * (using `typeof`) and define an appropriate getter/setter combo that aligns
 * to that type. This means class properties assigned to Numbers can only ever
 * be Numbers, assigned to Booleans can only ever be Booleans, and assigned to
 * Strings can only ever be Strings.
 *
 * This is automatically called as part of `@controller`. If a class uses the
 * `@controller` decorator it should not call this manually.
 */ const $eb3c1389b956a11c$var$initialized = new WeakSet();
function $eb3c1389b956a11c$export$798400a729264cd9(instance, names) {
    if ($eb3c1389b956a11c$var$initialized.has(instance)) return;
    $eb3c1389b956a11c$var$initialized.add(instance);
    const proto = Object.getPrototypeOf(instance);
    const prefix = proto?.constructor?.attrPrefix ?? "data-";
    if (!names) names = (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, $eb3c1389b956a11c$var$attrKey);
    for (const key of names){
        const value = instance[key];
        const name = (0, $89c72635121fe752$export$6e0977d6448738a4)(`${prefix}${key}`);
        let descriptor = {
            configurable: true,
            get () {
                return this.getAttribute(name) || "";
            },
            set (newValue) {
                this.setAttribute(name, newValue || "");
            }
        };
        if (typeof value === "number") descriptor = {
            configurable: true,
            get () {
                return Number(this.getAttribute(name) || 0);
            },
            set (newValue) {
                this.setAttribute(name, newValue);
            }
        };
        else if (typeof value === "boolean") descriptor = {
            configurable: true,
            get () {
                return this.hasAttribute(name);
            },
            set (newValue) {
                this.toggleAttribute(name, newValue);
            }
        };
        Object.defineProperty(instance, key, descriptor);
        if (key in instance && !instance.hasAttribute(name)) descriptor.set.call(instance, value);
    }
}
function $eb3c1389b956a11c$export$ed3b9fa3b306413c(classObject) {
    let observed = classObject.observedAttributes || [];
    const prefix = classObject.attrPrefix ?? "data-";
    const attrToAttributeName = (name)=>(0, $89c72635121fe752$export$6e0977d6448738a4)(`${prefix}${name}`);
    Object.defineProperty(classObject, "observedAttributes", {
        configurable: true,
        get () {
            return [
                ...(0, $9e554c3b768f72a7$export$6990040ee07315)(classObject.prototype, $eb3c1389b956a11c$var$attrKey)
            ].map(attrToAttributeName).concat(observed);
        },
        set (attributes) {
            observed = attributes;
        }
    });
}


const $ad59128f5070c7aa$var$dynamicElements = new Map();
const $ad59128f5070c7aa$var$ready = new Promise((resolve)=>{
    if (document.readyState !== "loading") resolve();
    else document.addEventListener("readystatechange", ()=>resolve(), {
        once: true
    });
});
const $ad59128f5070c7aa$var$firstInteraction = new Promise((resolve)=>{
    const controller = new AbortController();
    controller.signal.addEventListener("abort", ()=>resolve());
    const listenerOptions = {
        once: true,
        passive: true,
        signal: controller.signal
    };
    const handler = ()=>controller.abort();
    document.addEventListener("mousedown", handler, listenerOptions);
    // eslint-disable-next-line github/require-passive-events
    document.addEventListener("touchstart", handler, listenerOptions);
    document.addEventListener("keydown", handler, listenerOptions);
    document.addEventListener("pointerdown", handler, listenerOptions);
});
const $ad59128f5070c7aa$var$visible = (tagName)=>new Promise((resolve)=>{
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) {
                resolve();
                observer.disconnect();
                return;
            }
        }, {
            // Currently the threshold is set to 256px from the bottom of the viewport
            // with a threshold of 0.1. This means the element will not load until about
            // 2 keyboard-down-arrow presses away from being visible in the viewport,
            // giving us some time to fetch it before the contents are made visible
            rootMargin: "0px 0px 256px 0px",
            threshold: 0.01
        });
        for (const el of document.querySelectorAll(tagName))observer.observe(el);
    });
const $ad59128f5070c7aa$var$strategies = {
    ready: ()=>$ad59128f5070c7aa$var$ready,
    firstInteraction: ()=>$ad59128f5070c7aa$var$firstInteraction,
    visible: $ad59128f5070c7aa$var$visible
};
const $ad59128f5070c7aa$var$timers = new WeakMap();
function $ad59128f5070c7aa$var$scan(element) {
    cancelAnimationFrame($ad59128f5070c7aa$var$timers.get(element) || 0);
    $ad59128f5070c7aa$var$timers.set(element, requestAnimationFrame(()=>{
        for (const tagName of $ad59128f5070c7aa$var$dynamicElements.keys()){
            const child = element instanceof Element && element.matches(tagName) ? element : element.querySelector(tagName);
            if (customElements.get(tagName) || child) {
                const strategyName = child?.getAttribute("data-load-on") || "ready";
                const strategy = strategyName in $ad59128f5070c7aa$var$strategies ? $ad59128f5070c7aa$var$strategies[strategyName] : $ad59128f5070c7aa$var$strategies.ready;
                // eslint-disable-next-line github/no-then
                for (const cb of $ad59128f5070c7aa$var$dynamicElements.get(tagName) || [])strategy(tagName).then(cb);
                $ad59128f5070c7aa$var$dynamicElements.delete(tagName);
                $ad59128f5070c7aa$var$timers.delete(element);
            }
        }
    }));
}
let $ad59128f5070c7aa$var$elementLoader;
function $ad59128f5070c7aa$export$f44ed0cb636dc95(tagNameOrObj, singleCallback) {
    if (typeof tagNameOrObj === "string" && singleCallback) tagNameOrObj = {
        [tagNameOrObj]: singleCallback
    };
    for (const [tagName, callback] of Object.entries(tagNameOrObj)){
        if (!$ad59128f5070c7aa$var$dynamicElements.has(tagName)) $ad59128f5070c7aa$var$dynamicElements.set(tagName, new Set());
        $ad59128f5070c7aa$var$dynamicElements.get(tagName).add(callback);
    }
    $ad59128f5070c7aa$export$d1203567a167490e(document);
}
function $ad59128f5070c7aa$export$d1203567a167490e(target) {
    $ad59128f5070c7aa$var$elementLoader || ($ad59128f5070c7aa$var$elementLoader = new MutationObserver((mutations)=>{
        if (!$ad59128f5070c7aa$var$dynamicElements.size) return;
        for (const mutation of mutations){
            for (const node of mutation.addedNodes)if (node instanceof Element) $ad59128f5070c7aa$var$scan(node);
        }
    }));
    $ad59128f5070c7aa$var$scan(target);
    $ad59128f5070c7aa$var$elementLoader.observe(target, {
        subtree: true,
        childList: true
    });
}


const $9e554c3b768f72a7$var$symbol = Symbol.for("catalyst");
class $9e554c3b768f72a7$export$442891cd14dc451a {
    constructor(classObject){
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const delegate = this;
        const connectedCallback = classObject.prototype.connectedCallback;
        classObject.prototype.connectedCallback = function() {
            delegate.connectedCallback(this, connectedCallback);
        };
        const disconnectedCallback = classObject.prototype.disconnectedCallback;
        classObject.prototype.disconnectedCallback = function() {
            delegate.disconnectedCallback(this, disconnectedCallback);
        };
        const attributeChangedCallback = classObject.prototype.attributeChangedCallback;
        classObject.prototype.attributeChangedCallback = function(name, oldValue, newValue) {
            delegate.attributeChangedCallback(this, name, oldValue, newValue, attributeChangedCallback);
        };
        let observedAttributes = classObject.observedAttributes || [];
        Object.defineProperty(classObject, "observedAttributes", {
            configurable: true,
            get () {
                return delegate.observedAttributes(this, observedAttributes);
            },
            set (attributes) {
                observedAttributes = attributes;
            }
        });
        (0, $eb3c1389b956a11c$export$ed3b9fa3b306413c)(classObject);
        (0, $ffcf580ef90d17f8$export$6503ec6e8aabbaf)(classObject);
    }
    observedAttributes(instance, observedAttributes) {
        return observedAttributes;
    }
    connectedCallback(instance, connectedCallback) {
        instance.toggleAttribute("data-catalyst", true);
        customElements.upgrade(instance);
        (0, $b3a0e8a56f0f8cc8$export$8360d16b03002d26)(instance);
        (0, $eb3c1389b956a11c$export$798400a729264cd9)(instance);
        (0, $159e4db42da5d545$export$2385a24977818dd0)(instance);
        connectedCallback?.call(instance);
        if (instance.shadowRoot) {
            (0, $159e4db42da5d545$export$f5153ed4b04fdf21)(instance.shadowRoot);
            (0, $ad59128f5070c7aa$export$d1203567a167490e)(instance.shadowRoot);
        }
    }
    disconnectedCallback(element, disconnectedCallback) {
        disconnectedCallback?.call(element);
    }
    attributeChangedCallback(instance, name, oldValue, newValue, attributeChangedCallback) {
        (0, $eb3c1389b956a11c$export$798400a729264cd9)(instance);
        if (name !== "data-catalyst" && attributeChangedCallback) attributeChangedCallback.call(instance, name, oldValue, newValue);
    }
}
function $9e554c3b768f72a7$export$6990040ee07315(proto, name) {
    if (!Object.prototype.hasOwnProperty.call(proto, $9e554c3b768f72a7$var$symbol)) {
        const parent = proto[$9e554c3b768f72a7$var$symbol];
        const map = proto[$9e554c3b768f72a7$var$symbol] = new Map();
        if (parent) for (const [key, value] of parent)map.set(key, new Set(value));
    }
    const map = proto[$9e554c3b768f72a7$var$symbol];
    if (!map.has(name)) map.set(name, new Set());
    return map.get(name);
}


function $dbc93f05a5c2ccff$export$44271b4f0c6a3563(proto, key) {
    (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, "target").add(key);
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            return (0, $77fe3787e15eb027$export$7b12e7cdde3e579d)(this, key);
        }
    });
}
function $dbc93f05a5c2ccff$export$121e5dccf103a51e(proto, key) {
    (0, $9e554c3b768f72a7$export$6990040ee07315)(proto, "targets").add(key);
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            return (0, $77fe3787e15eb027$export$e6c09e60297821e4)(this, key);
        }
    });
}



function $435094da9351c1d8$export$de3b759ab07e4403(classObject) {
    new (0, $9e554c3b768f72a7$export$442891cd14dc451a)(classObject);
}










function $11312eb9db73a681$export$361afa7bac659960(locale, alertId = (0, $5cb959b633531006$export$9e1c824dbb29e809)()) {
    const id = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div
    class="flash flash-error py-2 span-12 width-full"
    id="${alertId}"
    role="group"
    tabindex="-1"
    aria-labelledby="${id}"
    hidden
  >
    <strong id="${id}">${(0, $2868cc1235412e16$export$a86e9a9bd8b26f8a)[locale]}</strong>
    <ul class="pl-3" aria-label="${(0, $2868cc1235412e16$export$a1c514477edb0163)[locale]}"></ul>
  </div>`;
}

var $d16ce7f43425aac3$export$5c65f956a8d65120;
(function(ValidationErrorCode) {
    ValidationErrorCode["EmailUndeliverable"] = "email-undeliverable";
    ValidationErrorCode["ReCaptchaFailed"] = "recaptcha-failed";
    ValidationErrorCode["PasswordTooWeak"] = "password-too-weak";
    ValidationErrorCode["PasswordTooCommon"] = "password-too-common";
    ValidationErrorCode["LoginUnavailable"] = "login-unavailable";
    ValidationErrorCode["EmailAlreadyRegistered"] = "email-already-registered";
    ValidationErrorCode["EmailAlreadyVerified"] = "email-already-verified";
    ValidationErrorCode["EmailNotRegistered"] = "email-not-registered";
    ValidationErrorCode["UserAlreadyOrganizationMember"] = "user-already-organization-member";
    ValidationErrorCode["CannotInviteYourself"] = "cannot-invite-yourself";
    ValidationErrorCode["UserAlreadyInvited"] = "user-already-invited";
    ValidationErrorCode["InvitationEmailSentTooRecently"] = "invitation-email-sent-too-recently";
    ValidationErrorCode["DuplicateName"] = "duplicate-name";
    ValidationErrorCode["ReferencesPreventDeletion"] = "references-prevent-deletion";
    ValidationErrorCode["OrganizationAlreadyInvited"] = "organization-already-invited";
    ValidationErrorCode["OrganizationAlreadyProjectMember"] = "organization-already-project-member";
})($d16ce7f43425aac3$export$5c65f956a8d65120 || ($d16ce7f43425aac3$export$5c65f956a8d65120 = {}));
const $d16ce7f43425aac3$export$34f98ade51897c1e = {
    [$d16ce7f43425aac3$export$5c65f956a8d65120.EmailUndeliverable]: "Email address is undeliverable. Contact support for assistance if you believe this to be an error.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.PasswordTooWeak]: "Password is too weak.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.PasswordTooCommon]: "Password is too common.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.ReCaptchaFailed]: "Activity flagged by bot detection. Contact support for assistance if you believe this to be an error.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.LoginUnavailable]: '"{value}" is unavailable. {label} must be unique.',
    [$d16ce7f43425aac3$export$5c65f956a8d65120.EmailAlreadyRegistered]: "Email already registered.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.EmailAlreadyVerified]: "Email already verified. Go ahead and sign-in.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.EmailNotRegistered]: "No account matching specified email.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.UserAlreadyOrganizationMember]: "User is already a member of the organization.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.CannotInviteYourself]: "You cannot invite yourself.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.UserAlreadyInvited]: "User already invited.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.InvitationEmailSentTooRecently]: "Invitation emails cannot be sent more than once per hour.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.DuplicateName]: "{label} must be unique.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.ReferencesPreventDeletion]: "Unable to delete. Record is in use.",
    [$d16ce7f43425aac3$export$5c65f956a8d65120.OrganizationAlreadyInvited]: '"{value}" has already been invited to the project.',
    [$d16ce7f43425aac3$export$5c65f956a8d65120.OrganizationAlreadyProjectMember]: "The organization is already a member of the project."
};
const $d16ce7f43425aac3$export$3b74fc4995751e90 = "validation-error";
function $d16ce7f43425aac3$export$939b1e8f8fdbed84(obj) {
    return !!obj && typeof obj === "object" && "type" in obj && obj.type === $d16ce7f43425aac3$export$3b74fc4995751e90 && "message" in obj && typeof obj.message === "string";
}

const $2a2dcd2529aa22ab$export$1514431ed310ac1b = 30;
const $2a2dcd2529aa22ab$export$c26822de30dcb83e = /^[a-zA-Z\d](?:[a-zA-Z\d]|-(?=[a-zA-Z\d])){0,29}$/;
const $2a2dcd2529aa22ab$export$49a9f30d59ee31c2 = new RegExp($2a2dcd2529aa22ab$export$c26822de30dcb83e.source.substr(1, $2a2dcd2529aa22ab$export$c26822de30dcb83e.source.length - 2)).source;
const $2a2dcd2529aa22ab$var$markdownTerminators = /[\s\\`*^[\]!&<>{}$%@~\-+=:\/_\,\.\?();]/.source;
const $2a2dcd2529aa22ab$export$bcd7648bc82e2622 = new RegExp(`(^|${$2a2dcd2529aa22ab$var$markdownTerminators})(@${$2a2dcd2529aa22ab$export$49a9f30d59ee31c2}\/${$2a2dcd2529aa22ab$export$49a9f30d59ee31c2})(?:$|${$2a2dcd2529aa22ab$var$markdownTerminators})`, "g");
const $2a2dcd2529aa22ab$export$b8d98489a2ee4ef9 = new RegExp(`(^|${$2a2dcd2529aa22ab$var$markdownTerminators})(@${$2a2dcd2529aa22ab$export$49a9f30d59ee31c2})\/(${$2a2dcd2529aa22ab$export$49a9f30d59ee31c2})($|${$2a2dcd2529aa22ab$var$markdownTerminators})`, "g");
const $2a2dcd2529aa22ab$export$dbb5f91a13f35b86 = /^[a-f0-9]{24}$/;
const $2a2dcd2529aa22ab$export$c1524f9be65f4b8a = 14;
const $2a2dcd2529aa22ab$export$9ea34356f788bd3a = 70; // auth0 limit is 72






function $1523f11a9aa97b8a$export$8ab937f042a29230(target) {
    return target instanceof HTMLSelectElement || target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement;
}
function $1523f11a9aa97b8a$export$51ca0221714b36af(target) {
    if (target instanceof HTMLTextAreaElement) target.value = target.value.trim();
    else if (target instanceof HTMLInputElement && (target.type === "text" || target.type === "email")) target.value = target.value.trim();
}
function $1523f11a9aa97b8a$var$escapeRegex(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function $1523f11a9aa97b8a$var$getPointerSiblingRegex(pointer) {
    const [, base, name] = /(^.*\/)(?:\d+)(\/[^:]*)/.exec(pointer) ?? [];
    if (base === undefined || name === undefined) throw new Error(`Unexpected pointer "${pointer}" for sibling expression.`);
    const source = `^${$1523f11a9aa97b8a$var$escapeRegex(base)}\\d+${$1523f11a9aa97b8a$var$escapeRegex(name)}(?::|$)`;
    return new RegExp(source);
}
function $1523f11a9aa97b8a$export$3ef28703d495bc16(input) {
    const r = $1523f11a9aa97b8a$var$getPointerSiblingRegex(input.name);
    return Array.from(input.form.elements).filter($1523f11a9aa97b8a$export$8ab937f042a29230).filter((el)=>r.test(el.name));
}
function $1523f11a9aa97b8a$export$7d38c4fd1103f2c4(form, disabled) {
    for (const element of form.elements)if (element instanceof HTMLButtonElement && element.type === "submit" && !element.hasAttribute("name")) element.toggleAttribute("disabled", disabled);
}
function $1523f11a9aa97b8a$export$7f9cba67632f8265(form, busy) {
    for (const element of form.elements)if (element instanceof HTMLButtonElement && element.type === "submit") element.classList.toggle("btn-busy", busy);
}
function $1523f11a9aa97b8a$export$d711e159ced15444(form) {
    for (const element of form.elements)if (element instanceof HTMLButtonElement && element.type === "submit" && element.hasAttribute("new") && element.lastElementChild instanceof HTMLSpanElement) element.lastElementChild.textContent = (0, $2868cc1235412e16$export$f093e2a834170186)[(0, $58ccb23ba1dadd05$export$180605366c04f0cd)()];
}
function $1523f11a9aa97b8a$export$2d71e4ce1d783c30(form) {
    const disabled = Array.from(form.elements).filter((el)=>$1523f11a9aa97b8a$export$8ab937f042a29230(el) && el.disabled);
    for (const el of disabled)el.disabled = false;
    const data = new FormData(form);
    for (const el of disabled)el.disabled = true;
    return data;
}
function $1523f11a9aa97b8a$export$18cb2924d47bc4a1(iterable) {
    for (const _ of iterable)return false;
    return true;
}


const $f3a2ac2d620bcd8b$export$4ad0f6b40344a757 = "form-validation-error";
const $f3a2ac2d620bcd8b$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
function $f3a2ac2d620bcd8b$export$236350842f3cd9bc(input) {
    const labelElement = (input.type === "checkbox" || input.type === "radio" ? input.closest("fieldset")?.querySelector("legend") : null) ?? input.labels?.[0];
    const textElement = labelElement?.querySelector("[data-label-text]") ?? labelElement;
    const label = textElement?.textContent ?? input.getAttribute("aria-label");
    if (!label) throw new Error(`${input.nodeName} name="${input.name}" id="${input.id}" has no associated label.`);
    return label.trim();
}
function $f3a2ac2d620bcd8b$var$getGroup(input) {
    const group = input.closest(".form-group");
    if (!group) throw new Error(`${input.nodeName} type="${input.type}" name="${input.name}" id="${input.id}" is not within a .form-group. Parent #${input.parentElement?.id} ${input.parentElement?.className}`);
    return group;
}
function $f3a2ac2d620bcd8b$var$getBody(input) {
    const body = input.closest(".form-group-body");
    if (!body) throw new Error(`${input.nodeName} name="${input.name}" id="${input.id}" is not within a .form-group-body`);
    return body;
}
function $f3a2ac2d620bcd8b$var$createErrorAlert(form) {
    const formLayout = form.classList.contains("row") ? form : form.querySelector(".row") ?? form;
    formLayout.insertAdjacentHTML("afterbegin", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $11312eb9db73a681$export$361afa7bac659960)($f3a2ac2d620bcd8b$var$locale)));
    return formLayout.firstElementChild;
}
function $f3a2ac2d620bcd8b$var$getErrorAlert(form, warn = false) {
    const id = form.getAttribute("error-alert");
    const errorAlert = id ? document.getElementById(id) : form.querySelector(".flash.flash-error, .flash.flash-warn") ?? $f3a2ac2d620bcd8b$var$createErrorAlert(form);
    if (!errorAlert) throw new Error(`getErrorAlert: No element with id="${id}" found.`);
    errorAlert.classList.toggle("flash-warn", warn);
    errorAlert.classList.toggle("flash-error", !warn);
    const title = errorAlert.firstElementChild;
    title.textContent = warn ? (0, $2868cc1235412e16$export$145bab8279e1c23d)[$f3a2ac2d620bcd8b$var$locale] : (0, $2868cc1235412e16$export$a86e9a9bd8b26f8a)[$f3a2ac2d620bcd8b$var$locale];
    return {
        errorAlert: errorAlert,
        errorList: errorAlert.lastElementChild
    };
}
function $f3a2ac2d620bcd8b$var$createErrorNote(input) {
    const note = document.createElement("p");
    note.id = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    input.setAttribute("aria-describedby", `${note.id} ${input.getAttribute("aria-describedby") || ""}`);
    note.classList.add("note", "error");
    $f3a2ac2d620bcd8b$var$getBody(input).after(note);
    return note;
}
function $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9(element, message) {
    const group = $f3a2ac2d620bcd8b$var$getGroup(element);
    const note = group.querySelector(".note.error") || $f3a2ac2d620bcd8b$var$createErrorNote(element);
    note.textContent = message;
}
function $f3a2ac2d620bcd8b$export$2e85a6f149681784(input, label) {
    if (input.closest("[validate-required]")?.getAttribute("validate-required") === "false") return null;
    const customMessage = input.getAttribute("validate-required-message");
    if (input.required && input.value.trim() === "" && !(input instanceof HTMLSelectElement && (input.options.length === 0 || input.options.length === 1 && input.options[0].value === "")) && input.type !== "checkbox" && input.type !== "radio") return customMessage ? customMessage.replaceAll("{label}", label) : (0, $2868cc1235412e16$export$433bde3ee140c661)[$f3a2ac2d620bcd8b$var$locale](label);
    if (input.type === "checkbox") {
        const items = input.form?.elements.namedItem(input.name);
        if (!items || !(items instanceof RadioNodeList) || items.item(items.length - 1) !== input || Array.from(items).find((x)=>x.checked)) return null;
        return customMessage ? customMessage.replaceAll("{label}", label) : (0, $2868cc1235412e16$export$433bde3ee140c661)[$f3a2ac2d620bcd8b$var$locale](label);
    }
    if (input.type === "radio") {
        const items = input.form?.elements.namedItem(input.name);
        if (!items || !(items instanceof RadioNodeList) || items.item(items.length - 1) !== input || Array.from(items).find((x)=>x.checked && x.value.length)) return null;
        return customMessage ? customMessage.replaceAll("{label}", label) : (0, $2868cc1235412e16$export$433bde3ee140c661)[$f3a2ac2d620bcd8b$var$locale](label);
    }
    return null;
}
function $f3a2ac2d620bcd8b$var$validatePattern(input, label) {
    if (input.validity.patternMismatch) return input.getAttribute("pattern-message") ?? (0, $2868cc1235412e16$export$dd0340f9174b778)[$f3a2ac2d620bcd8b$var$locale](label);
    return null;
}
function $f3a2ac2d620bcd8b$var$validateStep(input, label) {
    if (input.validity.stepMismatch) {
        const step = input.getAttribute("step");
        if (step === "1") return (0, $2868cc1235412e16$export$cd31f99195471735)[$f3a2ac2d620bcd8b$var$locale](label);
        return (0, $2868cc1235412e16$export$b79fa817bdc814b1)[$f3a2ac2d620bcd8b$var$locale](label, step);
    }
    return null;
}
function $f3a2ac2d620bcd8b$var$validateLoginPattern(input, label) {
    if (input.validity.valid && input.hasAttribute("validate-login") && input.value && !(0, $2a2dcd2529aa22ab$export$c26822de30dcb83e).test(input.value)) return (0, $2868cc1235412e16$export$110dcc8e73edbe8a)[$f3a2ac2d620bcd8b$var$locale](label);
    return null;
}
function $f3a2ac2d620bcd8b$var$validateUrl(input, label) {
    if (input.type === "url" && input.value && (input.validity.typeMismatch || input.validity.patternMismatch)) return (0, $2868cc1235412e16$export$6c61a0cedd6edf45)[$f3a2ac2d620bcd8b$var$locale](label);
    return null;
}
function $f3a2ac2d620bcd8b$var$validateEmail(input, label) {
    if (input.type === "email" && input.value && input.validity.typeMismatch) return (0, $2868cc1235412e16$export$6c61a0cedd6edf45)[$f3a2ac2d620bcd8b$var$locale](label);
    return null;
}
function $f3a2ac2d620bcd8b$var$validateMinLength(input, label) {
    if ((input instanceof HTMLTextAreaElement || input instanceof HTMLInputElement) && // input.validity.tooShort
    input.minLength !== -1 && input.value.length !== 0 && input.value.length < input.minLength) return (0, $2868cc1235412e16$export$9138bb72343fb2ba)[$f3a2ac2d620bcd8b$var$locale](label, input.minLength);
    return null;
}
function $f3a2ac2d620bcd8b$var$validateMaxLength(input, label) {
    if ((input instanceof HTMLTextAreaElement || input instanceof HTMLInputElement) && // input.validity.tooLong
    input.maxLength !== -1 && input.value.length !== 0 && input.value.length > input.maxLength) return (0, $2868cc1235412e16$export$eefaf1eea407a083)[$f3a2ac2d620bcd8b$var$locale](label, input.maxLength);
    return null;
}
function $f3a2ac2d620bcd8b$var$validateMin(input, label) {
    if (input instanceof HTMLInputElement && input.value.length !== 0 && input.validity.rangeUnderflow) return (0, $2868cc1235412e16$export$76d1215b01ac474d)[$f3a2ac2d620bcd8b$var$locale](label, input.getAttribute("min"));
    return null;
}
function $f3a2ac2d620bcd8b$var$validateMax(input, label) {
    if (input instanceof HTMLInputElement && input.validity.rangeOverflow) return (0, $2868cc1235412e16$export$7090c56f2894c141)[$f3a2ac2d620bcd8b$var$locale](label, input.getAttribute("max"));
    return null;
}
function $f3a2ac2d620bcd8b$var$validateLessOrEqual(input, label) {
    let otherName;
    let other;
    let dateValue;
    let otherDateValue;
    if (input instanceof HTMLInputElement && input.value.length !== 0 && (otherName = input.getAttribute("validate-less-or-equal")) && (other = input.form?.elements.namedItem(otherName)) && other instanceof HTMLInputElement && other.value.length !== 0 && other.type === input.type && (input.type === "number" && input.valueAsNumber > other.valueAsNumber || input.type === "text" && input.closest("date-input") && other.closest("date-input") && (dateValue = (0, $dbca384612ad025b$export$7660134aa4da2247)(input.value)) && dateValue && (otherDateValue = (0, $dbca384612ad025b$export$7660134aa4da2247)(other.value)) && otherDateValue && dateValue > otherDateValue)) {
        const otherLabel = $f3a2ac2d620bcd8b$export$236350842f3cd9bc(other);
        return (0, $2868cc1235412e16$export$5d0a69f765a632f4)[$f3a2ac2d620bcd8b$var$locale](label, otherLabel);
    }
    return null;
}
function $f3a2ac2d620bcd8b$var$validateMaxSiblings(input, _label) {
    if (!input.validity.valid || !input.hasAttribute("validate-max-items")) return null;
    const max = +input.getAttribute("validate-max-items");
    const items = (0, $1523f11a9aa97b8a$export$3ef28703d495bc16)(input).filter((x)=>!(x instanceof HTMLInputElement && x.type === "radio" && !x.checked));
    if (items.length > max && items.slice(max).includes(input)) return (0, $2868cc1235412e16$export$22ec1f3944b408e9)[$f3a2ac2d620bcd8b$var$locale](max);
    return null;
}
function $f3a2ac2d620bcd8b$var$validateUniqueSiblings(input, label) {
    if (!input.validity.valid || !input.hasAttribute("validate-unique") || !input.value || input instanceof HTMLInputElement && input.type === "radio" && !input.checked) return null;
    const items = (0, $1523f11a9aa97b8a$export$3ef28703d495bc16)(input);
    const rawMax = input.getAttribute("validate-unique") || "1";
    const max = parseInt(rawMax);
    if (isNaN(max)) return null;
    if (items.filter((x)=>x.value === input.value && !(x instanceof HTMLInputElement && x.type === "radio" && !x.checked)).indexOf(input) >= max) return max === 1 ? (0, $2868cc1235412e16$export$edb12e2f2b2628ce)[$f3a2ac2d620bcd8b$var$locale](label) : (0, $2868cc1235412e16$export$18d990bed133506d)[$f3a2ac2d620bcd8b$var$locale](label, max);
    return null;
}
const $f3a2ac2d620bcd8b$var$validators = [
    $f3a2ac2d620bcd8b$export$2e85a6f149681784,
    $f3a2ac2d620bcd8b$var$validateStep,
    $f3a2ac2d620bcd8b$var$validateMinLength,
    $f3a2ac2d620bcd8b$var$validateMaxLength,
    $f3a2ac2d620bcd8b$var$validateMin,
    $f3a2ac2d620bcd8b$var$validateMax,
    $f3a2ac2d620bcd8b$var$validateUrl,
    $f3a2ac2d620bcd8b$var$validateLoginPattern,
    $f3a2ac2d620bcd8b$var$validatePattern,
    $f3a2ac2d620bcd8b$var$validateEmail,
    $f3a2ac2d620bcd8b$var$validateLessOrEqual,
    $f3a2ac2d620bcd8b$var$validateMaxSiblings,
    $f3a2ac2d620bcd8b$var$validateUniqueSiblings
];
function $f3a2ac2d620bcd8b$export$86f1725708ac86dc(validator) {
    $f3a2ac2d620bcd8b$var$validators.push(validator);
}
function $f3a2ac2d620bcd8b$var$canValidate(target) {
    return (0, $1523f11a9aa97b8a$export$8ab937f042a29230)(target) && target.type !== "hidden" && !(target.type === "radio" && !target.required) && !(target.type === "checkbox" && !target.required);
}
async function $f3a2ac2d620bcd8b$export$ed692cabb252e59b(form, displayValidity = true, scope = form) {
    const errors = [];
    const { errorAlert: errorAlert, errorList: errorList } = $f3a2ac2d620bcd8b$var$getErrorAlert(form, displayValidity === "info");
    if (displayValidity) {
        errorAlert.hidden = true;
        errorList.innerHTML = "";
    }
    for (const input of form.elements){
        if (scope !== form && !scope.contains(input) || !$f3a2ac2d620bcd8b$var$canValidate(input)) continue;
        const label = $f3a2ac2d620bcd8b$export$236350842f3cd9bc(input);
        const group = $f3a2ac2d620bcd8b$var$getGroup(input);
        if (displayValidity) {
            $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9(input, "");
            group.classList.remove("errored");
        }
        for (const validator of $f3a2ac2d620bcd8b$var$validators){
            const message = validator(input, label);
            if (!message) continue;
            if (!form.dispatchEvent(new CustomEvent($f3a2ac2d620bcd8b$export$4ad0f6b40344a757, {
                bubbles: true,
                cancelable: true,
                detail: {
                    validator: validator,
                    form: form,
                    group: group,
                    input: input,
                    label: label,
                    message: message
                }
            }))) continue;
            errors.push({
                input: input,
                message: message
            });
            if (displayValidity) {
                $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9(input, message);
                group.classList.toggle("errored", displayValidity === true);
                const linkTarget = $f3a2ac2d620bcd8b$var$getFirstInputWithName(input) ?? input.closest(".form-group-body")?.querySelector("[id]");
                if (linkTarget) linkTarget.style.scrollMarginTop = `${Math.max(linkTarget.offsetTop - group.offsetTop, 60)}px`;
                errorList.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li>
              <a class="Link--primary" href="#${linkTarget?.id}">${message}</a>
            </li>`));
            }
            break;
        }
    }
    if (errors.length === 0) return {
        valid: true
    };
    if (displayValidity) {
        errorAlert.hidden = false;
        errorAlert.focus();
    }
    return {
        valid: false,
        errors: errors
    };
}
function $f3a2ac2d620bcd8b$var$getFirstInputWithName(input) {
    if (input instanceof HTMLInputElement && (input.type === "checkbox" || input.type === "radio")) {
        input = input.form?.querySelector(`[name="${input.name}"][type="${input.type}"]`) ?? input;
        return input;
    } else return input;
}
function $f3a2ac2d620bcd8b$export$b7702f01a27b2311(target) {
    if (!$f3a2ac2d620bcd8b$var$canValidate(target) && // scenario where a server validation error was added for something that is not normally client-side validated
    !(target instanceof HTMLInputElement && target.closest(".form-group.errored"))) return;
    $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9(target, "");
    $f3a2ac2d620bcd8b$var$getGroup(target).classList.remove("errored");
    const { errorAlert: errorAlert, errorList: errorList } = $f3a2ac2d620bcd8b$var$getErrorAlert(target.form);
    errorList.querySelectorAll(`a[href="#${target.id}"],a[href="#${$f3a2ac2d620bcd8b$var$getFirstInputWithName(target).id}"],a[href="#${target.closest(".form-group-body")?.querySelector("[id]")?.id}"]`).forEach((a)=>a.parentElement.remove());
    if (!errorList.firstElementChild) errorAlert.hidden = true;
}
function $f3a2ac2d620bcd8b$export$7977be5e446db387(form, body) {
    if (!(0, $d16ce7f43425aac3$export$939b1e8f8fdbed84)(body)) {
        $f3a2ac2d620bcd8b$export$dd5ae15f22741a23(form);
        return;
    }
    let { property: property, message: message } = body;
    const { errorAlert: errorAlert, errorList: errorList } = $f3a2ac2d620bcd8b$var$getErrorAlert(form);
    let input = null;
    if (property) for(let i = 0; i < form.elements.length; i++){
        let el = form.elements.item(i);
        if (el instanceof RadioNodeList) el = el.item(0);
        if (el.matches(`:is([name="${property}"],[name^="${property}:"]):not([type="hidden"])`)) {
            input = el;
            break;
        }
    }
    if ((0, $1523f11a9aa97b8a$export$8ab937f042a29230)(input)) {
        const label = $f3a2ac2d620bcd8b$export$236350842f3cd9bc(input);
        message = message.replaceAll("{label}", label).replaceAll("{value}", input.value);
        $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9(input, message);
        const group = $f3a2ac2d620bcd8b$var$getGroup(input);
        group.classList.add("errored");
        input.style.scrollMarginTop = `${Math.max(input.offsetTop - group.offsetTop, 60)}px`;
        errorList.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li>
          <a
            class="Link--primary"
            href="#${input.id || input.closest(".form-group-body")?.querySelector("[id]")?.id}"
            >${message}</a
          >
        </li>`));
    } else errorList.insertAdjacentHTML(`beforeend`, (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li>${message}</li>`));
    errorAlert.hidden = false;
    errorAlert.focus();
}
function $f3a2ac2d620bcd8b$export$dd5ae15f22741a23(form) {
    const { errorAlert: errorAlert, errorList: errorList } = $f3a2ac2d620bcd8b$var$getErrorAlert(form);
    errorList.insertAdjacentHTML(`beforeend`, (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li>${(0, $2868cc1235412e16$export$f725eab7abaa007d)[$f3a2ac2d620bcd8b$var$locale]}</li>`));
    errorAlert.hidden = false;
    errorAlert.focus();
}


var $b7f59518ed83f2ab$exports = {};
var $65619179e53f57ac$exports = {};
"use strict";
$65619179e53f57ac$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $b7f59518ed83f2ab$var$url = new URL("excel-worker.451f2ecc.js", import.meta.url);
$b7f59518ed83f2ab$exports = $65619179e53f57ac$exports($b7f59518ed83f2ab$var$url.toString(), $b7f59518ed83f2ab$var$url.origin, true);


async function $084f49e21d0e189c$export$bf2e8542514694ef(arrayBuffer, name, form, lowerCaseKeys = false) {
    const worker = new Worker($b7f59518ed83f2ab$exports);
    await new Promise((resolve)=>worker.addEventListener("message", resolve, {
            once: true
        }));
    const instruction = {
        arrayBuffer: await arrayBuffer,
        lowerCaseKeys: lowerCaseKeys
    };
    worker.postMessage(instruction);
    const event = await new Promise((resolve)=>worker.addEventListener("message", resolve, {
            once: true
        }));
    worker.terminate();
    if (event.data.type === "xlsx-error") {
        const error = {
            type: "validation-error",
            message: `Error opening "${name}". Ensure the file is a valid Excel file.`
        };
        (0, $f3a2ac2d620bcd8b$export$7977be5e446db387)(form, error);
        return null;
    }
    return event.data.data;
}








function $00cbd9c0279de546$export$de3b759ab07e4403(name) {
    return function(classObject) {
        const connect = classObject.prototype.connectedCallback;
        classObject.prototype.connectedCallback = function() {
            this.toggleAttribute("data-catalyst", true);
            (0, $b3a0e8a56f0f8cc8$export$8360d16b03002d26)(this);
            (0, $eb3c1389b956a11c$export$798400a729264cd9)(this);
            (0, $159e4db42da5d545$export$2385a24977818dd0)(this);
            if (connect) connect.call(this);
            if (this.shadowRoot) (0, $159e4db42da5d545$export$f5153ed4b04fdf21)(this.shadowRoot);
        };
        (0, $eb3c1389b956a11c$export$ed3b9fa3b306413c)(classObject);
        if (!window.customElements.get(name)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window[classObject.name] = classObject;
            window.customElements.define(name, classObject);
        }
    };
}


function $eb08f38ae8877120$export$89348ae70780cd7a(element) {
    const event = new Event("change", {
        bubbles: true
    });
    element.dispatchEvent(event);
    return event;
}
function $eb08f38ae8877120$export$9657601bf1e130ee(element) {
    "scrollIntoViewIfNeeded" in element && typeof element.scrollIntoViewIfNeeded === "function" ? element.scrollIntoViewIfNeeded() : element.scrollIntoView({
        block: "center",
        behavior: "smooth"
    });
}
function $eb08f38ae8877120$export$956fd4dade47957a(element) {
    if (!element) return false;
    const selector = ':is(select,input,textarea,button:is(.btn,.btn-octicon,.btn-link),a,summary):not([hidden],[type="hidden"],.sr-only,[readonly],[tabindex="-1"],[data-action*="click:editable-list#removeListItem"],.btn-close)';
    const target = element instanceof HTMLElement && element.matches(selector) ? element : element.querySelector(selector);
    if (target) {
        if (target instanceof HTMLInputElement) target.select();
        else if (target instanceof HTMLTextAreaElement) target.setSelectionRange(target.value.length, target.value.length);
        target.focus();
        return true;
    }
    return false;
}
function $eb08f38ae8877120$export$e3607ec2d7a891c4(element, classname) {
    if (element.classList.contains(classname)) {
        element.classList.remove(classname);
        setTimeout($eb08f38ae8877120$export$e3607ec2d7a891c4, 0, element, classname);
        return;
    }
    element.classList.add(classname);
    const remove = ()=>element.classList.remove(classname);
    element.addEventListener("animationend", remove);
    element.addEventListener("animationcancel", remove);
}


var $5854062ef7ec26b7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $5854062ef7ec26b7$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
const $5854062ef7ec26b7$var$detailsTabState = {};
let $5854062ef7ec26b7$var$ActivityControllerElement = class ActivityControllerElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.assignmentRuleTimeout = 0;
        this.inputTimeout = 0;
        this.location = new URL(location.href);
        this.editElements = (elementToFocus)=>{
            if (this.elementsContainer?.hidden) {
                this.elementsContainer.hidden = false;
                this.elementsSummaryContainer.remove(); // todo: fix duplicate heading ids
                history.pushState($5854062ef7ec26b7$var$detailsTabState, "", location.pathname + "/details");
                this.location = new URL(location.href);
                document.querySelector('.UnderlineNav-item[aria-current="page"]')?.setAttribute("aria-current", "false");
                document.querySelector('.UnderlineNav-item[href$="/details"]')?.setAttribute("aria-current", "page");
            }
            if (elementToFocus) elementToFocus.scrollIntoView({
                block: elementToFocus.clientHeight > window.innerHeight * 0.8 ? "start" : "center"
            });
            (0, $eb08f38ae8877120$export$956fd4dade47957a)(elementToFocus ?? this.elementsContainer);
            if (elementToFocus?.parentElement instanceof HTMLDetailsElement && !elementToFocus.parentElement.open) {
                elementToFocus.parentElement.open = true;
                elementToFocus.parentElement.dispatchEvent(new ToggleEvent("toggle", {
                    bubbles: true,
                    newState: "open",
                    oldState: "closed"
                }));
            }
        };
        this.nextEventIndex = 0;
        this.applyAssignmentRule = async (body)=>{
            this.assigneePicker.summary.classList.remove("btn-updated");
            const controller = new AbortController();
            setTimeout(()=>controller.abort("timeout"), 5000);
            const url = new URL(this.status_assignment_src, location.origin);
            url.searchParams.set("contract_id", this.form.elements.namedItem("contract_id").value);
            const response = await fetch(`${url.pathname}${url.search}`, {
                method: "POST",
                body: body,
                signal: controller.signal
            });
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
            if (response.status !== 200) return;
            const html = await response.text();
            this.assigneePicker.summary.querySelector("[data-menu-button]").innerHTML = html;
            this.assigneePicker.select();
            this.assigneePicker.summary.classList.add("btn-updated");
            const subscribersTemplate = this.assigneePicker.querySelector("#automatic-subscribers");
            this.form.elements.namedItem("subscribers:json").replaceWith(subscribersTemplate.content);
            const contractsTemplate = this.assigneePicker.querySelector("#assignment-rule-contract");
            this.assigneePicker.contractFormGroupContainer.innerHTML = "";
            this.assigneePicker.contractFormGroupContainer.append(contractsTemplate.content);
        };
        // async updateResponseHistory(
        //   event: Event,
        //   form = this.readForm(),
        //   design = getData<FormDesign>(form.form_design_id)
        // ) {
        //   const element =
        //     event.target instanceof Element && event.target.closest('[form-element]');
        //   if (!element) {
        //     return;
        //   }
        //   const id = element.getAttribute('form-element');
        //   const el = findFormDesignElement(design.elements, el => el.id === id);
        //   if (!el) {
        //     throw new Error(`Unable to find form design element with id "${id}".`);
        //   }
        //   if (el.type !== 'field') {
        //     return;
        //   }
        //   const property = design.properties.find(p => p.name === el.key);
        //   if (!property) {
        //     throw new Error(
        //       `Unable to get property with name "${el.key}" from form design.`
        //     );
        //   }
        //   if (
        //     property.type === 'addresses' ||
        //     property.type === 'phones' ||
        //     property.type === 'emails'
        //   ) {
        //     this.historyCounter.textContent = '0';
        //     this.historyContainer.innerHTML = '';
        //     return;
        //   }
        //   if (!this.history.has(property.property_id)) {
        //     const url = `/api/organizations/${this.organization_id}/people/${form.person_id}/responses/${property.name}`;
        //     this.history.set(
        //       property.property_id,
        //       fetch(url).then(r => {
        //         if (r.ok) {
        //           return r.json();
        //         } else {
        //           this.history.delete(property.property_id);
        //           throw new Error(`Failed to fetch response history "${url}".`);
        //         }
        //       })
        //     );
        //   }
        //   this.historyCounter.textContent = '0';
        //   this.historyContainer.innerHTML = `<span>Loading</span><span class="AnimatedEllipsis"></span>`;
        //   const allHistory = await this.history.get(property.property_id)!;
        //   const history = allHistory.filter(x => x.form_id !== form.form_id);
        //   this.historyCounter.textContent = history.length.toString();
        //   if (history.length) {
        //     const elId = newElementId();
        //     this.historyContainer.innerHTML = render(html`
        //       <h5 id="${elId}">${property.label} history</h5>
        //       <ol class="Box Box--condensed" aria-labelledby="${elId}">
        //         ${history.map(
        //           hi => html`<li class="Box-row d-flex flex-items-center">
        //             <div class="flex-1">
        //               <span class="d-block mb-1 text-bold"
        //                 >${getPropertyDisplayValue(property, hi.value)}</span
        //               >
        //               <a
        //                 href="/${this.organization_login}/people/${uuidToBase58(
        //                   form.person_id!
        //                 )}/forms/${uuidToBase58(hi.form_id)}"
        //                 class="Link--primary f6 text-capitalize"
        //               >
        //                 <relative-time datetime="${hi.create_datetime}"
        //                   >${hi.create_datetime}</relative-time
        //                 >
        //                 in ${hi.form_design_title}</a
        //               >
        //             </div>
        //             ${property.calculated
        //               ? null
        //               : html`<button
        //                   class="btn btn-sm ml-3"
        //                   type="button"
        //                   data-action="click:activity-controller#applyHistoryValue"
        //                   form-id="${hi.form_id}"
        //                   property-id="${property.property_id}"
        //                 >
        //                   Insert
        //                 </button>`}
        //           </li>`
        //         )}
        //       </ol>
        //     `);
        //   } else {
        //     // todo: blankslate
        //     this.historyContainer.innerHTML = render(
        //       html`
        //         <h5>${property.label} history</h5>
        //         <p class="zero-state">No prior responses</p>
        //       `
        //     );
        //   }
        // }
        // async applyHistoryValue({ target }: Event) {
        //   if (!(target instanceof HTMLElement)) {
        //     throw new Error('Expected element target');
        //   }
        //   const property_id = +target.getAttribute('property-id')!;
        //   const form_id = target.getAttribute('form-id')!;
        //   const allHistory = await this.history.get(property_id);
        //   if (!allHistory) {
        //     throw new Error(`Expected history for ${property_id} to be loaded.`);
        //   }
        //   const item = allHistory.find(hi => hi.form_id === form_id);
        //   if (!item) {
        //     throw new Error(
        //       `Expected history value for form "${form_id}"  and property ${property_id} to be available.`
        //     );
        //   }
        //   const form = this.readForm();
        //   const design = getData<FormDesign>(form.form_design_id);
        //   const property = design.properties.find(p => p.property_id === property_id);
        //   if (!property) {
        //     throw new Error(`Property ${property_id} not found in form design.`);
        //   }
        //   const expressionScope = new FormExpressionScope(form, design);
        //   walkFormDesign(design, expressionScope, (el, visible) => {
        //     if (!visible || el.type !== 'field' || el.key !== property.name) {
        //       return;
        //     }
        //     const element = this.form.querySelector(`[form-element="${el.id}"]`);
        //     if (!element) {
        //       throw new Error(`Unable to find form-element with id "${el.id}".`);
        //     }
        //     setActivityElementValue(element, property, item.value, true);
        //   });
        // }
        this.busyUploadingVaccineSurvey = false;
    }
    async connectedCallback() {
        this.detachedAbortController = new AbortController();
        if (location.hash === "#:print:") {
            history.replaceState(undefined, "", location.pathname + location.search);
            let includeFragment;
            while(includeFragment = this.querySelector("include-fragment[src]"))await new Promise((resolve)=>includeFragment.addEventListener("include-fragment-replaced", resolve, {
                    once: true
                }));
            print();
        }
        $5854062ef7ec26b7$var$resolveFieldLinks(this.form, this.editElements);
        const clickHandler = (event)=>{
            const behavior = event.target instanceof Element && event.target.closest("[activity-behavior]")?.getAttribute("activity-behavior");
            switch(behavior){
                case "edit-details":
                    {
                        event.preventDefault();
                        const focusTarget = event.target instanceof HTMLAnchorElement && event.target.getAttribute("href")?.startsWith("#") && document.getElementById(event.target.getAttribute("href").substr(1)) || null;
                        this.editElements(focusTarget);
                        return;
                    }
                case "print-summary":
                case "print-summary-with-comments":
                case "print-details":
                    {
                        const { origin: origin, pathname: pathname, search: search } = location;
                        const actualIsDetails = pathname.endsWith("/details");
                        const requestedIsDetails = behavior === "print-details";
                        if (actualIsDetails === requestedIsDetails) {
                            this.printCommentsItems.forEach((el)=>el.classList.toggle("d-print-none", behavior !== "print-summary-with-comments"));
                            print();
                            addEventListener("afterprint", ()=>this.printCommentsItems.forEach((el)=>el.classList.add("d-print-none")));
                        } else {
                            const requestedPathname = actualIsDetails ? pathname.substr(0, pathname.length - 8) : pathname + "/details";
                            location.href = `${origin}${requestedPathname}${search}#:print:`;
                        }
                        return;
                    }
                default:
                    if (behavior) throw new Error(`Unexpected activity-behavior "${behavior}".`);
            }
        };
        addEventListener("click", clickHandler, {
            capture: true,
            signal: this.detachedAbortController.signal
        });
        const popstateHandler = (event)=>{
            if (event.state === $5854062ef7ec26b7$var$detailsTabState) this.editElements();
            else {
                const url = new URL(location.href);
                if (url.origin + url.pathname + url.search !== this.location.origin + this.location.pathname + this.location.search) location.reload();
            }
        };
        addEventListener("popstate", popstateHandler, {
            signal: this.detachedAbortController.signal
        });
    }
    disconnectedCallback() {
        this.detachedAbortController?.abort();
        this.detachedAbortController = undefined;
    }
    get newCommentTextArea() {
        return this.form.elements.namedItem("comment_body");
    }
    get formBehavior() {
        return this.form.querySelector("form-behavior");
    }
    handleValidationError(event) {
        if (event.detail.group.hasAttribute("form-element") && event.detail.group.classList.contains("form-element--skipped")) event.preventDefault();
        else this.editElements();
    }
    handleServerValidationError() {
        this.editElements();
    }
    focusElement(event) {
        event.preventDefault();
        const idish = event.target instanceof Element && event.target.getAttribute("element-identifier");
        let el = this.querySelector(`[form-element="${idish}"],[name="${idish}"],[name^="${idish}:"],[id="${idish}"]`);
        if (el instanceof HTMLInputElement && el.type === "hidden") el = el.parentElement;
        this.editElements(el);
        el?.closest(".form-group")?.classList.add("element-changed-animation--fast");
    }
    assignToMe() {
        this.editElements();
        this.assigneePicker.assignToMeAndSave();
    }
    async activitySaved(event) {
        // Reset comment textarea and its preview tab.
        const hadComment = this.newCommentTextArea.value.trim() !== "";
        this.newCommentTextArea.value = "";
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.newCommentTextArea);
        this.querySelectorAll("markdown-editor tab-container").forEach((el)=>{
            if (el.tabIndex === 0) el.selectTab(0);
        });
        // Switch to PUT mode body
        if (this.creationFields) {
            this.activity_id = event.detail.headers.get("activity_id");
            this.creationFields.remove();
            for (const el of [
                ...this.needsActivityId,
                ...document.querySelectorAll('#sticky-organization-header [href*="__ACTIVITY_ID__"]')
            ]){
                if (el.matches('[src*="__ACTIVITY_ID__"]')) el.setAttribute("src", el.getAttribute("src").replace("__ACTIVITY_ID__", this.activity_id));
                if (el.matches('[href*="__ACTIVITY_ID__"]')) el.setAttribute("href", el.getAttribute("href").replace("__ACTIVITY_ID__", this.activity_id));
            }
        }
        const html = await event.detail.text();
        this.timelineContainer.innerHTML = html;
        const subscribersContent = this.timelineContainer.querySelector('[id="subscribers-content"]');
        if (subscribersContent) this.subscribersSection.replaceWith(subscribersContent.content);
        const attachmentsContent = this.timelineContainer.querySelector('[id="attachments-content"]');
        if (attachmentsContent) this.attachmentsSection.replaceWith(attachmentsContent.content);
        const eventQuestionnairesContent = this.timelineContainer.querySelector('[id="event-questionnaires-content"]');
        if (eventQuestionnairesContent) this.eventQuestionnairesSection?.replaceWith(eventQuestionnairesContent.content);
        const tabNavContent = this.timelineContainer.querySelector('[id="activity-tabnav-content"]');
        if (tabNavContent) document.getElementById("header-tabnav")?.replaceWith(tabNavContent.content);
        const addChildContent = this.timelineContainer.querySelector('[id="add-child-content"]');
        if (addChildContent) this.addChildPlaceholder?.replaceWith(addChildContent.content);
        this.timelineContainer.querySelectorAll('[id^="attachment-question-"]').forEach((template)=>{
            this.querySelector(`[form-element="${template.id.substr("attachment-question-".length)}"]`)?.replaceWith(template.content);
        });
        this.addAnotherContent?.removeAttribute("hidden");
        if (hadComment) {
            const item = this.timelineContainer.querySelector(".TimelineItem-body:has(.markdown-body)");
            if (item) // Scroll on next tick because scrolling immediately will interfere with requires-submit link clicks.
            setTimeout((0, $eb08f38ae8877120$export$9657601bf1e130ee), 0, item);
        }
        // Previous steps will have artifically dirtied the form... accept those changes.
        this.form.querySelector("form-behavior")?.acceptChanges();
    }
    statusFocus({ target: target }) {
        // clear status id from hash after it receives focus.
        if (target instanceof Element && target.id === location.hash.substr(1)) history.replaceState(undefined, "", location.pathname + location.search);
    }
    recommendationValueInputFocused({ target: target }) {
        target instanceof Element && target.closest(".form-group").querySelector("button,a").focus();
    }
    async subscriptionUpdated(event) {
        const html = await event.detail.text();
        const template = document.createElement("template");
        template.innerHTML = html;
        this.subscribersSection.replaceWith(template.content);
    }
    async editComment(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        const markdownContent = item.querySelector(".markdown-body");
        const activity_comment_id = markdownContent.getAttribute("activity_comment_id");
        const markdown = markdownContent.getAttribute("source-markdown") ?? "";
        const fragment = this.editCommentTemplate.content.cloneNode(true);
        const form = fragment.firstElementChild;
        form.action = `/api/organizations/${this.organization_id}/activities/${this.activity_id}/comments/${activity_comment_id}?_method=PUT`;
        const bodyTextArea = form.elements.namedItem("body");
        bodyTextArea.value = markdown;
        item.append(fragment);
        item.querySelector(".TimelineItem-body").hidden = true;
        await new Promise((resolve)=>setTimeout(resolve));
        (0, $eb08f38ae8877120$export$9657601bf1e130ee)(bodyTextArea);
        bodyTextArea.focus();
    }
    keyDown(event) {
        // When a user presses tab after editing an number/text input and the
        // subsequent field becomes visible due to conditional logic,
        // focus will skip the newly visible field.
        // The following code forces evaluation of the form state early to circumvent the issue.
        if (event.key === "Tab" && document.activeElement instanceof HTMLInputElement && document.activeElement.type === "number") this.handleChange(event);
    }
    editCommentKeyDown(event) {
        if (event.key === "Escape") {
            event.preventDefault();
            this.cancelCommentEdit(event);
        }
    }
    cancelCommentEdit(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        const form = event.target instanceof Element && event.target.closest("form");
        if (form) form.remove();
        item.querySelector(".TimelineItem-body").hidden = false;
    }
    async deleteComment(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        if (!confirm("Are you sure you want to delete this comment?")) return;
        const markdownContent = item.querySelector(".markdown-body");
        const activity_comment_id = markdownContent.getAttribute("activity_comment_id");
        const response = await fetch(`/api/organizations/${this.organization_id}/activities/${this.activity_id}/comments/${activity_comment_id}`, {
            method: "DELETE"
        });
        if (response.ok) item.remove();
    }
    async quoteReply(event) {
        const item = this.getTimelineItem(event);
        if (!item) return;
        const markdown = item.querySelector(".markdown-body")?.getAttribute("source-markdown") ?? "";
        const prompt = `[enter your reply here]`;
        const blockquote = `> ${markdown.split(/\r?\n/).join("\n> ")}\n\n`;
        const start = blockquote.length;
        this.newCommentTextArea.value = blockquote + prompt;
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.newCommentTextArea);
        await new Promise((resolve)=>setTimeout(resolve));
        this.newCommentTextArea.scrollIntoView({
            behavior: "smooth"
        });
        this.newCommentTextArea.focus();
        this.newCommentTextArea.setSelectionRange(start, this.newCommentTextArea.value.length);
    }
    getTimelineItem(event) {
        return event.target instanceof Element && event.target.closest(".TimelineItem");
    }
    getElementsAndProperties(json) {
        if (!this._elementsAndProperties) {
            const { elements: elements, properties: properties, activityDefinition: activityDefinition, standardPropertyValues: standardPropertyValues, rucaLookup: rucaLookup, areaOfPersistentUnemploymentLookup: areaOfPersistentUnemploymentLookup } = JSON.parse(json);
            this._elementsAndProperties = {
                activityDefinition: activityDefinition,
                elements: elements,
                propertyMap: (0, $a3570cdd24dfa717$export$e439fc32198f78c5)(properties, "property_id"),
                standardPropertyValues: standardPropertyValues,
                rucaLookup: rucaLookup,
                areaOfPersistentUnemploymentLookup: areaOfPersistentUnemploymentLookup
            };
        }
        return this._elementsAndProperties;
    }
    handleInput(event) {
        const { target: target } = event;
        if (target instanceof HTMLInputElement && [
            "text",
            "number"
        ].includes(target.type) || target instanceof HTMLTextAreaElement) {
            clearTimeout(this.inputTimeout);
            this.inputTimeout = setTimeout(()=>this.handleChange(event), 300);
        }
    }
    log(event, ...args) {
        var _a;
        if (new URLSearchParams(location.search).has("debug")) {
            const name = event.target instanceof Element && event.target.getAttribute("name") || "(name missing)";
            (_a = event).__log_index__ ?? (_a.__log_index__ = this.nextEventIndex++);
            const index = event.__log_index__;
            console.info(`Handle ${event.type} #${index} on ${name}`, ...args);
        }
    }
    handleChange(event) {
        this.log(event, "Enter handleChange");
        try {
            clearTimeout(this.inputTimeout);
            const formData = (0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(this.form);
            const isModal = this.closest("modal-content");
            const statusChanged = event.type === "change" && event.target instanceof HTMLInputElement && event.target.name === "status";
            if (statusChanged) {
                const status = event.target.value;
                // defer validation until after questions have been updated with required status.
                clearTimeout(this.assignmentRuleTimeout);
                this.assignmentRuleTimeout = setTimeout(()=>{
                    (0, $f3a2ac2d620bcd8b$export$ed692cabb252e59b)(this.form, "info");
                    this.formBehavior.setBusy(this.applyAssignmentRule(formData));
                    if (!isModal) {
                        const statusLabel = document.getElementById("activity-status-label");
                        statusLabel.insertAdjacentHTML("afterend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $99a756c897582e70$export$76dce95b982175c)(status, $5854062ef7ec26b7$var$locale)));
                        statusLabel.remove();
                    }
                }, 0);
            }
            const { responses: responses = {}, definition_json: definition_json, status: status, start_date: start_date, end_date: end_date } = (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)(formData);
            const { activityDefinition: { type: type, duration_days: duration_days }, elements: elements, propertyMap: propertyMap, standardPropertyValues: standardPropertyValues, rucaLookup: rucaLookup, areaOfPersistentUnemploymentLookup: areaOfPersistentUnemploymentLookup } = this.getElementsAndProperties(definition_json);
            if (status) standardPropertyValues.activity_status = status;
            standardPropertyValues.activity_start_date = start_date ?? new Date().toISOString().substr(0, 10);
            standardPropertyValues.activity_end_date = end_date ?? null;
            if (this.assigneePicker) {
                standardPropertyValues.activity_assignee_organization = this.assigneePicker.value?.organization_login ?? null;
                standardPropertyValues.activity_assignee_user = this.assigneePicker.value?.user_login ?? null;
            }
            const scope = new (0, $0dbabea6e8ef01ef$export$241dc8d30919de44)(standardPropertyValues, responses, propertyMap, rucaLookup, areaOfPersistentUnemploymentLookup, {}, undefined);
            const startDateInput = this.form.elements.namedItem("start_date:date");
            const endDateInput = this.form.elements.namedItem("end_date:date");
            const dueDateInput = this.form.elements.namedItem("due_date:date");
            // Set end date required on status change.
            // Set end date value based on whether the status is opened or closed.
            if (statusChanged && endDateInput instanceof HTMLInputElement && !endDateInput.disabled) {
                const required = (0, $0dc330fba39b622a$export$a94a7861f82ee3e6)(type, status ?? standardPropertyValues.activity_status);
                endDateInput.setAttribute("validate-required", String(required));
                const newEndDateValue = required ? (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(new Date()) : "";
                if (!!endDateInput.value !== !!newEndDateValue) {
                    endDateInput.classList.remove("element-changed-animation");
                    endDateInput.value = newEndDateValue;
                    (0, $eb08f38ae8877120$export$89348ae70780cd7a)(endDateInput);
                    setTimeout(()=>endDateInput.classList.add("element-changed-animation"), 0);
                    this.log(event, "Exit handleChange - end date changed");
                    return; // dispatchChange will trigger handleChange again.
                }
            }
            // if start date or end date changed, and end date is before start date, update the date to match
            if (event.type === "change" && startDateInput instanceof HTMLInputElement && endDateInput instanceof HTMLInputElement && endDateInput.value && // document.activeElement !== startDateInput &&
            // document.activeElement !== endDateInput &&
            (event.target === startDateInput || event.target === endDateInput) && !endDateInput.disabled) {
                const startDate = (0, $dbca384612ad025b$export$7660134aa4da2247)(startDateInput.value);
                const endDate = (0, $dbca384612ad025b$export$7660134aa4da2247)(endDateInput.value);
                if (startDate && endDate && startDate > endDate) {
                    const input = event.target === startDateInput ? endDateInput : startDateInput;
                    const value = event.target === startDateInput ? startDate : endDate;
                    input.classList.remove("element-changed-animation");
                    input.value = (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(value);
                    (0, $eb08f38ae8877120$export$89348ae70780cd7a)(input);
                    setTimeout(()=>input.classList.add("element-changed-animation"), 0);
                    this.log(event, "Exit handleChange - start or end date changed");
                    return; // dispatchChange will trigger handleChange again.
                }
            }
            // if start date changed, update due date
            if (event.type === "change" && startDateInput instanceof HTMLInputElement && dueDateInput instanceof HTMLInputElement && // document.activeElement !== startDateInput &&
            // document.activeElement !== dueDateInput &&
            event.target === startDateInput && !startDateInput.disabled) {
                const startDate = (0, $dbca384612ad025b$export$7660134aa4da2247)(startDateInput.value);
                if (startDate) {
                    const value = (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(startDate, duration_days));
                    if (dueDateInput.value !== value) {
                        dueDateInput.classList.remove("element-changed-animation");
                        dueDateInput.value = value;
                        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(dueDateInput);
                        setTimeout(()=>dueDateInput.classList.add("element-changed-animation"), 0);
                        this.log(event, "Exit handleChange - due date changed");
                        return; // dispatchChange will trigger handleChange again.
                    }
                }
            }
            let visibleProperties = formData.has("title") ? 1 : 0;
            let answeredProperties = formData.get("title") ? 1 : 0;
            let changed = null;
            (0, $0dc330fba39b622a$export$d89c0470e9f1cc7e)(elements, scope, (el, visible, currentlyRequired)=>{
                if (changed) return;
                if (visible && el.type === "property") {
                    visibleProperties++;
                    if ((responses[`p${el.property_id}`] ?? "") !== "") answeredProperties++;
                }
                const element = this.form.querySelector(`[form-element="${el.index}"]`);
                if (!element) {
                    if (el.type === "recommendation" || el.type === "event-activity") return;
                    throw new Error(`Unable to locate element corresponding to "${el.index}" ("${el.type}").`);
                }
                const summaryElements = this.querySelectorAll(`[summary-element="${el.index}"]`);
                // show/hide elements based on their visibility expression.
                summaryElements.forEach((el)=>el.toggleAttribute("hidden", !visible));
                element.classList.toggle("form-element--skipped", !visible);
                if (el.type === "heading") {
                    const navLink = this.headingNavLinks.find((x)=>x.getAttribute("element") === el.index.toString());
                    if (navLink) navLink.hidden = !visible;
                }
                // synchronize required state.
                element.setAttribute("validate-required", String(currentlyRequired && visible));
                if (el.type !== "property") return;
                const property = propertyMap[el.property_id];
                if (!property) throw new Error(`Unable to get property with id "${el.property_id}" from property array.`);
                const { property_id: property_id, type: type, calculated: calculated, expression: expression } = property;
                // clear data from skipped fields.
                if (!visible) {
                    if (responses[`p${property_id}`] !== undefined) {
                        if (responses[`p${property_id}`] !== "" && responses[`p${property_id}`] !== null) this.log(event, `Clearing ${property.label} (${property_id}) - current value ${JSON.stringify(responses[`p${property_id}`])}`);
                        $5854062ef7ec26b7$var$setActivityElementValue(element, property, undefined);
                        delete responses[`p${property_id}`];
                    }
                    return;
                }
                // update calculated fields.
                if (!calculated || !expression) return;
                let value = (0, $0dbabea6e8ef01ef$export$61b73397e464436e)(type, expression, scope);
                if (responses[`p${property_id}`] !== value) {
                    this.log(event, `Calculated field ${property.label} (${property_id}) changed to ${value}`);
                    changed = $5854062ef7ec26b7$var$setActivityElementValue(element, property, value);
                    this.log(event, "Changed input", changed);
                    responses[`p${property_id}`] = value;
                    const outputElement = element.querySelector("output");
                    outputElement.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $669809489e0e2c7d$export$42402a68ff28dfc0)(property, value));
                } else this.log(event, `Calculated field ${property.label} (${property_id}) remained ${value}`);
                const detailsContent = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $ba5ed3cba264080f$export$10eb477033c32543)((0, $58ccb23ba1dadd05$export$180605366c04f0cd)(), responses, propertyMap, element.getAttribute("references")?.split(",").map(Number) ?? []));
                const detailsListElement = element.querySelector("details ul");
                if (detailsListElement.innerHTML !== detailsContent) detailsListElement.innerHTML = detailsContent;
            });
            if (changed) {
                this.log(event, `Displatching change for ${changed.getAttribute("name")}`);
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(changed);
                return;
            }
            if (!isModal) {
                const progressLabel = document.getElementById("activity-progress-label");
                if (progressLabel) progressLabel.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $9dad25ba7a5dc18c$export$3194dcd7e2b21417)(answeredProperties / visibleProperties), "f5 color-fg-accent")}
            ${answeredProperties} of ${visibleProperties} ${(0, $2868cc1235412e16$export$989066564c2ca33b)[$5854062ef7ec26b7$var$locale]}`);
            }
        } finally{
            this.log(event, "Exit handleChange");
        }
    }
    async handleRailKeydown({ key: key, shiftKey: shiftKey, target: target }) {
        if (this.busyUploadingVaccineSurvey || !shiftKey || key !== "?" || !(target instanceof HTMLAnchorElement) || !target.getAttribute("href")?.startsWith("/attachments/")) return;
        const associatedTab = document.querySelector('.UnderlineNav-item[href$="/associated"]');
        if (!associatedTab) throw new Error("Unable to find associated tab.");
        const counter = associatedTab.querySelector(".Counter");
        if (counter?.textContent?.trim()?.replace(/^0$/g, "")) {
            if (!confirm(`PRESS CANCEL! Event already has ${counter.textContent.trim()} associated activities. Only press OK if you are sure you want to upload a new set of vaccine surveys.`)) return;
        }
        this.busyUploadingVaccineSurvey = true;
        target.classList.add("btn-busy");
        try {
            const name = target.title;
            const form = this.closest("activity-controller").form;
            const attachmentResponse = await fetch(target.href + "?noredirect");
            if (!attachmentResponse.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(attachmentResponse, await attachmentResponse.text());
            const data = name.endsWith(".csv") ? $5854062ef7ec26b7$var$parseCsv(await attachmentResponse.text()) : await (0, $084f49e21d0e189c$export$bf2e8542514694ef)(attachmentResponse.arrayBuffer(), name, form);
            if (data === null || !Array.isArray(data)) throw new Error(`Unable to read data from ${name}.`);
            else if (data.length === 0) throw new Error(`No data found in ${name}.`);
            console.table(data);
            const response = await fetch(`/api/organizations/${this.organization_id}/activities/${this.activity_id}/upload-vaccine-surveys`, {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const errors = await response.json();
            if (errors.length) {
                console.table(errors);
                throw new Error("Data validation errors. See console for details.");
            } else alert(`Vaccine surveys uploaded.`);
        } catch (err) {
            this.busyUploadingVaccineSurvey = false;
            alert(err);
            throw err;
        } finally{
            target.classList.remove("btn-busy");
            if (this.busyUploadingVaccineSurvey) {
                target.textContent = "Refresh page & confirm count before proceeding";
                target.classList.add("color-fg-danger");
                target.removeAttribute("href");
            }
        }
    }
};
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "form", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "elementsContainer", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "elementsSummaryContainer", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "creationFields", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "timelineContainer", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "editCommentTemplate", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "subscribersSection", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "attachmentsSection", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "eventQuestionnairesSection", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "needsActivityId", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "addAnotherContent", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "assigneePicker", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "assigneePrintContainer", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "addChildPlaceholder", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "headingNavLinks", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "printCommentsItems", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "organization_login", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "organization_id", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "subject_person_id", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "activity_id", void 0);
$5854062ef7ec26b7$var$__decorate([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $5854062ef7ec26b7$var$ActivityControllerElement.prototype, "status_assignment_src", void 0);
$5854062ef7ec26b7$var$ActivityControllerElement = $5854062ef7ec26b7$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("activity-controller")
], $5854062ef7ec26b7$var$ActivityControllerElement);
var $5854062ef7ec26b7$export$2e2bcd8739ae039 = $5854062ef7ec26b7$var$ActivityControllerElement;
function $5854062ef7ec26b7$var$setActivityElementValue(element, property, value) {
    let changed = null;
    if (!property.calculated && property.type === "int" && property.choice_type !== "none") {
        const inputs = element.querySelectorAll(`[name="responses/p${property.property_id}"],[name^="responses/p${property.property_id}:"]`);
        let checkedFn;
        if (property.choice_type === "multiple") {
            if (typeof value === "number") value = (0, $0f65d914a7138590$export$7ad13431816ff1fa)(value);
            if (Array.isArray(value)) checkedFn = (x)=>x.checked = value.find((v)=>String(v) === x.value);
            else checkedFn = (x)=>x.checked = x.value === "";
        } else checkedFn = (x)=>x.checked = x.value === String(value);
        inputs.forEach((x)=>{
            const checked = checkedFn(x);
            if (checked !== x.checked) {
                changed = x;
                x.checked = checked;
            }
        });
    } else {
        const input = element.querySelector(`[name="responses/p${property.property_id}"],[name^="responses/p${property.property_id}:"]`);
        if (property.type === "date") {
            if (value) value = new Date(value);
            if (value instanceof Date) value = (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(value);
        }
        value = (value ?? "").toString();
        if (input.value !== value) {
            changed = input;
            input.value = value;
        }
    }
    return changed;
}
function $5854062ef7ec26b7$var$resolveFieldLinks(form, editElements) {
    document.querySelectorAll('[href^="#field:"]').forEach((a)=>{
        const property_id = a.getAttribute("href").substr(7);
        const input = form.querySelector(`[name="responses/p${property_id}"][id],[name^="responses/p${property_id}:"][id]`);
        if (!input) return;
        const group = input.closest(".form-group");
        if (!group) return;
        input.style.scrollMarginTop = `${Math.max(input.offsetTop - group.offsetTop, 60)}px`;
        a.href = `#${input.id}`;
        if (a.closest(".PropertyTable")) a.addEventListener("click", ()=>{
            editElements(input);
        });
    });
    document.querySelectorAll('[href^="#associated:person"],[href^="#associated:person-details"],[href^="#associated:parent-activity"]').forEach((a)=>{
        const association = a.getAttribute("href").substr(12);
        switch(association){
            case "person":
                a.href = location.pathname.split("/").slice(0, 4).join("/");
                break;
            case "person-details":
                a.href = location.pathname.split("/").slice(0, 4).join("/") + "/details";
                break;
            case "parent-activity":
                a.href = document.getElementById("activity-parent-label")?.getAttribute("href") ?? a.href;
                break;
        }
    });
    document.querySelectorAll('[href^="#status:"]').forEach((a)=>{
        const status = a.getAttribute("href").substr(8);
        if (!(0, $0dc330fba39b622a$export$d009ce1991333b4e).some((x)=>x.id === status)) return;
        a.role = "button";
        a.addEventListener("click", (event)=>{
            event.preventDefault();
            const radios = form.elements.namedItem("status");
            for(let i = radios.length - 1; i >= 0; i--){
                const radio = radios.item(i);
                if (radio.value === status) {
                    radio.click();
                    break;
                }
            }
        });
    });
    document.querySelectorAll('[href^="#print:"]').forEach((a)=>{
        const behavior = a.getAttribute("href").substr(7);
        if (![
            "summary",
            "summary-with-comments",
            "details"
        ].includes(behavior)) return;
        a.role = "button";
        a.setAttribute("activity-behavior", `print-${behavior}`);
        a.toggleAttribute("data-requires-submit", true);
        a.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span>${a.textContent}</span>`);
        a.addEventListener("click", (event)=>{
            event.preventDefault();
        });
    });
}
function $5854062ef7ec26b7$var$parseCsv(str) {
    var arr = [];
    var quote = false; // true means we're inside a quoted field
    var col, c;
    // iterate over each character, keep track of current row and column (of the returned array)
    for(var row = col = c = 0; c < str.length; c++){
        var cc = str[c], nc = str[c + 1]; // current character, next character
        arr[row] = arr[row] || []; // create a new row if necessary
        arr[row][col] = arr[row][col] || ""; // create a new column (start with empty string) if necessary
        // If the current character is a quotation mark, and we're inside a
        // quoted field, and the next character is also a quotation mark,
        // add a quotation mark to the current column and skip the next character
        if (cc == '"' && quote && nc == '"') {
            arr[row][col] += cc;
            ++c;
            continue;
        }
        // If it's just one quotation mark, begin/end quoted field
        if (cc == '"') {
            quote = !quote;
            continue;
        }
        // If it's a comma and we're not in a quoted field, move on to the next column
        if (cc == "," && !quote) {
            ++col;
            continue;
        }
        // If it's a newline (CRLF) and we're not in a quoted field, skip the next character
        // and move on to the next row and move to column 0 of that new row
        if (cc == "\r" && nc == "\n" && !quote) {
            ++row;
            col = 0;
            ++c;
            continue;
        }
        // If it's a newline (LF or CR) and we're not in a quoted field,
        // move on to the next row and move to column 0 of that new row
        if (cc == "\n" && !quote) {
            ++row;
            col = 0;
            continue;
        }
        if (cc == "\r" && !quote) {
            ++row;
            col = 0;
            continue;
        }
        // Otherwise, append the current character to the current column
        arr[row][col] += cc;
    }
    const [header, ...rest] = arr;
    return rest.map((r)=>{
        return r.reduce((acc, v, i)=>{
            let key = header[i];
            acc[key] = v;
            return acc;
        }, {});
    });
}








var $91b836fa8d8a90fc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $91b836fa8d8a90fc$var$ActivitySelectElement_1;
const $91b836fa8d8a90fc$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
const $91b836fa8d8a90fc$var$activitySelectChangeEvent = "activity-select-change";
let $91b836fa8d8a90fc$var$ActivitySelectElement = $91b836fa8d8a90fc$var$ActivitySelectElement_1 = class ActivitySelectElement extends HTMLElement {
    get remoteInput() {
        return this.querySelector("remote-input");
    }
    get parent_activity_definition_id() {
        return this.getAttribute("parent_activity_definition_id");
    }
    get activity_definition_id() {
        return this.getAttribute("activity_definition_id");
    }
    get organization_id() {
        return this.getAttribute("organization_id");
    }
    get activity_id() {
        return this.input.value || null;
    }
    get start_date() {
        return this.input.getAttribute("activity_start_date") || null;
    }
    get end_date() {
        return this.input.getAttribute("activity_end_date") || null;
    }
    get name() {
        return this.getAttribute("name");
    }
    get required() {
        return this.hasAttribute("required");
    }
    get label() {
        return this.getAttribute("label");
    }
    get period() {
        return this.hasAttribute("period");
    }
    get menuButton() {
        return this.querySelector("summary [data-menu-button]");
    }
    connectedCallback() {
        addEventListener($91b836fa8d8a90fc$var$activitySelectChangeEvent, this);
        this.addEventListener("focus", this, {
            capture: true
        });
    }
    disconnectedCallback() {
        removeEventListener($91b836fa8d8a90fc$var$activitySelectChangeEvent, this);
        this.removeEventListener("focus", this, {
            capture: true
        });
    }
    handleEvent(event) {
        switch(event.type){
            case $91b836fa8d8a90fc$var$activitySelectChangeEvent:
                {
                    if (event.target === this || !(event.target instanceof $91b836fa8d8a90fc$var$ActivitySelectElement_1)) return;
                    if (this.parent_activity_definition_id !== event.target.activity_definition_id) return;
                    // update remote-input.src
                    const remoteInput = this.remoteInput;
                    const url = new URL(remoteInput.src, location.origin);
                    url.searchParams.delete("parent_activity_id");
                    const activity_id = event.target.activity_id;
                    if (activity_id) url.searchParams.set("parent_activity_id", activity_id);
                    remoteInput.src = url.href;
                    // clear selected value
                    this.clear();
                    return;
                }
            case "focus":
                {
                    const remoteInput = this.remoteInput;
                    const url = new URL(remoteInput.src, location.origin);
                    const form = this.closest("form");
                    const startDateInput = form?.elements.namedItem("start_date:date");
                    if (startDateInput instanceof HTMLInputElement && isFinite(Date.parse(startDateInput.value))) url.searchParams.set("start_date", new Date(startDateInput.value).toISOString().substr(0, 10));
                    remoteInput.src = url.href;
                    return;
                }
            default:
                throw new Error(`Unhandled event: ${event.type}`);
        }
    }
    detailsMenuSelected() {
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.input);
        this.dispatchEvent(new CustomEvent($91b836fa8d8a90fc$var$activitySelectChangeEvent, {
            bubbles: true
        }));
        const activity_id = this.activity_id;
        this.preview?.remove();
        if (activity_id) this.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<include-fragment
            src="/api/organizations/${this.organization_id}/activities/${this.activity_id}/summary-card?target=activity-select.preview"
            accept="text/fragment+html"
            class="d-flex flex-justify-center py-4 color-bg-inset border rounded"
            data-target="activity-select.preview"
          >
            <div class="spinner-border f1 color-fg-muted" role="status">
              <span class="sr-only">${(0, $2868cc1235412e16$export$25a57b30938bf753)[$91b836fa8d8a90fc$var$locale]}</span>
            </div>
          </include-fragment>`));
        if (this.period) {
            const start_date = this.start_date;
            const end_date = this.end_date;
            const form = this.closest("form");
            const startDateInput = form?.elements.namedItem("start_date:date");
            const endDateInput = form?.elements.namedItem("end_date:date");
            const dueDateInput = form?.elements.namedItem("due_date:date");
            if (form && startDateInput instanceof HTMLInputElement && endDateInput instanceof HTMLInputElement && dueDateInput instanceof HTMLInputElement) {
                startDateInput.value = start_date ? (0, $dbca384612ad025b$export$6aa1a8800137fac7).format(new Date(start_date + "T00:00:00.000Z")) : "";
                endDateInput.value = end_date ? (0, $dbca384612ad025b$export$6aa1a8800137fac7).format(new Date(end_date + "T00:00:00.000Z")) : "";
                dueDateInput.value = endDateInput.value;
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(startDateInput);
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(endDateInput);
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(dueDateInput);
            }
        }
    }
    inputFocused() {
        this.querySelector("summary")?.click();
    }
    clear() {
        // clear value
        if (this.activity_id) {
            this.menuButton.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $99a756c897582e70$export$385c659e35a543c6)($91b836fa8d8a90fc$var$locale, this.name, this.required, this.label));
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.input);
            this.dispatchEvent(new CustomEvent($91b836fa8d8a90fc$var$activitySelectChangeEvent, {
                bubbles: true
            }));
        }
        // clear preview
        this.preview?.remove();
        // clear menu filter and results
        const filterInput = this.remoteInput.input;
        filterInput.value = "";
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(filterInput);
        this.querySelector("SelectMenu-list").innerHTML = "";
    }
};
$91b836fa8d8a90fc$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $91b836fa8d8a90fc$var$ActivitySelectElement.prototype, "preview", void 0);
$91b836fa8d8a90fc$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $91b836fa8d8a90fc$var$ActivitySelectElement.prototype, "input", void 0);
$91b836fa8d8a90fc$var$ActivitySelectElement = $91b836fa8d8a90fc$var$ActivitySelectElement_1 = $91b836fa8d8a90fc$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("activity-select")
], $91b836fa8d8a90fc$var$ActivitySelectElement);
var $91b836fa8d8a90fc$export$2e2bcd8739ae039 = $91b836fa8d8a90fc$var$ActivitySelectElement;




// https://regex101.com/r/CQkTWn/1
// https://stackoverflow.com/a/52619927/725866
const $61bb30abbf62bbfa$export$1854a57995e68990 = /^\s*(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(b|box|bin)[-.\s]*)|.*((p|post)[-.\s]*(o|off|office)[-.\s]*)|.*((p|post)[-.\s]*(b|box|bin)[-.\s]*)|(box|bin)[-.\s]*)(#|n|num|number)?\s*\d+/i;
function $61bb30abbf62bbfa$export$338eada492427913(q) {
    return q.match($61bb30abbf62bbfa$export$1854a57995e68990)?.[0]?.trim().toUpperCase().replace(/post/i, "Post").replace(/office/i, "Office").replace(/box/i, "Box") ?? "";
}
function $61bb30abbf62bbfa$export$8fecc3029e4bae36(precision) {
    return precision === "Subaddress" || precision === "PointAddress" || precision === "StreetAddress" || precision === "POI";
}
const $61bb30abbf62bbfa$export$3650e4ad787ea880 = [
    "",
    "Subaddress",
    "PointAddress",
    "StreetAddress",
    "StreetInt",
    "StreetAddressExt",
    "DistanceMarker",
    "StreetMidBlock",
    "StreetName",
    "Locality",
    "PostalLoc",
    "PostalExt",
    "Postal",
    "POI",
    "LatLong",
    "XY",
    "YX",
    "MGRS",
    "USNG"
];
const $61bb30abbf62bbfa$export$d30a285adb132bc8 = {
    City: "city",
    "Primary Postal": "postal_code",
    Region: "region_abbr",
    Subregion: "subregion"
};
function $61bb30abbf62bbfa$export$df322274cb6efbe1(address) {
    address.precision = "";
    address.street_address = "";
    address.street_address = "";
    address.sub_address = "";
    address.neighborhood = "";
    address.district = "";
    address.metro_area = "";
    address.city = "";
    address.region = "";
    address.region_abbr = "";
    address.subregion = "";
    address.postal_code = "";
    address.postal_code_ext = "";
    address.country = "";
    address.entry_x = 0;
    address.entry_y = 0;
    address.rooftop_x = 0;
    address.rooftop_y = 0;
}



var $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e;
(function(ContactType) {
    ContactType[ContactType["Unknown"] = 4096] = "Unknown";
    ContactType[ContactType["EmergencyContact"] = 1] = "EmergencyContact";
    ContactType[ContactType["Employer"] = 2] = "Employer";
    ContactType[ContactType["FederalAgency"] = 4] = "FederalAgency";
    ContactType[ContactType["InsuranceCompany"] = 8] = "InsuranceCompany";
    ContactType[ContactType["NextOfKin"] = 16] = "NextOfKin";
    ContactType[ContactType["StateAgency"] = 32] = "StateAgency";
    ContactType[ContactType["PrimaryEmergencyContact"] = 1048576] = "PrimaryEmergencyContact";
    ContactType[ContactType["Billing"] = 64] = "Billing";
    ContactType[ContactType["Administrative"] = 128] = "Administrative";
    ContactType[ContactType["HumanResource"] = 256] = "HumanResource";
    ContactType[ContactType["Payor"] = 512] = "Payor";
    ContactType[ContactType["Patient"] = 1024] = "Patient";
    ContactType[ContactType["Press"] = 2048] = "Press";
    ContactType[ContactType["Site"] = 262144] = "Site";
    ContactType[ContactType["PrimarySite"] = 524288] = "PrimarySite";
})($fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e || ($fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e = {}));
const $fedade72d0b68ff2$export$4c75d574fa86190 = [
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.PrimaryEmergencyContact,
        fhirCode: "C",
        label: (0, $2868cc1235412e16$export$c9238058729ccab6)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.EmergencyContact,
        fhirCode: "C",
        label: (0, $2868cc1235412e16$export$e6d3bbcb6498fe45)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.NextOfKin,
        fhirCode: "N",
        label: (0, $2868cc1235412e16$export$f5494529e20e3385)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.Employer,
        fhirCode: "E",
        label: (0, $2868cc1235412e16$export$f26cbd52422ea099)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.FederalAgency,
        fhirCode: "F",
        label: (0, $2868cc1235412e16$export$70154fb96da70b31)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.StateAgency,
        fhirCode: "S",
        label: (0, $2868cc1235412e16$export$51027e8a6e256ee6)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.InsuranceCompany,
        fhirCode: "I",
        label: (0, $2868cc1235412e16$export$df8757b11bea02f0)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.Unknown,
        fhirCode: "U",
        label: (0, $2868cc1235412e16$export$230e1efc20c8172a)
    }
];
const $fedade72d0b68ff2$export$2a7ee7224f7cfe9c = [
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.Billing,
        fhirCode: "BILL",
        label: (0, $2868cc1235412e16$export$58faafdea4528c0c)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.Administrative,
        fhirCode: "ADMIN",
        label: (0, $2868cc1235412e16$export$3bd695ac39288245)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.HumanResource,
        fhirCode: "HR",
        label: (0, $2868cc1235412e16$export$66ac5ac68c1dcca4)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.Payor,
        fhirCode: "PAYOR",
        label: (0, $2868cc1235412e16$export$2cea9b5b0a64eca3)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.Patient,
        fhirCode: "PATINF",
        label: (0, $2868cc1235412e16$export$ab57077c7aa64ad3)
    },
    {
        id: $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e.Press,
        fhirCode: "PRESS",
        label: (0, $2868cc1235412e16$export$f8432d94cae4776c)
    }
];



function $125c741ec276b361$export$b580f1dfaaa8cdab(person) {
    return `${person.last_name}, ${person.first_name} ${person.middle_name}`.trim();
}
function $125c741ec276b361$var$getAddressQuery(address) {
    const { street_address: street_address, sub_address: sub_address, city: city, region_abbr: region_abbr, postal_code: postal_code, postal_code_ext: postal_code_ext } = address;
    let query = street_address || "";
    if (street_address && sub_address) query += (query ? ", " : "") + sub_address;
    if (city) query += (query ? ", " : "") + city;
    if (region_abbr) query += (query ? ", " : "") + region_abbr;
    if (postal_code) query += (query ? " " : "") + postal_code + (postal_code_ext ? "-" + postal_code_ext : "");
    return query;
}
function $125c741ec276b361$var$getMapUrl(address, type) {
    const query = $125c741ec276b361$var$getAddressQuery(address);
    const url = new URL(type === "search" ? "https://www.google.com/maps/search/" : "https://www.google.com/maps/dir/");
    url.searchParams.set("api", "1");
    url.searchParams.set(type === "search" ? "query" : "destination", query);
    return url;
}
function $125c741ec276b361$export$16324af849cc98bd(address, link = true) {
    const { street_address: street_address, sub_address: sub_address, city: city, region_abbr: region_abbr, postal_code: postal_code, postal_code_ext: postal_code_ext, subregion: subregion } = address;
    let formatted = street_address || "";
    if (sub_address) formatted += (formatted ? ", " : "") + sub_address;
    if (city) formatted += (formatted ? ", " : "") + city;
    if (region_abbr) formatted += (formatted ? ", " : "") + region_abbr;
    if (postal_code) formatted += (formatted ? " " : "") + postal_code + (postal_code_ext ? "-" + postal_code_ext : "");
    const parts = [];
    if (formatted) {
        if (link) {
            if (link === true) link = "primary";
            parts.push((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a class="Link--${link}" href="${$125c741ec276b361$var$getMapUrl(address, "search")}"
          >${formatted}</a
        >`);
        } else parts.push(formatted);
    }
    if (subregion) {
        if (parts.length) parts.push(" - ");
        parts.push((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="text-nowrap">County: ${subregion}</span>`);
    }
    return parts;
}
function $125c741ec276b361$export$26fab7c7c56386a9(address) {
    const { street_address: street_address, sub_address: sub_address, city: city, region_abbr: region_abbr, postal_code: postal_code, postal_code_ext: postal_code_ext, subregion: subregion } = address;
    let formatted = street_address || "";
    if (sub_address) formatted += (formatted ? ", " : "") + sub_address;
    if (city) formatted += (formatted ? ", " : "") + city;
    if (region_abbr) formatted += (formatted ? ", " : "") + region_abbr;
    if (postal_code) formatted += (formatted ? " " : "") + postal_code + (postal_code_ext ? "-" + postal_code_ext : "");
    if (subregion) {
        if (formatted) formatted += " - ";
        formatted += `County: ${subregion}`;
    }
    return formatted;
}
function $125c741ec276b361$export$ff1216816de7f138(phone, link = true) {
    if (link) {
        if (link === true) link = "primary";
        return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${phone.type ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="color-fg-muted">${phone.type + " "}</span>` : null}<a
        class="Link--${link}"
        href="tel:${phone.number.replaceAll(/[^\d]/g, "")}"
        >${phone.number}${phone.extension ? " ext " + phone.extension : ""}</a
      >`;
    }
    return `${phone.type ? phone.type + ": " : ""}${phone.number}${phone.extension ? " ext " + phone.extension : ""}`;
}
function $125c741ec276b361$export$2b79b564cdea702d(email, link = true, copy = true) {
    const copyButton = copy ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`&nbsp;<clipboard-copy
          class="btn-octicon d-print-none ml-n1 mt-n1 mb-n1 mr-n1 f6"
          style="vertical-align: baseline;"
          aria-label="Copy email"
          value="${email.email}"
          >${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$e3d4d49f14b4dd60))}</clipboard-copy
        >` : null;
    if (link) {
        if (link === true) link = "primary";
        return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${email.type ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="color-fg-muted">${email.type + " "}</span>` : null}<a class="Link--${link}" href="mailto:${email.email}"
        >${email.email}</a
      >${copyButton}`;
    }
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${email.type ? email.type + ": " : ""}${email.email}${copyButton}`;
}
function $125c741ec276b361$export$9496e8a7688d3d34(locale, item, contactTypes, link = "secondary") {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="d-flex flex-column gap-1 lh-condensed">
    <span class="d-flex gap-1 flex-items-center flex-wrap">
      <span>${item.name}</span>
      ${contactTypes.filter((x)=>x.id & item.type && x.id !== (0, $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e).PrimaryEmergencyContact).map(({ id: id, label: label })=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Label"
              >${id === (0, $fedade72d0b68ff2$export$9f5bdfa4eeb4bc7e).EmergencyContact ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
                      class="d-item-has-primary-emergency-contact-checked"
                      >${(0, $2868cc1235412e16$export$c860bd028d704467)[locale]}</span
                    >${" "}` : null}${label[locale]}</span
            >`)}
    </span>
    ${item.description ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="f6">${item.description}</span>` : null}
    <span class="f6 color-fg-muted d-flex flex-wrap gap-2 d-none-empty"
      >${item.phones?.map((x)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span>${$125c741ec276b361$export$ff1216816de7f138(x, link)}</span>`)}${item.emails?.map((x)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span>${$125c741ec276b361$export$2b79b564cdea702d(x, link)}</span>`)}</span
    >
    ${item.addresses?.map((x)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="f6 color-fg-muted">${$125c741ec276b361$export$16324af849cc98bd(x, link)}</span>`)}
  </span>`;
}
function $125c741ec276b361$export$c4d8c2c033da1ba(locale, precision) {
    const precise = (0, $61bb30abbf62bbfa$export$8fecc3029e4bae36)(precision ?? "");
    const text = precise ? (0, $2868cc1235412e16$export$5c704772b04618d5)[locale] : (0, $2868cc1235412e16$export$ebe06c687744d6e6)[locale];
    const iconContent = precise ? (0, $2b6d0b8c1c80c786$export$9c13049f489fa947) : (0, $2b6d0b8c1c80c786$export$8e47d324a7a20b30);
    const classname = precise ? "color-fg-success" : "color-fg-attention";
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
    class="d-inline-flex gap-1 flex-items-center text-bold ${classname}"
    >${text} ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)(iconContent)}</span
  >`;
}







var $36685b15dd410ef1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $36685b15dd410ef1$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
let $36685b15dd410ef1$var$AddressScopeElement = class AddressScopeElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.onChange = ()=>{};
        this.onCommit = async ({ target: target })=>{
            if (!(target instanceof HTMLElement)) return;
            try {
                this.fieldset.disabled = true;
                const suggestion = JSON.parse(target.getAttribute("data-autocomplete-data"));
                const postOfficeBox = target.getAttribute("data-autocomplete-post-office-box");
                const manual = suggestion.magicKey === "MANUAL";
                let candidate;
                if (manual) {
                    candidate = {
                        street_address: suggestion.text,
                        sub_address: "",
                        city: "",
                        region: "",
                        region_abbr: "",
                        postal_code: "",
                        postal_code_ext: "",
                        country: "",
                        neighborhood: "",
                        district: "",
                        metro_area: "",
                        entry_x: "",
                        entry_y: "",
                        rooftop_x: "",
                        rooftop_y: "",
                        precision: "",
                        subregion: ""
                    };
                    for (const input of this.manual_inputs)input.disabled = false;
                } else {
                    const params = new URLSearchParams({
                        q: suggestion.text,
                        "magic-key": suggestion.magicKey,
                        "for-storage": "true"
                    });
                    const response = await fetch(`/api/addresses/candidates?${params}`);
                    if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return;
                    if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
                    const candidates = await response.json();
                    candidate = candidates[0];
                    if (postOfficeBox) candidate.street_address = postOfficeBox;
                }
                for (let [key, value] of Object.entries(candidate)){
                    if (key === "postal_code" && candidate.postal_code_ext) value = `${value}-${candidate.postal_code_ext}`;
                    const input = this.getInput(key);
                    if (input instanceof HTMLInputElement) {
                        const newValue = String(value ?? "");
                        if (input.value !== newValue) {
                            input.value = newValue;
                            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(input);
                            (0, $eb08f38ae8877120$export$e3607ec2d7a891c4)(input, "element-changed-animation--fast");
                        }
                    }
                }
                this.rooftop_map_link.href = `https://www.google.com/maps/search/?api=1&query=${candidate.rooftop_y},${candidate.rooftop_x}`;
                this.rooftop_map_link.hidden = !candidate.rooftop_x || !candidate.rooftop_y;
                this.entry_map_link.href = `https://www.google.com/maps/search/?api=1&query=${candidate.entry_y},${candidate.entry_x}`;
                this.entry_map_link.hidden = !candidate.entry_x || !candidate.entry_y;
                this.updatePrecision(candidate.precision);
            } finally{
                this.fieldset.disabled = false;
                this.sub_address.focus();
            }
        };
        this.onInput = ({ target: target })=>{
            if (!(target instanceof HTMLInputElement) || target.type === "checkbox" || target.name.includes("/sub_address")) return;
            this.updatePrecision("");
            this.rooftop_map_link.hidden = true;
            this.entry_map_link.hidden = true;
            const toClear = [
                "precision",
                "neighborhood",
                "district",
                "metro_area",
                "entry_x",
                "entry_y",
                "rooftop_x",
                "rooftop_y"
            ];
            if (target.name.includes("/region_abbr")) {
                toClear.push("region");
                toClear.push("country");
            }
            for (const key of toClear){
                const input = this.getInput(key);
                if (input instanceof HTMLInputElement) {
                    input.value = "";
                    (0, $eb08f38ae8877120$export$e3607ec2d7a891c4)(input, "element-changed-animation--fast");
                }
            }
        };
    }
    connectedCallback() {
        this.addEventListener("combobox-commit", this.onCommit);
        this.addEventListener("input", this.onInput);
        this.addEventListener("change", this.onChange);
        this.autocomplete.fetchOnEmpty = false;
    }
    disconnectedCallback() {
        this.removeEventListener("combobox-commit", this.onCommit);
        this.removeEventListener("input", this.onInput);
        this.removeEventListener("change", this.onChange);
    }
    onAutocompleteInputBlur() {
        // Close the dropdown on blur.
        // Timeout ensures this doesn't interfere with blurs that occur when selecting a suggestion.
        setTimeout(()=>{
            if (this.autocomplete.open) this.autocomplete.open = false;
        }, 300); // do not reduce without testing quickly toggling between autocomplete suggestions with mouse.
    }
    onAutocompleteLoadEnd() {
        // Don't open the dropdown when the input is not focused.
        if (document.activeElement !== this.autocomplete.inputElement) setTimeout(()=>{
            if (this.autocomplete.open) this.autocomplete.open = false;
        }, 0);
    }
    getInput(key) {
        return this.querySelector(`[name$="/${key}"],[name*="/${key}:"]`);
    }
    updatePrecision(precision) {
        this.precision_summary.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $125c741ec276b361$export$c4d8c2c033da1ba)($36685b15dd410ef1$var$locale, precision));
    }
};
$36685b15dd410ef1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $36685b15dd410ef1$var$AddressScopeElement.prototype, "autocomplete", void 0);
$36685b15dd410ef1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $36685b15dd410ef1$var$AddressScopeElement.prototype, "fieldset", void 0);
$36685b15dd410ef1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $36685b15dd410ef1$var$AddressScopeElement.prototype, "sub_address", void 0);
$36685b15dd410ef1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $36685b15dd410ef1$var$AddressScopeElement.prototype, "precision_summary", void 0);
$36685b15dd410ef1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $36685b15dd410ef1$var$AddressScopeElement.prototype, "rooftop_map_link", void 0);
$36685b15dd410ef1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $36685b15dd410ef1$var$AddressScopeElement.prototype, "entry_map_link", void 0);
$36685b15dd410ef1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $36685b15dd410ef1$var$AddressScopeElement.prototype, "manual_inputs", void 0);
$36685b15dd410ef1$var$AddressScopeElement = $36685b15dd410ef1$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("address-scope")
], $36685b15dd410ef1$var$AddressScopeElement);





var $c77cb93b30acb274$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c77cb93b30acb274$export$e9e220b14ab953c3 = class AssigneePickerElement extends HTMLElement {
    get value() {
        const raw = this.summary.querySelector("[data-value]").getAttribute("data-value");
        return JSON.parse(raw);
    }
    focusMenu() {
        this.remoteInput.input.focus();
    }
    select() {
        const value = this.value;
        const organization_id = value?.organization_id ?? "";
        const organization_login = value?.organization_login ?? "";
        const user_id = value?.user_id ?? "";
        const user_login = value?.user_login ?? "";
        let change = false;
        if (this.organizationIdInput.value !== organization_id) {
            change = true;
            this.organizationIdInput.value = organization_id;
            this.organizationLoginInput?.setAttribute("value", organization_login);
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.organizationIdInput);
            if (this.contractFormGroupContainer) {
                const template = organization_id ? this.suggestions.querySelector(`[data-contracts-for="${organization_id}"]`) : this.suggestions.querySelector("[data-create-organization-contracts]");
                if (template instanceof HTMLTemplateElement) {
                    this.contractFormGroupContainer.innerHTML = "";
                    this.contractFormGroupContainer.append(template.content);
                }
            }
        }
        if (this.userIdInput.value !== user_id) {
            change = true;
            this.userIdInput.value = user_id;
            this.userLoginInput?.setAttribute("value", user_login);
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.userIdInput);
            this.assignToMeButton?.parentElement?.toggleAttribute("hidden", user_id !== "");
        }
        if (this.remoteInput.input?.value) {
            this.remoteInput.input.value = "";
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.remoteInput.input);
        }
        if (change) this.dispatchEvent(new CustomEvent("assignee-change", {
            bubbles: true,
            detail: value
        }));
    }
    remoteSuccess() {
    // formerly used to insert a clear selection button
    }
    assignToMeAndSave() {
        if (!this.assignToMeMenuItem) throw new Error("assignToMeMenuItem not found");
        this.suggestions.innerHTML = "";
        this.suggestions.append(this.assignToMeMenuItem.content.cloneNode(true));
        this.suggestions.querySelector("button")?.click();
        this.summary.focus();
        this.userIdInput.form?.requestSubmit();
    }
};
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "userIdInput", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "userLoginInput", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "organizationIdInput", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "organizationLoginInput", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "summary", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "remoteInput", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "suggestions", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "contractFormGroupContainer", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "assignToMeMenuItem", void 0);
$c77cb93b30acb274$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $c77cb93b30acb274$export$e9e220b14ab953c3.prototype, "assignToMeButton", void 0);
$c77cb93b30acb274$export$e9e220b14ab953c3 = $c77cb93b30acb274$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("assignee-picker")
], $c77cb93b30acb274$export$e9e220b14ab953c3);





var $09b21c92f652e598$export$902eb194f883041a = 2, $09b21c92f652e598$export$aca53469ff012f69 = 3, $09b21c92f652e598$export$8af5e2d4f952c9f0 = 4, $09b21c92f652e598$export$4b4c4ef3a93a84d8 = 5, $09b21c92f652e598$export$67379271b4d26982 = 6, $09b21c92f652e598$export$230d7efa1736763e = 7, $09b21c92f652e598$export$329adfa5d98f30d5 = 8, $09b21c92f652e598$export$cf55d1bff75690da = 9, $09b21c92f652e598$export$3d914d751c5a82b8 = 10, $09b21c92f652e598$export$59510b5000cc9845 = 11, $09b21c92f652e598$export$5885cc5c5726058b = 12, $09b21c92f652e598$export$166201854b6928 = 13, $09b21c92f652e598$export$7f506b34fdef1832 = 14, $09b21c92f652e598$export$2f339926cb9fdf8b = 15, $09b21c92f652e598$export$57525e83c912026f = 16, $09b21c92f652e598$export$b395009ca7f092c7 = 17, $09b21c92f652e598$export$633927de1c6436f9 = 18, $09b21c92f652e598$export$74f94c628b84d921 = 19, $09b21c92f652e598$export$afa7aa09bb57d54f = 20, $09b21c92f652e598$export$893a2be9220efb8b = 21, $09b21c92f652e598$export$bb0a446c22f826c7 = 22, $09b21c92f652e598$export$add304fab23e505a = 23, $09b21c92f652e598$export$85059ac6bee8a624 = 24, $09b21c92f652e598$export$8ffe6fa0f85bec13 = 25, $09b21c92f652e598$export$6b636bdca7063f33 = 26, $09b21c92f652e598$export$88a597d0c7ae97b = 27, $09b21c92f652e598$export$1aad44a7533f8ad8 = 28, $09b21c92f652e598$export$fc88ff6ef7948967 = 29, $09b21c92f652e598$export$86319a0886767dcb = 30, $09b21c92f652e598$export$8df7bf301eafa719 = 31;
var $09b21c92f652e598$export$74921a9774a80542 = 1, $09b21c92f652e598$export$ed91b2a31d0810c8 = 2, $09b21c92f652e598$export$ce37e184d908d785 = 4, $09b21c92f652e598$export$be74dcf36d511131 = 8, $09b21c92f652e598$export$21c466265830bc3a = 16;
function $09b21c92f652e598$var$ee(e) {
    switch(e){
        case $09b21c92f652e598$export$74921a9774a80542:
            return "href";
        case $09b21c92f652e598$export$ed91b2a31d0810c8:
            return "src";
        case $09b21c92f652e598$export$ce37e184d908d785:
            return "class";
        case $09b21c92f652e598$export$be74dcf36d511131:
            return "checked";
        case $09b21c92f652e598$export$21c466265830bc3a:
            return "start";
    }
}
var $09b21c92f652e598$var$ne = (e)=>{
    switch(e){
        case 1:
            return 3;
        case 2:
            return 4;
        case 3:
            return 5;
        case 4:
            return 6;
        case 5:
            return 7;
        default:
            return 8;
    }
}, $09b21c92f652e598$var$te = $09b21c92f652e598$var$ne;
var $09b21c92f652e598$var$O = 24;
function $09b21c92f652e598$export$8f49e4af10703ce3(e) {
    let c = new Uint32Array($09b21c92f652e598$var$O);
    return c[0] = 1, {
        renderer: e,
        text: "",
        pending: "",
        tokens: c,
        len: 0,
        token: 1,
        fence_end: 0,
        blockquote_idx: 0,
        hr_char: "",
        hr_chars: 0,
        fence_start: 0,
        spaces: new Uint8Array($09b21c92f652e598$var$O),
        indent: "",
        indent_len: 0,
        table_state: 0
    };
}
function $09b21c92f652e598$export$1bb76c36683ac7c2(e) {
    e.pending.length > 0 && $09b21c92f652e598$export$fd28f50634d220c2(e, `
`);
}
function $09b21c92f652e598$var$a(e) {
    e.text.length !== 0 && (e.renderer.add_text(e.renderer.data, e.text), e.text = "");
}
function $09b21c92f652e598$var$_(e) {
    e.len -= 1, e.token = e.tokens[e.len], e.renderer.end_token(e.renderer.data);
}
function $09b21c92f652e598$var$i(e, c) {
    (e.tokens[e.len] === 24 || e.tokens[e.len] === 23) && c !== 25 && $09b21c92f652e598$var$_(e), e.len += 1, e.tokens[e.len] = c, e.token = c, e.renderer.add_token(e.renderer.data, c);
}
function $09b21c92f652e598$var$re(e, c, n) {
    for(; n <= e.len;){
        if (e.tokens[n] === c) return n;
        n += 1;
    }
    return -1;
}
function $09b21c92f652e598$var$l(e, c) {
    for(e.fence_start = 0; e.len > c;)$09b21c92f652e598$var$_(e);
}
function $09b21c92f652e598$var$u(e, c) {
    let n = 0;
    for(let t = 0; t <= e.len && (c -= e.spaces[t], !(c < 0)); t += 1)switch(e.tokens[t]){
        case 9:
        case 10:
        case 20:
        case 25:
            n = t;
            break;
    }
    for(; e.len > n;)$09b21c92f652e598$var$_(e);
    return c;
}
function $09b21c92f652e598$var$A(e, c) {
    let n = -1, t = -1;
    for(let s = e.blockquote_idx + 1; s <= e.len; s += 1)if (e.tokens[s] === 25) {
        if (e.indent_len < e.spaces[s]) {
            t = -1;
            break;
        }
        t = s;
    } else e.tokens[s] === c && (n = s);
    return t === -1 ? n === -1 ? ($09b21c92f652e598$var$l(e, e.blockquote_idx), $09b21c92f652e598$var$i(e, c), !0) : ($09b21c92f652e598$var$l(e, n), !1) : ($09b21c92f652e598$var$l(e, t), $09b21c92f652e598$var$i(e, c), !0);
}
function $09b21c92f652e598$var$g(e, c) {
    $09b21c92f652e598$var$i(e, 25), e.spaces[e.len] = e.indent_len + c, $09b21c92f652e598$var$E(e), e.token = 103;
}
function $09b21c92f652e598$var$E(e) {
    e.indent = "", e.indent_len = 0, e.pending = "";
}
function $09b21c92f652e598$var$N(e) {
    switch(e){
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return !0;
        default:
            return !1;
    }
}
function $09b21c92f652e598$var$ie(e) {
    switch(e){
        case 32:
        case 58:
        case 59:
        case 41:
        case 44:
        case 33:
        case 46:
        case 63:
        case 93:
        case 10:
            return !0;
        default:
            return !1;
    }
}
function $09b21c92f652e598$var$se(e) {
    return $09b21c92f652e598$var$N(e) || $09b21c92f652e598$var$ie(e);
}
function $09b21c92f652e598$export$fd28f50634d220c2(e, c) {
    for (let n of c){
        if (e.token === 101) {
            switch(n){
                case " ":
                    e.indent_len += 1;
                    continue;
                case "	":
                    e.indent_len += 4;
                    continue;
            }
            let s = $09b21c92f652e598$var$u(e, e.indent_len);
            e.indent_len = 0, e.token = e.tokens[e.len], s > 0 && $09b21c92f652e598$export$fd28f50634d220c2(e, " ".repeat(s));
        }
        let t = e.pending + n;
        switch(e.token){
            case 21:
            case 1:
            case 20:
            case 24:
            case 23:
                switch(e.pending[0]){
                    case void 0:
                        e.pending = n;
                        continue;
                    case " ":
                        e.pending = n, e.indent += " ", e.indent_len += 1;
                        continue;
                    case "	":
                        e.pending = n, e.indent += "	", e.indent_len += 4;
                        continue;
                    case `
`:
                        if (e.tokens[e.len] === 25 && e.token === 21) {
                            $09b21c92f652e598$var$_(e), $09b21c92f652e598$var$E(e), e.pending = n;
                            continue;
                        }
                        $09b21c92f652e598$var$l(e, e.blockquote_idx), $09b21c92f652e598$var$E(e), e.blockquote_idx = 0, e.fence_start = 0, e.pending = n;
                        continue;
                    case "#":
                        switch(n){
                            case "#":
                                if (e.pending.length < 6) {
                                    e.pending = t;
                                    continue;
                                }
                                break;
                            case " ":
                                $09b21c92f652e598$var$u(e, e.indent_len), $09b21c92f652e598$var$i(e, $09b21c92f652e598$var$te(e.pending.length)), $09b21c92f652e598$var$E(e);
                                continue;
                        }
                        break;
                    case ">":
                        {
                            let r = $09b21c92f652e598$var$re(e, 20, e.blockquote_idx + 1);
                            r === -1 ? ($09b21c92f652e598$var$l(e, e.blockquote_idx), e.blockquote_idx += 1, e.fence_start = 0, $09b21c92f652e598$var$i(e, 20)) : e.blockquote_idx = r, $09b21c92f652e598$var$E(e), e.pending = n;
                            continue;
                        }
                    case "-":
                    case "*":
                    case "_":
                        if (e.hr_chars === 0 && (e.hr_chars = 1, e.hr_char = e.pending), e.hr_chars > 0) {
                            switch(n){
                                case e.hr_char:
                                    e.hr_chars += 1, e.pending = t;
                                    continue;
                                case " ":
                                    e.pending = t;
                                    continue;
                                case `
`:
                                    if (e.hr_chars < 3) break;
                                    $09b21c92f652e598$var$u(e, e.indent_len), e.renderer.add_token(e.renderer.data, 22), e.renderer.end_token(e.renderer.data), $09b21c92f652e598$var$E(e), e.hr_chars = 0;
                                    continue;
                            }
                            e.hr_chars = 0;
                        }
                        if (e.pending[0] !== "_" && e.pending[1] === " ") {
                            $09b21c92f652e598$var$A(e, 23), $09b21c92f652e598$var$g(e, 2), $09b21c92f652e598$export$fd28f50634d220c2(e, t.slice(2));
                            continue;
                        }
                        break;
                    case "`":
                        if (e.pending.length < 3) {
                            if (n === "`") {
                                e.pending = t, e.fence_start = t.length;
                                continue;
                            }
                            e.fence_start = 0;
                            break;
                        }
                        switch(n){
                            case "`":
                                e.pending.length === e.fence_start ? (e.pending = t, e.fence_start = t.length) : ($09b21c92f652e598$var$i(e, 2), $09b21c92f652e598$var$E(e), e.fence_start = 0, $09b21c92f652e598$export$fd28f50634d220c2(e, t));
                                continue;
                            case `
`:
                                $09b21c92f652e598$var$u(e, e.indent_len), $09b21c92f652e598$var$i(e, 10), e.pending.length > e.fence_start && e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$ce37e184d908d785, e.pending.slice(e.fence_start)), $09b21c92f652e598$var$E(e), e.token = 101;
                                continue;
                            default:
                                e.pending = t;
                                continue;
                        }
                    case "+":
                        if (n !== " ") break;
                        $09b21c92f652e598$var$A(e, 23), $09b21c92f652e598$var$g(e, 2);
                        continue;
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        if (e.pending[e.pending.length - 1] === ".") {
                            if (n !== " ") break;
                            $09b21c92f652e598$var$A(e, 24) && e.pending !== "1." && e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$21c466265830bc3a, e.pending.slice(0, -1)), $09b21c92f652e598$var$g(e, e.pending.length + 1);
                            continue;
                        } else {
                            let r = n.charCodeAt(0);
                            if (r === 46 || $09b21c92f652e598$var$N(r)) {
                                e.pending = t;
                                continue;
                            }
                        }
                        break;
                    case "|":
                        $09b21c92f652e598$var$l(e, e.blockquote_idx), $09b21c92f652e598$var$i(e, 27), $09b21c92f652e598$var$i(e, 28), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                }
                let s = t;
                if (e.token === 21) e.token = e.tokens[e.len], e.renderer.add_token(e.renderer.data, 21), e.renderer.end_token(e.renderer.data);
                else if (e.indent_len >= 4) {
                    let r = 0;
                    for(; r < 4; r += 1)if (e.indent[r] === "	") {
                        r = r + 1;
                        break;
                    }
                    s = e.indent.slice(r) + t, $09b21c92f652e598$var$i(e, 9);
                } else $09b21c92f652e598$var$i(e, 2);
                $09b21c92f652e598$var$E(e), $09b21c92f652e598$export$fd28f50634d220c2(e, s);
                continue;
            case 27:
                if (e.table_state === 1) switch(n){
                    case "-":
                    case " ":
                    case "|":
                    case ":":
                        e.pending = t;
                        continue;
                    case `
`:
                        e.table_state = 2, e.pending = "";
                        continue;
                    default:
                        $09b21c92f652e598$var$_(e), e.table_state = 0;
                        break;
                }
                else switch(e.pending){
                    case "|":
                        $09b21c92f652e598$var$i(e, 28), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                    case `
`:
                        $09b21c92f652e598$var$_(e), e.pending = "", e.table_state = 0, $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                }
                break;
            case 28:
                switch(e.pending){
                    case "":
                        break;
                    case "|":
                        $09b21c92f652e598$var$i(e, 29), $09b21c92f652e598$var$_(e), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                    case `
`:
                        $09b21c92f652e598$var$_(e), e.table_state = Math.min(e.table_state + 1, 2), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                    default:
                        $09b21c92f652e598$var$i(e, 29), $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                        continue;
                }
                break;
            case 29:
                if (e.pending === "|") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                    continue;
                }
                break;
            case 9:
                switch(t){
                    case `
    `:
                    case `
   	`:
                    case `
  	`:
                    case `
 	`:
                    case `
	`:
                        e.text += `
`, e.pending = "";
                        continue;
                    case `
`:
                    case `
 `:
                    case `
  `:
                    case `
   `:
                        e.pending = t;
                        continue;
                    default:
                        e.pending.length !== 0 ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = n) : e.text += n;
                        continue;
                }
            case 10:
                switch(n){
                    case "`":
                        e.pending = t;
                        continue;
                    case `
`:
                        if (t.length === e.fence_start + e.fence_end + 1) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "", e.fence_start = 0, e.fence_end = 0, e.token = 101;
                            continue;
                        }
                        e.token = 101;
                        break;
                    case " ":
                        if (e.pending[0] === `
`) {
                            e.pending = t, e.fence_end += 1;
                            continue;
                        }
                        break;
                }
                e.text += e.pending, e.pending = n, e.fence_end = 1;
                continue;
            case 11:
                switch(n){
                    case "`":
                        t.length === e.fence_start + +(e.pending[0] === " ") ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "", e.fence_start = 0) : e.pending = t;
                        continue;
                    case `
`:
                        e.text += e.pending, e.pending = "", e.token = 21, e.blockquote_idx = 0, $09b21c92f652e598$var$a(e);
                        continue;
                    case " ":
                        e.text += e.pending, e.pending = n;
                        continue;
                    default:
                        e.text += t, e.pending = "";
                        continue;
                }
            case 103:
                switch(e.pending.length){
                    case 0:
                        if (n !== "[") break;
                        e.pending = t;
                        continue;
                    case 1:
                        if (n !== " " && n !== "x") break;
                        e.pending = t;
                        continue;
                    case 2:
                        if (n !== "]") break;
                        e.pending = t;
                        continue;
                    case 3:
                        if (n !== " ") break;
                        e.renderer.add_token(e.renderer.data, 26), e.pending[1] === "x" && e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$be74dcf36d511131, ""), e.renderer.end_token(e.renderer.data), e.pending = " ";
                        continue;
                }
                e.token = e.tokens[e.len], e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, t);
                continue;
            case 14:
            case 15:
                {
                    let r = "*", d = 12;
                    if (e.token === 15 && (r = "_", d = 13), r === e.pending) {
                        if ($09b21c92f652e598$var$a(e), r === n) {
                            $09b21c92f652e598$var$_(e), e.pending = "";
                            continue;
                        }
                        $09b21c92f652e598$var$i(e, d), e.pending = n;
                        continue;
                    }
                    break;
                }
            case 12:
            case 13:
                {
                    let r = "*", d = 14;
                    switch(e.token === 13 && (r = "_", d = 15), e.pending){
                        case r:
                            r === n ? e.tokens[e.len - 1] === d ? e.pending = t : ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, d), e.pending = "") : ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = n);
                            continue;
                        case r + r:
                            let R = e.token;
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), $09b21c92f652e598$var$_(e), r !== n ? ($09b21c92f652e598$var$i(e, R), e.pending = n) : e.pending = "";
                            continue;
                    }
                    break;
                }
            case 16:
                if (t === "~~") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "";
                    continue;
                }
                break;
            case 105:
                n === `
` ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 30), e.pending = "") : (e.token = e.tokens[e.len], e.pending[0] === "\\" ? e.text += "[" : e.text += "$$", e.pending = "", $09b21c92f652e598$export$fd28f50634d220c2(e, n));
                continue;
            case 30:
                if (t === "\\]" || t === "$$") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = "";
                    continue;
                }
                break;
            case 31:
                if (t === "\\)" || e.pending[0] === "$") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), n === ")" ? e.pending = "" : e.pending = n;
                    continue;
                }
                break;
            case 102:
                t === "http://" || t === "https://" ? ($09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 18), e.pending = t, e.text = t) : "http:/"[e.pending.length] === n || "https:/"[e.pending.length] === n ? e.pending = t : (e.token = e.tokens[e.len], $09b21c92f652e598$export$fd28f50634d220c2(e, n));
                continue;
            case 17:
            case 19:
                if (e.pending === "]") {
                    $09b21c92f652e598$var$a(e), n === "(" ? e.pending = t : ($09b21c92f652e598$var$_(e), e.pending = n);
                    continue;
                }
                if (e.pending[0] === "]" && e.pending[1] === "(") {
                    if (n === ")") {
                        let r = e.token === 17 ? $09b21c92f652e598$export$74921a9774a80542 : $09b21c92f652e598$export$ed91b2a31d0810c8, d = e.pending.slice(2);
                        e.renderer.set_attr(e.renderer.data, r, d), $09b21c92f652e598$var$_(e), e.pending = "";
                    } else e.pending += n;
                    continue;
                }
                break;
            case 18:
                n === " " || n === `
` || n === "\\" ? (e.renderer.set_attr(e.renderer.data, $09b21c92f652e598$export$74921a9774a80542, e.pending), $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$_(e), e.pending = n) : (e.text += n, e.pending = t);
                continue;
            case 104:
                if (t.startsWith("<br")) {
                    if (t.length === 3 || n === " " || n === "/" && (t.length === 4 || e.pending[e.pending.length - 1] === " ")) {
                        e.pending = t;
                        continue;
                    }
                    if (n === ">") {
                        $09b21c92f652e598$var$a(e), e.token = e.tokens[e.len], e.renderer.add_token(e.renderer.data, 21), e.renderer.end_token(e.renderer.data), e.pending = "";
                        continue;
                    }
                }
                e.token = e.tokens[e.len], e.text += "<", e.pending = e.pending.slice(1), $09b21c92f652e598$export$fd28f50634d220c2(e, n);
                continue;
        }
        switch(e.pending[0]){
            case "\\":
                if (e.token === 19 || e.token === 30 || e.token === 31) break;
                switch(n){
                    case "(":
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 31), e.pending = "";
                        continue;
                    case "[":
                        e.token = 105, e.pending = t;
                        continue;
                    case `
`:
                        e.pending = n;
                        continue;
                    default:
                        let s1 = n.charCodeAt(0);
                        e.pending = "", e.text += $09b21c92f652e598$var$N(s1) || s1 >= 65 && s1 <= 90 || s1 >= 97 && s1 <= 122 ? t : n;
                        continue;
                }
            case `
`:
                switch(e.token){
                    case 19:
                    case 30:
                    case 31:
                        break;
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$l(e, e.blockquote_idx), e.blockquote_idx = 0, e.pending = n;
                        continue;
                    default:
                        $09b21c92f652e598$var$a(e), e.pending = n, e.token = 21, e.blockquote_idx = 0;
                        continue;
                }
                break;
            case "<":
                if (e.token !== 19 && e.token !== 30 && e.token !== 31) {
                    $09b21c92f652e598$var$a(e), e.pending = t, e.token = 104;
                    continue;
                }
                break;
            case "`":
                if (e.token === 19) break;
                n === "`" ? (e.fence_start += 1, e.pending = t) : (e.fence_start += 1, $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 11), e.text = n === " " || n === `
` ? "" : n, e.pending = "");
                continue;
            case "_":
            case "*":
                {
                    if (e.token === 19 || e.token === 30 || e.token === 31 || e.token === 14) break;
                    let s = 12, r = 14, d = e.pending[0];
                    if (d === "_" && (s = 13, r = 15), e.pending.length === 1) {
                        if (d === n) {
                            e.pending = t;
                            continue;
                        }
                        if (n !== " " && n !== `
`) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, s), e.pending = n;
                            continue;
                        }
                    } else {
                        if (d === n) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, r), $09b21c92f652e598$var$i(e, s), e.pending = "";
                            continue;
                        }
                        if (n !== " " && n !== `
`) {
                            $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, r), e.pending = n;
                            continue;
                        }
                    }
                    break;
                }
            case "~":
                if (e.token !== 19 && e.token !== 16) {
                    if (e.pending === "~") {
                        if (n === "~") {
                            e.pending = t;
                            continue;
                        }
                    } else if (n !== " " && n !== `
`) {
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 16), e.pending = n;
                        continue;
                    }
                }
                break;
            case "$":
                if (e.token !== 19 && e.token !== 16 && e.pending === "$") {
                    if (n === "$") {
                        e.token = 105, e.pending = t;
                        continue;
                    } else {
                        if ($09b21c92f652e598$var$se(n.charCodeAt(0))) break;
                        $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 31), e.pending = n;
                        continue;
                    }
                }
                break;
            case "[":
                if (e.token !== 19 && e.token !== 17 && e.token !== 30 && e.token !== 31 && n !== "]") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 17), e.pending = n;
                    continue;
                }
                break;
            case "!":
                if (e.token !== 19 && n === "[") {
                    $09b21c92f652e598$var$a(e), $09b21c92f652e598$var$i(e, 19), e.pending = "";
                    continue;
                }
                break;
            case " ":
                if (e.pending.length === 1 && n === " ") continue;
                break;
        }
        if (e.token !== 19 && e.token !== 17 && e.token !== 30 && e.token !== 31 && n === "h" && (e.pending === " " || e.pending === "")) {
            e.text += e.pending, e.pending = n, e.token = 102;
            continue;
        }
        e.text += e.pending, e.pending = n;
    }
    $09b21c92f652e598$var$a(e);
}
function $09b21c92f652e598$export$13f0775b4d8e3ff(e) {
    return {
        add_token: $09b21c92f652e598$var$oe,
        end_token: $09b21c92f652e598$var$de,
        add_text: $09b21c92f652e598$var$Ee,
        set_attr: $09b21c92f652e598$var$le,
        data: {
            nodes: [
                e,
                ,
                ,
                ,
                , 
            ],
            index: 0
        }
    };
}
function $09b21c92f652e598$var$oe(e, c) {
    let n = e.nodes[e.index], t;
    switch(c){
        case 1:
            return;
        case 20:
            t = document.createElement("blockquote");
            break;
        case 2:
            t = document.createElement("p");
            break;
        case 21:
            t = document.createElement("br");
            break;
        case 22:
            t = document.createElement("hr");
            break;
        case 3:
            t = document.createElement("h1");
            break;
        case 4:
            t = document.createElement("h2");
            break;
        case 5:
            t = document.createElement("h3");
            break;
        case 6:
            t = document.createElement("h4");
            break;
        case 7:
            t = document.createElement("h5");
            break;
        case 8:
            t = document.createElement("h6");
            break;
        case 12:
        case 13:
            t = document.createElement("em");
            break;
        case 14:
        case 15:
            t = document.createElement("strong");
            break;
        case 16:
            t = document.createElement("s");
            break;
        case 11:
            t = document.createElement("code");
            break;
        case 18:
        case 17:
            t = document.createElement("a");
            break;
        case 19:
            t = document.createElement("img");
            break;
        case 23:
            t = document.createElement("ul");
            break;
        case 24:
            t = document.createElement("ol");
            break;
        case 25:
            t = document.createElement("li");
            break;
        case 26:
            let s = t = document.createElement("input");
            s.type = "checkbox", s.disabled = !0;
            break;
        case 9:
        case 10:
            n = n.appendChild(document.createElement("pre")), t = document.createElement("code");
            break;
        case 27:
            t = document.createElement("table");
            break;
        case 28:
            switch(n.children.length){
                case 0:
                    n = n.appendChild(document.createElement("thead"));
                    break;
                case 1:
                    n = n.appendChild(document.createElement("tbody"));
                    break;
                default:
                    n = n.children[1];
            }
            t = document.createElement("tr");
            break;
        case 29:
            t = document.createElement(n.parentElement?.tagName === "THEAD" ? "th" : "td");
            break;
        case 30:
            t = document.createElement("equation-block");
            break;
        case 31:
            t = document.createElement("equation-inline");
            break;
    }
    e.nodes[++e.index] = n.appendChild(t);
}
function $09b21c92f652e598$var$de(e) {
    e.index -= 1;
}
function $09b21c92f652e598$var$Ee(e, c) {
    e.nodes[e.index].appendChild(document.createTextNode(c));
}
function $09b21c92f652e598$var$le(e, c, n) {
    e.nodes[e.index].setAttribute($09b21c92f652e598$var$ee(c), n);
}






var $fe24aa9d181c0b4f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $fe24aa9d181c0b4f$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
let $fe24aa9d181c0b4f$var$AssistantChatControllerElement = class AssistantChatControllerElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.initialized = false;
    }
    get src() {
        return this.getAttribute("src");
    }
    async init() {
        if (this.initialized) return;
        this.initialized = true;
        const url = new URL(this.src, location.origin);
        url.searchParams.set("type", "init");
        const response = await fetch(url.origin + url.pathname, {
            method: "POST",
            body: url.searchParams
        });
        if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
    }
    async submit(event) {
        event.preventDefault();
        const message = (event.detail.get("suggested-message") ?? event.detail.get("message")).trim();
        if (!message) return;
        const restart_conversation = event.detail.has("suggested-message");
        this.initialized = true;
        const assistantMarkdownBodyId = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
        this.horizontalRule.hidden = false;
        this.form.insertAdjacentHTML("afterend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div class="align-self-start mr-6">
            <span class="f6">Cumulus Assistant</span>
            <div
              class="border rounded color-bg-default p-3 pr-5 markdown-body f5 position-relative"
              id="${assistantMarkdownBodyId}"
            >
              <span>${(0, $2868cc1235412e16$export$7ea5605264efeacf)[$fe24aa9d181c0b4f$var$locale]}</span
              ><span class="AnimatedEllipsis"></span>
            </div>
          </div>
          <div class="align-self-end ml-6">
            <span class="f6 color-fg-accent">${(0, $2868cc1235412e16$export$1108f562936cb617)[$fe24aa9d181c0b4f$var$locale]}</span>
            <div
              class="border rounded color-bg-accent color-border-accent element-changed-animation p-3 markdown-body f5"
            >
              <p>${message}</p>
            </div>
          </div>`));
        const markdownBody = document.getElementById(assistantMarkdownBodyId);
        const renderer = (0, $09b21c92f652e598$export$13f0775b4d8e3ff)(markdownBody);
        const markdownParser = (0, $09b21c92f652e598$export$8f49e4af10703ce3)(renderer);
        // pause before busying the submit buttons
        await new Promise((resolve)=>setTimeout(resolve));
        let received = "";
        try {
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(this.form, true);
            this.field.disabled = true;
            this.field.value = message;
            const url = new URL(this.src, location.origin);
            url.searchParams.set("type", "message");
            url.searchParams.set("role", "user");
            url.searchParams.set("content", message);
            if (restart_conversation) url.searchParams.set("restart_conversation", "true");
            if (message.trim() === "/system") {
                const response = await fetch(url);
                if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
                received = await response.text();
                markdownBody.innerHTML = "";
                (0, $09b21c92f652e598$export$fd28f50634d220c2)(markdownParser, received);
                return;
            }
            await new Promise((resolve, reject)=>{
                const source = new EventSource(url.href, {
                    withCredentials: true
                });
                source.addEventListener("error", ()=>{
                    source.close();
                    reject(new Error("EventSource error"));
                });
                source.addEventListener("message", (event)=>{
                    if (event.data == "[DONE]") {
                        source.close();
                        resolve();
                        return;
                    }
                    if (received.length === 0) markdownBody.innerHTML = "";
                    const data = JSON.parse(event.data);
                    received += data.response;
                    (0, $09b21c92f652e598$export$fd28f50634d220c2)(markdownParser, data.response);
                });
            });
            if (received.length === 0) throw new Error("Empty response");
            url.searchParams.set("role", "assistant");
            url.searchParams.set("content", received);
            url.searchParams.delete("restart_conversation");
            const response = await fetch(url.origin + url.pathname, {
                method: "POST",
                body: url.searchParams
            });
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
        } catch (err) {
            if (received.length === 0) markdownBody.innerHTML = "";
            markdownBody.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<p class="text-italic">${(0, $2868cc1235412e16$export$f725eab7abaa007d)[$fe24aa9d181c0b4f$var$locale]}</p>`));
            throw err;
        } finally{
            this.field.disabled = false;
            this.field.focus();
            (0, $09b21c92f652e598$export$1bb76c36683ac7c2)(markdownParser);
            (0, $eb08f38ae8877120$export$9657601bf1e130ee)(markdownBody.parentElement);
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(this.form, false);
            if (received.length) {
                this.field.value = "";
                markdownBody.insertAdjacentHTML("afterbegin", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<clipboard-copy
              class="btn-octicon position-absolute top-0 right-0 p-2 m-0"
              value="${received}"
              aria-label="${(0, $2868cc1235412e16$export$5f486e535de293fa)[$fe24aa9d181c0b4f$var$locale]}"
              >${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$e3d4d49f14b4dd60))}</clipboard-copy
            >`));
            }
        }
    }
};
$fe24aa9d181c0b4f$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fe24aa9d181c0b4f$var$AssistantChatControllerElement.prototype, "form", void 0);
$fe24aa9d181c0b4f$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fe24aa9d181c0b4f$var$AssistantChatControllerElement.prototype, "field", void 0);
$fe24aa9d181c0b4f$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fe24aa9d181c0b4f$var$AssistantChatControllerElement.prototype, "horizontalRule", void 0);
$fe24aa9d181c0b4f$var$AssistantChatControllerElement = $fe24aa9d181c0b4f$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("assistant-chat-controller")
], $fe24aa9d181c0b4f$var$AssistantChatControllerElement);
var $fe24aa9d181c0b4f$export$2e2bcd8739ae039 = $fe24aa9d181c0b4f$var$AssistantChatControllerElement;






function $2211ef13a71debdf$export$495f1fafaa7af669({ locale: locale, readonly: readonly = false, display: display, inserted_property_id: inserted_property_id, versions: versions }) {
    if (versions.length === 0) return null;
    const extension = (0, $de5ef9373ca12f93$export$5f7821c344028c56)(versions[0].name);
    const type = (0, $de5ef9373ca12f93$export$1d5ffa38c010beaf)[extension];
    if (!type) throw new Error(`Unknown attachment type for extension ${extension}`);
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<attachment-group
    class="d-flex flex-column gap-1 lh-condensed${display === "card" ? " py-1 px-2 border rounded color-bg-default" : ""}"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("style", display === "card" ? `min-width: 250px; max-width: 350px` : null)}
    display="${display}"
    versions="${JSON.stringify(versions)}"
    version-count="${versions.length}"
  >
    ${inserted_property_id ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
          type="hidden"
          name="attachments/-:json"
          value=${JSON.stringify({
        attachment_id: versions[0].id,
        property_id: inserted_property_id
    })}
        />` : null}
    <span
      class="d-flex gap-3 ${display === "signature" ? "align-items-start" : "align-items-center"} flex-justify-between"
    >
      ${display === "signature" ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<img
            class="signature-image"
            src="${versions[0].href}"
            alt="Signature"
            style="height: 40px"
          />` : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a
            class="Link--primary Truncate text-bold"
            href="${versions[0].href}"
            title="${versions[0].name}"
          >
            <span class="Truncate-text">
              ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)(type.icon48(), {
        size: 18,
        viewBox: 48
    })}
              ${versions[0].name}</span
            >
          </a>`}
      ${readonly ? null : $2211ef13a71debdf$var$deleteButton(locale, versions[0])}
    </span>
    <span class="color-fg-muted text-capitalize-first-letter">
      <relative-time datetime="${versions[0].date_iso}"></relative-time>
      by ${(0, $904f4b114d3dc756$export$b6e69390c23686fb)(versions[0].user_unsafe_html)}
    </span>
    ${versions.length < 2 ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<details class="details-reset">
          <summary class="color-fg-muted f6">
            ${versions.length - 1 === 1 ? (0, $2868cc1235412e16$export$4822b96394899afb)[locale] : (0, $2868cc1235412e16$export$a7ad54c5a26c2c49)[locale](versions.length - 1)}
            <span class="dropdown-caret"></span>
          </summary>
          <span class="pl-3 d-flex flex-column gap-1 mt-1">
            ${versions.slice(1).map((x)=>display === "signature" ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
                      class="d-flex gap-3 align-items-start flex-justify-between"
                    >
                      <img
                        class="signature-image"
                        src="${x.href}"
                        alt="Signature"
                        style="height: 40px"
                      />
                      ${readonly ? null : $2211ef13a71debdf$var$deleteButton(locale, x)}
                    </span>
                    <span class="color-fg-muted text-capitalize-first-letter">
                      <relative-time datetime="${x.date_iso}"></relative-time>
                      by ${(0, $904f4b114d3dc756$export$b6e69390c23686fb)(x.user_unsafe_html)}
                    </span>` : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
                    class="d-flex flex-items-center gap-3 flex-justify-between color-fg-muted"
                  >
                    <span
                      ><a
                        class="Link--primary text-capitalize-first-letter"
                        href="${x.href}"
                        ><relative-time datetime="${x.date_iso}"></relative-time
                      ></a>
                      <span>by</span>
                      ${(0, $904f4b114d3dc756$export$b6e69390c23686fb)(x.user_unsafe_html)}</span
                    >
                    ${readonly ? null : $2211ef13a71debdf$var$deleteButton(locale, x)}
                  </span>`)}
          </span>
        </details>`}
  </attachment-group>`;
}
function $2211ef13a71debdf$var$deleteButton(locale, { id: id, name: name }) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<button
    type="button"
    class="btn-octicon btn-octicon-danger mt-n1 mb-n1 ml-n1 mr-n1"
    aria-label="${(0, $2868cc1235412e16$export$9279b045541daaab)[locale](name)}"
    data-action="click:attachment-group#deleteClick"
    attachment-id="${id}"
  >
    ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$c6e11f163cc2dc47))}
  </button>`;
}








var $e0094f86fca373c1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $e0094f86fca373c1$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
let $e0094f86fca373c1$var$AttachmentQuestionElement = class AttachmentQuestionElement extends HTMLElement {
    get property_id() {
        return parseInt(this.getAttribute("property-id"));
    }
    async attachmentAccepted(event) {
        const attachments = event.detail.attachments;
        const uploadUrl = new URL(this.fileAttachmentElement.getAttribute("upload-href"), location.origin);
        let count = this.valueInput.value ? this.valueInput.valueAsNumber : 0;
        try {
            this.fileInput.disabled = true;
            this.fileInput.labels?.[0].classList.add("btn-busy");
            await (0, $49d75368cd6df2b4$export$14d3a7d22f26659e)({
                locale: $e0094f86fca373c1$var$locale,
                attachments: attachments,
                uploadUrl: uploadUrl,
                attachmentSaved: (attachment)=>{
                    count++;
                    this.emptyContent.hidden = true;
                    this.content.insertAdjacentHTML("afterbegin", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $2211ef13a71debdf$export$495f1fafaa7af669)({
                        locale: $e0094f86fca373c1$var$locale,
                        readonly: false,
                        display: "card",
                        inserted_property_id: this.property_id,
                        versions: [
                            {
                                id: attachment.id,
                                name: attachment.name,
                                href: attachment.href,
                                date_iso: new Date().toISOString(),
                                user_unsafe_html: "you"
                            }
                        ]
                    })));
                }
            });
        } finally{
            this.fileInput.disabled = false;
            this.fileInput.labels?.[0].classList.remove("btn-busy");
            this.fileInput.focus();
            this.valueInput.value = count.toString();
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.valueInput);
        }
    }
    valueInputFocused() {
        this.fileInput.focus();
    }
    decrementCount() {
        if (this.valueInput.value === "1") {
            this.valueInput.value = "";
            this.emptyContent.hidden = false;
        } else this.valueInput.value = (parseInt(this.valueInput.value) - 1).toString();
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.valueInput);
    }
};
$e0094f86fca373c1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $e0094f86fca373c1$var$AttachmentQuestionElement.prototype, "fileInput", void 0);
$e0094f86fca373c1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $e0094f86fca373c1$var$AttachmentQuestionElement.prototype, "valueInput", void 0);
$e0094f86fca373c1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $e0094f86fca373c1$var$AttachmentQuestionElement.prototype, "fileAttachmentElement", void 0);
$e0094f86fca373c1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $e0094f86fca373c1$var$AttachmentQuestionElement.prototype, "content", void 0);
$e0094f86fca373c1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $e0094f86fca373c1$var$AttachmentQuestionElement.prototype, "emptyContent", void 0);
$e0094f86fca373c1$var$AttachmentQuestionElement = $e0094f86fca373c1$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("attachment-question")
], $e0094f86fca373c1$var$AttachmentQuestionElement);
let $e0094f86fca373c1$var$AttachmentGroupElement = class AttachmentGroupElement extends HTMLElement {
    connectedCallback() {
        addEventListener("attachment-delete", this);
    }
    disconnectedCallback() {
        removeEventListener("attachment-delete", this);
    }
    get display() {
        return this.getAttribute("display");
    }
    versions() {
        return JSON.parse(this.getAttribute("versions"));
    }
    deleteClick(event) {
        const attachment_id = event.target instanceof Element && event.target.closest("button")?.getAttribute("attachment-id");
        if (!attachment_id) throw new Error("Delete attachment: expected attachment id.");
        const name = this.versions().find((x)=>x.id === attachment_id)?.name;
        if (!name) throw new Error("Delete attachment: versions did not contain attachment id.");
        if (confirm(this.display === "signature" ? (0, $2868cc1235412e16$export$30aaf2514f0013cf)[$e0094f86fca373c1$var$locale] : (0, $2868cc1235412e16$export$4a4b0db14c023cd8)[$e0094f86fca373c1$var$locale](name))) this.dispatchEvent(new CustomEvent("attachment-delete", {
            bubbles: true,
            detail: {
                attachment_id: attachment_id,
                logged: false,
                display: this.display
            }
        }));
    }
    handleEvent(event) {
        if (!event.detail.logged) {
            event.detail.logged = true;
            const controller = document.querySelector("activity-controller");
            if (!controller) throw new Error("Expected activity-controller.");
            controller.form.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
            type="hidden"
            name="delete_attachments/-:json"
            value=${JSON.stringify({
                attachment_id: event.detail.attachment_id
            })}
          />`));
            if (event.detail.display !== "signature") {
                const heading = controller.attachmentsSection.querySelector("h2");
                if (heading) {
                    const count = +heading.getAttribute("attachment-count") - 1;
                    heading.setAttribute("attachment-count", count.toString());
                    if (count === 0) controller.attachmentsSection.innerHTML = "";
                    heading.textContent = count === 1 ? (0, $2868cc1235412e16$export$234c584cd96079ce)[$e0094f86fca373c1$var$locale] : (0, $2868cc1235412e16$export$dd7aa9dbdc015ba1)[$e0094f86fca373c1$var$locale](count);
                }
            }
        }
        const versions = this.versions();
        const index = versions.findIndex((v)=>v.id === event.detail.attachment_id);
        if (index === -1) return;
        versions.splice(index, 1);
        (this.closest("attachment-question") ?? this.closest("signature-question"))?.decrementCount();
        // re-render the attachment group
        this.insertAdjacentHTML("afterend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $2211ef13a71debdf$export$495f1fafaa7af669)({
            locale: $e0094f86fca373c1$var$locale,
            readonly: false,
            display: this.display,
            versions: versions
        })));
        this.remove();
    }
};
$e0094f86fca373c1$var$AttachmentGroupElement = $e0094f86fca373c1$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("attachment-group")
], $e0094f86fca373c1$var$AttachmentGroupElement);



function $887db6b147a603ec$export$e4f5fb782e2ac71d(text, textToMark) {
    if (textToMark.length === 0) return text;
    const index = text.toLowerCase().indexOf(textToMark.toLowerCase());
    if (index === -1) return text;
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${text.substr(0, index)}<mark>${text.substr(index, textToMark.length)}</mark>${text.substr(index + textToMark.length)}`;
}


class $bf1702375e7eaec1$export$c93b5c132cf05ac3 extends HTMLElement {
    connectedCallback() {
        this.disconnectController = new AbortController();
        const signal = this.disconnectController.signal;
        const autocomplete = this.closest("auto-complete");
        if (!autocomplete) return;
        if (autocomplete.src === "/use-events") autocomplete.fetchResult = $bf1702375e7eaec1$var$dispatchAutoCompleteProvide;
        autocomplete.inputElement?.addEventListener("blur", ()=>{
            // Close the dropdown on blur.
            // Timeout ensures this doesn't interfere with blurs that occur when selecting a suggestion.
            setTimeout(()=>{
                if (autocomplete.open) autocomplete.open = false;
            }, 300); // do not reduce without testing quickly toggling between autocomplete suggestions with mouse.
        }, {
            signal: signal
        });
        autocomplete.addEventListener("auto-complete-change", ()=>{
            if (autocomplete.inputElement?.value.endsWith(" ")) // trigger input event to fetch new suggestions
            autocomplete.inputElement.dispatchEvent(new CustomEvent("input", {
                bubbles: true
            }));
        }, {
            signal: signal
        });
        if (this.firstElementChild instanceof HTMLInputElement) {
            const input = this.firstElementChild;
            autocomplete.addEventListener("combobox-commit", ({ target: target })=>{
                if (!(target instanceof HTMLElement)) return;
                const { id: id, title: title } = JSON.parse(target.getAttribute("data-autocomplete-data"));
                input.value = id;
                input.dataset.displayValue = title;
                target.setAttribute("data-autocomplete-value", title);
            }, {
                signal: signal,
                capture: true
            });
            autocomplete.inputElement?.addEventListener("change", ()=>{
                const current = autocomplete.inputElement.value;
                if (current !== input.dataset.displayValue) {
                    autocomplete.inputElement.value = "";
                    input.value = "";
                    input.dataset.displayValue = "";
                }
            }, {
                signal: signal
            });
        }
    }
    disconnectedCallback() {
        this.disconnectController.abort();
    }
}
async function $bf1702375e7eaec1$var$dispatchAutoCompleteProvide(_url) {
    const provided = [];
    const provide = (result)=>{
        provided.push(result);
    };
    const relatedTarget = this.inputElement;
    this.dispatchEvent(new CustomEvent("auto-complete-provide", {
        bubbles: true,
        detail: {
            relatedTarget: relatedTarget,
            provide: provide
        }
    }));
    const results = await Promise.all(provided);
    return (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(results.flatMap((x)=>x.suggestions).map(({ id: id, title: title })=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li
            role="option"
            class="autocomplete-item"
            data-autocomplete-value="${id}"
            data-autocomplete-data="${JSON.stringify({
            id: id,
            title: title
        })}"
          >
            ${(0, $887db6b147a603ec$export$e4f5fb782e2ac71d)(title, relatedTarget.value)}
          </li>`));
}
if (!window.customElements.get("auto-complete-behavior")) {
    window.AutoCompleteBehaviorElement = $bf1702375e7eaec1$export$c93b5c132cf05ac3;
    window.customElements.define("auto-complete-behavior", $bf1702375e7eaec1$export$c93b5c132cf05ac3);
}




function $625d7180bf862706$export$e1e9fa9aba80de8b(item, disabled) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
    <li
      role="option"
      aria-selected="true"
      id="${(0, $5cb959b633531006$export$9e1c824dbb29e809)()}"
      class="autocomplete-list-box-item autocomplete-list-box-item-option"
      data-list-box-value="${JSON.stringify(item)}"
    >
      ${item.title}
      <button
        class="btn-close"
        tabindex="-1"
        type="button"
        aria-label="Delete ${item.title}"
        title="Delete"
        data-list-box-delete
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("hidden", disabled)}
      ></button>
    </li>
  `;
}
function $625d7180bf862706$export$c8ce1c1a107990cc({ id: id, label: label, name: name, value: value, required: required, autocompleteSrc: autocompleteSrc, disabled: disabled, parametric: parametric }) {
    if (!name.endsWith(":json")) throw new Error(`Unexpected <list-box> input name "${name}". Name should end with ":json" directive.`);
    const autocompleteListId = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<autocomplete-list-box
    class="d-block"
    ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
    ${(0, $904f4b114d3dc756$export$65c20e333206336e)("parametric", parametric)}
    data-action="
        combobox-commit:autocomplete-list-box#comboboxCommit
        list-box-item-delete:autocomplete-list-box#listBoxItemDelete
        auto-complete-results-html-rendered:autocomplete-list-box#resultsAdded
      "
  >
    <auto-complete
      class="d-block position-relative"
      src="${autocompleteSrc}"
      for="${autocompleteListId}"
      data-target="autocomplete-list-box.autocomplete"
      fetch-on-empty
    >
      <list-box
        class="d-block form-control input-sm use-focus-within p-0 cursor-text"
        data-action="click:autocomplete-list-box#focusAutocompleteInput"
        multiple
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
      >
        <ul
          aria-label="${label}"
          class="autocomplete-list-box-list"
          data-target="autocomplete-list-box.list"
        >
          ${(value ?? []).map((x)=>$625d7180bf862706$export$e1e9fa9aba80de8b(x, disabled))}
          <li
            class="autocomplete-list-box-item flex-1"
            data-target="autocomplete-list-box.autocompleteInputItem"
          >
            <input
              class="autocomplete-list-box-input"
              id="${id}"
              type="search"
              maxlength="200"
              ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required && (value ?? []).length === 0)}
              ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
              aria-label="Value"
              autocomplete="none"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              data-target="autocomplete-list-box.autocompleteInput"
              data-action="keydown:autocomplete-list-box#handleInputKeyDown"
            />
          </li>
        </ul>
      </list-box>
      <ul id="${autocompleteListId}" class="autocomplete-results" hidden></ul>
    </auto-complete>
    <input
      type="hidden"
      name="${name}"
      value="${JSON.stringify(value)}"
      data-target="autocomplete-list-box.valueInput"
    />
  </autocomplete-list-box>`;
}









const $cb12e05ecb76e37d$var$definitionsMap = new Map();
const $cb12e05ecb76e37d$var$propertiesMap = new Map();
function $cb12e05ecb76e37d$export$acd79bbf6f49afea(form) {
    let definition = $cb12e05ecb76e37d$var$definitionsMap.get(form);
    let properties = $cb12e05ecb76e37d$var$propertiesMap.get(form);
    if (definition && properties) ;
    else {
        // console.log('not cached');
        definition = (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)((0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(form)).definition;
        definition.parameters ?? (definition.parameters = []);
        definition.parameters.forEach((p, i)=>{
            p.name = p.name.toUpperCase();
            if (!(0, $d175770e6e5170f5$export$99da40ee05a17718).test(p.name)) p.name = `$PARAMETER_${i}`;
        });
        properties = Array.from(form.querySelectorAll('[data-property^="{"]')).map((el)=>JSON.parse(el.dataset.property)).filter((x, i, a)=>a.findIndex((y)=>y.property_id === x.property_id) === i);
        $cb12e05ecb76e37d$var$definitionsMap.set(form, definition);
        $cb12e05ecb76e37d$var$propertiesMap.set(form, properties);
        Promise.resolve().then(()=>{
            $cb12e05ecb76e37d$var$definitionsMap.delete(form);
            $cb12e05ecb76e37d$var$propertiesMap.delete(form);
        });
    }
    return {
        definition: definition,
        properties: properties
    };
}


function $dc1ba3c708ab185c$export$149e10162b59b4e2(input) {
    return $dc1ba3c708ab185c$var$getInputParameters(input).filteredParameters;
}
function $dc1ba3c708ab185c$export$9c08897bbef487d2(input, values) {
    for (const value of values){
        if (!(0, $d175770e6e5170f5$export$99da40ee05a17718).test(value)) continue;
        const { parameters: parameters, filteredParameters: filteredParameters, hint: hint } = $dc1ba3c708ab185c$var$getInputParameters(input);
        if (!parameters.some((p)=>p.name === value)) return {
            valid: false,
            message: `Invalid parameter reference. Unknown parameter "${value}".`
        };
        if (!filteredParameters.some((p)=>p.name === value)) return {
            valid: false,
            message: `Invalid parameter reference.${hint ? ` Parameter "${value}" is not of type ${hint}.` : ""}`
        };
    }
    return {
        valid: true
    };
}
function $dc1ba3c708ab185c$var$getInputParameters(input) {
    // todo: request via event.
    if (!input.form) throw new Error("Input is not form associated.");
    const { definition: definition, properties: properties } = (0, $cb12e05ecb76e37d$export$acd79bbf6f49afea)(input.form);
    const { columns: columns, parameters: parameters } = definition;
    // parameters are used in filters, so we need to know the type of filter to determine which types of parameters are valid.
    const filterPointer = "/" + input.name.split("/").slice(0, -1).join("/");
    const filter = (0, $91beb2998e956c83$export$3988ae62b71be9a3)({
        definition: definition
    }, filterPointer);
    if (!filter) throw new Error(`Unable to locate filter associated with parameter reference "${filterPointer}".`);
    const parameterTypes = [];
    const types = [];
    let hint = undefined;
    let property_id;
    if (filter.type === "standard") property_id = filter.property_id;
    else if (filter.aggregate === "min" || filter.aggregate === "max" || filter.aggregate === "last-created" || filter.aggregate === "last-started" || filter.aggregate === "last-ended") property_id = filter.subquery_property_id;
    else {
        parameterTypes.push("literal-number", "select-number");
        types.push("int", "decimal");
        hint = "number";
    }
    if (property_id) {
        const property = properties.find((p)=>p.property_id === property_id);
        if (!property) throw new Error(`Unable to locate property associated with filter "${filterPointer}" with property_id ${property_id}.`);
        switch(property.type){
            case "currency":
            case "decimal":
            case "int":
                parameterTypes.push("literal-number", "select-number");
                types.push("int", "decimal");
                hint = "number";
                break;
            case "date":
                parameterTypes.push("literal-date", "select-date");
                types.push("date", "datetime");
                hint = "date";
                break;
            case "uniqueidentifier":
                switch(property.property_id){
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.create_organization_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.update_organization_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).user_organization.organization_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.update_organization_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.organization_id:
                        parameterTypes.push("organization");
                        hint = "organization";
                        break;
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.user_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.create_user_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.update_user_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_user_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.update_user_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_user_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.comment_create_user_id:
                    case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.comment_mentioned_user_id:
                        parameterTypes.push("user");
                        hint = "user";
                        break;
                }
                break;
        }
    }
    const filteredParameters = [];
    for (const parameter of parameters){
        if (parameterTypes.includes(parameter.type)) filteredParameters.push(parameter);
        else if (parameter.type === "expression" && types.length) {
            const result = (0, $d0aca128151552ea$export$9692209d71b8f134)({
                name: parameter.name,
                expression: parameter.expression,
                getDefinitionInfo: ()=>({
                        columns: columns,
                        parameters: parameters,
                        properties: properties
                    })
            });
            if (result.valid && types.includes(result.type)) filteredParameters.push(parameter);
        } else if (parameter.type === "subquery" && types.length) {
            const { type: type } = (0, $d175770e6e5170f5$export$13d77bb70d7b9d75)(parameter, properties);
            if (type && types.includes(type)) filteredParameters.push(parameter);
        }
    }
    return {
        parameterTypes: parameterTypes,
        types: types,
        hint: hint,
        definition: definition,
        properties: properties,
        parameters: parameters,
        filteredParameters: filteredParameters
    };
}





var $ee61b7dff0fee643$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// fire event when results html is added to the menu
// https://github.com/github/auto-complete-element/blob/8df0008b15af3dc5064db09e15533b77e3f70033/src/autocomplete.ts#L209
const $ee61b7dff0fee643$var$standardIdentifyOptions = (0, $17d439654615f6cc$export$2e2bcd8739ae039).prototype.identifyOptions;
(0, $17d439654615f6cc$export$2e2bcd8739ae039).prototype.identifyOptions = function(...args) {
    this.container.dispatchEvent(new CustomEvent("auto-complete-results-html-rendered", {
        bubbles: true,
        detail: {
            results: this.results,
            query: this.input.value.trim()
        }
    }));
    $ee61b7dff0fee643$var$standardIdentifyOptions.call(this, ...args);
};
let $ee61b7dff0fee643$var$AutocompleteListBoxElement = class AutocompleteListBoxElement extends HTMLElement {
    get parametric() {
        return this.hasAttribute("parametric");
    }
    connectedCallback() {
        document.body.addEventListener("focus", this, {
            capture: true
        });
        document.body.addEventListener("click", this);
    }
    disconnectedCallback() {
        document.body.removeEventListener("focus", this, {
            capture: true
        });
        document.body.removeEventListener("click", this);
    }
    getValue() {
        const current = Array.from(this.list.querySelectorAll("[data-list-box-value]")).map((el)=>JSON.parse(el.getAttribute("data-list-box-value")));
        if (current.length === 0) return null;
        return current;
    }
    synchronize() {
        if (this.hasAttribute("required") && !this.list.querySelectorAll("[data-list-box-value]").length) this.autocompleteInput.required = true;
        else this.autocompleteInput.required = false;
        this.valueInput.value = JSON.stringify(this.getValue());
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.valueInput);
    }
    clear() {
        this.list.querySelectorAll("[data-list-box-value]").forEach((el)=>el.remove());
        this.synchronize();
    }
    handleInputKeyDown(event) {
        if (event.key === "Enter" && this.autocompleteInput.value.length) {
            event.preventDefault();
            return;
        }
        if (event.key === "Backspace" && this.autocompleteInput.value === "" && this.autocompleteInputItem.previousElementSibling instanceof HTMLElement && !event.metaKey && !event.altKey && !event.ctrlKey && !event.shiftKey) {
            this.autocompleteInputItem.previousElementSibling.click();
            this.list.dispatchEvent(new KeyboardEvent(event.type, event));
        }
    }
    async comboboxCommit(event) {
        this.autocomplete.value = "";
        if (!(event.target instanceof Element)) return;
        let value = JSON.parse(event.target.getAttribute("data-autocomplete-data"));
        let item;
        if ("magicKey" in value) {
            const params = new URLSearchParams({
                q: value.text,
                "magic-key": value.magicKey,
                "for-storage": "true"
            });
            this.autocompleteInputItem.insertAdjacentHTML("beforebegin", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li
            class="autocomplete-list-box-item autocomplete-list-box-item-option"
          >
            <span class="spinner-border color-fg-muted"></span>
          </li>`));
            const spinner = this.autocompleteInputItem.previousElementSibling;
            const response = await fetch(`/api/addresses/candidates?${params}`);
            spinner.remove();
            if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
            const [candidate] = await response.json();
            const category = new URL(this.autocomplete.src, location.href).searchParams.get("category");
            const field = (0, $61bb30abbf62bbfa$export$d30a285adb132bc8)[category];
            item = {
                id: candidate[field],
                title: candidate[field]
            };
        } else item = value;
        const current = this.getValue() || [];
        if (current.find((x)=>x.id === item.id)) return;
        this.autocompleteInputItem.insertAdjacentHTML("beforebegin", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $625d7180bf862706$export$e1e9fa9aba80de8b)(item, false)));
        this.synchronize();
        this.focusAutocompleteInput();
    }
    listBoxItemDelete() {
        if (this.list.querySelectorAll("[data-list-box-value]").length === 0) this.autocompleteInput.focus();
        Promise.resolve().then(()=>this.synchronize());
    }
    focusAutocompleteInput() {
        this.autocompleteInput.focus();
    }
    handleEvent(event) {
        if ([
            "focus",
            "click"
        ].includes(event.type) && !this.contains(event.target)) {
            this.autocompleteInput.value = "";
            this.autocomplete.open = false;
        }
    }
    resultsAdded(event) {
        if (!this.parametric || !this.valueInput?.form) return;
        const { results: results, query: query } = event.detail;
        const parameters = (0, $dc1ba3c708ab185c$export$149e10162b59b4e2)(this.valueInput).filter((x)=>x.name.toLowerCase().includes(query.toLowerCase()));
        if (!parameters?.length) return;
        results.insertAdjacentHTML("afterbegin", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(parameters.map(({ name: name })=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li
              role="option"
              class="autocomplete-item"
              data-autocomplete-value="${name}"
              data-autocomplete-data="${JSON.stringify({
                id: name,
                title: name
            })}"
            >
              ${(0, $887db6b147a603ec$export$e4f5fb782e2ac71d)(name, query)}
            </li>`)));
    }
};
$ee61b7dff0fee643$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee61b7dff0fee643$var$AutocompleteListBoxElement.prototype, "list", void 0);
$ee61b7dff0fee643$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee61b7dff0fee643$var$AutocompleteListBoxElement.prototype, "autocomplete", void 0);
$ee61b7dff0fee643$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee61b7dff0fee643$var$AutocompleteListBoxElement.prototype, "valueInput", void 0);
$ee61b7dff0fee643$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee61b7dff0fee643$var$AutocompleteListBoxElement.prototype, "autocompleteInput", void 0);
$ee61b7dff0fee643$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee61b7dff0fee643$var$AutocompleteListBoxElement.prototype, "autocompleteInputItem", void 0);
$ee61b7dff0fee643$var$AutocompleteListBoxElement = $ee61b7dff0fee643$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("autocomplete-list-box")
], $ee61b7dff0fee643$var$AutocompleteListBoxElement);
(0, $f3a2ac2d620bcd8b$export$86f1725708ac86dc)((input, _label)=>{
    if (input instanceof HTMLInputElement && input.getAttribute("data-target")?.includes("autocomplete-list-box.autocompleteInput")) {
        const box = input.closest("autocomplete-list-box");
        if (!box || !box.parametric || box.autocompleteInput !== input) return null;
        const items = JSON.parse(box.valueInput.value);
        if (items.length === 0) return null;
        const result = (0, $dc1ba3c708ab185c$export$9c08897bbef487d2)(box.valueInput, items.map((x)=>x.id));
        return result.valid ? null : result.message;
    }
    return null;
});



class $5ecb6bc4106f092a$export$6348a873744bbf39 extends HTMLElement {
    constructor(){
        super(...arguments);
        this.clearCheckedRadioTimeout = 0;
    }
    connectedCallback() {
        this.addEventListener("change", this, true);
        this.addEventListener("click", this);
        this.addEventListener("keydown", this);
        this.addEventListener("keyup", this);
        this.setTabindexes();
    }
    disconnectedCallback() {
        this.removeEventListener("change", this, true);
        this.removeEventListener("click", this);
        this.removeEventListener("keydown", this);
        this.removeEventListener("keyup", this);
    }
    handleEvent(event) {
        if (event.type === "click" && event.target instanceof HTMLElement && event.target.closest("legend")) {
            this.querySelector('[tabindex="0"]')?.focus();
            return;
        }
        if (event.target instanceof HTMLInputElement && (event.target.type === "checkbox" || event.target.type === "radio")) switch(event.type){
            case "click":
                if (event.target.type === "radio" && event.target.checked) {
                    // Click happens before the change event.
                    // Wait for the change event to fire, if it does, we do not need to clear the radio because it just became checked.
                    const checkedRadio = event.target;
                    clearTimeout(this.clearCheckedRadioTimeout);
                    this.clearCheckedRadioTimeout = setTimeout(()=>{
                        checkedRadio.checked = false;
                        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(checkedRadio);
                    });
                }
                return;
            case "change":
                clearTimeout(this.clearCheckedRadioTimeout);
                this.handleExclusive(event);
                this.setTabindexes();
                return;
            case "keydown":
                switch(event.key){
                    case "ArrowUp":
                    case "ArrowLeft":
                        event.preventDefault();
                        this.moveFocus(event.target, -1);
                        return;
                    case "ArrowDown":
                    case "ArrowRight":
                        event.preventDefault();
                        this.moveFocus(event.target, 1);
                        return;
                }
                return;
            case "keyup":
                switch(event.key){
                    case " ":
                        if (event.target.type === "radio" && event.target.checked) {
                            event.preventDefault();
                            event.target.checked = false;
                            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(event.target);
                        }
                        return;
                }
                return;
        }
    }
    moveFocus(from, delta) {
        const inputs = Array.from(this.querySelectorAll('input[type="checkbox"],input[type="radio"]'));
        let index = inputs.indexOf(from) + delta;
        if (index < 0) index = inputs.length - 1;
        else if (index >= inputs.length) index = 0;
        const to = inputs[index];
        to.focus();
        if (to.checked) {
            from.tabIndex = -1;
            to.tabIndex = 0;
        }
    }
    setTabindexes() {
        const inputs = this.querySelectorAll('input[type="checkbox"],input[type="radio"]');
        let x = undefined;
        for (const input of inputs){
            if (!x) {
                input.tabIndex = 0;
                x = input;
            } else if (x && !x.checked && input.checked) {
                input.tabIndex = 0;
                x.tabIndex = -1;
                x = input;
            } else input.tabIndex = -1;
        }
    }
    handleExclusive({ target: target }) {
        if (target instanceof HTMLInputElement && target.type === "checkbox" && target.checked) {
            const isExclusive = target.hasAttribute("exclusive");
            const inputs = Array.from(this.querySelectorAll(`input[name="${target.name}"]`));
            /**
             * 1. checked an exclusive: uncheck everything else
             * 2. check non-exclusive: uncheck all exclusive
             */ for (const input of inputs){
                if (input === target) continue;
                if (isExclusive && input.checked || input.checked && input.hasAttribute("exclusive")) input.checked = false;
            }
        }
    }
}
if (!window.customElements.get("choice-group")) {
    window.ChoiceGroupElement = $5ecb6bc4106f092a$export$6348a873744bbf39;
    window.customElements.define("choice-group", $5ecb6bc4106f092a$export$6348a873744bbf39);
}







var $74468e1d1a2f27e8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $74468e1d1a2f27e8$var$DashboardControllerElement = class DashboardControllerElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.busy = false;
    }
    connectedCallback() {
        this.key = JSON.parse(this.keyScript.textContent);
        this.parameter_types = JSON.parse(this.getAttribute("parameter_types"));
        const date_loaded = document.getElementById("dashboard-refresh-time")?.getAttribute("datetime");
        if (date_loaded && Date.now() - new Date(date_loaded).getTime() > 900000 // 15 minutes
        ) this.refresh(true);
    }
    async submitParameters(event) {
        event.preventDefault();
        const behavior = event.target;
        await Promise.resolve();
        await this.refresh(false);
        behavior.acceptChanges();
    }
    propagateParameters(parameter_values) {
        for (const element of this.elements){
            if (element.getAttribute("element-type") !== "report") continue;
            const parameter_names_json = element.getAttribute("inherited-parameter-names");
            if (!parameter_names_json) continue;
            const grid = element.querySelector("report-grid");
            if (!grid) continue;
            const parameter_names = JSON.parse(parameter_names_json);
            for (const name of parameter_names){
                const value = parameter_values[name];
                if (value === undefined || value === null) continue;
                const input = grid.parametersForm.querySelector(`input[name^="parameter_values/${name}:"]`);
                if (!(input instanceof HTMLInputElement)) throw new Error(`Expected report-grid parameter input for inherited parameter "${name}".`);
                input.value = Array.isArray(value) ? JSON.stringify(value) : value.toString();
            }
        }
    }
    async refresh(cardsOnly) {
        if (this.busy) return;
        this.busy = true;
        const url = this.getAttribute("refresh-source");
        const { parameter_values: selected_parameter_values = {} } = (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)(new FormData(this.parametersForm));
        let response;
        try {
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(this.parametersForm, true);
            for (const element of this.elements)element.classList.add("shimmer");
            response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    key: this.key,
                    parameter_values: selected_parameter_values
                })
            });
        } finally{
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(this.parametersForm, false);
            for (const element of this.elements)element.classList.remove("shimmer");
            this.busy = false;
        }
        if (!response.ok) {
            (0, $f3a2ac2d620bcd8b$export$7977be5e446db387)(this.parametersForm);
            throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
        }
        const locationUrl = new URL(location.href);
        (0, $d175770e6e5170f5$export$8731bf6742d09f4c)(locationUrl.searchParams, selected_parameter_values);
        history.replaceState(null, "", locationUrl.href);
        const { elements: elements, parameter_values: calculated_parameter_values, date_loaded: date_loaded } = await response.json();
        document.getElementById("dashboard-refresh-time")?.setAttribute("datetime", date_loaded + "Z");
        const parameter_values = (0, $d175770e6e5170f5$export$292a5b8f6eaffa0b)(selected_parameter_values, calculated_parameter_values);
        this.propagateParameters(parameter_values);
        for(let index = 0; index < this.elements.length; index++){
            const element = this.elements[index];
            const element_type = element.getAttribute("element-type");
            const result = elements[index];
            if (!result || result.type !== element_type) // Element mismatch, reload the page. Can happen while editing the dashboard.
            location.reload();
            element.hidden = !result.visible;
            if (result.template) {
                element.insertAdjacentHTML("afterend", result.template);
                element.remove();
            } else switch(result.type){
                case "report":
                    if (result.visible && !cardsOnly) {
                        const grid = element.querySelector("report-grid");
                        grid?.submitParameters();
                    }
            }
        }
    }
};
$74468e1d1a2f27e8$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $74468e1d1a2f27e8$var$DashboardControllerElement.prototype, "keyScript", void 0);
$74468e1d1a2f27e8$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $74468e1d1a2f27e8$var$DashboardControllerElement.prototype, "parametersForm", void 0);
$74468e1d1a2f27e8$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $74468e1d1a2f27e8$var$DashboardControllerElement.prototype, "elements", void 0);
$74468e1d1a2f27e8$var$DashboardControllerElement = $74468e1d1a2f27e8$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("dashboard-controller")
], $74468e1d1a2f27e8$var$DashboardControllerElement);










var $d17d66b0d9673d4e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $d17d66b0d9673d4e$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
let $d17d66b0d9673d4e$var$DateInputElement = class DateInputElement extends HTMLElement {
    get relative() {
        return this.hasAttribute("relative");
    }
    get parametric() {
        return this.hasAttribute("parametric");
    }
    showPicker() {
        if (this.input.value === "") this.pickerInput.valueAsDate = null;
        else if (this.relative && (0, $dbca384612ad025b$export$aebd7d4ffee5ebdd)(this.input.value)) this.pickerInput.valueAsDate = new Date((0, $dbca384612ad025b$export$5729bdcef1c036db)(Date.now(), this.input.value) ?? Date.now());
        else if (this.parametric && (0, $d175770e6e5170f5$export$99da40ee05a17718).test(this.input.value)) this.pickerInput.valueAsDate = null;
        else this.pickerInput.valueAsDate = (0, $dbca384612ad025b$export$7660134aa4da2247)(this.input.value) ?? null;
        this.pickerInput.showPicker();
    }
    suggestionSelected() {
        return Array.from(this.input.list.children).map((o)=>o.value).includes(this.input.value);
    }
    handlePickerInputChange(_event) {
        let value = "";
        if (this.pickerInput.value) {
            // simplify valueAsDate / UTC handling.
            const [year, month, day] = this.pickerInput.value.split("-");
            value = `${+month}/${+day}/${year}`;
        }
        if (this.input.value !== value) {
            this.input.value = value;
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.input);
        }
    }
    handleInputChange(event) {
        if (event.isTrusted && this.input.value) {
            const date = (0, $dbca384612ad025b$export$7660134aa4da2247)(this.input.value);
            if (date) {
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const year = date.getFullYear();
                this.input.value = `${month}/${day}/${year}`;
            } else if (this.parametric && (0, $d175770e6e5170f5$export$99da40ee05a17718).test(this.input.value.trim().toUpperCase())) this.input.value = this.input.value.trim().toUpperCase();
            else if (this.relative && (0, $dbca384612ad025b$export$aebd7d4ffee5ebdd)(this.input.value)) ;
            else setTimeout(()=>{
                (0, $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9)(this.input, `${(0, $f3a2ac2d620bcd8b$export$236350842f3cd9bc)(this.input)} is invalid.`);
                this.closest(".form-group")?.classList.add("errored");
            });
        }
    }
    updateSuggestions() {
        let suggestions = $d17d66b0d9673d4e$var$getNumberSuggestions(this.input, this.relative);
        if (!suggestions.length) suggestions = $d17d66b0d9673d4e$var$getWordSuggestions(this.input, this.relative, this.parametric);
        let option = this.input.list.firstElementChild;
        for (const suggestion of suggestions){
            option ?? (option = document.createElement("option"));
            option.value = suggestion.id.toString();
            option.textContent = suggestion.title;
            if (!option.parentElement) this.input.list.append(option);
            option = option.nextElementSibling;
        }
        while(option){
            const next = option.nextElementSibling;
            option.remove();
            option = next;
        }
    // if (
    //   event.type === 'input' &&
    //   event.isTrusted &&
    //   this.input.value &&
    //   (parseUserDate(this.input.value) ||
    //     (this.parametric &&
    //       identifierRegex.test(this.input.value.trim().toUpperCase())) ||
    //     (this.parametric && isRelativeDate(this.input.value)))
    // ) {
    //   dispatchChange(this.input);
    // }
    }
};
$d17d66b0d9673d4e$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d17d66b0d9673d4e$var$DateInputElement.prototype, "input", void 0);
$d17d66b0d9673d4e$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d17d66b0d9673d4e$var$DateInputElement.prototype, "pickerInput", void 0);
$d17d66b0d9673d4e$var$DateInputElement = $d17d66b0d9673d4e$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("date-input")
], $d17d66b0d9673d4e$var$DateInputElement);
function $d17d66b0d9673d4e$var$getWordSuggestions(input, relative, parametric) {
    if (/[0-9/]/.test(input.value)) return [];
    const today = new Date();
    return [
        ...parametric ? (0, $dc1ba3c708ab185c$export$149e10162b59b4e2)(input).map((x)=>({
                id: x.name,
                title: x.name
            })) : [],
        {
            title: `Today${relative ? "" : ` (${(0, $dbca384612ad025b$export$faf60e60fca9bed1).format(today)})`}`,
            id: relative ? "Today" : (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(today)
        },
        {
            title: `Yesterday${relative ? "" : ` (${(0, $dbca384612ad025b$export$faf60e60fca9bed1).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, -1))})`}`,
            id: relative ? "Yesterday" : (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, -1))
        },
        {
            title: `Tomorrow${relative ? "" : ` (${(0, $dbca384612ad025b$export$faf60e60fca9bed1).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, 1))})`}`,
            id: relative ? "Tomorrow" : (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, 1))
        }
    ];
}
function $d17d66b0d9673d4e$var$getNumberSuggestions(input, relative) {
    const [, rawN] = /^\s*@?\s*(\d+)\s*$/.exec(input.value) || [];
    const n = parseInt(rawN);
    const today = new Date();
    const initialDate = relative ? null : (0, $dbca384612ad025b$export$7660134aa4da2247)(input.defaultValue);
    if (n > 0 && n <= 9999) {
        const unit = n === 1 ? "day" : "days";
        return [
            {
                title: `${n} ${unit} ago${relative ? "" : ` (${(0, $dbca384612ad025b$export$faf60e60fca9bed1).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, 0 - n))})`}`,
                id: relative ? n === 1 ? "Yesterday" : `${n} ${unit} ago` : (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, 0 - n))
            },
            {
                title: `${n} ${unit} from now${relative ? "" : ` (${(0, $dbca384612ad025b$export$faf60e60fca9bed1).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, n))})`}`,
                id: relative ? n === 1 ? "Tomorrow" : `${n} ${unit} from now` : (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(today, n))
            },
            ...initialDate ? [
                {
                    title: `${n} ${unit} from ${(0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(initialDate)} (${(0, $dbca384612ad025b$export$faf60e60fca9bed1).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(initialDate, n))})`,
                    id: (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format((0, $dbca384612ad025b$export$dd412b56f1e4d8aa)(initialDate, n))
                }
            ] : []
        ];
    }
    return [];
}
(0, $f3a2ac2d620bcd8b$export$86f1725708ac86dc)((input, label)=>{
    if (input instanceof HTMLInputElement && input.type === "text" && input.value.length && input.parentElement instanceof $d17d66b0d9673d4e$var$DateInputElement) {
        const value = input.value;
        if (input.parentElement.relative && (0, $dbca384612ad025b$export$aebd7d4ffee5ebdd)(value)) return null;
        if (input.parentElement.parametric) {
            const result = (0, $dc1ba3c708ab185c$export$9c08897bbef487d2)(input, [
                value
            ]);
            return result.valid ? null : result.message;
        }
        const date = Date.parse(value);
        if (isFinite(date) && date >= (0, $dbca384612ad025b$export$5c333a116e949cdd) && date <= (0, $dbca384612ad025b$export$a75f2bff57811055)) return null;
        return (0, $2868cc1235412e16$export$6c61a0cedd6edf45)[$d17d66b0d9673d4e$var$locale](label);
    }
    return null;
});










let $3ab98cd9ce68d450$var$loaded = undefined;
function $3ab98cd9ce68d450$export$29933d84054794ee() {
    if ($3ab98cd9ce68d450$var$loaded === undefined) $3ab98cd9ce68d450$var$loaded = new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
        script.onload = ()=>resolve();
        script.onerror = reject;
        document.head.appendChild(script);
    });
    return $3ab98cd9ce68d450$var$loaded;
}
async function $3ab98cd9ce68d450$var$recaptchaReady() {
    await $3ab98cd9ce68d450$export$29933d84054794ee();
    return new Promise((resolve)=>grecaptcha.ready(resolve));
}
async function $3ab98cd9ce68d450$export$e84dc4729f1af205(action = "submit") {
    await $3ab98cd9ce68d450$var$recaptchaReady;
    return grecaptcha.execute(RECAPTCHA_SITE_KEY, {
        action: action
    });
}




const $56b400225c9c516b$export$ee9f6aa6c23bab6c = "form-before-submit";
const $56b400225c9c516b$export$7acd55e6ec74c9ed = "form-after-submit";
const $56b400225c9c516b$export$707ab90452beb68e = "form-after-submit-data";
const $56b400225c9c516b$export$45a4a6ccc6565969 = "form-server-validation-error";
class $56b400225c9c516b$export$eff824212e04ca3f extends HTMLElement {
    constructor(){
        super();
        this.submitting = null;
        this.initialData = new FormData();
        this.toDispose = [];
        this.isDirty = false;
        this.commitTimeout = 0;
        this.mutationTimeout = 0;
        this.busyCount = 0;
        this.busyPromise = undefined;
        this.resolveBusyPromise = ()=>{};
        this.commit = (event)=>{
            if (!this.isFormValueElementEvent(event)) return;
            (0, $f3a2ac2d620bcd8b$export$b7702f01a27b2311)(event.target);
            clearTimeout(this.commitTimeout);
            if (event.type === "change") (0, $1523f11a9aa97b8a$export$51ca0221714b36af)(event.target);
            this.setDirty();
        };
    }
    get isNew() {
        return this.hasAttribute("new");
    }
    get canSubmit() {
        return this.isDirty || this.isNew;
    }
    get unloadPromptRequired() {
        return this.isDirty && this.getAttribute("unload-prompt") !== "false";
    }
    setBusy(work) {
        if (this.busyCount === 0) this.busyPromise = new Promise((resolve)=>{
            this.resolveBusyPromise = resolve;
        });
        this.busyCount++;
        work.finally(()=>{
            this.busyCount--;
            if (this.busyCount === 0) {
                this.busyPromise = undefined;
                this.resolveBusyPromise();
            }
        });
    }
    connectedCallback() {
        const form = this.parentElement;
        if (!(form instanceof HTMLFormElement)) return;
        form.setAttribute("novalidate", "");
        this.initialData = (0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(form);
        this.subscribe(window, "input", this);
        this.subscribe(window, "change", this);
        this.subscribe(form, "submit", this);
        this.subscribe(window, "keydown", this);
        this.subscribe(form, "details-menu-selected", this);
        this.subscribe(form, "auto-complete-change", this);
        this.observer = new MutationObserver(()=>{
            clearTimeout(this.mutationTimeout);
            this.mutationTimeout = setTimeout(()=>this.setDirty(), 300);
        });
        this.observer.observe(form, {
            subtree: true,
            childList: true
        });
        (0, $1523f11a9aa97b8a$export$7d38c4fd1103f2c4)(form, !this.isNew);
        if (this.hasAttribute("recaptcha")) {
            (0, $3ab98cd9ce68d450$export$29933d84054794ee)();
            form.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<p class="note m-0 lh-default">
            ${(0, $2868cc1235412e16$export$9783dfaf4b8f5180)[(0, $58ccb23ba1dadd05$export$180605366c04f0cd)()]}
          </p>`));
        }
    }
    disconnectedCallback() {
        clearTimeout(this.commitTimeout);
        clearTimeout(this.mutationTimeout);
        for (const dispose of this.toDispose)dispose();
        this.observer?.disconnect();
        window.removeEventListener("beforeunload", this);
    }
    subscribe(target, type, listener) {
        const options = {
            capture: type === "details-menu-selected"
        };
        target.addEventListener(type, listener, options);
        this.toDispose.push(()=>target.removeEventListener(type, listener, options));
    }
    setDirty() {
        const form = this.parentElement;
        const initial = new URLSearchParams(this.initialData).toString();
        const current = new URLSearchParams((0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(form)).toString();
        this.isDirty = current !== initial;
        (0, $1523f11a9aa97b8a$export$7d38c4fd1103f2c4)(form, !this.canSubmit);
        // https://web.dev/articles/bfcache
        window.removeEventListener("beforeunload", this);
        if (this.unloadPromptRequired) window.addEventListener("beforeunload", this);
    }
    acceptChanges() {
        const form = this.parentElement;
        this.initialData = (0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(form);
        this.setDirty();
    }
    handleEvent(event) {
        switch(event.type){
            case "submit":
                this.handleSubmitEvent(event);
                break;
            case "beforeunload":
                this.handleUnloadEvent(event);
                break;
            case "input":
                this.scheduleCommit(event);
                break;
            case "change":
                this.commit(event);
                break;
            case "auto-complete-change":
                this.commit({
                    type: "change",
                    target: event.target.inputElement
                });
                break;
            case "keydown":
                this.handleKeyDown(event);
                break;
            case "details-menu-selected":
                this.setDirty();
                break;
            default:
                throw new Error(`Unexpected event "${event.type}".`);
        }
    }
    isFormValueElementEvent({ target: target }) {
        return (0, $1523f11a9aa97b8a$export$8ab937f042a29230)(target) && target.form === this.parentElement;
    }
    scheduleCommit(event) {
        if (!this.isFormValueElementEvent(event)) return;
        (0, $f3a2ac2d620bcd8b$export$b7702f01a27b2311)(event.target);
        clearTimeout(this.commitTimeout);
        this.commitTimeout = setTimeout(this.commit, 300, event);
    }
    async handleUnloadEvent(event) {
        if (!this.unloadPromptRequired) return;
        event.preventDefault();
        event.returnValue = "You have unsaved work."; // browser overrides this text
    }
    handleKeyDown(event) {
        if (!(event.ctrlKey || event.metaKey) || event.shiftKey || event.altKey || event.key !== "s" || event.defaultPrevented || this.getAttribute("submit-shortcut") === "false" || this.getAttribute("unload-prompt") === "false") return;
        const closestBehavior = event.target instanceof Element && event.target.closest("form")?.querySelector("form-behavior");
        if (closestBehavior && closestBehavior !== this) return;
        event.preventDefault();
        if ((0, $1523f11a9aa97b8a$export$8ab937f042a29230)(event.target)) {
            event.target.blur();
            event.target.focus();
        }
        this.setDirty();
        if (!this.canSubmit) return;
        const form = this.parentElement;
        form.requestSubmit();
    }
    async handleSubmitEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.submit(event.submitter);
    }
    submit(submitter) {
        if (!this.submitting) this.submitting = this.submitInternal(submitter);
        return this.submitting;
    }
    async submitInternal(submitter) {
        await this.busyPromise;
        const form = this.parentElement;
        const recaptcha = this.hasAttribute("recaptcha");
        try {
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(form, true);
            const body = (0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(form);
            if (submitter?.hasAttribute("name") && submitter.hasAttribute("value")) body.set(submitter.getAttribute("name"), submitter.getAttribute("value"));
            const [{ valid: valid }, recaptchaToken] = await Promise.all([
                (0, $f3a2ac2d620bcd8b$export$ed692cabb252e59b)(form),
                recaptcha ? (0, $3ab98cd9ce68d450$export$e84dc4729f1af205)() : Promise.resolve(null)
            ]);
            if (!valid) return;
            const beforeSubmitEvent = new CustomEvent($56b400225c9c516b$export$ee9f6aa6c23bab6c, {
                detail: body,
                bubbles: true,
                cancelable: true
            });
            if (!this.dispatchEvent(beforeSubmitEvent)) return;
            const afterSubmitEvent = new CustomEvent($56b400225c9c516b$export$7acd55e6ec74c9ed, {
                detail: body,
                bubbles: true
            });
            if (!form.hasAttribute("action")) {
                this.dispatchEvent(afterSubmitEvent);
                return;
            }
            if (this.hasAttribute("standard-submit")) {
                window.removeEventListener("beforeunload", this);
                form.submit(); // unable to make form.requestSubmit(submitter) work?
                this.dispatchEvent(afterSubmitEvent);
                return;
            }
            const method = submitter?.getAttribute("formmethod") ?? form.method;
            const action = submitter?.getAttribute("formaction") ?? form.action;
            if (method === "get" && this.hasAttribute("navigation")) {
                const params = new URLSearchParams(body);
                this.navigate(`${form.action}?${params}`);
                return;
            }
            const url = new URL(action || location.href, location.origin);
            const init = {
                method: method,
                body: body
            };
            if (url.searchParams.has("_method")) {
                init.method = url.searchParams.get("_method");
                url.searchParams.delete("_method");
            }
            if (init.method === "get") {
                delete init.body;
                for (const [key, value] of body){
                    if (typeof value !== "string") throw new Error(`Cannot use non-string value in GET request.`);
                    url.searchParams.set(key, value);
                }
            }
            if (init.method === "delete" && (0, $1523f11a9aa97b8a$export$18cb2924d47bc4a1)(body.keys())) delete init.body; // cloudflare throws 400 when DELETE is used with form data body.
            const request = new Request(url.href, init);
            if (recaptchaToken) request.headers.set("recaptcha-token", recaptchaToken);
            if (this.hasAttribute("accept")) request.headers.set("accept", this.getAttribute("accept"));
            const response = await fetch(request);
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(form, false);
            if (response.ok) {
                this.initialData = body;
                this.removeAttribute("new");
                form.action = response.headers.get("x-cumulus-form-action") ?? form.action;
                this.setDirty();
                (0, $1523f11a9aa97b8a$export$d711e159ced15444)(form);
                this.dispatchEvent(afterSubmitEvent);
                this.dispatchEvent(new CustomEvent($56b400225c9c516b$export$707ab90452beb68e, {
                    detail: response,
                    bubbles: true
                }));
                this.navigate(response.headers.get("location"));
            } else if (response.status === 400) {
                const body = response.headers.get("content-type") === "application/json" ? await response.json() : null;
                (0, $f3a2ac2d620bcd8b$export$7977be5e446db387)(form, body);
                this.dispatchEvent(new CustomEvent($56b400225c9c516b$export$45a4a6ccc6565969, {
                    bubbles: true
                }));
            } else if (!(0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) (0, $f3a2ac2d620bcd8b$export$dd5ae15f22741a23)(form);
        } finally{
            this.submitting = null;
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(form, false);
        }
    }
    navigate(href) {
        switch(this.getAttribute("navigation")){
            case null:
                break;
            case "follow":
                if (href) location.href = href;
                break;
            case "replace":
                if (href) location.replace(href);
                break;
            case "replace-state":
                if (href) history.replaceState(undefined, "", href);
                break;
            case "modal":
                if (href) {
                    const frag = document.createElement("include-fragment");
                    frag.src = href;
                    const modal = document.createElement("modal-content");
                    modal.append(frag);
                    document.body.append(modal);
                }
                break;
            case "reload":
                location.reload();
                break;
            default:
                throw new Error(`Unexpected submit attribute value.`);
        }
    }
}
if (!window.customElements.get("form-behavior")) {
    window.FormBehaviorElement = $56b400225c9c516b$export$eff824212e04ca3f;
    window.customElements.define("form-behavior", $56b400225c9c516b$export$eff824212e04ca3f);
}


const $2cec88eec4bda265$export$675da22fdc41408c = "modal-dismiss";
function $2cec88eec4bda265$var$focusable(el) {
    const result = (el instanceof HTMLButtonElement || el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement || el instanceof HTMLAnchorElement || el instanceof HTMLElement && el.tagName === "SUMMARY") && el.isConnected && el.tabIndex >= 0 && !el.disabled && !el.hidden && el.offsetWidth > 0 && el.offsetHeight > 0 && el.type !== "hidden";
    return result;
}
function $2cec88eec4bda265$var$autofocus(container) {
    let target = Array.from(container.querySelectorAll("[autofocus]")).filter($2cec88eec4bda265$var$focusable)[0];
    if (!target && container.firstElementChild instanceof (0, $4941bdcfe743ed78$export$2e2bcd8739ae039)) {
        container.firstElementChild.addEventListener("include-fragment-replaced", ()=>$2cec88eec4bda265$var$autofocus(container), {
            once: true
        });
        return;
    }
    if (!target) {
        target = container;
        container.setAttribute("tabindex", "-1");
    }
    target.focus();
}
let $2cec88eec4bda265$var$hideCount = 0;
function $2cec88eec4bda265$var$hideBodyScrollbar() {
    $2cec88eec4bda265$var$hideCount++;
    if ($2cec88eec4bda265$var$hideCount > 1) return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = document.documentElement.clientWidth;
    const bodyStyle = document.body.style;
    bodyStyle.paddingRight = `${Math.abs(window.innerWidth - documentWidth)}px`;
    bodyStyle.overflow = "hidden";
}
function $2cec88eec4bda265$var$unhideBodyScrollbar() {
    $2cec88eec4bda265$var$hideCount--;
    if ($2cec88eec4bda265$var$hideCount > 0) return;
    const bodyStyle = document.body.style;
    bodyStyle.paddingRight = "";
    bodyStyle.overflow = "";
}
class $2cec88eec4bda265$export$973593ccecb6664f extends HTMLElement {
    get controller() {
        const id = this.getAttribute("controller-id");
        return id ? document.getElementById(id) : null;
    }
    connectedCallback() {
        this.setAttribute("role", "dialog");
        this.setAttribute("aria-modal", "true");
        this.setAriaLabelledBy();
        $2cec88eec4bda265$var$hideBodyScrollbar();
        this.activeElement = document.activeElement;
        setTimeout($2cec88eec4bda265$var$autofocus, 0, this);
        this.addEventListener("keydown", this);
        this.addEventListener("click", this);
        this.addEventListener((0, $56b400225c9c516b$export$7acd55e6ec74c9ed), this);
        addEventListener("focus", this, true);
        this.addEventListener("include-fragment-replaced", this, true);
    }
    disconnectedCallback() {
        $2cec88eec4bda265$var$unhideBodyScrollbar();
        if (this.activeElement instanceof HTMLElement && this.activeElement.isConnected && $2cec88eec4bda265$var$focusable(this.activeElement)) // this.ownerDocument.documentElement.style.scrollBehavior = 'auto';
        this.activeElement.focus();
        this.removeEventListener("keydown", this);
        this.removeEventListener("click", this);
        this.removeEventListener((0, $56b400225c9c516b$export$7acd55e6ec74c9ed), this);
        removeEventListener("focus", this, true);
        this.removeEventListener("include-fragment-replaced", this, true);
    }
    async handleEvent(event) {
        const { target: target } = event;
        switch(event.type){
            case 0, $56b400225c9c516b$export$7acd55e6ec74c9ed:
                await new Promise((resolve)=>setTimeout(resolve));
                this.remove();
                break;
            case "keydown":
                if (!(event instanceof KeyboardEvent)) return;
                if (this.hasAttribute("force-submit")) return;
                if (event.key === "Escape" || event.key === "Esc") {
                    event.stopPropagation();
                    if (this.canDismiss()) this.remove();
                }
                break;
            case "click":
                if (!this.hasAttribute("force-submit") && (target === this || target instanceof Element && target.closest("[modal-dismiss]")) && this.canDismiss()) {
                    if (target instanceof Element && target.closest('button[type="submit"]')) await new Promise((resolve)=>setTimeout(resolve));
                    this.remove();
                }
                break;
            case "focus":
                if (target instanceof Element && (this.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_CONTAINED_BY) === 0 && target.closest("modal-content") === null) {
                    event.preventDefault();
                    Array.from(this.querySelectorAll("a,button,input,select,summary,textarea")).filter($2cec88eec4bda265$var$focusable)[0]?.focus();
                }
                break;
            case "include-fragment-replaced":
                this.setAriaLabelledBy();
                break;
            default:
                throw new Error(`Unexpected event type "${event.type}".`);
        }
    }
    setAriaLabelledBy() {
        const heading = this.querySelector("h1,h2,h3,h4,h5,h6");
        if (heading) {
            if (!heading.id) heading.id = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
            this.setAttribute("aria-labelledby", heading.id);
        }
    }
    canDismiss() {
        return this.dispatchEvent(new CustomEvent($2cec88eec4bda265$export$675da22fdc41408c, {
            bubbles: true,
            cancelable: true
        }));
    }
}
if (!window.customElements.get("modal-content")) {
    window.ModalContentElement = $2cec88eec4bda265$export$973593ccecb6664f;
    window.customElements.define("modal-content", $2cec88eec4bda265$export$973593ccecb6664f);
}



function $ac78e381acc25afa$export$4820f16af6be735(content) {
    return new Promise((resolve)=>{
        document.body.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<modal-content>${content}</modal-content>`));
        const modal = document.body.lastElementChild;
        const handleSubmit = (event)=>{
            dispose();
            modal.remove();
            resolve({
                submitted: true,
                formData: event.detail,
                data: (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)(event.detail)
            });
        };
        const handleClose = ()=>{
            dispose();
            resolve({
                submitted: false
            });
        };
        const dispose = ()=>{
            modal.removeEventListener((0, $56b400225c9c516b$export$7acd55e6ec74c9ed), handleSubmit);
            modal.removeEventListener((0, $2cec88eec4bda265$export$675da22fdc41408c), handleClose);
        };
        modal.addEventListener((0, $56b400225c9c516b$export$7acd55e6ec74c9ed), handleSubmit);
        modal.addEventListener((0, $2cec88eec4bda265$export$675da22fdc41408c), handleClose);
    });
}




var $697ee5b9b882d869$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $697ee5b9b882d869$export$1ffd6d40eedae5b3 = class EditAvatarElement extends HTMLElement {
    async fileSelected({ target: target }) {
        if (!(target instanceof HTMLInputElement) || !target.files || target.files.length === 0) return;
        const file = target.files[0];
        const url = URL.createObjectURL(file);
        try {
            target.disabled = true;
            const result = await (0, $ac78e381acc25afa$export$4820f16af6be735)($697ee5b9b882d869$var$avatarCropModalTemplate(url));
            if (!result.submitted) return;
            target.labels?.item(1).classList.add("btn-busy");
            const { x: x, y: y, width: width, height: height } = result.data;
            if (width !== height) throw new Error("Dimensions must be square.");
            const sourceImage = new Image();
            await new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>{
                    sourceImage.src = reader.result;
                    resolve();
                };
                reader.readAsDataURL(file);
            });
            const size = (0, $0698681c3e411266$export$65bbdb088890cb21).maxSize;
            const quality = 1;
            const type = (0, $0698681c3e411266$export$65bbdb088890cb21).type;
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(sourceImage, x, y, width, height, 0, 0, size, size);
            const blob = await new Promise((resolve)=>canvas.toBlob(resolve, type, quality));
            if (!blob) throw new Error("canvas.toBlob resolved with null");
            const body = new FormData();
            body.set("file", blob, file.name);
            const action = this.getAttribute("action");
            if (!action) throw new Error("action attribute required.");
            const actionUrl = new URL(action, location.origin);
            let response = await fetch(actionUrl, {
                method: "PUT",
                body: body
            });
            if (response.status >= 500 && response.status < 600) {
                response.text().then((text)=>{
                    throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, text);
                });
                await new Promise((resolve)=>setTimeout(resolve, 3000));
                actionUrl.searchParams.set("retry", "1");
                response = await fetch(actionUrl, {
                    method: "PUT",
                    body: body
                });
            }
            if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) {
                alert("Upload failed. Please try again later.");
                throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
            }
            location.reload();
        } finally{
            target.disabled = false;
            target.value = "";
            URL.revokeObjectURL(url);
            target.labels?.item(1).classList.remove("btn-busy");
        }
    }
};
$697ee5b9b882d869$export$1ffd6d40eedae5b3 = $697ee5b9b882d869$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("edit-avatar")
], $697ee5b9b882d869$export$1ffd6d40eedae5b3);
function $697ee5b9b882d869$var$avatarCropModalTemplate(url) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<form
    class="Box d-flex flex-column anim-fade-in fast"
    style="max-height: calc(100vh - 48px - 48px)"
  >
    <form-behavior new></form-behavior>
    <div class="Box-header">
      <h3 class="Box-title">Crop your new profile picture</h3>
    </div>
    <div class="Box-body overflow-auto">
      <image-crop src="${url}" rounded style="max-width: 400px">
        <input type="hidden" data-image-crop-input="x" name="x" />
        <input type="hidden" data-image-crop-input="y" name="y" />
        <input type="hidden" data-image-crop-input="width" name="width" />
        <input type="hidden" data-image-crop-input="height" name="height" />
      </image-crop>
    </div>
    <div class="Box-footer">
      <button type="submit" class="btn btn-primary" autofocus>
        <span>Save profile picture</span>
      </button>
      <button type="button" class="btn" modal-dismiss>Cancel</button>
    </div>
  </form>`;
}








var $966a268ff99dc387$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $966a268ff99dc387$export$c0762fb6e6e5d033 = class EditableListElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.handlePaste = (event)=>{
            let li = event.target instanceof HTMLInputElement && event.target.closest("li");
            if (!li) return;
            if (li.closest("editable-list") !== this) return;
            const rows = (event.clipboardData?.getData("text/plain") ?? "").split(/\r?\n/).map((row)=>row.split("	").map((cell)=>cell.trim()));
            if (rows.length < 2) return;
            event.preventDefault();
            let startInputIndex = NaN;
            let focusTarget;
            for (const row of rows){
                if (!li) li = this.addListItem();
                let col = 0;
                let inputIndex = 0;
                for (const input of li.querySelectorAll("input")){
                    if (row.length > col && input.form && [
                        "text",
                        "email",
                        "number"
                    ].includes(input.type) && getComputedStyle(input).display !== "none" && (inputIndex >= startInputIndex || input === event.target)) {
                        if (input === event.target) startInputIndex = inputIndex;
                        input.value = row[col];
                        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(input);
                        focusTarget = input;
                        col++;
                    }
                    inputIndex++;
                }
                li = li.nextElementSibling;
            }
            focusTarget?.focus();
            focusTarget && (0, $eb08f38ae8877120$export$9657601bf1e130ee)(focusTarget);
        };
    }
    connectedCallback() {
        this.addEventListener("paste", this.handlePaste);
    }
    disconnectedCallback() {
        this.removeEventListener("paste", this.handlePaste);
    }
    safariBug(list) {
        // https://support.cumulus.care/a/tickets/1992
        list.style.zoom = "1";
        setTimeout(()=>list.style.zoom = "");
    }
    removeListItem(event) {
        const target = event.target;
        const item = target.closest("li");
        this.removeListItemInternal(item);
    }
    removeAllListItems() {
        const list = this.querySelector("ol,ul");
        if (!list) return;
        for (const item of Array.from(list.children))this.removeListItemInternal(item);
    }
    removeListItemInternal(item) {
        item.querySelectorAll('.form-group.errored input:not([type="hidden"])').forEach((input)=>{
            if (input.form) (0, $f3a2ac2d620bcd8b$export$b7702f01a27b2311)(input);
        });
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        let next = item.nextElementSibling;
        (0, $eb08f38ae8877120$export$956fd4dade47957a)(item.previousElementSibling) || (0, $eb08f38ae8877120$export$956fd4dade47957a)(this);
        item.remove();
        this.synchronizeBlankslate();
        const listName = this.getAttribute("name");
        let i = index;
        while(next){
            $966a268ff99dc387$var$updatePointers(next, listName, i);
            next = next.nextElementSibling;
            i++;
        }
        this.dispatchEvent(new CustomEvent("editable-list-change", {
            bubbles: true,
            detail: {
                indexes: [
                    ...Array(list.children.length + 1).keys()
                ].reduce((p, c)=>{
                    p[c] = c === index ? null : c < index ? c : c - 1;
                    return p;
                }, {})
            }
        }));
        this.safariBug(list);
    }
    moveListItemUp(event) {
        const target = event.target;
        const item = target.closest("li");
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const previous = item.previousElementSibling;
        const listName = this.getAttribute("name");
        if (previous) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            previous.before(item);
            $966a268ff99dc387$var$updatePointers(item, listName, index - 1);
            $966a268ff99dc387$var$updatePointers(previous, listName, index);
            target.focus();
            this.dispatchEvent(new CustomEvent("editable-list-change", {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c === index - 1 ? index : c === index ? index - 1 : c;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    moveListItemDown(event) {
        const target = event.target;
        const item = target.closest("li");
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const next = item.nextElementSibling;
        const listName = this.getAttribute("name");
        if (next) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            next.after(item);
            $966a268ff99dc387$var$updatePointers(item, listName, index + 1);
            $966a268ff99dc387$var$updatePointers(next, listName, index);
            target.focus();
            this.dispatchEvent(new CustomEvent("editable-list-change", {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c === index + 1 ? index : c === index ? index + 1 : c;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    moveListItemTop(event) {
        const target = event.target;
        const item = target.closest("li");
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const first = list.firstElementChild;
        const listName = this.getAttribute("name");
        if (first && first !== item) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            first.before(item);
            for(let i = 0; i <= index; i++)$966a268ff99dc387$var$updatePointers(list.children.item(i), listName, i);
            target.focus();
            this.dispatchEvent(new CustomEvent("editable-list-change", {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c === index ? 0 : c < index ? c - 1 : c;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    moveListItemBottom(event) {
        const target = event.target;
        const item = target.closest("li");
        const list = item.parentElement;
        const index = Array.from(list.children).indexOf(item);
        const last = list.lastElementChild;
        const listName = this.getAttribute("name");
        if (last && last !== item) {
            this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
            item.remove();
            last.after(item);
            for(let i = index; i < list.children.length; i++)$966a268ff99dc387$var$updatePointers(list.children.item(i), listName, i);
            target.focus();
            this.dispatchEvent(new CustomEvent("editable-list-change", {
                bubbles: true,
                detail: {
                    indexes: [
                        ...Array(list.children.length).keys()
                    ].reduce((p, c)=>{
                        p[c] = c < index ? c : c === index ? list.children.length - 1 : c - 1;
                        return p;
                    }, {})
                }
            }));
            this.rowHighlightClass && item.classList.add(this.rowHighlightClass);
        }
    }
    editListItem(event) {
        const target = event.target;
        const item = target.closest("li");
        item.classList.add("Editable--editing");
        (0, $eb08f38ae8877120$export$956fd4dade47957a)(item);
    }
    duplicateListItem(event) {
        const target = event.target;
        const item = target.closest("li");
        this.rowHighlightClass && item.classList.remove(this.rowHighlightClass);
        const template = document.createElement("template");
        const clone = item.cloneNode(true);
        const itemSelects = item.querySelectorAll("select");
        const cloneSelects = clone.querySelectorAll("select");
        for(let i = 0; i < itemSelects.length; i++){
            cloneSelects[i].querySelector("[selected]")?.removeAttribute("selected");
            cloneSelects[i].querySelector(`[value="${itemSelects[i].hasAttribute("data-clone-value") ? itemSelects[i].getAttribute("data-clone-value") : itemSelects[i].value}"]`)?.toggleAttribute("selected", true);
        }
        template.content.append(clone);
        return this.insertListItemInternal(template, item);
    }
    addListItem() {
        return this.insertListItemInternal(this.itemTemplate);
    }
    addSecondaryListItem() {
        return this.insertListItemInternal(this.secondaryItemTemplate);
    }
    addTertiaryListItem() {
        return this.insertListItemInternal(this.tertiaryItemTemplate);
    }
    insertListItemInternal(itemTemplate, after) {
        const list = this.querySelector("ol,ul");
        if (!list || !itemTemplate) return null;
        const maxItems = parseInt(this.getAttribute("max-items") ?? "");
        if (Number.isInteger(maxItems) && list.children.length >= maxItems) {
            const label = document.getElementById(list.getAttribute("aria-labelledby") ?? "undefined-labelledby-id")?.innerText ?? list.getAttribute("aria-label") ?? "items";
            alert(`The maximum number of ${label.toLowerCase()} is ${maxItems}.`);
            return;
        }
        const fragment = $966a268ff99dc387$export$75a0370f3222215a(itemTemplate);
        let index;
        if (after) {
            after.after(fragment);
            index = Array.from(list.children).indexOf(after) + 1;
        } else {
            list.append(fragment);
            index = list.children.length - 1;
        }
        this.synchronizeBlankslate();
        const inserted = list.children.item(index);
        (0, $eb08f38ae8877120$export$956fd4dade47957a)(inserted);
        while(index < list.children.length){
            $966a268ff99dc387$export$ae91b67ff38afcc3(list.children.item(index));
            index++;
        }
        inserted.querySelectorAll('input[type="checkbox"][data-action*="change:editable-list#handlePrimaryChanged"]').forEach((input)=>{
            input.checked = !(0, $1523f11a9aa97b8a$export$3ef28703d495bc16)(input).filter((input)=>input.matches('[data-action*="change:editable-list#handlePrimaryChanged"]')).some((el)=>el.checked);
        });
        this.dispatchEvent(new CustomEvent("editable-list-change", {
            bubbles: true,
            detail: {
                indexes: Array.from({
                    length: list.children.length
                }).map((_, index)=>index).reduce((p, c)=>{
                    p[c] = c;
                    return p;
                }, {})
            }
        }));
        this.safariBug(list);
        this.rowHighlightClass && inserted.classList.add(this.rowHighlightClass);
        (0, $eb08f38ae8877120$export$9657601bf1e130ee)(inserted);
        return inserted;
    }
    synchronizeBlankslate() {
        const list = this.querySelector("ol,ul");
        if (!list || !this.blankslateTemplate) return;
        if (list.children.length > 1 && this.blankslate) this.blankslate.remove();
        else if (list.children.length === 0) {
            const fragment = $966a268ff99dc387$export$75a0370f3222215a(this.blankslateTemplate);
            list.append(fragment);
        }
    }
    handlePrimaryChanged({ target: target }) {
        if (target.checked) (0, $1523f11a9aa97b8a$export$3ef28703d495bc16)(target).filter((el)=>el.matches('[data-action*="change:editable-list#handlePrimaryChanged"]')).forEach((el)=>{
            el.checked = el === target;
        });
    }
};
$966a268ff99dc387$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $966a268ff99dc387$export$c0762fb6e6e5d033.prototype, "itemTemplate", void 0);
$966a268ff99dc387$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $966a268ff99dc387$export$c0762fb6e6e5d033.prototype, "secondaryItemTemplate", void 0);
$966a268ff99dc387$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $966a268ff99dc387$export$c0762fb6e6e5d033.prototype, "tertiaryItemTemplate", void 0);
$966a268ff99dc387$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $966a268ff99dc387$export$c0762fb6e6e5d033.prototype, "blankslate", void 0);
$966a268ff99dc387$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $966a268ff99dc387$export$c0762fb6e6e5d033.prototype, "blankslateTemplate", void 0);
$966a268ff99dc387$var$__decorate([
    (0, $eb3c1389b956a11c$export$7aabe8b3a840d2fd)
], $966a268ff99dc387$export$c0762fb6e6e5d033.prototype, "rowHighlightClass", void 0);
$966a268ff99dc387$export$c0762fb6e6e5d033 = $966a268ff99dc387$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("editable-list")
], $966a268ff99dc387$export$c0762fb6e6e5d033);
const $966a268ff99dc387$var$referenceAttributes = [
    "for",
    "aria-labelledby",
    "aria-describedby",
    "aria-owns",
    "data-toggle-for",
    "form",
    "list",
    "input",
    "error-alert"
];
function $966a268ff99dc387$export$75a0370f3222215a(template) {
    const fragment = template.content.cloneNode(true);
    for (const el of Array.from(fragment.querySelectorAll("[id]"))){
        const newId = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
        for (const attr of $966a268ff99dc387$var$referenceAttributes)for (const ref of fragment.querySelectorAll(`[${attr}~="${el.id}"]`)){
            const current = ref.getAttribute(attr);
            const updated = current.split(/\s+/).map((v)=>v === el.id ? newId : v).join(" ");
            // console.log(`${attr} "${current}" "${updated}"`);
            ref.setAttribute(attr, updated);
        }
        el.id = newId;
    }
    return fragment;
}
function $966a268ff99dc387$export$ae91b67ff38afcc3(el) {
    let li = el.closest("li") ?? null;
    let editableList = li?.closest("editable-list") ?? null;
    const updates = [];
    while(editableList && li){
        const listName = editableList.getAttribute("name");
        const index = Array.prototype.indexOf.call(li.parentElement.children, li);
        updates.unshift({
            listName: listName,
            index: index
        });
        li = editableList.closest("li");
        editableList = li?.closest("editable-list") ?? null;
    }
    for (const { listName: listName, index: index } of updates)$966a268ff99dc387$var$updatePointers(el, listName, index);
}
function $966a268ff99dc387$var$updatePointer(el, listName, index) {
    const suffix = el.getAttribute("name").replace(listName, "").replace(/^\/\d+/, "");
    el.setAttribute("name", `${listName}/${index}${suffix}`);
}
function $966a268ff99dc387$var$updatePointers(el, listName, index) {
    const selector = `[name^="${listName}/"]`;
    if (el.matches(selector)) $966a268ff99dc387$var$updatePointer(el, listName, index);
    el.querySelectorAll(selector).forEach((el)=>$966a268ff99dc387$var$updatePointer(el, listName, index));
}







var $1fd8ad828c12b706$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1fd8ad828c12b706$var$ExcelAttachmentElement = class ExcelAttachmentElement extends HTMLElement {
    async attachmentAccepted(event) {
        const attachments = event.detail.attachments;
        (0, $f3a2ac2d620bcd8b$export$b7702f01a27b2311)(this.valueInput.form);
        try {
            this.fileInput.disabled = true;
            this.fileInput.labels?.[0].classList.add("btn-busy");
            const file = attachments[0].file;
            const data = await (0, $084f49e21d0e189c$export$bf2e8542514694ef)(file.arrayBuffer(), file.name, this.valueInput.form, this.getAttribute("lower-case-keys") === "true");
            this.valueInput.value = JSON.stringify(data);
            this.filenameInput.value = file.name;
            await this.querySelector("form-behavior")?.submit();
        } finally{
            this.fileInput.disabled = false;
            this.fileInput.labels?.[0].classList.remove("btn-busy");
            this.fileInput.focus();
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.valueInput);
        }
    }
    valueInputFocused() {
        this.fileInput.focus();
    }
};
$1fd8ad828c12b706$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $1fd8ad828c12b706$var$ExcelAttachmentElement.prototype, "fileInput", void 0);
$1fd8ad828c12b706$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $1fd8ad828c12b706$var$ExcelAttachmentElement.prototype, "valueInput", void 0);
$1fd8ad828c12b706$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $1fd8ad828c12b706$var$ExcelAttachmentElement.prototype, "filenameInput", void 0);
$1fd8ad828c12b706$var$ExcelAttachmentElement = $1fd8ad828c12b706$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("excel-attachment")
], $1fd8ad828c12b706$var$ExcelAttachmentElement);


const $9151eade1f5d9549$export$4a61b9856b3d6ba6 = "expression-scope-request";





/*
in-use:
Identifier
Literal
CallExpression
BinaryExpression
UnaryExpression (only negation of literal numbers and boolean expressions)
*/ const $40788fc153d47c94$var$functions = {
    SELECTED: {
        returnType: ()=>"boolean",
        minArguments: 2,
        maxArguments: 33,
        restArgument: true,
        arguments: [
            {
                type: "property-reference",
                validate: (property)=>[
                        "single",
                        "multiple"
                    ].includes(property.choice_type) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not a single or multiple choice property.`
                    }
            },
            {
                type: "choice-reference"
            }
        ]
    },
    COUNTIF: {
        returnType: ()=>"int",
        minArguments: 1,
        maxArguments: 15,
        restArgument: true,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "boolean" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean.`
                    }
            }
        ]
    },
    ANY: {
        returnType: ()=>"boolean",
        minArguments: 2,
        maxArguments: 15,
        restArgument: true,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "boolean" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean.`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "boolean" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean.`
                    }
            }
        ]
    },
    VALUE: {
        returnType: ({ context: { properties: properties }, args: args })=>{
            const node = args[0];
            let property = undefined;
            if (node.type === "Literal") property = properties[node.value];
            else property = (0, $0dbabea6e8ef01ef$export$7442465335b8f729)[node.name.toUpperCase()];
            if (!property) throw new Error(`Unable to locate property for "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}".`);
            switch(property?.type){
                case "signature":
                case "medications":
                case "attachment":
                case "int":
                    return "int";
                case "currency":
                case "decimal":
                    return "decimal";
                case "bit":
                    return "boolean";
                case "varchar100":
                case "varcharmax":
                    return "string";
                case "date":
                    return "date";
                default:
                    throw new Error(`Unexepected property type "${property?.type}" used in "VALUE(${node.value})" expression.`);
            }
        },
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "property-reference",
                validate: (property)=>[
                        "int",
                        "decimal",
                        "currency"
                    ].includes(property.type) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not an int, decimal, or currency property.`
                    }
            }
        ]
    },
    ANSWERED: {
        returnType: ()=>"boolean",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "property-reference",
                validate: ()=>({
                        valid: true
                    })
            }
        ]
    },
    SCORE: {
        returnType: ()=>"int",
        minArguments: 1,
        maxArguments: 32,
        restArgument: true,
        arguments: [
            {
                type: "property-reference",
                validate: (property)=>[
                        "single",
                        "multiple"
                    ].includes(property.choice_type) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Property ${property.property_id} is not a single or multiple choice property.`
                    }
            },
            {
                type: "choice-reference"
            }
        ]
    },
    ABS: {
        returnType: ({ valueTypes: [type] })=>type,
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    ROUND: {
        returnType: ({ args: [, len] })=>!len || len.type == "Literal" && len.value === 0 ? "int" : "decimal",
        minArguments: 1,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            },
            {
                type: "literal",
                validate: (value)=>typeof value === "number" && Number.isInteger(value) && value >= 0 && value <= 3 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer between 0 and 3`
                    }
            }
        ]
    },
    FLOOR: {
        returnType: ()=>"int",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    CEILING: {
        returnType: ()=>"int",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    MIN: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.includes("decimal") ? "decimal" : "int",
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    MAX: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.includes("decimal") ? "decimal" : "int",
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "decimal" || type === "int" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected number`
                    }
            }
        ]
    },
    NOW: {
        returnType: ()=>"datetime",
        minArguments: 0,
        maxArguments: 0,
        restArgument: false,
        arguments: []
    },
    AGE: {
        returnType: ()=>"int",
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATEADD: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.at(-1),
        minArguments: 3,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: "contextual-identifier",
                validate: (name)=>[
                        "DAY",
                        "MONTH",
                        "QUARTER",
                        "YEAR",
                        "WEEK"
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: "literal",
                validate: (value)=>Number.isInteger(value) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATEDIFF: {
        returnType: ()=>"int",
        minArguments: 3,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: "contextual-identifier",
                validate: (name)=>[
                        "DAY",
                        "MONTH",
                        "QUARTER",
                        "YEAR",
                        "WEEK"
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATEPART: {
        returnType: ()=>"int",
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "contextual-identifier",
                validate: (name)=>[
                        "DAY",
                        "MONTH",
                        "QUARTER",
                        "YEAR",
                        "WEEK"
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATETRUNC: {
        returnType: ()=>"date",
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "contextual-identifier",
                validate: (name)=>[
                        "DAY",
                        "MONTH",
                        "QUARTER",
                        "YEAR",
                        "WEEK"
                    ].includes(name.toUpperCase()) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected "DAY", "WEEK", "MONTH", "QUARTER", or "YEAR"`
                    }
            },
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    EOMONTH: {
        returnType: ()=>"datetime",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    DATE: {
        returnType: ()=>"date",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "literal",
                validate: (value)=>typeof value === "string" && isFinite(Date.parse(value)) && /^\d{4}-\d{1,2}-\d{1,2}$/.test(value) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string in the format of "YYYY-MM-DD"`
                    }
            }
        ]
    },
    IF: {
        returnType: ({ valueTypes: [, type1, type2] })=>type1 === type2 ? type1 : (0, $b78ece0e2b37257d$export$3b8a04534ed45870)[type1][0],
        minArguments: 3,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "boolean" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected boolean`
                    }
            },
            {
                type: "value",
                validate: ()=>({
                        valid: true
                    })
            },
            {
                type: "value",
                validate: (type2, [, type1])=>(0, $b78ece0e2b37257d$export$3b8a04534ed45870)[type1].includes(type2) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected arguments of the same type.`
                    }
            }
        ]
    },
    LOWER: {
        returnType: ()=>"string",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "string" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            }
        ]
    },
    UPPER: {
        returnType: ()=>"string",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "string" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            }
        ]
    },
    RURAL: {
        returnType: ()=>"boolean",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    AREA_OF_PERSISTENT_UNEMPLOYMENT: {
        returnType: ()=>"boolean",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "date" || type === "datetime" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected date`
                    }
            }
        ]
    },
    HAS_VISIBLE_PREDECESSORS: {
        returnType: ()=>"boolean",
        minArguments: 0,
        maxArguments: 0,
        restArgument: false,
        arguments: []
    },
    DEBUG: {
        returnType: ({ valueTypes: valueTypes })=>valueTypes.at(-1),
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "literal",
                validate: (value)=>typeof value === "string" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected debug label to be string literal.`
                    }
            },
            {
                type: "value",
                validate: ()=>({
                        valid: true
                    })
            }
        ]
    },
    CAN_VIEW_ACTIVITY_TYPE: {
        returnType: ()=>"boolean",
        minArguments: 1,
        maxArguments: 1,
        restArgument: false,
        arguments: [
            {
                type: "literal",
                validate: (value)=>typeof value === "string" && (0, $0dc330fba39b622a$export$16b104bd64f9fad8).includes(value) ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected activity type to be one of '${(0, $0dc330fba39b622a$export$16b104bd64f9fad8).join(", ")}'.`
                    }
            }
        ]
    },
    MID: {
        returnType: ()=>"string",
        minArguments: 2,
        maxArguments: 3,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "string" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            },
            {
                type: "literal",
                validate: (value)=>typeof value === "number" && Number.isInteger(value) && value > 1 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer greater than or equal to 1`
                    }
            },
            {
                type: "literal",
                validate: (value)=>typeof value === "number" && Number.isInteger(value) && value >= 0 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer greater than or equal to 0`
                    }
            }
        ]
    },
    LEFT: {
        returnType: ()=>"string",
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "string" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            },
            {
                type: "literal",
                validate: (value)=>typeof value === "number" && Number.isInteger(value) && value >= 0 ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected integer greater than or equal to 0`
                    }
            }
        ]
    },
    RIGHT: {
        returnType: ()=>"string",
        minArguments: 2,
        maxArguments: 2,
        restArgument: false,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "string" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string`
                    }
            }
        ]
    },
    MATCH: {
        returnType: ()=>"boolean",
        minArguments: 2,
        maxArguments: 20,
        restArgument: true,
        arguments: [
            {
                type: "value",
                validate: (type)=>type === "string" || type === "int" || type === "decimal" ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected string, int or decimal`
                    }
            },
            {
                type: "value",
                validate: (type, valueTypes)=>type === valueTypes[0] ? {
                        valid: true
                    } : {
                        valid: false,
                        reason: `Expected ${valueTypes[0]}`
                    }
            }
        ]
    }
};
function $40788fc153d47c94$var$validateActivityExpression({ node: node, context: context }) {
    switch(node.type){
        case "BinaryExpression":
            {
                const { left: left, right: right, operator: operator } = node;
                const types = {
                    "+": [
                        "int",
                        "decimal",
                        "string"
                    ],
                    "-": [
                        "int",
                        "decimal"
                    ],
                    "*": [
                        "int",
                        "decimal"
                    ],
                    "/": [
                        "int",
                        "decimal"
                    ],
                    "%": [
                        "int",
                        "decimal"
                    ],
                    "&&": [
                        "boolean"
                    ],
                    "||": [
                        "boolean"
                    ],
                    ">": [
                        "int",
                        "decimal",
                        "date",
                        "datetime"
                    ],
                    ">=": [
                        "int",
                        "decimal",
                        "date",
                        "datetime"
                    ],
                    "<": [
                        "int",
                        "decimal",
                        "date",
                        "datetime"
                    ],
                    "<=": [
                        "int",
                        "decimal",
                        "date",
                        "datetime"
                    ],
                    "==": [
                        "int",
                        "decimal",
                        "date",
                        "datetime",
                        "string",
                        "boolean"
                    ],
                    "!=": [
                        "int",
                        "decimal",
                        "date",
                        "datetime",
                        "string",
                        "boolean"
                    ]
                }[operator];
                if (!types) return {
                    valid: false,
                    reason: `Invalid operator "${operator}" in expression "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}".`
                };
                const leftResult = $40788fc153d47c94$var$validateActivityExpression({
                    node: left,
                    context: context
                });
                if (leftResult.valid === false) return leftResult;
                if (!context.scanReferences && !types.includes(leftResult.type)) return {
                    valid: false,
                    reason: `The expression "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(left, [])}" (${leftResult.type}) cannot be used with the "${operator}" operator because it does not evaluate to one of the following types: ${types.join(", ")}.`
                };
                const rightResult = $40788fc153d47c94$var$validateActivityExpression({
                    node: right,
                    context: context
                });
                if (rightResult.valid === false) return rightResult;
                if (!context.scanReferences) {
                    if (!types.includes(rightResult.type)) return {
                        valid: false,
                        reason: `The expression "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(right, [])}" (${rightResult.type}) cannot be used with the "${operator}" operator because it does not evaluate to one of the following types: ${types.join(", ")}.`
                    };
                    if (!(0, $b78ece0e2b37257d$export$3b8a04534ed45870)[leftResult.type].includes(rightResult.type)) return {
                        valid: false,
                        reason: `The expression "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(right, [])}" (${rightResult.type}) does not match the type of the expression on the left side of the "${operator}" operator (${(0, $b78ece0e2b37257d$export$3b8a04534ed45870)[leftResult.type].join(", ")}).`
                    };
                }
                if ([
                    "&&",
                    "||",
                    ">",
                    ">=",
                    "<",
                    "<=",
                    "==",
                    "!="
                ].includes(operator)) return {
                    valid: true,
                    type: "boolean"
                };
                else if (operator === "/" || leftResult.type === "decimal" || rightResult.type === "decimal") return {
                    valid: true,
                    type: "decimal"
                };
                else return {
                    valid: true,
                    type: leftResult.type
                };
            }
        case "CallExpression":
            {
                // Ensure callee is literal.
                const callee = node.callee;
                if (callee.type !== "Identifier") return {
                    valid: false,
                    reason: `Invalid expression.`
                };
                // Coerce callee name to uppercase.
                callee.name = callee.name.toUpperCase();
                // Ensure callee is supported function.
                const fn = $40788fc153d47c94$var$functions[callee.name];
                if (!fn) return {
                    valid: false,
                    reason: `Invalid expression "${callee.name}".`
                };
                // Ensure minimum number of arguments.
                if (fn.minArguments > node.arguments.length) return {
                    valid: false,
                    reason: `Too few arguments for "${callee.name}" function. Expected ${fn.minArguments === fn.arguments.length ? fn.minArguments : `${fn.minArguments} - ${fn.arguments.length}`}.`
                };
                // Ensure maximum number of arguments.
                if (fn.maxArguments < node.arguments.length) return {
                    valid: false,
                    reason: `Too many arguments for "${callee.name}" function. Expected at most ${fn.maxArguments} arguments.`
                };
                // Validate each argument.
                let property = undefined;
                const valueTypes = [];
                for(let i = 0; i < node.arguments.length; i++){
                    const argInfo = i < fn.arguments.length ? fn.arguments[i] : fn.restArgument ? fn.arguments[fn.arguments.length - 1] : null;
                    if (!argInfo) throw new Error(`Invalid function definition. Unable to find argument definition for argument ${i} of ${callee.name}. Check maxArguments and restArgument properties.`);
                    const argNode = node.arguments[i];
                    switch(argInfo.type){
                        case "property-reference":
                            if (argNode.type === "Identifier" && Object.hasOwn((0, $0dbabea6e8ef01ef$export$7442465335b8f729), argNode.name.toUpperCase())) property = (0, $0dbabea6e8ef01ef$export$7442465335b8f729)[argNode.name.toUpperCase()];
                            else if (argNode.type === "Literal" && typeof argNode.value === "number" && Number.isInteger(argNode.value)) {
                                property = context.properties[argNode.value];
                                if (!context.references.includes(argNode.value)) context.references.push(argNode.value);
                            } else return {
                                valid: false,
                                reason: `Invalid argument "${argNode.raw ?? argNode.name}" in "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}". Expected an integer property id or one of the following: ${Object.getOwnPropertyNames((0, $0dbabea6e8ef01ef$export$7442465335b8f729)).join(", ")}.`
                            };
                            if (!context.scanReferences) {
                                if (!property) return {
                                    valid: false,
                                    reason: `Invalid argument "${argNode.raw}" in "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}". Property ${argNode.value} does not appear on this record.`
                                };
                                const result = argInfo.validate(property);
                                if (!result) return result;
                            }
                            continue;
                        case "choice-reference":
                            if (argNode.type !== "Literal" || typeof argNode.value !== "number" || !Number.isInteger(argNode.value)) return {
                                valid: false,
                                reason: `Invalid argument "${argNode.raw}" in "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}". Expected integer choice id.`
                            };
                            if (!context.scanReferences) {
                                if (!property) throw new Error(`Invalid function definition. Argument ${i} of ${callee.name} is a choice reference but there's no preceding property reference.`);
                                if (!property.choices?.some((c)=>c.choice_id === argNode.value)) return {
                                    valid: false,
                                    reason: `Invalid choice id "${argNode.raw}" in "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}". Valid choice IDs: ${property.choices?.map((x)=>x.choice_id).join(", ")}.`
                                };
                            }
                            continue;
                        case "literal":
                            {
                                if (argNode.type === "UnaryExpression" && argNode.operator === "-" && argNode.argument.type === "Literal" && typeof argNode.argument.value === "number" && Number.isFinite(argNode.argument.value)) {
                                    const result = argInfo.validate(argNode.argument.value * -1);
                                    if (!result.valid) return result;
                                    continue;
                                }
                                if (argNode.type !== "Literal") return {
                                    valid: false,
                                    reason: `Invalid argument "${argNode.raw}" in "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}". Expected a literal value.`
                                };
                                const result = argInfo.validate(argNode.value);
                                if (!result.valid) return result;
                                continue;
                            }
                        case "value":
                            {
                                const result = $40788fc153d47c94$var$validateActivityExpression({
                                    node: argNode,
                                    context: context
                                });
                                if (result.valid === false) return result;
                                const result2 = argInfo.validate(result.type, valueTypes);
                                if (!result2.valid && !context.scanReferences) return result2;
                                valueTypes.push(result.type);
                                continue;
                            }
                        case "contextual-identifier":
                            {
                                if (argNode.type !== "Identifier") return {
                                    valid: false,
                                    reason: `Invalid argument "${argNode.raw}" in "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}". Expected an identifier.`
                                };
                                const result = argInfo.validate(argNode.name);
                                if (!result.valid) return result;
                                continue;
                            }
                        default:
                            throw new Error(`Unexpected argument type "${argInfo.type}".`);
                    }
                }
                return {
                    valid: true,
                    type: context.scanReferences ? "int" : fn.returnType({
                        context: context,
                        args: node.arguments,
                        valueTypes: valueTypes
                    })
                };
            }
        case "UnaryExpression":
            {
                const { operator: operator, argument: argument } = node;
                if (operator !== "-" && operator !== "!") return {
                    valid: false,
                    reason: `Invalid expression "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}".`
                };
                const result = $40788fc153d47c94$var$validateActivityExpression({
                    node: argument,
                    context: context
                });
                if (result.valid === false) return result;
                if (operator === "-") {
                    if (context.scanReferences) return {
                        valid: true,
                        type: "int"
                    };
                    if (result.type !== "decimal" && result.type !== "int") return {
                        valid: false,
                        reason: `Cannot negate "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}" expression.`
                    };
                    return {
                        valid: true,
                        type: result.type
                    };
                } else {
                    if (context.scanReferences) return {
                        valid: true,
                        type: "boolean"
                    };
                    if (result.type !== "boolean") return {
                        valid: false,
                        reason: `Cannot negate "${(0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node)}" expression.`
                    };
                    return {
                        valid: true,
                        type: "boolean"
                    };
                }
            }
        case "Literal":
            {
                const { value: value, raw: raw } = node;
                if (typeof value === "number" && isFinite(value) && value >= -100000000 && value <= 100000000) return {
                    valid: true,
                    type: value % 1 === 0 ? "int" : "decimal"
                };
                if (typeof value === "boolean") return {
                    valid: true,
                    type: "boolean"
                };
                if (typeof value === "string") return {
                    valid: true,
                    type: "string"
                };
                return {
                    valid: false,
                    reason: `Invalid expression "${raw}".`
                };
            }
        case "Identifier":
            {
                const name = node.name.toUpperCase();
                if (context.identifiers[name]) return {
                    valid: true,
                    type: context.identifiers[name]
                };
                return {
                    valid: false,
                    reason: `Invalid expression "${name}".`
                };
            }
        default:
            return {
                valid: false,
                reason: "Invalid expression."
            };
    }
}
function $40788fc153d47c94$var$parseExpression(expression) {
    try {
        return {
            valid: true,
            node: (0, $cec7b3c0f35c015b$export$2e2bcd8739ae039)(expression)
        };
    } catch (e) {
        if (e instanceof Error && "description" in e && typeof e.description === "string" && "index" in e && typeof e.index === "number") return {
            valid: false,
            reason: e.description
        };
        return {
            valid: false,
            reason: `Invalid expression "${expression}"`
        };
    }
}
function $40788fc153d47c94$export$8da72883fbab6547({ expression: expression, getContext: getContext }) {
    const parseResult = $40788fc153d47c94$var$parseExpression(expression);
    if (!parseResult.valid) return parseResult;
    const { node: node } = parseResult;
    const originalNode = structuredClone(node);
    const result = $40788fc153d47c94$var$validateActivityExpression({
        node: node,
        context: {
            ...getContext()
        }
    });
    if (!result.valid) return result;
    return {
        valid: true,
        node: node,
        originalNode: originalNode,
        type: result.type
    };
}





class $b7c84a6621e3ef00$export$f9765a67b1be7546 extends HTMLElement {
    constructor(){
        super(...arguments);
        this.timeout = 0;
        this.processChange = ()=>{
            if (this.input.value.trim() === "") return;
            const result = $b7c84a6621e3ef00$var$parseAndValidate(this.input, this.allowedTypes);
            if (!result.valid) {
                setTimeout(()=>{
                    (0, $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9)(this.input, result.reason);
                    this.closest(".form-group")?.classList.add("errored");
                });
                return;
            }
            const formatted = (0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(result.originalNode);
            if (this.input.value !== formatted) {
                this.input.value = formatted;
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.input);
            }
        };
    }
    connectedCallback() {
        this.addEventListener("change", this);
        this.addEventListener("blur", this);
        this.addEventListener("keydown", this);
    }
    disconnectedCallback() {
        this.removeEventListener("change", this);
        this.removeEventListener("blur", this);
        this.removeEventListener("keydown", this);
    }
    get input() {
        return this.querySelector("input");
    }
    get allowedTypes() {
        return this.getAttribute("allowed-types")?.split(/\s+/g).filter((0, $b78ece0e2b37257d$export$b6b5b1f15bbc92d6)) ?? [];
    }
    handleEvent(event) {
        if (event.target === this.input) {
            if (event instanceof KeyboardEvent) {
                if (event.key === "Enter") event.preventDefault();
                else return;
            }
            if (event.isTrusted) {
                clearTimeout(this.timeout);
                this.processChange();
            }
        } else {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.processChange, 300);
        }
    }
}
if (!window.customElements.get("expression-input")) {
    window.ExpressionInput = $b7c84a6621e3ef00$export$f9765a67b1be7546;
    window.customElements.define("expression-input", $b7c84a6621e3ef00$export$f9765a67b1be7546);
}
function $b7c84a6621e3ef00$var$parseAndValidate(input, allowedTypes) {
    const event = new CustomEvent((0, $9151eade1f5d9549$export$4a61b9856b3d6ba6), {
        bubbles: true,
        cancelable: true,
        detail: {
            identifiers: {}
        }
    });
    if (input.dispatchEvent(event)) return {
        valid: false,
        reason: "Expression scope request was not handled."
    };
    const context = {
        properties: {},
        references: [],
        scanReferences: false,
        identifiers: event.detail.identifiers
    };
    const result = (0, $40788fc153d47c94$export$8da72883fbab6547)({
        expression: input.value,
        getContext: ()=>context
    });
    if (!result.valid) return {
        valid: false,
        reason: result.reason
    };
    if (allowedTypes.includes(result.type)) return result;
    return {
        valid: false,
        reason: `Expression must result in a ${allowedTypes.join(" / ")}.`
    };
}
(0, $f3a2ac2d620bcd8b$export$86f1725708ac86dc)((input)=>{
    let exp;
    if (input instanceof HTMLInputElement && input.type === "text" && input.value.trim() !== "" && (exp = input.closest("expression-input"))) {
        const result = $b7c84a6621e3ef00$var$parseAndValidate(input, exp.allowedTypes);
        if (!result.valid) return result.reason;
    }
    return null;
});




var $5f5c6c95ad9692c7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5f5c6c95ad9692c7$export$9437640b5217dd0f = class GeolocationControllerElement extends HTMLElement {
    connectedCallback() {
        if ("geolocation" in navigator) this.button?.addEventListener("click", this);
        else this.button?.remove();
        this.autocomplete?.addEventListener("combobox-commit", this);
    }
    disconnectedCallback() {
        this.button?.removeEventListener("click", this);
        this.autocomplete?.removeEventListener("combobox-commit", this);
    }
    handleEvent({ type: type, target: target }) {
        switch(type){
            case "click":
                this.geolocate();
                return;
            case "combobox-commit":
                if (!(target instanceof HTMLElement)) return;
                const value = JSON.parse(target.getAttribute("data-autocomplete-data"));
                const form = document.createElement("form");
                form.method = "POST";
                form.action = "/api/location/magic-key";
                form.hidden = true;
                form.onformdata = ({ formData: formData })=>{
                    formData.set("q", value.text);
                    formData.set("magic_key", value.magicKey);
                    formData.set("redirect_uri", location.pathname + location.search);
                };
                this.append(form);
                form.submit();
                return;
            default:
                throw new Error(`Unhandled event type: ${type}`);
        }
    }
    async geolocate() {
        let position;
        try {
            position = await new Promise((resolve, reject)=>navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true,
                    maximumAge: 300000
                }));
        } catch (err) {
            let code = -1;
            if (err instanceof GeolocationPositionError) code = err.code;
            switch(code){
                case GeolocationPositionError.PERMISSION_DENIED:
                    break;
                case GeolocationPositionError.POSITION_UNAVAILABLE:
                    alert("Position unavailable");
                    break;
                case GeolocationPositionError.TIMEOUT:
                    alert("Timed out while retrieving position.");
                    break;
                default:
                    alert("Error getting position.");
                    break;
            }
            return;
        }
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "/api/location/reverse-geocode";
        form.hidden = true;
        form.onformdata = ({ formData: formData })=>{
            formData.set("latitude:number", position.coords.latitude.toString());
            formData.set("longitude:number", position.coords.longitude.toString());
            formData.set("redirect_uri", location.pathname + location.search);
        };
        this.append(form);
        form.submit();
    }
};
$5f5c6c95ad9692c7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5f5c6c95ad9692c7$export$9437640b5217dd0f.prototype, "button", void 0);
$5f5c6c95ad9692c7$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $5f5c6c95ad9692c7$export$9437640b5217dd0f.prototype, "autocomplete", void 0);
$5f5c6c95ad9692c7$export$9437640b5217dd0f = $5f5c6c95ad9692c7$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("geolocation-controller")
], $5f5c6c95ad9692c7$export$9437640b5217dd0f);




class $1a9c211b9d7d4ce6$var$InsertAdjacentHtmlElement extends HTMLElement {
    constructor(){
        super();
        this.afterSubmit = async (event)=>{
            const { detail: response } = event;
            const element = this.ownerDocument.getElementById(this.getAttribute("element"));
            const position = this.getAttribute("position");
            const setFocus = this.hasAttribute("set-focus");
            const text = await response.text();
            const template = document.createElement("template");
            template.innerHTML = text;
            const content = template.content.cloneNode(true);
            const firstControl = content.querySelector("input,select,textarea");
            const firstElement = content.firstElementChild;
            switch(position){
                case "afterbegin":
                    element.prepend(content);
                    break;
                case "afterend":
                    element.after(content);
                    break;
                case "beforebegin":
                    element.before(content);
                    break;
                case "beforeend":
                    element.append(content);
                    break;
                case "replace":
                    element.after(content);
                    element.remove();
                    break;
                default:
                    throw new Error(`Unexpected position: "${position}"`);
            }
            if (firstControl) (0, $eb08f38ae8877120$export$89348ae70780cd7a)(firstControl);
            if (setFocus) (0, $eb08f38ae8877120$export$956fd4dade47957a)(firstElement);
        };
    }
    connectedCallback() {
        this.addEventListener((0, $56b400225c9c516b$export$707ab90452beb68e), this.afterSubmit);
    }
    disconnectedCallback() {
        this.removeEventListener((0, $56b400225c9c516b$export$707ab90452beb68e), this.afterSubmit);
    }
}
if (!window.customElements.get("insert-adjacent-html")) {
    window.InsertAdjacentHtmlElement = $1a9c211b9d7d4ce6$var$InsertAdjacentHtmlElement;
    window.customElements.define("insert-adjacent-html", $1a9c211b9d7d4ce6$var$InsertAdjacentHtmlElement);
}




var $809cecb49dae38dd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $809cecb49dae38dd$export$4b9f8fa2c586d82a = class ListBoxElement extends HTMLElement {
    get disabled() {
        return this.hasAttribute("disabled");
    }
    connectedCallback() {
        this.list = this.firstElementChild;
        this.list.setAttribute("role", "listbox");
        this.list.setAttribute("aria-multiselectable", this.hasAttribute("multiple").toString());
        this.ensureActiveDescendent();
        this.list.addEventListener("keydown", this);
        this.list.addEventListener("click", this);
        this.observer = new MutationObserver(()=>this.ensureActiveDescendent());
        this.observer.observe(this.list, {
            childList: true
        });
    }
    disconnectedCallback() {
        this.list.removeEventListener("keydown", this);
        this.list.removeEventListener("click", this);
        this.observer.disconnect();
    }
    handleEvent(event) {
        switch(event.type){
            case "keydown":
                this.handleKeyDown(event);
                break;
            case "click":
                this.handleClick(event);
                break;
            default:
                throw new Error(`Unexpected event type: "${event.type}".`);
        }
    }
    handleKeyDown(event) {
        if (event.target !== this.list) return;
        if (event.shiftKey || event.metaKey || event.altKey || event.ctrlKey) return;
        if (!this.activeDescendant) return;
        switch(event.key){
            case "Enter":
                if (this.clickActiveDescendant()) event.preventDefault();
                break;
            case "ArrowDown":
            case "ArrowRight":
                this.navigate(1);
                event.preventDefault();
                break;
            case "ArrowUp":
            case "ArrowLeft":
                this.navigate(-1);
                event.preventDefault();
                break;
            case "Delete":
            case "Backspace":
                if (this.disabled) return;
                if (this.deleteActiveDescendant()) event.preventDefault();
                break;
        }
    }
    handleClick(event) {
        const del = event.target instanceof Element && event.target.closest("[data-list-box-delete]") && !this.disabled;
        const option = event.target instanceof Element && event.target.closest('[role="option"]');
        if (!option) return;
        this.identifyOptions();
        this.list.setAttribute("aria-activedescendant", option.id);
        let result;
        if (del) result = this.deleteActiveDescendant();
        else result = this.clickActiveDescendant();
        if (result) event.preventDefault();
    }
    clickActiveDescendant() {
        const active = this.activeDescendant;
        if (!active) return false;
        const event = new CustomEvent("list-box-item-click", {
            bubbles: true,
            detail: active
        });
        this.dispatchEvent(event);
        // todo: set aria-selected
        return !event.defaultPrevented;
    }
    deleteActiveDescendant() {
        const active = this.activeDescendant;
        if (!active) return false;
        const event = new CustomEvent("list-box-item-delete", {
            bubbles: true,
            detail: active
        });
        this.dispatchEvent(event);
        if (event.defaultPrevented) return false;
        this.navigate(-1);
        active.remove();
        this.ensureActiveDescendent();
        return true;
    }
    get activeDescendant() {
        const id = this.list.getAttribute("aria-activedescendant");
        if (!id) return null;
        return this.list.querySelector("#" + id);
    }
    activate(option) {
        Array.from(this.list.querySelectorAll('[role="option"]')).filter((x)=>x !== option).forEach((x)=>x.removeAttribute("data-list-box-active"));
        this.list.setAttribute("aria-activedescendant", option.id);
        option.setAttribute("data-list-box-active", "true");
    }
    navigate(delta) {
        this.identifyOptions();
        const options = Array.from(this.list.querySelectorAll('[role="option"]'));
        const active = this.activeDescendant;
        let index = options.indexOf(active);
        index = Math.min(options.length - 1, Math.max(0, index + delta));
        this.activate(options[index]);
    }
    identifyOptions() {
        this.list.querySelectorAll('[role="option"]:not([id])').forEach((x)=>x.id = (0, $5cb959b633531006$export$9e1c824dbb29e809)());
    }
    ensureActiveDescendent() {
        this.identifyOptions();
        const option = this.activeDescendant || this.list.querySelector('[role="option"][aria-selected="true"]') || this.list.querySelector('[role="option"]');
        if (option) {
            this.activate(option);
            this.list.setAttribute("tabindex", "0");
        } else {
            this.list.removeAttribute("aria-activedescendant");
            this.list.removeAttribute("tabindex");
        }
    }
};
$809cecb49dae38dd$export$4b9f8fa2c586d82a = $809cecb49dae38dd$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("list-box")
], $809cecb49dae38dd$export$4b9f8fa2c586d82a);


const $c059c8d9958b5533$export$9488ee68e59e0b92 = /(?:[-@*_~`#>\]|])|(?:\d\.)/;







let $f45801a871018868$var$emojiPromise = null;
async function $f45801a871018868$var$findEmoji(text, src) {
    if (!$f45801a871018868$var$emojiPromise) $f45801a871018868$var$emojiPromise = fetch(src).then((r)=>{
        if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(r)) {
            $f45801a871018868$var$emojiPromise = null;
            return [];
        }
        return r.json();
    });
    if (text.length === 0) return [
        {
            id: "+1",
            text: [],
            value: "\uD83D\uDC4D"
        },
        {
            id: "-1",
            text: [],
            value: "\uD83D\uDC4E"
        },
        {
            id: "100",
            text: [],
            value: "\uD83D\uDCAF"
        },
        {
            id: "cry",
            text: [],
            value: "\uD83D\uDE22"
        },
        {
            id: "heart",
            text: [],
            value: "\u2764\uFE0F"
        }
    ];
    const emoji = await $f45801a871018868$var$emojiPromise;
    text = text.toLowerCase();
    const suggestions = [];
    let i = 0;
    while(i < emoji.length && suggestions.length < 5){
        if (emoji[i].text.find((t)=>t.startsWith(text))) suggestions.push(emoji[i]);
        i++;
    }
    return suggestions;
}
const $f45801a871018868$var$fragment = document.createElement("ul");
$f45801a871018868$var$fragment.setAttribute("aria-label", "Results");
$f45801a871018868$var$fragment.className = "suggester suggester-container";
$f45801a871018868$var$fragment.setAttribute("role", "listbox");
let $f45801a871018868$var$mentionFetchController;
async function $f45801a871018868$var$provideMention(mentionsSrc, text) {
    $f45801a871018868$var$mentionFetchController?.abort("superseded");
    $f45801a871018868$var$mentionFetchController = new AbortController();
    const url = new URL(mentionsSrc, location.origin);
    url.searchParams.set("q", text);
    const response = await fetch(url, {
        signal: $f45801a871018868$var$mentionFetchController.signal,
        headers: {
            accept: "text/fragment+html"
        }
    });
    if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return "";
    if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
    return response.text();
}
let $f45801a871018868$var$previewFetchController;
async function $f45801a871018868$var$previewMarkdown(previewSrc, markdown) {
    $f45801a871018868$var$previewFetchController?.abort("superseded");
    $f45801a871018868$var$previewFetchController = undefined;
    if (markdown.trim().length === 0) return (0, $2868cc1235412e16$export$fff7de9eec117c98)[(0, $58ccb23ba1dadd05$export$180605366c04f0cd)()];
    if (!(0, $c059c8d9958b5533$export$9488ee68e59e0b92).test(markdown)) return markdown;
    $f45801a871018868$var$previewFetchController = new AbortController();
    const url = new URL(previewSrc, location.origin);
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/json",
            accept: "text/fragment+html"
        },
        body: JSON.stringify(markdown),
        signal: $f45801a871018868$var$previewFetchController.signal
    });
    if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return `<p class="text-italic">Unable to render markdown preview: session is expired</p>`;
    if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response);
    return response.text();
}
class $f45801a871018868$export$8d00bac029d641e5 extends HTMLElement {
    constructor(){
        super(...arguments);
        this.markdownToPreview = undefined;
        this.selectionStart = undefined;
    }
    connectedCallback() {
        this.addEventListener("change", this);
        this.addEventListener("input", this);
        this.addEventListener("tab-container-changed", this);
        this.addEventListener("text-expander-change", this, {
            capture: true
        });
        this.addEventListener("text-expander-value", this, {
            capture: true
        });
        this.addEventListener("text-expander-committed", this, {
            capture: true
        });
        this.addEventListener("file-attachment-accepted", this);
        this.addEventListener("blur", this, {
            capture: true
        });
        this.markdownToPreview = this.querySelector("text-expander textarea")?.value ?? undefined;
    }
    disconnectedCallback() {
        this.removeEventListener("change", this);
        this.removeEventListener("input", this);
        this.removeEventListener("tab-container-changed", this);
        this.removeEventListener("text-expander-change", this, {
            capture: true
        });
        this.removeEventListener("text-expander-value", this, {
            capture: true
        });
        this.removeEventListener("text-expander-committed", this, {
            capture: true
        });
        this.removeEventListener("file-attachment-accepted", this);
        this.removeEventListener("blur", this, {
            capture: true
        });
    }
    handleEvent(event) {
        const { type: type, target: target } = event;
        switch(type){
            case "text-expander-committed":
            case "change":
            case "input":
                if (!(target instanceof HTMLTextAreaElement)) return;
                this.invalidatePreview(target.value);
                this.selectionStart = target.selectionStart;
                return;
            case "tab-container-changed":
                this.preview();
                return;
            case "text-expander-value":
                {
                    const { detail: detail } = event;
                    const value = detail.item.getAttribute("data-value");
                    detail.value = value;
                    return;
                }
            case "text-expander-change":
                const { detail: { key: key, provide: provide, text: text } } = event;
                if (key === ":") provide(this.provideEmoji(text));
                if (key === "@") {
                    const mentionsSrc = this.getAttribute("mentions-src");
                    if (mentionsSrc) provide(this.provideMention(mentionsSrc, text));
                }
                return;
            case "file-attachment-accepted":
                this.fileAttachmentAccepted(event);
                return;
            case "blur":
                if (event.target instanceof HTMLTextAreaElement) this.selectionStart = event.target.selectionStart;
                return;
            default:
                throw new Error(`Unexpected event type "${type}".`);
        }
    }
    provideEmoji(text) {
        return $f45801a871018868$var$findEmoji(text, this.getAttribute("emoji-src")).then((emoji)=>{
            $f45801a871018868$var$fragment.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(emoji.map((x)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<li role="option" data-value="${x.value}">
              ${x.value} ${x.id}
            </li>`));
            return {
                matched: emoji.length > 0,
                fragment: $f45801a871018868$var$fragment
            };
        });
    }
    provideMention(mentionsSrc, text) {
        return $f45801a871018868$var$provideMention(mentionsSrc, text).then((html)=>{
            $f45801a871018868$var$fragment.innerHTML = html;
            return {
                matched: $f45801a871018868$var$fragment.childElementCount > 0,
                fragment: $f45801a871018868$var$fragment
            };
        });
    }
    get markdownBody() {
        const el = this.querySelector(".markdown-body");
        if (!el) throw new Error("Missing .markdown-body element.");
        return el;
    }
    async preview() {
        if (this.markdownToPreview === undefined) return;
        const md = this.markdownToPreview;
        this.markdownToPreview = undefined;
        const src = this.getAttribute("preview-src");
        const html = await $f45801a871018868$var$previewMarkdown(src, md);
        this.markdownBody.innerHTML = html;
    }
    invalidatePreview(value) {
        const markdownBody = this.markdownBody;
        this.markdownToPreview = value;
        markdownBody.setAttribute("source-markdown", value);
        markdownBody.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div class="py-3 d-flex flex-justify-center">
        <div class="spinner-border f1 color-fg-muted"></div>
      </div>`);
    }
    async fileAttachmentAccepted(event) {
        const locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
        const fileAttachmentElement = event.target instanceof HTMLElement && event.target;
        if (!fileAttachmentElement) throw new Error("Missing file attachment element");
        const uploadHref = fileAttachmentElement.getAttribute("upload-href");
        if (!uploadHref) throw new Error("Missing upload href");
        const uploadUrl = new URL(uploadHref, location.origin);
        const attachments = event.detail.attachments;
        const fileLabelContentSpan = fileAttachmentElement.hasAttribute("data-file-label-content-id") && document.getElementById(fileAttachmentElement.getAttribute("data-file-label-content-id"));
        if (!fileLabelContentSpan) throw new Error("Missing file label content span");
        const textarea = fileAttachmentElement.querySelector("textarea");
        if (!textarea) throw new Error("Missing textarea");
        if (document.activeElement !== textarea) textarea.focus();
        let interval = 0;
        const progressSpan = document.createElement("span");
        progressSpan.append(document.createElement("span"), document.createTextNode(" "), document.createElement("span"));
        progressSpan.firstElementChild.classList.add("spinner-border", "color-fg-muted");
        const setProgress = ()=>{
            const index = attachments.filter((attachment)=>attachment.isSaved() || attachment.isSaving()).length;
            progressSpan.lastElementChild.textContent = (0, $2868cc1235412e16$export$7f449188bb84ac2c)[locale](index, attachments.length);
        };
        setProgress();
        const attachmentSaved = (attachment)=>{
            const { id: id, name: name, href: href } = attachment;
            const start = this.selectionStart ?? textarea.selectionStart;
            const end = this.selectionStart ?? textarea.selectionEnd;
            const prefix = start > 0 ? "  \n" : "";
            textarea.setRangeText(`${prefix}${attachment.isImage() ? "!" : ""}[${name}](${href})  `, start, end, "end");
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(textarea);
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "attachments/-/attachment_id";
            input.value = id;
            textarea.form?.insertAdjacentElement("beforeend", input);
        };
        try {
            fileLabelContentSpan.hidden = true;
            fileLabelContentSpan.after(progressSpan);
            interval = setInterval(setProgress, 50);
            await (0, $49d75368cd6df2b4$export$14d3a7d22f26659e)({
                locale: locale,
                attachments: attachments,
                uploadUrl: uploadUrl,
                attachmentSaved: attachmentSaved
            });
        } finally{
            progressSpan.remove();
            fileLabelContentSpan.hidden = false;
            clearInterval(interval);
        }
    }
}
if (!window.customElements.get("markdown-editor")) {
    window.MarkdownEditorElement = $f45801a871018868$export$8d00bac029d641e5;
    window.customElements.define("markdown-editor", $f45801a871018868$export$8d00bac029d641e5);
}


var $33f6193270268989$var$I = Object.defineProperty;
var $33f6193270268989$var$S = (n, t, s)=>t in n ? $33f6193270268989$var$I(n, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : n[t] = s;
var $33f6193270268989$var$A = (n, t, s)=>$33f6193270268989$var$S(n, typeof t != "symbol" ? t + "" : t, s);
const $33f6193270268989$export$6ad93df59e712c43 = {
    "#": {
        pattern: /[0-9]/
    },
    "@": {
        pattern: /[a-zA-Z]/
    },
    "*": {
        pattern: /[a-zA-Z0-9]/
    }
}, $33f6193270268989$var$R = (n, t, s)=>n.replaceAll(t, "").replace(s, ".").replace("..", ".").replace(/[^.\d]/g, ""), $33f6193270268989$var$C = (n, t, s)=>{
    var e;
    return new Intl.NumberFormat(((e = s.number) == null ? void 0 : e.locale) ?? "en", {
        minimumFractionDigits: n,
        maximumFractionDigits: t,
        roundingMode: "trunc"
    });
}, $33f6193270268989$var$P = (n, t = !0, s)=>{
    var k, g, b, d;
    const e = ((k = s.number) == null ? void 0 : k.unsigned) !== !0 && n.startsWith("-") ? "-" : "", r = ((g = s.number) == null ? void 0 : g.fraction) ?? 0;
    let a = $33f6193270268989$var$C(0, r, s);
    const u = a.formatToParts(1000.12), p = ((b = u.find((o)=>o.type === "group")) == null ? void 0 : b.value) ?? " ", f = ((d = u.find((o)=>o.type === "decimal")) == null ? void 0 : d.value) ?? ".", i = $33f6193270268989$var$R(n, p, f);
    if (Number.isNaN(parseFloat(i))) return e;
    const h = i.split(".");
    if (h[1] != null && h[1].length >= 1) {
        const o = h[1].length <= r ? h[1].length : r;
        a = $33f6193270268989$var$C(o, r, s);
    }
    let l = a.format(parseFloat(i));
    return t ? r > 0 && i.endsWith(".") && !i.slice(0, -1).includes(".") && (l += f) : l = $33f6193270268989$var$R(l, p, f), e + l;
};
class $33f6193270268989$export$991dcf7284de63d {
    constructor(t = {}){
        $33f6193270268989$var$A(this, "opts", {});
        $33f6193270268989$var$A(this, "memo", /* @__PURE__ */ new Map());
        const s = {
            ...t
        };
        if (s.tokens != null) {
            s.tokens = s.tokensReplace ? {
                ...s.tokens
            } : {
                ...$33f6193270268989$export$6ad93df59e712c43,
                ...s.tokens
            };
            for (const e of Object.values(s.tokens))typeof e.pattern == "string" && (e.pattern = new RegExp(e.pattern));
        } else s.tokens = $33f6193270268989$export$6ad93df59e712c43;
        Array.isArray(s.mask) && (s.mask.length > 1 ? s.mask = [
            ...s.mask
        ].sort((e, r)=>e.length - r.length) : s.mask = s.mask[0] ?? ""), s.mask === "" && (s.mask = null), this.opts = s;
    }
    masked(t) {
        return this.process(String(t), this.findMask(String(t)));
    }
    unmasked(t) {
        return this.process(String(t), this.findMask(String(t)), !1);
    }
    isEager() {
        return this.opts.eager === !0;
    }
    isReversed() {
        return this.opts.reversed === !0;
    }
    completed(t) {
        const s = this.findMask(String(t));
        if (this.opts.mask == null || s == null) return !1;
        const e = this.process(String(t), s).length;
        return typeof this.opts.mask == "string" ? e >= this.opts.mask.length : e >= s.length;
    }
    findMask(t) {
        const s = this.opts.mask;
        if (s == null) return null;
        if (typeof s == "string") return s;
        if (typeof s == "function") return s(t);
        const e = this.process(t, s.slice(-1).pop() ?? "", !1);
        return s.find((r)=>this.process(t, r, !1).length >= e.length) ?? "";
    }
    escapeMask(t) {
        const s = [], e = [];
        return t.split("").forEach((r, a)=>{
            r === "!" && t[a - 1] !== "!" ? e.push(a - e.length) : s.push(r);
        }), {
            mask: s.join(""),
            escaped: e
        };
    }
    process(t, s, e = !0) {
        if (this.opts.number != null) return $33f6193270268989$var$P(t, e, this.opts);
        if (s == null) return t;
        const r = `v=${t},mr=${s},m=${e ? 1 : 0}`;
        if (this.memo.has(r)) return this.memo.get(r);
        const { mask: a, escaped: u } = this.escapeMask(s), p = [], f = this.opts.tokens != null ? this.opts.tokens : {}, i = this.isReversed() ? -1 : 1, h = this.isReversed() ? "unshift" : "push", l = this.isReversed() ? 0 : a.length - 1, k = this.isReversed() ? ()=>o > -1 && c > -1 : ()=>o < a.length && c < t.length, g = (v)=>!this.isReversed() && v <= l || this.isReversed() && v >= l;
        let b, d = -1, o = this.isReversed() ? a.length - 1 : 0, c = this.isReversed() ? t.length - 1 : 0, E = !1;
        for(; k();){
            const v = a.charAt(o), m = f[v], y = (m == null ? void 0 : m.transform) != null ? m.transform(t.charAt(c)) : t.charAt(c);
            if (!u.includes(o) && m != null ? (y.match(m.pattern) != null ? (p[h](y), m.repeated ? (d === -1 ? d = o : o === l && o !== d && (o = d - i), l === d && (o -= i)) : m.multiple && (E = !0, o -= i), o += i) : m.multiple ? E && (o += i, c -= i, E = !1) : y === b ? b = void 0 : m.optional && (o += i, c -= i), c += i) : (e && !this.isEager() && p[h](v), y === v && !this.isEager() ? c += i : b = v, this.isEager() || (o += i)), this.isEager()) for(; g(o) && (f[a.charAt(o)] == null || u.includes(o));){
                if (e) {
                    if (p[h](a.charAt(o)), t.charAt(c) === a.charAt(o)) {
                        o += i, c += i;
                        continue;
                    }
                } else a.charAt(o) === t.charAt(c) && (c += i);
                o += i;
            }
        }
        return this.memo.set(r, p.join("")), this.memo.get(r);
    }
}
const $33f6193270268989$var$w = (n)=>JSON.parse(n.replaceAll("'", '"')), $33f6193270268989$var$T = (n, t = {})=>{
    const s = {
        ...t
    };
    n.dataset.maska != null && n.dataset.maska !== "" && (s.mask = $33f6193270268989$var$x(n.dataset.maska)), n.dataset.maskaEager != null && (s.eager = $33f6193270268989$var$M(n.dataset.maskaEager)), n.dataset.maskaReversed != null && (s.reversed = $33f6193270268989$var$M(n.dataset.maskaReversed)), n.dataset.maskaTokensReplace != null && (s.tokensReplace = $33f6193270268989$var$M(n.dataset.maskaTokensReplace)), n.dataset.maskaTokens != null && (s.tokens = $33f6193270268989$var$W(n.dataset.maskaTokens));
    const e = {};
    return n.dataset.maskaNumberLocale != null && (e.locale = n.dataset.maskaNumberLocale), n.dataset.maskaNumberFraction != null && (e.fraction = parseInt(n.dataset.maskaNumberFraction)), n.dataset.maskaNumberUnsigned != null && (e.unsigned = $33f6193270268989$var$M(n.dataset.maskaNumberUnsigned)), (n.dataset.maskaNumber != null || Object.values(e).length > 0) && (s.number = e), s;
}, $33f6193270268989$var$M = (n)=>n !== "" ? !!JSON.parse(n) : !0, $33f6193270268989$var$x = (n)=>n.startsWith("[") && n.endsWith("]") ? $33f6193270268989$var$w(n) : n, $33f6193270268989$var$W = (n)=>{
    if (n.startsWith("{") && n.endsWith("}")) return $33f6193270268989$var$w(n);
    const t = {};
    return n.split("|").forEach((s)=>{
        const e = s.split(":");
        t[e[0]] = {
            pattern: new RegExp(e[1]),
            optional: e[2] === "optional",
            multiple: e[2] === "multiple",
            repeated: e[2] === "repeated"
        };
    }), t;
};
class $33f6193270268989$export$6fe74da4426e2d7a {
    constructor(t, s = {}){
        $33f6193270268989$var$A(this, "items", /* @__PURE__ */ new Map());
        $33f6193270268989$var$A(this, "eventAbortController");
        $33f6193270268989$var$A(this, "onInput", (t)=>{
            if (t instanceof CustomEvent && t.type === "input" && !t.isTrusted && !t.bubbles) return;
            const s = t.target, e = this.items.get(s);
            if (e === void 0) return;
            const r = "inputType" in t && t.inputType.startsWith("delete"), a = e.isEager(), u = r && a && e.unmasked(s.value) === "" ? "" : s.value;
            this.fixCursor(s, r, ()=>this.setValue(s, u));
        });
        this.options = s, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
    }
    update(t = {}) {
        this.options = {
            ...t
        }, this.init(Array.from(this.items.keys()));
    }
    updateValue(t) {
        var s;
        t.value !== "" && t.value !== ((s = this.processInput(t)) == null ? void 0 : s.masked) && this.setValue(t, t.value);
    }
    destroy() {
        this.eventAbortController.abort(), this.items.clear();
    }
    init(t) {
        const s = this.getOptions(this.options);
        for (const e of t){
            if (!this.items.has(e)) {
                const { signal: a } = this.eventAbortController;
                e.addEventListener("input", this.onInput, {
                    capture: !0,
                    signal: a
                });
            }
            const r = new $33f6193270268989$export$991dcf7284de63d($33f6193270268989$var$T(e, s));
            this.items.set(e, r), queueMicrotask(()=>this.updateValue(e)), e.selectionStart === null && r.isEager() && console.warn("Maska: input of `%s` type is not supported", e.type);
        }
    }
    getInputs(t) {
        return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [
            t
        ];
    }
    getOptions(t) {
        const { onMaska: s, preProcess: e, postProcess: r, ...a } = t;
        return a;
    }
    fixCursor(t, s, e) {
        var k, g;
        const r = t.selectionStart, a = t.value;
        if (e(), r === null || r === a.length && !s) return;
        const u = t.value, p = a.slice(0, r), f = u.slice(0, r), i = (k = this.processInput(t, p)) == null ? void 0 : k.unmasked, h = (g = this.processInput(t, f)) == null ? void 0 : g.unmasked;
        if (i === void 0 || h === void 0) return;
        let l = r;
        p !== f && (l += s ? u.length - a.length : i.length - h.length), t.setSelectionRange(l, l);
    }
    setValue(t, s) {
        const e = this.processInput(t, s);
        e !== void 0 && (t.value = e.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((r)=>r(e)) : this.options.onMaska(e)), t.dispatchEvent(new CustomEvent("maska", {
            detail: e
        })), t.dispatchEvent(new CustomEvent("input", {
            detail: e.masked
        })));
    }
    processInput(t, s) {
        const e = this.items.get(t);
        if (e === void 0) return;
        let r = s ?? t.value;
        this.options.preProcess != null && (r = this.options.preProcess(r));
        let a = e.masked(r);
        return this.options.postProcess != null && (a = this.options.postProcess(a)), {
            masked: a,
            unmasked: e.unmasked(r),
            completed: e.completed(r)
        };
    }
}


class $65d0fb07df9db387$export$c655c6fc8d11b048 extends HTMLElement {
    connectedCallback() {
        const pattern = this.getAttribute("pattern");
        if (pattern && this.firstElementChild instanceof HTMLInputElement) this.mask = new (0, $33f6193270268989$export$6fe74da4426e2d7a)(this.firstElementChild, {
            mask: pattern
        });
    }
    disconnectedCallback() {
        this.mask?.destroy();
    }
}
if (!window.customElements.get("mask-input")) {
    window.MaskInputElement = $65d0fb07df9db387$export$c655c6fc8d11b048;
    window.customElements.define("mask-input", $65d0fb07df9db387$export$c655c6fc8d11b048);
}



const $e55c1aeea21e594e$export$511f44e01e024619 = [
    {
        id: "taking-as-directed",
        title: "Taking as directed"
    },
    {
        id: "taking-not-as-directed",
        title: "Not taking as directed"
    },
    {
        id: "on-hold-as-directed",
        title: "On hold per instructions"
    },
    {
        id: "on-hold-not-as-directed",
        title: "On hold against instructions"
    },
    {
        id: "stopped-as-directed",
        title: "Stopped as prescribed"
    },
    {
        id: "stopped-not-as-directed",
        title: "Stopped against instructions"
    },
    {
        id: "unknown",
        title: "Unknown"
    }
];
const $e55c1aeea21e594e$export$a8bce9498e67d565 = {
    "taking-as-directed": null,
    "taking-not-as-directed": "danger",
    "on-hold-as-directed": null,
    "on-hold-not-as-directed": "danger",
    "stopped-as-directed": null,
    "stopped-not-as-directed": "danger",
    unknown: "attention"
};
const $e55c1aeea21e594e$export$614987c2a84b2ba5 = {
    "taking-as-directed": (0, $2b6d0b8c1c80c786$export$1d8a03084661a191),
    "taking-not-as-directed": (0, $2b6d0b8c1c80c786$export$8e47d324a7a20b30),
    "on-hold-as-directed": (0, $2b6d0b8c1c80c786$export$adcaf896a7be650b),
    "on-hold-not-as-directed": (0, $2b6d0b8c1c80c786$export$8e47d324a7a20b30),
    "stopped-as-directed": (0, $2b6d0b8c1c80c786$export$d0c2ff82f0790e53),
    "stopped-not-as-directed": (0, $2b6d0b8c1c80c786$export$8e47d324a7a20b30),
    unknown: (0, $2b6d0b8c1c80c786$export$c5abb880dda04c02)
};
const $e55c1aeea21e594e$export$75dc9672272ed723 = 40;
function $e55c1aeea21e594e$export$54acbb69c3b90fd2({ organization_id: organization_id, person_id: person_id, activity_id: activity_id, medication: medication }) {
    /*
    /api/medications/autocomplete/:drugbank_pcid/:mode(strengths|routes|forms)
    */ const base = `/api/organizations/${organization_id}/medications/autocomplete`;
    const search = new URLSearchParams();
    if (person_id) search.set("person_id", person_id);
    if (activity_id) search.set("activity_id", activity_id);
    const { drugbank_level: level, drugbank_pcid: pcid, strength: strength, route: route, form: form } = medication ?? {};
    if (!pcid || strength && route && form) return `${base}?${search}`;
    if (!strength) return `${base}/${pcid}/strengths?${search}`;
    if (!route) return `${base}/${pcid}/routes?${search}`;
    if (!form) return `${base}/${pcid}/forms?${search}`;
    throw new Error(`Invalid drugbank_level: ${level}`);
}





var $683ed28381dba4a1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $683ed28381dba4a1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $683ed28381dba4a1$var$_MedicationInputElement_instances, $683ed28381dba4a1$var$_MedicationInputElement_log;
/*
keydown -> esc -> resets to medication name search, but only when value is empty
*/ let $683ed28381dba4a1$var$MedicationInputElement = class MedicationInputElement extends HTMLElement {
    constructor(){
        super(...arguments);
        $683ed28381dba4a1$var$_MedicationInputElement_instances.add(this);
    }
    get organization_id() {
        return this.getAttribute("organization_id");
    }
    get person_id() {
        return this.getAttribute("person_id");
    }
    get activity_id() {
        return this.getAttribute("activity_id");
    }
    focusSearchInput() {
        this.autocomplete.inputElement?.focus();
    }
    searchInputFocused({ isTrusted: isTrusted }) {
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "searchInputFocused", isTrusted);
    }
    searchInputBlurred() {
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "searchInputBlurred");
        // Close the dropdown on blur.
        // Timeout ensures this doesn't interfere with blurs that occur when selecting a suggestion.
        setTimeout(()=>{
            if (this.autocomplete.open) this.autocomplete.open = false;
            this.autocomplete.inputElement.value = "";
        }, 300); // do not reduce without testing quickly toggling between autocomplete suggestions with mouse.
    }
    async searchInputKeydown(event) {
        const { key: key, shiftKey: shiftKey, metaKey: metaKey, altKey: altKey, ctrlKey: ctrlKey } = event;
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "searchInputKeydown", key);
        if (shiftKey || metaKey || altKey || ctrlKey) return;
        if (key === "Backspace") {
            this.stepBack();
            return;
        }
    }
    searchInputChanged() {
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "searchInputChanged", this.autocomplete.inputElement?.value);
    }
    onAutocompleteLoadStart() {
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "onAutocompleteLoadStart", this.autocomplete.inputElement?.value);
    }
    onAutocompleteLoadEnd() {
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "onAutocompleteLoadEnd", this.autocomplete.forElement?.childElementCount);
        this.autocomplete.forElement?.classList.remove("btn-busy");
        // Don't open the dropdown when the input is not focused.
        if (document.activeElement !== this.autocomplete.inputElement) setTimeout(()=>{
            if (this.autocomplete.open) {
                $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "CLOSE");
                this.autocomplete.open = false;
            }
        }, 0);
    }
    onAutocompleteChange() {
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "onAutocompleteChange", this.autocomplete.inputElement?.value);
    }
    async onAutocompleteCommit({ target: target }) {
        if (!(target instanceof HTMLElement)) return;
        const data = JSON.parse(target.getAttribute("data-autocomplete-data"));
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "onAutocompleteCommit");
        this.apply(data);
    }
    async stepBack() {
        const drugbank_pcid = this.drugbank_pcid.value;
        if (this.autocomplete.inputElement.value.length === 0 && drugbank_pcid) {
            this.autocomplete.open = false;
            if (this.drugbank_level.value === "1" || this.brand_name.value && this.drugbank_level.value === "2") {
                this.apply(null);
                return;
            }
            try {
                this.displaySpan.parentElement?.classList.add("btn-busy");
                const response = await fetch(new URL(`/api/medications/product-concepts/${drugbank_pcid}/parents`, location.origin));
                if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
                const parents = await response.json();
                // console.table(
                //   parents.map(({ brand_name, form, route, strength, name }) => ({
                //     brand_name,
                //     route,
                //     form,
                //     strength,
                //     name
                //   }))
                // );
                // console.table([
                //   {
                //     brand_name: this.brand_name.value,
                //     route: this.route.value,
                //     form: this.form.value,
                //     strength: this.strength.value,
                //     name: this.name.value
                //   }
                // ]);
                this.apply(parents.find((x)=>{
                    // name, strength, route, form
                    if ((x.brand_name ?? "") !== this.brand_name.value) return false;
                    if (this.form.value) return (x.route ?? "") === this.route.value && (x.strength ?? "") === this.strength.value;
                    else if (this.route.value) return (x.strength ?? "") === this.strength.value && (x.form ?? "") === this.form.value;
                    return true;
                }) ?? null);
            } catch (err) {
                this.apply(null);
            } finally{
                this.displaySpan.parentElement?.classList.remove("btn-busy");
            }
        }
    }
    apply(data) {
        $683ed28381dba4a1$var$__classPrivateFieldGet(this, $683ed28381dba4a1$var$_MedicationInputElement_instances, "m", $683ed28381dba4a1$var$_MedicationInputElement_log).call(this, "apply", JSON.stringify(data, null, 2));
        // set selection.
        this.displaySpan.textContent = data?.name ?? "";
        this.drugbank_pcid.value = data?.drugbank_pcid ?? "";
        this.drugbank_level.value = data?.drugbank_level.toString() ?? "";
        this.name.value = data?.name ?? "";
        this.display_name.value = data?.display_name ?? "";
        this.brand_name.value = data?.brand_name ?? "";
        this.strength.value = data?.strength ?? "";
        this.route.value = data?.route ?? "";
        this.form.value = data?.form ?? "";
        this.rxcui.value = data?.rxcui?.toString() ?? "";
        if (data?.dose_and_frequency) {
            const input = this.closest("li")?.querySelector('input[name$="/dose_and_frequency"]');
            if (input) {
                input.value = data.dose_and_frequency;
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(input);
            }
        }
        if (data?.prescriber) {
            const input = this.closest("li")?.querySelector('input[name$="/prescriber"]');
            if (input) {
                input.value = data.prescriber;
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(input);
            }
        }
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.drugbank_pcid);
        // clear the search input.
        this.autocomplete.value = "";
        // clear the required input - so required validation will fire.
        this.valueInput.value = "";
        if (data?.drugbank_level === (data?.brand_name ? 5 : 4)) {
            // disable search
            this.autocomplete.src = "";
            this.autocomplete.open = false;
            // put a value in the required input so that the form will validate.
            this.valueInput.value = data.name;
            return;
        }
        // update the autocomplete source.
        this.autocomplete.src = (0, $e55c1aeea21e594e$export$54acbb69c3b90fd2)({
            organization_id: this.organization_id,
            person_id: this.person_id,
            activity_id: this.activity_id,
            medication: data
        });
        // refocus the input element, to prevent onAutocompleteLoadEnd from closing the menu.
        // this can happen when the user clicks on a result instead of using the keyboard.
        this.autocomplete.inputElement?.focus();
        // start a new search
        this.autocomplete.inputElement?.dispatchEvent(new CustomEvent("focus"));
        // keep the menu open and set it busy.
        this.autocomplete.open = true;
        this.autocomplete.forElement?.classList.add("btn-busy");
    }
};
$683ed28381dba4a1$var$_MedicationInputElement_instances = new WeakSet();
$683ed28381dba4a1$var$_MedicationInputElement_log = function _MedicationInputElement_log(...args) {
    if (location.hostname === "local.cumulus.care") console.log("[medication-input]", ...args, this.autocomplete.src);
};
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "displaySpan", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "autocomplete", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "drugbank_pcid", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "drugbank_level", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "display_name", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "name", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "brand_name", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "strength", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "route", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "form", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "rxcui", void 0);
$683ed28381dba4a1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $683ed28381dba4a1$var$MedicationInputElement.prototype, "valueInput", void 0);
$683ed28381dba4a1$var$MedicationInputElement = $683ed28381dba4a1$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("medication-input")
], $683ed28381dba4a1$var$MedicationInputElement);


function $3663a2715d0ea857$export$d9ffdbc590df6d8a(a, b, locale = "en") {
    return a.localeCompare(b, locale, {
        sensitivity: "base"
    }) === 0;
}
function $3663a2715d0ea857$export$d8dd5bf0f45452aa(a, b, locale = "en") {
    return a.localeCompare(b, locale, {
        sensitivity: "base"
    });
}





var $fd5aec581338ad52$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fd5aec581338ad52$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $fd5aec581338ad52$var$_MedicationListQuestionElement_instances, $fd5aec581338ad52$var$_MedicationListQuestionElement_log;
const $fd5aec581338ad52$var$fragment = document.createElement("ul");
$fd5aec581338ad52$var$fragment.setAttribute("aria-label", "Suggestions");
$fd5aec581338ad52$var$fragment.className = "suggester suggester-container mt-1";
$fd5aec581338ad52$var$fragment.setAttribute("role", "listbox");
let $fd5aec581338ad52$var$MedicationListQuestionElement = class MedicationListQuestionElement extends HTMLElement {
    constructor(){
        super(...arguments);
        $fd5aec581338ad52$var$_MedicationListQuestionElement_instances.add(this);
        this.drugDrugInteractionsTimeout = 0;
    }
    checkDrugDrugInteractions() {
        const ids = this.drugbankProductConceptInputs.map((x)=>x.value).filter((x)=>x).join(",");
        if (ids === this.getAttribute("drugbank-pcids")) return;
        clearTimeout(this.drugDrugInteractionsTimeout);
        setTimeout(async ()=>{
            const params = new URLSearchParams([
                [
                    "drugbank_pcids",
                    ids
                ],
                [
                    "target",
                    "medication-list-question.drugDrugInteractionsContent"
                ]
            ]);
            const url = new URL(`/api/medications/interactions?${params}`, location.origin);
            const response = await fetch(url);
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const el = this.drugDrugInteractionsContent;
            el.insertAdjacentHTML("afterend", await response.text());
            el.remove();
            this.setAttribute("drugbank-pcids", ids);
        }, 300);
    }
    valueInputFocused() {
        this.addButton.focus();
    }
    updateValueElement() {
        const newValue = String(this.listElement.children.length || ""); // encode zero as empty string
        if (this.valueInput.value !== newValue) {
            this.valueInput.value = newValue;
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.valueInput);
        }
    }
    providePrescribers({ detail: { provide: provide, relatedTarget: relatedTarget } }) {
        const q = relatedTarget.value.trim().toLowerCase();
        provide(Promise.resolve({
            suggestions: this.prescriberInputs.filter((x)=>x !== relatedTarget).map((x)=>x.value.trim()).filter((x, i, a)=>a.findIndex((y)=>(0, $3663a2715d0ea857$export$d9ffdbc590df6d8a)(y, x)) === i).filter((x)=>x.toLowerCase().includes(q)).sort((a, b)=>{
                const ai = $fd5aec581338ad52$var$clampIndex(a.toLowerCase().indexOf(q));
                const bi = $fd5aec581338ad52$var$clampIndex(b.toLowerCase().indexOf(q));
                return ai - bi || a.localeCompare(b, "en", {
                    sensitivity: "base"
                });
            }).map((id)=>({
                    id: id,
                    title: id
                }))
        }));
    }
    provideAdherence({ detail: { provide: provide, relatedTarget: relatedTarget } }) {
        const q = relatedTarget.value.trim().toLowerCase();
        provide(Promise.resolve({
            suggestions: q.length === 0 ? (0, $e55c1aeea21e594e$export$511f44e01e024619) : (0, $e55c1aeea21e594e$export$511f44e01e024619).filter((x)=>x.title.toLowerCase().includes(q)).sort((a, b)=>{
                const ai = $fd5aec581338ad52$var$clampIndex(a.title.toLowerCase().indexOf(q));
                const bi = $fd5aec581338ad52$var$clampIndex(b.title.toLowerCase().indexOf(q));
                return ai - bi || a.title.localeCompare(b.title, "en", {
                    sensitivity: "base"
                });
            })
        }));
    }
    provideFrequency({ detail: { provide: provide, relatedTarget: relatedTarget } }) {
        const pattern = /^ *(?:(take|give|apply|instill|inject|inhale) +)?(\d+(?:\.\d+|\/\d+)?)(?: +)?(\w+)?( +)?(\w+)?( +)?(\w+)?( +)?/i;
        const q = relatedTarget.value; // do not trim
        const [, verb, quantity, unit, unitDelim, route, routeDelim, frequency, frequencyDelim] = q.match(pattern) ?? [];
        $fd5aec581338ad52$var$__classPrivateFieldGet(this, $fd5aec581338ad52$var$_MedicationListQuestionElement_instances, "m", $fd5aec581338ad52$var$_MedicationListQuestionElement_log).call(this, JSON.stringify({
            verb: verb,
            quantity: quantity,
            unit: unit,
            unitDelim: unitDelim,
            route: route,
            routeDelim: routeDelim,
            frequency: frequency,
            frequencyDelim: frequencyDelim
        }, null, 2));
        let options;
        let term;
        let template;
        if (frequencyDelim || $fd5aec581338ad52$var$frequencies.some((f)=>f.abbr === frequency)) {
            // completed - no suggestions
            options = [];
            term = "";
            template = ()=>"";
        } else if (routeDelim || $fd5aec581338ad52$var$routes.some((r)=>r.abbr === route?.toLowerCase())) {
            // suggest frequencies
            options = $fd5aec581338ad52$var$frequencies;
            term = frequency;
            template = ({ abbr: abbr })=>[
                    verb,
                    quantity,
                    unit,
                    route,
                    abbr
                ].join(" ").trim();
        } else if (unitDelim || $fd5aec581338ad52$var$units.some((u)=>u.abbr === unit)) {
            // suggest routes
            const routeSubset = $fd5aec581338ad52$var$units.find((x)=>x.abbr === unit.toLowerCase())?.routes;
            options = routeSubset ? $fd5aec581338ad52$var$routes.filter((x)=>routeSubset.includes(x.abbr)) : $fd5aec581338ad52$var$routes;
            term = route;
            template = ({ abbr: abbr })=>[
                    verb,
                    quantity,
                    unit,
                    abbr
                ].join(" ").trim() + " ";
        } else if (quantity) {
            // suggest units
            const drugbankRoute = relatedTarget.closest("li")?.querySelector('input[name*="/route:"]')?.value ?? "";
            const unitSubset = $fd5aec581338ad52$var$routeToUnits[drugbankRoute] ?? [];
            options = $fd5aec581338ad52$var$units.filter((x)=>unitSubset.length === 0 || unitSubset.includes(x.abbr)).map((x)=>quantity === "1" ? x : {
                    abbr: x.abbr,
                    def: x.def + "s"
                });
            term = unit;
            template = ({ abbr: abbr })=>[
                    verb,
                    quantity,
                    abbr
                ].join(" ").trim() + " ";
        } else {
            // no suggestions- do not need to suggest verbs, they're optional.
            options = [];
            term = "";
            template = ()=>"";
        }
        if (term) {
            const lowerTerm = term.toLowerCase();
            options = options.filter((x)=>x.abbr.toLowerCase().includes(term) || x.def.toLowerCase().includes(lowerTerm)).sort((a, b)=>{
                const ai = Math.min($fd5aec581338ad52$var$clampIndex(a.abbr.toLowerCase().indexOf(lowerTerm)), $fd5aec581338ad52$var$clampIndex(a.def.toLowerCase().indexOf(lowerTerm)));
                const bi = Math.min($fd5aec581338ad52$var$clampIndex(b.abbr.toLowerCase().indexOf(lowerTerm)), $fd5aec581338ad52$var$clampIndex(b.def.toLowerCase().indexOf(lowerTerm)));
                return ai - bi || a.abbr.localeCompare(b.abbr, "en", {
                    sensitivity: "base"
                });
            });
        }
        provide(Promise.resolve({
            suggestions: options.map((x)=>({
                    id: template(x),
                    title: `${x.abbr}: ${x.def}`
                }))
        }));
    }
};
$fd5aec581338ad52$var$_MedicationListQuestionElement_instances = new WeakSet();
$fd5aec581338ad52$var$_MedicationListQuestionElement_log = function _MedicationListQuestionElement_log(..._args) {
    if (location.hostname === "local.cumulus.care") console.log("[medication-list-question]", ..._args);
};
$fd5aec581338ad52$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fd5aec581338ad52$var$MedicationListQuestionElement.prototype, "valueInput", void 0);
$fd5aec581338ad52$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fd5aec581338ad52$var$MedicationListQuestionElement.prototype, "listElement", void 0);
$fd5aec581338ad52$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fd5aec581338ad52$var$MedicationListQuestionElement.prototype, "addButton", void 0);
$fd5aec581338ad52$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fd5aec581338ad52$var$MedicationListQuestionElement.prototype, "prescriberList", void 0);
$fd5aec581338ad52$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $fd5aec581338ad52$var$MedicationListQuestionElement.prototype, "prescriberInputs", void 0);
$fd5aec581338ad52$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $fd5aec581338ad52$var$MedicationListQuestionElement.prototype, "drugbankProductConceptInputs", void 0);
$fd5aec581338ad52$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $fd5aec581338ad52$var$MedicationListQuestionElement.prototype, "drugDrugInteractionsContent", void 0);
$fd5aec581338ad52$var$MedicationListQuestionElement = $fd5aec581338ad52$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("medication-list-question")
], $fd5aec581338ad52$var$MedicationListQuestionElement);
function $fd5aec581338ad52$var$clampIndex(n) {
    return n === -1 ? Number.MAX_SAFE_INTEGER : n;
}
// drugbank routes to units
const $fd5aec581338ad52$var$routeToUnits = {
    "Auricular (otic)": [
        "gtt",
        "mL"
    ],
    Buccal: [
        "tab",
        "mg",
        "mL"
    ],
    Conjunctival: [
        "gtt",
        "mL"
    ],
    Cutaneous: [
        "g",
        "mL",
        "patch"
    ],
    Dental: [
        "g",
        "mg",
        "mL"
    ],
    "Electro-osmosis": [
        "mg",
        "mL"
    ],
    Endocervical: [
        "g",
        "mg",
        "mL"
    ],
    Endosinusial: [
        "gtt",
        "mL"
    ],
    Endotracheal: [
        "mg",
        "mL"
    ],
    Enteral: [
        "tab",
        "cap",
        "mg",
        "mL"
    ],
    Epidural: [
        "mg",
        "mL",
        "IU"
    ],
    Extracorporeal: [
        "mg",
        "mL"
    ],
    Hemodialysis: [
        "mg",
        "mL",
        "IU"
    ],
    Infiltration: [
        "mg",
        "mL"
    ],
    Interstitial: [
        "mg",
        "mL"
    ],
    "Intra-amniotic": [
        "mg",
        "mL"
    ],
    "Intra-arterial": [
        "mg",
        "mL",
        "IU",
        "vial"
    ],
    "Intra-articular": [
        "mg",
        "mL"
    ],
    Intrabiliary: [
        "mg",
        "mL"
    ],
    Intrabronchial: [
        "mg",
        "mL",
        "puff"
    ],
    Intrabursal: [
        "mg",
        "mL"
    ],
    Intracardiac: [
        "mg",
        "mL",
        "IU"
    ],
    Intracaudal: [
        "mg",
        "mL"
    ],
    Intracavernous: [
        "mg",
        "mL"
    ],
    Intracavitary: [
        "mg",
        "mL"
    ],
    Intracerebral: [
        "mg",
        "mL"
    ],
    Intracisternal: [
        "mg",
        "mL"
    ],
    Intracoronary: [
        "mg",
        "mL"
    ],
    Intradermal: [
        "mg",
        "mL",
        "unit"
    ],
    Intradiscal: [
        "mg",
        "mL"
    ],
    Intraduodenal: [
        "mg",
        "mL"
    ],
    Intragastric: [
        "mg",
        "mL"
    ],
    Intraileal: [
        "mg",
        "mL"
    ],
    Intralesional: [
        "mg",
        "mL"
    ],
    Intramuscular: [
        "mg",
        "mL",
        "unit",
        "IU",
        "vial",
        "amp"
    ],
    Intraocular: [
        "gtt",
        "mg",
        "mL"
    ],
    Intraperitoneal: [
        "mg",
        "mL",
        "IU"
    ],
    Intrapleural: [
        "mg",
        "mL"
    ],
    Intrapulmonary: [
        "mg",
        "mL",
        "puff"
    ],
    Intraspinal: [
        "mg",
        "mL",
        "IU"
    ],
    Intrasynovial: [
        "mg",
        "mL"
    ],
    Intrathecal: [
        "mg",
        "mL"
    ],
    Intratumor: [
        "mg",
        "mL"
    ],
    Intrauterine: [
        "mg",
        "mL",
        "IU"
    ],
    Intravenous: [
        "mg",
        "mL",
        "unit",
        "IU",
        "vial",
        "amp"
    ],
    "Intravenous bolus": [
        "mg",
        "mL",
        "unit",
        "IU",
        "vial",
        "amp"
    ],
    "Intravenous drip": [
        "mg",
        "mL",
        "unit",
        "IU"
    ],
    Nasal: [
        "gtt",
        "mg",
        "mL",
        "puff"
    ],
    Nasogastric: [
        "mg",
        "mL"
    ],
    Ophthalmic: [
        "gtt",
        "mg",
        "mL"
    ],
    Oral: [
        "tab",
        "cap",
        "mg",
        "mL"
    ],
    Oropharyngeal: [
        "mg",
        "mL"
    ],
    Parenteral: [
        "mg",
        "mL",
        "unit",
        "IU",
        "vial",
        "amp"
    ],
    Percutaneous: [
        "g",
        "mL",
        "patch"
    ],
    Periodontal: [
        "mg",
        "mL"
    ],
    Rectal: [
        "mg",
        "mL",
        "supp"
    ],
    "Respiratory (inhalation)": [
        "mg",
        "mL",
        "puff"
    ],
    "Soft tissue": [
        "mg",
        "mL"
    ],
    Subcutaneous: [
        "mg",
        "mL",
        "unit",
        "IU",
        "vial",
        "amp"
    ],
    Sublingual: [
        "tab",
        "mg"
    ],
    Submucosal: [
        "mg",
        "mL"
    ],
    Topical: [
        "g",
        "mL",
        "patch"
    ],
    Transdermal: [
        "mg",
        "mL",
        "patch"
    ],
    Transmucosal: [
        "mg",
        "mL"
    ],
    Urethral: [
        "mg",
        "mL",
        "supp"
    ],
    Vaginal: [
        "mg",
        "mL",
        "g",
        "supp"
    ] // Creams, tablets, suppositories
};
// Unit abbreviations
const $fd5aec581338ad52$var$units = [
    {
        abbr: "tab",
        def: "Tablet",
        routes: [
            "po",
            "sl",
            "pr"
        ]
    },
    {
        abbr: "cap",
        def: "Capsule",
        routes: [
            "po",
            "sl",
            "pr"
        ]
    },
    {
        abbr: "gtt",
        def: "Drop",
        routes: [
            "po",
            "sl",
            "pr",
            "iv",
            "top",
            "od",
            "os",
            "ou",
            "ad",
            "as",
            "au"
        ]
    },
    {
        abbr: "mcg",
        def: "Microgram",
        routes: [
            "po",
            "iv",
            "im",
            "sc",
            "inh"
        ]
    },
    {
        abbr: "mg",
        def: "Milligram",
        routes: [
            "po",
            "iv",
            "im",
            "sc",
            "inh",
            "top",
            "pr"
        ]
    },
    {
        abbr: "g",
        def: "Gram",
        routes: [
            "po",
            "top",
            "pr"
        ]
    },
    {
        abbr: "mEq",
        def: "Milliequivalent",
        routes: [
            "po",
            "iv"
        ]
    },
    {
        abbr: "mL",
        def: "Milliliter",
        routes: [
            "po",
            "iv",
            "im",
            "sc",
            "id",
            "pr",
            "top",
            "inh"
        ]
    },
    {
        abbr: "unit",
        def: "Unit",
        routes: [
            "sc",
            "iv",
            "im"
        ]
    },
    {
        abbr: "puff",
        def: "Puff",
        routes: [
            "inh",
            "nasal"
        ]
    },
    {
        abbr: "patch",
        def: "Transdermal Patch",
        routes: [
            "transdermal",
            "top"
        ]
    },
    {
        abbr: "IU",
        def: "International Unit",
        routes: [
            "iv",
            "im",
            "sc"
        ]
    },
    {
        abbr: "supp",
        def: "Suppository",
        routes: [
            "pr",
            "vag"
        ]
    },
    {
        abbr: "amp",
        def: "Ampule",
        routes: [
            "iv",
            "im",
            "sc"
        ]
    },
    {
        abbr: "vial",
        def: "Vial",
        routes: [
            "iv",
            "im",
            "sc"
        ]
    } // Administer 1 vial IM q4w
];
// Route of Administration Abbreviations
const $fd5aec581338ad52$var$routes = [
    {
        abbr: "po",
        def: "By mouth"
    },
    {
        abbr: "sl",
        def: "Sublingual"
    },
    {
        abbr: "im",
        def: "Intramuscular"
    },
    {
        abbr: "iv",
        def: "Intravenous"
    },
    {
        abbr: "sc",
        def: "Subcutaneous"
    },
    {
        abbr: "pr",
        def: "Per rectum"
    },
    {
        abbr: "id",
        def: "Intradermal"
    },
    {
        abbr: "inh",
        def: "Inhaled"
    },
    {
        abbr: "top",
        def: "Topical"
    },
    {
        abbr: "od",
        def: "Right eye"
    },
    {
        abbr: "os",
        def: "Left eye"
    },
    {
        abbr: "ou",
        def: "Both eyes"
    },
    {
        abbr: "ad",
        def: "Right ear"
    },
    {
        abbr: "as",
        def: "Left ear"
    },
    {
        abbr: "au",
        def: "Both ears"
    } // Instill 2 gtt AU bid
];
// Time & Frequency Abbreviations
const $fd5aec581338ad52$var$frequencies = [
    {
        abbr: "qd",
        def: "Once daily"
    },
    {
        abbr: "bid",
        def: "Twice daily"
    },
    {
        abbr: "tid",
        def: "Three times daily"
    },
    {
        abbr: "qid",
        def: "Four times daily"
    },
    // { abbr: 'qod', def: 'Every other day (discouraged)' }, // Take 1 tab po qod
    {
        abbr: "qam",
        def: "Every morning"
    },
    {
        abbr: "qpm",
        def: "Every evening"
    },
    {
        abbr: "qhs",
        def: "Every night at bedtime"
    },
    {
        abbr: "q1h",
        def: "Every hour"
    },
    {
        abbr: "q2h",
        def: "Every 2 hours"
    },
    {
        abbr: "q3h",
        def: "Every 3 hours"
    },
    {
        abbr: "q4h",
        def: "Every 4 hours"
    },
    {
        abbr: "q6h",
        def: "Every 6 hours"
    },
    {
        abbr: "q8h",
        def: "Every 8 hours"
    },
    {
        abbr: "qwk",
        def: "Every week"
    },
    {
        abbr: "prn",
        def: "As needed"
    },
    {
        abbr: "stat",
        def: "Immediately"
    },
    {
        abbr: "ac",
        def: "Before meals"
    },
    {
        abbr: "pc",
        def: "After meals"
    } // Take 1 tab po PC
];




class $2085423fd74fd7e1$export$f58ae03993ef5132 extends HTMLElement {
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: "open"
        });
        this.templateSlot = document.createElement("slot");
        this.templateSlot.name = "template";
        shadow.append(document.createElement("slot"), this.templateSlot);
    }
    connectedCallback() {
        this.querySelector("button")?.addEventListener("click", this);
        if (this.hasAttribute("open-modal")) this.open();
    }
    disconnectedCallback() {
        this.querySelector("button")?.removeEventListener("click", this);
    }
    handleEvent(event) {
        if (event.target instanceof Element && event.target.closest(":disabled")) return;
        this.open();
    }
    open() {
        const document1 = this.ownerDocument;
        const template = this.templateSlot.assignedElements()[0];
        const src = this.getAttribute("src");
        let content;
        if (!template) {
            if (src) {
                const frag = document1.createElement("include-fragment");
                frag.src = src;
                content = frag;
            } else throw new Error('Part "template" or attribute "src" is required.');
        } else if (!(template instanceof HTMLTemplateElement)) throw new Error('Part "template" is not an HTMLTemplateElement');
        else {
            content = template.content.cloneNode(true);
            if (src) content.querySelector("include-fragment").src = src;
        }
        if (!this.id) this.id = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
        const modal = document1.createElement("modal-content");
        modal.setAttribute("controller-id", this.id);
        modal.append(content);
        document1.body.append(modal);
    }
}
if (!window.customElements.get("modal-controller")) {
    window.ModalControllerElement = $2085423fd74fd7e1$export$f58ae03993ef5132;
    window.customElements.define("modal-controller", $2085423fd74fd7e1$export$f58ae03993ef5132);
}






class $dc89a90c270b1969$export$5bfad2f7bf9699f7 extends HTMLElement {
    get parametric() {
        return this.hasAttribute("parametric");
    }
    connectedCallback() {
        this.addEventListener("change", this);
        this.addEventListener("blur", this, {
            capture: true
        });
        if (this.hasAttribute("parametric")) this.addEventListener("focus", this, {
            capture: true
        });
    }
    disconnectedCallback() {
        this.removeEventListener("change", this);
        this.removeEventListener("blur", this, {
            capture: true
        });
        this.removeEventListener("focus", this, {
            capture: true
        });
    }
    handleEvent(event) {
        const input = event.target instanceof HTMLInputElement && event.target === this.firstElementChild && event.target;
        if (!input) return;
        if (event.type === "change" || event.type === "blur") {
            const value = parseFloat(input.value);
            if (!isFinite(value)) {
                if (this.parametric && (0, $d175770e6e5170f5$export$99da40ee05a17718).test(input.value.toUpperCase())) input.value = input.value.toUpperCase();
                return;
            }
            // format the value to the specified number of digits
            const minimumFractionDigits = parseInt(this.getAttribute("minimum-fraction-digits") ?? "0");
            const maximumFractionDigits = parseInt(this.getAttribute("maximum-fraction-digits") ?? minimumFractionDigits.toString());
            const formatted = new Intl.NumberFormat("en-us", {
                useGrouping: false,
                minimumFractionDigits: minimumFractionDigits,
                maximumFractionDigits: maximumFractionDigits,
                roundingMode: "floor"
            }).format(value);
            if (input.value !== formatted) {
                input.value = formatted;
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(input);
            }
        } else if (event.type === "focus") {
            if (!this.parametric || !input.list || !input.form) return;
            const parameters = (0, $dc1ba3c708ab185c$export$149e10162b59b4e2)(input);
            if (!parameters?.length) return;
            input.list.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(parameters.map((x)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<option value="${x.name}">${x.name}</option>`));
        }
    }
}
if (!window.customElements.get("number-input")) {
    window.NumberInputElement = $dc89a90c270b1969$export$5bfad2f7bf9699f7;
    window.customElements.define("number-input", $dc89a90c270b1969$export$5bfad2f7bf9699f7);
}
(0, $f3a2ac2d620bcd8b$export$86f1725708ac86dc)((input, label)=>{
    if (input instanceof HTMLInputElement && input.type === "text" && input.value.length && input.parentElement instanceof $dc89a90c270b1969$export$5bfad2f7bf9699f7) {
        const value = input.value;
        if (input.parentElement.parametric) {
            const result = (0, $dc1ba3c708ab185c$export$9c08897bbef487d2)(input, [
                value
            ]);
            return result.valid ? null : result.message;
        }
        const num = parseFloat(value);
        if (isFinite(num)) return null;
        return `${label} is invalid.`;
    }
    return null;
});




var $00f49788a386ead3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $00f49788a386ead3$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $00f49788a386ead3$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $00f49788a386ead3$var$_SideBarElement_observer, $00f49788a386ead3$var$_SideBarElement_timeout;
let $00f49788a386ead3$export$dcd314c2ee8251f2 = class SideBarElement extends HTMLElement {
    constructor(){
        super(...arguments);
        $00f49788a386ead3$var$_SideBarElement_observer.set(this, new ResizeObserver(()=>this.scheduleUpdate()));
        $00f49788a386ead3$var$_SideBarElement_timeout.set(this, 0);
    }
    connectedCallback() {
        $00f49788a386ead3$var$__classPrivateFieldGet(this, $00f49788a386ead3$var$_SideBarElement_observer, "f").observe(this);
        this.update();
    }
    disconnectedCallback() {
        $00f49788a386ead3$var$__classPrivateFieldGet(this, $00f49788a386ead3$var$_SideBarElement_observer, "f").disconnect();
    }
    scheduleUpdate() {
        clearTimeout($00f49788a386ead3$var$__classPrivateFieldGet(this, $00f49788a386ead3$var$_SideBarElement_timeout, "f"));
        $00f49788a386ead3$var$__classPrivateFieldSet(this, $00f49788a386ead3$var$_SideBarElement_timeout, setTimeout(()=>this.update(), 0), "f");
    }
    update() {
        clearTimeout($00f49788a386ead3$var$__classPrivateFieldGet(this, $00f49788a386ead3$var$_SideBarElement_timeout, "f"));
        for (const item of this.items)item.hidden = false;
        this.more.hidden = true;
        this.moreMenuList.innerHTML = "";
        if (this.itemsContainer.scrollWidth <= this.itemsContainer.clientWidth) return;
        this.more.hidden = false;
        for(let i = this.items.length - 1; i >= 0; i--){
            const item = this.items[i];
            const overflowItem = item.cloneNode(true);
            overflowItem.removeAttribute("data-targets");
            overflowItem.role = "menuitem";
            overflowItem.className = "SelectMenu-item";
            this.moreMenuList.prepend(overflowItem);
            item.hidden = true;
            if (this.itemsContainer.scrollWidth <= this.itemsContainer.clientWidth) break;
        }
    }
};
$00f49788a386ead3$var$_SideBarElement_observer = new WeakMap();
$00f49788a386ead3$var$_SideBarElement_timeout = new WeakMap();
$00f49788a386ead3$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $00f49788a386ead3$export$dcd314c2ee8251f2.prototype, "more", void 0);
$00f49788a386ead3$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $00f49788a386ead3$export$dcd314c2ee8251f2.prototype, "moreMenuList", void 0);
$00f49788a386ead3$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $00f49788a386ead3$export$dcd314c2ee8251f2.prototype, "itemsContainer", void 0);
$00f49788a386ead3$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $00f49788a386ead3$export$dcd314c2ee8251f2.prototype, "items", void 0);
$00f49788a386ead3$export$dcd314c2ee8251f2 = $00f49788a386ead3$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("overflow-nav")
], $00f49788a386ead3$export$dcd314c2ee8251f2);


class $0b207656f02e789e$export$58667bf9645f93c6 extends HTMLElement {
    connectedCallback() {
        this.addEventListener("input", $0b207656f02e789e$var$setParam);
    }
    disconnectedCallback() {
        this.removeEventListener("input", $0b207656f02e789e$var$setParam);
    }
}
function $0b207656f02e789e$var$setParam({ target: target }) {
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
        const url = new URL(location.href);
        if (target.value === "") url.searchParams.delete(target.name);
        else url.searchParams.set(target.name, target.value);
        if (url.href !== location.href) history.replaceState(null, "", url.href);
    }
}
if (!window.customElements.get("param-input")) {
    window.ParamInputElement = $0b207656f02e789e$export$58667bf9645f93c6;
    window.customElements.define("param-input", $0b207656f02e789e$export$58667bf9645f93c6);
}











function $456252ed2e235022$export$8e2ee32c32a0ef22(attrs = {}) {
    let value = "";
    if (attrs.value instanceof Date) value = (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(attrs.value);
    else if (attrs.value) value = attrs.value;
    const inputId = attrs.id ?? (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    const listId = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
    <input
      type="date"
      form="undefined-form"
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("value", attrs.value instanceof Date ? attrs.value.toISOString().substr(0, 10) : null)}
      tabindex="-1"
      aria-labelledby="${inputId}"
      data-target="date-input.pickerInput"
      data-action="change:date-input#handlePickerInputChange"
      style="
        width: 0;
        max-width: 0;
        max-height: 1px;
        margin-bottom: -4px;
        align-self: end;
        overflow: hidden;
        -webkit-appearance: none;
        padding: 0;
        border: none;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
      "
    />
    <input
      class="form-control ${attrs.small ? "input-sm" : ""} mr-1"
      id="${inputId}"
      type="text"
      autocomplete="none"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      list="${listId}"
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("name", attrs.name)}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("value", value)}
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", attrs.required)}
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", attrs.disabled)}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", attrs.form)}
      ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-label", attrs.ariaLabel)}
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", attrs.autofocus)}
      ${attrs.inputAttrs?.map((x, i)=>[
            i == 0 ? null : " ",
            x
        ])}
      data-target="date-input.input ${attrs.target}"
      data-action="${[
        "change:date-input#handleInputChange",
        "blur:date-input#handleInputChange",
        "input:date-input#updateSuggestions",
        "focus:date-input#updateSuggestions",
        attrs.action
    ].join(" ")}"
    />
    <datalist id="${listId}"></datalist>
    <button
      class="btn ${attrs.small ? "btn-sm" : ""} d-print-none"
      type="button"
      aria-label="Show calendar"
      data-action="click:date-input#showPicker"
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("hidden", attrs.disabled)}
    >
      ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$2daa3271a740c7f))}
    </button>
  `;
}



function $7c0cd8cd96487c75$export$6db68b231e9eddb6(locale) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`&nbsp;<abbr
      class="form-group-required-asterisk"
      title="${(0, $2868cc1235412e16$export$bf155eef9c17fa3b)[locale]}"
      >*</abbr
    >`;
}
function $7c0cd8cd96487c75$export$bdc7259586f8f739(config) {
    let { locale: locale = (0, $f2e3bdb9929a0de6$export$d7f512c98c859244), name: name, label: label, required: required = false, classes: classes = "", headerClasses: headerClasses = "", description: description, attrs: attrs, disabled: disabled = false, id: id = (0, $5cb959b633531006$export$9e1c824dbb29e809)(), form: form, small: small = false, target: target, action: action, inputAttrs: inputAttrs, autofocus: autofocus = false } = config;
    const descriptionId = description ? (0, $5cb959b633531006$export$9e1c824dbb29e809)() : "";
    const describedBy = descriptionId;
    const desc = description ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<p class="note" id="${descriptionId}">${description}</p>` : null;
    let input;
    switch(config.type){
        case "name":
        case "text":
            {
                const { value: value = "", spellcheck: spellcheck = true, maxLength: maxLength, minLength: minLength, autocomplete: autocomplete = "off", autocompleteList: autocompleteList, inputClasses: inputClasses, inputWrapper: inputWrapper = (content)=>content } = config;
                input = inputWrapper((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
            class="form-control${small ? " input-sm" : ""}${inputClasses ? ` ${inputClasses}` : ""}"
            id="${id}"
            name="${name}"
            type="text"
            value="${value}"
            spellcheck="${spellcheck}"
            autocomplete="${autocomplete}"
            autocapitalize="${config.type === "name" ? "words" : "sentences"}"
            maxlength="${maxLength}"
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("minlength", minLength?.toString())}
            ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
            ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
            ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
            ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
          />${autocompleteList}`);
                break;
            }
        case "email":
            {
                const { value: value = "", autocomplete: autocomplete = "none", maxLength: maxLength = 256 } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? " input-sm" : ""}"
        id="${id}"
        name="${name}"
        type="email"
        value="${value}"
        autocomplete="${autocomplete}"
        minlength="4"
        maxlength="${maxLength}"
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      />`;
                break;
            }
        case "url":
            {
                const { value: value = "", https: https = true } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? " input-sm" : ""}"
        id="${id}"
        name="${name}"
        type="url"
        value="${value}"
        autocomplete="none"
        pattern="${https ? "https" : "http(s)?"}://.*"
        minlength="14"
        maxlength="256"
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      />`;
                break;
            }
        case "login":
            {
                const { value: value = "", maxLength: maxLength = (0, $2a2dcd2529aa22ab$export$1514431ed310ac1b) } = config;
                const autocomplete = "none";
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? " input-sm" : ""}"
        id="${id}"
        name="${name}"
        type="text"
        value="${value}"
        autocomplete="${autocomplete}"
        maxlength="${maxLength}"
        validate-login
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      />`;
                break;
            }
        case "password":
            {
                const autocomplete = "new-password";
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? " input-sm" : ""}"
        id="${id}"
        name="${name}"
        type="password"
        autocomplete="${autocomplete}"
        minlength="${0, $2a2dcd2529aa22ab$export$c1524f9be65f4b8a}"
        maxlength="${0, $2a2dcd2529aa22ab$export$9ea34356f788bd3a}"
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      />`;
                break;
            }
        case "textarea":
            {
                const { value: value = "", spellcheck: spellcheck = true, maxLength: maxLength, minLength: minLength, rows: rows = Math.min(Math.max(Math.floor(maxLength / 125), 1), 8), placeholder: placeholder } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<textarea
        class="form-control${small ? " input-sm" : ""} field-sizing-content"
        id="${id}"
        name="${name}"
        autocapitalize="sentences"
        autocomplete="off"
        maxlength="${maxLength}"
        spellcheck="${spellcheck}"
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("minlength", minLength?.toString())}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("placeholder", placeholder)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        style="${`min-height: ${small ? 16 * rows + 7.334 : 20 * rows + 11.334}px;`}"
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      >
${value}</textarea
      >`;
                break;
            }
        case "select":
            {
                const { value: value = "", options: options } = config;
                const opts = $7c0cd8cd96487c75$export$d3199b8dddc55be(options, value);
                if (options.length === 0) {
                    classes += " form-group--empty-select";
                    opts.unshift($7c0cd8cd96487c75$var$selectOptionTemplate("", "", "", false));
                } else if (!required && !options.find((x)=>x.value === "")) opts.unshift($7c0cd8cd96487c75$var$selectOptionTemplate("", "", value, false));
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<select
        class="form-select${small ? " select-sm" : ""}"
        id="${id}"
        name="${name}"
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      >
        ${opts}
      </select>`;
                break;
            }
        case "rich-select":
            {
                const { value: value = "", options: options, small: small, menuWidthClass: menuWidthClass, summaryId: summaryId } = config;
                const opts = Array.from(options);
                const none = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="color-fg-muted text-italic">None</span>`;
                if (opts.length === 0) {
                    classes += " form-group--empty-select";
                    opts.unshift({
                        value: "",
                        text: none,
                        disabled: disabled
                    });
                } else if (!required && !opts.find((x)=>x.value === "")) opts.unshift({
                    value: "",
                    text: none,
                    disabled: disabled
                });
                const cur = opts.find((o)=>o.value === value);
                if (!cur) throw new Error(`Option with value matching ${JSON.stringify(value)} not found.`);
                const summaryContent = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="sr-only">${label}:</span>
        <span class="flex-1" data-menu-button style="min-width: 0"
          >${cur.text}</span
        >
        <span class="dropdown-caret"></span>`;
                if (disabled) input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
          class="form-control${small ? " input-sm" : ""} d-flex flex-items-center gap-2"
          disabled
          >${summaryContent}</span
        >`;
                else {
                    const filterTargetId = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
                    input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<details
          class="details-reset details-overlay position-relative"
          id="${id}"
        >
          <summary
            class="form-control${small ? " input-sm" : ""} d-flex flex-items-center gap-2"
            style="scroll-margin-top: 60px"
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("id", summaryId)}
            ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
          >
            ${summaryContent}
          </summary>
          <details-menu
            class="SelectMenu ${opts.length > 6 ? "SelectMenu--hasFilter" : ""}"
            role="menu"
          >
            <div class="SelectMenu-modal min-width-full ${menuWidthClass}">
              <header class="SelectMenu-header">
                <h3 class="SelectMenu-title">Select ${label}</h3>
                <button
                  class="SelectMenu-closeButton"
                  type="button"
                  data-toggle-for="${id}"
                  aria-label="Close menu"
                >
                  ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$4d48f840957dea1b))}
                </button>
              </header>
              <filter-input
                class="SelectMenu-filter"
                aria-owns="${filterTargetId}"
                ${(0, $904f4b114d3dc756$export$65c20e333206336e)("hidden", opts.length <= 6)}
              >
                <input
                  class="SelectMenu-input form-control"
                  type="text"
                  autofocus
                  autocomplete="off"
                  placeholder="Filter"
                  aria-label="Filter"
                  form="undefined-form"
                />
              </filter-input>
              <div
                class="SelectMenu-list"
                id="${filterTargetId}"
                data-filter-list
              >
                ${opts.map((o)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<label
                      class="SelectMenu-item"
                      role="menuitemradio"
                      aria-checked="${o.value === value}"
                      tabindex="0"
                    >
                      ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$1d8a03084661a191), "SelectMenu-icon SelectMenu-icon--check f4")}
                      <input
                        class="sr-only"
                        type="radio"
                        name="${name}"
                        value="${o.value}"
                        tabindex="-1"
                        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("checked", o.value === value)}
                        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
                        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
                        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
                        ${inputAttrs?.map((x, i)=>[
                                i == 0 ? null : " ",
                                x
                            ])}
                      />
                      ${o.description ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
                            ><span
                              data-menu-button-contents
                              style="min-width: 0"
                              >${o.text}</span
                            ><span
                              class="text-normal color-fg-muted f6 d-block"
                              style="min-width: 0"
                              >${o.description}</span
                            ></span
                          >` : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
                            data-menu-button-contents
                            style="min-width: 0"
                            >${o.text}</span
                          >`}
                    </label>`)}
              </div>
            </div>
          </details-menu>
        </details>`;
                }
                break;
            }
        case "remote-rich-select":
            {
                const { value: value, src: src, small: small, menuAction: menuAction, footerContent: footerContent, menuWidthClass: menuWidthClass, summaryId: summaryId } = config;
                const summaryContent = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="sr-only">${label}:</span>
        <span class="flex-1" data-menu-button style="min-width: 0"
          >${value}</span
        >
        <span class="dropdown-caret"></span>`;
                if (disabled) input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
          class="form-control${small ? " input-sm" : ""} d-flex flex-items-center gap-2"
          disabled
          >${summaryContent}</span
        >`;
                else {
                    const filterTargetId = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
                    input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<details
          class="details-reset details-overlay position-relative"
          id="${id}"
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        >
          <summary
            class="form-control${small ? " input-sm" : ""} d-flex flex-items-center gap-2"
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("id", summaryId)}
            ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
          >
            ${summaryContent}
          </summary>
          <details-menu
            class="SelectMenu SelectMenu--hasFilter"
            role="menu"
            ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", menuAction)}
          >
            <div class="SelectMenu-modal min-width-full ${menuWidthClass}">
              <header class="SelectMenu-header">
                <h3 class="SelectMenu-title">Select ${label}</h3>
                <button
                  class="SelectMenu-closeButton"
                  type="button"
                  data-toggle-for="${id}"
                  aria-label="Close menu"
                >
                  ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$4d48f840957dea1b))}
                </button>
              </header>
              <remote-input
                class="SelectMenu-filter"
                aria-owns="${filterTargetId}"
                src="${src}"
              >
                <input
                  class="SelectMenu-input form-control"
                  type="text"
                  autofocus
                  autocomplete="off"
                  placeholder="Search..."
                  aria-label="Search"
                  maxlength="100"
                  form="undefined-form"
                />
              </remote-input>
              <div class="SelectMenu-list" id="${filterTargetId}"></div>
              ${footerContent ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<footer class="SelectMenu-footer">
                    ${footerContent}
                  </footer>` : null}
            </div>
          </details-menu>
        </details>`;
                }
                break;
            }
        case "date":
            {
                const { value: value = null, relative: relative = false, parametric: parametric = false } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<date-input
        class="d-flex position-relative"
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("relative", relative)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("parametric", parametric)}
        >${(0, $456252ed2e235022$export$8e2ee32c32a0ef22)({
                    id: id,
                    name: name,
                    value: value,
                    required: required,
                    disabled: disabled,
                    autofocus: autofocus,
                    form: form,
                    small: small,
                    target: target,
                    action: action,
                    inputAttrs: inputAttrs
                })}</date-input
      >`;
                break;
            }
        case "time":
            {
                const { value: value = "" } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? " input-sm" : ""}"
        id="${id}"
        name="${name}"
        type="time"
        autocomplete="none"
        value="${value}"
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      />`;
                break;
            }
        case "integer":
        case "currency":
        case "number":
            {
                const { value: value, min: min, max: max } = config;
                const minimumFractionDigits = config.type === "number" ? config.minimumFractionDigits : config.type === "integer" ? 0 : 2;
                const maximumFractionDigits = config.type === "number" ? config.maximumFractionDigits : config.type === "integer" ? 0 : 2;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? " input-sm" : ""}${config.type === "currency" ? " form-control-currency" : ""}"
        id="${id}"
        name="${name}"
        type="number"
        autocomplete="none"
        value="${value === undefined ? "" : config.type === "integer" ? value : new Intl.NumberFormat("en-us", {
                    useGrouping: false,
                    minimumFractionDigits: minimumFractionDigits,
                    maximumFractionDigits: maximumFractionDigits,
                    roundingMode: "floor"
                }).format(value)}"
        step="${config.type === "integer" ? "1" : "any"}"
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("min", min?.toString())}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("max", max?.toString())}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      />`;
                if (config.type === "currency" || config.type === "number") input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<number-input
          minimum-fraction-digits="${minimumFractionDigits}"
          maximum-fraction-digits="${maximumFractionDigits}"
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("class", config.type === "currency" ? "form-control-symbol-container" : null)}
          >${input}${config.type === "currency" ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="form-control-symbol" aria-hidden="true"
                >$</span
              >` : null}</number-input
        >`;
                break;
            }
        case "tel":
            {
                const { value: value = "", autocomplete: autocomplete = "none" } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<mask-input pattern="(###) ###-####">
        <input
          class="form-control${small ? " input-sm" : ""}"
          id="${id}"
          name="${name}"
          type="tel"
          autocomplete="${autocomplete}"
          value="${value}"
          maxlength="14"
          pattern="^\\(\\d{3}\\) \\d{3}-\\d{4}$"
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
          ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
        />
      </mask-input>`;
                break;
            }
        case "zip":
            {
                const { value: value = "", autocomplete: autocomplete = "none" } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<mask-input pattern="#####-####">
        <input
          class="form-control${small ? " input-sm" : ""}"
          id="${id}"
          name="${name}"
          type="text"
          autocomplete="${autocomplete}"
          value="${value}"
          maxlength="10"
          pattern="^\\d{5}(?:-\\d{4})?$"
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
          ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
        />
      </mask-input>`;
                break;
            }
        case "numeric-code":
            {
                const { value: value = "", maxLength: maxLength, minLength: minLength } = config;
                input = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
        class="form-control${small ? " input-sm" : ""}"
        id="${id}"
        name="${name}"
        type="tel"
        autocomplete="none"
        value="${value}"
        pattern="^\\d+$"
        maxlength="${maxLength}"
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("minlength", minLength?.toString())}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${inputAttrs?.map((x, i)=>[
                        i == 0 ? null : " ",
                        x
                    ])}
      />`;
                break;
            }
        default:
            throw new Error(`Unexpected form group type`);
    }
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div
    class="form-group break-inside-avoid ${classes}"
    ${attrs?.map((x, i)=>[
            i == 0 ? null : " ",
            x
        ])}
  >
    <label class="form-group-header d-inline-block ${headerClasses}" for="${id}"
      ><span data-label-text>${label}</span>${required && (config.type !== "select" || config.type === "select" && config.options.some((x)=>x.value === "")) && config.type !== "rich-select" ? $7c0cd8cd96487c75$export$6db68b231e9eddb6(locale) : null}
    </label>
    <div class="form-group-body">${input}</div>
    ${desc}
  </div>`;
}
function $7c0cd8cd96487c75$export$a347ff2415ee3093({ label: label, name: name, checked: checked, disabled: disabled, description: description, classes: classes, attrs: attrs, form: form, target: target, action: action, inputAttrs: inputAttrs, autofocus: autofocus, required: required, id: id = (0, $5cb959b633531006$export$9e1c824dbb29e809)(), trueValue: trueValue = true, falseValue: falseValue = false }) {
    const labelContent = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span data-label-text>${label}</span>`;
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div
    class="form-group ${classes}"
    ${attrs?.map((x, i)=>[
            i == 0 ? null : " ",
            x
        ])}
  >
    <div class="form-group-body">
      <label
        class="d-inline-flex ${description ? "flex-items-start" : "flex-items-center"} gap-1"
        for="${id}"
      >
        <input
          type="hidden"
          name="${name}"
          value="${falseValue}"
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        />
        <input
          id="${id}"
          class="flex-shrink-0${description ? " mt-1" : ""}"
          type="checkbox"
          name="${name}"
          value="${trueValue}"
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("checked", checked)}
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
          ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-target", target)}
          ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
          ${inputAttrs?.map((x, i)=>[
            i == 0 ? null : " ",
            x
        ])}
        />
        ${description ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="d-flex flex-column">
              ${labelContent}
              <span class="color-fg-muted f6 text-normal">${description}</span>
            </span>` : labelContent}</label
      >
    </div>
  </div>`;
}
function $7c0cd8cd96487c75$export$227eadb0dfb7a1({ locale: locale = (0, $f2e3bdb9929a0de6$export$d7f512c98c859244), form: form, small: small, isNew: isNew, label: label = isNew ? (0, $2868cc1235412e16$export$baff25308003b0cc)[locale] : (0, $2868cc1235412e16$export$f093e2a834170186)[locale], describedBy: describedBy } = {}) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<button
    type="submit"
    class="btn btn-primary${small ? " btn-sm" : ""} justify-self-start d-print-none"
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
    ${(0, $904f4b114d3dc756$export$65c20e333206336e)("new", isNew)}
    ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
    disabled
  >
    <span class="saved-indicator"></span>
    <span>${label}</span>
  </button>`;
}
function* $7c0cd8cd96487c75$export$9720603651db00f5(items, valueProperty, textProperty) {
    for (const item of items){
        const value = String(item[valueProperty]);
        const text = String(item[textProperty]);
        yield {
            value: value,
            text: text
        };
    }
}
function $7c0cd8cd96487c75$var$selectOptionsTemplate(items, selectedValue) {
    return items.map(({ value: value, text: text, disabled: disabled = false })=>$7c0cd8cd96487c75$var$selectOptionTemplate(text, value, selectedValue, disabled));
}
function $7c0cd8cd96487c75$export$d3199b8dddc55be(options, value) {
    const opts = [];
    for (const [group, items] of Object.entries((0, $a3570cdd24dfa717$export$3f063810d7bf01bd)(options, (x)=>x.group ?? "")))if (group) opts.push((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<optgroup label="${group}">
          ${$7c0cd8cd96487c75$var$selectOptionsTemplate(items, value)}
        </optgroup>`);
    else opts.push(...$7c0cd8cd96487c75$var$selectOptionsTemplate(items, value));
    return opts;
}
function $7c0cd8cd96487c75$var$selectOptionTemplate(text, value, selectedValue, disabled) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<option
    value="${value}"
    ${(0, $904f4b114d3dc756$export$65c20e333206336e)("selected", value === selectedValue)}
    ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
  >
    ${text}
  </option>`;
}
function $7c0cd8cd96487c75$export$403e83ebb3fcef38({ label: label, name: name, options: options, multiple: multiple, value: value, required: required = false, disabled: disabled = false, description: description, classes: classes, attrs: attrs, form: form, autofocus: autofocus = false, locale: locale = (0, $f2e3bdb9929a0de6$export$d7f512c98c859244) }) {
    let printOnlyDesc = false;
    if (!description) {
        printOnlyDesc = true;
        description = multiple ? (0, $2868cc1235412e16$export$2beae1cfd23206a)[locale] : (0, $2868cc1235412e16$export$24bd8284d2d99ce0)[locale];
    }
    const desc = description ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<p
        class="note text-normal mt-0 mb-1${printOnlyDesc ? " d-screen-none" : ""}"
      >
        ${description}
      </p>` : null;
    const inline = options.length <= 4 && !options.some((c)=>c.description) && options.reduce((acc, c)=>acc + c.text.length, 0) <= 40;
    const type = multiple ? "checkbox" : "radio";
    const choices = [];
    for (const option of options){
        const checked = option.value === value || Array.isArray(value) && value.includes(option.value);
        choices.push($7c0cd8cd96487c75$var$choiceTemplate({
            type: type,
            name: name,
            value: option.value,
            label: option.text,
            description: option.description,
            checked: checked,
            exclusive: option.exclusive ?? false,
            required: required,
            disabled: disabled || (option.disabled ?? false),
            describedBy: "",
            form: form,
            autofocus: autofocus,
            inputId: option.id ?? (0, $5cb959b633531006$export$9e1c824dbb29e809)(),
            selectedContent: option.selectedContent,
            action: option.action,
            hidden: option.hidden,
            attrs: option.attrs
        }));
    }
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<fieldset
    class="form-group break-inside-avoid ${classes}"
    ${attrs?.map((x, i)=>[
            i == 0 ? null : " ",
            x
        ])}
  >
    <choice-group class="d-block">
      <legend class="form-group-header text-bold">
        <span data-label-text>${label}</span>${required ? $7c0cd8cd96487c75$export$6db68b231e9eddb6(locale) : null}
        ${desc}
      </legend>
      <div
        class="form-group-body d-flex flex-items-start ${inline ? "gap-3 flex-wrap" : "flex-column gap-2"}"
      >
        ${!required && !multiple ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input type="hidden" name="${name}" value="" />` : null}
        ${choices}
      </div>
    </choice-group>
  </fieldset>`;
}
function $7c0cd8cd96487c75$var$choiceTemplate({ type: type, name: name, value: value, label: label, checked: checked, description: description, exclusive: exclusive, required: required, disabled: disabled, describedBy: describedBy, form: form, autofocus: autofocus, inputId: inputId, selectedContent: selectedContent, action: action, hidden: hidden, attrs: attrs }) {
    const labelContent = (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
    data-label-text
    class="${value ? "" : "text-italic"}"
    >${label}</span
  >`;
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<label
      class="text-normal d-inline-flex ${description ? "flex-items-start" : "flex-items-center"} gap-1${value === "" ? " d-print-none" : ""}"
      for="${inputId}"
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("hidden", hidden)}
    >
      <input
        id="${inputId}"
        class="flex-shrink-0${description ? " mt-1" : ""}"
        type="${type}"
        name="${name}"
        value="${value}"
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("checked", checked)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("exclusive", exclusive)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("required", required)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
        ${(0, $904f4b114d3dc756$export$65c20e333206336e)("autofocus", autofocus)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("aria-describedby", describedBy)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("form", form)}
        ${(0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("data-action", action)}
        ${attrs}
      />
      ${description ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="d-flex flex-column">
            ${labelContent}
            <span class="color-fg-muted f6">${description}</span>
          </span>` : labelContent}</label
    >${selectedContent ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div class="ml-3 display-if-preceding-checked">
          ${selectedContent}
        </div>` : null}`;
}






var $eb47756f72462014$exports = {};

let $eb47756f72462014$var$url = new URL("pdf-worker.4b349d18.js", import.meta.url);
$eb47756f72462014$exports = $65619179e53f57ac$exports($eb47756f72462014$var$url.toString(), $eb47756f72462014$var$url.origin, true);


async function $783a537f548d6757$export$41acd41aa74798f6(instruction) {
    const worker = new Worker($eb47756f72462014$exports);
    await new Promise((resolve)=>worker.addEventListener("message", resolve, {
            once: true
        }));
    worker.postMessage(instruction);
    const event = await new Promise((resolve)=>worker.addEventListener("message", resolve, {
            once: true
        }));
    worker.terminate();
    if (event.data.type === "pdf-error") throw new Error("Error merging PDFs.");
    return event.data.data;
}


var $d5730b9a00a10dc5$exports = {};

let $d5730b9a00a10dc5$var$url = new URL("zip-worker.314c642f.js", import.meta.url);
$d5730b9a00a10dc5$exports = $65619179e53f57ac$exports($d5730b9a00a10dc5$var$url.toString(), $d5730b9a00a10dc5$var$url.origin, true);


async function $57a02fda2a235c50$export$45dd46e8f031b200(files, comment) {
    const worker = new Worker($d5730b9a00a10dc5$exports);
    await new Promise((resolve)=>worker.addEventListener("message", resolve, {
            once: true
        }));
    const zippable = files.reduce((acc, { filename: filename, data: data })=>{
        acc[filename] = data;
        return acc;
    }, {});
    worker.postMessage({
        files: zippable,
        comment: comment
    });
    const event = await new Promise((resolve)=>worker.addEventListener("message", resolve, {
            once: true
        }));
    worker.terminate();
    if (event.data.type === "zip-error") throw new Error("Error creating ZIPs.");
    return event.data.data;
}




var $13cce1ccdabe5ca9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $13cce1ccdabe5ca9$export$58f6b614176a5046 = class PdfTemplateListElement extends HTMLElement {
    async fileAttachmentAccepted(event) {
        const uploadHref = this.getAttribute("upload-href");
        if (!uploadHref) throw new Error("Missing upload href");
        const uploadUrl = new URL(uploadHref, location.origin);
        const locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
        const attachments = event.detail.attachments;
        try {
            this.fileInput.disabled = true;
            this.fileInput.labels?.forEach((label)=>label.classList.add("btn-busy"));
            await (0, $49d75368cd6df2b4$export$14d3a7d22f26659e)({
                locale: locale,
                attachments: attachments,
                uploadUrl: uploadUrl,
                attachmentSaved: ({ id: id })=>{
                    location.href = `${location.origin}${location.pathname}/${(0, $a5db82e8fe4c003a$export$7077a352e654daea)(id)}`;
                }
            });
        } finally{
            this.fileInput.disabled = false;
            this.fileInput.labels?.forEach((label)=>label.classList.remove("btn-busy"));
        }
    }
};
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$58f6b614176a5046.prototype, "fileInput", void 0);
$13cce1ccdabe5ca9$export$58f6b614176a5046 = $13cce1ccdabe5ca9$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("pdf-template-list")
], $13cce1ccdabe5ca9$export$58f6b614176a5046);
function $13cce1ccdabe5ca9$var$breakAcroFieldName(name) {
    return name.split(/\]\./g).map((x, i)=>i === 0 ? x : [
            (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`]<wbr />.${x}`
        ]).flat();
}
class $13cce1ccdabe5ca9$var$PDFViewerBase extends HTMLElement {
    constructor(){
        super(...arguments);
        this.pdfLoaded = Promise.withResolvers();
        this.handleAnnotationClick = async (event)=>{
            const target = event.target;
            if (!this.isAnnotationField(target) || !this.viewerApplication) return;
            // Make radios uncheckable.
            if (target.type === "radio" && target instanceof this.iframe.contentWindow.window.HTMLInputElement && target.checked) {
                // Click happens before the change event.
                // Wait for the change event to fire, if it does, we do not need to clear the radio because it just became checked.
                const timeout = setTimeout(()=>{
                    target.checked = false;
                    (0, $eb08f38ae8877120$export$89348ae70780cd7a)(target);
                });
                target.addEventListener("change", ()=>clearTimeout(timeout), {
                    once: true,
                    capture: true
                });
            }
            this.onAnnotationFieldClick?.(this.viewerApplication, target, event);
        };
        this.handleAnnotationFocus = async (event)=>{
            const target = event.target;
            if (!this.isAnnotationField(target) || !this.viewerApplication) return;
            this.onAnnotationFieldFocus?.(this.viewerApplication, target, event);
        };
        this.handleAnnotationChange = (event)=>{
            const target = event.target;
            if (!this.isAnnotationField(target) || !this.viewerApplication) return;
            this.onAnnotationFieldChange?.(this.viewerApplication, target, event);
        };
        this.handleKeydown = (event)=>{
            if (!(event.ctrlKey || event.metaKey) || event.shiftKey || event.altKey || event.key !== "s" || event.defaultPrevented || !this.viewerApplication) return;
            event.preventDefault();
            event.stopImmediatePropagation(); // Prevents the default save dialog from opening.
            const target = event.target;
            if (this.isAnnotationField(target)) {
                target.blur();
                target.focus();
            }
            this.onCtrlS?.(this.viewerApplication);
        };
    }
    connectedCallback() {
        this.detachedController = new AbortController();
    }
    disconnectedCallback() {
        this.detachedController?.abort();
    }
    async iframeLoaded() {
        const iframe = this.iframe;
        const viewerWindow = iframe.contentWindow;
        if (!viewerWindow) throw new Error("Expected iframe contentWindow");
        const viewerApplication = this.viewerApplication = viewerWindow.PDFViewerApplication;
        await this.viewerApplication.initializedPromise;
        if (!this.hasAttribute("restore-position")) {
            // Prevent remembering the last page viewed.
            viewerApplication.preferences.set("viewOnLoad", 1); // 1 = initial position
            viewerApplication.preferences.set("defaultZoomValue", "auto");
            viewerApplication.preferences.set("sidebarViewOnLoad", 0); // 0 = none, 1 = thumbnails, 2 = outline, 3 = attachments
            viewerApplication.preferences.set("scrollModeOnLoad", 0); // 0 = vertical scrolling
            viewerApplication.preferences.set("spreadModeOnLoad", 0); // 0 = no spreads
        }
        viewerApplication.preferences.set("enableSignatureEditor", true);
        // Prevent drop from updating the PDF document.
        viewerApplication.appConfig.mainContainer.addEventListener("drop", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            console.log("STOPPED DROP");
        }, {
            capture: true,
            signal: this.detachedController?.signal
        });
        // Remove menu item which opens another PDF file.
        // TODO: remove the whole right menu? (secondaryToolbar.toolbar).
        const openFileMenuItem = viewerApplication.appConfig.secondaryToolbar.openFileButton;
        if (openFileMenuItem?.nextElementSibling?.matches(".horizontalToolbarSeparator")) openFileMenuItem.nextElementSibling.toggleAttribute("hidden", true);
        openFileMenuItem?.toggleAttribute("hidden", true);
        // Field events
        viewerApplication.appConfig.viewerContainer.addEventListener("click", this.handleAnnotationClick, {
            signal: this.detachedController?.signal
        });
        viewerApplication.appConfig.viewerContainer.addEventListener("focus", this.handleAnnotationFocus, {
            capture: true,
            signal: this.detachedController?.signal
        });
        viewerApplication.appConfig.viewerContainer.addEventListener("change", this.handleAnnotationChange, {
            signal: this.detachedController?.signal
        });
        this.iframe.contentWindow?.window.addEventListener("keydown", this.handleKeydown, {
            capture: true,
            signal: this.detachedController?.signal
        });
        viewerApplication.eventBus.on("annotationlayerrendered", ()=>this.onAnnotationLayerRendered?.(viewerApplication), {
            signal: this.detachedController?.signal
        });
        await Promise.all([
            new Promise((resolve)=>viewerApplication.eventBus.on("documentloaded", resolve, {
                    once: true,
                    signal: this.detachedController?.signal
                }))
        ]);
        // Prevent edits to PDF from interrupting beforeunload event.
        viewerApplication.pdfDocument.annotationStorage.onSetModified = null;
        viewerApplication.pdfDocument.annotationStorage.onResetModified = null;
        viewerApplication.pdfDocument.annotationStorage.onAnnotationEditor = null;
        this.pdfLoaded.resolve(viewerApplication);
        this.onPdfLoaded?.(viewerApplication);
    }
    isAnnotationField(target) {
        return target && "matches" in target && typeof target.matches === "function" && target.matches("section[data-annotation-id] [data-element-id]:is(input, select, textarea)");
    }
}
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$var$PDFViewerBase.prototype, "iframe", void 0);
let $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1 = class PdfTemplateElement extends $13cce1ccdabe5ca9$var$PDFViewerBase {
    constructor(){
        super(...arguments);
        this.acroForm = {};
        this.fieldsById = {};
        this.fieldOutlineTimeout = 0;
        this.removeFieldOutline = ()=>{};
        this.viewerOutlineTimeout = 0;
        this.removeViewerOutline = ()=>{};
        this.fixScrollTop = (message)=>{
            if (document.documentElement.scrollTop > 0) {
                document.documentElement.scrollTop = 0;
                console.log("fixScrollTop", message);
            }
            setTimeout(this.fixScrollTop, 0, message + " + timeout");
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        // Fix nested scroll issues.
        addEventListener("click", ()=>this.fixScrollTop("click event"));
        addEventListener("focus", ()=>this.fixScrollTop("focus event"), {
            capture: true
        });
    }
    async onPdfLoaded(viewerApplication) {
        // If new, set title and end page.
        if (this.form.querySelector("form-behavior[new]")) {
            const { info: info } = await viewerApplication.pdfDocument.getMetadata();
            this.titleInput.value = this.titleInput.value || info.Title || "";
            this.endPageInput.value = viewerApplication.pdfDocument.numPages.toString();
            this.form.firstElementChild.acceptChanges();
        }
        // Set max page numbers.
        this.startPageInput.max = viewerApplication.pdfDocument.numPages.toString();
        this.endPageInput.max = viewerApplication.pdfDocument.numPages.toString();
        // Get form.
        const acroForm = await viewerApplication.pdfDocument.getFieldObjects();
        // If there are no fields, let them know, and return.
        if (!acroForm || !Object.values(acroForm).some((fields)=>fields.some((field)=>[
                    "text",
                    "checkbox",
                    "radiobutton"
                ].includes(field.type) && field.editable !== false && field.hidden !== true))) {
            this.noFieldsFlash.hidden = false;
            return;
        }
        this.acroForm = acroForm;
        this.fieldsById = Object.values(acroForm).flat().reduce((acc, field)=>{
            acc[field.id] = field;
            return acc;
        }, {});
        this.iframe.contentWindow?.document.head.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<style>
          @keyframes activeFieldOutlineFade {
            0% {
              outline: 4px solid #0969da;
            }
            99.9% {
              outline: 4px solid transparent;
            }
            100% {
              outline: unset;
            }
          }

          .active-field-outline {
            outline: 4px solid #0969da;
          }
          .active-field-outline--fade {
            animation: activeFieldOutlineFade 2s ease-out forwards;
          }
          .cumulus-mapped {
            --annotation-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(46, 160, 67, 0.15);'/></svg>");
          }
        </style>`));
        this.renderMappingFields(viewerApplication);
    }
    onCtrlS(_viewerApplication) {
        this.form.requestSubmit();
    }
    onAnnotationFieldClick(viewerApplication, target, event) {
        this.handleAnnotationFieldClickOrChange(viewerApplication, target, event);
    }
    onAnnotationFieldFocus(viewerApplication, target, event) {
        this.handleAnnotationFieldClickOrChange(viewerApplication, target, event);
    }
    async handleAnnotationFieldClickOrChange(_viewerApplication, target, _event) {
        const id = `acro-field-${target.dataset.elementId}`;
        const element = document.getElementById(id);
        clearTimeout(this.fieldOutlineTimeout);
        this.removeFieldOutline();
        await new Promise((resolve)=>setTimeout(resolve, 0));
        element.classList.add("element-changed-animation");
        this.removeFieldOutline = ()=>element.classList.remove("element-changed-animation");
        this.fieldOutlineTimeout = setTimeout(this.removeFieldOutline, 2050);
        (0, $eb08f38ae8877120$export$9657601bf1e130ee)(element);
        this.fixScrollTop("handleAnnotationClick - scrollIntoView");
    }
    onAnnotationFieldChange(viewerApplication, target, _event) {
        // sync all fields with the same name.
        const eventFieldId = target.getAttribute("data-element-id");
        const name = this.fieldsById[eventFieldId].name;
        const fields = this.acroForm[name].filter((field)=>[
                "text",
                "checkbox",
                "radiobutton"
            ].includes(field.type));
        for (const field of fields){
            const initialValue = field.value;
            const override = viewerApplication.pdfDocument.annotationStorage.getValue(field.id, {});
            // console.log(name, id, initialValue, override, field);
            const value = override?.value ?? initialValue;
            const element = document.getElementById(`acro-field-value-${field.id}`);
            element.value = typeof value === "boolean" && [
                "checkbox",
                "radiobutton"
            ].includes(field.type) ? value ? "On" : "Off" : String(value);
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(element);
            if (field.id === eventFieldId) {
                (0, $eb08f38ae8877120$export$9657601bf1e130ee)(element);
                this.fixScrollTop("handleAnnotationChange - scrollIntoView");
            }
        }
    }
    syncFieldMappedStatus(annotationInput, expressionInput) {
        const value = expressionInput.value.trim();
        annotationInput.classList.toggle("cumulus-mapped", value !== "");
        annotationInput.title = value;
    }
    async syncAcroField(event) {
        if (!this.viewerApplication) return;
        if (event.target instanceof HTMLAnchorElement) event.preventDefault();
        const viewerApplication = this.viewerApplication;
        const target = event.target;
        const id = target.getAttribute("element-id");
        const field = this.fieldsById[id];
        // render page if not already rendered
        const page = viewerApplication.pdfViewer.getPageView(field.page);
        viewerApplication.appConfig.toolbar.pageNumber.value = String(field.page + 1);
        viewerApplication.appConfig.toolbar.pageNumber.dispatchEvent(new Event("change", {
            bubbles: true
        }));
        // viewerApplication.eventBus.dispatch('pagenumberchanged', {
        //   source: self,
        //   value: field.page! + 1
        // });
        if (page.renderingState !== 3 /* PDFRenderingStates.FINISHED */ ) await Promise.all([
            new Promise((resolve)=>viewerApplication.eventBus.on("pagerendered", resolve, {
                    once: true,
                    signal: this.detachedController?.signal
                })),
            new Promise((resolve)=>viewerApplication.eventBus.on("annotationlayerrendered", resolve, {
                    once: true,
                    signal: this.detachedController?.signal
                }))
        ]);
        const element = viewerApplication.appConfig.viewerContainer.querySelector(`[data-element-id="${id}"]`);
        if (event.type === "change") this.syncFieldMappedStatus(element, target);
        else {
            // click (on anchor) or expression focus/blur
            // focus (which will scroll field into view) OR only scroll into view
            if (target instanceof HTMLAnchorElement) {
                element.focus();
                this.fixScrollTop("syncAcroField - focus");
            } else {
                (0, $eb08f38ae8877120$export$9657601bf1e130ee)(element);
                this.fixScrollTop("syncAcroField - scrollIntoView");
            }
            // remove previous outline
            clearTimeout(this.viewerOutlineTimeout);
            this.removeViewerOutline();
            this.removeViewerOutline = ()=>{};
            // outline current field
            if (event.type !== "blur") {
                await new Promise((resolve)=>setTimeout(resolve, 0));
                element.classList.add("active-field-outline");
                this.removeViewerOutline = ()=>element.classList.remove("active-field-outline", "active-field-outline--fade");
            }
            // enqueue outline removal
            if (target instanceof HTMLAnchorElement) {
                element.classList.add("active-field-outline--fade");
                this.viewerOutlineTimeout = setTimeout(this.removeViewerOutline, 2050);
            }
        }
    }
    onAnnotationLayerRendered(viewerApplication) {
        for (const { id: id } of Object.values(this.acroForm).flat().filter((x)=>[
                "text",
                "checkbox",
                "radiobutton"
            ].includes(x.type))){
            const annotationInput = viewerApplication.appConfig.viewerContainer.querySelector(`[data-element-id="${id}"]`);
            if (!annotationInput) continue;
            const expressionInput = this.form.querySelector(`textarea[element-id="${id}"]`);
            if (!expressionInput) continue;
            this.syncFieldMappedStatus(annotationInput, expressionInput);
        }
    }
    renderMappingFields(viewerApplication) {
        const dataFields = JSON.parse(this.fieldsScript.textContent);
        let templates = [];
        for (const name of this.getNamesInPositionOrder()){
            const fields = this.acroForm[name].filter((field)=>[
                    "text",
                    "checkbox",
                    "radiobutton"
                ].includes(field.type));
            for (const field of fields){
                const index = templates.length;
                const dataField = dataFields.find((dataField)=>dataField.name === field.name && dataField.export_values === field.exportValues);
                if (dataField && dataField.value !== field.value) viewerApplication.pdfDocument.annotationStorage.setValue(field.id, {
                    value: dataField.value
                });
                templates.push((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<section
            id="acro-field-${field.id}"
            class="rounded-1 p-3 mt-n3 ml-n3 mb-n3 mr-n3"
          >
            <h3 class="f4 mb-2">
              ${field.editable === false || field.hidden === true ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`${$13cce1ccdabe5ca9$var$breakAcroFieldName(field.name)}
                  ${field.type === "radiobutton" && field.exportValues ? `/ ${field.exportValues}` : null}` : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<a
                    class="Link--primary"
                    href="#"
                    tabindex="-1"
                    element-id="${field.id}"
                    data-action="click:pdf-template#syncAcroField"
                    >${$13cce1ccdabe5ca9$var$breakAcroFieldName(field.name)}${field.type === "radiobutton" && field.exportValues ? ` / ${field.exportValues}` : null}</a
                  >`}
              <span class="Label Label--primary text-capitalize"
                >${field.type}</span
              >
              ${field.type === "text" && field.charLimit ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Label">${field.charLimit} characters</span>` : null}
              ${field.type === "text" && field.multiline ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Label">Multiline</span>` : null}
              ${field.editable === false ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Label Label--attention">Read only</span>` : null}
              ${field.hidden === true ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span class="Label Label--attention">Hidden</span>` : null}
            </h3>
            ${(0, $7c0cd8cd96487c75$export$bdc7259586f8f739)({
                    type: "textarea",
                    label: "Mapping",
                    value: dataField?.expression ? (0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(dataField.expression.ast) : "",
                    maxLength: 3000,
                    disabled: this.titleInput.disabled,
                    spellcheck: false,
                    rows: 2,
                    name: `mapping/fields/${index}/expression:nullstring`,
                    inputAttrs: [
                        (0, $904f4b114d3dc756$export$7aabe8b3a840d2fd)("element-id", field.id)
                    ],
                    action: "focus:pdf-template#syncAcroField blur:pdf-template#syncAcroField change:pdf-template#syncAcroField",
                    classes: "position-relative",
                    headerClasses: "sr-only"
                })}
            <details class="details-reset">
              <summary class="note" tabindex="-1">Details</summary>
              <div class="d-flex flex-column gap-3 mt-2 ml-3">
                ${(0, $7c0cd8cd96487c75$export$bdc7259586f8f739)({
                    type: field.multiline === true ? "textarea" : "text",
                    label: "Value",
                    value: dataField ? dataField.value : field.value,
                    maxLength: field.type === "text" && field.charLimit ? field.charLimit : 300,
                    name: `mapping/fields/${index}/value`,
                    disabled: true,
                    id: `acro-field-value-${field.id}`
                })}
                <pre><code class="p-3 f6 overflow-auto">${JSON.stringify(field, null, 2)}</code></pre>
              </div>
            </details>
            <input
              type="hidden"
              name="mapping/fields/${index}/name"
              value="${field.name}"
            />
            <input
              type="hidden"
              name="mapping/fields/${index}/type"
              value="${field.type}"
            />
            <input
              type="hidden"
              name="mapping/fields/${index}/id"
              value="${field.id}"
            />
            <input
              type="hidden"
              name="mapping/fields/${index}/page:integer"
              value="${field.page}"
            />
            ${field.editable === undefined ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
                  type="hidden"
                  name="mapping/fields/${index}/editable:boolean"
                  value="${field.editable}"
                />`}
            ${field.hidden === undefined ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
                  type="hidden"
                  name="mapping/fields/${index}/hidden:boolean"
                  value="${field.hidden}"
                />`}
            ${field.multiline === undefined ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
                  type="hidden"
                  name="mapping/fields/${index}/multiline:boolean"
                  value="${field.multiline}"
                />`}
            ${field.charLimit === undefined ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
                  type="hidden"
                  name="mapping/fields/${index}/charlimit:integer"
                  value="${field.charLimit}"
                />`}
            ${field.exportValues === undefined ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
                  type="hidden"
                  name="mapping/fields/${index}/export_values"
                  value="${field.exportValues}"
                />`}
            ${field.defaultValue === undefined ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
                  type="hidden"
                  name="mapping/fields/${index}/default_value"
                  value="${field.defaultValue}"
                />`}
          </section>`);
            }
        }
        this.form.insertAdjacentHTML("beforeend", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(templates));
        this.form.firstElementChild.acceptChanges();
    }
    getNamesInPositionOrder() {
        return Object.values(this.acroForm).flat().filter((widget)=>[
                "text",
                "checkbox",
                "radiobutton"
            ].includes(widget.type)).map((widget)=>({
                page: widget.page ?? 1000,
                name: widget.name,
                rect: widget.rect ?? [
                    0,
                    0
                ] // fallback if rect is missing
            })).sort((a, b)=>{
            // sort by page ascending, then Y descending (top to bottom), then X ascending (left to right)
            const dp = a.page - b.page;
            const dy = b.rect[1] - a.rect[1];
            return dp !== 0 ? dp : dy !== 0 ? dy : a.rect[0] - b.rect[0];
        }).map((widget)=>widget.name).filter((x, i, a)=>a.indexOf(x) === i); // remove duplicates
    }
};
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1.prototype, "form", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1.prototype, "titleInput", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1.prototype, "startPageInput", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1.prototype, "endPageInput", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1.prototype, "noFieldsFlash", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1.prototype, "fieldsScript", void 0);
$13cce1ccdabe5ca9$export$44e254a6b1fb3cc1 = $13cce1ccdabe5ca9$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("pdf-template")
], $13cce1ccdabe5ca9$export$44e254a6b1fb3cc1);
let $13cce1ccdabe5ca9$export$b64fa31f87d70dc7 = class SelectPdfTemplatesElement extends HTMLElement {
    selectTemplates(event) {
        const target = event.target;
        const selectAll = target.dataset.select === "all";
        const checkboxes = this.form.elements.namedItem("template");
        for (const checkbox of checkboxes){
            if (!(checkbox instanceof HTMLInputElement)) throw new Error("Expected HTMLInputElement");
            checkbox.checked = selectAll && !checkbox.disabled;
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(checkbox);
        }
    }
    filterTemplates(event) {
        const target = event.target;
        const label = target.dataset.filterLabel.toLowerCase();
        target.parentElement?.querySelectorAll("[aria-current]").forEach((el)=>{
            el.removeAttribute("aria-current");
        });
        target.setAttribute("aria-current", "true");
        const checkboxes = this.form.elements.namedItem("template");
        for (const checkbox of checkboxes){
            if (!(checkbox instanceof HTMLInputElement)) throw new Error("Expected HTMLInputElement");
            const visible = label === "all" || checkbox.dataset.labels?.toLowerCase().split(",").includes(label);
            if (!visible && checkbox.checked) {
                checkbox.checked = false;
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(checkbox);
            }
            checkbox.closest("label")?.toggleAttribute("hidden", !visible);
        }
    }
};
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$b64fa31f87d70dc7.prototype, "form", void 0);
$13cce1ccdabe5ca9$export$b64fa31f87d70dc7 = $13cce1ccdabe5ca9$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("select-pdf-templates")
], $13cce1ccdabe5ca9$export$b64fa31f87d70dc7);
let $13cce1ccdabe5ca9$export$9bf81fc16d2d903d = class PdfViewerElement extends $13cce1ccdabe5ca9$var$PDFViewerBase {
    constructor(){
        super(...arguments);
        this.preparedPromise = Promise.withResolvers();
    }
    onAnnotationFieldChange() {
        this.dispatchEvent(new Event("pdf-viewer-field-changed", {
            bubbles: true
        }));
    }
    async onPdfLoaded(viewerApplication) {
        const values = JSON.parse(this.valuesScript.textContent);
        const acroForm = await viewerApplication.pdfDocument.getFieldObjects();
        if (!acroForm) {
            console.warn("No acroForm found");
            this.preparedPromise.resolve(viewerApplication);
            return;
        }
        const fields = Object.values(acroForm).flat();
        for (const { name: name, export_values: export_values, value: value } of values){
            const field = fields.find((field)=>field.name === name && field.exportValues === export_values);
            if (!field) {
                console.warn(`Field ${name} with export value ${export_values} not found`);
                continue;
            }
            if (field.value === value) continue;
            viewerApplication.pdfDocument.annotationStorage.setValue(field.id, {
                value: value
            });
        }
        this.preparedPromise.resolve(viewerApplication);
    }
    async save() {
        // https://github.com/mozilla/pdf.js/blob/2e10ff6dd4a875b63743b4a764e7375f1bb94e1d/web/app.js#L1174
        // https://github.com/mozilla/pdf.js/blob/master/web/download_manager.js#L27
        const viewerApplication = await this.preparedPromise.promise;
        const downloadManager = viewerApplication.downloadManager;
        let data;
        viewerApplication.downloadManager = {
            download (d) {
                data = d;
            }
        };
        try {
            await viewerApplication.downloadOrSave();
        } finally{
            viewerApplication.downloadManager = downloadManager;
        }
        return Uint8Array.from(data);
    }
};
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$9bf81fc16d2d903d.prototype, "valuesScript", void 0);
$13cce1ccdabe5ca9$export$9bf81fc16d2d903d = $13cce1ccdabe5ca9$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("pdf-viewer")
], $13cce1ccdabe5ca9$export$9bf81fc16d2d903d);
let $13cce1ccdabe5ca9$export$8820d0a37b88b23d = class PreparePdfDocumentsElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.current = 0;
        this.hasChanges = false;
        this.isSubmitting = false;
    }
    selectTemplate(event) {
        const index = +event.target.value;
        if (index === this.current) return;
        this.viewerElements[this.current].classList.add("v-hidden");
        this.instructionElements[this.current].hidden = true;
        this.current = index;
        this.viewerElements[this.current].classList.remove("v-hidden");
        this.instructionElements[this.current].hidden = false;
    }
    // showPrevious() {
    //   this.viewerElements[this.current].classList.add('v-hidden');
    //   this.instructionElements[this.current].hidden = true;
    //   this.current--;
    //   this.viewerElements[this.current].classList.remove('v-hidden');
    //   this.instructionElements[this.current].hidden = false;
    //   this.previousButton.disabled = this.current === 0;
    //   this.nextButton.disabled = this.current === this.viewerElements.length - 1;
    // }
    // showNext() {
    //   this.viewerElements[this.current].classList.add('v-hidden');
    //   this.instructionElements[this.current].hidden = true;
    //   this.current++;
    //   this.viewerElements[this.current].classList.remove('v-hidden');
    //   this.instructionElements[this.current].hidden = false;
    //   this.previousButton.disabled = this.current === 0;
    //   this.nextButton.disabled = this.current === this.viewerElements.length - 1;
    // }
    async download(event) {
        event.preventDefault();
        if (this.isSubmitting) return;
        try {
            this.isSubmitting = true;
            const pdfTemplates = JSON.parse(this.templatesScript.textContent);
            await Promise.resolve();
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(this.downloadForm, true);
            let { filename: filename, type: downloadType } = Object.fromEntries(event.detail);
            const pdfs = await Promise.all(this.viewerElements.map((el)=>el.save()));
            let url;
            if (downloadType === "zip") {
                if (!/\.zip$/i.test(filename)) filename += ".zip";
                const data = await (0, $57a02fda2a235c50$export$45dd46e8f031b200)(pdfs.map((data, i)=>({
                        filename: (0, $de5ef9373ca12f93$export$fa302515f2a866ab)(pdfTemplates[i].title + ".pdf"),
                        data: data
                    })), "Created by " + this.getAttribute("user_name") + " at " + this.getAttribute("organization_name"));
                url = URL.createObjectURL(new Blob([
                    data
                ], {
                    type: "application/zip"
                }));
            } else {
                if (!/\.pdf$/i.test(filename)) filename += ".pdf";
                const data = await (0, $783a537f548d6757$export$41acd41aa74798f6)({
                    title: filename,
                    author: this.getAttribute("user_name") + " at " + this.getAttribute("organization_name"),
                    pdfs: pdfs.map((data, i)=>({
                            title: pdfTemplates[i].title,
                            data: data,
                            start_page: pdfTemplates[i].start_page,
                            end_page: pdfTemplates[i].end_page
                        }))
                });
                url = URL.createObjectURL(new Blob([
                    data
                ], {
                    type: "application/pdf"
                }));
            }
            console.log(filename);
            $13cce1ccdabe5ca9$var$download(url, (0, $de5ef9373ca12f93$export$fa302515f2a866ab)(filename));
        } finally{
            (0, $1523f11a9aa97b8a$export$7f9cba67632f8265)(this.downloadForm, false);
            this.isSubmitting = false;
        }
    }
    pdfFieldChanged() {
        if (this.hasChanges) return;
        this.hasChanges = true;
        window.addEventListener("beforeunload", (event)=>{
            event.preventDefault();
            event.returnValue = "You have unsaved work."; // browser overrides this text
        });
    }
};
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $13cce1ccdabe5ca9$export$8820d0a37b88b23d.prototype, "viewerElements", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $13cce1ccdabe5ca9$export$8820d0a37b88b23d.prototype, "instructionElements", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$8820d0a37b88b23d.prototype, "nextButton", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$8820d0a37b88b23d.prototype, "previousButton", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$8820d0a37b88b23d.prototype, "downloadForm", void 0);
$13cce1ccdabe5ca9$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $13cce1ccdabe5ca9$export$8820d0a37b88b23d.prototype, "templatesScript", void 0);
$13cce1ccdabe5ca9$export$8820d0a37b88b23d = $13cce1ccdabe5ca9$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("prepare-pdf-documents")
], $13cce1ccdabe5ca9$export$8820d0a37b88b23d);
function $13cce1ccdabe5ca9$var$download(blobUrl, filename) {
    const a = document.createElement("a");
    if (!a.click) throw new Error('DownloadManager: "a.click()" is not supported.');
    a.href = blobUrl;
    a.target = "_parent";
    // Use a.download if available. This increases the likelihood that
    // the file is downloaded instead of opened by another PDF plugin.
    if ("download" in a) a.download = filename;
    // <a> must be in the document for recent Firefox versions,
    // otherwise .click() is ignored.
    (document.body || document.documentElement).append(a);
    a.click();
    a.remove();
} /*
Issues:
- https://github.com/mozilla/pdf.js/issues/19837

template list
- feature flag

template detail
- feature flag

activity ui
- feature flag
- download zip
- auto-reload
*/ 






var $776affef6c656a9e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $776affef6c656a9e$export$5ebdec4bfbe94776 = class PersonMatchesElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.refreshTimeout = 0;
        this.refresh = async ()=>{
            const body = (0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(this.form);
            const currentFingerprint = $776affef6c656a9e$var$getFingerprint(body);
            if (this.lastFingerprint === currentFingerprint) return;
            const result = await (0, $f3a2ac2d620bcd8b$export$ed692cabb252e59b)(this.form, false);
            if (!result.valid) return;
            this.lastFingerprint = currentFingerprint;
            const url = new URL(this.getAttribute("src"), location.origin);
            const response = await fetch(url, {
                method: "POST",
                body: body
            });
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const html = await response.text();
            const template = document.createElement("template");
            template.innerHTML = html;
            this.replaceWith(template.content);
        };
        this.scheduleRefresh = ()=>{
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = setTimeout(this.refresh, 300);
        };
    }
    get form() {
        return this.closest("form");
    }
    connectedCallback() {
        const form = this.form;
        if (!form) return;
        this.lastFingerprint = $776affef6c656a9e$var$getFingerprint((0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(form));
        this.disconnectController?.abort();
        this.disconnectController = new AbortController();
        form.addEventListener("change", this.scheduleRefresh, {
            signal: this.disconnectController.signal
        });
        form.addEventListener("editable-list-change", this.scheduleRefresh, {
            signal: this.disconnectController.signal
        });
    }
    disconnectedCallback() {
        this.disconnectController?.abort();
    }
};
$776affef6c656a9e$export$5ebdec4bfbe94776 = $776affef6c656a9e$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("person-matches")
], $776affef6c656a9e$export$5ebdec4bfbe94776);
function $776affef6c656a9e$var$getFingerprint(formData) {
    const { first_name: first_name, last_name: last_name, dob: dob, ssn: ssn, medicaid_id: medicaid_id, veteran_id: veteran_id, agingis_id: agingis_id, scsep_participant_id: scsep_participant_id, external_id: external_id, emails: emails, phones: phones } = (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)(formData);
    return [
        first_name,
        last_name,
        dob,
        ssn,
        medicaid_id,
        veteran_id,
        agingis_id,
        scsep_participant_id,
        external_id,
        ...emails.map((e)=>e.email),
        ...phones.map((p)=>p.number)
    ].join("/");
}





var $07114f3af7a5be61$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $07114f3af7a5be61$var$ReportColumnElement = class ReportColumnElement extends HTMLElement {
    // When the property, aggregate function, or expression type changed, update the grouping/summarization select options
    updateSummarizationOptions() {
        const propertyInput = this.propertyFormGroup?.querySelector("[data-property]");
        const property = propertyInput ? JSON.parse(propertyInput.getAttribute("data-property")) : null;
        const column = {
            type: this.typeInput.value,
            aggregate: this.aggregateSelect?.value
        };
        const groupingOptions = (0, $d175770e6e5170f5$export$3cb1b09c699eed1)(column, property, this.expressionInput?.expressionType ?? null);
        const options = (0, $7c0cd8cd96487c75$export$d3199b8dddc55be)(groupingOptions.map((g)=>({
                text: g === "none" ? "None" : g === "group" ? "Group" : (0, $d175770e6e5170f5$export$78c94180fed6d79f)[g],
                value: g,
                group: [
                    "none",
                    "group"
                ].includes(g) ? undefined : "Summarization functions"
            })), groupingOptions.includes(this.groupingSelect.value) ? this.groupingSelect.value : "none");
        this.groupingSelect.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(options);
    }
};
$07114f3af7a5be61$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $07114f3af7a5be61$var$ReportColumnElement.prototype, "typeInput", void 0);
$07114f3af7a5be61$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $07114f3af7a5be61$var$ReportColumnElement.prototype, "propertyFormGroup", void 0);
$07114f3af7a5be61$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $07114f3af7a5be61$var$ReportColumnElement.prototype, "groupingSelect", void 0);
$07114f3af7a5be61$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $07114f3af7a5be61$var$ReportColumnElement.prototype, "aggregateSelect", void 0);
$07114f3af7a5be61$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $07114f3af7a5be61$var$ReportColumnElement.prototype, "expressionInput", void 0);
$07114f3af7a5be61$var$ReportColumnElement = $07114f3af7a5be61$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("report-column")
], $07114f3af7a5be61$var$ReportColumnElement);










var $dee7bcbf16f54289$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dee7bcbf16f54289$var$ReportConfigurationElement = class ReportConfigurationElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.previewTimeout = 0;
        this.previewController = undefined;
    }
    connectedCallback() {
        if (this.previewContainer) this.preview();
        this.addEventListener("details-menu-selected", this, true);
    }
    disconnectedCallback() {
        this.removeEventListener("details-menu-selected", this, true);
    }
    handleEvent(event) {
        switch(event.type){
            case "details-menu-selected":
                this.enqueuePreview(event);
                if (event.target instanceof Element && event.target.querySelector('[name^="is_shared:"],[name^="project_id"]')) this.handleSharedWithChanged(!!event.target.querySelector('[name^="is_shared:"]'));
                break;
        }
    }
    get type() {
        return this.getAttribute("entity-type");
    }
    get organization_id() {
        return this.getAttribute("organization-id");
    }
    get previewStatusContainer() {
        return document.getElementById(this.getAttribute("preview-status"));
    }
    validateConfiguration() {
        return (0, $f3a2ac2d620bcd8b$export$ed692cabb252e59b)(this.form, true, this);
    }
    setLoadingPreview() {
        this.previewContainer.innerHTML = `<h2 class="p-3"><span>Loading</span><span class="AnimatedEllipsis"></span></h2>`;
        this.previewStatusContainer.innerHTML = `<span class="AnimatedEllipsis"></span>`;
        this.querySelectorAll("output[report-parameter-value-output]").forEach((el)=>el.innerHTML = `<span>Loading</span><span class="AnimatedEllipsis"></span>`);
    }
    setPreviewValidationError() {
        this.previewContainer.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
      <h2 class="p-3">Validation error</h2>
    `);
        this.previewStatusContainer.textContent = "0";
        this.querySelectorAll("output[report-parameter-value-output]").forEach((el)=>el.innerHTML = "");
    }
    setPreviewServerError(sessionExpired) {
        this.previewContainer.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
      <h2 class="p-3">
        ${sessionExpired ? "Session expired" : "Error loading report preview."}
      </h2>
    `);
        this.previewStatusContainer.textContent = "0";
        this.querySelectorAll("output[report-parameter-value-output]").forEach((el)=>el.innerHTML = "");
    }
    setPreviewResults(fragment) {
        this.previewContainer.innerHTML = fragment;
        const parameter_values = this.previewContainer.querySelector("dashboard-controller[parameter_values]")?.getAttribute("parameter_values");
        if (parameter_values) {
            this.previewStatusContainer.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$1d8a03084661a191), "color-fg-success"));
            this.previewParameterValues(JSON.parse(parameter_values));
        }
    }
    onReportGridRowsLoaded(event) {
        if (event.target instanceof Element && event.target.closest("dashboard-controller")) // ignore events originating from a dashboard grid.
        return;
        const { count: count, parameter_values: parameter_values } = event.detail;
        this.previewStatusContainer.textContent = (0, $834ded10eeb0a740$export$688d13a530c5dcbc).format(count);
        this.previewParameterValues(parameter_values);
    }
    previewParameterValues(parameter_values) {
        this.querySelectorAll("output[report-parameter-value-output]").forEach((el)=>{
            el.innerHTML = "";
            const li = el.closest("li");
            const name = li?.querySelector('input[name$="/name"]')?.value;
            if (name && name in parameter_values) el.innerHTML = parameter_values[name]?.toString() ?? "NULL";
        });
    }
    enqueuePreview(event) {
        if (event.target instanceof Element && event.target.closest("form") !== this.form) return;
        clearTimeout(this.previewTimeout);
        this.previewTimeout = setTimeout(()=>this.preview(), 300);
    }
    async preview() {
        clearTimeout(this.previewTimeout);
        const { valid: valid } = await (0, $f3a2ac2d620bcd8b$export$ed692cabb252e59b)(this.form, false, this.previewFields);
        if (!valid) return;
        if (this.previewController) this.previewController.abort("superseded");
        this.setLoadingPreview();
        const data = (0, $1523f11a9aa97b8a$export$2d71e4ce1d783c30)(this.form);
        data.set("title", "Preview");
        const body = new URLSearchParams(data);
        this.previewController = new AbortController();
        const response = await fetch(`/api/organizations/${this.organization_id}/reports/preview`, {
            method: "POST",
            body: body,
            signal: this.previewController.signal
        });
        this.previewController = undefined;
        if (response.ok) {
            const fragment = await response.text();
            this.setPreviewResults(fragment);
        } else if (response.status === 400) this.setPreviewValidationError();
        else this.setPreviewServerError((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response));
    }
    columnSortChanged(event) {
        const target = event.target;
        for (const select of this.columnSortSelects)if (select !== target && select.value[0] >= (target.value[0] ?? "0") && select.value !== "") select.value = "";
        $dee7bcbf16f54289$var$updateColumnSortOptions(target, this.columnSortSelects);
    }
    columnSortFocused(event) {
        const target = event.target;
        $dee7bcbf16f54289$var$updateColumnSortOptions(target, this.columnSortSelects);
    }
    handleExpressionScopeRequest(event) {
        event.preventDefault();
        const { definition: { parameters: parameters }, properties: properties } = (0, $cb12e05ecb76e37d$export$acd79bbf6f49afea)(this.form);
        for (const parameter of parameters){
            if (!(0, $d175770e6e5170f5$export$99da40ee05a17718).test(parameter.name)) continue;
            const result = (0, $85b8830740b7c142$export$ce555e23b0c0b6f2)({
                parameter: parameter,
                properties: properties,
                parseExpression: (expression)=>(0, $d0aca128151552ea$export$9692209d71b8f134)({
                        name: parameter.name,
                        expression: expression,
                        getDefinitionInfo: ()=>({
                                columns: [],
                                parameters: parameters,
                                properties: properties
                            })
                    })
            });
            if (result.valid) event.detail.identifiers[parameter.name] = result.type;
        }
    }
    async handleSharedWithChanged(is_shared_changed) {
        await new Promise((resolve)=>setTimeout(resolve)); // wait for value to commit.
        const projectIdInput = this.querySelector('[name="project_id"]:checked');
        if (!(projectIdInput instanceof HTMLInputElement)) throw new Error("Expected project_id input element");
        const isSharedInput = this.querySelector('[name^="is_shared:"]:checked');
        if (!(isSharedInput instanceof HTMLInputElement)) throw new Error("Expected is_shared input element");
        const is_shared = +isSharedInput.value;
        this.sharesFormGroup.hidden = is_shared !== (0, $d175770e6e5170f5$export$fbac3d2f26b21a45).SpecificOrganizations && is_shared !== (0, $d175770e6e5170f5$export$fbac3d2f26b21a45).SpecificUsers;
        const box = this.sharesFormGroup.querySelector("autocomplete-list-box");
        if (!box) throw new Error("Expected autocomplete-list-box element");
        if (is_shared_changed) box.clear();
        if (!this.sharesFormGroup.hidden) {
            this.sharesFormGroup.querySelector(".form-label").textContent = `Shared with ${is_shared === (0, $d175770e6e5170f5$export$fbac3d2f26b21a45).SpecificOrganizations ? "organizations" : "users"}`;
            const [path] = box.autocomplete.src.split("?");
            box.autocomplete.src = `${path}?with=${is_shared}${projectIdInput.value ? `&project_id=${projectIdInput.value}` : ""}`;
        }
    }
};
$dee7bcbf16f54289$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dee7bcbf16f54289$var$ReportConfigurationElement.prototype, "form", void 0);
$dee7bcbf16f54289$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dee7bcbf16f54289$var$ReportConfigurationElement.prototype, "previewFields", void 0);
$dee7bcbf16f54289$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dee7bcbf16f54289$var$ReportConfigurationElement.prototype, "previewContainer", void 0);
$dee7bcbf16f54289$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $dee7bcbf16f54289$var$ReportConfigurationElement.prototype, "columnSortSelects", void 0);
$dee7bcbf16f54289$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dee7bcbf16f54289$var$ReportConfigurationElement.prototype, "sharesFormGroup", void 0);
$dee7bcbf16f54289$var$ReportConfigurationElement = $dee7bcbf16f54289$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("report-configuration")
], $dee7bcbf16f54289$var$ReportConfigurationElement);
function $dee7bcbf16f54289$var$updateColumnSortOptions(target, selects) {
    const max = Math.max(...selects.map((x)=>+(x.value[0] ?? "-1"))) + (target.value ? 1 : 2);
    for (const option of target.options)option.disabled = option.value > max.toString();
}






class $e53d9d0f6f0b2945$export$1f6a6ab45fe37b4d extends HTMLElement {
    constructor(){
        super(...arguments);
        this.editableList = null;
        this.timeout = 0;
        this.processChange = ()=>{
            if (this.input.value.trim() === "") {
                // this.note.innerHTML = render(expressionHelpText);
                this.expressionType = null;
                return;
            }
            const result = $e53d9d0f6f0b2945$var$parseAndValidate(this.input);
            if (!result.valid) {
                setTimeout(()=>{
                    (0, $f3a2ac2d620bcd8b$export$e0ddcd48746f2dd9)(this.input, result.reason);
                    this.closest(".form-group")?.classList.add("errored");
                });
                this.expressionType = null;
                return;
            }
            const formatted = (0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(result.originalNode);
            if (this.input.value !== formatted) {
                this.input.value = formatted;
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.input);
            }
            this.expressionType = result.type;
        };
    }
    connectedCallback() {
        this.addEventListener("change", this);
        this.addEventListener("blur", this);
        this.addEventListener("keydown", this);
        this.editableList = this.closest("editable-list");
        this.editableList?.addEventListener("change", this);
        this.editableList?.addEventListener("details-menu-selected", this, {
            capture: true
        });
        this.editableList?.addEventListener("editable-list-change", this);
    }
    disconnectedCallback() {
        this.removeEventListener("change", this);
        this.removeEventListener("blur", this);
        this.removeEventListener("keydown", this);
        this.editableList?.removeEventListener("change", this);
        this.editableList?.removeEventListener("details-menu-selected", this, {
            capture: true
        });
        this.editableList?.removeEventListener("editable-list-change", this);
    }
    get input() {
        return this.querySelector("input");
    }
    // get note() {
    //   return this.closest('.form-group')!.querySelector('.note:not(.error)')!;
    // }
    get expressionType() {
        return this.getAttribute("expression-type");
    }
    set expressionType(value) {
        if (value === null) this.removeAttribute("expression-type");
        else this.setAttribute("expression-type", value);
        this.dispatchEvent(new CustomEvent("report-expression-changed"));
    }
    handleEvent(event) {
        if (event.type === "editable-list-change") {
            if (event.target !== this.editableList) return;
            const indexes = event.detail.indexes;
            const node = (0, $d0aca128151552ea$export$49e0f493cc4d655f)(this.input.value, indexes);
            if (node) {
                clearTimeout(this.timeout);
                this.input.value = (0, $b78ece0e2b37257d$export$8fc0a65b8428632a)(node);
                this.processChange();
                (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.input);
            }
        } else if (event.target === this.input) {
            if (event instanceof KeyboardEvent) {
                if (event.key === "Enter") event.preventDefault();
                else return;
            }
            if (event.isTrusted) {
                clearTimeout(this.timeout);
                this.processChange();
            }
        } else {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.processChange, 300);
        }
    }
}
if (!window.customElements.get("report-expression-input")) {
    window.ReportExpressionInputElement = $e53d9d0f6f0b2945$export$1f6a6ab45fe37b4d;
    window.customElements.define("report-expression-input", $e53d9d0f6f0b2945$export$1f6a6ab45fe37b4d);
}
function $e53d9d0f6f0b2945$var$parseAndValidate(input) {
    let name;
    if (input.name.includes("/parameters/")) {
        const raw = input.closest("li")?.querySelector('input[name$="/name"]')?.value?.toUpperCase();
        if (raw && (0, $d175770e6e5170f5$export$99da40ee05a17718).test(raw)) name = raw;
        else name = `$PARAMETER_${parseInt(input.name.split("/")[2])}`;
    } else if (input.name.includes("/columns/")) name = (0, $d0aca128151552ea$export$672971f1d929056c)(parseInt(input.name.split("/")[2]));
    else return {
        valid: false,
        reason: "Unable to locate name associated with formula."
    };
    return (0, $d0aca128151552ea$export$9692209d71b8f134)({
        name: name,
        expression: input.value,
        getDefinitionInfo: ()=>{
            const { definition: { columns: columns, parameters: parameters }, properties: properties } = (0, $cb12e05ecb76e37d$export$acd79bbf6f49afea)(input.form);
            return {
                columns: columns,
                parameters: parameters,
                properties: properties
            };
        }
    });
}
(0, $f3a2ac2d620bcd8b$export$86f1725708ac86dc)((input)=>{
    if (input instanceof HTMLInputElement && input.type === "text" && input.value.length && input.parentElement instanceof $e53d9d0f6f0b2945$export$1f6a6ab45fe37b4d) {
        const result = $e53d9d0f6f0b2945$var$parseAndValidate(input);
        if (!result.valid) return result.reason;
    }
    return null;
});








function $f63a8d12a0a33aa0$var$booleanFilterValueTemplate(value, choices, name, controlId, disabled) {
    choices = choices || [
        {
            choice_id: 0,
            exclusive: 0,
            label: "No"
        },
        {
            choice_id: 1,
            exclusive: 0,
            label: "Yes"
        }
    ];
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
    <select
      id="${controlId}"
      class="form-select select-sm"
      name="${name}:boolean"
      aria-label="Value"
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
    >
      ${choices.map((c)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
          <option
            value="${Boolean(c.choice_id)}"
            ${(0, $904f4b114d3dc756$export$65c20e333206336e)("selected", value === Boolean(c.choice_id))}
          >
            ${c.label}
          </option>
        `)}
    </select>
  `;
}
function $f63a8d12a0a33aa0$var$dateFilterValueTemplate(value, name, controlId, disabled) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`
    <date-input class="d-flex position-relative" relative parametric>
      ${(0, $456252ed2e235022$export$8e2ee32c32a0ef22)({
        name: `${name}:date:relative:parametric`,
        required: true,
        ariaLabel: "Value",
        value: value,
        small: true,
        id: controlId,
        disabled: disabled
    })}
    </date-input>
  `;
}
function $f63a8d12a0a33aa0$var$stringFilterValueTemplate(value, name, controlId, disabled) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
    id="${controlId}"
    type="text"
    name="${name}"
    class="form-control input-sm"
    aria-label="Value"
    value="${value}"
    maxlength="100"
    required
    autocomplete="none"
    autocorrect="off"
    autocapitalize="on"
    spellcheck="false"
    ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
  />`;
}
function $f63a8d12a0a33aa0$var$numberFilterValueTemplate(value, type, name, controlId, disabled) {
    const listId = (0, $5cb959b633531006$export$9e1c824dbb29e809)();
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<number-input
    minimum-fraction-digits="${type === "currency" ? 2 : 0}"
    maximum-fraction-digits="${type === "int" ? 0 : 2}"
    parametric
    ><input
      id="${controlId}"
      type="text"
      name="${name}:integer:parametric"
      class="form-control input-sm"
      aria-label="Value"
      value="${value === null ? "" : value}"
      required
      ${(0, $904f4b114d3dc756$export$65c20e333206336e)("disabled", disabled)}
      list="${listId}" />
    <datalist id="${listId}"></datalist
  ></number-input>`;
}
function $f63a8d12a0a33aa0$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards) {
    if (property.choice_type !== "big-single" && property.choice_type !== "big-multiple" && !(property.response && [
        "single",
        "multiple"
    ].includes(property.choice_type)) && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.gender && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.gender_identity && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.sexual_orientation && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.race && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.ethnicity && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.marital_status && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_language && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.type && property.property_id !== (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_dow) throw new Error(`Property ${property.property_id} is not supported in list box.`);
    let src;
    switch(property.property_id){
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.city:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.postal_code:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.region_abbr:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.primary_physical.subregion:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.city:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.postal_code:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.region_abbr:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.assignee_organization_primary_physical.subregion:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.city:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.postal_code:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.region_abbr:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.create_organization_primary_physical.subregion:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.city:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.postal_code:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.region_abbr:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).person.primary_physical.subregion:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_physical.city:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_physical.postal_code:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_physical.region_abbr:
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).organization_project.primary_physical.subregion:
            {
                const params = new URLSearchParams({
                    category: (0, $669809489e0e2c7d$export$cc0d55d7ff08492f)[property.property_id],
                    wildcards: wildcards.toString()
                });
                src = `/api/addresses/suggestions?${params}`;
                break;
            }
        case (0, $669809489e0e2c7d$export$3f9e8a95c406046).activity.sctid:
            {
                const params = new URLSearchParams({
                    "semantic-tag": "procedure",
                    control: "autocomplete"
                });
                src = `/api/snomed/concepts?${params}`;
                break;
            }
        default:
            {
                const params = new URLSearchParams({
                    property_id: property.property_id.toString(),
                    operator: filter.operator,
                    wildcards: wildcards.toString(),
                    entity_type: entity_type
                });
                src = `/api/organizations/${organization_id}/reports/filter-suggestions?${params}`;
                break;
            }
    }
    return (0, $625d7180bf862706$export$c8ce1c1a107990cc)({
        id: controlId,
        label: "Value",
        name: `${name}:json`,
        value: filter.value,
        required: true,
        autocompleteSrc: src,
        disabled: disabled,
        parametric: wildcards
    });
}
function $f63a8d12a0a33aa0$export$cf33aefe7f9b5b61(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards) {
    if (!(0, $d175770e6e5170f5$export$156328d95560793b)(filter, property).includes(filter.operator)) return null;
    const info = (0, $d175770e6e5170f5$export$bce341c22388011b)(filter, property, filter.operator);
    if (info === null) return null;
    if (info === "blank") return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
      type="hidden"
      name="${name}"
      value="${filter.operator}"
    />`;
    switch(info.type){
        case "date":
            {
                let value;
                if (filter.value === null) value = null;
                else if (typeof filter.value === "number") value = new Date(filter.value);
                else if (typeof filter.value === "string") {
                    if ((0, $dbca384612ad025b$export$aebd7d4ffee5ebdd)(filter.value)) value = filter.value;
                    else if ((0, $d175770e6e5170f5$export$99da40ee05a17718).test(filter.value.toUpperCase())) // toUpperCase handles dev data before uppercase was enforced.
                    value = filter.value.toUpperCase();
                    else value = new Date(filter.value);
                } else throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $f63a8d12a0a33aa0$var$dateFilterValueTemplate(value, name, controlId, disabled);
            }
        case "bit":
            if (filter.value !== null && typeof filter.value !== "boolean") throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            return $f63a8d12a0a33aa0$var$booleanFilterValueTemplate(filter.value === null ? true : filter.value, property.choices, name, controlId, disabled);
        case "varchar100":
        case "varcharmax":
            if (info.choice_type === "none") {
                if (filter.value !== null && typeof filter.value !== "string") throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $f63a8d12a0a33aa0$var$stringFilterValueTemplate(filter.value || "", name, controlId, disabled);
            } else {
                if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $f63a8d12a0a33aa0$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards);
            }
        case "activity":
        case "uniqueidentifier":
            if (info.choice_type === "none") throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            else {
                if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $f63a8d12a0a33aa0$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards);
            }
        case "int":
            if (info.choice_type === "none") {
                if (filter.value !== null && typeof filter.value !== "number" && !(typeof filter.value === "string" && (0, $d175770e6e5170f5$export$99da40ee05a17718).test(filter.value))) throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $f63a8d12a0a33aa0$var$numberFilterValueTemplate(filter.value, "int", name, controlId, disabled);
            } else {
                if (!property) throw new Error(`Expected property for ${info.type} filter filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
                return $f63a8d12a0a33aa0$var$listBoxFilterValueTemplate(organization_id, entity_type, property, filter, name, controlId, disabled, wildcards);
            }
        case "decimal":
        case "currency":
            if (filter.value !== null && typeof filter.value !== "number" && !(typeof filter.value === "string" && (0, $d175770e6e5170f5$export$99da40ee05a17718).test(filter.value))) throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
            return $f63a8d12a0a33aa0$var$numberFilterValueTemplate(filter.value, info.type, name, controlId, disabled);
        default:
            throw new Error(`Unexpected ${info.type} filter value ${JSON.stringify(filter.value)} in filter ${JSON.stringify(filter)} resolving to value info ${JSON.stringify(info)}.`);
    }
}




var $dab64ba7821cb431$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dab64ba7821cb431$var$ReportFilterElement = class ReportFilterElement extends HTMLElement {
    get organization_id() {
        return this.getAttribute("organization-id");
    }
    get entity_type() {
        return this.getAttribute("entity-type");
    }
    get valueElementID() {
        return this.getAttribute("value-element-id");
    }
    get valueFormGroup() {
        return this.valueContainer.closest(".form-group");
    }
    get type() {
        return this.typeInput.value;
    }
    get property() {
        const input = this.propertySelect.querySelector("summary input");
        const value = input?.value;
        if (!value) return null;
        return JSON.parse(input.getAttribute("data-property"));
    }
    get operator() {
        return this.operatorSelect.value;
    }
    set operator(value) {
        this.operatorSelect.value = value;
    }
    get aggregate() {
        return this.aggregateSelect?.value;
    }
    get operatorFormGroup() {
        return this.operatorSelect.closest(".form-group");
    }
    handleLeftSideChange() {
        const filter = {
            type: this.type,
            aggregate: this.aggregate
        };
        const property = this.property;
        const ops = (0, $d175770e6e5170f5$export$156328d95560793b)(filter, property);
        // coerce operator
        let current = this.operator;
        this.operator = current = ops.includes(current) ? current : ops[0];
        // show/hide operator select
        this.operatorFormGroup.hidden = ops.length === 0;
        this.operatorSelect.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(ops.map((op)=>(0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<option value="${op}" ${(0, $904f4b114d3dc756$export$65c20e333206336e)("selected", op === current)}>
            ${property?.type === "date" ? (0, $d175770e6e5170f5$export$cc43c7363164eb92)[op] : (0, $d175770e6e5170f5$export$16e3502ebc32b20f)[op]}
          </option>`));
        this.setValueInput();
    }
    handleOperatorChange() {
        if (this.operator === "blank" || this.operator === "notblank" || this.valueFormGroup?.hidden) this.setValueInput();
    }
    setValueInput() {
        const nameBase = this.getAttribute("name");
        const wildcards = this.getAttribute("wildcards") === "true";
        const property = this.property;
        const property_id = property?.property_id;
        const operator = this.operator;
        const filter = this.type === "standard" ? {
            type: "standard",
            property_id: property_id,
            operator: operator,
            value: null
        } : {
            type: "subquery",
            aggregate: this.aggregate,
            operator: operator,
            subquery_property_id: property_id,
            value: null
        };
        const valueTemplate = (0, $f63a8d12a0a33aa0$export$cf33aefe7f9b5b61)(this.organization_id, this.entity_type, property, filter, `${nameBase}/value`, this.valueElementID, false, wildcards);
        this.valueContainer.closest(".form-group").hidden = !valueTemplate || this.operator === "blank" || this.operator === "notblank";
        this.valueContainer.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)(valueTemplate);
    }
};
$dab64ba7821cb431$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dab64ba7821cb431$var$ReportFilterElement.prototype, "typeInput", void 0);
$dab64ba7821cb431$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dab64ba7821cb431$var$ReportFilterElement.prototype, "propertySelect", void 0);
$dab64ba7821cb431$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dab64ba7821cb431$var$ReportFilterElement.prototype, "aggregateSelect", void 0);
$dab64ba7821cb431$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dab64ba7821cb431$var$ReportFilterElement.prototype, "operatorSelect", void 0);
$dab64ba7821cb431$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dab64ba7821cb431$var$ReportFilterElement.prototype, "valueContainer", void 0);
$dab64ba7821cb431$var$ReportFilterElement = $dab64ba7821cb431$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("report-filter")
], $dab64ba7821cb431$var$ReportFilterElement);







var $ee4009eadba61a40$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $ee4009eadba61a40$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
const $ee4009eadba61a40$var$datetimeFormat = new Intl.DateTimeFormat((0, $f2e3bdb9929a0de6$export$d7f512c98c859244), {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true
});
const $ee4009eadba61a40$var$columnTypes = {
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).single_choice]: {
        valueFormatter: ({ value: value, colDef: colDef })=>{
            if (typeof value === "number") ;
            else if (typeof value === "boolean") value = value ? 1 : 0;
            else return value;
            const choices = colDef?.context?.choices;
            return choices?.find((c)=>c.choice_id === value)?.label;
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).multiple_choice]: {
        valueFormatter: ({ value: value, colDef: colDef })=>{
            if (typeof value !== "number") return value;
            const choices = colDef?.context?.choices;
            return choices?.filter((c)=>(2 ** c.choice_id & value) !== 0).map((c)=>c.label).join(", ");
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).boolean]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== "boolean" && value !== 0 && value !== 1) return value;
            return value ? (0, $2868cc1235412e16$export$310250c811816278)[$ee4009eadba61a40$var$locale] : (0, $2868cc1235412e16$export$9692d1a0658a3861)[$ee4009eadba61a40$var$locale];
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).date]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== "string" || value === "") return value;
            if (value.length === 10) {
                const ds = value.split("-").map((s)=>parseInt(s));
                ds[1] = ds[1] - 1; // js month is zero-based month
                const d = new Date(ds[0], ds[1], ds[2]);
                return (0, $dbca384612ad025b$export$41d8fd8f1a1513f).format(d);
            }
            const d = new Date(value + (value.endsWith("Z") ? "" : "Z"));
            return $ee4009eadba61a40$var$datetimeFormat.format(d);
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).decimal]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== "number") return value;
            return (0, $834ded10eeb0a740$export$688d13a530c5dcbc).format(value);
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).currency]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== "number") return value;
            return (0, $834ded10eeb0a740$export$4670d0ed237a9270).format(value);
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).int]: {
        valueFormatter: ({ value: value })=>{
            if (typeof value !== "number") return value;
            // hack: don't use commas when the int might be a year
            if (value >= 1900 || value < 2100) return value;
            return (0, $834ded10eeb0a740$export$688d13a530c5dcbc).format(value);
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).row_href]: {
        cellRenderer: ({ value: value, colDef: colDef })=>{
            const a = document.createElement("a");
            a.className = "btn btn-sm";
            a.href = value;
            a.textContent = colDef?.cellRendererParams?.title ?? (0, $2868cc1235412e16$export$41e323ff2c7efe95)[$ee4009eadba61a40$var$locale];
            a.style.marginTop = "-6px";
            return a;
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).composite_address]: {
        cellRenderer: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_address_map;
            const address = {
                street_address: row[map["street_address"]],
                sub_address: row[map["sub_address"]],
                city: row[map["city"]],
                region_abbr: row[map["region_abbr"]],
                subregion: row[map["subregion"]],
                postal_code: row[map["postal_code"]],
                postal_code_ext: row[map["postal_code_ext"]]
            };
            return (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $125c741ec276b361$export$16324af849cc98bd)(address, true));
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).composite_phone]: {
        cellRenderer: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_phone_map;
            const phone = {
                type: row[map["type"]],
                number: row[map["number"]],
                extension: row[map["extension"]]
            };
            if (phone.type && phone.number) return (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $125c741ec276b361$export$ff1216816de7f138)(phone, true));
            return "";
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).composite_email]: {
        cellRenderer: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_email_map;
            const email = {
                type: row[map["type"] ?? "zzz-nothing-matches-this-key"],
                email: row[map["email"]]
            };
            if (email.type && email.email) return (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $125c741ec276b361$export$2b79b564cdea702d)(email, true, false));
            if (email.email) {
                const a = document.createElement("a");
                a.href = `mailto:${email.email}`;
                a.className = "Link--primary";
                a.textContent = email.email;
                return a;
            }
            return "";
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).composite_full_name]: {
        cellRenderer: ({ colDef: colDef, data: row })=>{
            const map = colDef.context.composite_full_name_map;
            const person = {
                last_name: row[map["last_name"]],
                first_name: row[map["first_name"]],
                middle_name: row[map["middle_name"]]
            };
            return person.last_name ? (0, $125c741ec276b361$export$b580f1dfaaa8cdab)(person) : "";
        }
    },
    [(0, $d175770e6e5170f5$export$457cf8f69ee54250).value_map]: {
        valueFormatter: ({ value: value, colDef: colDef })=>{
            const map = colDef.context.value_map;
            return map[value] ?? value;
        }
    }
};
let $ee4009eadba61a40$var$ReportGridElement = class ReportGridElement extends HTMLElement {
    connectedCallback() {
        agGrid.LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);
        if (this.closest("[hidden]")) return;
        this.initialize();
    }
    disconnectedCallback() {
        this.grid?.destroy();
    }
    initialize() {
        if (this.grid) return;
        const options = JSON.parse(this.optionsScript.textContent);
        this.key = JSON.parse(this.keyScript.textContent);
        this.optionsScript.remove();
        options.getContextMenuItems = ({})=>{
            return [
                "copy"
            ];
        };
        options.popupParent = document.body;
        options.columnTypes = $ee4009eadba61a40$var$columnTypes;
        options.rowModelType = "serverSide";
        options.skipHeaderOnAutoSize = true;
        options.suppressColumnVirtualisation = true;
        options.rowClassRules = {
            "color-bg-subtle": ({ rowIndex: rowIndex })=>rowIndex % 2 !== 0
        };
        options.defaultColDef = Object.assign(options.defaultColDef ?? {}, {
            headerComponentParams: {
                template: (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div class="ag-cell-label-container" role="presentation">
            <span
              data-ref="eMenu"
              class="ag-header-icon ag-header-cell-menu-button"
              aria-hidden="true"
            ></span>
            <span
              data-ref="eFilterButton"
              class="ag-header-icon ag-header-cell-filter-button"
              aria-hidden="true"
            ></span>
            <div
              data-ref="eLabel"
              class="ag-header-cell-label"
              role="presentation"
            >
              <span
                data-ref="eText"
                class="ag-header-cell-text line-clamp-4"
              ></span>
              <span
                data-ref="eFilter"
                class="ag-header-icon ag-header-label-icon ag-filter-icon"
                aria-hidden="true"
              ></span>
              <span
                data-ref="eSortAsc"
                class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon"
                style="--ag-icon-size: 14px"
                aria-hidden="true"
              ></span>
              <span
                data-ref="eSortDesc"
                class="ag-header-icon ag-header-label-icon ag-sort-descending-icon"
                style="--ag-icon-size: 14px"
                aria-hidden="true"
              ></span>
              <!-- <span
                data-ref="eSortNone"
                class="ag-header-icon ag-header-label-icon ag-sort-none-icon"
                style="--ag-icon-size: 14px"
                aria-hidden="true"
              ></span> -->
              <span
                data-ref="eSortOrder"
                class="ag-sort-order"
                style="position: relative; bottom: -8px; left: -4px; font-size: 0.625rem"
                aria-hidden="true"
              ></span>
            </div>
          </div>`)
            }
        });
        options.serverSideDatasource = {
            getRows: async ({ request: { startRow: startRow, endRow: endRow, sortModel: sortModel }, success: success, fail: fail })=>{
                const url = this.getAttribute("row-source");
                const { parameter_values: parameter_values = {} } = (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)(new FormData(this.parametersForm));
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        startRow: startRow,
                        endRow: endRow,
                        sortModel: sortModel.slice(0, (0, $d175770e6e5170f5$export$f258709b40073be1).sorts),
                        key: this.key,
                        parameter_values: parameter_values
                    })
                });
                if (!response.ok) {
                    fail();
                    return;
                }
                const detail = await response.json();
                success({
                    rowData: detail.rows,
                    rowCount: detail.count
                });
                this.dispatchEvent(new CustomEvent("report-grid-rows-loaded", {
                    detail: detail,
                    bubbles: true
                }));
            }
        };
        const grid = this.grid = agGrid.createGrid(this.gridContainer, options);
        grid.addEventListener("firstDataRendered", ()=>{
            setTimeout(()=>{
                const columns = grid.getAllDisplayedColumns();
                const widths = columns.map((c)=>c.getActualWidth());
                const columnsWidth = widths.reduce((a, b)=>a + b, 0);
                const gridWidth = this.clientWidth;
                if (columnsWidth > gridWidth - 16) return;
                const available = gridWidth - columnsWidth;
                const start = columns[0].getColId() === "navigation" ? 1 : 0;
                const utilized = widths.slice(start).reduce((a, b)=>a + b, 0);
                const newWidths = [];
                for(let i = start; i < columns.length; i++){
                    const current = widths[i];
                    const ratio = current / utilized;
                    const newWidth = Math.min(current + available * ratio, Math.max(current, 500));
                    newWidths.push({
                        key: columns[i].getColId(),
                        newWidth: newWidth
                    });
                }
                grid.setColumnWidths(newWidths);
            });
        });
    }
    submitParameters(event) {
        event?.preventDefault();
        event?.target?.acceptChanges();
        if (event?.detail.get("download-csv") === "true") {
            event.detail.delete("download-csv");
            const action = this.getAttribute("csv-action");
            const form = document.createElement("form");
            form.method = "POST";
            form.action = action;
            form.style.display = "none";
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "key";
            input.value = this.key;
            form.appendChild(input);
            for (const [key, value] of event.detail.entries()){
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = value;
                form.appendChild(input);
            }
            document.body.appendChild(form);
            form.submit();
            form.remove();
            return;
        }
        if (this.grid) {
            this.grid.refreshServerSide({
                purge: true
            });
            if (event) {
                const { parameter_values: parameter_values = {} } = (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)(new FormData(this.parametersForm));
                const locationUrl = new URL(location.href);
                (0, $d175770e6e5170f5$export$8731bf6742d09f4c)(locationUrl.searchParams, parameter_values);
                history.replaceState(null, "", locationUrl.href);
            }
        } else this.initialize();
    }
};
$ee4009eadba61a40$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee4009eadba61a40$var$ReportGridElement.prototype, "optionsScript", void 0);
$ee4009eadba61a40$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee4009eadba61a40$var$ReportGridElement.prototype, "keyScript", void 0);
$ee4009eadba61a40$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee4009eadba61a40$var$ReportGridElement.prototype, "gridContainer", void 0);
$ee4009eadba61a40$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $ee4009eadba61a40$var$ReportGridElement.prototype, "parametersForm", void 0);
$ee4009eadba61a40$var$ReportGridElement = $ee4009eadba61a40$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("report-grid")
], $ee4009eadba61a40$var$ReportGridElement);






var $d59e8b395689b542$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d59e8b395689b542$var$ReportSubqueryAggregationElement = class ReportSubqueryAggregationElement extends HTMLElement {
    updateAggregation(event) {
        const propertyInput = this.aggregationTargetFormGroup.querySelector('input[name^="definition/"]');
        this.clearPropertyInput(propertyInput);
        const remote = this.aggregationTargetFormGroup.querySelector("remote-input");
        const url = new URL(remote.getAttribute("src"), location.origin);
        const entity_type = (0, $d175770e6e5170f5$export$416b29773ad00249)[this.associationSelect.value];
        // reset filters and aggregate if entity type changed
        const entity_type_changed = url.searchParams.get("entity_type") !== entity_type;
        if (entity_type_changed) {
            this.aggregateSelect.value = "count";
            this.closest("li")?.querySelector('editable-list[name$="/filters"]')?.removeAllListItems();
        }
        const aggregateGroup = this.aggregateSelect.closest(".form-group");
        if (this.associationSelect.value === "parent-activity" || this.associationSelect.value === "grandparent-activity") {
            aggregateGroup.hidden = true;
            this.aggregateSelect.value = "max";
            if (event.target !== this.aggregateSelect) (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.aggregateSelect);
        } else if (aggregateGroup.hidden) {
            this.aggregateSelect.value = "count";
            aggregateGroup.hidden = false;
        }
        if (this.aggregateSelect.value === "count") {
            // hide the property input
            this.aggregationTargetFormGroup.hidden = true;
            propertyInput.required = false;
        } else {
            // show the property input
            this.aggregationTargetFormGroup.hidden = false;
            propertyInput.required = true;
        }
        // update the property input's remote input
        this.updatePropertySuggestionSrc();
    }
    clearPropertyInput(propertyInput) {
        propertyInput.value = "";
        propertyInput.removeAttribute("value");
        propertyInput.removeAttribute("data-property");
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(propertyInput);
        propertyInput.previousElementSibling.className = "color-fg-muted text-italic";
        propertyInput.previousElementSibling.textContent = "Select field...";
    }
    updatePropertySuggestionSrc() {
        const entity_type = (0, $d175770e6e5170f5$export$416b29773ad00249)[this.associationSelect.value];
        const editableList = this.closest("li")?.querySelector('editable-list[name$="filters"]');
        const containers = [
            this.aggregationTargetFormGroup,
            editableList?.itemTemplate?.content
        ].filter((x)=>x !== undefined);
        for (const container of containers){
            const remote = container.querySelector("remote-input");
            const url = new URL(remote.getAttribute("src"), location.origin);
            url.searchParams.set("entity_type", entity_type);
            url.searchParams.set("association", this.associationSelect.value);
            url.searchParams.set("aggregate", this.aggregateSelect.value);
            remote.setAttribute("src", `${url.pathname}?${url.searchParams}`);
            const remoteFilterInput = remote.firstElementChild;
            remoteFilterInput.value = "";
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(remoteFilterInput);
        }
    }
};
$d59e8b395689b542$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d59e8b395689b542$var$ReportSubqueryAggregationElement.prototype, "associationSelect", void 0);
$d59e8b395689b542$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d59e8b395689b542$var$ReportSubqueryAggregationElement.prototype, "aggregateSelect", void 0);
$d59e8b395689b542$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d59e8b395689b542$var$ReportSubqueryAggregationElement.prototype, "aggregationTargetFormGroup", void 0);
$d59e8b395689b542$var$ReportSubqueryAggregationElement = $d59e8b395689b542$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("report-subquery-aggregation")
], $d59e8b395689b542$var$ReportSubqueryAggregationElement);




var $d72f708aad76407b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d72f708aad76407b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $d72f708aad76407b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $d72f708aad76407b$var$_SideBarElement_prefersCollapsed;
const $d72f708aad76407b$export$de3a936f575807 = "sidebar-collapsed";
const $d72f708aad76407b$var$collapsedClass = "Sidebar--collapsed";
let $d72f708aad76407b$export$dcd314c2ee8251f2 = class SideBarElement extends HTMLElement {
    constructor(){
        super(...arguments);
        $d72f708aad76407b$var$_SideBarElement_prefersCollapsed.set(this, false);
        this.restoreCollapsedState = ({ target: target })=>{
            if (target instanceof Node && !this.contains(target)) {
                this.toggleCollapsedClass(this.prefersCollapsed);
                this.toggleWindowSubscriptions(false);
            }
        };
    }
    get prefersCollapsed() {
        return $d72f708aad76407b$var$__classPrivateFieldGet(this, $d72f708aad76407b$var$_SideBarElement_prefersCollapsed, "f");
    }
    set prefersCollapsed(value) {
        $d72f708aad76407b$var$__classPrivateFieldSet(this, $d72f708aad76407b$var$_SideBarElement_prefersCollapsed, value, "f");
        document.cookie = `sidebar-collapsed=${value};path=/;${location.protocol === "https:" ? "secure;" : ""}samesite=lax;max-age=31536000`;
    }
    connectedCallback() {
        $d72f708aad76407b$var$__classPrivateFieldSet(this, $d72f708aad76407b$var$_SideBarElement_prefersCollapsed, this.classList.contains($d72f708aad76407b$var$collapsedClass), "f");
    }
    disconnectedCallback() {
        this.toggleWindowSubscriptions(false);
    }
    toggleWindowSubscriptions(value) {
        const method = value ? "addEventListener" : "removeEventListener";
        window[method]("focus", this.restoreCollapsedState, true);
        window[method]("click", this.restoreCollapsedState);
    }
    toggleExpanded() {
        this.prefersCollapsed = this.toggleCollapsedClass();
    }
    toggleCollapsedClass(add = !this.classList.contains($d72f708aad76407b$var$collapsedClass)) {
        const current = this.classList.contains($d72f708aad76407b$var$collapsedClass);
        if (add !== current) {
            this.classList.toggle($d72f708aad76407b$var$collapsedClass, add);
            this.dispatchEvent(new CustomEvent($d72f708aad76407b$export$de3a936f575807, {
                detail: add,
                bubbles: true
            }));
        }
        return add;
    }
    activateSearch() {
        this.toggleCollapsedClass(false);
        this.searchInput.focus();
        this.toggleWindowSubscriptions(true);
    }
};
$d72f708aad76407b$var$_SideBarElement_prefersCollapsed = new WeakMap();
$d72f708aad76407b$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $d72f708aad76407b$export$dcd314c2ee8251f2.prototype, "searchInput", void 0);
$d72f708aad76407b$export$dcd314c2ee8251f2 = $d72f708aad76407b$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("side-bar")
], $d72f708aad76407b$export$dcd314c2ee8251f2);




/*!
 * Signature Pad v5.0.7 | https://github.com/szimek/signature_pad
 * (c) 2025 Szymon Nowak | Released under the MIT license
 */ class $bb6f6b25baebfb25$var$Point {
    constructor(x, y, pressure, time){
        if (isNaN(x) || isNaN(y)) throw new Error(`Point is invalid: (${x}, ${y})`);
        this.x = +x;
        this.y = +y;
        this.pressure = pressure || 0;
        this.time = time || Date.now();
    }
    distanceTo(start) {
        return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
    }
    equals(other) {
        return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
    }
    velocityFrom(start) {
        return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
    }
}
class $bb6f6b25baebfb25$var$Bezier {
    static fromPoints(points, widths) {
        const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
        const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
        return new $bb6f6b25baebfb25$var$Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
    }
    static calculateControlPoints(s1, s2, s3) {
        const dx1 = s1.x - s2.x;
        const dy1 = s1.y - s2.y;
        const dx2 = s2.x - s3.x;
        const dy2 = s2.y - s3.y;
        const m1 = {
            x: (s1.x + s2.x) / 2.0,
            y: (s1.y + s2.y) / 2.0
        };
        const m2 = {
            x: (s2.x + s3.x) / 2.0,
            y: (s2.y + s3.y) / 2.0
        };
        const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
        const dxm = m1.x - m2.x;
        const dym = m1.y - m2.y;
        const k = l1 + l2 == 0 ? 0 : l2 / (l1 + l2);
        const cm = {
            x: m2.x + dxm * k,
            y: m2.y + dym * k
        };
        const tx = s2.x - cm.x;
        const ty = s2.y - cm.y;
        return {
            c1: new $bb6f6b25baebfb25$var$Point(m1.x + tx, m1.y + ty),
            c2: new $bb6f6b25baebfb25$var$Point(m2.x + tx, m2.y + ty)
        };
    }
    constructor(startPoint, control2, control1, endPoint, startWidth, endWidth){
        this.startPoint = startPoint;
        this.control2 = control2;
        this.control1 = control1;
        this.endPoint = endPoint;
        this.startWidth = startWidth;
        this.endWidth = endWidth;
    }
    length() {
        const steps = 10;
        let length = 0;
        let px;
        let py;
        for(let i = 0; i <= steps; i += 1){
            const t = i / steps;
            const cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
            const cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
            if (i > 0) {
                const xdiff = cx - px;
                const ydiff = cy - py;
                length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
            }
            px = cx;
            py = cy;
        }
        return length;
    }
    point(t, start, c1, c2, end) {
        return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
    }
}
class $bb6f6b25baebfb25$var$SignatureEventTarget {
    constructor(){
        try {
            this._et = new EventTarget();
        } catch (_a) {
            this._et = document;
        }
    }
    addEventListener(type, listener, options) {
        this._et.addEventListener(type, listener, options);
    }
    dispatchEvent(event) {
        return this._et.dispatchEvent(event);
    }
    removeEventListener(type, callback, options) {
        this._et.removeEventListener(type, callback, options);
    }
}
function $bb6f6b25baebfb25$var$throttle(fn, wait = 250) {
    let previous = 0;
    let timeout = null;
    let result;
    let storedContext;
    let storedArgs;
    const later = ()=>{
        previous = Date.now();
        timeout = null;
        result = fn.apply(storedContext, storedArgs);
        if (!timeout) {
            storedContext = null;
            storedArgs = [];
        }
    };
    return function wrapper(...args) {
        const now = Date.now();
        const remaining = wait - (now - previous);
        storedContext = this;
        storedArgs = args;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = fn.apply(storedContext, storedArgs);
            if (!timeout) {
                storedContext = null;
                storedArgs = [];
            }
        } else if (!timeout) timeout = window.setTimeout(later, remaining);
        return result;
    };
}
class $bb6f6b25baebfb25$export$2e2bcd8739ae039 extends $bb6f6b25baebfb25$var$SignatureEventTarget {
    constructor(canvas, options = {}){
        var _a, _b, _c;
        super();
        this.canvas = canvas;
        this._drawingStroke = false;
        this._isEmpty = true;
        this._lastPoints = [];
        this._data = [];
        this._lastVelocity = 0;
        this._lastWidth = 0;
        this._handleMouseDown = (event)=>{
            if (!this._isLeftButtonPressed(event, true) || this._drawingStroke) return;
            this._strokeBegin(this._pointerEventToSignatureEvent(event));
        };
        this._handleMouseMove = (event)=>{
            if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
                this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
                return;
            }
            this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
        };
        this._handleMouseUp = (event)=>{
            if (this._isLeftButtonPressed(event)) return;
            this._strokeEnd(this._pointerEventToSignatureEvent(event));
        };
        this._handleTouchStart = (event)=>{
            if (event.targetTouches.length !== 1 || this._drawingStroke) return;
            if (event.cancelable) event.preventDefault();
            this._strokeBegin(this._touchEventToSignatureEvent(event));
        };
        this._handleTouchMove = (event)=>{
            if (event.targetTouches.length !== 1) return;
            if (event.cancelable) event.preventDefault();
            if (!this._drawingStroke) {
                this._strokeEnd(this._touchEventToSignatureEvent(event), false);
                return;
            }
            this._strokeMoveUpdate(this._touchEventToSignatureEvent(event));
        };
        this._handleTouchEnd = (event)=>{
            if (event.targetTouches.length !== 0) return;
            if (event.cancelable) event.preventDefault();
            this.canvas.removeEventListener("touchmove", this._handleTouchMove);
            this._strokeEnd(this._touchEventToSignatureEvent(event));
        };
        this._handlePointerDown = (event)=>{
            if (!event.isPrimary || !this._isLeftButtonPressed(event) || this._drawingStroke) return;
            event.preventDefault();
            this._strokeBegin(this._pointerEventToSignatureEvent(event));
        };
        this._handlePointerMove = (event)=>{
            if (!event.isPrimary) return;
            if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
                this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
                return;
            }
            event.preventDefault();
            this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
        };
        this._handlePointerUp = (event)=>{
            if (!event.isPrimary || this._isLeftButtonPressed(event)) return;
            event.preventDefault();
            this._strokeEnd(this._pointerEventToSignatureEvent(event));
        };
        this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
        this.minWidth = options.minWidth || 0.5;
        this.maxWidth = options.maxWidth || 2.5;
        this.throttle = (_a = options.throttle) !== null && _a !== void 0 ? _a : 16;
        this.minDistance = (_b = options.minDistance) !== null && _b !== void 0 ? _b : 5;
        this.dotSize = options.dotSize || 0;
        this.penColor = options.penColor || "black";
        this.backgroundColor = options.backgroundColor || "rgba(0,0,0,0)";
        this.compositeOperation = options.compositeOperation || "source-over";
        this.canvasContextOptions = (_c = options.canvasContextOptions) !== null && _c !== void 0 ? _c : {};
        this._strokeMoveUpdate = this.throttle ? $bb6f6b25baebfb25$var$throttle($bb6f6b25baebfb25$export$2e2bcd8739ae039.prototype._strokeUpdate, this.throttle) : $bb6f6b25baebfb25$export$2e2bcd8739ae039.prototype._strokeUpdate;
        this._ctx = canvas.getContext("2d", this.canvasContextOptions);
        this.clear();
        this.on();
    }
    clear() {
        const { _ctx: ctx, canvas: canvas } = this;
        ctx.fillStyle = this.backgroundColor;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this._data = [];
        this._reset(this._getPointGroupOptions());
        this._isEmpty = true;
    }
    fromDataURL(dataUrl, options = {}) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            const ratio = options.ratio || window.devicePixelRatio || 1;
            const width = options.width || this.canvas.width / ratio;
            const height = options.height || this.canvas.height / ratio;
            const xOffset = options.xOffset || 0;
            const yOffset = options.yOffset || 0;
            this._reset(this._getPointGroupOptions());
            image.onload = ()=>{
                this._ctx.drawImage(image, xOffset, yOffset, width, height);
                resolve();
            };
            image.onerror = (error)=>{
                reject(error);
            };
            image.crossOrigin = "anonymous";
            image.src = dataUrl;
            this._isEmpty = false;
        });
    }
    toDataURL(type = "image/png", encoderOptions) {
        switch(type){
            case "image/svg+xml":
                if (typeof encoderOptions !== "object") encoderOptions = undefined;
                return `data:image/svg+xml;base64,${btoa(this.toSVG(encoderOptions))}`;
            default:
                if (typeof encoderOptions !== "number") encoderOptions = undefined;
                return this.canvas.toDataURL(type, encoderOptions);
        }
    }
    on() {
        this.canvas.style.touchAction = "none";
        this.canvas.style.msTouchAction = "none";
        this.canvas.style.userSelect = "none";
        const isIOS = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
        if (window.PointerEvent && !isIOS) this._handlePointerEvents();
        else {
            this._handleMouseEvents();
            if ("ontouchstart" in window) this._handleTouchEvents();
        }
    }
    off() {
        this.canvas.style.touchAction = "auto";
        this.canvas.style.msTouchAction = "auto";
        this.canvas.style.userSelect = "auto";
        this.canvas.removeEventListener("pointerdown", this._handlePointerDown);
        this.canvas.removeEventListener("mousedown", this._handleMouseDown);
        this.canvas.removeEventListener("touchstart", this._handleTouchStart);
        this._removeMoveUpEventListeners();
    }
    _getListenerFunctions() {
        var _a;
        const canvasWindow = window.document === this.canvas.ownerDocument ? window : (_a = this.canvas.ownerDocument.defaultView) !== null && _a !== void 0 ? _a : this.canvas.ownerDocument;
        return {
            addEventListener: canvasWindow.addEventListener.bind(canvasWindow),
            removeEventListener: canvasWindow.removeEventListener.bind(canvasWindow)
        };
    }
    _removeMoveUpEventListeners() {
        const { removeEventListener: removeEventListener } = this._getListenerFunctions();
        removeEventListener("pointermove", this._handlePointerMove);
        removeEventListener("pointerup", this._handlePointerUp);
        removeEventListener("mousemove", this._handleMouseMove);
        removeEventListener("mouseup", this._handleMouseUp);
        removeEventListener("touchmove", this._handleTouchMove);
        removeEventListener("touchend", this._handleTouchEnd);
    }
    isEmpty() {
        return this._isEmpty;
    }
    fromData(pointGroups, { clear: clear = true } = {}) {
        if (clear) this.clear();
        this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this));
        this._data = this._data.concat(pointGroups);
    }
    toData() {
        return this._data;
    }
    _isLeftButtonPressed(event, only) {
        if (only) return event.buttons === 1;
        return (event.buttons & 1) === 1;
    }
    _pointerEventToSignatureEvent(event) {
        return {
            event: event,
            type: event.type,
            x: event.clientX,
            y: event.clientY,
            pressure: "pressure" in event ? event.pressure : 0
        };
    }
    _touchEventToSignatureEvent(event) {
        const touch = event.changedTouches[0];
        return {
            event: event,
            type: event.type,
            x: touch.clientX,
            y: touch.clientY,
            pressure: touch.force
        };
    }
    _getPointGroupOptions(group) {
        return {
            penColor: group && "penColor" in group ? group.penColor : this.penColor,
            dotSize: group && "dotSize" in group ? group.dotSize : this.dotSize,
            minWidth: group && "minWidth" in group ? group.minWidth : this.minWidth,
            maxWidth: group && "maxWidth" in group ? group.maxWidth : this.maxWidth,
            velocityFilterWeight: group && "velocityFilterWeight" in group ? group.velocityFilterWeight : this.velocityFilterWeight,
            compositeOperation: group && "compositeOperation" in group ? group.compositeOperation : this.compositeOperation
        };
    }
    _strokeBegin(event) {
        const cancelled = !this.dispatchEvent(new CustomEvent("beginStroke", {
            detail: event,
            cancelable: true
        }));
        if (cancelled) return;
        const { addEventListener: addEventListener } = this._getListenerFunctions();
        switch(event.event.type){
            case "mousedown":
                addEventListener("mousemove", this._handleMouseMove);
                addEventListener("mouseup", this._handleMouseUp);
                break;
            case "touchstart":
                addEventListener("touchmove", this._handleTouchMove);
                addEventListener("touchend", this._handleTouchEnd);
                break;
            case "pointerdown":
                addEventListener("pointermove", this._handlePointerMove);
                addEventListener("pointerup", this._handlePointerUp);
                break;
        }
        this._drawingStroke = true;
        const pointGroupOptions = this._getPointGroupOptions();
        const newPointGroup = Object.assign(Object.assign({}, pointGroupOptions), {
            points: []
        });
        this._data.push(newPointGroup);
        this._reset(pointGroupOptions);
        this._strokeUpdate(event);
    }
    _strokeUpdate(event) {
        if (!this._drawingStroke) return;
        if (this._data.length === 0) {
            this._strokeBegin(event);
            return;
        }
        this.dispatchEvent(new CustomEvent("beforeUpdateStroke", {
            detail: event
        }));
        const point = this._createPoint(event.x, event.y, event.pressure);
        const lastPointGroup = this._data[this._data.length - 1];
        const lastPoints = lastPointGroup.points;
        const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
        const isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
        const pointGroupOptions = this._getPointGroupOptions(lastPointGroup);
        if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
            const curve = this._addPoint(point, pointGroupOptions);
            if (!lastPoint) this._drawDot(point, pointGroupOptions);
            else if (curve) this._drawCurve(curve, pointGroupOptions);
            lastPoints.push({
                time: point.time,
                x: point.x,
                y: point.y,
                pressure: point.pressure
            });
        }
        this.dispatchEvent(new CustomEvent("afterUpdateStroke", {
            detail: event
        }));
    }
    _strokeEnd(event, shouldUpdate = true) {
        this._removeMoveUpEventListeners();
        if (!this._drawingStroke) return;
        if (shouldUpdate) this._strokeUpdate(event);
        this._drawingStroke = false;
        this.dispatchEvent(new CustomEvent("endStroke", {
            detail: event
        }));
    }
    _handlePointerEvents() {
        this._drawingStroke = false;
        this.canvas.addEventListener("pointerdown", this._handlePointerDown);
    }
    _handleMouseEvents() {
        this._drawingStroke = false;
        this.canvas.addEventListener("mousedown", this._handleMouseDown);
    }
    _handleTouchEvents() {
        this.canvas.addEventListener("touchstart", this._handleTouchStart);
    }
    _reset(options) {
        this._lastPoints = [];
        this._lastVelocity = 0;
        this._lastWidth = (options.minWidth + options.maxWidth) / 2;
        this._ctx.fillStyle = options.penColor;
        this._ctx.globalCompositeOperation = options.compositeOperation;
    }
    _createPoint(x, y, pressure) {
        const rect = this.canvas.getBoundingClientRect();
        return new $bb6f6b25baebfb25$var$Point(x - rect.left, y - rect.top, pressure, new Date().getTime());
    }
    _addPoint(point, options) {
        const { _lastPoints: _lastPoints } = this;
        _lastPoints.push(point);
        if (_lastPoints.length > 2) {
            if (_lastPoints.length === 3) _lastPoints.unshift(_lastPoints[0]);
            const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2], options);
            const curve = $bb6f6b25baebfb25$var$Bezier.fromPoints(_lastPoints, widths);
            _lastPoints.shift();
            return curve;
        }
        return null;
    }
    _calculateCurveWidths(startPoint, endPoint, options) {
        const velocity = options.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - options.velocityFilterWeight) * this._lastVelocity;
        const newWidth = this._strokeWidth(velocity, options);
        const widths = {
            end: newWidth,
            start: this._lastWidth
        };
        this._lastVelocity = velocity;
        this._lastWidth = newWidth;
        return widths;
    }
    _strokeWidth(velocity, options) {
        return Math.max(options.maxWidth / (velocity + 1), options.minWidth);
    }
    _drawCurveSegment(x, y, width) {
        const ctx = this._ctx;
        ctx.moveTo(x, y);
        ctx.arc(x, y, width, 0, 2 * Math.PI, false);
        this._isEmpty = false;
    }
    _drawCurve(curve, options) {
        const ctx = this._ctx;
        const widthDelta = curve.endWidth - curve.startWidth;
        const drawSteps = Math.ceil(curve.length()) * 2;
        ctx.beginPath();
        ctx.fillStyle = options.penColor;
        for(let i = 0; i < drawSteps; i += 1){
            const t = i / drawSteps;
            const tt = t * t;
            const ttt = tt * t;
            const u = 1 - t;
            const uu = u * u;
            const uuu = uu * u;
            let x = uuu * curve.startPoint.x;
            x += 3 * uu * t * curve.control1.x;
            x += 3 * u * tt * curve.control2.x;
            x += ttt * curve.endPoint.x;
            let y = uuu * curve.startPoint.y;
            y += 3 * uu * t * curve.control1.y;
            y += 3 * u * tt * curve.control2.y;
            y += ttt * curve.endPoint.y;
            const width = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);
            this._drawCurveSegment(x, y, width);
        }
        ctx.closePath();
        ctx.fill();
    }
    _drawDot(point, options) {
        const ctx = this._ctx;
        const width = options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
        ctx.beginPath();
        this._drawCurveSegment(point.x, point.y, width);
        ctx.closePath();
        ctx.fillStyle = options.penColor;
        ctx.fill();
    }
    _fromData(pointGroups, drawCurve, drawDot) {
        for (const group of pointGroups){
            const { points: points } = group;
            const pointGroupOptions = this._getPointGroupOptions(group);
            if (points.length > 1) for(let j = 0; j < points.length; j += 1){
                const basicPoint = points[j];
                const point = new $bb6f6b25baebfb25$var$Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);
                if (j === 0) this._reset(pointGroupOptions);
                const curve = this._addPoint(point, pointGroupOptions);
                if (curve) drawCurve(curve, pointGroupOptions);
            }
            else {
                this._reset(pointGroupOptions);
                drawDot(points[0], pointGroupOptions);
            }
        }
    }
    toSVG({ includeBackgroundColor: includeBackgroundColor = false } = {}) {
        const pointGroups = this._data;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const minX = 0;
        const minY = 0;
        const maxX = this.canvas.width / ratio;
        const maxY = this.canvas.height / ratio;
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        svg.setAttribute("viewBox", `${minX} ${minY} ${maxX} ${maxY}`);
        svg.setAttribute("width", maxX.toString());
        svg.setAttribute("height", maxY.toString());
        if (includeBackgroundColor && this.backgroundColor) {
            const rect = document.createElement("rect");
            rect.setAttribute("width", "100%");
            rect.setAttribute("height", "100%");
            rect.setAttribute("fill", this.backgroundColor);
            svg.appendChild(rect);
        }
        this._fromData(pointGroups, (curve, { penColor: penColor })=>{
            const path = document.createElement("path");
            if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
                const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} ` + `C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ` + `${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ` + `${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
                path.setAttribute("d", attr);
                path.setAttribute("stroke-width", (curve.endWidth * 2.25).toFixed(3));
                path.setAttribute("stroke", penColor);
                path.setAttribute("fill", "none");
                path.setAttribute("stroke-linecap", "round");
                svg.appendChild(path);
            }
        }, (point, { penColor: penColor, dotSize: dotSize, minWidth: minWidth, maxWidth: maxWidth })=>{
            const circle = document.createElement("circle");
            const size = dotSize > 0 ? dotSize : (minWidth + maxWidth) / 2;
            circle.setAttribute("r", size.toString());
            circle.setAttribute("cx", point.x.toString());
            circle.setAttribute("cy", point.y.toString());
            circle.setAttribute("fill", penColor);
            svg.appendChild(circle);
        });
        return svg.outerHTML;
    }
}





var $4ad9bc367bc57de1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4ad9bc367bc57de1$var$SignaturePadElement = class SignaturePadElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.resizeCanvas = ()=>{
            const canvas = this.canvas;
            if (canvas.closest("[hidden]")) return;
            const { width: oldWidth, height: oldHeight, ratio: oldRatio } = canvas;
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            const width = canvas.offsetWidth * ratio;
            const height = canvas.offsetHeight * ratio;
            if (canvas.width !== oldWidth || canvas.height !== oldHeight || ratio !== oldRatio) {
                canvas.width = width;
                canvas.height = height;
                canvas.ratio = ratio;
                canvas.getContext("2d")?.scale(ratio, ratio);
                this.signaturePad.clear();
            }
        };
    }
    connectedCallback() {
        this.signaturePad = new (0, $bb6f6b25baebfb25$export$2e2bcd8739ae039)(this.canvas);
        this.signaturePad.addEventListener("endStroke", ()=>this.endStroke());
        addEventListener("resize", this.resizeCanvas);
        this.resizeCanvas();
    }
    disconnectedCallback() {
        this.signaturePad.removeEventListener("endStroke", ()=>this.endStroke());
        removeEventListener("resize", this.resizeCanvas);
    }
    setRequired(active) {
        this.typeSignatureInput.required = active === "type-signature";
        this.drawSignatureInput.required = active === "draw-signature";
        // clear validation
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.typeSignatureInput);
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.drawSignatureInput);
    }
    tabContainerChanged(event) {
        const typeSignatureTabActive = event.tab?.id === "tab-type-signature";
        this.setRequired(typeSignatureTabActive ? "type-signature" : "draw-signature");
        this.resizeCanvas();
    }
    updateDrawSignatureInputValue() {
        const value = this.signaturePad.isEmpty() ? "" : this.signaturePad.toDataURL("image/png");
        if (this.drawSignatureInput.value !== value) {
            this.drawSignatureInput.value = value;
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.drawSignatureInput);
        }
    }
    endStroke() {
        this.updateDrawSignatureInputValue();
    }
    undo() {
        const data = this.signaturePad.toData();
        if (data) {
            data.pop();
            this.signaturePad.fromData(data);
            this.updateDrawSignatureInputValue();
        }
    }
    handleTypeSignatureInput() {
        const value = this.typeSignatureInput.value;
        if (value.length === 0) return;
        const firstLetter = value.charAt(0);
        if (firstLetter === firstLetter.toUpperCase()) return;
        const start = this.typeSignatureInput.selectionStart;
        const end = this.typeSignatureInput.selectionEnd;
        this.typeSignatureInput.value = firstLetter.toUpperCase() + value.slice(1);
        this.typeSignatureInput.setSelectionRange(start, end);
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.typeSignatureInput);
    }
    handleDrawSignatureInputFocus() {
        this.undoButton.focus();
    }
    handleFontButtonClick(event) {
        const button = event.target instanceof Element && event.target.closest("button");
        if (!button) return;
        const { font_family: font_family, size: size } = JSON.parse(button.value);
        this.typeSignatureInput.style.fontFamily = font_family;
        this.typeSignatureInput.style.fontSize = `${size}px`;
        button.closest("details-menu")?.querySelectorAll("[aria-checked]").forEach((b)=>b.setAttribute("aria-checked", "false"));
        button.setAttribute("aria-checked", "true");
    }
    async submit(event) {
        event.preventDefault();
        const { set_default_signature: set_default_signature } = (0, $5ec20dbd8175d55e$export$cbe32539d61674a2)(event.detail);
        // wait for form to finish clearing btn-busy before we re-add it
        await new Promise((resolve)=>setTimeout(resolve));
        try {
            this.submitButton.classList.add("btn-busy");
            const canvas = document.createElement("canvas");
            if (this.querySelector('.tabnav-tab[aria-selected="true"]')?.id === "tab-type-signature") {
                const ctx = canvas.getContext("2d");
                const { fontSize: fontSize, fontFamily: fontFamily } = this.typeSignatureInput.style;
                const font = `${+fontSize.substr(0, 2) * 2}px ${fontFamily}`;
                ctx.font = font;
                ctx.textBaseline = "top";
                const { actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent } = ctx.measureText(this.typeSignatureInput.value);
                canvas.width = actualBoundingBoxRight - actualBoundingBoxLeft;
                canvas.height = actualBoundingBoxAscent + actualBoundingBoxDescent;
                ctx.font = font;
                ctx.textBaseline = "top";
                ctx.fillText(this.typeSignatureInput.value, actualBoundingBoxLeft, actualBoundingBoxAscent);
            } else {
                const groups = this.signaturePad.toData();
                const points = groups.map((g)=>g.points).flat();
                const minX = Math.max(-4, Math.min(...points.map((p)=>p.x - 4)));
                const minY = Math.max(-4, Math.min(...points.map((p)=>p.y - 4)));
                const maxX = Math.min(this.canvas.width / 2 + 4, Math.max(...points.map((p)=>p.x + 4)));
                const maxY = Math.min(this.canvas.height / 2 + 4, Math.max(...points.map((p)=>p.y + 4)));
                console.log(minX, maxX, this.canvas.width, minY, maxY, this.canvas.height);
                for (const point of points){
                    point.x -= minX;
                    point.y -= minY;
                }
                canvas.width = (maxX - minX) * 2;
                canvas.height = (maxY - minY) * 2;
                canvas.getContext("2d")?.scale(2, 2);
                const pad = new (0, $bb6f6b25baebfb25$export$2e2bcd8739ae039)(canvas);
                pad.fromData(groups);
            }
            const blob = await new Promise((resolve)=>canvas.toBlob(resolve, "image/png"));
            const modal = this.closest("modal-content");
            modal?.controller?.dispatchEvent(new CustomEvent("signature-accepted", {
                bubbles: true,
                detail: {
                    blob: blob,
                    set_default_signature: set_default_signature
                }
            }));
            modal?.remove();
        } catch (err) {
            (0, $f3a2ac2d620bcd8b$export$7977be5e446db387)(this.typeSignatureInput.form);
            throw err;
        } finally{
            this.submitButton.classList.remove("btn-busy");
        }
    }
};
$4ad9bc367bc57de1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4ad9bc367bc57de1$var$SignaturePadElement.prototype, "canvas", void 0);
$4ad9bc367bc57de1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4ad9bc367bc57de1$var$SignaturePadElement.prototype, "typeSignatureInput", void 0);
$4ad9bc367bc57de1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4ad9bc367bc57de1$var$SignaturePadElement.prototype, "drawSignatureInput", void 0);
$4ad9bc367bc57de1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4ad9bc367bc57de1$var$SignaturePadElement.prototype, "submitButton", void 0);
$4ad9bc367bc57de1$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $4ad9bc367bc57de1$var$SignaturePadElement.prototype, "undoButton", void 0);
$4ad9bc367bc57de1$var$SignaturePadElement = $4ad9bc367bc57de1$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("signature-pad")
], $4ad9bc367bc57de1$var$SignaturePadElement);





function $43dcc60fa97a767b$export$365d3f09bda4fd2c({ locale: locale, src: src, attachment_id: attachment_id, inserted_property_id: inserted_property_id, readonly: readonly = false }) {
    return (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<span
    class="d-flex flex-items-start gap-2"
    attachment-id="${attachment_id}"
  >
    <img src="${src}" alt="Signature" style="height: 40px" />
    ${inserted_property_id ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<input
          type="hidden"
          name="attachments/-:json"
          value=${JSON.stringify({
        attachment_id: attachment_id,
        property_id: inserted_property_id
    })}
        />` : null}
    ${readonly ? null : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<button
          type="button"
          class="btn-octicon btn-octicon-danger mt-n1 mb-n1 ml-n1 mr-n1"
          aria-label="${(0, $2868cc1235412e16$export$31a34480861da9d9)[locale]}"
          data-action="click:signature-question#deleteSignature"
        >
          ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$c6e11f163cc2dc47))}
        </button>`}
  </span>`;
}
function $43dcc60fa97a767b$export$67089e03b19318ed(locale, default_signature_href) {
    return default_signature_href ? (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<button
          class="SelectMenu-item d-block"
          type="button"
          role="menuitem"
          data-action="click:signature-question#signWithDefaultSignature"
        >
          <span class="text-bold d-block"
            >${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$f8913d335ddc81bb), "SelectMenu-icon color-fg-accent")}
            <span class="f5 text-bold"
              >${(0, $2868cc1235412e16$export$9feabe39d774db92)[locale]}</span
            ></span
          >
          <img
            class="signature-image d-block width-full my-3 px-3"
            src="${default_signature_href}"
            alt
          />
        </button>
        <button
          class="SelectMenu-item d-block btn-octicon-danger"
          type="button"
          role="menuitem"
          data-action="click:signature-question#resetDefaultSignature"
        >
          ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$c6e11f163cc2dc47), "SelectMenu-icon")}
          <span>${(0, $2868cc1235412e16$export$51e87c4ec4bfa4c8)[locale]}</span>
        </button>` : (0, $904f4b114d3dc756$export$c0bb0b647f701bb5)`<div class="SelectMenu-blankslate">
        ${(0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)((0, $2b6d0b8c1c80c786$export$f8913d335ddc81bb), {
        classes: "color-fg-muted f2"
    })}
        <h4 class="my-2">${(0, $2868cc1235412e16$export$c3b2af361dc85df7)[locale]}</h4>
        <p class="mb-3 color-fg-muted">
          ${(0, $2868cc1235412e16$export$4f405bdda60d10a2)[locale]}
        </p>
      </div>`;
}









var $166040d592260e4b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $166040d592260e4b$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
let $166040d592260e4b$var$SignatureQuestionElement = class SignatureQuestionElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.objectUrls = [];
    }
    get property_id() {
        return parseInt(this.getAttribute("property-id"));
    }
    get user_id() {
        return this.getAttribute("user-id");
    }
    get uploadUrl() {
        return new URL(this.getAttribute("upload-href"), location.origin);
    }
    connectedCallback() {
        addEventListener("default-signature-updated", this);
    }
    disconnectedCallback() {
        this.objectUrls.forEach(URL.revokeObjectURL);
        removeEventListener("default-signature-updated", this);
    }
    handleEvent(event) {
        if (event.type === "default-signature-updated") this.selectMenuList.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $43dcc60fa97a767b$export$67089e03b19318ed)($166040d592260e4b$var$locale, event.detail.href));
    }
    async signatureAccepted({ detail: { set_default_signature: set_default_signature, blob: blob } }) {
        try {
            this.signaturePadButton.classList.add("btn-busy");
            const file = new File([
                blob
            ], "signature.png", {
                type: "image/png"
            });
            const attachment = new (0, $60111cd6ea196be2$export$71e4db985cfcf9e3)(file);
            attachment.name = file.name;
            await (0, $49d75368cd6df2b4$export$14d3a7d22f26659e)({
                locale: $166040d592260e4b$var$locale,
                attachments: [
                    attachment
                ],
                uploadUrl: this.uploadUrl,
                attachmentSaved: ()=>{}
            });
            const href = URL.createObjectURL(blob);
            this.objectUrls.unshift(href);
            this.appendAttachment(attachment.id, attachment.name, href);
            if (set_default_signature) {
                const userAttachment = new (0, $60111cd6ea196be2$export$71e4db985cfcf9e3)(file);
                userAttachment.name = file.name;
                (0, $49d75368cd6df2b4$export$14d3a7d22f26659e)({
                    locale: $166040d592260e4b$var$locale,
                    attachments: [
                        userAttachment
                    ],
                    uploadUrl: new URL(`/attachments?owner_type=user&owner_id=${this.user_id}`, location.origin),
                    attachmentSaved: ()=>{}
                }).then(()=>fetch("/api/settings/default-signature", {
                        method: "POST",
                        headers: {
                            "content-type": "application/json"
                        },
                        body: JSON.stringify({
                            attachment_id: userAttachment.id
                        })
                    })).then(async (response)=>{
                    if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return;
                    if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
                    this.dispatchEvent(new CustomEvent("default-signature-updated", {
                        bubbles: true,
                        detail: {
                            href: href
                        }
                    }));
                });
            }
        } finally{
            this.signaturePadButton.classList.remove("btn-busy");
            this.signaturePadButton.focus();
        }
    }
    appendAttachment(id, name, href) {
        this.emptyContent.hidden = true;
        this.content.insertAdjacentHTML("afterbegin", (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $2211ef13a71debdf$export$495f1fafaa7af669)({
            locale: $166040d592260e4b$var$locale,
            readonly: false,
            display: "signature",
            inserted_property_id: this.property_id,
            versions: [
                {
                    id: id,
                    name: name,
                    date_iso: new Date().toISOString(),
                    href: href,
                    user_unsafe_html: "you"
                }
            ]
        })));
        let count = this.valueInput.value ? this.valueInput.valueAsNumber : 0;
        count++;
        this.valueInput.value = count.toString();
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.valueInput);
    }
    async signWithDefaultSignature() {
        try {
            this.signaturePadButton.classList.add("btn-busy");
            const { owner_id: owner_id, owner_type: owner_type } = Object.fromEntries(this.uploadUrl.searchParams);
            const response = await fetch(`${location.origin}/api/sign-with-default-signature`, {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    owner_type: owner_type,
                    owner_id: owner_id
                })
            });
            if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
            const { id: id, href: href, download_href: download_href, name: name } = await response.json();
            this.appendAttachment(id, name, download_href ?? href);
        } finally{
            this.signaturePadButton.classList.remove("btn-busy");
        }
    }
    async resetDefaultSignature() {
        try {
            this.signaturePadButton.classList.add("btn-busy");
            const response = await fetch(`${location.origin}/api/settings/default-signature`, {
                method: "DELETE"
            });
            if ((0, $c7540adae100fff1$export$91cdf58e199a84d0)(response)) return;
            if (!response.ok) throw new (0, $06268db7bba09be5$export$ea86d8b2c6b5cbfd)(response, await response.text());
            this.dispatchEvent(new CustomEvent("default-signature-updated", {
                bubbles: true,
                detail: {
                    href: null
                }
            }));
        } finally{
            this.signaturePadButton.classList.remove("btn-busy");
        }
    }
    valueInputFocused() {
        this.signaturePadButton.focus();
    }
    decrementCount() {
        if (this.valueInput.value === "1") {
            this.valueInput.value = "";
            this.emptyContent.hidden = false;
        } else this.valueInput.value = (parseInt(this.valueInput.value) - 1).toString();
        (0, $eb08f38ae8877120$export$89348ae70780cd7a)(this.valueInput);
    }
};
$166040d592260e4b$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $166040d592260e4b$var$SignatureQuestionElement.prototype, "signaturePadButton", void 0);
$166040d592260e4b$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $166040d592260e4b$var$SignatureQuestionElement.prototype, "valueInput", void 0);
$166040d592260e4b$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $166040d592260e4b$var$SignatureQuestionElement.prototype, "content", void 0);
$166040d592260e4b$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $166040d592260e4b$var$SignatureQuestionElement.prototype, "emptyContent", void 0);
$166040d592260e4b$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $166040d592260e4b$var$SignatureQuestionElement.prototype, "selectMenuList", void 0);
$166040d592260e4b$var$SignatureQuestionElement = $166040d592260e4b$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("signature-question")
], $166040d592260e4b$var$SignatureQuestionElement);







var $2d8e68cb13769b04$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $2d8e68cb13769b04$var$locale = (0, $58ccb23ba1dadd05$export$180605366c04f0cd)();
let $2d8e68cb13769b04$var$SignatureSubmitterElement = class SignatureSubmitterElement extends HTMLElement {
    constructor(){
        super(...arguments);
        this.objectUrls = [];
    }
    get uploadUrl() {
        return new URL(this.getAttribute("upload-href"), location.origin);
    }
    get jwt() {
        return this.getAttribute("jwt");
    }
    disconnectedCallback() {
        this.objectUrls.forEach(URL.revokeObjectURL);
    }
    async signatureAccepted({ detail: { blob: blob } }) {
        try {
            this.signaturePadButton.classList.add("btn-busy");
            const file = new File([
                blob
            ], "signature.png", {
                type: "image/png"
            });
            const attachment = new (0, $60111cd6ea196be2$export$71e4db985cfcf9e3)(file);
            attachment.name = file.name;
            await (0, $49d75368cd6df2b4$export$14d3a7d22f26659e)({
                locale: $2d8e68cb13769b04$var$locale,
                attachments: [
                    attachment
                ],
                uploadUrl: this.uploadUrl,
                attachmentSaved: ()=>{},
                jwt: this.jwt ?? ""
            });
            const href = URL.createObjectURL(blob);
            this.objectUrls.unshift(href);
            this.input.value = attachment.id;
            this.closest("form")?.requestSubmit();
        } catch (err) {
            console.error(err);
            return;
        } finally{
            this.signaturePadButton.classList.remove("btn-busy");
            this.signaturePadButton.focus();
        }
    }
};
$2d8e68cb13769b04$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $2d8e68cb13769b04$var$SignatureSubmitterElement.prototype, "signaturePadButton", void 0);
$2d8e68cb13769b04$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $2d8e68cb13769b04$var$SignatureSubmitterElement.prototype, "input", void 0);
$2d8e68cb13769b04$var$SignatureSubmitterElement = $2d8e68cb13769b04$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("signature-submitter")
], $2d8e68cb13769b04$var$SignatureSubmitterElement);


class $44c6c3824f8c8f2e$export$50241aa08d3f66b4 extends HTMLElement {
    connectedCallback() {
        this.disconnectController = new AbortController();
        this.addEventListener("click", ()=>this.toggle(), {
            signal: this.disconnectController.signal,
            once: true
        });
    }
    disconnectedCallback() {
        this.disconnectController?.abort();
    }
    toggle() {
        this.textContent = this.getAttribute("value") ?? "[Value missing]";
    }
}
if (!window.customElements.get("ssn-reveal")) {
    window.SsnRevealElement = $44c6c3824f8c8f2e$export$50241aa08d3f66b4;
    window.customElements.define("ssn-reveal", $44c6c3824f8c8f2e$export$50241aa08d3f66b4);
}



class $4f57a1285397fa75$export$e8dc149a419cc43a extends HTMLElement {
    connectedCallback() {
        this.setAttribute("role", "alert");
        addEventListener((0, $56b400225c9c516b$export$ee9f6aa6c23bab6c), this);
        addEventListener((0, $56b400225c9c516b$export$7acd55e6ec74c9ed), this);
    }
    disconnectedCallback() {
        removeEventListener((0, $56b400225c9c516b$export$ee9f6aa6c23bab6c), this);
        removeEventListener((0, $56b400225c9c516b$export$7acd55e6ec74c9ed), this);
    }
    handleEvent(event) {
        if (event.target instanceof Element && event.target.closest(`[id="${this.getAttribute("for")}"]`)) this.hidden = event.type === (0, $56b400225c9c516b$export$ee9f6aa6c23bab6c);
    }
}
if (!window.customElements.get("submit-alert")) {
    window.SubmitAlertElement = $4f57a1285397fa75$export$e8dc149a419cc43a;
    window.customElements.define("submit-alert", $4f57a1285397fa75$export$e8dc149a419cc43a);
}





var $e9973f93e356d205$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e9973f93e356d205$var$SwapControllerElement = class SwapControllerElement extends HTMLElement {
    swap({ target: target }) {
        const value = target && "value" in target && typeof target.value === "string" ? target.value : null;
        {
            const template = this.templates.find((t)=>t.getAttribute("data-value") === value);
            if (template) {
                const fragment = (0, $966a268ff99dc387$export$75a0370f3222215a)(template);
                const nodes = Array.from(fragment.children);
                const current = this.target;
                current.after(fragment);
                current.remove();
                nodes.forEach((0, $966a268ff99dc387$export$ae91b67ff38afcc3));
            }
        }
        {
            const template = this.secondaryTemplates.find((t)=>t.getAttribute("data-value") === value);
            if (template) {
                const fragment = (0, $966a268ff99dc387$export$75a0370f3222215a)(template);
                const nodes = Array.from(fragment.children);
                const current = this.secondaryTarget;
                current.after(fragment);
                current.remove();
                nodes.forEach((0, $966a268ff99dc387$export$ae91b67ff38afcc3));
            }
        }
    }
};
$e9973f93e356d205$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $e9973f93e356d205$var$SwapControllerElement.prototype, "target", void 0);
$e9973f93e356d205$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $e9973f93e356d205$var$SwapControllerElement.prototype, "templates", void 0);
$e9973f93e356d205$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $e9973f93e356d205$var$SwapControllerElement.prototype, "secondaryTarget", void 0);
$e9973f93e356d205$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$121e5dccf103a51e)
], $e9973f93e356d205$var$SwapControllerElement.prototype, "secondaryTemplates", void 0);
$e9973f93e356d205$var$SwapControllerElement = $e9973f93e356d205$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("swap-controller")
], $e9973f93e356d205$var$SwapControllerElement);






var $dd79c604d5105d37$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dd79c604d5105d37$var$TimelineControllerElement = class TimelineControllerElement extends HTMLElement {
    changeMode(event) {
        const button = event.currentTarget;
        this.querySelectorAll("[data-timeline-mode][aria-selected]").forEach((el)=>{
            el.setAttribute("aria-selected", String(el === button));
        });
        this.reload();
    }
    changeSort(event) {
        const button = event.currentTarget;
        const sort = button.dataset.timelineSort;
        button.setAttribute("aria-label", sort === "asc" ? "Sort ascending" : "Sort descending");
        button.dataset.timelineSort = sort === "asc" ? "desc" : "asc";
        button.setAttribute("cookie-value", sort === "asc" ? "" : "asc");
        button.innerHTML = (0, $904f4b114d3dc756$export$b3890eb0ae9dca99)((0, $2b6d0b8c1c80c786$export$1ca1ec8b29a4ce27)(sort === "asc" ? (0, $2b6d0b8c1c80c786$export$f4b6d034496ffda1) : (0, $2b6d0b8c1c80c786$export$a7f606f216bfee52)));
        this.reload();
    }
    toggleAssistant() {
        this.assistant.hidden = !this.assistant.hidden;
        if (!this.assistant.hidden) (0, $eb08f38ae8877120$export$956fd4dade47957a)(this.assistant);
    }
    reload() {
        this.searchInput.value = "";
        const remote = this.searchInput.closest("remote-input");
        // Setting src, even to the same value, will cause the remote input to reload because it will invoke
        // fetchResults with checkCurrentQuery=false.
        // https://github.com/github/remote-input-element/blob/dcb027c993790dbfd4ac50e0c65c29a0c73f5780/src/index.ts#L20
        remote.src = remote.src;
    }
};
$dd79c604d5105d37$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dd79c604d5105d37$var$TimelineControllerElement.prototype, "searchInput", void 0);
$dd79c604d5105d37$var$__decorate([
    (0, $dbc93f05a5c2ccff$export$44271b4f0c6a3563)
], $dd79c604d5105d37$var$TimelineControllerElement.prototype, "assistant", void 0);
$dd79c604d5105d37$var$TimelineControllerElement = $dd79c604d5105d37$var$__decorate([
    (0, $00cbd9c0279de546$export$de3b759ab07e4403)("timeline-controller")
], $dd79c604d5105d37$var$TimelineControllerElement);
var $dd79c604d5105d37$export$2e2bcd8739ae039 = $dd79c604d5105d37$var$TimelineControllerElement;




class $0d5b4f0f1b8d3ac9$var$UppercaseTextInput extends HTMLElement {
    connectedCallback() {
        this.addEventListener("change", this);
    }
    disconnectedCallback() {
        this.removeEventListener("change", this);
    }
    handleEvent(event) {
        if (event.target instanceof HTMLInputElement && event.target.type === "text" && event.target.value !== event.target.value.toUpperCase()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.target.value = event.target.value.toUpperCase();
            (0, $eb08f38ae8877120$export$89348ae70780cd7a)(event.target);
        }
    }
}
(0, $f3a2ac2d620bcd8b$export$86f1725708ac86dc)((input, label)=>{
    if (input instanceof HTMLInputElement && input.type === "text" && input.value.length && input.parentElement instanceof $0d5b4f0f1b8d3ac9$var$UppercaseTextInput && input.value !== input.value.toUpperCase()) return `${label} must be all uppercase letters.`;
    return null;
});
if (!window.customElements.get("uppercase-text-input")) {
    window.UppercaseTextInput = $0d5b4f0f1b8d3ac9$var$UppercaseTextInput;
    window.customElements.define("uppercase-text-input", $0d5b4f0f1b8d3ac9$var$UppercaseTextInput);
}






class $eed88219b0d9247d$export$3024f3bfb62054a3 {
    constructor(trie){
        this.children = [];
        this.parent = trie;
    }
    delete(value) {
        const index = this.children.indexOf(value);
        if (index === -1) return false;
        this.children = this.children.slice(0, index).concat(this.children.slice(index + 1));
        if (this.children.length === 0) this.parent.delete(this);
        return true;
    }
    add(value) {
        this.children.push(value);
        return this;
    }
}
class $eed88219b0d9247d$export$4e51cba2d60a1772 {
    constructor(trie){
        this.parent = null;
        this.children = {};
        this.parent = trie || null;
    }
    get(edge) {
        return this.children[edge];
    }
    insert(edges) {
        let currentNode = this;
        for(let i = 0; i < edges.length; i += 1){
            const edge = edges[i];
            let nextNode = currentNode.get(edge);
            if (i === edges.length - 1) {
                if (nextNode instanceof $eed88219b0d9247d$export$4e51cba2d60a1772) {
                    currentNode.delete(nextNode);
                    nextNode = null;
                }
                if (!nextNode) {
                    nextNode = new $eed88219b0d9247d$export$3024f3bfb62054a3(currentNode);
                    currentNode.children[edge] = nextNode;
                }
                return nextNode;
            } else {
                if (nextNode instanceof $eed88219b0d9247d$export$3024f3bfb62054a3) nextNode = null;
                if (!nextNode) {
                    nextNode = new $eed88219b0d9247d$export$4e51cba2d60a1772(currentNode);
                    currentNode.children[edge] = nextNode;
                }
            }
            currentNode = nextNode;
        }
        return currentNode;
    }
    delete(node) {
        for(const edge in this.children){
            const currentNode = this.children[edge];
            if (currentNode === node) {
                const success = delete this.children[edge];
                if (Object.keys(this.children).length === 0 && this.parent) this.parent.delete(this);
                return success;
            }
        }
        return false;
    }
}
const $eed88219b0d9247d$var$macosSymbolLayerKeys = {
    ["\xa1"]: "1",
    ["\u2122"]: "2",
    ["\xa3"]: "3",
    ["\xa2"]: "4",
    ["\u221E"]: "5",
    ["\xa7"]: "6",
    ["\xb6"]: "7",
    ["\u2022"]: "8",
    ["\xaa"]: "9",
    ["\xba"]: "0",
    ["\u2013"]: "-",
    ["\u2260"]: "=",
    ["\u2044"]: "!",
    ["\u20AC"]: "@",
    ["\u2039"]: "#",
    ["\u203A"]: "$",
    ["\uFB01"]: "%",
    ["\uFB02"]: "^",
    ["\u2021"]: "&",
    ["\xb0"]: "*",
    ["\xb7"]: "(",
    ["\u201A"]: ")",
    ["\u2014"]: "_",
    ["\xb1"]: "+",
    ["\u0153"]: "q",
    ["\u2211"]: "w",
    ["\xae"]: "r",
    ["\u2020"]: "t",
    ["\xa5"]: "y",
    ["\xf8"]: "o",
    ["\u03C0"]: "p",
    ["\u201C"]: "[",
    ["\u2018"]: "]",
    ["\xab"]: "\\",
    ["\u0152"]: "Q",
    ["\u201E"]: "W",
    ["\xb4"]: "E",
    ["\u2030"]: "R",
    ["\u02C7"]: "T",
    ["\xc1"]: "Y",
    ["\xa8"]: "U",
    ["\u02C6"]: "I",
    ["\xd8"]: "O",
    ["\u220F"]: "P",
    ["\u201D"]: "{",
    ["\u2019"]: "}",
    ["\xbb"]: "|",
    ["\xe5"]: "a",
    ["\xdf"]: "s",
    ["\u2202"]: "d",
    ["\u0192"]: "f",
    ["\xa9"]: "g",
    ["\u02D9"]: "h",
    ["\u2206"]: "j",
    ["\u02DA"]: "k",
    ["\xac"]: "l",
    ["\u2026"]: ";",
    ["\xe6"]: "'",
    ["\xc5"]: "A",
    ["\xcd"]: "S",
    ["\xce"]: "D",
    ["\xcf"]: "F",
    ["\u02DD"]: "G",
    ["\xd3"]: "H",
    ["\xd4"]: "J",
    ["\uF8FF"]: "K",
    ["\xd2"]: "L",
    ["\xda"]: ":",
    ["\xc6"]: '"',
    ["\u03A9"]: "z",
    ["\u2248"]: "x",
    ["\xe7"]: "c",
    ["\u221A"]: "v",
    ["\u222B"]: "b",
    ["\xb5"]: "m",
    ["\u2264"]: ",",
    ["\u2265"]: ".",
    ["\xf7"]: "/",
    ["\xb8"]: "Z",
    ["\u02DB"]: "X",
    ["\xc7"]: "C",
    ["\u25CA"]: "V",
    ["\u0131"]: "B",
    ["\u02DC"]: "N",
    ["\xc2"]: "M",
    ["\xaf"]: "<",
    ["\u02D8"]: ">",
    ["\xbf"]: "?"
};
const $eed88219b0d9247d$var$macosUppercaseLayerKeys = {
    ["`"]: "~",
    ["1"]: "!",
    ["2"]: "@",
    ["3"]: "#",
    ["4"]: "$",
    ["5"]: "%",
    ["6"]: "^",
    ["7"]: "&",
    ["8"]: "*",
    ["9"]: "(",
    ["0"]: ")",
    ["-"]: "_",
    ["="]: "+",
    ["["]: "{",
    ["]"]: "}",
    ["\\"]: "|",
    [";"]: ":",
    ["'"]: '"',
    [","]: "<",
    ["."]: ">",
    ["/"]: "?",
    ["q"]: "Q",
    ["w"]: "W",
    ["e"]: "E",
    ["r"]: "R",
    ["t"]: "T",
    ["y"]: "Y",
    ["u"]: "U",
    ["i"]: "I",
    ["o"]: "O",
    ["p"]: "P",
    ["a"]: "A",
    ["s"]: "S",
    ["d"]: "D",
    ["f"]: "F",
    ["g"]: "G",
    ["h"]: "H",
    ["j"]: "J",
    ["k"]: "K",
    ["l"]: "L",
    ["z"]: "Z",
    ["x"]: "X",
    ["c"]: "C",
    ["v"]: "V",
    ["b"]: "B",
    ["n"]: "N",
    ["m"]: "M"
};
const $eed88219b0d9247d$var$syntheticKeyNames = {
    " ": "Space",
    "+": "Plus"
};
function $eed88219b0d9247d$export$675b475d602780dc(event, platform = navigator.platform) {
    var _a, _b, _c;
    const { ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey, key: key } = event;
    const hotkeyString = [];
    const modifiers = [
        ctrlKey,
        altKey,
        metaKey,
        shiftKey
    ];
    for (const [i, mod] of modifiers.entries())if (mod) hotkeyString.push($eed88219b0d9247d$var$modifierKeyNames[i]);
    if (!$eed88219b0d9247d$var$modifierKeyNames.includes(key)) {
        const altNormalizedKey = hotkeyString.includes("Alt") && $eed88219b0d9247d$var$matchApplePlatform.test(platform) ? (_a = $eed88219b0d9247d$var$macosSymbolLayerKeys[key]) !== null && _a !== void 0 ? _a : key : key;
        const shiftNormalizedKey = hotkeyString.includes("Shift") && $eed88219b0d9247d$var$matchApplePlatform.test(platform) ? (_b = $eed88219b0d9247d$var$macosUppercaseLayerKeys[altNormalizedKey]) !== null && _b !== void 0 ? _b : altNormalizedKey : altNormalizedKey;
        const syntheticKey = (_c = $eed88219b0d9247d$var$syntheticKeyNames[shiftNormalizedKey]) !== null && _c !== void 0 ? _c : shiftNormalizedKey;
        hotkeyString.push(syntheticKey);
    }
    return hotkeyString.join("+");
}
const $eed88219b0d9247d$var$modifierKeyNames = [
    "Control",
    "Alt",
    "Meta",
    "Shift"
];
function $eed88219b0d9247d$export$e8d1c6663be136b1(hotkey, platform) {
    let result;
    result = $eed88219b0d9247d$var$localizeMod(hotkey, platform);
    result = $eed88219b0d9247d$var$sortModifiers(result);
    return result;
}
const $eed88219b0d9247d$var$matchApplePlatform = /Mac|iPod|iPhone|iPad/i;
function $eed88219b0d9247d$var$localizeMod(hotkey, platform) {
    var _a;
    const ssrSafeWindow = typeof window === "undefined" ? undefined : window;
    const safePlatform = (_a = platform !== null && platform !== void 0 ? platform : ssrSafeWindow === null || ssrSafeWindow === void 0 ? void 0 : ssrSafeWindow.navigator.platform) !== null && _a !== void 0 ? _a : "";
    const localModifier = $eed88219b0d9247d$var$matchApplePlatform.test(safePlatform) ? "Meta" : "Control";
    return hotkey.replace("Mod", localModifier);
}
function $eed88219b0d9247d$var$sortModifiers(hotkey) {
    const key = hotkey.split("+").pop();
    const modifiers = [];
    for (const modifier of [
        "Control",
        "Alt",
        "Meta",
        "Shift"
    ])if (hotkey.includes(modifier)) modifiers.push(modifier);
    if (key) modifiers.push(key);
    return modifiers.join("+");
}
const $eed88219b0d9247d$var$SEQUENCE_DELIMITER = " ";
class $eed88219b0d9247d$export$3f9c3ffe4833e2df {
    constructor({ onReset: onReset } = {}){
        this._path = [];
        this.timer = null;
        this.onReset = onReset;
    }
    get path() {
        return this._path;
    }
    get sequence() {
        return this._path.join($eed88219b0d9247d$var$SEQUENCE_DELIMITER);
    }
    registerKeypress(event) {
        this._path = [
            ...this._path,
            $eed88219b0d9247d$export$675b475d602780dc(event)
        ];
        this.startTimer();
    }
    reset() {
        var _a;
        this.killTimer();
        this._path = [];
        (_a = this.onReset) === null || _a === void 0 || _a.call(this);
    }
    killTimer() {
        if (this.timer != null) window.clearTimeout(this.timer);
        this.timer = null;
    }
    startTimer() {
        this.killTimer();
        this.timer = window.setTimeout(()=>this.reset(), $eed88219b0d9247d$export$3f9c3ffe4833e2df.CHORD_TIMEOUT);
    }
}
$eed88219b0d9247d$export$3f9c3ffe4833e2df.CHORD_TIMEOUT = 1500;
function $eed88219b0d9247d$export$b109b10146e8f9ba(sequence) {
    return sequence.split($eed88219b0d9247d$var$SEQUENCE_DELIMITER).map((h)=>$eed88219b0d9247d$export$e8d1c6663be136b1(h)).join($eed88219b0d9247d$var$SEQUENCE_DELIMITER);
}
function $eed88219b0d9247d$var$isFormField(element) {
    if (!(element instanceof HTMLElement)) return false;
    const name = element.nodeName.toLowerCase();
    const type = (element.getAttribute("type") || "").toLowerCase();
    return name === "select" || name === "textarea" || name === "input" && type !== "submit" && type !== "reset" && type !== "checkbox" && type !== "radio" && type !== "file" || element.isContentEditable;
}
function $eed88219b0d9247d$var$fireDeterminedAction(el, path) {
    const delegateEvent = new CustomEvent("hotkey-fire", {
        cancelable: true,
        detail: {
            path: path
        }
    });
    const cancelled = !el.dispatchEvent(delegateEvent);
    if (cancelled) return;
    if ($eed88219b0d9247d$var$isFormField(el)) el.focus();
    else el.click();
}
function $eed88219b0d9247d$var$expandHotkeyToEdges(hotkey) {
    const output = [];
    let acc = [
        ""
    ];
    let commaIsSeparator = false;
    for(let i = 0; i < hotkey.length; i++){
        if (commaIsSeparator && hotkey[i] === ",") {
            output.push(acc);
            acc = [
                ""
            ];
            commaIsSeparator = false;
            continue;
        }
        if (hotkey[i] === $eed88219b0d9247d$var$SEQUENCE_DELIMITER) {
            acc.push("");
            commaIsSeparator = false;
            continue;
        } else if (hotkey[i] === "+") commaIsSeparator = false;
        else commaIsSeparator = true;
        acc[acc.length - 1] += hotkey[i];
    }
    output.push(acc);
    return output.map((h)=>h.map((k)=>$eed88219b0d9247d$export$e8d1c6663be136b1(k)).filter((k)=>k !== "")).filter((h)=>h.length > 0);
}
const $eed88219b0d9247d$var$hotkeyRadixTrie = new $eed88219b0d9247d$export$4e51cba2d60a1772();
const $eed88219b0d9247d$var$elementsLeaves = new WeakMap();
let $eed88219b0d9247d$var$currentTriePosition = $eed88219b0d9247d$var$hotkeyRadixTrie;
const $eed88219b0d9247d$var$sequenceTracker = new $eed88219b0d9247d$export$3f9c3ffe4833e2df({
    onReset () {
        $eed88219b0d9247d$var$currentTriePosition = $eed88219b0d9247d$var$hotkeyRadixTrie;
    }
});
function $eed88219b0d9247d$var$keyDownHandler(event) {
    if (event.defaultPrevented) return;
    if (!(event.target instanceof Node)) return;
    if ($eed88219b0d9247d$var$isFormField(event.target)) {
        const target = event.target;
        if (!target.id) return;
        if (!target.ownerDocument.querySelector(`[data-hotkey-scope="${target.id}"]`)) return;
    }
    const newTriePosition = $eed88219b0d9247d$var$currentTriePosition.get($eed88219b0d9247d$export$675b475d602780dc(event));
    if (!newTriePosition) {
        $eed88219b0d9247d$var$sequenceTracker.reset();
        return;
    }
    $eed88219b0d9247d$var$sequenceTracker.registerKeypress(event);
    $eed88219b0d9247d$var$currentTriePosition = newTriePosition;
    if (newTriePosition instanceof $eed88219b0d9247d$export$3024f3bfb62054a3) {
        const target = event.target;
        let shouldFire = false;
        let elementToFire;
        const formField = $eed88219b0d9247d$var$isFormField(target);
        for(let i = newTriePosition.children.length - 1; i >= 0; i -= 1){
            elementToFire = newTriePosition.children[i];
            const scope = elementToFire.getAttribute("data-hotkey-scope");
            if (!formField && !scope || formField && target.id === scope) {
                shouldFire = true;
                break;
            }
        }
        if (elementToFire && shouldFire) {
            $eed88219b0d9247d$var$fireDeterminedAction(elementToFire, $eed88219b0d9247d$var$sequenceTracker.path);
            event.preventDefault();
        }
        $eed88219b0d9247d$var$sequenceTracker.reset();
    }
}
function $eed88219b0d9247d$export$4b3e715f166fdd78(element, hotkey) {
    if (Object.keys($eed88219b0d9247d$var$hotkeyRadixTrie.children).length === 0) document.addEventListener("keydown", $eed88219b0d9247d$var$keyDownHandler);
    const hotkeys = $eed88219b0d9247d$var$expandHotkeyToEdges(hotkey || element.getAttribute("data-hotkey") || "");
    const leaves = hotkeys.map((h)=>$eed88219b0d9247d$var$hotkeyRadixTrie.insert(h).add(element));
    $eed88219b0d9247d$var$elementsLeaves.set(element, leaves);
}
function $eed88219b0d9247d$export$a846c21fa8a8ce67(element) {
    const leaves = $eed88219b0d9247d$var$elementsLeaves.get(element);
    if (leaves && leaves.length) for (const leaf of leaves)leaf && leaf.delete(element);
    if (Object.keys($eed88219b0d9247d$var$hotkeyRadixTrie.children).length === 0) document.removeEventListener("keydown", $eed88219b0d9247d$var$keyDownHandler);
}


const $96df9d39f45d810f$var$attrName = "data-hotkey";
function $96df9d39f45d810f$var$installSubtree(element = document.documentElement) {
    if (element.hasAttribute($96df9d39f45d810f$var$attrName)) (0, $eed88219b0d9247d$export$4b3e715f166fdd78)(element);
    for (const el of element.querySelectorAll(`[${$96df9d39f45d810f$var$attrName}]`))(0, $eed88219b0d9247d$export$4b3e715f166fdd78)(el);
}
const $96df9d39f45d810f$var$observer = new MutationObserver((mutations)=>{
    for (const mutation of mutations){
        if (mutation.type === "attributes" && mutation.target instanceof HTMLElement) (0, $eed88219b0d9247d$export$4b3e715f166fdd78)(mutation.target);
        else if (mutation.type === "childList" && mutation.addedNodes.length) {
            for (const node of mutation.addedNodes)if (node instanceof HTMLElement) $96df9d39f45d810f$var$installSubtree(node);
        }
    }
});
$96df9d39f45d810f$var$observer.observe(document, {
    childList: true,
    subtree: true,
    attributeFilter: [
        $96df9d39f45d810f$var$attrName
    ]
});
$96df9d39f45d810f$var$installSubtree();



addEventListener("click", async (event)=>{
    const target = event.target;
    if (!(target instanceof Element)) return;
    // todo... switch all these to "click-behavior" attributes
    // data-requires-submit
    {
        const button = target.closest("[data-requires-submit]:is(button, a, label, summary)");
        const requiresSubmit = button && (button.closest("modal-content")?.querySelector('form-behavior:not([unload-prompt="false"])') ?? document.querySelector('form-behavior:not([unload-prompt="false"]'));
        if (requiresSubmit?.canSubmit) {
            event.preventDefault();
            event.stopPropagation();
            button.classList.add("btn-busy");
            await requiresSubmit.submit();
            button.classList.remove("btn-busy");
            if (requiresSubmit.canSubmit) // prevent further processing of subsequent behaviors below.
            return;
            else target.closest("button, a, label, summary")?.click();
        }
    }
    target.closest(".js-flash-close") && target.closest(".flash")?.remove();
    target.closest("[data-dismiss]") && document.getElementById(target.closest("[data-dismiss]").getAttribute("data-dismiss"))?.remove();
    // data-toggle-for attribute
    {
        const toggle = target.closest("[data-toggle-for]");
        if (toggle) {
            const id = toggle.getAttribute("data-toggle-for");
            if (id) {
                const toggleTarget = document.getElementById(id);
                if (toggleTarget) toggleTarget.toggleAttribute("open", !toggleTarget.hasAttribute("open"));
            }
        }
    }
    // cookie set
    {
        const button = target.closest(":is(button,a)[cookie-name][cookie-value][cookie-max-age]");
        if (button) {
            const name = button.getAttribute("cookie-name");
            const value = button.getAttribute("cookie-value");
            const maxAge = button.getAttribute("cookie-max-age");
            if (name) document.cookie = `${name}=${value};path=/;${location.protocol === "https:" ? "secure;" : ""};samesite=lax;max-age=${maxAge}`;
        }
    }
    // print button
    {
        const button = target.closest('[click-behavior="print"]');
        if (button) print();
    }
    // reveal element
    {
        const button = target.closest('[click-behavior="reveal"]');
        if (button) {
            const id = button.getAttribute("aria-controls");
            const element = id && document.getElementById(id);
            if (element) {
                element.hidden = false;
                (0, $eb08f38ae8877120$export$9657601bf1e130ee)(element);
                (0, $eb08f38ae8877120$export$956fd4dade47957a)(element);
            }
        }
    }
    // hide element
    {
        const button = target.closest('[click-behavior="hide"]');
        if (button) {
            const id = button.getAttribute("aria-controls");
            const element = id && document.getElementById(id);
            if (element) element.hidden = true;
        }
    }
}, true);
// addEventListener(
//   'mouseover',
//   ({ target }) => {
//     const details =
//       target instanceof HTMLElement &&
//       target.closest<HTMLDetailsElement>(
//         'details[data-hover-open]:not([open])'
//       );
//     if (details) {
//       console.log(details);
//       details.open = true;
//       details.lastElementChild?.addEventListener(
//         'mouseleave',
//         () => setTimeout(() => (details.open = false)),
//         {
//           once: true,
//           passive: true
//         }
//       );
//     }
//   }
//   // true
//   //{ capture: true, passive: true }
// );
addEventListener("clipboard-copy", ({ target: target })=>{
    if (!(target instanceof HTMLElement)) return;
    target.classList.add("btn-copied");
    setTimeout(()=>target.classList.remove("btn-copied"), 1000);
});
const $69091849387cceb7$var$organizationHeader = document.getElementById("sticky-organization-header");
if ($69091849387cceb7$var$organizationHeader) {
    const small = matchMedia("screen and (min-width: 544px)");
    const handler = ()=>{
        const scrolled = document.documentElement.scrollTop > 0 && small.matches && $69091849387cceb7$var$organizationHeader.getBoundingClientRect().top === 0;
        $69091849387cceb7$var$organizationHeader.classList.toggle("border-bottom", scrolled);
        $69091849387cceb7$var$organizationHeader.classList.toggle("color-shadow-medium", scrolled);
    };
    addEventListener("scroll", handler, {
        passive: true
    });
    small.addEventListener("change", handler, {
        passive: true
    });
    handler();
}
function $69091849387cceb7$var$getHighchartsThemeClass() {
    const colorMode = document.documentElement.getAttribute("data-color-mode");
    const theme = document.documentElement.getAttribute("data-light-theme") ?? "light";
    return colorMode === "auto" ? "highcharts-auto" : theme.startsWith("dark") ? "highcharts-dark" : "highcharts-light";
}
document.getElementById("theme-select")?.addEventListener("details-menu-selected", (event)=>{
    const theme = event.detail.relatedTarget.getAttribute("theme") ?? "auto";
    document.documentElement.setAttribute("data-color-mode", theme === "auto" ? "auto" : "light");
    document.documentElement.setAttribute("data-light-theme", theme === "auto" ? "light" : theme);
    const sidebar = document.querySelector("side-bar");
    const sidebarThemeMap = {
        light: "dark",
        light_high_contrast: "dark_high_contrast",
        dark: "dark",
        dark_dimmed: "dark_dimmed",
        dark_high_contrast: "dark_high_contrast",
        dark_colorblind: "dark_colorblind",
        light_colorblind: "dark_colorblind",
        dark_tritanopia: "dark_tritanopia",
        light_tritanopia: "dark_tritanopia",
        auto: "dark"
    };
    sidebar?.setAttribute("data-color-mode", theme === "auto" ? "auto" : "light");
    sidebar?.setAttribute("data-light-theme", sidebarThemeMap[theme]);
    document.cookie = "theme=" + theme + ";path=/;" + (location.protocol === "https:" ? "secure;" : "") + "samesite=lax;max-age=31536000";
    const highchartsThemeClass = $69091849387cceb7$var$getHighchartsThemeClass();
    document.querySelectorAll(".highcharts-container").forEach((container)=>{
        container.classList.remove("highcharts-auto", "highcharts-light", "highcharts-dark");
        container.classList.add(highchartsThemeClass);
    });
});
// if the selected details menu item has an input whose name attribute
// is missing, apply the current input's name
addEventListener("details-menu-select", (event)=>{
    let contents = event.detail.relatedTarget.querySelector("[data-menu-button-contents]");
    if (contents instanceof HTMLTemplateElement) contents = contents.content;
    const input = contents?.querySelector("input:not([name])");
    const current = event.target instanceof (0, $8449f1a811eb81cd$export$2e2bcd8739ae039) && event.target.closest("details")?.firstElementChild?.querySelector("input");
    if (input && current) input.name = current.name;
}, true);
addEventListener("keydown", (event)=>{
    if (event.key === " " && event.target instanceof HTMLAnchorElement && event.target.getAttribute("role") === "button") {
        event.preventDefault();
        event.target.click();
    }
});


//# sourceMappingURL=manifest.f45fdcac.js.map
